import { GraphQLClient, RequestOptions } from 'graphql-request';
import { DocumentNode } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: any; output: any; }
  /** Custom scalar type for brand kit JSON data. */
  BrandKitJson: { input: BrandKitJson; output: BrandKitJson; }
  Date: { input: any; output: any; }
  FeedCellValue: { input: FeedCellValue; output: FeedCellValue; }
  FeedJson: { input: FeedJson; output: FeedJson; }
  JSON: { input: any; output: any; }
  /** Custom scalar type for design JSON data. */
  JsonDesign: { input: JsonDesign; output: JsonDesign; }
  /** Custom scalar type for design set JSON data. */
  JsonDesignSet: { input: JsonDesignSet; output: JsonDesignSet; }
  JsonTransitionAll: { input: any; output: any; }
  LanguageCodesType: { input: any; output: any; }
  LanguageFallbackFonts: { input: any; output: any; }
  StringOrInt: { input: string | number; output: string | number; }
  TToken: { input: any; output: any; }
  WorkflowJson: { input: any; output: any; }
  WorkflowRunOutput: { input: any; output: any; }
};

/** User-defined AI generation rules for creative output. */
export type AiGenerationRules = {
  __typename?: 'AIGenerationRules';
  /** Copywriting rules — tone, phrasing, headline conventions (markdown). */
  copy?: Maybe<Scalars['String']['output']>;
  /** Things the brand always or never does in creative output (markdown). */
  dosAndDonts?: Maybe<Scalars['String']['output']>;
  /** Layout composition rules — spacing, element placement, structure (markdown). */
  layout?: Maybe<Scalars['String']['output']>;
};

/** Two rules that cannot both be honoured. */
export type AiGenerationRulesConflict = {
  __typename?: 'AIGenerationRulesConflict';
  first: AiGenerationRulesConflictRule;
  /** One sentence explaining why the two cannot both hold. */
  reason: Scalars['String']['output'];
  second: AiGenerationRulesConflictRule;
};

/** Which rule field a quoted conflict excerpt came from. */
export enum AiGenerationRulesConflictField {
  COPY = 'COPY',
  DOS_AND_DONTS = 'DOS_AND_DONTS',
  LAYOUT = 'LAYOUT'
}

/** One side of a contradiction. */
export type AiGenerationRulesConflictRule = {
  __typename?: 'AIGenerationRulesConflictRule';
  /** The rule field the excerpt was quoted from. */
  field: AiGenerationRulesConflictField;
  /** The conflicting rule text, quoted from the user's rules. */
  text: Scalars['String']['output'];
};

/** User-defined AI generation rules for creative output. */
export type AiGenerationRulesContext = {
  __typename?: 'AIGenerationRulesContext';
  /** Copywriting rules (markdown). */
  copy?: Maybe<Scalars['String']['output']>;
  /** Things the brand always or never does in creative output (markdown). */
  dosAndDonts?: Maybe<Scalars['String']['output']>;
  /** Layout composition rules (markdown). */
  layout?: Maybe<Scalars['String']['output']>;
};

/** Advisory contradiction review of a brand kit's AI generation rules. */
export type AiGenerationRulesReview = {
  __typename?: 'AIGenerationRulesReview';
  /** Empty unless the status is CONFLICTS. */
  conflicts: Array<AiGenerationRulesConflict>;
  status: AiGenerationRulesReviewStatus;
};

/** Whether the AI generation rules have been reviewed for contradictions. */
export enum AiGenerationRulesReviewStatus {
  /** No two rules contradict each other. */
  CLEAN = 'CLEAN',
  /** At least one pair of rules cannot both be honoured. */
  CONFLICTS = 'CONFLICTS',
  /** The review could not be completed. Clients show nothing. */
  FAILED = 'FAILED',
  /** A review is running, or the last one did not finish. */
  PENDING = 'PENDING'
}

export type AbTest = {
  __typename?: 'AbTest';
  adTagSyncStatus?: Maybe<AbTestTagContainerSettings>;
  chancesToWin?: Maybe<Array<ChanceToWin>>;
  count?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  designs?: Maybe<Array<Design>>;
  endDate: Scalars['Date']['output'];
  endedAt?: Maybe<Scalars['Date']['output']>;
  endedType?: Maybe<EndedType>;
  endingType?: Maybe<EndedType>;
  folderId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  keyMetric: KeyMetric;
  name: Scalars['String']['output'];
  projectId: Scalars['Int']['output'];
  startedAt?: Maybe<Scalars['Date']['output']>;
  tagContainerHash?: Maybe<Scalars['String']['output']>;
  tagContainerId?: Maybe<Scalars['Int']['output']>;
  thumb?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
  updatedByName?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<AbTestUsage>;
  winnerId?: Maybe<Scalars['Int']['output']>;
};

export type AbTestDeleteResultPayload = {
  __typename?: 'AbTestDeleteResultPayload';
  result: Scalars['Boolean']['output'];
  trashItem: TrashItem;
};

export type AbTestDesign = {
  __typename?: 'AbTestDesign';
  designId: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type AbTestTagContainerSettings = {
  __typename?: 'AbTestTagContainerSettings';
  active: Scalars['Boolean']['output'];
  embeds?: Maybe<EmbedsProgress>;
  syncStatus: AdTagSyncStatus;
};

export type AbTestTagContainerSyncStatus = {
  __typename?: 'AbTestTagContainerSyncStatus';
  abTestId: Scalars['Int']['output'];
  tagContainer: TagContainerSyncStatus;
};

export type AbTestUsage = {
  __typename?: 'AbTestUsage';
  clicks?: Maybe<Scalars['Int']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
};

export type AbTests = {
  __typename?: 'AbTests';
  nodes: Array<AbTest>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Response after accepting a team invitation. */
export type AcceptTeamInvitationPayload = {
  __typename?: 'AcceptTeamInvitationPayload';
  /** ID of the team that was joined. */
  teamId: Scalars['Int']['output'];
};

export type AccessType = {
  __typename?: 'AccessType';
  canDownload?: Maybe<Scalars['Boolean']['output']>;
  canEdit: Scalars['Boolean']['output'];
  canView: Scalars['Boolean']['output'];
  isPasswordProtected: Scalars['Boolean']['output'];
};

export type Account = {
  __typename?: 'Account';
  authId: Scalars['String']['output'];
  confirmed: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  testUser: Scalars['Boolean']['output'];
};

export type AccountBalance = {
  __typename?: 'AccountBalance';
  balance: Scalars['Float']['output'];
};

/** Result of requesting an account change (email or password). */
export type AccountChangePayload = {
  __typename?: 'AccountChangePayload';
  /** Whether the account change request was successful. */
  result: Scalars['Boolean']['output'];
};

export type AccountData = {
  __typename?: 'AccountData';
  /** @deprecated Always null: integration reads no longer return stored OAuth tokens. */
  accessToken?: Maybe<Scalars['String']['output']>;
  connectedEmail?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['String']['output']>;
  /** @deprecated Always null: integration reads no longer return stored OAuth tokens. */
  refreshToken?: Maybe<Scalars['String']['output']>;
};

export type AccountStatsPayload = {
  __typename?: 'AccountStatsPayload';
  /** @deprecated Not used anymore. */
  reducedTrialPeriod?: Maybe<Scalars['Int']['output']>;
  usedTrials: UsedTrials;
};

export type AcquiredReseller = {
  acquiredThroughReseller: Scalars['Boolean']['input'];
  teamId: Scalars['Int']['input'];
};

export type ActivateAddonPayload = ActiveAddonResult | ThreeDSecurePayload;

export type ActivateWinBackTrialPayload = {
  __typename?: 'ActivateWinBackTrialPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ActiveAddonResult = {
  __typename?: 'ActiveAddonResult';
  invoiceId?: Maybe<Scalars['String']['output']>;
  result: Scalars['Boolean']['output'];
};

export type ActiveUsageRestriction = {
  __typename?: 'ActiveUsageRestriction';
  action: UsageRestrictionAction;
  expiresAt?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<UsageRestrictionMetadata>;
  scope: UsageRestrictionScope;
};

/** Individual card in a carousel ad */
export type AdCard = {
  __typename?: 'AdCard';
  /** Card description text */
  body?: Maybe<Scalars['String']['output']>;
  /** CDN URL for original image stored in CDN */
  cdnOriginalImageUrl?: Maybe<Scalars['String']['output']>;
  /** CDN URL for resized image stored in CDN */
  cdnResizedImageUrl?: Maybe<Scalars['String']['output']>;
  /** CDN URL for HD video stored in CDN */
  cdnVideoHdUrl?: Maybe<Scalars['String']['output']>;
  /** CDN URL for video preview image stored in CDN */
  cdnVideoPreviewImageUrl?: Maybe<Scalars['String']['output']>;
  /** CDN URL for SD video stored in CDN */
  cdnVideoSdUrl?: Maybe<Scalars['String']['output']>;
  /** Card-specific call-to-action */
  cta?: Maybe<Scalars['String']['output']>;
  /** Interactive preview URL */
  interactivePreviewUrl?: Maybe<Scalars['String']['output']>;
  /** Card-specific landing page URL */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** Original image URL for the card */
  originalImageUrl?: Maybe<Scalars['String']['output']>;
  /** Resized image URL for the card */
  resizedImageUrl?: Maybe<Scalars['String']['output']>;
  /** Card title */
  title?: Maybe<Scalars['String']['output']>;
  /** High-definition video URL */
  videoHdUrl?: Maybe<Scalars['String']['output']>;
  /** Video preview/thumbnail image URL */
  videoPreviewImageUrl?: Maybe<Scalars['String']['output']>;
  /** Standard-definition video URL */
  videoSdUrl?: Maybe<Scalars['String']['output']>;
};

/** Complete ad data with content, media, and metadata */
export type AdData = {
  __typename?: 'AdData';
  /** Unique ad archive identifier */
  adArchiveId: Scalars['String']['output'];
  /** Main text content of the ad */
  bodyText?: Maybe<Scalars['String']['output']>;
  /** Branded content information if applicable */
  brandedContent?: Maybe<BrandedContent>;
  /** Carousel cards if the ad is a carousel */
  cards: Array<AdCard>;
  /** CDN URLs for images processed and stored in CDN */
  cdnImages: Array<Scalars['String']['output']>;
  /** Call-to-action text */
  cta?: Maybe<Scalars['String']['output']>;
  /** Display format of the ad (single image, carousel, video, etc.) */
  displayFormat?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the ad stopped running */
  endDate?: Maybe<Scalars['Float']['output']>;
  /** Image URLs if the ad includes images */
  images: Array<Scalars['String']['output']>;
  /** Whether the ad is currently active */
  isActive: Scalars['Boolean']['output'];
  /** Landing page URL */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** ID of the page that published the ad */
  pageId: Scalars['String']['output'];
  /** Name of the page that published the ad */
  pageName: Scalars['String']['output'];
  /** URL of the page's profile picture */
  pageProfilePictureUrl?: Maybe<Scalars['String']['output']>;
  /** Platform where the ad was retrieved from */
  platform: Platform;
  /** Platforms where the ad is published */
  publisherPlatform: Array<Scalars['String']['output']>;
  /** Timestamp when the ad started running */
  startDate?: Maybe<Scalars['Float']['output']>;
  /** Ad title/headline */
  title?: Maybe<Scalars['String']['output']>;
  /** Total time the ad has been active in seconds */
  totalActiveTime?: Maybe<Scalars['Float']['output']>;
  /** Video content if the ad includes videos */
  videos: Array<AdVideo>;
};

/** Detailed information about a specific ad */
export type AdDetails = {
  __typename?: 'AdDetails';
  /** Unique ad identifier */
  adId: Scalars['String']['output'];
  /** Audience targeting and reach information */
  audienceInfo?: Maybe<AudienceInfo>;
  /** Page/brand ID that published the ad */
  pageId: Scalars['String']['output'];
  /** Name of the page/brand */
  pageName: Scalars['String']['output'];
  /** URL of the page's profile picture */
  pageProfilePictureUrl?: Maybe<Scalars['String']['output']>;
  /** Platform where the ad is published */
  platform: Platform;
  /** Transparency and spend information */
  transparencyInfo?: Maybe<TransparencyInfo>;
  /** List of policy violations if any */
  violationTypes: Array<Scalars['String']['output']>;
};

/** Response containing detailed information about a specific ad */
export type AdDetailsResponse = {
  __typename?: 'AdDetailsResponse';
  /** Detailed ad information */
  data?: Maybe<AdDetails>;
  /** Error message if request failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Platform where the ad was retrieved from */
  platform: Platform;
  /** Whether the request was successful */
  success: Scalars['Boolean']['output'];
};

/** The planned entry: the design size, the first Copilot message and an optional follow-up message. */
export type AdEntryPlan = {
  __typename?: 'AdEntryPlan';
  /** True when the planner failed and the deterministic fallback answered. */
  fallback: Scalars['Boolean']['output'];
  followUp?: Maybe<Scalars['String']['output']>;
  prompt: Scalars['String']['output'];
  size: AdEntrySize;
};

export type AdEntrySize = {
  __typename?: 'AdEntrySize';
  /** Set for CATALOG sizes. */
  designSizeTypeId?: Maybe<Scalars['Int']['output']>;
  height: Scalars['Float']['output'];
  /** Set for CATALOG sizes. */
  identifier?: Maybe<Scalars['String']['output']>;
  kind: AdEntrySizeKind;
  /** The unit width and height are in: the one the user typed them in. Set for CUSTOM sizes. */
  measureUnit?: Maybe<MeasureUnit>;
  width: Scalars['Float']['output'];
};

export enum AdEntrySizeKind {
  CATALOG = 'CATALOG',
  CUSTOM = 'CUSTOM'
}

export enum AdFormatType {
  AD = 'ad',
  ANIMATED_AD = 'animated_ad',
  PRODUCT_PHOTOGRAPHY = 'product_photography',
  STATIC_AD = 'static_ad',
  UGC_VIDEO = 'ugc_video',
  VIDEO = 'video'
}

/** AI-generated insights data for a specific ad */
export type AdInsightsData = {
  __typename?: 'AdInsightsData';
  /** Actionable insights and recommendations */
  insights: InsightsRecommendations;
  /**
   * Performance metrics across six psychological dimensions
   * that influence ad effectiveness and user engagement.
   */
  radarMetrics: RadarMetrics;
};

/** Input for generating AI-powered ad insights */
export type AdInsightsInput = {
  /** Ad identifier to analyze */
  adId: Scalars['String']['input'];
  /** Brand/page ID that published the ad */
  brandId: Scalars['String']['input'];
  /** @BreakingBad */
  json: Scalars['JSON']['input'];
  /** Platform where the ad was published */
  platform: Platform;
};

/** Response containing AI-generated ad insights */
export type AdInsightsResponse = {
  __typename?: 'AdInsightsResponse';
  /** Generated insights data */
  data?: Maybe<AdInsightsData>;
  /** Error message if insight generation failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Whether the insight generation was successful */
  success: Scalars['Boolean']['output'];
};

/** Represents an advertising network. */
export type AdNetwork = {
  __typename?: 'AdNetwork';
  /** A list of team associations for this ad network. */
  adNetworkTeams?: Maybe<Array<AdNetworkTeam>>;
  /** Indicates if the ad network supports ad tags. */
  adTag?: Maybe<Scalars['Boolean']['output']>;
  /** The cachebuster macro for the ad network. */
  cachebusterMacro: Scalars['String']['output'];
  /** The click tag macro for the ad network. */
  clickTagMacro?: Maybe<Scalars['String']['output']>;
  /** Indicates if the ad network supports HTML5. */
  html5?: Maybe<Scalars['Boolean']['output']>;
  /** The unique identifier for the ad network. */
  id: Scalars['Int']['output'];
  /** The URL of the ad network's logo. */
  logo?: Maybe<Scalars['String']['output']>;
  /** The name of the ad network. */
  name: Scalars['String']['output'];
  /** The path associated with the ad network, if any. */
  path?: Maybe<Scalars['String']['output']>;
  /** The status of the ad network (active/inactive). */
  status: Scalars['Boolean']['output'];
  /** The ID of the team associated with this ad network. */
  teamId?: Maybe<Scalars['Int']['output']>;
  /** Indicates if the ad network is for testing purposes only. */
  testOnly?: Maybe<Scalars['Boolean']['output']>;
  /** The type of the ad network. */
  type: Scalars['String']['output'];
};

/** Options for ad networks, specifying the type of ad. */
export enum AdNetworkOption {
  /** Ad serving type */
  AD_SERVING = 'AD_SERVING',
  /** HTML5 ad type */
  HTML5 = 'HTML5'
}

/** Represents the association between a team and an ad network. */
export type AdNetworkTeam = {
  __typename?: 'AdNetworkTeam';
  /** The ID of the ad network. */
  adNetworkId: Scalars['Int']['output'];
  /** The status of the association. */
  status: Scalars['Boolean']['output'];
  /** The ID of the team. */
  teamId: Scalars['Int']['output'];
};

export type AdPublishingExportSettings = {
  imageQuality: Scalars['Int']['input'];
  url: Scalars['String']['input'];
};

export type AdPublishingExportSettingsDv360 = {
  imageQuality?: InputMaybe<Scalars['Int']['input']>;
  url: Scalars['String']['input'];
};

/** Reference to a specific ad */
export type AdReference = {
  __typename?: 'AdReference';
  /** Ad identifier */
  adId: Scalars['String']['output'];
  /** Platform where the ad was found */
  platform: Platform;
};

/** Settings specific to an ad serving design. */
export type AdServingDesignSettings = {
  __typename?: 'AdServingDesignSettings';
  /** Additional properties for the ad tag. */
  adTagProps?: Maybe<AdTagPropsType>;
  /** Ad scaling 'Scale + reflow': with responsive scaling on, the leftover room is laid out by the design's constraints. */
  responsiveReflow: Scalars['Boolean']['output'];
  /** Indicates if responsive scaling is enabled. */
  responsiveScaling: Scalars['Boolean']['output'];
  /** The target window for the URL (e.g., _blank, _self). */
  target: Scalars['String']['output'];
  /** The primary URL for the ad. */
  url?: Maybe<Scalars['String']['output']>;
  /** A suffix to append to the URL. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
  /** Indicates if the ad should use the URL as a click tag. */
  useAsClickTag: Scalars['Boolean']['output'];
};

/** Represents a dynamic variable used in ad serving. */
export type AdServingDynamicVar = {
  __typename?: 'AdServingDynamicVar';
  /** The default value for the dynamic variable. */
  defaultValue: Scalars['String']['output'];
  /** The unique identifier for the dynamic variable. */
  id: Scalars['Int']['output'];
  /** The macro code for the dynamic variable. */
  macroCode: Scalars['String']['output'];
};

/** Represents an external tracking URL for ad serving. */
export type AdServingExternalTrackingUrl = {
  __typename?: 'AdServingExternalTrackingUrl';
  /** The unique identifier for the external tracking URL. */
  id: Scalars['Int']['output'];
  /** The type of external tracking. */
  trackingType: AdTagExternalDesignTrackingType;
  /** The URL for external tracking. */
  url: Scalars['String']['output'];
};

/** Represents an ad serving network with its synchronization status. */
export type AdServingNetwork = {
  __typename?: 'AdServingNetwork';
  /** The ID of the ad serving network. */
  id: Scalars['Int']['output'];
  /** The name of the ad serving network. */
  name: Scalars['String']['output'];
  /** The synchronization status of the network. */
  syncStatus: AdTagSyncStatus;
};

/** Payload containing information about ad serving networks for a design. */
export type AdServingNetworksPayload = {
  __typename?: 'AdServingNetworksPayload';
  /** Indicates if the design content is out of sync. */
  designOutOfSync: Scalars['Boolean']['output'];
  /** Progress of embeds. */
  embeds: EmbedsProgress;
  /** A list of networks and their synchronization statuses. */
  networks: Array<StatusSyncNetwork>;
  /** Indicates if the ad serving settings are out of sync. */
  settingsOutOfSync: Scalars['Boolean']['output'];
  /** The overall synchronization status of the ad tag. */
  syncStatus: AdTagSyncStatus;
};

/** Payload containing ad serving settings. */
export type AdServingSettingsPayload = {
  __typename?: 'AdServingSettingsPayload';
  /** Indicates if ad serving is active for the design. */
  active: Scalars['Boolean']['output'];
  /** A list of dynamic variables for the design. */
  dynamicVars: Array<AdServingDynamicVar>;
  /**
   * Progress of embeds. @deprecated Not needed anymore. @BreakingBad
   * @deprecated Not needed anymore
   */
  embeds?: Maybe<EmbedsProgress>;
  /** A list of external tracking URLs for the design. */
  externalTrackingUrls: Array<AdServingExternalTrackingUrl>;
  /** A list of ad serving networks and their statuses. @BreakingBad */
  networks: Array<AdServingNetwork>;
  /** The ad serving settings for the design. */
  settings: AdServingDesignSettings;
  /**
   * Synchronization status of the ad tag. @deprecated Not needed anymore. @BreakingBad
   * @deprecated Not needed anymore
   */
  syncStatus?: Maybe<AdTagSyncStatus>;
  /**
   * Indicates if the ad tag is synced. @deprecated Not needed anymore. @BreakingBad
   * @deprecated Not needed anymore
   */
  syncedTag?: Maybe<Scalars['Boolean']['output']>;
};

/** Payload containing the ad serving status for a design. */
export type AdServingStatusPayload = {
  __typename?: 'AdServingStatusPayload';
  /** Indicates if ad serving is active. */
  active: Scalars['Boolean']['output'];
  /** Indicates if the design content is out of sync. */
  designOutOfSync: Scalars['Boolean']['output'];
  /** Indicates if the ad serving settings are out of sync. */
  settingsOutOfSync: Scalars['Boolean']['output'];
  /** The reason for the current synchronization state, if any. */
  syncReason?: Maybe<AdServingSyncReason>;
  /** The overall synchronization status of the ad tag. */
  syncStatus: AdTagSyncStatus;
};

/** Reason for an ad serving synchronization. */
export enum AdServingSyncReason {
  /** Both design and settings are out of sync. */
  DESIGN_AND_SETTINGS_OUT_OF_SYNC = 'DESIGN_AND_SETTINGS_OUT_OF_SYNC',
  /** The design content has changed and is out of sync. */
  DESIGN_OUT_OF_SYNC = 'DESIGN_OUT_OF_SYNC',
  /** Ad serving was just enabled. */
  ENABLE_AD_SERVING = 'ENABLE_AD_SERVING',
  /** A retry attempt to update the ad code. */
  RETRY_UPDATE_CODE = 'RETRY_UPDATE_CODE',
  /** The ad serving settings have changed and are out of sync. */
  SETTINGS_OUT_OF_SYNC = 'SETTINGS_OUT_OF_SYNC'
}

/**
 * Studio Assistant per-thread chat mode. EDIT = full read+write. READ = read-only
 * inspection (tools that mutate the design are refused with a text answer +
 * offer-to-switch). Missing on legacy threads → treated as EDIT.
 */
export enum AdStudioChatMode {
  EDIT = 'EDIT',
  READ = 'READ'
}

export type AdStudioContext = {
  __typename?: 'AdStudioContext';
  brandKitContext?: Maybe<BrandKitContextResult>;
  /** serializeBrandStyle output for the brand kit; null when absent. */
  brandStyleDescription?: Maybe<Scalars['String']['output']>;
  designContext: AdStudioDesignContext;
};

export type AdStudioDesignContext = {
  __typename?: 'AdStudioDesignContext';
  checksum: Scalars['String']['output'];
  computedAt: Scalars['String']['output'];
  /** Deterministic design facts (sizes, texts, urls, fonts, colors) — recomputed live, never stale. */
  facts: Scalars['JSON']['output'];
  /** True when the summary predates the current design checksum (cooldown window). */
  stale: Scalars['Boolean']['output'];
  /** AI semantic summary of the design; null only when compute failed with no cached fallback. */
  summary?: Maybe<Scalars['String']['output']>;
};

/**
 * Which Ad Studio a team is on, as resolved by the app itself (the same inputs
 * AdStudioGate mounts on). The values are the internal values of HubSpot's
 * `ad_studio_experience` dropdown on the Teams object, so nothing between here
 * and HubSpot has to translate them.
 */
export enum AdStudioExperience {
  NEW = 'new',
  OLD = 'old'
}

/** A row of a master's family, removed or not, with when it existed. */
export type AdStudioFamilyRow = {
  __typename?: 'AdStudioFamilyRow';
  /** When it was created (ISO 8601). */
  createdAt: Scalars['String']['output'];
  /** The size's type, matched across a family's members; null for a size without one. */
  designSizeTypeId?: Maybe<Scalars['Int']['output']>;
  /** Hash of the row. */
  hash: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  /** A set's top row, which holds no document of its own. */
  isSet: Scalars['Boolean']['output'];
  languageCode?: Maybe<Scalars['String']['output']>;
  /** Hash of the member it belongs to: the master for the master and its sizes, a variation's top row for it and its sizes. */
  memberHash: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** Each removal, oldest first; the last is open while the row is removed. */
  removals: Array<AdStudioFamilyRowRemoval>;
  width: Scalars['Int']['output'];
};

/** One removal of a family row, open while it lasts. */
export type AdStudioFamilyRowRemoval = {
  __typename?: 'AdStudioFamilyRowRemoval';
  /** When it was removed (ISO 8601). */
  removedAt: Scalars['String']['output'];
  /** When it was restored (ISO 8601); null while it is still removed. */
  restoredAt?: Maybe<Scalars['String']['output']>;
};

/**
 * One size's document, and NOTHING that can be traversed further.
 *
 * A LEAF on purpose. Returning `Design` here would let an authorized caller put a master
 * or variation TOP-ROW hash in `hashes` - the membership check accepts those, since their
 * family id matches - and then select `sizes { json }` or `variations { sizes { json } }`
 * beneath each returned row. One call would fan out across the whole family per requested
 * hash, walking straight past the 50-document bound, the request-work budget that pins it,
 * and the `@rateLimit` sizing that assumes 50 documents per call. Exposing only the four
 * fields the caller actually reads makes that traversal unrepresentable rather than merely
 * discouraged.
 */
export type AdStudioFamilySizeJson = {
  __typename?: 'AdStudioFamilySizeJson';
  /** Content checksum of the stored document, for the tab's content-addressed refetch. */
  checksum?: Maybe<Scalars['String']['output']>;
  /** The size row's hash - what the caller asked for, and matches results back by. */
  hash: Scalars['String']['output'];
  /** Unique identifier for the size row. */
  id: Scalars['Int']['output'];
  /** The banner document. Null when it is withheld or could not be read. */
  json?: Maybe<JsonDesignWithHash>;
};

export type AdStudioLogoAvailability = {
  __typename?: 'AdStudioLogoAvailability';
  /** svg (logo) layer ids (bannersetElementId || id — cross-size-stable, not the raw per-document properties.id) for which at least one brand kit logo differs from the asset currently in that layer — the Content panel disables the Logo row for any layer NOT in this list, since offering it would be a guaranteed no-op generation. */
  availableLayerIds: Array<Scalars['Int']['output']>;
};

/** A chat thread for an AdStudio design */
export type AdStudioThread = {
  __typename?: 'AdStudioThread';
  /** Mastra agentId that owns this thread (null for legacy threads) */
  agentId?: Maybe<Scalars['String']['output']>;
  /** Studio Assistant chat mode for this thread (null on legacy threads → treat as EDIT) */
  chatMode?: Maybe<AdStudioChatMode>;
  /** ISO timestamp when thread was created */
  createdAt: Scalars['String']['output'];
  /** Design hash this thread belongs to */
  designHash: Scalars['String']['output'];
  /** Optional design name */
  designName?: Maybe<Scalars['String']['output']>;
  /** Unique thread ID */
  id: Scalars['String']['output'];
  /** Thread title */
  title: Scalars['String']['output'];
};

export enum AdTagCodeFormat {
  CSV = 'CSV',
  STRING = 'STRING',
  XLSX = 'XLSX'
}

export type AdTagContactMePayload = {
  __typename?: 'AdTagContactMePayload';
  result: Scalars['Boolean']['output'];
};

export type AdTagDesignNetwork = {
  __typename?: 'AdTagDesignNetwork';
  id: Scalars['Int']['output'];
  syncStatus: AdTagSyncStatus;
};

export type AdTagDesignNetworksPayload = {
  __typename?: 'AdTagDesignNetworksPayload';
  embeds: EmbedsProgress;
  networks: Array<AdTagDesignNetwork>;
};

export type AdTagDesignSettings = {
  __typename?: 'AdTagDesignSettings';
  adTagProps?: Maybe<AdTagPropsType>;
  responsiveScaling: Scalars['Boolean']['output'];
  target: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
  urlSuffix?: Maybe<Scalars['String']['output']>;
  useAsClickTag: Scalars['Boolean']['output'];
};

export type AdTagDynamicVar = {
  __typename?: 'AdTagDynamicVar';
  defaultValue: Scalars['String']['output'];
  macroCode: Scalars['String']['output'];
};

export enum AdTagExternalDesignTrackingType {
  CLICKED = 'CLICKED',
  DISPLAYED = 'DISPLAYED',
  LOADED = 'LOADED',
  REQUESTED = 'REQUESTED'
}

export type AdTagExternalDesignTrackingUrl = {
  __typename?: 'AdTagExternalDesignTrackingUrl';
  trackingType: AdTagExternalDesignTrackingType;
  url: Scalars['String']['output'];
};

export type AdTagGenerateCodePayload = {
  __typename?: 'AdTagGenerateCodePayload';
  code: Scalars['String']['output'];
};

export type AdTagNetworksPayload = {
  __typename?: 'AdTagNetworksPayload';
  networks: Array<AdNetwork>;
};

/** Properties for ad tags, including stick settings and live feed variations. */
export type AdTagPropsType = {
  __typename?: 'AdTagPropsType';
  /** Settings for how the design sticks to the page. */
  designStickSettings?: Maybe<DesignStickSettingsType>;
  /** Settings for live feed variations. */
  liveFeedVariation?: Maybe<LiveFeedVariationType>;
  /** Indicates if window.open should use noreferrer. */
  windowOpenNoReferrer?: Maybe<Scalars['Boolean']['output']>;
};

export enum AdTagReportBreakdowns {
  DATE = 'date',
  DESIGN = 'design',
  DESIGN_SIZE = 'design_size',
  FEED_VARIATION = 'feed_variation',
  MONTH = 'month',
  NETWORK = 'network',
  PROJECT = 'project'
}

export type AdTagReportFilters = {
  __typename?: 'AdTagReportFilters';
  breakdowns?: Maybe<Array<Maybe<AdTagReportBreakdowns>>>;
  designs?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  from?: Maybe<Scalars['Date']['output']>;
  networks?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  projects?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  to?: Maybe<Scalars['Date']['output']>;
};

export type AdTagReportPayload = {
  __typename?: 'AdTagReportPayload';
  records?: Maybe<Array<Maybe<AdTagReportRecord>>>;
};

export type AdTagReportRecord = {
  __typename?: 'AdTagReportRecord';
  clicks: Scalars['Int']['output'];
  ctr: Scalars['Float']['output'];
  date?: Maybe<Scalars['String']['output']>;
  designHash?: Maybe<Scalars['String']['output']>;
  designName?: Maybe<Scalars['String']['output']>;
  designSize?: Maybe<Scalars['String']['output']>;
  networkId?: Maybe<Scalars['Int']['output']>;
  networkName?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['Int']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
  views: Scalars['Int']['output'];
};

export type AdTagReportResult = {
  __typename?: 'AdTagReportResult';
  createdAt?: Maybe<Scalars['Date']['output']>;
  filters: AdTagReportFilters;
  id: Scalars['Int']['output'];
  schedule?: Maybe<AdTagSchedule>;
  teamId: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum AdTagReportScheduleDays {
  FRI = 'fri',
  MON = 'mon',
  SAT = 'sat',
  SUN = 'sun',
  THU = 'thu',
  TUE = 'tue',
  WED = 'wed'
}

export enum AdTagReportScheduleEvery {
  DAY = 'day',
  MONTH = 'month',
  WEEK = 'week'
}

export enum AdTagReportScheduleFrequency {
  CUSTOM = 'custom',
  DAILY = 'daily',
  MONTHLY = 'monthly',
  ONCE = 'once',
  WEEKLY = 'weekly'
}

export enum AdTagReportScheduleRange {
  CURRENT_WEEK = 'Current_week',
  LAST_7_DAYS = 'Last_7_days',
  LAST_14_DAYS = 'Last_14_days',
  LAST_24_HOURS = 'Last_24_hours',
  LAST_30_DAYS = 'Last_30_days',
  PREVIOUS_3_MONTHS = 'Previous_3_months',
  PREVIOUS_MONTH = 'Previous_month',
  PREVIOUS_WEEK = 'Previous_week'
}

export enum AdTagReportScheduleStatus {
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS'
}

export type AdTagReportsPayload = {
  __typename?: 'AdTagReportsPayload';
  result: Array<Maybe<AdTagReportResult>>;
};

export type AdTagSchedule = {
  __typename?: 'AdTagSchedule';
  daysSelected?: Maybe<Array<Maybe<AdTagReportScheduleDays>>>;
  emails: Array<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  everyNum?: Maybe<Scalars['Int']['output']>;
  everySelection?: Maybe<AdTagReportScheduleEvery>;
  exeTime: Scalars['String']['output'];
  expression?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<AdTagReportScheduleFrequency>;
  id: Scalars['Int']['output'];
  nextDate?: Maybe<Scalars['Date']['output']>;
  onDay?: Maybe<Scalars['Int']['output']>;
  range?: Maybe<AdTagReportScheduleRange>;
  startDate: Scalars['Date']['output'];
  status?: Maybe<AdTagReportScheduleStatus>;
};

export type AdTagSubscriptionPayload = {
  __typename?: 'AdTagSubscriptionPayload';
  activatedAt?: Maybe<Scalars['Date']['output']>;
  state?: Maybe<SubscriptionStatus>;
};

export type AdTagSyncPayload = {
  __typename?: 'AdTagSyncPayload';
  syncStatus: AdTagSyncStatus;
};

/** Synchronization status for ad tags. */
export enum AdTagSyncStatus {
  /** Error during synchronization. */
  ERROR = 'ERROR',
  /** Successfully synchronized. */
  SYNCED = 'SYNCED',
  /** Currently synchronizing. */
  SYNCING = 'SYNCING',
  /** Not synchronized. */
  UNSYNCED = 'UNSYNCED'
}

export type AdTagSyncStatusPayload = {
  __typename?: 'AdTagSyncStatusPayload';
  active: Scalars['Boolean']['output'];
  designId: Scalars['Int']['output'];
  embeds: EmbedsProgress;
  syncStatus: AdTagSyncStatus;
};

export type AdTagTier = {
  __typename?: 'AdTagTier';
  endQuantity: Scalars['Int']['output'];
  price: Scalars['Float']['output'];
};

export type AdTagTiersPayload = {
  __typename?: 'AdTagTiersPayload';
  planPrice: Scalars['Float']['output'];
  tiers?: Maybe<Array<AdTagTier>>;
};

export type AdTagUsage = {
  __typename?: 'AdTagUsage';
  cost: Scalars['Float']['output'];
  impressions: Scalars['Int']['output'];
  lastInvoice?: Maybe<Invoice>;
};

/** Video content in an ad */
export type AdVideo = {
  __typename?: 'AdVideo';
  /** CDN URL for HD video stored in CDN */
  cdnVideoHdUrl?: Maybe<Scalars['String']['output']>;
  /** CDN URL for video preview image stored in CDN */
  cdnVideoPreviewImageUrl?: Maybe<Scalars['String']['output']>;
  /** CDN URL for SD video stored in CDN */
  cdnVideoSdUrl?: Maybe<Scalars['String']['output']>;
  /** High-definition video URL */
  videoHdUrl?: Maybe<Scalars['String']['output']>;
  /** Video preview/thumbnail image URL */
  videoPreviewImageUrl?: Maybe<Scalars['String']['output']>;
  /** Standard-definition video URL */
  videoSdUrl?: Maybe<Scalars['String']['output']>;
};

export type AddAdTagNetworkPayload = {
  __typename?: 'AddAdTagNetworkPayload';
  result: AdNetwork;
};

export type AddAiDesignCardToMoodboardPayload = {
  __typename?: 'AddAiDesignCardToMoodboardPayload';
  cardId: Scalars['String']['output'];
};

export type AddAiImageCardsToMoodboardPayload = {
  __typename?: 'AddAiImageCardsToMoodboardPayload';
  cardIds: Array<Scalars['String']['output']>;
};

export type AddAiVideoCardsToMoodboardPayload = {
  __typename?: 'AddAiVideoCardsToMoodboardPayload';
  cardIds: Array<Scalars['String']['output']>;
};

export type AddCardToMoodBoardInput = {
  card: PlatformAdInput;
  moodboardId?: InputMaybe<Scalars['Int']['input']>;
};

export type AddCardToMoodBoardPayload = {
  __typename?: 'AddCardToMoodBoardPayload';
  result: Scalars['Boolean']['output'];
};

export type AddCustomSizePayload = {
  __typename?: 'AddCustomSizePayload';
  customSize: CustomSize;
};

export type AddDesignSizeTypePayload = {
  __typename?: 'AddDesignSizeTypePayload';
  designSizeType: DesignSizeType;
};

export type AddDesignSizesResult = {
  __typename?: 'AddDesignSizesResult';
  /** The design's hash; a single design becomes a set with a new hash when a size is added. */
  hash: Scalars['String']['output'];
  /** The caller's open editor tab steps aside for this edit: it reloads to show it. */
  openEditorRefreshes: Scalars['Boolean']['output'];
  sizes: Array<AddedDesignSize>;
};

/** Response after adding a design to templates. */
export type AddDesignToTemplatesPayload = {
  __typename?: 'AddDesignToTemplatesPayload';
  /** The design that was added as a template. */
  design: Design;
};

export type AddFolderToBrandTemplatePayload = {
  __typename?: 'AddFolderToBrandTemplatePayload';
  folder: Folder;
};

export type AddFolderToTemplatesPayload = {
  __typename?: 'AddFolderToTemplatesPayload';
  folder: Folder;
};

/** Payload for the addNetworkAdServing mutation. */
export type AddNetworkAdServingPayload = {
  __typename?: 'AddNetworkAdServingPayload';
  /** The ad serving network that was added. @BreakingBad */
  network: AdServingNetwork;
  /** Indicates if the settings are out of sync after adding the network. */
  settingsOutOfSync: Scalars['Boolean']['output'];
  /** The synchronization status of the ad tag. */
  syncStatus: AdTagSyncStatus;
};

/** Response after adding a new design to a set. */
export type AddNewDesignToSetPayload = {
  __typename?: 'AddNewDesignToSetPayload';
  /** Newly added design. */
  createdDesign: Design;
  /** The updated design set. */
  designSet: Design;
};

/** Result of adding a new value to user onboarding. */
export type AddNewValueToUserOnboardingPayload = {
  __typename?: 'AddNewValueToUserOnboardingPayload';
  /** Whether the operation was successful. */
  success: Scalars['Boolean']['output'];
};

export type AddOn = {
  __typename?: 'AddOn';
  code?: Maybe<Scalars['String']['output']>;
};

export enum AddOnTierType {
  FLAT = 'flat',
  TIERED = 'tiered',
  VOLUME = 'volume'
}

export enum AddOnType {
  FIXED = 'fixed',
  USAGE = 'usage'
}

export type AddOnsType = {
  __typename?: 'AddOnsType';
  addOn?: Maybe<AddOn>;
  unitAmount?: Maybe<Scalars['Float']['output']>;
};

/** Response after adding a group to a project. */
export type AddProjectGroupPayload = {
  __typename?: 'AddProjectGroupPayload';
  /** The group that was added to the project. */
  group: TeamUserGroup;
};

/** Response after adding a user to a project. */
export type AddProjectUserPayload = {
  __typename?: 'AddProjectUserPayload';
  /** The team user that was added to the project. */
  member: TeamUser;
};

export type AddTeamToPaymentExperimentPayload = {
  __typename?: 'AddTeamToPaymentExperimentPayload';
  result: Scalars['Boolean']['output'];
};

export type AddTextInsightToMoodBoardInput = {
  /** @deprecated Use projectId instead */
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  /** Name of the competitor for group naming */
  competitorName: Scalars['String']['input'];
  /** Optional specific moodboard ID (if not provided, uses latest moodboard) */
  moodboardId?: InputMaybe<Scalars['Int']['input']>;
  /** Project ID for context @BreakingBad */
  projectId: Scalars['Int']['input'];
  /** Text content to add to moodboard */
  text: Scalars['String']['input'];
};

export type AddTextInsightToMoodBoardPayload = {
  __typename?: 'AddTextInsightToMoodBoardPayload';
  /** Whether a new group was created for this insight */
  groupCreated: Scalars['Boolean']['output'];
  /** ID of the group where text was added */
  groupId: Scalars['String']['output'];
  /** Hash of the moodboard for frontend access */
  moodboardHash: Scalars['String']['output'];
  /** ID of the moodboard where text was added */
  moodboardId: Scalars['Int']['output'];
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** ID of the created text card */
  textCardId: Scalars['String']['output'];
};

/** Response when adding typography to a brand kit. */
export type AddTypographyPayload = {
  __typename?: 'AddTypographyPayload';
  /** The newly added typography configuration. */
  typography: Typography;
};

/** Response after adding a user to a group. */
export type AddUserToGroupPayload = {
  __typename?: 'AddUserToGroupPayload';
  /** The updated group with the new member. */
  group: TeamUserGroup;
};

export type AddedDesignSize = {
  __typename?: 'AddedDesignSize';
  /** The AI resize it waits for: on AI_RESIZING. */
  aiResize?: Maybe<AiResizedSizeJob>;
  /** What adding it with the AI resize costs, in credits: on NEEDS_AI_RESIZE, AI_RESIZING and AI_RESIZE_IN_PROGRESS. */
  creditCost?: Maybe<Scalars['Int']['output']>;
  height: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** The size's hash: the new one when ADDED, the one the design has when EXISTS. */
  sizeHash?: Maybe<Scalars['String']['output']>;
  status: AddedDesignSizeStatus;
  width: Scalars['Int']['output'];
};

/**
 * How a size asked for ended: ADDED, laid out on the free resize path; EXISTS, the design already has a size of those
 * dimensions; NEEDS_AI_RESIZE, it needs the AI resize and nothing was written (ask again with spendCredits);
 * AI_RESIZING, the AI resize started and completeAiResizedSize adds the size; AI_RESIZE_IN_PROGRESS, it needs the AI
 * resize and waits for the one in progress on this design (one at a time: ask again once it is added); NEEDS_EDITOR, it
 * needs the AI resize on a design with several slides, so it is added in the editor.
 */
export enum AddedDesignSizeStatus {
  ADDED = 'ADDED',
  AI_RESIZE_IN_PROGRESS = 'AI_RESIZE_IN_PROGRESS',
  AI_RESIZING = 'AI_RESIZING',
  EXISTS = 'EXISTS',
  NEEDS_AI_RESIZE = 'NEEDS_AI_RESIZE',
  NEEDS_EDITOR = 'NEEDS_EDITOR'
}

export type AdditionalCreditsPayload = {
  __typename?: 'AdditionalCreditsPayload';
  credits: Array<Maybe<CreditPayload>>;
};

export type Addon = {
  __typename?: 'Addon';
  code: Scalars['String']['output'];
  currencies: Array<Maybe<Currency>>;
  name: Scalars['String']['output'];
  tierType?: Maybe<AddOnTierType>;
  tiers?: Maybe<Array<Tier>>;
};

export type AddonsUsage = {
  __typename?: 'AddonsUsage';
  addonsUsage?: Maybe<Array<AddonsUsageInfo>>;
  feedCredits: Scalars['Int']['output'];
  totalCredits: Scalars['Int']['output'];
  totalImpressions: Scalars['Int']['output'];
};

export type AddonsUsageInfo = {
  __typename?: 'AddonsUsageInfo';
  addonCode: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
  unitAmount: Scalars['Float']['output'];
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
};

export type AdjustmentLayerInput = {
  layerId: Scalars['ID']['input'];
  properties: Scalars['JSON']['input'];
};

export type AdminAdNetwork = {
  __typename?: 'AdminAdNetwork';
  adTag: Scalars['Boolean']['output'];
  cachebusterMacro: Scalars['String']['output'];
  clickTagMacro?: Maybe<Scalars['String']['output']>;
  html5: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
  teamId?: Maybe<Scalars['Int']['output']>;
  testOnly: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type AdminAiModel = {
  __typename?: 'AdminAiModel';
  daysUntilShutdown?: Maybe<Scalars['Int']['output']>;
  deprecationContext?: Maybe<Scalars['String']['output']>;
  deprecationDate?: Maybe<Scalars['String']['output']>;
  modelId: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  replacementModels?: Maybe<Array<Scalars['String']['output']>>;
  shutdownDate?: Maybe<Scalars['String']['output']>;
  status: AdminAiModelStatus;
  url?: Maybe<Scalars['String']['output']>;
  usedBy: Array<Scalars['String']['output']>;
};

export enum AdminAiModelStatus {
  DEPRECATED = 'DEPRECATED',
  OK = 'OK',
  SHUTDOWN = 'SHUTDOWN',
  SHUTTING_DOWN = 'SHUTTING_DOWN',
  UNKNOWN = 'UNKNOWN'
}

/** A team with a custom share-link domain and/or a notification From email (Share link & Custom branding). */
export type AdminBrandedTeam = {
  __typename?: 'AdminBrandedTeam';
  /** The share-link subdomain the team set (Share URL settings → Your subdomain name). */
  domain?: Maybe<Scalars['String']['output']>;
  /** Null until the domain has been checked once. */
  domainStatus?: Maybe<TeamBrandStatus>;
  /** Null until the email records have been checked once. */
  emailStatus?: Maybe<TeamBrandStatus>;
  /** The notification sender address the team set (Notification email → From Email). */
  fromEmail?: Maybe<Scalars['String']['output']>;
  /** Plan name, as on the admin team page. Null when Recurly could not be read for this team. */
  planName?: Maybe<Scalars['String']['output']>;
  /** Plan-group version, as on the admin team page. Null when Recurly could not be read for this team. */
  planVersion?: Maybe<Scalars['String']['output']>;
  teamId: Scalars['Int']['output'];
  teamName: Scalars['String']['output'];
};

/** What a listed team has set: each value keeps the teams that have it, whatever else they have. */
export enum AdminBrandedTeamBranding {
  DOMAIN = 'DOMAIN',
  DOMAIN_AND_FROM_EMAIL = 'DOMAIN_AND_FROM_EMAIL',
  FROM_EMAIL = 'FROM_EMAIL'
}

export type AdminBrandedTeamList = {
  __typename?: 'AdminBrandedTeamList';
  items: Array<AdminBrandedTeam>;
  /** The teams listed after this page: the whole list is the teams shown so far plus these. */
  remainingCount: Scalars['Int']['output'];
};

/** A check status to list: the TeamBrandStatus values, or NOT_CHECKED for a value the daily check has not reached yet. */
export enum AdminBrandedTeamStatusFilter {
  INVALID = 'INVALID',
  NOT_CHECKED = 'NOT_CHECKED',
  PENDING = 'PENDING',
  VALID = 'VALID'
}

export type AdminBulkAddDisposableEmailsResult = {
  __typename?: 'AdminBulkAddDisposableEmailsResult';
  addedCount: Scalars['Int']['output'];
  invalidEntries: Array<Scalars['String']['output']>;
  skippedCount: Scalars['Int']['output'];
  skippedDeletedCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type AdminCancellationReasons = {
  __typename?: 'AdminCancellationReasons';
  cancellationDate: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
  subscriptionId: Scalars['String']['output'];
  teamId?: Maybe<Scalars['Int']['output']>;
  teamOwnerEmail: Scalars['String']['output'];
  usersCount: Scalars['Int']['output'];
};

export enum AdminCancellationReasonsOrderBy {
  CANCELLATION_DATE = 'CANCELLATION_DATE',
  REASON = 'REASON',
  TEAM_ID = 'TEAM_ID'
}

export type AdminChatMessage = {
  __typename?: 'AdminChatMessage';
  /** The agent of the message's thread. */
  agentId?: Maybe<Scalars['String']['output']>;
  content: Scalars['JSON']['output'];
  createdAt: Scalars['String']['output'];
  generatedMedia?: Maybe<Array<AdminGeneratedMedia>>;
  id: Scalars['String']['output'];
  role: Scalars['String']['output'];
  /** The thread the message belongs to; a related read mixes several. */
  threadId?: Maybe<Scalars['String']['output']>;
};

/** A Copilot chat's sentiment as the sentiment sweep stored it. */
export type AdminChatSentiment = {
  __typename?: 'AdminChatSentiment';
  /** The current session's sentiment: positive, neutral, mixed or negative. Null until the thread is scored. */
  label?: Maybe<Scalars['String']['output']>;
  /**
   * The verdict on the latest finished session: successful, unsuccessful, unclear, recovered, blocked_by_plan,
   * declined_by_policy or abandoned.
   */
  outcome?: Maybe<Scalars['String']['output']>;
  /**
   * How an abandoned session's last turn ended: done_no_reaction, result_not_placed, agent_question, in_progress,
   * agent_silent or other. Null for any other outcome.
   */
  outcomeAbandonedAfter?: Maybe<Scalars['String']['output']>;
  outcomeDesignImageUrl?: Maybe<Scalars['String']['output']>;
  /** The design's render, scored 0-10 when the verdict was given. */
  outcomeDesignScore?: Maybe<Scalars['Float']['output']>;
  /**
   * What refused the request that session ended on: plan_excluded, billing_required, agent_refusal or
   * provider_moderation. Null when no gate did.
   */
  outcomeGate?: Maybe<Scalars['String']['output']>;
  outcomeJudgedAt?: Maybe<Scalars['String']['output']>;
  outcomeReason?: Maybe<Scalars['String']['output']>;
  /** What the user wanted in that session. */
  outcomeWanted?: Maybe<Scalars['String']['output']>;
  /** The user messages the sweep flagged, oldest first. */
  signals: Array<AdminChatSentimentSignal>;
  /** The chat's alert in Slack; null when none was posted. */
  slackUrl?: Maybe<Scalars['String']['output']>;
};

/** One user message the sentiment sweep flagged. */
export type AdminChatSentimentSignal = {
  __typename?: 'AdminChatSentimentSignal';
  /** What a complaint is about: broken, brief_miss, capability_gap, subjective, unrequested_change, blocked, slow or user_side. */
  cause?: Maybe<Scalars['String']['output']>;
  /** The words of the user's message that show the sentiment, kept only until the alert is posted or given up. */
  evidenceQuote?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** The Linear issue the complaint was filed or merged into, such as AIA-123. */
  linearIssueIdentifier?: Maybe<Scalars['String']['output']>;
  messageCreatedAt: Scalars['String']['output'];
  /** The message's id, as adminChatMessages returns it. */
  messageId: Scalars['String']['output'];
  /** How many times the user had already asked for what this message asks. */
  reAskCount: Scalars['Int']['output'];
  /** Why the scoring model flagged the message. */
  reason: Scalars['String']['output'];
  /** What the user asked for, when the cause is capability_gap. */
  requestedCapability?: Maybe<Scalars['String']['output']>;
  /** negative or positive */
  sentiment: Scalars['String']['output'];
  /** low, medium or high */
  severity: Scalars['String']['output'];
  /** Why it was not posted: capped, retry_expired, excluded or low_severity. */
  slackSkippedReason?: Maybe<Scalars['String']['output']>;
  /** The Slack message that carried the signal; null when it was never posted. */
  slackUrl?: Maybe<Scalars['String']['output']>;
  /** new, acknowledged, dismissed or issue_filed */
  status: Scalars['String']['output'];
  /** dry_run or file: a dry run's verdict filed nothing. */
  triageMode?: Maybe<Scalars['String']['output']>;
  triageReason?: Maybe<Scalars['String']['output']>;
  /** defect, preference or unclear; null until the triage judges the complaint. */
  triageVerdict?: Maybe<Scalars['String']['output']>;
};

/** One text the Chat Logs page displays, keyed by an id the page chooses. */
export type AdminChatTextInput = {
  id: Scalars['String']['input'];
  /** user or assistant */
  role: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type AdminChatTextTranslation = {
  __typename?: 'AdminChatTextTranslation';
  english: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type AdminChatThread = {
  __typename?: 'AdminChatThread';
  agentId?: Maybe<Scalars['String']['output']>;
  chatType: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastMessageAt?: Maybe<Scalars['String']['output']>;
  messageCount: Scalars['Int']['output'];
  metadata: Scalars['JSON']['output'];
  title?: Maybe<Scalars['String']['output']>;
  user?: Maybe<AdminChatUser>;
  userDeletedAt?: Maybe<Scalars['String']['output']>;
};

export type AdminChatThreadList = {
  __typename?: 'AdminChatThreadList';
  threads: Array<AdminChatThread>;
  total: Scalars['Int']['output'];
};

export type AdminChatTranslation = {
  __typename?: 'AdminChatTranslation';
  /** Some texts stayed untranslated because a translation call failed or left them out. */
  incomplete: Scalars['Boolean']['output'];
  /** ISO 639-1 code of the thread's main language; null when it could not be told. */
  mainLanguage?: Maybe<Scalars['String']['output']>;
  /** English for each text not already in English. Empty for an English thread. */
  translations: Array<AdminChatTextTranslation>;
};

export type AdminChatUser = {
  __typename?: 'AdminChatUser';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  teamId?: Maybe<Scalars['Int']['output']>;
  teamName?: Maybe<Scalars['String']['output']>;
};

export type AdminCutoutCredits = {
  __typename?: 'AdminCutoutCredits';
  imageBalance: Scalars['Float']['output'];
  lowCreditsThreshold: Scalars['Int']['output'];
  monthBalance: Scalars['Float']['output'];
  monthExpireDate: Scalars['String']['output'];
  monthStartDate: Scalars['String']['output'];
  totalBalance: Scalars['Float']['output'];
};

export type AdminDesign = {
  __typename?: 'AdminDesign';
  createdByUser?: Maybe<DesignAuthor>;
  createdDate: Scalars['Date']['output'];
  /** Soft-delete timestamp. Non-null means the design was trashed directly. */
  deletedAt?: Maybe<Scalars['Date']['output']>;
  folder?: Maybe<Scalars['String']['output']>;
  hash: Scalars['String']['output'];
  height: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  lastModifiedAt?: Maybe<Scalars['Date']['output']>;
  lastModifiedByUser?: Maybe<DesignAuthor>;
  /** True when the design has no live location left in this listing's scope: every project_designs link is parent-deleted, link-deleted, or in a deleted workspace (without its own deletedAt necessarily set). */
  locationTrashed: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  project: AdminProjectDesign;
  /** Public-share hash. Use with `/share/d/<publicHash>` to open the design preview link in admin contexts. */
  publicHash: Scalars['String']['output'];
  teamId: Scalars['Int']['output'];
  /** True when the design is marked as a template (appears in user templates listing). */
  template: Scalars['Boolean']['output'];
  thumbnail?: Maybe<Scalars['String']['output']>;
  type: AdminDesignMetaData;
  width: Scalars['Float']['output'];
};

export type AdminDesignList = {
  __typename?: 'AdminDesignList';
  designs: Array<AdminDesign>;
  pageInfo: PageInfo;
  projects: Array<AdminProjectDesign>;
};

export type AdminDesignMetaData = {
  __typename?: 'AdminDesignMetaData';
  category?: Maybe<Scalars['String']['output']>;
  isDesignSet: Scalars['Boolean']['output'];
  setCount: Scalars['Int']['output'];
  unit: Scalars['String']['output'];
};

/** Moderation state for a single design, for the reviewer working #phishing-alerts-review. */
export type AdminDesignModeration = {
  __typename?: 'AdminDesignModeration';
  /** False once the design has been deactivated (soft-deleted) — nothing serves it. */
  active: Scalars['Boolean']['output'];
  createdByUser?: Maybe<DesignAuthor>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  /** Effective demotion: demoted AND not exempt. What the share panel shows the customer. */
  forcedTeamOnly: Scalars['Boolean']['output'];
  hash: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isDesignSet: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Web-Risk-confirmed full block. */
  phishingBlocked: Scalars['Boolean']['output'];
  /** Admin-set "allow unsafe URLs" — suppresses enforcement, detection still alerts. */
  phishingEnforceExempt: Scalars['Boolean']['output'];
  /** Scanner-applied team-only demotion. */
  phishingShareTeamOnly: Scalars['Boolean']['output'];
  /** Open the customer-facing preview: `${VITE_APP_URL}/share/d/<publicHash>`. */
  publicHash: Scalars['String']['output'];
  /** The design's own visibility. Enforcement never changes this. */
  publicStatus: PublicStatus;
  /** Set parent, when this design is one size of a multi-size set. */
  setId?: Maybe<Scalars['Int']['output']>;
  teamId: Scalars['Int']['output'];
  /** Flags still open (pending_review / blocked), newest first. */
  urlFlags: Array<AdminDesignUrlFlag>;
};

export enum AdminDesignQueryType {
  ACCOUNT_ID = 'ACCOUNT_ID',
  DESIGN_HASH = 'DESIGN_HASH',
  DESIGN_NAME = 'DESIGN_NAME',
  EMAIL = 'EMAIL',
  TEAM_ID = 'TEAM_ID'
}

export type AdminDesignSample = {
  __typename?: 'AdminDesignSample';
  /** Which size elementCount/textChars describe — the square when there is one. */
  anchorRole: Scalars['String']['output'];
  bridges: Array<AdminDesignSampleBridge>;
  category?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  /** Net of every standing verdict — display and history only; the review status decides. */
  curationScore: Scalars['Int']['output'];
  disabled: Scalars['Boolean']['output'];
  elementCount: Scalars['Int']['output'];
  feedback: AdminDesignSampleFeedback;
  /** Every version of this set, oldest first — itself included. */
  lineage: Array<AdminDesignSampleVersion>;
  myReason?: Maybe<DesignSampleRejectReason>;
  /** The acting admin's own standing verdict, if any. */
  myVerdict?: Maybe<Scalars['Int']['output']>;
  /** Distinct preset reasons across every standing rejection. */
  reasons: Array<DesignSampleRejectReason>;
  retrievable: Scalars['Boolean']['output'];
  reviewStatus: DesignSampleReviewStatus;
  sampleId: Scalars['String']['output'];
  sizes: Array<AdminDesignSampleSize>;
  /** The platform design-set hash the sample was ingested from (null for payload-only ingests). */
  sourceSetHash?: Maybe<Scalars['String']['output']>;
  sourceTeamId?: Maybe<Scalars['Int']['output']>;
  sourceType: DesignSampleSourceType;
  /** Pipeline status (pending | processing | ready | failed) — distinct from the review status. */
  status: Scalars['String']['output'];
  textChars: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
  verdictCount: Scalars['Int']['output'];
  verdicts: Array<AdminDesignSampleVerdict>;
  /** Which snapshot of the set this row is. */
  version: Scalars['Int']['output'];
};

/** Where a layout puts the four parts a resize card places, and how its copy and main image relate. */
export type AdminDesignSampleArrangement = {
  __typename?: 'AdminDesignSampleArrangement';
  copy?: Maybe<AdminDesignSampleZone>;
  /** over | off | partial: where the copy sits against the main image; null without either. */
  copyOverlap?: Maybe<Scalars['String']['output']>;
  /** full | partial | none: the main image's share of the canvas. */
  coverage: Scalars['String']['output'];
  cta?: Maybe<AdminDesignSampleZone>;
  /** over | off | partial: where the call to action sits against the main image; null without either. */
  ctaOverlap?: Maybe<Scalars['String']['output']>;
  /** copy | media: which reads first; null when they do not sit apart. */
  lead?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<AdminDesignSampleZone>;
  /** over | off | partial: where the logo sits against the main image; null without either. */
  logoOverlap?: Maybe<Scalars['String']['output']>;
  media?: Maybe<AdminDesignSampleZone>;
};

/**
 * One element of a stored size, in the design's own CANVAS pixels.
 *
 * `x/y/w/h` is the canvas-clipped box the element SPANS. `points` is the footprint the sampler's
 * layout raster scores, already turned and cut to the canvas with the raster's own rule, so a
 * consumer draws it as given and never re-derives a rotation. It is the painted polygon wherever the
 * sampler kept the layer's pre-rotation box; a tilted layer a clipping frame cuts is scored, and
 * drawn, as its span. For an upright layer the two are the same rectangle.
 */
export type AdminDesignSampleBox = {
  __typename?: 'AdminDesignSampleBox';
  /** Subjects only: the photo layer this focal region belongs to. */
  for?: Maybe<Scalars['String']['output']>;
  h: Scalars['Float']['output'];
  /**
   * The original layer id, shared by the element's counterparts in the set's other sizes. An
   * `anon-<n>` is synthesized for a layer with no id: an ordinal within this size, never an identity
   * across sizes. On a subject, `subject-<host layer id>`.
   */
  id: Scalars['String']['output'];
  /** The scored footprint's vertices, in drawing order. */
  points: Array<AdminDesignSamplePoint>;
  /**
   * Always null. An admin tab loaded before `points` still selects it, and a field the schema no longer
   * has would fail that tab's whole query.
   * @deprecated Use points.
   */
  r?: Maybe<Scalars['Float']['output']>;
  /**
   * Always null, for the same tabs as `r`.
   * @deprecated Use points.
   */
  rect?: Maybe<AdminDesignSampleBoxRect>;
  /** text | media | logo | cta | shape | subject. */
  role: Scalars['String']['output'];
  w: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
  /** Paint order after flattening. */
  z: Scalars['Int']['output'];
};

export type AdminDesignSampleBoxRect = {
  __typename?: 'AdminDesignSampleBoxRect';
  h: Scalars['Float']['output'];
  w: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

/**
 * The matcher's geometry for a sample's stored sizes — what retrieval scores,
 * drawn over the screenshots `adminDesignSamplePreview` answers.
 *
 * The elements are the NORMALIZED representation, not the raw layer tree:
 * hidden, off-canvas and micro layers are already gone and decorative fragments
 * are aggregated away, because that reduced set is what a match is scored on.
 * Photo focal areas ride along as `subject` elements.
 *
 * Only sizes that HAVE stored boxes are listed, and only for a sample whose
 * pipeline has settled. Admin-only for the same reason as the previews sibling:
 * the corpus is competitor design data.
 */
export type AdminDesignSampleBoxesPayload = {
  __typename?: 'AdminDesignSampleBoxesPayload';
  sampleId: Scalars['String']['output'];
  variants: Array<AdminDesignSampleVariantBoxes>;
};

export type AdminDesignSampleBridge = {
  __typename?: 'AdminDesignSampleBridge';
  elementMatchRatio: Scalars['Float']['output'];
  /** The orientation this conversion leaves FROM. */
  fromRole: Scalars['String']['output'];
  /** Whether the conversion clears the ops match-ratio floor retrieval applies. */
  retrievable: Scalars['Boolean']['output'];
  /** The orientation it converts INTO. */
  role: Scalars['String']['output'];
};

/**
 * The design's own canvas — the frame every box on it is measured in. Float, not Int: a design sized in
 * mm, cm or inches stores fractional pixels, and one such size must not null the whole payload.
 */
export type AdminDesignSampleCanvas = {
  __typename?: 'AdminDesignSampleCanvas';
  h: Scalars['Float']['output'];
  w: Scalars['Float']['output'];
};

/** How many samples sit in each review status under the current filters (the status filter itself excluded). */
export type AdminDesignSampleFacets = {
  __typename?: 'AdminDesignSampleFacets';
  approved: Scalars['Int']['output'];
  boosted: Scalars['Int']['output'];
  needsReview: Scalars['Int']['output'];
  rejected: Scalars['Int']['output'];
};

/** SAMPLE-chip retrieval judgments from the resize modal, tallied per direction. */
export type AdminDesignSampleFeedback = {
  __typename?: 'AdminDesignSampleFeedback';
  down: Scalars['Int']['output'];
  up: Scalars['Int']['output'];
};

/** ok is always true — a write that did not happen is an error here, not a quiet false. */
export type AdminDesignSampleFeedbackPayload = {
  __typename?: 'AdminDesignSampleFeedbackPayload';
  ok: Scalars['Boolean']['output'];
};

/** ok is always true — a write that did not happen is an error here, not a quiet false. */
export type AdminDesignSampleGradeFeedbackPayload = {
  __typename?: 'AdminDesignSampleGradeFeedbackPayload';
  ok: Scalars['Boolean']['output'];
};

export type AdminDesignSampleList = {
  __typename?: 'AdminDesignSampleList';
  facets: AdminDesignSampleFacets;
  rows: Array<AdminDesignSample>;
  total: Scalars['Int']['output'];
};

/** One ranked hit of a simulated retrieval. */
export type AdminDesignSampleMatch = {
  __typename?: 'AdminDesignSampleMatch';
  /** Which ANN channels proposed the hit. */
  channels: Array<Scalars['String']['output']>;
  /** The share of `rerank` that the sample's review status contributed. */
  curationBonus: Scalars['Float']['output'];
  /** With the OUTCOME retrieval: the layout family of the hit's conversion, as `outcome.families` names it; null otherwise. */
  family?: Maybe<Scalars['Int']['output']>;
  /** The raw rerank the pool is ordered by — curation bonus included. */
  rerank: Scalars['Float']['output'];
  sample: AdminDesignSample;
  /** Calibrated v3 score. */
  score: Scalars['Float']['output'];
  /** The size that matched the query — the layout a judgment of this hit is about. Null from a sampler that predates it. */
  source?: Maybe<AdminDesignSampleMatchedSize>;
  /** Per-trait shares of the score deficit (the sampler's v3 decomposition). */
  traits?: Maybe<Scalars['JSON']['output']>;
};

export type AdminDesignSampleMatchList = {
  __typename?: 'AdminDesignSampleMatchList';
  /** The OUTCOME retrieval's families; null for the REGULAR one. */
  outcome?: Maybe<AdminDesignSampleOutcome>;
  resolved: AdminDesignSampleResolvedQuery;
  /** With the OUTCOME retrieval: family by family, in `outcome.families` order. */
  rows: Array<AdminDesignSampleMatch>;
  timings?: Maybe<Scalars['JSON']['output']>;
  total: Scalars['Int']['output'];
};

/** One stored size of a sample, as retrieval matched it. */
export type AdminDesignSampleMatchedSize = {
  __typename?: 'AdminDesignSampleMatchedSize';
  height: Scalars['Int']['output'];
  role: Scalars['String']['output'];
  variantId: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

/** How the OUTCOME retrieval grouped the top matches, and which of the lane's cards grounds on each family. */
export type AdminDesignSampleOutcome = {
  __typename?: 'AdminDesignSampleOutcome';
  /** The families in the order the lane's cards take them, then those no card is offered, by rank. */
  families: Array<AdminDesignSampleOutcomeFamily>;
  /** Whether an auto-layout frame lays out the query's main image, which no card may then move. */
  flow: Scalars['Boolean']['output'];
  /** The prompt rules the families were judged against. */
  locks: Array<Scalars['String']['output']>;
  /** cutout | opaque | unknown: only a photo known to be opaque lets a card change its coverage or set copy on it. */
  photo: Scalars['String']['output'];
};

export type AdminDesignSampleOutcomeFamily = {
  __typename?: 'AdminDesignSampleOutcomeFamily';
  arrangement: AdminDesignSampleArrangement;
  /** The default-order rank of its best match. */
  bestRank: Scalars['Int']['output'];
  /** The rules among `requires` no card may lift: why no card is offered it. */
  blocked: Array<Scalars['String']['output']>;
  /** The 1-based card of a generation grounded on it; runs past the last card start over. Null when no card is offered it. */
  card?: Maybe<Scalars['Int']['output']>;
  /** The rows of this family carry it as `family`. */
  family: Scalars['Int']['output'];
  /** The prompt rules its conversions break, which its card lifts. */
  requires: Array<Scalars['String']['output']>;
  size: Scalars['Int']['output'];
};

export type AdminDesignSamplePoint = {
  __typename?: 'AdminDesignSamplePoint';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

/**
 * A sample's real renders, one per stored size.
 *
 * Admin-only, and the URLs are short-lived capabilities on private objects:
 * the corpus is competitor design data, so there is deliberately no
 * equivalent field on the app-facing schema.
 */
export type AdminDesignSamplePreviewPayload = {
  __typename?: 'AdminDesignSamplePreviewPayload';
  picks: AdminDesignSamplePreviewPicks;
  sampleId: Scalars['String']['output'];
  sourceType: Scalars['String']['output'];
  variants: Array<AdminDesignSampleScreenshot>;
};

/** Which variant to show per role — the same choice retrieval makes for a bridge. */
export type AdminDesignSamplePreviewPicks = {
  __typename?: 'AdminDesignSamplePreviewPicks';
  horizontal?: Maybe<Scalars['String']['output']>;
  /** The size the conversions below leave from. */
  source?: Maybe<Scalars['String']['output']>;
  square?: Maybe<Scalars['String']['output']>;
  vertical?: Maybe<Scalars['String']['output']>;
};

/** How the sampler interpreted designRef: a design, or a set resolved to one of its children. */
export type AdminDesignSampleResolvedQuery = {
  __typename?: 'AdminDesignSampleResolvedQuery';
  hash: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  kind: Scalars['String']['output'];
  role: Scalars['String']['output'];
  /**
   * The slide the ranking actually flattened — the first one, since the panel
   * has no slide picker. Reported so a judgment recorded here identifies the
   * same question the resize worker's judgments do (the golden set groups on
   * design + slide + bridge); null for a design with no slide.
   */
  slideId?: Maybe<Scalars['Int']['output']>;
  width: Scalars['Int']['output'];
};

/** One stored size of a sample, with a short-lived URL to its screenshot. */
export type AdminDesignSampleScreenshot = {
  __typename?: 'AdminDesignSampleScreenshot';
  expiresAt?: Maybe<Scalars['String']['output']>;
  height: Scalars['Int']['output'];
  role: Scalars['String']['output'];
  /** Presigned GET; null when this size has no screenshot yet. */
  url?: Maybe<Scalars['String']['output']>;
  variantId: Scalars['String']['output'];
  /** The SCREENSHOT's own pixels (retina-scaled), not the design's canvas. */
  width: Scalars['Int']['output'];
};

export type AdminDesignSampleSize = {
  __typename?: 'AdminDesignSampleSize';
  elementCount: Scalars['Int']['output'];
  height: Scalars['Int']['output'];
  role: Scalars['String']['output'];
  /** The variant row this size is — what a preview screenshot is keyed by. */
  variantId: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type AdminDesignSampleVariantBoxes = {
  __typename?: 'AdminDesignSampleVariantBoxes';
  canvas: AdminDesignSampleCanvas;
  elements: Array<AdminDesignSampleBox>;
  /**
   * The 0-based slide this size's screenshot shows. The boxes always describe the first slide, while the
   * screenshot is taken at the designer's fallback frame, which can sit on a later one.
   */
  picturedSlide: Scalars['Int']['output'];
  role: Scalars['String']['output'];
  variantId: Scalars['String']['output'];
};

/** One curator's standing verdict on the sample (2 boost, 1 approve, -1 reject). */
export type AdminDesignSampleVerdict = {
  __typename?: 'AdminDesignSampleVerdict';
  note?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<DesignSampleRejectReason>;
  updatedAt: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
  verdict: Scalars['Int']['output'];
};

/** One version of a set, as the card lists its history. */
export type AdminDesignSampleVersion = {
  __typename?: 'AdminDesignSampleVersion';
  createdAt: Scalars['String']['output'];
  /** Whether THIS version is the one retrieval serves. At most one per set. */
  retrievable: Scalars['Boolean']['output'];
  reviewStatus: DesignSampleReviewStatus;
  sampleId: Scalars['String']['output'];
  /** Pipeline status (pending | processing | ready | failed). */
  status: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

/** A part's box as shares of its canvas (0–1), so layouts of different sizes compare. */
export type AdminDesignSampleZone = {
  __typename?: 'AdminDesignSampleZone';
  h: Scalars['Float']['output'];
  w: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

/** A box on the canvas, in its px. */
export type AdminDesignScorerBox = {
  __typename?: 'AdminDesignScorerBox';
  height: Scalars['Float']['output'];
  width: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

/** One check at one scorer version: labels on an older implementation never ready a changed one. */
export type AdminDesignScorerCheckStats = {
  __typename?: 'AdminDesignScorerCheckStats';
  check: Scalars['String']['output'];
  findings: Scalars['Int']['output'];
  labelled: Scalars['Int']['output'];
  notReal: Scalars['Int']['output'];
  /** Of those, the ones whose element the review marked blocking. */
  opusBlocked: Scalars['Int']['output'];
  /** At least 80% real over at least 30 decided labels. */
  readyToCount: Scalars['Boolean']['output'];
  real: Scalars['Int']['output'];
  /** Findings on passes the review examined. */
  reviewedByOpus: Scalars['Int']['output'];
  /** The check's own revision: labels are counted per check and revision, across scorer versions that left it alone. */
  revision: Scalars['Int']['output'];
  /** The newest scorer version among these findings. */
  scorerVersion: Scalars['String']['output'];
  unclear: Scalars['Int']['output'];
};

export type AdminDesignScorerFinding = {
  __typename?: 'AdminDesignScorerFinding';
  /** What the finding outlines on the render, when its evidence carries a box (the design check). */
  box?: Maybe<AdminDesignScorerBox>;
  /** The check; on the design check, the reading (core.outOfCanvas.cutChars). */
  check: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  /** The plan id the finding names (text-1, cta, logo); on the design check, the element's id. */
  element: Scalars['String']['output'];
  environment: Scalars['String']['output'];
  height: Scalars['Float']['output'];
  issueKey: Scalars['String']['output'];
  label?: Maybe<DesignScorerFindingVerdict>;
  labelNote?: Maybe<Scalars['String']['output']>;
  /** The check's note: element ids and measurements, no copy. */
  message: Scalars['String']['output'];
  opus: DesignScorerOpusOutcome;
  scorerVersion: Scalars['String']['output'];
  shadowId: Scalars['ID']['output'];
  width: Scalars['Float']['output'];
};

export type AdminDesignScorerProviderCount = {
  __typename?: 'AdminDesignScorerProviderCount';
  provider: Scalars['String']['output'];
  ran: Scalars['Int']['output'];
};

export type AdminDesignScorerReview = {
  __typename?: 'AdminDesignScorerReview';
  checks: Array<AdminDesignScorerCheckStats>;
  /** The review passes read (newest first, at most 500). */
  passes: Scalars['Int']['output'];
  /** Unlabelled first, the ones the review kept leading; at most limit. */
  queue: Array<AdminDesignScorerFinding>;
  /** Totals over every pass read. */
  runSummary: AdminDesignScorerRunSummary;
  /** The newest review passes as A/B runs, at most 200. */
  runs: Array<AdminDesignScorerRun>;
};

/** One review pass of a layered generation: the Opus review beside the scorer's checks and its AI pass. */
export type AdminDesignScorerRun = {
  __typename?: 'AdminDesignScorerRun';
  /** The AI pass: off, ran, notMeasured or notSampled. */
  ai: Scalars['String']['output'];
  /** Questions the AI pass flagged at or above its arm's threshold. */
  aiFlags: Array<Scalars['String']['output']>;
  /** Why the AI pass measured nothing (no_key, image_size, timeout...). */
  aiReasons: Array<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  /** The deterministic pass: ran or notMeasured. An empty finding list means nothing unless it ran. */
  deterministic: Scalars['String']['output'];
  findings: Array<AdminDesignScorerRunFinding>;
  height: Scalars['Float']['output'];
  opus: DesignScorerOpusVerdict;
  /** Plan ids the review marked blocking. */
  opusBlocked: Array<Scalars['String']['output']>;
  /** Plan ids the review blocked that no scorer finding names. */
  opusOnly: Array<Scalars['String']['output']>;
  /** The arm that answered (provider/model), when the AI pass ran or tried. */
  provider?: Maybe<Scalars['String']['output']>;
  runId?: Maybe<Scalars['String']['output']>;
  scorerVersion: Scalars['String']['output'];
  shadowId: Scalars['ID']['output'];
  width: Scalars['Float']['output'];
};

export type AdminDesignScorerRunFinding = {
  __typename?: 'AdminDesignScorerRunFinding';
  check: Scalars['String']['output'];
  element: Scalars['String']['output'];
  /** The issue key (check:element:counterpart): unique within a pass. */
  key: Scalars['String']['output'];
  /** The review marked the same element blocking. */
  opusBlocked: Scalars['Boolean']['output'];
};

/** The A/B totals over the passes the review examined (not skipped). */
export type AdminDesignScorerRunSummary = {
  __typename?: 'AdminDesignScorerRunSummary';
  aiByProvider: Array<AdminDesignScorerProviderCount>;
  aiRan: Scalars['Int']['output'];
  /** Reviewed passes the review passed and the scorer measured and found nothing on. */
  bothQuiet: Scalars['Int']['output'];
  /** Reviewed passes the scorer measured, where the review blocked an element no scorer finding names. */
  opusOnly: Scalars['Int']['output'];
  opusRevise: Scalars['Int']['output'];
  reviewed: Scalars['Int']['output'];
  /** Reviewed passes with at least one scorer finding. */
  scorerFlagged: Scalars['Int']['output'];
  /** Reviewed passes where the deterministic pass measured nothing. */
  scorerUnmeasured: Scalars['Int']['output'];
};

export enum AdminDesignSortField {
  CREATED_AT = 'CREATED_AT',
  /** The creator's name, case-insensitive; a creator with no user left sorts as 'Deleted User'. */
  CREATED_BY = 'CREATED_BY',
  LAST_MODIFIED_AT = 'LAST_MODIFIED_AT',
  NAME = 'NAME',
  TEAM_ID = 'TEAM_ID'
}

/** One url-safety flag raised against the design — the evidence a reviewer judges a false positive on. */
export type AdminDesignUrlFlag = {
  __typename?: 'AdminDesignUrlFlag';
  carrier?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  /** What enforcement did for this flag, or why it was suppressed. */
  enforcementOutcome?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  suppressionReason?: Maybe<Scalars['String']['output']>;
  tier: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type AdminDisposableEmailConfig = {
  __typename?: 'AdminDisposableEmailConfig';
  blockingEnabled: Scalars['Boolean']['output'];
  deletedCount: Scalars['Int']['output'];
  lastSyncedAt?: Maybe<Scalars['Date']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type AdminDisposableEmailDomain = {
  __typename?: 'AdminDisposableEmailDomain';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  domain: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type AdminDisposableEmailListPage = {
  __typename?: 'AdminDisposableEmailListPage';
  items: Array<AdminDisposableEmailDomain>;
  totalCount: Scalars['Int']['output'];
};

export enum AdminDisposableEmailStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED'
}

export type AdminGeneratedMedia = {
  __typename?: 'AdminGeneratedMedia';
  kind: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type AdminLogResult = {
  __typename?: 'AdminLogResult';
  createdAt: Scalars['Date']['output'];
  email: Scalars['String']['output'];
  eventDescription?: Maybe<Scalars['String']['output']>;
  eventName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  info: AdminLogsInfo;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type AdminLogUser = {
  __typename?: 'AdminLogUser';
  email: Scalars['String']['output'];
};

export type AdminLogs = {
  __typename?: 'AdminLogs';
  pageInfo: PageInfo;
  result: Array<AdminLogResult>;
};

export type AdminLogsInfo = {
  __typename?: 'AdminLogsInfo';
  arguments: Scalars['JSON']['output'];
  impersonate?: Maybe<AdminLogsInfoImpersonate>;
  operation: AdminLogsInfoOperation;
  requiredRights?: Maybe<Scalars['String']['output']>;
  returnType?: Maybe<Scalars['String']['output']>;
  userRights?: Maybe<Scalars['String']['output']>;
};

export type AdminLogsInfoImpersonate = {
  __typename?: 'AdminLogsInfoImpersonate';
  id?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type AdminLogsInfoOperation = {
  __typename?: 'AdminLogsInfoOperation';
  name?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type AdminMutation = {
  __typename?: 'AdminMutation';
  /** @deprecated Not used */
  _empty?: Maybe<Scalars['String']['output']>;
  addAdditionalExportCredit: Scalars['Boolean']['output'];
  addAdminAdNetwork?: Maybe<AdminAdNetwork>;
  addAdminDisposableEmail: AdminDisposableEmailDomain;
  addAdminUrlSafetyEntry: AdminUrlSafetyListEntry;
  addAdminUser: AdminUser;
  addContentLibraryElement: ContentLibraryElement;
  addProductUpdate: Scalars['Int']['output'];
  addTopUpCredits: Scalars['Boolean']['output'];
  addTutorial: Scalars['Int']['output'];
  addTutorialCategory: Scalars['Int']['output'];
  /**
   * Starts the Copilot sentiment backfill for this environment's threads active since the given ISO date:
   * causes for signals scored before causes existed, the thread stamps and lifetime counts, an outcome for every
   * finished session without one, and the escalation of preferences in sessions that ended unaccepted. With
   * rejudgeUnsuccessfulBefore (ISO), it also judges again every unsuccessful verdict recorded before that instant,
   * so a session that ended on a plan, billing or content gate gets its gate outcome, and with rejudgeUnclearBefore
   * (ISO) every unclear verdict, so a session whose user left without downloading or coming back within a day becomes
   * abandoned. Runs in the background (its
   * result is logged as "[copilotSentiment] backfill finished") and is idempotent, so a rerun with the same
   * arguments continues where one stopped. Returns false when it did not start: capture is off here, a date is
   * not valid, or a backfill is already running.
   */
  adminBackfillCopilotSentiment: Scalars['Boolean']['output'];
  /** Record this admin's standing verdict on a corpus sample (approve, boost, reject with reason, or enable). */
  adminDesignSampleCuration: AdminDesignSample;
  /** Judge one ranked match: was this sample a good example for that query? */
  adminDesignSampleFeedback: AdminDesignSampleFeedbackPayload;
  /** Judge one grade: was that the right score for this conversion? */
  adminDesignSampleGradeFeedback: AdminDesignSampleGradeFeedbackPayload;
  /** Labels one finding; relabelling overwrites. The check, message and version are read from the pass, not sent. */
  adminLabelDesignScorerFinding: AdminDesignScorerFinding;
  /**
   * Posts today's Copilot sentiment digest so far to this environment's Slack channel, labelled as a manual run, so
   * a live test needs no overnight wait. It never counts as the daily digest: tomorrow's scheduled post still covers
   * the whole day. Main environments only: returns false when nothing was posted (a branch environment, Slack not
   * configured, or the post failed).
   */
  adminPostCopilotSentimentDigest: Scalars['Boolean']['output'];
  /**
   * Posts adminCopilotSentimentReleaseComparison's text to this environment's Slack channel, without the digest's
   * metadata, so it never starts the triage. Returns false when Slack is not configured.
   */
  adminPostCopilotSentimentReleaseComparison: Scalars['Boolean']['output'];
  /** Rank a single resize. Renders headless Chrome and (optionally) calls a vision judge — hence a mutation. Choose the saved-hash or the data overload, and which evaluation tiers run. */
  adminRankResize: ResizeRankingResult;
  /** Rank a pasted candidate against a saved reference size (reference resolved by hash, candidate supplied as JSON). */
  adminRankResizeAgainstSaved: ResizeRankingResult;
  /** Re-run the vision-gate evaluation for a design and SAVE the result as the new latest design score (append-only). */
  adminRescoreDesign: StoredDesignScore;
  /**
   * Runs one Copilot sentiment sweep in this environment now. Branch environments have no crons, so this is how
   * a branch switched on in Statsig copilot_sentiment_settings is scored; skipIdle scores threads without
   * waiting for the quiet window and judges sessions without waiting for the session gap, so a session still in
   * progress gets its verdict now and is not judged again when it really ends. For tests, not for prod.
   */
  adminRunCopilotSentimentSweep: CopilotSentimentSweepResult;
  /** Wizard-triggered AI-judge escalation (Opus) — fills ONLY the full channel. Rejects when already judged unless force. */
  adminWatchdogJudge: AdminWatchdogEvaluation;
  /** Re-run the deterministic evaluation for one row from its stored provenance (overwrites the det channel only). Use to heal rows graded against stale/empty content once the real design exists. */
  adminWatchdogReevaluate: AdminWatchdogEvaluation;
  /** Regenerate expired/missing PNG snapshots from the stored JSONs and return fresh presigned URLs. */
  adminWatchdogRerender: AdminWatchdogEvaluation;
  /** Record the human review verdict for one evaluation (re-review overwrites; PENDING is not a valid target). */
  adminWatchdogReview: AdminWatchdogEvaluation;
  /** Manually awards a trial to a free team. Rejected when the team already has a live subscription. */
  awardTeamTrial: AwardTeamTrialPayload;
  /** Recompute layout signatures for SET-template children. Idempotent; safe to re-run. */
  backfillDesignLayoutSignatures: BackfillDesignLayoutSignaturesPayload;
  bulkAddAdminDisposableEmails: AdminBulkAddDisposableEmailsResult;
  /**
   * @deprecated Migration service has been removed.
   * Bulk convert design sets to templates.
   * For batch migration of design sets.
   * @deprecated Migration service has been removed
   */
  bulkConvertSetsToTemplate: Scalars['Boolean']['output'];
  /**
   * @deprecated Migration service has been removed.
   * Bulk convert single designs to templates.
   * For batch migration of individual designs.
   * @deprecated Migration service has been removed
   */
  bulkConvertSinglesToTemplate: Scalars['Boolean']['output'];
  changeEmail: Scalars['Boolean']['output'];
  clearAgentChats: ClearAgentChatsPayload;
  clearCreateAgentChats: ClearCreateAgentChatsPayload;
  cloneDesign: CloneDesignPayload;
  cloneDesignToTeam: CloneDesignToTeamPayload;
  cloneMoodBoard: CloneMoodBoardPayload;
  cloneProjectToTeam: CloneProjectToTeamPayload;
  createAgentLog: Scalars['Boolean']['output'];
  createUsageRestriction: UsageRestriction;
  /** Applies one restriction across many teams. Never partially throws — see BulkUsageRestrictionResult. */
  createUsageRestrictionsBulk: BulkUsageRestrictionResult;
  deleteContentLibraryElement: Scalars['Boolean']['output'];
  deleteContentLibrarySeparator: Scalars['Boolean']['output'];
  deleteCouponEligibilityCache: Scalars['Boolean']['output'];
  /** @deprecated Migration service has been removed */
  deleteMigration: Scalars['Boolean']['output'];
  deleteNextgenAiTemplate: Scalars['Boolean']['output'];
  deleteProductUpdate: Scalars['Boolean']['output'];
  deleteRedisStream: Scalars['Boolean']['output'];
  /**
   * Remove a font's backup once its repair has been accepted. Its own decision: while the backup
   * exists the repair is reversible from this page, so nothing deletes it automatically.
   */
  deleteStoredFontBackup: DeleteStoredFontBackupResult;
  deleteSubcategory: Scalars['Boolean']['output'];
  /**
   * Delete template categories from the database.
   * Permanently removes categories from the system.
   */
  deleteTemplateCategories: Scalars['Boolean']['output'];
  /**
   * Delete template tags from the database.
   * Permanently removes tags from the system.
   */
  deleteTemplateTags: Scalars['Boolean']['output'];
  /**
   * Delete templates from the database.
   * Permanently removes templates from the system.
   */
  deleteTemplates: Scalars['Boolean']['output'];
  deleteTutorial: Scalars['Boolean']['output'];
  deleteTutorialCategory: Scalars['Boolean']['output'];
  deleteUsageRestriction: Scalars['Boolean']['output'];
  disableTeamAdTags: TeamAdTags;
  duplicateDesigns: DuplicateDesignsPayload;
  editContentLibraryElement: ContentLibraryElement;
  editProductUpdate: Scalars['Boolean']['output'];
  editTeamUsageMonth: TeamImpressionsBilling;
  editTutorial: Scalars['Boolean']['output'];
  editTutorialCategory: Scalars['Boolean']['output'];
  enableAdobeAem: Scalars['Boolean']['output'];
  enableAdvancedCss: Scalars['Boolean']['output'];
  enableBynder: Scalars['Boolean']['output'];
  enableCloudinary: Scalars['Boolean']['output'];
  enableCmyk: Scalars['Boolean']['output'];
  enableCreatopy20: Scalars['Boolean']['output'];
  enableFrontify: Scalars['Boolean']['output'];
  enableOrangeLogic: Scalars['Boolean']['output'];
  enableRealTimeDataFeedSourceTypes: Scalars['Boolean']['output'];
  enableSharePoint: Scalars['Boolean']['output'];
  enableStickyAdsAccess: Scalars['Boolean']['output'];
  enableTeamAdTags: TeamAdTags;
  enableVeeva: Scalars['Boolean']['output'];
  enforceTeamTwoFactor: Scalars['Boolean']['output'];
  exportSetThumbnailAdmin: ExportSetThumbnailPayload;
  /** Fix media assets with URL issues (admin only). */
  fixMediaFromUrl: FixMediaFromUrl;
  /** @deprecated Migration service has been removed */
  fixMigratedTeamDesignsCustomFonts: Scalars['Boolean']['output'];
  generateDesignSetVideoThumbnailsAdmin?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Regenerate color information for all templates.
   * Analyzes template images and extracts dominant colors.
   */
  generateTemplateColors: Scalars['Boolean']['output'];
  invalidatePayment: InvalidatePaymentPayload;
  logTeamCreditsToRecurly: Scalars['Boolean']['output'];
  logTeamUsageToRecurly: Scalars['Boolean']['output'];
  markTeamUsageRecurlyBilled: TeamImpressionsBilling;
  /**
   * Migrate operation - deprecated
   * @deprecated Migration service has been removed
   */
  migrate: Scalars['Boolean']['output'];
  /** @deprecated Brand template migration service has been removed. @BreakingBad */
  migrateBrandTemplates: Scalars['Boolean']['output'];
  moveCacheJsons: MoveCacheJsonsPayload;
  moveTeam: MoveTeamPayload;
  moveUsages: Scalars['Boolean']['output'];
  orderTutorial: Scalars['Boolean']['output'];
  orderTutorialCategory: Scalars['Boolean']['output'];
  parseTemplates: ParseTemplates;
  publishContentLibrary: Scalars['Boolean']['output'];
  /** Publish google fonts */
  publishFontsJson: Scalars['Boolean']['output'];
  publishProductUpdate: Scalars['String']['output'];
  publishTutorial: Tutorial;
  removeAdminDisposableEmail: Scalars['Boolean']['output'];
  removeAdminUrlSafetyEntry: Scalars['Boolean']['output'];
  removeAdminUser: Scalars['Boolean']['output'];
  removeSuccessManager: Scalars['Boolean']['output'];
  removeUnusedSSL: Scalars['Boolean']['output'];
  /**
   * Rewrite ONE stored font file so the browsers' sanitizer stops refusing it. Upload-time repair
   * (#5890, #6052, #6183) cannot help a file already in the bucket, and such a file fails every
   * capture that uses it. Inspects by default and writes only when "apply" is set.
   */
  repairStoredFont: RepairStoredFontResult;
  resendEmailChange: Scalars['Boolean']['output'];
  /** Reset the multiple session for a user (if there are errors with this) */
  resetMultipleSession: Scalars['Boolean']['output'];
  resetRedisStream: Scalars['Boolean']['output'];
  /**
   * Set a team's design counter so the free-plan quota can be exercised more than
   * once (PLA-489). The counter is monotonic in the product, so without this
   * every quota test consumes a team permanently. Refuses outside local, test,
   * dev and staging.
   */
  resetTeamDesignCount: TeamDesignCount;
  restoreAdminDisposableEmail: AdminDisposableEmailDomain;
  restoreAdminUrlSafetyEntry: AdminUrlSafetyListEntry;
  /**
   * Put a font's original bytes back, from the copy its first repair set aside — the way back from a
   * repair whose result is wrong for the customer. Does NOT check that the restored bytes load:
   * putting back a file the browsers refuse is the point. The CDN still caches the key, so purge it
   * afterwards. The backup is kept, so a restore can be repeated.
   */
  restoreStoredFont: RestoreStoredFontResult;
  /** @deprecated Migration service has been removed */
  retryAssetsMigration: Scalars['Boolean']['output'];
  saveContentLibrarySeparator: ContentLibraryElement;
  saveContentLibrarySubcategory?: Maybe<ContentLibraryCategory>;
  /** Reversible takedown / restore. Deactivating also disables the ad tag, since the hosted embed has no serve-time check. */
  setAdminDesignActive: AdminDesignModeration;
  /** False-positive unblock: exempts the design and clears both enforcement states. Detection keeps alerting. */
  setAdminDesignPhishingExempt: AdminDesignModeration;
  /** Visibility override. Independent of the phishing flags — use the exemption to clear a false positive. */
  setAdminDesignPublicStatus: AdminDesignModeration;
  setAdminDisposableEmailBlocking: AdminDisposableEmailConfig;
  setDesignSizeTypeId: Scalars['Boolean']['output'];
  setFeatureAccess: Scalars['Boolean']['output'];
  setFeedCloudbedsApiKey: Scalars['Boolean']['output'];
  /** Set email confirmation status in Intercom for a user. */
  setIntercomEmailConfirmation: SetIntercomEmailConfirmationPayload;
  setNextgenAiTemplatePublishStatus: Scalars['Boolean']['output'];
  setTwoFactorAdmin: Scalars['Boolean']['output'];
  signUploadUrlAdmin: SignUploadUrlResult;
  syncSubscriptionSeats: SyncSubscriptionPayload;
  syncSubscriptionWithRecurly: SyncSubscriptionPayload;
  toggleApiAccess: Scalars['Boolean']['output'];
  toggleBrandedShareLink: Scalars['Boolean']['output'];
  toggleTeamSettingsFeatureAccess: Scalars['Boolean']['output'];
  undoEmailChange: Scalars['Boolean']['output'];
  updateAcquiredReseller: Scalars['Boolean']['output'];
  /** @deprecated Not used */
  updateAdServingAccess: Scalars['Boolean']['output'];
  updateAdminAdNetwork?: Maybe<AdminAdNetwork>;
  updateAdminUser: AdminUser;
  updateAgentSystemPrompt: Scalars['Boolean']['output'];
  updateAiResizeModel: AiResizeModelPayload;
  updateAiResizePrompt: AiResizePromptPayload;
  updateAllowWorkspacesWithoutBrandKit: Scalars['Boolean']['output'];
  updateCloneFromUrlStatus: Scalars['Boolean']['output'];
  updateCron: Cron;
  updateDesignSizeTypeTypes: Scalars['Boolean']['output'];
  updateDisableAutoBackgroundRemovalInLightEditor: Scalars['Boolean']['output'];
  updateDisableBrandKitInLightEditor: Scalars['Boolean']['output'];
  updateDisableEditorAutoSave: Scalars['Boolean']['output'];
  updateEnableLightEditorTranslateAllTexts: Scalars['Boolean']['output'];
  updateMaintenance: Scalars['Boolean']['output'];
  updateMonthlyAiCredits: Scalars['Boolean']['output'];
  updatePermanentFlag: UpdatePermanentFlagPayload;
  updateSuccessManager: Scalars['Boolean']['output'];
  updateTeamCredit: Scalars['Boolean']['output'];
  updateTeamExportCredit: Scalars['Boolean']['output'];
  updateTeamSettings: Scalars['Boolean']['output'];
  updateTeamWhiteLabelAccess: Scalars['Boolean']['output'];
  updateTeamWhiteLabeledIntegration: Scalars['Boolean']['output'];
  /**
   * Update the visibility status of template categories.
   * Controls where categories appear in the interface.
   */
  updateTemplateCategoriesStatus: Scalars['Boolean']['output'];
  /** Update template tags by hash script with provided data. */
  updateTemplateTagsByHash: Scalars['Boolean']['output'];
  /**
   * Update the app visibility status of templates.
   * Controls whether templates appear in the application.
   */
  updateTemplatesAppStatus: Scalars['Boolean']['output'];
  /**
   * Update the categories associated with templates.
   * Connects templates to specified categories.
   */
  updateTemplatesCategories: Scalars['Boolean']['output'];
  /**
   * Update the gallery visibility status of templates.
   * Controls whether templates appear in the public gallery.
   */
  updateTemplatesGalleryStatus: Scalars['Boolean']['output'];
  /**
   * Update the pin-to-top status of templates.
   * Controls whether templates are pinned to the top of listings.
   */
  updateTemplatesPinToTop: Scalars['Boolean']['output'];
  /**
   * Update the tags associated with templates.
   * Connects templates to specified tags.
   */
  updateTemplatesTags: Scalars['Boolean']['output'];
  /**
   * Update the use in create agent status of templates.
   * Controls whether templates are used in the Create Agent.
   */
  updateTemplatesUseInCreateAgent: Scalars['Boolean']['output'];
  updateTemporaryEnterprise: TeamSettings;
  updateTestAccountStatus: Scalars['Boolean']['output'];
  updateTestUserStatus: Scalars['Boolean']['output'];
  updateUsageRestriction: UsageRestriction;
  updateUseAppFileNaming: Scalars['Boolean']['output'];
  updateUserActiveStatus: Scalars['Boolean']['output'];
  updateV6CreditsPerSeat: Scalars['Boolean']['output'];
  /**
   * Create or update a template.
   * Handles both insertion of new templates and updates to existing ones.
   */
  upsertTemplate: AdminTemplateItemPayload;
  /**
   * Create or update a template category.
   * Handles both insertion of new categories and updates to existing ones.
   */
  upsertTemplateCategory: AdminTemplateCategoryItemPayload;
  /**
   * Create or update a template tag.
   * Handles both insertion of new tags and updates to existing ones.
   */
  upsertTemplateTag: AdminTemplateTagItemPayload;
  verifyUserEmail: Scalars['Boolean']['output'];
  writeOffTeamUsageRecurly: TeamImpressionsBilling;
};


export type AdminMutationAddAdditionalExportCreditArgs = {
  input: InputUpdateTeamCredit;
};


export type AdminMutationAddAdminAdNetworkArgs = {
  input: InputAddAdminAdNetwork;
};


export type AdminMutationAddAdminDisposableEmailArgs = {
  domain: Scalars['String']['input'];
};


export type AdminMutationAddAdminUrlSafetyEntryArgs = {
  input: InputAddAdminUrlSafetyEntry;
};


export type AdminMutationAddAdminUserArgs = {
  input: InputAddAdminUser;
};


export type AdminMutationAddContentLibraryElementArgs = {
  input: InputAddContentLibraryElement;
};


export type AdminMutationAddProductUpdateArgs = {
  input: InputAddProductUpdate;
};


export type AdminMutationAddTopUpCreditsArgs = {
  input: InputUpdateTeamCredit;
};


export type AdminMutationAddTutorialArgs = {
  input: InputAddTutorial;
};


export type AdminMutationAddTutorialCategoryArgs = {
  input: InputAddTutorialCategory;
};


export type AdminMutationAdminBackfillCopilotSentimentArgs = {
  rejudgeUnclearBefore?: InputMaybe<Scalars['String']['input']>;
  rejudgeUnsuccessfulBefore?: InputMaybe<Scalars['String']['input']>;
  since: Scalars['String']['input'];
};


export type AdminMutationAdminDesignSampleCurationArgs = {
  input: InputAdminDesignSampleCuration;
};


export type AdminMutationAdminDesignSampleFeedbackArgs = {
  input: InputAdminDesignSampleFeedback;
};


export type AdminMutationAdminDesignSampleGradeFeedbackArgs = {
  input: InputAdminDesignSampleGradeFeedback;
};


export type AdminMutationAdminLabelDesignScorerFindingArgs = {
  input: InputAdminLabelDesignScorerFinding;
};


export type AdminMutationAdminPostCopilotSentimentReleaseComparisonArgs = {
  from: Scalars['String']['input'];
  releaseAt: Scalars['String']['input'];
  to: Scalars['String']['input'];
};


export type AdminMutationAdminRankResizeArgs = {
  input: InputAdminRankResize;
};


export type AdminMutationAdminRankResizeAgainstSavedArgs = {
  input: InputRankAgainstSaved;
};


export type AdminMutationAdminRescoreDesignArgs = {
  input: InputAdminEvalDesign;
};


export type AdminMutationAdminRunCopilotSentimentSweepArgs = {
  skipIdle?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AdminMutationAdminWatchdogJudgeArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
};


export type AdminMutationAdminWatchdogReevaluateArgs = {
  id: Scalars['Int']['input'];
};


export type AdminMutationAdminWatchdogRerenderArgs = {
  id: Scalars['Int']['input'];
};


export type AdminMutationAdminWatchdogReviewArgs = {
  input: InputAdminWatchdogReview;
};


export type AdminMutationAwardTeamTrialArgs = {
  input: InputAwardTeamTrial;
};


export type AdminMutationBackfillDesignLayoutSignaturesArgs = {
  input: InputBackfillDesignLayoutSignatures;
};


export type AdminMutationBulkAddAdminDisposableEmailsArgs = {
  domains: Array<Scalars['String']['input']>;
};


export type AdminMutationBulkConvertSetsToTemplateArgs = {
  input: InputBulkConvertSetsToTemplate;
};


export type AdminMutationBulkConvertSinglesToTemplateArgs = {
  input: InputBulkConvertSinglesToTemplate;
};


export type AdminMutationChangeEmailArgs = {
  input: InputChangeEmail;
};


export type AdminMutationClearAgentChatsArgs = {
  input: InputClearAgentChats;
};


export type AdminMutationClearCreateAgentChatsArgs = {
  input: InputClearCreateAgentChats;
};


export type AdminMutationCloneDesignArgs = {
  input: InputCloneDesign;
};


export type AdminMutationCloneDesignToTeamArgs = {
  input: InputCloneDesignToTeam;
};


export type AdminMutationCloneMoodBoardArgs = {
  input: InputCloneMoodBoard;
};


export type AdminMutationCloneProjectToTeamArgs = {
  input: InputCloneProjectToTeam;
};


export type AdminMutationCreateAgentLogArgs = {
  input: InputCreateAgentLog;
};


export type AdminMutationCreateUsageRestrictionArgs = {
  input: InputCreateUsageRestriction;
};


export type AdminMutationCreateUsageRestrictionsBulkArgs = {
  input: InputCreateUsageRestrictionsBulk;
};


export type AdminMutationDeleteContentLibraryElementArgs = {
  input: InputDeleteContentLibraryElement;
};


export type AdminMutationDeleteContentLibrarySeparatorArgs = {
  input: InputDeleteContentLibrarySeparator;
};


export type AdminMutationDeleteCouponEligibilityCacheArgs = {
  input: InputDeleteCouponEligibilityCache;
};


export type AdminMutationDeleteMigrationArgs = {
  input: InputDeleteMigration;
};


export type AdminMutationDeleteNextgenAiTemplateArgs = {
  input: InputDeleteNextgenAiTemplates;
};


export type AdminMutationDeleteProductUpdateArgs = {
  input: InputDeleteProductUpdate;
};


export type AdminMutationDeleteRedisStreamArgs = {
  input: InputDeleteRedisStream;
};


export type AdminMutationDeleteStoredFontBackupArgs = {
  input: InputDeleteStoredFontBackup;
};


export type AdminMutationDeleteSubcategoryArgs = {
  input: InputDeleteSubcategory;
};


export type AdminMutationDeleteTemplateCategoriesArgs = {
  input: InputDeleteTemplateCategories;
};


export type AdminMutationDeleteTemplateTagsArgs = {
  input: InputDeleteTemplateTags;
};


export type AdminMutationDeleteTemplatesArgs = {
  input: InputDeleteTemplates;
};


export type AdminMutationDeleteTutorialArgs = {
  input: InputDeleteTutorial;
};


export type AdminMutationDeleteTutorialCategoryArgs = {
  input: InputDeleteTutorialCategory;
};


export type AdminMutationDeleteUsageRestrictionArgs = {
  input: InputDeleteUsageRestriction;
};


export type AdminMutationDisableTeamAdTagsArgs = {
  input: InputGetTeam;
};


export type AdminMutationDuplicateDesignsArgs = {
  input: InputDuplicateDesigns;
};


export type AdminMutationEditContentLibraryElementArgs = {
  input: InputEditContentLibraryElement;
};


export type AdminMutationEditProductUpdateArgs = {
  input: InputEditProductUpdate;
};


export type AdminMutationEditTeamUsageMonthArgs = {
  input: InputEditTeamUsageMonth;
};


export type AdminMutationEditTutorialArgs = {
  input: InputEditTutorial;
};


export type AdminMutationEditTutorialCategoryArgs = {
  input: InputEditTutorialCategory;
};


export type AdminMutationEnableAdobeAemArgs = {
  input: InputAdobeAem;
};


export type AdminMutationEnableAdvancedCssArgs = {
  input: InputEnableAdvancedCss;
};


export type AdminMutationEnableBynderArgs = {
  input: InputBynder;
};


export type AdminMutationEnableCloudinaryArgs = {
  input: InputCloudinary;
};


export type AdminMutationEnableCmykArgs = {
  input: InputCmyk;
};


export type AdminMutationEnableCreatopy20Args = {
  input: InputEnableCreatopy20;
};


export type AdminMutationEnableFrontifyArgs = {
  input: InputFrontify;
};


export type AdminMutationEnableOrangeLogicArgs = {
  input: InputOrangeLogic;
};


export type AdminMutationEnableRealTimeDataFeedSourceTypesArgs = {
  input: InputEnableRealTimeDataFeedSourceTypes;
};


export type AdminMutationEnableSharePointArgs = {
  input: InputSharePoint;
};


export type AdminMutationEnableStickyAdsAccessArgs = {
  input: InputStickyAdsAccess;
};


export type AdminMutationEnableTeamAdTagsArgs = {
  input: InputGetTeam;
};


export type AdminMutationEnableVeevaArgs = {
  input: InputVeeva;
};


export type AdminMutationEnforceTeamTwoFactorArgs = {
  input: TeamTwoFactor;
};


export type AdminMutationExportSetThumbnailAdminArgs = {
  input: InputExportSetThumbnail;
};


export type AdminMutationFixMediaFromUrlArgs = {
  input: FixMediaFromUrlInput;
};


export type AdminMutationFixMigratedTeamDesignsCustomFontsArgs = {
  input: InputFixMigratedTeamDesignsCustomFonts;
};


export type AdminMutationGenerateDesignSetVideoThumbnailsAdminArgs = {
  input: InputGenerateDesignSetVideoThumbnails;
};


export type AdminMutationInvalidatePaymentArgs = {
  input: InputInvalidatePayment;
};


export type AdminMutationMarkTeamUsageRecurlyBilledArgs = {
  input: InputMarkTeamUsageRecurlyBilled;
};


export type AdminMutationMigrateArgs = {
  input: InputMigrationStart;
};


export type AdminMutationMigrateBrandTemplatesArgs = {
  input: InputMigrateMultipleBrandTemplates;
};


export type AdminMutationMoveCacheJsonsArgs = {
  input?: InputMaybe<InputMoveCacheJsons>;
};


export type AdminMutationMoveTeamArgs = {
  input: InputMoveTeam;
};


export type AdminMutationOrderTutorialArgs = {
  input: InputOrderTutorial;
};


export type AdminMutationOrderTutorialCategoryArgs = {
  input: InputOrderTutorialCategory;
};


export type AdminMutationParseTemplatesArgs = {
  input: InputParseTemplates;
};


export type AdminMutationPublishFontsJsonArgs = {
  input: InputPublishFontsJson;
};


export type AdminMutationPublishProductUpdateArgs = {
  input: InputPublishProductUpdate;
};


export type AdminMutationPublishTutorialArgs = {
  input: InputPublishTutorial;
};


export type AdminMutationRemoveAdminDisposableEmailArgs = {
  id: Scalars['Int']['input'];
};


export type AdminMutationRemoveAdminUrlSafetyEntryArgs = {
  id: Scalars['Int']['input'];
};


export type AdminMutationRemoveAdminUserArgs = {
  input: InputRemoveAdminUser;
};


export type AdminMutationRemoveSuccessManagerArgs = {
  input: InputRemoveSuccessManager;
};


export type AdminMutationRepairStoredFontArgs = {
  input: InputRepairStoredFont;
};


export type AdminMutationResendEmailChangeArgs = {
  input: InputUserUserId;
};


export type AdminMutationResetMultipleSessionArgs = {
  input: InputResetMultipleSession;
};


export type AdminMutationResetRedisStreamArgs = {
  input: InputResetRedisStream;
};


export type AdminMutationResetTeamDesignCountArgs = {
  input: InputResetTeamDesignCount;
};


export type AdminMutationRestoreAdminDisposableEmailArgs = {
  id: Scalars['Int']['input'];
};


export type AdminMutationRestoreAdminUrlSafetyEntryArgs = {
  id: Scalars['Int']['input'];
};


export type AdminMutationRestoreStoredFontArgs = {
  input: InputRestoreStoredFont;
};


export type AdminMutationRetryAssetsMigrationArgs = {
  input: InputMigrate;
};


export type AdminMutationSaveContentLibrarySeparatorArgs = {
  input: InputSaveContentLibrarySeparator;
};


export type AdminMutationSaveContentLibrarySubcategoryArgs = {
  input: InputSaveContentLibrarySubcategory;
};


export type AdminMutationSetAdminDesignActiveArgs = {
  active: Scalars['Boolean']['input'];
  designId: Scalars['Int']['input'];
};


export type AdminMutationSetAdminDesignPhishingExemptArgs = {
  designId: Scalars['Int']['input'];
  exempt: Scalars['Boolean']['input'];
};


export type AdminMutationSetAdminDesignPublicStatusArgs = {
  designId: Scalars['Int']['input'];
  publicStatus: PublicStatus;
};


export type AdminMutationSetAdminDisposableEmailBlockingArgs = {
  blockingEnabled: Scalars['Boolean']['input'];
};


export type AdminMutationSetDesignSizeTypeIdArgs = {
  input: InputSetDesignSizeTypeId;
};


export type AdminMutationSetFeatureAccessArgs = {
  input: InputSetFeatureAccess;
};


export type AdminMutationSetFeedCloudbedsApiKeyArgs = {
  input: InputSetFeedCloudbedsApiKey;
};


export type AdminMutationSetNextgenAiTemplatePublishStatusArgs = {
  input: InputSetNextgenAiTemplatesPublishStatus;
};


export type AdminMutationSetTwoFactorAdminArgs = {
  input: InputAdminTwoFactor;
};


export type AdminMutationSignUploadUrlAdminArgs = {
  input: InputSignUploadUrl;
};


export type AdminMutationSyncSubscriptionSeatsArgs = {
  input: InputSyncSubscriptionWithRecurly;
};


export type AdminMutationSyncSubscriptionWithRecurlyArgs = {
  input: InputSyncSubscriptionWithRecurly;
};


export type AdminMutationToggleApiAccessArgs = {
  input: InputApiAccess;
};


export type AdminMutationToggleBrandedShareLinkArgs = {
  input: InputBrandedShareLink;
};


export type AdminMutationToggleTeamSettingsFeatureAccessArgs = {
  input: InputToggleTeamSettingsFeatureAccess;
};


export type AdminMutationUndoEmailChangeArgs = {
  input: InputUserUserId;
};


export type AdminMutationUpdateAcquiredResellerArgs = {
  input: AcquiredReseller;
};


export type AdminMutationUpdateAdServingAccessArgs = {
  input: InputAdServingAccess;
};


export type AdminMutationUpdateAdminAdNetworkArgs = {
  input: InputUpdateAdminAdNetwork;
};


export type AdminMutationUpdateAdminUserArgs = {
  input: InputUpdateAdminUser;
};


export type AdminMutationUpdateAgentSystemPromptArgs = {
  input: InputUpdateAgentSystemPrompt;
};


export type AdminMutationUpdateAiResizeModelArgs = {
  input: InputUpdateAiResizeModel;
};


export type AdminMutationUpdateAiResizePromptArgs = {
  input: InputUpdateAiResizePrompt;
};


export type AdminMutationUpdateAllowWorkspacesWithoutBrandKitArgs = {
  input: InputUpdateAllowWorkspacesWithoutBrandKit;
};


export type AdminMutationUpdateCloneFromUrlStatusArgs = {
  input: InputUpdateCloneFromUrlStatus;
};


export type AdminMutationUpdateCronArgs = {
  input: InputUpdateCron;
};


export type AdminMutationUpdateDesignSizeTypeTypesArgs = {
  input: InputDesignSizeTypeTypes;
};


export type AdminMutationUpdateDisableAutoBackgroundRemovalInLightEditorArgs = {
  input: InputUpdateDisableAutoBackgroundRemovalInLightEditor;
};


export type AdminMutationUpdateDisableBrandKitInLightEditorArgs = {
  input: InputUpdateDisableBrandKitInLightEditor;
};


export type AdminMutationUpdateDisableEditorAutoSaveArgs = {
  input: InputUpdateDisableEditorAutoSave;
};


export type AdminMutationUpdateEnableLightEditorTranslateAllTextsArgs = {
  input: InputUpdateEnableLightEditorTranslateAllTexts;
};


export type AdminMutationUpdateMaintenanceArgs = {
  input: InputMaintenance;
};


export type AdminMutationUpdateMonthlyAiCreditsArgs = {
  input: InputUpdateTeamCredit;
};


export type AdminMutationUpdatePermanentFlagArgs = {
  input: InputUpdatePermanentFlag;
};


export type AdminMutationUpdateSuccessManagerArgs = {
  input: InputUpdateSuccessManager;
};


export type AdminMutationUpdateTeamCreditArgs = {
  input: InputUpdateTeamCredit;
};


export type AdminMutationUpdateTeamExportCreditArgs = {
  input: InputUpdateTeamCredit;
};


export type AdminMutationUpdateTeamSettingsArgs = {
  input: InputUpdateTeamSettings;
};


export type AdminMutationUpdateTeamWhiteLabelAccessArgs = {
  input: WhiteLabelAccess;
};


export type AdminMutationUpdateTeamWhiteLabeledIntegrationArgs = {
  input: WhiteLabeledIntegration;
};


export type AdminMutationUpdateTemplateCategoriesStatusArgs = {
  input: InputUpdateTemplateCategoriesStatus;
};


export type AdminMutationUpdateTemplateTagsByHashArgs = {
  input: Array<InputTemplateHashTag>;
};


export type AdminMutationUpdateTemplatesAppStatusArgs = {
  input: InputUpdateTemplatesStatus;
};


export type AdminMutationUpdateTemplatesCategoriesArgs = {
  input: InputUpdateTemplatesCategories;
};


export type AdminMutationUpdateTemplatesGalleryStatusArgs = {
  input: InputUpdateTemplatesStatus;
};


export type AdminMutationUpdateTemplatesPinToTopArgs = {
  input: InputUpdateTemplatesStatus;
};


export type AdminMutationUpdateTemplatesTagsArgs = {
  input: InputUpdateTemplatesTags;
};


export type AdminMutationUpdateTemplatesUseInCreateAgentArgs = {
  input: InputUpdateTemplatesStatus;
};


export type AdminMutationUpdateTemporaryEnterpriseArgs = {
  input: InputUpdateTemporaryEnterprise;
};


export type AdminMutationUpdateTestAccountStatusArgs = {
  input: InputUpdateTestAccountStatus;
};


export type AdminMutationUpdateTestUserStatusArgs = {
  input: InputUpdateTestUserStatus;
};


export type AdminMutationUpdateUsageRestrictionArgs = {
  input: InputUpdateUsageRestriction;
};


export type AdminMutationUpdateUseAppFileNamingArgs = {
  input: InputUpdateUseAppFileNaming;
};


export type AdminMutationUpdateUserActiveStatusArgs = {
  input: InputUpdateUserActiveStatus;
};


export type AdminMutationUpdateV6CreditsPerSeatArgs = {
  input: InputUpdateV6CreditsPerSeat;
};


export type AdminMutationUpsertTemplateArgs = {
  input: InputUpsertTemplate;
};


export type AdminMutationUpsertTemplateCategoryArgs = {
  input: InputUpsertTemplateCategory;
};


export type AdminMutationUpsertTemplateTagArgs = {
  input: InputUpsertTemplateTag;
};


export type AdminMutationVerifyUserEmailArgs = {
  input: InputVerifyUserEmail;
};


export type AdminMutationWriteOffTeamUsageRecurlyArgs = {
  input: InputWriteOffTeamUsageRecurly;
};

export type AdminNotesJsonLog = {
  __typename?: 'AdminNotesJsonLog';
  changeReason?: Maybe<Scalars['String']['output']>;
  changedAt: Scalars['Date']['output'];
  filePaths: Array<Scalars['String']['output']>;
  newEmail: Scalars['String']['output'];
  oldEmail: Scalars['String']['output'];
};

export type AdminNotesList = {
  __typename?: 'AdminNotesList';
  adminName: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  jsonLog?: Maybe<AdminNotesJsonLog>;
  textLog: Scalars['String']['output'];
  type: AdminNotesType;
};

export enum AdminNotesType {
  CHANGE_EMAIL = 'CHANGE_EMAIL',
  NOTE = 'NOTE'
}

export type AdminProjectDesign = {
  __typename?: 'AdminProjectDesign';
  id: Scalars['Int']['output'];
  isPersonal?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AdminProjectDetail = {
  __typename?: 'AdminProjectDetail';
  brandKitName?: Maybe<Scalars['String']['output']>;
  designsCount: Scalars['Int']['output'];
  foldersCount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  teamId: Scalars['Int']['output'];
  teamName?: Maybe<Scalars['String']['output']>;
};

export type AdminProjectList = {
  __typename?: 'AdminProjectList';
  projects: Array<AdminProjectDesign>;
};

export type AdminQuery = {
  __typename?: 'AdminQuery';
  /** @deprecated Not used */
  _empty?: Maybe<Scalars['String']['output']>;
  accounts: Array<Account>;
  adminAdNetwork: AdminAdNetwork;
  adminAdNetworks: Array<AdminAdNetwork>;
  adminAiModels: Array<AdminAiModel>;
  /**
   * The translation an earlier adminTranslateChatTexts left in ai-agents' cache for these texts, so the Chat Logs
   * page can open on it; null when any of it is not cached. Never runs a model call.
   */
  adminCachedChatTranslation?: Maybe<AdminChatTranslation>;
  adminChatMessages: Array<AdminChatMessage>;
  /** The Copilot sentiment stored for a chat; null when the sentiment sweep never scored it. */
  adminChatSentiment?: Maybe<AdminChatSentiment>;
  /** One thread as adminChatThreads lists it, for a chat log opened by its link. Null when there is no such thread. */
  adminChatThread?: Maybe<AdminChatThread>;
  adminChatThreads: AdminChatThreadList;
  /**
   * Translate the design with DeepL / OpenAI / Claude under the same Brandkit context,
   * then score all candidates with one fixed judge and rank them.
   * Opt in to deepl-legacy for the old Ad Studio DeepL baseline (no Brandkit options).
   */
  adminCompareTranslations: TranslationCompareResult;
  /**
   * Copilot product health and generation quality per 100 active threads before and after releaseAt, from the
   * stored causes and active thread-days, with the real-customer alerts of [from, to) by cause. Run
   * adminBackfillCopilotSentiment first so older complaints have causes and older days have active threads.
   * ISO dates; at most 31 days.
   */
  adminCopilotSentimentReleaseComparison: Scalars['String']['output'];
  adminCutoutCredits: AdminCutoutCredits;
  /** Allowlisted eval judges for the model picker. */
  adminDesignEvalModels: Array<DesignEvalModelOption>;
  /** Look a design up by the id-hash shown in the phishing Slack alert, or by its share-link hash. Includes deactivated designs. */
  adminDesignModeration?: Maybe<AdminDesignModeration>;
  /** Renderable target(s) for a design hash: itself for a plain design, or the child sizes for a design set. */
  adminDesignRenderTargets: Array<DesignRenderTarget>;
  /** The matcher's boxes per stored size, with photo focal areas among them as `subject` elements. */
  adminDesignSampleBoxes?: Maybe<AdminDesignSampleBoxesPayload>;
  /** Resize grade of one conversion of a corpus sample: json + html tiers, never the vision judge. Additionally gated on the resize_ranking_grade Statsig gate, fail-closed. Tracks the ranking ENGINE, not retrieval. */
  adminDesignSampleGrade: ResizeRankingResult;
  /** Simulate the resize lane's retrieval for a design and page through the whole reranked pool. */
  adminDesignSampleMatches: AdminDesignSampleMatchList;
  /** A sample's screenshots — every stored size, plus which to show per role. */
  adminDesignSamplePreview?: Maybe<AdminDesignSamplePreviewPayload>;
  /** Paginated corpus listing for the Design Samples grid. limit is server-capped at 60. */
  adminDesignSamples: AdminDesignSampleList;
  /**
   * One surface's passes (default LAYERED) of one environment (default master) within sinceDays (default 14, at most
   * 90). On CANVAS_LIVE a finding seen by many checks of the same design and slide is listed and counted once, and
   * runs are empty: there is no review to compare with.
   */
  adminDesignScorerReview: AdminDesignScorerReview;
  /** The rendered ad of one pass, presigned for 15 minutes; null when the snapshot has expired or has no render. */
  adminDesignScorerReviewImage?: Maybe<Scalars['String']['output']>;
  /** The child sizes (the copies) of a design set, in the same shape as the designs list. Includes trashed children so a trashed set can still be inspected. Gated with MANAGE_ACCOUNTS to match getDesignListByAdmin. */
  adminDesignSetChildren: Array<AdminDesign>;
  adminDisposableEmailConfig: AdminDisposableEmailConfig;
  adminDisposableEmails: AdminDisposableEmailListPage;
  /** The latest persisted vision-gate score for a design (its SET parent for crafted ads), or null if none was ever saved. */
  adminLatestDesignScore?: Maybe<StoredDesignScore>;
  /** Returns the list of unique events triggered */
  adminLogUniqueEvents: Array<Scalars['String']['output']>;
  /** Returns all admin logs */
  adminLogs: AdminLogs;
  adminMe: AdminUser;
  adminNotes: Array<AdminNotesList>;
  adminScoreDesign: DesignEvalResult;
  /**
   * Tells a thread's main language from the texts the Chat Logs page displays and, when it is not English,
   * translates them to English. Runs a model call per request: at most 600 texts of 20,000 characters each.
   */
  adminTranslateChatTexts: AdminChatTranslation;
  /** Allowlisted soft-dimension judges for Admin translation compare. */
  adminTranslationCompareJudges: Array<TranslationCompareJudgeOption>;
  /** Allowlisted translators for Admin translation compare. */
  adminTranslationCompareTranslators: Array<TranslationCompareTranslatorOption>;
  adminUrlSafetyEntries: AdminUrlSafetyListPage;
  /** Live entry count per list — the overview shown above the table. */
  adminUrlSafetyListCounts: Array<AdminUrlSafetyListCount>;
  adminUser: AdminUser;
  adminUsers: Array<AdminUser>;
  /** One evaluation with both result channels + presigned snapshot URLs — the wizard's per-row fetch. */
  adminWatchdogEvaluation: AdminWatchdogEvaluation;
  /** Paginated watchdog evaluations for the review table. limit is server-capped at 500. */
  adminWatchdogEvaluations: AdminWatchdogEvaluationList;
  aiResizeModel: AiResizeModelPayload;
  aiResizeModels: AiResizeModelsPayload;
  aiResizePrompt: AiResizePromptPayload;
  /** @deprecated Brand template migration service has been removed. @BreakingBad */
  checkBrandTemplatesMigrationStatus: BrandTemplatesMigrationStatusResult;
  contentLibraryCategories?: Maybe<Array<Maybe<ContentLibraryCategory>>>;
  contentLibrarySignUploadUrl: SignUploadUrlResult;
  /**
   * Count designs that `backfillDesignLayoutSignatures` would process with
   * the same `sourceType` and `onlyMissing` flags. Used by the admin UI to
   * show a `processed / total` progress display.
   */
  countDesignLayoutSignatureBackfillCandidates: Scalars['Int']['output'];
  /**
   * Get details of a design set.
   * For admin interface design set inspection.
   */
  designSetDetails: DesignSetDetailsPayload;
  designSizeTypes: Array<DesignSizeType>;
  feed: Scalars['JSON']['output'];
  getAddedAdditionalCredit: AdditionalCreditsPayload;
  getAgentSystemPrompt: Scalars['String']['output'];
  /** Returns all AI automated reports for a specific automated report schedule */
  getAiAutomatedReportsByScheduleId: Array<AiAutomatedReport>;
  /** Returns all AI automated reports for a specific team user */
  getAiAutomatedReportsByTeamUser: Array<AiAutomatedReport>;
  /** Teams with a custom share-link domain or a notification From email, highest team id first. */
  getBrandedTeamsByAdmin: AdminBrandedTeamList;
  getCancellationReasons: CancellationReasonsList;
  getCreditBalanceAdmin: CreditBalance;
  getCrons: Array<Cron>;
  getDesignListByAdmin: AdminDesignList;
  getFeatureAccess: FeatureAccessValue;
  getFeedCloudbedsApiKey: GetFeedCloudbedsApiKeyPayload;
  getGeneratedPassword: Scalars['String']['output'];
  getMaintenance: MaintenanceType;
  /** @deprecated Migration service has been removed */
  getMigrations: MigrationsPayload;
  getProjectDetailByAdmin?: Maybe<AdminProjectDetail>;
  getProjectListByAdmin: AdminProjectList;
  getRedisKey: RedisValue;
  getRedisStreams: RedisStreamsResult;
  getSignedMediaUrl: UploadUrlPayload;
  getSubscriptionPlan: SubscriptionPlan;
  getSuccessManagers: Array<AdminSuccessManager>;
  getTeamAdTags: TeamAdTags;
  getTeamByAdmin: AdminTeamDetails;
  getTeamCreditsReport: TeamCreditsReport;
  getTeamCurrentAiUsage: TeamCurrentAiUsage;
  getTeamCurrentPeriodUsage: TeamCurrentPeriodUsage;
  getTeamDesignsMonthlyReport: TeamDesignsMonthlyReport;
  getTeamImpressionsBilling: TeamImpressionsBilling;
  getTeamImpressionsReport: TeamImpressionsReport;
  getTeamRestrictionContextAdmin?: Maybe<TeamRestrictionContext>;
  getTeamTwoFactorAdmin: TeamTwoFactorResult;
  getTeamUserDesignsReport: TeamUserDesignsReport;
  getTeamsByAdmin: AdminTeamList;
  getTwoFactorAdmin: TwoFactorAdmin;
  getUsageRestriction?: Maybe<UsageRestriction>;
  getUsageRestrictions: UsageRestrictionPage;
  getUserByAdmin?: Maybe<AppUserType>;
  getUsersByAdmin: AdminUserList;
  getV6CreditsOverrideAdmin?: Maybe<V6CreditsOverride>;
  hashToId: HashToIdResponse;
  idToHash: IdToHashResponse;
  loadAdminNextgenAiTemplates: Array<NextgenAiAdminTemplate>;
  productUpdates: Array<UpdatesPayload>;
  signUploadUrl: SignUploadUrlResult;
  /** Whether a repair has set this font's original bytes aside, and when. Read-only. */
  storedFontBackup: StoredFontBackupResult;
  /**
   * Get all template categories.
   * For admin interface category management.
   */
  templateCategories: AdminTemplateCategoryPayload;
  /**
   * Get all template tags.
   * For admin interface tag management.
   */
  templateTags: AdminTemplateTagPayload;
  /**
   * Get all template tags with pagination.
   * For admin interface with large numbers of tags.
   */
  templateTagsPaged: AdminTemplateTagPaggedPayload;
  /**
   * Get all templates with filtering and pagination.
   * For admin interface template management.
   */
  templates: AdminTemplatePayload;
  thresholdAddonsUsage: ThresholdAddonsUsageRedis;
  tutorials: Array<Tutorial>;
  tutorialsCategories: Array<TutorialCategory>;
};


export type AdminQueryAdminAdNetworkArgs = {
  input: InputGetAdminAdNetwork;
};


export type AdminQueryAdminCachedChatTranslationArgs = {
  texts: Array<AdminChatTextInput>;
};


export type AdminQueryAdminChatMessagesArgs = {
  includeRelated?: InputMaybe<Scalars['Boolean']['input']>;
  threadId: Scalars['String']['input'];
};


export type AdminQueryAdminChatSentimentArgs = {
  threadId: Scalars['String']['input'];
};


export type AdminQueryAdminChatThreadArgs = {
  threadId: Scalars['String']['input'];
};


export type AdminQueryAdminChatThreadsArgs = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  chatType?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mainOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type AdminQueryAdminCompareTranslationsArgs = {
  input: InputAdminCompareTranslations;
};


export type AdminQueryAdminCopilotSentimentReleaseComparisonArgs = {
  from: Scalars['String']['input'];
  releaseAt: Scalars['String']['input'];
  to: Scalars['String']['input'];
};


export type AdminQueryAdminDesignModerationArgs = {
  hash: Scalars['String']['input'];
};


export type AdminQueryAdminDesignRenderTargetsArgs = {
  designHash: Scalars['String']['input'];
};


export type AdminQueryAdminDesignSampleBoxesArgs = {
  input: InputAdminDesignSampleBoxes;
};


export type AdminQueryAdminDesignSampleGradeArgs = {
  input: InputAdminDesignSampleGrade;
};


export type AdminQueryAdminDesignSampleMatchesArgs = {
  input: InputAdminDesignSampleMatches;
};


export type AdminQueryAdminDesignSamplePreviewArgs = {
  input: InputAdminDesignSamplePreview;
};


export type AdminQueryAdminDesignSamplesArgs = {
  filter?: InputMaybe<InputAdminDesignSamplesFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<DesignSampleSortField>;
  sortOrder?: InputMaybe<DesignSampleSortOrder>;
};


export type AdminQueryAdminDesignScorerReviewArgs = {
  environment?: InputMaybe<Scalars['String']['input']>;
  exclude?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sinceDays?: InputMaybe<Scalars['Int']['input']>;
  surface?: InputMaybe<DesignScorerReviewSurface>;
};


export type AdminQueryAdminDesignScorerReviewImageArgs = {
  shadowId: Scalars['ID']['input'];
};


export type AdminQueryAdminDesignSetChildrenArgs = {
  setHash: Scalars['String']['input'];
};


export type AdminQueryAdminDisposableEmailsArgs = {
  input: InputListAdminDisposableEmails;
};


export type AdminQueryAdminLatestDesignScoreArgs = {
  designHash: Scalars['String']['input'];
};


export type AdminQueryAdminLogsArgs = {
  input: InputAdminLogs;
};


export type AdminQueryAdminNotesArgs = {
  input: InputAdminNotes;
};


export type AdminQueryAdminScoreDesignArgs = {
  input: InputAdminEvalDesign;
};


export type AdminQueryAdminTranslateChatTextsArgs = {
  texts: Array<AdminChatTextInput>;
};


export type AdminQueryAdminUrlSafetyEntriesArgs = {
  input: InputListAdminUrlSafetyEntries;
};


export type AdminQueryAdminUserArgs = {
  input: InputGetAdminUser;
};


export type AdminQueryAdminWatchdogEvaluationArgs = {
  id: Scalars['Int']['input'];
};


export type AdminQueryAdminWatchdogEvaluationsArgs = {
  filter?: InputMaybe<InputAdminWatchdogEvaluationsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<ResizeWatchdogSortField>;
  sortOrder?: InputMaybe<ResizeWatchdogSortOrder>;
};


export type AdminQueryAiResizeModelArgs = {
  input: InputAiResizeModel;
};


export type AdminQueryCheckBrandTemplatesMigrationStatusArgs = {
  input: InputMigrateMultipleBrandTemplates;
};


export type AdminQueryContentLibrarySignUploadUrlArgs = {
  input: InputContentLibrarySignUploadUrl;
};


export type AdminQueryCountDesignLayoutSignatureBackfillCandidatesArgs = {
  onlyMissing?: InputMaybe<Scalars['Boolean']['input']>;
  sourceType?: InputMaybe<BackfillSignatureSourceType>;
};


export type AdminQueryDesignSetDetailsArgs = {
  input: InputDesignSetDetails;
};


export type AdminQueryFeedArgs = {
  input: InputAdminFeed;
};


export type AdminQueryGetAddedAdditionalCreditArgs = {
  input: InputGetTeam;
};


export type AdminQueryGetAgentSystemPromptArgs = {
  input: InputGetAgentSystemPrompt;
};


export type AdminQueryGetAiAutomatedReportsByScheduleIdArgs = {
  input: InputGetAiAutomatedReportsByScheduleId;
};


export type AdminQueryGetAiAutomatedReportsByTeamUserArgs = {
  input: InputGetAiAutomatedReportsByTeamUser;
};


export type AdminQueryGetBrandedTeamsByAdminArgs = {
  input: InputAdminBrandedTeams;
};


export type AdminQueryGetCancellationReasonsArgs = {
  input?: InputMaybe<InputAdminCancellationReasons>;
};


export type AdminQueryGetCreditBalanceAdminArgs = {
  input: InputGetTeam;
};


export type AdminQueryGetDesignListByAdminArgs = {
  input: InputAdminDesigns;
};


export type AdminQueryGetFeatureAccessArgs = {
  input: InputGetFeatureAccess;
};


export type AdminQueryGetFeedCloudbedsApiKeyArgs = {
  input: InputGetTeam;
};


export type AdminQueryGetMigrationsArgs = {
  input: InputMigrations;
};


export type AdminQueryGetProjectDetailByAdminArgs = {
  input: InputGetProjectDetail;
};


export type AdminQueryGetProjectListByAdminArgs = {
  input: InputAdminProjects;
};


export type AdminQueryGetRedisKeyArgs = {
  input: InputGetRedisKey;
};


export type AdminQueryGetRedisStreamsArgs = {
  input: InputGetRedisStreams;
};


export type AdminQueryGetSignedMediaUrlArgs = {
  input: InputSignUploadUrl;
};


export type AdminQueryGetSubscriptionPlanArgs = {
  input: InputSubscriptionPlan;
};


export type AdminQueryGetTeamAdTagsArgs = {
  input: InputGetTeam;
};


export type AdminQueryGetTeamByAdminArgs = {
  input: InputGetTeam;
};


export type AdminQueryGetTeamCreditsReportArgs = {
  input: InputTeamAnalyticsReport;
};


export type AdminQueryGetTeamCurrentAiUsageArgs = {
  teamId: Scalars['Int']['input'];
};


export type AdminQueryGetTeamCurrentPeriodUsageArgs = {
  teamId: Scalars['Int']['input'];
};


export type AdminQueryGetTeamDesignsMonthlyReportArgs = {
  input: InputTeamAnalyticsReport;
};


export type AdminQueryGetTeamImpressionsBillingArgs = {
  input: InputGetTeamImpressionsBilling;
};


export type AdminQueryGetTeamImpressionsReportArgs = {
  input: InputTeamAnalyticsReport;
};


export type AdminQueryGetTeamRestrictionContextAdminArgs = {
  input: InputGetTeam;
};


export type AdminQueryGetTeamTwoFactorAdminArgs = {
  input: InputTeamTwoFactor;
};


export type AdminQueryGetTeamUserDesignsReportArgs = {
  input: InputTeamAnalyticsReport;
};


export type AdminQueryGetTeamsByAdminArgs = {
  input: InputAdminTeams;
};


export type AdminQueryGetTwoFactorAdminArgs = {
  input: InputUserUserId;
};


export type AdminQueryGetUsageRestrictionArgs = {
  id: Scalars['Int']['input'];
};


export type AdminQueryGetUsageRestrictionsArgs = {
  includeExpired?: InputMaybe<Scalars['Boolean']['input']>;
  isTrial?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  teamId?: InputMaybe<Scalars['Int']['input']>;
};


export type AdminQueryGetUserByAdminArgs = {
  input: InputGetUserByAdmin;
};


export type AdminQueryGetUsersByAdminArgs = {
  input: InputGetUserList;
};


export type AdminQueryGetV6CreditsOverrideAdminArgs = {
  input: InputGetTeam;
};


export type AdminQueryHashToIdArgs = {
  input: InputHashToId;
};


export type AdminQueryIdToHashArgs = {
  input: InputIdToHash;
};


export type AdminQueryLoadAdminNextgenAiTemplatesArgs = {
  input: InputLoadNextgenAiTemplatesForCategory;
};


export type AdminQueryProductUpdatesArgs = {
  input?: InputMaybe<InputProductUpdate>;
};


export type AdminQuerySignUploadUrlArgs = {
  type: Scalars['String']['input'];
};


export type AdminQueryStoredFontBackupArgs = {
  input: InputStoredFontBackup;
};


export type AdminQueryTemplateCategoriesArgs = {
  input?: InputMaybe<InputTemplateCategoriesWebsite>;
};


export type AdminQueryTemplateTagsPagedArgs = {
  input: InputAdminTemplateTag;
};


export type AdminQueryTemplatesArgs = {
  input: InputAdminTemplates;
};


export type AdminQueryThresholdAddonsUsageArgs = {
  input: InputThresholdAddonsUsage;
};


export type AdminQueryTutorialsArgs = {
  input?: InputMaybe<InputTutorial>;
};

export enum AdminRights {
  MANAGE_ACCOUNTS = 'MANAGE_ACCOUNTS',
  MANAGE_ADMINISTRATORS = 'MANAGE_ADMINISTRATORS',
  MANAGE_ADMIN_LOGS = 'MANAGE_ADMIN_LOGS',
  MANAGE_AD_NETWORKS = 'MANAGE_AD_NETWORKS',
  MANAGE_AD_SERVING = 'MANAGE_AD_SERVING',
  MANAGE_AGENT = 'MANAGE_AGENT',
  MANAGE_AI_RESIZE = 'MANAGE_AI_RESIZE',
  /**
   * @deprecated Brand template migration service has been removed. @BreakingBad
   * @deprecated Brand template migration service has been removed. @BreakingBad
   */
  MANAGE_BRAND_TEMPLATES_MIGRATION = 'MANAGE_BRAND_TEMPLATES_MIGRATION',
  MANAGE_CONTENT_LIBRARY = 'MANAGE_CONTENT_LIBRARY',
  MANAGE_DESIGNS = 'MANAGE_DESIGNS',
  MANAGE_DESIGN_CLONES = 'MANAGE_DESIGN_CLONES',
  MANAGE_INTERNAL_TOOLS = 'MANAGE_INTERNAL_TOOLS',
  MANAGE_INVALIDATE_CACHE = 'MANAGE_INVALIDATE_CACHE',
  MANAGE_MAINTENANCE = 'MANAGE_MAINTENANCE',
  MANAGE_MIGRATIONS = 'MANAGE_MIGRATIONS',
  MANAGE_NEXT_GEN = 'MANAGE_NEXT_GEN',
  MANAGE_TEMPLATES = 'MANAGE_TEMPLATES',
  MANAGE_UPDATES = 'MANAGE_UPDATES',
  SUCCESS_MANAGER = 'SUCCESS_MANAGER'
}

export type AdminSuccessManager = {
  __typename?: 'AdminSuccessManager';
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AdminTeam = {
  __typename?: 'AdminTeam';
  id: Scalars['Int']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  ownerEmail: Scalars['String']['output'];
  planName?: Maybe<Scalars['String']['output']>;
};

export type AdminTeamDetails = {
  __typename?: 'AdminTeamDetails';
  accountManager?: Maybe<Scalars['Int']['output']>;
  aiCreditsLimit?: Maybe<Scalars['Int']['output']>;
  cloneFromUrl: Scalars['Boolean']['output'];
  credit?: Maybe<Scalars['Int']['output']>;
  debugAccessEnabled: Scalars['Boolean']['output'];
  editorStatus: Scalars['String']['output'];
  exportCredit?: Maybe<Scalars['BigInt']['output']>;
  id: Scalars['Int']['output'];
  isCreatopy20?: Maybe<Scalars['Boolean']['output']>;
  isCreditActive: Scalars['Boolean']['output'];
  isTrial: Scalars['Boolean']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  members: Array<AdminTeamMembers>;
  name: Scalars['String']['output'];
  ownerEmail: Scalars['String']['output'];
  /** Invitations not accepted yet, as the app's Team settings → Members lists them. */
  pendingInvitations: Array<AdminTeamInvitation>;
  planStatus: Scalars['String']['output'];
  planVersion: Scalars['String']['output'];
  registrationDate: Scalars['Date']['output'];
  teamSettings?: Maybe<TeamSettings>;
  teamUsers?: Maybe<Scalars['BigInt']['output']>;
  testAccount?: Maybe<Scalars['Boolean']['output']>;
  trialVariant?: Maybe<Variant>;
};

/** An invitation to the team that has not been accepted yet. Accepted invitations are deleted. */
export type AdminTeamInvitation = {
  __typename?: 'AdminTeamInvitation';
  /** True while a team manager still has to approve the invitation or join request; false once it only waits for the invitee to accept. */
  awaitingApproval: Scalars['Boolean']['output'];
  /** When the invitation was sent, in epoch milliseconds. */
  dateInvited: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** True when the invitee asked to join the team themselves, rather than being invited. */
  joinRequest: Scalars['Boolean']['output'];
  /** Name of the role the invitee will get. */
  role: Scalars['String']['output'];
  /** Id of the existing account registered with the invited email, or null when the invitee has no account yet. */
  userId?: Maybe<Scalars['String']['output']>;
};

export type AdminTeamList = {
  __typename?: 'AdminTeamList';
  pageInfo: PageInfo;
  teams: Array<AdminTeam>;
};

export type AdminTeamMembers = {
  __typename?: 'AdminTeamMembers';
  avatar?: Maybe<Scalars['String']['output']>;
  /** When the user joined the team, in epoch milliseconds. */
  dateAdded: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  role: Scalars['String']['output'];
};

export enum AdminTeamQueryType {
  ACCOUNT_ID = 'ACCOUNT_ID',
  BANNER_HASH = 'BANNER_HASH',
  EMAIL = 'EMAIL',
  SUCCESS_MANAGER = 'SUCCESS_MANAGER',
  TEAM_ID = 'TEAM_ID'
}

/**
 * Template category information for admin interface.
 * Includes reference count for administrative purposes.
 */
export type AdminTemplateCategoryItemPayload = {
  __typename?: 'AdminTemplateCategoryItemPayload';
  /** Unique ID for the category. */
  id: Scalars['Int']['output'];
  /** Machine-readable identifier for the category. */
  identifier: Scalars['String']['output'];
  /** Display name of the category. */
  name: Scalars['String']['output'];
  /** Number of templates using this category. */
  refCount?: Maybe<Scalars['Int']['output']>;
  /** Whether the category is visible in the app. */
  showInApp: Scalars['Boolean']['output'];
  /** Whether the category is visible in the gallery. */
  showInGallery: Scalars['Boolean']['output'];
};

/** Response payload for admin template categories query. */
export type AdminTemplateCategoryPayload = {
  __typename?: 'AdminTemplateCategoryPayload';
  /** List of template categories. */
  categories: Array<AdminTemplateCategoryItemPayload>;
};

/** Design information for admin template interface. */
export type AdminTemplateDesignPayload = {
  __typename?: 'AdminTemplateDesignPayload';
  /** When the design was created. */
  createdDate: Scalars['Date']['output'];
  /** ID of the design size type. */
  designSizeTypeId?: Maybe<Scalars['Int']['output']>;
  /** Unique hash identifier for the design. */
  hash: Scalars['String']['output'];
  /** Height of the design in pixels. */
  height: Scalars['Float']['output'];
  /** When the design was last modified. */
  lastModifiedAt?: Maybe<Scalars['Date']['output']>;
  /** Display name of the design. */
  name: Scalars['String']['output'];
  /** Public hash identifier for the design. */
  publicHash: Scalars['String']['output'];
  /** Width of the design in pixels. */
  width: Scalars['Float']['output'];
};

/** Design set information for admin template interface. */
export type AdminTemplateDesignSetPayload = {
  __typename?: 'AdminTemplateDesignSetPayload';
  /** ID of the design size type for this set. */
  designSizeTypeId?: Maybe<Scalars['Int']['output']>;
  /** Unique hash identifier for the design set. */
  hash: Scalars['String']['output'];
  /** Unique ID for the design set. */
  id: Scalars['Int']['output'];
  /** Display name of the design set. */
  name: Scalars['String']['output'];
  /** Public hash identifier for the design set. */
  publicHash: Scalars['String']['output'];
};

/**
 * Template information for admin interface.
 * Detailed template data with all related information.
 */
export type AdminTemplateItemPayload = {
  __typename?: 'AdminTemplateItemPayload';
  /** Category IDs associated with this template. */
  categoryIds: Array<Scalars['Int']['output']>;
  /** When the template was created. */
  createdAt: Scalars['Date']['output'];
  /** Design ID associated with this template. */
  designId: Scalars['Int']['output'];
  /** Design set this template belongs to. */
  designSet: AdminTemplateDesignSetPayload;
  /** Designs in this template. */
  designs: Array<AdminTemplateDesignPayload>;
  /** Whether the template is hidden in the Static section. */
  hideInStaticSection: Scalars['Boolean']['output'];
  /** Unique ID for the template. */
  id: Scalars['Int']['output'];
  /** Whether the template is pinned to the top. */
  pinToTop: Scalars['Boolean']['output'];
  /** Whether the template is visible in the app. */
  showInApp: Scalars['Boolean']['output'];
  /** Whether the template is visible in the gallery. */
  showInGallery: Scalars['Boolean']['output'];
  /** Tag IDs associated with this template. */
  tagIds: Array<Scalars['Int']['output']>;
  /** Total number of designs in this template. */
  totalDesignCount: Scalars['Int']['output'];
  /** When the template was last updated. */
  updatedAt: Scalars['Date']['output'];
  /** Whether the template is used in the Create Agent. */
  useInCreateAgent: Scalars['Boolean']['output'];
};

/** Response payload for admin templates query. */
export type AdminTemplatePayload = {
  __typename?: 'AdminTemplatePayload';
  /** List of template nodes matching the criteria. */
  nodes: Array<AdminTemplateItemPayload>;
  /** Current ordering configuration. */
  orderBy: AdminTemplatesOrderByPayload;
  /** Pagination information. */
  pageInfo: PageInfo;
  /** Total count of templates matching the criteria. */
  totalCount: Scalars['Int']['output'];
};

/**
 * Template tag information for admin interface.
 * Basic tag data without reference count.
 */
export type AdminTemplateTagItemPayload = {
  __typename?: 'AdminTemplateTagItemPayload';
  /** Unique ID for the tag. */
  id: Scalars['Int']['output'];
  /** Whether this tag represents a color. */
  isColor: Scalars['Boolean']['output'];
  /** Whether this tag represents a style. */
  isStyle: Scalars['Boolean']['output'];
  /** Display name of the tag. */
  name: Scalars['String']['output'];
  /** Whether the tag is visible in the app. */
  showInApp: Scalars['Boolean']['output'];
  /** Whether the tag is visible in the gallery. */
  showInGallery: Scalars['Boolean']['output'];
};

/**
 * Template tag information with reference count.
 * Used for detailed tag management in admin interface.
 */
export type AdminTemplateTagItemWithCountPayload = {
  __typename?: 'AdminTemplateTagItemWithCountPayload';
  /** Unique ID for the tag. */
  id: Scalars['Int']['output'];
  /** Whether this tag represents a color. */
  isColor: Scalars['Boolean']['output'];
  /** Whether this tag represents a style. */
  isStyle: Scalars['Boolean']['output'];
  /** Display name of the tag. */
  name: Scalars['String']['output'];
  /** Number of templates using this tag. */
  refCount: Scalars['Int']['output'];
  /** Whether the tag is visible in the app. */
  showInApp: Scalars['Boolean']['output'];
  /** Whether the tag is visible in the gallery. */
  showInGallery: Scalars['Boolean']['output'];
};

/**
 * Template tag information for admin interface with pagination.
 * Includes reference count for administrative purposes.
 */
export type AdminTemplateTagPaggedItemPayload = {
  __typename?: 'AdminTemplateTagPaggedItemPayload';
  /** Unique ID for the tag. */
  id: Scalars['Int']['output'];
  /** Whether this tag represents a color. */
  isColor: Scalars['Boolean']['output'];
  /** Whether this tag represents a style. */
  isStyle: Scalars['Boolean']['output'];
  /** Display name of the tag. */
  name: Scalars['String']['output'];
  /** Number of templates using this tag. */
  refCount: Scalars['Int']['output'];
  /** Whether the tag is visible in the app. */
  showInApp: Scalars['Boolean']['output'];
  /** Whether the tag is visible in the gallery. */
  showInGallery: Scalars['Boolean']['output'];
};

/** Response payload for paginated admin template tags query. */
export type AdminTemplateTagPaggedPayload = {
  __typename?: 'AdminTemplateTagPaggedPayload';
  /** Pagination information. */
  pageInfo: PageInfo;
  /** List of template tags with reference counts. */
  tags: Array<AdminTemplateTagPaggedItemPayload>;
  /** Total count of tags matching the criteria. */
  totalCount: Scalars['Int']['output'];
};

/** Response payload for admin template tags query. */
export type AdminTemplateTagPayload = {
  __typename?: 'AdminTemplateTagPayload';
  /** List of template tags with reference counts. */
  tags: Array<AdminTemplateTagItemWithCountPayload>;
};

/** Fields by which admin templates can be ordered. */
export enum AdminTemplatesOrderByFields {
  /** Order by app visibility status */
  APP_STATUS = 'APP_STATUS',
  /** Order by template name */
  BANNER_NAME = 'BANNER_NAME',
  /** Order by banner number */
  BANNER_NR = 'BANNER_NR',
  /** Order by category */
  CATEGORY = 'CATEGORY',
  /** Order by submission date */
  DATE_SUBMITTED = 'DATE_SUBMITTED',
  /** Order by gallery visibility status */
  GALLERY_STATUS = 'GALLERY_STATUS',
  /** Order by template hash */
  HASH = 'HASH',
  /** Order by size variation */
  SIZE_VARIATION = 'SIZE_VARIATION',
  /** Order by tag */
  TAG = 'TAG'
}

/** Order by information for admin templates listing. */
export type AdminTemplatesOrderByPayload = {
  __typename?: 'AdminTemplatesOrderByPayload';
  /** Field being used for ordering. */
  orderBy: AdminTemplatesOrderByFields;
  /** Direction of ordering. */
  orderType: OrderType;
};

export enum AdminUrlSafetyList {
  ALLOWLIST_DOMAIN = 'ALLOWLIST_DOMAIN',
  BRAND_DOMAIN = 'BRAND_DOMAIN',
  BRAND_TOKEN = 'BRAND_TOKEN',
  LURE_KEYWORD = 'LURE_KEYWORD',
  RISKY_TLD = 'RISKY_TLD',
  SHORTENER = 'SHORTENER',
  STORAGE_HOST = 'STORAGE_HOST'
}

export type AdminUrlSafetyListCount = {
  __typename?: 'AdminUrlSafetyListCount';
  count: Scalars['Int']['output'];
  list: AdminUrlSafetyList;
};

export type AdminUrlSafetyListEntry = {
  __typename?: 'AdminUrlSafetyListEntry';
  /** Only set for BRAND_DOMAIN — the brand whose official domain this is. */
  brand?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  list: AdminUrlSafetyList;
  /** Why the entry exists (an FP report, a ticket). */
  note?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type AdminUrlSafetyListPage = {
  __typename?: 'AdminUrlSafetyListPage';
  items: Array<AdminUrlSafetyListEntry>;
  totalCount: Scalars['Int']['output'];
};

export type AdminUser = {
  __typename?: 'AdminUser';
  authId: Scalars['String']['output'];
  confirmed: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  rights?: Maybe<AdminUserRights>;
  testUser: Scalars['Boolean']['output'];
};

export type AdminUserList = {
  __typename?: 'AdminUserList';
  pageInfo: PageInfo;
  users: Array<AppUserType>;
};

export enum AdminUserQueryType {
  ACCOUNT_ID = 'ACCOUNT_ID',
  EMAIL = 'EMAIL',
  TEAM_ID = 'TEAM_ID',
  USER_ID = 'USER_ID'
}

export type AdminUserRights = {
  __typename?: 'AdminUserRights';
  MANAGE_ACCOUNTS: Scalars['Boolean']['output'];
  MANAGE_ADMINISTRATORS: Scalars['Boolean']['output'];
  MANAGE_ADMIN_LOGS: Scalars['Boolean']['output'];
  MANAGE_AD_NETWORKS: Scalars['Boolean']['output'];
  MANAGE_AD_SERVING: Scalars['Boolean']['output'];
  MANAGE_AGENT: Scalars['Boolean']['output'];
  MANAGE_AI_RESIZE: Scalars['Boolean']['output'];
  /**
   * @deprecated Brand template migration service has been removed. @BreakingBad
   * @deprecated Brand template migration service has been removed. @BreakingBad
   */
  MANAGE_BRAND_TEMPLATES_MIGRATION: Scalars['Boolean']['output'];
  MANAGE_CONTENT_LIBRARY: Scalars['Boolean']['output'];
  MANAGE_DESIGNS: Scalars['Boolean']['output'];
  MANAGE_DESIGN_CLONES: Scalars['Boolean']['output'];
  MANAGE_INTERNAL_TOOLS: Scalars['Boolean']['output'];
  MANAGE_INVALIDATE_CACHE: Scalars['Boolean']['output'];
  MANAGE_MAINTENANCE: Scalars['Boolean']['output'];
  MANAGE_MIGRATIONS: Scalars['Boolean']['output'];
  MANAGE_NEXT_GEN: Scalars['Boolean']['output'];
  MANAGE_TEMPLATES: Scalars['Boolean']['output'];
  MANAGE_UPDATES: Scalars['Boolean']['output'];
  SUCCESS_MANAGER: Scalars['Boolean']['output'];
};

/** The wizard's full per-row fetch: everything, incl. both result channels + presigned snapshot URLs. */
export type AdminWatchdogEvaluation = {
  __typename?: 'AdminWatchdogEvaluation';
  /** Whether the captured candidate was ultimately applied by the user. */
  applied: Scalars['Boolean']['output'];
  blindVerdict?: Maybe<ResizeWatchdogBlindVerdict>;
  /** Null for GRADE_CANDIDATE rows (no live design). */
  candidateDesignId?: Maybe<Scalars['Int']['output']>;
  /** Null for GRADE_CANDIDATE rows (content-addressed, no live design). */
  candidateHash?: Maybe<Scalars['String']['output']>;
  candidateHeight: Scalars['Int']['output'];
  /** Generator label for GRADE_CANDIDATE rows: template | flex | smart | ai (from methodDetail.candidateSource). */
  candidateKind?: Maybe<Scalars['String']['output']>;
  /** Short-lived presigned GET URL (~15 min); null when the snapshot is missing/expired — the wizard offers rerender. */
  candidatePngUrl?: Maybe<Scalars['String']['output']>;
  candidateWidth: Scalars['Int']['output'];
  checksum: Scalars['String']['output'];
  comparatorInvoked?: Maybe<Scalars['Boolean']['output']>;
  configHash: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  detMeanScore?: Maybe<Scalars['Float']['output']>;
  detOverallScore: Scalars['Float']['output'];
  detResult: ResizeRankingResult;
  detVerdict: ResizeRankingVerdict;
  engineSha: Scalars['String']['output'];
  engineVersion: Scalars['String']['output'];
  evaluatedAt: Scalars['String']['output'];
  fullMeanScore?: Maybe<Scalars['Float']['output']>;
  fullOverallScore?: Maybe<Scalars['Float']['output']>;
  fullResult?: Maybe<ResizeRankingResult>;
  fullVerdict?: Maybe<ResizeRankingVerdict>;
  id: Scalars['Int']['output'];
  judgeModelId?: Maybe<Scalars['String']['output']>;
  judgeOk?: Maybe<Scalars['Boolean']['output']>;
  judgedAt?: Maybe<Scalars['String']['output']>;
  judgedBy?: Maybe<Scalars['Int']['output']>;
  methodDetail?: Maybe<Scalars['JSON']['output']>;
  promptHash?: Maybe<Scalars['String']['output']>;
  referenceChecksum?: Maybe<Scalars['String']['output']>;
  referenceDesignId?: Maybe<Scalars['Int']['output']>;
  referenceHash: Scalars['String']['output'];
  referenceIsFallback: Scalars['Boolean']['output'];
  referencePngUrl?: Maybe<Scalars['String']['output']>;
  renderOk: Scalars['Boolean']['output'];
  resizeCreatedAt: Scalars['String']['output'];
  resizeMethod: ResizeWatchdogMethod;
  reviewMode?: Maybe<ResizeWatchdogReviewMode>;
  reviewNote?: Maybe<Scalars['String']['output']>;
  reviewStatus: ResizeWatchdogReviewStatus;
  reviewTargetChannel?: Maybe<ResizeWatchdogReviewChannel>;
  reviewTargetVerdict?: Maybe<ResizeRankingVerdict>;
  reviewedAt?: Maybe<Scalars['String']['output']>;
  reviewedBy?: Maybe<Scalars['Int']['output']>;
  /** The reviewing admin's email, resolved lazily via the user dataloader — null when unreviewed or the user is gone. */
  reviewedByEmail?: Maybe<Scalars['String']['output']>;
  /** The hash the admin /designs search accepts: the candidate's SET hash (that search only matches set_id IS NULL rows), the candidate's own hash for standalone designs, null when the design row is gone. */
  setHash?: Maybe<Scalars['String']['output']>;
  teamId?: Maybe<Scalars['Int']['output']>;
  tiersRun: Array<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type AdminWatchdogEvaluationList = {
  __typename?: 'AdminWatchdogEvaluationList';
  rows: Array<AdminWatchdogEvaluationRow>;
  total: Scalars['Int']['output'];
};

/** Scalar-only list row — the table never fetches result payloads or image URLs (L14). */
export type AdminWatchdogEvaluationRow = {
  __typename?: 'AdminWatchdogEvaluationRow';
  /** Whether the captured candidate was ultimately applied by the user. */
  applied: Scalars['Boolean']['output'];
  /** Null for GRADE_CANDIDATE rows (content-addressed, no live design). */
  candidateHash?: Maybe<Scalars['String']['output']>;
  candidateHeight: Scalars['Int']['output'];
  /** Generator label for GRADE_CANDIDATE rows: template | flex | smart | ai (from methodDetail.candidateSource). */
  candidateKind?: Maybe<Scalars['String']['output']>;
  candidateWidth: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  /** The DISPLAYED grade — the uncapped weight-normalised mean (two-channel doctrine). */
  detMeanScore?: Maybe<Scalars['Float']['output']>;
  detOverallScore: Scalars['Float']['output'];
  detVerdict: ResizeRankingVerdict;
  engineVersion: Scalars['String']['output'];
  fullMeanScore?: Maybe<Scalars['Float']['output']>;
  fullVerdict?: Maybe<ResizeRankingVerdict>;
  id: Scalars['Int']['output'];
  judgeOk?: Maybe<Scalars['Boolean']['output']>;
  referenceHash: Scalars['String']['output'];
  referenceIsFallback: Scalars['Boolean']['output'];
  renderOk: Scalars['Boolean']['output'];
  resizeCreatedAt: Scalars['String']['output'];
  resizeMethod: ResizeWatchdogMethod;
  reviewMode?: Maybe<ResizeWatchdogReviewMode>;
  reviewStatus: ResizeWatchdogReviewStatus;
  reviewedAt?: Maybe<Scalars['String']['output']>;
  reviewedBy?: Maybe<Scalars['Int']['output']>;
  /** The reviewing admin's email, resolved lazily via the user dataloader — null when unreviewed or the user is gone. */
  reviewedByEmail?: Maybe<Scalars['String']['output']>;
  /** The hash the admin /designs search accepts: the candidate's SET hash (that search only matches set_id IS NULL rows), the candidate's own hash for standalone designs, null when the design row is gone. */
  setHash?: Maybe<Scalars['String']['output']>;
  teamId?: Maybe<Scalars['Int']['output']>;
  tiersRun: Array<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Individual message in an ads library chat session */
export type AdsLibraryChatMessage = {
  __typename?: 'AdsLibraryChatMessage';
  /** Message content (text content or JSON string) */
  content: Scalars['String']['output'];
  /** Unique message identifier */
  id: Scalars['ID']['output'];
  /** Whether this is a welcome briefing message */
  isWelcomeBrief?: Maybe<Scalars['Boolean']['output']>;
  /** Message parts (for multimodal content, Mastra UIMessage compatible) */
  parts?: Maybe<Array<MessagePart>>;
  /** Message role (user, assistant, system, tool) */
  role: Scalars['String']['output'];
  /** Session this message belongs to */
  sessionId: Scalars['ID']['output'];
  /** Message status (streaming, complete, error, cancelled) */
  status: Scalars['String']['output'];
  /** When the message was sent */
  timestamp: Scalars['String']['output'];
};

/** Ads library chat session information */
export type AdsLibraryChatSession = {
  __typename?: 'AdsLibraryChatSession';
  /** When the session was created */
  createdAt: Scalars['String']['output'];
  /** Unique session identifier */
  id: Scalars['ID']['output'];
  /** Total number of messages in the session */
  messageCount: Scalars['Int']['output'];
  /** Session title */
  title?: Maybe<Scalars['String']['output']>;
  /** When the session was last updated */
  updatedAt: Scalars['String']['output'];
};

/** Streaming payload for ads library chat responses */
export type AdsLibraryChatStreamPayload = {
  __typename?: 'AdsLibraryChatStreamPayload';
  /** Chunk of streaming response content */
  chunk: Scalars['String']['output'];
  /** Whether the streaming response is complete */
  done: Scalars['Boolean']['output'];
  /** Whether this is an existing message being loaded (vs new streaming content) */
  isExistingMessage?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this is a welcome brief message (auto-generated introduction) */
  isWelcomeBrief?: Maybe<Scalars['Boolean']['output']>;
  /** ID of the message being streamed */
  messageId?: Maybe<Scalars['String']['output']>;
  /** Role of the message (for existing messages) */
  role?: Maybe<Scalars['String']['output']>;
};

/** Response after snapshotting the master's sizes baseline. */
export type AdvanceSizesSyncBaselinePayload = {
  __typename?: 'AdvanceSizesSyncBaselinePayload';
  master: Design;
};

export type AdvertiserCm360 = {
  __typename?: 'AdvertiserCm360';
  accountId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type AdvertiserDv360 = {
  __typename?: 'AdvertiserDV360';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  partnerId: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type AdvertiserIdsInput = {
  facebook: Scalars['String']['input'];
  google: Scalars['String']['input'];
};

export type AdvertisersCm360Payload = {
  __typename?: 'AdvertisersCm360Payload';
  items: Array<AdvertiserCm360>;
};

export type AdvertisersDv360Payload = {
  __typename?: 'AdvertisersDV360Payload';
  items: Array<AdvertiserDv360>;
};

export type AdvertisersDv360Input = {
  email: Scalars['String']['input'];
  partnerId: Scalars['String']['input'];
  /** The team whose DV360 account to use, or the caller's own personal one */
  teamId: Scalars['Int']['input'];
};

export type AdvertisersInput = {
  /** @BreakingBad */
  email: Scalars['String']['input'];
  profileId: Scalars['String']['input'];
  /** The team whose CM360 account to use, or the caller's own personal one */
  teamId: Scalars['Int']['input'];
};

export enum AdvertisingChannelType {
  DEMAND_GEN = 'DEMAND_GEN',
  DISPLAY = 'DISPLAY',
  HOTEL = 'HOTEL',
  LOCAL = 'LOCAL',
  LOCAL_SERVICES = 'LOCAL_SERVICES',
  MULTI_CHANNEL = 'MULTI_CHANNEL',
  PERFORMANCE_MAX = 'PERFORMANCE_MAX',
  SEARCH = 'SEARCH',
  SHOPPING = 'SHOPPING',
  SMART = 'SMART',
  TRAVEL = 'TRAVEL',
  UNKNOWN = 'UNKNOWN',
  VIDEO = 'VIDEO'
}

/** A bound ISI's source converted to ISI rich text: an AEM Content Fragment (CRE-389) or a SharePoint document (CRE-706). */
export type AemContentFragmentIsi = {
  __typename?: 'AemContentFragmentIsi';
  /** Name for the ISI text layer: ISI: then the fragment title. */
  layerName: Scalars['String']['output'];
  /** What the editor acts on from the fragment's AEM metadata, each absent when AEM gives none the reader can read: expiresAt (a UTC ISO 8601 timestamp) and newerVersion, what replaces this source: { publishUrl } for an AEM fragment, { driveId, itemId } for a SharePoint document. */
  metadata: Scalars['JSON']['output'];
  /** JsonTextSlateConfigNode array for the layer config.nodes. */
  nodes: Scalars['JSON']['output'];
};

/** A placed AEM asset copied into The Brief's CDN (used when useAemDelivery is false). */
export type AemImportedAsset = {
  __typename?: 'AemImportedAsset';
  height?: Maybe<Scalars['Int']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

/** The result of processing after-join actions, including where to redirect the user. */
export type AfterJoinPayload = {
  __typename?: 'AfterJoinPayload';
  /** Optional hash of a design created during the after-join process. */
  designHash?: Maybe<Scalars['String']['output']>;
  /** URL where the user should be redirected after processing. */
  redirectUrl: Scalars['String']['output'];
};

/** Age range targeting for an ad */
export type AgeAudience = {
  __typename?: 'AgeAudience';
  /** Maximum age targeted */
  max: Scalars['Int']['output'];
  /** Minimum age targeted */
  min: Scalars['Int']['output'];
};

/** Age and gender distribution for a specific age range */
export type AgeGenderBreakdown = {
  __typename?: 'AgeGenderBreakdown';
  /** Age range (e.g., '18-24', '25-34') */
  ageRange: Scalars['String']['output'];
  /** Number of female users in this age range */
  female?: Maybe<Scalars['Int']['output']>;
  /** Number of male users in this age range */
  male?: Maybe<Scalars['Int']['output']>;
  /** Number of users with unknown gender in this age range */
  unknown?: Maybe<Scalars['Int']['output']>;
};

/** Age range definition (legacy audience analytics) */
export type AgeRange = {
  __typename?: 'AgeRange';
  /** Maximum age */
  max: Scalars['Int']['output'];
  /** Minimum age */
  min: Scalars['Int']['output'];
};

/** Age range statistics (legacy audience analytics) */
export type AgeRangeItem = {
  __typename?: 'AgeRangeItem';
  /** Count of users in this age range */
  count: Scalars['Int']['output'];
  /** Percentage of total audience */
  percentage: Scalars['Float']['output'];
  /** Age range (e.g., '18-24', '25-34') */
  range: Scalars['String']['output'];
};

export enum AgentType {
  CREATE = 'CREATE',
  INSPIRE = 'INSPIRE',
  LAUNCH = 'LAUNCH',
  LEARN = 'LEARN'
}

export type AiAgentAutomatedReportPayload = {
  __typename?: 'AiAgentAutomatedReportPayload';
  aiAgentAutomatedReportScheduleId: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  platform?: Maybe<AiAgentPlatform>;
  platformAccountId?: Maybe<Scalars['String']['output']>;
  platformAccountName?: Maybe<Scalars['String']['output']>;
  status: AiAgentAutomatedReportStatus;
  updatedAt: Scalars['Date']['output'];
};

export type AiAgentAutomatedReportSchedulePayload = {
  __typename?: 'AiAgentAutomatedReportSchedulePayload';
  createdAt: Scalars['Date']['output'];
  destination: AutomateCopilotAiReportDestination;
  email?: Maybe<Scalars['String']['output']>;
  frequency: AutomateCopilotAiReportFrequency;
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  isRecurring: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  platform: AiAgentPlatform;
  platformAccountId: Scalars['String']['output'];
  platformAccountName: Scalars['String']['output'];
  scheduleTime: Scalars['Date']['output'];
  updatedAt: Scalars['Date']['output'];
};

export enum AiAgentAutomatedReportStatus {
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS'
}

export type AiAgentAutomatedReportsDashboardPayload = {
  __typename?: 'AiAgentAutomatedReportsDashboardPayload';
  recentReports: Array<AiAgentAutomatedReportPayload>;
  reportSchedules: PaginatedAiAgentAutomatedReportSchedulePayload;
};

export enum AiAgentPlatform {
  GOOGLE_ADS = 'GOOGLE_ADS',
  META = 'META'
}

export type AiAutomatedReport = {
  __typename?: 'AiAutomatedReport';
  aiAgentAutomatedReportScheduleId: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  hash: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  password?: Maybe<Scalars['String']['output']>;
  publicStatus: Scalars['String']['output'];
  status: Scalars['String']['output'];
  teamUserId: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type AiChat = {
  __typename?: 'AiChat';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  messages: Array<AiChatMessage>;
  name: Scalars['String']['output'];
  options?: Maybe<ChatOptions>;
  projectId?: Maybe<Scalars['Int']['output']>;
  scope: ChatScope;
  sharedBy?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type AiChatContent = {
  data?: InputMaybe<Scalars['String']['input']>;
  hiddenToTheModel?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type AiChatMessage = {
  __typename?: 'AiChatMessage';
  content: Array<AiChatMessageContent>;
  feedback?: Maybe<CopilotAiChatMessageFeedback>;
  id?: Maybe<Scalars['String']['output']>;
  questionMessageId?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
};

export type AiChatMessageContent = {
  __typename?: 'AiChatMessageContent';
  data?: Maybe<Scalars['String']['output']>;
  hiddenToTheModel?: Maybe<Scalars['Boolean']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type AiChatsPayload = {
  __typename?: 'AiChatsPayload';
  pageInfo: PageInfo;
  result: Array<AiChat>;
};

export type AiFlowCreatorChatStreamPayload = {
  __typename?: 'AiFlowCreatorChatStreamPayload';
  assistantMessageId: Scalars['String']['output'];
  chatId: Scalars['Int']['output'];
  chunk: Scalars['String']['output'];
  done: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  questionMessageId?: Maybe<Scalars['String']['output']>;
  userMessageId: Scalars['String']['output'];
};

export enum AiGenerationRulesField {
  COPY = 'copy',
  DOSANDDONTS = 'dosAndDonts',
  LAYOUT = 'layout'
}

export type AiMailNotificationUserInfo = {
  __typename?: 'AiMailNotificationUserInfo';
  aiEmailNotificationsEnabled: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type AiOperationProgress = {
  __typename?: 'AiOperationProgress';
  percent: Scalars['Int']['output'];
  status: ImageGenerationStatus;
};

export type AiOperationUsage = {
  __typename?: 'AiOperationUsage';
  imagesGenerated: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  usage: Scalars['Int']['output'];
};

export enum AiProvider {
  AUTO_IMAGE = 'AUTO_IMAGE',
  BLACK_FOREST_FLUX = 'BLACK_FOREST_FLUX',
  GEMINI_3_1_FLASH_IMAGE = 'GEMINI_3_1_FLASH_IMAGE',
  GEMINI_OMNI = 'GEMINI_OMNI',
  GOOGLE_GEMINI = 'GOOGLE_GEMINI',
  GPT_IMAGE_2 = 'GPT_IMAGE_2',
  NANO_BANANA_PRO = 'NANO_BANANA_PRO',
  VEO3 = 'VEO3',
  VEO3_1_FIRST_LAST_FRAME = 'VEO3_1_FIRST_LAST_FRAME',
  VEO3_1_REFERENCE_TO_VIDEO = 'VEO3_1_REFERENCE_TO_VIDEO'
}

export type AiResizeModel = {
  __typename?: 'AiResizeModel';
  createdAt: Scalars['Date']['output'];
  fewShots: Scalars['Int']['output'];
  hasPrompt?: Maybe<Scalars['Boolean']['output']>;
  hasSystemPromptLandscape?: Maybe<Scalars['Boolean']['output']>;
  hasSystemPromptPortrait?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  model: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  platform: ResizePlatform;
  prompt?: Maybe<Scalars['String']['output']>;
  systemPromptLandscape?: Maybe<Scalars['String']['output']>;
  systemPromptPortrait?: Maybe<Scalars['String']['output']>;
  temperature: Scalars['Float']['output'];
  updatedAt: Scalars['Date']['output'];
  updatedBy: Scalars['String']['output'];
  useImage: Scalars['Boolean']['output'];
  variants: Scalars['Int']['output'];
};

export type AiResizeModelPayload = {
  __typename?: 'AiResizeModelPayload';
  model?: Maybe<AiResizeModel>;
};

export type AiResizeModelsPayload = {
  __typename?: 'AiResizeModelsPayload';
  models: Array<AiResizeModel>;
};

export type AiResizePayload = {
  __typename?: 'AiResizePayload';
  resizedJson?: Maybe<Scalars['JsonDesign']['output']>;
  resizedLayerInfo: Array<ResizeLayerInfo>;
  sourceJson?: Maybe<Scalars['JsonDesign']['output']>;
  sourceLayerInfo: Array<ResizeLayerInfo>;
};

export type AiResizePromptPayload = {
  __typename?: 'AiResizePromptPayload';
  createdAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  prompt: Scalars['String']['output'];
  systemPromptLandscape: Scalars['String']['output'];
  systemPromptPortrait: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  updatedBy: Scalars['String']['output'];
};

export type AiResizeSampleHtmlPayload = {
  __typename?: 'AiResizeSampleHtmlPayload';
  html: Scalars['String']['output'];
};

export type AiResizeSessionPromptsPayload = {
  __typename?: 'AiResizeSessionPromptsPayload';
  sessionId: Scalars['String']['output'];
  variants: Array<AiResizeVariantPrompt>;
};

export type AiResizeStatusPayload = {
  __typename?: 'AiResizeStatusPayload';
  status: Array<DesignResizeStatus>;
  time: Scalars['Float']['output'];
};

export type AiResizeVariant = {
  __typename?: 'AiResizeVariant';
  derivedFrom?: Maybe<Scalars['String']['output']>;
  resizeVersion: Scalars['Int']['output'];
  slideId: Scalars['Int']['output'];
  targetHash: Scalars['String']['output'];
  variantId: Scalars['String']['output'];
};

/** Worker-reported LLM cost/latency for one variant (dev-only UI diagnostics). */
export type AiResizeVariantGenerationStats = {
  __typename?: 'AiResizeVariantGenerationStats';
  /** Prefix tokens served from cache. Anthropic EXCLUDES these from inputTokens, so cost reads need both. */
  cacheReadTokens?: Maybe<Scalars['Int']['output']>;
  /** Wall-clock of the Claude call only (excludes screenshot/setup and the /resize merge). */
  durationMs: Scalars['Int']['output'];
  inputTokens?: Maybe<Scalars['Int']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  outputTokens?: Maybe<Scalars['Int']['output']>;
  stopReason?: Maybe<Scalars['String']['output']>;
  thinkingChars?: Maybe<Scalars['Int']['output']>;
  visibleChars?: Maybe<Scalars['Int']['output']>;
};

export type AiResizeVariantPrompt = {
  __typename?: 'AiResizeVariantPrompt';
  /** The captured prompt object; null when the variant has no capture (knob off, or write raced a discard). */
  prompt?: Maybe<Scalars['JSON']['output']>;
  resizeVersion: Scalars['Int']['output'];
  targetHash: Scalars['String']['output'];
  variantId: Scalars['String']['output'];
};

/**
 * Whether a design sample rode this variant's prompt — and NOTHING about which
 * one.
 *
 * The worker still reports ids, scores and bridge dims (see
 * `InputAiResizeSampleInfo`, written over the signed internal surface), but none
 * of it is answered here: a sample id plus its score is enough to walk the
 * corpus one query at a time, and this field is served to every app user. The
 * admin Design Samples page reads the corpus directly instead.
 */
export type AiResizeVariantSampleInfo = {
  __typename?: 'AiResizeVariantSampleInfo';
  /** Why a requested sample was not selected, as the worker reported it (InputAiResizeSampleInfo.failure); null when one was or the report predates it. */
  failure?: Maybe<Scalars['String']['output']>;
  requested: Scalars['Boolean']['output'];
  /** How long the sample lookup took, ms. */
  retrieveMs?: Maybe<Scalars['Int']['output']>;
  selected: Scalars['Boolean']['output'];
};

export type AiResizeVariantState = {
  __typename?: 'AiResizeVariantState';
  canvasBackground?: Maybe<Scalars['String']['output']>;
  derivedFrom?: Maybe<Scalars['String']['output']>;
  failed?: Maybe<Scalars['Boolean']['output']>;
  failureMessage?: Maybe<Scalars['String']['output']>;
  generationStats?: Maybe<AiResizeVariantGenerationStats>;
  json?: Maybe<Scalars['JsonDesign']['output']>;
  percent?: Maybe<Scalars['Float']['output']>;
  resizeVersion: Scalars['Int']['output'];
  sampleInfo?: Maybe<AiResizeVariantSampleInfo>;
  slideId: Scalars['Int']['output'];
  targetHash: Scalars['String']['output'];
  variantId: Scalars['String']['output'];
};

export type AiResizeVariantStatusPayload = {
  __typename?: 'AiResizeVariantStatusPayload';
  sessionId: Scalars['String']['output'];
  time: Scalars['Float']['output'];
  variants: Array<AiResizeVariantState>;
};

/**
 * Why an AI-resized size was not added: AI_FAILED, the AI resize or adding its result failed; INTERRUPTED, the
 * session ended: discarded by an AI resize of the design opened in the editor, or expired; CREDITS_LIMIT, the balance
 * cannot pay for it; USAGE_RESTRICTED, the team's usage is restricted; ABANDONED, the caller stopped waiting.
 */
export enum AiResizedSizeFailure {
  ABANDONED = 'ABANDONED',
  AI_FAILED = 'AI_FAILED',
  CREDITS_LIMIT = 'CREDITS_LIMIT',
  INTERRUPTED = 'INTERRUPTED',
  USAGE_RESTRICTED = 'USAGE_RESTRICTED'
}

/** The AI resize a new size waits for: completeAiResizedSize takes its variant. */
export type AiResizedSizeJob = {
  __typename?: 'AiResizedSizeJob';
  variantId: Scalars['String']['output'];
};

/**
 * How an AI-resized size ended: PENDING, still being laid out, or the design is being edited (call again); ADDED, the
 * size was added and its credits charged; EXISTS, the design has a size of those dimensions now, nothing charged;
 * FAILED, see failure, nothing charged.
 */
export enum AiResizedSizeStatus {
  ADDED = 'ADDED',
  EXISTS = 'EXISTS',
  FAILED = 'FAILED',
  PENDING = 'PENDING'
}

/** One AI Studio composer Generate request: a prompt plus the variant operations it spawned. */
export type AiStudioGeneration = {
  __typename?: 'AiStudioGeneration';
  /** Requested aspect ratio as 'W:H' (e.g. '4:5'), read from the ops' input — sizes pending tiles before any asset exists. Null once the ops are cleaned up. */
  aspectRatio?: Maybe<Scalars['String']['output']>;
  /** The Copilot chat thread that started it — the Copilot reads only its own chat's generations. Null outside a chat. */
  chatThreadId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** Durable completed tiles. May overlap with fresh SUCCESS entries in operations — clients drop media entries whose operationId is present there (ops win). */
  media: Array<AiStudioGenerationMedia>;
  /** Variant tiles, in creation order. Same shape checkAiOperations returns, so pending tiles can be polled and swapped in place. */
  operations: Array<GeneratedImageResult>;
  prompt: Scalars['String']['output'];
  /** What the composer was set to for this generation. Null once the 3-month op cleanup removes the input it is read from. */
  settings?: Maybe<AiStudioGenerationSettings>;
  type: AiStudioGenerationType;
};

/** History, not the design's current state: REPLACED says the swap landed, not that the layer still shows it. */
export type AiStudioGenerationCopilotOutcome = {
  __typename?: 'AiStudioGenerationCopilotOutcome';
  /** The swap landed but the requested cutout did not: the image kept its background. */
  cutoutDemoted?: Maybe<Scalars['Boolean']['output']>;
  /** The client's own facts about the outcome, as it last wrote them. */
  details?: Maybe<Scalars['JSON']['output']>;
  kind: AiStudioGenerationOutcomeKind;
  status: AiStudioGenerationOutcomeStatus;
  targetDesignBackground?: Maybe<Scalars['Boolean']['output']>;
  /** The replaced layer (bannersetElementId). Null for a place or the design's own background. */
  targetLayerId?: Maybe<Scalars['Int']['output']>;
  targetLayerName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

/** One AI Studio generation batch, shaped for internal AI-agent consumers (internal use for AI agents). */
export type AiStudioGenerationInternal = {
  __typename?: 'AiStudioGenerationInternal';
  aspectRatio?: Maybe<Scalars['String']['output']>;
  /** What the Copilot recorded should happen once it finishes, and how far that got. Null when none was requested. */
  copilotOutcome?: Maybe<AiStudioGenerationCopilotOutcome>;
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  media: Array<AiStudioGenerationMediaInternal>;
  operations: Array<GeneratedImageResult>;
  prompt: Scalars['String']['output'];
  /** A video joined from scenes: how many (from its settings). Null for a single clip, and once the op cleanup removes the input it is counted from. */
  sceneCount?: Maybe<Scalars['Int']['output']>;
  type: AiStudioGenerationType;
};

/** A permanent media pointer persisted when an AI Studio variant finished. Survives the 3-month ai_operation cleanup. Entries arrive in display order. */
export type AiStudioGenerationMedia = {
  __typename?: 'AiStudioGenerationMedia';
  /** Media hashid; the permanent URL is {cdnUrl}/assets/media/{hash} */
  hash: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  /** Id of the AiOperation that produced it (plain id — the op row may be deleted). Dedupe key against operations, and the merge-sort key for variant order. */
  operationId: Scalars['Int']['output'];
  /** Pixel dimensions of the produced asset (from the media row; null when probing failed). */
  width?: Maybe<Scalars['Int']['output']>;
};

/** A generation's permanent media pointer, with its asset URL resolved server-side (internal use for AI agents). */
export type AiStudioGenerationMediaInternal = {
  __typename?: 'AiStudioGenerationMediaInternal';
  hash: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  operationId: Scalars['Int']['output'];
  /** Permanent asset URL, resolved from the assets CDN base so internal callers need no CDN config of their own. */
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export enum AiStudioGenerationOutcomeKind {
  PLACE = 'PLACE',
  REPLACE = 'REPLACE'
}

/** RECORDED — waiting on the generation; RUNNING — being applied; PLACED, REPLACED and FAILED are terminal. */
export enum AiStudioGenerationOutcomeStatus {
  FAILED = 'FAILED',
  PLACED = 'PLACED',
  RECORDED = 'RECORDED',
  REPLACED = 'REPLACED',
  RUNNING = 'RUNNING'
}

/** Composer settings a generation was fired with, read back from its operations' input. Lets the feed show what a generation started from and re-apply it to the composer. */
export type AiStudioGenerationSettings = {
  __typename?: 'AiStudioGenerationSettings';
  /** Single video: the requested clip length, so Reuse settings can restore it. Null for images, chains (their length is the scenes'), and edits (the source's pacing wins), and once the op cleanup removes the input it is read from. */
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  /** Omni: the request asked for multiple shots instead of a single scene. */
  multiScene: Scalars['Boolean']['output'];
  /** Reference images the generation started from, in composer order (video: the first-frame image first, then the extra Omni assets). Empty when it started from the prompt alone. */
  referenceImageUrls: Array<Scalars['String']['output']>;
  /** Requested resolution label — '1K'/'4K' for image, '360p'/'720p'/'1080p'/'4k' for video. */
  resolution?: Maybe<Scalars['String']['output']>;
  /** Multi-scene: how many scene cards the chain was fired with, so a finished clip can say what it is made of. Null for a single-scene generation, and once the op cleanup removes the input it is counted from. */
  sceneCount?: Maybe<Scalars['Int']['output']>;
  /** Single video: whether the request asked for sound. Null when not recorded, for chains (always sound) and for edits (the source's audio wins). */
  soundOn?: Maybe<Scalars['Boolean']['output']>;
  /** Omni asset edit: media hash of the source video this generation edits. */
  sourceMediaHash?: Maybe<Scalars['String']['output']>;
  /** The composer's On-brand toggle: the generation was grounded in the design's ad context. */
  useDesignContext: Scalars['Boolean']['output'];
  /** Variants requested. Read from ai_studio_generation.expected_count, so it survives the op cleanup. */
  variantCount: Scalars['Int']['output'];
};

export enum AiStudioGenerationType {
  AUDIO = 'AUDIO',
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO'
}

export type AiStudioGenerationsInternalResult = {
  __typename?: 'AiStudioGenerationsInternalResult';
  items: Array<AiStudioGenerationInternal>;
  pageInfo: PageInfo;
};

export type AiStudioGenerationsResult = {
  __typename?: 'AiStudioGenerationsResult';
  /** Ordered oldest → newest (most recent last), chat-feed style. */
  items: Array<AiStudioGeneration>;
  pageInfo: PageInfo;
};

/** Font compatibility information for a single language in AI translate feeds. */
export type AiTranslateFeedFontCheck = {
  __typename?: 'AiTranslateFeedFontCheck';
  /** Language code (EN, FR, DE, etc.). */
  languageCode: Scalars['String']['output'];
  /** Fonts that don't support this language. */
  unsupportedFonts: Array<UnsupportedFont>;
};

/** Response containing all projects accessible to the user. */
export type AllUserProjectsResults = {
  __typename?: 'AllUserProjectsResults';
  /** List of accessible projects. */
  nodes: Array<Project>;
};

export type AnalyticsData = {
  anonymousId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** Analyzed image data (output type for cached metadata) */
export type AnalyzedImage = {
  __typename?: 'AnalyzedImage';
  /** Type of content (person, product, scene, logo, text, abstract) */
  contentType: Scalars['String']['output'];
  /** Brief description of what's in the image */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether the image contains readable text */
  hasText?: Maybe<Scalars['Boolean']['output']>;
};

export type AnimationSuggestion = {
  __typename?: 'AnimationSuggestion';
  category: Scalars['String']['output'];
  name: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
};

export type AnimationSuggestionsResult = {
  __typename?: 'AnimationSuggestionsResult';
  animations: Array<AnimationSuggestion>;
};

/**
 * Available scopes for API tokens.
 * Defines what features a token can access.
 */
export enum ApiTokenScope {
  /** Access to Creatopy API */
  CREATOPY_API = 'CREATOPY_API',
  /** Access to Figma plugin */
  FIGMA = 'FIGMA',
  /** Access to Zapier integration */
  ZAPIER = 'ZAPIER'
}

export type AppIntegration = {
  __typename?: 'AppIntegration';
  /** @deprecated Always null: integration reads no longer return stored OAuth tokens. */
  accessToken?: Maybe<Scalars['String']['output']>;
  appIntegration: AppIntegrationType;
  connectedEmail: Scalars['String']['output'];
  slackUserId?: Maybe<Scalars['String']['output']>;
  teamId?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Always null: integration reads no longer return stored OAuth tokens. */
  userToken?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
  workspaceName?: Maybe<Scalars['String']['output']>;
};

export enum AppIntegrationType {
  NOTION = 'NOTION',
  SLACK = 'SLACK'
}

export type AppTemplatePayload = {
  __typename?: 'AppTemplatePayload';
  designTypeName?: Maybe<Scalars['String']['output']>;
  hasAnimation: Scalars['Boolean']['output'];
  hasVideo: Scalars['Boolean']['output'];
  hash: Scalars['String']['output'];
  height: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  measureUnit?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Whether the template is pinned to the top of listings. */
  pinToTop: Scalars['Boolean']['output'];
  setHash?: Maybe<Scalars['String']['output']>;
  sizes?: Maybe<Array<Maybe<TemplateWebsiteSizePayload>>>;
  /** The template set's last save, which a save of any of its sizes moves — its thumbnails' version, so their URLs change with every save. */
  updatedAt: Scalars['Date']['output'];
  width: Scalars['Float']['output'];
};

export type AppTemplatesPayload = {
  __typename?: 'AppTemplatesPayload';
  pageInfo: PageInfo;
  templates: Array<AppTemplatePayload>;
  totalCount: Scalars['Int']['output'];
};

export type AppUserType = {
  __typename?: 'AppUserType';
  avatar?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isChangeEmailPending?: Maybe<Scalars['Boolean']['output']>;
  isTestUser?: Maybe<Scalars['Boolean']['output']>;
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

/** Project-level design approval settings. */
export type ApprovalConfig = {
  __typename?: 'ApprovalConfig';
  /** Whether the approval workflow is enabled. */
  enabled: Scalars['Boolean']['output'];
  /** Whether designs must be approved before they can be published or downloaded. */
  requireApprovalBeforePublish: Scalars['Boolean']['output'];
};

/** Response after approving a team invitation. */
export type ApproveTeamInvitationPayload = {
  __typename?: 'ApproveTeamInvitationPayload';
  /** Whether the approval was successful. */
  result: Scalars['Boolean']['output'];
};

export enum ArtboardsImportMode {
  DESIGNS = 'designs',
  SET = 'set',
  SLIDES = 'slides'
}

/** Per-team Adobe Asset Selector MFE configuration. */
export type AssetSelectorConfig = {
  __typename?: 'AssetSelectorConfig';
  /** Optional — only some AEM tenants require an API key on the Discovery service; the MFE accepts undefined. */
  apiKey?: Maybe<Scalars['String']['output']>;
  /** Optional — delivery host/domain for placed assets (e.g. a custom delivery domain or CDN). Unset = derived from the author repo host (author- → delivery-). */
  deliveryHost?: Maybe<Scalars['String']['output']>;
  /** Optional — allow-list of MFE features. Documented values: upload, collections. Unset = both enabled. */
  featureSet?: Maybe<Array<Scalars['String']['output']>>;
  imsClientId: Scalars['String']['output'];
  imsOrg: Scalars['String']['output'];
  imsScope: Scalars['String']['output'];
  /** Optional — pin the picker to a single AEM repository. Unset = MFE auto-discovers from the user's IMS profile. */
  repositoryId?: Maybe<Scalars['String']['output']>;
  /** Optional — root folder path the picker opens at. Doubles as encapsulation: users cannot traverse above this path. */
  rootPath?: Maybe<Scalars['String']['output']>;
  /** Placed-asset source: true = inject the AEM delivery URL (default); false = download a copy to The Brief's CDN at place-time. */
  useAemDelivery: Scalars['Boolean']['output'];
};

export type AssetsNextgenAi = {
  __typename?: 'AssetsNextgenAi';
  content?: Maybe<Scalars['JSON']['output']>;
  fetchedBrandDescriptionStatus?: Maybe<NextGenAiFetchedStatus>;
  fetchedBrandStyleStatus?: Maybe<NextGenAiFetchedStatus>;
  fetchedBrandfetchStatus?: Maybe<NextGenAiFetchedStatus>;
  fetchedFontsStatus?: Maybe<NextGenAiFetchedStatus>;
  fetchedIdentityStatus?: Maybe<NextGenAiFetchedStatus>;
  fetchedLogoStatus?: Maybe<NextGenAiFetchedStatus>;
  fetchedMediaStatus?: Maybe<NextGenAiFetchedStatus>;
  fetchedStyleStatus?: Maybe<NextGenAiFetchedStatus>;
  fetchedTextStatus?: Maybe<NextGenAiFetchedStatus>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  urlContent?: Maybe<Scalars['JSON']['output']>;
};

/** Response after assigning a brand kit to a design. */
export type AssignDesignBrandKitPayload = {
  __typename?: 'AssignDesignBrandKitPayload';
  /** The updated design. */
  design: Design;
};

/** Response after assigning the default brand kit to a design. */
export type AssignDesignDefaultBrandKitPayload = {
  __typename?: 'AssignDesignDefaultBrandKitPayload';
  /** The updated design. */
  design: Design;
};

/** Response after ensuring a design JSON is saved. */
export type AssureDesignJsonIsSavedPayload = {
  __typename?: 'AssureDesignJsonIsSavedPayload';
  /** Whether the design JSON is saved. */
  result: Scalars['Boolean']['output'];
};

export type AttachFeedPayload = {
  __typename?: 'AttachFeedPayload';
  /** Opaque revision of the newly committed design-feed attachment. */
  attachmentRevision: Scalars['String']['output'];
  /** Whether the newly committed attachment currently has materialized layer bindings. */
  bindings: Scalars['Boolean']['output'];
  hash: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  productSetId?: Maybe<Scalars['Int']['output']>;
  productSetName?: Maybe<Scalars['String']['output']>;
  row: Scalars['Int']['output'];
  rows: Scalars['Int']['output'];
};

/** Audience analysis comparing targets vs. actual reach (legacy audience analytics) */
export type AudienceAnalytics = {
  __typename?: 'AudienceAnalytics';
  /** Actual audience that was reached */
  reachedAudience: ReachedAudience;
  /** Original audience targeting settings */
  targetAudience: TargetAudience;
  /** Top performing geographic locations */
  topLocations: Array<LocationItem>;
};

/** Audience targeting and demographic information for an ad */
export type AudienceInfo = {
  __typename?: 'AudienceInfo';
  /** Age range of the targeted audience */
  ageAudience: AgeAudience;
  /** Detailed demographic breakdown by country */
  demographics: Array<CountryBreakdown>;
  /** Gender distribution of the audience */
  genderAudience: Scalars['String']['output'];
  /** Whether there are policy violations in targeting */
  hasViolatingPayerBeneficiary: Scalars['Boolean']['output'];
  /** Whether the ad has been taken down */
  isAdTakenDown: Scalars['Boolean']['output'];
  /** Geographic locations targeted by the ad */
  locationAudience: Array<LocationAudience>;
  /** Whether the ad targets EU users */
  targetsEu: Scalars['Boolean']['output'];
  /** Total estimated reach of the ad */
  totalReach: Scalars['Int']['output'];
};

export enum AudioFileFormat {
  MP3 = 'mp3',
  WAV = 'wav'
}

export type AuthForgotPasswordInput = {
  email: Scalars['String']['input'];
};

export type AuthForgotPasswordResult = {
  __typename?: 'AuthForgotPasswordResult';
  success: Scalars['Boolean']['output'];
};

export type AuthLoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type AuthLoginResult = {
  __typename?: 'AuthLoginResult';
  accessToken?: Maybe<Scalars['String']['output']>;
  expiresIn?: Maybe<Scalars['Int']['output']>;
  idToken?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  requiresAction?: Maybe<Scalars['Boolean']['output']>;
};

export type AuthProfileOption = {
  __typename?: 'AuthProfileOption';
  authUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type AuthRegisterInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
};

export type AuthenticateWithTokenPayload = {
  __typename?: 'AuthenticateWithTokenPayload';
  accessToken: Scalars['String']['output'];
  redirectUrl: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  sessionConfigToken?: Maybe<Scalars['String']['output']>;
  sessionId: Scalars['String']['output'];
};

export enum AutoCutStyle {
  HIGHLIGHTS = 'HIGHLIGHTS',
  TIGHTEN = 'TIGHTEN'
}

export enum AutomateCopilotAiReportDestination {
  EMAIL = 'email',
  IN_APP = 'in_app',
  NOTION = 'notion',
  SLACK = 'slack'
}

export enum AutomateCopilotAiReportFrequency {
  BI_WEEKLY = 'bi_weekly',
  DAILY = 'daily',
  MONTHLY = 'monthly',
  ONCE = 'once',
  WEEKLY = 'weekly'
}

export type AwardTeamTrialPayload = {
  __typename?: 'AwardTeamTrialPayload';
  message: Scalars['String']['output'];
  planCode: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  trialDays: Scalars['Int']['output'];
};

export type BsCustomSize = {
  height: Scalars['Float']['input'];
  measureUnit: MeasureUnit;
  name: Scalars['String']['input'];
  variation: Scalars['String']['input'];
  width: Scalars['Float']['input'];
};

export enum BvEmojiFrequency {
  ALWAYS = 'ALWAYS',
  NEVER = 'NEVER',
  SOMETIMES = 'SOMETIMES'
}

/**
 * Result of a `backfillDesignLayoutSignatures` invocation. Counts cover
 * only the designs touched by THIS call, not cumulative totals.
 */
export type BackfillDesignLayoutSignaturesPayload = {
  __typename?: 'BackfillDesignLayoutSignaturesPayload';
  /** Wall-clock duration of this call, in milliseconds. */
  durationMs: Scalars['Int']['output'];
  /** Designs that threw during processing. See server logs for the exact error. */
  errors: Scalars['Int']['output'];
  /**
   * True when this call stopped because `limit` was hit and at least one
   * more eligible row exists after `lastProcessedId`. False when the
   * scan ran out of candidates — the backfill is complete.
   */
  hasMore: Scalars['Boolean']['output'];
  /**
   * Highest design id processed by this call. Pass it as `afterId` on the
   * next call to resume. Null when no rows were processed.
   */
  lastProcessedId?: Maybe<Scalars['Int']['output']>;
  /** Designs read from DB in this call. */
  processedCount: Scalars['Int']['output'];
  /**
   * Designs whose underlying `design` row was soft-deleted. Their stale
   * `design_layout_signature` row is removed as a side-effect. Only
   * non-zero for `USER_DESIGN` runs.
   */
  skippedDeleted: Scalars['Int']['output'];
  /** Designs skipped because their banner JSON was missing on S3. */
  skippedNoJson: Scalars['Int']['output'];
  /** Designs skipped because their layout couldn't produce a meaningful signature (e.g. no slides, no leaf layers). */
  skippedUnusable: Scalars['Int']['output'];
  /** Designs whose signature was successfully written (inserted or updated). */
  written: Scalars['Int']['output'];
};

/**
 * Which signature bucket to refresh. `TEMPLATE` scans children of SET-type
 * templates. `USER_DESIGN` scans existing `user_design` rows in
 * `design_layout_signature` and preserves their `team_id`.
 */
export enum BackfillSignatureSourceType {
  TEMPLATE = 'TEMPLATE',
  USER_DESIGN = 'USER_DESIGN'
}

export type BackgroundTypeResult = {
  __typename?: 'BackgroundTypeResult';
  type?: Maybe<ImageBackgroundType>;
};

export type BalancePayload = {
  __typename?: 'BalancePayload';
  result: AccountBalance;
};

export type BannerData = {
  bannerId: Scalars['Int']['input'];
  dateLastUpdate?: InputMaybe<Scalars['Date']['input']>;
  downloadSettings?: InputMaybe<DownloadSettings>;
  folderId?: InputMaybe<Scalars['Int']['input']>;
  hasCustomFont?: InputMaybe<Scalars['Boolean']['input']>;
  hasRtlText?: InputMaybe<Scalars['Boolean']['input']>;
  isCustomTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  migrationId: Scalars['Int']['input'];
  setId?: InputMaybe<Scalars['Int']['input']>;
  workspaceId?: InputMaybe<Scalars['Int']['input']>;
};

export type BannerSetData = {
  bannerIds: Array<Scalars['Int']['input']>;
  dateLastUpdate?: InputMaybe<Scalars['Date']['input']>;
  downloadSettings?: InputMaybe<DownloadSettings>;
  folderId?: InputMaybe<Scalars['Int']['input']>;
  hasCustomFont?: InputMaybe<Scalars['Boolean']['input']>;
  hasRtlText?: InputMaybe<Scalars['Boolean']['input']>;
  isCustomTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  migrationId: Scalars['Int']['input'];
  setId: Scalars['Int']['input'];
  workspaceId?: InputMaybe<Scalars['Int']['input']>;
};

/** Response containing background remover credits. */
export type BgRemoverCreditsPayload = {
  __typename?: 'BgRemoverCreditsPayload';
  /** Number of background remover credits available. */
  bgRemoverCredits?: Maybe<Scalars['Int']['output']>;
  /** Whether to show the background remover question. */
  bgRemoverShowQuestion?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The value of total team downloads per month (deprecated).
   * @deprecated Not used, remove this
   */
  currentTeamDownloads?: Maybe<Scalars['Int']['output']>;
};

export type BillingInfo = {
  __typename?: 'BillingInfo';
  address?: Maybe<Address>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<PaymentMethod>;
  vatNumber?: Maybe<Scalars['String']['output']>;
};

export enum BlendModes {
  COLOR = 'color',
  COLOR_BURN = 'color_burn',
  COLOR_DODGE = 'color_dodge',
  DARKEN = 'darken',
  DIFFERENCE = 'difference',
  EXCLUSION = 'exclusion',
  HARD_LIGHT = 'hard_light',
  HUE = 'hue',
  LIGHTEN = 'lighten',
  LUMINOSITY = 'luminosity',
  MULTIPLY = 'multiply',
  NORMAL = 'normal',
  OVERLAY = 'overlay',
  SATURATION = 'saturation',
  SCREEN = 'screen',
  SOFT_LIGHT = 'soft_light'
}

export type BlurBg = {
  __typename?: 'BlurBg';
  url: Scalars['String']['output'];
};

export type BlurImageBackgroundResult = {
  __typename?: 'BlurImageBackgroundResult';
  image_res?: Maybe<Scalars['String']['output']>;
  sid?: Maybe<Scalars['String']['output']>;
};

export type BraintreeClientTokenPayload = {
  __typename?: 'BraintreeClientTokenPayload';
  token: Scalars['String']['output'];
};

/** Pagination information for brand ads */
export type BrandAdsPagination = {
  __typename?: 'BrandAdsPagination';
  /** Current page number */
  currentPage: Scalars['Int']['output'];
  /** Whether there are more pages available */
  hasNext: Scalars['Boolean']['output'];
  /** Token for retrieving the next page */
  nextToken?: Maybe<Scalars['String']['output']>;
};

/** Response containing brand ads from a specific platform */
export type BrandAdsResponse = {
  __typename?: 'BrandAdsResponse';
  /** List of ads from the brand */
  data: Array<AdData>;
  /**
   * Deprecated: legacy error message
   * @deprecated Legacy field kept for backward compatibility
   */
  error?: Maybe<Scalars['String']['output']>;
  /** Pagination information */
  pagination?: Maybe<BrandAdsPagination>;
  /** Platform where the ads were retrieved from */
  platform: Platform;
  /**
   * Deprecated: legacy success flag
   * @deprecated Legacy field kept for backward compatibility
   */
  success: Scalars['Boolean']['output'];
};

/** Complete brand analytics data */
export type BrandAnalyticsData = {
  __typename?: 'BrandAnalyticsData';
  /**
   * Deprecated: legacy audience analytics field
   * @deprecated Legacy field kept for backward compatibility
   */
  audienceAnalytics: AudienceAnalytics;
  /** Content analysis including media types and CTAs */
  contentAnalytics: ContentAnalytics;
  /** General statistics about the brand's ads */
  generalStats: GeneralStats;
  /** Link and landing page analysis */
  links: Array<LinkStats>;
  /** Performance metrics across platforms */
  performanceAnalytics: PerformanceAnalytics;
  /** Text content patterns and analysis */
  textContent: BrandAnalyticsTexts;
};

/** Input for retrieving brand analytics with optional country filtering */
export type BrandAnalyticsInput = {
  /** Brand competitor ID to analyze */
  brandCompetitorId: Scalars['Int']['input'];
  /** Optional country filter for targeting specific geographic markets */
  country?: InputMaybe<Scalars['String']['input']>;
};

/** Response containing comprehensive brand analytics */
export type BrandAnalyticsResponse = {
  __typename?: 'BrandAnalyticsResponse';
  /** Brand competitor ID that was analyzed */
  brandCompetitorId: Scalars['Int']['output'];
  /**
   * Legacy brand ID field - use brandCompetitorId instead
   * @deprecated Use brandCompetitorId instead
   */
  brandId?: Maybe<Scalars['Int']['output']>;
  /** Complete analytics data */
  data?: Maybe<BrandAnalyticsData>;
  /**
   * Deprecated: legacy error message
   * @deprecated Legacy field kept for backward compatibility
   */
  error?: Maybe<Scalars['String']['output']>;
  /**
   * Deprecated: legacy success flag
   * @deprecated Legacy field kept for backward compatibility
   */
  success: Scalars['Boolean']['output'];
  /** Timestamp of the analysis */
  timestamp: Scalars['String']['output'];
};

/** Text content analysis across different ad elements */
export type BrandAnalyticsTexts = {
  __typename?: 'BrandAnalyticsTexts';
  /** Analysis of ad body text patterns and frequency */
  body: Array<TextContent>;
  /** Analysis of call-to-action text patterns and frequency */
  cta: Array<TextContent>;
  /** Analysis of hook/opening patterns */
  hook: Array<TextContent>;
  /** Analysis of link description patterns */
  linkDescription: Array<Scalars['String']['output']>;
  /** Analysis of ad title/headline patterns and frequency */
  title: Array<TextContent>;
};

export type BrandColor = {
  __typename?: 'BrandColor';
  brightness?: Maybe<Scalars['Int']['output']>;
  hex: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

/** Brand competitor type for the new competitor system. */
export type BrandCompetitor = {
  __typename?: 'BrandCompetitor';
  /** External brand fetch ID for API lookups. */
  brandFetchId: Scalars['String']['output'];
  /** ID of the brand kit this competitor belongs to. */
  brandKitId: Scalars['Int']['output'];
  /** Domain/website of the competitor. */
  domain?: Maybe<Scalars['String']['output']>;
  /** Facebook brand data as JSON. */
  facebookBrandData?: Maybe<Scalars['JSON']['output']>;
  /** Facebook page ID. */
  facebookPageId?: Maybe<Scalars['String']['output']>;
  /** Google advertiser ID. */
  googleAdvertiserId?: Maybe<Scalars['String']['output']>;
  /** Google data as JSON. */
  googleData?: Maybe<Scalars['JSON']['output']>;
  /** @BreakingBad */
  id: Scalars['Int']['output'];
  /** Name of the competitor. */
  name?: Maybe<Scalars['String']['output']>;
};

/** Input for getting a brand competitor by unique constraint. */
export type BrandCompetitorByIdsInput = {
  /** External brand fetch ID. */
  brandFetchId: Scalars['String']['input'];
  /** ID of the brand kit. */
  brandKitId: Scalars['Int']['input'];
};

/** Input for getting brand competitors for a brand kit. */
export type BrandCompetitorsInput = {
  /** ID of the brand kit to get competitors for. */
  brandKitId: Scalars['Int']['input'];
};

export type BrandControl = {
  __typename?: 'BrandControl';
  /** Whether the team has at least one workspace on the new Ad Studio BETA. */
  hasNewAdStudioBetaWorkspace: Scalars['Boolean']['output'];
  teamId: Scalars['Int']['output'];
  useAdStudioAssistant: Scalars['Boolean']['output'];
  useAiImage: Scalars['Boolean']['output'];
  useAiPerformanceInsights: Scalars['Boolean']['output'];
  useAiText: Scalars['Boolean']['output'];
  useAllBrandKits: Scalars['Boolean']['output'];
  useColor: Scalars['Boolean']['output'];
  useCompetitiveIntelligence: Scalars['Boolean']['output'];
  useDesignElements: Scalars['Boolean']['output'];
  useElementsLibrary: Scalars['Boolean']['output'];
  useFont: Scalars['Boolean']['output'];
  useLinks: Scalars['Boolean']['output'];
  useMoveDesign: Scalars['Boolean']['output'];
  useNewAdStudio: Scalars['Boolean']['output'];
  usePredictiveScoring: Scalars['Boolean']['output'];
  useStock: Scalars['Boolean']['output'];
  useTemplate: Scalars['Boolean']['output'];
  useUpload: Scalars['Boolean']['output'];
};

export enum BrandControlTypes {
  USEADSTUDIOASSISTANT = 'useAdStudioAssistant',
  USEAIIMAGE = 'useAiImage',
  USEAIPERFORMANCEINSIGHTS = 'useAiPerformanceInsights',
  USEAITEXT = 'useAiText',
  USEALLBRANDKITS = 'useAllBrandKits',
  USECOLOR = 'useColor',
  USECOMPETITIVEINTELLIGENCE = 'useCompetitiveIntelligence',
  USEDESIGNELEMENTS = 'useDesignElements',
  USEELEMENTSLIBRARY = 'useElementsLibrary',
  USEFONT = 'useFont',
  USELINKS = 'useLinks',
  USEMOVEDESIGN = 'useMoveDesign',
  USENEWADSTUDIO = 'useNewAdStudio',
  USEPREDICTIVESCORING = 'usePredictiveScoring',
  USESTOCK = 'useStock',
  USETEMPLATE = 'useTemplate',
  USEUPLOAD = 'useUpload'
}

/** Paginated results of brand elements. */
export type BrandElementsResults = PaginationResults & {
  __typename?: 'BrandElementsResults';
  /** List of media elements for the current page. */
  nodes: Array<Media>;
  /** Pagination information. */
  pageInfo: PageInfo;
  /** Total number of elements matching the query. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Email configuration for custom branding. */
export type BrandEmail = {
  __typename?: 'BrandEmail';
  /** Email address for brand communications. */
  email?: Maybe<Scalars['String']['output']>;
  /** Name associated with the brand email. */
  name?: Maybe<Scalars['String']['output']>;
  /** TXT records for email verification. */
  txtRecords?: Maybe<Scalars['String']['output']>;
};

export type BrandFont = {
  __typename?: 'BrandFont';
  name?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  originId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  weights?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

/** Input for generating AI-powered brand insights */
export type BrandInsightsInput = {
  /** @BreakingBad */
  advertiserIds: AdvertiserIdsInput;
  /** Internal brand ID for caching and tracking */
  brandId: Scalars['Int']['input'];
  /** Optional country filter for geographic-specific insights */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Raw data to analyze (typically JSON string of ad data) */
  data: Scalars['String']['input'];
  /** Type of insight to generate */
  type: InsightType;
};

/** AI-generated brand insights across different categories */
export type BrandInsightsResponse = {
  __typename?: 'BrandInsightsResponse';
  /** Target audience analysis and recommendations */
  audienceInsights?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Deprecated: Not used anymore
   * @deprecated Not used anymore
   */
  contentInsights: Array<Scalars['String']['output']>;
  /** Analysis of call-to-action effectiveness */
  ctaInsights?: Maybe<Array<Scalars['String']['output']>>;
  /** Insights about attention-grabbing hooks and openers */
  hooksInsights?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Deprecated: Not used anymore
   * @deprecated Not used anymore
   */
  keyPatterns: Array<Scalars['String']['output']>;
  /** Landing page experience and conversion insights */
  landingPagesInsights?: Maybe<Array<Scalars['String']['output']>>;
  /** Performance optimization recommendations */
  performanceInsights?: Maybe<Array<Scalars['String']['output']>>;
  /** Sentiment analysis of ad content and messaging */
  sentimentInsights?: Maybe<Array<Scalars['String']['output']>>;
  /** Overall strategic summary of the brand's advertising */
  summary?: Maybe<Scalars['String']['output']>;
};

/**
 * A brand kit containing design assets that define a brand's identity.
 * Brand kits can include logos, colors, fonts, typography settings, and voice/tone.
 */
export type BrandKit = {
  __typename?: 'BrandKit';
  /** AI generation rules (dos/don'ts, layout, copy guidelines). */
  aiGenerationRules?: Maybe<AiGenerationRules>;
  /** Advisory review of the AI generation rules, naming rules that contradict each other. */
  aiGenerationRulesReview: AiGenerationRulesReview;
  /** Description of the brand. */
  brandDescription?: Maybe<Scalars['String']['output']>;
  /** Domain of the brand kit. */
  brandDomain?: Maybe<Scalars['String']['output']>;
  /** Name of the brand */
  brandName?: Maybe<Scalars['String']['output']>;
  /** Button presets for the brand. */
  buttons: Array<BrandKitButton>;
  /** Primary color palette for the brand. */
  colorsPalette?: Maybe<ColorPalette>;
  /** All color palettes defined for the brand. */
  colorsPalettes: Array<ColorPalette>;
  /** ID of the user who created the brand kit. */
  createdBy?: Maybe<Scalars['Int']['output']>;
  designComponents: DesignsComponentsResult;
  /** Query brand media elements with pagination and search. */
  elements: BrandElementsResults;
  /** All fonts used in the brand. */
  fonts: Array<Font>;
  /** Unique identifier for the brand kit. */
  id: Scalars['Int']['output'];
  /** Primary logo for the brand. */
  logo?: Maybe<Media>;
  /** Query logo folders in the brand kit. */
  logoFolders: MediaFolders;
  /** All logos associated with the brand, optionally filtered by folder. */
  logos: Array<Media>;
  /** Query media folders in the brand kit. */
  mediaFolders: MediaFolders;
  /** Name of the brand kit. */
  name: Scalars['String']['output'];
  /** The project that owns this hidden, read-only kit; null for a regular kit. */
  ownerProjectId?: Maybe<Scalars['Int']['output']>;
  /** Projects associated with this brand kit. */
  projects: Array<Project>;
  /** Target Audience for AI-generated content. */
  targetAudience?: Maybe<BrandTargetAudience>;
  /** ID of the team that owns this brand kit. */
  teamId: Scalars['Int']['output'];
  /** Typography settings for different text elements. */
  typography: Array<Typography>;
  /** Timestamp when the brand kit was last updated. */
  updatedAt: Scalars['Date']['output'];
  /** Voice and tone settings for AI-generated content. */
  voiceAndTone?: Maybe<BrandKitVoiceAndTone>;
};


/**
 * A brand kit containing design assets that define a brand's identity.
 * Brand kits can include logos, colors, fonts, typography settings, and voice/tone.
 */
export type BrandKitDesignComponentsArgs = {
  input: InputDesignComponents;
};


/**
 * A brand kit containing design assets that define a brand's identity.
 * Brand kits can include logos, colors, fonts, typography settings, and voice/tone.
 */
export type BrandKitElementsArgs = {
  input: InputBrandElements;
};


/**
 * A brand kit containing design assets that define a brand's identity.
 * Brand kits can include logos, colors, fonts, typography settings, and voice/tone.
 */
export type BrandKitLogoFoldersArgs = {
  input: InputBrandkitMediaFolder;
};


/**
 * A brand kit containing design assets that define a brand's identity.
 * Brand kits can include logos, colors, fonts, typography settings, and voice/tone.
 */
export type BrandKitLogosArgs = {
  input?: InputMaybe<InputBrandkitLogos>;
};


/**
 * A brand kit containing design assets that define a brand's identity.
 * Brand kits can include logos, colors, fonts, typography settings, and voice/tone.
 */
export type BrandKitMediaFoldersArgs = {
  input: InputBrandkitMediaFolder;
};

/**
 * Asset description metadata for a single BrandKit image asset.
 * Returned by brandKitAssetDescription. assetDescription is null when
 * no description has been generated for the asset yet.
 */
export type BrandKitAssetDescription = {
  __typename?: 'BrandKitAssetDescription';
  /** Stored description of the image, or null when unavailable. */
  assetDescription?: Maybe<Scalars['String']['output']>;
  /** ID of the brand kit asset (Media id). */
  assetId: Scalars['ID']['output'];
};

export type BrandKitButton = {
  __typename?: 'BrandKitButton';
  brandKitId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  properties?: Maybe<Scalars['JSON']['output']>;
};

export type BrandKitColorContext = {
  __typename?: 'BrandKitColorContext';
  /** Hex color code */
  hex: Scalars['String']['output'];
  /** Optional semantic name for this color */
  name?: Maybe<Scalars['String']['output']>;
};

export type BrandKitColorPaletteContext = {
  __typename?: 'BrandKitColorPaletteContext';
  /** Colors in this palette */
  colors: Array<BrandKitColorContext>;
  /** Palette name */
  name: Scalars['String']['output'];
};

export type BrandKitCompetitorContext = {
  __typename?: 'BrandKitCompetitorContext';
  /** Competitor domain/website */
  domain?: Maybe<Scalars['String']['output']>;
  /** Competitor name */
  name?: Maybe<Scalars['String']['output']>;
};

export type BrandKitConceptBrief = {
  __typename?: 'BrandKitConceptBrief';
  /** Hand this to planBrandKitImagery so its planners read the same brief. */
  briefId: Scalars['String']['output'];
  canvas: BrandKitConceptCanvas;
  /** One or two sentences for the user. Never enters a prompt. */
  conceptSummary: Scalars['String']['output'];
  /** Layer ids in the order they draw the eye, first to last. */
  hierarchy: Array<Scalars['Int']['output']>;
  layers: Array<BrandKitConceptLayer>;
  logoPlacement: BrandKitConceptLogoPlacement;
  paletteRoles: BrandKitConceptPaletteRoles;
  source: BrandKitConceptSource;
};

export type BrandKitConceptBriefResult = {
  __typename?: 'BrandKitConceptBriefResult';
  /** Null when the brief could not be planned — the caller falls back to its positional rules. */
  brief?: Maybe<BrandKitConceptBrief>;
  /** no-design | no-brand-kit | no-palette | no-inventory | model-failed | invalid-brief */
  reason?: Maybe<Scalars['String']['output']>;
};

export type BrandKitConceptCanvas = {
  __typename?: 'BrandKitConceptCanvas';
  /** dominant | secondary | accent | neutralLight | neutralDark | keep */
  fill: Scalars['String']['output'];
};

/** Composition attributes for an image or video slot — enumerations only, never a subject. */
export type BrandKitConceptComposition = {
  __typename?: 'BrandKitConceptComposition';
  /** shallow | deep */
  depth: Scalars['String']['output'];
  /** low | medium | high */
  detailLevel: Scalars['String']['output'];
  /** left | right | top | front | back | diffuse */
  lightDirection: Scalars['String']['output'];
  /** faces-left | faces-right | centered | none */
  subjectDirection: Scalars['String']['output'];
  /** dark | light | none */
  toneUnderCopy: Scalars['String']['output'];
};

/** One derived colour the brief introduced and how (white | black | tint | shade). */
export type BrandKitConceptDerivedColor = {
  __typename?: 'BrandKitConceptDerivedColor';
  color: Scalars['String']['output'];
  from: Scalars['String']['output'];
  /** The kit colour a tint or shade was derived from. */
  ofKitColor?: Maybe<Scalars['String']['output']>;
};

/** One layer's role and decisions. Field presence follows the layer kind. */
export type BrandKitConceptLayer = {
  __typename?: 'BrandKitConceptLayer';
  composition?: Maybe<BrandKitConceptComposition>;
  /** Shapes and SVGs, only when slotRoles was asked: neutral | subject | content */
  decorKind?: Maybe<Scalars['String']['output']>;
  /** Shapes and buttons: dominant | secondary | accent | neutralLight | neutralDark | keep */
  fill?: Maybe<Scalars['String']['output']>;
  /** The layer's bannersetElementId — shared across every size of a set. */
  layerId: Scalars['Int']['output'];
  /** Texts: other text layers this one reads together with. */
  readsWith?: Maybe<Array<Scalars['Int']['output']>>;
  /**
   * The layer's semantic role. Shapes/buttons: canvas-panel | card |
   * accent-shape | divider | decor | backdrop-behind-text. Texts: headline |
   * subheadline | body | caption | price-terms | legal | cta. Media:
   * hero-image | support-image | background-image. Logo: logo.
   */
  role: Scalars['String']['output'];
  /** Texts: the FIRST candidate for the contrast pass. */
  textColor?: Maybe<Scalars['String']['output']>;
  /** Texts: heading | subheading | body */
  typography?: Maybe<Scalars['String']['output']>;
  /** Texts: dominant | secondary | support */
  visualWeight?: Maybe<Scalars['String']['output']>;
};

export type BrandKitConceptLogoPlacement = {
  __typename?: 'BrandKitConceptLogoPlacement';
  /** top-left | top-right | bottom-left | bottom-right | existing */
  anchor: Scalars['String']['output'];
  /** small | medium */
  size: Scalars['String']['output'];
};

/** The kit's palette mapped onto THIS design's roles. Hex strings. */
export type BrandKitConceptPaletteRoles = {
  __typename?: 'BrandKitConceptPaletteRoles';
  accent: Scalars['String']['output'];
  derived: Array<BrandKitConceptDerivedColor>;
  dominant: Scalars['String']['output'];
  neutralDark: Scalars['String']['output'];
  neutralLight: Scalars['String']['output'];
  secondary: Scalars['String']['output'];
};

export type BrandKitConceptSource = {
  __typename?: 'BrandKitConceptSource';
  /** live | preview | none — what the model looked at. */
  render: Scalars['String']['output'];
  slideId?: Maybe<Scalars['Int']['output']>;
};

/**
 * Brand kit context for AI generation — includes identity, colors, typography,
 * voice/tone, target audiences, competitors, and logos.
 */
export type BrandKitContextResult = {
  __typename?: 'BrandKitContextResult';
  /** User-defined AI generation rules */
  aiGenerationRules?: Maybe<AiGenerationRulesContext>;
  /** Free-text brand description */
  brandDescription?: Maybe<Scalars['String']['output']>;
  /** Brand name */
  brandName?: Maybe<Scalars['String']['output']>;
  /**
   * The structured brand profile serialized to text ('full' scope) — what the
   * brand sells and, critically, what may and may not be invented in imagery
   * for it. Null when the kit has no profile or it has never been extracted.
   */
  brandProfileDescription?: Maybe<Scalars['String']['output']>;
  /** Brand visual style */
  brandStyle?: Maybe<BrandKitStyleContext>;
  /** Brand buttons (CTAs) */
  buttons: Array<BrandKitButton>;
  /** All color palettes with named colors */
  colorPalettes: Array<BrandKitColorPaletteContext>;
  /** Brand competitors */
  competitors: Array<BrandKitCompetitorContext>;
  /** Brand domain/website */
  domain?: Maybe<Scalars['String']['output']>;
  /** Brand logos */
  logos: Array<BrandKitLogoContext>;
  /** Name of the brand kit */
  name: Scalars['String']['output'];
  /** Target audience segments */
  targetAudiences: Array<BrandKitTargetAudienceContext>;
  /** Typography settings (heading, subheading, body, custom) */
  typography: Array<BrandKitTypographyItem>;
  /** Voice and tone settings */
  voiceAndTone?: Maybe<BrandKitVoiceAndToneContext>;
};

/** Replacement copy for a text layer proven to still hold the template's placeholder wording. */
export type BrandKitCopySlotPlan = {
  __typename?: 'BrandKitCopySlotPlan';
  /**
   * True when this text is a line of the user's own copy, placed as written.
   * Only a template run (forceRewrite) sets it. Every other line was written to
   * the template's own length; this one may be longer, so the client fits it to
   * the template's box.
   */
  fromUserCopy: Scalars['Boolean']['output'];
  /** The layer's bannersetElementId — shared across every size of a set. */
  layerId: Scalars['Int']['output'];
  /**
   * The layer's OWN wording at plan time — casing and line breaks intact —
   * the exact text provenance was proven against. Named for what it is, not
   * "current": a plan/fire round trip is seconds to a minute (a model call
   * plus generation kickoffs), the canvas stays fully editable the whole
   * time, and nothing else re-checks the layer's content before writing. The
   * client MUST re-extract the layer's LIVE text immediately before writing
   * and refuse when it no longer matches this (case/whitespace-insensitively,
   * the same way the server compared it) — otherwise a user's own edit made
   * during that window is silently overwritten.
   */
  provenText: Scalars['String']['output'];
  /** The brand-voiced replacement text for this layer. */
  text: Scalars['String']['output'];
};

/** A brand-kit image that carries an AI-authored description — the copilot greeting's product-asset candidates. */
export type BrandKitDescribedAsset = {
  __typename?: 'BrandKitDescribedAsset';
  /** One-line AI description of what the image shows (MediaAiMetadata IMAGE_DESCRIPTION). Never empty. */
  description: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** CDN url of the full image */
  src: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

/**
 * A brand guidelines document uploaded to a brand kit, with its extraction lifecycle.
 *
 * extractStatus is idle, running or error. extraction is the extractor's full answer:
 * one { value, provenance } entry per field of the brand guidelines schema, kept per
 * document for review. appliedFields names the kit fields the import filled; the
 * import fills EMPTY fields only and never overwrites.
 */
export type BrandKitDocument = {
  __typename?: 'BrandKitDocument';
  appliedFields: Array<Scalars['String']['output']>;
  brandKitId: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  extractError?: Maybe<Scalars['String']['output']>;
  extractStartedAt?: Maybe<Scalars['Date']['output']>;
  extractStatus: Scalars['String']['output'];
  /** Monotonic version stamped each time an extraction is requested. */
  extractVersion: Scalars['Int']['output'];
  extractedAt?: Maybe<Scalars['Date']['output']>;
  extraction?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sizeBytes: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
  /** A signed GET for the private document, valid for about an hour from this read. Re-query for a fresh one. */
  url: Scalars['String']['output'];
};

/**
 * Presigned S3 POST for one brand kit document. fileUrl is the value to pass to
 * importBrandKitDocument: the object's canonical URL, which is not readable on its
 * own because the object is private.
 */
export type BrandKitDocumentUploadUrl = {
  __typename?: 'BrandKitDocumentUploadUrl';
  fields: Scalars['JSON']['output'];
  fileUrl: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type BrandKitImageryPlan = {
  __typename?: 'BrandKitImageryPlan';
  /**
   * The design id baselineStatus and copy were resolved against — the pinned
   * MAIN size of the family (the same size pickMasterSizeRow picks: the set's
   * stored mainDesignId override, or the orientation auto-pick), never
   * necessarily the design designHash itself names. "Baseline design" and
   * "main design" are the same design by construction, not by coincidence —
   * the reason a copy write scoped to this id is also a write scoped to the
   * main design, which is deliberately the ONLY design this feature ever
   * writes copy to. Null when no size could be pinned (baselineStatus is then
   * always 'none' with an empty copy/slots). The client MUST scope its copy
   * write to exactly this design: writing it set-wide applies one size's
   * provenance proof to every sibling, which can silently overwrite a
   * sibling's own edited copy. A forceRewrite plan is the one exception: it is
   * resolved against, and writes to, the size targetDesignId names.
   */
  baselineDesignId?: Maybe<Scalars['Int']['output']>;
  /**
   * WHY no baseline could be established — no-template-id | template-gone |
   * publisher-gate | no-size-match — or null when baselineStatus is 'resolved'
   * (and also null on the early returns that never reach the baseline at all,
   * which the client must not render as a cause).
   *
   * A plain String for the same reason baselineStatus is one: a future
   * server-side variant has to degrade on an old client rather than break its
   * parse. The reasons are not interchangeable to a user — 'no-template-id'
   * means this design never came from a template, which is nothing to fix,
   * while 'no-size-match' is ours.
   */
  baselineReason?: Maybe<Scalars['String']['output']>;
  /** resolved | none | forced — 'none' means provenance could not be established and the client must confirm before applying; 'forced' is a template run (forceRewrite), which proved nothing and needed nothing. */
  baselineStatus: Scalars['String']['output'];
  /**
   * True when the caller passed a briefId that was still cached, so the image,
   * video and copy planners read the concept brief. False plans exactly as a
   * call without one.
   */
  briefApplied: Scalars['Boolean']['output'];
  /** Replacement copy for text layers proven to still hold the template's placeholder wording. */
  copy: Array<BrandKitCopySlotPlan>;
  /**
   * Count of eligible placeholder text layers the copy planner could NOT
   * process because the model call rejected, timed out, or returned an
   * invalid response — as opposed to the copy list simply being empty
   * because nothing was eligible to rewrite in the first place. Those two
   * are NOT the same fact: without this field the client cannot tell
   * "there was nothing to rewrite" from "there was something, and it
   * silently failed", and would report the former to the user while every
   * placeholder stays untouched. 0 whenever copy planning never ran, was
   * never attempted (no eligible layers), or succeeded. A forceRewrite plan
   * also counts the text slots the planner returned no copy for, since a
   * template's own copy left in place is just as unwritten.
   */
  copyPlanningFailed: Scalars['Int']['output'];
  skipped: Array<BrandKitImagerySkippedSlot>;
  slots: Array<BrandKitImagerySlotPlan>;
  /** Template mode: lines of the user's own copy that no text slot could take, exactly as written. */
  unplacedCopy: Array<Scalars['String']['output']>;
  /**
   * Attached photos (attachedImageUrls, each counted once) that no slot uses: one
   * the server refused (not media the design's team can reach), one past the
   * first 4, or one the image planner put in no slot. Every one of them when
   * nothing was planned at all.
   */
  unusedAttachedImageCount: Scalars['Int']['output'];
  /**
   * Video slots to regenerate. Fired through startVideoGenerationFromPrompt
   * rather than generateProductPhotography, and written back by the apply
   * hook's video branch — replaceLayer is the only primitive that can change
   * a layer's type.
   */
  video: Array<BrandKitVideoSlotPlan>;
  /**
   * Count of eligible video slots the planner could NOT process because the
   * model call rejected, timed out, or returned an invalid response — as
   * opposed to the video list being empty because nothing was eligible. NOTE:
   * no backticks anywhere in this file — it is a gql template literal, and one
   * would terminate it and silently empty the whole schema. Without this field a
   * video-only design reports "no images to replace" on a planner failure
   * while its clip silently stays. 0 whenever video planning never ran or
   * succeeded.
   */
  videoPlanningFailed: Scalars['Int']['output'];
};

/** An image or video layer the plan deliberately left alone. */
export type BrandKitImagerySkippedSlot = {
  __typename?: 'BrandKitImagerySkippedSlot';
  /**
   * image or video — which family the skipped layer belongs to.
   *
   * Load-bearing for reporting: user-supplied, hidden, feed-bound and
   * multi-slide are all shared between the two families, so without this a
   * client cannot tell "we left your own PHOTO alone" from "we left your own
   * FOOTAGE alone", and has to either stay silent or guess.
   *
   * copy appears only on a forceRewrite plan, for a text layer past the copy
   * planner's cap (reason over-capacity): it keeps the template's words.
   */
  kind: Scalars['String']['output'];
  layerId: Scalars['Int']['output'];
  /**
   * Why it was skipped: logo | feed-bound | backdrop | image-fill-shape |
   * hidden | multi-slide | over-capacity | user-supplied | video-duration |
   * video-not-entitled.
   *
   * video-duration means the slot's window could not be determined, or is
   * longer than any offered generation duration. video-not-entitled is pushed
   * by the CLIENT, never by the planner: the team's plan does not include AI
   * video generation.
   */
  reason: Scalars['String']['output'];
};

/** One image slot the brand-kit apply should regenerate. */
export type BrandKitImagerySlotPlan = {
  __typename?: 'BrandKitImagerySlotPlan';
  /** Display aspect ratio derived from the slot's own frame, e.g. 3:2. */
  aspectRatio: Scalars['String']['output'];
  /**
   * A brand-kit image the slot is generated FROM, sent as the generation's
   * base image. Present only when the planner matched a real asset to the
   * slot's subject, and only ever the url of an asset the server offered.
   *
   * This is what lets a brand whose product must never be invented still show
   * that product in a photo: the depiction rules forbid generating it, the kit
   * holds a photo of it, and the image is built on that photo.
   */
  assetUrl?: Maybe<Scalars['String']['output']>;
  /**
   * True when the slot is a shape whose fill is the photo: the result is
   * written into the shape's image fill, not an image layer's source. Such a
   * slot is always planned as a scene.
   */
  fillsShapeBackground?: Maybe<Scalars['Boolean']['output']>;
  /** How the result is placed: scene | cutout. */
  imageMode: Scalars['String']['output'];
  /** The prompt to generate this slot's replacement image with. */
  imagePrompt: Scalars['String']['output'];
  /** The layer's bannersetElementId — shared across every size of a set. */
  layerId: Scalars['Int']['output'];
  /** True when the slot PLACES assetUrl — the user's attached photo, background removed by the client — instead of generating. */
  placeAttachment?: Maybe<Scalars['Boolean']['output']>;
};

/** One placeable item in a brand kit, for the Ad Studio Copilot's picker. */
export type BrandKitItem = {
  __typename?: 'BrandKitItem';
  /** One of logo, asset or component. */
  category: Scalars['String']['output'];
  /** Stored AI description. Always null for logos, which never get one. */
  description?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Media hash, or design-component hash. The identifier a picker passes back. */
  ref: Scalars['String']['output'];
  /** CDN url. Null for components, which have no single file. */
  src?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

/** A page of a brand kit's placeable items, with the true total behind it. */
export type BrandKitItemsResult = {
  __typename?: 'BrandKitItemsResult';
  items: Array<BrandKitItem>;
  /**
   * How many placeable items the kit holds in the requested categories, before
   * capping. Exact for logos and assets.
   *
   * For components it is ALWAYS a FLOOR, truncated or not. The underlying
   * design query reports no grand total, and it additionally clamps its page to
   * a plan-dependent limit while reporting hasNextPage false on a free plan - so
   * a free-plan kit holding more components than that limit cannot be
   * distinguished here from one that holds exactly that many.
   */
  totalCount: Scalars['Int']['output'];
  /** True when the caps hid part of the kit. */
  truncated: Scalars['Boolean']['output'];
};

export type BrandKitLogoContext = {
  __typename?: 'BrandKitLogoContext';
  /** Logo height in pixels */
  height?: Maybe<Scalars['Int']['output']>;
  /** Logo file name */
  name?: Maybe<Scalars['String']['output']>;
  /** Logo image URL */
  src?: Maybe<Scalars['String']['output']>;
  /** Logo width in pixels */
  width?: Maybe<Scalars['Int']['output']>;
};

/** Structured facts about what a brand is and what may safely be depicted for it. */
export type BrandKitProfile = {
  __typename?: 'BrandKitProfile';
  /** Whether this was AI-generated. */
  aiGenerated: Scalars['Boolean']['output'];
  /** Sources analyzed to generate this profile. */
  analyzedSources: Array<Scalars['String']['output']>;
  /** ID of the brand kit these settings belong to. */
  brandKitId: Scalars['Int']['output'];
  /** Kind of business: ecommerce, saas, restaurant, hospitality, services, retail, nonprofit, media, automotive, fashion, food-beverage, consumer-electronics, events-entertainment, other. */
  businessType: Scalars['String']['output'];
  /** BCP-47 tag for the language the brand's ad copy is written in, e.g. "en", "en-GB". Empty when not evidenced by the copy. */
  copyLanguage: Scalars['String']['output'];
  /** Last extraction error message, if the pipeline failed. */
  extractError?: Maybe<Scalars['String']['output']>;
  /** ISO timestamp of when the current/last extraction started. */
  extractStartedAt?: Maybe<Scalars['String']['output']>;
  /** Current status of the extraction pipeline: idle, running, or error. */
  extractStatus: Scalars['String']['output'];
  /** Monotonic version counter stamped each time an extraction is requested. */
  extractVersion: Scalars['Int']['output'];
  /** Short industry description, e.g. "specialty coffee roaster". */
  industry: Scalars['String']['output'];
  /** ISO 3166-1 alpha-2 country code (uppercase) for the market whose conventions apply, e.g. "US", "DE". Empty when not evidenced by the copy. */
  marketCountry: Scalars['String']['output'];
  /** Subjects a generator must never invent, in the brand's own words. */
  neverInvent: Array<Scalars['String']['output']>;
  /** What the brand sells or provides. */
  offering: Array<Scalars['String']['output']>;
  /** Nature of the offering: physical-product, digital-product, service, physical-place, mixed. */
  offeringKind: Scalars['String']['output'];
  /** Subjects that may only come from the kit's own media: product, packaging, storefront, interior, app-ui, people-staff. */
  requiresRealAsset: Array<Scalars['String']['output']>;
  /** Subjects a generator may invent freely for this brand. */
  safeSubjects: Array<Scalars['String']['output']>;
};

/** Response containing the project ID associated with a brand kit. */
export type BrandKitProjectId = {
  __typename?: 'BrandKitProjectId';
  /** ID of the project associated with the brand kit. */
  projectId: Scalars['Int']['output'];
};

/** Response containing a single brand kit. */
export type BrandKitResult = {
  __typename?: 'BrandKitResult';
  /** The requested brand kit. */
  brandKit: BrandKit;
  /** Whether nobody has given the kit a brand yet, by the Ad Studio Copilot's rule: no brand name, description, colour, logo or font of its own, or an untouched Demo Brand Kit. */
  isEmpty: Scalars['Boolean']['output'];
};

export type BrandKitStyleContext = {
  __typename?: 'BrandKitStyleContext';
  /** Whether this was AI-generated */
  aiGenerated: Scalars['Boolean']['output'];
  /** Sources analyzed to generate this style */
  analyzedSources: Array<Scalars['String']['output']>;
  /** How colors are used (not what colors) */
  colorUsage: Array<Scalars['String']['output']>;
  /** CTA button style */
  ctaButtonStyle?: Maybe<BrandStyleCtaButton>;
  /** Last re-evaluation error message if the pipeline failed */
  evalError?: Maybe<Scalars['String']['output']>;
  /** ISO timestamp of when the current/last re-evaluation started */
  evalStartedAt?: Maybe<Scalars['String']['output']>;
  /** Current state of the async re-evaluation pipeline: idle, running, or error */
  evalStatus?: Maybe<Scalars['String']['output']>;
  /** Monotonic version counter stamped on every re-evaluation request */
  evalVersion?: Maybe<Scalars['Int']['output']>;
  /** Graphic elements and texture preferences */
  graphicElements: Array<Scalars['String']['output']>;
  /** Headline text style */
  headlineStyle?: Maybe<BrandStyleTextElement>;
  /** Illustration style preferences */
  illustrationStyle: Array<Scalars['String']['output']>;
  /** Layout and composition preferences */
  layoutPreferences: Array<Scalars['String']['output']>;
  /** Mood and atmosphere descriptors */
  mood: Array<Scalars['String']['output']>;
  /** Photography and imagery style preferences */
  photographyStyle: Array<Scalars['String']['output']>;
  /** Source images used in the brand style analysis */
  sourceImages?: Maybe<Array<BrandStyleSourceImage>>;
  /** Subheadline text style */
  subheadlineStyle?: Maybe<BrandStyleTextElement>;
  /** Schema version */
  version: Scalars['Int']['output'];
  /** Core visual aesthetic descriptors */
  visualStyle: Array<Scalars['String']['output']>;
};

export type BrandKitTargetAudienceContext = {
  __typename?: 'BrandKitTargetAudienceContext';
  /** Name of this audience segment */
  audienceName: Scalars['String']['output'];
  /** Description of this target audience */
  brandAudience?: Maybe<Scalars['String']['output']>;
};

export type BrandKitTypographyItem = {
  __typename?: 'BrandKitTypographyItem';
  /** Font face URL for custom uploaded fonts. Null for google/creatopy fonts. */
  fontFaceUrl?: Maybe<Scalars['String']['output']>;
  /** Canonical font-family name with weight suffix stripped (e.g. 'Roboto Condensed'). */
  fontFamily: Scalars['String']['output'];
  /** Display font label, may embed a weight word (e.g. 'Roboto Condensed Bold'). Prefer fontFamily for rendering. */
  fontName: Scalars['String']['output'];
  /** Font size in pixels */
  fontSize: Scalars['Int']['output'];
  /** Font system: 'custom' (uploaded Font row backs the typography) or 'google'. */
  fontType: Scalars['String']['output'];
  /** Display font weight string (e.g. '400', '700', 'bold'). Prefer fontWeightNum for rendering. */
  fontWeight?: Maybe<Scalars['String']['output']>;
  /** Numeric font weight (100–900). */
  fontWeightNum: Scalars['Int']['output'];
  /** Line height multiplier */
  lineHeight?: Maybe<Scalars['Float']['output']>;
  /** Typography role (heading, subheading, body, or custom) */
  type: Scalars['String']['output'];
};

/** One video slot the brand-kit apply should regenerate. */
export type BrandKitVideoSlotPlan = {
  __typename?: 'BrandKitVideoSlotPlan';
  /**
   * 16:9 or 9:16 — the only two aspects video generation supports — chosen
   * from the slot's OWN frame and never read from the model, so the value
   * that sizes the request and the value reported back cannot diverge. The
   * result is cover-cropped into the slot, which is almost never either ratio.
   */
  aspectRatio: Scalars['String']['output'];
  /**
   * A brand-kit image the clip is built around, passed as a SUBJECT REFERENCE.
   * Present only when the planner matched a real asset to the slot's subject.
   *
   * This is what lets a brand whose product must never be invented still show
   * that product: the depiction rules forbid generating it, the kit holds a
   * photo of it, and the model composes the clip around what that photo shows.
   *
   * Deliberately NOT the clip's first frame. That channel takes the asset
   * literally, cover-cropping it to the slot's aspect before the clip starts,
   * which cuts a subject that does not sit centred in a kit shot out of frame.
   * As a reference the model composes the opening frame itself, at the slot's
   * aspect, with the subject whole.
   */
  assetUrl?: Maybe<Scalars['String']['output']>;
  /**
   * True when the slot's window is longer than generation can produce, so the
   * clip covers only part of it. The slot is still served — a partly-covered
   * slot beats no clip at all — and the client explains the limit in plain
   * words rather than refusing.
   */
  durationClamped?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Seconds to generate, rounded UP to an offered duration so the clip always
   * COVERS the slot's window. Generating short is a visible defect rather than
   * a rounding error: the layer's build window ends at the clip's own length
   * with an INSTANT build-out, so the video vanishes for the remainder of the
   * slide.
   */
  durationSeconds: Scalars['Int']['output'];
  /** The layer's bannersetElementId — shared across every size of a set. */
  layerId: Scalars['Int']['output'];
  /** The prompt to generate this slot's replacement clip with. */
  videoPrompt: Scalars['String']['output'];
};

/** Visual style settings for a brand kit. */
export type BrandKitVisualStyle = {
  __typename?: 'BrandKitVisualStyle';
  /** Whether this was AI-generated. */
  aiGenerated?: Maybe<Scalars['Boolean']['output']>;
  /** Sources analyzed to generate this style. */
  analyzedSources?: Maybe<Array<Scalars['String']['output']>>;
  /** ID of the brand kit these settings belong to. */
  brandKitId: Scalars['Int']['output'];
  /** Last re-evaluation error message, if the pipeline failed. */
  brandStyleEvalError?: Maybe<Scalars['String']['output']>;
  /** ISO timestamp of when the current/last re-evaluation started. */
  brandStyleEvalStartedAt?: Maybe<Scalars['String']['output']>;
  /** Current status of the brand-style re-evaluation pipeline: idle, running, or error. */
  brandStyleEvalStatus: Scalars['String']['output'];
  /** Monotonic version counter stamped each time a re-evaluation is requested. */
  brandStyleEvalVersion: Scalars['Int']['output'];
  /** How colors are used (not what colors). */
  colorUsage?: Maybe<Array<Scalars['String']['output']>>;
  /** CTA button style analysis. */
  ctaButtonStyle?: Maybe<BrandStyleCtaButton>;
  /** Graphic elements and texture preferences. */
  graphicElements?: Maybe<Array<Scalars['String']['output']>>;
  /** Headline/title text style analysis. */
  headlineStyle?: Maybe<BrandStyleTextElement>;
  /** Illustration style preferences. */
  illustrationStyle?: Maybe<Array<Scalars['String']['output']>>;
  /** Layout and composition preferences. */
  layoutPreferences?: Maybe<Array<Scalars['String']['output']>>;
  /** Mood and atmosphere descriptors. */
  mood?: Maybe<Array<Scalars['String']['output']>>;
  /** Photography and imagery style preferences. */
  photographyStyle?: Maybe<Array<Scalars['String']['output']>>;
  /** Source images that were analyzed to generate the style. */
  sourceImages?: Maybe<Array<BrandStyleSourceImage>>;
  /** URL of the AI-generated brand style tile image. */
  styleTileUrl?: Maybe<Scalars['String']['output']>;
  /** Subheadline/secondary text style analysis. */
  subheadlineStyle?: Maybe<BrandStyleTextElement>;
  /** Core visual aesthetic descriptors. */
  visualStyle?: Maybe<Array<Scalars['String']['output']>>;
};

/** Voice and tone settings for AI-generated content in a brand kit. */
export type BrandKitVoiceAndTone = {
  __typename?: 'BrandKitVoiceAndTone';
  /** Whether the brand tone was AI-suggested. */
  aiSuggestedBrandTone?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the brand voice was AI-suggested. */
  aiSuggestedBrandVoice?: Maybe<Scalars['Boolean']['output']>;
  /** ID of the brand kit these settings belong to. */
  brandKitId?: Maybe<Scalars['Int']['output']>;
  /** Array of tone attributes for the brand. */
  brandTone?: Maybe<Array<Scalars['String']['output']>>;
  /** Description of the brand's voice. */
  brandVoice?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the voice and tone settings. */
  id?: Maybe<Scalars['Int']['output']>;
};

export type BrandKitVoiceAndToneContext = {
  __typename?: 'BrandKitVoiceAndToneContext';
  /** Tone keywords (e.g. friendly, professional) */
  brandTone?: Maybe<Array<Scalars['String']['output']>>;
  /** Description of the brand voice */
  brandVoice?: Maybe<Scalars['String']['output']>;
};

/** Response containing a list of brand kits and wizard display setting. */
export type BrandKitsResult = {
  __typename?: 'BrandKitsResult';
  /** List of brand kits for the team. */
  brandKits: Array<BrandKit>;
  /** Whether the brand kit wizard should be displayed for this team. */
  brandkitWizard: Scalars['Boolean']['output'];
  /** Pagination metadata. Present when a limit is supplied. */
  pageInfo?: Maybe<PageInfo>;
  /** Total number of kits matching the query, ignoring pagination. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type BrandLogo = {
  __typename?: 'BrandLogo';
  src?: Maybe<Scalars['String']['output']>;
  theme?: Maybe<Scalars['String']['output']>;
};

/** Company metrics for a brand. */
export type BrandMetrics = {
  __typename?: 'BrandMetrics';
  /** Number of employees. */
  employees?: Maybe<Scalars['Int']['output']>;
  /** Year founded. */
  founded?: Maybe<Scalars['Int']['output']>;
  /** Revenue information. */
  revenue?: Maybe<Scalars['String']['output']>;
};

export type BrandRecords = {
  __typename?: 'BrandRecords';
  dkim: RecordType;
  spf: RecordType;
};

/** Input for searching brands using external Brand Search API. */
export type BrandSearchApiInput = {
  /** Country code for filtering results (optional). */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Maximum number of results to return (optional, default: 10). */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** The search query string. */
  query: Scalars['String']['input'];
};

/** Response for Brand Search API. */
export type BrandSearchApiResponse = {
  __typename?: 'BrandSearchApiResponse';
  /** Error message if request failed. */
  error?: Maybe<Scalars['String']['output']>;
  /** The search query that was executed. */
  query: Scalars['String']['output'];
  /** Array of found brands. */
  results: Array<BrandSearchApiResult>;
  /** Source of the data (e.g., brandfetch, clearbit). */
  source: Scalars['String']['output'];
  /** Whether the request was successful. */
  success: Scalars['Boolean']['output'];
  /** Timestamp of the request. */
  timestamp: Scalars['String']['output'];
  /** Total number of results found. */
  totalResults: Scalars['Int']['output'];
};

/** Brand information from external Brand Search API. */
export type BrandSearchApiResult = {
  __typename?: 'BrandSearchApiResult';
  /** Brand description. */
  description?: Maybe<Scalars['String']['output']>;
  /** Brand domain/website. */
  domain?: Maybe<Scalars['String']['output']>;
  /** Unique brand identifier. */
  id: Scalars['String']['output'];
  /** Industry category. */
  industry?: Maybe<Scalars['String']['output']>;
  /** Location/country. */
  location?: Maybe<Scalars['String']['output']>;
  /** Brand logo URL. */
  logo?: Maybe<Scalars['String']['output']>;
  /** Company metrics. */
  metrics?: Maybe<BrandMetrics>;
  /** Brand name. */
  name: Scalars['String']['output'];
  /** Social media information. */
  socialMedia?: Maybe<BrandSocialMedia>;
  /** Brand website URL. */
  website?: Maybe<Scalars['String']['output']>;
};

/** Social media information for a brand. */
export type BrandSocialMedia = {
  __typename?: 'BrandSocialMedia';
  /** Facebook page URL. */
  facebook?: Maybe<Scalars['String']['output']>;
  /** Instagram profile URL. */
  instagram?: Maybe<Scalars['String']['output']>;
  /** LinkedIn page URL. */
  linkedin?: Maybe<Scalars['String']['output']>;
  /** Twitter profile URL. */
  twitter?: Maybe<Scalars['String']['output']>;
};

/** CTA button style descriptors. */
export type BrandStyleCtaButton = {
  __typename?: 'BrandStyleCtaButton';
  /** Color treatment descriptors (bold contrast, subtle, etc.). */
  colorTreatment?: Maybe<Array<Scalars['String']['output']>>;
  /** Shape descriptors (rounded, pill-shaped, outlined, etc.). */
  shape?: Maybe<Array<Scalars['String']['output']>>;
  /** Text style descriptors (all-caps, with arrow/icon, etc.). */
  textStyle?: Maybe<Array<Scalars['String']['output']>>;
};

export type BrandStyleReevaluationResult = {
  __typename?: 'BrandStyleReevaluationResult';
  brandKitId: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

/** A source image analyzed for brand style. */
export type BrandStyleSourceImage = {
  __typename?: 'BrandStyleSourceImage';
  /** Origin of the image (website, facebook_ads, brandfetch). */
  source: Scalars['String']['output'];
  /** Permanent CDN URL of the image. */
  url: Scalars['String']['output'];
};

/** Text element style descriptors (headline, subheadline). */
export type BrandStyleTextElement = {
  __typename?: 'BrandStyleTextElement';
  /** Color treatment descriptors (dark on light, high contrast, etc.). */
  colorTreatment?: Maybe<Array<Scalars['String']['output']>>;
  /** Font style descriptors (bold, serif, all-caps, etc.). */
  fontStyle?: Maybe<Array<Scalars['String']['output']>>;
  /** Sizing descriptors (large and dominant, compact, etc.). */
  sizing?: Maybe<Array<Scalars['String']['output']>>;
};

/** Target audience for AI-generated content in a brand kit. */
export type BrandTargetAudience = {
  __typename?: 'BrandTargetAudience';
  /** Whether the brand audience was AI-suggested. */
  aiSuggestedBrandAudience?: Maybe<Scalars['Boolean']['output']>;
  /** Name of the brand's audience. */
  audienceName?: Maybe<Scalars['String']['output']>;
  /** Description of the brand's audience. */
  brandAudience?: Maybe<Scalars['String']['output']>;
  /** ID of the brand kit these settings belong to. */
  brandKitId: Scalars['Int']['output'];
  /** Unique identifier for brand target audience. */
  id: Scalars['Int']['output'];
};

export type BrandTemplateFolderTreePayload = {
  __typename?: 'BrandTemplateFolderTreePayload';
  templatesFolders: Array<FolderTreeItem>;
};

export type BrandTemplatePayload = {
  __typename?: 'BrandTemplatePayload';
  design: Design;
};

/** @deprecated Brand template migration service has been removed. @BreakingBad */
export enum BrandTemplatesMigrationStatus {
  FAIL = 'FAIL',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS'
}

/** @deprecated Brand template migration service has been removed. @BreakingBad */
export type BrandTemplatesMigrationStatusResult = {
  __typename?: 'BrandTemplatesMigrationStatusResult';
  status: BrandTemplatesMigrationStatus;
};

/** Information about branded content partnerships */
export type BrandedContent = {
  __typename?: 'BrandedContent';
  /** Name of the branded content partner */
  pageName: Scalars['String']['output'];
  /** Profile picture URL of the partner */
  pageProfilePicUrl?: Maybe<Scalars['String']['output']>;
};

export type BrandedCopyAdContent = {
  __typename?: 'BrandedCopyAdContent';
  cta: Scalars['String']['output'];
  description: Scalars['String']['output'];
  headline: Scalars['String']['output'];
  mediaDescriptionIndex?: Maybe<Scalars['Int']['output']>;
  technique: Scalars['String']['output'];
};

/**
 * The versioned brief-assets slot (v2). `version` is the slot's monotonic
 * change counter — the compare-and-swap key for `replaceBriefAssets`; every
 * slot write (the brief stamp included) bumps it by 1.
 */
export type BriefAssetsSlot = {
  __typename?: 'BriefAssetsSlot';
  assets: Array<ChatBriefAsset>;
  /** Whether this brief has a product — see BriefProductState. */
  product: BriefProductState;
  version: Scalars['Int']['output'];
};

/**
 * Result of a versioned slot write. `written: false` is a version conflict
 * — the slot changed since the caller's view — and `slot` then carries the
 * CURRENT server state to re-seed from and reconcile; `written: true`
 * carries the persisted set at its new version.
 */
export type BriefAssetsWrite = {
  __typename?: 'BriefAssetsWrite';
  slot: BriefAssetsSlot;
  written: Scalars['Boolean']['output'];
};

/**
 * Whether an Ad Studio Copilot brief has a product. `ASSET` — the first
 * brief asset (`assets[0]`) is the preserved product the ad is built on,
 * every other image a style reference. `NONE` — there is no product; every
 * image is a style reference, and an empty asset list is also `NONE`.
 * `GENERATE` — the user was told no real image of their brand's own
 * restricted item exists and asked for it to be generated for this ad, so the
 * ad HAS a product but no image of it: every asset it carries is a style
 * reference, exactly as in `NONE`. Only the brief agent sets it; the card
 * echoes it back unchanged.
 */
export enum BriefProductState {
  ASSET = 'ASSET',
  GENERATE = 'GENERATE',
  NONE = 'NONE'
}

/** @deprecated Migration service has been removed */
export enum BsAccountType {
  /** @deprecated Migration service has been removed */
  FACEBOOK = 'FACEBOOK',
  /** @deprecated Migration service has been removed */
  GOOGLE = 'GOOGLE',
  /** @deprecated Migration service has been removed */
  MYSPACE = 'MYSPACE',
  /** @deprecated Migration service has been removed */
  SNACKTOOLS = 'SNACKTOOLS',
  /** @deprecated Migration service has been removed */
  TWITTER = 'TWITTER',
  /** @deprecated Migration service has been removed */
  YAHOO = 'YAHOO'
}

/** @deprecated Migration service has been removed */
export type BsPermissions = {
  __typename?: 'BsPermissions';
  /** @deprecated Migration service has been removed */
  approveVersion: Scalars['Boolean']['output'];
  /** @deprecated Migration service has been removed */
  billingOptions: Scalars['Boolean']['output'];
  /** @deprecated Migration service has been removed */
  changeShareSettings: Scalars['Boolean']['output'];
  /** @deprecated Migration service has been removed */
  createEdit: Scalars['Boolean']['output'];
  /** @deprecated Migration service has been removed */
  manageTeamMembers: Scalars['Boolean']['output'];
  /** @deprecated Migration service has been removed */
  manageWorkspaces: Scalars['Boolean']['output'];
  /** @deprecated Migration service has been removed */
  switchAccount: Scalars['Boolean']['output'];
  /** @deprecated Migration service has been removed */
  view: Scalars['Boolean']['output'];
};

/** @deprecated Migration service has been removed */
export enum BsPlanStatus {
  /** @deprecated Migration service has been removed */
  ACTIVE = 'ACTIVE',
  /** @deprecated Migration service has been removed */
  AD_TAG_ACTIVATED = 'AD_TAG_ACTIVATED',
  /** @deprecated Migration service has been removed */
  CUSTOM_TEAM_ACTIVE = 'CUSTOM_TEAM_ACTIVE',
  /** @deprecated Migration service has been removed */
  CUSTOM_TEAM_EXPIRED = 'CUSTOM_TEAM_EXPIRED',
  /** @deprecated Migration service has been removed */
  CUSTOM_TEAM_INACTIVE = 'CUSTOM_TEAM_INACTIVE',
  /** @deprecated Migration service has been removed */
  EXPIRED = 'EXPIRED',
  /** @deprecated Migration service has been removed */
  INACTIVE = 'INACTIVE',
  /** @deprecated Migration service has been removed */
  NEVER = 'NEVER',
  /** @deprecated Migration service has been removed */
  SUGGESTED = 'SUGGESTED'
}

/** @deprecated Migration service has been removed */
export type BsTeam = {
  __typename?: 'BsTeam';
  /** @deprecated Migration service has been removed */
  id: Scalars['Int']['output'];
  /** @deprecated Migration service has been removed */
  members?: Maybe<Array<BsTeamMember>>;
};

/** @deprecated Migration service has been removed */
export type BsTeamMember = {
  __typename?: 'BsTeamMember';
  /** @deprecated Migration service has been removed */
  email: Scalars['String']['output'];
  /** @deprecated Migration service has been removed */
  id: Scalars['Int']['output'];
  /** @deprecated Migration service has been removed */
  permissions: BsPermissions;
};

/** @deprecated Migration service has been removed */
export type BsUser = {
  __typename?: 'BsUser';
  /** @deprecated Migration service has been removed */
  id: Scalars['Int']['output'];
  /** @deprecated Migration service has been removed */
  type: BsAccountType;
};

/** One team the batch could not restrict. The rest of the batch still applied. */
export type BulkUsageRestrictionFailure = {
  __typename?: 'BulkUsageRestrictionFailure';
  error: Scalars['String']['output'];
  teamId: Scalars['Int']['output'];
};

/**
 * Outcome of a bulk restriction. Partial success is expected and is not an error:
 * created and failed together account for every deduplicated team id.
 */
export type BulkUsageRestrictionResult = {
  __typename?: 'BulkUsageRestrictionResult';
  created: Array<UsageRestriction>;
  failed: Array<BulkUsageRestrictionFailure>;
  /** Deduplicated team ids actually attempted. */
  requested: Scalars['Int']['output'];
};

/** Business size categories. */
export enum BusinessSizeType {
  /** Large business (typically 501+ employees). */
  LARGE = 'LARGE',
  /** Medium business (typically 51-500 employees). */
  MEDIUM = 'MEDIUM',
  /** Small business (typically 1-50 employees). */
  SMALL = 'SMALL'
}

export type BusinessSocialLink = {
  __typename?: 'BusinessSocialLink';
  accountId: Scalars['String']['output'];
  accountName: Scalars['String']['output'];
  avatarUrl?: Maybe<Scalars['String']['output']>;
  connectedBy: Scalars['Int']['output'];
  expiresAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  isDefault: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  teamId: Scalars['Int']['output'];
  type: DpaPlatformType;
};

export type ByUser = {
  __typename?: 'ByUser';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** Represents a Bynder asset. */
export type BynderAsset = {
  __typename?: 'BynderAsset';
  /** Focus point of the active original media item. */
  activeOriginalFocusPoint?: Maybe<BynderAssetItemFocusPoint>;
  /** Indicates if the asset is archived. */
  archive?: Maybe<Scalars['Boolean']['output']>;
  /** ID of the brand the asset belongs to. */
  brandId?: Maybe<Scalars['String']['output']>;
  /** Copyright information for the asset. */
  copyright?: Maybe<Scalars['String']['output']>;
  /** Date when the asset was created. */
  dateCreated?: Maybe<Scalars['String']['output']>;
  /** Date when the asset was last modified. */
  dateModified?: Maybe<Scalars['String']['output']>;
  /** Date when the asset was published. */
  datePublished?: Maybe<Scalars['String']['output']>;
  /** Description of the asset. */
  description?: Maybe<Scalars['String']['output']>;
  /** Number of downloads for the asset. */
  downloads?: Maybe<Scalars['Int']['output']>;
  /** File extension(s) of the asset. */
  extension?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Size of the asset file in bytes. */
  fileSize?: Maybe<Scalars['Int']['output']>;
  /** Height of the asset in pixels. */
  height?: Maybe<Scalars['Float']['output']>;
  /** Unique identifier for the asset. */
  id?: Maybe<Scalars['String']['output']>;
  /** Hashed ID of the asset. */
  idHash?: Maybe<Scalars['String']['output']>;
  /** Indicates if the asset is public. */
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the asset has limited usage rights. */
  limited?: Maybe<Scalars['Boolean']['output']>;
  /** List of media items (renditions/versions) for the asset. */
  mediaItems?: Maybe<Array<Maybe<BynderAssetItem>>>;
  /** Name of the asset. */
  name?: Maybe<Scalars['String']['output']>;
  /** Orientation of the asset (e.g., landscape, portrait). */
  orientation?: Maybe<Scalars['String']['output']>;
  /** URL of the original asset file. */
  original?: Maybe<Scalars['String']['output']>;
  /** List of property options associated with the asset. */
  propertyOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * Metaproperty representing the asset type.
   * Example: property_assettype: ["image"]
   */
  property_assettype?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** List of assets related to this asset. */
  relatedAssets?: Maybe<Array<Maybe<BynderRelatedAsset>>>;
  /** Tags associated with the asset. */
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Thumbnails for the asset (JSON object). */
  thumbnails?: Maybe<Scalars['JSON']['output']>;
  /** Base URL for transformations of this asset. */
  transformBaseUrl?: Maybe<Scalars['String']['output']>;
  /** Type of the asset (e.g., image, video, document). */
  type?: Maybe<Scalars['String']['output']>;
  /** User who created the asset. */
  userCreated?: Maybe<Scalars['String']['output']>;
  /** URLs for video preview renditions. */
  videoPreviewURLs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Number of views for the asset. */
  views?: Maybe<Scalars['Int']['output']>;
  /** Indicates if the asset is watermarked. */
  watermarked?: Maybe<Scalars['Boolean']['output']>;
  /** Width of the asset in pixels. */
  width?: Maybe<Scalars['Float']['output']>;
};

/** Response containing information for downloading a Bynder asset. */
export type BynderAssetDownload = {
  __typename?: 'BynderAssetDownload';
  /** Disclaimer associated with the asset download. */
  disclaimer?: Maybe<Scalars['String']['output']>;
  /** S3 file URL or path for the asset download. */
  s3_file?: Maybe<Scalars['String']['output']>;
};

/** Represents a specific media item (rendition or version) of a Bynder asset. */
export type BynderAssetItem = {
  __typename?: 'BynderAssetItem';
  /** Indicates if the media item is active. */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Additional ID for the media item, if any. */
  additionalId?: Maybe<Scalars['String']['output']>;
  /** Date when the media item was created. */
  dateCreated?: Maybe<Scalars['String']['output']>;
  /** Filename of the media item. */
  fileName?: Maybe<Scalars['String']['output']>;
  /** Focus point of the media item. */
  focusPoint?: Maybe<BynderAssetItemFocusPoint>;
  /** Height of the media item in pixels. */
  height?: Maybe<Scalars['Float']['output']>;
  /** Unique identifier for the media item. */
  id?: Maybe<Scalars['String']['output']>;
  /** Size of the media item in bytes. */
  size?: Maybe<Scalars['Int']['output']>;
  /** Thumbnails for the media item (JSON object). */
  thumbnails?: Maybe<Scalars['JSON']['output']>;
  /** Type of the media item (e.g., original, webversion, thumbnail). */
  type?: Maybe<Scalars['String']['output']>;
  /** Version number of the media item. */
  version?: Maybe<Scalars['Int']['output']>;
  /** Width of the media item in pixels. */
  width?: Maybe<Scalars['Float']['output']>;
};

/** Represents the focus point (x, y coordinates) of a Bynder asset item. */
export type BynderAssetItemFocusPoint = {
  __typename?: 'BynderAssetItemFocusPoint';
  /** The X-coordinate of the focus point. */
  x?: Maybe<Scalars['Float']['output']>;
  /** The Y-coordinate of the focus point. */
  y?: Maybe<Scalars['Float']['output']>;
};

/** Response containing the Bynder authentication URL. */
export type BynderAuthUrlResponse = {
  __typename?: 'BynderAuthUrlResponse';
  /** The URL to redirect the user to for Bynder authentication. */
  url: Scalars['String']['output'];
};

/** Represents related assets in Bynder, linked via a metaproperty. */
export type BynderRelatedAsset = {
  __typename?: 'BynderRelatedAsset';
  /** A list of IDs of the related assets. */
  assets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The ID of the metaproperty that defines the relationship. */
  metaPropertyId?: Maybe<Scalars['String']['output']>;
  /** The name of the metaproperty that defines the relationship. */
  metaPropertyName?: Maybe<Scalars['String']['output']>;
};

/** Response containing Bynder access and refresh tokens. */
export type BynderTokenResponse = {
  __typename?: 'BynderTokenResponse';
  /** The Bynder refresh token. */
  refreshToken: Scalars['String']['output'];
  /** The Bynder access token. */
  token: Scalars['String']['output'];
};

/** Represents a Bynder user profile. */
export type BynderUser = {
  __typename?: 'BynderUser';
  /** Indicates if the user account is active. */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** User's address. */
  address?: Maybe<Scalars['String']['output']>;
  /** User's cellphone number. */
  cellphoneNumber?: Maybe<Scalars['String']['output']>;
  /** User's city. */
  city?: Maybe<Scalars['String']['output']>;
  /** User's company name. */
  companyName?: Maybe<Scalars['String']['output']>;
  /** User's cost center. */
  costCenter?: Maybe<Scalars['String']['output']>;
  /** User's country. */
  country?: Maybe<Scalars['String']['output']>;
  /** User's county. */
  county?: Maybe<Scalars['String']['output']>;
  /** User's department. */
  department?: Maybe<Scalars['String']['output']>;
  /** User's department code. */
  departmentCode?: Maybe<Scalars['String']['output']>;
  /** User's email address. */
  email?: Maybe<Scalars['String']['output']>;
  /** User's employee number. */
  employeeNumber?: Maybe<Scalars['String']['output']>;
  /** User's first name. */
  firstname?: Maybe<Scalars['String']['output']>;
  /** User's gender. */
  gender?: Maybe<Scalars['String']['output']>;
  /** User's unique identifier. */
  id?: Maybe<Scalars['String']['output']>;
  /** User's infix (e.g., van, de). */
  infix?: Maybe<Scalars['String']['output']>;
  /** Indicates if the user can only log in via SSO. */
  isSSOOnly?: Maybe<Scalars['Boolean']['output']>;
  /** User's job title. */
  job?: Maybe<Scalars['String']['output']>;
  /** User's preferred language. */
  language?: Maybe<Scalars['String']['output']>;
  /** Timestamp of the user's last login. */
  lastLogin?: Maybe<Scalars['String']['output']>;
  /** User's last name. */
  lastname?: Maybe<Scalars['String']['output']>;
  /** User's legal entity. */
  legalEntity?: Maybe<Scalars['String']['output']>;
  /** Indicates if the user's details are persisted. */
  persisted?: Maybe<Scalars['Boolean']['output']>;
  /** User's phone number. */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** User's postal code. */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** User's profile ID. */
  profileId?: Maybe<Scalars['String']['output']>;
  /** User's state/province. */
  state?: Maybe<Scalars['String']['output']>;
  /** Terms and conditions status for the user. */
  terms?: Maybe<Scalars['String']['output']>;
  /** User's time zone. */
  timeZone?: Maybe<Scalars['String']['output']>;
  /** User's username. */
  username?: Maybe<Scalars['String']['output']>;
};

/** Call-to-action usage statistics */
export type CtaStats = {
  __typename?: 'CTAStats';
  /** Number of ads using this CTA */
  count: Scalars['Int']['output'];
  /** Actual CTA text used */
  ctaText: Scalars['String']['output'];
  /** Whether this CTA is a no CTA */
  noCTA: Scalars['Boolean']['output'];
  /** Percentage of total ads using this CTA */
  percentage: Scalars['Float']['output'];
  /** Type of CTA */
  type: Scalars['String']['output'];
};

export enum CacheControlScope {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC'
}

export type CancelActiveJobInput = {
  designId: Scalars['Int']['input'];
  platform: DpaPlatformType;
};

export type CancelLayeredAdResult = {
  __typename?: 'CancelLayeredAdResult';
  /** True when this call stopped the ad. False when it had already finished or failed; status says which. */
  cancelled: Scalars['Boolean']['output'];
  status: ImageGenerationStatus;
};

export type CancelSubscriptionPayload = {
  __typename?: 'CancelSubscriptionPayload';
  result: RecurlySubscription;
};

export type CancelWorkflowResponse = {
  __typename?: 'CancelWorkflowResponse';
  success: Scalars['Boolean']['output'];
};

export enum CancellationReasonCategory {
  INVALID_REASON = 'INVALID_REASON',
  LOW_USAGE = 'LOW_USAGE',
  MISSING_FEATURES = 'MISSING_FEATURES',
  NO_LONGER_NEEDED = 'NO_LONGER_NEEDED',
  OTHER = 'OTHER',
  SWITCHING_TO_COMPETITOR = 'SWITCHING_TO_COMPETITOR',
  TECHNICAL_ISSUES = 'TECHNICAL_ISSUES',
  TOO_EXPENSIVE = 'TOO_EXPENSIVE'
}

export type CancellationReasonValidation = {
  attemptNumber?: InputMaybe<Scalars['Int']['input']>;
  cancellationReason: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type CancellationReasonValidationResult = {
  __typename?: 'CancellationReasonValidationResult';
  category: CancellationReasonCategory;
  isValid: Scalars['Boolean']['output'];
};

export type CancellationReasonsList = {
  __typename?: 'CancellationReasonsList';
  pageInfo: PageInfo;
  results: Array<AdminCancellationReasons>;
};

export enum CaptionSourceType {
  AUDIO = 'AUDIO',
  VIDEO = 'VIDEO'
}

export enum CaptionStyleType {
  STYLE_1 = 'style_1',
  STYLE_2 = 'style_2',
  STYLE_3 = 'style_3',
  STYLE_4 = 'style_4',
  STYLE_5 = 'style_5',
  STYLE_6 = 'style_6',
  STYLE_7 = 'style_7',
  STYLE_8 = 'style_8',
  STYLE_9 = 'style_9'
}

/** Carousel card usage analytics */
export type CardAnalytics = {
  __typename?: 'CardAnalytics';
  /** Number of ads that include carousel cards */
  adsWithCards: Scalars['Int']['output'];
  /** Average number of cards per carousel ad */
  averageCardsPerAd: Scalars['Float']['output'];
  /** Distribution of card types */
  cardTypeDistribution: Array<CardTypeDistribution>;
  /** Total number of cards across all carousel ads */
  totalCards: Scalars['Int']['output'];
};

/** Card type distribution statistics */
export type CardTypeDistribution = {
  __typename?: 'CardTypeDistribution';
  /** Number of cards of this type */
  count: Scalars['Int']['output'];
  /** Percentage of total cards of this type */
  percentage: Scalars['Float']['output'];
  /** Type of card content */
  type: Scalars['String']['output'];
};

/**
 * A catalog — by identity the underlying feed row (D23), enriched with the
 * catalog columns added in CRE-400 (workspaceId, contentType, currency, ...).
 */
export type Catalog = {
  __typename?: 'Catalog';
  /** Number of designs connected to the conceptual All Products scope, including collapsed filterless source anchors */
  allProductsAttachedDesignsCount: Scalars['Int']['output'];
  /** Number of designs connected via design_feed (COUNT only — no design payloads) */
  attachedDesignsCount: Scalars['Int']['output'];
  /** Whether a manual Sync now can run for this source (same eligibility as the syncFeed mutation — Translation/manual sources without a URL can't re-sync) */
  canSyncNow: Scalars['Boolean']['output'];
  /** Typed columns of the catalog's source rows (ordered by index) — drives the Products table headers (CRE-405) */
  columns?: Maybe<Array<FeedColumn>>;
  contentType: CatalogContentType;
  createdAt: Scalars['Date']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  /** Profile picture URL of the catalog's creator, for surfaces that show a face beside createdByName; NULL when the user has none or the account is gone. Deliberately a scalar and not a User: the surface needs a picture, and the shared User type carries authId, email, accountId and anonymousId with no field-level authorization, so returning it here would open those to every catalog reader. Resolves through the same per-request loader createdByName uses, so selecting both costs one lookup */
  createdByPicture?: Maybe<Scalars['String']['output']>;
  /** Display currency for price fields (D20 — formatting only) */
  currency: Scalars['String']['output'];
  feedError?: Maybe<Scalars['String']['output']>;
  hash: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** Whether this catalog is a design-layer snapshot (a Design based source), regardless of whether that design still exists. sourceDesignId says WHICH design and reads NULL once it is deleted; this flag survives the deletion, because the catalog stays a non-syncing snapshot that only hand-written rows can grow */
  isDesignSnapshot: Scalars['Boolean']['output'];
  /** Whether the current user has favorited this catalog (CRE-451) — per-user; drives the catalogs-list All/Favorite grouping and the star toggle */
  isFavorite: Scalars['Boolean']['output'];
  /**
   * business_social_link accountId of the Meta account a Meta catalog reads through — a reference, not the
   * connection. The row itself (name, token expiry, status) is linkedBusinessSocialLinks, the one
   * BusinessSocialLink read every Meta consumer shares. NULL for every other source.
   */
  metaAccountId?: Maybe<Scalars['String']['output']>;
  /** Meta catalog vertical captured on Meta import (D10); NULL otherwise */
  metaVertical?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Next scheduled sync; NULL on manual-only catalogs */
  nextUpdate?: Maybe<Scalars['Date']['output']>;
  /** Number of conceptual product-set rows, including the All products default once — the list column / detail subline */
  productSetsCount: Scalars['Int']['output'];
  /** Product counts bucketed by each product's worst IMAGE-column readiness (CRE-415, §4.7) */
  readinessCounts: CatalogReadinessCounts;
  rows: Scalars['Int']['output'];
  /** Sync run history, newest first (CRE-414, §4.6); limit caps at the 50-run retention window */
  runs: Array<CatalogRun>;
  /** The design this catalog was built from by the Design based wizard source (CRE-595); NULL for every other source, for design-based catalogs created before the column existed, and once that design has been deleted (the stored id is not a foreign key, so it is resolved through the paranoid design loader and reads NULL for a design that no longer exists). Existence only: like CatalogConnection.designId, it is visible to every member of the catalog team and is not filtered by the requester's project access */
  sourceDesignId?: Maybe<Scalars['Int']['output']>;
  /** Host of the catalog's source URL, e.g. mavis.myshopify.com, including a non-default port, for naming the source on screen; NULL when the source has no URL (uploads, manual). Deliberately the HOST and not the URL: a CSV or Sheet source URL can carry a token or key in its path or query, and the host is all any surface needs to say where the products come from */
  sourceHost?: Maybe<Scalars['String']['output']>;
  /** The Meta source catalog's own product total, stamped at import and on every sync — NULL for non-Meta catalogs or before the first stamp; the header shows it instead of the mirrored row count */
  sourceProductsCount?: Maybe<Scalars['Int']['output']>;
  sourceType: FeedSourceType;
  status?: Maybe<FeedStatus>;
  /** Distinct tags across the catalog's products (CRE-409) — the tag facet list (R24) */
  tags: Array<Scalars['String']['output']>;
  /** Column products are matched on across syncs (R26); NULL = row-index mode. THE canonical name — overrides, tags, product sets, the _rows/ split and the ad tag all key on this column */
  targetColumn?: Maybe<Scalars['String']['output']>;
  teamId: Scalars['Int']['output'];
  /** Precomputed list-row thumbnail (CRE-445): first image-column URL picked at ingest; resolves straight off the feed row (no S3 read). NULL until a sync or the backfill stamps it */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** Sync schedule (§4.8) — never = manual-only syncs */
  updateFrequency: UpdateFrequencyType;
  updatedAt: Scalars['Date']['output'];
  /** Workspace (= project, D4) the catalog belongs to; NULL = unassigned, surfaces team-wide (§3.1) */
  workspaceId?: Maybe<Scalars['Int']['output']>;
};


/**
 * A catalog — by identity the underlying feed row (D23), enriched with the
 * catalog columns added in CRE-400 (workspaceId, contentType, currency, ...).
 */
export type CatalogRunsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * One recorded user mutation to a catalog (catalog_change design spec) — the
 * audit-trail sibling of CatalogRun/PublishRun. Insert-only: no UPDATE path.
 */
export type CatalogChange = {
  __typename?: 'CatalogChange';
  action: Scalars['String']['output'];
  /** User who made the change; null for a deleted user (never rendered as a fake system user). */
  changedBy?: Maybe<User>;
  /** Array of {field, old, new} — empty when the action carries no field-level diff. */
  changes: Scalars['JSON']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  /** Snapshot of the entity acted on when not feed-global — shape is per-action, see design spec §3. */
  subject?: Maybe<Scalars['JSON']['output']>;
};

export type CatalogChanges = {
  __typename?: 'CatalogChanges';
  hasNextPage: Scalars['Boolean']['output'];
  items: Array<CatalogChange>;
  totalCount: Scalars['Int']['output'];
};

export type CatalogChangesInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  hash: Scalars['String']['input'];
  /** 0-based page index; defaults to 0. */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Clamped to [1, 50]; defaults to 20. */
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** 'newest' (default) | 'oldest'. Plain string, same house rule as action — an unknown value reads as newest-first. */
  sort?: InputMaybe<Scalars['String']['input']>;
};

/**
 * One design connected to the catalog through design_feed (CRE-426, §5, D19):
 * design metadata + publish/DPA/destination state aggregated read-only from
 * the existing publish surfaces — no new publish machinery.
 */
export type CatalogConnection = {
  __typename?: 'CatalogConnection';
  designHash: Scalars['String']['output'];
  designId: Scalars['Int']['output'];
  /** liveOn with each destination's own sync state, in liveOn's order — the Live on logos' tooltips */
  destinations: Array<CatalogConnectionDestination>;
  /** Any active DPA settings row — the 'DPA catalog' badge */
  dpaEnabled: Scalars['Boolean']['output'];
  /** Design published (share page) OR live on any destination — a serving design is never a draft */
  isPublished: Scalars['Boolean']['output'];
  /** Distinct destination channel keys (meta/tiktok/google/pinterest/linkedin/snapchat/twitter/cm360/dv360/ad_tag) — the 'Live on' chips */
  liveOn: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /**
   * The applied set is gone at its source (product_set.deleted_at_source): the
   * row survives only because designs like this one still point at it, and no
   * sync brings its products into the catalog any more. Its productsCount is
   * NULL — the stored members are the membership frozen at the deletion, not
   * what the set brings in. Always false for an entire-catalog attachment.
   */
  productSetDeletedAtSource: Scalars['Boolean']['output'];
  /** design_feed.product_set_id (D24); NULL = entire catalog — the UI shows 'All products' */
  productSetId?: Maybe<Scalars['Int']['output']>;
  productSetName?: Maybe<Scalars['String']['output']>;
  /**
   * CHEAP product count only: catalog row count for entire-catalog
   * attachments, stored member count for static sets, NULL for dynamic/smart
   * sets — their live match count needs the merged S3 payload (what
   * loadProductSets pays for) and is deliberately not read here.
   */
  productsCount?: Maybe<Scalars['Int']['output']>;
  /** Project (workspace, D4) the design lives in — the tab's grouping heading; NULL = not in any project */
  projectId?: Maybe<Scalars['Int']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
  /** Renderable sizes (Design.sizes semantics): a SET counts its children, a single design is its own one size */
  sizesCount: Scalars['Int']['output'];
  /** Thumb design hash (a set's thumb child, else the design itself) — rendered client-side like the AdStudio attached-designs list */
  thumb: Scalars['String']['output'];
  /** The design's last save (Design.updatedAt) — the thumbnail's version, so its URL changes with every save */
  updatedAt: Scalars['Date']['output'];
};

/** One 'Live on' destination of a connected design and its catalog-sync state */
export type CatalogConnectionDestination = {
  __typename?: 'CatalogConnectionDestination';
  /** The liveOn channel key (meta/tiktok/google/pinterest/linkedin/snapchat/twitter/cm360/dv360/ad_tag) */
  channel: Scalars['String']['output'];
  /** This presence is a DPA catalog feed on that platform (an active dpa_settings row), not campaign creatives — the tooltip's 'DPA catalog' */
  dpaCatalog: Scalars['Boolean']['output'];
  /**
   * When this destination's live copy of the design was last refreshed from the
   * catalog, whatever scope was attached then: the last success/partial
   * publish_run for this design and catalog (the newest 50 per channel and
   * catalog are kept), or the latest ad_tag_sync stamp once EVERY size and
   * network row is SYNCED (one still syncing or failed = none). NULL = none.
   */
  lastSyncedAt?: Maybe<Scalars['Date']['output']>;
  /**
   * Whether this destination records its catalog syncs: the Meta and Pinterest
   * catalog publishes do (publish_run), and so does the ad-tag sync
   * (ad_tag_sync); a campaign-creative presence and the other catalog platforms
   * do not yet, and the UI says "sync not tracked" rather than "never".
   */
  syncTracked: Scalars['Boolean']['output'];
};

/**
 * Catalog content type (decision D9): 'products' = product catalog (the only
 * kind the V1 UI creates), 'content' = generic content rows (schema-ready for
 * non-product legacy feeds to surface later).
 */
export enum CatalogContentType {
  CONTENT = 'content',
  PRODUCTS = 'products'
}

/**
 * Per-product typed-IMAGE readiness (CRE-439) — the CatalogReadinessCounts
 * buckets as an enum, reused by product filters and dynamic set rules.
 */
export enum CatalogImageReadiness {
  LOW = 'low',
  MISSING = 'missing',
  READY = 'ready',
  UNKNOWN = 'unknown'
}

/**
 * A catalog product (CRE-406): one source row merged with its override layer
 * (§3.3 — source cells ⊕ product_override values) plus its tags.
 */
export type CatalogProduct = {
  __typename?: 'CatalogProduct';
  /** Column names whose value comes from a product_override row */
  overriddenFields: Array<Scalars['String']['output']>;
  /** Product identity (§4.2): target-ID column value, or the row index in row-index mode */
  productKey: Scalars['String']['output'];
  /** MERGED row keyed by column name (like FeedRowJsonContent): source cells with overrides applied on top */
  rowData: Scalars['JSON']['output'];
  rowIndex: Scalars['Int']['output'];
  /** UNMERGED source row keyed by column name — drives 'Source: {value}' + revert UX (CRE-411/412) */
  sourceRowData: Scalars['JSON']['output'];
  tags: Array<Scalars['String']['output']>;
};

export type CatalogProducts = {
  __typename?: 'CatalogProducts';
  items: Array<CatalogProduct>;
  /** Count after search/tag filtering, before pagination */
  total: Scalars['Int']['output'];
};

/**
 * How a DPA catalog publish writes into the customer's Meta catalog (CRE-497).
 * The server re-derives this behind the dpa_safe_catalog_publish gate — see
 * resolveDpaPublishMode — so the value sent here is a request, not an instruction.
 */
export enum CatalogPublishMode {
  /**
   * DESTRUCTIVE. Registers the feed as authoritative: products missing from it are
   * DELETED from the customer's catalog, on every scheduled re-fetch.
   */
  REPLACE = 'replace',
  /**
   * Overwrites field data on products that already exist in the catalog's primary feed.
   * Cannot create products.
   */
  SUPPLEMENTARY = 'supplementary',
  /**
   * Non-destructive upsert. Products in the feed are created or updated; every other
   * product already in the catalog is left untouched. The default.
   */
  UPDATE = 'update'
}

/**
 * Product readiness aggregate (CRE-415, D16): each product is counted once by
 * the readiness derived from its worst override-merged typed IMAGE column.
 * 'unknown' requires at least one IMAGE column but no classified image cell;
 * reads never reclassify. A catalog with no IMAGE columns returns zero in every
 * bucket.
 */
export type CatalogReadinessCounts = {
  __typename?: 'CatalogReadinessCounts';
  low: Scalars['Int']['output'];
  missing: Scalars['Int']['output'];
  ready: Scalars['Int']['output'];
  unknown: Scalars['Int']['output'];
};

/**
 * One sync run of a catalog (CRE-414, R13): the diff vs the previous payload
 * (added/updated/removed by productKey) plus per-row failures. Retention: the
 * newest 50 runs per catalog.
 */
export type CatalogRun = {
  __typename?: 'CatalogRun';
  added: Scalars['Int']['output'];
  durationMs: Scalars['Int']['output'];
  failures: Array<CatalogRunFailure>;
  id: Scalars['Int']['output'];
  removed: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
  startedAt: Scalars['Date']['output'];
  status: CatalogRunStatus;
  trigger: CatalogRunTrigger;
  /** User who triggered the run — set for manual/first_import runs; null for scheduled runs (and deleted users) */
  triggeredBy?: Maybe<User>;
  updated: Scalars['Int']['output'];
};

/** Per-row failure of a run (§4.6). row = 0-based row index in the new payload, -1 = run-level failure */
export type CatalogRunFailure = {
  __typename?: 'CatalogRunFailure';
  productKey?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  row: Scalars['Int']['output'];
};

export enum CatalogRunStatus {
  FAILED = 'failed',
  PARTIAL = 'partial',
  SUCCESS = 'success'
}

export enum CatalogRunTrigger {
  FIRST_IMPORT = 'first_import',
  MANUAL = 'manual',
  SCHEDULE = 'schedule'
}

/**
 * The status the list CHIP shows, not the raw feed status. `failed` covers a
 * recorded feedError even when the feed status is success, matching how the
 * client derives the chip — see mapSyncStatus in useCatalogsList.
 */
export enum CatalogSyncStatusFilter {
  FAILED = 'failed',
  IMPORTING = 'importing',
  NOTSYNCED = 'notSynced',
  SYNCED = 'synced'
}

/** Layer property a PRODUCT_CATALOG variation bind targets (CRE-541). Mirrors the shapes the editor's Quick Connect writes. */
export enum CatalogVariationBindProperty {
  /** A button layer's label. */
  BUTTON_LABEL = 'BUTTON_LABEL',
  /** A text/flexStrip layer's content chip. */
  FEED_TEXT = 'FEED_TEXT',
  /** An image/video layer's source URL. */
  URL = 'URL'
}

/** Paginated catalogs list (CRE-495). Ordered by the `sort` argument, newest-first by default. */
export type Catalogs = {
  __typename?: 'Catalogs';
  items: Array<Catalog>;
  /** Count after search and all facet filtering (CRE-451), before pagination */
  total: Scalars['Int']['output'];
};

/** How the catalogs list is ordered (CRE-451). Figma's toolbar shows `Newest`. */
export enum CatalogsSort {
  NAMEASC = 'nameAsc',
  NAMEDESC = 'nameDesc',
  NEWEST = 'newest',
  OLDEST = 'oldest'
}

export type ChanceToWin = {
  __typename?: 'ChanceToWin';
  chance: Scalars['Float']['output'];
  designId: Scalars['Int']['output'];
};

export type ChangeBrandControlOptionPayload = {
  __typename?: 'ChangeBrandControlOptionPayload';
  brandControl: BrandControl;
};

export type ChangeDesignFeedRowPayload = {
  __typename?: 'ChangeDesignFeedRowPayload';
  /** Opaque revision of the committed design-feed attachment. Null for impersonator previews. */
  attachmentRevision?: Maybe<Scalars['String']['output']>;
  catalogHash: Scalars['String']['output'];
  catalogId: Scalars['Int']['output'];
  persisted: Scalars['Boolean']['output'];
  productSetId?: Maybe<Scalars['Int']['output']>;
  productSetName?: Maybe<Scalars['String']['output']>;
  row: Scalars['Int']['output'];
  /** Authoritative selected row keyed by catalog column name, from the same snapshot as row/rowKey. */
  rowData: Scalars['JSON']['output'];
  /** Stable key of the authoritative selected row — its row address. Resolved server-side because an ordinal counts occurrences across the WHOLE payload, which a client holding one row or one page cannot do. */
  rowKey?: Maybe<Scalars['String']['output']>;
};

export type ChangeDesignProductSetPayload = {
  __typename?: 'ChangeDesignProductSetPayload';
  /** Opaque revision of the committed design-feed attachment. */
  attachmentRevision: Scalars['String']['output'];
  catalogHash: Scalars['String']['output'];
  catalogId: Scalars['Int']['output'];
  productSetId?: Maybe<Scalars['Int']['output']>;
  productSetName?: Maybe<Scalars['String']['output']>;
  row: Scalars['Int']['output'];
  /** Authoritative selected row keyed by catalog column name, from the same snapshot as row/rowKey. */
  rowData: Scalars['JSON']['output'];
  /** Optional stable key of the authoritative selected row. */
  rowKey?: Maybe<Scalars['String']['output']>;
};

/** Response after changing a team's owner. */
export type ChangeOwnerPayload = {
  __typename?: 'ChangeOwnerPayload';
  /** The updated team with the new owner. */
  team: Team;
};

export type ChangeVideoSpeedResult = {
  __typename?: 'ChangeVideoSpeedResult';
  /** Real duration of the produced clip, in seconds. */
  duration: Scalars['Float']['output'];
  /** URL of the re-timed mp4. */
  url: Scalars['String']['output'];
};

export enum ChannelType {
  GOOGLE_ADS = 'google_ads',
  INSTAGRAM = 'instagram',
  LINKEDIN = 'linkedin',
  META = 'meta',
  TIKTOK = 'tiktok',
  YOUTUBE = 'youtube'
}

/** Context information from the moodboard */
export type ChatAgentContextInput = {
  /** ID of the associated brand kit */
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  /** Name of the brand */
  brandName?: InputMaybe<Scalars['String']['input']>;
  /** Name of the moodboard */
  moodboardName?: InputMaybe<Scalars['String']['input']>;
  /** IDs of selected cards on the moodboard */
  selectedCardIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Types of content selected (image, video, design, text) */
  selectedContentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Descriptions of selected images (if available from metadata) */
  selectedImageDescriptions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Hashes of selected images */
  selectedImageHashes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether each selected image has background removed (parallel to selectedImageHashes) */
  selectedImageNoBgFlags?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** URLs of uploaded assets */
  uploadedAssetUrls?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A message in the chat agent conversation */
export type ChatAgentMessage = {
  content: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

/**
 * AI SDK formatted stream chunk for assistant-ui compatibility.
 * Contains JSON-encoded AI SDK messages with role, content parts (text, tool-calls).
 */
export type ChatAgentStreamChunk = {
  __typename?: 'ChatAgentStreamChunk';
  /** Whether the stream is complete */
  done: Scalars['Boolean']['output'];
  /** Error message for error events */
  error?: Maybe<Scalars['String']['output']>;
  /** JSON-encoded AI SDK message (role, content array with text/tool-call parts) */
  payload: Scalars['String']['output'];
  /** Thread ID for this conversation */
  threadId: Scalars['String']['output'];
};

/**
 * Input for the chat agent stream subscription.
 * Includes moodboard context and user message.
 */
export type ChatAgentStreamInput = {
  /** Context from the moodboard (selected items, brand kit, etc.) */
  context?: InputMaybe<ChatAgentContextInput>;
  /** Force creation of a new thread, discarding any existing thread for this moodboard */
  forceNewThread?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user's message (optional - if not provided, this is an initial load / resume) */
  message?: InputMaybe<ChatAgentMessage>;
  /** The moodboard hash to provide context */
  moodboardHash: Scalars['String']['input'];
  /** Request initial suggestions generation (used when sidebar opens) */
  requestSuggestions?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional thread ID for conversation continuity */
  threadId?: InputMaybe<Scalars['String']['input']>;
};

export type ChatAssetInput = {
  type?: InputMaybe<MediaType>;
  url: Scalars['String']['input'];
};

/** One brief-owned asset as persisted (role derived from position: first = product, rest = reference). */
export type ChatBriefAsset = {
  __typename?: 'ChatBriefAsset';
  height?: Maybe<Scalars['Int']['output']>;
  role: Scalars['String']['output'];
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

/**
 * Presigned S3 POST for a document attached to a chat message. The object is
 * private; `fileUrl` is its canonical URL, which is what the composer sends
 * back with the message and is not readable on its own.
 */
export type ChatDocumentUploadUrl = {
  __typename?: 'ChatDocumentUploadUrl';
  fields: Scalars['JSON']['output'];
  fileUrl: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ChatOptions = {
  __typename?: 'ChatOptions';
  adFormat?: Maybe<AdFormatType>;
  aspectRatio?: Maybe<Scalars['String']['output']>;
  brandKitId?: Maybe<Scalars['Int']['output']>;
  captionStyle?: Maybe<CaptionStyleType>;
  channel?: Maybe<Array<ChannelType>>;
  duration?: Maybe<Scalars['Int']['output']>;
  mode?: Maybe<VideoGenerationMode>;
  model?: Maybe<AiProvider>;
  objective?: Maybe<ObjectiveType>;
  resolution?: Maybe<Scalars['String']['output']>;
  soundOn?: Maybe<Scalars['Boolean']['output']>;
  ugcIntent?: Maybe<UgcIntent>;
  variantsNo?: Maybe<Scalars['Int']['output']>;
};

export type ChatOptionsInput = {
  adFormat?: InputMaybe<AdFormatType>;
  aspectRatio?: InputMaybe<Scalars['String']['input']>;
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  captionStyle?: InputMaybe<CaptionStyleType>;
  channel?: InputMaybe<Array<ChannelType>>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<VideoGenerationMode>;
  model?: InputMaybe<AiProvider>;
  objective?: InputMaybe<ObjectiveType>;
  resolution?: InputMaybe<Scalars['String']['input']>;
  soundOn?: InputMaybe<Scalars['Boolean']['input']>;
  ugcIntent?: InputMaybe<UgcIntent>;
  variantsNo?: InputMaybe<Scalars['Int']['input']>;
};

export enum ChatScope {
  CREATE = 'CREATE',
  LEARN = 'LEARN'
}

/**
 * Types of actions that can be checked when validating if a design is being edited.
 * Used to prevent conflicts when multiple users work with the same design.
 */
export enum CheckActionTypes {
  /** Check if a design can be deleted. */
  DELETE_DESIGN = 'DELETE_DESIGN',
  /** Check if the folder containing a design can be deleted. */
  DELETE_FOLDER = 'DELETE_FOLDER',
  /** Check if the project containing a design can be deleted. */
  DELETE_PROJECT = 'DELETE_PROJECT',
  /** Check if a design can be moved. */
  MOVE_DESIGN = 'MOVE_DESIGN',
  /** Check if a design can be renamed. */
  RENAME_DESIGN = 'RENAME_DESIGN'
}

export type CheckActiveJobInput = {
  designId: Scalars['Int']['input'];
  platform: DpaPlatformType;
  publishTypePrefix?: InputMaybe<Scalars['String']['input']>;
};

/** Response containing font compatibility information for AI translation feeds. */
export type CheckAiTranslateFeedFontsCompatibilityPayload = {
  __typename?: 'CheckAiTranslateFeedFontsCompatibilityPayload';
  /** Array of language compatibility checks. */
  languages: Array<AiTranslateFeedFontCheck>;
};

export type CheckCouponAppliedInput = {
  couponCode: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type CheckCouponAppliedPayload = {
  __typename?: 'CheckCouponAppliedPayload';
  wasApplied: Scalars['Boolean']['output'];
};

/** Response containing font compatibility information for a design. */
export type CheckDesignFontsCompatibilityPayload = {
  __typename?: 'CheckDesignFontsCompatibilityPayload';
  /** Font compatibility checks for each text layer. */
  layers: Array<DesignLayerFontCheck>;
};

export type CheckDuplicatingFolderPayload = {
  __typename?: 'CheckDuplicatingFolderPayload';
  result: Scalars['Boolean']['output'];
  tree?: Maybe<Array<FolderTreeItem>>;
};

/** Response after checking if designs are being edited. */
export type CheckEditingDesignPayload = {
  __typename?: 'CheckEditingDesignPayload';
  /** Whether the action can proceed (no editing conflicts). */
  result: Scalars['Boolean']['output'];
};

/** @deprecated checkFeedFields mutation has been removed */
export type CheckFeedFieldsInput = {
  designHash: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type CheckFeedSourceUrlPayload = {
  __typename?: 'CheckFeedSourceUrlPayload';
  delimiter: DelimiterCsv;
  sourceType: FeedSourceType;
};

export type CheckFeedStatusActionTypePayload = {
  __typename?: 'CheckFeedStatusActionTypePayload';
  actionType: FeedActionType;
  feedActionInProgress: Scalars['Boolean']['output'];
  processedCount?: Maybe<Scalars['Int']['output']>;
  status: FeedStatus;
  totalCount: Scalars['Int']['output'];
};

/** Response containing font compatibility information. */
export type CheckFontCompatiblePayload = {
  __typename?: 'CheckFontCompatiblePayload';
  /** Characters that are not supported by the font. */
  unsupportedCharacters: Array<Scalars['String']['output']>;
};

export type CheckIfTeamIsInPaymentExperimentResult = {
  __typename?: 'CheckIfTeamIsInPaymentExperimentResult';
  result: Scalars['Boolean']['output'];
};

export type CheckIfUserIsInPaymentExperimentResult = {
  __typename?: 'CheckIfUserIsInPaymentExperimentResult';
  result?: Maybe<PaymentExperiment>;
};

/** Response after checking moodboard media status. */
export type CheckMoodBoardMediaPayload = {
  __typename?: 'CheckMoodBoardMediaPayload';
  /** The media asset with current status. */
  media: Media;
};

/** @deprecated Migration service has been removed */
export type CheckValidCodePayload = {
  __typename?: 'CheckValidCodePayload';
  /** @deprecated Migration service has been removed */
  result: Scalars['Boolean']['output'];
};

export type ClaimExperimentCreditsResult = {
  __typename?: 'ClaimExperimentCreditsResult';
  success: Scalars['Boolean']['output'];
};

export type ClearAgentChatsPayload = {
  __typename?: 'ClearAgentChatsPayload';
  deletedCount: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type ClearCreateAgentChatsPayload = {
  __typename?: 'ClearCreateAgentChatsPayload';
  deletedCount: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type ClickHeatmapBin = {
  __typename?: 'ClickHeatmapBin';
  count: Scalars['Int']['output'];
  x: Scalars['Int']['output'];
  y: Scalars['Int']['output'];
};

export type ClickHeatmapPayload = {
  __typename?: 'ClickHeatmapPayload';
  bins: Array<ClickHeatmapBin>;
  designHeight: Scalars['Int']['output'];
  designWidth: Scalars['Int']['output'];
  gridHeight: Scalars['Int']['output'];
  gridWidth: Scalars['Int']['output'];
  /** The subset carrying coordinates, i.e. what the grid can draw. */
  positionedClicks: Scalars['Int']['output'];
  /** Every click in the window — the same figure the Analytics chart reports. */
  totalClicks: Scalars['Int']['output'];
};

export type CloneDesignFromEnvPayload = {
  __typename?: 'CloneDesignFromEnvPayload';
  /** Hash of the design created in this environment from the source environment. */
  designHash?: Maybe<Scalars['String']['output']>;
  result: Scalars['Boolean']['output'];
};

export type CloneDesignPayload = {
  __typename?: 'CloneDesignPayload';
  /**
   * Hash of the clone created in the dev environment. On live this is the hash
   * minted by the dev server's cloneDesignFromEnv; on dev it is the clone itself.
   */
  devDesignHash?: Maybe<Scalars['String']['output']>;
  /**
   * Hash of the clone created in the live environment. Null when the mutation
   * did not run on live (dev/local only clone to the dev target).
   */
  liveDesignHash?: Maybe<Scalars['String']['output']>;
  result: Scalars['Boolean']['output'];
};

/** Status of design cloning feature. */
export type CloneDesignStatus = {
  __typename?: 'CloneDesignStatus';
  /** Whether design cloning is enabled. */
  enabled: Scalars['Boolean']['output'];
};

export type CloneDesignToTeamPayload = {
  __typename?: 'CloneDesignToTeamPayload';
  designHash: Scalars['String']['output'];
  folderId?: Maybe<Scalars['Int']['output']>;
  projectId: Scalars['Int']['output'];
  result: Scalars['Boolean']['output'];
};

export type CloneMoodBoardFromEnvPayload = {
  __typename?: 'CloneMoodBoardFromEnvPayload';
  result: Scalars['Boolean']['output'];
};

export type CloneMoodBoardPayload = {
  __typename?: 'CloneMoodBoardPayload';
  devMoodboardHash?: Maybe<Scalars['String']['output']>;
  liveMoodboardHash?: Maybe<Scalars['String']['output']>;
  result: Scalars['Boolean']['output'];
};

export type CloneProjectToTeamPayload = {
  __typename?: 'CloneProjectToTeamPayload';
  brandKitId?: Maybe<Scalars['Int']['output']>;
  projectId?: Maybe<Scalars['Int']['output']>;
  result: Scalars['Boolean']['output'];
};

export type CloudIntegration = {
  __typename?: 'CloudIntegration';
  /** @deprecated Always null: integration reads no longer return stored OAuth tokens. */
  accessToken?: Maybe<Scalars['String']['output']>;
  baseUrl?: Maybe<Scalars['String']['output']>;
  connectedEmail: Scalars['String']['output'];
  expiresAt: Scalars['Date']['output'];
  /** CloudIntegration primary key. Populated when the row comes from the DB (e.g. getIntegrations); threaded as integrationId into integration-keyed ops across ad channels — LinkedIn/TikTok/Pinterest publish + read resolvers (findByPk) and the LinkedIn/Pinterest rotated-token writeback. Nullable because some resolvers build CloudIntegration-shaped objects without a row id. */
  id?: Maybe<Scalars['Int']['output']>;
  integrationApp: Integrations;
  /** @deprecated Always null: integration reads no longer return stored OAuth tokens. */
  refreshToken?: Maybe<Scalars['String']['output']>;
  teamId?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type CloudIntegrationResult = {
  __typename?: 'CloudIntegrationResult';
  hasPersonalIntegration: Scalars['Boolean']['output'];
  hasTeamIntegration: Scalars['Boolean']['output'];
  personalAccountData?: Maybe<AccountData>;
  teamAccountData?: Maybe<AccountData>;
};

/** The team's Cloudinary settings. Neither is a secret: every Cloudinary delivery URL carries the cloud name. */
export type CloudinaryConfig = {
  __typename?: 'CloudinaryConfig';
  cloudName: Scalars['String']['output'];
  /** The folder Save to Cloudinary files exports in, a Cloudinary folder path such as marketing/exports. Null for the account's root. */
  defaultFolder?: Maybe<Scalars['String']['output']>;
};

/** Where to send the user to sign in to Cloudinary. Single use, valid for 10 minutes. */
export type CloudinaryConnectionStart = {
  __typename?: 'CloudinaryConnectionStart';
  authorizeUrl: Scalars['String']['output'];
};

export type CloudinaryConnectionTest = {
  __typename?: 'CloudinaryConnectionTest';
  cloudName: Scalars['String']['output'];
  defaultFolder?: Maybe<Scalars['String']['output']>;
  /** False when the default folder no longer exists in Cloudinary (in dynamic mode the next export creates it again). Null when the default is the root. */
  defaultFolderFound?: Maybe<Scalars['Boolean']['output']>;
  /** Null when Cloudinary didn't tell this login. */
  folderMode?: Maybe<CloudinaryFolderMode>;
};

/** One exported file sent to Cloudinary. */
export type CloudinaryExportUpload = {
  __typename?: 'CloudinaryExportUpload';
  /** Where Cloudinary holds the asset (dynamic folder mode). */
  assetFolder?: Maybe<Scalars['String']['output']>;
  designHash: Scalars['String']['output'];
  /** The public ID was taken already (a retry, or an earlier export of the same file), and Cloudinary kept that asset. */
  existing: Scalars['Boolean']['output'];
  format: Scalars['String']['output'];
  /** Cloudinary's own words. */
  message?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  publicId?: Maybe<Scalars['String']['output']>;
  /** Why it wasn't saved: a reason of the whole save, or too_large, not_found, rejected, rate_limited, unavailable, timeout. */
  reason?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  /** saved or failed */
  status: Scalars['String']['output'];
};

export type CloudinaryFolder = {
  __typename?: 'CloudinaryFolder';
  name: Scalars['String']['output'];
  /** The full path, as setCloudinaryDefaultFolder takes it. */
  path: Scalars['String']['output'];
};

/** Cloudinary's folder mode for the account: dynamic (assets carry a folder) or fixed (the folder is part of the public ID). */
export enum CloudinaryFolderMode {
  DYNAMIC = 'DYNAMIC',
  FIXED = 'FIXED'
}

export type CloudinaryFolderPage = {
  __typename?: 'CloudinaryFolderPage';
  folders: Array<CloudinaryFolder>;
  /** Null on the last page. */
  nextCursor?: Maybe<Scalars['String']['output']>;
  /** How many subfolders the folder has, across all pages. */
  totalCount: Scalars['Int']['output'];
};

export type CollectTransactionDataPayload = {
  __typename?: 'CollectTransactionDataPayload';
  result: Scalars['Boolean']['output'];
};

export type Color = {
  __typename?: 'Color';
  color: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ColorPalette = {
  __typename?: 'ColorPalette';
  brandKitId: Scalars['Int']['output'];
  colors: Array<Color>;
  createdBy: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

export type ColorPalettePayload = {
  __typename?: 'ColorPalettePayload';
  colorPalette: ColorPalette;
};

export type Comment = {
  __typename?: 'Comment';
  attachments?: Maybe<Array<Maybe<CommentAttachments>>>;
  authorAvatar?: Maybe<Scalars['String']['output']>;
  authorName: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  threadId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export enum CommentAttachmentFormat {
  AVCHD = 'avchd',
  AVI = 'avi',
  JPEG = 'jpeg',
  JPG = 'jpg',
  MKV = 'mkv',
  MOV = 'mov',
  MP3 = 'mp3',
  MP4 = 'mp4',
  MPEG = 'mpeg',
  MTS = 'mts',
  OGG = 'ogg',
  PNG = 'png',
  SVG = 'svg',
  WAV = 'wav',
  WEBM = 'webm',
  WMV = 'wmv'
}

export enum CommentAttachmentStatus {
  ERROR = 'ERROR',
  PROCESSING = 'PROCESSING',
  VALID = 'VALID'
}

export enum CommentAttachmentType {
  AUDIO = 'AUDIO',
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO'
}

export type CommentAttachmentUploadUrlPayload = {
  __typename?: 'CommentAttachmentUploadUrlPayload';
  hash: Scalars['String']['output'];
  uploadUrl: PresignedPost;
};

export type CommentAttachments = {
  __typename?: 'CommentAttachments';
  checksum: Scalars['String']['output'];
  commentId: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  createdByUser?: Maybe<ByUser>;
  fileName: Scalars['String']['output'];
  format: CommentAttachmentFormat;
  hash: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  src?: Maybe<Scalars['String']['output']>;
  status: CommentAttachmentStatus;
  type: CommentAttachmentType;
  updatedAt: Scalars['Date']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type CommentAttachmentsResult = {
  __typename?: 'CommentAttachmentsResult';
  items: Array<CommentAttachments>;
  pageInfo: PageInfo;
};

export type CommentAuthor = {
  __typename?: 'CommentAuthor';
  avatar?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CommentThread = {
  __typename?: 'CommentThread';
  access?: Maybe<CommentThreadAccess>;
  comments: Array<Comment>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  designHash: Scalars['String']['output'];
  hotspotType?: Maybe<CommentThreadHotspotType>;
  id: Scalars['Int']['output'];
  position: CommentThreadPosition;
  read?: Maybe<Scalars['Boolean']['output']>;
  resolved?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userDetails?: Maybe<Array<Maybe<CommentThreadUserDetails>>>;
};

export enum CommentThreadAccess {
  EDITORS = 'editors',
  PUBLIC = 'public'
}

export enum CommentThreadHotspotType {
  ARROW = 'arrow',
  PIN = 'pin',
  RECTANGLE = 'rectangle'
}

export type CommentThreadPosition = {
  __typename?: 'CommentThreadPosition';
  key: Scalars['Int']['output'];
  s?: Maybe<Scalars['Float']['output']>;
  slideId: Scalars['Int']['output'];
  x: Scalars['Int']['output'];
  y: Scalars['Int']['output'];
};

export type CommentThreadUserDetails = {
  __typename?: 'CommentThreadUserDetails';
  lastReadAt?: Maybe<Scalars['Date']['output']>;
};

/** Competitor information for a company. */
export type Competitor = {
  __typename?: 'Competitor';
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type CompleteAiResizedSizeResult = {
  __typename?: 'CompleteAiResizedSizeResult';
  failure?: Maybe<AiResizedSizeFailure>;
  /** The design's hash: a set's once a single design became one. */
  hash: Scalars['String']['output'];
  /** The caller's open editor tab steps aside for this edit: it reloads to show it. */
  openEditorRefreshes: Scalars['Boolean']['output'];
  /** The size's hash: on ADDED and EXISTS. */
  sizeHash?: Maybe<Scalars['String']['output']>;
  status: AiResizedSizeStatus;
};

/** Result of confirming a user's email. */
export type ConfirmEmailPayload = {
  __typename?: 'ConfirmEmailPayload';
  /** Whether the email confirmation was successful. */
  result: Scalars['Boolean']['output'];
};

export type ConnectCatalogToDesignPayload = {
  __typename?: 'ConnectCatalogToDesignPayload';
  /** Opaque revision of the attachment this connect left. */
  attachmentRevision: Scalars['String']['output'];
  /** The value pinned into design_feed.bindings, over every size. */
  bindings: Scalars['Boolean']['output'];
  /** The design or set the catalog is now attached to. */
  design: Design;
  /** False when the connect left checksum debt: something is bound and the observed catalog checksum or overrides revision is missing or no longer current. */
  materializationCurrent: Scalars['Boolean']['output'];
};

export type ConsumeNextgenFlowCreditsPayload = {
  __typename?: 'ConsumeNextgenFlowCreditsPayload';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  transactionId?: Maybe<Scalars['Int']['output']>;
};

export type ContactLeadAiRecommendation = {
  __typename?: 'ContactLeadAIRecommendation';
  contact: Scalars['Boolean']['output'];
  reason: Scalars['String']['output'];
};

/** Content analysis including media types and CTAs */
export type ContentAnalytics = {
  __typename?: 'ContentAnalytics';
  /** Analysis of carousel card usage */
  cardAnalytics: CardAnalytics;
  /** Analysis of call-to-action usage */
  ctaAnalytics: Array<CtaStats>;
  /** Analysis of link domains used */
  linkDomainAnalytics: Array<LinkDistribution>;
  /** Distribution of media types used */
  mediaTypes: MediaTypeStats;
};

export type ContentLibraryCategory = {
  __typename?: 'ContentLibraryCategory';
  columns?: Maybe<Scalars['Int']['output']>;
  elementBgColor?: Maybe<Scalars['String']['output']>;
  elements?: Maybe<Array<Maybe<ContentLibraryElement>>>;
  icon?: Maybe<Scalars['String']['output']>;
  iconDateUpdated?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  identifier: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['Int']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  subcategories?: Maybe<Array<Maybe<ContentLibraryCategory>>>;
};

export type ContentLibraryElement = {
  __typename?: 'ContentLibraryElement';
  categoryId: Scalars['Int']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  iconDateUpdated?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  premium?: Maybe<Scalars['Int']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

/**
 * One brand-kit photo an aiGenerate slot may be built on, as the planner sees it.
 * Deliberately carries no url: a picked ref is resolved server-side at submit,
 * against the same roster, so a model can only ever name a photo offered here.
 */
export type ContentVariationBrandKitAsset = {
  __typename?: 'ContentVariationBrandKitAsset';
  /** What the photo shows (AI description), never empty. */
  description: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** The value the planner returns verbatim to pick this photo. */
  ref: Scalars['String']['output'];
};

export type ContentVariationBrandKitSummary = {
  __typename?: 'ContentVariationBrandKitSummary';
  /** The brand kit's explicit AI generation rules (dos & don'ts, layout, copy), pre-rendered by buildAIGenerationGuidelines — already <user_data>-wrapped, emitted verbatim into the prompt. Null when the brand kit sets no rules. */
  aiGenerationGuidelines?: Maybe<Scalars['String']['output']>;
  brandDescription?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  /** The structured brand profile, serialized to text and scoped to what this job can act on (full for a job with imagery targets, identity-only for a copy-only job) — see scopeBrandProfileToJob in internalOps.ts. Null when the brand kit has no profile, or the profile has never been extracted. */
  brandProfileDescription?: Maybe<Scalars['String']['output']>;
  brandStyleDescription?: Maybe<Scalars['String']['output']>;
  brandTone?: Maybe<Array<Scalars['String']['output']>>;
  brandVoice?: Maybe<Scalars['String']['output']>;
};

export type ContentVariationBrandLogo = {
  __typename?: 'ContentVariationBrandLogo';
  format?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type ContentVariationImageOperationStatus = {
  __typename?: 'ContentVariationImageOperationStatus';
  operationId: Scalars['Int']['output'];
  status: ImageGenerationStatus;
};

export enum ContentVariationImagerySource {
  AI_GENERATE = 'AI_GENERATE',
  LIBRARY = 'LIBRARY'
}

export type ContentVariationJobContext = {
  __typename?: 'ContentVariationJobContext';
  brandKit?: Maybe<ContentVariationBrandKitSummary>;
  /** The brand kit's own describable photos an aiGenerate slot may be built on, access-gated to the job's user. Empty outside aiGenerate imagery, once the bundle is in, or when the user may not use the kit. */
  brandKitAssets: Array<ContentVariationBrandKitAsset>;
  /** The design's brand kit logos, offered to the deterministic logo selector. NOT filtered by format — a raster pick converts the layer. Empty when the design has no brand kit or the job has no svg imagery target. */
  brandLogos: Array<ContentVariationBrandLogo>;
  designSummary?: Maybe<Scalars['String']['output']>;
  /** True once a bundle has been persisted (internalSubmitContentVariationBundle claimed it) — lets Job 1's worker skip a redundant generateObject call on a BullMQ retry. */
  hasBundle: Scalars['Boolean']['output'];
  /** The job's persisted input snapshot (mode, targets, audiences, imagery source/photoIds, count, direction). */
  input: Scalars['JSON']['output'];
  /** Library photo metadata for the job's requested photoIds; empty outside library imagery mode. */
  photos: Array<ContentVariationPhoto>;
  status: ContentVariationJobStatus;
  /** Current copy for every copy target — image targets are omitted (they carry no text). */
  targetTexts: Array<ContentVariationTargetText>;
};

export enum ContentVariationJobStatus {
  APPLYING = 'APPLYING',
  DONE = 'DONE',
  DONE_WITH_ERRORS = 'DONE_WITH_ERRORS',
  FAILED = 'FAILED',
  GENERATING_CONTENT = 'GENERATING_CONTENT'
}

export type ContentVariationJobSummary = {
  __typename?: 'ContentVariationJobSummary';
  /** Count of variations actually materialized (outcomes with status CREATED). */
  createdCount: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /**
   * Superseded by variations, which carries per-entry status and preview. Kept because a browser bundle cached from before this deploy still selects it, and an unknown field makes GraphQL reject the WHOLE poll request — the Content panel's placeholders and toasts would stop updating for those clients until a reload. Remove once no such client can be in use.
   * @deprecated Use variations; removed once pre-deploy clients have drained.
   */
  labels: Array<Scalars['String']['output']>;
  requestedCount: Scalars['Int']['output'];
  status: ContentVariationJobStatus;
  /** One entry per requestedCount, always — synthesized from the bundle + outcomes (see getContentVariationJobsForDesign). */
  variations: Array<ContentVariationVariationSummary>;
};

export enum ContentVariationMode {
  EVERYONE = 'EVERYONE',
  PER_AUDIENCE = 'PER_AUDIENCE'
}

export enum ContentVariationOutcomeStatus {
  ASSETS_READY = 'ASSETS_READY',
  CREATED = 'CREATED',
  CREATING = 'CREATING',
  FAILED = 'FAILED',
  PENDING = 'PENDING'
}

export type ContentVariationPhoto = {
  __typename?: 'ContentVariationPhoto';
  /** Cached description metadata; a photo with none yet gets one lazily generated and persisted (bounded per job — see internalOps.ts's loadPhotos) rather than always reading as null. Still null when generation fails, is capped out, or times out. */
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

/** Which BullMQ job name a dead-queue-job failure signal came from — GENERATE (contentVariationsGenerate) owns the whole row until a bundle lands; APPLY (contentVariationsApply) owns one variation via its own variationIndex, except for a legacy pre-split payload (no variationIndex) which still owns the whole row. */
export enum ContentVariationQueueStage {
  APPLY = 'APPLY',
  GENERATE = 'GENERATE'
}

export type ContentVariationSubmitBundleResult = {
  __typename?: 'ContentVariationSubmitBundleResult';
  /** Epoch ms of the FIRST image slot genuinely enqueued (AiOperation created, credit transaction started, ProductPhotographyDirectFlow enqueued) — the real image-fired instant, not merely when this whole mutation returns. Null when no slot ever fired (library/copy-only/logo-only mode, or every slot failed to fire). Bundle-wide fallback for a variation with no entry of its own in variationImageEnqueuedAt. */
  firstImageEnqueuedAt?: Maybe<Scalars['Float']['output']>;
  /** AiOperation ids fired for this bundle's aiGenerate imagery slots, in job-input order — empty in library/copy-only mode. */
  imageOperationIds: Array<Scalars['Int']['output']>;
  /** The SAME real image-fired instant as firstImageEnqueuedAt, but per variation: index i is variation i's own first imagePrompt slot's enqueue time. Always as long as the bundle's variations array; an entry is null when that variation fired no imagePrompt slot (photoId/keepOriginal/brandLogoId, or every one of its slots failed). Lets each variation's apply job measure apply.outcome from its OWN slot instead of inheriting an earlier variation's hand-off instant. */
  variationImageEnqueuedAt: Array<Maybe<Scalars['Float']['output']>>;
};

export type ContentVariationTargetText = {
  __typename?: 'ContentVariationTargetText';
  /** Current text/button-label content of this target, read from the pinned main size; null when the layer resolves to neither shape. */
  currentText?: Maybe<Scalars['String']['output']>;
  layerKey: Scalars['String']['output'];
  layerType: Scalars['String']['output'];
  /** Distinct style spans in reading order; empty only for buttons/lists. A single-style layer still returns one run — treat length < 2 as no usable style slots. */
  styleRuns: Array<ContentVariationTextStyleRun>;
};

export type ContentVariationTargets = {
  __typename?: 'ContentVariationTargets';
  copyLayerIds: Array<Scalars['Int']['output']>;
  imageryLayerIds: Array<Scalars['Int']['output']>;
  source: VariationTargetsSource;
};

export type ContentVariationTextStyleRun = {
  __typename?: 'ContentVariationTextStyleRun';
  /** Effective fill: the painting gradient mark, else the legacy color mark. */
  fill: Scalars['String']['output'];
  fontSize?: Maybe<Scalars['Float']['output']>;
  /** Stable slot id — what a bundle's copy runs reference by styleIndex. */
  index: Scalars['Int']['output'];
  startsParagraph: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
};

export type ContentVariationVariationSummary = {
  __typename?: 'ContentVariationVariationSummary';
  /** The variation's Design id, published only once this entry is CREATED — the client holds its placeholder until this id appears in the grid, so a landed variation is never in neither list. */
  designId?: Maybe<Scalars['Int']['output']>;
  /** Position in the job's bundle — stable, and the index the per-variation apply job is addressed by. */
  index: Scalars['Int']['output'];
  /** Null while the job is still planning; the bundle's own label once it lands. */
  label?: Maybe<Scalars['String']['output']>;
  /** Blurred-skeleton preview. Null until this variation reaches ASSETS_READY. */
  previewImageUrl?: Maybe<Scalars['String']['output']>;
  status: ContentVariationOutcomeStatus;
};

export type ConvertHtmlToJsonInput = {
  height?: InputMaybe<Scalars['Int']['input']>;
  html: Scalars['String']['input'];
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type ConvertHtmlToJsonResult = {
  __typename?: 'ConvertHtmlToJsonResult';
  jsonDesign: Scalars['JSON']['output'];
};

/** Response after converting a single design to a set. */
export type ConvertSingleDesignToSetPayload = {
  __typename?: 'ConvertSingleDesignToSetPayload';
  /** The newly created design set. */
  designSet: Design;
};

export type CopilotAiChat = {
  __typename?: 'CopilotAiChat';
  id: Scalars['Int']['output'];
  messages: Array<CopilotAiChatMessage>;
  name: Scalars['String']['output'];
  options?: Maybe<ChatOptions>;
  scope: ChatScope;
  sharedBy?: Maybe<Scalars['String']['output']>;
};

export type CopilotAiChatMessage = {
  __typename?: 'CopilotAiChatMessage';
  content: Scalars['String']['output'];
  feedback?: Maybe<CopilotAiChatMessageFeedback>;
  id?: Maybe<Scalars['String']['output']>;
  questionMessageId?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
};

export type CopilotAiChatMessageFeedback = {
  __typename?: 'CopilotAiChatMessageFeedback';
  isPositiveFeedback: Scalars['Boolean']['output'];
  showAdditionalFeedbackModal: Scalars['Boolean']['output'];
};

export type CopilotAiChatStreamPayload = {
  __typename?: 'CopilotAiChatStreamPayload';
  assistantMessageId: Scalars['String']['output'];
  chatId: Scalars['Int']['output'];
  chunk: Scalars['String']['output'];
  done: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  questionMessageId?: Maybe<Scalars['String']['output']>;
  userMessageId: Scalars['String']['output'];
};

export type CopilotAiChatsPayload = {
  __typename?: 'CopilotAiChatsPayload';
  pageInfo: PageInfo;
  result: Array<CopilotAiChat>;
};

export type CopilotBrandExtraction = {
  __typename?: 'CopilotBrandExtraction';
  /** The images an ad may use: at least 300 px on the short side, not a logo, at most 3. */
  adImages: Array<CopilotBrandExtractionImage>;
  brandDescription?: Maybe<Scalars['String']['output']>;
  /** The draft while it is one; the regular kit once saved as a new kit. */
  brandKitId?: Maybe<Scalars['Int']['output']>;
  brandKitName?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  /** Whether the user may fix fonts on this card now (see the card). */
  canFixFonts: Scalars['Boolean']['output'];
  colors: Array<Scalars['String']['output']>;
  fonts: Array<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  imageUrls: Array<Scalars['String']['output']>;
  /** Whether the website's brand is the brand of the design's kit; null until the extraction is READY, and always null from copilotActiveBrandExtraction. */
  kitMatch?: Maybe<CopilotBrandKitMatch>;
  logoUrls: Array<Scalars['String']['output']>;
  missingFonts: Array<CopilotBrandExtractionMissingFont>;
  sections: CopilotBrandExtractionSections;
  sourceUrl: Scalars['String']['output'];
  state: CopilotBrandExtractionState;
  tone: Array<Scalars['String']['output']>;
  visualStyle: Array<Scalars['String']['output']>;
  voice?: Maybe<Scalars['String']['output']>;
};

export enum CopilotBrandExtractionFontRole {
  BODY = 'BODY',
  HEADING = 'HEADING'
}

export type CopilotBrandExtractionImage = {
  __typename?: 'CopilotBrandExtractionImage';
  hash: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type CopilotBrandExtractionMissingFont = {
  __typename?: 'CopilotBrandExtractionMissingFont';
  /** A Google font: free to use, so the card offers it by name (owner decision 2). */
  isGoogleFont: Scalars['Boolean']['output'];
  /** The brand's font as the site or Brandfetch names it. */
  name: Scalars['String']['output'];
  roles: Array<CopilotBrandExtractionFontRole>;
  /** What the draft uses for those roles instead (one per distinct substitute). */
  usedInstead: Array<Scalars['String']['output']>;
};

export enum CopilotBrandExtractionSectionState {
  DONE = 'DONE',
  MISSING = 'MISSING',
  PENDING = 'PENDING'
}

export type CopilotBrandExtractionSections = {
  __typename?: 'CopilotBrandExtractionSections';
  colors: CopilotBrandExtractionSectionState;
  fonts: CopilotBrandExtractionSectionState;
  images: CopilotBrandExtractionSectionState;
  logos: CopilotBrandExtractionSectionState;
  visualStyle: CopilotBrandExtractionSectionState;
  voiceAndTone: CopilotBrandExtractionSectionState;
};

export type CopilotBrandExtractionStart = {
  __typename?: 'CopilotBrandExtractionStart';
  brandName?: Maybe<Scalars['String']['output']>;
  /** INVALID_URL | UNREACHABLE | UNSAFE_URL (not a public address, or redirects to one) | RATE_LIMITED | START_FAILED */
  error?: Maybe<Scalars['String']['output']>;
  /** The name of a kit the team already has for the same domain. */
  existingKitName?: Maybe<Scalars['String']['output']>;
  /** Null when the extraction was refused before anything was created. */
  id?: Maybe<Scalars['Int']['output']>;
  /** active | failed */
  status: Scalars['String']['output'];
};

export enum CopilotBrandExtractionState {
  DISCARDED = 'DISCARDED',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  READY = 'READY',
  RUNNING = 'RUNNING',
  SAVED = 'SAVED'
}

export type CopilotBrandKitMatch = {
  __typename?: 'CopilotBrandKitMatch';
  /** The design's brand kit; null when the design has none. */
  kitName?: Maybe<Scalars['String']['output']>;
  verdict: CopilotBrandKitMatchVerdict;
};

export enum CopilotBrandKitMatchVerdict {
  DIFFERENT = 'DIFFERENT',
  NO_BRAND = 'NO_BRAND',
  SAME = 'SAME',
  UNCLEAR = 'UNCLEAR'
}

export type CopilotDocumentBrandKitChange = {
  __typename?: 'CopilotDocumentBrandKitChange';
  /** The kit's value today, as a short human-readable summary; null when empty. */
  current?: Maybe<Scalars['String']['output']>;
  field: CopilotDocumentBrandKitField;
  /** What the document would write, as a short human-readable summary. */
  next: Scalars['String']['output'];
};

/** A brand kit field the Copilot can write from the document read in a thread. */
export enum CopilotDocumentBrandKitField {
  AI_RULES = 'AI_RULES',
  AUDIENCES = 'AUDIENCES',
  BRAND_NAME = 'BRAND_NAME',
  BUTTONS = 'BUTTONS',
  COLORS = 'COLORS',
  DESCRIPTION = 'DESCRIPTION',
  IMAGES = 'IMAGES',
  LOGO = 'LOGO',
  STYLE = 'STYLE',
  TONE = 'TONE',
  TYPOGRAPHY = 'TYPOGRAPHY',
  VOICE = 'VOICE'
}

export type CopilotDocumentBrandKitPreview = {
  __typename?: 'CopilotDocumentBrandKitPreview';
  /** The design's brand kit; null when the design has none. */
  brandKitId?: Maybe<Scalars['Int']['output']>;
  brandKitName?: Maybe<Scalars['String']['output']>;
  /** MANAGE_BRANDS on the design's team. */
  canCreateBrandKit: Scalars['Boolean']['output'];
  /** MANAGE_BRANDS on that kit. */
  canUpdateBrandKit: Scalars['Boolean']['output'];
  /** Only fields the document has a value for; a field whose next equals current is omitted. */
  changes: Array<CopilotDocumentBrandKitChange>;
};

/**
 * What the Copilot saves: the document read in the thread, or the brand the chat extracted from a
 * website into its draft kit.
 */
export enum CopilotDocumentBrandKitSource {
  DOCUMENT = 'DOCUMENT',
  WEBSITE = 'WEBSITE'
}

/** Where the Copilot saves a read document: the design's brand kit, or a new kit in the design's team. */
export enum CopilotDocumentBrandKitTarget {
  CURRENT = 'CURRENT',
  NEW = 'NEW'
}

export enum CopilotGenerationMode {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO'
}

/** Why a Copilot scene tool cannot read or change a video. */
export enum CopilotLongVideoRefusal {
  /** The video can no longer be changed scene by scene (notEditableReason says why). */
  NOT_EDITABLE = 'NOT_EDITABLE',
  /** No finished video with that hash is in the design's generations. */
  NOT_FOUND = 'NOT_FOUND',
  /** The generation is not a video joined from scenes. */
  NOT_LONG_VIDEO = 'NOT_LONG_VIDEO',
  /** A scene number is not in the video (unknownScene, sceneCount). */
  UNKNOWN_SCENE = 'UNKNOWN_SCENE'
}

/** A Copilot 'import media from a URL' tool call. */
export type CopilotMediaImport = {
  __typename?: 'CopilotMediaImport';
  createdAt: Scalars['String']['output'];
  /** Why a failed import failed: UNSAFE_URL, UNSUPPORTED_CONTENT, URL_TOO_LONG, SCRAPE_FAILED, NOTHING_FOUND, IMPORT_FAILED or TIMED_OUT. */
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  items: Array<CopilotMediaImportItem>;
  /** direct (an image or video link) or page (a scraped web page). */
  kind: Scalars['String']['output'];
  sourceUrl: Scalars['String']['output'];
  /** pending, scraping, importing, done or failed. */
  status: Scalars['String']['output'];
  /** What the imported page states about its product; null for direct links and pages that state nothing. */
  subject?: Maybe<CopilotMediaImportSubject>;
  toolCallId: Scalars['String']['output'];
};

/** One Media row a Copilot media import linked into the design's library. */
export type CopilotMediaImportItem = {
  __typename?: 'CopilotMediaImportItem';
  /** Stored or generated image description; null for videos and when unavailable. */
  description?: Maybe<Scalars['String']['output']>;
  hash: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  isVideo: Scalars['Boolean']['output'];
  mediumId: Scalars['Int']['output'];
  /** False while a video is still being processed. */
  ready: Scalars['Boolean']['output'];
  /** The web address the media was imported from. */
  sourceUrl: Scalars['String']['output'];
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

/** An imported page's facts about its main item (a product, an event, a trip, a service…), read from its markup (schema.org data, og tags, title). */
export type CopilotMediaImportSubject = {
  __typename?: 'CopilotMediaImportSubject';
  brand?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** When it ends; only with a startDate. */
  endDate?: Maybe<Scalars['String']['output']>;
  /** The item's schema.org type in words, e.g. 'music event', 'hotel', 'product'. */
  itemType?: Maybe<Scalars['String']['output']>;
  /** Where it is: a venue and address, the areas served, a trip's stops, 'Online' or 'Remote'. */
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Who offers the item: a provider, an organizer, an employer or a publisher. */
  offeredBy?: Maybe<Scalars['String']['output']>;
  /** As the page states it, amount and currency, e.g. '499.99 RON'. */
  price?: Maybe<Scalars['String']['output']>;
  /** True when the price is the lowest of several, shown 'from' it. */
  priceFrom?: Maybe<Scalars['Boolean']['output']>;
  /** The site's own name. */
  siteName?: Maybe<Scalars['String']['output']>;
  /** When the item starts, as the page's local date and time, e.g. '2026-11-14 19:30'. */
  startDate?: Maybe<Scalars['String']['output']>;
  /** A short model-written summary of the page's visible text. */
  summary?: Maybe<Scalars['String']['output']>;
};

/** A Copilot generation a page load still has to act on. */
export type CopilotPendingGeneration = {
  __typename?: 'CopilotPendingGeneration';
  /** Whether its end has already been told to its chat. */
  announced: Scalars['Boolean']['output'];
  generation: AiStudioGeneration;
  /** What the Copilot client knew when it started it ({ toolCallId, announced, client }). */
  kickoff: Scalars['JSON']['output'];
  outcome?: Maybe<AiStudioGenerationCopilotOutcome>;
};

export type CopilotPublicHashPayload = {
  __typename?: 'CopilotPublicHashPayload';
  hash: Scalars['String']['output'];
  isPasswordProtected: Scalars['Boolean']['output'];
  publicStatus: PublicStatus;
};

export type CopilotPublicResourceAccessPayload = {
  __typename?: 'CopilotPublicResourceAccessPayload';
  hash: Scalars['String']['output'];
  isPasswordProtected: Scalars['Boolean']['output'];
  location: LocationType;
  publicStatus: PublicStatus;
};

export type CopilotSceneEdit = {
  __typename?: 'CopilotSceneEdit';
  /** FAILED: STILL_FAILED, STILL_TIMED_OUT, INTERRUPTED, or the error code a step's start was refused with. */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** STARTED: the regeneration's operations, lowest first. */
  operationIds: Array<Scalars['Int']['output']>;
  /** FAILED with USAGE_RESTRICTION_ERROR: the restriction's action and scope. */
  restrictionAction?: Maybe<Scalars['String']['output']>;
  restrictionScope?: Maybe<Scalars['String']['output']>;
  status: CopilotSceneEditStatus;
};

export enum CopilotSceneEditStatus {
  /** It stopped before the regeneration started (errorCode). */
  FAILED = 'FAILED',
  /** Opening pictures are still being edited. */
  PENDING = 'PENDING',
  /** The regeneration started (operationIds). */
  STARTED = 'STARTED'
}

/** What one Copilot sentiment sweep did. */
export type CopilotSentimentSweepResult = {
  __typename?: 'CopilotSentimentSweepResult';
  capped: Scalars['Int']['output'];
  claimed: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  /** Finished sessions whose verdict failed; the next sweep retries them. */
  judgeFailed: Scalars['Int']['output'];
  /** Finished sessions given a verdict. */
  judged: Scalars['Int']['output'];
  postFailed: Scalars['Int']['output'];
  posted: Scalars['Int']['output'];
  scored: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
};

export type CopilotVideoStoryboard = {
  __typename?: 'CopilotVideoStoryboard';
  notEditableReason?: Maybe<Scalars['String']['output']>;
  /** Set when the video cannot be changed scene by scene; storyboard is then null. */
  refusal?: Maybe<CopilotLongVideoRefusal>;
  /** The video's resolution, such as 720p; null when its row does not say. */
  resolution?: Maybe<Scalars['String']['output']>;
  storyboard?: Maybe<MultiSceneStoryboard>;
};

export type CopySampleAdDesignsPayload = {
  __typename?: 'CopySampleAdDesignsPayload';
  /** True when this team had already redeemed the link and its EXISTING copy was returned. */
  alreadyCopied: Scalars['Boolean']['output'];
  brandName?: Maybe<Scalars['String']['output']>;
  designCount: Scalars['Int']['output'];
  designSetHash: Scalars['String']['output'];
  designSetId: Scalars['Int']['output'];
  projectId: Scalars['Int']['output'];
  teamId: Scalars['Int']['output'];
};

/** Demographic breakdown for a specific country */
export type CountryBreakdown = {
  __typename?: 'CountryBreakdown';
  /** Age and gender distribution within this country */
  ageGenderBreakdowns: Array<AgeGenderBreakdown>;
  /** Country name */
  country: Scalars['String']['output'];
};

/** Coupon duration type for determining if discount applies on renewal */
export enum CouponDuration {
  /** Discount applies forever (recurring) */
  FOREVER = 'FOREVER',
  /** Discount applies once */
  SINGLE_USE = 'SINGLE_USE',
  /** Discount applies for a limited time period */
  TEMPORAL = 'TEMPORAL'
}

/** Coupon information for preview responses */
export type CouponInfo = {
  __typename?: 'CouponInfo';
  /** Coupon code */
  code: Scalars['String']['output'];
  /** Discount fixed amount */
  discountAmount?: Maybe<Scalars['Float']['output']>;
  /** Discount percentage (0-100) */
  discountPercent?: Maybe<Scalars['Float']['output']>;
  /** Duration type: FOREVER (recurring), SINGLE_USE (one-time), TEMPORAL (limited time) */
  duration: CouponDuration;
};

export type CouponPayload = {
  __typename?: 'CouponPayload';
  discount: Scalars['Float']['output'];
};

/** Input for the Crafted Ads Home query. */
export type CraftedDesignsInput = {
  /** Optional brand kit to scope the strip to. Omitted → the team's whole crafted set (legacy). When set, only designs generated for this kit are returned, so the strip matches the active brand-kit card. */
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  /** Team to fetch the crafted designs for. The caller must be a member. */
  teamId: Scalars['Int']['input'];
};

/** Result for the Crafted Ads Home query — the team's persisted designs + an isGenerating flag for FE polling. */
export type CraftedDesignsResult = {
  __typename?: 'CraftedDesignsResult';
  /** List of persisted Crafted Ad designs (SET rows). An empty array means the FE renders nothing. */
  designs: Array<Design>;
  /** True iff a Crafted Ad generation is currently in flight for the team — drives the FE poll. */
  isGenerating: Scalars['Boolean']['output'];
};

export type CreateAiFlowCreatorChatInput = {
  options?: InputMaybe<ChatOptionsInput>;
  projectId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type CreateAiFlowCreatorChatPayload = {
  __typename?: 'CreateAiFlowCreatorChatPayload';
  chatId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CreateAppIntegrationPayload = {
  __typename?: 'CreateAppIntegrationPayload';
  appIntegration: AppIntegration;
};

/** Input for creating a new brand competitor. */
export type CreateBrandCompetitorInput = {
  /** External brand fetch ID for API lookups. */
  brandFetchId: Scalars['String']['input'];
  /** ID of the brand kit to add the competitor to. */
  brandKitId: Scalars['Int']['input'];
  /** Domain/website of the competitor. */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** Facebook brand data as JSON. */
  facebookBrandData?: InputMaybe<Scalars['JSON']['input']>;
  /** Facebook page ID. */
  facebookPageId?: InputMaybe<Scalars['String']['input']>;
  /** Google advertiser ID. */
  googleAdvertiserId?: InputMaybe<Scalars['String']['input']>;
  /** Google data as JSON. */
  googleData?: InputMaybe<Scalars['JSON']['input']>;
  /** Name of the competitor. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Response when creating a brand kit. */
export type CreateBrandKitPayload = {
  __typename?: 'CreateBrandKitPayload';
  /** The newly created brand kit. */
  brandKit: BrandKit;
};

/** @deprecated not used */
export type CreateBrandTemplatePayload = {
  __typename?: 'CreateBrandTemplatePayload';
  /** @deprecated Field no longer supported */
  design: Design;
};

export type CreateBulkDesignsPayload = {
  __typename?: 'CreateBulkDesignsPayload';
  result: CreateBulkDesignsResult;
};

export type CreateBulkDesignsResult = {
  __typename?: 'CreateBulkDesignsResult';
  folderId: Scalars['Int']['output'];
};

export type CreateCloudIntegrationPayload = {
  __typename?: 'CreateCloudIntegrationPayload';
  integration: CloudIntegration;
};

export type CreateCommentResult = {
  __typename?: 'CreateCommentResult';
  comment?: Maybe<Comment>;
  thread?: Maybe<CommentThread>;
};

export type CreateDesignComponentPayload = {
  __typename?: 'CreateDesignComponentPayload';
  /** @deprecated Field no longer supported */
  design: Design;
  designComponent: DesignComponent;
};

/** Response after creating a design from a Getting Started step template. */
export type CreateDesignFromGettingStartedPayload = {
  __typename?: 'CreateDesignFromGettingStartedPayload';
  /** The created design. */
  design: Design;
};

export type CreateDesignFromJsonsPayload = {
  __typename?: 'CreateDesignFromJsonsPayload';
  design: Design;
};

/** Response after creating a design. */
export type CreateDesignPayload = {
  __typename?: 'CreateDesignPayload';
  /** The created design. */
  design: Design;
};

/** Response after creating design variation(s). */
export type CreateDesignVariationPayload = {
  __typename?: 'CreateDesignVariationPayload';
  /**
   * The CANONICAL master of the family — always a design SET. Creating the
   * FIRST variation of a standalone design converts that design into a
   * single-child set (invariant: a design with variations is always a set),
   * so this can differ from the design the client had open — the client must
   * navigate to it when it does.
   */
  masterSet: Design;
  /** The newly created variation set(s), linked via masterSetId and excluded from all design listings. */
  variations: Array<Design>;
};

export type CreateDriveFolderResult = {
  __typename?: 'CreateDriveFolderResult';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<Scalars['String']['output']>;
};

export type CreateDummyCommentsPayload = {
  __typename?: 'CreateDummyCommentsPayload';
  result: Scalars['Boolean']['output'];
};

export type CreateFeatureResult = {
  __typename?: 'CreateFeatureResult';
  result: Scalars['Boolean']['output'];
};

export type CreateFolderPayload = {
  __typename?: 'CreateFolderPayload';
  folder: Folder;
};

/** Response after creating a design from a Creatopy template. */
export type CreateFromCreatopyDesignPayload = {
  __typename?: 'CreateFromCreatopyDesignPayload';
  /** The created design. */
  design: Design;
};

export type CreateLearnAgentReportSignedUrlPayload = {
  __typename?: 'CreateLearnAgentReportSignedUrlPayload';
  signedUrl: Scalars['String']['output'];
};

export type CreateMediaFolderPayload = {
  __typename?: 'CreateMediaFolderPayload';
  mediaFolder: MediaFolder;
};

export type CreateMoodBoardCommentInput = {
  authorEmail?: InputMaybe<Scalars['String']['input']>;
  authorName?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  moodBoardHash: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  threadId: Scalars['Int']['input'];
};

export type CreateMoodBoardCommentThreadInput = {
  moodBoardHash: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['JSON']['input'];
};

/** Response after creating a moodboard media asset. */
export type CreateMoodBoardMediaPayload = {
  __typename?: 'CreateMoodBoardMediaPayload';
  /** The created media asset. */
  media: Media;
};

/** Response after creating a new media asset. */
export type CreateNewMediaPayload = {
  __typename?: 'CreateNewMediaPayload';
  /** ID of the folder the media was saved to. */
  folderId?: Maybe<Scalars['Int']['output']>;
  /** The created media asset. */
  media: Media;
};

export type CreatePlanResult = {
  __typename?: 'CreatePlanResult';
  result: Scalars['Boolean']['output'];
};

export type CreateSubscriptionChangePayload = {
  __typename?: 'CreateSubscriptionChangePayload';
  invoiceId?: Maybe<Scalars['String']['output']>;
  result: Scalars['Boolean']['output'];
};

export type CreateSubscriptionPayload = {
  __typename?: 'CreateSubscriptionPayload';
  invoiceId?: Maybe<Scalars['String']['output']>;
  team: Team;
};

/** Response after creating a team user group. */
export type CreateTeamUserGroupPayload = {
  __typename?: 'CreateTeamUserGroupPayload';
  /** The newly created team user group. */
  group: TeamUserGroup;
};

export type CreateTemporaryDownloadPreviewPayload = {
  __typename?: 'CreateTemporaryDownloadPreviewPayload';
  hash: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type CreateTemporaryPreviewPayload = {
  __typename?: 'CreateTemporaryPreviewPayload';
  hash: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type CreateTranslationFeedPayload = {
  __typename?: 'CreateTranslationFeedPayload';
  result: CreateTranslationFeedResult;
};

export type CreateTranslationFeedResult = {
  __typename?: 'CreateTranslationFeedResult';
  bindings?: Maybe<Scalars['JSON']['output']>;
  feed: Feed;
};

/** Result of creating default resources for a new user. */
export type CreateUserDefaultsPayload = {
  __typename?: 'CreateUserDefaultsPayload';
  /**
   * Whether the operation was successful.
   * @deprecated Do not use anymore
   */
  result: Scalars['Boolean']['output'];
  /** The team created or assigned to the user. */
  team?: Maybe<Team>;
};

/**
 * A set that was just created, always a local row. sourceId is the set's id at
 * Meta when it was created in a catalog imported from Meta, and null otherwise.
 */
export type CreatedProductSet = {
  __typename?: 'CreatedProductSet';
  /** Local product_set row */
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** The set's id at Meta, for a set created in a catalog imported from Meta; null otherwise */
  sourceId?: Maybe<Scalars['String']['output']>;
};

/** Feed field->column bindings recorded at publish (output mirror of CreativeFeedBindingsInput). */
export type CreativeFeedBindings = {
  __typename?: 'CreativeFeedBindings';
  description?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  primaryText?: Maybe<Scalars['String']['output']>;
};

/** Per-row creative bindings for a feed batch: each value is a feed COLUMN NAME whose per-row value overrides that creative field. Only meaningful with rowRange. */
export type CreativeFeedBindingsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  primaryText?: InputMaybe<Scalars['String']['input']>;
};

export type CreatopyTemplate = {
  __typename?: 'CreatopyTemplate';
  createdAt: Scalars['Date']['output'];
  design: CreatopyTemplateDesign;
  id: Scalars['Int']['output'];
  pinToTop: Scalars['Boolean']['output'];
};

export type CreatopyTemplateDesign = {
  __typename?: 'CreatopyTemplateDesign';
  hash: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  setSizes: Array<CreatopyTemplateSize>;
  /** The template set's last save, which a save of any of its sizes moves — its thumbnails' version, so their URLs change with every save. */
  updatedAt: Scalars['Date']['output'];
};

export type CreatopyTemplateSize = {
  __typename?: 'CreatopyTemplateSize';
  hash: Scalars['String']['output'];
  height: Scalars['Float']['output'];
  measureUnit: MeasureUnit;
  width: Scalars['Float']['output'];
};

export type CreditBalance = {
  __typename?: 'CreditBalance';
  availableRecurringCredits: Scalars['Int']['output'];
  availableRollingCredits: Scalars['Int']['output'];
  availableTopUpCredits: Scalars['Int']['output'];
  consumedRecurringCredits: Scalars['Int']['output'];
  consumedRollingCredits: Scalars['Int']['output'];
  consumedTopUpCredits: Scalars['Int']['output'];
  creditsLimit: CreditLimit;
  /** @deprecated No longer used. Free users have zero credits. */
  dailyConsumedCredits?: Maybe<Scalars['Int']['output']>;
  lockedRecurringCredits: Scalars['Int']['output'];
  lockedRollingCredits: Scalars['Int']['output'];
  lockedTopUpCredits: Scalars['Int']['output'];
  totalAvailableCredits: Scalars['Int']['output'];
  totalConsumedCredits: Scalars['Int']['output'];
  totalLockedCredits: Scalars['Int']['output'];
};

export type CreditLimit = {
  __typename?: 'CreditLimit';
  recurringCredits: Scalars['Int']['output'];
  rollingCredits: Scalars['Int']['output'];
  topUpCredits: Scalars['Int']['output'];
};

export enum CreditManagementError {
  CREDIT_OPERATION_NOT_FOUND = 'CREDIT_OPERATION_NOT_FOUND',
  NOT_ENOUGH_CREDITS = 'NOT_ENOUGH_CREDITS',
  OPERATION_COUNT_NOT_VALID = 'OPERATION_COUNT_NOT_VALID',
  SUBSCRIPTION_NOT_FOUND = 'SUBSCRIPTION_NOT_FOUND',
  TRANSACTION_NOT_FOUND = 'TRANSACTION_NOT_FOUND',
  TRANSACTION_NOT_PENDING = 'TRANSACTION_NOT_PENDING',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  USAGE_RESTRICTED = 'USAGE_RESTRICTED'
}

export type CreditOperationItem = {
  __typename?: 'CreditOperationItem';
  cost: Scalars['Float']['output'];
  featureName: Scalars['String']['output'];
  featureType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type CreditOperationsPayload = {
  __typename?: 'CreditOperationsPayload';
  operations: Array<CreditOperationItem>;
};

export type CreditPayload = {
  __typename?: 'CreditPayload';
  date?: Maybe<Scalars['Date']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type CreditTransaction = {
  __typename?: 'CreditTransaction';
  amount: Scalars['Int']['output'];
  amountFromRecurring: Scalars['Int']['output'];
  amountFromRolling: Scalars['Int']['output'];
  amountFromTopUp: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  operationType: Scalars['String']['output'];
  status: CreditTransactionStatus;
  teamId: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type CreditTransactionHistoryPayload = {
  __typename?: 'CreditTransactionHistoryPayload';
  items: Array<CreditTransaction>;
  pageInfo: PageInfo;
};

export type CreditTransactionPayload = {
  __typename?: 'CreditTransactionPayload';
  creditBalance?: Maybe<CreditBalance>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<CreditManagementError>;
  restrictionDetails?: Maybe<RestrictionDetails>;
  success: Scalars['Boolean']['output'];
  transactionId?: Maybe<Scalars['Int']['output']>;
  transactionStatus?: Maybe<CreditTransactionStatus>;
};

export enum CreditTransactionStatus {
  CONSUMED = 'CONSUMED',
  FAILED = 'FAILED',
  LOCKED = 'LOCKED',
  REVERSED = 'REVERSED'
}

export type CreditType = {
  __typename?: 'CreditType';
  /** The account credits coming from recurly */
  accountCredit?: Maybe<Scalars['Float']['output']>;
  /** The total amount already paid on the previous invoice for current billing cycle */
  paid?: Maybe<Scalars['Float']['output']>;
  /** The prorated credits comming from the previous subscription (refund) */
  prorateCredits?: Maybe<Scalars['Float']['output']>;
};

/** Result of credits operation for background removal. */
export type CreditsBgRemoverPayload = {
  __typename?: 'CreditsBgRemoverPayload';
  /** Whether the operation was successful. */
  result: Scalars['Boolean']['output'];
};

export type Cron = {
  __typename?: 'Cron';
  name: Scalars['String']['output'];
  status: CronStatus;
};

export enum CronStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export type CropVideoResult = {
  __typename?: 'CropVideoResult';
  /** Real duration of the cropped clip, in seconds. */
  duration: Scalars['Float']['output'];
  /** Real height of the produced file. */
  height?: Maybe<Scalars['Int']['output']>;
  /** URL of the cropped mp4. */
  url: Scalars['String']['output'];
  /** Real width of the produced file. Both axes are rounded down to even for h264. */
  width?: Maybe<Scalars['Int']['output']>;
};

export type Currency = {
  __typename?: 'Currency';
  currency: Scalars['String']['output'];
  unitAmount: Scalars['Float']['output'];
};

export type CurrentSubscriptionPayload = {
  __typename?: 'CurrentSubscriptionPayload';
  hasPaidInvoice?: Maybe<Scalars['Boolean']['output']>;
  paymentMethod?: Maybe<PaymentTypes>;
  subscription?: Maybe<RecurlySubscription>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type CustomBranding = {
  __typename?: 'CustomBranding';
  brandColor?: Maybe<Scalars['String']['output']>;
  brandDomain?: Maybe<Scalars['String']['output']>;
  brandEmail?: Maybe<Scalars['String']['output']>;
  brandFavicon?: Maybe<Scalars['Boolean']['output']>;
  brandFrom?: Maybe<Scalars['String']['output']>;
  brandLogo?: Maybe<Scalars['Boolean']['output']>;
  brandRecords?: Maybe<BrandRecords>;
  domainStatus?: Maybe<TeamBrandStatus>;
  emailStatus?: Maybe<TeamBrandStatus>;
  pageTitle?: Maybe<Scalars['String']['output']>;
};

export type CustomDesignSetSizeTypesPayload = {
  __typename?: 'CustomDesignSetSizeTypesPayload';
  /** One page of sets: twenty at most. */
  designSizeTypes: Array<DesignSizeType>;
  /** Whether the team has more sets after this page. */
  hasMore: Scalars['Boolean']['output'];
};

export type CustomSize = {
  __typename?: 'CustomSize';
  height: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  measureUnit: MeasureUnit;
  name: Scalars['String']['output'];
  projectId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Date']['output'];
  width: Scalars['Float']['output'];
};

export type CustomTransitionPayload = {
  __typename?: 'CustomTransitionPayload';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  properties: Scalars['JsonTransitionAll']['output'];
};

export type CutVideoResult = {
  __typename?: 'CutVideoResult';
  /** Real duration of the concatenated result, in seconds. */
  duration: Scalars['Float']['output'];
  /** URL of the cut mp4. */
  url: Scalars['String']['output'];
};

export type DataLakePayload = {
  __typename?: 'DataLakePayload';
  result: Scalars['Boolean']['output'];
};

export type DefaultAudiences = {
  __typename?: 'DefaultAudiences';
  audiences: Array<SuggestedAudience>;
  source: DefaultAudiencesSource;
};

export enum DefaultAudiencesSource {
  AI = 'AI',
  /** Legacy empty result — no longer emitted; kept for client compatibility. */
  NONE = 'NONE',
  /** Deterministic preset fallback — served when the AI suggestion fails; never cached. */
  PRESET = 'PRESET'
}

/** Result of deleting a user account. */
export type DeleteAccountPayload = {
  __typename?: 'DeleteAccountPayload';
  /** Whether the account deletion was successful. */
  result: Scalars['Boolean']['output'];
};

export type DeleteAdPublishJobFromRedisInput = {
  designId: Scalars['Int']['input'];
  platform: DpaPlatformType;
  publishTypePrefix?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteAdjustmentInput = {
  designId: Scalars['Int']['input'];
  designProperties?: InputMaybe<Array<Scalars['String']['input']>>;
  designProperty?: InputMaybe<Scalars['String']['input']>;
  layerId?: InputMaybe<Scalars['ID']['input']>;
  properties?: InputMaybe<Array<Scalars['String']['input']>>;
  property?: InputMaybe<Scalars['String']['input']>;
  rowIndex: Scalars['Int']['input'];
};

export type DeleteAppIntegrationPayload = {
  __typename?: 'DeleteAppIntegrationPayload';
  integrationWasDeleted: Scalars['Boolean']['output'];
};

/** Response when deleting a font from a brand kit. */
export type DeleteBrandKitFontPayload = {
  __typename?: 'DeleteBrandKitFontPayload';
  /** ID of the brand kits that should reset typography. */
  brandKitsShouldResetTypography?: Maybe<Array<Scalars['Int']['output']>>;
  /** ID of the deleted font. */
  fontId: Scalars['Int']['output'];
  /** Whether the deletion was successful. */
  result: Scalars['Boolean']['output'];
  /** Whether typography settings need to be reset due to the font deletion. */
  shouldResetTypography: Scalars['Boolean']['output'];
};

/** Response after deleting media from a brand kit. */
export type DeleteBrandKitMediaPayload = {
  __typename?: 'DeleteBrandKitMediaPayload';
  /** Whether the operation was successful. */
  result: Scalars['Boolean']['output'];
};

export type DeleteCloudIntegrationPayload = {
  __typename?: 'DeleteCloudIntegrationPayload';
  integrationWasDeleted: Scalars['Boolean']['output'];
};

export type DeleteCommentResult = {
  __typename?: 'DeleteCommentResult';
  commentId: Scalars['Int']['output'];
  threadId: Scalars['Int']['output'];
  threadWasDeleted: Scalars['Boolean']['output'];
};

export type DeleteCommentsOnTemplateChangeResult = {
  __typename?: 'DeleteCommentsOnTemplateChangeResult';
  designId: Scalars['Int']['output'];
};

export type DeleteCopilotAiChatMessagePayload = {
  __typename?: 'DeleteCopilotAiChatMessagePayload';
  chatId: Scalars['Int']['output'];
  messageId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteCopilotAiChatPayload = {
  __typename?: 'DeleteCopilotAiChatPayload';
  chatId: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteDesignCommentsResult = {
  __typename?: 'DeleteDesignCommentsResult';
  success: Scalars['Boolean']['output'];
};

/** Response after deleting a design. */
export type DeleteDesignPayload = {
  __typename?: 'DeleteDesignPayload';
  /** Whether the deletion was successful. */
  result: Scalars['Boolean']['output'];
  /** Trash item representation of the deleted design. */
  trashItem: TrashItem;
};

export type DeleteFolderPayload = {
  __typename?: 'DeleteFolderPayload';
  innerDesigns: Array<TrashItemIdWithParentDeleted>;
  innerFolders: Array<TrashItemIdWithParentDeleted>;
  trashItem: TrashItem;
};

export type DeleteFolderPermanentlyPayload = {
  __typename?: 'DeleteFolderPermanentlyPayload';
  designIds: Array<DeleteTrashItemPermanentlyIdType>;
  folderIds: Array<DeleteTrashItemPermanentlyIdType>;
};

export type DeleteMediaFolderPayload = {
  __typename?: 'DeleteMediaFolderPayload';
  mediaFolder: MediaFolder;
};

export type DeleteMoodBoardCommentInput = {
  id: Scalars['Int']['input'];
  moodBoardHash: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteMoodBoardCommentThreadInput = {
  moodBoardHash: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  threadId: Scalars['Int']['input'];
};

export type DeletePlatformAdInput = {
  /** Platform ad ID */
  id: Scalars['Int']['input'];
};

/** Response after deleting a project. */
export type DeleteProjectPayload = {
  __typename?: 'DeleteProjectPayload';
  /** Designs within the project that were also deleted. */
  innerDesigns: Array<TrashItemIdWithParentDeleted>;
  /** Folders within the project that were also deleted. */
  innerFolders: Array<TrashItemIdWithParentDeleted>;
  /** Whether the deletion was successful. */
  success: Scalars['Boolean']['output'];
  /** Trash item representation of the deleted project. */
  trashItem?: Maybe<TrashItem>;
};

/** Response after permanently deleting a project. */
export type DeleteProjectPermanentlyPayload = {
  __typename?: 'DeleteProjectPermanentlyPayload';
  /** IDs of designs that were permanently deleted. */
  designIds: Array<DeleteTrashItemPermanentlyIdType>;
  /** IDs of folders that were permanently deleted. */
  folderIds: Array<DeleteTrashItemPermanentlyIdType>;
};

export type DeleteSlideCommentsResult = {
  __typename?: 'DeleteSlideCommentsResult';
  slideId: Scalars['Int']['output'];
};

export type DeleteStoredFontBackupResult = {
  __typename?: 'DeleteStoredFontBackupResult';
  backup: StoredFontBackup;
  /** True only when "apply" was set and there was a backup to remove. */
  deleted: Scalars['Boolean']['output'];
  hash: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Input for deleting a team client ID. */
export type DeleteTeamClientId = {
  /** ID of the client to delete. */
  id: Scalars['Int']['input'];
  /** ID of the team that owns the client. */
  teamId: Scalars['Int']['input'];
};

/** Response after deleting a team. */
export type DeleteTeamPayload = {
  __typename?: 'DeleteTeamPayload';
  /** Whether the deletion was successful. */
  result: Scalars['Boolean']['output'];
};

/** Simple ID wrapper type for deleted items. */
export type DeleteTrashItemPermanentlyIdType = {
  __typename?: 'DeleteTrashItemPermanentlyIdType';
  /** ID of the deleted item. */
  id: Scalars['Int']['output'];
};

export type DeleteWorkflowResponse = {
  __typename?: 'DeleteWorkflowResponse';
  success: Scalars['Boolean']['output'];
};

export enum DelimiterCsv {
  COMMA = 'COMMA',
  SEMICOLON = 'SEMICOLON',
  TAB = 'TAB'
}

export enum DemoType {
  AI_VIDEO = 'AI_VIDEO',
  STANDARD = 'STANDARD'
}

/**
 * A design in Creatopy, representing a visual creation.
 * Designs can be static images, animations, or interactive content.
 */
export type Design = {
  __typename?: 'Design';
  /** Ad tag settings for the design. */
  adTag?: Maybe<DesignAdTagSettings>;
  /** Analytics data for the design's ad tag. */
  adTagAnalytics?: Maybe<DesignAdTagAnalytics>;
  /** Whether the design was generated via API. */
  apiGenerated?: Maybe<Scalars['Boolean']['output']>;
  /** The current approval status of the design (state id: draft, in-review, changes-requested, approved). */
  approvalStatus?: Maybe<Scalars['String']['output']>;
  /** Brand kit associated with this design. */
  brandKit?: Maybe<BrandKit>;
  /** ID of the brand kit associated with this design. */
  brandKitId?: Maybe<Scalars['Int']['output']>;
  /** Checksum for the design data. */
  checksum?: Maybe<Scalars['String']['output']>;
  /** Comment information for the design. */
  comments: DesignComments;
  /** When the design was created. */
  createdAt: Scalars['Date']['output'];
  /** User who created the design. */
  createdByUser?: Maybe<ByUser>;
  /** Source where the design was created. */
  creationSource?: Maybe<DesignCreationSource>;
  /** Property paths the user customised directly on this size (SyncOverrides shape) — the cross-size push withholds them unless the size is explicitly opted in for overwrite. Master-set size rows only; null on master sizes and never-edited rows. */
  crossSizeOverrides?: Maybe<Scalars['JSON']['output']>;
  /** How the user started the design, or its set's for a size that records none. Null when nothing recorded it, as on designs made before it was stored. */
  designOrigin?: Maybe<DesignOrigin>;
  /** Size type information for the design. */
  designSize?: Maybe<DesignSizeType>;
  /** ID of the design size type. */
  designSizeTypeId?: Maybe<Scalars['Int']['output']>;
  /** Child designs in a design set. */
  designs?: Maybe<Array<Design>>;
  /** Duration of the design in seconds (for animations). */
  duration?: Maybe<Scalars['Float']['output']>;
  estimatedSize?: Maybe<Scalars['Int']['output']>;
  estimatorHtmlSettings?: Maybe<DesignHtmlSettings>;
  /** Whether the design is flagged for export with the next batch. */
  exportNext?: Maybe<Scalars['Boolean']['output']>;
  /** Feed configuration for the design (if applicable). */
  feed?: Maybe<DesignFeed>;
  /** PLA-452: true when phishing enforcement has demoted this design's share link to team-only and no admin exemption applies. While true, the share panel disables the Public option and shows a contact-support notice. Independent of publicStatus, which is left untouched. */
  forcedTeamOnly: Scalars['Boolean']['output'];
  /** Whether the design contains animations. */
  hasAnimation: Scalars['Boolean']['output'];
  /** Whether the design contains audio elements. */
  hasAudio: Scalars['Boolean']['output'];
  /** Whether the design uses custom fonts. */
  hasCustomFont: Scalars['Boolean']['output'];
  /** Whether the design contains other embedded content. */
  hasEmbed: Scalars['Boolean']['output'];
  /** Whether the design contains image elements. */
  hasImage: Scalars['Boolean']['output'];
  /** True when this design carries motion - a video layer or animations. It is hasVideo OR hasAnimation collapsed to the one question every caller actually asks. Nullable on purpose: a nullable field stays OPTIONAL in generated clients, so selecting it costs no existing fixture two fields it never reads. */
  hasMotion?: Maybe<Scalars['Boolean']['output']>;
  /** Has right to left text */
  hasRtlText: Scalars['Boolean']['output'];
  /** Whether the design contains video elements. */
  hasVideo: Scalars['Boolean']['output'];
  /** Whether the design contains YouTube embeds. */
  hasYoutube: Scalars['Boolean']['output'];
  /** Unique hash identifier for the design. */
  hash: Scalars['String']['output'];
  /** Height of the design in specified measurement units. */
  height: Scalars['Float']['output'];
  /** HTML export settings for the design. */
  htmlSettings?: Maybe<DesignHtmlSettings>;
  /** Unique identifier for the design. */
  id: Scalars['Int']['output'];
  /** Whether a thumbnail image has been generated. */
  imageGenerated?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the design is protected by a password. */
  isPasswordProtected: Scalars['Boolean']['output'];
  /** JSON data for the design. */
  json?: Maybe<JsonDesignWithHash>;
  /** LANGUAGE variation top rows only: DeepL language code this variation was created for. Null for masters, duplicate variations, and size children. */
  languageCode?: Maybe<Scalars['LanguageCodesType']['output']>;
  /** Number of times the animation loops. */
  loopCount?: Maybe<Scalars['Int']['output']>;
  /** SET rows only: id of the size child that hydrates as the main design in the new Ad Studio single-design mode; null = frontend auto-pick. */
  mainDesignId?: Maybe<Scalars['Int']['output']>;
  /** Set when this design is a variation of the referenced master design; variations are excluded from design listings. */
  masterSetId?: Maybe<Scalars['Int']['output']>;
  /** The designSizeTypeId of THE master size — the size the Design tab edits (first set child by creation order; a standalone design is its own master size). Only the master size's changes offer the cross-size sync. Null for set children. */
  masterSizeTypeId?: Maybe<Scalars['Int']['output']>;
  /** Master per-size checksums this variation was last synced with. Null for non-variations — out-of-sync detection compares these against the master sizes' current checksum. */
  masterSyncState?: Maybe<DesignMasterSyncState>;
  /** Measurement unit for the design dimensions. */
  measureUnit: MeasureUnit;
  /** Media assets uploaded into this design's own library, independent of what's placed on the canvas. */
  mediaLibrary: DesignMediaLibraryResult;
  /** All folders of this design's media library, flat; the client derives the tree from parentId. */
  mediaLibraryFolders: Array<DesignMediaFolder>;
  /** Name of the design. */
  name: Scalars['String']['output'];
  /** Whether the design is permanent (can't be deleted). */
  permanent: Scalars['Boolean']['output'];
  /** Public sharing status of the design. */
  publicStatus: PublicStatus;
  /** Server time, in milliseconds, at the start of this request: every read in it comes after. The editor sends the first one it loads as markEditDesign's and updateDesigns' openedAt. */
  readAt: Scalars['Float']['output'];
  /** Design aiResize status. */
  resizeProgress?: Maybe<Scalars['Float']['output']>;
  /** Dedicated reviewers assigned to this design. */
  reviewers: Array<DesignReviewer>;
  /** Set CHILD rows only: hash of the parent set - the family's CANONICAL hash, the one an Ad Studio URL must carry (a child resolves no sizes and no variations). Null on top-level nodes. */
  setHash?: Maybe<Scalars['String']['output']>;
  /** ID of the design set this design belongs to (if applicable). */
  setId?: Maybe<Scalars['Int']['output']>;
  /** JSON data for the design set (if this is a set). */
  setJson?: Maybe<Scalars['JsonDesignSet']['output']>;
  /** Hash for sharing the design publicly. */
  shareHash: Scalars['String']['output'];
  /** Information about how the design is shared. */
  shared: SharedPayload;
  /** User who shared the design (if applicable). */
  sharedBy?: Maybe<ByUser>;
  /** The renderable design sizes of this node, normalized across set vs single design: a design set returns its child sizes, a standalone single design returns itself as its one size (and a set child returns none). Lets clients read sizes uniformly without special-casing sets. */
  sizes: Array<Design>;
  /** Metadata of the master's sizes baseline snapshot (used by the cross-size push). Null until first initialized. */
  sizesSyncBaseline?: Maybe<DesignSizesSyncBaseline>;
  /** The master's baseline size JSONs keyed by designSizeTypeId (read from S3 on demand — select only when previewing the cross-size push). Null until a baseline exists. Master top rows only. */
  sizesSyncBaselineJson?: Maybe<Scalars['JSON']['output']>;
  /** Number of slides in the design (for animations). */
  slidesCount?: Maybe<Scalars['Int']['output']>;
  /** Everything this variation size row has diverged on (SyncOverrides shape from @thebrief-ai/shared/designSync). Null = never captured (sync skips such rows). Variation size rows only — feeds the sync review preview and relink UI. */
  syncOverrides?: Maybe<Scalars['JSON']['output']>;
  /** Whether the design is a template. */
  template?: Maybe<Scalars['Boolean']['output']>;
  /** Hash of the template this design was created from (if applicable). */
  templateHash?: Maybe<Scalars['String']['output']>;
  /** ID of the template this design was created from (if applicable). */
  templateId?: Maybe<Scalars['Int']['output']>;
  /** URL to the design thumbnail. */
  thumb?: Maybe<Scalars['String']['output']>;
  /** Type of design (design, set, component). */
  type: DesignType;
  /** When the design was last updated. */
  updatedAt: Scalars['Date']['output'];
  /** User who last updated the design. */
  updatedByUser?: Maybe<ByUser>;
  usage: Array<DesignUsage>;
  /** Variations of this design set: copies linked via masterSetId and excluded from all design listings. */
  variations?: Maybe<Array<Design>>;
  /** Width of the design in specified measurement units. */
  width: Scalars['Float']['output'];
};


/**
 * A design in Creatopy, representing a visual creation.
 * Designs can be static images, animations, or interactive content.
 */
export type DesignMediaLibraryArgs = {
  input?: InputMaybe<InputDesignMediaLibrary>;
};


/**
 * A design in Creatopy, representing a visual creation.
 * Designs can be static images, animations, or interactive content.
 */
export type DesignUsageArgs = {
  input: InputAbTest;
};

/** Analytics data for an ad tag. */
export type DesignAdTagAnalytics = {
  __typename?: 'DesignAdTagAnalytics';
  /** Number of clicks on the ad. */
  clicks: Scalars['Int']['output'];
  /** Number of views of the ad. */
  views: Scalars['Int']['output'];
};

/** One design's ad-tag analytics, keyed by hash, for the split `designsAdTagAnalytics` query. */
export type DesignAdTagAnalyticsEntry = {
  __typename?: 'DesignAdTagAnalyticsEntry';
  /** Clicks/views for the design; null if the design has no ad-serving usage. */
  analytics?: Maybe<DesignAdTagAnalytics>;
  /** Hash of the design these analytics belong to. */
  hash: Scalars['String']['output'];
};

/** Ad tag settings for a design. */
export type DesignAdTagSettings = {
  __typename?: 'DesignAdTagSettings';
  /** Whether the ad tag is active. */
  active: Scalars['Boolean']['output'];
  /** Dynamic variables used in the ad tag. */
  dynamicVars?: Maybe<Array<AdTagDynamicVar>>;
  /** Progress of embed generation. */
  embeds?: Maybe<EmbedsProgress>;
  /** Synchronization status of the ad tag. */
  syncStatus: AdTagSyncStatus;
  /** Target URL for the ad tag. */
  url?: Maybe<Scalars['String']['output']>;
  /** Whether the design URL is used as a click tag. */
  useAsClickTag?: Maybe<Scalars['Boolean']['output']>;
};

export type DesignAnimatorSuggestion = {
  __typename?: 'DesignAnimatorSuggestion';
  config: Scalars['JSON']['output'];
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type DesignAnimatorSuggestionsResult = {
  __typename?: 'DesignAnimatorSuggestionsResult';
  suggestions: Array<DesignAnimatorSuggestion>;
};

/** A record of an approval status change. */
export type DesignApprovalHistoryEntry = {
  __typename?: 'DesignApprovalHistoryEntry';
  /** The user who made the change. */
  changedBy?: Maybe<User>;
  /** Optional comment explaining the change. */
  comment?: Maybe<Scalars['String']['output']>;
  /** When the change was made. */
  createdAt: Scalars['Date']['output'];
  /** The design ID. */
  designId: Scalars['Int']['output'];
  /** The previous status ID (null for initial assignment). */
  fromStatusId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier. */
  id: Scalars['Int']['output'];
  /** The new status ID. */
  toStatusId: Scalars['String']['output'];
};

export type DesignAuthor = {
  __typename?: 'DesignAuthor';
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type DesignBrandKitRef = {
  __typename?: 'DesignBrandKitRef';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export enum DesignChangeKind {
  ADD_IMAGE = 'ADD_IMAGE',
  ADD_TEXT = 'ADD_TEXT',
  /** A new video layer of a library video, placed like ADD_IMAGE: the slide lasts at least as long as the clip. */
  ADD_VIDEO = 'ADD_VIDEO',
  BACKGROUND_COLOR = 'BACKGROUND_COLOR',
  FONT = 'FONT',
  IMAGE = 'IMAGE',
  MOVE = 'MOVE',
  /** Where the layer sits in its slide's or group's stack: see LayerOrder. A layer inside a frame is skipped. */
  ORDER = 'ORDER',
  REMOVE = 'REMOVE',
  RESIZE = 'RESIZE',
  TEXT = 'TEXT',
  TEXT_COLOR = 'TEXT_COLOR',
  /** A library video in the place of an image or video layer: the slide lasts at least as long as the clip. */
  VIDEO = 'VIDEO',
  VISIBLE = 'VISIBLE'
}

export type DesignChangeResult = {
  __typename?: 'DesignChangeResult';
  appliedSizeHashes: Array<Scalars['String']['output']>;
  index: Scalars['Int']['output'];
  kind: DesignChangeKind;
  skipped: Array<DesignChangeSkip>;
};

export type DesignChangeSkip = {
  __typename?: 'DesignChangeSkip';
  /** LAYER_MISSING, WRONG_KIND, or UNCHANGED (the writer had nothing to do on that layer). */
  reason: Scalars['String']['output'];
  sizeHash: Scalars['String']['output'];
};

export type DesignCheck = {
  __typename?: 'DesignCheck';
  /** The brand module's state. notBuilt until it lands. */
  brand: Scalars['String']['output'];
  cached: Scalars['Boolean']['output'];
  checkedAt: Scalars['String']['output'];
  designHash: Scalars['String']['output'];
  /** The size that was checked. */
  designId: Scalars['Int']['output'];
  height: Scalars['Int']['output'];
  /** The cache key: the size, its saved content, the slide, the brand kit, the scorer version and its settings. */
  key: Scalars['String']['output'];
  kitId?: Maybe<Scalars['Int']['output']>;
  /** What capped provisionalScore: deterministic MAJOR or CRITICAL issues. Null when nothing lowered it. */
  provisionalCap?: Maybe<DesignCheckProvisionalCap>;
  /**
   * Not the scorer's score: the mean of the measured rules' own scores, every rule weighted 1, at most
   * provisionalCap.score. Null when none measured.
   */
  provisionalScore?: Maybe<Scalars['Float']['output']>;
  render?: Maybe<DesignCheckRender>;
  /** Why the check has no render: busy (no render slot freed in time) or failed. */
  renderMissing?: Maybe<Scalars['String']['output']>;
  renderMs?: Maybe<Scalars['Int']['output']>;
  /** scorer.score()'s result, whole: score, verdict, rules, issues, AI answers, passes, versions, timings. */
  result: Scalars['JSON']['output'];
  slideId?: Maybe<Scalars['Int']['output']>;
  width: Scalars['Int']['output'];
};

/** What capped the provisional number, by the scorer's cap rule. */
export type DesignCheckProvisionalCap = {
  __typename?: 'DesignCheckProvisionalCap';
  criticals: Scalars['Int']['output'];
  majors: Scalars['Int']['output'];
  /** The cap: the scorer's majorCap for a deterministic MAJOR, its criticalCap for a CRITICAL. */
  score: Scalars['Float']['output'];
};

export type DesignCheckRender = {
  __typename?: 'DesignCheckRender';
  /** JPEG of the render the scorer saw, at most 1080 px on its long edge. */
  base64: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};

/** Comment information for a design. */
export type DesignComments = {
  __typename?: 'DesignComments';
  /** Total number of comments on the design. */
  count: Scalars['Int']['output'];
  /** Whether there are unread comments for the current user. */
  hasUnread: Scalars['Boolean']['output'];
};

export type DesignCommentsResult = {
  __typename?: 'DesignCommentsResult';
  isGuest: Scalars['Boolean']['output'];
  threads?: Maybe<Array<CommentThread>>;
};

export type DesignComponent = {
  __typename?: 'DesignComponent';
  createdAt: Scalars['Date']['output'];
  hash: Scalars['String']['output'];
  height: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  json: Scalars['JsonDesign']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  updatedByUser?: Maybe<ByUser>;
  width: Scalars['Float']['output'];
};

export type DesignContent = {
  __typename?: 'DesignContent';
  brandKit?: Maybe<DesignBrandKitRef>;
  catalogVariation: Scalars['Boolean']['output'];
  /** Who has the design open in the editor, if anyone. */
  editing?: Maybe<DesignEditingHolder>;
  feedBound: Scalars['Boolean']['output'];
  /** The set's or the standalone design's hash. */
  hash: Scalars['String']['output'];
  /** Where the template keeps image choices, when that binds the caller. */
  imageScope?: Maybe<DesignImageScope>;
  /** Each slide's and group's layers front first, as the editor's Layers panel lists them; a group before its layers. */
  layers: Array<DesignLayerSummary>;
  /** An unversioned file, or one with duplicate layer ids: described, but not editable until the editor saves it. */
  legacy: Scalars['Boolean']['output'];
  /** The design-wide locks that bind the caller: SIZES, BACKGROUND, and STRUCTURE (adding, removing or reordering layers, a font family) for a Content editor. */
  locks: Array<DesignLock>;
  /** How the brand template's locks bind the caller. */
  locksBind: LocksBind;
  name: Scalars['String']['output'];
  /** The size the layers describe. */
  size: DesignContentSize;
  sizes: Array<DesignContentSize>;
  teamId: Scalars['Int']['output'];
  /** The design is a brand or workspace template itself. */
  template: Scalars['Boolean']['output'];
};

export type DesignContentSize = {
  __typename?: 'DesignContentSize';
  hash: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  main: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

/** Sources where designs can be created. */
export enum DesignCreationSource {
  /** Created in Ad Studio. */
  ADSTUDIO = 'adstudio',
  /** Created via API. */
  API = 'api',
  /** System-generated Crafted Ad from the user's Brand Kit. */
  CRAFTED = 'crafted',
  /** Exported from Figma */
  FIGMA = 'figma',
  /** Created in legacy editor. */
  LEGACY_EDITOR = 'legacy_editor',
  /** Created in legacy generator. */
  LEGACY_GENERATOR = 'legacy_generator',
  /** Created in Light Editor. */
  LIGHT_EDITOR = 'light_editor',
  /** Created in Moodboard. */
  MOODBOARD = 'moodboard',
  /** Created in NextGen flow. */
  NEXTGEN_FLOW = 'nextgen_flow',
  /** Imported from a PSD file (Photoshop import). */
  PSD = 'psd',
  /** Imported by a prospect claiming lead-pipeline sample ads (share-token redemption). */
  SAMPLE_AD = 'sample_ad',
  /** System-generated motion version of a downloaded static (static to motion). */
  STATIC_TO_MOTION = 'static_to_motion',
  /** Created in white-labeled Ad Studio. */
  WL_ADSTUDIO = 'wl_adstudio',
  /** Created in white-labeled Light Editor. */
  WL_LIGHT_EDITOR = 'wl_light_editor',
  /** Created in white-labeled NextGen flow. */
  WL_NEXTGEN_FLOW = 'wl_nextgen_flow'
}

export type DesignEditingHolder = {
  __typename?: 'DesignEditingHolder';
  firstName: Scalars['String']['output'];
  /** The caller has the design open in the editor. */
  isCaller: Scalars['Boolean']['output'];
  /** The holder's tab steps aside for an edit from their own AI assistant: an edit from it goes through and the tab reloads. */
  stepsAside: Scalars['Boolean']['output'];
};

/** Response containing the editing status of a design. */
export type DesignEditingStatusPayload = {
  __typename?: 'DesignEditingStatusPayload';
  /** User who is currently editing the design (null if not being edited or if current user is editing). */
  editingUser?: Maybe<DesignEditingUser>;
  /** Whether the design is currently being edited by someone. */
  isBeingEdited: Scalars['Boolean']['output'];
};

/** The user editing a design: their id and name only. */
export type DesignEditingUser = {
  __typename?: 'DesignEditingUser';
  /** Unique identifier of the user. */
  id: Scalars['Int']['output'];
  /** User's full name. */
  name: Scalars['String']['output'];
};

export type DesignEvalCriterion = {
  __typename?: 'DesignEvalCriterion';
  id: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  /** 0-100, or null when the dimension does not apply (e.g. no CTA in the design). */
  score?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
};

export type DesignEvalDefect = {
  __typename?: 'DesignEvalDefect';
  description: Scalars['String']['output'];
  severity: DesignEvalSeverity;
  type: Scalars['String']['output'];
};

/** An allowlisted eval judge. `id` is the value to pass as `InputAdminEvalDesign.model`. */
export type DesignEvalModelOption = {
  __typename?: 'DesignEvalModelOption';
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
};

export type DesignEvalResult = {
  __typename?: 'DesignEvalResult';
  /** Whether a usable brand reference was applied to this evaluation (false if the design has no brand kit or it carried no visual signal). */
  brandKitApplied: Scalars['Boolean']['output'];
  defects: Array<DesignEvalDefect>;
  dimensions: Array<DesignEvalCriterion>;
  /** Whether a reference logo image was attached to the judge. */
  logoReferenceUsed: Scalars['Boolean']['output'];
  /** The model that produced this evaluation. */
  modelId: Scalars['String']['output'];
  overallScore: Scalars['Int']['output'];
  /** The exact rendered image URL that was evaluated. */
  thumbnailUrl: Scalars['String']['output'];
  verdict: DesignEvalVerdict;
};

export enum DesignEvalSeverity {
  CRITICAL = 'CRITICAL',
  MAJOR = 'MAJOR',
  MINOR = 'MINOR'
}

export enum DesignEvalVerdict {
  BORDERLINE = 'BORDERLINE',
  REJECT = 'REJECT',
  SHIP = 'SHIP'
}

/** Feed configuration for a design. */
export type DesignFeed = {
  __typename?: 'DesignFeed';
  /** Opaque revision of the design-feed attachment, used to reject stale product-set materialization. */
  attachmentRevision?: Maybe<Scalars['String']['output']>;
  /** Whether the feed has data bindings. */
  bindings?: Maybe<Scalars['Boolean']['output']>;
  /** Set only by the Variations tab's catalog connect (CRE-541), in the same transaction that creates the variation: the design is a catalog VARIATION whose content follows the catalog. This marker alone is the identity; bindings is the serving bake's gate, flipped when the connect completes. A variation the old editor bound through Apply Feed has bindings without the marker and keeps every editing surface. */
  catalogVariation?: Maybe<Scalars['Boolean']['output']>;
  /** Checksum for the feed configuration. */
  checksum?: Maybe<Scalars['String']['output']>;
  /** Hash identifier for the feed. */
  hash?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the feed configuration. */
  id?: Maybe<Scalars['Int']['output']>;
  /** Name of the feed. */
  name?: Maybe<Scalars['String']['output']>;
  /** Whether the scoping product set was deleted at its source (Meta) since it was imported. The row survives for the designs still scoped to it, which keep rendering the frozen membership; the editor flags the scope. Null when unscoped. */
  productSetDeletedAtSource?: Maybe<Scalars['Boolean']['output']>;
  /** Product set scoping this design's feed (CRE-438, D24). Null = the whole catalog ('All Products'). */
  productSetId?: Maybe<Scalars['Int']['output']>;
  /** Display name of the scoping product set (CRE-438). Null when unscoped or the scope is unresolvable. */
  productSetName?: Maybe<Scalars['String']['output']>;
  /** Current row in the feed. */
  row?: Maybe<Scalars['Int']['output']>;
  /** Total number of rows in the feed. */
  rows?: Maybe<Scalars['Int']['output']>;
};

export type DesignFeedAdjustmentInfo = {
  __typename?: 'DesignFeedAdjustmentInfo';
  adjustedRows: Array<Scalars['String']['output']>;
  designId: Scalars['Int']['output'];
  feedId: Scalars['Int']['output'];
};

/**
 * HTML export settings for a design.
 * These settings control how a design is exported to HTML.
 */
export type DesignHtmlSettings = {
  __typename?: 'DesignHtmlSettings';
  /** IDs of ad networks to optimize for. */
  adNetworksIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Whether to convert custom fonts to web-safe formats. */
  convertCustomFonts: Scalars['Boolean']['output'];
  /** ID of the design these settings apply to. */
  designId: Scalars['Int']['output'];
  /** Whether to include a fallback static image. */
  fallbackImage: Scalars['Boolean']['output'];
  /** Image quality percentage for exported images (1-100). */
  imageQuality: Scalars['Int']['output'];
  /** Whether to minify the HTML output. */
  minifyHtml?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the exported HTML scales to fit the container it's opened in. */
  responsiveScaling: Scalars['Boolean']['output'];
  /** Whether to generate retina (2x) images. */
  retina: Scalars['Boolean']['output'];
  /** Whether to only generate retina images (no 1x images). */
  retinaOnly: Scalars['Boolean']['output'];
  /** HTML target attribute for the link (_blank, _self, etc.). */
  target: Scalars['String']['output'];
  /** When these settings were last updated. */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Target URL for the design when clicked. */
  url?: Maybe<Scalars['String']['output']>;
  /** Whether to use the design URL as a click tag for ads. */
  useAsClickTag: Scalars['Boolean']['output'];
};

export type DesignImageScope = {
  __typename?: 'DesignImageScope';
  brandKitName: Scalars['String']['output'];
  /** The kit folder (and the folders below it) images must come from; null for the whole kit. */
  folderName?: Maybe<Scalars['String']['output']>;
};

/** Where an importable medium came from. */
export enum DesignImportableMediaOrigin {
  /** Referenced by the design's canvas JSON. */
  CANVAS = 'CANVAS',
  /** Present in the design's own media library. */
  LIBRARY = 'LIBRARY'
}

/** Everything importable out of one design. */
export type DesignImportableMediaResult = {
  __typename?: 'DesignImportableMediaResult';
  /** Importable media, canvas items first. */
  items: Array<DesignImportableMedium>;
};

/** One medium that can be imported out of a design. */
export type DesignImportableMedium = {
  __typename?: 'DesignImportableMedium';
  /** Media hashid; null for an unregistered canvas asset. Thumbnails resize off this. */
  hash?: Maybe<Scalars['String']['output']>;
  /** Opaque handle; pass back to importMediaFromDesign to import this item. */
  key: Scalars['String']['output'];
  /** Set when the item is an existing media row; null for an unregistered canvas asset. */
  mediumId?: Maybe<Scalars['Int']['output']>;
  /** Display name. */
  name: Scalars['String']['output'];
  /** Whether the item came from the design's canvas or from its media library. */
  origin: DesignImportableMediaOrigin;
  /** Media type. */
  type: MediaType;
  /** Media.url for an existing row, or the absolute URL for an unregistered canvas asset. */
  url?: Maybe<Scalars['String']['output']>;
};

export type DesignLayerFont = {
  __typename?: 'DesignLayerFont';
  family: Scalars['String']['output'];
  italic: Scalars['Boolean']['output'];
  weight: Scalars['Int']['output'];
};

/** Font compatibility information for a single layer in a design. */
export type DesignLayerFontCheck = {
  __typename?: 'DesignLayerFontCheck';
  /** ID of the bannerset element (if applicable). */
  bannersetElementId?: Maybe<Scalars['Int']['output']>;
  /** ID of the layer being checked. */
  layerId: Scalars['Int']['output'];
  /** Characters in the layer not supported by the font. */
  unsupportedCharacters: Array<Scalars['String']['output']>;
};

export type DesignLayerSummary = {
  __typename?: 'DesignLayerSummary';
  colors: Array<Scalars['String']['output']>;
  /** Filled from a product feed, so an edit would be overwritten by the next feed sync. */
  feedBound: Scalars['Boolean']['output'];
  font?: Maybe<DesignLayerFont>;
  groupRef?: Maybe<Scalars['String']['output']>;
  height: Scalars['Float']['output'];
  /** The Media hash of a library image. */
  imageId?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  /** What of this layer the design's brand template locks for the caller (DesignContent.locksBind says how). */
  locks: Array<DesignLock>;
  /** The character limit the template set on the layer's text, when TEXT_LENGTH is in locks. */
  maxLength?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  /** The layer's bannersetElementId, which editDesign changes it by; null in a legacy file. */
  ref?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  visible: Scalars['Boolean']['output'];
  width: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type DesignLintConformance = {
  __typename?: 'DesignLintConformance';
  /** Set iff status is SKIPPED. */
  reason?: Maybe<Scalars['String']['output']>;
  status: DesignLintConformanceStatus;
  /** Non-empty iff status is FAIL. */
  violations: Array<DesignLintConformanceViolation>;
};

export enum DesignLintConformanceStatus {
  FAIL = 'FAIL',
  PASS = 'PASS',
  /** No fixer applied anything, so there was no refactored structure to gate. */
  SKIPPED = 'SKIPPED'
}

export type DesignLintConformanceViolation = {
  __typename?: 'DesignLintConformanceViolation';
  /** One of the linter's `CONFORMANCE_CODES` (kebab-case, so a String rather than an enum). */
  code: Scalars['String']['output'];
  detail: Scalars['String']['output'];
};

/** How the linter refers to one element: its slide plus `bannersetElementId ?? properties.id`. */
export type DesignLintElementRef = {
  __typename?: 'DesignLintElementRef';
  elementId: Scalars['String']['output'];
  slideIndex: Scalars['Int']['output'];
};

export type DesignLintFix = {
  __typename?: 'DesignLintFix';
  /** The applied summary, the declined reason, or the reverted sentence naming the gate's violations. Always populated. */
  detail: Scalars['String']['output'];
  status: DesignLintFixStatus;
};

/**
 * `REVERTED` is applied-then-undone: the FIXER said yes and the conformance GATE said no, so the
 * pattern's whole batch was rolled back. Distinct from `DECLINED` on purpose — collapsing the two
 * hides exactly the fixer bugs the gate exists to catch.
 */
export enum DesignLintFixStatus {
  APPLIED = 'APPLIED',
  DECLINED = 'DECLINED',
  REVERTED = 'REVERTED'
}

/**
 * What one pattern did with ONE subject it considered.
 *
 * THREE values for the same reason `DesignLintPatternStatus` has six. `ALREADY_SATISFIED` is NOT a
 * refusal — the design already says what the pattern would have said (a container already carrying this
 * linter's valid stamp), which is a success, and reporting it as declined would invert its meaning.
 */
export enum DesignLintObservationOutcome {
  /**
   * ANOTHER unit now covers these layers, so this subject produced no problem of its own. Not a
   * decline, and deliberately not `ACCEPTED`: no problem names this subject, and saying otherwise
   * would make the report disagree with itself.
   */
  ABSORBED = 'ABSORBED',
  /** It became a problem — find it in `patterns` under this observation's `subject`. */
  ACCEPTED = 'ACCEPTED',
  /** Nothing to do, and that is a good outcome. */
  ALREADY_SATISFIED = 'ALREADY_SATISFIED',
  /** A rung stopped it; `declinedBy` names which. */
  DECLINED = 'DECLINED'
}

/**
 * The resizeability patterns the linter knows about.
 *
 * Values are `@thebrief-ai/design-linter`'s own `PATTERN_IDS` strings VERBATIM (camelCase, not the
 * usual SCREAMING_CASE) on purpose: `apps/app` renders the pre-resize dialog from
 * `@thebrief-ai/design-linter/registry`'s catalogue, whose entries are keyed by exactly these ids, so
 * a camelCase enum makes the client's join a direct key lookup and leaves ZERO mapping table to drift.
 * Parity with `PATTERN_IDS` is pinned by a unit test.
 */
export enum DesignLintPattern {
  BINDCAPTIONCTA = 'bindCaptionCta',
  BINDTEXTSHADOW = 'bindTextShadow',
  BINDVISUALGROUP = 'bindVisualGroup',
  CTACOMPOSITE = 'ctaComposite',
  DEDUPESTACKED = 'dedupeStacked',
  DELETECOVERED = 'deleteCovered',
  DELETEEMPTYIMAGE = 'deleteEmptyImage',
  DELETEOFFCANVAS = 'deleteOffCanvas',
  FITTEXTBOX = 'fitTextBox',
  HEROSCALEUNIT = 'heroScaleUnit',
  LIFTBACKGROUND = 'liftBackground',
  TAGFOCALAREA = 'tagFocalArea',
  TAGFULLBLEED = 'tagFullBleed',
  TAGLEGALTEXT = 'tagLegalText',
  TAGLEGIBILITY = 'tagLegibility',
  TAGLOGOLOCKUP = 'tagLogoLockup',
  TAGRASTERLEGALTEXT = 'tagRasterLegalText',
  TEXTCLUSTER = 'textCluster'
}

/**
 * ONE subject a pattern CONSIDERED, with the rung that stopped it.
 *
 * Additive observability — the verdicts stay in `patterns`. `DesignLintProblem` structurally cannot
 * carry this: it exists only per EMITTED problem, so a subject a pattern examined and refused leaves no
 * trace in the report at all. That matters because a `visualGroup` the model NAMED and the code REFUSED
 * is otherwise indistinguishable from one the model never named — and those two need opposite fixes, a
 * prompt change versus a predicate change (AIR-6).
 */
export type DesignLintPatternObservation = {
  __typename?: 'DesignLintPatternObservation';
  /**
   * The rung's id, set iff outcome is DECLINED. A String rather than an enum: there are dozens of rung
   * constants across the patterns' separate vocabularies, and pinning them into the schema would make
   * every new rung a breaking schema change.
   */
  declinedBy?: Maybe<Scalars['String']['output']>;
  /** Measured facts about the subject. Pattern-specific, opaque to the client, serialisable by contract — and never the model's own strings. */
  facts: Scalars['JSON']['output'];
  outcome: DesignLintObservationOutcome;
  pattern: DesignLintPattern;
  /** The layers the pattern examined together. */
  subject: Array<DesignLintElementRef>;
};

export type DesignLintPatternOutcome = {
  __typename?: 'DesignLintPatternOutcome';
  /** One entry per problem, in the same order. Non-empty iff status is PROBLEMS_FOUND. */
  fixes: Array<DesignLintFix>;
  pattern: DesignLintPattern;
  /** Non-empty iff status is PROBLEMS_FOUND. */
  problems: Array<DesignLintProblem>;
  /** Set iff status is NOT_SCANNED or NOT_MEASURED — the reason the pattern could not run. */
  reason?: Maybe<Scalars['String']['output']>;
  status: DesignLintPatternStatus;
};

/**
 * Per-pattern verdict.
 *
 * `DRAFT` (registered but not implemented) and `NOT_FOUND` (ran, found nothing) are distinct values
 * on purpose — a detector that never ran must never be mistaken for one that ran and found nothing.
 * `NOT_SCANNED` is the same rule one layer up: detectors do not run without layer 1, so an
 * enabled+implemented pattern whose scan was unavailable has no verdict at all. `NOT_MEASURED` is
 * that rule once more, for a prerequisite BEYOND the scan — `fitTextBox` needs resolved font
 * metrics, and a pattern whose input was missing has no verdict either.
 */
export enum DesignLintPatternStatus {
  DISABLED = 'DISABLED',
  DRAFT = 'DRAFT',
  NOT_FOUND = 'NOT_FOUND',
  NOT_MEASURED = 'NOT_MEASURED',
  NOT_SCANNED = 'NOT_SCANNED',
  PROBLEMS_FOUND = 'PROBLEMS_FOUND'
}

/**
 * Where the picture layer 1 looked at came from. `NONE` carries the reason: a scan without a picture
 * is a real but WEAKER scan (the picture-dependent patterns cannot form their visual groups), and it
 * is reported as such, never as a scan that looked.
 */
export enum DesignLintPreviewSource {
  /** No picture reached the model; `reason` says why. */
  NONE = 'NONE',
  /** The server rendered the scoped document through jpg-png, synchronously, for this scan. */
  RENDERED = 'RENDERED',
  /** The caller supplied the PNG — the signed-DEV surface and the e2e suite, which render their own. */
  SUPPLIED = 'SUPPLIED'
}

export type DesignLintProblem = {
  __typename?: 'DesignLintProblem';
  /** Pattern-specific measured facts. Opaque to the client; serialisable by contract. */
  data?: Maybe<Scalars['JSON']['output']>;
  elements: Array<DesignLintElementRef>;
  /** Why this is a problem, in one human sentence. Rendered verbatim. */
  evidence: Scalars['String']['output'];
  pattern: DesignLintPattern;
};

/** Report plus the resulting document. Internal only — the raw-JSON callers need both to run a render gate. */
export type DesignLintRefactorResult = {
  __typename?: 'DesignLintRefactorResult';
  /** The refactored design when `report.applied`, otherwise a value-identical copy of the input. */
  jsonDesign: Scalars['JSON']['output'];
  report: DesignLintReport;
};

export type DesignLintReport = {
  __typename?: 'DesignLintReport';
  /** false ⇒ nothing was changed; any returned JSON is value-identical to the input. */
  applied: Scalars['Boolean']['output'];
  conformance: DesignLintConformance;
  /**
   * What each runnable pattern considered and did not turn into a problem, in pattern order.
   *
   * EMPTY when no runnable pattern reports observations at all, which is NOT the same as "nothing was
   * declined" — read it against `patterns`, never on its own.
   */
  observations: Array<DesignLintPatternObservation>;
  /** One entry per known pattern, in the linter's canonical order. */
  patterns: Array<DesignLintPatternOutcome>;
  scan: DesignLintScan;
};

export type DesignLintScan = {
  __typename?: 'DesignLintScan';
  /** Set iff status is RAN. On UNAVAILABLE there is no number at all, deliberately. */
  candidateCount?: Maybe<Scalars['Int']['output']>;
  /** Set iff status is RAN. */
  modelId?: Maybe<Scalars['String']['output']>;
  /**
   * The picture this scan reasoned from. Null iff the scan was REPLAYED from its token (the apply
   * path): a replay forms no new judgement and carries no preview of its own. Reported on UNAVAILABLE
   * too — whether a picture was rendered is orthogonal to whether the model answered.
   */
  preview?: Maybe<DesignLintScanPreview>;
  /** Set iff status is RAN. Hash over the base prompt plus every enabled detector's fragment — the cache key. */
  promptVersion?: Maybe<Scalars['String']['output']>;
  /** Set iff status is UNAVAILABLE. */
  reason?: Maybe<Scalars['String']['output']>;
  /**
   * Set iff status is RAN and the scan was recorded. Hand it back to `applyDesignLintFixes` to apply
   * fixes from THESE candidates instead of scanning again. Null means there is nothing to replay, so
   * the caller must scan again — never that the design is fine.
   */
  scanToken?: Maybe<Scalars['String']['output']>;
  status: DesignLintScanStatus;
  /**
   * What the scan says the design is MADE OF. THREE states, and collapsing any two of them is the bug
   * this field exists to make visible:
   *
   *  * `status: UNAVAILABLE` — the scan never ran, so there is no answer of any kind.
   *  * `status: RAN` with `visualGroups: null` — the scan ran and the grouping question was NOT
   *    answered. It is a replay from a cache written before the field existed. The linter reports
   *    `NOT_MEASURED` for the patterns that need it, never `NOT_FOUND`.
   *  * `status: RAN` with `visualGroups: []` — a real answer: the model looked and found no grouping.
   *
   * So `null` is never "no groups" and `[]` is never "we did not ask". Check `preview` alongside it:
   * an empty answer from a facts-only scan means something different from one that saw the picture.
   */
  visualGroups?: Maybe<Array<DesignLintVisualGroup>>;
};

export type DesignLintScanPreview = {
  __typename?: 'DesignLintScanPreview';
  /** Decoded image bytes handed to the model (a RENDERED picture is JPEG at the design's own size). Set iff source is SUPPLIED or RENDERED. */
  bytes?: Maybe<Scalars['Int']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  /** Set iff source is NONE. */
  reason?: Maybe<Scalars['String']['output']>;
  /** Wall time of the server-side render, in ms. Set iff a render was attempted — RENDERED, or NONE after a failed one. */
  renderMs?: Maybe<Scalars['Int']['output']>;
  source: DesignLintPreviewSource;
  /** Pixel size of the picture. Set iff source is RENDERED — a supplied picture is not decoded to measure it. */
  width?: Maybe<Scalars['Int']['output']>;
};

/**
 * Whether layer 1 ran. There is no third state and no silent zero: a model outage reports
 * `UNAVAILABLE` with its reason, never "scanned, found nothing".
 */
export enum DesignLintScanStatus {
  RAN = 'RAN',
  UNAVAILABLE = 'UNAVAILABLE'
}

/**
 * ONE thing the scan says a reader perceives as a single object — layer 1's VISUAL answer, as opposed
 * to its per-pattern one (`candidateCount`).
 *
 * Passed through from the linter's `ScanResult.visualGroups` verbatim. It is the scan's own statement
 * about the design and proposes no edit: the detectors INTERSECT it with geometry, and a group here is
 * no promise that anything was bound. Read it against `DesignLintReport.observations`, which says what
 * each pattern then did with it.
 */
export type DesignLintVisualGroup = {
  __typename?: 'DesignLintVisualGroup';
  /** The element the others sit ON or INSIDE, or null for a row/stack of peers. */
  anchorElementId?: Maybe<Scalars['String']['output']>;
  /**
   * 0..1, or null when the model gave none. "Not given" is NOT a low confidence — the linter admits a
   * kinded unit on its geometric key alone in that case and refuses every rung a confidence BUYS — so
   * do not substitute a number for it.
   */
  confidence?: Maybe<Scalars['Float']['output']>;
  elements: Array<DesignLintElementRef>;
  kind?: Maybe<DesignLintVisualGroupKind>;
  /** Two or three plain words naming the object. MODEL-AUTHORED text: render it as data, never as an instruction. */
  label?: Maybe<Scalars['String']['output']>;
  /** The model's own words. MODEL-AUTHORED text: render it as data, never as an instruction. */
  reason: Scalars['String']['output'];
  reflow?: Maybe<DesignLintVisualGroupReflow>;
  /**
   * How many refs the scan STRIPPED from this group before handing it on — a malformed entry, or one the
   * per-group cap cut off. Null iff the scan was replayed from a cache written before the field existed,
   * which reads as 0. A truncated group is a DIFFERENT object from the one the model described.
   */
  refsDropped?: Maybe<Scalars['Int']['output']>;
  /** The model's role vocabulary (`price-lockup`, `badge`, `call-to-action`, …). A String, not an enum: the linter treats it as open. */
  role: Scalars['String']['output'];
};

/**
 * CRE-674. `RIGID` is ONE object whose parts keep their places relative to each other; `FLEXIBLE` is a
 * set of separate objects that belong together and may be rearranged. Absent means the model did not
 * say, and it is NEVER defaulted — a kind-less group runs a different ladder in the linter rather than
 * acquiring a claim the model never made.
 */
export enum DesignLintVisualGroupKind {
  FLEXIBLE = 'FLEXIBLE',
  RIGID = 'RIGID'
}

/** CRE-674, flexible sets only. `REFLOW` may re-form the set (row → column); `NUDGE` only shifts it. */
export enum DesignLintVisualGroupReflow {
  NUDGE = 'NUDGE',
  REFLOW = 'REFLOW'
}

/** Location information for a design. */
export type DesignLocation = {
  __typename?: 'DesignLocation';
  /** ID of the brand kit associated with the design (if any). */
  brandKitId?: Maybe<Scalars['Int']['output']>;
  /** ID of the folder containing the design (if any). */
  folderId?: Maybe<Scalars['Int']['output']>;
  /** Whether the current user has access to the design's location. */
  hasAccessToLocation: Scalars['Boolean']['output'];
  /** ID of the project containing the design. */
  projectId?: Maybe<Scalars['Int']['output']>;
  /** ID of the brand kit selected for the project. */
  projectSelectedBrandKitId?: Maybe<Scalars['Int']['output']>;
  /** Method by which the design is shared. */
  shareThrough?: Maybe<DesignLocationShareThrough>;
  /** ID of the team that owns the design. */
  teamId: Scalars['Int']['output'];
};

/** Methods by which a design can be shared. */
export enum DesignLocationShareThrough {
  /** Shared directly as a design. */
  DESIGN = 'design',
  /** Shared through a folder. */
  FOLDER = 'folder'
}

/**
 * What a brand template keeps as it is. TEXT, TEXT_LENGTH (a character limit), COLOR, FONT_SIZE (a resize scales the
 * type too), BACKGROUND, IMAGE, IMAGE_SOURCE
 * and VIDEO_SOURCE (where a replacement may come from), VIDEO, POSITION, SIZE: a layer's; SIZES (adding or removing
 * sizes), BACKGROUND: the design's; STRUCTURE: the changes no lock covers, refused to a Content editor on a design
 * whose author locked something.
 */
export enum DesignLock {
  BACKGROUND = 'BACKGROUND',
  COLOR = 'COLOR',
  FONT_SIZE = 'FONT_SIZE',
  IMAGE = 'IMAGE',
  IMAGE_SOURCE = 'IMAGE_SOURCE',
  POSITION = 'POSITION',
  SIZE = 'SIZE',
  SIZES = 'SIZES',
  STRUCTURE = 'STRUCTURE',
  TEXT = 'TEXT',
  TEXT_LENGTH = 'TEXT_LENGTH',
  VIDEO = 'VIDEO',
  VIDEO_SOURCE = 'VIDEO_SOURCE'
}

/** The master state a variation was last synced with (variation top rows only). */
export type DesignMasterSyncState = {
  __typename?: 'DesignMasterSyncState';
  /** Master per-size checksums at variation creation / last sync. */
  perSize: Array<DesignSyncPerSizeChecksum>;
  /** When the variation was created or last synced with the master. */
  syncedAt: Scalars['Date']['output'];
};

/** A folder in a design's media library. */
export type DesignMediaFolder = {
  __typename?: 'DesignMediaFolder';
  /** ID of the folder. */
  id: Scalars['Int']['output'];
  /** Number of media items directly inside this folder (not counting subfolders). */
  mediaCount: Scalars['Int']['output'];
  /** Name of the folder. */
  name: Scalars['String']['output'];
  /** Parent folder id; null for folders at the library root. */
  parentId?: Maybe<Scalars['Int']['output']>;
};

/** One screen of the import browser. */
export type DesignMediaImportBrowseResult = {
  __typename?: 'DesignMediaImportBrowseResult';
  /** Design rows for this screen. */
  designs: Array<DesignMediaImportDesign>;
  /** Folder rows for this screen. */
  folders: Array<DesignMediaImportFolder>;
  /** Breadcrumb of folderId (its ancestors and itself), root-first; empty at the project root and while searching. */
  path: Array<DesignMediaImportPathItem>;
  /** The resolved project id (needed when the input omitted projectId). */
  projectId: Scalars['Int']['output'];
};

/** A design row in the import browser. */
export type DesignMediaImportDesign = {
  __typename?: 'DesignMediaImportDesign';
  /** Hash of the design. */
  hash: Scalars['String']['output'];
  /** ID of the design. */
  id: Scalars['Int']['output'];
  /** Whether a preview image has been generated for this design yet. */
  imageGenerated: Scalars['Boolean']['output'];
  /** Name of the design. */
  name: Scalars['String']['output'];
  /** Hash to render the design preview from; the design's own hash unless it is a set. */
  thumbHash: Scalars['String']['output'];
  /** When the design was last modified. */
  updatedAt: Scalars['Date']['output'];
};

/** A folder row in the import browser. */
export type DesignMediaImportFolder = {
  __typename?: 'DesignMediaImportFolder';
  /** Number of direct child designs. */
  designCount: Scalars['Int']['output'];
  /** Number of direct child folders. */
  folderCount: Scalars['Int']['output'];
  /** ID of the folder. */
  id: Scalars['Int']['output'];
  /** Name of the folder. */
  name: Scalars['String']['output'];
};

/** A breadcrumb ancestor of the browsed folder. */
export type DesignMediaImportPathItem = {
  __typename?: 'DesignMediaImportPathItem';
  /** ID of the folder. */
  id: Scalars['Int']['output'];
  /** Name of the folder. */
  name: Scalars['String']['output'];
};

/** Paginated result of a design's media library. */
export type DesignMediaLibraryResult = {
  __typename?: 'DesignMediaLibraryResult';
  /** Media assets in the design's library matching the query. */
  items: Array<Media>;
  /** Total count of media assets in the design's library matching the query (ignores limit/offset). */
  total: Scalars['Int']['output'];
};

/**
 * How an asset entered the library.
 *
 * AI_GENERATED is DERIVED — an AI Studio generation link, or embedded
 * provenance metadata — so it always agrees with the card's AI badge. The other
 * two read the stored provenance column. An uploaded AI image therefore matches
 * both UPLOAD and AI_GENERATED: it is both, and the buckets are deliberately not
 * exclusive.
 *
 * Assets whose provenance was never recorded match no value here and are
 * reachable only by omitting the filter.
 */
export enum DesignMediaSource {
  AI_GENERATED = 'AI_GENERATED',
  IMPORTED_FROM_DESIGN = 'IMPORTED_FROM_DESIGN',
  UPLOAD = 'UPLOAD'
}

/** How the user started a design. DesignCreationSource is the surface that made it. */
export enum DesignOrigin {
  /** An empty canvas: Start from scratch, Create new, a dashboard size. */
  BLANK = 'blank',
  /** A copy of one of the user's designs. */
  DUPLICATE = 'duplicate',
  /** Created by the Home page chat, which already holds the user's request. */
  HOME_CHAT = 'home_chat',
  /** Created by the start-from-assets picker, which already holds the user's request. */
  START_FROM_ASSETS = 'start_from_assets',
  /** Picked from a template. */
  TEMPLATE = 'template'
}

/** Defines the position of a design on the page. */
export enum DesignPosition {
  /** Positioned at the bottom. */
  BOTTOM = 'bottom',
  /** Takes up the full screen. */
  FULLSCREEN = 'fullscreen',
  /** No specific positioning. */
  NONE = 'none',
  /** Positioned at the top. */
  TOP = 'top'
}

/** Information about a project logo. */
export type DesignProjectLogoResult = {
  __typename?: 'DesignProjectLogoResult';
  /** Theme color of the project. */
  color?: Maybe<Scalars['String']['output']>;
  /** Height of the logo in pixels. */
  height?: Maybe<Scalars['Int']['output']>;
  /** ID of the project. */
  id: Scalars['Int']['output'];
  /** Logo URL of the project. */
  logo?: Maybe<Scalars['String']['output']>;
  /** Name of the project. */
  name: Scalars['String']['output'];
  /** Width of the logo in pixels. */
  width?: Maybe<Scalars['Int']['output']>;
};

/** A renderable design the eval can target. `hash` always renders (never a non-renderable design-SET hash). */
export type DesignRenderTarget = {
  __typename?: 'DesignRenderTarget';
  /** True when the design (or its parent set) has a brand kit attached. */
  hasBrandKit: Scalars['Boolean']['output'];
  hash: Scalars['String']['output'];
  /** Human label for the picker, e.g. 1080 x 1080. */
  label: Scalars['String']['output'];
};

export type DesignResizeStatus = {
  __typename?: 'DesignResizeStatus';
  hash: Scalars['String']['output'];
  percent?: Maybe<Scalars['Float']['output']>;
};

/** A dedicated reviewer assigned to a design. */
export type DesignReviewer = {
  __typename?: 'DesignReviewer';
  /** The user who added this reviewer. */
  addedBy: User;
  /** When the reviewer was assigned. */
  createdAt: Scalars['Date']['output'];
  /** The design ID. */
  designId: Scalars['Int']['output'];
  /** Unique identifier. */
  id: Scalars['Int']['output'];
  /** Optional message from the editor to the reviewer. */
  message?: Maybe<Scalars['String']['output']>;
  /** The reviewer user. */
  user: User;
  /** The reviewer's user ID. */
  userId: Scalars['Int']['output'];
};

/**
 * The tiers this surface may persist a judgment about.
 *
 * Deliberately NOT the shared ResizeRankingCategory, which also has IMAGE. The check has to
 * live in the SDL rather than the resolver: @admin writes the whole mutation input into
 * admin_log.info BEFORE invoking the resolver, so a resolver-side refusal returns an error
 * only after the vision model's notes and finding types are already in the audit store.
 * GraphQL rejects an out-of-enum value during variable coercion, which is earlier than that.
 */
export enum DesignSampleGradedTier {
  HTML = 'HTML',
  JSON = 'JSON'
}

export enum DesignSampleRejectReason {
  BROKEN_DESIGN = 'BROKEN_DESIGN',
  DUPLICATE = 'DUPLICATE',
  LOW_QUALITY_CONTENT = 'LOW_QUALITY_CONTENT',
  MISLEADING_CONVERSION = 'MISLEADING_CONVERSION',
  OFF_BRAND = 'OFF_BRAND',
  OTHER = 'OTHER',
  POOR_LAYOUT = 'POOR_LAYOUT'
}

/** Which retrieval the match panel simulates. */
export enum DesignSampleRetrieval {
  /** The top matches grouped by the layout their conversion produced, as the v11 resize lane's cards take them. */
  OUTCOME = 'OUTCOME',
  /** The default order, paged: what a resize run grounds on without a layout family. */
  REGULAR = 'REGULAR'
}

/** The persisted review workflow: every processed sample starts in NEEDS_REVIEW; the last admin action moves it. */
export enum DesignSampleReviewStatus {
  APPROVED = 'APPROVED',
  BOOSTED = 'BOOSTED',
  NEEDS_REVIEW = 'NEEDS_REVIEW',
  REJECTED = 'REJECTED'
}

export enum DesignSampleSortField {
  CREATED_AT = 'CREATED_AT',
  CURATION_SCORE = 'CURATION_SCORE',
  /** The review queue first: NEEDS_REVIEW, APPROVED, BOOSTED, REJECTED. */
  REVIEW_STATUS = 'REVIEW_STATUS',
  UPDATED_AT = 'UPDATED_AT'
}

export enum DesignSampleSortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export enum DesignSampleSourceType {
  CUSTOMER = 'CUSTOMER',
  TEMPLATE = 'TEMPLATE'
}

/** An orientation a design can be — either side of a conversion. */
export enum DesignSampleTransition {
  HORIZONTAL = 'HORIZONTAL',
  SQUARE = 'SQUARE',
  VERTICAL = 'VERTICAL'
}

/**
 * Which DIRECTED conversion a listed sample must be able to demonstrate.
 *
 * The three deprecated members are the filter as it was when every conversion
 * left a square, so each names one unambiguously. They are kept because the
 * admin is a single-page app: a curator whose bundle was loaded before the
 * deploy keeps sending them, and an enum member that no longer exists is
 * refused by GraphQL VALIDATION — before any resolver could translate it — so
 * their filtered queue would simply stop loading until they happened to
 * refresh.
 */
export enum DesignSampleTransitionFilter {
  ANY = 'ANY',
  /** @deprecated Requires BOTH of the square's conversions; no single directed value means that, and ANY is broader. Kept for links saved before the filter became directed. */
  BOTH = 'BOTH',
  /** @deprecated Named the destination only; use SQUARE_TO_HORIZONTAL. */
  HORIZONTAL = 'HORIZONTAL',
  HORIZONTAL_TO_SQUARE = 'HORIZONTAL_TO_SQUARE',
  HORIZONTAL_TO_VERTICAL = 'HORIZONTAL_TO_VERTICAL',
  SQUARE_TO_HORIZONTAL = 'SQUARE_TO_HORIZONTAL',
  SQUARE_TO_VERTICAL = 'SQUARE_TO_VERTICAL',
  /** @deprecated Named the destination only; use SQUARE_TO_VERTICAL. */
  VERTICAL = 'VERTICAL',
  VERTICAL_TO_HORIZONTAL = 'VERTICAL_TO_HORIZONTAL',
  VERTICAL_TO_SQUARE = 'VERTICAL_TO_SQUARE'
}

export enum DesignScorerAgreement {
  AGREE = 'AGREE',
  DISAGREE = 'DISAGREE',
  NOT_COMPARABLE = 'NOT_COMPARABLE'
}

export enum DesignScorerFindingVerdict {
  NOT_REAL = 'NOT_REAL',
  REAL = 'REAL',
  UNCLEAR = 'UNCLEAR'
}

/**
 * What the layered engine's Opus review said about the element a finding names, on the same pass. BLOCKED means it
 * asked for a change; whether one applied is not recorded (a sketch layout drops position-only corrections).
 */
export enum DesignScorerOpusOutcome {
  BLOCKED = 'BLOCKED',
  KEPT = 'KEPT',
  /** The surface has no review to compare with (the design check). */
  NONE = 'NONE',
  SKIPPED = 'SKIPPED'
}

/** What the layered engine's Opus review said about a whole pass. */
export enum DesignScorerOpusVerdict {
  NONE = 'NONE',
  PASS = 'PASS',
  REVISE = 'REVISE',
  SKIPPED = 'SKIPPED'
}

/** Whose findings the review page labels. */
export enum DesignScorerReviewSurface {
  /** The new Ad Studio's design check (canvas.live): Core's deterministic findings, each reading on its own. */
  CANVAS_LIVE = 'CANVAS_LIVE',
  /** The layered engine's review passes (aiAgent.layered), beside the Opus review. */
  LAYERED = 'LAYERED'
}

/** The design scorer's verdict. NOT_MEASURED: it measured nothing, which is never shown as a pass. */
export enum DesignScorerVerdict {
  BORDERLINE = 'BORDERLINE',
  FAIL = 'FAIL',
  NOT_MEASURED = 'NOT_MEASURED',
  PASS = 'PASS'
}

/** Response payload for design set details query. */
export type DesignSetDetailsPayload = {
  __typename?: 'DesignSetDetailsPayload';
  /** Unique hash identifier for the design set. */
  hash: Scalars['String']['output'];
  /** Unique ID for the design set. */
  id: Scalars['Int']['output'];
  /** Display name of the design set. */
  name: Scalars['String']['output'];
  /** Type of the design set (STATIC, ANIMATED, VIDEO). */
  type: DesignSizeTypeTypes;
};

/** Response payload for design set templates query. */
export type DesignSetTemplatesPayload = {
  __typename?: 'DesignSetTemplatesPayload';
  /** List of template categories with their templates. */
  templates: Array<TemplateCategory>;
};

export type DesignSize = {
  __typename?: 'DesignSize';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  size: Scalars['String']['output'];
};

export type DesignSizeInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  size: Scalars['String']['input'];
};

export type DesignSizeType = {
  __typename?: 'DesignSizeType';
  animated?: Maybe<Scalars['Boolean']['output']>;
  category?: Maybe<DesignSizeTypeCategory>;
  countDesignSizeTypesInSet?: Maybe<Scalars['Int']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  designSizeTypesInSet?: Maybe<Array<DesignSizeType>>;
  height?: Maybe<Scalars['Float']['output']>;
  heightInPx?: Maybe<Scalars['Float']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  kind: DesignSizeTypeKind;
  measureUnit?: Maybe<MeasureUnit>;
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  static?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  variation?: Maybe<Scalars['String']['output']>;
  video?: Maybe<Scalars['Boolean']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  widthInPx?: Maybe<Scalars['Float']['output']>;
};

export enum DesignSizeTypeCategory {
  DIGITAL = 'digital',
  DISPLAY = 'display',
  PRINT = 'print',
  SOCIAL = 'social'
}

export enum DesignSizeTypeKind {
  CUSTOM_DESIGN = 'custom_design',
  CUSTOM_SET = 'custom_set',
  SYSTEM_DESIGN = 'system_design',
  SYSTEM_SET = 'system_set'
}

export enum DesignSizeTypeSetCategory {
  DISPLAY = 'display',
  SOCIAL_CAMPAIGN = 'social_campaign',
  SOCIAL_POST = 'social_post',
  VIDEO = 'video'
}

/**
 * Types of design size types.
 * Categorizes templates by content type.
 */
export enum DesignSizeTypeTypes {
  /** Templates with animations but no video */
  ANIMATED = 'ANIMATED',
  /** Templates with neither animation nor video */
  STATIC = 'STATIC',
  /** Templates with video content */
  VIDEO = 'VIDEO'
}

/** Metadata of the master's sizes baseline snapshot (master top rows only). */
export type DesignSizesSyncBaseline = {
  __typename?: 'DesignSizesSyncBaseline';
  /** When the snapshot was captured. */
  capturedAt: Scalars['Date']['output'];
  /** Per-size checksums at snapshot time — sizes whose current checksum differs have unsynced edits. */
  perSize: Array<DesignSyncPerSizeChecksum>;
};

/** Settings for how a design sticks to the page. */
export type DesignStickSettingsType = {
  __typename?: 'DesignStickSettingsType';
  /** Time in seconds before the design appears (if displayOption is DELAY). */
  appearenceTime?: Maybe<Scalars['Float']['output']>;
  /** Background color for the sticky design. */
  background?: Maybe<Scalars['String']['output']>;
  /** How the design is displayed (e.g., instant, scroll, delay). @BreakingBad */
  displayOption?: Maybe<DisplayMode>;
  /**
   * Indicates if there is a transition. @deprecated Use displayOption instead.
   * @deprecated Use displayOption instead
   */
  transition?: Maybe<Scalars['Boolean']['output']>;
  /** The type of sticking behavior. @BreakingBad */
  type?: Maybe<DesignPosition>;
};

/** Defines how a design sticks to the page. @deprecated Use DesignPosition instead. */
export enum DesignStickType {
  /**
   * Sticks to the bottom. @deprecated Use DesignPosition instead.
   * @deprecated Use DesignPosition instead
   */
  BOTTOM = 'BOTTOM',
  /**
   * Takes up the full screen. @deprecated Use DesignPosition instead.
   * @deprecated Use DesignPosition instead
   */
  FULLSCREEN = 'FULLSCREEN',
  /**
   * No sticking behavior. @deprecated Use DesignPosition instead.
   * @deprecated Use DesignPosition instead
   */
  NONE = 'NONE',
  /**
   * Sticks to the top. @deprecated Use DesignPosition instead.
   * @deprecated Use DesignPosition instead
   */
  TOP = 'TOP'
}

/** One size's content checksum, used by the master↔variation sync feature. */
export type DesignSyncPerSizeChecksum = {
  __typename?: 'DesignSyncPerSizeChecksum';
  /** The size row's content checksum (md5 of its banner JSON) at capture time. */
  checksum: Scalars['String']['output'];
  /** The design_size_type the checksum belongs to. */
  designSizeTypeId: Scalars['Int']['output'];
};

/** Template category information for design interface. */
export type DesignTemplateCategoryItemPayload = {
  __typename?: 'DesignTemplateCategoryItemPayload';
  /** Unique ID for the category. */
  id: Scalars['Int']['output'];
  /** Machine-readable identifier for the category. */
  identifier: Scalars['String']['output'];
  /** Display name of the category. */
  name: Scalars['String']['output'];
  /** Whether the category is visible in the app. */
  showInApp: Scalars['Boolean']['output'];
  /** Whether the category is visible in the gallery. */
  showInGallery: Scalars['Boolean']['output'];
};

/** Response payload for design template categories query. */
export type DesignTemplateCategoryPayload = {
  __typename?: 'DesignTemplateCategoryPayload';
  /** List of template categories. */
  categories: Array<DesignTemplateCategoryItemPayload>;
};

/** Template tag information for design interface. */
export type DesignTemplateTagItemPayload = {
  __typename?: 'DesignTemplateTagItemPayload';
  /** Unique ID for the tag. */
  id: Scalars['Int']['output'];
  /** Whether this tag represents a color. */
  isColor: Scalars['Boolean']['output'];
  /** Whether this tag represents a style. */
  isStyle: Scalars['Boolean']['output'];
  /** Display name of the tag. */
  name: Scalars['String']['output'];
  /** Whether the tag is visible in the app. */
  showInApp: Scalars['Boolean']['output'];
  /** Whether the tag is visible in the gallery. */
  showInGallery: Scalars['Boolean']['output'];
};

/** Response payload for design template tags query. */
export type DesignTemplateTagPayload = {
  __typename?: 'DesignTemplateTagPayload';
  /** List of template tags. */
  tags: Array<DesignTemplateTagItemPayload>;
};

/** Response payload for design templates count query. */
export type DesignTemplatesCountPayload = {
  __typename?: 'DesignTemplatesCountPayload';
  /** Template count by type. */
  result: TemplatesTypeCount;
};

/** Response payload for design templates query. */
export type DesignTemplatesPayload = {
  __typename?: 'DesignTemplatesPayload';
  /** List of templates matching the query criteria. */
  templates: Array<Maybe<TemplateType>>;
};

/** Types of designs in Creatopy. */
export enum DesignType {
  /** A reusable design component. */
  COMPONENT = 'component',
  /** A single design. */
  DESIGN = 'design',
  /** A set of related designs (design set). */
  SET = 'set'
}

export type DesignUsage = {
  __typename?: 'DesignUsage';
  abTestId?: Maybe<Scalars['Int']['output']>;
  amountClicks: Scalars['Int']['output'];
  amountViews: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  networkId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/**
 * Kind of design variation to create. Defaults to DUPLICATE (copy the master
 * design set as-is). Reserved values are placeholders for future variation
 * kinds and are not yet implemented.
 */
export enum DesignVariationType {
  /** Reserved: variation produced by altering textual content. */
  CONTENT = 'CONTENT',
  /** Copy the master design set structure (all sizes) and link it as a variation. */
  DUPLICATE = 'DUPLICATE',
  /** Reserved: variation localized into another language. */
  LANGUAGE = 'LANGUAGE',
  /** Variation bound to a product catalog / feed — one clone whose sizes render the catalog's current row (CRE-541). */
  PRODUCT_CATALOG = 'PRODUCT_CATALOG'
}

/** A specific version of a design. */
export type DesignVersion = {
  __typename?: 'DesignVersion';
  /** JSON representation of the design at this version. */
  banner?: Maybe<Scalars['JsonDesign']['output']>;
  /** Unique identifier for the version. */
  id: Scalars['String']['output'];
};

/** Information about a version in a design's history. */
export type DesignVersionHistory = {
  __typename?: 'DesignVersionHistory';
  /** Unique identifier for the version. */
  id: Scalars['String']['output'];
  /** Timestamp when this version was created. */
  lastModified: Scalars['String']['output'];
  /** Name of the user who created this version. */
  lastModifiedByName?: Maybe<Scalars['String']['output']>;
  /** Profile picture URL of the user who created this version. */
  lastModifiedByProfilePicture?: Maybe<Scalars['String']['output']>;
  /** The save this version came from, when it was made with one: versions sharing it are one save across a family. */
  saveId?: Maybe<Scalars['String']['output']>;
  /** Hash that identifies this version's size. */
  sizeHash: Scalars['String']['output'];
  /** Custom name for this version (if set). */
  versionName?: Maybe<Scalars['String']['output']>;
};

export type DesignWithIsCached = {
  __typename?: 'DesignWithIsCached';
  id: Scalars['Int']['output'];
  isCached: Scalars['Boolean']['output'];
};

/** Result for `designsAdTagAnalytics` — one entry per requested, accessible hash. */
export type DesignsAdTagAnalyticsResult = {
  __typename?: 'DesignsAdTagAnalyticsResult';
  /** Analytics entries, one per resolvable design hash. */
  entries: Array<DesignAdTagAnalyticsEntry>;
};

/** Result containing designs retrieved by hashes. */
export type DesignsByHashResult = {
  __typename?: 'DesignsByHashResult';
  /** List of retrieved designs. */
  designs: Array<Design>;
};

/** Input for retrieving designs by their hashes. */
export type DesignsByHashes = {
  /** Array of design hashes to retrieve. */
  hashes: Array<Scalars['String']['input']>;
};

export type DesignsComponentsResult = PaginationResults & {
  __typename?: 'DesignsComponentsResult';
  nodes: Array<DesignComponent>;
  pageInfo: PageInfo;
  /** Total designs count for current filters, not implemented */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Response containing duration information for designs. */
export type DesignsDurationPayload = {
  __typename?: 'DesignsDurationPayload';
  /** List of design durations. */
  result?: Maybe<Array<Maybe<HashDesignDuration>>>;
};

export type DesignsFeedPropertyBinding = {
  __typename?: 'DesignsFeedPropertyBinding';
  column?: Maybe<Scalars['String']['output']>;
  designHash: Scalars['String']['output'];
};

export type DesignsFeedUrlBinding = {
  __typename?: 'DesignsFeedUrlBinding';
  column?: Maybe<Scalars['String']['output']>;
  designHash: Scalars['String']['output'];
};

/** Paginated results of designs. */
export type DesignsResult = PaginationResults & {
  __typename?: 'DesignsResult';
  /** List of designs for the current page. */
  nodes: Array<Design>;
  /** Pagination information. */
  pageInfo: PageInfo;
  /** Total designs count for current filters, not implemented */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** @deprecated not used */
export enum DesiredResolution {
  HD = 'HD',
  NHD = 'NHD',
  ORIGINAL = 'ORIGINAL',
  SVGA = 'SVGA',
  UHD = 'UHD',
  UWFHD = 'UWFHD',
  UWGHD = 'UWGHD',
  WQXGA = 'WQXGA',
  WUXGA = 'WUXGA',
  XGA = 'XGA'
}

export type Detailed = {
  __typename?: 'Detailed';
  /** Balance after the feed/credits/coupons has been applied */
  balance?: Maybe<Scalars['Float']['output']>;
  balanceAvailableForNextPayment: Scalars['Float']['output'];
  /** Credits applied on the account in Recurly */
  credits?: Maybe<CreditType>;
  /** Discount applied from a coupon */
  discount?: Maybe<Scalars['Float']['output']>;
  items?: Maybe<Array<Maybe<Item>>>;
  /** Subtotal amount without any fees/credits/coupons */
  subtotal?: Maybe<Scalars['Float']['output']>;
};

export type DetectChatIntentInput = {
  assets?: InputMaybe<Array<ChatAssetInput>>;
  chatId?: InputMaybe<Scalars['Int']['input']>;
  mediaType?: InputMaybe<AdFormatType>;
  prompt: Scalars['String']['input'];
};

export type DetectChatIntentPayload = {
  __typename?: 'DetectChatIntentPayload';
  aspectRatio?: Maybe<Scalars['String']['output']>;
  channel?: Maybe<Array<ChannelType>>;
  duration?: Maybe<Scalars['Int']['output']>;
  mediaType?: Maybe<AdFormatType>;
  mode?: Maybe<VideoGenerationMode>;
  model?: Maybe<AiProvider>;
  objective?: Maybe<ObjectiveType>;
  resolution?: Maybe<Scalars['String']['output']>;
  soundOn?: Maybe<Scalars['Boolean']['output']>;
  ugcIntent?: Maybe<UgcIntent>;
  variants?: Maybe<Scalars['Int']['output']>;
};

export type DetectedLanguage = {
  __typename?: 'DetectedLanguage';
  detectedLanguageCode: Scalars['LanguageCodesType']['output'];
};

export type DiscountSubscriptionPayload = {
  __typename?: 'DiscountSubscriptionPayload';
  result: Scalars['Boolean']['output'];
};

export type DiscoverVeevaResponse = {
  __typename?: 'DiscoverVeevaResponse';
  authProfiles?: Maybe<Array<AuthProfileOption>>;
  authType?: Maybe<Scalars['String']['output']>;
  authUrl?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  tenantId?: Maybe<Scalars['String']['output']>;
};

/** Response when updating the brand kit wizard display setting. */
export type DisplayBrandKitWizardPayload = {
  __typename?: 'DisplayBrandKitWizardPayload';
  /** Whether the brand kit wizard should be displayed. */
  brandkitWizard: Scalars['Boolean']['output'];
};

/** Defines how an ad is displayed. */
export enum DisplayMode {
  /** Displays after a specified delay. */
  DELAY = 'delay',
  /** Displays instantly. */
  INSTANT = 'instant',
  /** Displays when scrolled into view. */
  SCROLL = 'scroll'
}

/** Options for how an ad is displayed. @deprecated Use DisplayMode instead. */
export enum DisplayOption {
  /**
   * Displays after a delay. @deprecated Use DisplayMode instead.
   * @deprecated Use DisplayMode instead
   */
  DELAY = 'DELAY',
  /**
   * Displays instantly. @deprecated Use DisplayMode instead.
   * @deprecated Use DisplayMode instead
   */
  INSTANT = 'INSTANT',
  /**
   * Displays on scroll. @deprecated Use DisplayMode instead.
   * @deprecated Use DisplayMode instead
   */
  SCROLL = 'SCROLL'
}

export enum DitherAlgorithm {
  BAYER = 'BAYER',
  FLOYD_STEINBERG = 'FLOYD_STEINBERG'
}

/** Slim team record returned by the domain-owner lookup. */
export type DomainTeam = {
  __typename?: 'DomainTeam';
  id: Scalars['Int']['output'];
  /** Team logo asset key (used to build a logo URL on the client). Null when the team has no logo. */
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Masked owner email for display in domain-team onboarding. The domain remains visible. */
  ownerEmail: Scalars['String']['output'];
  /** Masked owner name for display in domain-team onboarding. */
  ownerName: Scalars['String']['output'];
  /** Invitation request status when the current user has asked to join this team. */
  requestStatus?: Maybe<TeamInvitationStatus>;
};

export type Download = {
  __typename?: 'Download';
  aemUploadError?: Maybe<Scalars['String']['output']>;
  aemUploadedPath?: Maybe<Scalars['String']['output']>;
  /** The team's default Cloudinary folder; empty for the account's root. */
  cloudinaryFolder?: Maybe<Scalars['String']['output']>;
  /** That folder in Cloudinary's console, once something was saved. */
  cloudinaryFolderUrl?: Maybe<Scalars['String']['output']>;
  /** Why the Cloudinary save stopped (not_connected, reconnect, forbidden...), or files_failed when only some files failed. */
  cloudinaryUploadError?: Maybe<Scalars['String']['output']>;
  /** One per exported file sent to Cloudinary. */
  cloudinaryUploads?: Maybe<Array<CloudinaryExportUpload>>;
  email?: Maybe<Scalars['String']['output']>;
  googleDriveUploadError?: Maybe<Scalars['String']['output']>;
  googleDriveWebViewLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  progress?: Maybe<Scalars['Float']['output']>;
  saveToAem?: Maybe<Scalars['Boolean']['output']>;
  saveToCloudinary?: Maybe<Scalars['Boolean']['output']>;
  saveToGoogleDrive?: Maybe<Scalars['Boolean']['output']>;
  saveToSharePoint?: Maybe<Scalars['Boolean']['output']>;
  sendViaEmail: Scalars['Boolean']['output'];
  sharePointUploadError?: Maybe<Scalars['String']['output']>;
  sharePointWebUrl?: Maybe<Scalars['String']['output']>;
  status: ExportStatus;
  statusMessage: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: DownloadType;
  url: Scalars['String']['output'];
};

export type DownloadAiAgentAutomatedReportPayload = {
  __typename?: 'DownloadAiAgentAutomatedReportPayload';
  reportHtml: Scalars['String']['output'];
  reportName: Scalars['String']['output'];
};

export type DownloadAiAgentReportPayload = {
  __typename?: 'DownloadAiAgentReportPayload';
  reportName: Scalars['String']['output'];
  reportPdf: Scalars['String']['output'];
};

export type DownloadAudioUrl = {
  __typename?: 'DownloadAudioUrl';
  url?: Maybe<Scalars['String']['output']>;
};

export type DownloadCacheStatus = {
  __typename?: 'DownloadCacheStatus';
  isCached: Scalars['Boolean']['output'];
};

export type DownloadCancel = {
  __typename?: 'DownloadCancel';
  result: Scalars['Boolean']['output'];
};

export type DownloadCancelAll = {
  __typename?: 'DownloadCancelAll';
  result: Scalars['Boolean']['output'];
};

export type DownloadCreditsUsage = {
  __typename?: 'DownloadCreditsUsage';
  remaining: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  used: Scalars['Int']['output'];
};

/** Information about download settings for shared links. */
export type DownloadEnabled = {
  __typename?: 'DownloadEnabled';
  /** Whether downloads are enabled. */
  enabled: Scalars['Boolean']['output'];
  /** Whether the team has access to control this setting. */
  hasAccess: Scalars['Boolean']['output'];
};

/** Response containing download settings for shared links. */
export type DownloadEnabledShareLinkPayload = {
  __typename?: 'DownloadEnabledShareLinkPayload';
  /** Download settings for shared links. */
  result: DownloadEnabled;
};

export type DownloadFeedInterval = {
  __typename?: 'DownloadFeedInterval';
  /** @deprecated Use range instead */
  end?: Maybe<Scalars['Int']['output']>;
  /** The returned range is in dense positions within the design's current product set. */
  productSetOrdinals?: Maybe<Scalars['Boolean']['output']>;
  range?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use range instead */
  start?: Maybe<Scalars['Int']['output']>;
  targetColumn?: Maybe<Scalars['String']['output']>;
};

export type DownloadIntegrationFileResult = {
  __typename?: 'DownloadIntegrationFileResult';
  fileBase64?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type DownloadInvoicePayload = {
  __typename?: 'DownloadInvoicePayload';
  downloadUrl: Scalars['String']['output'];
};

/** @deprecated use InputDesignPresetV2 instead */
export type DownloadPreset = {
  __typename?: 'DownloadPreset';
  limitFilename: Scalars['Boolean']['output'];
  preset: Scalars['String']['output'];
};

export type DownloadPresetV2 = {
  __typename?: 'DownloadPresetV2';
  delimiter: Scalars['String']['output'];
  limitFilename: Scalars['Boolean']['output'];
  preset: Scalars['String']['output'];
};

export type DownloadSettings = {
  colorProfile?: InputMaybe<Scalars['String']['input']>;
  convertCustomFonts: Scalars['Boolean']['input'];
  imageQuality: Scalars['Int']['input'];
  minifyHtml?: InputMaybe<Scalars['Boolean']['input']>;
  retina: Scalars['Boolean']['input'];
  retinaOnly: Scalars['Boolean']['input'];
  target: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  useAsClickTag: Scalars['Boolean']['input'];
};

export type DownloadStatus = {
  __typename?: 'DownloadStatus';
  progress: Scalars['Float']['output'];
  status: ExportStatus;
  statusMessage?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum DownloadType {
  AD_TAG_HTML5 = 'AD_TAG_HTML5',
  AMP = 'AMP',
  GIF = 'GIF',
  GIF_OPTIMIZED = 'GIF_OPTIMIZED',
  GIF_STATIC = 'GIF_STATIC',
  HTML = 'HTML',
  HTML_CUSTOM_NETWORK = 'HTML_CUSTOM_NETWORK',
  HTML_NEXT = 'HTML_NEXT',
  JPG = 'JPG',
  MP4 = 'MP4',
  PDF = 'PDF',
  PDF_PRINT = 'PDF_PRINT',
  PNG = 'PNG',
  PSD = 'PSD',
  WEBP = 'WEBP'
}

export type DownloadViaEmail = {
  __typename?: 'DownloadViaEmail';
  result: Scalars['Boolean']['output'];
};

export type DownloadZipResultPayload = {
  __typename?: 'DownloadZipResultPayload';
  result: Scalars['Boolean']['output'];
};

export type DpaErrors = {
  __typename?: 'DpaErrors';
  key: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export enum DpaPlatformType {
  CM360 = 'cm360',
  DV360 = 'dv360',
  FACEBOOK = 'facebook',
  GOOGLE_ADS = 'google_ads',
  INSTAGRAM = 'instagram',
  LINKEDIN = 'linkedin',
  NONE = 'none',
  PINTEREST = 'pinterest',
  PINTEREST_URL = 'pinterest_url',
  SNAPCHAT = 'snapchat',
  TIKTOK = 'tiktok',
  /** TikTok URL-catalog mode: the generated feed CSV with no TikTok catalog behind it (tiktok = the DPA mode, a catalog in the advertiser's Business Center) */
  TIKTOK_URL = 'tiktok_url',
  TWITTER = 'twitter'
}

export type DpaSettings = {
  __typename?: 'DpaSettings';
  accountId?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  adAccountId?: Maybe<Scalars['String']['output']>;
  businessId?: Maybe<Scalars['String']['output']>;
  campaignId?: Maybe<Scalars['String']['output']>;
  catalogId?: Maybe<Scalars['String']['output']>;
  catalogPublishMode?: Maybe<CatalogPublishMode>;
  checksum?: Maybe<Scalars['String']['output']>;
  designHash?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  fbCsvUrl?: Maybe<Scalars['String']['output']>;
  includeVideos?: Maybe<Scalars['Boolean']['output']>;
  jobId?: Maybe<Scalars['String']['output']>;
  pageId?: Maybe<Scalars['String']['output']>;
  setBy?: Maybe<Scalars['Int']['output']>;
  supplementary?: Maybe<Scalars['Boolean']['output']>;
  syncStatus?: Maybe<DpaSyncStatus>;
  /** The placement-tags choice the last catalog publish saved; null when none was saved. */
  tagImagesForPlacements?: Maybe<Scalars['Boolean']['output']>;
  teamId?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<DpaPlatformType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum DpaSyncStatus {
  ERROR = 'error',
  SYNCED = 'synced',
  SYNCING = 'syncing',
  UNSYNCED = 'unsynced'
}

/** An AI-drafted column suggestion (CRE-424) — editable in the wizard before creation */
export type DraftedCatalogColumn = {
  __typename?: 'DraftedCatalogColumn';
  name: Scalars['String']['output'];
  type: FeedColumnType;
};

export type DuplicateBrandTemplateFolderPayload = {
  __typename?: 'DuplicateBrandTemplateFolderPayload';
  duplicating?: Maybe<Scalars['Boolean']['output']>;
  folder: Folder;
};

/** Response after duplicating a design. */
export type DuplicateDesignPayload = {
  __typename?: 'DuplicateDesignPayload';
  /** The duplicated design. */
  design: Design;
};

export type DuplicateDesignsPayload = {
  __typename?: 'DuplicateDesignsPayload';
  result: Scalars['Boolean']['output'];
};

export type DuplicateFolderPayload = {
  __typename?: 'DuplicateFolderPayload';
  duplicating?: Maybe<Scalars['Boolean']['output']>;
  folder: Folder;
};

export type DuplicateReportPayload = {
  __typename?: 'DuplicateReportPayload';
  result: AdTagReportResult;
};

export type EditDesignResult = {
  __typename?: 'EditDesignResult';
  changes: Array<DesignChangeResult>;
  hash: Scalars['String']['output'];
  /** The caller's open editor tab steps aside for this edit: it reloads to show it. */
  openEditorRefreshes: Scalars['Boolean']['output'];
};

export type EditorSettings = {
  __typename?: 'EditorSettings';
  actionsOpen?: Maybe<Scalars['Boolean']['output']>;
  adServingPopupDismissedAt?: Maybe<Scalars['Int']['output']>;
  /**
   * The new Ad Studio's AI Assistant dock, as the user last left it: open or closed. Null until they
   * first close or open it there; the dock is open on arrival while it is null.
   */
  adStudioAssistantOpen?: Maybe<Scalars['Boolean']['output']>;
  adStudioEnabled?: Maybe<Scalars['Boolean']['output']>;
  adStudioReminderDismissDate?: Maybe<Scalars['Int']['output']>;
  adStudioReminderEnabled?: Maybe<Scalars['Boolean']['output']>;
  adStudioSwitchBackBannerDismissed?: Maybe<Scalars['Boolean']['output']>;
  aiEmailNotificationsEnabled?: Maybe<Scalars['Boolean']['output']>;
  aiImageOpen?: Maybe<Scalars['Boolean']['output']>;
  aiResizeModelId?: Maybe<Scalars['Int']['output']>;
  autoZoomInFocusMode?: Maybe<Scalars['Boolean']['output']>;
  backgroundOpen?: Maybe<Scalars['Boolean']['output']>;
  backgroundRemoverOpen?: Maybe<Scalars['Boolean']['output']>;
  brandKitComponentsNotification?: Maybe<Scalars['Boolean']['output']>;
  brandKitEmptyComponents?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The user said they don't need a brand kit ("go without" when the Ad Studio Copilot asked about an
   * empty one): the Copilot stops asking them to set one up and the Home brand kit card hides. False
   * until they say so.
   */
  brandKitSetupDeclined?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The brand kits whose signup website scan the user took as their brand (Yes, Use it as is or Upload, under
   * the Ad Studio Copilot's "I found your brand on acme.com. Use it for your designs?"): the Copilot stops asking.
   */
  confirmedScanBrandKitIds?: Maybe<Array<Scalars['Int']['output']>>;
  cropOpen?: Maybe<Scalars['Boolean']['output']>;
  effectsOpen?: Maybe<Scalars['Boolean']['output']>;
  emptyFolderInfo?: Maybe<Scalars['Boolean']['output']>;
  enterSingleEditOnZoom?: Maybe<Scalars['Boolean']['output']>;
  favoriteFonts?: Maybe<Array<Scalars['String']['output']>>;
  firstTimeInteractionWithNewDesign?: Maybe<Scalars['Boolean']['output']>;
  genStudioExploreDialog?: Maybe<Scalars['Boolean']['output']>;
  guidelinesVisible?: Maybe<Scalars['Boolean']['output']>;
  labelOpen?: Maybe<Scalars['Boolean']['output']>;
  lastVisitedProjectId?: Maybe<Scalars['Int']['output']>;
  layerOpen?: Maybe<Scalars['Boolean']['output']>;
  optionsOpen?: Maybe<Scalars['Boolean']['output']>;
  rulerVisible?: Maybe<Scalars['Boolean']['output']>;
  showMeasurementsEnabled?: Maybe<Scalars['Boolean']['output']>;
  slidesStripVisible?: Maybe<Scalars['Boolean']['output']>;
  snapToObjectsEnabled?: Maybe<Scalars['Boolean']['output']>;
  styleOpen?: Maybe<Scalars['Boolean']['output']>;
  submitFeedback?: Maybe<Scalars['Boolean']['output']>;
  textOpen?: Maybe<Scalars['Boolean']['output']>;
  timelineCollapsed?: Maybe<Scalars['Boolean']['output']>;
  trimOpen?: Maybe<Scalars['Boolean']['output']>;
  wizardSteps?: Maybe<Array<Scalars['String']['output']>>;
  wizardVisible?: Maybe<Scalars['Boolean']['output']>;
};

export enum ElementType {
  ELEMENT = 'ELEMENT',
  SEPARATOR = 'SEPARATOR'
}

export enum ElementTypes {
  FILES = 'FILES',
  FOLDERS = 'FOLDERS'
}

export type EmailPreferences = {
  __typename?: 'EmailPreferences';
  abTestStatus: Scalars['Boolean']['output'];
  blog: Scalars['Boolean']['output'];
  commentMention: Scalars['Boolean']['output'];
  commentResolved: Scalars['Boolean']['output'];
  feedStatus: Scalars['Boolean']['output'];
  insights: Scalars['Boolean']['output'];
  newComments: Scalars['Boolean']['output'];
  newReply: Scalars['Boolean']['output'];
  newsletter: Scalars['Boolean']['output'];
  productUpdates: Scalars['Boolean']['output'];
  promotionsAndOffers: Scalars['Boolean']['output'];
  replySameComment: Scalars['Boolean']['output'];
  surveyAndBeta: Scalars['Boolean']['output'];
};

export type EmailTemplate = {
  __typename?: 'EmailTemplate';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  identifier: Scalars['String']['output'];
  sender: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  tags: Scalars['String']['output'];
};

export type EmbedsProgress = {
  __typename?: 'EmbedsProgress';
  done: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/** Payload for the enableAdServing mutation. */
export type EnableAdServingPayload = {
  __typename?: 'EnableAdServingPayload';
  /**
   * Dynamic variables. @deprecated Not needed anymore. @BreakingBad
   * @deprecated Not needed anymore
   */
  dynamicVars?: Maybe<Array<AdServingDynamicVar>>;
  /**
   * Progress of embeds. @deprecated Not needed anymore. @BreakingBad
   * @deprecated Not needed anymore
   */
  embeds?: Maybe<EmbedsProgress>;
  /**
   * External tracking URLs. @deprecated Not needed anymore. @BreakingBad
   * @deprecated Not needed anymore
   */
  externalTrackingUrls?: Maybe<Array<AdServingExternalTrackingUrl>>;
  /** A list of networks and their synchronization statuses after enabling ad serving. */
  networks: Array<StatusSyncNetwork>;
  /**
   * Indicates if the ad tag is synced. @deprecated Not needed anymore. @BreakingBad
   * @deprecated Not needed anymore
   */
  syncedTag?: Maybe<Scalars['Boolean']['output']>;
};

export type EndSessionPayload = {
  __typename?: 'EndSessionPayload';
  response?: Maybe<Scalars['String']['output']>;
};

export enum EndedType {
  AUTOMATICALLY = 'AUTOMATICALLY',
  MANUALLY = 'MANUALLY',
  SCHEDULED = 'SCHEDULED'
}

/** Input for managing SSO enforcement. */
export type EnforceSso = {
  /** How to enforce SSO (OPTIONAL, ENFORCED, etc.). */
  enforceSso: Scalars['String']['input'];
  /** ID of the team to update. */
  teamId: Scalars['Int']['input'];
};

/** Information about SSO enforcement settings for a team. */
export type EnforceTeamSsoPayload = {
  __typename?: 'EnforceTeamSsoPayload';
  /** How SSO is enforced (OPTIONAL, ENFORCED, etc.). */
  enforceSso?: Maybe<Scalars['String']['output']>;
};

export type EnrollTeamToVariantPayload = {
  __typename?: 'EnrollTeamToVariantPayload';
  invoiceId?: Maybe<Scalars['String']['output']>;
  trialLength?: Maybe<Scalars['Int']['output']>;
};

export enum ErrorCode {
  AB_TESTS_NOT_FOUND = 'AB_TESTS_NOT_FOUND',
  AB_TEST_BELONGS_TO_ANOTHER_PROJECT = 'AB_TEST_BELONGS_TO_ANOTHER_PROJECT',
  AB_TEST_NOT_FOUND = 'AB_TEST_NOT_FOUND',
  ADD_BILLING_INFO_ERROR = 'ADD_BILLING_INFO_ERROR',
  AD_NETWORK_EXISTS = 'AD_NETWORK_EXISTS',
  AD_NETWORK_NOT_FOUND = 'AD_NETWORK_NOT_FOUND',
  AD_NETWORK_NO_ACCESS = 'AD_NETWORK_NO_ACCESS',
  AD_REPORT_NOT_FOUND = 'AD_REPORT_NOT_FOUND',
  AD_TAG_DESIGN_NOT_FOUND_ERROR = 'AD_TAG_DESIGN_NOT_FOUND_ERROR',
  AD_TAG_DYNAMIC_VAR_ERROR = 'AD_TAG_DYNAMIC_VAR_ERROR',
  AD_TAG_EXTERNAL_TRACKING_ERROR = 'AD_TAG_EXTERNAL_TRACKING_ERROR',
  AD_TAG_NETWORK_NOT_FOUND_ERROR = 'AD_TAG_NETWORK_NOT_FOUND_ERROR',
  AD_TAG_NO_SUBSCRIPTION_ERROR = 'AD_TAG_NO_SUBSCRIPTION_ERROR',
  AD_TAG_REPORT_DOESNT_BELONG_TO_THIS_TEAM_ERROR = 'AD_TAG_REPORT_DOESNT_BELONG_TO_THIS_TEAM_ERROR',
  AD_TAG_SUBSCRIPTION_INACTIVE_BY_ADMIN = 'AD_TAG_SUBSCRIPTION_INACTIVE_BY_ADMIN',
  AI_NSFW_PROMPT_ERROR = 'AI_NSFW_PROMPT_ERROR',
  AI_OPERATION_FAILED = 'AI_OPERATION_FAILED',
  AI_OPERATION_NOT_FOUND = 'AI_OPERATION_NOT_FOUND',
  AI_SENSITIVE_CONTENT_RATE_LIMITED = 'AI_SENSITIVE_CONTENT_RATE_LIMITED',
  AI_SERVICE_UNAVAILABLE = 'AI_SERVICE_UNAVAILABLE',
  ANOTHER_MIGRATION_IN_PROGRESS = 'ANOTHER_MIGRATION_IN_PROGRESS',
  ATTACHMENT_UPLOAD_ERROR = 'ATTACHMENT_UPLOAD_ERROR',
  BAD_USER_INPUT = 'BAD_USER_INPUT',
  BANNERSNACK_SUBSCRIPTION_CANCEL_ERROR = 'BANNERSNACK_SUBSCRIPTION_CANCEL_ERROR',
  BG_REMOVER_DEFAULT = 'BG_REMOVER_DEFAULT',
  BG_REMOVER_FILE_NOT_EXISTS = 'BG_REMOVER_FILE_NOT_EXISTS',
  BG_REMOVER_IMAGE_ERROR = 'BG_REMOVER_IMAGE_ERROR',
  BG_REMOVER_TOO_MANY_REQUEST = 'BG_REMOVER_TOO_MANY_REQUEST',
  BILLING_PROVIDER_RATE_LIMITED = 'BILLING_PROVIDER_RATE_LIMITED',
  BRAND_KIT_NOT_EDITABLE = 'BRAND_KIT_NOT_EDITABLE',
  BRAND_KIT_NOT_FOUND = 'BRAND_KIT_NOT_FOUND',
  BRAND_KIT_NO_ACCESS = 'BRAND_KIT_NO_ACCESS',
  BRAND_KIT_PROJECT_NOT_FOUND = 'BRAND_KIT_PROJECT_NOT_FOUND',
  BUSINESS_LINK_NOT_FOUND = 'BUSINESS_LINK_NOT_FOUND',
  CM360_AUTH_ERROR = 'CM360_AUTH_ERROR',
  COLOR_PALETTE_ERROR = 'COLOR_PALETTE_ERROR',
  COLOR_PALETTE_NOT_FOUND = 'COLOR_PALETTE_NOT_FOUND',
  COMMENT_NOT_FOUND = 'COMMENT_NOT_FOUND',
  CORRUPTED_FILE_FORMAT = 'CORRUPTED_FILE_FORMAT',
  COUPON_NOT_FOUND = 'COUPON_NOT_FOUND',
  CREATE_NEXTGEN_AI_DESIGN_ERROR = 'CREATE_NEXTGEN_AI_DESIGN_ERROR',
  CREDITS_LIMIT_REACHED = 'CREDITS_LIMIT_REACHED',
  CREDIT_TRANSACTION_ERROR = 'CREDIT_TRANSACTION_ERROR',
  DESIGNS_NOT_FOUND = 'DESIGNS_NOT_FOUND',
  DESIGN_BULK_EXCLUSIVE_ERROR = 'DESIGN_BULK_EXCLUSIVE_ERROR',
  DESIGN_EXCLUSIVE_ERROR = 'DESIGN_EXCLUSIVE_ERROR',
  DESIGN_NOT_A_SET = 'DESIGN_NOT_A_SET',
  DESIGN_NOT_FOUND = 'DESIGN_NOT_FOUND',
  DESIGN_NO_ACCESS = 'DESIGN_NO_ACCESS',
  DISPOSABLE_EMAIL_DOMAIN_EXISTS = 'DISPOSABLE_EMAIL_DOMAIN_EXISTS',
  DISPOSABLE_EMAIL_DOMAIN_INVALID = 'DISPOSABLE_EMAIL_DOMAIN_INVALID',
  DISPOSABLE_EMAIL_DOMAIN_PREVIOUSLY_DELETED = 'DISPOSABLE_EMAIL_DOMAIN_PREVIOUSLY_DELETED',
  DUPLICATE_FOLDER_ERROR = 'DUPLICATE_FOLDER_ERROR',
  DUPLICATE_FONT_ERROR = 'DUPLICATE_FONT_ERROR',
  DV360_AUTH_ERROR = 'DV360_AUTH_ERROR',
  EMAIL_CHANGE_REQUEST_EXPIRED = 'EMAIL_CHANGE_REQUEST_EXPIRED',
  EMAIL_NOT_VERIFIED = 'EMAIL_NOT_VERIFIED',
  EXPORT_DESIGNS_LIMIT = 'EXPORT_DESIGNS_LIMIT',
  FAILED_TO_FETCH = 'FAILED_TO_FETCH',
  FB_BUSINESS_LINK_NOT_FOUND = 'FB_BUSINESS_LINK_NOT_FOUND',
  FB_TOKEN_EXPIRED = 'FB_TOKEN_EXPIRED',
  FEED_CANNOT_BE_EMPTY = 'FEED_CANNOT_BE_EMPTY',
  FEED_CANNOT_REMOVE_LAST_COLUMN = 'FEED_CANNOT_REMOVE_LAST_COLUMN',
  FEED_CANNOT_REMOVE_SOURCE_COLUMN = 'FEED_CANNOT_REMOVE_SOURCE_COLUMN',
  FEED_CANNOT_REMOVE_TARGET_COLUMN = 'FEED_CANNOT_REMOVE_TARGET_COLUMN',
  FEED_COLUMNS_DUPLICATE = 'FEED_COLUMNS_DUPLICATE',
  FEED_COLUMNS_MISMATCH = 'FEED_COLUMNS_MISMATCH',
  FEED_COLUMN_NOT_FOUND = 'FEED_COLUMN_NOT_FOUND',
  FEED_COLUMN_OPS_NOT_SUPPORTED = 'FEED_COLUMN_OPS_NOT_SUPPORTED',
  FEED_CONTENT_INVALID = 'FEED_CONTENT_INVALID',
  FEED_FILE_TOO_LARGE = 'FEED_FILE_TOO_LARGE',
  FEED_INDEXING_FAILED = 'FEED_INDEXING_FAILED',
  FEED_INVALID_CHANNABLE_DOMAIN = 'FEED_INVALID_CHANNABLE_DOMAIN',
  FEED_INVALID_COLUMN_NAME = 'FEED_INVALID_COLUMN_NAME',
  FEED_INVALID_EXTRA_DATA = 'FEED_INVALID_EXTRA_DATA',
  FEED_INVALID_GOOGLE_DRIVE_DOMAIN = 'FEED_INVALID_GOOGLE_DRIVE_DOMAIN',
  FEED_INVALID_TARGET_COLUMN = 'FEED_INVALID_TARGET_COLUMN',
  FEED_INVALID_URL = 'FEED_INVALID_URL',
  FEED_IN_PROCESSING = 'FEED_IN_PROCESSING',
  FEED_MISSING_SOURCE = 'FEED_MISSING_SOURCE',
  FEED_NOT_FOUND = 'FEED_NOT_FOUND',
  FEED_NO_ACCESS = 'FEED_NO_ACCESS',
  FEED_NO_CONTENT = 'FEED_NO_CONTENT',
  FEED_ROWS_MISMATCH = 'FEED_ROWS_MISMATCH',
  FEED_ROW_NOT_FOUND = 'FEED_ROW_NOT_FOUND',
  FEED_SEARCH_FAILED = 'FEED_SEARCH_FAILED',
  FEED_SYNC_TIMEOUT = 'FEED_SYNC_TIMEOUT',
  /** A job on this .fig import key is still running: wait for its status to change. */
  FIG_FILE_STILL_PROCESSING = 'FIG_FILE_STILL_PROCESSING',
  /** A .fig import key past its day, or never issued: upload the file again. */
  FIG_FILE_UPLOAD_EXPIRED = 'FIG_FILE_UPLOAD_EXPIRED',
  FILE_EXCEEDS_SIZE_LIMIT = 'FILE_EXCEEDS_SIZE_LIMIT',
  FILE_NOT_FOUND = 'FILE_NOT_FOUND',
  FILE_UPLOAD_ERROR = 'FILE_UPLOAD_ERROR',
  FOLDERS_NOT_FOUND = 'FOLDERS_NOT_FOUND',
  FOLDER_BELONGS_TO_ANOTHER_PROJECT = 'FOLDER_BELONGS_TO_ANOTHER_PROJECT',
  FOLDER_NOT_FOUND = 'FOLDER_NOT_FOUND',
  FOLDER_NO_ACCESS = 'FOLDER_NO_ACCESS',
  FONT_COMPATIABILITY_CHECK_ERROR = 'FONT_COMPATIABILITY_CHECK_ERROR',
  FONT_UPLOAD_ERROR = 'FONT_UPLOAD_ERROR',
  FORBIDDEN = 'FORBIDDEN',
  FREE_TEAM_LIMIT_EXCEEDED = 'FREE_TEAM_LIMIT_EXCEEDED',
  GOOGLE_ADS_AUTH_ERROR = 'GOOGLE_ADS_AUTH_ERROR',
  GRAPHQL_VALIDATION_FAILED = 'GRAPHQL_VALIDATION_FAILED',
  IMAGES_STILL_UPLOADING = 'IMAGES_STILL_UPLOADING',
  INTEGRATION_ACCOUNT_ALREADY_CONNECTED = 'INTEGRATION_ACCOUNT_ALREADY_CONNECTED',
  INTEGRATION_EMPTY = 'INTEGRATION_EMPTY',
  INTEGRATION_FILE_DOWNLOAD_ERROR = 'INTEGRATION_FILE_DOWNLOAD_ERROR',
  INTEGRATION_LOADING_ERROR = 'INTEGRATION_LOADING_ERROR',
  INTEGRATION_NOT_FOUND = 'INTEGRATION_NOT_FOUND',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  INVOICE_NOT_FOUND = 'INVOICE_NOT_FOUND',
  ITEMS_NOT_DELETED = 'ITEMS_NOT_DELETED',
  ITEMS_NOT_DUPLICATED = 'ITEMS_NOT_DUPLICATED',
  ITEMS_NOT_FOUND = 'ITEMS_NOT_FOUND',
  ITEMS_NOT_MOVED = 'ITEMS_NOT_MOVED',
  ITEM_NOT_DELETED = 'ITEM_NOT_DELETED',
  ITEM_NOT_DUPLICATED = 'ITEM_NOT_DUPLICATED',
  ITEM_NOT_DUPLICATED_NO_SIZES = 'ITEM_NOT_DUPLICATED_NO_SIZES',
  ITEM_NOT_MOVED = 'ITEM_NOT_MOVED',
  JSON_NOT_FOUND = 'JSON_NOT_FOUND',
  LEGACY_PLAN_REACTIVATION_BLOCKED = 'LEGACY_PLAN_REACTIVATION_BLOCKED',
  LINKEDIN_AUTH_ERROR = 'LINKEDIN_AUTH_ERROR',
  LOGO_UPLOAD_ERROR = 'LOGO_UPLOAD_ERROR',
  MAIN_SUBSCRIPTION_CANCELED = 'MAIN_SUBSCRIPTION_CANCELED',
  MEDIA_DURATION_ERROR = 'MEDIA_DURATION_ERROR',
  MEDIA_FOLDER_NOT_FOUND = 'MEDIA_FOLDER_NOT_FOUND',
  MEDIA_NOT_FOUND = 'MEDIA_NOT_FOUND',
  MEDIA_WRONG_FORMAT = 'MEDIA_WRONG_FORMAT',
  MIGRATE_BANNER_ERROR = 'MIGRATE_BANNER_ERROR',
  MIGRATE_FOLDER_ERROR = 'MIGRATE_FOLDER_ERROR',
  MIGRATE_MEDIA_ERROR = 'MIGRATE_MEDIA_ERROR',
  MIGRATION_ALREADY_DONE = 'MIGRATION_ALREADY_DONE',
  MIGRATION_IN_PROGRESS = 'MIGRATION_IN_PROGRESS',
  MOOD_BOARD_ERROR_LOADING_MOODBOARD = 'MOOD_BOARD_ERROR_LOADING_MOODBOARD',
  MOOD_BOARD_NOT_FOUND = 'MOOD_BOARD_NOT_FOUND',
  MOOD_BOARD_NO_ACCESS = 'MOOD_BOARD_NO_ACCESS',
  MOOD_BOARD_SHARE_ERROR_LOADING_MOODBOARD = 'MOOD_BOARD_SHARE_ERROR_LOADING_MOODBOARD',
  MOOD_BOARD_SHARE_INVALID_PASSWORD = 'MOOD_BOARD_SHARE_INVALID_PASSWORD',
  MOOD_BOARD_SHARE_NOT_FOUND = 'MOOD_BOARD_SHARE_NOT_FOUND',
  MOOD_BOARD_SHARE_NO_ACCESS = 'MOOD_BOARD_SHARE_NO_ACCESS',
  MOOD_BOARD_SHARE_PASSWORD_PROTECTED = 'MOOD_BOARD_SHARE_PASSWORD_PROTECTED',
  MOOD_BOARD_SHARE_PASSWORD_PROTECTED_INVALID_PASSWORD = 'MOOD_BOARD_SHARE_PASSWORD_PROTECTED_INVALID_PASSWORD',
  MOOD_BOARD_SHARE_READ_ONLY = 'MOOD_BOARD_SHARE_READ_ONLY',
  MULTIPLE_SESSIONS_NOT_ALLOWED = 'MULTIPLE_SESSIONS_NOT_ALLOWED',
  PERSISTED_QUERY_NOT_FOUND = 'PERSISTED_QUERY_NOT_FOUND',
  PROJECT_NOT_FOUND = 'PROJECT_NOT_FOUND',
  PROJECT_NO_ACCESS = 'PROJECT_NO_ACCESS',
  PROMPT_NOT_FOUND = 'PROMPT_NOT_FOUND',
  RATE_LIMIT_ERROR = 'RATE_LIMIT_ERROR',
  RATE_LIMIT_EXCEEDED = 'RATE_LIMIT_EXCEEDED',
  REFERENCE_IMAGE_INVALID = 'REFERENCE_IMAGE_INVALID',
  RUN_OUT_OF_AI_VIDEO_GENERATION_CREDITS = 'RUN_OUT_OF_AI_VIDEO_GENERATION_CREDITS',
  RUN_OUT_OF_BACKGROUND_REMOVAL_CREDITS = 'RUN_OUT_OF_BACKGROUND_REMOVAL_CREDITS',
  SAMPLE_AD_ASSETS_MISSING = 'SAMPLE_AD_ASSETS_MISSING',
  SAMPLE_AD_COPY_EXPIRED = 'SAMPLE_AD_COPY_EXPIRED',
  SAMPLE_AD_COPY_NOT_FOUND = 'SAMPLE_AD_COPY_NOT_FOUND',
  SHARED_DESIGNS_ERROR = 'SHARED_DESIGNS_ERROR',
  SSO_AUTO_JOIN_ALREADY_ENABLED_ERROR = 'SSO_AUTO_JOIN_ALREADY_ENABLED_ERROR',
  STRING_LENGTH_TOO_LONG = 'STRING_LENGTH_TOO_LONG',
  SUBSCRIPTION_NOT_FOUND = 'SUBSCRIPTION_NOT_FOUND',
  SUBSCRIPTION_SEATS_ERROR = 'SUBSCRIPTION_SEATS_ERROR',
  SVG_TOO_COMPLEX = 'SVG_TOO_COMPLEX',
  SVG_UPLOAD_ERROR = 'SVG_UPLOAD_ERROR',
  TAG_CONTAINER_NOT_FOUND = 'TAG_CONTAINER_NOT_FOUND',
  TEAM_IDENTITY_PROVIDER_NOT_FOUND_ERROR = 'TEAM_IDENTITY_PROVIDER_NOT_FOUND_ERROR',
  TEAM_NOT_FOUND = 'TEAM_NOT_FOUND',
  TEAM_NO_ACCESS = 'TEAM_NO_ACCESS',
  TEAM_USER_NOT_FOUND = 'TEAM_USER_NOT_FOUND',
  TEMPLATES_NOT_FOUND = 'TEMPLATES_NOT_FOUND',
  TEMPLATE_ALREADY_CREATED = 'TEMPLATE_ALREADY_CREATED',
  TEMPLATE_NOT_FOUND = 'TEMPLATE_NOT_FOUND',
  TEMPORARY_USER_TOKEN_EXPIRED = 'TEMPORARY_USER_TOKEN_EXPIRED',
  TIKTOK_AUTH_ERROR = 'TIKTOK_AUTH_ERROR',
  TIKTOK_PERMISSION_ERROR = 'TIKTOK_PERMISSION_ERROR',
  TRASH_ITEM_RESTORED = 'TRASH_ITEM_RESTORED',
  UNAUTHENTICATED = 'UNAUTHENTICATED',
  URL_SAFETY_LIST_ENTRY_EXISTS = 'URL_SAFETY_LIST_ENTRY_EXISTS',
  URL_SAFETY_LIST_ENTRY_INVALID = 'URL_SAFETY_LIST_ENTRY_INVALID',
  USAGE_RESTRICTION_ERROR = 'USAGE_RESTRICTION_ERROR',
  USER_ALREADY_CONFIRMED_ERROR = 'USER_ALREADY_CONFIRMED_ERROR',
  USER_NOT_AUTHENTICATED = 'USER_NOT_AUTHENTICATED',
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  USER_NOT_MEMBER_OF_TEAM = 'USER_NOT_MEMBER_OF_TEAM',
  USER_WITH_EMAIL_ALREADY_EXIST = 'USER_WITH_EMAIL_ALREADY_EXIST',
  VIDEO_EDIT_SOURCE_TOO_LARGE = 'VIDEO_EDIT_SOURCE_TOO_LARGE',
  VIDEO_EDIT_SOURCE_TOO_LONG = 'VIDEO_EDIT_SOURCE_TOO_LONG',
  VIDEO_EDIT_SOURCE_UNAVAILABLE = 'VIDEO_EDIT_SOURCE_UNAVAILABLE'
}

export type ErrorState = {
  __typename?: 'ErrorState';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ErrorTranslate = {
  feedError?: InputMaybe<Scalars['String']['input']>;
  logs?: InputMaybe<Scalars['String']['input']>;
};

export type Event = {
  account: Scalars['JSON']['input'];
  eventName?: InputMaybe<Scalars['String']['input']>;
  subscription?: InputMaybe<Scalars['JSON']['input']>;
};

export type ExpansionConfig = {
  __typename?: 'ExpansionConfig';
  nextPlan?: Maybe<ExpansionNextPlan>;
  upgradePath: Array<Scalars['String']['output']>;
};

export type ExpansionNextPlan = {
  __typename?: 'ExpansionNextPlan';
  code: Scalars['String']['output'];
  planGroup?: Maybe<Scalars['String']['output']>;
  properties: PlanProperties;
};

export type ExpansionPayload = {
  __typename?: 'ExpansionPayload';
  config: ExpansionConfig;
};

export enum ExperimentType {
  DISABLED = 'disabled',
  NOCC = 'noCC',
  NORMAL = 'normal',
  OPTIN = 'optIn',
  OPTOUT = 'optOut',
  TRIAL7 = 'trial7',
  TRIAL14 = 'trial14',
  YESCC = 'yesCC'
}

export type ExpiredSubscription = {
  __typename?: 'ExpiredSubscription';
  planCode?: Maybe<Scalars['String']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  planVersion?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  /** True if the team had an active paid subscription (vs only a trial that expired without conversion) */
  wasPaid?: Maybe<Scalars['Boolean']['output']>;
};

export type ExportDesignThumbnailPayload = {
  __typename?: 'ExportDesignThumbnailPayload';
  result: Scalars['Boolean']['output'];
};

/** @deprecated No resolver implemented for exportDpaFinished mutation */
export type ExportDpaFinishedInput = {
  catalogName?: InputMaybe<Scalars['String']['input']>;
  count: Scalars['Int']['input'];
  designHash: Scalars['String']['input'];
  skipSettingsUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['Int']['input'];
};

export type ExportFeedToCsvResult = {
  __typename?: 'ExportFeedToCsvResult';
  csvContent: Scalars['String']['output'];
  filename: Scalars['String']['output'];
};

export type ExportImageForLastSavedDesignsPayload = {
  __typename?: 'ExportImageForLastSavedDesignsPayload';
  result: Scalars['Int']['output'];
};

export type ExportResultPayload = {
  __typename?: 'ExportResultPayload';
  result: Scalars['Boolean']['output'];
};

export type ExportSetThumbnailPayload = {
  __typename?: 'ExportSetThumbnailPayload';
  designs: Array<ExportDesignThumbnailPayload>;
};

export enum ExportStatus {
  COMPLETE = 'COMPLETE',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS'
}

export enum ExportType {
  AD_TAG_HTML5 = 'AD_TAG_HTML5',
  AD_TAG_MRAID = 'AD_TAG_MRAID',
  AMP = 'AMP',
  ANIMATED_GIF = 'ANIMATED_GIF',
  ANIMATED_GIF_LOW = 'ANIMATED_GIF_LOW',
  DISABLE_EMBED = 'DISABLE_EMBED',
  GIF = 'GIF',
  GIF_OPTIMIZED = 'GIF_OPTIMIZED',
  HTML = 'HTML',
  HTML_NEXT = 'HTML_NEXT',
  IMAGE = 'IMAGE',
  MP4 = 'MP4',
  PDF = 'PDF',
  PDF_API = 'PDF_API',
  PDF_PRINT = 'PDF_PRINT',
  PDF_PRINT_API = 'PDF_PRINT_API',
  ZIP = 'ZIP'
}

export type ExtractResizeInfoPayload = {
  __typename?: 'ExtractResizeInfoPayload';
  layers: Array<ResizeLayerInfo>;
  originalHeight: Scalars['Int']['output'];
  originalWidth: Scalars['Int']['output'];
};

/** [Deprecated] Complete brand kit assets extracted from a website URL. */
export type ExtractedBrandKitAssets = {
  __typename?: 'ExtractedBrandKitAssets';
  /** Extracted brand name. */
  brandName: Scalars['String']['output'];
  /** All extracted colors (combined from logo and style). */
  colors: Array<Scalars['String']['output']>;
  /** Images. */
  images: Array<ExtractedImage>;
  /** Logo information. */
  logo: ExtractedLogo;
  /** Source URL that was analyzed. */
  sourceUrl: Scalars['String']['output'];
  /** Style information. */
  style: ExtractedStyle;
  /** Text content. */
  text: ExtractedText;
};

/** [Deprecated] Text header information. */
export type ExtractedHeader = {
  __typename?: 'ExtractedHeader';
  /** Header level (1-6). */
  level: Scalars['Int']['output'];
  /** Header text content. */
  text: Scalars['String']['output'];
};

/** [Deprecated] Image information extracted from a website. */
export type ExtractedImage = {
  __typename?: 'ExtractedImage';
  /** Alt text of the image. */
  alt?: Maybe<Scalars['String']['output']>;
  /** Height of the image. */
  height?: Maybe<Scalars['Int']['output']>;
  /** URL of the extracted image. */
  src: Scalars['String']['output'];
  /** Title of the image. */
  title?: Maybe<Scalars['String']['output']>;
  /** Width of the image. */
  width?: Maybe<Scalars['Int']['output']>;
};

/** [Deprecated] Logo information extracted from a website. */
export type ExtractedLogo = {
  __typename?: 'ExtractedLogo';
  /** Colors extracted from the logo. */
  colors?: Maybe<Array<Scalars['String']['output']>>;
  /** Favicon URL. */
  favicon?: Maybe<Scalars['String']['output']>;
  /** URL of the extracted logo. */
  src?: Maybe<Scalars['String']['output']>;
  /** SVG content of the logo (if available). */
  svg?: Maybe<Scalars['String']['output']>;
};

/** [Deprecated] Style information extracted from a website. */
export type ExtractedStyle = {
  __typename?: 'ExtractedStyle';
  /** Primary accent color. */
  accentColor?: Maybe<Scalars['String']['output']>;
  /** Background color. */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** Border radius used on the site. */
  borderRadius?: Maybe<Scalars['String']['output']>;
  /** Text color. */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** [Deprecated] Text content extracted from a website. */
export type ExtractedText = {
  __typename?: 'ExtractedText';
  /** Extracted brand name. */
  brandName?: Maybe<Scalars['String']['output']>;
  /** Essential text content from the site. */
  essentialText?: Maybe<Scalars['String']['output']>;
  /** Headers found on the page. */
  headers?: Maybe<Array<ExtractedHeader>>;
  /** All inner text content. */
  innerText?: Maybe<Scalars['String']['output']>;
};

export type FacebookAdCreativeSettingsInput = {
  callToActionType?: InputMaybe<FacebookCallToActionType>;
  descriptions?: InputMaybe<Array<Scalars['String']['input']>>;
  displayLink?: InputMaybe<Scalars['String']['input']>;
  headlines?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The destination URL for the ad creative (matches Meta's link field). Optional for page/profile destinations. */
  link?: InputMaybe<Scalars['String']['input']>;
  /** Media type for the ad creative: IMAGE (default), VIDEO, or AUTO (detect from the design's video/animation content). */
  mediaType?: InputMaybe<FacebookAdMediaType>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  primaryTexts?: InputMaybe<Array<Scalars['String']['input']>>;
  urlTags?: InputMaybe<Scalars['String']['input']>;
};

export enum FacebookAdMediaType {
  /** Auto-detect from the design: rendered as VIDEO when it contains a video layer or animations, otherwise IMAGE. */
  AUTO = 'AUTO',
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO'
}

export type FacebookAdSetSettingsInput = {
  /** Facebook Application ID — required when destination_type is APP. */
  applicationId?: InputMaybe<Scalars['String']['input']>;
  /** Bid cap for COST_CAP / LOWEST_COST_WITH_BID_CAP strategies (cents). */
  bidAmount?: InputMaybe<Scalars['Int']['input']>;
  /** Bid strategy at ad set level -- only used when campaign budget is OFF and budget sharing is disabled. */
  bidStrategy?: InputMaybe<FacebookBidStrategy>;
  billingEvent?: InputMaybe<FacebookBillingEvent>;
  customConversionId?: InputMaybe<Scalars['String']['input']>;
  customEventType?: InputMaybe<FacebookConversionEventType>;
  dailyBudget?: InputMaybe<Scalars['Int']['input']>;
  dailyMinSpendTarget?: InputMaybe<Scalars['Int']['input']>;
  dailySpendCap?: InputMaybe<Scalars['Int']['input']>;
  destinationType?: InputMaybe<FacebookDestinationType>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  /** When true, uses Facebook Dynamic Creative (is_dynamic_creative=true on the ad set). */
  isDynamicCreative?: InputMaybe<Scalars['Boolean']['input']>;
  /** Lead gen form ID — required for ON_AD (Instant Forms) destination. */
  leadFormId?: InputMaybe<Scalars['String']['input']>;
  lifetimeBudget?: InputMaybe<Scalars['Int']['input']>;
  optimizationGoal?: InputMaybe<FacebookOptimizationGoal>;
  pixelId?: InputMaybe<Scalars['String']['input']>;
  /** ROAS floor for LOWEST_COST_WITH_MIN_ROAS strategy. Integer scaled 10000x (e.g. 15000 = 1.5 ROAS). */
  roasAverageFloor?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  status: FacebookEntityStatus;
  targeting?: InputMaybe<FacebookTargetingInput>;
};

export enum FacebookBidStrategy {
  COST_CAP = 'COST_CAP',
  LOWEST_COST_WITHOUT_CAP = 'LOWEST_COST_WITHOUT_CAP',
  LOWEST_COST_WITH_BID_CAP = 'LOWEST_COST_WITH_BID_CAP',
  LOWEST_COST_WITH_MIN_ROAS = 'LOWEST_COST_WITH_MIN_ROAS'
}

export enum FacebookBillingEvent {
  APP_INSTALLS = 'APP_INSTALLS',
  IMPRESSIONS = 'IMPRESSIONS',
  LINK_CLICKS = 'LINK_CLICKS',
  PAGE_LIKES = 'PAGE_LIKES',
  POST_ENGAGEMENT = 'POST_ENGAGEMENT',
  THRUPLAY = 'THRUPLAY'
}

/** Basic information about a Facebook brand/page */
export type FacebookBrand = {
  __typename?: 'FacebookBrand';
  /** Page category */
  category?: Maybe<Scalars['String']['output']>;
  /** Country where the page is based */
  country?: Maybe<Scalars['String']['output']>;
  /** Type of entity (page, profile, etc.) */
  entityType?: Maybe<Scalars['String']['output']>;
  /** Number of Facebook followers */
  fbFollowers?: Maybe<Scalars['Int']['output']>;
  /** Number of Instagram followers */
  igFollowers?: Maybe<Scalars['Int']['output']>;
  /** Instagram username */
  igUsername?: Maybe<Scalars['String']['output']>;
  /** Whether Instagram account is verified */
  igVerification?: Maybe<Scalars['Boolean']['output']>;
  /** Profile image URL */
  imageUri?: Maybe<Scalars['String']['output']>;
  /**
   * Number of page likes
   * @deprecated Use fbFollowers instead
   */
  likes?: Maybe<Scalars['Int']['output']>;
  /** Page name */
  name: Scalars['String']['output'];
  /** Page alias/username */
  pageAlias?: Maybe<Scalars['String']['output']>;
  /** Unique page identifier */
  pageId: Scalars['String']['output'];
  /** Whether the page is deleted */
  pageIsDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** Verification status */
  verification?: Maybe<Scalars['String']['output']>;
};

/** Detailed information about a Facebook brand/page */
export type FacebookBrandDetails = {
  __typename?: 'FacebookBrandDetails';
  /** Best description of the page */
  bestDescription: FacebookPageDescription;
  /** Page category name */
  categoryName: Scalars['String']['output'];
  /** Unique page identifier */
  id: Scalars['String']['output'];
  /** Page name */
  name: Scalars['String']['output'];
  /** Page likes information */
  pageLikers: FacebookPageLikers;
  /** Profile picture URL */
  profilePictureUri: Scalars['String']['output'];
  /** Page URL */
  url: Scalars['String']['output'];
  /** Verification status */
  verificationStatus: Scalars['String']['output'];
  /** List of associated websites */
  websites: Array<Scalars['String']['output']>;
};

/** Response containing Facebook brand details */
export type FacebookBrandDetailsResponse = {
  __typename?: 'FacebookBrandDetailsResponse';
  /** Brand/page ID that was queried */
  brandId: Scalars['String']['output'];
  /** Detailed brand information */
  data?: Maybe<FacebookBrandDetails>;
  /** Error message if request failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Whether the request was successful */
  success: Scalars['Boolean']['output'];
  /** Timestamp of the response */
  timestamp: Scalars['String']['output'];
};

/** Input for searching Facebook brands */
export type FacebookBrandSearchInput = {
  /** Type of ads to focus on (e.g., 'political', 'issues') */
  adType?: InputMaybe<Scalars['String']['input']>;
  /** Country code to filter results */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Whether to use mobile-optimized search */
  isMobile?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search query term */
  query: Scalars['String']['input'];
};

/** Response containing Facebook brand search results */
export type FacebookBrandSearchResponse = {
  __typename?: 'FacebookBrandSearchResponse';
  /** List of matching Facebook brands */
  results: Array<FacebookBrand>;
};

export enum FacebookBudgetStrategy {
  AD_SET_BUDGET = 'AD_SET_BUDGET',
  CAMPAIGN_BUDGET = 'CAMPAIGN_BUDGET'
}

export enum FacebookCallToActionType {
  APPLY_NOW = 'APPLY_NOW',
  BOOK_NOW = 'BOOK_NOW',
  CALL_NOW = 'CALL_NOW',
  CONTACT_US = 'CONTACT_US',
  DOWNLOAD = 'DOWNLOAD',
  GET_QUOTE = 'GET_QUOTE',
  LEARN_MORE = 'LEARN_MORE',
  NO_BUTTON = 'NO_BUTTON',
  SEND_MESSAGE = 'SEND_MESSAGE',
  SHOP_NOW = 'SHOP_NOW',
  SIGN_UP = 'SIGN_UP',
  SUBSCRIBE = 'SUBSCRIBE',
  WATCH_MORE = 'WATCH_MORE'
}

export enum FacebookCampaignObjective {
  OUTCOME_APP_PROMOTION = 'OUTCOME_APP_PROMOTION',
  OUTCOME_AWARENESS = 'OUTCOME_AWARENESS',
  OUTCOME_ENGAGEMENT = 'OUTCOME_ENGAGEMENT',
  OUTCOME_LEADS = 'OUTCOME_LEADS',
  OUTCOME_SALES = 'OUTCOME_SALES',
  OUTCOME_TRAFFIC = 'OUTCOME_TRAFFIC'
}

export type FacebookCampaignSettingsInput = {
  bidStrategy?: InputMaybe<FacebookBidStrategy>;
  budgetStrategy: FacebookBudgetStrategy;
  dailyBudget?: InputMaybe<Scalars['Int']['input']>;
  isAdsetBudgetSharingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lifetimeBudget?: InputMaybe<Scalars['Int']['input']>;
  objective: FacebookCampaignObjective;
  specialAdCategories: Array<FacebookSpecialAdCategory>;
  status: FacebookEntityStatus;
};

export enum FacebookConversionEventType {
  ADD_PAYMENT_INFO = 'ADD_PAYMENT_INFO',
  ADD_TO_CART = 'ADD_TO_CART',
  ADD_TO_WISHLIST = 'ADD_TO_WISHLIST',
  COMPLETE_REGISTRATION = 'COMPLETE_REGISTRATION',
  CONTACT = 'CONTACT',
  CONTENT_VIEW = 'CONTENT_VIEW',
  CUSTOMIZE_PRODUCT = 'CUSTOMIZE_PRODUCT',
  DONATE = 'DONATE',
  FIND_LOCATION = 'FIND_LOCATION',
  INITIATED_CHECKOUT = 'INITIATED_CHECKOUT',
  LEAD = 'LEAD',
  PURCHASE = 'PURCHASE',
  SCHEDULE = 'SCHEDULE',
  SEARCH = 'SEARCH',
  START_TRIAL = 'START_TRIAL',
  SUBMIT_APPLICATION = 'SUBMIT_APPLICATION',
  SUBSCRIBE = 'SUBSCRIBE'
}

export enum FacebookDestinationType {
  APP = 'APP',
  INSTAGRAM_DIRECT = 'INSTAGRAM_DIRECT',
  INSTAGRAM_PROFILE_AND_FACEBOOK_PAGE = 'INSTAGRAM_PROFILE_AND_FACEBOOK_PAGE',
  LEAD_FROM_IG_DIRECT = 'LEAD_FROM_IG_DIRECT',
  LEAD_FROM_MESSENGER = 'LEAD_FROM_MESSENGER',
  MESSAGING_INSTAGRAM_DIRECT_MESSENGER_WHATSAPP = 'MESSAGING_INSTAGRAM_DIRECT_MESSENGER_WHATSAPP',
  MESSENGER = 'MESSENGER',
  ON_AD = 'ON_AD',
  ON_EVENT = 'ON_EVENT',
  ON_PAGE = 'ON_PAGE',
  ON_POST = 'ON_POST',
  ON_VIDEO = 'ON_VIDEO',
  PHONE_CALL = 'PHONE_CALL',
  UNDEFINED = 'UNDEFINED',
  WEBSITE = 'WEBSITE',
  WHATSAPP = 'WHATSAPP'
}

export enum FacebookEntityStatus {
  ACTIVE = 'ACTIVE',
  PAUSED = 'PAUSED'
}

export enum FacebookOptimizationGoal {
  AD_RECALL_LIFT = 'AD_RECALL_LIFT',
  APP_INSTALLS = 'APP_INSTALLS',
  CONVERSATIONS = 'CONVERSATIONS',
  EVENT_RESPONSES = 'EVENT_RESPONSES',
  IMPRESSIONS = 'IMPRESSIONS',
  IN_APP_VALUE = 'IN_APP_VALUE',
  LANDING_PAGE_VIEWS = 'LANDING_PAGE_VIEWS',
  LEAD_GENERATION = 'LEAD_GENERATION',
  LINK_CLICKS = 'LINK_CLICKS',
  OFFSITE_CONVERSIONS = 'OFFSITE_CONVERSIONS',
  PAGE_LIKES = 'PAGE_LIKES',
  POST_ENGAGEMENT = 'POST_ENGAGEMENT',
  PROFILE_AND_PAGE_ENGAGEMENT = 'PROFILE_AND_PAGE_ENGAGEMENT',
  QUALITY_CALL = 'QUALITY_CALL',
  QUALITY_LEAD = 'QUALITY_LEAD',
  REACH = 'REACH',
  THRUPLAY = 'THRUPLAY',
  TWO_SECOND_CONTINUOUS_VIDEO_VIEWS = 'TWO_SECOND_CONTINUOUS_VIDEO_VIEWS',
  VALUE = 'VALUE',
  VISIT_INSTAGRAM_PROFILE = 'VISIT_INSTAGRAM_PROFILE'
}

/** Page description information */
export type FacebookPageDescription = {
  __typename?: 'FacebookPageDescription';
  /** Description text */
  text: Scalars['String']['output'];
};

/** Facebook page likes information */
export type FacebookPageLikers = {
  __typename?: 'FacebookPageLikers';
  /** Number of people who like the page */
  count: Scalars['Int']['output'];
};

export enum FacebookSpecialAdCategory {
  CREDIT = 'CREDIT',
  EMPLOYMENT = 'EMPLOYMENT',
  FINANCIAL_PRODUCTS_SERVICES = 'FINANCIAL_PRODUCTS_SERVICES',
  HOUSING = 'HOUSING',
  ISSUES_ELECTIONS_POLITICS = 'ISSUES_ELECTIONS_POLITICS',
  NONE = 'NONE',
  ONLINE_GAMBLING_AND_GAMING = 'ONLINE_GAMBLING_AND_GAMING'
}

export type FacebookTargetingInput = {
  /** Meta's Advantage+ audience. On unless false. With it on, Meta chooses the ages and genders from ageMin: ageMin must be 18 to 25 (20 to 25 when countries include Thailand), and an ageMax below 65 or any genders are refused. With it false, the age range and the genders are sent as given. A locked special ad category (HOUSING, EMPLOYMENT, FINANCIAL_PRODUCTS_SERVICES or CREDIT) means ages 18 to 65+ (20 to 65+ with this on in Thailand) and all genders, whatever this is: a new campaign in one refuses any other audience, and for an existing campaign the worker applies that audience itself. */
  advantageAudience?: InputMaybe<Scalars['Boolean']['input']>;
  /** The maximum age: from the minimum age to 65, where 65 means 65 and older. Not below 65 with advantageAudience on. In a new campaign with a locked special ad category it can only be 65. */
  ageMax?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum age: 13 to 65, or 18 to 25 with advantageAudience on (20 to 25 when countries include Thailand, TH). 18 when left out, or 20 with advantageAudience on in Thailand. In a new campaign with a locked special ad category it can only be 18, or 20 with advantageAudience on in Thailand. */
  ageMin?: InputMaybe<Scalars['Int']['input']>;
  /** The countries the new ad set is shown in, as ISO 3166-1 alpha-2 codes. Required for a new ad set unless savedAudienceId is set: there is no default location, and a publish without one is refused. A new ad set shown in Singapore (SG) or Taiwan (TW) is refused too: Meta wants a beneficiary and payer verified with it there, which this API cannot name. An existing ad set keeps its own audience. */
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The genders: 1 men, 2 women. Needs a minimum age of 18, or 20 when countries include Thailand (TH). Not allowed with advantageAudience on, or in a new campaign with a locked special ad category. */
  genders?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** The id of one of the ad account's saved audiences (fbSavedAudiences). Meta has no field that names a saved audience on an ad set, so the new ad set gets a copy of that audience's targeting as Meta holds it when the job runs, suggestions included. Leave out countries, ageMin, ageMax, genders and advantageAudience with it. Its locations are checked before anything is created in Meta: a new ad set in Singapore or Taiwan is refused, one in the EU needs the ad account's beneficiary and payer, and one with locations not in one country we can name (a country group, or a place Meta gives no country for) is refused. In Thailand, Advantage+ audience starts at 20. Not allowed in a campaign whose special ad category fixes the audience (HOUSING, EMPLOYMENT, FINANCIAL_PRODUCTS_SERVICES or CREDIT). */
  savedAudienceId?: InputMaybe<Scalars['String']['input']>;
};

/** Information about a favorite element. */
export type FavoriteElementResult = {
  __typename?: 'FavoriteElementResult';
  /** Additional information about the favorite element. */
  info: Scalars['JSON']['output'];
  /** Path to the favorite element. */
  path: Scalars['String']['output'];
  /** Type of the favorite element. */
  type: Scalars['String']['output'];
};

/** Information about a favorite project. */
export type FavoriteProjectsResult = {
  __typename?: 'FavoriteProjectsResult';
  /** When the project was marked as favorite. */
  favoredAt: Scalars['Date']['output'];
  /** ID of the favorited project. */
  projectId: Scalars['Int']['output'];
};

/** Response after marking a team as favorite. */
export type FavouriteTeamPayload = {
  __typename?: 'FavouriteTeamPayload';
  /** Whether the team is now marked as favorite. */
  favourite: Scalars['Boolean']['output'];
  /** ID of the team. */
  teamId: Scalars['Int']['output'];
};

export type FbAd = {
  __typename?: 'FbAd';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FbAdAccount = {
  __typename?: 'FbAdAccount';
  /** The ISO 3166-1 alpha-2 code of the country Meta has for the ad account's business, where a new ad set's locations start. Null when that is unknown. */
  businessCountryCode?: Maybe<Scalars['String']['output']>;
  /** True when the ad account has both a default beneficiary and a default payor set in Meta, which ads shown in the EU need. Null when that is unknown. */
  hasDsaDefaults?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  owner: Scalars['String']['output'];
};

/** Editable creative fields recovered from an existing ad, used to pre-fill the edit-existing-ad form. */
export type FbAdCreative = {
  __typename?: 'FbAdCreative';
  /** Returned as a raw Meta value (not the enum) so unmapped CTA types from Meta don't break serialization. */
  callToActionType?: Maybe<Scalars['String']['output']>;
  descriptions?: Maybe<Array<Scalars['String']['output']>>;
  displayLink?: Maybe<Scalars['String']['output']>;
  headlines?: Maybe<Array<Scalars['String']['output']>>;
  link?: Maybe<Scalars['String']['output']>;
  /** Resolved media type of the existing creative (IMAGE or VIDEO). */
  mediaType?: Maybe<FacebookAdMediaType>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  primaryTexts?: Maybe<Array<Scalars['String']['output']>>;
  urlTags?: Maybe<Scalars['String']['output']>;
};

export type FbAdSet = {
  __typename?: 'FbAdSet';
  /** @deprecated ads field use fbAds query instead */
  ads: Array<FbAd>;
  destinationType?: Maybe<Scalars['String']['output']>;
  effectiveStatus?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FbBusiness = {
  __typename?: 'FbBusiness';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FbCampaign = {
  __typename?: 'FbCampaign';
  /** @deprecated adSets field use fbAdSets query instead */
  adSets: Array<FbAdSet>;
  bidStrategy?: Maybe<Scalars['String']['output']>;
  dailyBudget?: Maybe<Scalars['String']['output']>;
  effectiveStatus?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lifetimeBudget?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  objective: Scalars['String']['output'];
  /** The campaign's special ad categories as Meta reports them (for example HOUSING). Can contain NONE, which means no category, or be empty when Meta reports none. Null when that is unknown. */
  specialAdCategories?: Maybe<Array<Scalars['String']['output']>>;
};

export type FbCatalog = {
  __typename?: 'FbCatalog';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FbCustomConversion = {
  __typename?: 'FbCustomConversion';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FbInstantExperience = {
  __typename?: 'FbInstantExperience';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FbLeadForm = {
  __typename?: 'FbLeadForm';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type FbPage = {
  __typename?: 'FbPage';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FbPixel = {
  __typename?: 'FbPixel';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  trackedEvents: Array<Scalars['String']['output']>;
};

/** An audience saved in a Meta ad account for reuse. A new ad set takes a copy of its targeting (FacebookTargetingInput.savedAudienceId). */
export type FbSavedAudience = {
  __typename?: 'FbSavedAudience';
  /** Whether it has Advantage+ audience on, which makes its age range, genders, custom audiences and detailed targeting suggestions. */
  advantageAudience: Scalars['Boolean']['output'];
  /** The ISO 3166-1 alpha-2 codes of the countries its locations are in: its countries and the countries of its regions, cities and other places. */
  countries: Array<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** True when some of its locations are not in one country we can name (a country group, or a place Meta gives no country for), so the rules for a country cannot be checked on them. */
  hasLocationsWithoutCountry: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Meta's summary of the audience, line by line. */
  summary: Array<FbTargetingSentence>;
};

/** A line of Meta's own summary of a targeting spec: what it covers (for example Location:) and the values it has there. */
export type FbTargetingSentence = {
  __typename?: 'FbTargetingSentence';
  children: Array<Scalars['String']['output']>;
  content: Scalars['String']['output'];
};

export type Feature = {
  __typename?: 'Feature';
  category?: Maybe<Scalars['String']['output']>;
  config: FeatureConfig;
  feature: Scalars['String']['output'];
  plans: Array<FeaturePlan>;
};

export type FeatureAccess = {
  __typename?: 'FeatureAccess';
  state: FeatureState;
  value?: Maybe<Scalars['Int']['output']>;
};

export type FeatureAccessForAllPlansResponse = {
  __typename?: 'FeatureAccessForAllPlansResponse';
  plans: Array<FeaturePlan>;
};

export enum FeatureAccessResource {
  FEED = 'FEED',
  PROJECT = 'PROJECT',
  TEAM = 'TEAM'
}

export type FeatureAccessValue = {
  __typename?: 'FeatureAccessValue';
  allPlansFeatures: Scalars['String']['output'];
  disableEditing: Scalars['Boolean']['output'];
};

export type FeatureBreakdown = {
  __typename?: 'FeatureBreakdown';
  credits: Scalars['Int']['output'];
  featureName: Scalars['String']['output'];
  featureType: Scalars['String']['output'];
};

export type FeatureConfig = {
  __typename?: 'FeatureConfig';
  position?: Maybe<Scalars['Int']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
};

export type FeatureExpositionPayload = {
  __typename?: 'FeatureExpositionPayload';
  name: Scalars['String']['output'];
  properties: FeatureProperties;
  suggestedPlan?: Maybe<PlanGroup>;
};

export enum FeatureName {
  ADOPTIMIZE = 'adOptimize',
  ADSERVING = 'adServing',
  /** @deprecated use adServing */
  ADSERVINGLISTING = 'adServingListing',
  /** @deprecated use adServing */
  ADSERVINGREPORT = 'adServingReport',
  ADTAG = 'adTag',
  ADOBEAEM = 'adobeAem',
  ADVANCEDANIMATIONS = 'advancedAnimations',
  ADVANCEDCSS = 'advancedCss',
  ADVANCEDEXPORTSETTINGS = 'advancedExportSettings',
  AIBACKGROUNDREMOVER = 'aiBackgroundRemover',
  AIFUNCTIONALITIES = 'aiFunctionalities',
  AIRESIZE = 'aiResize',
  AITEXT = 'aiText',
  AITEXTTRANSLATE = 'aiTextTranslate',
  AITRANSLATEFEED = 'aiTranslateFeed',
  AIVIDEOGENERATION = 'aiVideoGeneration',
  ANIMATIONS = 'animations',
  APIKEY = 'apiKey',
  AUDIO = 'audio',
  AUTOMATEDREPORTING = 'automatedReporting',
  AUTOSCROLL = 'autoscroll',
  /** @deprecated use aiBackgroundRemover */
  BACKGROUNDREMOVER = 'backgroundRemover',
  BRANDCONTROL = 'brandControl',
  BRANDINSIGHTS = 'brandInsights',
  BRANDKITUPLOADS = 'brandKitUploads',
  BRANDKITS = 'brandKits',
  BRANDSTYLE = 'brandStyle',
  BRANDSTYLERETRAINING = 'brandStyleRetraining',
  BULKEXPORTWITHFEED = 'bulkExportWithFeed',
  BYNDER = 'bynder',
  CATALOGS = 'catalogs',
  CHAT = 'chat',
  CLOUDINTEGRATIONS = 'cloudIntegrations',
  CLOUDINARY = 'cloudinary',
  CMYK = 'cmyk',
  COMMENTS = 'comments',
  CUSTOMBRANDING = 'customBranding',
  CUSTOMROLES = 'customRoles',
  CUSTOMTEMPLATES = 'customTemplates',
  CUSTOMIZETEMPLATEPERMISSIONS = 'customizeTemplatePermissions',
  DESIGNAPPROVALSYSTEM = 'designApprovalSystem',
  DESIGNSHARE = 'designShare',
  DESIGNSHAREWITHPASSWORD = 'designShareWithPassword',
  DESIGNVERSIONHISTORY = 'designVersionHistory',
  DESIGNS = 'designs',
  DOWNLOADAMP = 'downloadAmp',
  DOWNLOADGIF = 'downloadGif',
  DOWNLOADHTML5 = 'downloadHtml5',
  DOWNLOADJPG = 'downloadJpg',
  DOWNLOADMP4 = 'downloadMp4',
  DOWNLOADPDF = 'downloadPdf',
  DOWNLOADPNG = 'downloadPng',
  EDITWITHPROMPT = 'editWithPrompt',
  ENFORCETWOFACTOR = 'enforceTwoFactor',
  EXPORTCREDITS = 'exportCredits',
  EXPORTPSD = 'exportPsd',
  EXPORTREPORTS = 'exportReports',
  FEED = 'feed',
  FEEDBATCHPUBLISH = 'feedBatchPublish',
  FEEDEDIT = 'feedEdit',
  FEEDREALTIMEDATA = 'feedRealTimeData',
  FEEDREMOVEBG = 'feedRemoveBg',
  FEEDROWSDOWNLOAD = 'feedRowsDownload',
  FEEDSIZELIMIT = 'feedSizeLimit',
  FIGMAPLUGIN = 'figmaPlugin',
  FRONTIFY = 'frontify',
  GENAIFLOWS = 'genAIFlows',
  GENERATOR = 'generator',
  GIPHY = 'giphy',
  IDENTITYPROVIDER = 'identityProvider',
  LEARNAGENT = 'learnAgent',
  LIGHTEDITOR = 'lightEditor',
  LOGINACTIVITY = 'loginActivity',
  MAGICANIMATOR = 'magicAnimator',
  METAINTEGRATION = 'metaIntegration',
  MOODBOARDS = 'moodboards',
  MULTIPLEDOWNLOADS = 'multipleDownloads',
  OPTIMIZEAICHAT = 'optimizeAiChat',
  OPTIMIZEANALITICS = 'optimizeAnalitics',
  OPTIMIZEGUI = 'optimizeGui',
  ORANGELOGIC = 'orangeLogic',
  PDFSTANDARDS = 'pdfStandards',
  PHOTOSHOP = 'photoshop',
  PREDICTIVESCORING = 'predictiveScoring',
  PREMIUMELEMENTS = 'premiumElements',
  PREMIUMTEMPLATES = 'premiumTemplates',
  PRODUCTPHOTOGRAPHY = 'productPhotography',
  PROJECTS = 'projects',
  PUBLICAPI = 'publicApi',
  PUBLISHDIRECTLY = 'publishDirectly',
  ROLESANDPERMISSIONS = 'rolesAndPermissions',
  SELECTEDADNETWORKS = 'selectedAdNetworks',
  SHARELINK = 'shareLink',
  SHAREABLEREPORTS = 'shareableReports',
  SHAREPOINT = 'sharepoint',
  SHUTTERSTOCK = 'shutterstock',
  STICKYADS = 'stickyAds',
  STOCKAUDIO = 'stockAudio',
  TEAMASSETS = 'teamAssets',
  TEAMCONTENTEDITORS = 'teamContentEditors',
  TEAMDESIGNERS = 'teamDesigners',
  TEAMUSERS = 'teamUsers',
  UNLIMITEDDOWNLOADS = 'unlimitedDownloads',
  USERGROUPS = 'userGroups',
  VIDEO = 'video',
  ZAPIER = 'zapier'
}

export type FeaturePlan = {
  __typename?: 'FeaturePlan';
  config: FeaturePlanConfig;
  plan: Scalars['String']['output'];
};

export type FeaturePlanConfig = {
  __typename?: 'FeaturePlanConfig';
  state: Scalars['String']['output'];
  value?: Maybe<Scalars['Int']['output']>;
};

export type FeatureProperties = {
  __typename?: 'FeatureProperties';
  actionLabel: Scalars['String']['output'];
  buttonType?: Maybe<Scalars['String']['output']>;
  /** Feature description – translation key */
  description: Array<Scalars['String']['output']>;
  illustration: Scalars['String']['output'];
  /** Gradient key */
  logo?: Maybe<Scalars['String']['output']>;
  secondaryActionLabel?: Maybe<Scalars['String']['output']>;
  /** Feature title – translation key */
  title: Scalars['String']['output'];
  /** Gradient or Color key */
  titleHighlight?: Maybe<Scalars['String']['output']>;
};

export enum FeatureState {
  LIMITED = 'LIMITED',
  NO = 'NO',
  YES = 'YES'
}

export type FeaturebaseTeamData = {
  __typename?: 'FeaturebaseTeamData';
  accountType: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  monthlySpend: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  planName: Scalars['String']['output'];
};

export type FeaturebaseTeamDataPayload = {
  __typename?: 'FeaturebaseTeamDataPayload';
  teams: Array<FeaturebaseTeamData>;
  user: FeaturebaseUserData;
};

export type FeaturebaseUserData = {
  __typename?: 'FeaturebaseUserData';
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FeaturesAccess = {
  __typename?: 'FeaturesAccess';
  /** Limit some access to adOptimize plan */
  adOptimize: FeatureAccess;
  /** Limit access to adServing service */
  adServing: FeatureAccess;
  /** @deprecated use adServing */
  adServingListing: FeatureAccess;
  /** @deprecated use adServing */
  adServingReport: FeatureAccess;
  /** Limit access to activate ad-serving plan */
  adTag?: Maybe<FeatureAccess>;
  /** Limit access to Adobe AEM integration */
  adobeAem: FeatureAccess;
  /** Limit access to advancedAnimations */
  advancedAnimations: FeatureAccess;
  /** Limit access to advanced css */
  advancedCss: FeatureAccess;
  /** Limit access to advanced export settings */
  advancedExportSettings: FeatureAccess;
  aiBackgroundRemover: FeatureAccess;
  /** Limit access to ai when credits ends */
  aiFunctionalities?: Maybe<FeatureAccess>;
  aiResize: FeatureAccess;
  /** Limit access to aiText */
  aiText: FeatureAccess;
  aiTextTranslate: FeatureAccess;
  aiTranslateFeed: FeatureAccess;
  aiVideoGeneration: FeatureAccess;
  /** Limit access to animations in editor */
  animations: FeatureAccess;
  /** Limit access to API Key */
  apiKey: FeatureAccess;
  audio: FeatureAccess;
  automatedReporting: FeatureAccess;
  autoscroll: FeatureAccess;
  /**
   * Limit access to background remover
   * @deprecated use aiBackgroundRemover
   */
  backgroundRemover: FeatureAccess;
  /** Limit access to brand Control */
  brandControl: FeatureAccess;
  brandInsights: FeatureAccess;
  brandKitUploads: FeatureAccess;
  brandKits: FeatureAccess;
  /** Limit access to brand style */
  brandStyle: FeatureAccess;
  brandStyleRetraining: FeatureAccess;
  bulkExportWithFeed: FeatureAccess;
  /** Limit access to bynder integration */
  bynder: FeatureAccess;
  /** Limit access to Product Catalogs (CRE-404, D18) — mirrors feed (catalog = feed identity, D23) */
  catalogs: FeatureAccess;
  chat: FeatureAccess;
  cloudIntegrations: FeatureAccess;
  /** Limit access to Cloudinary integration (picking from its Media Library and saving exports to it) */
  cloudinary: FeatureAccess;
  /** Limit access to CMYK */
  cmyk: FeatureAccess;
  comments: FeatureAccess;
  /** Limit access to custom branding */
  customBranding: FeatureAccess;
  /** Add custom roles */
  customRoles: FeatureAccess;
  customTemplates: FeatureAccess;
  /** Limit access to customize template permissions for Light Editor */
  customizeTemplatePermissions?: Maybe<FeatureAccess>;
  designApprovalSystem: FeatureAccess;
  /** Limit access to sharing designs to at least creator plan in editor */
  designShare: FeatureAccess;
  /** Limit access to sharing designs to at least plus plan in editor */
  designShareWithPassword: FeatureAccess;
  /** Limit access to version history for designs */
  designVersionHistory: FeatureAccess;
  /** Limit number of designs */
  designs: FeatureAccess;
  downloadAmp: FeatureAccess;
  downloadGif: FeatureAccess;
  downloadHtml5: FeatureAccess;
  downloadJpg: FeatureAccess;
  downloadMp4: FeatureAccess;
  downloadPdf: FeatureAccess;
  downloadPng: FeatureAccess;
  editWithPrompt: FeatureAccess;
  /** Limit access to enforce 2FA */
  enforceTwoFactor: FeatureAccess;
  /** Limit access to exports when using credits */
  exportCredits: FeatureAccess;
  /** Limit access to exporting designs as a PSD file */
  exportPsd: FeatureAccess;
  exportReports: FeatureAccess;
  feed: FeatureAccess;
  /** Limit access to feed-row batch publishing to Meta (Enterprise v5+ only) */
  feedBatchPublish: FeatureAccess;
  feedEdit: FeatureAccess;
  feedRealTimeData: FeatureAccess;
  /** Limit access to remove bg on images from feed */
  feedRemoveBg: FeatureAccess;
  /** Limit access to bulk feed download */
  feedRowsDownload: FeatureAccess;
  feedSizeLimit: FeatureAccess;
  figmaPlugin: FeatureAccess;
  /** Limit access to frontify integration */
  frontify: FeatureAccess;
  /** Limit access to start from assets and URL flows */
  genAIFlows: FeatureAccess;
  generator: FeatureAccess;
  giphy: FeatureAccess;
  /** Limit access to identity provider */
  identityProvider: FeatureAccess;
  learnAgent: FeatureAccess;
  /** Limit access to light editor */
  lightEditor: FeatureAccess;
  loginActivity: FeatureAccess;
  magicAnimator: FeatureAccess;
  /** Limit access to metaIntegration */
  metaIntegration: FeatureAccess;
  moodboards: FeatureAccess;
  /** Limit access to download multiple designs at once */
  multipleDownloads?: Maybe<FeatureAccess>;
  optimizeAiChat: FeatureAccess;
  /** Limit access to optimizeAnalitics */
  optimizeAnalitics: FeatureAccess;
  optimizeGui: FeatureAccess;
  /** Limit access to orangeLogic integration */
  orangeLogic: FeatureAccess;
  /** Limit access to PDF/X print standards (PDF/X-1a, PDF/X-4) on CMYK PDF exports */
  pdfStandards: FeatureAccess;
  /** Limit access to photoshop feature */
  photoshop: FeatureAccess;
  predictiveScoring: FeatureAccess;
  /** Limit access to premium elements in editor */
  premiumElements: FeatureAccess;
  /** Limit acces to premium templates */
  premiumTemplates: FeatureAccess;
  productPhotography: FeatureAccess;
  /** Limit access to projects */
  projects: FeatureAccess;
  /** Limit access to publicAPI */
  publicApi: FeatureAccess;
  /** Limit access to publishDirectly */
  publishDirectly: FeatureAccess;
  rolesAndPermissions: FeatureAccess;
  /** Limit access to selectedAdNetworks */
  selectedAdNetworks: FeatureAccess;
  /** Limit access to share link for free users */
  shareLink: FeatureAccess;
  shareableReports: FeatureAccess;
  /** Limit access to SharePoint integration */
  sharepoint: FeatureAccess;
  /** Limit access to shutterstock */
  shutterstock: FeatureAccess;
  /** Limit access to sticky-ads feature */
  stickyAds?: Maybe<FeatureAccess>;
  /** Limit access to stock audio */
  stockAudio: FeatureAccess;
  teamAssets: FeatureAccess;
  /** Limit number of team content editors */
  teamContentEditors: FeatureAccess;
  /** Limit number of team designers */
  teamDesigners: FeatureAccess;
  /** Limit number of users allowed in team */
  teamUsers: FeatureAccess;
  /** Limit access to number of downloads per month */
  unlimitedDownloads?: Maybe<FeatureAccess>;
  userGroups: FeatureAccess;
  video: FeatureAccess;
  /** Limit access to Zapier */
  zapier: FeatureAccess;
};

export type FeaturesComparisonPayload = {
  __typename?: 'FeaturesComparisonPayload';
  features: Array<Feature>;
};

export type Feed = {
  __typename?: 'Feed';
  actionType?: Maybe<FeedActionType>;
  attachedDesigns?: Maybe<Array<FeedDesignAttached>>;
  checksum?: Maybe<Scalars['String']['output']>;
  columns?: Maybe<Array<FeedColumn>>;
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use feedJson */
  data?: Maybe<FeedData>;
  delimiter: DelimiterCsv;
  extraData?: Maybe<Scalars['JSON']['output']>;
  feedError?: Maybe<Scalars['String']['output']>;
  /** Column names behind the last feedError (e.g. columns missing on a FEED_COLUMNS_MISMATCH). */
  feedErrorColumns?: Maybe<Array<Scalars['String']['output']>>;
  feedJson?: Maybe<Scalars['FeedJson']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  hash: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isEdited: Scalars['Boolean']['output'];
  isSample: Scalars['Boolean']['output'];
  logs?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /**
   * Revision of the catalog's product OVERRIDES (count + newest write), which
   * never move the checksum. Lets a mounted board detect override edits from
   * OTHER clients by polling one cheap field (CRE-541). Null when the catalog
   * has no overrides.
   */
  overridesRevision?: Maybe<Scalars['String']['output']>;
  rows: Scalars['Int']['output'];
  sourceType: FeedSourceType;
  status?: Maybe<FeedStatus>;
  targetColumn?: Maybe<Scalars['String']['output']>;
  teamId: Scalars['Int']['output'];
  updateFrequency: UpdateFrequencyType;
  updatedAt: Scalars['Date']['output'];
  url?: Maybe<Scalars['String']['output']>;
};


export type FeedColumnsArgs = {
  input?: InputMaybe<InputFeeds>;
};


export type FeedDataArgs = {
  input?: InputMaybe<InputFeed>;
};


export type FeedFeedJsonArgs = {
  input?: InputMaybe<InputFeed>;
};

export enum FeedActionType {
  BULK_REMOVE = 'bulk_remove',
  BULK_REVERT = 'bulk_revert',
  BULK_SMART_CROP = 'bulk_smart_crop',
  NONE = 'none'
}

export type FeedBindingColumnInput = {
  name: Scalars['String']['input'];
  /** Up to three of the column's values, from the catalog's first rows. */
  samples?: InputMaybe<Array<Scalars['String']['input']>>;
  type: FeedColumnType;
};

/** A design layer the column matcher is asked about: its id (the client's getLayerId), name, type and shown text. */
export type FeedBindingLayerInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  /** The text a text layer shows, or a button's label. */
  text?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

/** The layer property a suggestion binds. Content only for now. */
export enum FeedBindingProperty {
  CONTENT = 'CONTENT'
}

/** NAME: the column shares the layer's name. AI: the model chose it. */
export enum FeedBindingSource {
  AI = 'AI',
  NAME = 'NAME'
}

export type FeedBindingSuggestion = {
  __typename?: 'FeedBindingSuggestion';
  column: Scalars['String']['output'];
  layerId: Scalars['ID']['output'];
  property: FeedBindingProperty;
  source: FeedBindingSource;
};

export type FeedBindingSuggestions = {
  __typename?: 'FeedBindingSuggestions';
  /** False when the model failed or missed its deadline, so the suggestions are the name matches alone. */
  modelAnswered: Scalars['Boolean']['output'];
  suggestions: Array<FeedBindingSuggestion>;
};

export type FeedColumn = {
  __typename?: 'FeedColumn';
  index: Scalars['Int']['output'];
  isManuallyAdded: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /**
   * When true, the renderers (canvas, export, ad-serving) ignore any
   * smartCrop.focalArea saved on cells in this column and fall back to
   * the design-time cover-fit crop. The cell-level focal data is
   * preserved, so toggling back on restores the focal points without
   * re-running detection. Drives the DEFAULT/FOCAL POINT toggle in
   * SmartCropModal and the "Enable focal point for all images in feed"
   * switch in the Properties Panel — both surfaces flip the same flag.
   */
  smartCropDisabled: Scalars['Boolean']['output'];
  type: FeedColumnType;
};

export type FeedColumnBgRemoveEligibility = {
  __typename?: 'FeedColumnBgRemoveEligibility';
  imageOriginalURL?: Maybe<Scalars['String']['output']>;
  imagePreviewURL?: Maybe<Scalars['String']['output']>;
  isEligible: Scalars['Boolean']['output'];
};

export enum FeedColumnType {
  ALL = 'all',
  BOOLEAN = 'boolean',
  COLOR = 'color',
  IMAGE = 'image',
  LANGUAGE = 'language',
  NUMBER = 'number',
  STRING = 'string',
  SVG = 'svg',
  URL = 'url',
  VIDEO = 'video'
}

/** @deprecated use FeedJson scalar instead */
export type FeedData = {
  __typename?: 'FeedData';
  columns: Array<Scalars['String']['output']>;
  data: Array<Array<Scalars['String']['output']>>;
};

export type FeedDesignAttached = {
  __typename?: 'FeedDesignAttached';
  hash: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastUpdatedBy?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  thumb?: Maybe<Scalars['String']['output']>;
  type: DesignType;
  updatedAt: Scalars['Date']['output'];
  updatedByUser?: Maybe<ByUser>;
};

export type FeedDownloadInterval = {
  /** @deprecated Use range instead */
  end?: InputMaybe<Scalars['Int']['input']>;
  /** Interpret range values as dense positions within the design's product set. */
  productSetOrdinals?: InputMaybe<Scalars['Boolean']['input']>;
  range?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use range instead */
  start?: InputMaybe<Scalars['Int']['input']>;
};

/** @deprecated checkFeedFields mutation has been removed */
export type FeedFieldCheck = {
  __typename?: 'FeedFieldCheck';
  hasDuplicatedIds: Scalars['Boolean']['output'];
  missingFields: Array<Scalars['String']['output']>;
  wrongFormatFields: Array<Scalars['String']['output']>;
};

export type FeedFieldsValidationInput = {
  designHash: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type FeedFieldsValidationPayload = {
  __typename?: 'FeedFieldsValidationPayload';
  emptyValueFields: Array<Scalars['String']['output']>;
  hasDuplicatedIds: Scalars['Boolean']['output'];
  missingFields: Array<Scalars['String']['output']>;
  /**
   * CRE-510. The Meta catalog this design's feed was IMPORTED from, or null when it was not
   * imported from one (every feed whose sourceType is not 'meta').
   *
   * Publishing back into that same catalog is only safe as a supplementary write, so the
   * publish dialog uses this to restrict the mode picker. It drives the UI ONLY — the same
   * restriction is re-derived server-side in resolveDpaPublishMode, because a disabled radio
   * is not a safety control and the mutation accepts whatever it is sent (CRE-464).
   *
   * Deliberately this one derived id rather than the feed's extraData blob, which also holds
   * the connector's accountId and businessId and has no business reaching the client.
   *
   * (No backticks in this description: the whole file is a gql template literal.)
   */
  sourceMetaCatalogId?: Maybe<Scalars['String']['output']>;
  wrongFormatFields: Array<Scalars['String']['output']>;
};

export type FeedFocalArea = {
  __typename?: 'FeedFocalArea';
  h: Scalars['Float']['output'];
  w: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type FeedFocalAreaInput = {
  h: Scalars['Float']['input'];
  w: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type FeedMatchBinding = {
  __typename?: 'FeedMatchBinding';
  column: Scalars['String']['output'];
  layer: Scalars['String']['output'];
};

export type FeedMatchColumn = {
  name: Scalars['String']['input'];
  type: FeedColumnType;
};

export type FeedMatchLayer = {
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type FeedMatchedResult = {
  __typename?: 'FeedMatchedResult';
  bindings: Array<FeedMatchBinding>;
};

/** How a feed mutation executes its data fetch (spec §3.2): INLINE = legacy in-request; ASYNC = enqueue to feed-sync, poll feed status. */
export enum FeedProcessingMode {
  ASYNC = 'ASYNC',
  INLINE = 'INLINE'
}

export type FeedRow = {
  __typename?: 'FeedRow';
  /** Opaque revision binding rowData to the design-feed attachment that selected it. */
  attachmentRevision?: Maybe<Scalars['String']['output']>;
  checksum?: Maybe<Scalars['String']['output']>;
  /**
   * The design's persisted product-set scope (CRE-447) — hydrates the editor
   * so an advertised design stays scoped after a reload. Null = whole catalog.
   */
  productSetId?: Maybe<Scalars['Int']['output']>;
  productSetName?: Maybe<Scalars['String']['output']>;
  /** Absolute row represented by rowData. */
  row?: Maybe<Scalars['Int']['output']>;
  rowData?: Maybe<Scalars['JSON']['output']>;
};

export type FeedRowWithIndex = {
  __typename?: 'FeedRowWithIndex';
  index: Scalars['Int']['output'];
  rowData: Array<Scalars['FeedCellValue']['output']>;
  /** Stable row identity when the producer exposes one */
  rowKey?: Maybe<Scalars['String']['output']>;
};

export type FeedRows = {
  __typename?: 'FeedRows';
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether a requested product-set scope still resolves. False means this response widened to All Products; null when no scope was requested. */
  productSetScopeResolved?: Maybe<Scalars['Boolean']['output']>;
  /** When scoped to a product set (CRE-438): the set's absolute row indices, in order, for the panel's counter/stepper/dropdown. Null/absent when unscoped. */
  rowIndices?: Maybe<Array<Scalars['Int']['output']>>;
  /** For count-only scoped reads: the requested absolute row's 1-based position in the product set, or null when it is not a member. */
  rowOrdinal?: Maybe<Scalars['Int']['output']>;
  rows: Array<FeedRowWithIndex>;
  totalCount: Scalars['Int']['output'];
};

export type FeedSample = {
  __typename?: 'FeedSample';
  createdAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  targetColumn?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  url: Scalars['String']['output'];
};

export enum FeedSourceType {
  CLOUDBEDS = 'cloudbeds',
  CSV_TSV = 'csv_tsv',
  ENTAIN = 'entain',
  FINANCE = 'finance',
  MANUAL = 'manual',
  META = 'meta',
  SHOPIFY = 'shopify',
  SUPERBET = 'superbet',
  TRANSLATION = 'translation',
  XML = 'xml'
}

export enum FeedStatus {
  ERROR = 'error',
  INITIAL = 'initial',
  PROCESSING = 'processing',
  SUCCESS = 'success'
}

/** Defines how variations from a feed are displayed. */
export enum FeedVariationDisplay {
  /** A/B test display mode. */
  ABNTEST = 'abntest',
  /** Dynamic content display mode. */
  DYNAMIC = 'dynamic',
  /** Looping display mode. */
  LOOP = 'loop',
  /** Display a specific row from the feed. */
  SPECIFIC_ROW = 'specific_row'
}

/** Levels of Zapier integration feedback. */
export enum FeedbackLevel {
  /** Level 1 feedback shown. */
  LEVEL1 = 'LEVEL1',
  /** Level 2 feedback shown. */
  LEVEL2 = 'LEVEL2',
  /** No feedback shown. */
  NONE = 'NONE'
}

export type Feeds = {
  __typename?: 'Feeds';
  count: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  items: Array<Feed>;
};

/** Response after fetching a team user group. */
export type FetchTeamUserGroupPayload = {
  __typename?: 'FetchTeamUserGroupPayload';
  /** The requested team user group. */
  group: TeamUserGroup;
};

export type FetcherBrandIdentity = {
  __typename?: 'FetcherBrandIdentity';
  brandTone?: Maybe<Array<Scalars['String']['output']>>;
  brandValues: Scalars['String']['output'];
  brandVoice: Scalars['String']['output'];
  exampleSentence: Scalars['String']['output'];
};

export type FetcherFont = {
  __typename?: 'FetcherFont';
  allUrls?: Maybe<Array<FetcherFontUrl>>;
  fontStyle: Scalars['String']['output'];
  fontWeight: Scalars['String']['output'];
  frequency: Scalars['Int']['output'];
  isCustom: Scalars['Boolean']['output'];
  isFallback: Scalars['Boolean']['output'];
  isGoogle: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type FetcherFontUrl = {
  __typename?: 'FetcherFontUrl';
  fontStyle: Scalars['String']['output'];
  fontWeight: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type FetcherFontsData = {
  __typename?: 'FetcherFontsData';
  fonts: Array<FetcherFont>;
};

export type FetcherLogo = {
  __typename?: 'FetcherLogo';
  colors?: Maybe<Array<Scalars['String']['output']>>;
  favicon?: Maybe<Scalars['String']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  svg?: Maybe<Scalars['String']['output']>;
  svg64?: Maybe<Scalars['String']['output']>;
};

export type FetcherLogoData = {
  __typename?: 'FetcherLogoData';
  logo: FetcherLogo;
};

export type FetcherMediaData = {
  __typename?: 'FetcherMediaData';
  media: Array<FetcherMediaFile>;
};

export type FetcherMediaFile = {
  __typename?: 'FetcherMediaFile';
  /** @deprecated Field no longer supported */
  background: Scalars['String']['output'];
  backgroundType: ImageBackgroundType;
  cropArea?: Maybe<MediaFileCropArea>;
  hasText: Scalars['Boolean']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type FetcherPaletteData = {
  __typename?: 'FetcherPaletteData';
  palette: Array<Scalars['String']['output']>;
};

export type FetcherScreenshotData = {
  __typename?: 'FetcherScreenshotData';
  screenshot: Scalars['String']['output'];
};

export type FetcherStyle = {
  __typename?: 'FetcherStyle';
  accentColor: Scalars['String']['output'];
  accentContrastColor: Scalars['String']['output'];
  backgroundColor: Scalars['String']['output'];
  borderRadius: Scalars['Int']['output'];
  textColor: Scalars['String']['output'];
};

export type FetcherStyleData = {
  __typename?: 'FetcherStyleData';
  style: FetcherStyle;
};

export type FetcherText = {
  __typename?: 'FetcherText';
  essentialText?: Maybe<Scalars['String']['output']>;
  headers?: Maybe<Array<FetcherTextHeader>>;
  innerText: Scalars['String']['output'];
};

export type FetcherTextData = {
  __typename?: 'FetcherTextData';
  text: FetcherText;
};

export type FetcherTextHeader = {
  __typename?: 'FetcherTextHeader';
  level: Scalars['Int']['output'];
  text: Scalars['String']['output'];
};

export type FigFileFonts = {
  __typename?: 'FigFileFonts';
  /** AvailableBrandKitFont list, as canImportFigmaToProject returns it. */
  availableFonts: Scalars['JSON']['output'];
  /** AvailableBrandKitFont list, as canImportFigmaToProject returns it. */
  builtInFonts: Scalars['JSON']['output'];
  /** The plugin check's refusals (no Brand Kit, no designs left); the frame lists are empty when there are any. */
  errors: Array<Scalars['String']['output']>;
  /** One MissingFontFamily list per input frame, as the public API's canImportFigmaToProject returns them. */
  frames: Array<Scalars['JSON']['output']>;
};

export type FigFileImportStatus = {
  __typename?: 'FigFileImportStatus';
  /** The job the key's current claim is for; null once the claim expired. */
  claimJobId?: Maybe<Scalars['String']['output']>;
  designUrl?: Maybe<Scalars['String']['output']>;
  progressStep?: Maybe<Scalars['String']['output']>;
  /** NOT_EXISTS when no job has reported for the key within the last hour. */
  status: ParseStatus;
};

export type FigFileJobPayload = {
  __typename?: 'FigFileJobPayload';
  key: Scalars['String']['output'];
};

export type FigFileStatus = {
  __typename?: 'FigFileStatus';
  /** The created design, once an import succeeded. */
  designUrl?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  progressCompleted?: Maybe<Scalars['Int']['output']>;
  /** Current processing step identifier, as the plugin import reports it. */
  progressStep?: Maybe<Scalars['String']['output']>;
  progressTotal?: Maybe<Scalars['Int']['output']>;
  /** NOT_EXISTS when no job has reported for the key within the last hour. */
  status: ParseStatus;
  /** A five-minute link to the STRUCTURE job's structure.json, set while the status is SUCCESS. */
  structureUrl?: Maybe<Scalars['String']['output']>;
};

export type FigFileUploadUrl = {
  __typename?: 'FigFileUploadUrl';
  fields: Scalars['JSON']['output'];
  /** The import key the later .fig calls take. */
  key: Scalars['String']['output'];
  /** The largest file the upload accepts, in bytes. */
  maxSizeBytes: Scalars['Int']['output'];
  /**
   * POST the file here as multipart form data: every entry of fields, then the file as the last part. Send no
   * other field (no ACL, no Content-Type): S3 refuses a POST carrying a field the signature does not list.
   */
  url: Scalars['String']['output'];
};

export type FinalizeCreditTransactionInput = {
  transactionId: Scalars['Int']['input'];
};

export type FinanceDataInstrument = {
  __typename?: 'FinanceDataInstrument';
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
};

export type FinanceDataInstruments = {
  __typename?: 'FinanceDataInstruments';
  commodities: Array<FinanceDataInstrument>;
  cryptocurrency: Array<FinanceDataInstrument>;
  currency: Array<FinanceDataInstrument>;
  metals: Array<FinanceDataInstrument>;
};

export type FinanceDataPair = {
  __typename?: 'FinanceDataPair';
  from: Scalars['String']['output'];
  to?: Maybe<Scalars['String']['output']>;
};

export type FinanceDataPairs = {
  __typename?: 'FinanceDataPairs';
  commodities: Array<FinanceDataPair>;
  cryptocurrency: Array<FinanceDataPair>;
  currency: Array<FinanceDataPair>;
  metals: Array<FinanceDataPair>;
};

export type FinancialData = {
  __typename?: 'FinancialData';
  instruments: FinanceDataInstruments;
  pairs: FinanceDataPairs;
};

/** Response after fixing media from URL issues. */
export type FixMediaFromUrl = {
  __typename?: 'FixMediaFromUrl';
  /** Whether the operation was successful. */
  result: Scalars['Boolean']['output'];
};

/**
 * Input for fixing media assets with URL issues.
 * Administrative function for addressing data problems.
 */
export type FixMediaFromUrlInput = {
  /** ID of the brand kit containing media to fix. */
  brandKitId: Scalars['Int']['input'];
};

/** One target's flex-resized result. Null when flex could not produce a layout. */
export type FlexResizeResult = {
  __typename?: 'FlexResizeResult';
  jsonDesign: Scalars['JSON']['output'];
};

export type FocalPointResult = {
  __typename?: 'FocalPointResult';
  naturalHeight: Scalars['Int']['output'];
  naturalWidth: Scalars['Int']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type Folder = {
  __typename?: 'Folder';
  apiGenerated: Scalars['Boolean']['output'];
  createdAt: Scalars['Date']['output'];
  createdByUser?: Maybe<ByUser>;
  duplicating?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  isParent?: Maybe<Scalars['Boolean']['output']>;
  /** Ancestor folder names from root to the immediate parent (excludes the folder itself). Lets the move dialog show where a search match lives. */
  location?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  /** Ancestor folders from root to the immediate parent (excludes the folder itself). Returned ONLY to a caller with direct access to the folder's location (team owner/admin, project creator/member/group, brand-kit template); a share-through caller who reached the leaf folder via a folder share gets null, so ancestor names/ids above the share boundary are never exposed. Nullable by design: that authorization null, and a failed ancestry walk, must not null out the folder payload its consumers render. Free ONLY on the single-folder query, where the FOLDER access directive has already walked this folder's ancestry (per-request DataLoader cache hit). On folder collections nothing warms the per-item keys, so selecting it costs the access check plus one ancestry walk (~3 queries per ancestor level) per returned folder — extend the folder request-work contract before adding a collection consumer. */
  path?: Maybe<Array<Parent>>;
  projectId: Scalars['Int']['output'];
  publicStatus: PublicStatus;
  shareHash: Scalars['String']['output'];
  shared: SharedPayload;
  sharedBy?: Maybe<ByUser>;
  template?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['Date']['output'];
  updatedByUser?: Maybe<ByUser>;
};

export type FolderSharedTo = {
  __typename?: 'FolderSharedTo';
  groups: Array<TeamUserGroup>;
  users: Array<TeamUser>;
};

export type FolderTreeItem = {
  __typename?: 'FolderTreeItem';
  apiGenerated?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  projectId?: Maybe<Scalars['Int']['output']>;
  shared: Scalars['Boolean']['output'];
  subFolders: Array<Scalars['Int']['output']>;
  template?: Maybe<Scalars['Boolean']['output']>;
};

export type FolderTreePayload = {
  __typename?: 'FolderTreePayload';
  mainFolders: Array<FolderTreeItem>;
  sharedFolders: Array<FolderTreeItem>;
  templatesFolders: Array<FolderTreeItem>;
};

export type Folders = {
  __typename?: 'Folders';
  items: Array<Folder>;
  path: Array<Parent>;
  rootFolderHash?: Maybe<Scalars['String']['output']>;
};

export enum FoldersOrderBy {
  NAME = 'NAME',
  UPDATED_AT = 'UPDATED_AT'
}

/** Font information. */
export type Font = {
  __typename?: 'Font';
  /** Checksum of the font file for integrity verification. */
  checksum: Scalars['String']['output'];
  /** ID of the user who created the font. */
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** Font family name. */
  family: Scalars['String']['output'];
  /** URL to the @font-face CSS. */
  fontFaceUrl: Scalars['String']['output'];
  /** URL to the font family CSS. */
  fontFamilyUrl: Scalars['String']['output'];
  /** Unique identifier for the font. */
  id: Scalars['Int']['output'];
  /** Raw line-box metrics extracted from the font file. Null until parsed under the metric-overrides feature. */
  metrics?: Maybe<FontMetrics>;
  /** Whether metric overrides are disabled for this font variant. */
  metricsOverrideDisabled: Scalars['Boolean']['output'];
  /** Display name of the font. */
  name: Scalars['String']['output'];
  /** Font subfamily name (Regular, Italic, etc.). */
  subFamily: Scalars['String']['output'];
  /** URL to the SVG representation. */
  svgUrl: Scalars['String']['output'];
  /** URL to the SVG weight representation. */
  svgWeightUrl: Scalars['String']['output'];
  /** User who uploaded the font. */
  uploadedBy?: Maybe<User>;
  /** Font version string. */
  version: Scalars['String']['output'];
  /** Font weight (400, 700, etc.). */
  weight: Scalars['Int']['output'];
  /** The weights a variable font's one file draws, from its wght axis. Null for a static font. */
  weightRange?: Maybe<FontWeightRange>;
};

/** Result of checking an uploaded font file against the browsers' font sanitizer. */
export type FontBrowserCheckPayload = {
  __typename?: 'FontBrowserCheckPayload';
  /** Why browsers refuse the file as uploaded. Empty unless the status is REPAIRABLE or REFUSED. */
  problems: Array<FontBrowserProblem>;
  /** What browsers make of the file. */
  status: FontBrowserStatus;
};

/** One reason browsers refuse a font file, as their sanitizer states it. */
export type FontBrowserProblem = {
  __typename?: 'FontBrowserProblem';
  /** The sanitizer's own message. */
  message: Scalars['String']['output'];
  /** The font table it rejected (cmap, glyf, …). Empty when the message names none. */
  table: Scalars['String']['output'];
};

/** What browsers make of an uploaded font file. */
export enum FontBrowserStatus {
  /** Browsers accept the file as uploaded. */
  ACCEPTED = 'ACCEPTED',
  /** Browsers refuse the file, and the automatic fix does not change that. */
  REFUSED = 'REFUSED',
  /** Browsers refuse the file as uploaded and accept it after the automatic fix. */
  REPAIRABLE = 'REPAIRABLE',
  /** No verdict to act on: the check could not run, or what it found does not settle what browsers do (a table they pass through unchecked, or a fix that could not be checked). Upload the file as usual. */
  UNCHECKED = 'UNCHECKED'
}

/** Font details and metadata. */
export type FontDetailsPayload = {
  __typename?: 'FontDetailsPayload';
  /** Font family name. */
  family: Scalars['String']['output'];
  /** URL to the @font-face CSS. */
  fontFaceUrl: Scalars['String']['output'];
  /** URL to the font family CSS. */
  fontFamilyUrl: Scalars['String']['output'];
  /** Display name of the font. */
  name: Scalars['String']['output'];
  /** Font subfamily name (Regular, Italic, etc.). */
  subFamily: Scalars['String']['output'];
  /** URL to the SVG representation. */
  svgUrl: Scalars['String']['output'];
  /** URL to the SVG weight representation. */
  svgWeightUrl: Scalars['String']['output'];
  /** Font version string. */
  version: Scalars['String']['output'];
  /** Font weight (400, 700, etc.). */
  weight: Scalars['Int']['output'];
  /** The weights a variable font's one file draws, from its wght axis. Null for a static font. */
  weightRange?: Maybe<FontWeightRange>;
};

/** Structure for adding a font from a URL. */
export type FontFromUrl = {
  /** Name of the font. */
  name: Scalars['String']['input'];
  /** Array of URLs to font files (different formats or weights). */
  urls: Array<Scalars['String']['input']>;
};

/** Raw font-metric values used to derive @font-face ascent/descent/line-gap overrides. */
export type FontMetrics = {
  __typename?: 'FontMetrics';
  capHeight?: Maybe<Scalars['Int']['output']>;
  hhea: FontMetricsHhea;
  os2: FontMetricsOs2;
  unitsPerEm: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  xHeight?: Maybe<Scalars['Int']['output']>;
};

/** Line-box metrics read from the font file's hhea table. */
export type FontMetricsHhea = {
  __typename?: 'FontMetricsHhea';
  ascender: Scalars['Int']['output'];
  descender: Scalars['Int']['output'];
  lineGap: Scalars['Int']['output'];
};

/** Line-box metrics read from the font file's OS/2 table. */
export type FontMetricsOs2 = {
  __typename?: 'FontMetricsOs2';
  fsSelection: Scalars['Int']['output'];
  sTypoAscender: Scalars['Int']['output'];
  sTypoDescender: Scalars['Int']['output'];
  sTypoLineGap: Scalars['Int']['output'];
  usWinAscent: Scalars['Int']['output'];
  usWinDescent: Scalars['Int']['output'];
  useTypoMetrics: Scalars['Boolean']['output'];
};

/** The lightest and heaviest weight a variable font draws. */
export type FontWeightRange = {
  __typename?: 'FontWeightRange';
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
};

export type GtmPaymentDetailsPayload = {
  __typename?: 'GTMPaymentDetailsPayload';
  invoice?: Maybe<Invoice>;
  invoiceCount: Scalars['Int']['output'];
  paymentMethod?: Maybe<PaymentTypes>;
  total?: Maybe<Scalars['Float']['output']>;
  transationId?: Maybe<Scalars['String']['output']>;
};

/** Gender distribution statistics (legacy audience analytics) */
export type GenderDistributionItem = {
  __typename?: 'GenderDistributionItem';
  /** Count of users in this gender category */
  count: Scalars['Int']['output'];
  /** Gender identifier */
  gender: Scalars['String']['output'];
  /** Percentage of total audience */
  percentage: Scalars['Float']['output'];
};

/** General statistics about a brand's advertising */
export type GeneralStats = {
  __typename?: 'GeneralStats';
  /** Number of currently active ads */
  activeAdsCount: Scalars['Int']['output'];
  /** Number of Facebook followers */
  fbFollowers?: Maybe<Scalars['Int']['output']>;
  /** Timestamp of the first ad published */
  firstAdDate?: Maybe<Scalars['Float']['output']>;
  /** Number of Instagram followers */
  igFollowers?: Maybe<Scalars['Int']['output']>;
  /** Timestamp of the most recent ad published */
  lastAdDate?: Maybe<Scalars['Float']['output']>;
  /** Total number of ads found */
  totalAds: Scalars['Int']['output'];
};

export type GenerateContentVariationsResult = {
  __typename?: 'GenerateContentVariationsResult';
  jobId: Scalars['Int']['output'];
};

export type GenerateDesignNameResult = {
  __typename?: 'GenerateDesignNameResult';
  name: Scalars['String']['output'];
};

export enum GenerateFromContentMode {
  BEST = 'BEST',
  FAST = 'FAST'
}

export type GenerateVeevaNotes = {
  __typename?: 'GenerateVeevaNotes';
  text: Scalars['String']['output'];
};

export type GenerateVeevaPdfResponse = {
  __typename?: 'GenerateVeevaPdfResponse';
  jobId: Scalars['String']['output'];
};

export type GenerateVeevaPdfStatusResponse = {
  __typename?: 'GenerateVeevaPdfStatusResponse';
  status: Scalars['String']['output'];
  /** @deprecated Field no longer supported */
  url?: Maybe<Scalars['String']['output']>;
  urls?: Maybe<Scalars['JSON']['output']>;
};

export type GeneratedDesignFromImageResult = {
  __typename?: 'GeneratedDesignFromImageResult';
  data?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  status?: Maybe<ImageGenerationStatus>;
};

export type GeneratedDesignResult = {
  __typename?: 'GeneratedDesignResult';
  hash: Scalars['String']['output'];
  json?: Maybe<Scalars['JSON']['output']>;
};

export type GeneratedEmbedCodeResult = {
  __typename?: 'GeneratedEmbedCodeResult';
  code: Scalars['String']['output'];
};

export type GeneratedImageResult = {
  __typename?: 'GeneratedImageResult';
  attemptCount?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  mediaHashes?: Maybe<Array<Scalars['String']['output']>>;
  minutes?: Maybe<Scalars['Int']['output']>;
  output?: Maybe<Array<Scalars['String']['output']>>;
  progress?: Maybe<Scalars['Int']['output']>;
  remainingSeconds?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Field no longer supported */
  sid?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ImageGenerationStatus>;
  viewedAt?: Maybe<Scalars['String']['output']>;
};

export type GeneratedTextResult = {
  __typename?: 'GeneratedTextResult';
  texts: Array<Maybe<Scalars['String']['output']>>;
};

export type GeneratedVideoResult = {
  __typename?: 'GeneratedVideoResult';
  id: Scalars['Int']['output'];
  output?: Maybe<Array<Scalars['String']['output']>>;
};

export type GenerationContext = {
  aiAgentPlatform?: InputMaybe<AiAgentPlatform>;
  aiAgentPlatformAccountId?: InputMaybe<Scalars['String']['input']>;
  aiAgentPlatformAccountName?: InputMaybe<Scalars['String']['input']>;
  audio?: InputMaybe<Scalars['Boolean']['input']>;
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  imageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  provider?: InputMaybe<AiProvider>;
  referenceImageOption?: InputMaybe<ProductPhotographyOption>;
  text: Scalars['String']['input'];
  veoOptions?: InputMaybe<VeoOptions>;
};

export enum GenerationLanguage {
  CHINESE = 'CHINESE',
  DUTCH = 'DUTCH',
  ENGLISH = 'ENGLISH',
  FRENCH = 'FRENCH',
  GERMAN = 'GERMAN',
  ITALIAN = 'ITALIAN',
  PORTUGUESE = 'PORTUGUESE',
  ROMANIAN = 'ROMANIAN',
  RUSSIAN = 'RUSSIAN',
  SPANISH = 'SPANISH'
}

export enum GenerationLanguageCode {
  BG = 'BG',
  CS = 'CS',
  DA = 'DA',
  DE = 'DE',
  EL = 'EL',
  EN = 'EN',
  EN_GB = 'EN_GB',
  EN_US = 'EN_US',
  ES = 'ES',
  ET = 'ET',
  FI = 'FI',
  FR = 'FR',
  HU = 'HU',
  ID = 'ID',
  IT = 'IT',
  JA = 'JA',
  KO = 'KO',
  LT = 'LT',
  LV = 'LV',
  NB = 'NB',
  NL = 'NL',
  PL = 'PL',
  PT = 'PT',
  PT_BR = 'PT_BR',
  PT_PT = 'PT_PT',
  RO = 'RO',
  RU = 'RU',
  SK = 'SK',
  SL = 'SL',
  SV = 'SV',
  TR = 'TR',
  UK = 'UK',
  ZH = 'ZH'
}

/** Surface a generation request originated from. Drives per-surface bookkeeping (AI Studio results feed). */
export enum GenerationSource {
  AI_STUDIO = 'AI_STUDIO'
}

export enum GenerationType {
  AD_PROMPT_GENERATION = 'AD_PROMPT_GENERATION',
  AUTOMATED_REPORT_NAME = 'AUTOMATED_REPORT_NAME',
  AUTOMATE_REPORT = 'AUTOMATE_REPORT',
  BACKGROUND_PROMPT_GENERATION = 'BACKGROUND_PROMPT_GENERATION',
  CAMPAIGN_BRIEF = 'CAMPAIGN_BRIEF',
  CONTENT_BASED_PROMPT_GENERATION = 'CONTENT_BASED_PROMPT_GENERATION',
  DESCRIPTION = 'DESCRIPTION',
  GENERATE = 'GENERATE',
  GRAMMAR = 'GRAMMAR',
  HEADLINE = 'HEADLINE',
  IDEAS = 'IDEAS',
  ILLUSTRATION_PROMPT_GENERATION = 'ILLUSTRATION_PROMPT_GENERATION',
  IMAGE_PROMPT_GENERATION = 'IMAGE_PROMPT_GENERATION',
  IMPROVE = 'IMPROVE',
  LINEART_PROMPT_GENERATION = 'LINEART_PROMPT_GENERATION',
  LONGER = 'LONGER',
  PRODUCT_PHOTOGRAPHY_PROMPT_GENERATION = 'PRODUCT_PHOTOGRAPHY_PROMPT_GENERATION',
  PROMPT = 'PROMPT',
  PROMPT_AND_CONTEXT = 'PROMPT_AND_CONTEXT',
  SHAPE_PROMPT_GENERATION = 'SHAPE_PROMPT_GENERATION',
  SHORTER = 'SHORTER',
  SIMPLIFY = 'SIMPLIFY',
  SPLIT_PROMPT = 'SPLIT_PROMPT',
  SUMMARIZE = 'SUMMARIZE',
  TEXT_LAYER_PROMPT_GENERATION = 'TEXT_LAYER_PROMPT_GENERATION',
  TRANSLATE = 'TRANSLATE',
  VIDEO_PROMPT_GENERATION = 'VIDEO_PROMPT_GENERATION',
  VOICE_TONE = 'VOICE_TONE'
}

export enum GenerationVoiceToneType {
  ASSERTIVE = 'ASSERTIVE',
  CASUAL = 'CASUAL',
  CONFIDENT = 'CONFIDENT',
  EMOTIONAL = 'EMOTIONAL',
  FORMAL = 'FORMAL',
  FRIENDLY = 'FRIENDLY',
  HUMOROUS = 'HUMOROUS',
  NORMAL = 'NORMAL',
  OPTIMISTIC = 'OPTIMISTIC',
  PROFESSIONAL = 'PROFESSIONAL',
  SERIOUS = 'SERIOUS'
}

export type GeneratorBrandedCopyData = {
  __typename?: 'GeneratorBrandedCopyData';
  textContent?: Maybe<Array<BrandedCopyAdContent>>;
};

export type GeneratorTextContentData = {
  __typename?: 'GeneratorTextContentData';
  textContent?: Maybe<Array<UrlAdDataTextContent>>;
};

export type GetAccessTokenResult = {
  __typename?: 'GetAccessTokenResult';
  accessToken: Scalars['String']['output'];
  expiresIn: Scalars['Date']['output'];
  grantedScopes?: Maybe<Scalars['String']['output']>;
  refreshToken: Scalars['String']['output'];
  tenantId?: Maybe<Scalars['String']['output']>;
};

export type GetActiveUsageRestrictionsInput = {
  teamId: Scalars['Int']['input'];
};

export type GetAdPublishProgressInput = {
  designId?: InputMaybe<Scalars['Int']['input']>;
  jobId: Scalars['String']['input'];
  platform?: InputMaybe<DpaPlatformType>;
  publishTypePrefix?: InputMaybe<Scalars['String']['input']>;
};

export type GetBrandStatusPayload = {
  __typename?: 'GetBrandStatusPayload';
  status: TeamBrandStatus;
};

/** Response containing brand kit JSON data. */
export type GetBrandkitJsonPayload = {
  __typename?: 'GetBrandkitJsonPayload';
  /** JSON data for the brand kit. */
  brandkitJson: Scalars['BrandKitJson']['output'];
  /** Hash of the brand kit. */
  hash: Scalars['String']['output'];
};

export type GetCloudIntegrationAccountEmailResult = {
  __typename?: 'GetCloudIntegrationAccountEmailResult';
  email?: Maybe<Scalars['String']['output']>;
};

export type GetColumnsFromFeedSourcePayload = {
  __typename?: 'GetColumnsFromFeedSourcePayload';
  columns: Array<Scalars['String']['output']>;
};

/** @deprecated use GetColumnsFromFeedSourcePayload instead */
export type GetColumnsFromFeedSourceUrlPayload = {
  __typename?: 'GetColumnsFromFeedSourceUrlPayload';
  columns: Array<Scalars['String']['output']>;
};

export type GetCreditBalanceInput = {
  teamId: Scalars['Int']['input'];
};

export type GetCreditTiersInput = {
  planCode: Scalars['String']['input'];
};

export type GetCreditTransactionHistoryInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  operationType?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<CreditTransactionStatus>;
  teamId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

export type GetCustomBrandingPayload = {
  __typename?: 'GetCustomBrandingPayload';
  result?: Maybe<CustomBranding>;
};

/** Response containing a design size type. */
export type GetDesignSizeTypePayload = {
  __typename?: 'GetDesignSizeTypePayload';
  /** The matching design size type. */
  result: DesignSizeType;
};

export type GetDpaSettingsInput = {
  designHash: Scalars['String']['input'];
  /** Scope the settings row to a platform family (default: the Meta family) */
  platform?: InputMaybe<DpaPlatformType>;
  teamId: Scalars['Int']['input'];
};

/** Input for retrieving SSO enforcement settings. */
export type GetEnforceTeamSso = {
  /** ID of the team to get settings for. */
  teamId: Scalars['Int']['input'];
};

export type GetFbAdAccountsInput = {
  accountId: Scalars['String']['input'];
  businessId: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

export type GetFbAdCreativeInput = {
  accountId: Scalars['String']['input'];
  adId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type GetFbAdSetsInput = {
  accountId: Scalars['String']['input'];
  adAccountId: Scalars['String']['input'];
  campaignId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

export type GetFbAdsInput = {
  accountId: Scalars['String']['input'];
  adAccountId: Scalars['String']['input'];
  adSetId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

export type GetFbBusinessesInput = {
  accountId: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

export type GetFbCampaignsInput = {
  accountId: Scalars['String']['input'];
  adAccountId: Scalars['String']['input'];
  businessId: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

export type GetFbCatalogsInput = {
  accountId: Scalars['String']['input'];
  businessId: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

export type GetFbCustomConversionsInput = {
  accountId: Scalars['String']['input'];
  adAccountId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type GetFbInstantExperiencesInput = {
  accountId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type GetFbLeadFormsInput = {
  accountId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type GetFbPagesInput = {
  accountId: Scalars['String']['input'];
  businessId: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

export type GetFbPixelsInput = {
  accountId: Scalars['String']['input'];
  adAccountId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type GetFbSavedAudiencesInput = {
  accountId: Scalars['String']['input'];
  adAccountId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type GetFeedCloudbedsApiKeyPayload = {
  __typename?: 'GetFeedCloudbedsApiKeyPayload';
  apiKey?: Maybe<Scalars['String']['output']>;
  expiresIn?: Maybe<Scalars['Int']['output']>;
};

export type GetGoogleAdsCampaignsPayload = {
  __typename?: 'GetGoogleAdsCampaignsPayload';
  data: Array<GoogleAdsCampaignItem>;
  filters: GoogleAdsCampaignsFilters;
  pagination: GoogleAdsCampaignsPagination;
  version: Scalars['String']['output'];
};

export type GetGroupedIntegrationAccountsResult = {
  __typename?: 'GetGroupedIntegrationAccountsResult';
  googleAdsIntegrations: Array<GroupedIntegrationAccount>;
  metaIntegrations: Array<GroupedIntegrationAccount>;
};

export type GetImpressionsTiersInput = {
  planCode: Scalars['String']['input'];
};

export type GetIntegrationAccountsResult = {
  __typename?: 'GetIntegrationAccountsResult';
  accounts: Array<Maybe<IntegrationAccount>>;
};

/** @deprecated This type is no longer used */
export type GetIntegrationCampaignsResult = {
  __typename?: 'GetIntegrationCampaignsResult';
  campaigns: Array<Maybe<IntegrationCampaign>>;
};

export type GetLinkedBusinessLinksInput = {
  teamId: Scalars['Int']['input'];
};

export type GetMetaAdPreviewPayload = {
  __typename?: 'GetMetaAdPreviewPayload';
  adPreview: Scalars['String']['output'];
};

export type GetMetaAdsPayload = {
  __typename?: 'GetMetaAdsPayload';
  ads: Array<MetaAdsItem>;
  data: MetaAdsSummary;
  pagination: MetaAdsPagination;
  success: Scalars['Boolean']['output'];
};

export type GetMoodBoardCommentThreadsInput = {
  moodBoardHash: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};

export type GetMoodBoardCommentsInput = {
  moodBoardHash: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  threadId: Scalars['Int']['input'];
};

export type GetOrCreateDesignSizeTypePayload = {
  __typename?: 'GetOrCreateDesignSizeTypePayload';
  designSizeType: DesignSizeType;
  justCreated: Scalars['Boolean']['output'];
};

export type GetRoomTypesPayload = {
  __typename?: 'GetRoomTypesPayload';
  result: Scalars['JSON']['output'];
};

export type GetSeatsTiersInput = {
  planCode: Scalars['String']['input'];
};

/** Response containing comment settings for shared links. */
export type GetShareLinkCommentsEnabledPayload = {
  __typename?: 'GetShareLinkCommentsEnabledPayload';
  /** Whether comments are enabled on shared links. */
  commentsEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type GetSlackAccessTokenResult = {
  __typename?: 'GetSlackAccessTokenResult';
  accessToken: Scalars['String']['output'];
  connectedEmail?: Maybe<Scalars['String']['output']>;
  slackUserId?: Maybe<Scalars['String']['output']>;
  userToken?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
  workspaceName?: Maybe<Scalars['String']['output']>;
};

export type GetSlackChannelsInput = {
  teamId: Scalars['Int']['input'];
  workspaceId: Scalars['String']['input'];
};

export type GetSlackIntegrationsInput = {
  teamId: Scalars['Int']['input'];
};

export type GetSubscriptionInfoInput = {
  teamId: Scalars['Int']['input'];
};

/** Response containing the system group. */
export type GetSystemGroupPayload = {
  __typename?: 'GetSystemGroupPayload';
  /** The system group for the team. */
  group: TeamUserGroup;
};

export type GetTeamConsumptionReportInput = {
  creditOperationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  teamId: Scalars['Int']['input'];
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Input for retrieving two-factor settings. */
export type GetTeamTwoFactor = {
  /** ID of the team to get settings for. */
  teamId: Scalars['Int']['input'];
};

export type GetUrlContentType = {
  __typename?: 'GetUrlContentType';
  contentType?: Maybe<Scalars['String']['output']>;
};

export enum GifQuality {
  CUSTOM = 'CUSTOM',
  HIGH = 'HIGH',
  LOW = 'LOW',
  MAX_QUALITY = 'MAX_QUALITY',
  MEDIUM = 'MEDIUM',
  OPTIMIZED = 'OPTIMIZED'
}

export type GoodCustomerTeamOwner = {
  __typename?: 'GoodCustomerTeamOwner';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Range of ad counts for Google advertisers */
export type GoogleAdCountRange = {
  __typename?: 'GoogleAdCountRange';
  /** Maximum estimated number of ads */
  max: Scalars['Int']['output'];
  /** Minimum estimated number of ads */
  min: Scalars['Int']['output'];
};

/** Google Ads account information returned from the Google Ads API */
export type GoogleAdsAccount = {
  __typename?: 'GoogleAdsAccount';
  /** Child accounts of the manager account */
  childAccounts?: Maybe<Array<GoogleAdsAccount>>;
  /** Google Ads account ID */
  id: Scalars['String']['output'];
  /** Is this a manager account? */
  isManager: Scalars['Boolean']['output'];
  /** Display name of the Google Ads account */
  name?: Maybe<Scalars['String']['output']>;
  /** Status of the Google Ads account */
  status: GoogleAdsAccountStatus;
};

export enum GoogleAdsAccountStatus {
  /** Indicates a canceled account unable to serve ads. Can be reactivated by an admin user. */
  CANCELED = 'CANCELED',
  /**
   * Indicates a closed account unable to serve ads.
   * Test account will also have CLOSED status. Status is permanent and may not be reopened.
   */
  CLOSED = 'CLOSED',
  /** Indicates an active account able to serve ads. */
  ENABLED = 'ENABLED',
  /** Indicates a suspended account unable to serve ads. May only be activated by Google support. */
  SUSPENDED = 'SUSPENDED',
  /** Used for return value only. Represents value unknown in this version. */
  UNKNOWN = 'UNKNOWN',
  /** Not specified. */
  UNSPECIFIED = 'UNSPECIFIED'
}

/** Response containing list of Google Ads accounts */
export type GoogleAdsAccounts = {
  __typename?: 'GoogleAdsAccounts';
  /** List of available Google Ads accounts */
  accounts: Array<GoogleAdsAccount>;
};

/** Input for fetching Google Ads accounts */
export type GoogleAdsAccountsInput = {
  /** Email of the Google Ads account */
  email: Scalars['String']['input'];
  /** Filter accounts by name (case-insensitive). Searches each manager's whole subtree; matches return flat under their root manager. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Team ID for access control */
  teamId: Scalars['Int']['input'];
};

/** Google Ads Ad Group information */
export type GoogleAdsAdGroup = {
  __typename?: 'GoogleAdsAdGroup';
  /** Ad group ID */
  id: Scalars['String']['output'];
  /** Ad group name */
  name: Scalars['String']['output'];
  /** Ad group status (ENABLED, PAUSED, etc.) */
  status: Scalars['String']['output'];
};

/** Response containing list of Google Ads ad groups */
export type GoogleAdsAdGroups = {
  __typename?: 'GoogleAdsAdGroups';
  /** List of ad groups */
  adGroups: Array<GoogleAdsAdGroup>;
  /** Token for fetching next page of results */
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

/** Input for fetching Google Ads ad groups */
export type GoogleAdsAdGroupsInput = {
  /** Google Ads account ID */
  adAccountId: Scalars['String']['input'];
  /** Campaign ID to filter ad groups by */
  campaignId?: InputMaybe<Scalars['String']['input']>;
  /** Email of the Google Ads account */
  email: Scalars['String']['input'];
  /** Manager account ID */
  managerId?: InputMaybe<Scalars['String']['input']>;
  /** Search query to filter ad groups by name */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Team ID for access control */
  teamId: Scalars['Int']['input'];
};

/** Available Google Ads ad types that can be created from Creatopy designs */
export enum GoogleAdsAdType {
  /** HTML5 Upload Ad - uses HTML5 creative for interactive display ads */
  HTML5_UPLOAD_AD = 'HTML5_UPLOAD_AD',
  /** Image Ad - uses specific image sizes for display placements */
  IMAGE_AD = 'IMAGE_AD',
  /** Responsive Display Ad - automatically adjusts size, appearance, and format to fit available ad spaces */
  RESPONSIVE_DISPLAY_AD = 'RESPONSIVE_DISPLAY_AD'
}

/** Google Ads Asset Group information (used in Performance Max campaigns) */
export type GoogleAdsAssetGroup = {
  __typename?: 'GoogleAdsAssetGroup';
  /** Asset group ID */
  id: Scalars['String']['output'];
  /** Asset group name */
  name: Scalars['String']['output'];
  /** Asset group status (ENABLED, PAUSED, etc.) */
  status: Scalars['String']['output'];
};

/** Response containing list of Google Ads asset groups */
export type GoogleAdsAssetGroups = {
  __typename?: 'GoogleAdsAssetGroups';
  /** List of asset groups */
  assetGroups: Array<GoogleAdsAssetGroup>;
  /** Token for fetching next page of results */
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

/** Input for fetching Google Ads asset groups */
export type GoogleAdsAssetGroupsInput = {
  /** Google Ads account ID */
  adAccountId: Scalars['String']['input'];
  /** Campaign ID to filter asset groups by */
  campaignId?: InputMaybe<Scalars['String']['input']>;
  /** Email of the Google Ads account */
  email: Scalars['String']['input'];
  /** Manager account ID */
  managerId?: InputMaybe<Scalars['String']['input']>;
  /** Search query to filter asset groups by name */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Team ID for access control */
  teamId: Scalars['Int']['input'];
};

/** Google Ads campaign information */
export type GoogleAdsCampaign = {
  __typename?: 'GoogleAdsCampaign';
  /** Campaign ID */
  id: Scalars['String']['output'];
  /** Campaign name */
  name: Scalars['String']['output'];
  /** Campaign serving status (ENABLED, PAUSED, etc.) */
  servingStatus: Scalars['String']['output'];
  /** Campaign status (ENABLED, PAUSED, etc.) */
  status: Scalars['String']['output'];
  /** Campaign type (DISPLAY, PERFORMANCE_MAX, etc.) */
  type: GoogleAdsCampaignType;
};

export type GoogleAdsCampaignItem = {
  __typename?: 'GoogleAdsCampaignItem';
  advertisingChannelType: AdvertisingChannelType;
  allConversions?: Maybe<Scalars['String']['output']>;
  allVisualAssets: Array<Scalars['String']['output']>;
  avgCost?: Maybe<Scalars['String']['output']>;
  avgCpc?: Maybe<Scalars['String']['output']>;
  clicks?: Maybe<Scalars['String']['output']>;
  conversions?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<Scalars['String']['output']>;
  costPerAllConversions?: Maybe<Scalars['String']['output']>;
  costPerConversion?: Maybe<Scalars['String']['output']>;
  ctr?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  impressions?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status: GoogleAdsStatus;
  visualAssetUrl?: Maybe<Scalars['String']['output']>;
  visualAssets: Array<GoogleAdsVisualAsset>;
};

/**
 * Google Ads campaign types supported by Creatopy
 *
 * Maps to Google Ads API CampaignType enum values:
 * - PERFORMANCE_MAX = 10 (Google Ads API)
 * - DISPLAY = 3 (Google Ads API)
 * - SEARCH = 2 (Google Ads API)
 */
export enum GoogleAdsCampaignType {
  /** Display campaigns - Visual ads shown across the Google Display Network */
  DISPLAY = 'DISPLAY',
  /** Performance Max - AI-driven campaigns that run across all Google channels */
  PERFORMANCE_MAX = 'PERFORMANCE_MAX',
  /** Search campaigns - Text ads shown in Google search results (not yet implemented) */
  SEARCH = 'SEARCH'
}

/** Response containing list of Google Ads campaigns */
export type GoogleAdsCampaigns = {
  __typename?: 'GoogleAdsCampaigns';
  /** List of campaigns */
  campaigns: Array<GoogleAdsCampaign>;
  /** Token for fetching next page of results */
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type GoogleAdsCampaignsFilters = {
  __typename?: 'GoogleAdsCampaignsFilters';
  campaignType: Scalars['String']['output'];
  dateRange: Scalars['String']['output'];
  search?: Maybe<Scalars['String']['output']>;
  sortBy: Scalars['String']['output'];
  sortOrder: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

/** Input for fetching Google Ads campaigns */
export type GoogleAdsCampaignsInput = {
  /** Google Ads account ID */
  adAccountId: Scalars['String']['input'];
  /** Email of the Google Ads account */
  email: Scalars['String']['input'];
  /** Manager account ID */
  managerId?: InputMaybe<Scalars['String']['input']>;
  /** Search query to filter campaigns by name */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Team ID for access control */
  teamId: Scalars['Int']['input'];
};

export type GoogleAdsCampaignsPagination = {
  __typename?: 'GoogleAdsCampaignsPagination';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type GoogleAdsIntegrationByTeamUserIdResult = {
  __typename?: 'GoogleAdsIntegrationByTeamUserIdResult';
  connectedEmail: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export type GoogleAdsIntegrationResult = {
  __typename?: 'GoogleAdsIntegrationResult';
  email: Scalars['String']['output'];
  /** @deprecated Always null: integration reads no longer return stored OAuth tokens. */
  refreshToken?: Maybe<Scalars['String']['output']>;
  selected: Scalars['Boolean']['output'];
};

/** Input for getting Google Ads campaign size requirements */
export type GoogleAdsSizeRequirementsInput = {
  campaignType: GoogleAdsCampaignType;
  designId: Scalars['Int']['input'];
  downloadType?: InputMaybe<DownloadType>;
  isNewAssetGroup?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Result containing size requirements for a campaign type */
export type GoogleAdsSizeRequirementsResult = {
  __typename?: 'GoogleAdsSizeRequirementsResult';
  campaignType: GoogleAdsCampaignType;
  requirements: Array<SizeRequirement>;
};

export enum GoogleAdsSortBy {
  ALLCONVERSIONS = 'allConversions',
  AVERAGECPC = 'averageCpc',
  CLICKS = 'clicks',
  CONVERSIONS = 'conversions',
  COST = 'cost',
  COSTPERALLCONVERSIONS = 'costPerAllConversions',
  COSTPERCONVERSION = 'costPerConversion',
  CTR = 'ctr',
  IMPRESSIONS = 'impressions',
  NAME = 'name'
}

export enum GoogleAdsSortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export enum GoogleAdsStatus {
  ENABLED = 'ENABLED',
  PAUSED = 'PAUSED',
  REMOVED = 'REMOVED'
}

export type GoogleAdsVisualAsset = {
  __typename?: 'GoogleAdsVisualAsset';
  fieldType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  level: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Input for getting Google advertiser by ID */
export type GoogleAdvertiserByIdInput = {
  /** Google advertiser ID to fetch details for */
  advertiserId: Scalars['String']['input'];
};

/** Response containing Google advertiser details by ID */
export type GoogleAdvertiserByIdResponse = {
  __typename?: 'GoogleAdvertiserByIdResponse';
  /** Advertiser details */
  data?: Maybe<GoogleSuggestion>;
  /** Error message if request failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Whether the request was successful */
  success: Scalars['Boolean']['output'];
  /** Timestamp of the request */
  timestamp: Scalars['String']['output'];
};

/** Google font information. */
export type GoogleFont = {
  __typename?: 'GoogleFont';
  /** Name of the font family. */
  fontName: Scalars['String']['output'];
  /** Available weight variants for this font. */
  variants: Array<GoogleFontWeight>;
};

/** Weight variant for a Google font. */
export type GoogleFontWeight = {
  __typename?: 'GoogleFontWeight';
  /** Weight value (400, 700, etc.). */
  weight: Scalars['String']['output'];
};

/** A single Google ad suggestion (advertiser or domain) */
export type GoogleSuggestion = {
  __typename?: 'GoogleSuggestion';
  /** Estimated range of active ads for this advertiser */
  adCountRange?: Maybe<GoogleAdCountRange>;
  /** Unique advertiser identifier */
  advertiserId?: Maybe<Scalars['String']['output']>;
  /** Country where the advertiser is based */
  country?: Maybe<Scalars['String']['output']>;
  /** Domain name (for domain type suggestions) */
  domain?: Maybe<Scalars['String']['output']>;
  /** Whether this is a profile page */
  isProfile?: Maybe<Scalars['Boolean']['output']>;
  /** Advertiser name (for advertiser type) */
  name?: Maybe<Scalars['String']['output']>;
  /** Type of suggestion ('advertiser' or 'domain') */
  type: Scalars['String']['output'];
};

/** Google suggestions search result data */
export type GoogleSuggestionsSearchData = {
  __typename?: 'GoogleSuggestionsSearchData';
  /** Original search keyword */
  keyword: Scalars['String']['output'];
  /** Region where the search was performed */
  region: Scalars['String']['output'];
  /** List of suggestions (advertisers and domains) */
  suggestions: Array<GoogleSuggestion>;
  /** Number of unique advertisers found */
  totalAdvertisers: Scalars['Int']['output'];
  /** Number of unique domains found */
  totalDomains: Scalars['Int']['output'];
  /** Total number of suggestions found */
  totalSuggestions: Scalars['Int']['output'];
};

/** Input for searching Google ad suggestions */
export type GoogleSuggestionsSearchInput = {
  /** Country code for geo-specific suggestions */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Maximum number of suggestions to return */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Keyword to search for */
  query: Scalars['String']['input'];
  /** Geographic region for suggestions */
  region?: InputMaybe<Scalars['String']['input']>;
};

/** Response containing Google ad suggestions */
export type GoogleSuggestionsSearchResponse = {
  __typename?: 'GoogleSuggestionsSearchResponse';
  /** Search results data */
  data?: Maybe<GoogleSuggestionsSearchData>;
  /** Error message if search failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Whether the search was successful */
  success: Scalars['Boolean']['output'];
  /** Timestamp of the search */
  timestamp: Scalars['String']['output'];
};

export type GroupedIntegrationAccount = {
  __typename?: 'GroupedIntegrationAccount';
  accounts: Array<IntegrationCustomer>;
  id: Scalars['String']['output'];
  identifier: Scalars['String']['output'];
  platform: AiAgentPlatform;
};

/** Response indicating if a team has Ad Studio access. */
export type HasAdStudioExperimentPayload = {
  __typename?: 'HasAdStudioExperimentPayload';
  /** Whether the team has access to Ad Studio. */
  adStudioAccess?: Maybe<Scalars['Boolean']['output']>;
};

/** @deprecated not used */
export type HasDesignsAdTagActivePayload = {
  __typename?: 'HasDesignsAdTagActivePayload';
  /** Whether the team has designs with active ad tags. */
  result: Scalars['Boolean']['output'];
};

/** Response describing whether a team has ever served an ad. */
export type HasEverServedAdPayload = {
  __typename?: 'HasEverServedAdPayload';
  /** True if the team has ever had ad serving enabled on any design. */
  result: Scalars['Boolean']['output'];
};

/** Duration information for a design by hash. */
export type HashDesignDuration = {
  __typename?: 'HashDesignDuration';
  /** Number of child designs in a set. */
  designsCount: Scalars['Int']['output'];
  /** Duration of the design in seconds. */
  duration: Scalars['Float']['output'];
  /** Hash of the design. */
  hash: Scalars['String']['output'];
  /** Number of slides in the design. */
  slidesCount: Scalars['Int']['output'];
};

export type HashToIdResponse = {
  __typename?: 'HashToIdResponse';
  brandKit?: Maybe<Scalars['Float']['output']>;
  design?: Maybe<Scalars['Float']['output']>;
  feed?: Maybe<Scalars['Float']['output']>;
  font?: Maybe<Scalars['Float']['output']>;
  media?: Maybe<Scalars['Float']['output']>;
  mediaFolder?: Maybe<Scalars['Float']['output']>;
  moodBoard?: Maybe<Scalars['Float']['output']>;
  publicDesign?: Maybe<Scalars['Float']['output']>;
  user?: Maybe<Scalars['Float']['output']>;
};

export type HubAgentStreamPayload = {
  __typename?: 'HubAgentStreamPayload';
  chunk: Scalars['String']['output'];
  done: Scalars['Boolean']['output'];
  embedingsResults: Array<SimilaritySearchResult>;
};

export type HubIntention = {
  __typename?: 'HubIntention';
  createdAt: Scalars['Date']['output'];
  description: Scalars['String']['output'];
  embeddings: Array<HubIntentionEmbedding>;
  id: Scalars['Int']['output'];
  intention: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type HubIntentionEmbedding = {
  __typename?: 'HubIntentionEmbedding';
  createdAt: Scalars['Date']['output'];
  hubIntention: HubIntention;
  hubIntentionId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  phrase: Scalars['String']['output'];
  source: HubIntentionEmbeddingSource;
  updatedAt: Scalars['Date']['output'];
};

export enum HubIntentionEmbeddingSource {
  MANUAL = 'MANUAL',
  USER = 'USER'
}

export type HubspotSubscriptionStatus = {
  __typename?: 'HubspotSubscriptionStatus';
  isUnsubscribed: Scalars['Boolean']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type IgbvReplaceRule = {
  pattern: Scalars['String']['input'];
  replacement: Scalars['String']['input'];
};

export type IgWithBrandVoiceRules = {
  avoids?: InputMaybe<Array<Scalars['String']['input']>>;
  replaces?: InputMaybe<Array<IgbvReplaceRule>>;
  useEmojiFrequency: BvEmojiFrequency;
  useEmojiInSocial: Scalars['Boolean']['input'];
};

export type IdToHashResponse = {
  __typename?: 'IdToHashResponse';
  brandKit: Scalars['String']['output'];
  design: Scalars['String']['output'];
  feed: Scalars['String']['output'];
  font: Scalars['String']['output'];
  media: Scalars['String']['output'];
  mediaFolder: Scalars['String']['output'];
  moodBoard: Scalars['String']['output'];
  publicDesign: Scalars['String']['output'];
  user: Scalars['String']['output'];
};

/** Status of an identity provider invitation. */
export type IdentityProviderInvitationStatus = {
  __typename?: 'IdentityProviderInvitationStatus';
  /** Status of the invitation request. */
  requestStatus?: Maybe<TeamInvitationStatus>;
};

export type IdentityProviderTeamOption = {
  __typename?: 'IdentityProviderTeamOption';
  identityProviderAlias?: Maybe<Scalars['String']['output']>;
  requestStatus?: Maybe<Scalars['String']['output']>;
  team: Team;
};

export type IdentityProviderWithTeam = {
  __typename?: 'IdentityProviderWithTeam';
  requestStatus?: Maybe<Scalars['String']['output']>;
  team: Team;
};

export type IdentityProvidersWithTeams = {
  __typename?: 'IdentityProvidersWithTeams';
  teams: Array<IdentityProviderTeamOption>;
};

/** Result from image analysis using vision AI */
export type ImageAnalysisResult = {
  __typename?: 'ImageAnalysisResult';
  /** Type of content detected in the image */
  contentType: Scalars['String']['output'];
  /** Brief description of the image content */
  description?: Maybe<Scalars['String']['output']>;
  /** Dominant colors in the image (hex codes) */
  dominantColors?: Maybe<Array<Scalars['String']['output']>>;
  /** Suggested actions based on the image content */
  suggestions: Array<Scalars['String']['output']>;
};

export enum ImageBackgroundType {
  OPAQUE = 'OPAQUE',
  TRANSPARENT = 'TRANSPARENT',
  UNIFORM = 'UNIFORM',
  WHITE = 'WHITE'
}

export enum ImageGenerationAspectRatio {
  LANDSCAPE = 'LANDSCAPE',
  MATCH_INPUT_IMAGE = 'MATCH_INPUT_IMAGE',
  PORTRAIT = 'PORTRAIT',
  RATIO_1_2 = 'RATIO_1_2',
  RATIO_1_4 = 'RATIO_1_4',
  RATIO_1_8 = 'RATIO_1_8',
  RATIO_2_1 = 'RATIO_2_1',
  RATIO_2_3 = 'RATIO_2_3',
  RATIO_3_2 = 'RATIO_3_2',
  RATIO_3_4 = 'RATIO_3_4',
  RATIO_4_1 = 'RATIO_4_1',
  RATIO_4_3 = 'RATIO_4_3',
  RATIO_4_5 = 'RATIO_4_5',
  RATIO_5_4 = 'RATIO_5_4',
  RATIO_8_1 = 'RATIO_8_1',
  RATIO_9_21 = 'RATIO_9_21',
  RATIO_21_9 = 'RATIO_21_9',
  SQUARE = 'SQUARE'
}

export enum ImageGenerationQuality {
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM'
}

export enum ImageGenerationStatus {
  FAIL = 'FAIL',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS'
}

export enum ImageGenerationStyle {
  ANIME = 'ANIME',
  BRAND_STYLE = 'BRAND_STYLE',
  DIGITAL_ART = 'DIGITAL_ART',
  ISOMETRIC = 'ISOMETRIC',
  MODEL_3D = 'MODEL_3D',
  NONE = 'NONE',
  PIXEL_ART = 'PIXEL_ART',
  REALISTIC = 'REALISTIC',
  VAPORWAVE = 'VAPORWAVE'
}

export enum ImageGenerationType {
  PROMPT = 'PROMPT',
  PROMPT_AND_CONTEXT = 'PROMPT_AND_CONTEXT',
  VARIANTS = 'VARIANTS'
}

export type ImageSubtleAnimationResult = {
  __typename?: 'ImageSubtleAnimationResult';
  motionType: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
};

export type ImagesFromFeedWithBgRemoved = {
  column: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type ImagesFromFeedWithBgReverted = {
  column: Scalars['String']['input'];
};

export type ImpersonateUserPayload = {
  __typename?: 'ImpersonateUserPayload';
  impersonatedAuthId?: Maybe<Scalars['String']['output']>;
};

/** Identifies the staff member who initiated an impersonation session against a customer account. */
export type ImpersonatorInfo = {
  __typename?: 'ImpersonatorInfo';
  /** Resolved email address of the impersonator from our user database. */
  email?: Maybe<Scalars['String']['output']>;
  /** Keycloak user id of the impersonator. */
  userId?: Maybe<Scalars['String']['output']>;
  /** Keycloak username of the impersonator (typically their work email). */
  username?: Maybe<Scalars['String']['output']>;
};

/** Outcome of a URL import; a failed item never aborts the batch. */
export type ImportDesignMediaFromUrlsResult = {
  __typename?: 'ImportDesignMediaFromUrlsResult';
  failedUrls: Array<Scalars['String']['output']>;
  /** Media ids now linked to the design's library for the imported urls (existing rows are reused, so an id may predate this call). */
  importedMediumIds: Array<Scalars['Int']['output']>;
  importedUrls: Array<Scalars['String']['output']>;
};

/** Outcome of an import; per-key so one dead source URL cannot block the rest. */
export type ImportMediaFromDesignResult = {
  __typename?: 'ImportMediaFromDesignResult';
  /** Keys that could not be imported (e.g. the source URL could not be fetched). */
  failedKeys: Array<Scalars['String']['output']>;
  /** Keys that were linked into the target library. */
  importedKeys: Array<Scalars['String']['output']>;
};

export type ImprovementSuggestions = {
  __typename?: 'ImprovementSuggestions';
  id: Scalars['String']['output'];
  score: Scalars['Int']['output'];
  suggestions: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/** We can index by feedId directly or pass designHash in case of publicFeed from Sharelink */
export type IndexFeedRowsInput = {
  designHash?: InputMaybe<Scalars['String']['input']>;
  feedId?: InputMaybe<Scalars['Int']['input']>;
};

export type IndexFeedRowsPayload = {
  __typename?: 'IndexFeedRowsPayload';
  result?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Input for AI generation rules. */
export type InputAiGenerationRules = {
  /** Copy/writing guidelines (markdown). */
  copy?: InputMaybe<Scalars['String']['input']>;
  /** Things the brand always or never does (markdown). */
  dosAndDonts?: InputMaybe<Scalars['String']['input']>;
  /** Layout guidelines (markdown). */
  layout?: InputMaybe<Scalars['String']['input']>;
};

export type InputAbTest = {
  id: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

export type InputAbTestDesign = {
  designId: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InputAbTests = {
  folderId?: InputMaybe<Scalars['Int']['input']>;
  includeInFolders?: Scalars['Boolean']['input'];
  orderBy?: OrderBy;
  orderType?: OrderType;
  projectId: Scalars['Int']['input'];
};

/** Input for accepting a team invitation. */
export type InputAcceptTeamInvitation = {
  /** ID of the default team to set after accepting (optional). */
  defaultTeamId?: InputMaybe<Scalars['Int']['input']>;
  /** Hash identifier of the invitation. */
  hash: Scalars['String']['input'];
};

export type InputAccess = {
  checkDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Specifies the argument name available on the query input
   * to be used for resolving the team
   */
  idField?: InputMaybe<Scalars['String']['input']>;
  /** If set to true pass checking template permissions if the design is a template */
  ignoreEnforcingTemplateAccessForTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Specifies the iterator id field
   * to be used for resolving the access in a list of objects. Example designs directive
   */
  iteratorIdField?: InputMaybe<Scalars['String']['input']>;
  /**
   * Specify the list of permissions that can access the resource.
   * If you don't specify this will check only if user is in team
   */
  requiredPermissions?: InputMaybe<Array<Permission>>;
  /** Specify the starting point for resolving the team */
  resource: PermissionResource;
  /** If set to true and no id was specified in the query or mutation input it will skip this access check */
  skipIfIdNotSpecified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputAccount = {
  teamId: Scalars['Int']['input'];
};

export type InputAccountStats = {
  teamId: Scalars['Int']['input'];
};

export type InputActivateAddon = {
  teamId: Scalars['Int']['input'];
  threeDSecureToken?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type InputActivateWinBackTrial = {
  planCode: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputAdFormat = {
  height: Scalars['Int']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  platformGuidelines: Scalars['String']['input'];
  requiresCta: Scalars['Boolean']['input'];
  safeZones: Scalars['String']['input'];
  width: Scalars['Int']['input'];
};

/** Input type for querying ad networks. */
export type InputAdNetworks = {
  /** Filter by ad network option (HTML5 or AD_SERVING). */
  option?: InputMaybe<AdNetworkOption>;
  /** Filter by status (active/inactive). */
  status?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the team for which to retrieve ad networks. */
  teamId: Scalars['Int']['input'];
};

/** Input for querying ad serving information for a design. */
export type InputAdServing = {
  /** The ID of the design. */
  designId: Scalars['Int']['input'];
};

/** @deprecated not used */
export type InputAdServingAccess = {
  adServingAccess: Scalars['Boolean']['input'];
  teamId: Scalars['Int']['input'];
};

/** Input for querying the ad serving networks for a design. */
export type InputAdServingNetworks = {
  /** The ID of the design. */
  designId: Scalars['Int']['input'];
};

/** Input for ad serving properties, combining stick settings and live feed variations. */
export type InputAdServingProps = {
  /** Settings for how the design sticks to the page. */
  designStickSettings?: InputMaybe<InputDesignStickSettings>;
  /** Settings for live feed variations. */
  liveFeedVariation?: InputMaybe<InputLiveFeedVariation>;
  /** Indicates if window.open should use noreferrer. */
  windowOpenNoReferrer?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for sending ad serving code via email. */
export type InputAdServingSendCodeViaEmail = {
  /** The ID of the design. */
  designId: Scalars['Int']['input'];
  /** A list of email addresses to send the code to. */
  emails: Array<Scalars['String']['input']>;
  /** Include this design's whole variation family in the emailed archives. */
  includeVariations?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if the code should also be sent to the current user. */
  sendToUser: Scalars['Boolean']['input'];
  /**
   * Narrow the emailed archives to these family members, as the Variation control
   * narrows the blob and the download. A hash outside the derived family is
   * ignored; null means every member.
   */
  variationHashes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input for querying the ad serving status for a design. */
export type InputAdServingStatus = {
  /** The ID of the design. */
  designId: Scalars['Int']['input'];
};

/** Input for reading several of ONE variation family's size documents in a single request. */
export type InputAdStudioFamilySizeJsons = {
  /**
   * The hash naming the family: the master top row, or a top-level VARIATION of it that
   * the caller may expand into its siblings - the Variations tab is routinely open on one,
   * and `Design.variations` already expands it the same way. A SIZE CHILD is not
   * accepted, because nothing expands one today. This is the hash `@access` authorizes,
   * and the family every requested size must belong to.
   */
  hash: Scalars['String']['input'];
  /**
   * Hashes of the size rows to return documents for. A hash outside the family named by
   * `hash` is OMITTED from the result, never resolved - it is not an error, because the
   * caller's roster can legitimately race a removal. At most 50 per call.
   */
  hashes: Array<Scalars['String']['input']>;
};

export type InputAdStudioTestClaimed = {
  teamId: Scalars['Int']['input'];
};

export type InputAdTagContactMe = {
  designId?: InputMaybe<Scalars['Int']['input']>;
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputAdTagDynamicVar = {
  defaultValue: Scalars['String']['input'];
  macroCode: Scalars['String']['input'];
};

export type InputAdTagExternalDesignTrackingUrl = {
  trackingType: AdTagExternalDesignTrackingType;
  url: Scalars['String']['input'];
};

export type InputAdTagFeatureState = {
  cancelSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  teamId: Scalars['Int']['input'];
  terminateOldAdServing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputAdTagGenerateCode = {
  codeFormat: AdTagCodeFormat;
  designId: Scalars['Int']['input'];
  /** Include this design's whole variation family, derived server-side from the master's id. */
  includeVariations?: InputMaybe<Scalars['Boolean']['input']>;
  networkIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /**
   * Narrows the derived family to these member hashes; null selects every member.
   * A FILTER, never the authorization surface: a hash outside the family is ignored.
   */
  variationHashes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InputAdTagProps = {
  designStickSettings?: InputMaybe<InputDesignStickSettings>;
};

export type InputAdTagReport = {
  breakdowns?: InputMaybe<Array<InputMaybe<AdTagReportBreakdowns>>>;
  designs?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  from: Scalars['Date']['input'];
  networks?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  teamId: Scalars['Int']['input'];
  to: Scalars['Date']['input'];
};

export type InputAdTagReportFilters = {
  breakdowns?: InputMaybe<Array<InputMaybe<AdTagReportBreakdowns>>>;
  designs?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  from?: InputMaybe<Scalars['Date']['input']>;
  networks?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export type InputAdTagReportScheduleRun = {
  emails: Array<Scalars['String']['input']>;
  filters: InputAdTagReportFilters;
  id: Scalars['Int']['input'];
  range?: InputMaybe<AdTagReportScheduleRange>;
  scheduleId?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type InputAdTagReports = {
  orderBy?: OrderBy;
  orderType?: OrderType;
  teamId: Scalars['Int']['input'];
};

export type InputAdTagSchedule = {
  daysSelected?: InputMaybe<Array<InputMaybe<AdTagReportScheduleDays>>>;
  emails: Array<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  everyNum?: InputMaybe<Scalars['Int']['input']>;
  everySelection?: InputMaybe<AdTagReportScheduleEvery>;
  exeTime: Scalars['String']['input'];
  expression?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<AdTagReportScheduleFrequency>;
  id?: InputMaybe<Scalars['Int']['input']>;
  onDay?: InputMaybe<Scalars['Int']['input']>;
  range?: InputMaybe<AdTagReportScheduleRange>;
  startDate: Scalars['Date']['input'];
};

export type InputAdTagSubscription = {
  teamId: Scalars['Int']['input'];
};

export type InputAdTagUsage = {
  teamId: Scalars['Int']['input'];
};

export type InputAdTextContent = {
  body?: InputMaybe<Scalars['String']['input']>;
  cta?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
};

export type InputAddAdminAdNetwork = {
  adTag: Scalars['Boolean']['input'];
  cachebusterMacro: Scalars['String']['input'];
  clickTagMacro?: InputMaybe<Scalars['String']['input']>;
  html5: Scalars['Boolean']['input'];
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  status: Scalars['Boolean']['input'];
  testOnly: Scalars['Boolean']['input'];
  type: Scalars['String']['input'];
};

export type InputAddAdminUrlSafetyEntry = {
  /** Required for BRAND_DOMAIN, rejected for every other list. */
  brand?: InputMaybe<Scalars['String']['input']>;
  list: AdminUrlSafetyList;
  note?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type InputAddAdminUser = {
  email: Scalars['String']['input'];
  rights: InputAdminUserRights;
};

export type InputAddAiDesignCardToMoodboard = {
  /** Chat thread ID for journey tracking */
  chatThreadId?: InputMaybe<Scalars['String']['input']>;
  /** Hash of the design to link as a design card (enables double-click → Ad Studio) */
  designHash: Scalars['String']['input'];
  height?: InputMaybe<Scalars['Int']['input']>;
  mediaSourceType?: InputMaybe<MediaSourceType>;
  moodboardHash: Scalars['String']['input'];
  sourceCardIds?: InputMaybe<Array<Scalars['String']['input']>>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type InputAddAiImageCardsToMoodboard = {
  /** Chat thread ID for journey tracking */
  chatThreadId?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  mediaSourceType?: InputMaybe<MediaSourceType>;
  moodboardHash: Scalars['String']['input'];
  operationIds: Array<Scalars['Int']['input']>;
  sourceCardIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Generation trigger for source attribution (e.g., chat_agent_image_generation) */
  trigger?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type InputAddAiResizeVariant = {
  fresh?: InputMaybe<Scalars['Boolean']['input']>;
  sessionId: Scalars['String']['input'];
  slideId?: InputMaybe<Scalars['Int']['input']>;
  sourceHash: Scalars['String']['input'];
  targetHash: Scalars['String']['input'];
  targetHeight?: InputMaybe<Scalars['Int']['input']>;
  targetWidth?: InputMaybe<Scalars['Int']['input']>;
  version: Scalars['Int']['input'];
};

export type InputAddAiVideoCardsToMoodboard = {
  /** Chat thread ID for journey tracking */
  chatThreadId?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  hasAudio?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  mediaSourceType?: InputMaybe<MediaSourceType>;
  moodboardHash: Scalars['String']['input'];
  operationIds: Array<Scalars['Int']['input']>;
  sourceCardIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Generation trigger for source attribution (e.g., chat_agent_video_generation) */
  trigger?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for appending user-uploaded source images to a brand kit's style analysis. */
export type InputAddBrandStyleSourceImages = {
  /** ID of the brand kit to update. */
  brandKitId: Scalars['Int']['input'];
  /** URLs of images to append (duplicates are silently skipped). */
  urls: Array<Scalars['String']['input']>;
};

export type InputAddColorToPalette = {
  brandKitId: Scalars['Int']['input'];
  color: InputColor;
  id: Scalars['Int']['input'];
};

/** Input for adding a single competitor by name or domain. */
export type InputAddCompetitor = {
  /** Company name or domain/website URL to analyze. */
  input: Scalars['String']['input'];
};

export type InputAddContentLibraryElement = {
  categoryId: Scalars['Int']['input'];
  fileName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  premium?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for adding a custom ad network. */
export type InputAddCustomAdNetwork = {
  /** The cachebuster macro for the custom ad network. */
  cachebusterMacro: Scalars['String']['input'];
  /** The click tag macro for the custom ad network. */
  clickTagMacro?: InputMaybe<Scalars['String']['input']>;
  /** The URL of the logo for the custom ad network. */
  logo?: InputMaybe<Scalars['String']['input']>;
  /** The name of the custom ad network. */
  name: Scalars['String']['input'];
  /** The ID of the team to which this ad network will be added. */
  teamId: Scalars['Int']['input'];
};

export type InputAddCustomSize = {
  designHash?: InputMaybe<Scalars['String']['input']>;
  height: Scalars['Float']['input'];
  measureUnit: MeasureUnit;
  name: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
  width: Scalars['Float']['input'];
};

/** Input for adding media to a design's media library. */
export type InputAddDesignMediaToLibrary = {
  /** ID of the design whose library the media is added to. */
  designId: Scalars['Int']['input'];
  /** Folder the imported media lands in; null/omitted lands at the library root (already-linked media keeps its folder). */
  folderId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Hashids of media to add, for callers that only hold the public hash and never
   * the numeric id (AI Studio result tiles). Merged with mediumIds; every entry
   * must decode to a real medium.
   */
  mediumHashes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** IDs of the media assets to add to the design's library. */
  mediumIds: Array<Scalars['Int']['input']>;
};

/** Input for adding reviewers to a design. */
export type InputAddDesignReviewers = {
  /** The design hash. */
  designHash: Scalars['String']['input'];
  /** Optional message to include with the review request. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** List of reviewer user IDs. */
  reviewerUserIds: Array<Scalars['Int']['input']>;
};

export type InputAddDesignSetSizeType = {
  designSizeTypeIds: Array<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputAddDesignSizeType = {
  height: Scalars['Float']['input'];
  measureUnit: MeasureUnit;
  name?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
  width: Scalars['Float']['input'];
};

export type InputAddDesignSizes = {
  hash: Scalars['String']['input'];
  /** The user agreed to add sizes to a design whose brand template keeps its sizes: see InputEditDesign. */
  lockedChangesAgreed?: InputMaybe<Scalars['Boolean']['input']>;
  sizes: Array<InputSizeToAdd>;
  /** Start the AI resize for a size the free path cannot lay out. Its credits are charged when the size is added. */
  spendCredits?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for adding a design to templates. */
export type InputAddDesignToTemplates = {
  /** ID of the design to add as a template. */
  designId: Scalars['Int']['input'];
  /** Whether GenStudio features are enabled. */
  genStudioEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the project to associate with the template. */
  projectId: Scalars['Int']['input'];
  /** ID of the team that owns the design. */
  teamId: Scalars['Int']['input'];
};

export type InputAddFolderToBrandTemplate = {
  brandKitId: Scalars['Int']['input'];
  folderId: Scalars['Int']['input'];
};

export type InputAddFolderToTemplates = {
  folderId: Scalars['Int']['input'];
};

export type InputAddFontToBrandKit = {
  name: Scalars['String']['input'];
  urls: Array<Scalars['String']['input']>;
};

/** Input for adding multiple fonts to a brand kit. */
export type InputAddFontsFromUrl = {
  /** ID of the brand kit to add fonts to. */
  brandKitId: Scalars['Int']['input'];
  /** Array of fonts to add. */
  fonts: Array<FontFromUrl>;
};

/** Input for adding multiple logos to a brand kit. */
export type InputAddLogosFromUrl = {
  /** ID of the brand kit to add logos to. */
  brandKitId: Scalars['Int']['input'];
  /** Array of logos to add. */
  logos: Array<LogoFromUrl>;
};

/** Input for adding a network to ad serving for a design. */
export type InputAddNetworkAdServing = {
  /** The ID of the design. */
  designId: Scalars['Int']['input'];
  /** Add the network to every member of this design's variation family. A family shares one network selection. */
  includeVariations?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the network to add. */
  networkId: Scalars['Int']['input'];
};

/**
 * Input for adding a new design to an existing design set.
 * Use this to expand a design set with additional sizes.
 */
export type InputAddNewDesignToSet = {
  /** ID of the design size type for the new design. */
  designSizeTypeId: Scalars['Int']['input'];
  /** JSON representation of the new design to add. */
  json: Scalars['JsonDesign']['input'];
  /** Name for the new design in the set. */
  name: Scalars['String']['input'];
  /** Hash of the design set to add to. */
  setHash: Scalars['String']['input'];
};

export type InputAddNewFeedColumn = {
  columnIndex: Scalars['Int']['input'];
  columnName: Scalars['String']['input'];
  columnType: FeedColumnType;
  feedId: Scalars['Int']['input'];
};

export type InputAddNewValueToUserOnboarding = {
  /** Key to add to the user's onboarding properties. */
  key: Scalars['String']['input'];
  /** Value to set for the key (limited to 100 characters). */
  value: Scalars['String']['input'];
};

export type InputAddPinnedFolder = {
  folderId: Scalars['Int']['input'];
  pos: Scalars['Int']['input'];
};

export type InputAddProductUpdate = {
  audience?: InputMaybe<InputProductUpdateAudience>;
  description: Scalars['String']['input'];
  fileHash?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileType?: InputMaybe<MediaType>;
  /** @deprecated This field is no longer used */
  onlyAdStudioUsers?: InputMaybe<Scalars['Boolean']['input']>;
  standalone?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  version: ProductUpdateVersion;
};

/** Input for adding a group to a project. */
export type InputAddProjectGroup = {
  /** ID of the group to add. */
  groupId: Scalars['Int']['input'];
  /** ID of the project to add the group to. */
  projectId: Scalars['Int']['input'];
};

/** Input for adding a user to a project. */
export type InputAddProjectUser = {
  /** ID of the project to add the user to. */
  projectId: Scalars['Int']['input'];
  /** ID of the user to add. */
  userId: Scalars['Int']['input'];
};

export type InputAddTeamToPaymentExperiment = {
  experimentId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputAddToBrandTemplate = {
  brandKitId: Scalars['Int']['input'];
  designId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputAddTutorial = {
  title: Scalars['String']['input'];
  tutorialCategoryId: Scalars['Int']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type InputAddTutorialCategory = {
  name: Scalars['String']['input'];
};

/** Input for adding a new typography configuration to a brand kit. */
export type InputAddTypography = {
  /** ID of the brand kit to add typography to. */
  brandKitId: Scalars['Int']['input'];
};

export type InputAddUrlDataToBrandKit = {
  data: InputUrlDataToBrandKit;
  teamId: Scalars['Int']['input'];
};

/** Input for adding a user to a group. */
export type InputAddUserToGroup = {
  /** ID of the group to add the user to. */
  groupId: Scalars['Int']['input'];
  /** ID of the team that owns the group. */
  teamId: Scalars['Int']['input'];
  /** ID of the user to add. */
  userId: Scalars['Int']['input'];
};

export type InputAddedGoogleFont = {
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  fontName: Scalars['String']['input'];
  variants: Array<Scalars['String']['input']>;
};

export type InputAddonsUsage = {
  teamId: Scalars['Int']['input'];
};

export type InputAddress = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  region: Scalars['String']['input'];
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

export type InputAdminBrandedTeams = {
  /** The last team of the page before, so the page starts with the team listed after it. Omitted for the first page. */
  afterTeamId?: InputMaybe<Scalars['Int']['input']>;
  /** Only the teams matching every filter set. The paging and remainingCount follow the filtered list. */
  filter?: InputMaybe<InputAdminBrandedTeamsFilter>;
  /** 1 to 50: every returned team costs one (Redis-cached) Recurly subscription lookup. */
  limit: Scalars['Int']['input'];
};

export type InputAdminBrandedTeamsFilter = {
  branding?: InputMaybe<AdminBrandedTeamBranding>;
  /** Only the teams whose domain has this status. */
  domainStatus?: InputMaybe<AdminBrandedTeamStatusFilter>;
  /** Only the teams whose From email has this status. */
  emailStatus?: InputMaybe<AdminBrandedTeamStatusFilter>;
  /** Part of the team name, the domain or the From email, in any case, or the exact team id. At most 100 characters; blank lists every team. */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type InputAdminCancellationReasons = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderType>;
  orderBy?: InputMaybe<AdminCancellationReasonsOrderBy>;
};

export type InputAdminCompareTranslations = {
  designHash: Scalars['String']['input'];
  /** Fixed judge model id (design-scoring allowlist). Defaults to Claude Opus. */
  judgeModel?: InputMaybe<Scalars['String']['input']>;
  /** Source language code. Defaults to EN. */
  sourceLang?: InputMaybe<Scalars['String']['input']>;
  /** DeepL-style language code, e.g. ES, DE, FR, PT-BR. */
  targetLang: Scalars['String']['input'];
  /** Translator ids to compare. Defaults to brand-aligned deepl plus OpenAI/Claude. Opt-in: deepl-legacy. */
  translators?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InputAdminDesignSampleBoxes = {
  sampleId: Scalars['String']['input'];
  /**
   * The sizes on the caller's stage. Omitted, every stored size answers — a sample can hold dozens, and
   * the preview dialog draws at most three.
   */
  variantIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InputAdminDesignSampleCuration = {
  note?: InputMaybe<Scalars['String']['input']>;
  /** Only with a rejection. */
  reason?: InputMaybe<DesignSampleRejectReason>;
  sampleId: Scalars['String']['input'];
  /** 2 boost · 1 approve · -1 reject · null enable (clears this admin's verdict, back to NEEDS_REVIEW). */
  verdict?: InputMaybe<Scalars['Int']['input']>;
};

export type InputAdminDesignSampleFeedback = {
  /** square | horizontal | vertical: which conversion is being judged. */
  queryBridge?: InputMaybe<Scalars['String']['input']>;
  /** The design the ranking was run for — the sampler's RESOLVED child when a set was searched. */
  queryDesignHash: Scalars['String']['input'];
  /** Which slide posed the query; from the matches response's resolved block. */
  querySlideId?: InputMaybe<Scalars['Int']['input']>;
  sampleId: Scalars['String']['input'];
  /**
   * The size that matched (the row's source.variantId). A sample keeps every size of an orientation, so the
   * sample alone does not say which layout was judged; the sampler records this one's size.
   */
  sourceVariantId?: InputMaybe<Scalars['String']['input']>;
  /** +1 good match / -1 bad match. Re-judging the same question updates it. */
  verdict: Scalars['Int']['input'];
};

/**
 * One conversion to grade, on demand. The sampler's own snapshot of the source side is the reference and this role's
 * conversion the candidate — the exact bytes retrieval serves.
 */
export type InputAdminDesignSampleGrade = {
  role: DesignSampleTransition;
  sampleId: Scalars['String']['input'];
  /** The orientation the conversion leaves FROM; must differ from the role. Defaults to the square. */
  sourceRole?: InputMaybe<DesignSampleTransition>;
  /**
   * The exact source variant on the caller's stage. Wins over sourceRole plus the target, which
   * re-select the source by aspect — a sample with several sizes in that orientation would otherwise
   * be graded against one variant while the stage displayed another.
   */
  sourceVariantId?: InputMaybe<Scalars['String']['input']>;
  targetHeight?: InputMaybe<Scalars['Int']['input']>;
  /** The size on the stage: grades the same conversion the preview shows for it. Both dims or neither. */
  targetWidth?: InputMaybe<Scalars['Int']['input']>;
};

export type InputAdminDesignSampleGradeFeedback = {
  /**
   * What the grade SHOULD have been, in the judge's eyes — how a thumbs-down says which WAY the
   * grading was wrong. Optional: a bare thumb is a judgment too.
   */
  expectedVerdict?: InputMaybe<ResizeRankingVerdict>;
  graded: InputAdminDesignSampleGradedSnapshot;
  /**
   * Why, in the judge's words: up to 500 characters describing the defect rather than the copy.
   * Admin-authored prose, not engine output — and, like every field of this input, recorded into
   * admin_log.info by @admin.
   */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Which conversion was graded. */
  role: DesignSampleTransition;
  sampleId: Scalars['String']['input'];
  /** The orientation the graded conversion left FROM. Defaults to the square. */
  sourceRole?: InputMaybe<DesignSampleTransition>;
  /**
   * The exact source variant the grade was taken on — the one the stage pinned. Its size is part of the
   * judgment's identity: a sample's 300x250 and 970x250 conversions into one orientation are two judgments.
   */
  sourceVariantId?: InputMaybe<Scalars['String']['input']>;
  targetHeight?: InputMaybe<Scalars['Int']['input']>;
  /** The size on the stage the grade was taken at — part of the judgment's identity. Both dims or neither. */
  targetWidth?: InputMaybe<Scalars['Int']['input']>;
  /** +1 the grading is right / -1 the grading is wrong. Re-judging the same conversion updates it. */
  verdict: Scalars['Int']['input'];
};

export type InputAdminDesignSampleGradedDelta = {
  candFraction: Scalars['Float']['input'];
  refFraction: Scalars['Float']['input'];
};

/** One finding's STRUCTURE. There is deliberately no description field — see the rule input below. */
export type InputAdminDesignSampleGradedFinding = {
  /** The third such piece, from engine 0.8.0: whether this MAJOR reached the cap without a second one. */
  capsAlone?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether the finding counted toward the cap gates, and which soften it was eligible for — the two pieces
   * of ENGINE ARITHMETIC a stored judgment could not otherwise reproduce: replaying the first 62 of them
   * matched only 58 until the flag was reconstructed by hand from the overlap rule's source. Both are a
   * boolean and an enum, no more prose than the severity beside them. Optional, so an admin bundle built
   * before engine 0.6.0 keeps recording judgments.
   */
  countsTowardCap?: InputMaybe<Scalars['Boolean']['input']>;
  delta?: InputMaybe<InputAdminDesignSampleGradedDelta>;
  severity: ResizeRankingSeverity;
  softenFamily?: InputMaybe<ResizeRankingSoftenFamily>;
  type: Scalars['String']['input'];
};

/**
 * One graded rule, as a WHITELIST rather than free-form JSON.
 *
 * The engine interpolates the authored layer name into a finding's description
 * (Element "Q3 Hero Headline" is 40% outside the canvas), and design CONTENT is confined to
 * design-sampler's payload store. A client that simply forwarded the engine's result would
 * carry those names into this table AND into admin_log.info, where — because these rows
 * outlive a corpus purge — they would outlive the payload. Enumerating the fields makes that
 * structurally impossible for every caller instead of relying on one mapper's discipline:
 * GraphQL rejects an unknown input field, so a description cannot be sent at all.
 *
 * NOTHING HERE IS PROSE. A finding's type is a static code the engine picks
 * ("missingElement"); every other field is a number, an enum or an id. The rule's own notes
 * were dropped for the same reason its description was: they are free text, the category that
 * would vouch for them is caller-supplied, and @admin records the input into admin_log.info
 * before any resolver can object. Structure is what scorer mining reads — which rule, what
 * score, which findings — and the sentence that renders it can be regenerated from the rule
 * registry by anyone who wants it.
 */
export type InputAdminDesignSampleGradedRule = {
  category: DesignSampleGradedTier;
  findings: Array<InputAdminDesignSampleGradedFinding>;
  id: Scalars['String']['input'];
  /** Null when the rule did not apply — never coerced to 0, which would read as a bad score. */
  score?: InputMaybe<Scalars['Float']['input']>;
  status: ResizeRankingRuleStatus;
  title: Scalars['String']['input'];
  weight: Scalars['Float']['input'];
};

/**
 * The grading being judged, exactly as the chip displayed it.
 *
 * Supplied by the caller rather than recomputed here: `adminDesignSampleGrade` persists
 * nothing and re-runs the CURRENT engine on every dialog open, so re-grading server-side
 * would pay a second headless render AND risk recording a different score than the one the
 * admin actually disagreed with. The engine identity is attached by the resolver from its
 * own constants, never from the wire.
 */
export type InputAdminDesignSampleGradedSnapshot = {
  /** The number ON the chip: the weighted mean of the rule scores. */
  meanScore: Scalars['Float']['input'];
  /** The engine's post-cap overallScore, which a critical rule can hold below the mean. */
  overallScore: Scalars['Float']['input'];
  /** The per-rule breakdown, whitelisted field by field. */
  rules: Array<InputAdminDesignSampleGradedRule>;
  verdict: ResizeRankingVerdict;
};

export type InputAdminDesignSampleMatches = {
  /** A design hash, a design-set hash (what an Ad Studio URL carries), or a numeric design id. */
  designRef: Scalars['String']['input'];
  /** Let rejected samples match too, to see what a rejection removed. */
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Server-capped at 30. Ignored by the OUTCOME retrieval, which answers its whole grouped head. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Calibrated score floor (0 random-grade, 0.75 judged-good, 1 identical). */
  minScore?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /**
   * REGULAR when omitted. OUTCOME judges the families against the rules the lane's prompt holds for
   * the target size, so it needs targetWidth and targetHeight. It leaves out the alignment invariant,
   * which the worker states only where AI_RESIZE_PROMPT_ALIGNMENT_FACTS is on (not production).
   */
  retrieval?: InputMaybe<DesignSampleRetrieval>;
  /** Which child of a SET ref to query with; ignored for a design ref. Defaults to the square. */
  sourceRole?: InputMaybe<DesignSampleTransition>;
  targetHeight?: InputMaybe<Scalars['Int']['input']>;
  /** The size being resized into: picks the nearest-aspect conversion per hit, as the resize lane does. */
  targetWidth?: InputMaybe<Scalars['Int']['input']>;
  transition: DesignSampleTransition;
};

export type InputAdminDesignSamplePreview = {
  sampleId: Scalars['String']['input'];
  /** Which size the stage reads the sample FROM. Defaults to the square. */
  sourceRole?: InputMaybe<DesignSampleTransition>;
  /** The EXACT size to read FROM. Wins over sourceRole and over the nearest-target rule, so the stage and the grade resolve one source. */
  sourceVariantId?: InputMaybe<Scalars['String']['input']>;
  targetHeight?: InputMaybe<Scalars['Int']['input']>;
  /** The conversion being reviewed: picks the same-role variant nearest it. Both or neither. */
  targetWidth?: InputMaybe<Scalars['Int']['input']>;
};

export type InputAdminDesignSamplesFilter = {
  reviewStatus?: InputMaybe<DesignSampleReviewStatus>;
  /** Case-insensitive prefix on the set hash or the sample id. */
  search?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<DesignSampleSourceType>;
  teamId?: InputMaybe<Scalars['Int']['input']>;
  transition?: InputMaybe<DesignSampleTransitionFilter>;
};

export type InputAdminDesigns = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderType>;
  search: Scalars['String']['input'];
  sortBy?: InputMaybe<AdminDesignSortField>;
  type: AdminDesignQueryType;
};

export type InputAdminEvalDesign = {
  designHash: Scalars['String']['input'];
  /** An allowlisted model id from `adminDesignEvalModels`. Defaults to the default judge when omitted. */
  model?: InputMaybe<Scalars['String']['input']>;
  /** Score brandFidelity against the design's brand kit (logo + palette + style), mirroring the crafted vision gate. Ignored when the design has no brand kit. */
  useBrandKitContext?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputAdminFeed = {
  id: Scalars['String']['input'];
};

export type InputAdminLabelDesignScorerFinding = {
  issueKey: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  shadowId: Scalars['ID']['input'];
  /** Default LAYERED. */
  surface?: InputMaybe<DesignScorerReviewSurface>;
  verdict: DesignScorerFindingVerdict;
};

export type InputAdminLogs = {
  email?: InputMaybe<Scalars['String']['input']>;
  endCursor?: InputMaybe<Scalars['String']['input']>;
  eventName?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputAdminNotes = {
  teamId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputAdminProjects = {
  teamId: Scalars['Int']['input'];
};

/** Exactly one overload must be provided (enforced by @oneOf). */
export type InputAdminRankResize =
  { byData: InputRankByData; bySavedDesign?: never; }
  |  { byData?: never; bySavedDesign: InputRankBySavedDesign; };

export type InputAdminTeams = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search: Scalars['String']['input'];
  type: AdminTeamQueryType;
};

/** Input for retrieving admin template tags. */
export type InputAdminTemplateTag = {
  /** Filter criteria for tags. */
  filter: InputAdminTemplatesTagFilter;
};

/** Input for retrieving admin templates with filtering and pagination. */
export type InputAdminTemplates = {
  /** Pagination cursor. */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Filter criteria for templates. */
  filter?: InputMaybe<InputAdminTemplatesFilter>;
  /** Ordering options. */
  orderBy?: InputMaybe<InputAdminTemplatesOrderBy>;
};

/**
 * Input for filtering templates in admin interface.
 * Provides comprehensive filtering options for administrators.
 */
export type InputAdminTemplatesFilter = {
  /** Template name to search for. */
  bannerName?: InputMaybe<Scalars['String']['input']>;
  /** Category ID to filter by. */
  category?: InputMaybe<Scalars['Int']['input']>;
  /** Design size ID to filter by. */
  designSize?: InputMaybe<Scalars['Int']['input']>;
  /** Template hash to filter by. */
  hash?: InputMaybe<Scalars['String']['input']>;
  /** Filter by templates pinned to top. */
  pinToTop?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by templates visible in the app. */
  showInApp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by templates visible in the gallery. */
  showInGallery?: InputMaybe<Scalars['Boolean']['input']>;
  /** End date for submission date filtering. */
  submitEndDate?: InputMaybe<Scalars['Date']['input']>;
  /** Start date for submission date filtering. */
  submitStartDate?: InputMaybe<Scalars['Date']['input']>;
  /** Tag IDs to filter by. */
  tags?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Type of design (STATIC, ANIMATED, VIDEO) to filter by. */
  type?: InputMaybe<DesignSizeTypeTypes>;
  /** End date for update date filtering. */
  updateEndDate?: InputMaybe<Scalars['Date']['input']>;
  /** Start date for update date filtering. */
  updateStartDate?: InputMaybe<Scalars['Date']['input']>;
  /** Filter by templates used in the Create Agent. */
  useInCreateAgent?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for ordering admin templates. */
export type InputAdminTemplatesOrderBy = {
  /** Field to order by, defaults to DATE_SUBMITTED. */
  orderBy?: AdminTemplatesOrderByFields;
  /** Direction of ordering, defaults to DESC. */
  orderType?: OrderType;
};

/** Input for filtering admin template tags. */
export type InputAdminTemplatesTagFilter = {
  /** Number of tags already fetched (for pagination). */
  fetchedCount?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by color tags. */
  isColor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by style tags. */
  isStyle?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search term to filter tags by name. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter by tags visible in the app. */
  showInApp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by tags visible in the gallery. */
  showInGallery?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputAdminTwoFactor = {
  enableTwoFactor: Scalars['Boolean']['input'];
  userId: Scalars['Int']['input'];
};

export type InputAdminUserRights = {
  MANAGE_ACCOUNTS: Scalars['Boolean']['input'];
  MANAGE_ADMINISTRATORS: Scalars['Boolean']['input'];
  MANAGE_ADMIN_LOGS: Scalars['Boolean']['input'];
  MANAGE_AD_NETWORKS: Scalars['Boolean']['input'];
  MANAGE_AD_SERVING: Scalars['Boolean']['input'];
  MANAGE_AGENT: Scalars['Boolean']['input'];
  MANAGE_AI_RESIZE: Scalars['Boolean']['input'];
  MANAGE_BRAND_TEMPLATES_MIGRATION: Scalars['Boolean']['input'];
  MANAGE_CONTENT_LIBRARY: Scalars['Boolean']['input'];
  MANAGE_DESIGNS: Scalars['Boolean']['input'];
  MANAGE_DESIGN_CLONES: Scalars['Boolean']['input'];
  MANAGE_INTERNAL_TOOLS: Scalars['Boolean']['input'];
  MANAGE_INVALIDATE_CACHE: Scalars['Boolean']['input'];
  MANAGE_MAINTENANCE: Scalars['Boolean']['input'];
  MANAGE_MIGRATIONS: Scalars['Boolean']['input'];
  MANAGE_NEXT_GEN: Scalars['Boolean']['input'];
  MANAGE_TEMPLATES: Scalars['Boolean']['input'];
  MANAGE_UPDATES: Scalars['Boolean']['input'];
  SUCCESS_MANAGER: Scalars['Boolean']['input'];
};

export type InputAdminWatchdogEvaluationsFilter = {
  /** ISO date range on created_at — a date-only string parses to that day's midnight UTC (rows at/after it match). */
  createdAfter?: InputMaybe<Scalars['String']['input']>;
  /** Inclusive of the WHOLE named day: a date-only string is midnight UTC, so the server matches created_at strictly before the NEXT day's midnight. */
  createdBefore?: InputMaybe<Scalars['String']['input']>;
  gradeMax?: InputMaybe<Scalars['Float']['input']>;
  /** Inclusive grade range on the effective mean — COALESCE(full_mean_score, det_mean_score), same rule as verdict. */
  gradeMin?: InputMaybe<Scalars['Float']['input']>;
  /** Prefix-matches candidate OR reference hash (server-side). */
  hashSearch?: InputMaybe<Scalars['String']['input']>;
  renderOk?: InputMaybe<Scalars['Boolean']['input']>;
  resizeMethod?: InputMaybe<ResizeWatchdogMethod>;
  reviewStatus?: InputMaybe<ResizeWatchdogReviewStatus>;
  teamId?: InputMaybe<Scalars['Int']['input']>;
  /** Effective verdict — COALESCE(full_verdict, det_verdict). */
  verdict?: InputMaybe<ResizeRankingVerdict>;
};

export type InputAdminWatchdogReview = {
  /** Required iff mode is BLIND — the reviewer's own pass/fail committed before the reveal. */
  blindVerdict?: InputMaybe<ResizeWatchdogBlindVerdict>;
  id: Scalars['Int']['input'];
  mode: ResizeWatchdogReviewMode;
  note?: InputMaybe<Scalars['String']['input']>;
  /** The human's call — CONFIRMED (tool right) or OVERRULED (tool wrong). PENDING is not a valid target. */
  status: ResizeWatchdogReviewStatus;
};

export type InputAdobeAem = {
  adobeAem: Scalars['Boolean']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputAdoptAiStudioGenerationChatThread = {
  chatThreadId: Scalars['String']['input'];
  /** Operations of the generations to file; generations already filed under a chat are left alone. */
  operationIds: Array<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputAiChatMessage = {
  content: Array<AiChatContent>;
  role: Scalars['String']['input'];
};

export type InputAiFlowCreatorChatStream = {
  chatId?: InputMaybe<Scalars['Int']['input']>;
  folderId?: InputMaybe<Scalars['Int']['input']>;
  message: InputAiChatMessage;
  options?: InputMaybe<ChatOptionsInput>;
  projectId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputAiOperationUsage = {
  teamId: Scalars['Int']['input'];
};

export type InputAiReportHtmlToEmail = {
  chatId: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  htmlId: Scalars['Int']['input'];
  messageId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputAiReportHtmlToPdfCallback = {
  isAutomatedReport: Scalars['Boolean']['input'];
  reportId: Scalars['Int']['input'];
};

export type InputAiResize = {
  hash: Scalars['String']['input'];
  platform: ResizePlatform;
  slideId: Scalars['Int']['input'];
  targetHash: Scalars['String']['input'];
};

/** Worker-reported LLM cost/latency for one variant (dev diagnostics, mirrors the [resizeTiming] log). */
export type InputAiResizeGenerationStats = {
  /** Prefix tokens served from cache. Anthropic EXCLUDES these from inputTokens, so cost reads need both. */
  cacheReadTokens?: InputMaybe<Scalars['Int']['input']>;
  /** Wall-clock of the Claude call only (excludes screenshot/setup and the /resize merge). */
  durationMs: Scalars['Int']['input'];
  inputTokens?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  outputTokens?: InputMaybe<Scalars['Int']['input']>;
  stopReason?: InputMaybe<Scalars['String']['input']>;
  thinkingChars?: InputMaybe<Scalars['Int']['input']>;
  visibleChars?: InputMaybe<Scalars['Int']['input']>;
};

export type InputAiResizeHtmlPreviewJson = {
  anonymousId?: InputMaybe<Scalars['String']['input']>;
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  canvasBackground?: InputMaybe<Scalars['String']['input']>;
  generationStats?: InputMaybe<InputAiResizeGenerationStats>;
  hash: Scalars['String']['input'];
  html: Scalars['String']['input'];
  logoHash?: InputMaybe<Scalars['String']['input']>;
  promptCapture?: InputMaybe<InputAiResizePromptCapture>;
  resizeVersion: Scalars['Int']['input'];
  resizedLayersInfo: Array<Array<InputResizedLayerInfo>>;
  sampleInfo?: InputMaybe<InputAiResizeSampleInfo>;
  sessionId: Scalars['String']['input'];
  slideId: Scalars['Int']['input'];
  startTime?: InputMaybe<Scalars['Float']['input']>;
  targetHash: Scalars['String']['input'];
  textColours?: InputMaybe<Array<InputAiResizeTextColour>>;
  useTextFontSizeOptimization?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  variantId: Scalars['String']['input'];
};

export type InputAiResizeHtmlUpdateJson = {
  anonymousId?: InputMaybe<Scalars['String']['input']>;
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  hash: Scalars['String']['input'];
  html: Scalars['String']['input'];
  isOpusVersion?: InputMaybe<Scalars['Boolean']['input']>;
  logoHash?: InputMaybe<Scalars['String']['input']>;
  resizedLayersInfo: Array<Array<InputResizedLayerInfo>>;
  slideId: Scalars['Int']['input'];
  startTime?: InputMaybe<Scalars['Float']['input']>;
  targetHash: Scalars['String']['input'];
  transactionId?: InputMaybe<Scalars['Int']['input']>;
  useTextFontSizeOptimization?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputAiResizeJson = {
  hash: Scalars['String']['input'];
};

export type InputAiResizeModel = {
  id: Scalars['Int']['input'];
};

/**
 * The exact prompt the worker sent to the LLM for one variant. Captured only
 * when the worker runs with AI_RESIZE_CAPTURE_PROMPTS=true; the screenshot is
 * replaced by hasScreenshot/screenshotMediaType markers.
 */
export type InputAiResizePromptCapture = {
  effort?: InputMaybe<Scalars['String']['input']>;
  hasScreenshot: Scalars['Boolean']['input'];
  maxTokens?: InputMaybe<Scalars['Int']['input']>;
  model: Scalars['String']['input'];
  /** The repair turn that followed repairedFrom and produced the variant. */
  repairRequest?: InputMaybe<Scalars['String']['input']>;
  /** Set when the variant is the render check's repair: the model's first answer, without its thinking. */
  repairedFrom?: InputMaybe<Scalars['String']['input']>;
  sampleCount?: InputMaybe<Scalars['Int']['input']>;
  sampleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  screenshotMediaType?: InputMaybe<Scalars['String']['input']>;
  system: Scalars['String']['input'];
  userText: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};

/** One retrieved sample that rode the prompt (id + retrieval score). */
export type InputAiResizeSampleEntry = {
  sampleId: Scalars['String']['input'];
  score?: InputMaybe<Scalars['Float']['input']>;
  /** The sampler's whole score breakdown: rerank, RRF, per-channel rank/distance, curation bonus, traits. */
  scores?: InputMaybe<Scalars['JSON']['input']>;
  targetHeight?: InputMaybe<Scalars['Int']['input']>;
  /** Dims of the bridge target that actually rode the prompt — mirrors AiResizeSampleEntry, which already carried them while this input did not (the worker's writeback was rejected wholesale, failing the job). */
  targetWidth?: InputMaybe<Scalars['Int']['input']>;
  /** Per-trait shares of the score deficit (sampler v3 decomposition). */
  traits?: InputMaybe<Scalars['JSON']['input']>;
};

/** Render an arbitrary design JSON to the resize prompt's HTML dialect (frames mode). */
export type InputAiResizeSampleHtml = {
  /** Saliency per media key. Passed explicitly so this path never calls image-detections itself. */
  focalRegions?: InputMaybe<Array<InputMediaFocalRegion>>;
  json: Scalars['JSON']['input'];
  /** Slide to render (bannersetElementId ?? id); defaults to the first slide. */
  slideId?: InputMaybe<Scalars['Int']['input']>;
};

/** Worker-reported design-sampler retrieval outcome for one variant (dev diagnostics). */
export type InputAiResizeSampleInfo = {
  bridge?: InputMaybe<Scalars['String']['input']>;
  /** Why a requested sample was not selected: the lookup's fall-open reason (timeout, http, rejected, malformed, error, budget, circuit-open, disabled), empty (no example in the answer) or unusable (none could ride the prompt). Null when one was. */
  failure?: InputMaybe<Scalars['String']['input']>;
  /** The version asked design-sampler for a sample (usesDesignSample versions). */
  requested: Scalars['Boolean']['input'];
  /** How long the sample lookup took, ms. */
  retrieveMs?: InputMaybe<Scalars['Int']['input']>;
  sampleId?: InputMaybe<Scalars['String']['input']>;
  /** EVERY sample that rode the prompt, most similar first (sampleId/score above stay the TOP hit's). */
  samples?: InputMaybe<Array<InputAiResizeSampleEntry>>;
  score?: InputMaybe<Scalars['Float']['input']>;
  /** A sample was retrieved and rode the prompt (fail-open: false = sample-less run). */
  selected: Scalars['Boolean']['input'];
};

/** Collect the captured prompts of the user's CURRENT session on a source design. */
export type InputAiResizeSessionPrompts = {
  hash: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};

export type InputAiResizeStatus = {
  hashes: Array<Scalars['String']['input']>;
};

/** rag-vari22: a text the worker found lost on a backdrop of its own shade, and the colour it takes (#000000 or #ffffff). */
export type InputAiResizeTextColour = {
  colour: Scalars['String']['input'];
  elementId: Scalars['String']['input'];
};

export type InputAiResizeUpdateJson = {
  anonymousId?: InputMaybe<Scalars['String']['input']>;
  hash: Scalars['String']['input'];
  resizedLayersInfo: Array<Array<InputResizedLayerInfo>>;
  slideId: Scalars['Int']['input'];
  startTime?: InputMaybe<Scalars['Float']['input']>;
  targetHash: Scalars['String']['input'];
  transactionId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputAiResizeVariantStatus = {
  sessionId: Scalars['String']['input'];
};

export type InputAiResizeWithHtml = {
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  hash: Scalars['String']['input'];
  logoHash?: InputMaybe<Scalars['String']['input']>;
  resizeVersion?: InputMaybe<Scalars['Int']['input']>;
  slideId: Scalars['Int']['input'];
  stubModel?: InputMaybe<Scalars['Boolean']['input']>;
  targetHash: Scalars['String']['input'];
};

export type InputAiStudioGenerations = {
  /** Cursor from a previous page's pageInfo.endCursor — returns the generations OLDER than it (scroll-up loading) */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Only the generations started from this Copilot chat thread. Omitted: every generation on the design. */
  chatThreadId?: InputMaybe<Scalars['String']['input']>;
  /** Design hash whose AI Studio generation history to list (decoded to the design id server-side) */
  designHash: Scalars['String']['input'];
  /** Page size, default 10 */
  first?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputAllPlansState = {
  plan: Scalars['String']['input'];
  state: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for retrieving all projects accessible to the current user. */
export type InputAllUserProjects = {
  /** ID of the team whose projects to retrieve. */
  teamId: Scalars['Int']['input'];
};

/**
 * Input for `analyzeDesignTree` — the flex pre-warm: builds the layout analysis
 * and caches its skeleton SERVER-SIDE, so the subsequent `resizeFlexVariants`
 * reuses it (one model call per modal open, nothing carried by the client).
 * Call it fire-and-forget when the resize panel opens.
 */
export type InputAnalyzeDesignTree = {
  /** Hash of the design set the source belongs to, or of a standalone design (then `mainSizeHash` must equal it). */
  hash: Scalars['String']['input'];
  /** Hash of the main size design inside the set, or `hash` itself for a standalone design (the source banner to analyze). */
  mainSizeHash?: InputMaybe<Scalars['String']['input']>;
  /** Slide being resized (bannersetElementId), to scope a multi-slide source to its CURRENT slide. */
  slideId?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Input for `analyzeSourceDesign` — the upfront, geometry-only analysis of a
 * design's main size that returns text roles + decorative-element classification.
 * Call it when the resize panel opens; pass the result into
 * `resizeAlternatives` / `resizeWithTemplate` as `sourceAnalysis`.
 */
export type InputAnalyzeSourceDesign = {
  /** Hash of the design set the source belongs to, or of a standalone design (then `mainSizeHash` must equal it). */
  hash: Scalars['String']['input'];
  /** Hash of the main size design inside the set, or `hash` itself for a standalone design (the source banner to analyze). */
  mainSizeHash?: InputMaybe<Scalars['String']['input']>;
  /** Slide being resized (bannersetElementId). Required to scope a multi-slide source to its CURRENT slide; mirrors `slideId` on `resizeAlternatives` / `resizeWithTemplate`. */
  slideId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputAnimationSuggestions = {
  imageHash?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputApiAccess = {
  apiAccessDisabled: Scalars['Boolean']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputAppTemplates = {
  cursor: Scalars['String']['input'];
};

export type InputApplyAiResizeVariant = {
  slideId: Scalars['Int']['input'];
  targetHash: Scalars['String']['input'];
  variantId: Scalars['String']['input'];
};

export type InputApplyDesignLintFixes = {
  /** The saved design to fix. The server loads its JSON; the caller never supplies a document here. */
  hash: Scalars['String']['input'];
  /** The patterns the user ticked. Anything omitted keeps its detector's own default. */
  patterns?: InputMaybe<Array<InputDesignLintPattern>>;
  /**
   * The token from the scan the user was SHOWN, so the fixes applied are the ones they saw. REQUIRED
   * in practice: applying WITHOUT it is rejected (`DESIGN_LINT_SCAN_TOKEN_REQUIRED`) rather than
   * silently re-scanning and applying fixes nobody looked at. A token that no longer matches the design
   * is `STALE` and an evicted one is `EXPIRED`; on any of these the caller scans again for a fresh one.
   */
  scanToken?: InputMaybe<Scalars['String']['input']>;
  /**
   * Scope the fix to ONE slide — the slide being resized. MUST equal the slideId passed to the scan, or
   * the replay token will not match (the token is the scoped design's identity). Omitted ⇒ whole design.
   */
  slideId?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for approving a team invitation. */
export type InputApproveTeamInvitaion = {
  /** ID of the invitation to approve. */
  inviteId: Scalars['Int']['input'];
  /** ID of the role to assign to the invited user. */
  roleId: Scalars['Int']['input'];
  /** ID of the team that sent the invitation. */
  teamId: Scalars['Int']['input'];
};

export type InputAskHubAgent = {
  limit: Scalars['Int']['input'];
  query: Scalars['String']['input'];
  threshold: Scalars['Float']['input'];
};

export type InputAskOnboardingAssistant = {
  query: Scalars['String']['input'];
};

/** Input for assigning a brand kit to a design. */
export type InputAssignDesignBrandKit = {
  /** ID of the brand kit to assign (null to remove assignment). */
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  /** Hash of the design to update. */
  hash: Scalars['String']['input'];
};

/** Input for assigning the default brand kit to a design. */
export type InputAssignDesignDefaultBrandKit = {
  /** Hash of the design to update. */
  hash: Scalars['String']['input'];
};

export type InputAssignUserRole = {
  teamId: Scalars['Int']['input'];
  teamRoleId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

/** Input for ensuring a design JSON is saved. */
export type InputAssureDesignJsonIsSaved = {
  /** Hash of the design to check. */
  hash: Scalars['String']['input'];
  /** Tags every version this call creates, so one save across a family's members reads as one: letters, digits and dashes, 64 at most. */
  saveId?: InputMaybe<Scalars['String']['input']>;
};

export type InputAttachFeed = {
  designId: Scalars['Int']['input'];
  feedId: Scalars['Int']['input'];
  /** Local product set this design renders (D24, CRE-428). Must belong to the feed; null/omitted = entire catalog. Imported Meta sets use their materialized local row. */
  productSetId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputAttachment = {
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type InputAutoconfigTeamIdentityProvider = {
  autoConfigUrl?: InputMaybe<Scalars['String']['input']>;
  /**
   * PLA-463. IGNORED. This field used to write the automatically_add_users
   * column, which is now the SSO auto-join switch; writing it here bypasses the
   * single-holder guard. Kept for wire compatibility only — use
   * updateTeamIdentityProviderAutoJoin instead.
   */
  automaticallyAddUsers: Scalars['Boolean']['input'];
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  singleLogoutServiceUrl?: InputMaybe<Scalars['String']['input']>;
  singleSignOnServiceUrl?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputAutomateCopilotAiReport = {
  chatId: Scalars['Int']['input'];
  destination: AutomateCopilotAiReportDestination;
  email?: InputMaybe<Scalars['String']['input']>;
  frequency: AutomateCopilotAiReportFrequency;
  htmlId: Scalars['Int']['input'];
  messageId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  platform: AiAgentPlatform;
  platformAccountId: Scalars['String']['input'];
  platformAccountName: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['Int']['input']>;
  scheduleTime: Scalars['Date']['input'];
  slackChannelId?: InputMaybe<Scalars['String']['input']>;
  slackWorkspaceId?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

/** Input for getting available API token scopes. */
export type InputAvailableApiTokenScopes = {
  /** ID of the team to get scopes for. */
  teamId: Scalars['Int']['input'];
};

export type InputAwardTeamTrial = {
  /** Must be one of AWARDABLE_TRIAL_PLAN_CODES; anything else is rejected server-side. */
  planCode: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

/** Input for the `backfillDesignLayoutSignatures` admin mutation. */
export type InputBackfillDesignLayoutSignatures = {
  /**
   * Resume cursor. Only designs with `id > afterId` are considered. Pass
   * `lastProcessedId` from the previous call's payload to continue where
   * the last batch stopped.
   */
  afterId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Maximum number of designs to process in this call. Leave null to
   * process all eligible rows. Useful for splitting the work across
   * multiple calls when HTTP timeouts are a concern.
   */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /**
   * When true, skip designs that already have a row in
   * `design_layout_signature`. Use this for incremental updates after
   * publishing new templates. When false (default), every eligible design
   * is rescomputed and UPSERTed. Ignored for `USER_DESIGN`.
   */
  onlyMissing?: InputMaybe<Scalars['Boolean']['input']>;
  /** Which signature bucket to refresh. Defaults to `TEMPLATE`. */
  sourceType?: InputMaybe<BackfillSignatureSourceType>;
};

export type InputBackgroundType = {
  imageUrl: Scalars['String']['input'];
};

export type InputBalance = {
  teamId: Scalars['Int']['input'];
};

/** Input for retrieving a Bannersnack design JSON. */
export type InputBannersnackDesignJson = {
  /** Hash of the design to retrieve. */
  hash: Scalars['String']['input'];
};

/** Input for retrieving multiple Bannersnack design JSONs. */
export type InputBannersnackDesignsJson = {
  /** Array of design hashes to retrieve. */
  hashes: Array<Scalars['String']['input']>;
};

export type InputBillingInfo = {
  teamId: Scalars['Int']['input'];
};

export type InputBlurBg = {
  app?: InputMaybe<Scalars['String']['input']>;
  blurRatio?: InputMaybe<Scalars['Int']['input']>;
  folderId?: InputMaybe<Scalars['Int']['input']>;
  isPreview: Scalars['Boolean']['input'];
  teamId: Scalars['Int']['input'];
  url: Scalars['String']['input'];
};

/** Input for retrieving brand elements with pagination and search. */
export type InputBrandElements = {
  /** Pagination cursor for retrieving the next set of results. */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Maximum number of elements to retrieve. */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the parent folder (optional). */
  parentId?: InputMaybe<Scalars['Int']['input']>;
  /** Search and filter options. */
  searchOptions?: InputMaybe<InputBrandKitElementsSearchOptions>;
};

export type InputBrandIdentity = {
  content: Scalars['String']['input'];
};

/** Input for retrieving a specific brand kit by ID. */
export type InputBrandKit = {
  /** ID of the brand kit to retrieve. */
  id: Scalars['Int']['input'];
  /** ID of the team whose brand kit to retrieve. */
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for brandKitAssetDescription query. */
export type InputBrandKitAssetDescription = {
  /** ID of the brand kit asset (Media id). */
  assetId: Scalars['ID']['input'];
  /** ID of the brand kit that owns the asset (used for the access check). */
  brandKitId: Scalars['ID']['input'];
};

export type InputBrandKitColor = {
  color: Scalars['String']['input'];
};

export type InputBrandKitDocumentMedia = {
  /** Photographs or artwork showing the brand's visual style. */
  assets: Array<Scalars['String']['input']>;
  /** The document's logo, at most one. */
  logos: Array<Scalars['String']['input']>;
};

export type InputBrandKitDocumentRef = {
  brandKitId: Scalars['Int']['input'];
  documentId: Scalars['Int']['input'];
};

export type InputBrandKitDocuments = {
  brandKitId: Scalars['Int']['input'];
};

/** Search options for brand kit elements. */
export type InputBrandKitElementsSearchOptions = {
  /** Filter by media format (e.g., JPG, PNG). */
  mediaFormat?: InputMaybe<MediaFormat>;
  /** Filter by media type (e.g., IMAGE, VIDEO). */
  mediaType?: InputMaybe<MediaType>;
  /** Search query for filtering elements by name. */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Input for listing fonts of a given family within a specific brand kit. */
export type InputBrandKitFontsByFamily = {
  brandKitId: Scalars['Int']['input'];
  family: Scalars['String']['input'];
};

export type InputBrandKitId = {
  brandKitId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type InputBrandKitLogoUrl = {
  src: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

/** Search options for brand kit media folders. */
export type InputBrandKitMediaFoldersSearchOptions = {
  /** Search query for filtering folders by name. */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Input for retrieving brand kits for a team. */
export type InputBrandKits = {
  /** Max number of kits to return. Omit to return all (legacy behaviour). */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Number of kits to skip (offset pagination). */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Optional sorting options. */
  options?: InputMaybe<InputPaginationOptions>;
  /** Case-insensitive filter on kit name. */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  /** ID of the team whose brand kits to retrieve. */
  teamId: Scalars['Int']['input'];
};

/** Input for retrieving brand media folders with search. */
export type InputBrandMediaFolders = {
  /** Search and filter options for folders. */
  searchOptions?: InputMaybe<InputBrandKitMediaFoldersSearchOptions>;
};

export type InputBrandProfileExtractionFields = {
  businessType?: InputMaybe<Scalars['String']['input']>;
  copyLanguage?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  marketCountry?: InputMaybe<Scalars['String']['input']>;
  neverInvent?: InputMaybe<Array<Scalars['String']['input']>>;
  offering?: InputMaybe<Array<Scalars['String']['input']>>;
  offeringKind?: InputMaybe<Scalars['String']['input']>;
  requiresRealAsset?: InputMaybe<Array<Scalars['String']['input']>>;
  safeSubjects?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Brand profile fields to save. Omitted fields are normalised to their default. */
export type InputBrandProfileFields = {
  /** Kind of business: ecommerce, saas, restaurant, hospitality, services, retail, nonprofit, media, automotive, fashion, food-beverage, consumer-electronics, events-entertainment, other. */
  businessType?: InputMaybe<Scalars['String']['input']>;
  /** BCP-47 tag for the language the brand's ad copy is written in, e.g. "en", "en-GB". */
  copyLanguage?: InputMaybe<Scalars['String']['input']>;
  /** Short industry description. */
  industry?: InputMaybe<Scalars['String']['input']>;
  /** ISO 3166-1 alpha-2 country code (uppercase), e.g. "US", "DE". */
  marketCountry?: InputMaybe<Scalars['String']['input']>;
  /** Subjects a generator must never invent. */
  neverInvent?: InputMaybe<Array<Scalars['String']['input']>>;
  /** What the brand sells or provides. */
  offering?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Nature of the offering: physical-product, digital-product, service, physical-place, mixed. */
  offeringKind?: InputMaybe<Scalars['String']['input']>;
  /** Subjects that may only come from the kit's own media. */
  requiresRealAsset?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Subjects a generator may invent freely. */
  safeSubjects?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InputBrandStyleCtaButton = {
  colorTreatment?: InputMaybe<Array<Scalars['String']['input']>>;
  shape?: InputMaybe<Array<Scalars['String']['input']>>;
  textStyle?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InputBrandStyleSourceImage = {
  source: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type InputBrandStyleTextElement = {
  colorTreatment?: InputMaybe<Array<Scalars['String']['input']>>;
  fontStyle?: InputMaybe<Array<Scalars['String']['input']>>;
  sizing?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InputBrandTargetAudience = {
  /** ID of the brand kit to retrieve target audience for. */
  brandKitId: Scalars['Int']['input'];
};

export type InputBrandTemplateDesigns = {
  /** Design cursor to start from */
  after?: InputMaybe<Scalars['String']['input']>;
  brandKitId: Scalars['Int']['input'];
  folderId?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: OrderBy;
  orderType?: OrderType;
};

export type InputBrandTemplateFolders = {
  brandKitId: Scalars['Int']['input'];
  orderBy?: OrderBy;
  orderType?: OrderType;
  parentId?: InputMaybe<Scalars['Int']['input']>;
  /** When set, template folders are matched by name across the whole brand kit (parentId is ignored). */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type InputBrandTemplatesFolderTree = {
  brandKitId: Scalars['Int']['input'];
};

/** Visual style fields to update. */
export type InputBrandVisualStyle = {
  /** Whether this was AI-generated. */
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  /** How colors are used (not what colors). */
  colorUsage?: InputMaybe<Array<Scalars['String']['input']>>;
  /** CTA button style analysis. */
  ctaButtonStyle?: InputMaybe<InputBrandStyleCtaButton>;
  /** Graphic elements and texture preferences. */
  graphicElements?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Headline/title text style analysis. */
  headlineStyle?: InputMaybe<InputBrandStyleTextElement>;
  /** Illustration style preferences. */
  illustrationStyle?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Layout and composition preferences. */
  layoutPreferences?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Mood and atmosphere descriptors. */
  mood?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Photography and imagery style preferences. */
  photographyStyle?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Subheadline/secondary text style analysis. */
  subheadlineStyle?: InputMaybe<InputBrandStyleTextElement>;
  /** Core visual aesthetic descriptors. */
  visualStyle?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InputBrandVoiceTextGeneration = {
  brandTone: Array<Scalars['String']['input']>;
  brandVoice: Scalars['String']['input'];
};

export type InputBrandedShareLink = {
  brandedShareLinkDisabled: Scalars['Boolean']['input'];
  teamId: Scalars['Int']['input'];
};

/** Input for retrieving logos in a brand kit, optionally filtered by folder. */
export type InputBrandkitLogos = {
  /** ID of the folder to filter logos by (null for root/unfiled logos). */
  folderId?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for retrieving media folders in a brand kit. */
export type InputBrandkitMediaFolder = {
  /** ID of the parent folder (optional). */
  parentId?: InputMaybe<Scalars['Int']['input']>;
};

/** One brief-owned asset submitted by the living brief card. */
export type InputBriefAsset = {
  /** Original pixel height, when known (forwarded to the generation engine). */
  height?: InputMaybe<Scalars['Int']['input']>;
  url: Scalars['String']['input'];
  /** Original pixel width, when known (forwarded to the generation engine). */
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type InputBufferAttachment = {
  buffer: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type InputBuildJsonDesignFromExtractedInfo = {
  /** Opt in to snapping extracted colors onto the brand palette and the brand-font fallback. Off by default so the shared rebuild stays bit-identical for callers that do not request it. */
  applyBrandFidelity?: InputMaybe<Scalars['Boolean']['input']>;
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  extractedInfo: Scalars['JSON']['input'];
  /**
   * No longer needed, resolved from media metadata @BreakingBad
   * @deprecated No longer needed, resolved from media metadata
   */
  logoUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  mediaHash?: InputMaybe<Scalars['String']['input']>;
};

export type InputBulkAbTestTagContainerSyncStatus = {
  abTestIds: Array<Scalars['Int']['input']>;
  projectId: Scalars['Int']['input'];
};

/**
 * @deprecated Migration service has been removed.
 * Input for bulk converting design sets to templates.
 * Used for automated migrations.
 */
export type InputBulkConvertSetsToTemplate = {
  /** ID of the migration process to track. */
  migrationId: Scalars['Int']['input'];
};

/**
 * @deprecated Migration service has been removed.
 * Input for bulk converting single designs to templates.
 * Used for automated migrations.
 */
export type InputBulkConvertSinglesToTemplate = {
  /** ID of the migration process to track. */
  migrationId: Scalars['Int']['input'];
};

export type InputBulkDeleteAiAgentReports = {
  reportIds: Array<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputBulkDesignAdTag = {
  designIds: Array<Scalars['Int']['input']>;
};

export type InputBulkDownloadAiAgentAutomatedReports = {
  reportIds: Array<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputBulkDownloadAiAgentReports = {
  reportIds: Array<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputBulkRemoveBgFeed = {
  columnIndex: Scalars['Int']['input'];
  feedId: Scalars['Int']['input'];
};

export type InputBulkRevertBgFeed = {
  columnIndex: Scalars['Int']['input'];
  feedId: Scalars['Int']['input'];
};

export type InputBulkSmartCropFeed = {
  columnIndex: Scalars['Int']['input'];
  feedId: Scalars['Int']['input'];
  mode: Scalars['String']['input'];
  overwriteUserEdits?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputBynder = {
  bynder: Scalars['Boolean']['input'];
  teamId: Scalars['Int']['input'];
};

/** Filters for querying Bynder assets. */
export type InputBynderAssetFilters = {
  /** Filter by archived assets. */
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by Bynder brand ID. */
  brandId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by Bynder category ID. */
  categoryId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by Bynder collection ID. */
  collectionId?: InputMaybe<Scalars['String']['input']>;
  /** Whether to include a count of total matching assets. */
  count?: InputMaybe<Scalars['Boolean']['input']>;
  /** Cursor for pagination in Bynder API v2. */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Filter by creation date (exact date or range start). */
  dateCreated?: InputMaybe<Scalars['String']['input']>;
  /** Filter by specific creation date. */
  dateCreatedOn?: InputMaybe<Scalars['String']['input']>;
  /** Filter by creation date (range end). */
  dateCreatedTo?: InputMaybe<Scalars['String']['input']>;
  /** Filter by modification date (exact date or range start). */
  dateModified?: InputMaybe<Scalars['String']['input']>;
  /** Filter by specific modification date. */
  dateModifiedOn?: InputMaybe<Scalars['String']['input']>;
  /** Filter by modification date (range end). */
  dateModifiedTo?: InputMaybe<Scalars['String']['input']>;
  /** Filter by a specific Bynder asset ID. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Filter by a list of Bynder asset IDs (comma-separated string or array). */
  ids?: InputMaybe<Scalars['String']['input']>;
  /** Whether to include media items for each asset. */
  includeMediaItems?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include the version number for each asset. */
  includeVersionNumber?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by publicly available assets. */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search keyword. */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** Maximum number of assets to return. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by limited usage assets. */
  limited?: InputMaybe<Scalars['Boolean']['input']>;
  /** Field to order the results by. */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  /** Filter by asset orientation (e.g., landscape, portrait, square). */
  orientation?: InputMaybe<Scalars['String']['input']>;
  /** Page number for pagination. */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by custom properties (JSON object). */
  properties?: InputMaybe<Scalars['JSON']['input']>;
  /** Filter by Bynder property option ID. */
  propertyOptionId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by Bynder sub-brand ID. */
  subBrandId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by tags (comma-separated string). */
  tags?: InputMaybe<Scalars['String']['input']>;
  /** Whether to include the total number of assets (deprecated, use count). */
  total?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by asset type (e.g., image, video, document). */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Filters for querying Bynder collections. */
export type InputBynderCollectionFilters = {
  /** Indicates whether or not the response should include count results. */
  count?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by a specific Bynder collection ID. */
  ids?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether or not the return should only contain collections marked as public. */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search keyword. */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** Maximum number of collections to return. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum amount of assets that the returned collections should have. */
  minCount?: InputMaybe<Scalars['Int']['input']>;
  /** Field to order the results by. */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  /** Page number for pagination. */
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** Input to get Bynder authentication URL. */
export type InputBynderGetAuth = {
  /** The Bynder portal URL. */
  portalUrl: Scalars['String']['input'];
};

/** Input to get the current Bynder user. */
export type InputBynderGetCurrentUser = {
  /** The Bynder portal URL. */
  portalUrl: Scalars['String']['input'];
  /** The Bynder access token. */
  token: Scalars['String']['input'];
};

export type InputCm360PublishUpdate = {
  count: Scalars['Int']['input'];
  creditTransactionId?: InputMaybe<Scalars['Int']['input']>;
  designHash: Scalars['String']['input'];
  exportType?: InputMaybe<DownloadType>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  success: Scalars['Boolean']['input'];
  userId: Scalars['Int']['input'];
};

/** Input for updating a team's owner via customer support. */
export type InputCsTeamOwnerUpdate = {
  /** Email of the new owner. */
  ownerEmail: Scalars['String']['input'];
  /** ID of the team to update. */
  teamId: Scalars['Int']['input'];
};

export type InputCancelAiResize = {
  hash: Scalars['String']['input'];
};

export type InputCancelBsSubscription = {
  keepAdTagActive?: InputMaybe<Scalars['Boolean']['input']>;
  migrationId: Scalars['Int']['input'];
};

export type InputCancelDownload = {
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputCancelLayeredAd = {
  /** Id of the layered-ad AiOperation to stop. */
  aiOperationId: Scalars['Int']['input'];
};

export type InputCancelSubscription = {
  reason: Scalars['String']['input'];
  reasonCategory?: InputMaybe<CancellationReasonCategory>;
  subscriptionId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
  timeframe?: InputMaybe<Scalars['String']['input']>;
};

export type InputCancelWorkflow = {
  hash: Scalars['String']['input'];
  moodboardHash: Scalars['String']['input'];
};

export type InputCatalog = {
  hash: Scalars['String']['input'];
};

/** A user-defined typed column for a manual catalog (CRE-424, D12) */
export type InputCatalogColumn = {
  name: Scalars['String']['input'];
  /** Restricted server-side to the manual-catalog subset (string/number/url/boolean/image) */
  type: FeedColumnType;
};

export type InputCatalogConnections = {
  hash: Scalars['String']['input'];
};

export type InputCatalogProducts = {
  /** Ad-hoc column filters — same rule shape as a dynamic set's rules, ANDed (CRE-444) */
  filters?: InputMaybe<Array<InputProductSetRule>>;
  hash: Scalars['String']['input'];
  /** Page size: 50 when absent; must be 1-100 (a value outside that range is rejected) */
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Only products of this set (CRE-418, D25 — resolved server-side); composes with search/tag */
  productSetId?: InputMaybe<Scalars['Int']['input']>;
  /** Only products whose derived typed-IMAGE readiness matches this bucket (CRE-439); catalogs without IMAGE columns match none */
  readiness?: InputMaybe<CatalogImageReadiness>;
  /** Case-insensitive substring match across the merged row's cell values */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Exact match on a product tag */
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type InputCatalogPublishRuns = {
  channel?: InputMaybe<Scalars['String']['input']>;
  hash: Scalars['String']['input'];
  /** 0-based page index; defaults to 0. */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Clamped to [1, 50]; defaults to 20. */
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** 'newest' (default) | 'oldest'. Plain string, same house rule as channel — an unknown value reads as newest-first. */
  sort?: InputMaybe<Scalars['String']['input']>;
};

/** Per-row failure of a catalog run (CRE-414, §4.6). row = 0-based index, -1 = run-level failure */
export type InputCatalogRunFailure = {
  productKey?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
  row: Scalars['Int']['input'];
};

/**
 * Catalog run stats computed by the feed-sync worker (CRE-414 — the worker
 * holds both the old and the new payload, so the diff is computed there and
 * persisted by updateFeedData; see services/feed/updateFeedDbData.ts).
 */
export type InputCatalogRunStats = {
  added: Scalars['Int']['input'];
  /** productKeys added this run (capped at 5000) — feeds the new_this_week smart set (CRE-417) */
  addedKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** productKeys whose availability flipped out→in this run (capped at 5000) — feeds back_in_stock (CRE-417) */
  backInStockKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  durationMs: Scalars['Int']['input'];
  failures: Array<InputCatalogRunFailure>;
  removed: Scalars['Int']['input'];
  skipped: Scalars['Int']['input'];
  startedAt: Scalars['Date']['input'];
  status: CatalogRunStatus;
  /** Run trigger — mutation-triggered worker syncs pass manual/first_import; absent = schedule (old workers) */
  trigger?: InputMaybe<CatalogRunTrigger>;
  /** User who triggered a manual/first_import run — recorded on catalog_run for attribution */
  triggeredByUserId?: InputMaybe<Scalars['Int']['input']>;
  updated: Scalars['Int']['input'];
};

/**
 * One reviewed column→layer bind from the mapping dialog (CRE-541). layerId is
 * the layer's bannersetElementId (or its id when no cross-size id exists); the
 * server derives the feed hash itself rather than trusting the client's.
 */
export type InputCatalogVariationBind = {
  column: Scalars['String']['input'];
  layerId: Scalars['String']['input'];
  property: CatalogVariationBindProperty;
};

export type InputCatalogs = {
  /** Creator facet (CRE-451), by team user id. Empty or omitted = every creator. */
  createdByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Only catalogs the current user has favorited (CRE-495) */
  favoritesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Case-insensitive substring match on the catalog name (CRE-495) */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Ordering (CRE-451). Omitted = newest first, which is what shipped before. */
  sort?: InputMaybe<CatalogsSort>;
  /** Source-type facet (CRE-451). Empty or omitted = no source filtering. */
  sourceTypes?: InputMaybe<Array<FeedSourceType>>;
  /** Sync-status facet (CRE-451). Empty or omitted = no status filtering. */
  statuses?: InputMaybe<Array<CatalogSyncStatusFilter>>;
  teamId: Scalars['Int']['input'];
  /** Refresh-schedule facet (CRE-451). Empty or omitted = no schedule filtering. */
  updateFrequencies?: InputMaybe<Array<UpdateFrequencyType>>;
  /**
   * Ignored: catalogs are team-level for now, so the list is never narrowed to a
   * workspace. Kept optional so older clients that still send it keep validating.
   */
  workspaceId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputChangeAbTestEndingType = {
  endingType: EndedType;
  id: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

export type InputChangeBrandControlOption = {
  teamId: Scalars['Int']['input'];
  type: BrandControlTypes;
  value: Scalars['Boolean']['input'];
};

export type InputChangeDesignFeedRow = {
  catalogId: Scalars['Int']['input'];
  designId: Scalars['Int']['input'];
  /** Opaque attachment revision observed by the caller before selecting this row. */
  expectedAttachmentRevision: Scalars['String']['input'];
  /**
   * Take the persisted path even while impersonating. Row NAVIGATION by an
   * impersonator stays a preview that writes nothing; this opt-in exists for the
   * impersonator's explicit "Save" action, which is a deliberate, confirmed write
   * to the customer's design. Ignored outside an impersonated session.
   */
  persistWhileImpersonating?: InputMaybe<Scalars['Boolean']['input']>;
  row: Scalars['Int']['input'];
};

export type InputChangeDesignProductSet = {
  catalogId: Scalars['Int']['input'];
  designId: Scalars['Int']['input'];
  /** Opaque attachment revision observed by the caller. Omitted by clients deployed before attachment generations. */
  expectedAttachmentRevision?: InputMaybe<Scalars['String']['input']>;
  /** Product-set scope observed by the caller. Omitted by legacy clients; null means All products. */
  observedProductSetId?: InputMaybe<Scalars['Int']['input']>;
  /** Product set of the attached catalog this design should render. Null/omitted = the entire catalog. */
  productSetId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputChangeEmail = {
  changeReason?: InputMaybe<Scalars['String']['input']>;
  filePaths: Array<Scalars['String']['input']>;
  newEmail: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};

/** Input for changing the owner of a team. */
export type InputChangeOwner = {
  /** ID of the team to change ownership of. */
  teamId: Scalars['Int']['input'];
  /** ID of the user to make the new owner. */
  userId: Scalars['Int']['input'];
};

export type InputChangeVideoSpeed = {
  /** When true, audio pitch follows speed (varispeed). Default false preserves pitch. */
  changeAudioPitch?: InputMaybe<Scalars['Boolean']['input']>;
  /** 2–10 control points; a uniform speed is two identical-speed points. */
  points: Array<InputSpeedCurvePoint>;
  videoUrl: Scalars['String']['input'];
};

/** Input type for checking if an ad network exists. */
export type InputCheckAdNetworkExists = {
  /** The name of the ad network to check. */
  name: Scalars['String']['input'];
  /** The ID of the team associated with the ad network. */
  teamId: Scalars['Int']['input'];
};

export type InputCheckAiOperation = {
  id: Scalars['Int']['input'];
};

export type InputCheckAiOperations = {
  ids: Array<Scalars['Int']['input']>;
};

/** Input for checking if fonts in a design support AI translate feeds. */
export type InputCheckAiTranslateFeedFontsCompatibility = {
  /** ID of the design to check fonts for. */
  designId: Scalars['Int']['input'];
};

/**
 * Input for checking multiple font/text combinations.
 * Used for batch compatibility checking.
 */
export type InputCheckBulkFontCompatible = {
  /** ID of the design context. */
  designId: Scalars['Int']['input'];
  /** Array of font and text checks to perform. */
  texts: Array<InputFontCheck>;
};

/** Input for checking all fonts in a design for compatibility. */
export type InputCheckDesignFontsCompatibility = {
  /** ID of the design to check fonts for. */
  designId: Scalars['Int']['input'];
};

export type InputCheckDuplicatingFolder = {
  folderId: Scalars['Int']['input'];
};

/** Input for checking if designs are being edited. */
export type InputCheckEditingDesign = {
  /** Type of action to check. */
  checkActionType: CheckActionTypes;
  /** Array of design hashes to check. */
  designsHashes: Array<Scalars['String']['input']>;
  /** Whether this is a bulk action affecting multiple designs. */
  isBulkAction?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the designs are templates. */
  isTemplate: Scalars['Boolean']['input'];
};

export type InputCheckFeedSourceUrl = {
  teamId: Scalars['Int']['input'];
  url: Scalars['String']['input'];
};

export type InputCheckFeedStatusActionType = {
  feedId: Scalars['Int']['input'];
};

/** Input for checking if a font supports specific text. */
export type InputCheckFontCompatible = {
  /** ID of the design context. */
  designId: Scalars['Int']['input'];
  /** Font family name to check. */
  fontFamily: Scalars['String']['input'];
  /** Type of font (system, google, custom, etc.). */
  fontType: Scalars['String']['input'];
  /** URL to the font file (optional). */
  fontUrl?: InputMaybe<Scalars['String']['input']>;
  /** Text to check compatibility with. */
  text: Scalars['String']['input'];
};

/** Input for checking if a font supports a specific language. */
export type InputCheckFontCompatibleWithLanguage = {
  /** ID of the design context. */
  designId: Scalars['Int']['input'];
  /** Font family name to check. */
  fontFamily: Scalars['String']['input'];
  /** Type of font (system, google, custom, etc.). */
  fontType: Scalars['String']['input'];
  /** URL to the font file (optional). */
  fontUrl?: InputMaybe<Scalars['String']['input']>;
  /** Language code to check compatibility with (EN, FR, etc.). */
  languageCode: Scalars['String']['input'];
};

/** Input for checking an uploaded font against the browsers' font sanitizer. */
export type InputCheckFontForBrowsers = {
  /** ID of the brand kit the font is being uploaded to. */
  brandKitId: Scalars['Int']['input'];
  /** Hash identifier of the uploaded font file. */
  hash: Scalars['String']['input'];
  /** Original name of the font file. */
  name: Scalars['String']['input'];
};

export type InputCheckIfTeamIsInPaymentExperiment = {
  teamId: Scalars['Int']['input'];
};

export type InputCheckImageGeneration = {
  id: Scalars['Int']['input'];
};

/**
 * Input for checking media status in moodboard share context.
 * Used for polling media processing status without requiring authentication.
 */
export type InputCheckMoodBoardMedia = {
  /** Hash of the media asset to check. */
  hash: Scalars['String']['input'];
  /** Moodboard share hash for access validation. */
  moodBoardHash: Scalars['String']['input'];
  /** Optional password for password-protected moodboards. */
  password?: InputMaybe<Scalars['String']['input']>;
};

export type InputCheckScoreChecksum = {
  designId: Scalars['Int']['input'];
};

export type InputCheckTranslateFeedStatus = {
  feedId: Scalars['Int']['input'];
};

export type InputCheckValidCode = {
  code: Scalars['String']['input'];
  migrationId: Scalars['Int']['input'];
};

export type InputClaimAiStudioGenerationAnnouncement = {
  /** Any operation of the generation. */
  operationId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputClaimAiStudioGenerationApply = {
  /** The client's own facts about the outcome. Capped at 4 KB. */
  details?: InputMaybe<Scalars['JSON']['input']>;
  kind: AiStudioGenerationOutcomeKind;
  /** Any operation of the generation. */
  operationId: Scalars['Int']['input'];
  targetDesignBackground?: InputMaybe<Scalars['Boolean']['input']>;
  targetLayerId?: InputMaybe<Scalars['Int']['input']>;
  targetLayerName?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputClaimExperimentCredits = {
  campaignKey: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputClaimMotionDraft = {
  /** The claiming job's id: a replay of the same job's claim resumes the row it created. */
  claimToken?: InputMaybe<Scalars['String']['input']>;
  /** The sizes the user downloaded; the set's own id stands for all of its sizes. */
  designIds: Array<Scalars['Int']['input']>;
  /** Each downloaded design's content checksum at download time, keyed by design id; content edited since is refused. */
  downloadedChecksums?: InputMaybe<Scalars['JSON']['input']>;
  /** The downloaded design's SET parent. */
  setId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

export type InputClearAgentChats = {
  scope: ChatScope;
  teamId: Scalars['Int']['input'];
};

export type InputClearCreateAgentChats = {
  teamId: Scalars['Int']['input'];
};

export type InputCloneDesign = {
  hash: Scalars['String']['input'];
};

export type InputCloneDesignFeedFromEnv = {
  bindings: Scalars['Boolean']['input'];
  feedChecksum?: InputMaybe<Scalars['String']['input']>;
  row: Scalars['Int']['input'];
};

export type InputCloneDesignFromEnv = {
  /** Whether the source is a design set born as a set; sent only when true */
  bornAsSet?: InputMaybe<Scalars['Boolean']['input']>;
  designFeed?: InputMaybe<InputCloneDesignFeedFromEnv>;
  feed?: InputMaybe<InputCloneFeedFromEnv>;
  /** Design Hash from ENV */
  hash: Scalars['String']['input'];
  /** CDN from where to get the assets(logos,fonts,etc) */
  resourcesDomain: Scalars['String']['input'];
  /** If this is a design set then the sizes hashes must be specified */
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InputCloneDesignToTeam = {
  hash: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputCloneFeedFromEnv = {
  checksum?: InputMaybe<Scalars['String']['input']>;
  delimiter: DelimiterCsv;
  fileName?: InputMaybe<Scalars['String']['input']>;
  hash: Scalars['String']['input'];
  isSample: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  rows: Scalars['Int']['input'];
  sourceType: FeedSourceType;
  status: FeedStatus;
  targetColumn?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type InputCloneMoodBoard = {
  hash: Scalars['String']['input'];
};

export type InputCloneMoodBoardFromEnv = {
  hash: Scalars['String']['input'];
  moodboardDomain: Scalars['String']['input'];
  resourcesDomain: Scalars['String']['input'];
};

export type InputCloneProjectToTeam = {
  projectId: Scalars['Int']['input'];
  targetTeamId: Scalars['Int']['input'];
};

export type InputCloudbeds = {
  roomTypeIds: Array<Scalars['String']['input']>;
  startEndDate?: InputMaybe<Array<Scalars['Date']['input']>>;
};

export type InputCloudinary = {
  cloudinary: Scalars['Boolean']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputCmyk = {
  cmyk: Scalars['Boolean']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputCollectTransactionData = {
  amountInCents: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  invoiceNumber: Scalars['Int']['input'];
  lastName: Scalars['String']['input'];
  subscriptionId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
  timestamp: Scalars['String']['input'];
  transactionId: Scalars['String']['input'];
};

export type InputColor = {
  color: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InputCommentAttachmentUploadUrl = {
  commentId: Scalars['Int']['input'];
};

export type InputCommentSubscription = {
  designHash: Scalars['String']['input'];
};

export type InputCommentThreadPosition = {
  s?: InputMaybe<Scalars['Float']['input']>;
  slideId: Scalars['Int']['input'];
  x: Scalars['Int']['input'];
  y: Scalars['Int']['input'];
};

export type InputCompleteAiResizedSize = {
  /** Stop waiting: the session is discarded and nothing is charged. */
  abandon?: InputMaybe<Scalars['Boolean']['input']>;
  /** The design's hash, as addDesignSizes was called with it. */
  hash: Scalars['String']['input'];
  /** The size's name, as addDesignSizes was asked for it. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The variant addDesignSizes answered on AI_RESIZING; the size's dimensions and source come from its session. */
  variantId: Scalars['String']['input'];
};

export type InputCompleteBrandKitDocumentExtraction = {
  documentId: Scalars['Int']['input'];
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** DocumentExtractionResult from the extractor, on success. */
  extraction?: InputMaybe<Scalars['JSON']['input']>;
  /** The document's logo and brand images, as URLs to ingest, on success. */
  media?: InputMaybe<InputBrandKitDocumentMedia>;
  /** success or error */
  outcome: Scalars['String']['input'];
  /** Version stamped on the job; a stale stamp is discarded. */
  version: Scalars['Int']['input'];
};

export type InputCompleteBrandStyleReevaluation = {
  brandKitId: Scalars['Int']['input'];
  brandStyle?: InputMaybe<Scalars['JSON']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  outcome: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};

export type InputCompleteCloudinaryConnection = {
  /** The authorization code from the popup's URL. Named code so that request logs redact it. */
  code: Scalars['String']['input'];
  state: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputCompleteMotionDraft = {
  clipHeight: Scalars['Int']['input'];
  clipWidth: Scalars['Int']['input'];
  draftId: Scalars['Int']['input'];
  durationSeconds: Scalars['Float']['input'];
  mediaHash: Scalars['String']['input'];
  primaryDesignId: Scalars['Int']['input'];
  qcResult?: InputMaybe<Scalars['JSON']['input']>;
  sizeDesignIds: Array<Scalars['Int']['input']>;
};

export type InputConfirmEmail = {
  /** Confirmation code sent to the user's email. */
  confirmationCode: Scalars['String']['input'];
};

export type InputConfirmEmailChange = {
  accountId: Scalars['String']['input'];
};

/** One size of the design being connected: its FULL document, this catalog's markers included, baked at rowIndex. */
export type InputConnectCatalogSize = {
  banner: Scalars['JsonDesign']['input'];
  hash: Scalars['String']['input'];
  /** The size's Design.checksum when the app read it. A size whose document changed since is refused. */
  observedChecksum?: InputMaybe<Scalars['String']['input']>;
};

export type InputConnectCatalogToDesign = {
  catalogId: Scalars['Int']['input'];
  /** The design, or the set, the catalog attaches to (design_feed.designId). Never one size of a set. */
  designId: Scalars['Int']['input'];
  /** Feed.checksum the banners were baked under. If the catalog has moved since, the connect leaves checksum debt. */
  observedCatalogChecksum?: InputMaybe<Scalars['String']['input']>;
  /** Feed.overridesRevision the banners were baked under: omitted when never read, null for none, else count:newestWrite. */
  observedOverridesRevision?: InputMaybe<Scalars['String']['input']>;
  /** Local product set the design renders. Null or omitted means the entire catalog. */
  productSetId?: InputMaybe<Scalars['Int']['input']>;
  /** Absolute catalog row every banner was baked with. It must belong to the scope; it becomes the attachment's row. */
  rowIndex: Scalars['Int']['input'];
  /** Every size of the design, each exactly once. */
  sizes: Array<InputConnectCatalogSize>;
};

export type InputConsumeNextgenFlowCredits = {
  featureName: Scalars['String']['input'];
  featureType: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputContentLibrarySignUploadUrl = {
  fileName: Scalars['String']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
};

export type InputContentVariationJobs = {
  designHash: Scalars['String']['input'];
};

export type InputContentVariationSuggestedAudience = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type InputContinueAbTest = {
  id: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

/**
 * Input for converting a single design to a design set.
 * This allows creating variations of the design in different sizes.
 */
export type InputConvertSingleDesignToSet = {
  /** Hash of the design to convert to a set. */
  hash: Scalars['String']['input'];
};

export type InputConvertTrialSubscription = {
  teamId: Scalars['Int']['input'];
};

export type InputCopilotActiveBrandExtraction = {
  chatThreadId: Scalars['String']['input'];
  designHash: Scalars['String']['input'];
};

export type InputCopilotAiChat = {
  chatId?: InputMaybe<Scalars['Int']['input']>;
  message: InputCopilotAiChatMessage;
  teamId: Scalars['Int']['input'];
};

export type InputCopilotAiChatMessage = {
  content: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

export type InputCopilotBrandExtraction = {
  designHash: Scalars['String']['input'];
  extractionId: Scalars['Int']['input'];
};

export type InputCopilotDocumentBrandKitPreview = {
  designHash: Scalars['String']['input'];
  /**
   * WEBSITE only: the extraction the card shows. Refused with BRAND_KIT_CHANGED when the chat's
   * active extraction is another one now.
   */
  extractionId?: InputMaybe<Scalars['Int']['input']>;
  /** Only these fields; omitted or empty = every field the document has a value for. */
  fields?: InputMaybe<Array<CopilotDocumentBrandKitField>>;
  /** DOCUMENT when omitted. */
  source?: InputMaybe<CopilotDocumentBrandKitSource>;
  threadId: Scalars['String']['input'];
};

export type InputCopilotMediaImport = {
  designHash: Scalars['String']['input'];
  importId: Scalars['Int']['input'];
};

export type InputCopilotMediaImports = {
  chatThreadId: Scalars['String']['input'];
  /** Generate missing image descriptions on this read (default true). The one-turn wait reads again with false once the import is done. */
  describeImages?: InputMaybe<Scalars['Boolean']['input']>;
  designHash: Scalars['String']['input'];
};

export type InputCopilotPendingGenerations = {
  designHash: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputCopilotSceneChange = {
  /** The scene's prompt with the change made. Not with retake. */
  prompt?: InputMaybe<Scalars['String']['input']>;
  /** Another take of the scene as it is. */
  retake?: InputMaybe<Scalars['Boolean']['input']>;
  /** The scene number, from the storyboard. */
  scene: Scalars['Int']['input'];
  /** An instruction for the scene's opening picture, for a change to how it looks. */
  stillChange?: InputMaybe<Scalars['String']['input']>;
};

export type InputCopilotSceneEdit = {
  designHash: Scalars['String']['input'];
  /** The first opening-picture edit's operation, from the scene edit's start. */
  sceneEditId: Scalars['Int']['input'];
};

export type InputCopilotVideoStoryboard = {
  /** The design whose generations hold the video; the user must be able to edit it. */
  designHash: Scalars['String']['input'];
  /** The finished long video's media hash, from its generations row. */
  generationHash: Scalars['String']['input'];
};

export type InputCopySampleAdDesigns = {
  /** Sample-ads share token from the outreach/share-page link (group-level; multi-redeem). */
  shareToken: Scalars['String']['input'];
  /** Team the designs are copied into. The caller must be a member. */
  teamId: Scalars['Int']['input'];
};

export type InputCountProductSetRuleMatches = {
  hash: Scalars['String']['input'];
  /** The ANDed rule list to evaluate — the dynamic-set editor's live count (CRE-419) */
  rules: Array<InputProductSetRule>;
};

export type InputCouponDiscount = {
  couponCode: Scalars['String']['input'];
  planCode: Scalars['String']['input'];
  planTermEndsAt: Scalars['Date']['input'];
  seatPrice: Scalars['Float']['input'];
  seatsQuantity?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputCreateAbTest = {
  description?: InputMaybe<Scalars['String']['input']>;
  designs: Array<InputAbTestDesign>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  endingType?: InputMaybe<EndedType>;
  folderId?: InputMaybe<Scalars['Int']['input']>;
  keyMetric?: InputMaybe<KeyMetric>;
  name: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
};

export type InputCreateAgentLog = {
  teamId?: InputMaybe<Scalars['Int']['input']>;
  textLog: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Input for creating a media asset via API.
 * Used for automating media creation.
 */
export type InputCreateApiMedia = {
  /** Hash of the template to associate with. */
  templateHash: Scalars['String']['input'];
  /** URL of the media to create. */
  url: Scalars['String']['input'];
};

export type InputCreateAppIntegration = {
  accessToken: Scalars['String']['input'];
  appIntegration: AppIntegrationType;
  connectedEmail: Scalars['String']['input'];
  slackUserID?: InputMaybe<Scalars['String']['input']>;
  slackUserId?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['Int']['input']>;
  type: IntegrationAccountType;
  userId?: InputMaybe<Scalars['Int']['input']>;
  userToken?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
  workspaceName?: InputMaybe<Scalars['String']['input']>;
};

export type InputCreateAssetsNextgenAi = {
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  fetcherType?: InputMaybe<Array<NextgenAiFetcherType>>;
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Input for creating a new brand kit in Creatopy.
 * Brand kits contain design assets like logos, colors, and fonts that define a brand's identity.
 */
export type InputCreateBrandKit = {
  /** Array of colors to include in the brand kit. */
  colors?: InputMaybe<Array<InputColor>>;
  /** Array of fonts to add to the brand kit, referenced by URL. */
  fonts?: InputMaybe<Array<FontFromUrl>>;
  /** Array of logos to add to the brand kit, referenced by URL. */
  logos?: InputMaybe<Array<LogoFromUrl>>;
  /** Name of the brand kit. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of an existing NextgenAi record to reuse for brand style analysis instead of creating a new one. */
  nextgenAiId?: InputMaybe<Scalars['Int']['input']>;
  /** Source information for tracking where the brand kit was created from. */
  source?: InputMaybe<Scalars['String']['input']>;
  /** ID of the team that will own this brand kit. */
  teamId: Scalars['Int']['input'];
  /** Voice and tone settings for the brand kit, used for AI-generated content. */
  voiceAndTone?: InputMaybe<InputVoiceAndTone>;
};

export type InputCreateBrandKitButton = {
  brandKitId: Scalars['Int']['input'];
  properties: Scalars['JSON']['input'];
};

/** Input for setting target audience for a brand kit. */
export type InputCreateBrandTargetAudience = {
  /** Whether the brand audience was AI-suggested. */
  aiSuggestedBrandAudience: Scalars['Boolean']['input'];
  /** Name of the brand's audience. */
  audienceName: Scalars['String']['input'];
  /** Description of the brand's audience. */
  brandAudience: Scalars['String']['input'];
  /** ID of the brand kit to update. */
  brandKitId: Scalars['Int']['input'];
};

export type InputCreateBrandTemplate = {
  brandKitId: Scalars['Int']['input'];
  creationSource?: InputMaybe<DesignCreationSource>;
  designSizeTypeId?: InputMaybe<Scalars['Int']['input']>;
  exportNext?: InputMaybe<Scalars['Boolean']['input']>;
  folderId?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  isApiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  json?: InputMaybe<Scalars['JsonDesign']['input']>;
  measureUnit?: InputMaybe<MeasureUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  sizeVariation?: InputMaybe<Scalars['String']['input']>;
  slidesCount?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type InputCreateBrandTemplateSet = {
  brandKitId: Scalars['Int']['input'];
  creationSource?: InputMaybe<DesignCreationSource>;
  designSizeTypeId: Scalars['Int']['input'];
  exportNext?: InputMaybe<Scalars['Boolean']['input']>;
  folderId?: InputMaybe<Scalars['Int']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputCreateBulkDesigns = {
  designId: Scalars['Int']['input'];
  feedId: Scalars['Int']['input'];
  parentId?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['Int']['input'];
  selectedRows: Array<Scalars['Int']['input']>;
};

export type InputCreateCloudIntegration = {
  accessToken: Scalars['String']['input'];
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  connectedEmail: Scalars['String']['input'];
  expiresAt: Scalars['Date']['input'];
  grantedScopes?: InputMaybe<Scalars['String']['input']>;
  integrationApp: Integrations;
  refreshToken: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['Int']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  type: IntegrationAccountType;
  /** Marks the integration as personal. It is always the signed-in user's own; the id sent is ignored. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputCreateColorPalette = {
  brandKitId: Scalars['Int']['input'];
};

export type InputCreateComment = {
  access?: InputMaybe<CommentThreadAccess>;
  authorEmail?: InputMaybe<Scalars['String']['input']>;
  authorName?: InputMaybe<Scalars['String']['input']>;
  designHash: Scalars['String']['input'];
  hotspotType?: InputMaybe<CommentThreadHotspotType>;
  message: Scalars['String']['input'];
  position?: InputMaybe<InputCommentThreadPosition>;
  reCaptchaToken?: InputMaybe<Scalars['String']['input']>;
  threadId?: InputMaybe<Scalars['Int']['input']>;
  uploadingFileName?: InputMaybe<Scalars['String']['input']>;
};

export type InputCreateCustomSizesFromBsCustomSizes = {
  migrationId: Scalars['Int']['input'];
  sizes: Array<WorkspaceSizes>;
};

export type InputCreateDefaultBrandKitButton = {
  brandKitId: Scalars['Int']['input'];
  properties: Scalars['JSON']['input'];
};

export type InputCreateDemoMoodBoard = {
  /** @deprecated Use projectId instead */
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  demoType?: InputMaybe<DemoType>;
  name: Scalars['String']['input'];
  /** Project ID for context @BreakingBad */
  projectId: Scalars['Int']['input'];
};

/**
 * Input for creating a new design.
 * This is the primary way to create a single design in Creatopy.
 */
export type InputCreateDesign = {
  /** ID of the brand kit to associate with the design. */
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  /** Source where the design is being created. */
  creationSource?: InputMaybe<DesignCreationSource>;
  /** How the user started the design (optional; unset records it as unknown). */
  designOrigin?: InputMaybe<DesignOrigin>;
  /**
   * ID of the design size (deprecated).
   * @deprecated Use designSizeTypeId
   */
  designSizeId?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the design size type to use. */
  designSizeTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** Design total time (optional) */
  duration?: InputMaybe<Scalars['Int']['input']>;
  /** Whether to mark the design for export with the next batch. */
  exportNext?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the folder to create the design in (optional). */
  folderId?: InputMaybe<Scalars['Int']['input']>;
  /** Height of the design in the specified measurement unit. */
  height?: InputMaybe<Scalars['Float']['input']>;
  /** Whether this design is generated via API. */
  isApiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this design is a template. */
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  /** JSON representation of the design content. */
  json?: InputMaybe<Scalars['JsonDesign']['input']>;
  /** Measurement unit for the design dimensions (px, mm, cm, in). */
  measureUnit?: InputMaybe<MeasureUnit>;
  /** Name of the design (optional - will use a default name if not provided). */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of the project to create the design in. */
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** Size variation name for predefined sizes. */
  sizeVariation?: InputMaybe<Scalars['String']['input']>;
  /** Number of slides in the design (defaults to 1). */
  slidesCount?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the team that will own the design. */
  teamId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Hash of a template to use (deprecated).
   * @deprecated Use InputCreateDesignFromTemplate
   */
  templateHash?: InputMaybe<Scalars['String']['input']>;
  /** Width of the design in the specified measurement unit. */
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type InputCreateDesignComponent = {
  brandKitId: Scalars['Int']['input'];
  height: Scalars['Float']['input'];
  json: Scalars['JsonDesign']['input'];
  name: Scalars['String']['input'];
  width: Scalars['Float']['input'];
};

export type InputCreateDesignFromBsBanner = {
  bannerData: BannerData;
  json: Scalars['JSON']['input'];
};

/** Input for creating a design from a Getting Started step template. */
export type InputCreateDesignFromGettingStarted = {
  /** When true, the design copied from the step's template may be created as a design set holding one size. Server-gated, as on InputDuplicateDesign. */
  asSetIfSingle?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the project to create the design in. */
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the Getting Started step (e.g. ad-studio, single-asset). */
  stepId: Scalars['String']['input'];
  /** ID of the team to create the design in. */
  teamId: Scalars['Int']['input'];
};

/**
 * Input for creating a design from a JSON design (typically generated from an image).
 * This is specifically for AI-generated designs from images.
 */
export type InputCreateDesignFromImageJson = {
  /** ID of the folder to place the design in. */
  folderId?: InputMaybe<Scalars['Int']['input']>;
  /** JSON representation of the design content. */
  json: Scalars['JsonDesign']['input'];
  /** Name for the new design. */
  name: Scalars['String']['input'];
  /** ID of the project to create the design in. */
  projectId: Scalars['Int']['input'];
  /** When true and folderId is not set, automatically place the design in an 'AI generated designs' folder. */
  useAiFolder?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputCreateDesignFromJsons = {
  jsons: Array<Scalars['JsonDesign']['input']>;
  teamId: Scalars['Int']['input'];
};

/**
 * Input for creating a design from a template.
 * Use this to create a design based on an existing template.
 */
export type InputCreateDesignFromTemplate = {
  /** Source where the design is being created. */
  creationSource?: InputMaybe<DesignCreationSource>;
  /** ID of the design size type to use. */
  designSizeTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** Whether to mark the design for export with the next batch. */
  exportNext?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the folder to create the design in (optional). */
  folderId?: InputMaybe<Scalars['Int']['input']>;
  /** Name for the new design. */
  name: Scalars['String']['input'];
  /** ID of the project to create the design in. */
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the team that will own the design. */
  teamId?: InputMaybe<Scalars['Int']['input']>;
  /** Hash of the template design to use as a base. */
  templateHash: Scalars['String']['input'];
};

/** Input for creating a folder in a design's media library. */
export type InputCreateDesignMediaFolder = {
  /** ID of the design whose library the folder is created in. */
  designId: Scalars['Int']['input'];
  /** Name of the folder (1-100 chars after trimming). */
  name: Scalars['String']['input'];
  /** Parent folder id; null/omitted creates the folder at the library root. */
  parentId?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Input for creating a design set (deprecated).
 * A design set is a collection of related designs, typically in different sizes.
 */
export type InputCreateDesignSet = {
  /** ID of the brand kit to associate with the design set. */
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  /** Source where the design set is being created. */
  creationSource?: InputMaybe<DesignCreationSource>;
  /** Design JSONs, if this is sent sizes are ignored. */
  designJsons?: InputMaybe<Array<InputDesignJsonForSet>>;
  /** JSON representation of the design set. */
  designSetJson?: InputMaybe<Scalars['JSON']['input']>;
  /** ID of the design size type for the design set. */
  designSizeTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** Design total time (optional) */
  duration?: InputMaybe<Scalars['Int']['input']>;
  /** Whether to mark the design set for export with the next batch. */
  exportNext?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the folder to create the design set in (optional). */
  folderId?: InputMaybe<Scalars['Int']['input']>;
  /** Hash of an existing design to use as a base. */
  fromHash?: InputMaybe<Scalars['String']['input']>;
  /** Whether this design set is generated via API. */
  isApiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this design set is a template. */
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name for the design set (optional). */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of the project to create the design set in. */
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** Sizes for the design set, ignored if designJsons is provided. */
  sizes?: InputMaybe<Array<InputDesignSetSize>>;
  /** Number of slides in each design. */
  slidesCount?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the team that will own the design set. */
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputCreateDesignSetFromBsBannerSet = {
  bannerSetData: BannerSetData;
  setJson?: InputMaybe<Scalars['JSON']['input']>;
};

/** Input for creating one or more variations of a master design set. */
export type InputCreateDesignVariation = {
  /** PRODUCT_CATALOG only: reviewed column→layer bindings from the mapping dialog. At least ONE binding is required — an unbound catalog variation would render static content with every editing surface gated (see CRE-553), so an empty/omitted list is rejected. */
  binds?: InputMaybe<Array<InputCatalogVariationBind>>;
  /** PRODUCT_CATALOG only (CRE-541): hash of the catalog the new variation binds to. Required for that kind, rejected for every other. */
  catalogHash?: InputMaybe<Scalars['String']['input']>;
  /** Source language for LANGUAGE variations. Used as the DeepL source_lang hint. */
  detectedLanguage?: InputMaybe<Scalars['LanguageCodesType']['input']>;
  /** Target languages for LANGUAGE variations. One variation is created per language not already present. */
  languages?: InputMaybe<Array<Scalars['LanguageCodesType']['input']>>;
  /** PRODUCT_CATALOG only: local product set scoping the attachment; null/omitted = the entire catalog. */
  productSetId?: InputMaybe<Scalars['Int']['input']>;
  /** Hash of the design set to duplicate — the master itself or an existing variation. The copy links to the true master. */
  sourceHash: Scalars['String']['input'];
  /** Which kind of variation to create. Defaults to duplicating the source. */
  variationType?: DesignVariationType;
};

/**
 * Input for creating a design with an asset.
 * Use this to create a design based on an existing asset.
 */
export type InputCreateDesignWithAsset = {
  /** File type of the asset. */
  assetMediaType: MediaType;
  /** Asset URL to create the design from. */
  assetUrl: Scalars['String']['input'];
  /** Source where the design is being created. */
  creationSource?: InputMaybe<DesignCreationSource>;
  /** ID of the folder to create the design in (optional). */
  folderId?: InputMaybe<Scalars['Int']['input']>;
  /** Name for the new design. */
  name: Scalars['String']['input'];
  /** ID of the project to create the design in. */
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the team that will own the design. */
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Input for creating a design with an image/video layer already placed on the stage.
 * This is specifically designed for mood board functionality where the image should be
 * automatically placed on the design when created.
 */
export type InputCreateDesignWithImageLayer = {
  /** ID of the brand kit to associate with the design. */
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  /** Source where the design is being created. */
  creationSource?: InputMaybe<DesignCreationSource>;
  /** ID of the design size type to use. */
  designSizeTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** Design total time (optional) */
  duration?: InputMaybe<Scalars['Int']['input']>;
  /** Whether to mark the design for export with the next batch. */
  exportNext?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the folder to create the design in (optional). */
  folderId?: InputMaybe<Scalars['Int']['input']>;
  /** Height of the design in the specified measurement unit. */
  height?: InputMaybe<Scalars['Float']['input']>;
  /** URL of the image/video to be placed on the design stage. */
  imageUrl: Scalars['String']['input'];
  /** Whether this design is generated via API. */
  isApiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this design is a template. */
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Measurement unit for the design dimensions (px, mm, cm, in). */
  measureUnit?: InputMaybe<MeasureUnit>;
  /** Type of media being added (image or video). */
  mediaType: MediaType;
  /** Hash of the moodboard (optional - used when creating from moodboard to organize in folders). */
  moodboardHash?: InputMaybe<Scalars['String']['input']>;
  /** Name of the design (optional - will use a default name if not provided). */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Original height of the image/video for proper scaling. */
  originalHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Original width of the image/video for proper scaling. */
  originalWidth?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the project to create the design in. */
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** Whether to save the image/video to brand kit automatically. */
  saveToBrandKit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Size variation name for predefined sizes. */
  sizeVariation?: InputMaybe<Scalars['String']['input']>;
  /** Number of slides in the design (defaults to 1). */
  slidesCount?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the team that will own the design. */
  teamId?: InputMaybe<Scalars['Int']['input']>;
  /** Width of the design in the specified measurement unit. */
  width?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * Input for creating a design with a video layer already placed on the stage.
 * This is specifically designed for mood board functionality where the video should be
 * automatically placed on the design when created.
 * Handles both video URLs and hashes from S3 platform.
 */
export type InputCreateDesignWithVideoLayer = {
  /** ID of the brand kit to associate with the design. */
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  /** Source where the design is being created. */
  creationSource?: InputMaybe<DesignCreationSource>;
  /** ID of the design size type to use. */
  designSizeTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** Design total time (optional) */
  duration?: InputMaybe<Scalars['Int']['input']>;
  /** Whether to mark the design for export with the next batch. */
  exportNext?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the folder to create the design in (optional). */
  folderId?: InputMaybe<Scalars['Int']['input']>;
  /** Height of the design in the specified measurement unit. */
  height?: InputMaybe<Scalars['Float']['input']>;
  /** Whether this design is generated via API. */
  isApiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this design is a template. */
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Measurement unit for the design dimensions (px, mm, cm, in). */
  measureUnit?: InputMaybe<MeasureUnit>;
  /** Hash of the moodboard (optional - used when creating from moodboard to organize in folders). */
  moodboardHash?: InputMaybe<Scalars['String']['input']>;
  /** Name of the design (optional - will use a default name if not provided). */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Original height of the video for proper scaling. */
  originalHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Original width of the video for proper scaling. */
  originalWidth?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the project to create the design in. */
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** Whether to save the video to brand kit automatically. */
  saveToBrandKit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Size variation name for predefined sizes. */
  sizeVariation?: InputMaybe<Scalars['String']['input']>;
  /** Number of slides in the design (defaults to 1). */
  slidesCount?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the team that will own the design. */
  teamId?: InputMaybe<Scalars['Int']['input']>;
  /** Hash of the video from S3 platform (required if videoUrl is not provided). Takes precedence over videoUrl. */
  videoHash?: InputMaybe<Scalars['String']['input']>;
  /** URL of the video to be placed on the design stage (required if videoHash is not provided). */
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  /** Width of the design in the specified measurement unit. */
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type InputCreateDriveFolder = {
  accountType?: InputMaybe<IntegrationAccountType>;
  folderName: Scalars['String']['input'];
  parentFolderId?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputCreateDummyComments = {
  designHash: Scalars['String']['input'];
};

/** Input for creating or editing a webhook for a team. */
export type InputCreateEditTeamWebhook = {
  /** IDs of actions that trigger this webhook. */
  actions: Array<Scalars['Int']['input']>;
  /** Name for the webhook. */
  name: Scalars['String']['input'];
  /** ID of the team that owns the webhook. */
  teamId: Scalars['Int']['input'];
  /** URL to send webhook events to. */
  url: Scalars['String']['input'];
  /** ID of the webhook to edit (null for create). */
  webhookId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputCreateFeature = {
  /** Feature category */
  category: Scalars['String']['input'];
  /** Feature config */
  config?: InputMaybe<Scalars['JSON']['input']>;
  /** ID of a style to associate with the new feature */
  featureStyleId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  /** Name of the suggested plan group */
  planGroup: Scalars['String']['input'];
  /** Style properties for new feature */
  properties?: InputMaybe<InputFeatureProperties>;
};

export type InputCreateFeed = {
  data?: InputMaybe<Scalars['String']['input']>;
  delimiter: DelimiterCsv;
  fileName?: InputMaybe<Scalars['String']['input']>;
  isSample?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Structured feed payload (columns + rows). Used by chat-driven custom-feed
   * creation (Studio Assistant Phase 3) to avoid round-tripping rows through a
   * CSV string. Mutually exclusive with `data` and `url` — the resolver uses
   * whichever is provided.
   */
  jsonData?: InputMaybe<Scalars['FeedJson']['input']>;
  name: Scalars['String']['input'];
  processingMode?: InputMaybe<FeedProcessingMode>;
  /**
   * The design a "Design based" catalog was snapshotted from (CRE-595). That
   * wizard source builds an ordinary csv_tsv feed out of the design's layers,
   * so without this the result is indistinguishable from an uploaded file.
   * Provenance only — it does not change how the feed syncs or renders.
   */
  sourceDesignId?: InputMaybe<Scalars['Int']['input']>;
  sourceType?: InputMaybe<FeedSourceType>;
  targetColumn?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
  updateFrequency?: InputMaybe<UpdateFrequencyType>;
  url?: InputMaybe<Scalars['String']['input']>;
  /**
   * Workspace (project) to stamp on the feed. Catalogs are team-level for now: the
   * catalogs wizard omits it like AdStudio feed creation always did, and no list
   * scopes by it (architecture §1 status note). Must belong to teamId when sent.
   */
  workspaceId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputCreateFolder = {
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputCreateFolderFromBsFolder = {
  bannersnackFolderId: Scalars['Int']['input'];
  bannersnackParentId?: InputMaybe<Scalars['Int']['input']>;
  bannersnackSubfoldersIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  folderLevel: Scalars['Int']['input'];
  migrationId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  workspaceId?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for creating a design from a Creatopy template. */
export type InputCreateFromCreatopyDesign = {
  /** When true, a copy of a single design may be created as a design set holding one size. Server-gated, as on InputDuplicateDesign. */
  asSetIfSingle?: InputMaybe<Scalars['Boolean']['input']>;
  /** Hash of the template design to use. */
  designHash: Scalars['String']['input'];
  /**
   * Filter by design size type categories (deprecated).
   * @deprecated Use setDesignSizeTypeId
   */
  filterCategories?: InputMaybe<Array<DesignSizeTypeCategory>>;
  /** ID of the folder to create the design in. */
  folderId?: InputMaybe<Scalars['Int']['input']>;
  /** Whether to keep the original name from the template. */
  keepOriginalName?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the project to create the design in. */
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** Whether to remove animations from the template. */
  removeAnimation?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the design size type to set. */
  setDesignSizeTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the team to create the design in. */
  teamId: Scalars['Int']['input'];
};

export type InputCreateIntercomConversation = {
  message: Scalars['String']['input'];
};

export type InputCreateLearnAgentReportSignedUrl = {
  chatId: Scalars['Int']['input'];
  htmlId: Scalars['Int']['input'];
  htmlTitle: Scalars['String']['input'];
  messageId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

/**
 * Manual catalog creation (CRE-424, architecture §5/§6.3): a blank catalog with
 * sourceType 'manual', an empty S3 payload and the given typed columns. Rows are
 * added later through the existing edit view (updateFeedRow, D15).
 */
export type InputCreateManualCatalog = {
  columns: Array<InputCatalogColumn>;
  name: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
  /** Workspace the catalog lands in; omitted = unassigned (surfaces team-wide, §3.1) */
  workspaceId?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Input for creating a new media asset.
 * Used by both createMedia and createNewMedia mutations.
 */
export type InputCreateMedia = {
  /** ID of the brand kit to assign the media to (optional). */
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the design whose media library the media is added to (optional). */
  designId?: InputMaybe<Scalars['Int']['input']>;
  /** Destination path for the media file. */
  destination: Scalars['String']['input'];
  /** When true, enqueue AI metadata extraction (e.g. variation suggestions) for images. Used by moodboard uploads. */
  extractMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  /** Flags that can be used to direct the processing stage */
  flags?: InputMaybe<InputCreateMediaFlags>;
  /** Format of the media file (jpg, png, etc.) */
  format?: InputMaybe<MediaFormat>;
  /** ID of the design-media-library folder the upload lands in (requires designId; optional). */
  libraryFolderId?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the media folder to save to (optional). */
  mediaFolderId?: InputMaybe<Scalars['Int']['input']>;
  mediaSourceType?: InputMaybe<MediaSourceType>;
  /** Display name for the media asset. */
  name: Scalars['String']['input'];
  /** ID of the project to assign the media to (optional). */
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** When true, create the Media record without attaching it to any project (so it does not show up in the brand kit / team media library). Used for standalone analysis inputs such as visual-style reference images. */
  skipProjectAssociation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Source path of the media file. */
  source: Scalars['String']['input'];
  /** ID of the team that will own the media (optional). */
  teamId?: InputMaybe<Scalars['Int']['input']>;
  /** Timeout for the gis media process (optional). */
  timeout?: InputMaybe<Scalars['Int']['input']>;
  /** Type of media (IMAGE, VIDEO, etc.) */
  type: MediaType;
  /** Public URL for the media (optional). */
  url?: InputMaybe<Scalars['String']['input']>;
  /** Whether to use user-specific upload folders. */
  useUserUploadFolders?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputCreateMediaFlags = {
  skipXlinkHrefsCheck?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputCreateMediaFolder = {
  brandKitId: Scalars['Int']['input'];
  checkDuplicate?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<MediaFolderType>;
};

export type InputCreateMediaFolderInternal = {
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<MediaFolderType>;
  userId: Scalars['Int']['input'];
};

export type InputCreateMoodBoard = {
  /** @deprecated Use projectId instead */
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  /** Project ID for context @BreakingBad */
  projectId: Scalars['Int']['input'];
};

export type InputCreateMoodBoardFromTemplateHash = {
  templateHash: Scalars['String']['input'];
};

/**
 * Input for creating media assets in moodboard share context.
 * Used for anonymous uploads where no authenticated user is required.
 */
export type InputCreateMoodBoardMedia = {
  /** Destination path for the media file. */
  destination: Scalars['String']['input'];
  /** Format of the media file (optional). */
  format?: InputMaybe<MediaFormat>;
  /** Moodboard share hash for access validation. */
  moodBoardHash: Scalars['String']['input'];
  /** Display name for the media asset. */
  name: Scalars['String']['input'];
  /** Optional password for password-protected moodboards. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Source path of the media file (S3 URL). */
  source: Scalars['String']['input'];
  /** Type of media (IMAGE, VIDEO, etc.) */
  type: MediaType;
  /** Public URL for the media (optional). */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type InputCreateMoodboardTeamInvitation = {
  hash: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  returnUrl: Scalars['String']['input'];
};

export type InputCreateNextGenLogo = {
  assetUrl: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  nextGenId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputCreateNextGenMedia = {
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  generateDescription?: InputMaybe<Scalars['Boolean']['input']>;
  nextGenId?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['Int']['input'];
  url: Scalars['String']['input'];
};

export type InputCreateNextGenSignedUrl = {
  contentType: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
};

export type InputCreateNextgenAi = {
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  fetcherType?: InputMaybe<Array<NextgenAiFetcherType>>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['Int']['input'];
  teamId?: InputMaybe<Scalars['Int']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type InputCreateNextgenAiBrandKit = {
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  brandValues?: InputMaybe<Scalars['String']['input']>;
  brandVoice?: InputMaybe<Scalars['String']['input']>;
  colors: Array<Scalars['String']['input']>;
  fonts: Array<InputCreateNextgenAiDesignFont>;
  logos: Array<InputCreateNextgenAiDesignLogo>;
  media: Array<InputCreateNextgenAiDesignMedia>;
  projectId: Scalars['Int']['input'];
  updateName?: InputMaybe<Scalars['Boolean']['input']>;
  url: Scalars['String']['input'];
  usedInGenerativeFlows?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputCreateNextgenAiDesign = {
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  folderId?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['Int']['input'];
  templateType: NextgenAiTemplateType;
  templates: Array<InputCreateNextgenAiDesignTemplate>;
  url: Scalars['String']['input'];
  wlSession?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputCreateNextgenAiDesignFont = {
  allUrls?: InputMaybe<Array<InputCreateNextgenAiDesignFontUrl>>;
  name: Scalars['String']['input'];
};

export type InputCreateNextgenAiDesignFontUrl = {
  fontStyle: Scalars['String']['input'];
  fontWeight: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type InputCreateNextgenAiDesignLogo = {
  id?: InputMaybe<Scalars['Int']['input']>;
  src: Scalars['String']['input'];
};

export type InputCreateNextgenAiDesignMedia = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  url: Scalars['String']['input'];
};

export type InputCreateNextgenAiDesignTemplate = {
  json?: InputMaybe<Scalars['JsonDesign']['input']>;
  name: Scalars['String']['input'];
  setHash: Scalars['String']['input'];
  sizeHash?: InputMaybe<Scalars['String']['input']>;
  sizes?: InputMaybe<Array<InputCreateNextgenAiDesignTemplateSizes>>;
  templateCategory?: InputMaybe<NextGenAiTemplateCategory>;
  uniqueId: Scalars['String']['input'];
};

export type InputCreateNextgenAiDesignTemplateSizes = {
  designSizeTypeName?: InputMaybe<Scalars['String']['input']>;
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

export type InputCreateOnboardingMoodBoard = {
  /** @deprecated Use projectId instead */
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  /** Project ID for context @BreakingBad */
  projectId: Scalars['Int']['input'];
  selectedIndustry: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputCreatePlan = {
  /** Recurly plan code */
  code: Scalars['String']['input'];
  /** Feature lists (now and soon) for plan */
  features?: InputMaybe<InputPlanFeatures>;
  /** Name of the group */
  planGroup: Scalars['String']['input'];
  /** Position of the group when displayed */
  position: Scalars['Int']['input'];
  /** Visual properties for plan */
  properties: InputPlanProperties;
};

export type InputCreateProductSet = {
  hash: Scalars['String']['input'];
  /** Dynamic sets: how the rule list combines (CRE-423) — omitted defaults to ALL server-side */
  matchMode?: InputMaybe<ProductSetMatchMode>;
  /** Static sets: the productKeys */
  members?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  /** Dynamic sets: the rule list */
  rules?: InputMaybe<Array<InputProductSetRule>>;
  /** dynamic or static — smart sets are created through setSmartSetEnabled */
  type: ProductSetType;
};

/** Input for creating a new project. */
export type InputCreateProject = {
  /** ID of the brand kit to associate with the project (optional). */
  brandkitId?: InputMaybe<Scalars['Int']['input']>;
  /** Theme color for the project. */
  color: Scalars['String']['input'];
  /** Description of the project (optional). */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name of the project. */
  name: Scalars['String']['input'];
  /** ID of the team that will own the project. */
  teamId: Scalars['Int']['input'];
  /** Create the project without a brand kit (only when the team allows it; cannot be combined with brandkitId). */
  withoutBrandKit?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputCreateSubscription = {
  /** The number of additional usage units - Ultra plans only */
  additionalUsage?: InputMaybe<Scalars['Int']['input']>;
  address?: InputMaybe<InputAddress>;
  coupon?: InputMaybe<Scalars['String']['input']>;
  /** The number of credits used as AddOn */
  credits?: InputMaybe<Scalars['Int']['input']>;
  /** When true, indicates the request comes from checkout/pricing page and should update plan version */
  fromCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  /** The number of impressions used as AddOn */
  impressions?: InputMaybe<Scalars['Int']['input']>;
  /** @BreakingBad - deprecated, migration feature removed */
  migrationId?: InputMaybe<Scalars['Int']['input']>;
  paymentType?: InputMaybe<PaymentTypes>;
  planCode: Scalars['String']['input'];
  /** The number of recurring credits used as AddOn */
  recurringCredits?: InputMaybe<Scalars['Int']['input']>;
  seats: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
  threeDSecureToken?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Variant>;
};

export type InputCreateSubscriptionChange = {
  /** The number of additional usage units (200 AI credits each at $50/mo) - Ultra plans only */
  additionalUsage?: InputMaybe<Scalars['Int']['input']>;
  address?: InputMaybe<InputAddress>;
  coupon?: InputMaybe<Scalars['String']['input']>;
  /** The number of credits used as AddOn */
  credits?: InputMaybe<Scalars['Int']['input']>;
  /** When true, indicates the request comes from checkout/pricing page and should update plan version */
  fromCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  /** The number of impressions used as AddOn */
  impressions?: InputMaybe<Scalars['Int']['input']>;
  /** @BreakingBad - deprecated, migration feature removed */
  migrationId?: InputMaybe<Scalars['Int']['input']>;
  paymentType?: InputMaybe<PaymentTypes>;
  planCode: Scalars['String']['input'];
  /** The number of recurring credits used as AddOn */
  recurringCredits?: InputMaybe<Scalars['Int']['input']>;
  seats?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
  threeDSecureToken?: InputMaybe<Scalars['String']['input']>;
  /** When to apply the change: 'now' (immediate), 'bill_date' (next billing cycle), or 'term_end' (end of term) */
  timeframe?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type InputCreateTeamIdentityProvider = {
  providerType: ProviderType;
  teamId: Scalars['Int']['input'];
};

/** Input for creating a team user group. */
export type InputCreateTeamUserGroup = {
  /** ID of the team to create the group in. */
  teamId: Scalars['Int']['input'];
};

export type InputCreateTemplatesFolder = {
  brandKitId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['Int']['input']>;
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputCreateTranslationFeed = {
  designId: Scalars['Int']['input'];
  detectedLanguage: Scalars['LanguageCodesType']['input'];
  languages: Array<Scalars['LanguageCodesType']['input']>;
};

export type InputCreateUsageRestriction = {
  action: UsageRestrictionAction;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['Date']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  scope: UsageRestrictionScope;
  teamId: Scalars['Int']['input'];
};

/** Applies one restriction to many teams. Same fields as the single-team input, with teamIds in place of teamId. */
export type InputCreateUsageRestrictionsBulk = {
  action: UsageRestrictionAction;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['Date']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  scope: UsageRestrictionScope;
  /** Duplicates are collapsed. Rejected when empty or above the batch ceiling. */
  teamIds: Array<Scalars['Int']['input']>;
};

export type InputCreateWorkflow = {
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  moodboardHash: Scalars['String']['input'];
  name: Scalars['String']['input'];
  trigger: Scalars['String']['input'];
  workflows: Array<Scalars['WorkflowJson']['input']>;
};

export type InputCropVideo = {
  height: Scalars['Float']['input'];
  videoUrl: Scalars['String']['input'];
  width: Scalars['Float']['input'];
  /**
   * The crop rectangle as FRACTIONS of the displayed frame (0-1), origin top-left —
   * never pixels. Resolved server-side against ffmpeg's own frame dimensions, which
   * is what makes a rotated source crop the axis the viewer actually saw.
   */
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

/** Final stored-space geometry for one element in one target size (cross-size push v2). */
export type InputCrossSizeAddedPlacement = {
  designSizeTypeId: Scalars['Int']['input'];
  /** bannersetElementId of the placed element: an added layer (roots AND descendants of added groups), or a pre-existing element of the target the user re-arranged in the positioning canvas. */
  el: Scalars['Int']['input'];
  height: Scalars['Float']['input'];
  paddingBottom?: InputMaybe<Scalars['Float']['input']>;
  paddingLeft?: InputMaybe<Scalars['Float']['input']>;
  paddingRight?: InputMaybe<Scalars['Float']['input']>;
  paddingTop?: InputMaybe<Scalars['Float']['input']>;
  rotation?: InputMaybe<Scalars['Float']['input']>;
  /** Text/countdown render scale, when the user resized the layer in the positioning canvas. */
  scale?: InputMaybe<Scalars['Float']['input']>;
  width: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type InputCurrentSubscription = {
  teamId: Scalars['Int']['input'];
};

export type InputCurrentTeamDownloads = {
  teamId: Scalars['Int']['input'];
};

export type InputCustomDesignSetSizeTypes = {
  /** How many sets to skip: the number already loaded. */
  offset: Scalars['Int']['input'];
  /** Keeps only the sets whose name contains this text, whatever the letter case. */
  search?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputCutSegment = {
  /** Seconds from the start of the source. Clamped server-side to the clip's real duration. */
  end: Scalars['Float']['input'];
  /** Seconds from the start of the source. >= 0 and lower than end. */
  start: Scalars['Float']['input'];
};

export type InputCutVideo = {
  /** 1–64 kept spans in source order: chronological, non-overlapping, each at least 0.5s long. */
  segments: Array<InputCutSegment>;
  videoUrl: Scalars['String']['input'];
};

export type InputDataLake = {
  eventName: Scalars['String']['input'];
  metadata: Scalars['JSON']['input'];
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputDecideMotionDraft = {
  draftId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputDeclineScannedBrand = {
  brandKitId: Scalars['Int']['input'];
};

export type InputDelDubBrandTargetAudience = {
  /** ID of the brand kit to update. */
  brandKitId: Scalars['Int']['input'];
  /** ID of the target audience to update. */
  id: Scalars['Int']['input'];
};

export type InputDeleteAiAgentAutomationSchedule = {
  projectId?: InputMaybe<Scalars['Int']['input']>;
  scheduleId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputDeleteAppIntegration = {
  appIntegration: AppIntegrationType;
  teamId?: InputMaybe<Scalars['Int']['input']>;
  type: IntegrationAccountType;
  userId?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['String']['input'];
};

/** Input for deleting a brand kit. */
export type InputDeleteBrandKit = {
  /** Whether to copy the website to the default brand kit. */
  copyWebsite?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the brand kit to use as default after deletion (optional). */
  defaultBrandKitId?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the brand kit to delete. */
  id: Scalars['Int']['input'];
};

export type InputDeleteBrandKitButton = {
  brandKitId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};

/** Input for deleting a font from a brand kit. */
export type InputDeleteBrandKitFont = {
  /** ID of the font to delete. */
  fontId: Scalars['Int']['input'];
  /** ID of the brand kit containing the font. */
  id: Scalars['Int']['input'];
};

/** Input for deleting media from a brand kit. */
export type InputDeleteBrandKitMedia = {
  /** ID of the brand kit that owns the media. */
  brandKitId: Scalars['Int']['input'];
  /** ID of the media to delete. */
  id: Scalars['Int']['input'];
};

export type InputDeleteCloudIntegration = {
  email?: InputMaybe<Scalars['String']['input']>;
  integrationApp: Integrations;
  teamId?: InputMaybe<Scalars['Int']['input']>;
  type: IntegrationAccountType;
  /** Marks the integration as personal. It is always the signed-in user's own; the id sent is ignored. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputDeleteCloudinaryConfig = {
  teamId: Scalars['Int']['input'];
};

export type InputDeleteColorPalette = {
  brandKitId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};

export type InputDeleteComment = {
  authorEmail?: InputMaybe<Scalars['String']['input']>;
  authorName?: InputMaybe<Scalars['String']['input']>;
  commentId: Scalars['Int']['input'];
};

export type InputDeleteCommentsOnTemplateChange = {
  designId: Scalars['Int']['input'];
};

export type InputDeleteContentLibraryElement = {
  id: Scalars['Int']['input'];
};

export type InputDeleteContentLibrarySeparator = {
  id: Scalars['Int']['input'];
};

export type InputDeleteCopilotAiChat = {
  chatId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputDeleteCopilotAiChatMessage = {
  chatId: Scalars['Int']['input'];
  messageId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputDeleteCouponEligibilityCache = {
  coupon: Scalars['String']['input'];
  plan: Scalars['String']['input'];
  secret: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputDeleteCustomTransition = {
  id: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

/**
 * Input for deleting a design.
 * This moves the design to trash rather than permanently deleting it.
 */
export type InputDeleteDesign = {
  /** ID of the design to delete. */
  id: Scalars['Int']['input'];
  /** ID of the team that owns the design. */
  teamId: Scalars['Int']['input'];
};

export type InputDeleteDesignComments = {
  designId: Scalars['Int']['input'];
};

export type InputDeleteDesignComponent = {
  id: Scalars['Int']['input'];
};

export type InputDeleteDesignComponents = {
  brandKitId: Scalars['Int']['input'];
  ids: Array<Scalars['Int']['input']>;
};

/** Input for deleting a design-media-library folder. */
export type InputDeleteDesignMediaFolder = {
  /** ID of the design that owns the folder. */
  designId: Scalars['Int']['input'];
  /** ID of the folder to delete (with its subfolders and their library items). */
  folderId: Scalars['Int']['input'];
};

/**
 * Input for permanently deleting a design from trash.
 * This cannot be undone.
 */
export type InputDeleteDesignPermanently = {
  /** ID of the design to permanently delete. */
  id: Scalars['Int']['input'];
  /** ID of the team that owns the design. */
  teamId: Scalars['Int']['input'];
};

export type InputDeleteFeed = {
  id: Scalars['Int']['input'];
};

export type InputDeleteFeedColumn = {
  columnName: Scalars['String']['input'];
  feedId: Scalars['Int']['input'];
};

export type InputDeleteFeedRows = {
  id: Scalars['Int']['input'];
  rows: Array<Scalars['String']['input']>;
};

export type InputDeleteFolder = {
  folderId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputDeleteFolderPermanently = {
  folderId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

/** Input for deleting a media asset. */
export type InputDeleteMedia = {
  /** ID of the brand kit that owns the media (optional). */
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the media to delete. */
  id: Scalars['Int']['input'];
  /** ID of the project that owns the media (optional). */
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the team that owns the media (optional). */
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputDeleteMediaFolder = {
  mediaFolderId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

/** @deprecated Migration service has been removed */
export type InputDeleteMigration = {
  id: Scalars['Int']['input'];
};

export type InputDeleteMoodBoard = {
  id: Scalars['Int']['input'];
};

export type InputDeleteNextgenAiTemplates = {
  setHash: Scalars['String']['input'];
};

export type InputDeleteProductSet = {
  hash: Scalars['String']['input'];
  id: Scalars['Int']['input'];
};

export type InputDeleteProductUpdate = {
  id: Scalars['Int']['input'];
};

/** Input for deleting a project. */
export type InputDeleteProject = {
  /** ID of the project to delete. */
  id: Scalars['Int']['input'];
  /** ID of the team that owns the project. */
  teamId: Scalars['Int']['input'];
};

/** Input for permanently deleting a project from trash. */
export type InputDeleteProjectPermanently = {
  /** ID of the project to delete. */
  id: Scalars['Int']['input'];
  /** ID of the team that owns the project. */
  teamId: Scalars['Int']['input'];
};

export type InputDeleteRedisStream = {
  dbValue: Scalars['Int']['input'];
  streamName: Scalars['String']['input'];
};

export type InputDeleteReport = {
  id: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputDeleteReportPermanently = {
  id: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputDeleteReportSchedule = {
  id: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputDeleteRole = {
  roleId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputDeleteSlideComments = {
  designId: Scalars['Int']['input'];
  slideId: Scalars['Int']['input'];
};

export type InputDeleteStoredFontBackup = {
  /** Removes the backup only when true. Reports what it would do otherwise. */
  apply?: InputMaybe<Scalars['Boolean']['input']>;
  hash: Scalars['String']['input'];
};

export type InputDeleteSubcategory = {
  id: Scalars['Int']['input'];
};

/** Input for deleting a team. */
export type InputDeleteTeam = {
  /** ID of the team to delete. */
  teamId: Scalars['Int']['input'];
};

/** Input for deleting a webhook. */
export type InputDeleteTeamWebhook = {
  /** ID of the team that owns the webhook. */
  teamId: Scalars['Int']['input'];
  /** ID of the webhook to delete. */
  webhookId: Scalars['Int']['input'];
};

/** Input for deleting template categories. */
export type InputDeleteTemplateCategories = {
  /** IDs of categories to delete. */
  categoryIds: Array<Scalars['Int']['input']>;
};

/** Input for deleting template tags. */
export type InputDeleteTemplateTags = {
  /** IDs of tags to delete. */
  tagIds: Array<Scalars['Int']['input']>;
};

/** Input for deleting templates. */
export type InputDeleteTemplates = {
  /** IDs of templates to delete. */
  templateIds: Array<Scalars['Int']['input']>;
};

export type InputDeleteTutorial = {
  id: Scalars['Int']['input'];
  tutorialCategoryId: Scalars['Int']['input'];
};

export type InputDeleteTutorialCategory = {
  id: Scalars['Int']['input'];
};

export type InputDeleteUsageRestriction = {
  id: Scalars['Int']['input'];
};

export type InputDeleteWorkflow = {
  hash: Scalars['String']['input'];
};

/**
 * Input for retrieving a design by hash.
 * This is the primary way to fetch a specific design.
 */
export type InputDesign = {
  /** Hash of the design to retrieve. */
  hash: Scalars['String']['input'];
  /** ID of the team that owns the design. */
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputDesignAdTag = {
  abTestId?: InputMaybe<Scalars['Int']['input']>;
  designId: Scalars['Int']['input'];
  force?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputDesignAdTagByHash = {
  designHash: Scalars['String']['input'];
};

export type InputDesignAnimatorElement = {
  height: Scalars['Float']['input'];
  layerName?: InputMaybe<Scalars['String']['input']>;
  layerType: Scalars['String']['input'];
  textContent?: InputMaybe<Scalars['String']['input']>;
  width: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type InputDesignAnimatorSuggestions = {
  bannerHeight: Scalars['Float']['input'];
  bannerWidth: Scalars['Float']['input'];
  designElements: Array<InputDesignAnimatorElement>;
  /** Preset names already shown; backend avoids repeating these names or near-duplicate styles. */
  existingSuggestionNames?: InputMaybe<Array<Scalars['String']['input']>>;
  teamId: Scalars['Int']['input'];
};

/** Input for querying approval history. */
export type InputDesignApprovalHistory = {
  /** The design hash. */
  designHash: Scalars['String']['input'];
};

export type InputDesignChange = {
  /** A hex colour, #rrggbb. */
  color?: InputMaybe<Scalars['String']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  /** ADD_TEXT: the text's size in pixels on the main size, 4 to 1000. */
  fontSize?: InputMaybe<Scalars['Float']['input']>;
  fontWeight?: InputMaybe<Scalars['Int']['input']>;
  /** RESIZE: the exact height in pixels; only when the call changes one size. */
  height?: InputMaybe<Scalars['Float']['input']>;
  /** The Media hash of a library image of the design's team, or of an image the design shows or showed (IMAGE, ADD_IMAGE). */
  imageId?: InputMaybe<Scalars['String']['input']>;
  italic?: InputMaybe<Scalars['Boolean']['input']>;
  kind: DesignChangeKind;
  /** The layer's ref from designContent; omitted only for the whole design's BACKGROUND_COLOR, ADD_TEXT, ADD_IMAGE and ADD_VIDEO. */
  layerRef?: InputMaybe<Scalars['String']['input']>;
  /** The margin from the canvas edges, in percent of its shorter side: 0 to 40, default 5. */
  marginPercent?: InputMaybe<Scalars['Float']['input']>;
  /** ORDER: where the layer goes in its stack. */
  order?: InputMaybe<LayerOrder>;
  /** MOVE, ADD_TEXT, ADD_IMAGE, ADD_VIDEO: where the layer goes, on each size's own canvas. */
  position?: InputMaybe<LayoutPosition>;
  /** ORDER with ABOVE or BEHIND: the ref of the layer it goes in front of or behind. */
  relativeToRef?: InputMaybe<Scalars['String']['input']>;
  /** RESIZE: the new size in percent of the current one, 10 to 1000 (120 is 20% bigger). */
  scalePercent?: InputMaybe<Scalars['Float']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  /** The Media hash of a processed library video of the design's team (VIDEO, ADD_VIDEO). */
  videoId?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  /** RESIZE: the exact width in pixels; only when the call changes one size. */
  width?: InputMaybe<Scalars['Float']['input']>;
  /** ADD_TEXT, ADD_IMAGE, ADD_VIDEO: the new layer's width in percent of the canvas width, 5 to 100. */
  widthPercent?: InputMaybe<Scalars['Float']['input']>;
  /** MOVE: the exact left edge in pixels; only when the call changes one size. */
  x?: InputMaybe<Scalars['Float']['input']>;
  /** MOVE: the exact top edge in pixels; only when the call changes one size. */
  y?: InputMaybe<Scalars['Float']['input']>;
};

export type InputDesignCheck = {
  /** The design or design set open in Ad Studio. */
  hash: Scalars['String']['input'];
  /** Check again instead of answering from the cache. */
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  /** A size of that set (its Design id). Omitted: the main size. */
  sizeId?: InputMaybe<Scalars['Int']['input']>;
  /** A slide (its bannersetElementId). Omitted: the first slide. */
  slideId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputDesignClickHeatmap = {
  designHash: Scalars['String']['input'];
  /** Window bounds, taken from the Analytics page's own date picker so the tiles match the chart. */
  from: Scalars['Date']['input'];
  gridSize?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Restrict the aggregation to these ad networks, mirroring the multi-select
   * Analytics network filter. Omitted or empty means every network.
   */
  networkIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  to: Scalars['Date']['input'];
};

export type InputDesignComponent = {
  hash: Scalars['String']['input'];
};

export type InputDesignComponents = {
  after?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderBy?: OrderBy;
  orderType?: OrderType;
};

export type InputDesignContent = {
  /** The design's hash: a set, a standalone design, or one of a set's sizes (resolved to its set). */
  hash: Scalars['String']['input'];
  /** A size to describe instead of the main one. */
  sizeHash?: InputMaybe<Scalars['String']['input']>;
};

export type InputDesignDimensions = {
  /** Height of the design in pixels. */
  height: Scalars['Int']['input'];
  /** Width of the design in pixels. */
  width: Scalars['Int']['input'];
};

export type InputDesignFeedAdjustment = {
  designId: Scalars['Int']['input'];
  rowIndex: Scalars['Int']['input'];
};

export type InputDesignFeedAdjustments = {
  designId: Scalars['Int']['input'];
};

/** Input for retrieving HTML export settings for a design. */
export type InputDesignHtmlSettings = {
  /** Hash of the design to get HTML settings for. */
  designHash: Scalars['String']['input'];
};

/**
 * Input for providing a design JSON for a design set.
 * Used when creating design sets with specific designs.
 */
export type InputDesignJsonForSet = {
  /** ID of the design size type for this design. */
  designSizeTypeId: Scalars['Int']['input'];
  /** JSON representation of the design content. */
  json: Scalars['JsonDesign']['input'];
};

/** Per-pattern override on top of the detector's own `defaultEnabled`. */
export type InputDesignLintPattern = {
  enabled: Scalars['Boolean']['input'];
  pattern: DesignLintPattern;
};

/** Input for one screen of the import-from-designs workspace browser. */
export type InputDesignMediaImportBrowse = {
  /** ID of a design to exclude everywhere, e.g. the current design (optional). */
  excludeDesignId?: InputMaybe<Scalars['Int']['input']>;
  /** Folder to list; the project root when omitted. */
  folderId?: InputMaybe<Scalars['Int']['input']>;
  /** Project to browse; the caller's personal project when omitted. */
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** Project-wide flat search over folder and design names; folderId is ignored while searching (optional). */
  search?: InputMaybe<Scalars['String']['input']>;
  /** ID of the team being browsed. */
  teamId: Scalars['Int']['input'];
};

/** Input for retrieving a design's media library. */
export type InputDesignMediaLibrary = {
  /**
   * Folder filter (tri-state). Omitted: no folder filter (all items).
   * Null: items at the library root. A folder id: items inside that folder.
   */
  folderId?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum number of items to return (optional). */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Number of items to skip for pagination (optional). */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Search text to filter by (optional). */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Source to filter by (optional). Omitted: every source, including assets whose provenance is unknown. */
  source?: InputMaybe<DesignMediaSource>;
  /** Type of media to filter by (optional). */
  type?: InputMaybe<MediaType>;
};

/** @deprecated use InputDesignPresetV2 instead */
export type InputDesignPreset = {
  designId: Scalars['Int']['input'];
  limitFilename: Scalars['Boolean']['input'];
  preset: Scalars['String']['input'];
};

export type InputDesignPresetV2 = {
  delimiter: Scalars['String']['input'];
  designId: Scalars['Int']['input'];
  limitFilename: Scalars['Boolean']['input'];
  preset: Scalars['String']['input'];
  saveUserPreset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputDesignPublishRuns = {
  channel?: InputMaybe<Scalars['String']['input']>;
  designHash: Scalars['String']['input'];
  /** 0-based page index; defaults to 0. */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Clamped to [1, 50]; defaults to 20. */
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** 'newest' (default) | 'oldest'. Plain string, same house rule as channel — an unknown value reads as newest-first. */
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type InputDesignScorerRender = {
  /** Base64 of the render the scorer read; at most 8 MB of base64 (6 MB decoded), or the snapshot is kept without it. */
  base64: Scalars['String']['input'];
  /** image/png or image/jpeg. */
  contentType: Scalars['String']['input'];
};

/** Input for retrieving design set details. */
export type InputDesignSetDetails = {
  /** Hash of the design set to retrieve details for. */
  hash: Scalars['String']['input'];
};

/**
 * Input for specifying a size in a design set.
 * Used when creating design sets with multiple sizes.
 */
export type InputDesignSetSize = {
  /** Height of the design in the specified measurement unit. */
  height: Scalars['Int']['input'];
  /** Measurement unit for the dimensions (defaults to px). */
  measureUnit?: InputMaybe<MeasureUnit>;
  /** Name for this size variation. */
  name: Scalars['String']['input'];
  /** Size variation identifier for predefined sizes. */
  sizeVariation?: InputMaybe<Scalars['String']['input']>;
  /** Width of the design in the specified measurement unit. */
  width: Scalars['Int']['input'];
};

/**
 * Input for retrieving design set templates.
 * Allows filtering and pagination of design sets.
 */
export type InputDesignSetTemplates = {
  /** Category of design size type to filter by. */
  category?: InputMaybe<DesignSizeTypeCategory>;
  /** Maximum number of templates to return. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Number of templates to skip (for pagination). */
  start?: InputMaybe<Scalars['Int']['input']>;
  /** Type of templates to filter by. */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Input for retrieving design size type information. */
export type InputDesignSizeType = {
  /** ID of the design size type to retrieve. */
  designSizeTypeId: Scalars['Int']['input'];
};

export type InputDesignSizeTypeInPx = {
  id: Scalars['Int']['input'];
};

export type InputDesignSizeTypeTypes = {
  animated: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
  static: Scalars['Boolean']['input'];
  video: Scalars['Boolean']['input'];
};

export type InputDesignSizeTypes = {
  /** @deprecated Field no longer supported */
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Field no longer supported */
  skipPagination?: InputMaybe<Scalars['Boolean']['input']>;
  teamId: Scalars['Int']['input'];
};

/** Input for design stick settings. */
export type InputDesignStickSettings = {
  /** Time in seconds before the design appears. */
  appearenceTime?: InputMaybe<Scalars['Float']['input']>;
  /** Background color for the sticky design. */
  background?: InputMaybe<Scalars['String']['input']>;
  /** How the design is displayed. @BreakingBad */
  displayOption?: InputMaybe<DisplayMode>;
  /** The type of sticking behavior. @BreakingBad */
  type?: InputMaybe<DesignPosition>;
};

/**
 * Input for requesting design templates.
 * Used to filter and limit design templates returned.
 */
export type InputDesignTemplates = {
  /** Dimensions of the design to filter by (e.g., '1200x628'). */
  designSize?: InputMaybe<Scalars['String']['input']>;
  /** ID of the design size type to filter by. */
  designSizeTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum number of templates to return. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Type of template to select (e.g., static, animated, video). */
  selectType?: InputMaybe<Scalars['String']['input']>;
};

/** Input for counting templates by design size type. */
export type InputDesignTemplatesCount = {
  /** ID of the design size type to count templates for. */
  designSizeTypeId: Scalars['Int']['input'];
};

/** Input for retrieving a specific design version. */
export type InputDesignVersion = {
  /** Hash of the design. */
  hash: Scalars['String']['input'];
  /** ID of the version to retrieve. */
  versionId: Scalars['String']['input'];
};

/** Input for retrieving a design's version history. */
export type InputDesignVersionHistory = {
  /** Hash of the design to get history for. */
  hash: Scalars['String']['input'];
};

/**
 * Input for retrieving designs with various filtering options.
 *
 * How to use this:
 * - If you have cursor you can specify only `after` param, no need to specify anything else,
 * other params will be ignored
 * - If you have folderId you can specify only `folderId` param
 * - To get templates from a brandKit specify `brandKitId`
 * - To get designs from project specify `projectId`
 * - To get private user designs from a team specify `userId` and `teamId`
 * - To get all the designs that an user have access in a team specify only `teamId`
 * - To filter designs by name specify `name`, this should work with all params
 * - name, orderBy and orderType are optional and you can specify them to any query,
 * those will be ignored if you specify `after` param
 */
export type InputDesigns = {
  /** Design cursor to start from */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Get all designs from project */
  allProjectDesigns?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get templates from brandkit */
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  /** Page size. Defaults to 50 and is capped at 100. Encoded into `after` so later pages keep the same size. */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Get designs from specific folder */
  folderId?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by design height */
  height?: InputMaybe<Scalars['Float']['input']>;
  /** Filter to only include API-generated designs */
  isApiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter to only include templates */
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by measurement unit */
  measureUnit?: InputMaybe<MeasureUnit>;
  /** Search for design name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Field to order designs by (defaults to DATE_MODIFIED) */
  orderBy?: OrderBy;
  /** Order direction (defaults to DESC) */
  orderType?: OrderType;
  /** Get designs from this project only */
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** Get all designs the user has access in team */
  teamId?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by design type (design, set, component) */
  type?: InputMaybe<DesignType>;
  /** Filter by design width */
  width?: InputMaybe<Scalars['Float']['input']>;
};

/** Input for `designsAdTagAnalytics`. */
export type InputDesignsAdTagAnalytics = {
  /** Hashes of the designs to fetch ad-tag analytics for. Max 100 per call. */
  designHashes: Array<Scalars['String']['input']>;
};

/** Input for retrieving duration information for designs. */
export type InputDesignsDuration = {
  /** Array of design hashes to get durations for. */
  hashes: Array<Scalars['String']['input']>;
};

export type InputDesignsFeedPropertyBinding = {
  designs: Array<InputDesignsFeedPropertyBindingDesign>;
  feedProperty: Scalars['String']['input'];
};

export type InputDesignsFeedPropertyBindingDesign = {
  designId: Scalars['Int']['input'];
};

export type InputDesignsFeedUrlBinding = {
  designs: Array<InputDesignsFeedUrlBindingDesign>;
};

export type InputDesignsFeedUrlBindingDesign = {
  designId: Scalars['Int']['input'];
};

export type InputDetachFeed = {
  designId: Scalars['Int']['input'];
};

/** Input for disabling ad serving for a design. */
export type InputDisableAdServing = {
  /** The ID of the design. */
  designId: Scalars['Int']['input'];
  /** Disable every member of this design's variation family, not just the design itself. */
  includeVariations?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputDiscardAiResizeSession = {
  sessionId: Scalars['String']['input'];
};

export type InputDiscountSubscription = {
  teamId: Scalars['Int']['input'];
};

export type InputDismissMotionDraft = {
  draftId: Scalars['Int']['input'];
  /** Optional one-tap reason (kept to 64 characters). */
  reason?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

/** Input for toggling the brand kit wizard display for a team. */
export type InputDisplayBrandKitWizard = {
  /** Whether to display the brand kit wizard. */
  brandkitWizard: Scalars['Boolean']['input'];
  /** ID of the team to update the setting for. */
  teamId: Scalars['Int']['input'];
};

/** @deprecated Brand template migration service has been removed. @BreakingBad */
export type InputDoMigrateBrandTemplates = {
  id: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputDownload = {
  downloadId: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputDownloadAiAgentAutomatedReport = {
  reportId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputDownloadAiAgentReport = {
  chatId: Scalars['Int']['input'];
  htmlId: Scalars['Int']['input'];
  messageId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

/** The editor session a download started in (docs/analytics-ids.md). Every field is optional; none changes the export. */
export type InputDownloadAnalyticsContext = {
  /** The client's editor_shell (new_ad_studio, ad_studio, light_editor, legacy_editor). */
  editorShell?: InputMaybe<Scalars['String']['input']>;
  /** ad_studio_opened.entry_source of the editor visit. */
  entrySource?: InputMaybe<Scalars['String']['input']>;
  /** The Home chat handoff's thread_id, when the visit came from it. */
  threadId?: InputMaybe<Scalars['String']['input']>;
};

export type InputDownloadAudio = {
  designHash: Scalars['String']['input'];
  id: Scalars['Int']['input'];
};

export type InputDownloadCreate = {
  /** Target AEM DAM folder path (from the Destination Selector). */
  aemDestinationPath?: InputMaybe<Scalars['String']['input']>;
  /** Write-scoped Adobe IMS bearer relayed from the browser MFE. */
  aemImsToken?: InputMaybe<Scalars['String']['input']>;
  /** AEM repository host the destination folder lives in. */
  aemRepositoryId?: InputMaybe<Scalars['String']['input']>;
  /** Analytics only: the editor session that started this download, copied onto export_finished. */
  analyticsContext?: InputMaybe<InputDownloadAnalyticsContext>;
  designs: Array<InputDownloadDesign>;
  downloadViaEmail?: InputMaybe<Scalars['String']['input']>;
  googleDriveFolderId?: InputMaybe<Scalars['String']['input']>;
  /** When true, publish the finished export to Adobe AEM at completion. */
  saveToAem?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, send each exported file to the team's default Cloudinary folder, with the signed-in user's own login. */
  saveToCloudinary?: InputMaybe<Scalars['Boolean']['input']>;
  saveToGoogleDrive?: InputMaybe<Scalars['Boolean']['input']>;
  saveToSharePoint?: InputMaybe<Scalars['Boolean']['input']>;
  shouldConsumeCredits?: InputMaybe<Scalars['Boolean']['input']>;
  shouldConsumeCreditsNewSystem?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type InputDownloadCreditsUsage = {
  teamId: Scalars['Int']['input'];
};

export type InputDownloadDesign = {
  colorProfile?: InputMaybe<PrintColorProfile>;
  convertCustomFonts?: InputMaybe<Scalars['Boolean']['input']>;
  /** PDF only: registration crop marks around each page, which grows by the margin they need. */
  cropMarks?: InputMaybe<Scalars['Boolean']['input']>;
  customSlides?: InputMaybe<Array<Scalars['Int']['input']>>;
  detailedSnapshots?: InputMaybe<Array<InputMaybe<Snapshot>>>;
  ditherAlgorithm?: InputMaybe<DitherAlgorithm>;
  fallbackImage?: InputMaybe<Scalars['Boolean']['input']>;
  fallbackImagePosition?: InputMaybe<Scalars['Int']['input']>;
  feedDownloadInterval?: InputMaybe<FeedDownloadInterval>;
  gifQuality?: InputMaybe<GifQuality>;
  hash: Scalars['String']['input'];
  /** Only with pdfStandard: the resolution of the images in the document. Defaults to dpi300. */
  imageResolution?: InputMaybe<PdfImageResolution>;
  isiOnly?: InputMaybe<Scalars['Boolean']['input']>;
  lossyCompression?: InputMaybe<LossyCompression>;
  maxColors?: InputMaybe<MaxColors>;
  minifyHtml?: InputMaybe<Scalars['Boolean']['input']>;
  mp4Quality?: InputMaybe<Mp4Quality>;
  networkIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Only with pdfStandard. Defaults to gracol2006_coated1. */
  outputProfile?: InputMaybe<PdfOutputProfile>;
  /** PDF only, and only with colorProfile cmyk. */
  pdfStandard?: InputMaybe<PdfStandard>;
  position?: InputMaybe<Scalars['String']['input']>;
  psdBundleMode?: InputMaybe<PsdBundleMode>;
  quality?: InputMaybe<Scalars['Int']['input']>;
  responsiveScaling?: InputMaybe<Scalars['Boolean']['input']>;
  retina?: InputMaybe<Scalars['Boolean']['input']>;
  retinaMultiplier?: InputMaybe<Scalars['Float']['input']>;
  retinaOnly?: InputMaybe<Scalars['Boolean']['input']>;
  siblingHashes?: InputMaybe<Array<Scalars['String']['input']>>;
  slides?: InputMaybe<Slides>;
  snapshots?: InputMaybe<Array<Scalars['Float']['input']>>;
  target?: InputMaybe<Scalars['String']['input']>;
  targetFPS?: InputMaybe<Scalars['Int']['input']>;
  type: DownloadType;
  url?: InputMaybe<Scalars['String']['input']>;
  useAsClickTag?: InputMaybe<Scalars['Boolean']['input']>;
  /** Veeva screengrab frame: render the ISI scrollbar so it survives PDF scale (CRE-624) */
  veevaScreengrab?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for retrieving download settings for shared links. */
export type InputDownloadEnabledShareLink = {
  /** ID of the team to get settings for. */
  teamId: Scalars['Int']['input'];
};

export type InputDownloadFeedInterval = {
  hash: Scalars['String']['input'];
};

export type InputDownloadIntegrationFiles = {
  id: Scalars['String']['input'];
  integrationType: Integrations;
  isTeamAccount: Scalars['Boolean']['input'];
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputDownloadInvoice = {
  invoiceId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputDownloadPreset = {
  designId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputDownloadReport = {
  reportId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputDownloadZipResult = {
  downloadId: Scalars['String']['input'];
  status: ExportStatus;
  statusMessage?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type InputDraftColumnsFromPrompt = {
  /** Free-text description of what the catalog should hold */
  prompt: Scalars['String']['input'];
};

export type InputDraftMultiSceneStoryboard = {
  /** Target aspect ratio (e.g. 16:9) — drafts generate their scene stills at this aspect. Defaults to 16:9. */
  aspectRatio?: InputMaybe<Scalars['String']['input']>;
  /** The overall video brief the storyboard is drafted from. */
  brief: Scalars['String']['input'];
  designHash?: InputMaybe<Scalars['String']['input']>;
  /** User reference images from the composer, at most 10. The draft resolves the scene-1 anchor from them: one -> used directly, several -> a composed anchor is generated from all of them. */
  referenceImages?: InputMaybe<Array<Scalars['String']['input']>>;
  teamId: Scalars['Int']['input'];
  /** Soft total-duration budget in seconds. The draft picks the scene count (1-10) and per-scene durations (3-10s) to fill it; the drafted cards remain freely editable, so the real total may drift. Defaults to 16; clamped to 8-100. */
  totalDurationSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** AI Studio On-brand: ground the draft's stills in the originating design's context (mirrors InputVideoGeneration). */
  useDesignContext?: InputMaybe<Scalars['Boolean']['input']>;
};

/** One scene the storyboard drafter wrote for a multi-scene video requested by length alone. */
export type InputDraftedMultiSceneScene = {
  prompt: Scalars['String']['input'];
  /** The scene's generated still, first (scene 1 = the anchor). */
  referenceImages?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input for duplicating an existing brand kit to a team. */
export type InputDuplicateBrandKit = {
  /** ID of the brand kit to duplicate. */
  brandKitId: Scalars['Int']['input'];
  /** ID of the team that will own the duplicate. */
  teamId: Scalars['Int']['input'];
};

export type InputDuplicateBrandTemplate = {
  brandKitId: Scalars['Int']['input'];
  designId: Scalars['Int']['input'];
  folderId?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputDuplicateBrandTemplateFolder = {
  brandKitId: Scalars['Int']['input'];
  folderId: Scalars['Int']['input'];
};

export type InputDuplicateColorPalette = {
  brandKitId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};

export type InputDuplicateCopilotAiChat = {
  chatId: Scalars['Int']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
};

/** Input for duplicating a design. */
export type InputDuplicateDesign = {
  /** Whether to add the design to the designs list (for templates). */
  addToDesigns?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, a copy of a single design may be created as a design set holding one size. Server-gated: ignored unless the gate is on for the destination team, and never applied to a copy of a set, a template or an internal copy. */
  asSetIfSingle?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the design to duplicate. */
  designId: Scalars['Int']['input'];
  /** How the user started the copy. Defaults to duplicate; a brand template picked from the library sends template. */
  designOrigin?: InputMaybe<DesignOrigin>;
  /** ID of the folder to duplicate to (optional). */
  folderId?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the project to duplicate to (optional). */
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the team to duplicate to (optional). */
  teamId?: InputMaybe<Scalars['Int']['input']>;
  /** When true and folderId is not set, automatically place the design in an 'AI generated designs' folder. */
  useAiFolder?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputDuplicateDesigns = {
  designIds: Array<Scalars['Int']['input']>;
  projectId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputDuplicateFolder = {
  addToDesigns?: InputMaybe<Scalars['Boolean']['input']>;
  folderId: Scalars['Int']['input'];
};

/** Input for duplicating a moodboard */
export type InputDuplicateMoodBoard = {
  id: Scalars['Int']['input'];
  moodboardName?: InputMaybe<Scalars['String']['input']>;
  /** Project ID for the duplicated moodboard @BreakingBad */
  projectId: Scalars['Int']['input'];
};

export type InputDuplicateReport = {
  reportId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputDuplicateSubFolder = {
  addToDesigns?: InputMaybe<Scalars['Boolean']['input']>;
  addToTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  folderId: Scalars['Int']['input'];
  parentId?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  traceContext?: InputMaybe<TraceContext>;
  userId: Scalars['Int']['input'];
};

export type InputDv360PublishUpdate = {
  count: Scalars['Int']['input'];
  creditTransactionId?: InputMaybe<Scalars['Int']['input']>;
  designHash: Scalars['String']['input'];
  exportType?: InputMaybe<DownloadType>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  success: Scalars['Boolean']['input'];
  userId: Scalars['Int']['input'];
};

export type InputEditColorInPalette = {
  brandKitId: Scalars['Int']['input'];
  currentColor: InputColor;
  id: Scalars['Int']['input'];
  newColor: InputColor;
};

export type InputEditContentLibraryElement = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  premium?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Scalars['String']['input']>;
};

export type InputEditDesign = {
  changes: Array<InputDesignChange>;
  hash: Scalars['String']['input'];
  /**
   * The user agreed to change what the design's brand template locks: a locked change is refused TEMPLATE_LOCKED with
   * agreeable true until it is sent. It has no effect for a Content editor, whom the locks always bind (agreeable false).
   */
  lockedChangesAgreed?: InputMaybe<Scalars['Boolean']['input']>;
  /** The sizes the changes apply to (hashes from designContent). Without it, content changes land on every size, and a layout change on a design with several sizes is refused SIZES_NOT_NAMED. */
  sizeHashes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InputEditImage = {
  /** @BreakingBad Was not used */
  background?: InputMaybe<Scalars['String']['input']>;
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  createMedia?: InputMaybe<Scalars['Boolean']['input']>;
  images: Array<Scalars['String']['input']>;
  /** URL of a black/white mask PNG (white = area to edit). When set, the edit is applied only inside the masked region (inpainting). */
  mask?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  prompt: Scalars['String']['input'];
  /** @BreakingBad Was not used */
  quality?: InputMaybe<Scalars['Int']['input']>;
  /** @BreakingBad Was not used */
  size?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  teamId: Scalars['Int']['input'];
  variants?: InputMaybe<Scalars['Int']['input']>;
};

export type InputEditProductUpdate = {
  audience?: InputMaybe<InputProductUpdateAudience>;
  description: Scalars['String']['input'];
  fileHash?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileType?: InputMaybe<MediaType>;
  id: Scalars['Int']['input'];
  /** @deprecated This field is no longer used */
  onlyAdStudioUsers?: InputMaybe<Scalars['Boolean']['input']>;
  standalone?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  version: ProductUpdateVersion;
};

export type InputEditTeamUsageMonth = {
  amount: Scalars['Int']['input'];
  /** YYYY-MM, within the last editableMonths months. */
  month: Scalars['String']['input'];
  note: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputEditTutorial = {
  id: Scalars['Int']['input'];
  title: Scalars['String']['input'];
  tutorialCategoryId: Scalars['Int']['input'];
  url: Scalars['String']['input'];
};

export type InputEditTutorialCategory = {
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type InputEmailPreferences = {
  abTestStatus?: InputMaybe<Scalars['Boolean']['input']>;
  blog?: InputMaybe<Scalars['Boolean']['input']>;
  commentMention?: InputMaybe<Scalars['Boolean']['input']>;
  commentResolved?: InputMaybe<Scalars['Boolean']['input']>;
  feedStatus?: InputMaybe<Scalars['Boolean']['input']>;
  insights?: InputMaybe<Scalars['Boolean']['input']>;
  newComments?: InputMaybe<Scalars['Boolean']['input']>;
  newReply?: InputMaybe<Scalars['Boolean']['input']>;
  newsletter?: InputMaybe<Scalars['Boolean']['input']>;
  productUpdates?: InputMaybe<Scalars['Boolean']['input']>;
  promotionsAndOffers?: InputMaybe<Scalars['Boolean']['input']>;
  replySameComment?: InputMaybe<Scalars['Boolean']['input']>;
  surveyAndBeta?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputEmailSend = {
  attachments?: InputMaybe<Array<InputMaybe<InputAttachment>>>;
  bufferAttachments?: InputMaybe<Array<InputBufferAttachment>>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  injectHtmlOn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sender?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['String']['input']>;
  template: Scalars['String']['input'];
};

export type InputEmailTemplate = {
  identifier: Scalars['String']['input'];
};

/** Input for enabling ad serving for a design. */
export type InputEnableAdServing = {
  /**
   * Ad tag properties. @deprecated Not needed anymore. @BreakingBad
   * @deprecated Not needed anymore
   */
  adTagProps?: InputMaybe<InputDesignStickSettings>;
  /** The ID of the design. */
  designId: Scalars['Int']['input'];
  /**
   * Dynamic variables. @deprecated Not needed anymore. @BreakingBad
   * @deprecated Not needed anymore
   */
  dynamicVars?: InputMaybe<Array<InputUpsertDynamicVar>>;
  /**
   * External tracking URLs. @deprecated Not needed anymore. @BreakingBad
   * @deprecated Not needed anymore
   */
  externalTrackingUrls?: InputMaybe<Array<InputUpsertExternalTrackingUrl>>;
  /**
   * Enable this design's whole variation family. Members are derived server-side
   * from the master's id, so the DESIGN access check on designId still binds.
   * Absent or false reproduces the pre-family behaviour exactly.
   */
  includeVariations?: InputMaybe<Scalars['Boolean']['input']>;
  /** A list of network IDs to enable ad serving for. */
  networks: Array<Scalars['Int']['input']>;
  /**
   * Enable responsive scaling. @deprecated Not needed anymore. @BreakingBad
   * @deprecated Not needed anymore
   */
  responsiveScaling?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * URL target. @deprecated Not needed anymore. @BreakingBad
   * @deprecated Not needed anymore
   */
  target?: InputMaybe<Scalars['String']['input']>;
  /**
   * Primary URL. @deprecated Not needed anymore. @BreakingBad
   * @deprecated Not needed anymore
   */
  url?: InputMaybe<Scalars['String']['input']>;
  /**
   * URL suffix. @deprecated Not needed anymore. @BreakingBad
   * @deprecated Not needed anymore
   */
  urlSuffix?: InputMaybe<Scalars['String']['input']>;
  /**
   * Use as click tag. @deprecated Not needed anymore. @BreakingBad
   * @deprecated Not needed anymore
   */
  useAsClickTag?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputEnableAdvancedCss = {
  hasAdvancedCssAccess: Scalars['Boolean']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputEnableCreatopy20 = {
  teamId: Scalars['Int']['input'];
};

/** Input for switching a workspace to the new Ad Studio BETA. */
export type InputEnableProjectNewAdStudioBeta = {
  /** The workspace (project) to switch. */
  projectId: Scalars['Int']['input'];
};

export type InputEnableRealTimeDataFeedSourceTypes = {
  feedSourceTypes: Array<InputMaybe<FeedSourceType>>;
  teamId: Scalars['Int']['input'];
};

export type InputEndSession = {
  accessToken: Scalars['String']['input'];
  designHash?: InputMaybe<Scalars['String']['input']>;
  refreshToken: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputEnforceAdServingEntitlement = {
  teamId: Scalars['Int']['input'];
  /** What asked for the check, for the audit trail: the Recurly event name, or "sweep". */
  trigger: Scalars['String']['input'];
};

export type InputEnrollTeamToPaymentVariant = {
  campaignCreditsBonus?: InputMaybe<Scalars['Int']['input']>;
  campaignName?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated We don't use this anymore */
  isSocialLogin?: InputMaybe<Scalars['Boolean']['input']>;
  planCode: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
  /** @deprecated Experiment is not used anymore */
  trialClarityExp?: InputMaybe<Scalars['String']['input']>;
  variant: Variant;
};

/**
 * One usage milestone reached by an Enterprise team, as computed by the credits
 * service after a transaction: threshold is 85 or 100 (percent of includedCredits).
 * The cycle dates are the window the numbers were measured over; they are shown
 * in the email and key its idempotency.
 */
export type InputEnterpriseCreditsUsageEmail = {
  cycleEndsAt?: InputMaybe<Scalars['Date']['input']>;
  cycleStartedAt?: InputMaybe<Scalars['Date']['input']>;
  includedCredits: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
  threshold: Scalars['Int']['input'];
  usedCredits: Scalars['Int']['input'];
};

export type InputEstimateHtmlSize = {
  convertCustomFonts?: InputMaybe<Scalars['Boolean']['input']>;
  fallbackImage?: InputMaybe<Scalars['Boolean']['input']>;
  hash: Scalars['String']['input'];
  minifyHtml?: InputMaybe<Scalars['Boolean']['input']>;
  quality?: InputMaybe<Scalars['Int']['input']>;
  retina?: InputMaybe<Scalars['Boolean']['input']>;
  retinaOnly?: InputMaybe<Scalars['Boolean']['input']>;
  unarchivedEstimation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputExpandImage = {
  app?: InputMaybe<Scalars['String']['input']>;
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  canvasSize: Array<Scalars['Int']['input']>;
  createMedia?: InputMaybe<Scalars['Boolean']['input']>;
  image: Scalars['String']['input'];
  negativePrompt?: InputMaybe<Scalars['String']['input']>;
  originalImageLocation: Array<Scalars['Int']['input']>;
  originalImageSize: Array<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  seed?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Field no longer supported */
  sid?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputExpansion = {
  isExperiment?: InputMaybe<Scalars['Boolean']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputExportDesignThumbnail = {
  hash: Scalars['String']['input'];
  skipCache?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input type for exporting feed to CSV */
export type InputExportFeedToCsv = {
  feedId: Scalars['Int']['input'];
};

export type InputExportImageForLastSavedDesigns = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  timeOffsetEnd?: InputMaybe<Scalars['Int']['input']>;
  timeOffsetStart?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Input for updating export status of media.
 * Used by export systems to track media status.
 */
export type InputExportMedia = {
  /** Duration in seconds (for video/audio). */
  duration?: InputMaybe<Scalars['Float']['input']>;
  /** File format of the media. */
  format?: InputMaybe<Scalars['String']['input']>;
  /** Hash of the media to update. */
  hash: Scalars['String']['input'];
  /** Height of the media in pixels. */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** Optional moodboard context for syncing card hash after video processing */
  moodBoardMeta?: InputMaybe<InputExportMediaMoodBoardMeta>;
  /** File size in bytes. */
  size?: InputMaybe<Scalars['Int']['input']>;
  /** Processing status of the media. */
  status?: MediaStatus;
  /** Type of media being exported. */
  type: Scalars['String']['input'];
  /** Width of the media in pixels. */
  width?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Moodboard context passed alongside an export media update
 * so the card hash can be synced to the Yjs document in one call.
 */
export type InputExportMediaMoodBoardMeta = {
  /** The card ID to update */
  cardId: Scalars['String']['input'];
  /** The moodboard hash */
  moodBoardHash: Scalars['String']['input'];
};

export type InputExportResult = {
  analyticsData?: InputMaybe<AnalyticsData>;
  colorProfile?: InputMaybe<PrintColorProfile>;
  /** The design checksum the render was queued for. A finished thumbnail render that sends it marks the design's image generated only while the design still has that checksum. */
  designChecksum?: InputMaybe<Scalars['String']['input']>;
  designHash?: InputMaybe<Scalars['String']['input']>;
  downloadId?: InputMaybe<Scalars['String']['input']>;
  exportId?: InputMaybe<Scalars['String']['input']>;
  exportType?: InputMaybe<ExportType>;
  feedRow?: InputMaybe<Scalars['StringOrInt']['input']>;
  jobType?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  oneSlide?: InputMaybe<Scalars['Boolean']['input']>;
  snapshotsCount?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ExportStatus>;
  statusMessage?: InputMaybe<Scalars['String']['input']>;
  zipSize?: InputMaybe<Scalars['Int']['input']>;
};

export type InputExportSetThumbnail = {
  designSetHash: Scalars['String']['input'];
  skipCache?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [Deprecated] Input for extracting brand kit assets from a website URL. */
export type InputExtractBrandKitAssets = {
  /** URL of the website to extract brand assets from. */
  url: Scalars['String']['input'];
};

export type InputExtractResizeInfo = {
  hash: Scalars['String']['input'];
  isHtml?: InputMaybe<Scalars['Boolean']['input']>;
  slideId: Scalars['Int']['input'];
};

export type InputFacebookPublishUpdateStatus = {
  count: Scalars['Int']['input'];
  creditTransactionId?: InputMaybe<Scalars['Int']['input']>;
  designHash: Scalars['String']['input'];
  error?: InputMaybe<PublishErrorInput>;
  /** @BreakingBad is mandatory */
  jobData: Scalars['JSON']['input'];
  jobId?: InputMaybe<Scalars['String']['input']>;
  success: Scalars['Boolean']['input'];
  userId: Scalars['Int']['input'];
};

export type InputFailMotionDraft = {
  code: Scalars['String']['input'];
  draftId: Scalars['Int']['input'];
  qcResult?: InputMaybe<Scalars['JSON']['input']>;
};

/** A variation top row's master sync state to restore — the shape the status query returns it in. */
export type InputFamilyMasterSyncState = {
  perSize: Array<InputSizeChecksum>;
  /** ISO timestamp, as the status query returned it. */
  syncedAt: Scalars['String']['input'];
};

/**
 * One size row's target state — a member of the Variations tab's client-side
 * family snapshot (docs/adstudio-variations-master-sync.md, "Variations tab
 * undo/redo — client family snapshots"). Only the fields present are written;
 * the client sends exactly the members an action changed.
 */
export type InputFamilySizeState = {
  /**
   * Whether the row is present in the target state: a soft-deleted row is
   * restored, a live one soft-removed. Absent = liveness untouched. Refused on
   * a standalone design's own row (it has no set to be removed from).
   */
  alive?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Row checksum naming the content to restore, resolved against the
   * persisted-version store the tab's writers keep (keepPreviousVersion).
   * Absent = keep the content. A version that is not in the store refuses the
   * whole restore (FAMILY_RESTORE_VERSION_UNAVAILABLE) — nothing is written.
   */
  checksum?: InputMaybe<Scalars['String']['input']>;
  /** A master-set size row's customisation record, restored verbatim (SyncOverrides shape). Absent = untouched, null = clear. */
  crossSizeOverrides?: InputMaybe<Scalars['JSON']['input']>;
  /** Hash of the size row: a master-set child, or a size of one of the master's variations. */
  hash: Scalars['String']['input'];
  /** A variation size row's recorded divergence, restored verbatim (SyncOverrides shape). Absent = untouched, null = clear. */
  syncOverrides?: InputMaybe<Scalars['JSON']['input']>;
};

/** One variation top row's target state (see InputFamilySizeState). */
export type InputFamilyVariationState = {
  /** Whether the variation is present in the target state: restored — the top row plus the sizes this input restores under it, in one call — or soft-removed with its children. Absent = untouched. */
  alive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Hash of the variation top row (a design linked by masterSetId). */
  hash: Scalars['String']['input'];
  /** The master sync state to restore. Absent or null = untouched (a null state is never written). */
  masterSyncState?: InputMaybe<InputFamilyMasterSyncState>;
};

/** Input for retrieving favorite elements. */
export type InputFavoriteElements = {
  /** Hash of the design to check favorites for. */
  designHash: Scalars['String']['input'];
  /** ID of the team to retrieve favorites from. */
  teamId: Scalars['Int']['input'];
};

/** Input for retrieving favorite projects. */
export type InputFavoriteProjects = {
  /** ID of the team whose favorite projects to retrieve. */
  teamId: Scalars['Int']['input'];
};

/** Input for marking a team as favorite. */
export type InputFavouriteTeam = {
  /** Whether to mark as favorite (true) or remove favorite (false). */
  favourite: Scalars['Boolean']['input'];
  /** ID of the team to mark as favorite. */
  teamId: Scalars['Int']['input'];
};

export type InputFeatureAccess = {
  /** Specify the requested feature name to perform the operation */
  feature: FeatureName;
  /** Specify the resource for resolving the team */
  resource: FeatureAccessResource;
};

export type InputFeatureAccessForAllPlans = {
  name: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputFeatureConfig = {
  state: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type InputFeatureExposition = {
  name: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputFeaturePlanMap = {
  config: InputFeatureConfig;
  planGroup: Scalars['String']['input'];
};

export type InputFeatureProperties = {
  actionLabel: Scalars['String']['input'];
  buttonType: Scalars['String']['input'];
  /** Feature description – translation key */
  description: Array<Scalars['String']['input']>;
  illustration: Scalars['String']['input'];
  /** Gradient key */
  logo: Scalars['String']['input'];
  /** Feature title – translation key */
  title: Scalars['String']['input'];
  /** Gradient or Color key */
  titleHighlight: Scalars['String']['input'];
};

export type InputFeaturesAccess = {
  teamId: Scalars['Int']['input'];
};

export type InputFeaturesComparison = {
  teamId: Scalars['Int']['input'];
};

export type InputFeed = {
  checksum?: InputMaybe<Scalars['String']['input']>;
  designId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  lastIndex?: InputMaybe<Scalars['Int']['input']>;
  limitRows?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputFeedColumnBgRemoveEligibility = {
  columnIndex: Scalars['Int']['input'];
  feedId: Scalars['Int']['input'];
};

export type InputFeedMatch = {
  columns: Array<FeedMatchColumn>;
  layers: Array<FeedMatchLayer>;
};

export type InputFeedRevertBgCount = {
  columnIndex: Scalars['Int']['input'];
  feedId: Scalars['Int']['input'];
};

export type InputFeedRow = {
  checksum?: InputMaybe<Scalars['String']['input']>;
  designId: Scalars['Int']['input'];
};

/**
 * Studio Assistant custom-feed auto-fill context. When set on a productPhotography
 * call, the server persists it on the resulting AiOperation; on completion, the
 * resulting image URL is written back into feed.data[rowIndex][columnName] via
 * the updateFeedRow service. Lets the writeback happen even when the user has
 * closed the chat panel or the app — the worker hits the feed directly.
 */
export type InputFeedRowContext = {
  /** Column INDEX captured at op-creation. Writeback uses this when present so a mid-flight column rename doesn't break the lookup-by-name path. */
  columnIndex?: InputMaybe<Scalars['Int']['input']>;
  columnName: Scalars['String']['input'];
  feedId: Scalars['Int']['input'];
  rowIndex: Scalars['Int']['input'];
};

export type InputFeedRows = {
  /** Return only the scoped total without materializing row payloads. */
  countOnly?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Scope the rows to a product set (CRE-438). Null/absent = the whole catalog ('All Products'), i.e. today's behaviour. */
  productSetId?: InputMaybe<Scalars['Int']['input']>;
  row?: InputMaybe<Scalars['Int']['input']>;
  /** Page size, capped at 1000 rows (a larger value is clamped); a scoped page also carries its selected row when it falls off the page. Absent: 100 rows, or only the requested row when 'row' is set. */
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};

export type InputFeeds = {
  columnType?: InputMaybe<FeedColumnType>;
  feedId?: InputMaybe<Scalars['Int']['input']>;
  feedName?: InputMaybe<Scalars['String']['input']>;
  includeSamples?: InputMaybe<Scalars['Boolean']['input']>;
  prevId?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
  withPagination?: InputMaybe<Scalars['Boolean']['input']>;
};

/** @deprecated use InputGetColumnsFromFeedSourceUrl instead */
export type InputFetchFeedUrl = {
  delimiter: DelimiterCsv;
  url: Scalars['String']['input'];
};

/** Input for fetching a team user group. */
export type InputFetchTeamUserGroup = {
  /** ID of the group to fetch. */
  groupId: Scalars['Int']['input'];
};

export type InputFetcher = {
  url: Scalars['String']['input'];
};

export type InputFigFileFontReplacement = {
  /** The font family the file uses. */
  family: Scalars['String']['input'];
  replacementFamily: Scalars['String']['input'];
  weights: Array<InputFigFileFontWeight>;
};

/** One source weight and the weight of the replacement family to use for it (1 to 1000). */
export type InputFigFileFontWeight = {
  replacementWeight: Scalars['Int']['input'];
  weight: Scalars['Int']['input'];
};

export type InputFigFileFonts = {
  /** At most 1,000 frames, and 4 MiB once the list is serialized as JSON (UTF-8). */
  frames: Array<Scalars['String']['input']>;
  projectId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

export type InputFigFileReport = {
  /** The created design, with SUCCESS for an import: the app takes an import SUCCESS without one as never queued. */
  designUrl?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  /** The BullMQ job id graphql queued the job under, which the key's claim holds. */
  jobId: Scalars['String']['input'];
  key: Scalars['String']['input'];
  /** Write only while the record still says PENDING: for a job BullMQ gave up on, which may still have finished. */
  onlyIfPending?: InputMaybe<Scalars['Boolean']['input']>;
  progressCompleted?: InputMaybe<Scalars['Int']['input']>;
  progressStep?: InputMaybe<Scalars['String']['input']>;
  progressTotal?: InputMaybe<Scalars['Int']['input']>;
  status: ParseStatus;
};

export type InputFigFileStatus = {
  key: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputFinance = {
  dateInterval: Scalars['Int']['input'];
  financialData: InputFinanceData;
};

export type InputFinanceData = {
  commodities: Array<InputFinancePair>;
  cryptocurrency: Array<InputFinancePair>;
  currency: Array<InputFinancePair>;
  metals: Array<InputFinancePair>;
};

export type InputFinancePair = {
  from: Scalars['String']['input'];
  to?: InputMaybe<Scalars['String']['input']>;
};

/** Input for finding competitors for a company. */
export type InputFindCompetitors = {
  /** Name of the company to find competitors for. */
  companyName: Scalars['String']['input'];
};

/** @deprecated Migration service has been removed */
export type InputFixMigratedTeamDesignsCustomFonts = {
  teamId: Scalars['Int']['input'];
};

/** One target canvas for an internal flex resize. */
export type InputFlexTarget = {
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

export type InputFocalPoint = {
  imageUrl: Scalars['String']['input'];
};

export type InputFolder = {
  folderId: Scalars['Int']['input'];
  projectId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputFolderTree = {
  projectId?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputFolders = {
  isApiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: OrderBy;
  orderType?: OrderType;
  parentId?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** When set, folders are matched by name across the whole project (parentId is ignored). */
  search?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for checking a single font's compatibility with text. */
export type InputFontCheck = {
  /** Font family name to check. */
  fontFamily: Scalars['String']['input'];
  /** Type of font (system, google, custom, etc.). */
  fontType: Scalars['String']['input'];
  /** URL to the font file (optional). */
  fontUrl?: InputMaybe<Scalars['String']['input']>;
  /** Text to check compatibility with. */
  text: Scalars['String']['input'];
};

/** Input for getting a font upload URL. */
export type InputFontUploadUrl = {
  /** ID of the brand kit to upload the font to. */
  brandKitId: Scalars['Int']['input'];
};

/** Input for retrieving fonts by family name. */
export type InputFontsByFamily = {
  /** Name of the font family to retrieve. */
  family: Scalars['String']['input'];
};

export type InputFrontify = {
  frontify: Scalars['Boolean']['input'];
  /** Frontify instance subdomain (e.g. mycompany for mycompany.frontify.com). Optional; cleared when frontify is false. */
  frontifyDomain?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputGtmPaymentDetails = {
  state?: InputMaybe<SubscriptionStatus>;
  teamId: Scalars['Int']['input'];
};

export type InputGenerateBackground = {
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  createMedia?: InputMaybe<Scalars['Boolean']['input']>;
  image: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['Int']['input']>;
  prompt: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
  variants?: InputMaybe<Scalars['Int']['input']>;
};

export type InputGenerateBackgroundBria = {
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Field no longer supported */
  canvasSize?: InputMaybe<Array<Scalars['Int']['input']>>;
  createMedia?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Field no longer supported */
  desiredResolution?: InputMaybe<DesiredResolution>;
  image: Scalars['String']['input'];
  /** @deprecated Field no longer supported */
  manualPlacementSelection?: InputMaybe<Array<ManualPlacementSelection>>;
  /** @deprecated Field no longer supported */
  negativePrompt?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Field no longer supported */
  paddingValues?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** @deprecated Field no longer supported */
  placementType?: InputMaybe<PlacementType>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  prompt: Scalars['String']['input'];
  /** @deprecated Field no longer supported */
  seed?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Field no longer supported */
  sid?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
  variants?: InputMaybe<Scalars['Int']['input']>;
};

export type InputGenerateBrandedCopy = {
  brandTone?: InputMaybe<Array<Scalars['String']['input']>>;
  brandVoice?: InputMaybe<InputGenerateWithBrandVoice>;
  innerText: Scalars['String']['input'];
  mediaDescription?: InputMaybe<Array<Scalars['String']['input']>>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  recaptchaToken: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type InputGenerateContentVariations = {
  /** Positive DB ids of saved Brand Kit audiences. Only read in PER_AUDIENCE mode. */
  audienceIds?: Array<Scalars['Int']['input']>;
  copyEnabled: Scalars['Boolean']['input'];
  copyLayerIds?: Array<Scalars['Int']['input']>;
  /**
   * Variation count in EVERYONE mode: 2/3/4/6, or — when imagerySource is
   * LIBRARY and the targets are not all logos — the number of entries in
   * photoIds, so that a request can make exactly one variation per picked
   * photo. Ignored in PER_AUDIENCE mode, where it is derived from the audience
   * count. A logo-only request must send exactly 1.
   */
  count: Scalars['Int']['input'];
  /** Hash of the master design/set the Variations tab is open on. Also scopes the media library and the job's masterSetId. Layer ids are resolved server-side against the pinned main design (mainDesignId child, else the master size). */
  designHash: Scalars['String']['input'];
  direction?: InputMaybe<Scalars['String']['input']>;
  imageryEnabled: Scalars['Boolean']['input'];
  imageryLayerIds?: Array<Scalars['Int']['input']>;
  imagerySource?: InputMaybe<ContentVariationImagerySource>;
  mode: ContentVariationMode;
  /** Library photo ids; validated against the design's media library. Only read when imagerySource is LIBRARY. */
  photoIds?: Array<Scalars['Int']['input']>;
  /** Ephemeral AI-suggested audiences (#3357), sent by value since they aren't persisted. Only read in PER_AUDIENCE mode. */
  suggestedAudiences?: Array<InputContentVariationSuggestedAudience>;
};

export type InputGenerateDesign = {
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  colors?: InputMaybe<Array<Scalars['String']['input']>>;
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  logos?: InputMaybe<Array<Scalars['String']['input']>>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
  templateHash?: InputMaybe<Scalars['String']['input']>;
  texts?: InputMaybe<Array<Scalars['String']['input']>>;
  urls?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  videos?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InputGenerateDesignJsonFromImage = {
  adFormat?: InputMaybe<InputAdFormat>;
  aspectRatio?: InputMaybe<Scalars['String']['input']>;
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated No longer needed */
  createMedia?: InputMaybe<Scalars['Boolean']['input']>;
  generateDesignImage?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated No longer needed, resolved from media metadata */
  logos?: InputMaybe<Array<Scalars['String']['input']>>;
  mediaHash?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated No longer needed */
  projectId?: InputMaybe<Scalars['Int']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputGenerateDesignName = {
  /** Brand kit ID to resolve brand name from */
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  /** Media hash to resolve image description from */
  mediaHash?: InputMaybe<Scalars['String']['input']>;
  /** User prompt describing the ad */
  prompt?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputGenerateDesignSetVideoThumbnails = {
  designSetHash: Scalars['String']['input'];
};

export type InputGenerateEmbedCode = {
  autoResize: Scalars['Boolean']['input'];
  currentCode?: InputMaybe<Scalars['String']['input']>;
  height: Scalars['Float']['input'];
  interiorMargin: Scalars['Float']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  preventClickThrough: Scalars['Boolean']['input'];
  prompt: Scalars['String']['input'];
  showScrollbar: Scalars['Boolean']['input'];
  teamId: Scalars['Int']['input'];
  useIframe: Scalars['String']['input'];
  width: Scalars['Float']['input'];
};

export type InputGenerateFromContent = {
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  createMedia?: InputMaybe<Scalars['Boolean']['input']>;
  image: Scalars['String']['input'];
  mode?: InputMaybe<GenerateFromContentMode>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
  variants?: InputMaybe<Scalars['Int']['input']>;
};

export type InputGenerateFromLineart = {
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  /** Ad Studio Copilot sketch card: the chat the generation was started from (verified server-side). */
  chatThreadId?: InputMaybe<Scalars['String']['input']>;
  /** What the Copilot client knew when it started this generation ({ toolCallId, announced, client }), stored on the ai_studio_generation row so any browser can pick it up. Requires generationSource AI_STUDIO. Capped at 32 KB. */
  copilotKickoff?: InputMaybe<Scalars['JSON']['input']>;
  createMedia?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ad Studio Copilot sketch card: the design the sketch was drawn in. With generationSource AI_STUDIO, records an AI Studio generation over the variant operations. */
  designHash?: InputMaybe<Scalars['String']['input']>;
  /** Set to AI_STUDIO by the Copilot sketch card; absent from the classic editor. */
  generationSource?: InputMaybe<GenerationSource>;
  image: Scalars['String']['input'];
  maxHeight?: InputMaybe<Scalars['Int']['input']>;
  maxWidth?: InputMaybe<Scalars['Int']['input']>;
  negativePrompt?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  prompt: Scalars['String']['input'];
  style?: InputMaybe<ImageGenerationStyle>;
  teamId: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
  variants?: InputMaybe<Scalars['Int']['input']>;
};

export type InputGenerateLayeredAd = {
  adFormatId: Scalars['String']['input'];
  /** Where the ad was requested: 'copilot', 'home_chat', 'start_from_assets', 'helper' or 'mcp' (set by startLayeredAd). Resolved by graphql's chat proxy, never by a model. A label for the Slack post and ai_generation_finished; an unknown value is dropped, never an error. */
  adStudioEntry?: InputMaybe<Scalars['String']['input']>;
  /** The Copilot asked for an animated ad. Admitted only when the layered_video_ads gate is on for the team; a team whose plan excludes AI video is refused (PLAN_FEATURE_REFUSED) and nothing starts. Omitted or false means a static ad, as before. */
  animated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Who chose attachedImageUrls: false when every one is a Brand Kit or library image the Copilot picked on its own (the user attached none and asked for none); true when the user specified them. Absent counts as the user's. Decides only whether flat-to-layers may draw the ad from scratch, with those images as its first references. */
  attachedByUser?: InputMaybe<Scalars['Boolean']['input']>;
  /** User-attached reference images (preserved subject and/or inspiration). Forwarded to the layered-ad engine as background-generation references. */
  attachedImageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  /** How to use the attached images, classified by the agent from the user's message: 'preserve' (default — feature the exact attached subject) or 'inspiration' (style cues only). */
  attachedImageUsage?: InputMaybe<Scalars['String']['input']>;
  /** How many leading attachedImageUrls are real products to keep together (Copilot multi-product ads, AIA-82). Omit for one; ignored under 'inspiration'. */
  attachedSubjectCount?: InputMaybe<Scalars['Int']['input']>;
  /** A new ad built on an earlier Copilot ad of the same chat (the ad preview's 'change this ad'). Used only when that ad's operation is this team's and this chat's (threadId), finished, and recorded its plate and layout; otherwise the ad is generated from the brief alone, as before. */
  base?: InputMaybe<InputLayeredAdBase>;
  body?: InputMaybe<Scalars['String']['input']>;
  brandKitId: Scalars['Int']['input'];
  brandStyleDescription?: InputMaybe<Scalars['String']['input']>;
  brandStyleImageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  cta?: InputMaybe<Scalars['String']['input']>;
  /** Hash of the current Ad Studio design to replace */
  designHash: Scalars['String']['input'];
  headline?: InputMaybe<Scalars['String']['input']>;
  /** Proof of concept — sketch to layout. The https URL of a wireframe the user drew of where the ad's elements go (hero image, headline, body, CTA, logo). The layered-ad engine reads its boxes as the layout and paints the hero where the sketch put it; the image itself is never a style reference. Omit it and generation is unchanged. */
  layoutSketchUrl?: InputMaybe<Scalars['String']['input']>;
  /** The Ad Studio Copilot brief's logo decision. When set, 'none' wins over every logo source (the attached document's included); 'src' mirrors logoSrc. */
  logo?: InputMaybe<InputLayeredAdLogo>;
  logoSrc?: InputMaybe<Scalars['String']['input']>;
  /** The user was told no real image of their brand's own restricted item exists and asked for it to be generated anyway. Narrows the engine's depiction rule for THAT item only — every other restricted row in the same ad keeps its restriction, and the brand profile itself still rides from the kit. */
  productAcceptedByUser?: InputMaybe<Scalars['Boolean']['input']>;
  /** The Copilot asked for the product on its own layer (an empty studio background plus a cut-out 'Product' layer). Admitted only when the layered_product_layer gate is on for the team, and never together with animated. Omitted or false means today's ad. */
  productLayer?: InputMaybe<Scalars['Boolean']['input']>;
  prompt: Scalars['String']['input'];
  /** Hash of the design the user was viewing when requesting generation; the worker falls back to the set's first child when absent */
  targetDesignHash?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
  texts?: InputMaybe<Array<InputLayeredAdText>>;
  /** The Copilot thread this generation was requested from. Used to read that thread's extracted brand-guidelines document server-side, and recorded on the operation so its Slack post can link the conversation in admin; no brand value is ever accepted from the caller. */
  threadId?: InputMaybe<Scalars['String']['input']>;
  /** The user's own request, as the Copilot forwarded it. Read only by a flat-to-layers ad from scratch, for what the ad is for, the language of its copy and a product the user left out; the layered-ad job never reads it. */
  userRequest?: InputMaybe<Scalars['String']['input']>;
};

/** Input for generating a client ID for a team. */
export type InputGenerateTeamClientId = {
  /** Name for the client ID. */
  name: Scalars['String']['input'];
  /** Scopes for the API token (optional for backward compatibility). */
  scopes?: InputMaybe<Array<ApiTokenScope>>;
  /** ID of the team to generate the client ID for. */
  teamId: Scalars['Int']['input'];
};

export type InputGenerateVeevaNotes = {
  designHash: Scalars['String']['input'];
  prompt: InputGenerateVeevaNotesPrompt;
};

export type InputGenerateVeevaNotesPrompt = {
  result: Scalars['String']['input'];
};

export type InputGenerateVeevaPdf = {
  /** @deprecated Field no longer supported */
  animationNotes?: InputMaybe<Array<Scalars['String']['input']>>;
  designHash: Scalars['String']['input'];
  designSizes?: InputMaybe<Array<DesignSizeInput>>;
  downloadCoverSlide?: InputMaybe<Scalars['Boolean']['input']>;
  exportAs?: InputMaybe<Array<Scalars['String']['input']>>;
  globalText?: InputMaybe<Scalars['String']['input']>;
  /** @BreakingBad slideData is now an array with notes, timings, id */
  slideData?: InputMaybe<SlideDataInput>;
};

export type InputGenerateVeevaPdfStatus = {
  jobId: Scalars['String']['input'];
};

export type InputGenerateWithBrandVoice = {
  brandValues: Scalars['String']['input'];
  brandVoice: Scalars['String']['input'];
  rules?: InputMaybe<IgWithBrandVoiceRules>;
};

export type InputGeneratorTextContent = {
  innerText: Scalars['String']['input'];
  language: Scalars['String']['input'];
  recaptchaToken: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  voiceTone?: InputMaybe<Scalars['String']['input']>;
};

export type InputGetAccessToken = {
  code: Scalars['String']['input'];
  integrationApp: Integrations;
  redirectUri?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for retrieving an ad network by its ID. */
export type InputGetAdNetworkById = {
  /** The ID of the ad network to retrieve. */
  id: Scalars['Int']['input'];
  /** The ID of the team associated with the ad network. */
  teamId: Scalars['Int']['input'];
};

export type InputGetAdminAdNetwork = {
  id: Scalars['Int']['input'];
};

export type InputGetAdminUser = {
  id: Scalars['Int']['input'];
};

export type InputGetAgentSystemPrompt = {
  teamId: Scalars['Int']['input'];
  type: AgentType;
};

export type InputGetAiAgentAutomatedReportsDashboard = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputGetAiAutomatedReportsByScheduleId = {
  automatedReportScheduleId: Scalars['Int']['input'];
};

export type InputGetAiAutomatedReportsByTeamUser = {
  teamUserId: Scalars['Int']['input'];
};

export type InputGetAiChats = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  scope: ChatScope;
  teamId: Scalars['Int']['input'];
};

export type InputGetAiOperationProgress = {
  operationId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputGetAuthEvents = {
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  eventTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['String']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the team to get login events for. */
  teamId: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputGetAutomatedReportHtml = {
  hash: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};

export type InputGetAutomatedReportHtmlById = {
  reportId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputGetAutomatedReportPublicHash = {
  reportId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputGetAutomatedReportPublicResourceAccess = {
  hash: Scalars['String']['input'];
};

export type InputGetAutomatedScheduleReports = {
  scheduleId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

/** Input for retrieving background remover credits. */
export type InputGetBgRemoverCredits = {
  /** ID of the team to get credits for. */
  teamId: Scalars['Int']['input'];
};

/** Input for retrieving brand kit JSON data. */
export type InputGetBrandKitJson = {
  /** Hash of the brand kit (for public access). */
  brandKitHash?: InputMaybe<Scalars['String']['input']>;
  /** ID of the brand kit (for authenticated access). */
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for reading the brand profile of a brand kit. */
export type InputGetBrandKitProfile = {
  /** ID of the brand kit. */
  brandKitId: Scalars['Int']['input'];
};

/** Input for retrieving the project ID associated with a brand kit. */
export type InputGetBrandKitProjectId = {
  /** ID of the brand kit to get the project for. */
  brandKitId: Scalars['Int']['input'];
};

/** Input for getting visual style for a brand kit. */
export type InputGetBrandKitVisualStyle = {
  /** ID of the brand kit. */
  brandKitId: Scalars['Int']['input'];
};

/** Input for retrieving voice and tone settings for a brand kit. */
export type InputGetBrandKitVoiceAndTone = {
  /** ID of the brand kit to retrieve voice and tone for. */
  brandKitId: Scalars['Int']['input'];
};

/** Input to fetch a specific Bynder asset. */
export type InputGetBynderAsset = {
  /** The ID of the Bynder asset. */
  id: Scalars['String']['input'];
  /** The ID of the team, optional. */
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

/** Input to get a download URL for a Bynder asset item. */
export type InputGetBynderAssetDownload = {
  /** The ID of the Bynder asset. */
  id: Scalars['String']['input'];
  /** The ID of the specific media item within the asset. */
  itemId: Scalars['String']['input'];
  /** The ID of the team, optional. */
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

/** Input to fetch a list of Bynder assets. */
export type InputGetBynderAssets = {
  /** Filters to apply when fetching Bynder assets. */
  filters: InputBynderAssetFilters;
  /** The ID of the team, optional. */
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

/** Input to fetch a list of Bynder collections. */
export type InputGetBynderCollections = {
  /** Filters to apply when fetching Bynder collections. */
  filters: InputBynderCollectionFilters;
  /** The ID of the team, optional. */
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

/** Input to get Bynder access token. */
export type InputGetBynderToken = {
  /** The authorization code received from Bynder. */
  code: Scalars['String']['input'];
  /** The Bynder portal URL. */
  portalUrl: Scalars['String']['input'];
};

export type InputGetCloudIntegration = {
  integrationApp: Integrations;
  teamId: Scalars['Int']['input'];
  /** Ignored: the personal integration is always the signed-in user's own. */
  userId: Scalars['Int']['input'];
};

export type InputGetCloudIntegrationAccountEmail = {
  accessToken: Scalars['String']['input'];
  integrationApp: Integrations;
  refreshToken: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<IntegrationAccountType>;
};

export type InputGetCloudinaryConfig = {
  teamId: Scalars['Int']['input'];
};

export type InputGetColumnsFromFeedSource = {
  delimiter?: InputMaybe<DelimiterCsv>;
  filterTargetColumn?: InputMaybe<Scalars['Boolean']['input']>;
  rawData?: InputMaybe<Scalars['String']['input']>;
  sourceType: FeedSourceType;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** @deprecated use InputGetColumnsFromFeedSource instead */
export type InputGetColumnsFromFeedSourceUrl = {
  delimiter: DelimiterCsv;
  filterTargetColumn?: InputMaybe<Scalars['Boolean']['input']>;
  url: Scalars['String']['input'];
};

export type InputGetCommentAttachments = {
  after?: InputMaybe<Scalars['String']['input']>;
  commentId: Scalars['Int']['input'];
  format?: InputMaybe<CommentAttachmentFormat>;
  lastId?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CommentAttachmentType>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Input for retrieving brand-kit custom fonts compatible with a design's
 * feed content for the given language codes.
 */
export type InputGetCompatibleFontsForLanguages = {
  /** ID of the brand kit whose custom fonts to evaluate. */
  brandKitId: Scalars['Int']['input'];
  /** ID of the design whose feed text drives the compatibility check. */
  designId: Scalars['Int']['input'];
  /** Language codes to evaluate (must match values in the feed's language column). */
  languageCodes: Array<Scalars['String']['input']>;
};

export type InputGetCopilotAiChatPublicHash = {
  chatId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputGetCopilotAiChats = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputGetCopilotAiPublicResourceAccess = {
  hash: Scalars['String']['input'];
};

export type InputGetCopilotAiReportPublicHash = {
  chatId: Scalars['Int']['input'];
  htmlId: Scalars['Int']['input'];
  messageId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputGetCustomBranding = {
  teamId: Scalars['Int']['input'];
};

export type InputGetCustomTransitions = {
  teamId: Scalars['Int']['input'];
};

export type InputGetDesignComments = {
  designHash: Scalars['String']['input'];
};

export type InputGetDesignComponentName = {
  id: Scalars['Int']['input'];
};

/** Input for checking if a design is currently being edited. */
export type InputGetDesignEditingStatus = {
  /** Hash of the design to check. */
  designHash: Scalars['String']['input'];
};

/** Input for retrieving the appropriate design size type based on dimensions. */
export type InputGetDesignSizeType = {
  /** ID of the user who created the design. */
  createdBy: Scalars['Int']['input'];
  /** Name of the design. */
  designName: Scalars['String']['input'];
  /** Height of the design in the specified measurement unit. */
  height: Scalars['Int']['input'];
  /** Measurement unit for the design dimensions. */
  measureUnit: MeasureUnit;
  /** ID of the team that owns the design. */
  teamId: Scalars['Int']['input'];
  /** Width of the design in the specified measurement unit. */
  width: Scalars['Int']['input'];
};

/** Input for retrieving a design's type. */
export type InputGetDesignType = {
  /** Hash of the design to get the type for. */
  designHash: Scalars['String']['input'];
};

export type InputGetDetectedLanguageForText = {
  texts: Array<Scalars['String']['input']>;
};

export type InputGetDomainStatus = {
  domain: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputGetEmailStatus = {
  email: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputGetExpiredSubscription = {
  teamId: Scalars['Int']['input'];
};

export type InputGetFeatureAccess = {
  version: Scalars['Int']['input'];
};

export type InputGetFeaturebaseTeamData = {
  userId: Scalars['Int']['input'];
};

export type InputGetGoogleAdsCampaigns = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  campaignType?: InputMaybe<AdvertisingChannelType>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  days?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  includeTotal?: InputMaybe<Scalars['Boolean']['input']>;
  includeVisuals?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  maxClicks?: InputMaybe<Scalars['Int']['input']>;
  maxConversions?: InputMaybe<Scalars['Int']['input']>;
  maxCost?: InputMaybe<Scalars['Float']['input']>;
  maxImpressions?: InputMaybe<Scalars['Int']['input']>;
  minClicks?: InputMaybe<Scalars['Int']['input']>;
  minConversions?: InputMaybe<Scalars['Int']['input']>;
  minCost?: InputMaybe<Scalars['Float']['input']>;
  minImpressions?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<GoogleAdsSortBy>;
  sortOrder?: InputMaybe<GoogleAdsSortOrder>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<GoogleAdsStatus>;
  teamId: Scalars['Int']['input'];
};

/** Input for retrieving identity provider team invitation status. */
export type InputGetIdentityProviderTeamInvitationStatus = {
  /** ID of the team to check (optional). */
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputGetIntegrationAccounts = {
  teamId: Scalars['Int']['input'];
};

/** @deprecated This input type is no longer used */
export type InputGetIntegrationCampaigns = {
  platform: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputGetLearnAgentChatPublicHash = {
  chatId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputGetLearnAgentReportHtml = {
  hash: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};

export type InputGetLearnAgentReportPublicHash = {
  chatId: Scalars['Int']['input'];
  htmlId: Scalars['Int']['input'];
  messageId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputGetMetaAdPreview = {
  adFormat?: InputMaybe<Scalars['String']['input']>;
  adId: Scalars['String']['input'];
  height?: InputMaybe<Scalars['Int']['input']>;
  integrationAccountId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type InputGetMetaAds = {
  accountId: Scalars['String']['input'];
  adName?: InputMaybe<Scalars['String']['input']>;
  adSetId?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['Date']['input'];
  integrationAccountId: Scalars['String']['input'];
  maxRows?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<MetaAdsSortBy>;
  sortOrder?: InputMaybe<MetaAdsSortOrder>;
  startDate: Scalars['Date']['input'];
  status?: InputMaybe<MetaAdsStatus>;
  teamId: Scalars['Int']['input'];
};

export type InputGetMoodBoard = {
  hash: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};

export type InputGetMoodBoardContent = {
  hash: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};

export type InputGetMoodBoardShare = {
  moodboardId: Scalars['Int']['input'];
};

export type InputGetMoodBoardShareByHash = {
  hash: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};

export type InputGetMoodBoardVersionContent = {
  hash: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  versionId: Scalars['String']['input'];
};

export type InputGetMoodBoardVersions = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  hash: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type InputGetMoodBoardsByBrandKitId = {
  brandKitId: Scalars['Int']['input'];
};

export type InputGetMoodBoardsByName = {
  brandKitId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type InputGetMoodBoardsByProjectId = {
  projectId: Scalars['Int']['input'];
};

export type InputGetOrCreateDesignSetSizeType = {
  designSizeTypeIds: Array<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

/** Input for getting platform ads for a brand kit */
export type InputGetPlatformAds = {
  brandKitId: Scalars['Int']['input'];
};

export type InputGetProjectDetail = {
  projectId: Scalars['Int']['input'];
};

export type InputGetPublicLink = {
  designId?: InputMaybe<Scalars['Int']['input']>;
  folderId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputGetRecentAiOperations = {
  /** Only return operations created within the last N minutes (default 30) */
  createdAfterMinutes?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};

export type InputGetRecentCopilotAds = {
  /** Only return ads created within the last N minutes (default 60) */
  createdAfterMinutes?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};

export type InputGetRedisKey = {
  dbValue?: InputMaybe<Scalars['Int']['input']>;
  key: Scalars['String']['input'];
};

export type InputGetRedisStreams = {
  dbValue: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchHash?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<StreamSortField>;
  sortOrder?: InputMaybe<StreamSortOrder>;
};

export type InputGetRoomTypes = {
  teamId: Scalars['Int']['input'];
};

export type InputGetSamlConfigFile = {
  teamId: Scalars['Int']['input'];
};

export type InputGetSavedScore = {
  mainDesignIds: Array<Scalars['Int']['input']>;
};

/** Input for retrieving comment settings for shared links. */
export type InputGetShareLinkCommentsEnabled = {
  /** ID of the team to get settings for. */
  teamId: Scalars['Int']['input'];
};

export type InputGetSharePointAccessToken = {
  teamId: Scalars['Int']['input'];
};

export type InputGetSharePointDefaultLocation = {
  accountType?: InputMaybe<IntegrationAccountType>;
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputGetSharePointPersonalDrive = {
  accountType: IntegrationAccountType;
};

export type InputGetSharedPublicLearnAgentChat = {
  hash: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};

export type InputGetSlackAccessToken = {
  appIntegration: AppIntegrationType;
  code: Scalars['String']['input'];
  redirectUri?: InputMaybe<Scalars['String']['input']>;
};

/** Input for retrieving fonts that support a list of language codes. */
export type InputGetSupportedFontsForLanguages = {
  /** Language codes to filter fonts by (EN, JA, etc.). */
  languageCodes: Array<Scalars['String']['input']>;
};

/** Input for retrieving an SVG URL. */
export type InputGetSvgUrl = {
  /** URL of the SVG to retrieve. */
  url: Scalars['String']['input'];
};

/** Input for retrieving the system group in a team. */
export type InputGetSystemGroup = {
  /** ID of the team to get the system group from. */
  teamId: Scalars['Int']['input'];
};

export type InputGetTeam = {
  teamId: Scalars['Int']['input'];
};

export type InputGetTeamIdentityProvider = {
  teamId: Scalars['Int']['input'];
};

export type InputGetTeamIdentityProviderDomainsStatus = {
  teamId: Scalars['Int']['input'];
};

export type InputGetTeamImpressionsBilling = {
  teamId: Scalars['Int']['input'];
};

/** Input for getting details about a temporarily uploaded font. */
export type InputGetTempFontDetails = {
  /** Hash identifier of the temporary font file. */
  hash: Scalars['String']['input'];
  /** Original name of the font file. */
  name: Scalars['String']['input'];
};

export type InputGetTemporaryEnterprise = {
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputGetUrlContentType = {
  url: Scalars['String']['input'];
};

export type InputGetUserByAdmin = {
  id: Scalars['Int']['input'];
};

export type InputGetUserList = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search: Scalars['String']['input'];
  type: AdminUserQueryType;
};

export type InputGetWorkflow = {
  hash?: InputMaybe<Scalars['String']['input']>;
  moodBoardHash?: InputMaybe<Scalars['String']['input']>;
};

export type InputGetWorkflowRealtimeSubscriptionToken = {
  moodboardHash: Scalars['String']['input'];
};

export type InputGetWorkflowRuns = {
  hash?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  moodBoardHash?: InputMaybe<Scalars['String']['input']>;
};

export type InputGoogleAdsPublishUpdate = {
  count: Scalars['Int']['input'];
  creditTransactionId?: InputMaybe<Scalars['Int']['input']>;
  designHash: Scalars['String']['input'];
  exportType?: InputMaybe<DownloadType>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  success: Scalars['Boolean']['input'];
  userId: Scalars['Int']['input'];
};

export type InputGoogleFontWeight = {
  weight: Scalars['String']['input'];
};

export type InputHandleTemporaryEnterprise = {
  accepted: Scalars['Boolean']['input'];
  teamId: Scalars['Int']['input'];
};

/** Input for checking if a team is in the Ad Studio experiment. */
export type InputHasAdStudioExperiment = {
  /** ID of the team to check. */
  teamId: Scalars['Int']['input'];
};

/** @deprecated not used */
export type InputHasDesignsAdTagActive = {
  /** ID of the team to check. */
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for checking whether a team has ever served an ad. */
export type InputHasEverServedAd = {
  /** ID of the team to check. */
  teamId: Scalars['Int']['input'];
};

export type InputHasFeeds = {
  teamId: Scalars['Int']['input'];
};

export type InputHashToId = {
  hash: Scalars['String']['input'];
};

export type InputHashedTeamId = {
  teamId: Scalars['Int']['input'];
};

export type InputIdToHash = {
  id: Scalars['Int']['input'];
};

export type InputImageGeneration = {
  aspectRatio: ImageGenerationAspectRatio;
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  createMedia?: InputMaybe<Scalars['Boolean']['input']>;
  creditOperationName?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  modelUid?: InputMaybe<Scalars['String']['input']>;
  negativePrompt?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  skipPromptCheck?: InputMaybe<Scalars['Boolean']['input']>;
  style?: InputMaybe<ImageGenerationStyle>;
  teamId: Scalars['Int']['input'];
  type: ImageGenerationType;
  userId?: InputMaybe<Scalars['Int']['input']>;
  userPrompt?: InputMaybe<Scalars['String']['input']>;
  variants?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type InputImageSubtleAnimation = {
  imageHash: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputImportAemAsset = {
  fileName: Scalars['String']['input'];
  /** The user's relayed Adobe IMS bearer (used server-side to fetch the author binary). */
  imsToken: Scalars['String']['input'];
  mimeType?: InputMaybe<Scalars['String']['input']>;
  /** DAM path of the asset, e.g. /content/dam/brand/logo.png. */
  path: Scalars['String']['input'];
  /** Author repo host, e.g. author-p1234-e5678.adobeaemcloud.com. */
  repositoryId: Scalars['String']['input'];
};

export type InputImportBrandKitDocument = {
  brandKitId: Scalars['Int']['input'];
  mimeType: Scalars['String']['input'];
  /** Original file name, shown in the list. */
  name: Scalars['String']['input'];
  sizeBytes: Scalars['Int']['input'];
  /** The fileUrl returned by signBrandKitDocumentUploadUrl once the upload succeeded. */
  url: Scalars['String']['input'];
};

/** Input for importing media into a design's library from external URLs. */
export type InputImportDesignMediaFromUrls = {
  /** The design whose library receives the media (the currently open design). */
  designId: Scalars['Int']['input'];
  /** design_media_folder id on the design; null/omitted lands at the library root. */
  folderId?: InputMaybe<Scalars['Int']['input']>;
  /** Direct media URLs to import. http(s) only; capped server-side. */
  urls: Array<Scalars['String']['input']>;
};

export type InputImportFigFileFrames = {
  folderId?: InputMaybe<Scalars['Int']['input']>;
  /** The missing-fonts dialog's picks; omit when nothing was replaced. */
  fontReplacements?: InputMaybe<Array<InputFigFileFontReplacement>>;
  /** Node ids of the frames to import, in import order, as structure.json lists them (at most 500). Several make one design set. */
  frameIds: Array<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

/** Input for importing media out of one design into another design's library. */
export type InputImportMediaFromDesign = {
  /** design_media_folder id on the TARGET design; null/omitted lands at the library root. */
  folderId?: InputMaybe<Scalars['Int']['input']>;
  /** Keys from designImportableMedia. */
  keys: Array<Scalars['String']['input']>;
  /** The design the media came from; every key is re-derived against its JSON. */
  sourceDesignHash: Scalars['String']['input'];
  /** The design whose library receives the media (the currently open design). */
  targetDesignId: Scalars['Int']['input'];
};

export type InputImportMetaCatalog = {
  /** business_social_link accountId of the connected Meta account */
  accountId: Scalars['String']['input'];
  businessId: Scalars['String']['input'];
  metaCatalogId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
  updateFrequency?: InputMaybe<UpdateFrequencyType>;
  workspaceId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputInitiateIntercomConversation = {
  fromAdmin: Scalars['Int']['input'];
};

export type InputInpaintWithAi = {
  maskUrl: Scalars['String']['input'];
  negativePrompt?: InputMaybe<Scalars['String']['input']>;
  prompt: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
  url: Scalars['String']['input'];
  variants?: InputMaybe<Scalars['Int']['input']>;
};

export type InputIntegrationFilesUploadUrl = {
  id: Scalars['String']['input'];
  integrationType: Integrations;
  type: MediaType;
};

export type InputIntegrationItems = {
  elementType: ElementTypes;
  folderId?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  nextPageToken?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputIntegrations = {
  integrationApp: Integrations;
  teamId: Scalars['Int']['input'];
};

export type InputIntercom = {
  jobType: IntercomJobType;
  teamIdField?: InputMaybe<Scalars['String']['input']>;
  trackingType: IntercomTrackingType;
  userIdField?: InputMaybe<Scalars['String']['input']>;
};

export type InputInternalCreateDesignFromJsons = {
  /**
   * Provenance of the import. Callers MUST pass their own source (figma import
   * service sends figma, photoshop import service sends psd); when omitted the
   * design is recorded with an unknown (null) source rather than being
   * attributed to a caller it did not come from.
   */
  creationSource?: InputMaybe<DesignCreationSource>;
  /** ID of the folder to create the design set in (optional). */
  folderId?: InputMaybe<Scalars['Int']['input']>;
  /** JSON representation of the designs inside the set. */
  jsons: Array<Scalars['JsonDesign']['input']>;
  /** Name for the design set (optional). */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of the project to create the design set in. */
  projectId: Scalars['Int']['input'];
  /** ID of the team that will own the design set. */
  teamId: Scalars['Int']['input'];
};

/**
 * Input for retrieving a design's JSON data internally.
 * Used by internal services.
 */
export type InputInternalDesignJson = {
  /** Hash of the design to retrieve JSON data for. */
  hash: Scalars['String']['input'];
};

export type InputInvalidatePayment = {
  clearPlans?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The Recurly notification that reported the change (e.g. billing_info_updated_notification),
   * sent by the Recurly webhook. An event that proves a cached answer wrong also clears that
   * answer's rate-limit fallback copy; any other or absent event keeps them all.
   */
  recurlyEvent?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

/** Input for inviting a user to a team. */
export type InputInviteTeamUser = {
  /** ID of the design to grant access to (optional). */
  designId?: InputMaybe<Scalars['Int']['input']>;
  /** Email address of the user to invite. */
  email: Scalars['String']['input'];
  /** ID of the folder to grant access to (optional). */
  folderId?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the project to grant access to (optional). */
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the role to assign to the invited user. */
  roleId: Scalars['Int']['input'];
  /** ID of the team to invite the user to. */
  teamId: Scalars['Int']['input'];
};

/** Input for inviting multiple users to multiple resources. */
export type InputInviteTeamUsersMultipleResources = {
  /** Email addresses and roles for the users to invite. */
  emails: Array<InputInviteTeamUsersMultipleResourcesEmail>;
  /** Resources to grant access to. */
  items: InputInviteTeamUsersMultipleResourcesItem;
  /** ID of the project to grant access to (optional). */
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the team to invite the users to. */
  teamId: Scalars['Int']['input'];
};

/** Input for an email and role combination when inviting multiple users. */
export type InputInviteTeamUsersMultipleResourcesEmail = {
  /** Email address of the user to invite. */
  email: Scalars['String']['input'];
  /** ID of the role to assign to the invited user. */
  roleId: Scalars['Int']['input'];
};

/** Resources to grant access to when inviting users. */
export type InputInviteTeamUsersMultipleResourcesItem = {
  /** IDs of designs to grant access to. */
  designIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** IDs of folders to grant access to. */
  folderIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Response after inviting multiple users to resources. */
export type InputInviteTeamUsersMultipleResourcesPayload = {
  __typename?: 'InputInviteTeamUsersMultipleResourcesPayload';
  /** Information about the invited users. */
  invitees: Array<TeamUserInvitee>;
};

export type InputInvoices = {
  teamId: Scalars['Int']['input'];
};

export type InputIsBrandKitDocumentExtractionCurrent = {
  documentId: Scalars['Int']['input'];
  version: Scalars['Int']['input'];
};

export type InputIsBrandProfileExtractionCurrent = {
  brandKitId: Scalars['Int']['input'];
  version: Scalars['Int']['input'];
};

/** @deprecated Brand template migration service has been removed. @BreakingBad */
export type InputIsTeamMigrated = {
  teamId: Scalars['Int']['input'];
};

export type InputJoinBetaNextgenAi = {
  teamId: Scalars['String']['input'];
};

export type InputJoinMoodboardTeam = {
  hash: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};

/** Input for joining a team. */
export type InputJoinTeam = {
  /** Business domain to join by. */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** ID of the team to join. */
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for a design JSON with hash identifier. */
export type InputJsonDesignWithHash = {
  /** JSON representation of the design content. */
  banner: Scalars['JsonDesign']['input'];
  /** ID of the design size type. */
  designSizeTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** Unique hash identifier for the design. */
  hash: Scalars['String']['input'];
  /** ID of the user creating or modifying the design. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** The earlier ad a layered ad builds on. */
export type InputLayeredAdBase = {
  /** The base ad's layered-ad operation. */
  aiOperationId: Scalars['Int']['input'];
  /** 'keep': the change leaves the base ad's picture as it is. 'edit': the change is to the picture itself, described by pictureChange. Any other value: no base. */
  picture: Scalars['String']['input'];
  /** With picture 'edit': the change to make to the base ad's picture. */
  pictureChange?: InputMaybe<Scalars['String']['input']>;
};

/** A brief's logo decision: exactly one of none (with a reason) or src. */
export type InputLayeredAdLogo = {
  /** Optional compact (icon) version of the same logo. Carried to the engine, which uses it for small canvases only under the logoDecisionLock engine setting. */
  compactSrc?: InputMaybe<Scalars['String']['input']>;
  /** true renders the ad without a logo. Requires reason; never sent with src. */
  none?: InputMaybe<Scalars['Boolean']['input']>;
  /** With none: why there is no logo, 'user' (the user asked for none) or 'no-usable-logo' (the kit has none usable). With src: 'user' when the user asked for that exact version of the logo, which no automatic swap then replaces; any other value is ignored. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** The src of the logo the brief chose, one of the brand kit's logos or the attached document's. */
  src?: InputMaybe<Scalars['String']['input']>;
};

export type InputLayeredAdText = {
  color?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};

export type InputLearnAgentAiChat = {
  chatId?: InputMaybe<Scalars['Int']['input']>;
  message: InputAiChatMessage;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
};

/** Input for leaving a team. */
export type InputLeaveTeam = {
  /** ID of the team to leave. */
  teamId: Scalars['Int']['input'];
  /** ID of the user who is leaving. */
  userId: Scalars['Int']['input'];
};

export type InputLimitRequest = {
  allowedRequests: Scalars['Int']['input'];
};

/** Writeback input from the worker — superset of InputCM360PublishUpdate */
export type InputLinkedInPublishUpdate = {
  count: Scalars['Int']['input'];
  creditTransactionId?: InputMaybe<Scalars['Int']['input']>;
  designHash: Scalars['String']['input'];
  error?: InputMaybe<LinkedInPublishErrorInput>;
  exportType?: InputMaybe<DownloadType>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  perSize?: InputMaybe<Array<LinkedInPerSizeStatusInput>>;
  success: Scalars['Boolean']['input'];
  userId: Scalars['Int']['input'];
};

/**
 * Durable rotated-refresh-token writeback from the worker (optimistic concurrency).
 *
 * The server applies the rotation only when the stored refreshToken still equals
 * expectedCurrentRefreshToken, so a slower parallel job cannot clobber a newer rotation.
 */
export type InputLinkedInRotatedToken = {
  /** Compare-and-set guard: the refresh token the write expects to be CURRENT in the DB */
  expectedCurrentRefreshToken: Scalars['String']['input'];
  /** CloudIntegration row id whose refresh token rotated */
  integrationId: Scalars['Int']['input'];
  /** The newly issued refresh token to persist */
  refreshToken: Scalars['String']['input'];
  /** New refresh-token expiry (seconds), persisted for the re-auth UX */
  refreshTokenExpiresIn?: InputMaybe<Scalars['Int']['input']>;
  /** Team that owns the integration (null for personal integrations) */
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputLintDesignJsonResizeability = {
  /** The design to scan. Not persisted — callers may have no Design row at all. */
  jsonDesign: Scalars['JSON']['input'];
  /** Allowlisted scan model id. Omitted takes the default; an unknown id is rejected, never coerced. */
  model?: InputMaybe<Scalars['String']['input']>;
  patterns?: InputMaybe<Array<InputDesignLintPattern>>;
  /** Base64 PNG preview. The scan reasons far better about layout with one, and works without. */
  previewPngBase64?: InputMaybe<Scalars['String']['input']>;
  /**
   * Render the preview server-side (jpg-png `POST /render` of the scoped document) when no
   * `previewPngBase64` is supplied — what the dialog's Query does. Off by default so the e2e suite,
   * which hands in its own full-size render, is unaffected; on, it is the way to measure the dialog's
   * whole server path without a browser.
   */
  renderPreview?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputLintDesignResizeability = {
  /** The saved design to scan. The server loads its JSON; the caller never supplies a document here. */
  hash: Scalars['String']['input'];
  patterns?: InputMaybe<Array<InputDesignLintPattern>>;
  /**
   * Base64 PNG of the design, for a caller that already holds a render of the SAVED bytes.
   *
   * The scan's visual-grouping answer is far better with a picture: the JSON projection can say a
   * label sits inside a plate's box, and only the picture says the two READ as one badge. OMIT IT and
   * the server renders one itself — synchronously, through jpg-png, from the exact scoped document it
   * is about to scan — which is what the pre-resize dialog does since 2026-08-27 (it used to enqueue a
   * JPG_PNG job, poll S3 and upload the result here). A supplied picture is trusted as-is, so it must
   * depict the saved bytes: a stale one is worse than none. The document itself is still loaded
   * server-side from the hash; this is a picture, never a source of truth about the design.
   */
  previewPngBase64?: InputMaybe<Scalars['String']['input']>;
  /**
   * Scope the scan to ONE slide — the slide being resized. A resize session touches a single slide, so
   * without this the whole design is scanned and (on apply) persisted, rewriting slides the user never
   * saw. The slide key is bannersetElementId ?? properties.id. Omitted ⇒ the whole design. It must
   * match the value passed to applyDesignLintFixes, or the replay token will not.
   */
  slideId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputListAdminDisposableEmails = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AdminDisposableEmailStatus>;
};

export type InputListAdminUrlSafetyEntries = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  list?: InputMaybe<AdminUrlSafetyList>;
  offset: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type InputListCloudinaryFolders = {
  /** nextCursor from the previous page of the same folder. */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** The folder whose subfolders to list. Null or empty for the account's root. */
  path?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputListSharePointDrives = {
  accountType?: InputMaybe<IntegrationAccountType>;
  siteId: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputListSharePointFolderChildren = {
  accountType?: InputMaybe<IntegrationAccountType>;
  driveId: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputListSharePointSites = {
  accountType?: InputMaybe<IntegrationAccountType>;
  query: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for live feed variation settings. */
export type InputLiveFeedVariation = {
  /** The index of the feed row to display. */
  feedRowIndex?: InputMaybe<Scalars['Int']['input']>;
  /** The target ID for the feed variation. */
  targetId?: InputMaybe<Scalars['String']['input']>;
  /** The type of feed variation display. @BreakingBad */
  type?: InputMaybe<FeedVariationDisplay>;
};

export type InputLoadBrandControl = {
  teamId: Scalars['Int']['input'];
};

export type InputLoadNextgenAiCreatopyTemplates = {
  category?: InputMaybe<Scalars['Int']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  templateCategory: NextGenAiTemplateCategory;
};

export type InputLoadNextgenAiProjectTemplates = {
  currentBrandKitId?: InputMaybe<Scalars['Int']['input']>;
  folderId?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated not needed */
  hasImageLayer?: InputMaybe<Scalars['Boolean']['input']>;
  hasVideoLayer?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated not needed */
  height?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['Int']['input'];
  /** @deprecated not needed */
  setHash?: InputMaybe<Scalars['String']['input']>;
  templateCategory?: InputMaybe<NextGenAiTemplateCategory>;
  /** @deprecated not needed */
  templateSize?: InputMaybe<TemplateSize>;
  templateSizes?: InputMaybe<Array<InputMaybe<TemplateSize>>>;
  /** @deprecated not needed */
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type InputLoadNextgenAiTemplateSizes = {
  hash: Scalars['String']['input'];
};

export type InputLoadNextgenAiTemplates = {
  /** @deprecated not needed */
  height?: InputMaybe<Scalars['Int']['input']>;
  properties: InputLoadNextgenAiTemplatesProperties;
  setHash?: InputMaybe<Scalars['String']['input']>;
  templateCategory?: InputMaybe<NextGenAiTemplateCategory>;
  templateSize?: InputMaybe<TemplateSize>;
  /** @deprecated not needed */
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type InputLoadNextgenAiTemplatesForCategory = {
  category?: InputMaybe<NextGenAiTemplateCategory>;
};

export type InputLoadNextgenAiTemplatesProperties = {
  animated?: InputMaybe<Scalars['Boolean']['input']>;
  audioCount?: InputMaybe<Scalars['Int']['input']>;
  buttonCount?: InputMaybe<Scalars['Int']['input']>;
  imageCount?: InputMaybe<Scalars['Int']['input']>;
  shapeCount?: InputMaybe<Scalars['Int']['input']>;
  svgCount?: InputMaybe<Scalars['Int']['input']>;
  textCount?: InputMaybe<Scalars['Int']['input']>;
  videoCount?: InputMaybe<Scalars['Int']['input']>;
  whiteLogo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputMaintenance = {
  active: Scalars['Boolean']['input'];
  schedule: Scalars['Date']['input'];
  seconds: Scalars['Int']['input'];
};

export type InputManuallyEndAbTest = {
  id: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
  winnerId?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Input for marking a single design as a template.
 * Used to convert individual designs to templates.
 */
export type InputMarkDesignAsTemplate = {
  /** Identifiers of categories to associate with the template. */
  categoriesIdentifier: Array<Scalars['String']['input']>;
  /** ID of the design to convert to a template. */
  designId: Scalars['Int']['input'];
  /** Whether the template should be visible in the app. */
  showInApp: Scalars['Boolean']['input'];
  /** Whether the template should be visible in the gallery. */
  showInGallery: Scalars['Boolean']['input'];
  /** Tags to associate with the template. */
  tags: Array<Scalars['String']['input']>;
  /** Tracing context for monitoring. */
  traceContext?: InputMaybe<TraceContext>;
};

/**
 * Input for marking a design set as a template.
 * Used to convert design sets to templates.
 */
export type InputMarkDesignSetAsTemplate = {
  /** Identifiers of categories to associate with the template. */
  categoriesIdentifier: Array<Scalars['String']['input']>;
  /** ID of the design set to convert to a template. */
  setDesignId: Scalars['Int']['input'];
  /** Whether the template should be visible in the app. */
  showInApp: Scalars['Boolean']['input'];
  /** Whether the template should be visible in the gallery. */
  showInGallery: Scalars['Boolean']['input'];
  /** Tags to associate with the template. */
  tags: Array<Scalars['String']['input']>;
  /** Tracing context for monitoring. */
  traceContext?: InputMaybe<TraceContext>;
};

/** Input for marking a design as being edited. */
export type InputMarkEditDesign = {
  /** Whether the design is currently being edited. */
  editing: Scalars['Boolean']['input'];
  /** Hash of the design to mark. */
  hash: Scalars['String']['input'];
  /** The server time (Design.readAt) the editor first loaded this design at. Sent by an editor that steps aside for an edit from the user's AI assistant: an edit from it goes through this tab's lock, and the tab reloads after. Absent, nothing changes. */
  openedAt?: InputMaybe<Scalars['Float']['input']>;
};

export type InputMarkProductUpdate = {
  productUpdateId: Scalars['Int']['input'];
};

export type InputMarkTeamAssetsForDeletion = {
  deletionDate: Scalars['Date']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputMarkTeamUsageRecurlyBilled = {
  /** The impressions the manual invoice covered, stored on the row so the reporter counts them as billed. */
  amount: Scalars['Int']['input'];
  billedAt: Scalars['Date']['input'];
  invoiceReference: Scalars['String']['input'];
  note: Scalars['String']['input'];
  rowId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputMarkTutorial = {
  tutorialId: Scalars['Int']['input'];
};

export type InputMarkTutorialAsViewed = {
  tutorialId: Scalars['Int']['input'];
};

/** Input for marking Zapier feedback as shown. */
export type InputMarkZapierFeedbackAsShown = {
  /** Level of feedback shown. */
  level: FeedbackLevel;
  /** ID of the team to mark feedback for. */
  teamId: Scalars['Int']['input'];
};

export type InputMatcher = {
  url: Scalars['String']['input'];
};

export type InputMatchingColors = {
  assetUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  colors: Array<Scalars['String']['input']>;
  mediaHash?: InputMaybe<Scalars['String']['input']>;
  mediaUrl?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Input for retrieving media assets.
 * Supports filtering and pagination.
 */
export type InputMedia = {
  /** Cursor for pagination (optional). */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Format of media to filter by (optional). */
  format?: InputMaybe<MediaFormat>;
  /**
   * Hash of a specific media to retrieve (deprecated).
   * @deprecated Use medium query to get media by hash
   */
  hash?: InputMaybe<Scalars['String']['input']>;
  /** Last ID for pagination (optional). */
  lastId?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the media folder to filter by (optional). */
  mediaFolderId?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the project to filter by (optional). */
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** Search text to filter by (optional). */
  search?: InputMaybe<Scalars['String']['input']>;
  /** ID of the team whose media to retrieve. */
  teamId: Scalars['Int']['input'];
  /** Type of media to filter by (optional). */
  type?: InputMaybe<MediaType>;
};

export type InputMediaFocalRegion = {
  focalHeight: Scalars['Float']['input'];
  focalWidth: Scalars['Float']['input'];
  height: Scalars['Float']['input'];
  key: Scalars['String']['input'];
  transparent?: InputMaybe<Scalars['Boolean']['input']>;
  width: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type InputMediaFocalRegions = {
  /** Answer only from the cache — never call image-detections. Callers on a latency budget set this. */
  cachedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Media hashids, or absolute URLs for assets this environment does not own. */
  keys: Array<Scalars['String']['input']>;
  /**
   * Read and write this environment's media cache (default true). A caller whose keys
   * did not originate here — the design-sampler corpus, rebuilt from another
   * environment's templates — sets false: a foreign hash decodes to SOME local media
   * id (the codec is the same everywhere), so a cache read would serve an unrelated
   * local asset's saliency and a write would file this image's under it. With false,
   * every key is computed, and none touches the cache.
   */
  mediaCache?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for querying media information. */
export type InputMediaInfoQuery = {
  /** Hash of the media to get information for. */
  hash: Scalars['String']['input'];
};

/** Input for retrieving a single media asset by hash. */
export type InputMedium = {
  /** Hash of the media to retrieve. */
  hash: Scalars['String']['input'];
  /** ID of the team that owns the media. */
  teamId: Scalars['Int']['input'];
};

export type InputMetaCatalogs = {
  accountId: Scalars['String']['input'];
  businessId: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputMetaFeedSyncAuth = {
  hash: Scalars['String']['input'];
};

export type InputMetaSetImportFailure = {
  /** Short, already-truncated failure reason. Currently only META_SET_RUNAWAY_REASON or a Meta error message. */
  reason: Scalars['String']['input'];
  sourceProductSetId: Scalars['String']['input'];
};

/**
 * Per-set outcome of an on-demand Meta catalog rebuild. Only the feed-sync worker
 * knows which set contributed which rows, so the membership writeback rides along
 * with the payload writeback that published them: a set is "imported" exactly when
 * the run that read it also stored its rows.
 */
export type InputMetaSetImportResult = {
  /** Sets that failed to read without aborting the run. They stay pending; the next run retries. */
  failed: Array<InputMetaSetImportFailure>;
  /** Sets whose rows are in the payload this run just uploaded. */
  imported: Array<InputMetaSetImported>;
  /** sourceProductSetIds Meta reports as gone. The row is kept and marked, never deleted. */
  missing: Array<Scalars['String']['input']>;
};

export type InputMetaSetImported = {
  /**
   * The RETAILER IDS this set contributed, in payload order — NOT productKeys.
   * graphql converts them, because a productKey is derived from the FINAL stored
   * payload (post image-processing enrichment) which only graphql has read.
   */
  retailerIds: Array<Scalars['String']['input']>;
  sourceProductSetId: Scalars['String']['input'];
};

export type InputMigrate = {
  migrationId: Scalars['Int']['input'];
};

/** @deprecated Brand template migration service has been removed. @BreakingBad */
export type InputMigrateBrandTemplates = {
  teamId: Scalars['Int']['input'];
};

/** @deprecated Brand template migration service has been removed. @BreakingBad */
export type InputMigrateMultipleBrandTemplates = {
  teamIds: Array<Scalars['Int']['input']>;
};

export type InputMigrationAccounts = {
  email: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputMigrationInviteeMember = {
  email: Scalars['String']['input'];
  roleId: Scalars['Int']['input'];
};

export type InputMigrationStart = {
  invitees: Array<InputMigrationInviteeMember>;
  migrationId: Scalars['Int']['input'];
};

/** @deprecated Migration service has been removed */
export type InputMigrations = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  table: MigrationTable;
};

export type InputMoodboardContext = {
  cardHeight: Scalars['Int']['input'];
  cardIds: Array<Scalars['String']['input']>;
  hash: Scalars['String']['input'];
  isReplacementMode?: InputMaybe<Scalars['Boolean']['input']>;
  trigger?: InputMaybe<Scalars['String']['input']>;
};

export type InputMotionDrafts = {
  teamId: Scalars['Int']['input'];
};

export type InputMoveAbTest = {
  abTestId: Scalars['Int']['input'];
  copyTo?: InputMaybe<Scalars['Boolean']['input']>;
  projectId: Scalars['Int']['input'];
  targetFolderId?: InputMaybe<Scalars['Int']['input']>;
  targetProjectId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputMoveBrandTemplateDesignsAndFolders = {
  brandKitId: Scalars['Int']['input'];
  copyTo?: InputMaybe<Scalars['Boolean']['input']>;
  currentParentId?: InputMaybe<Scalars['Int']['input']>;
  designIds: Array<Scalars['Int']['input']>;
  folderIds: Array<Scalars['Int']['input']>;
  location?: InputMaybe<Scalars['JSON']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
  sourceBrandKitId?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
};

/** Input for moving cached design JSONs to permanent storage. */
export type InputMoveCacheJsons = {
  /** Maximum number of designs to process (defaults to 1000). */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for moving a design. */
export type InputMoveDesign = {
  /** When true, and only together with copyTo, the copy of a single design may be created as a design set holding one size. Server-gated, as on InputDuplicateDesign. */
  asSetIfSingle?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to copy instead of move. */
  copyTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the design to move. */
  designId: Scalars['Int']['input'];
  /** When copying, keep the design's exact name instead of deriving a 'copy (N)' name. */
  keepName?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the target folder to move to (optional). */
  targetFolderId?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the target project to move to (optional). */
  targetProjectId?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the target team to move to (optional). */
  targetTeamId?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for moving design-media-library folders. */
export type InputMoveDesignMediaFolders = {
  /** ID of the design that owns the folders. */
  designId: Scalars['Int']['input'];
  /** Destination folder; null/omitted moves the folders to the library root. */
  destinationFolderId?: InputMaybe<Scalars['Int']['input']>;
  /** IDs of the folders to move. */
  folderIds: Array<Scalars['Int']['input']>;
};

/** Input for moving library media into a folder. */
export type InputMoveDesignMediaToFolder = {
  /** ID of the design whose library media is moved. */
  designId: Scalars['Int']['input'];
  /** Destination folder; null/omitted moves the media to the library root. */
  folderId?: InputMaybe<Scalars['Int']['input']>;
  /** IDs of the media to move. */
  mediumIds: Array<Scalars['Int']['input']>;
};

export type InputMoveFolder = {
  copyTo?: InputMaybe<Scalars['Boolean']['input']>;
  folderId: Scalars['Int']['input'];
  targetFolderId?: InputMaybe<Scalars['Int']['input']>;
  targetProjectId?: InputMaybe<Scalars['Int']['input']>;
  targetTeamId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputMoveFolders = {
  brandKitId: Scalars['Int']['input'];
  destinationBrandKitId: Scalars['Int']['input'];
  destinationFolderId?: InputMaybe<Scalars['Int']['input']>;
  mediaFoldersIds: Array<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputMoveMediaFolders = {
  brandKitId: Scalars['Int']['input'];
  mediaFoldersIds: Array<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputMoveTeam = {
  destinationTeamId: Scalars['Int']['input'];
  sourceTeamId: Scalars['Int']['input'];
};

/** Input for moving media elements to a brand kit. */
export type InputMoveToBrandkitElements = {
  /** ID of the destination brand kit. */
  brandKitId: Scalars['Int']['input'];
  /** Format of media to filter by. */
  format?: InputMaybe<Scalars['String']['input']>;
  /** IDs of media elements to move. */
  mediaElementsIds: Array<Scalars['Int']['input']>;
  /** Whether to move all matching media. */
  moveAll?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search text to filter media to move. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** ID of the team that owns the media. */
  teamId?: InputMaybe<Scalars['Int']['input']>;
  /** Type of media to filter by. */
  type?: InputMaybe<Scalars['String']['input']>;
  /** ID of the user making the request. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** One user-authored scene card of a Manual multi-scene Omni generation. */
export type InputMultiSceneScene = {
  /** Scene length in whole seconds, 3-10. */
  durationSeconds: Scalars['Int']['input'];
  /** The scene's prompt — required, non-empty. */
  prompt: Scalars['String']['input'];
  /** Optional reference image URLs grounding this scene, at most 3 (a drafted card's generated still rides first). */
  referenceImages?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InputMultiSceneStoryboard = {
  /** The finished MULTISCENE parent operation to reopen. */
  operationId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputMultiSceneStoryboardDraftPoll = {
  draftOperationId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

/**
 * Input for creating a new design set.
 * This is the preferred way to create a design set in Creatopy.
 */
export type InputNewDesignSet = {
  /** Hash of a Bannersnack template to use as a base. */
  bannersnackTemplateHash?: InputMaybe<Scalars['String']['input']>;
  /** Source where the design set is being created. */
  creationSource?: InputMaybe<DesignCreationSource>;
  /** ID of the design size type for the design set. */
  designSizeTypeId: Scalars['Int']['input'];
  /** Whether to mark the design set for export with the next batch. */
  exportNext?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the folder to create the design set in (optional). */
  folderId?: InputMaybe<Scalars['Int']['input']>;
  /** Name for the design set (optional). */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of the project to create the design set in. */
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the team that will own the design set. */
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputNewOrderPinnedFolderList = {
  newOrder: Array<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputNextGenAi = {
  id: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputNextGenAiBrandedContent = {
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  generateSummary?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputNextGenRecommandedBrandKit = {
  teamId: Scalars['Int']['input'];
  url: Scalars['String']['input'];
};

export type InputNextGenRemoveBg = {
  url: Scalars['String']['input'];
};

export type InputOnboardingFeatures = {
  teamId: Scalars['Int']['input'];
};

/**
 * Input for optimizing an image.
 * Controls the optimization process for reducing image size.
 */
export type InputOptimizeImage = {
  /** Quality threshold for optimization (optional). */
  threshold?: InputMaybe<Scalars['Int']['input']>;
  /** URL or hash of the image to optimize. */
  urlOrHash: Scalars['String']['input'];
};

export type InputOrangeLogic = {
  orangeLogic: Scalars['Boolean']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputOrderTutorial = {
  switchedId: Scalars['Int']['input'];
  switchedOrder: Scalars['Int']['input'];
  targetId: Scalars['Int']['input'];
  targetOrder: Scalars['Int']['input'];
  tutorialCategoryId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputOrderTutorialCategory = {
  switchedId: Scalars['Int']['input'];
  switchedOrder: Scalars['Int']['input'];
  targetId: Scalars['Int']['input'];
  targetOrder: Scalars['Int']['input'];
};

export type InputOverrideProductField = {
  /** Column name (or a reserved key like '__image' later) */
  field: Scalars['String']['input'];
  hash: Scalars['String']['input'];
  productKey: Scalars['String']['input'];
  /** FeedCellValue-shaped replacement for the cell */
  value: Scalars['JSON']['input'];
};

/**
 * One entry in the per-import font replacement map. `originalFontName` is
 * the raw PSD font name (e.g. "Gotham-Bold"). The remaining fields are a
 * concrete font selection compatible with the worker's getFont output.
 */
export type InputPsdFontReplacement = {
  fontFaceUrl?: InputMaybe<Scalars['String']['input']>;
  fontFamily: Scalars['String']['input'];
  fontStyle: Scalars['String']['input'];
  fontType: Scalars['String']['input'];
  fontUrl?: InputMaybe<Scalars['String']['input']>;
  fontWeight: Scalars['Int']['input'];
  originalFontName: Scalars['String']['input'];
};

export type InputPaginationOptions = {
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderType>;
};

export type InputParseTemplate = {
  animated: Scalars['Boolean']['input'];
  category: NextGenAiTemplateCategory;
  designSizeTypeName?: InputMaybe<Scalars['String']['input']>;
  hash: Scalars['String']['input'];
  setHash: Scalars['String']['input'];
  setName: Scalars['String']['input'];
};

export type InputParseTemplates = {
  category: NextGenAiTemplateCategory;
  folderSharedHash: Scalars['String']['input'];
};

/** Input for checking pause eligibility */
export type InputPauseEligibility = {
  teamId: Scalars['Int']['input'];
};

/** Input for pausing a subscription */
export type InputPauseSubscription = {
  /** Number of billing cycles to pause (1-3 for monthly, 1 for yearly) */
  pauseCycles: Scalars['Int']['input'];
  /** Optional reason for pausing */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Optional reason category */
  reasonCategory?: InputMaybe<CancellationReasonCategory>;
  subscriptionId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputPermanentDesign = {
  designId: Scalars['Int']['input'];
};

export type InputPersistCraftedDesign = {
  batchId: Scalars['Int']['input'];
  brandKitId: Scalars['Int']['input'];
  jsonDesign: Scalars['JSON']['input'];
  name: Scalars['String']['input'];
  slot: Scalars['String']['input'];
  visionScore?: InputMaybe<Scalars['JSON']['input']>;
};

/**
 * Input for `persistFlexDesignTree` — CACHE-ON-APPLY: promote the design's
 * server-cached preview skeleton (the one that produced the applied previews)
 * into the long-lived applied tier, so future previews of the unchanged design
 * reuse the accepted layout instead of a live model call. Call it
 * fire-and-forget after a successful flex apply.
 */
export type InputPersistFlexDesignTree = {
  /** Hash of the design set the source belongs to, or of a standalone design (then `mainSizeHash` must equal it). */
  hash: Scalars['String']['input'];
  /** Hash of the main size design inside the set, or `hash` itself for a standalone design (the applied source banner). */
  mainSizeHash?: InputMaybe<Scalars['String']['input']>;
  /** Slide that was resized (bannersetElementId), for multi-slide sources. */
  slideId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputPersonalIntegration = {
  userId: Scalars['Int']['input'];
};

/** Input for retrieving a user's personal project. */
export type InputPersonalProject = {
  /** ID of the team to get personal project from. */
  teamId: Scalars['Int']['input'];
};

export type InputPhotoshopFile = {
  action: PhotoshopAction;
  key: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputPhotoshopStatus = {
  key: Scalars['String']['input'];
};

export type InputPhotoshopStructure = {
  action: PhotoshopAction;
  artboardsImportMode?: InputMaybe<ArtboardsImportMode>;
  brandKitFolderId?: InputMaybe<Scalars['Int']['input']>;
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  createBrandKitFolder?: InputMaybe<Scalars['Boolean']['input']>;
  fileName: Scalars['String']['input'];
  folderId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Per-import font substitutions chosen by the user in the missing-font
   * replacement dialog. Keys are PSD font names that the worker would
   * otherwise have failed to match against the brandkit/Google Fonts;
   * the worker uses these in place of its own fallback during phase 2.
   * Empty / missing means no substitutions and the worker falls back as
   * before (Open Sans default).
   */
  fontReplacements?: InputMaybe<Array<InputPsdFontReplacement>>;
  /** @deprecated Not used anymore */
  groupLayers?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * CRE-454: when true, imported image layers are uploaded without a Brand-Kit
   * / project association (no `project_media` row), so they do not populate
   * the team's asset library. Designs still render — elements resolve images
   * by S3 path. Only honored when the `psd_import_skip_asset_library` Statsig
   * gate is ON for the team (the worker re-checks; API callers can't bypass).
   *
   * Sent by every import flow — dashboard create imports and the in-editor
   * ones (Brand-Kit panel, Insert panel, canvas drag&drop, Bynder/Frontify/Cloudinary);
   * both phase-2 actions (`designs` and `jsons`) honor it.
   *
   * Rollout constraint: clients only send this field when the gate is ON, and
   * an environment whose graphql predates it rejects the whole mutation
   * (`BAD_USER_INPUT`), failing the import outright. Never enable the gate in
   * an environment before this schema is deployed there.
   */
  skipAssetLibrary?: InputMaybe<Scalars['Boolean']['input']>;
  structure: Array<InputMaybe<Scalars['JSON']['input']>>;
  teamId: Scalars['Int']['input'];
};

export type InputPinnedFolder = {
  folderId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

export type InputPinnedFolders = {
  projectId?: InputMaybe<Scalars['Int']['input']>;
  sharedWithMe: Scalars['Boolean']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputPinterestRotatedToken = {
  /** Compare-and-set guard: the refresh token the write expects to be CURRENT in the DB */
  expectedCurrentRefreshToken: Scalars['String']['input'];
  /** CloudIntegration row id whose refresh token rotated */
  integrationId: Scalars['Int']['input'];
  /** The newly issued refresh token to persist */
  refreshToken: Scalars['String']['input'];
  /** New refresh-token expiry (seconds), persisted for the re-auth UX */
  refreshTokenExpiresIn?: InputMaybe<Scalars['Int']['input']>;
  /** Team that owns the integration */
  teamId: Scalars['Int']['input'];
};

/** Input for planning the start-from-assets entry into Ad Studio. */
export type InputPlanAdEntry = {
  /** How many images the user picked (0–10; the Home chat may send a prompt alone). */
  imageCount: Scalars['Int']['input'];
  /** The Home chat: an ad by default, but any other ask (an image, a video, copy, a question) is kept as asked. Omitted or false: ad-only, as the picker plans. */
  openEnded?: InputMaybe<Scalars['Boolean']['input']>;
  /** What the user typed on the picker screen. */
  prompt: Scalars['String']['input'];
};

export type InputPlanFeatures = {
  base?: InputMaybe<Scalars['String']['input']>;
  bold?: InputMaybe<Array<Scalars['String']['input']>>;
  color: Scalars['String']['input'];
  dotted?: InputMaybe<Array<Scalars['String']['input']>>;
  iconColor: Scalars['String']['input'];
  now: Array<Scalars['String']['input']>;
  soon: Array<Scalars['String']['input']>;
};

export type InputPlanProperties = {
  /** Label for the call to action button – translation key */
  actionLabel: Scalars['String']['input'];
  actionType: PlanActionType;
  available: Scalars['Boolean']['input'];
  bgColor: Scalars['String']['input'];
  /** Custom billing label – translation key */
  billingLabel?: InputMaybe<Scalars['String']['input']>;
  borderColor?: InputMaybe<Scalars['String']['input']>;
  boxBorderColor?: InputMaybe<Scalars['String']['input']>;
  buttonBackground?: InputMaybe<Scalars['String']['input']>;
  buttonBorder?: InputMaybe<Scalars['String']['input']>;
  buttonColor?: InputMaybe<Scalars['String']['input']>;
  buttonType: Scalars['String']['input'];
  color: Scalars['String']['input'];
  /** Plan description – translation key */
  description: Scalars['String']['input'];
  descriptionColor: Scalars['String']['input'];
  /** Plan subtitle – translation key */
  subTitle: Scalars['String']['input'];
  titleColor?: InputMaybe<Scalars['String']['input']>;
  titleGradient?: InputMaybe<Scalars['String']['input']>;
  upgradeBoxBgColor?: InputMaybe<Scalars['String']['input']>;
  upgradeBoxTitleColor?: InputMaybe<Scalars['String']['input']>;
  upgradeCardBackground?: InputMaybe<Scalars['String']['input']>;
  upgradeCardIllustration?: InputMaybe<Scalars['String']['input']>;
  upgradeCardSubTitle?: InputMaybe<Scalars['String']['input']>;
  upgradeCardTitle?: InputMaybe<Scalars['String']['input']>;
  upgradeCardTitleColor?: InputMaybe<Scalars['String']['input']>;
};

export type InputPlans = {
  getAllPlans?: InputMaybe<Scalars['Boolean']['input']>;
  isExperiment?: InputMaybe<Scalars['Boolean']['input']>;
  isMigrate?: InputMaybe<Scalars['Boolean']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputPlansInternal = {
  fromSite?: InputMaybe<Scalars['Boolean']['input']>;
  inPriceExperiment?: Scalars['Boolean']['input'];
};

/** Input for populating a brand kit from a website URL. */
export type InputPopulateBrandKitFromUrl = {
  /** Existing brand kit ID to populate (optional — creates a new one if omitted). */
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the team that owns (or will own) the brand kit. */
  teamId: Scalars['Int']['input'];
  /** Website URL to extract brand assets from. */
  url: Scalars['String']['input'];
};

/** One answer to the journey feedback prompt (welcome back / exit intent). */
export type InputPostJourneyFeedback = {
  answerText: Scalars['String']['input'];
  /** Chip picked instead of, or with, a typed answer. */
  chip?: InputMaybe<Scalars['String']['input']>;
  /** Hash of the design the user last worked on. */
  designHash?: InputMaybe<Scalars['String']['input']>;
  /** Download formats and meta_publish used from this browser. */
  exportFormats: Array<Scalars['String']['input']>;
  /** Furthest editor step reached: editor_opened, first_edit or previewed. */
  funnelStage: Scalars['String']['input'];
  hasAnimation?: InputMaybe<Scalars['Boolean']['input']>;
  hasVideoLayers?: InputMaybe<Scalars['Boolean']['input']>;
  signupAgeDays?: InputMaybe<Scalars['Int']['input']>;
  /** Sizes of that design as WxH. */
  sizes: Array<Scalars['String']['input']>;
  /** welcome_back or exit_intent. */
  surface: Scalars['String']['input'];
  /** Team whose editor the answer was given in. */
  teamId: Scalars['Int']['input'];
  /** The optional wish answer. */
  wishText?: InputMaybe<Scalars['String']['input']>;
};

export type InputPremiumAssetsUsage = {
  teamId: Scalars['Int']['input'];
};

export type InputPreviewCheckout = {
  /** The number of additional usage units (200 AI credits each at $50/mo) - Ultra plans only */
  additionalUsage?: InputMaybe<Scalars['Int']['input']>;
  /** Billing address for tax calculation preview */
  address?: InputMaybe<InputAddress>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  /** The number of credits used as AddOn */
  credits?: InputMaybe<Scalars['Int']['input']>;
  /** The number of impressions used as AddOn */
  impressions?: InputMaybe<Scalars['Int']['input']>;
  planCode: Scalars['String']['input'];
  /** The number of recurring credits used as AddOn */
  recurringCredits?: InputMaybe<Scalars['Int']['input']>;
  /** use only for new invitee */
  seats?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
  /** When to apply the change: 'now' (immediate), 'bill_date' (next billing cycle), or 'term_end' (end of term) */
  timeframe?: InputMaybe<Scalars['String']['input']>;
};

export type InputPreviewSubscriptionChange = {
  couponCode?: InputMaybe<Scalars['String']['input']>;
  /** The number of credits used as AddOn */
  credits?: InputMaybe<Scalars['Int']['input']>;
  /** The number of impressions used as AddOn */
  impressions?: InputMaybe<Scalars['Int']['input']>;
  /** @BreakingBad - deprecated, migration feature removed */
  migrationId?: InputMaybe<Scalars['Int']['input']>;
  planCode: Scalars['String']['input'];
  /** The number of recurring credits used as AddOn */
  recurringCredits?: InputMaybe<Scalars['Int']['input']>;
  /** use only for new invitee */
  seats?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputPreviewTopUpCredits = {
  couponCode?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
  topUpCredits: Scalars['Int']['input'];
};

export type InputPricingAbTest = {
  teamId: Scalars['Int']['input'];
};

export type InputProcessAfterJoin = {
  /** Hash identifier for the after join data that needs to be processed. */
  afterJoinHash: Scalars['String']['input'];
};

export type InputProcessFigFile = {
  key: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputProcessMoodBoardContent = {
  content: Scalars['JSON']['input'];
  hash: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Keep the board's updatedAt: the save only applies a media migration's link rewrite, not a user's edit. */
  preserveUpdatedAt?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputProductPhotography = {
  adFormat?: InputMaybe<InputAdFormat>;
  adTextContent?: InputMaybe<InputAdTextContent>;
  /** Further real products to keep, like baseImageUrl and fetched the same fail-hard way, after it (Copilot multi-product ads, AIA-82). Requires baseImageUrl; not supported on the brand-kit ad flow. */
  additionalBaseImageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  aspectRatio: ImageGenerationAspectRatio;
  baseImageUrl?: InputMaybe<Scalars['String']['input']>;
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  /** The Copilot chat thread this generation was started from. Recorded on the ai_studio_generation row (with generationSource AI_STUDIO) so the Copilot lists only its own chat's generations. Verified before any credit is held: a thread that is not this user's Copilot chat on this design is not recorded. */
  chatThreadId?: InputMaybe<Scalars['String']['input']>;
  /** What the Copilot client knew when it started this generation ({ toolCallId, announced, client }), stored on the ai_studio_generation row so any browser can pick the generation up. Requires generationSource AI_STUDIO. Capped at 32 KB. */
  copilotKickoff?: InputMaybe<Scalars['JSON']['input']>;
  createMedia?: InputMaybe<Scalars['Boolean']['input']>;
  creditOperationName?: InputMaybe<Scalars['String']['input']>;
  /** Design hash of the Ad Studio design where generation was triggered */
  designHash?: InputMaybe<Scalars['String']['input']>;
  /** Custom-feed auto-fill context. When present, the generated image URL is written back into the feed cell on completion (server-side, so it works even if the user has closed the app). */
  feedRowContext?: InputMaybe<InputFeedRowContext>;
  /** When AI_STUDIO, the request is recorded as an ai_studio_generation row grouping its variant operations */
  generationSource?: InputMaybe<GenerationSource>;
  /** Exact src URL of the logo to render: a brand-kit logo, or an image the user supplied in chat. Ignored when it is neither, in which case the brand-kit fallback applies. */
  logoSrc?: InputMaybe<Scalars['String']['input']>;
  moodboardContext?: InputMaybe<InputMoodboardContext>;
  /** Render the ad without a logo. Without it, a request that names no logo still gets a brand-kit logo picked by the server, which cannot see the vision pass's usability verdict. An explicit usable logoSrc still wins. */
  omitLogo?: InputMaybe<Scalars['Boolean']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  prompt: Scalars['String']['input'];
  provider: AiProvider;
  quality?: InputMaybe<ImageGenerationQuality>;
  referenceImageOption?: InputMaybe<ProductPhotographyOption>;
  referenceImageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  resolution?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
  /** AI Studio composer toggle: ground the generation in the design's ad context (requires designHash) */
  useDesignContext?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  variants?: InputMaybe<Scalars['Int']['input']>;
};

export type InputProductSetRule = {
  /** Price rules only: ISO currency of the amount */
  currency?: InputMaybe<Scalars['String']['input']>;
  field: Scalars['String']['input'];
  op: ProductSetRuleOp;
  value: Scalars['String']['input'];
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InputProductSets = {
  hash: Scalars['String']['input'];
};

export type InputProductUpdate = {
  /** @deprecated This field is no longer used */
  adStudioEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The team the viewer is in. It selects which targeted updates they see; without it only untargeted updates are
   * returned.
   */
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputProductUpdateAudience = {
  planGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  planVersions?: InputMaybe<Array<Scalars['Int']['input']>>;
  statsigExperiment?: InputMaybe<InputProductUpdateAudienceExperiment>;
  statsigGate?: InputMaybe<Scalars['String']['input']>;
};

export type InputProductUpdateAudienceExperiment = {
  group: Scalars['String']['input'];
  key: Scalars['String']['input'];
};

/** Input for retrieving a specific project. */
export type InputProject = {
  /** ID of the project to retrieve. */
  id: Scalars['Int']['input'];
  /** ID of the team that owns the project. */
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputProjectDesignTemplates = {
  designSizeTypeId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['Int']['input'];
};

/** Input for retrieving designs in a project. */
export type InputProjectDesigns = {
  /** ID of the project to get designs from. */
  projectId: Scalars['Int']['input'];
  /** ID of the team that owns the project. */
  teamId: Scalars['Int']['input'];
};

/** Input for retrieving fonts assigned to a project. */
export type InputProjectFonts = {
  /** ID of the project to get fonts for. */
  projectId: Scalars['Int']['input'];
  /** ID of the user making the request. */
  userId: Scalars['Int']['input'];
};

/** Input for updating a project's properties. */
export type InputProjectUpdate = {
  /** Whether designs in this project can be shared (optional). */
  allowSharing?: InputMaybe<Scalars['Boolean']['input']>;
  /** New description for the project (optional). */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID of the project to update. */
  id: Scalars['Int']['input'];
  /** Whether users can select a brand kit for this project (optional). */
  isBrandKitSelectable?: InputMaybe<Scalars['Boolean']['input']>;
  /** New logo URL for the project (optional). */
  logo?: InputMaybe<Scalars['String']['input']>;
  /** Maximum design size in MB allowed for this project (optional). */
  maxDesignSize?: InputMaybe<Scalars['Float']['input']>;
  /** New name for the project (optional). */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of the brand kit to associate with the project (optional). */
  selectedBrandKitId?: InputMaybe<Scalars['Int']['input']>;
  /** Whether all team members have access to this project (optional). */
  teamAccess?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether project calculations include unarchived designs (optional). */
  unarchivedEstimation?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for retrieving projects with pagination. */
export type InputProjects = {
  /** Pagination cursor. */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Pagination options. */
  options?: InputMaybe<InputPaginationOptions>;
  /** Optional search query to filter projects by name. */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  /** ID of the team whose projects to retrieve. */
  teamId: Scalars['Int']['input'];
};

/** Input for retrieving project shortcuts. */
export type InputProjectsShortcuts = {
  /** ID of the team whose project shortcuts to retrieve. */
  teamId: Scalars['Int']['input'];
};

export type InputPromoteCopilotBrandExtraction = {
  /** Also make the new kit this design's brand kit. */
  assignToDesign?: InputMaybe<Scalars['Boolean']['input']>;
  designHash: Scalars['String']['input'];
  extractionId: Scalars['Int']['input'];
};

export type InputPromotionalPlan = {
  planCode: Scalars['String']['input'];
};

export type InputPropagateSizesToVariations = {
  /** Sizes to propagate - the ones just added to the master. */
  designSizeTypeIds: Array<Scalars['Int']['input']>;
  /**
   * The master child the resize used as its content main. Each variation
   * prefers its own child at the SAME size type as its content source.
   */
  masterMainHash?: InputMaybe<Scalars['String']['input']>;
  /** The MASTER design set hash (the open set). */
  masterSetHash: Scalars['String']['input'];
  /** Slide key (`bannersetElementId`) the master resize ran on - forwarded to the per-variation merge. */
  slideId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * When set, propagate ONLY to these variations (top-level variation hashes).
   * The client fans the family out as one request per variation, so each
   * request stays small (bounded wall-clock, incremental grid updates) instead
   * of one long whole-family call. Absent = every variation of the master.
   */
  variationSetHashes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input for retrieving a public design. */
export type InputPublicDesign = {
  /** Public hash of the design to retrieve. */
  publicHash: Scalars['String']['input'];
};

/** Input for retrieving public designs. */
export type InputPublicDesigns = {
  /** Design cursor to start from */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Folder public link hash */
  folderHash?: InputMaybe<Scalars['String']['input']>;
  /** Field to order designs by (defaults to DATE_MODIFIED) */
  orderBy?: OrderBy;
  /** Order direction (defaults to DESC) */
  orderType?: OrderType;
};

export type InputPublicFeed = {
  designHash: Scalars['String']['input'];
  /** Target-column value this current-row-only share is pinned to */
  feedRow?: InputMaybe<Scalars['String']['input']>;
};

export type InputPublicFolders = {
  folderHash?: InputMaybe<Scalars['String']['input']>;
  orderBy?: OrderBy;
  orderType?: OrderType;
  rootFolderHash?: InputMaybe<Scalars['String']['input']>;
};

export type InputPublicResource = {
  designHash?: InputMaybe<Scalars['String']['input']>;
  folderHash?: InputMaybe<Scalars['String']['input']>;
};

/** Input for retrieving public team details. */
export type InputPublicTeamDetails = {
  /** ID of the team to get details for. */
  teamId: Scalars['Int']['input'];
};

/** One target canvas for a public-template resize. */
export type InputPublicTemplateTarget = {
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

export type InputPublishFeedPayload = {
  /** md5 of the uploaded FeedJson, from getFeedChecksum. */
  checksum: Scalars['String']['input'];
  /** Feed hash whose payload was just uploaded. */
  hash: Scalars['String']['input'];
};

export type InputPublishFontsJson = {
  addedFonts: Array<InputAddedGoogleFont>;
  removeFonts?: InputMaybe<Array<InputAddedGoogleFont>>;
  usedFonts: Array<InputUsedGoogleFont>;
};

export type InputPublishProductUpdate = {
  id: Scalars['Int']['input'];
};

export type InputPublishTutorial = {
  id: Scalars['Int']['input'];
  tutorialCategoryId: Scalars['Int']['input'];
};

export type InputPurchaseTopUpCredits = {
  couponCode?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
  topUpCredits: Scalars['Int']['input'];
};

export type InputPurgeNextTrashedDesigns = {
  /** How many designs to check, at most 500; 500 when left out. */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type InputPurgeTrashedDesigns = {
  /** At most 500 designs. */
  designIds: Array<Scalars['Int']['input']>;
  /**
   * Only designs trashed before this moment are deleted, and it must be at least 6
   * months ago: designs trashed since then are kept. A design not in Trash never is.
   */
  trashedBefore: Scalars['Date']['input'];
};

/** Input for pushing the edited master size's changes to its sibling sizes. */
export type InputPushMasterSizeChanges = {
  /** v2: apply structural changes (layer add/remove/move/reorder) too. Absent/false = v1 property-only push (old clients). */
  applyStructural?: InputMaybe<Scalars['Boolean']['input']>;
  /** Abort with MASTER_CHANGED when the source size's current checksum differs from what the client previewed. */
  expectedSourceChecksum: Scalars['String']['input'];
  /** Pre-existing elements whose RESIZE on the source is held back: what a resize writes besides the box (scale, paddings, a button's label font size, border weight, a line's lineData and drawing) is not pushed, so every target keeps the element's own size. Every other change of those elements still lands. Absent/empty = the full push. */
  holdBackResizedEls?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Hash of the master design (set or standalone). */
  masterHash: Scalars['String']['input'];
  /** Customised targets the user explicitly opted in for overwrite: their recorded cross-size customisations are NOT withheld from this push, and the overrides the push overwrites are pruned. Any other customised target receives the push with its customised properties kept. */
  overwriteCustomisedSizeTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Final per-target geometry from the positioning canvas: every added layer (user-adjusted or echoed defaults) plus every pre-existing element the user re-arranged there. Added elements without an entry land at the engine's proportional default placement; pre-existing elements without an entry keep whatever the push leaves them at. */
  placements?: InputMaybe<Array<InputCrossSizeAddedPlacement>>;
  /** The size whose baseline-relative changes are pushed. */
  sourceDesignSizeTypeId: Scalars['Int']['input'];
  targetDesignSizeTypeIds: Array<Scalars['Int']['input']>;
};

/** Rank a PASTED candidate design against a SAVED reference size — the reference is resolved server-side by hash, the candidate is supplied as JSON. The dedicated endpoint for the editor's 'paste resized JSON, compare to a saved size' flow, which mixes a hash reference with a JSON candidate. */
export type InputRankAgainstSaved = {
  /** The pasted candidate design JSON (bare or wrapped { banner }). */
  candidateJson: Scalars['String']['input'];
  /** Optional generator label for watchdog training capture. Ignored by the admin overload. */
  candidateSource?: InputMaybe<ResizeCandidateSource>;
  /** Which tiers to run; null = all. Render happens only when html or image is requested; the judge only when image is requested. */
  evaluations?: InputMaybe<InputRankEvaluations>;
  /** Allowlisted vision-judge model id; ignored unless the image tier runs. */
  model?: InputMaybe<Scalars['String']['input']>;
  /** A saved reference size hash; the server fetches its JSON. */
  referenceHash: Scalars['String']['input'];
};

/** Overload 2 — rank designs supplied as data; each tier runs iff its data is present on the candidate. */
export type InputRankByData = {
  candidate: InputRankDesignData;
  /** Allowlisted vision-judge model id; used only when the candidate carries an image. */
  model?: InputMaybe<Scalars['String']['input']>;
  reference: InputRankDesignData;
};

/** Overload 1 — rank two SAVED sizes by hash; the server fetches, renders, and judges as the evaluations require. */
export type InputRankBySavedDesign = {
  candidateHash: Scalars['String']['input'];
  /** Which tiers to run; null = all. The server only renders when html or image is requested, and only calls the vision judge when image is requested. */
  evaluations?: InputMaybe<InputRankEvaluations>;
  /** Allowlisted vision-judge model id; ignored unless the image tier runs. */
  model?: InputMaybe<Scalars['String']['input']>;
  referenceHash: Scalars['String']['input'];
};

/** A design supplied as data. json is required; renderedBoxes/image are optional and let a caller skip the server render to drive the html/image tiers directly. */
export type InputRankDesignData = {
  /** Optional base64-encoded PNG; presence enables the image tier without a server render. */
  image?: InputMaybe<Scalars['String']['input']>;
  /** Bare JsonDesign (its { properties, elements }) as a JSON string. */
  json: Scalars['String']['input'];
  /** Optional per-element rendered boxes; presence enables the html tier without a server render. */
  renderedBoxes?: InputMaybe<Array<InputRenderedBox>>;
};

/** Which evaluation tiers to run. Any omitted/null field defaults to true (run it). */
export type InputRankEvaluations = {
  html?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<Scalars['Boolean']['input']>;
  json?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputReactivateSubscription = {
  subscriptionId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputReadThread = {
  threadId: Scalars['Int']['input'];
};

export type InputRecentCreativesAndMoodboards = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** "user" = current user only (default), "team" = all project members */
  scope?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputRecentDesigns = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputRecentFolder = {
  folderId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

export type InputRecentFolders = {
  projectId?: InputMaybe<Scalars['Int']['input']>;
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputRecomposeCanvas = {
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

export type InputRecomposeText = {
  color?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};

export type InputRecordAiStudioGenerationOutcome = {
  cutoutDemoted?: InputMaybe<Scalars['Boolean']['input']>;
  /** The client's own facts about the outcome that the fields above do not hold. Replaced with every write, so send the current ones each time. Capped at 4 KB. */
  details?: InputMaybe<Scalars['JSON']['input']>;
  kind: AiStudioGenerationOutcomeKind;
  /** Any operation of the generation (the client knows its op ids, not the generation id). */
  operationId: Scalars['Int']['input'];
  status: AiStudioGenerationOutcomeStatus;
  targetDesignBackground?: InputMaybe<Scalars['Boolean']['input']>;
  targetLayerId?: InputMaybe<Scalars['Int']['input']>;
  targetLayerName?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputRecordCraftedBatchFailure = {
  batchId: Scalars['Int']['input'];
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InputRecordCustomDesignSetUse = {
  /** The custom set the user applied from the sizes panel. */
  id: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputRecordDesignScorerShadow = {
  agreement: DesignScorerAgreement;
  /** The function that called score(), such as ai-generation.verifyPass. */
  caller: Scalars['String']['input'];
  designHash?: InputMaybe<Scalars['String']['input']>;
  designId?: InputMaybe<Scalars['Int']['input']>;
  height: Scalars['Float']['input'];
  kitFingerprint?: InputMaybe<Scalars['String']['input']>;
  kitId?: InputMaybe<Scalars['Int']['input']>;
  /** scorer.score()'s result, whole. */
  newResult: Scalars['JSON']['input'];
  /** The caller's own result as it stands today. */
  oldResult?: InputMaybe<Scalars['JSON']['input']>;
  /** The image render is read against: a layered verify pass's plate alone. With render, at most 6 MB decoded. */
  originalRender?: InputMaybe<InputDesignScorerRender>;
  render?: InputMaybe<InputDesignScorerRender>;
  /** Links the calls of one job. */
  runId?: InputMaybe<Scalars['String']['input']>;
  slideId?: InputMaybe<Scalars['String']['input']>;
  /** What was scored: { design, original?, measurements? }. */
  snapshot?: InputMaybe<Scalars['JSON']['input']>;
  /** The scorer surface, such as aiAgent.layered. */
  surface: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['Int']['input']>;
  width: Scalars['Float']['input'];
};

/** The design whose share link the user copied. */
export type InputRecordDesignShareLinkCopied = {
  designId: Scalars['Int']['input'];
};

export type InputRecordPhishingUrlVerdict = {
  flagId: Scalars['Int']['input'];
  resolvedUrl?: InputMaybe<Scalars['String']['input']>;
  webRiskChecked: Scalars['Boolean']['input'];
  webRiskRaw?: InputMaybe<Scalars['JSON']['input']>;
  webRiskThreatTypes: Array<Scalars['String']['input']>;
};

export type InputRegenerateMultiSceneScenes = {
  /** The Copilot chat thread that asked for this scene edit. Verified before any credit is held: a thread that is not this user's Copilot chat on this design is not recorded. */
  chatThreadId?: InputMaybe<Scalars['String']['input']>;
  /** What the Copilot client knew when it started this edit ({ toolCallId, announced, client }), stored on the ai_studio_generation row so any browser can pick it up. Capped at 32 KB. */
  copilotKickoff?: InputMaybe<Scalars['JSON']['input']>;
  /** Design whose AI Studio results feed records the regen (the new card appears there). */
  designHash?: InputMaybe<Scalars['String']['input']>;
  /** 1-based indices of scenes to regenerate EVEN IF unchanged — the re-roll gesture: identical cards are reused for free by default, so a fresh take on an untouched scene has to be asked for. Forced scenes are generated and billed like any edited one. */
  forceRegenerateIndices?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** The finished MULTISCENE parent operation the edit is based on. */
  operationId: Scalars['Int']['input'];
  /** The FULL edited card list, 1-10 scenes — the count may differ from the original chain (added scenes always regenerate; removed scenes are simply absent from the result). The server diffs in-range cards against the persisted ones to compute the regen set itself. */
  scenes: Array<InputMultiSceneScene>;
  teamId: Scalars['Int']['input'];
};

export type InputRegenerateToken = {
  refreshToken: Scalars['String']['input'];
};

export type InputReindexDesignFeedAdjustments = {
  hash: Scalars['String']['input'];
};

/** Input for rejecting a team invitation. */
export type InputRejectTeamInvitation = {
  /** Hash identifier of the invitation. */
  hash: Scalars['String']['input'];
};

export type InputRemoveAdminUser = {
  id: Scalars['Int']['input'];
};

/** Remove a result tile from the AI Studio feed (soft delete — the asset itself survives in the library/brand kit). */
export type InputRemoveAiStudioResult = {
  /** The operation whose result to remove; all its media links are marked deleted. */
  operationId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

/** Input for removing animation from a design. */
export type InputRemoveAnimationFromDesign = {
  /** Hash of the design. */
  hash: Scalars['String']['input'];
  /** JSON of the design. */
  json: InputJsonDesignWithHash;
};

export type InputRemoveBg = {
  app?: InputMaybe<Scalars['String']['input']>;
  creditOperationName?: InputMaybe<Scalars['String']['input']>;
  folderId?: InputMaybe<Scalars['Int']['input']>;
  imgSource?: InputMaybe<Scalars['String']['input']>;
  size: RemoveBgSize;
  teamId: Scalars['Int']['input'];
  url: Scalars['String']['input'];
};

export type InputRemoveBgOnBoundedImage = {
  feedId: Scalars['Int']['input'];
  imagesFromFeedWithBgRemoved: Array<ImagesFromFeedWithBgRemoved>;
  rowIndex: Scalars['Int']['input'];
};

export type InputRemoveBillingInfo = {
  teamId: Scalars['Int']['input'];
};

/** Input for removing a single reference image from a brand kit's style analysis. */
export type InputRemoveBrandStyleSourceImage = {
  /** ID of the brand kit to update. */
  brandKitId: Scalars['Int']['input'];
  /** URL of the image to remove. */
  url: Scalars['String']['input'];
};

export type InputRemoveBrandedResource = {
  teamId: Scalars['Int']['input'];
  type: ResourceType;
};

export type InputRemoveColorFromPalette = {
  brandKitId: Scalars['Int']['input'];
  color: Scalars['String']['input'];
  id: Scalars['Int']['input'];
};

export type InputRemoveCommentAttachment = {
  commentId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};

export type InputRemoveCustomSize = {
  id: Scalars['Int']['input'];
};

/** Input for removing an external tracking URL from a design. */
export type InputRemoveDesignExternalTracking = {
  /** The ID of the design. */
  designId: Scalars['Int']['input'];
  /** The ID of the external tracking URL to remove. */
  id: Scalars['Int']['input'];
};

/**
 * Input for removing a design from a design set.
 * Use this to reduce a design set by removing specific sizes.
 */
export type InputRemoveDesignFromSet = {
  /** Hash of the design to remove from its set. */
  hash: Scalars['String']['input'];
};

/** Input for removing media from a design's media library. */
export type InputRemoveDesignMediaFromLibrary = {
  /** ID of the design whose library the media is removed from. */
  designId: Scalars['Int']['input'];
  /** IDs of the media assets to remove from the design's library. */
  mediumIds: Array<Scalars['Int']['input']>;
};

/** Input for removing a reviewer from a design. */
export type InputRemoveDesignReviewer = {
  /** The design hash. */
  designHash: Scalars['String']['input'];
  /** The design reviewer record ID to remove. */
  reviewerId: Scalars['Int']['input'];
};

export type InputRemoveDesignSizeType = {
  id: Scalars['Int']['input'];
};

export type InputRemoveDesignSizes = {
  hash: Scalars['String']['input'];
  /** The user agreed to remove sizes from a design whose brand template keeps its sizes: see InputEditDesign. */
  lockedChangesAgreed?: InputMaybe<Scalars['Boolean']['input']>;
  sizeHashes: Array<Scalars['String']['input']>;
};

/** Input for removing a dynamic variable from a design. */
export type InputRemoveDynamicVar = {
  /** The ID of the design. */
  designId: Scalars['Int']['input'];
  /** The ID of the dynamic variable to remove. */
  id: Scalars['Int']['input'];
};

/** Input for removing a member from a team. */
export type InputRemoveMember = {
  /** ID of the team to remove the member from. */
  teamId: Scalars['Int']['input'];
  /** ID of the user to remove. */
  userId: Scalars['Int']['input'];
};

/** Input for removing a network from ad serving for a design. */
export type InputRemoveNetworkAdServing = {
  /** The ID of the design. */
  designId: Scalars['Int']['input'];
  /**
   * Remove the network from every member of this design's variation family.
   * Removing it from the master alone leaves each variation's embed for that
   * network live on S3, so tags already handed to a trafficker keep serving.
   */
  includeVariations?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the network to remove. */
  networkId: Scalars['Int']['input'];
};

export type InputRemoveObject = {
  app?: InputMaybe<Scalars['String']['input']>;
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Field no longer supported */
  changes?: InputMaybe<Array<RemoveObjectChange>>;
  createMedia?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Field no longer supported */
  desiredResolution?: InputMaybe<DesiredResolution>;
  /** @deprecated Field no longer supported */
  enhance?: InputMaybe<Scalars['Boolean']['input']>;
  image: Scalars['String']['input'];
  maskUrl?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Field no longer supported */
  originalQuality?: InputMaybe<Scalars['Boolean']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Field no longer supported */
  sid?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

/** Input for removing a group from a project. */
export type InputRemoveProjectGroup = {
  /** ID of the group to remove. */
  groupId: Scalars['Int']['input'];
  /** ID of the project to remove the group from. */
  projectId: Scalars['Int']['input'];
};

/** Input for removing a user from a project. */
export type InputRemoveProjectUser = {
  /** ID of the project to remove the user from. */
  projectId: Scalars['Int']['input'];
  /** ID of the user to remove. */
  userId: Scalars['Int']['input'];
};

export type InputRemoveSuccessManager = {
  id: Scalars['Int']['input'];
};

export type InputRemoveTeamIdentityProvider = {
  teamId: Scalars['Int']['input'];
};

/** Input for removing a team user group. */
export type InputRemoveTeamUserGroup = {
  /** ID of the group to remove. */
  groupId: Scalars['Int']['input'];
  /** ID of the team that owns the group. */
  teamId: Scalars['Int']['input'];
};

/** Input for removing a typography configuration from a brand kit. */
export type InputRemoveTypography = {
  /** ID of the brand kit to remove typography from. */
  brandKitId: Scalars['Int']['input'];
  /** Type of typography to remove. */
  type: Scalars['String']['input'];
};

export type InputRemoveUrlsFromDesigns = {
  urls: Array<Scalars['String']['input']>;
};

/** Input for removing a user from a group. */
export type InputRemoveUserFromGroup = {
  /** ID of the group to remove the user from. */
  groupId: Scalars['Int']['input'];
  /** ID of the team that owns the group. */
  teamId: Scalars['Int']['input'];
  /** ID of the user to remove. */
  userId: Scalars['Int']['input'];
};

/** Input for removing/restoring a whole variation (Variations tab undo/redo of a duplicate). */
export type InputRemoveVariation = {
  /** Hash of the variation top row (a design linked by masterSetId). */
  hash: Scalars['String']['input'];
};

export type InputRemoveVideoBackground = {
  backgroundColor?: InputMaybe<RemoveVideoBackgroundColor>;
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  outputContainerAndCodec?: InputMaybe<RemoveVideoOutputContainerAndCodec>;
  preserveAudio?: InputMaybe<Scalars['Boolean']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
  video: Scalars['String']['input'];
};

export type InputRenameAbTest = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
};

/** Input for renaming a brand kit. */
export type InputRenameBrandKit = {
  /** ID of the brand kit to rename. */
  id: Scalars['Int']['input'];
  /** New name for the brand kit. */
  name: Scalars['String']['input'];
};

export type InputRenameBrandTargetAudience = {
  /** Name of the brand's audience. */
  audienceName: Scalars['String']['input'];
  /** ID of the brand kit to update. */
  brandKitId: Scalars['Int']['input'];
  /** ID of the target audience to update. */
  id: Scalars['Int']['input'];
};

export type InputRenameColorPalette = {
  brandKitId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type InputRenameCopilotAiChat = {
  chatId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputRenameCustomSize = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type InputRenameCustomTransition = {
  id: Scalars['Int']['input'];
  newName: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

/** Input for renaming a design. */
export type InputRenameDesign = {
  /** Hash of the design to rename. */
  hash: Scalars['String']['input'];
  /** New name for the design. */
  name: Scalars['String']['input'];
  /** Sent with every rename an editor tab makes (its first load's Design.readAt): such a rename is not recorded for open tabs, or it would reload that tab. Any other rename is. */
  openedAt?: InputMaybe<Scalars['Float']['input']>;
};

export type InputRenameDesignComponent = {
  /** @deprecated Field no longer supported */
  hash?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Field no longer supported */
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

/** Input for renaming a design-media-library folder. */
export type InputRenameDesignMediaFolder = {
  /** ID of the design that owns the folder. */
  designId: Scalars['Int']['input'];
  /** ID of the folder to rename. */
  folderId: Scalars['Int']['input'];
  /** New name (1-100 chars after trimming). */
  name: Scalars['String']['input'];
};

export type InputRenameDesignSizeType = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type InputRenameFolder = {
  folderId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

/** Input for renaming a media asset. */
export type InputRenameMedia = {
  /** ID of the brand kit that owns the media. */
  brandKitId: Scalars['Int']['input'];
  /** ID of the media to rename. */
  id: Scalars['Int']['input'];
  /** New name for the media. */
  name: Scalars['String']['input'];
};

export type InputRenameMediaFolder = {
  mediaFolderId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type InputRenameReport = {
  id: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

/** Input for renaming a typography configuration in a brand kit. */
export type InputRenameTypography = {
  /** ID of the brand kit containing the typography. */
  brandKitId: Scalars['Int']['input'];
  /** New name for the typography type. */
  name: Scalars['String']['input'];
  /** Current type of typography to rename. */
  type: Scalars['String']['input'];
};

/** A single element's true rendered box (jpg-png /render output), keyed by the embed's element id. */
export type InputRenderedBox = {
  height: Scalars['Float']['input'];
  id: Scalars['String']['input'];
  width: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type InputRepairRefusedFonts = {
  /** The design whose export saw the refusal, for the log. */
  designHash?: InputMaybe<Scalars['String']['input']>;
  /** URLs of the font files Chrome refused, as its 'Failed to decode downloaded font' line names them. */
  fontUrls: Array<Scalars['String']['input']>;
  /** The export job that saw the refusal, for the log. */
  jobId?: InputMaybe<Scalars['String']['input']>;
};

export type InputRepairStoredFont = {
  /**
   * Leave unset to inspect: the repair runs and reports, and NOTHING is written. Set true to store
   * the repaired bytes over the original.
   */
  apply?: InputMaybe<Scalars['Boolean']['input']>;
  /** The font's hash, as it appears in assets/fonts/<hash>/font.ttf and in a capture's failure. */
  hash: Scalars['String']['input'];
};

export type InputReplaceVideoBackground = {
  /** Image composited behind the clip's subject. Scaled to cover the frame and centre-cropped. */
  backgroundUrl: Scalars['String']['input'];
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
  video: Scalars['String']['input'];
};

export type InputReportAdStudioExperience = {
  experience: AdStudioExperience;
  teamId: Scalars['Int']['input'];
};

export type InputRequestProductSetImport = {
  /** Hash of the CATALOG, not of the set — MANAGE_CATALOG is checked service-side like every other hash-based catalog mutation */
  hash: Scalars['String']['input'];
  /** The set's id AT META, as loadProductSets reports it in sourceProductSetId */
  sourceProductSetId: Scalars['String']['input'];
};

/** Input for resending a team invitation. */
export type InputResendInvitation = {
  /** ID of the invitation to resend. */
  id: Scalars['Int']['input'];
  /** ID of the team that sent the invitation. */
  teamId: Scalars['Int']['input'];
};

export type InputReserveResizeApplyCredit = {
  sourceHash: Scalars['String']['input'];
};

export type InputResetAddonUsageForTeam = {
  invoiceId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputResetMultipleSession = {
  userId: Scalars['Int']['input'];
};

/** Input for resetting the no-downloads cache for a team. */
export type InputResetNoDownloadsCache = {
  /** ID of the team to reset the cache for. */
  teamId: Scalars['Int']['input'];
};

export type InputResetRedisStream = {
  dbValue: Scalars['Int']['input'];
  prefix: Scalars['String']['input'];
  streamName: Scalars['String']['input'];
};

/** Input for resetting sibling sizes back to the master size (discarding their own divergence). */
export type InputResetSizesToMasterSize = {
  /** Abort with MASTER_CHANGED when the source size's current checksum differs from what the client previewed. */
  expectedSourceChecksum: Scalars['String']['input'];
  /** Hash of the master design (set or standalone). */
  masterHash: Scalars['String']['input'];
  /** The size the targets are reset TO — must be the master size of the set. */
  sourceDesignSizeTypeId: Scalars['Int']['input'];
  /** The sizes that discard their divergence. The source size itself is skipped. */
  targetDesignSizeTypeIds: Array<Scalars['Int']['input']>;
};

export type InputResetTeamDesignCount = {
  teamId: Scalars['Int']['input'];
  /** The value to set the counter to. Whole number, not negative. */
  totalDesignsCreated: Scalars['Int']['input'];
};

/**
 * Input for `resizeAlternatives` — the picker-fallback companion to
 * `resizeWithTemplate`. Use this when the strict auto-pick returns
 * `resizeType: none` to surface up to 3 looser matches the user can
 * choose from.
 */
export type InputResizeAlternatives = {
  /**
   * resize_rag_classes: one preview per template class present in the selection
   * (extra-tall, tall, square, wide, extra-wide — the AI-resize modal's rows), at
   * the class's representative size, each tagged with `ratioClass`. Sent only by
   * a client that splits its rows by class; omit for per-orientation previews.
   */
  byClass?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The size types the user has currently selected in the resize panel.
   * The server collapses these into one representative dimension per
   * orientation (square / vertical / horizontal) and produces a preview
   * for each orientation present. An empty list yields no alternatives.
   */
  designSizeTypeIds: Array<Scalars['Int']['input']>;
  /** Hash of the design set the source belongs to, or of a standalone design (then `mainSizeHash` must equal it). */
  hash: Scalars['String']['input'];
  /**
   * When true, return ONLY the id-based best match (the design's own template,
   * layout unchanged) and skip the similarity search, the inline source analysis
   * and every semantic preview; a carried `sourceAnalysis` is returned as-is.
   * The RAG-only resize flow sets it: it shows no card a similarity search found.
   * Omit for the full picker.
   */
  idBasedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Hash of the main size design inside the set, or `hash` itself for a
   * standalone design. Required — the relaxed matcher needs the source banner
   * to produce per-candidate previews.
   */
  mainSizeHash?: InputMaybe<Scalars['String']['input']>;
  /**
   * Stable `bannersetElementId` of the slide to preview (see
   * `InputResizeWithTemplate.slideId`). When set, previews are scoped to this
   * slide; omit to keep the legacy mono-slide-only behavior.
   */
  slideId?: InputMaybe<Scalars['Int']['input']>;
  /** Pre-computed source-design analysis from `analyzeSourceDesign` (see `InputResizeWithTemplate`). */
  sourceAnalysis?: InputMaybe<Scalars['JSON']['input']>;
};

/**
 * Input for `resizeFlexVariants` — the flex-resize alternative to template
 * resize. The server analyzes the source (reusing the skeleton the
 * `analyzeDesignTree` pre-warm cached server-side, when present) and renders
 * previews at the user's selected sizes. Nothing is carried by the client.
 */
export type InputResizeFlexVariants = {
  /**
   * The size types the user has currently selected in the resize panel. The
   * server buckets these into orientations and produces one preview per
   * orientation at a representative selected size. An empty list yields nothing.
   */
  designSizeTypeIds: Array<Scalars['Int']['input']>;
  /** Hash of the design set the source belongs to, or of a standalone design (then `mainSizeHash` must equal it). */
  hash: Scalars['String']['input'];
  /** Hash of the main size design inside the set, or `hash` itself for a standalone design (the source banner to lay out). */
  mainSizeHash?: InputMaybe<Scalars['String']['input']>;
  /** Stable `bannersetElementId` of the slide to preview, for multi-slide sources. */
  slideId?: InputMaybe<Scalars['Int']['input']>;
  /** DEPRECATED — flex is fully deterministic now; ignored. Kept so older clients don't break. */
  sourceAnalysis?: InputMaybe<Scalars['JSON']['input']>;
};

export type InputResizeGradeFeedPost = {
  /** Hook-site timestamp (ISO). */
  appliedAtIso: Scalars['String']['input'];
  candidateHash: Scalars['String']['input'];
  candidateHeight: Scalars['Float']['input'];
  /** Pixels; fractional for an mm/cm/in size type, whose exact canvas the apply stamps. */
  candidateWidth: Scalars['Float']['input'];
  checksum: Scalars['String']['input'];
  referenceHash: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  variantId: Scalars['String']['input'];
  /** The AI resize manifest version, stringified. */
  version?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A single (template → sizes) pairing inside `InputResizeWithTemplate`.
 * Every size in `designSizeTypeIds` is resized against the same template.
 */
export type InputResizeTemplateGroup = {
  /** IDs of the design size types to create with this group's template (one result per id). */
  designSizeTypeIds: Array<Scalars['Int']['input']>;
  /**
   * When set, skips both id-based and similarity matching paths for this
   * group and uses this template SET directly. Wired from the picker UI:
   * when the user confirms one of the alternatives returned by
   * `resizeAlternatives`, the FE feeds the chosen SET hash back here so
   * the resize runs deterministically against that template. Invalid
   * overrides (deleted set, publisher gate denied) fall through to
   * `resizeType: none` for this group — the FE then runs legacy AI resize.
   */
  templateSetIdOverride?: InputMaybe<Scalars['String']['input']>;
};

export type InputResizeWithFlex = {
  /** The design to adapt. Not persisted — callers may have no Design row at all. */
  jsonDesign: Scalars['JSON']['input'];
  targets: Array<InputFlexTarget>;
};

export type InputResizeWithPublicTemplate = {
  /** The design to adapt. Not persisted — callers may have no Design row at all. */
  jsonDesign: Scalars['JSON']['input'];
  targets: Array<InputPublicTemplateTarget>;
};

/**
 * Input for creating a new size inside a design set by cloning the matching
 * size from the set's source template.
 */
export type InputResizeWithTemplate = {
  /** Hash of the design set to add the new sizes to. */
  hash: Scalars['String']['input'];
  /**
   * Hash of the main size design inside the set (the representative child).
   * Used to merge user content/styling into the template's target-size JSON.
   */
  mainSizeHash?: InputMaybe<Scalars['String']['input']>;
  /**
   * Stable `bannersetElementId` of the slide being resized. When set, the
   * source is treated as a mono-slide banner scoped to this slide: matching +
   * merge run on that slide only, and on a multi-slide design the other slides
   * (and top-level "all-slides" layers) are preserved in the writeback. Omit
   * (older clients) to keep the legacy contract — multi-slide sources then fall
   * back to legacy/AI resize.
   */
  slideId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Pre-computed source-design analysis (text roles + decor classification)
   * from `analyzeSourceDesign`, carried so apply reuses it instead of making
   * a second LLM call. Describes the SOURCE design, so it is one per call
   * (shared across all template groups). Omit to compute inline as a fallback.
   */
  sourceAnalysis?: InputMaybe<Scalars['JSON']['input']>;
  /**
   * One or more template groups to resize against. Each group pins a set
   * of sizes (`designSizeTypeIds`) to a single template (auto-picked, or
   * forced via `templateSetIdOverride`), so different sizes can be
   * resized using different templates in a single call. Groups are
   * expected to be disjoint (a given `designSizeTypeId` should appear in
   * at most one group). The frontend currently always sends a single
   * group; multi-group support is consumed later.
   */
  templates: Array<InputResizeTemplateGroup>;
};

export type InputResizedLayerInfo = {
  group?: InputMaybe<Scalars['Int']['input']>;
  height: Scalars['Float']['input'];
  horizontalAlign?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  layerName?: InputMaybe<Scalars['String']['input']>;
  layerText?: InputMaybe<Scalars['String']['input']>;
  layerType: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['Int']['input']>;
  width: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type InputResourceAccess = {
  designHash?: InputMaybe<Scalars['String']['input']>;
  folderHash?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type InputRestoreAbTest = {
  fromTrash?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

/**
 * Input for restoring a design from trash.
 * This brings back a previously deleted design.
 */
export type InputRestoreDesign = {
  /** Whether to restore from trash (true) or from a soft-delete (false). */
  fromTrash?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the design to restore. */
  id: Scalars['Int']['input'];
  /** ID of the team that owns the design. */
  teamId: Scalars['Int']['input'];
};

/** Input for restoring a previously removed design from a set. */
export type InputRestoreDesignFromSet = {
  /** Hash of the design to restore to its set. */
  hash: Scalars['String']['input'];
};

/** Input for restoring a project from trash. */
export type InputRestoreProject = {
  /** Whether to restore from trash (true) or from a soft-delete (false). */
  fromTrash?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the project to restore. */
  id: Scalars['Int']['input'];
  /** ID of the team that owns the project. */
  teamId: Scalars['Int']['input'];
};

export type InputRestoreStoredFont = {
  /** Copies the backup back only when true. Reports what it would do otherwise. */
  apply?: InputMaybe<Scalars['Boolean']['input']>;
  hash: Scalars['String']['input'];
};

export type InputRestoreVariation = {
  /**
   * Bring back exactly these child rows instead of every soft-deleted child
   * under the variation.
   *
   * Omitted restores them all, which is what the duplicate-undo wants — a fresh
   * duplicate's children were all removed together. It is wrong as the inverse
   * of a user's delete: a size removed EARLIER through the selection bar or the
   * Sizes panel is soft-deleted under the same parent and would come back with
   * the rest, resurrecting an ad the user deliberately took out. Callers with an
   * exact write set (removeVariation reports one) pass it here.
   *
   * An EMPTY list is honoured literally — the top row comes back alone — which
   * is the faithful inverse of removing a variation whose children were already
   * gone.
   */
  childHashes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Hash of the variation top row (a design linked by masterSetId). */
  hash: Scalars['String']['input'];
};

/**
 * Input for restoreVariationsFamilyState — a declarative target state for the
 * master's family. Every member is validated (ownership, team, shape, version
 * availability) BEFORE anything is written; applying the same target twice is
 * a no-op.
 */
export type InputRestoreVariationsFamilyState = {
  /** The stored main-design choice to restore. Absent = untouched; null = the orientation auto-pick. */
  mainDesignId?: InputMaybe<Scalars['Int']['input']>;
  /** Hash of the master design (set or standalone). */
  masterHash: Scalars['String']['input'];
  sizes: Array<InputFamilySizeState>;
  /** The sizes-baseline pointer to restore (per-size checksums; the content-addressed snapshot is never deleted, so only the pointer moves). Absent or null = untouched; empty = refused. */
  sizesSyncBaseline?: InputMaybe<Array<InputSizeChecksum>>;
  variations: Array<InputFamilyVariationState>;
};

/** Input for resuming a paused subscription */
export type InputResumeSubscription = {
  subscriptionId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputRetryAiOperation = {
  /** Id of the failed AiOperation to re-run. */
  operationId: Scalars['Int']['input'];
};

export type InputRetryAiResizeVariant = {
  variantId: Scalars['String']['input'];
};

/** Input for retrying the brand-style re-evaluation pipeline. */
export type InputRetryBrandStyleEvaluation = {
  /** ID of the brand kit to re-evaluate. */
  brandKitId: Scalars['Int']['input'];
};

export type InputRevertBgOnBoundedImage = {
  feedId: Scalars['Int']['input'];
  imagesFromFeedWithBgReverted: Array<ImagesFromFeedWithBgReverted>;
  rowIndex: Scalars['Int']['input'];
};

export type InputRevertProductField = {
  field: Scalars['String']['input'];
  hash: Scalars['String']['input'];
  productKey: Scalars['String']['input'];
};

/** Input for revoking a pending team invitation. */
export type InputRevokeInvitation = {
  /** ID of the invitation to revoke. */
  id: Scalars['Int']['input'];
  /** ID of the team that sent the invitation. */
  teamId: Scalars['Int']['input'];
};

export type InputRolePermission = {
  permission: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};

export type InputRoleSettings = {
  editorType: Scalars['String']['input'];
};

export type InputRunCustomWorkflow = {
  cards?: InputMaybe<Scalars['JSON']['input']>;
  moodboardHash: Scalars['String']['input'];
  nodeId?: InputMaybe<Scalars['String']['input']>;
  workflowHash: Scalars['String']['input'];
};

export type InputRunWorkflow = {
  cards?: InputMaybe<Scalars['JSON']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  moodboardHash: Scalars['String']['input'];
  nodeId?: InputMaybe<Scalars['String']['input']>;
};

export type InputSaveAssetSelectorConfig = {
  /** Optional — only some AEM tenants require an API key on the Discovery service. */
  apiKey?: InputMaybe<Scalars['String']['input']>;
  /** Optional — delivery host/domain for placed assets (custom delivery domain / CDN). Unset = derived from the author repo host. */
  deliveryHost?: InputMaybe<Scalars['String']['input']>;
  /** Optional — allow-list of MFE features (e.g. [upload, collections]). */
  featureSet?: InputMaybe<Array<Scalars['String']['input']>>;
  imsClientId: Scalars['String']['input'];
  imsOrg: Scalars['String']['input'];
  imsScope: Scalars['String']['input'];
  /** Optional — pin the picker to a single AEM repository. */
  repositoryId?: InputMaybe<Scalars['String']['input']>;
  /** Optional — root folder path the picker opens at; doubles as encapsulation. */
  rootPath?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
  /** Optional — placed-asset source. true = AEM delivery URL (default); false = download a copy to The Brief's CDN. */
  useAemDelivery?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputSaveBrandKitColors = {
  brandKitId: Scalars['Int']['input'];
  colors: Array<InputBrandKitColor>;
};

export type InputSaveBrandKitCompetitorFromChat = {
  brandKitId: Scalars['Int']['input'];
  domain?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type InputSaveBrandKitFont = {
  fontWeight?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  urls: Array<Scalars['String']['input']>;
};

export type InputSaveBrandKitFonts = {
  brandKitId: Scalars['Int']['input'];
  fonts: Array<InputSaveBrandKitFont>;
  userId: Scalars['Int']['input'];
};

/** Input for saving brand kit JSON data. */
export type InputSaveBrandKitJson = {
  /** ID of the brand kit to save JSON data for. */
  brandKitId: Scalars['Int']['input'];
  /** JSON data to save. */
  json: Scalars['BrandKitJson']['input'];
};

export type InputSaveBrandKitLogos = {
  brandKitId: Scalars['Int']['input'];
  logos: Array<InputBrandKitLogoUrl>;
  userId: Scalars['Int']['input'];
};

export type InputSaveBrandKitMedia = {
  brandKitId: Scalars['Int']['input'];
  media: Array<InputSaveBrandKitMedium>;
  userId: Scalars['Int']['input'];
};

export type InputSaveBrandKitMedium = {
  name?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type InputSaveBrandKitTargetAudienceFromChat = {
  audienceName: Scalars['String']['input'];
  brandAudience?: InputMaybe<Scalars['String']['input']>;
  brandKitId: Scalars['Int']['input'];
};

export type InputSaveBrandKitVoiceAndTone = {
  brandKitId: Scalars['Int']['input'];
  brandTone?: InputMaybe<Array<Scalars['String']['input']>>;
  brandVoice?: InputMaybe<Scalars['String']['input']>;
};

export type InputSaveBrandStyleSourceImages = {
  brandKitId: Scalars['Int']['input'];
  sourceImages: Array<InputBrandStyleSourceImage>;
};

export type InputSaveCatalogVariationDesigns = {
  /** The catalog the caller believes this variation renders. */
  catalogId: Scalars['Int']['input'];
  /** Opaque attachment revision observed by the caller. Compare-and-swapped before and after the writes; it covers row, product set and generation, so this save both requires and preserves all three. */
  expectedAttachmentRevision: Scalars['String']['input'];
  /** Feed.checksum the edited documents were baked under. If the catalog has moved since, the save leaves checksum debt rather than claiming the stored document is current. */
  observedCatalogChecksum?: InputMaybe<Scalars['String']['input']>;
  /** Feed.overridesRevision the edited documents were baked under. Same rule as observedCatalogChecksum. */
  observedOverridesRevision?: InputMaybe<Scalars['String']['input']>;
  /** Every size being written. Sizes omitted keep their stored document, and still count toward the pinned bindings aggregate. */
  sizes: Array<InputSaveCatalogVariationSize>;
  /** The attachment OWNER: the variation's set id, or its design id when the variation is single-shaped. Equals design_feed.designId. */
  variationId: Scalars['Int']['input'];
};

/** One size of a catalog variation to write. The banner is the FULL document, feed markers included. */
export type InputSaveCatalogVariationSize = {
  banner: Scalars['JsonDesign']['input'];
  designSizeTypeId?: InputMaybe<Scalars['Int']['input']>;
  hash: Scalars['String']['input'];
};

export type InputSaveCloudinaryConfig = {
  cloudName: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputSaveContentLibrarySeparator = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InputSaveContentLibrarySubcategory = {
  columns: Scalars['Int']['input'];
  elementBgColor: Scalars['String']['input'];
  fileName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputSaveCopilotAiChatMessageAdditionalFeedback = {
  chatId: Scalars['Int']['input'];
  feedbackText: Scalars['String']['input'];
  isPositiveFeedback: Scalars['Boolean']['input'];
  messageId: Scalars['String']['input'];
  questionMessageId?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputSaveCopilotAiChatMessageFeedback = {
  chatId: Scalars['Int']['input'];
  isPositiveFeedback: Scalars['Boolean']['input'];
  messageId: Scalars['String']['input'];
  questionMessageId?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputSaveCopilotDocumentToBrandKit = {
  designHash: Scalars['String']['input'];
  /**
   * CURRENT only: the brand kit the preview showed. The save refuses with BRAND_KIT_CHANGED
   * when the design's kit is another one now.
   */
  expectedBrandKitId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * WEBSITE only: the extraction the preview showed. The save refuses with BRAND_KIT_CHANGED
   * when the chat's active extraction is another one now.
   */
  extractionId?: InputMaybe<Scalars['Int']['input']>;
  fields?: InputMaybe<Array<CopilotDocumentBrandKitField>>;
  /** DOCUMENT when omitted. */
  source?: InputMaybe<CopilotDocumentBrandKitSource>;
  target: CopilotDocumentBrandKitTarget;
  threadId: Scalars['String']['input'];
};

export type InputSaveCustomTransition = {
  name: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
  transition: Scalars['JsonTransitionAll']['input'];
};

export type InputSaveDesignsJsonsForLater = {
  brandKitData: InputUrlDataToBrandKit;
  jsons: Array<Scalars['JsonDesign']['input']>;
  savedHash?: InputMaybe<Scalars['String']['input']>;
};

export type InputSaveFeedInterval = {
  hash: Scalars['String']['input'];
  /** The range came from a dense product-set selector; persist it as canonical absolute catalog rows. */
  productSetOrdinals?: InputMaybe<Scalars['Boolean']['input']>;
  range: Scalars['String']['input'];
};

export type InputSaveMoodBoardContent = {
  content: Scalars['JSON']['input'];
  hash: Scalars['String']['input'];
  metadata?: InputMaybe<MoodBoardContentMetadataInput>;
};

export type InputSaveQuestionBg = {
  answer: Scalars['Boolean']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputSaveReport = {
  filters: InputAdTagReportFilters;
  id?: InputMaybe<Scalars['Int']['input']>;
  schedule?: InputMaybe<InputAdTagSchedule>;
  teamId: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type InputScoringData = {
  brandKitId: Scalars['Int']['input'];
  designHash: Scalars['String']['input'];
  logoHash?: InputMaybe<Scalars['String']['input']>;
  recalculate?: InputMaybe<Scalars['Boolean']['input']>;
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputSearch = {
  /** cursor to start from */
  after?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<SearchMode>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
  text: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type InputSearchAndReplace = {
  image: Scalars['String']['input'];
  negativePrompt?: InputMaybe<Scalars['String']['input']>;
  prompt: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
  variants?: InputMaybe<Scalars['Int']['input']>;
};

export type InputSearchVeevaDocuments = {
  searchQuery: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
  vaultDNS: Scalars['String']['input'];
};

export type InputSelectMigrationAccount = {
  bannersnackUserId: Scalars['Int']['input'];
  migrationId: Scalars['Int']['input'];
};

export type InputSendBookACallContext = {
  appOrigin?: InputMaybe<Scalars['String']['input']>;
  currentPlan?: InputMaybe<Scalars['String']['input']>;
  gatedFeature?: InputMaybe<Scalars['String']['input']>;
  suggestedPlan?: InputMaybe<Scalars['String']['input']>;
};

export type InputSendGclid = {
  gclid: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputSendHtmlReportToEmail = {
  email: Scalars['String']['input'];
  reportName: Scalars['String']['input'];
  signedUrl: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputSendReferralLp = {
  referralLP: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};

export type InputSendTestEmail = {
  teamId: Scalars['Int']['input'];
};

export type InputSendTopUpCreditsEmail = {
  teamId: Scalars['Int']['input'];
};

export type InputSendUsageRestrictionAdminNotification = {
  action: UsageRestrictionAction;
  scope: UsageRestrictionScope;
  severity?: InputMaybe<RestrictionSeverity>;
  teamId: Scalars['Int']['input'];
};

export type InputSendUtk = {
  teamId: Scalars['Int']['input'];
  utk: Scalars['String']['input'];
};

export type InputSendUtms = {
  fbclid?: InputMaybe<Scalars['String']['input']>;
  firstFbclid?: InputMaybe<Scalars['String']['input']>;
  firstGbraid?: InputMaybe<Scalars['String']['input']>;
  firstGclid?: InputMaybe<Scalars['String']['input']>;
  firstLandingPage?: InputMaybe<Scalars['String']['input']>;
  firstMsclkid?: InputMaybe<Scalars['String']['input']>;
  firstReferrer?: InputMaybe<Scalars['String']['input']>;
  /** ISO timestamp of the first touch (tb_first_touch cookie), used to date first_seen_at. */
  firstTouchAt?: InputMaybe<Scalars['String']['input']>;
  firstWbraid?: InputMaybe<Scalars['String']['input']>;
  firstinternalCampaign?: InputMaybe<Scalars['String']['input']>;
  firstinternalMedium?: InputMaybe<Scalars['String']['input']>;
  firstinternalSource?: InputMaybe<Scalars['String']['input']>;
  firstutmCampaign?: InputMaybe<Scalars['String']['input']>;
  firstutmContent?: InputMaybe<Scalars['String']['input']>;
  firstutmMedium?: InputMaybe<Scalars['String']['input']>;
  firstutmSource?: InputMaybe<Scalars['String']['input']>;
  firstutmTerm?: InputMaybe<Scalars['String']['input']>;
  gbraid?: InputMaybe<Scalars['String']['input']>;
  gclid?: InputMaybe<Scalars['String']['input']>;
  internalCampaign?: InputMaybe<Scalars['String']['input']>;
  internalMedium?: InputMaybe<Scalars['String']['input']>;
  internalSource?: InputMaybe<Scalars['String']['input']>;
  landingPage?: InputMaybe<Scalars['String']['input']>;
  /** ISO timestamp of the most recent campaign-tagged visit (tb_last_touch cookie). */
  lastTouchAt?: InputMaybe<Scalars['String']['input']>;
  msclkid?: InputMaybe<Scalars['String']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
  wbraid?: InputMaybe<Scalars['String']['input']>;
};

export type InputSendWorkflowMessage = {
  data: Scalars['String']['input'];
  operationId: Scalars['String']['input'];
  status: WorkflowOperationStatus;
};

export type InputSetAnonymousId = {
  /** Anonymous identifier used for tracking users before they authenticate. */
  anonymousId: Scalars['String']['input'];
};

/** Input for setting a media asset as a brand kit logo. */
export type InputSetBrandKitLogo = {
  /** ID of the brand kit to set the logo for. */
  brandKitId: Scalars['Int']['input'];
  /** ID of the media asset to use as the logo. */
  mediaId: Scalars['Int']['input'];
};

/** Input for saving the brand profile of a brand kit. */
export type InputSetBrandKitProfile = {
  /** ID of the brand kit to update. */
  brandKitId: Scalars['Int']['input'];
  /** Profile fields to apply. */
  profile: InputBrandProfileFields;
};

/** Input for setting visual style for a brand kit. */
export type InputSetBrandKitVisualStyle = {
  /** ID of the brand kit to update. */
  brandKitId: Scalars['Int']['input'];
  /** Visual style settings to apply. */
  visualStyle: InputBrandVisualStyle;
};

/** Input for setting voice and tone for a brand kit. */
export type InputSetBrandKitVoiceAndTone = {
  /** ID of the brand kit to update. */
  brandKitId: Scalars['Int']['input'];
  /** Voice and tone settings to apply. */
  voiceAndTone: InputVoiceAndTone;
};

export type InputSetBrandedColor = {
  color: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputSetBrandedDomain = {
  domain: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputSetBrandedEmail = {
  email?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputSetBrandedFavicon = {
  teamId: Scalars['Int']['input'];
  tempUrl: Scalars['String']['input'];
};

export type InputSetBrandedLogo = {
  teamId: Scalars['Int']['input'];
  tempUrl: Scalars['String']['input'];
};

export type InputSetCatalogFavorite = {
  favorite: Scalars['Boolean']['input'];
  hash: Scalars['String']['input'];
};

export type InputSetCloudinaryDefaultFolder = {
  /** A folder path as Cloudinary's folder list gives it. Null, empty or / for the account's root. */
  folder?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputSetCopilotBrandExtractionFont = {
  designHash: Scalars['String']['input'];
  extractionId: Scalars['Int']['input'];
  /** Fonts just uploaded into the draft. Empty: use the draft's own linked fonts that match the name. */
  fontIds: Array<Scalars['Int']['input']>;
  /** The missing font being fixed, as `missingFonts.name` gives it. */
  missingFontName: Scalars['String']['input'];
  /** Set the missing Google font by name instead (no files). Only for an entry with isGoogleFont. */
  useGoogleFont?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputSetDefaultGoogleAdsIntegrationAccount = {
  email: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputSetDefaultMetaIntegrationAccount = {
  accountId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputSetDesignFeedRow = {
  designId: Scalars['Int']['input'];
  feedHash?: InputMaybe<Scalars['String']['input']>;
  row: Scalars['Int']['input'];
};

export type InputSetDesignSizeTypeId = {
  designId: Scalars['Int']['input'];
  designSizeTypeId: Scalars['Int']['input'];
};

/** Input for setting a project as favorite. */
export type InputSetFavoriteProject = {
  /** Whether to mark as favorite (true) or remove favorite (false). */
  favorite: Scalars['Boolean']['input'];
  /** ID of the project to mark as favorite. */
  projectId: Scalars['Int']['input'];
};

export type InputSetFeatureAccess = {
  allPlansState: Array<InputAllPlansState>;
  feature: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};

export type InputSetFeedCloudbedsApiKey = {
  apiKey: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputSetFeedColumnSmartCropEnabled = {
  columnIndex: Scalars['Int']['input'];
  /**
   * Whether focal-point smart-crop should be honored on this column. When
   * false, the renderers (canvas, export, ad-serving) ignore the cells'
   * smartCrop.focalArea and fall back to cover-fit. Cell data is left
   * intact so toggling back on restores the prior focal points.
   */
  enabled: Scalars['Boolean']['input'];
  feedId: Scalars['Int']['input'];
};

export type InputSetFeedRowSmartCropReviewed = {
  columnIndex: Scalars['Int']['input'];
  feedId: Scalars['Int']['input'];
  rowIndex: Scalars['Int']['input'];
};

export type InputSetHashes = {
  designId: Scalars['Int']['input'];
  hashes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InputSetMigrationStep = {
  migrationId: Scalars['Int']['input'];
  step: Scalars['String']['input'];
};

export type InputSetNextgenAiTemplatesPublishStatus = {
  published: Scalars['Boolean']['input'];
  setHash: Scalars['String']['input'];
};

export type InputSetPageTitle = {
  pageTitle: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

/** Input for setting a project logo. */
export type InputSetProjectLogo = {
  /** ID of the project to update. */
  projectId: Scalars['Int']['input'];
  /** Temporary URL of the uploaded logo image. */
  tempUrl: Scalars['String']['input'];
};

export type InputSetRole = {
  name: Scalars['String']['input'];
  permissions: Array<InputRolePermission>;
  roleId?: InputMaybe<Scalars['Int']['input']>;
  roleSettings?: InputMaybe<InputRoleSettings>;
  teamId: Scalars['Int']['input'];
};

export type InputSetSharePointDefaultLocation = {
  accountType?: InputMaybe<IntegrationAccountType>;
  location: SharePointDefaultExportLocationInput;
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputSetSmartCropOnFeedRow = {
  columnIndex: Scalars['Int']['input'];
  feedId: Scalars['Int']['input'];
  focalArea: FeedFocalAreaInput;
  imageHeight?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Natural pixel dimensions of the source image. The modal already has these
   * (smartCropOnImage returns them) so we persist them on the cell when the
   * user saves a manual edit — that's what feeds the canvas + export
   * renderers' V1.1 focal-crop derivation. Optional for backwards compat with
   * earlier clients.
   */
  imageWidth?: InputMaybe<Scalars['Int']['input']>;
  rowIndex: Scalars['Int']['input'];
  /**
   * Per-cell zoom expressed as a percentage. 100 (or unset) renders the
   * cover-fit crop centred on the focal point. Values >100 zoom in around
   * the focal point. Values <=100 are treated as 100 by the renderer.
   * Optional for backwards compat.
   */
  zoom?: InputMaybe<Scalars['Int']['input']>;
};

export type InputSetSmartSetEnabled = {
  enabled: Scalars['Boolean']['input'];
  hash: Scalars['String']['input'];
  kind: ProductSetSmartKind;
};

/** Input for setting a team logo. */
export type InputSetTeamLogo = {
  /** ID of the team to set the logo for. */
  teamId: Scalars['Int']['input'];
  /** Temporary URL of the uploaded logo image. */
  tempUrl: Scalars['String']['input'];
};

/** Input for setting typography options in a brand kit. */
export type InputSetTypographyOptions = {
  /** ID of the brand kit to update. */
  id: Scalars['Int']['input'];
  /** Typography settings to apply. */
  typography: InputTypography;
};

/** Input for promoting a variation to be its family's master (Variations tab 'Set as master'). */
export type InputSetVariationAsMaster = {
  /** Language code to relabel the demoted master with (its source language is not stored server-side, so the client passes it). Omit for a duplicate-type variation, or to leave the demoted master unlabeled. */
  demotedMasterLanguage?: InputMaybe<Scalars['LanguageCodesType']['input']>;
  /** Hash of the variation top row (a design linked by masterSetId) to promote. */
  variationHash: Scalars['String']['input'];
};

export type InputSettleResizeApplyCredit = {
  applied: Scalars['Boolean']['input'];
  sourceHash: Scalars['String']['input'];
  targetHash?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for sharing a design with users or groups. */
export type InputShareDesign = {
  /** ID of the design to share. */
  designId: Scalars['Int']['input'];
  /** List of users or groups to share with. */
  sharedUsersList: Array<InputSharedUser>;
};

export type InputShareFolder = {
  folderId: Scalars['Int']['input'];
  sharedUsersList: Array<InputSharedUser>;
};

export type InputShareFoldersAndDesigns = {
  elementList: Array<ShareFoldersAndDesignsShareElement>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  sharedUsersList: Array<InputSharedUser>;
  teamId: Scalars['Int']['input'];
};

export type InputSharePoint = {
  sharepoint: Scalars['Boolean']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputShareVariationSelection = {
  /** The design's INTERNAL hash (Design.idToHash), not the public share hash. */
  designHash: Scalars['String']['input'];
};

/** Input for retrieving users and groups with access to a shared design. */
export type InputSharedDesign = {
  /** ID of the design to check sharing information for. */
  designId: Scalars['Int']['input'];
};

export type InputSharedFolder = {
  folderId: Scalars['Int']['input'];
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputSharedUser = {
  id: Scalars['Int']['input'];
  type: UserOrgType;
};

export type InputShutterstockImage = {
  imageId: Scalars['String']['input'];
  searchId?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for generating a signed URL for uploading an ad network logo. */
export type InputSignAdNetworkLogoUploadUrl = {
  /** The filename of the logo to be uploaded. */
  filename: Scalars['String']['input'];
  /** The ID of the team for which the logo is being uploaded. */
  teamId: Scalars['Int']['input'];
};

export type InputSignBrandKitDocumentUploadUrl = {
  brandKitId: Scalars['Int']['input'];
  /** Exact media type of the file: application/pdf, text/plain, text/markdown or the .docx type. */
  contentType: Scalars['String']['input'];
};

export type InputSignChatDocumentUploadUrl = {
  /** Exact media type of the file: application/pdf, text/plain, text/markdown or the .docx type. */
  contentType: Scalars['String']['input'];
  /** The design whose chat the document is attached to — what the permission is checked against. */
  designHash: Scalars['String']['input'];
};

export type InputSignFigFileUploadUrl = {
  teamId: Scalars['Int']['input'];
};

export type InputSignShareUploadUrl = {
  hash: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  type: MediaType;
};

export type InputSignTempUploadUrl = {
  /** The file's own MIME type. A missing or mismatched one is stored as application/octet-stream. */
  contentType?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  type: MediaType;
};

export type InputSignUploadUrl = {
  type: MediaType;
};

/** Input for getting a signed media upload URL. */
export type InputSignedMediaUrl = {
  /** Type of media to upload. */
  type: MediaType;
};

/** First-party attribution read from the touch cookies at account creation. First-touch fields are write-once. */
export type InputSignupAttribution = {
  fbclid?: InputMaybe<Scalars['String']['input']>;
  firstFbclid?: InputMaybe<Scalars['String']['input']>;
  firstGclid?: InputMaybe<Scalars['String']['input']>;
  firstLandingPage?: InputMaybe<Scalars['String']['input']>;
  firstMsclkid?: InputMaybe<Scalars['String']['input']>;
  firstReferrer?: InputMaybe<Scalars['String']['input']>;
  firstTouchAt?: InputMaybe<Scalars['String']['input']>;
  firstutmCampaign?: InputMaybe<Scalars['String']['input']>;
  firstutmContent?: InputMaybe<Scalars['String']['input']>;
  firstutmMedium?: InputMaybe<Scalars['String']['input']>;
  firstutmSource?: InputMaybe<Scalars['String']['input']>;
  firstutmTerm?: InputMaybe<Scalars['String']['input']>;
  gclid?: InputMaybe<Scalars['String']['input']>;
  lastTouchAt?: InputMaybe<Scalars['String']['input']>;
  msclkid?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
};

/** One size's expected checksum for the sync precondition. */
export type InputSizeChecksum = {
  checksum: Scalars['String']['input'];
  designSizeTypeId: Scalars['Int']['input'];
};

/** A size to add: its width and height in pixels, and the name of a preset or of the new size. */
export type InputSizeToAdd = {
  height: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  width: Scalars['Int']['input'];
};

export type InputSmartCrop = {
  cropBackgroundHeight: Scalars['Float']['input'];
  cropBackgroundWidth: Scalars['Float']['input'];
  /** Current crop background — how the image is currently positioned/scaled behind the layer */
  cropBackgroundX: Scalars['Float']['input'];
  cropBackgroundY: Scalars['Float']['input'];
  /** Current crop rotation in degrees */
  cropRotation: Scalars['Float']['input'];
  designHeight: Scalars['Int']['input'];
  /** Design canvas dimensions */
  designWidth: Scalars['Int']['input'];
  /** Whether the image is flipped horizontally — mirrors the focal point */
  flipX?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the image is flipped vertically — mirrors the focal point */
  flipY?: InputMaybe<Scalars['Boolean']['input']>;
  imageLayerHeight: Scalars['Int']['input'];
  /** Image layer dimensions and position on the canvas */
  imageLayerWidth: Scalars['Int']['input'];
  imageLayerX: Scalars['Float']['input'];
  imageLayerY: Scalars['Float']['input'];
  /** All sibling elements on the design canvas (positions relative to the image layer) */
  layoutElements?: InputMaybe<Array<InputSmartCropLayoutElement>>;
  originalImageHeight: Scalars['Int']['input'];
  originalImageUrl: Scalars['String']['input'];
  /** Original image dimensions (needed for crop math) */
  originalImageWidth: Scalars['Int']['input'];
};

/** One banner to smart-crop, with the target canvas dimensions the crop is computed for. */
export type InputSmartCropBannerItem = {
  /** Banner JSON to re-frame. Image layers are smart-cropped in place. */
  banner: Scalars['JsonDesign']['input'];
  /** Target canvas height (px) the banner renders at. */
  designHeight: Scalars['Int']['input'];
  /** Target canvas width (px) the banner renders at. */
  designWidth: Scalars['Int']['input'];
  /**
   * The slide whose image layers to re-frame, by its cross-size key
   * (`bannersetElementId`), for a multi-slide banner. Absent → the first slide.
   */
  slideId?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for `smartCropBanners` — a batch of banners plus the source for cutout handling. */
export type InputSmartCropBanners = {
  /** Banners to smart-crop. One Vision call per unique image is made across the batch. */
  items: Array<InputSmartCropBannerItem>;
  /**
   * resize_rag_variants: respect the resize's deliberate framing — a photo the source framed past 1.5x, or one in a
   * small box, keeps the zoom it arrived with, and a nearly opaque "transparent" image keeps its framing instead of
   * being contained. Sent by a session started with the gate on; omitted, the crop is the one it always was.
   */
  resizeFraming?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The source (original-size) banner. Cutout (transparent-background) images keep
   * THIS banner's per-layer scaleMode instead of being forced to crop — mirroring
   * the template-resize path. Omit to skip that restoration.
   */
  sourceBanner?: InputMaybe<Scalars['JsonDesign']['input']>;
};

export type InputSmartCropLayoutElement = {
  elementHeight: Scalars['Float']['input'];
  /** Element type (text, svg, button, etc.) */
  elementType: Scalars['String']['input'];
  elementWidth: Scalars['Float']['input'];
  /** Position relative to the image layer top-left */
  elementX: Scalars['Float']['input'];
  elementY: Scalars['Float']['input'];
};

export type InputSmartCropOnImage = {
  url: Scalars['String']['input'];
};

export type InputSolveComment = {
  guestEmail?: InputMaybe<Scalars['String']['input']>;
  guestName?: InputMaybe<Scalars['String']['input']>;
  reCaptchaToken?: InputMaybe<Scalars['String']['input']>;
  threadId: Scalars['Int']['input'];
};

export type InputSpeedCurvePoint = {
  /** Fraction of the source clip's duration, 0–1. Strictly ascending; first point 0, last point 1. */
  position: Scalars['Float']['input'];
  /** Playback-rate multiplier at this position, 0.1–10. */
  speed: Scalars['Float']['input'];
};

export type InputStartAiAgentAutomationSchedule = {
  projectId?: InputMaybe<Scalars['Int']['input']>;
  scheduleId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputStartAiResizeVariants = {
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  hash: Scalars['String']['input'];
  logoHash?: InputMaybe<Scalars['String']['input']>;
  ragClasses?: InputMaybe<Scalars['Boolean']['input']>;
  slideId: Scalars['Int']['input'];
  stubModel?: InputMaybe<Scalars['Boolean']['input']>;
  targetHashes: Array<Scalars['String']['input']>;
  targetHeights?: InputMaybe<Array<Scalars['Int']['input']>>;
  targetWidths?: InputMaybe<Array<Scalars['Int']['input']>>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  variantsPerVersion?: InputMaybe<Scalars['Int']['input']>;
  versions?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type InputStartAutoCutVideo = {
  cuttingStyle: AutoCutStyle;
  targetLengthSeconds?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
  videoUrl: Scalars['String']['input'];
};

export type InputStartCaptionGeneration = {
  sourceType: CaptionSourceType;
  sourceUrl: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputStartCloudinaryConnection = {
  teamId: Scalars['Int']['input'];
};

export type InputStartCopilotBrandExtraction = {
  chatThreadId: Scalars['String']['input'];
  /** The design the Copilot conversation is about; the user must be able to edit it. */
  designHash: Scalars['String']['input'];
  toolCallId: Scalars['String']['input'];
  /** The brand's website; the scheme is optional. */
  url: Scalars['String']['input'];
};

export type InputStartCopilotBrandOnTemplate = {
  /** The website whose brand is put on the design: an http(s) address or a bare domain. Omitted: the brand of the design's own kit, with the site it was extracted from when there is one. */
  brandUrl?: InputMaybe<Scalars['String']['input']>;
  /** The design the Copilot conversation is about (a size set or a standalone design); the user must be able to edit it. */
  designHash: Scalars['String']['input'];
  /** The language of the user's message (for example English), or the one they asked the ad to be in: the ad's copy is written in it. Omitted: the language of the template's text. */
  language?: InputMaybe<Scalars['String']['input']>;
};

export type InputStartCopilotEditDesign = {
  /** The design the Copilot conversation is about (a size set or a standalone design); the user must be able to edit it. */
  designHash: Scalars['String']['input'];
  /** The media library item to rebuild as editable layers. */
  mediaHash: Scalars['String']['input'];
  /** The Copilot thread the request came from, linked from the lift's Slack post. Omitted when the caller has none. */
  threadId?: InputMaybe<Scalars['String']['input']>;
};

export type InputStartCopilotGeneration = {
  /** Video: the model may cut between shots. */
  allowSceneCuts?: InputMaybe<Scalars['Boolean']['input']>;
  /** The picture's or clip's aspect ratio, such as 4:5 or 16:9. */
  aspectRatio: Scalars['String']['input'];
  /** Video: with sound. Defaults to true. */
  audio?: InputMaybe<Scalars['Boolean']['input']>;
  /** The chat's registry entry for this call, in the browser's kickoff shape (toolCallId, announced, client). */
  copilotKickoff: Scalars['JSON']['input'];
  /** The design the Copilot conversation is about; the user must be able to edit it, and its team is billed. */
  designHash: Scalars['String']['input'];
  /** Video: one clip's length in seconds. Not with storyboardSeconds. */
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  mode: CopilotGenerationMode;
  /** The design's Brand Kit look is added to the request. */
  onBrand: Scalars['Boolean']['input'];
  /** The prompt as the model wrote it; an image's style is folded in here, as the browser card does. */
  prompt: Scalars['String']['input'];
  /** Pictures the result builds on, in order. */
  referenceImageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The stream request the call came from, one per attempt of a turn. */
  requestId?: InputMaybe<Scalars['String']['input']>;
  /** Video: the provider resolution, such as 720p. Defaults to 720p. */
  resolution?: InputMaybe<Scalars['String']['input']>;
  /** Video: a long video's length in seconds; it is planned, generated and joined from scenes. */
  storyboardSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** Image: a style preset key or free text. Omitted for no style. */
  style?: InputMaybe<Scalars['String']['input']>;
  /** The Copilot thread the call came from. Omitted when the caller has none. */
  threadId?: InputMaybe<Scalars['String']['input']>;
  /** The Copilot turn the call came from. With requestId, only the first attempt of a turn to start a job starts any. */
  turnId?: InputMaybe<Scalars['String']['input']>;
  /** Image: how many pictures, each billed. */
  variants?: InputMaybe<Scalars['Int']['input']>;
};

export type InputStartCopilotMediaImport = {
  chatThreadId: Scalars['String']['input'];
  /** The design the Copilot conversation is about; the user must be able to edit it. */
  designHash: Scalars['String']['input'];
  toolCallId: Scalars['String']['input'];
  /** A web page, or a direct image or video link. */
  url: Scalars['String']['input'];
};

export type InputStartCopilotSceneEdit = {
  /** The design the Copilot conversation is about; the user must be able to edit it, and its team is billed. */
  designHash: Scalars['String']['input'];
  /** The finished long video's media hash. */
  generationHash: Scalars['String']['input'];
  /** The stream request the call came from, one per attempt of a turn. */
  requestId?: InputMaybe<Scalars['String']['input']>;
  /** Only the scenes the user's words touch. */
  scenes: Array<InputCopilotSceneChange>;
  /** The Copilot thread the call came from. Omitted when the caller has none. */
  threadId?: InputMaybe<Scalars['String']['input']>;
  /** The editVideoScenes call, recorded on the new video's registry entry. */
  toolCallId: Scalars['String']['input'];
  /** The Copilot turn the call came from. With requestId, only the first attempt of a turn to start a job starts any. */
  turnId?: InputMaybe<Scalars['String']['input']>;
};

export type InputStartDraftedMultiSceneChain = {
  /** The MULTISCENE parent operation created by startVideoGenerationFromPrompt with a storyboard. */
  operationId: Scalars['Int']['input'];
  /** One drafted scene per planned duration, in order. */
  scenes: Array<InputDraftedMultiSceneScene>;
};

export type InputStartImageUpscale = {
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  createMedia?: InputMaybe<Scalars['Boolean']['input']>;
  faceEnhance?: InputMaybe<Scalars['Boolean']['input']>;
  image: Scalars['String']['input'];
  moodboardContext?: InputMaybe<InputMoodboardContext>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  scale: Scalars['Float']['input'];
  teamId: Scalars['Int']['input'];
};

/** What a signed-in user decides about a layered ad (startLayeredAd); everything else is derived on the server. */
export type InputStartLayeredAd = {
  /** An animated ad: the background becomes a short video clip, the words, logo and button stay still. Refused (LAYERED_AD_REFUSED, ANIMATION_NOT_AVAILABLE) for a team without animated ads, and like any AI video for a plan, trial or balance without it. */
  animated?: InputMaybe<Scalars['Boolean']['input']>;
  /** 'preserve' (default) or 'inspiration'. */
  attachedImageUsage?: InputMaybe<Scalars['String']['input']>;
  /** Images from the team's library, by media hash: featured as they are (preserve), or as style cues (inspiration). */
  attachedMediaHashes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** How many leading attached images are real products to keep together; omit for one. */
  attachedSubjectCount?: InputMaybe<Scalars['Int']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  cta?: InputMaybe<Scalars['String']['input']>;
  /** The design to fill: its size is the ad's, its brand kit the ad's brand. */
  designHash: Scalars['String']['input'];
  /** The ad's words go as given, even one alone. With none of headline, body, cta and texts, the server writes the headline, body and cta from the prompt, the images and the brand kit, as the app's brief does (none for a minimal-style brand or a prompt asking for no text), and refuses (LAYERED_AD_REFUSED, COPY_NOT_WRITTEN) with nothing spent when it cannot. */
  headline?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<LayeredAdLogoChoice>;
  /** The visual direction: what the ad shows and how it looks. */
  prompt: Scalars['String']['input'];
  texts?: InputMaybe<Array<InputLayeredAdText>>;
};

export type InputStartMotionDraftClip = {
  aspectRatio: Scalars['String']['input'];
  /** Which of the draft's clips this is (1, then 2 for the retry): a replay of the same attempt returns its operation. */
  attempt: Scalars['Int']['input'];
  draftId: Scalars['Int']['input'];
  durationSeconds: Scalars['Int']['input'];
  /** The clip's first frame: the hero framed for the clip's aspect. */
  imageUrl: Scalars['String']['input'];
  motionType?: InputMaybe<Scalars['String']['input']>;
  prompt: Scalars['String']['input'];
  resolution: Scalars['String']['input'];
};

export type InputStartRecomposeResize = {
  brandKitId: Scalars['Int']['input'];
  /**
   * The canvas to generate at — the TARGET size's real pixel dimensions, not
   * the source design's. Stated outright because the pipeline resolves a canvas
   * from `designHash` otherwise, which would hand the re-frame the source's own
   * aspect (nothing to extend), and because a brand-new add-sizes format has no
   * target design to resolve from at all.
   */
  canvas: InputRecomposeCanvas;
  /** The source design's ACTION (button) label. Absent when it has no button. */
  cta?: InputMaybe<Scalars['String']['input']>;
  /** The design being resized FROM. Never written to. */
  designHash: Scalars['String']['input'];
  /**
   * Which brand-kit logo VARIANT to prefer, by src URL (the engine's
   * `preferredLogoSrc` picks among `brand.logos`; it is not an arbitrary image).
   * The modal sends none: it has no reliable way to map a source design's image
   * layer back onto a brand-kit logo, and the engine resolves one from the brand
   * kit on its own. Kept so a caller that DOES know the variant can state it.
   */
  logoSrc?: InputMaybe<Scalars['String']['input']>;
  /** The source design's clean background plate, to be re-framed outward. */
  reframeBaseImageUrl: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
  /** Role-mapped copy lifted from the source design. */
  texts: Array<InputRecomposeText>;
};

export type InputStartVideoDubbing = {
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  /** The Copilot chat thread the dub was started from; recorded on the ai_studio_generation row once verified. */
  chatThreadId?: InputMaybe<Scalars['String']['input']>;
  /** What the Copilot client knew when it started the dub ({ toolCallId, announced, client }). Capped at 32 KB. */
  copilotKickoff?: InputMaybe<Scalars['JSON']['input']>;
  /** Design hash of the Ad Studio design the dub was asked for on. */
  designHash?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** Media hash of the source video (team-owned, processed, MP4, up to 100 seconds). The server builds the permanent URL itself. */
  sourceMediaHash: Scalars['String']['input'];
  /** A VIDEO_DUBBING_LANGUAGES code (see packages/shared), e.g. es or pt-BR. */
  targetLanguage: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
  /** A curated Gemini voice id (see VOICEOVER_VOICES in packages/shared); defaults to Kore. */
  voiceId?: InputMaybe<Scalars['String']['input']>;
};

export type InputStartVoiceoverGeneration = {
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  /** The design whose Media library files the finished clip (the Ad Studio library design id). */
  designId?: InputMaybe<Scalars['Int']['input']>;
  /** Optional delivery instruction, e.g. 'upbeat, confident'; up to 200 characters. */
  instruction?: InputMaybe<Scalars['String']['input']>;
  /** Optional language of the script, a LanguageCodes value such as DE or PT-BR. */
  language?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** The narration, 1–1000 characters after whitespace is collapsed. */
  script: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
  /** A curated Gemini voice id (see VOICEOVER_VOICES in packages/shared); defaults to Kore. */
  voiceId?: InputMaybe<Scalars['String']['input']>;
};

export type InputStickyAdsAccess = {
  stickyAdsAccess: Scalars['Boolean']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputStockAudio = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<InputStockMediaFilters>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type InputStockMedia = {
  after?: InputMaybe<Scalars['String']['input']>;
  designHash?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<InputStockMediaFilters>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  mediaType?: InputMaybe<StockMediaTypes>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  source: StockMediaSource;
};

export type InputStockMediaFilters = {
  aspectRatio?: InputMaybe<MediaFilterAspectRatio>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  category?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  hasVocals?: InputMaybe<Scalars['Boolean']['input']>;
  maxBpm?: InputMaybe<Scalars['Int']['input']>;
  maxDuration?: InputMaybe<Scalars['Int']['input']>;
  minBpm?: InputMaybe<Scalars['Int']['input']>;
  minDuration?: InputMaybe<Scalars['Int']['input']>;
  orientation?: InputMaybe<MediaOrientationType>;
  people?: InputMaybe<Scalars['Boolean']['input']>;
  peopleAge?: InputMaybe<Scalars['String']['input']>;
  peopleEthnicity?: InputMaybe<Array<Scalars['String']['input']>>;
  peopleGender?: InputMaybe<ShutterStockPeopleGender>;
  peopleNumber?: InputMaybe<Scalars['Int']['input']>;
  resolution?: InputMaybe<MediaFilterResolution>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type InputStopAiAgentAutomationSchedule = {
  projectId?: InputMaybe<Scalars['Int']['input']>;
  scheduleId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

/** Input for stopping A/B tests for a team. */
export type InputStopTeamAbTests = {
  /** ID of the team to stop A/B tests for. */
  teamId: Scalars['Int']['input'];
};

export type InputStorblocksItem = {
  designHash: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  resolution?: InputMaybe<MediaFilterResolution>;
};

export type InputStoreCopilotDocumentImage = {
  /** The image bytes, base64: a PNG or a JPEG of at most 7 MB decoded. */
  dataBase64: Scalars['String']['input'];
  /** The design the Copilot conversation is about; the user must be able to edit it. */
  designHash: Scalars['String']['input'];
};

export type InputStoredFontBackup = {
  hash: Scalars['String']['input'];
};

export type InputSubscription = {
  isMigrate?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<SubscriptionStatus>;
  teamId: Scalars['Int']['input'];
};

export type InputSubscriptionPlan = {
  subscriptionId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputSubscriptionPlanVersion = {
  teamId: Scalars['Int']['input'];
};

export type InputSubscriptionTermEnd = {
  teamId: Scalars['Int']['input'];
};

export type InputSuggestContentVariationTargets = {
  designHash: Scalars['String']['input'];
  layers: Array<InputVariationLayer>;
};

export type InputSuggestFeedColumnBindings = {
  columns: Array<FeedBindingColumnInput>;
  layers: Array<FeedBindingLayerInput>;
};

export type InputSuperbet = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  eventType: Scalars['String']['input'];
  events?: InputMaybe<Array<InputSuperbetEvent>>;
  marketLanguage: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  /** Superbet sport id for a Competition feed: 5 football (the default), 4 basketball, 2 tennis. */
  sportId?: InputMaybe<Scalars['Int']['input']>;
  startEndDate?: InputMaybe<Array<Scalars['Date']['input']>>;
  tournaments?: InputMaybe<Array<InputSuperbetTournament>>;
};

export type InputSuperbetEvent = {
  eventId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type InputSuperbetTournament = {
  name: Scalars['String']['input'];
  tournamentId: Scalars['Int']['input'];
};

export type InputSyncFeed = {
  id: Scalars['Int']['input'];
  processingMode?: InputMaybe<FeedProcessingMode>;
};

export type InputSyncFeedInternal = {
  feedId: Scalars['Int']['input'];
};

/** Input for syncing a card hash after video processing */
export type InputSyncMoodBoardCardHash = {
  /** The card ID to update */
  cardId: Scalars['String']['input'];
  /** The new hash (CDN reference) for the card */
  hash: Scalars['String']['input'];
  /** The moodboard hash */
  moodBoardHash: Scalars['String']['input'];
};

/** A user request to drop one recorded divergence and take the master value. */
export type InputSyncRelink = {
  /** The designSizeTypeId of the variation size the relink applies to. */
  designSizeTypeId: Scalars['Int']['input'];
  /** bannersetElementId scope; omit for design-scope properties or root-container order. */
  el?: InputMaybe<Scalars['Int']['input']>;
  kind: SyncRelinkKind;
  /** Dot path for PROPERTY relinks (e.g. properties.url). */
  path?: InputMaybe<Scalars['String']['input']>;
};

/** A user request to withhold one master change on this sync (the variation keeps its own value). */
export type InputSyncSkip = {
  /** The designSizeTypeId of the variation size the skip applies to. */
  designSizeTypeId: Scalars['Int']['input'];
  /** bannersetElementId scope: the changed element for PROPERTY, the added layer for ADDED_ELEMENT; omit for design-scope properties. */
  el?: InputMaybe<Scalars['Int']['input']>;
  kind: SyncSkipKind;
  /** Dot path for PROPERTY skips (e.g. properties.config). */
  path?: InputMaybe<Scalars['String']['input']>;
};

export type InputSyncSubscription = {
  teamId: Scalars['Int']['input'];
};

export type InputSyncSubscriptionWithRecurly = {
  teamId: Scalars['Int']['input'];
};

/** One variation to sync from the master. */
export type InputSyncVariationTarget = {
  /** Recorded divergences to drop on this sync (the master value wins for them). */
  relinks?: InputMaybe<Array<InputSyncRelink>>;
  /** Master changes to withhold on this sync (the variation keeps its own value; persisted as an override). */
  skips?: InputMaybe<Array<InputSyncSkip>>;
  syncText?: InputMaybe<Scalars['Boolean']['input']>;
  variationHash: Scalars['String']['input'];
};

/** Input for syncing variations from their master. */
export type InputSyncVariationsFromMaster = {
  /** Abort with MASTER_CHANGED when the master's current per-size checksums differ — the client refetches and re-previews. */
  expectedMasterChecksums?: InputMaybe<Array<InputSizeChecksum>>;
  /** Hash of the master design (set or standalone). */
  masterHash: Scalars['String']['input'];
  targets: Array<InputSyncVariationTarget>;
};

export type InputTagCatalogProducts = {
  hash: Scalars['String']['input'];
  productKeys: Array<Scalars['String']['input']>;
  tag: Scalars['String']['input'];
};

export type InputTagContainer = {
  id: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

export type InputTagContainerGenerateCode = {
  codeFormat: AdTagCodeFormat;
  projectId: Scalars['Int']['input'];
  tagContainerId: Scalars['Int']['input'];
};

/** Input for retrieving a specific team. */
export type InputTeam = {
  /** ID of the team to retrieve. */
  id: Scalars['Int']['input'];
  /** Whether this is for migration purposes. */
  isMigrate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputTeamAbTests = {
  orderBy?: OrderBy;
  orderType?: OrderType;
  teamId: Scalars['Int']['input'];
};

export type InputTeamAnalyticsReport = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputTeamAttribution = {
  teamId: Scalars['Int']['input'];
};

/** Input for retrieving a team's brand kit. */
export type InputTeamBrandKit = {
  /** ID of the team whose brand kit to retrieve. */
  teamId: Scalars['Int']['input'];
};

/** Input for retrieving client IDs for a team. */
export type InputTeamClientId = {
  /** ID of the team to get client IDs for. */
  teamId: Scalars['Int']['input'];
  /** ID of the user who created the client IDs (optional). */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for creating a new team. */
export type InputTeamCreate = {
  /** When true, create the team as active (skip the paranoid deletedAt placeholder used by the standard dormant-team onboarding flow). Defaults to false. */
  activate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the team to create. */
  name: Scalars['String']['input'];
  /** When true, set the team's brand kit up as signup does: extract the brand from the owner's work-email domain (any other owner keeps the kit empty). For the team a user starts from the domain-trial-ineligible onboarding, whose signup created no default team. Defaults to false. */
  signupBrandKit?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for updating a team's debug status. */
export type InputTeamDebugStatus = {
  /** Whether to enable debugging. */
  enabled: Scalars['Boolean']['input'];
  /** ID of the team to update. */
  teamId: Scalars['Int']['input'];
};

export type InputTeamFrequentlyUsedDesignSizeTypes = {
  teamId: Scalars['Int']['input'];
};

export type InputTeamIntegration = {
  teamId: Scalars['Int']['input'];
};

export type InputTeamIntegrationByTeamUserId = {
  teamUserId: Scalars['Int']['input'];
};

/** Input for retrieving a team's owner. */
export type InputTeamOwner = {
  /** ID of the team to get the owner for. */
  teamId: Scalars['Int']['input'];
};

export type InputTeamPaymentVariant = {
  teamId: Scalars['Int']['input'];
};

export type InputTeamPricingSource = {
  teamId: Scalars['Int']['input'];
};

export type InputTeamRole = {
  id: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputTeamRoleName = {
  name: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputTeamRoles = {
  teamId: Scalars['Int']['input'];
};

/** Input for retrieving team settings. */
export type InputTeamSettings = {
  /** ID of the team to get settings for. */
  teamId: Scalars['Int']['input'];
};

/** Input for retrieving a team's success manager. */
export type InputTeamSuccessManager = {
  /** ID of the team to get the success manager for. */
  teamId: Scalars['Int']['input'];
};

export type InputTeamTwoFactor = {
  teamId: Scalars['Int']['input'];
};

/** Input for updating a team's properties. */
export type InputTeamUpdate = {
  /** Whether brand kit wizard is enabled for the team (optional). */
  brandkitWizard?: InputMaybe<Scalars['Boolean']['input']>;
  /** Logo identifier for the team (optional). */
  logo?: InputMaybe<Scalars['String']['input']>;
  /** New name for the team (optional). */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of the team to update. */
  teamId: Scalars['Int']['input'];
  /** Total number of designs created in the team (optional). */
  totalDesignsCreated?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for retrieving a team user group. */
export type InputTeamUserGroup = {
  /** ID of the group to retrieve. */
  groupId: Scalars['Int']['input'];
  /** ID of the team that owns the group. */
  teamId: Scalars['Int']['input'];
};

/** Input for retrieving all user groups in a team. */
export type InputTeamUserGroups = {
  /** ID of the team to get groups from. */
  teamId: Scalars['Int']['input'];
};

/** Input for retrieving webhooks for a team. */
export type InputTeamWebhook = {
  /** ID of the team to get webhooks for. */
  teamId: Scalars['Int']['input'];
  /** ID of the user who created the webhooks (optional). */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for retrieving data about a webhook. */
export type InputTeamWebhookId = {
  /** ID of the team that owns the webhook. */
  teamId: Scalars['Int']['input'];
  /** ID of the webhook to retrieve. */
  webhookId: Scalars['Int']['input'];
};

/** Input for retrieving teams owned by a user. */
export type InputTeamsOwnedByUser = {
  /** ID of the user to get owned teams for. */
  userId: Scalars['Int']['input'];
};

export type InputTemplateCategoriesWebsite = {
  filter?: InputMaybe<InputTemplateCategoriesWebsiteFilter>;
};

export type InputTemplateCategoriesWebsiteFilter = {
  /** Design size type ID to filter by. */
  designSizeTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** Whether to show only templates visible in the app. */
  showInApp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show only templates visible in the gallery. */
  showInGallery?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Input for template hash and tags data.
 * Used for bulk updating template tags by hash.
 */
export type InputTemplateHashTag = {
  /** Hash of the design to find templates for. */
  hash: Scalars['String']['input'];
  /** Comma-separated list of tags to assign. */
  tags: Scalars['String']['input'];
};

/** Input for retrieving website templates with pagination. */
export type InputTemplatesWebsite = {
  /** Pagination cursor for templates. */
  cursor: Scalars['String']['input'];
};

/**
 * Input for filtering templates on the website.
 * Used for public-facing template gallery filtering.
 */
export type InputTemplatesWebsiteFilter = {
  /** Category IDs to filter by. */
  categories?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** When true, templates are shuffled with a deterministic order that changes daily. */
  dailyShuffle?: InputMaybe<Scalars['Boolean']['input']>;
  /** Design dimensions to filter by. */
  designDimensions?: InputMaybe<Array<InputDesignDimensions>>;
  /** Design size types to filter by. */
  designSizeTypes?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Whether to filter templates suitable for the user's company industry. */
  forCompanyIndustry?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Read with designSizeTypes. When neither they nor designDimensions resolve to
   * a system size type, keep only the templates that have a live size within 5%
   * of a designDimensions aspect ratio, instead of applying no size filter.
   */
  matchDesignDimensions?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search term to filter templates by name. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Whether to show only templates visible in the app. */
  showInApp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show only templates visible in the gallery. */
  showInGallery?: InputMaybe<Scalars['Boolean']['input']>;
  /** Tag IDs to filter by. */
  tags?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Type of design size (STATIC, ANIMATED, VIDEO). */
  type?: InputMaybe<DesignSizeTypeTypes>;
};

/** Input for ordering website templates. */
export type InputTemplatesWebsiteOrderBy = {
  /** Field to order by, defaults to CREATED_AT. */
  orderBy?: TemplatesWebsiteOrderByFields;
  /** Direction of ordering, defaults to DESC. */
  orderType?: OrderType;
};

export type InputTemporaryDownloadPreview = {
  downloadType: DownloadType;
  hash: Scalars['String']['input'];
  position?: InputMaybe<Scalars['String']['input']>;
  slideId: Scalars['Int']['input'];
};

export type InputTemporaryPreview = {
  hash: Scalars['String']['input'];
  slideId: Scalars['Int']['input'];
};

export type InputTestCloudinaryConnection = {
  teamId: Scalars['Int']['input'];
};

export type InputTextExtraction = {
  imageHash?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputTextGeneration = {
  app?: InputMaybe<Scalars['String']['input']>;
  brandVoice?: InputMaybe<InputBrandVoiceTextGeneration>;
  context: GenerationContext;
  /** @deprecated Use targetLanguage instead */
  language?: InputMaybe<GenerationLanguage>;
  maxLength?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Use maxLength instead */
  maxWords?: InputMaybe<Scalars['Int']['input']>;
  minLength?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Use minLength instead */
  minWords?: InputMaybe<Scalars['Int']['input']>;
  targetLanguage?: InputMaybe<GenerationLanguageCode>;
  teamId: Scalars['Int']['input'];
  type: GenerationType;
  userId?: InputMaybe<Scalars['Int']['input']>;
  userPrompt?: InputMaybe<Scalars['String']['input']>;
  variants?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Use brandVoice instead */
  voiceTone?: InputMaybe<GenerationVoiceToneType>;
};

export type InputThresholdAddonsUsage = {
  teamId: Scalars['Int']['input'];
};

export type InputTikTokPublishUpdateStatus = {
  count: Scalars['Int']['input'];
  creditTransactionId?: InputMaybe<Scalars['Int']['input']>;
  designHash: Scalars['String']['input'];
  error?: InputMaybe<PublishErrorInput>;
  /** @BreakingBad is mandatory */
  jobData: Scalars['JSON']['input'];
  jobId?: InputMaybe<Scalars['String']['input']>;
  success: Scalars['Boolean']['input'];
  userId: Scalars['Int']['input'];
};

export type InputToggleTeamSettingsFeatureAccess = {
  feature: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
  value?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputTrackAiResizeStepFailed = {
  anonymousId?: InputMaybe<Scalars['String']['input']>;
  errorCode?: InputMaybe<Scalars['Int']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  hash: Scalars['String']['input'];
  isOpusVersion?: InputMaybe<Scalars['Boolean']['input']>;
  resizeType: Scalars['String']['input'];
  slideId: Scalars['Int']['input'];
  startTime?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  step?: InputMaybe<Scalars['String']['input']>;
  targetHash: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputTrackSegmentEvent = {
  eventName: Scalars['String']['input'];
  /** Payload which is sent to segment */
  payload: Scalars['JSON']['input'];
  /** Segment properties */
  segmentProperties: SegmentProperties;
};

export type InputTranslateLightEditorCopy = {
  /** Design the caller can edit. Authorizes the request and selects the team's translator. */
  hash: Scalars['String']['input'];
  /** Ignored. Locks and character caps follow the team's customize-template-permissions entitlement. */
  ignoreContentPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  /** The selected size's current banner, including unsaved text. This is the copy that is translated. */
  json: Scalars['JsonDesign']['input'];
  /** Element keys to translate (bannersetElementId, falling back to id). Omitted, every editable layer is translated. An empty list translates nothing. */
  layerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Other sizes of this design set. Ids outside the set, and repeated ids, are ignored. Each patch is rebuilt from that size's banner instead of copying the selected size's config. */
  sizes?: InputMaybe<Array<InputTranslateLightEditorSize>>;
  /** Detected source language. Omitted, the translator detects it. */
  sourceLanguage?: InputMaybe<Scalars['String']['input']>;
  /** Target language code, the same codes language variations accept. */
  targetLanguage: Scalars['String']['input'];
};

export type InputTranslateLightEditorSize = {
  /** Open size this banner belongs to. */
  designId: Scalars['Int']['input'];
  /** That size's current banner, including unsaved text. */
  json: Scalars['JsonDesign']['input'];
};

/**
 * Input for fetching trash items with pagination and sorting options.
 * Default ordering is by deletion date in descending order (newest first).
 */
export type InputTrashItems = {
  /** Pagination cursor for fetching the next page of results. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Field to order the trash items by (name or deletedAt). */
  orderBy?: TrashOrderBy;
  /** Order direction (ASC or DESC). */
  orderType?: OrderType;
  /** ID of the team whose trash items should be fetched. */
  teamId: Scalars['Int']['input'];
};

export type InputTriggerCraftedAdsIfReady = {
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

export type InputTriggerDpaSync = {
  hash: Scalars['String']['input'];
};

export type InputTrimVideo = {
  /** Seconds from the start of the clip. Clamped server-side to the clip's real duration. */
  endTime: Scalars['Float']['input'];
  /** Seconds from the start of the clip. Must be >= 0 and lower than endTime. */
  startTime: Scalars['Float']['input'];
  videoUrl: Scalars['String']['input'];
};

export type InputTutorial = {
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type InputTwoFactor = {
  /** Whether to enable or disable two-factor authentication. */
  enableTwoFactor: Scalars['Boolean']['input'];
};

/** Typography configuration for text in a brand kit. */
export type InputTypography = {
  /** ID of the font in the brand kit (optional). */
  fontId?: InputMaybe<Scalars['Int']['input']>;
  /** Name of the font to use. */
  fontName: Scalars['String']['input'];
  /** Size of the font in pixels. */
  fontSize: Scalars['Int']['input'];
  /** Weight of the font (e.g., 'regular', 'bold'). */
  fontWeight: Scalars['String']['input'];
  /** Line height multiplier (optional). */
  lineHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Type of typography (e.g., 'heading', 'body', 'button'). */
  type: Scalars['String']['input'];
};

/** Input for removing sharing of a design. */
export type InputUnShareDesign = {
  /** ID of the design to unshare. */
  designId: Scalars['Int']['input'];
  /** ID of the user or group to remove sharing from. */
  id: Scalars['Int']['input'];
  /** Type of entity (SINGLE for user, GROUP for group). */
  type: UserOrgType;
};

export type InputUnShareFolder = {
  folderId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  type: UserOrgType;
};

export type InputUndoDeleteFolder = {
  folderId: Scalars['Int']['input'];
  fromTrash?: InputMaybe<Scalars['Boolean']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputUpdateAccessToken = {
  integrationApp: Integrations;
  teamId?: InputMaybe<Scalars['Int']['input']>;
  type: IntegrationAccountType;
  /** Marks the integration as personal. It is always the signed-in user's own; the id sent is ignored. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for updating ad serving access.  @depracated(remove this) */
export type InputUpdateAdServingAccess = {
  /** Whether to enable ad serving access. */
  access: Scalars['Boolean']['input'];
  /** ID of the team to update settings for. */
  teamId: Scalars['Int']['input'];
};

/** Input for updating the ad serving code for a design. */
export type InputUpdateAdServingCode = {
  /** The ID of the design. */
  designId: Scalars['Int']['input'];
  /** Re-sync every member of this design's variation family, not just the design itself. */
  includeVariations?: InputMaybe<Scalars['Boolean']['input']>;
  /** The reason for the synchronization. */
  syncReason: AdServingSyncReason;
};

/** Input for updating ad serving settings for a design. */
export type InputUpdateAdServingSettings = {
  /** Ad tag properties. @BreakingBad */
  adTagProps?: InputMaybe<InputAdServingProps>;
  /** The ID of the design. */
  designId: Scalars['Int']['input'];
  /** Ad scaling 'Scale + reflow' (only takes effect when responsiveScaling is true). */
  responsiveReflow?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if responsive scaling is enabled. */
  responsiveScaling?: InputMaybe<Scalars['Boolean']['input']>;
  /** The target window for the URL. */
  target?: InputMaybe<Scalars['String']['input']>;
  /** The primary URL for the ad. */
  url?: InputMaybe<Scalars['String']['input']>;
  /** A suffix to append to the URL. */
  urlSuffix?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if the ad should use the URL as a click tag. */
  useAsClickTag?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputUpdateAdTagDynamicVars = {
  designId: Scalars['Int']['input'];
  dynamicVars?: InputMaybe<Array<InputAdTagDynamicVar>>;
};

export type InputUpdateAdTagExternalDesignTracking = {
  designId: Scalars['Int']['input'];
  urls: Array<InputAdTagExternalDesignTrackingUrl>;
};

export type InputUpdateAdTagSettings = {
  adTagProps?: InputMaybe<InputAdTagProps>;
  designId: Scalars['Int']['input'];
  responsiveScaling?: InputMaybe<Scalars['Boolean']['input']>;
  target?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  urlSuffix?: InputMaybe<Scalars['String']['input']>;
  useAsClickTag?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputUpdateAdminAdNetwork = {
  adTag: Scalars['Boolean']['input'];
  cachebusterMacro?: InputMaybe<Scalars['String']['input']>;
  clickTagMacro?: InputMaybe<Scalars['String']['input']>;
  html5: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  status: Scalars['Boolean']['input'];
  testOnly: Scalars['Boolean']['input'];
  type: Scalars['String']['input'];
};

export type InputUpdateAdminUser = {
  id: Scalars['Int']['input'];
  rights: InputAdminUserRights;
};

export type InputUpdateAgentSystemPrompt = {
  systemPrompt: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
  type: AgentType;
};

export type InputUpdateAiGenerationRulesFromChat = {
  brandKitId: Scalars['Int']['input'];
  field: AiGenerationRulesField;
  value: Scalars['String']['input'];
};

export type InputUpdateAiResizeModel = {
  fewShots: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  model: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  platform: ResizePlatform;
  prompt?: InputMaybe<Scalars['String']['input']>;
  systemPromptLandscape?: InputMaybe<Scalars['String']['input']>;
  systemPromptPortrait?: InputMaybe<Scalars['String']['input']>;
  temperature: Scalars['Float']['input'];
  useImage: Scalars['Boolean']['input'];
  variants: Scalars['Int']['input'];
};

export type InputUpdateAiResizePrompt = {
  id: Scalars['Int']['input'];
  prompt: Scalars['String']['input'];
  systemPromptLandscape: Scalars['String']['input'];
  systemPromptPortrait: Scalars['String']['input'];
};

export type InputUpdateAllowWorkspacesWithoutBrandKit = {
  status: Scalars['Boolean']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputUpdateAutomatedOptimizeReport = {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['Int']['input'];
  status: AiAgentAutomatedReportStatus;
};

export type InputUpdateAutomatedReportPublicStatus = {
  hash: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  publicStatus?: InputMaybe<PublicStatus>;
  teamId: Scalars['Int']['input'];
};

export type InputUpdateBillingInfo = {
  billingDetails?: InputMaybe<InputAddress>;
  paymentType?: InputMaybe<PaymentTypes>;
  teamId: Scalars['Int']['input'];
  threeDSecureToken?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type InputUpdateBrandDetails = {
  description?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  /** ID of the brand kit to update. */
  id: Scalars['Int']['input'];
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating AI generation rules on a brand kit. */
export type InputUpdateBrandKitAiGenerationRules = {
  /** AI generation rules to save (full object, replaces existing). */
  aiGenerationRules: InputAiGenerationRules;
  /** ID of the brand kit to update. */
  brandKitId: Scalars['Int']['input'];
};

export type InputUpdateBrandKitButton = {
  brandKitId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  properties: Scalars['JSON']['input'];
};

export type InputUpdateBrandKitDescription = {
  brandDescription: Scalars['String']['input'];
  brandKitId: Scalars['Int']['input'];
};

export type InputUpdateBrandKitProfile = {
  analyzedSources?: InputMaybe<Array<Scalars['String']['input']>>;
  brandKitId: Scalars['Int']['input'];
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  outcome: Scalars['String']['input'];
  profile?: InputMaybe<InputBrandProfileExtractionFields>;
  /** Version stamped on the job; a stale stamp is discarded. */
  version: Scalars['Int']['input'];
};

export type InputUpdateBrandKitStyle = {
  brandKitId: Scalars['Int']['input'];
  brandStyle: Scalars['JSON']['input'];
};

export type InputUpdateBrandKitWithFonts = {
  brandKitId: Scalars['Int']['input'];
  fonts: Array<InputCreateNextgenAiDesignFont>;
  teamId: Scalars['Int']['input'];
  url: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};

export type InputUpdateBrandTargetAudience = {
  /** Whether the brand audience was AI-suggested. */
  aiSuggestedBrandAudience: Scalars['Boolean']['input'];
  /** Description of the brand's audience. */
  brandAudience: Scalars['String']['input'];
  /** ID of the brand kit to update. */
  brandKitId: Scalars['Int']['input'];
  /** ID of the target audience to update. */
  id: Scalars['Int']['input'];
};

export type InputUpdateBulkDesigns = {
  designId: Scalars['Int']['input'];
  feedId: Scalars['Int']['input'];
  folderId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
  targetRow: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

export type InputUpdateBulkRemoveBgFeed = {
  creditTransactionId?: InputMaybe<Scalars['String']['input']>;
  feedHash: Scalars['String']['input'];
  urls: Array<Scalars['String']['input']>;
};

export type InputUpdateBulkRevertBgFeed = {
  feedHash: Scalars['String']['input'];
};

export type InputUpdateBulkSmartCropFeed = {
  /**
   * Checksum of the payload the flow parent just uploaded. Optional only because
   * apps/feed-sync and apps/graphql roll independently - a worker new enough to
   * send it may reach a pod that is not; feed-sync retries without it. Absent
   * means "do not touch feed.checksum", which is the pre-existing behaviour.
   */
  checksum?: InputMaybe<Scalars['String']['input']>;
  feedHash: Scalars['String']['input'];
};

/**
 * Catalog settings writes (CRE-420, §5). Omitted fields stay unchanged.
 * Currency is display-only (D20) and deliberately NOT editable here.
 */
export type InputUpdateCatalogSettings = {
  hash: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  /** Column products are matched on (R26); empty string or null = row-index mode. Written to feed.target_column. Omit to leave the setting untouched — null and empty string both mean row-index mode, which is NOT the same as omitting it */
  targetColumn?: InputMaybe<Scalars['String']['input']>;
  /** Sync schedule (§4.8) — never = manual */
  updateFrequency?: InputMaybe<UpdateFrequencyType>;
};

export type InputUpdateCloneFromUrlStatus = {
  status: Scalars['Boolean']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputUpdateColorPalette = {
  brandKitId: Scalars['Int']['input'];
  colors: Array<InputColor>;
  id: Scalars['Int']['input'];
};

export type InputUpdateColorPaletteOrder = {
  brandKitId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  sortOrder: Scalars['Int']['input'];
};

export type InputUpdateComment = {
  authorEmail?: InputMaybe<Scalars['String']['input']>;
  authorName?: InputMaybe<Scalars['String']['input']>;
  commentId: Scalars['Int']['input'];
  designHash?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
};

export type InputUpdateCompany = {
  companyId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<Scalars['String']['input']>;
  planActivatedAt?: InputMaybe<Scalars['String']['input']>;
  planCanceledAt?: InputMaybe<Scalars['String']['input']>;
  planEndAt?: InputMaybe<Scalars['String']['input']>;
  planExpiresAt?: InputMaybe<Scalars['String']['input']>;
  planFrequency?: InputMaybe<Scalars['String']['input']>;
  planStartAt?: InputMaybe<Scalars['String']['input']>;
  planState?: InputMaybe<Scalars['String']['input']>;
  trial?: InputMaybe<Scalars['Boolean']['input']>;
  trialEndAt?: InputMaybe<Scalars['String']['input']>;
  trialStartAt?: InputMaybe<Scalars['String']['input']>;
};

export type InputUpdateCopilotAiChatPublicStatus = {
  hash: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  publicStatus?: InputMaybe<PublicStatus>;
  teamId: Scalars['Int']['input'];
};

export type InputUpdateCopilotAiReportPublicStatus = {
  hash: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  publicStatus?: InputMaybe<PublicStatus>;
  teamId: Scalars['Int']['input'];
};

export type InputUpdateCron = {
  name: Scalars['String']['input'];
  status: CronStatus;
};

/** Input type for updating a custom ad network. */
export type InputUpdateCustomAdNetwork = {
  /** The new cachebuster macro for the ad network. */
  cachebusterMacro?: InputMaybe<Scalars['String']['input']>;
  /** The new click tag macro for the ad network. */
  clickTagMacro?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the ad network to update. */
  id: Scalars['Int']['input'];
  /** The new logo URL for the ad network. */
  logo?: InputMaybe<Scalars['String']['input']>;
  /** The new name for the ad network. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The new status for the ad network. */
  status?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the team associated with the ad network. */
  teamId: Scalars['Int']['input'];
};

/**
 * Input for updating a design's content.
 * Use this to save changes to a design's JSON data.
 */
export type InputUpdateDesign = {
  /** ID of the design size type (optional). */
  designSizeTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** The stored version (the row checksum) the caller read this design at. updateDesigns refuses the whole batch with DESIGN_VERSION_CONFLICT, writing none of it, when a design sent with one is no longer at it. Absent or null checks nothing. Only updateDesigns checks it: the single-design updateDesign mutations ignore it, since they can write a set's only size rather than the hash they were sent. Sent by the Variations tab's bulk edit Apply. */
  expectedChecksum?: InputMaybe<Scalars['String']['input']>;
  /** Opaque product-set attachment revision that this JSON materializes. Omitted by legacy clients. */
  expectedFeedAttachmentRevision?: InputMaybe<Scalars['String']['input']>;
  /** False for intermediate sequential batches; true/omitted only when this request may acknowledge set-wide product-set materialization. */
  finalizeFeedMaterialization?: InputMaybe<Scalars['Boolean']['input']>;
  /** Monotonic hint that the full set being materialized has at least one feed-bound size. Used only to preserve a true aggregate across sequential batches. */
  hasFeedMaterializationBindings?: InputMaybe<Scalars['Boolean']['input']>;
  /** Hash of the design to update. */
  hash: Scalars['String']['input'];
  /** Updated JSON representation of the design content. */
  json: Scalars['JsonDesign']['input'];
  /** Keep a content-addressed copy of the document this write overwrites, so the Variations tab undo can restore it by the row checksum (see docs/adstudio-variations-master-sync.md, Variations tab undo/redo). Set by the Variations tab's own saves, and by the new Ad Studio autosave only for the tab's 'main design changes' step: on a master row's saves until one confirms it moved the row, never on every save. */
  keepPreviousVersion?: InputMaybe<Scalars['Boolean']['input']>;
  /** The server time (Design.readAt) the editor tab first loaded the design at. updateDesigns refuses the whole batch with DESIGN_CHANGED_OUTSIDE_EDITOR, writing none of it, while an edit from the user's AI assistant runs on a design sent with one, or when one ended after it. Absent or null checks nothing. Only updateDesigns checks it, as expectedChecksum. */
  openedAt?: InputMaybe<Scalars['Float']['input']>;
  /** Record no CROSS-SIZE customisation for this write; both override captures still run. For the new Ad Studio autosave's save of a parked size (one it keeps off the stage) that Quick connect's bind of every size wrote, a set-wide change like the Connect layers step's. On a variation the variation capture records it, so the next master sync keeps it as it keeps the main size's; on a master the size gets its cross-size record, empty when it has none, so a later star reads the change as the size's own (see docs/adstudio-variations-master-sync.md, Server-side capture). skipSyncOverrideCapture skips both captures and wins over this. */
  skipCrossSizeCustomisations?: InputMaybe<Scalars['Boolean']['input']>;
  /** Skip the variation / cross-size override CAPTURE for this write. Set by undo/redo restores — they replay a prior state, so capturing would falsely record the reverted paths as user customisations (see docs/adstudio-variations-master-sync.md, Variations tab undo/redo). Never set on a genuine user edit. */
  skipSyncOverrideCapture?: InputMaybe<Scalars['Boolean']['input']>;
  /** Hash of the source template, when this update represents a template replacement. The design's templateId is recomputed from this hash. */
  templateHash?: InputMaybe<Scalars['String']['input']>;
};

/** Input for changing a design's approval status. */
export type InputUpdateDesignApprovalStatus = {
  /** Optional comment. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** The design hash. */
  designHash: Scalars['String']['input'];
  /** The target status ID. */
  toStatusId: Scalars['String']['input'];
};

/**
 * Input for updating HTML export settings for a design.
 * These settings control how a design is exported to HTML.
 */
export type InputUpdateDesignHtmlSettings = {
  /** IDs of ad networks to optimize for. */
  adNetworksIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Whether to convert custom fonts to web-safe formats. */
  convertCustomFonts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Hash of the design to update HTML settings for. */
  designHash: Scalars['String']['input'];
  /** Whether to include a fallback static image. */
  fallbackImage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Image quality percentage for exported images (1-100). */
  imageQuality?: InputMaybe<Scalars['Int']['input']>;
  /** Whether to minify the HTML output. */
  minifyHtml?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the exported HTML scales to fit the container it's opened in. */
  responsiveScaling?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to generate retina (2x) images. */
  retina?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to only generate retina images (no 1x images). */
  retinaOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** HTML target attribute for the link (_blank, _self, etc.). */
  target?: InputMaybe<Scalars['String']['input']>;
  /** Target URL for the design when clicked. */
  url?: InputMaybe<Scalars['String']['input']>;
  /** Whether to use the design URL as a click tag for ads. */
  useAsClickTag?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputUpdateDesignMainDesign = {
  /** Hash of the design SET whose main design is being chosen. */
  hash: Scalars['String']['input'];
  /** Id of that SET's size child to hydrate as the main design. */
  mainDesignId: Scalars['Int']['input'];
};

export type InputUpdateDesignMeasureUnit = {
  currentMeasureUnit: MeasureUnit;
  hash: Scalars['String']['input'];
  measureUnit: MeasureUnit;
};

/**
 * Input for updating a design set.
 * Use this to update multiple designs in a set simultaneously.
 */
export type InputUpdateDesignSet = {
  /** Updated design JSONs for each design in the set. */
  designJsons: Array<InputJsonDesignWithHash>;
  /** Updated JSON representation of the design set. */
  designSetJson: Scalars['JSON']['input'];
  /** Hash of the design set to update. */
  hash: Scalars['String']['input'];
};

export type InputUpdateDesignSize = {
  hash: Scalars['String']['input'];
  qId: Scalars['String']['input'];
  size: Scalars['Float']['input'];
};

/**
 * Input for updating a design's size type.
 * Use this to change the categorization of a design's dimensions.
 */
export type InputUpdateDesignSizeTypeId = {
  /** New design size type ID to assign. */
  designSizeTypeId: Scalars['Int']['input'];
  /** Hash of the design to update. */
  hash: Scalars['String']['input'];
};

export type InputUpdateDisableAutoBackgroundRemovalInLightEditor = {
  status: Scalars['Boolean']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputUpdateDisableBrandKitInLightEditor = {
  status: Scalars['Boolean']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputUpdateDisableEditorAutoSave = {
  status: Scalars['Boolean']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputUpdateEditorSettings = {
  actionsOpen?: InputMaybe<Scalars['Boolean']['input']>;
  adServingPopupDismissedAt?: InputMaybe<Scalars['Int']['input']>;
  adStudioAssistantOpen?: InputMaybe<Scalars['Boolean']['input']>;
  adStudioEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  adStudioReminderDismissDate?: InputMaybe<Scalars['Int']['input']>;
  adStudioReminderEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  adStudioSwitchBackBannerDismissed?: InputMaybe<Scalars['Boolean']['input']>;
  aiEmailNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  aiImageOpen?: InputMaybe<Scalars['Boolean']['input']>;
  aiResizeModelId?: InputMaybe<Scalars['Int']['input']>;
  autoZoomInFocusMode?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundOpen?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundRemoverOpen?: InputMaybe<Scalars['Boolean']['input']>;
  brandKitComponentsNotification?: InputMaybe<Scalars['Boolean']['input']>;
  brandKitEmptyComponents?: InputMaybe<Scalars['Boolean']['input']>;
  brandKitSetupDeclined?: InputMaybe<Scalars['Boolean']['input']>;
  confirmedScanBrandKitIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  cropOpen?: InputMaybe<Scalars['Boolean']['input']>;
  effectsOpen?: InputMaybe<Scalars['Boolean']['input']>;
  emptyFolderInfo?: InputMaybe<Scalars['Boolean']['input']>;
  enterSingleEditOnZoom?: InputMaybe<Scalars['Boolean']['input']>;
  favoriteFonts?: InputMaybe<Array<Scalars['String']['input']>>;
  firstTimeInteractionWithNewDesign?: InputMaybe<Scalars['Boolean']['input']>;
  genStudioExploreDialog?: InputMaybe<Scalars['Boolean']['input']>;
  guidelinesVisible?: InputMaybe<Scalars['Boolean']['input']>;
  labelOpen?: InputMaybe<Scalars['Boolean']['input']>;
  lastVisitedProjectId?: InputMaybe<Scalars['Int']['input']>;
  layerOpen?: InputMaybe<Scalars['Boolean']['input']>;
  optionsOpen?: InputMaybe<Scalars['Boolean']['input']>;
  rulerVisible?: InputMaybe<Scalars['Boolean']['input']>;
  showMeasurementsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  slidesStripVisible?: InputMaybe<Scalars['Boolean']['input']>;
  snapToObjectsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  styleOpen?: InputMaybe<Scalars['Boolean']['input']>;
  submitFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  textOpen?: InputMaybe<Scalars['Boolean']['input']>;
  timelineCollapsed?: InputMaybe<Scalars['Boolean']['input']>;
  trimOpen?: InputMaybe<Scalars['Boolean']['input']>;
  wizardSteps?: InputMaybe<Array<Scalars['String']['input']>>;
  wizardVisible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputUpdateEnableLightEditorTranslateAllTexts = {
  status: Scalars['Boolean']['input'];
  teamId: Scalars['Int']['input'];
};

/** Input for updating trial extension experiment status.  @depracated(remove this) */
export type InputUpdateExtendTrial = {
  /** Whether the team is in the trial extension experiment. */
  isInExperiment: Scalars['Boolean']['input'];
  /** ID of the team to update settings for. */
  teamId: Scalars['Int']['input'];
};

export type InputUpdateFeature = {
  /** Category of feature to update */
  category?: InputMaybe<Scalars['String']['input']>;
  /** Feature config */
  config?: InputMaybe<Scalars['JSON']['input']>;
  featurePlanMap?: InputMaybe<Array<InputFeaturePlanMap>>;
  /** ID of a style to associate with the this feature */
  featureStyleId?: InputMaybe<Scalars['Int']['input']>;
  /** Name of feature to update */
  name: Scalars['String']['input'];
  /** Style properties for this feature */
  properties?: InputMaybe<InputFeatureProperties>;
  /** Name of the suggested plan group */
  suggestedPlanGroup?: InputMaybe<Scalars['String']['input']>;
};

export type InputUpdateFeed = {
  cloudbedsInput?: InputMaybe<InputCloudbeds>;
  data?: InputMaybe<Scalars['String']['input']>;
  delimiter?: InputMaybe<DelimiterCsv>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  financeInput?: InputMaybe<InputFinance>;
  id: Scalars['Int']['input'];
  isSample?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  processingMode?: InputMaybe<FeedProcessingMode>;
  sourceType?: InputMaybe<FeedSourceType>;
  superbetInput?: InputMaybe<InputSuperbet>;
  targetColumn?: InputMaybe<Scalars['String']['input']>;
  updateFrequency?: InputMaybe<UpdateFrequencyType>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type InputUpdateFeedColumn = {
  currentColumnName: Scalars['String']['input'];
  feedId: Scalars['Int']['input'];
  newColumnName?: InputMaybe<Scalars['String']['input']>;
  newColumnType?: InputMaybe<FeedColumnType>;
  newIndex?: InputMaybe<Scalars['Int']['input']>;
};

export type InputUpdateFeedData = {
  checksum?: InputMaybe<Scalars['String']['input']>;
  debugFlowId?: InputMaybe<Scalars['String']['input']>;
  /** Debug context for Slack thread tracking */
  debugThreadTs?: InputMaybe<Scalars['String']['input']>;
  feedError?: InputMaybe<Scalars['String']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  lastErrorChecksum?: InputMaybe<Scalars['String']['input']>;
  lastSuccessfulUpdate?: InputMaybe<Scalars['Date']['input']>;
  logs?: InputMaybe<Scalars['String']['input']>;
  /**
   * Per-set outcome of an on-demand rebuild. Present only on an on-demand Meta
   * catalog's run — absent everywhere else, so every existing writeback is
   * byte-identical.
   */
  metaSetImport?: InputMaybe<InputMetaSetImportResult>;
  /**
   * The scheduled run found nothing to write (unchanged source, or the same
   * error as last time). Releases the scheduler's PROCESSING + BULK_REMOVE
   * pre-set and touches nothing else.
   */
  noChange?: InputMaybe<Scalars['Boolean']['input']>;
  rows?: InputMaybe<Scalars['Int']['input']>;
  /** Catalog run history stats for this sync (CRE-414); trigger defaults to schedule when absent */
  runStats?: InputMaybe<InputCatalogRunStats>;
  /** Precomputed catalog-list thumbnail URL (CRE-445); the async worker stamps it after a sync so the list never reads S3 per row. Only persisted when non-null. */
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  updateFrequency?: InputMaybe<UpdateFrequencyType>;
};

export type InputUpdateFeedRow = {
  id: Scalars['Int']['input'];
  rowData: Array<Scalars['FeedCellValue']['input']>;
  rowIndex: Scalars['Int']['input'];
};

export type InputUpdateMigratedDesignStatus = {
  bannerId: Scalars['Int']['input'];
  isLastRetry?: InputMaybe<Scalars['Boolean']['input']>;
  log?: InputMaybe<Scalars['String']['input']>;
  migrationId: Scalars['Int']['input'];
  status: MigrateStatus;
};

export type InputUpdateMigratedFolderStatus = {
  bannersnackFolderId: Scalars['Int']['input'];
  isLastRetry?: InputMaybe<Scalars['Boolean']['input']>;
  log?: InputMaybe<Scalars['String']['input']>;
  migrationId: Scalars['Int']['input'];
  status: MigrateStatus;
};

export type InputUpdateMoodBoard = {
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InputUpdateMoodBoardContent = {
  content: Scalars['JSON']['input'];
  hash: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating moodboard attributes (internal services) */
export type InputUpdateMoodBoardInternal = {
  /** The moodboard hash (private or public/share hash) */
  hash: Scalars['String']['input'];
  /** Update moodboard name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Update screenshot generation timestamp */
  screenshotGeneratedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type InputUpdateMoodBoardShare = {
  allowTeamJoin?: InputMaybe<Scalars['Boolean']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  moodboardHash: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  publicStatus?: InputMaybe<PublicStatus>;
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputUpdateNetwork = {
  designId: Scalars['Int']['input'];
  networkId: Scalars['Int']['input'];
};

export type InputUpdateNextGenAiFetchedStatus = {
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  jobType: Scalars['String']['input'];
  nextGenId: Scalars['Int']['input'];
  status: NextGenAiFetchedStatus;
  teamId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputUpdateNextgenAi = {
  content?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
  urlContent?: InputMaybe<Scalars['JSON']['input']>;
};

/** Input for updating onboarding flows experiment status. */
export type InputUpdateOnboardingFlows = {
  /** Whether the team is in the onboarding flows experiment. */
  isInExperiment: Scalars['Boolean']['input'];
  /** ID of the team to update settings for. */
  teamId: Scalars['Int']['input'];
};

export type InputUpdateOnboardingFlowsTrial = {
  /** Experiment group to assign the user to for onboarding flows trial. */
  experimentGroup: Scalars['String']['input'];
};

export type InputUpdateOperation = {
  anonymousId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  gaClientId?: InputMaybe<Scalars['String']['input']>;
  gaSessionId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  operationStatus?: InputMaybe<ImageGenerationStatus>;
};

export type InputUpdateOperationPlacedDesign = {
  /** A complete design document. Mounted directly in the client's renderer, so a value without a sized canvas and at least one layer is rejected. */
  designJson: Scalars['JSON']['input'];
  id: Scalars['Int']['input'];
};

export type InputUpdateOperationPreview = {
  id: Scalars['Int']['input'];
  /** Absolute http(s) URL of an already-persisted image. Rendered directly by the client; a value of any other shape is rejected. */
  imageUrl: Scalars['String']['input'];
};

export type InputUpdateOperationStage = {
  id: Scalars['Int']['input'];
  /** Opaque caller-owned stage identifier, e.g. 'creating-image'. Never user-facing text. */
  stage: Scalars['String']['input'];
  /** Position in the caller's own ordered stage list; a non-advancing value is rejected. */
  stageOrdinal: Scalars['Int']['input'];
};

export type InputUpdatePermanentFlag = {
  designIds: Array<Scalars['Int']['input']>;
};

export type InputUpdatePhotoshopStatus = {
  errorCode?: InputMaybe<PsdErrorCodes>;
  key: Scalars['String']['input'];
  status: ParseStatus;
};

export type InputUpdateProductSet = {
  hash: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  /** Dynamic sets only — how the rule list combines (CRE-423) — omitted leaves it unchanged */
  matchMode?: InputMaybe<ProductSetMatchMode>;
  /** Static sets only — smart set members are worker-owned */
  members?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Dynamic sets only — smart set rules are worker-owned */
  rules?: InputMaybe<Array<InputProductSetRule>>;
};

/** Input for enabling or updating the approval workflow on a project. */
export type InputUpdateProjectApprovalConfig = {
  /** Whether to enable or disable the approval workflow. */
  enabled: Scalars['Boolean']['input'];
  /** The project to configure. */
  projectId: Scalars['Int']['input'];
  /** Whether designs must be approved before publishing. Defaults to true. */
  requireApprovalBeforePublish?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputUpdatePublicBillingInfo = {
  billingDetails?: InputMaybe<InputAddress>;
  paymentType?: InputMaybe<PaymentTypes>;
  teamId: Scalars['Int']['input'];
  threeDSecureToken?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type InputUpdateResourceStatus = {
  designHash?: InputMaybe<Scalars['String']['input']>;
  folderHash?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  publicStatus: PublicStatus;
  teamId: Scalars['Int']['input'];
};

/** Input for updating comment settings for shared links. */
export type InputUpdateShareLinkCommentsEnabled = {
  /** Whether to enable comments on shared links. */
  commentsEnabled: Scalars['Boolean']['input'];
  /** ID of the team to update settings for. */
  teamId: Scalars['Int']['input'];
};

/** Input for updating download settings for shared links. */
export type InputUpdateShareLinkDownloadEnabled = {
  /** Whether to enable downloads on shared links. */
  downloadEnabled: Scalars['Boolean']['input'];
  /** ID of the team to update settings for. */
  teamId: Scalars['Int']['input'];
};

export type InputUpdateShareVariationSelection = {
  /** The design's INTERNAL hash (Design.idToHash), not the public share hash. */
  designHash: Scalars['String']['input'];
  /** The variation hashes the owner scoped this link to. Empty or omitted means the whole family. */
  variationHashes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InputUpdateSubscription = {
  extendTrial?: InputMaybe<Scalars['Boolean']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputUpdateSubscriptionSeats = {
  seats: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputUpdateSuccessManager = {
  id: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

/** Input type for updating a system ad network's status for a team. */
export type InputUpdateSystemAdNetwork = {
  /** The ID of the system ad network to update. */
  id: Scalars['Int']['input'];
  /** The new status for the ad network for the specified team. */
  status: Scalars['Boolean']['input'];
  /** The ID of the team for which to update the ad network status. */
  teamId: Scalars['Int']['input'];
};

export type InputUpdateTagContainerAdTagSettings = {
  adTagProps?: InputMaybe<InputAdTagProps>;
  id: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
  responsiveScaling?: InputMaybe<Scalars['Boolean']['input']>;
  target?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  useAsClickTag?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputUpdateTagContainerNetwork = {
  networkId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
  tagContainerId: Scalars['Int']['input'];
};

export type InputUpdateTeamCredit = {
  credit: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputUpdateTeamIdentityProvider = {
  authorizationUrl?: InputMaybe<Scalars['String']['input']>;
  backchannelSupported?: InputMaybe<Scalars['Boolean']['input']>;
  clientAssertionSigningAlg?: InputMaybe<Scalars['String']['input']>;
  clientAuthMethod?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  disableUserInfo?: InputMaybe<Scalars['Boolean']['input']>;
  issuer?: InputMaybe<Scalars['String']['input']>;
  jwksUrl?: InputMaybe<Scalars['String']['input']>;
  logoutUrl?: InputMaybe<Scalars['String']['input']>;
  nameIDPolicyFormat?: InputMaybe<Scalars['String']['input']>;
  postBindingAuthnRequest?: InputMaybe<Scalars['Boolean']['input']>;
  postBindingLogout?: InputMaybe<Scalars['Boolean']['input']>;
  postBindingResponse?: InputMaybe<Scalars['Boolean']['input']>;
  principalAttribute?: InputMaybe<Scalars['String']['input']>;
  principalType?: InputMaybe<Scalars['String']['input']>;
  signSpMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  signatureAlgorithm?: InputMaybe<Scalars['String']['input']>;
  singleLogoutServiceUrl?: InputMaybe<Scalars['String']['input']>;
  singleSignOnServiceUrl?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
  tokenUrl?: InputMaybe<Scalars['String']['input']>;
  useJwksUrl?: InputMaybe<Scalars['Boolean']['input']>;
  userInfoUrl?: InputMaybe<Scalars['String']['input']>;
  validateSignature?: InputMaybe<Scalars['Boolean']['input']>;
  validateSignatures?: InputMaybe<Scalars['Boolean']['input']>;
  wantAssertionsEncrypted?: InputMaybe<Scalars['Boolean']['input']>;
  wantAssertionsSigned?: InputMaybe<Scalars['Boolean']['input']>;
  wantAuthnRequestsSigned?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * PLA-463. Every field except teamId is optional and tri-state: omit to leave
 * the current value alone, pass null to clear it back to the product default.
 */
export type InputUpdateTeamIdentityProviderAutoJoin = {
  /** Null leaves the user to pick a brand kit at first login. */
  autoJoinBrandKitId?: InputMaybe<Scalars['Int']['input']>;
  /** Null falls back to Light Editor. */
  autoJoinRoleId?: InputMaybe<Scalars['Int']['input']>;
  /** The auto-join switch. Persisted as the legacy automatically_add_users column. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputUpdateTeamIdentityProviderDomains = {
  domains: Array<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

/** Input for updating a team invitation. */
export type InputUpdateTeamInvitation = {
  /** ID of the invitation to update. */
  inviteId: Scalars['Int']['input'];
  /** ID of the new role to assign to the invited user. */
  roleId: Scalars['Int']['input'];
  /** ID of the team that sent the invitation. */
  teamId: Scalars['Int']['input'];
};

export type InputUpdateTeamSettings = {
  mergeSettings?: InputMaybe<Scalars['Boolean']['input']>;
  teamId: Scalars['Int']['input'];
  teamSettings: InputUpdateTeamSettingsDetails;
};

export type InputUpdateTeamSettingsDetails = {
  acquiredThroughReseller?: InputMaybe<Scalars['Boolean']['input']>;
  adServingAccess?: InputMaybe<Scalars['Boolean']['input']>;
  adobeAem?: InputMaybe<Scalars['Boolean']['input']>;
  advancedCssAccess?: InputMaybe<Scalars['Boolean']['input']>;
  allowWorkspacesWithoutBrandKit?: InputMaybe<Scalars['Boolean']['input']>;
  apiAccessDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  brandKitsLimit?: InputMaybe<Scalars['Int']['input']>;
  brandedShareLinkDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  bynder?: InputMaybe<Scalars['Boolean']['input']>;
  cloudinary?: InputMaybe<Scalars['Boolean']['input']>;
  cmyk?: InputMaybe<Scalars['Boolean']['input']>;
  designApprovalSystem?: InputMaybe<Scalars['Boolean']['input']>;
  designMaxHeight?: InputMaybe<Scalars['Int']['input']>;
  designMaxWidth?: InputMaybe<Scalars['Int']['input']>;
  disableAutoBackgroundRemovalInLightEditor?: InputMaybe<Scalars['Boolean']['input']>;
  disableBrandKitInLightEditor?: InputMaybe<Scalars['Boolean']['input']>;
  disableEditorAutoSave?: InputMaybe<Scalars['Boolean']['input']>;
  enableLightEditorTranslateAllTexts?: InputMaybe<Scalars['Boolean']['input']>;
  enforce2fa?: InputMaybe<Scalars['Boolean']['input']>;
  feedRealTimeData?: InputMaybe<Scalars['Boolean']['input']>;
  frontify?: InputMaybe<Scalars['Boolean']['input']>;
  frontifyDomain?: InputMaybe<Scalars['String']['input']>;
  /** Stable language-variation translator id (openai, deepl, anthropic, anthropic-opus). Defaults to deepl. */
  languageVariationTranslator?: InputMaybe<Scalars['String']['input']>;
  maxFolderDepth?: InputMaybe<Scalars['Int']['input']>;
  orangeLogic?: InputMaybe<Scalars['Boolean']['input']>;
  realTimeDataEnabledFeedTypes?: InputMaybe<Array<InputMaybe<FeedSourceType>>>;
  sharepoint?: InputMaybe<Scalars['Boolean']['input']>;
  stickyAdsAccess?: InputMaybe<Scalars['Boolean']['input']>;
  teamContentEditorsLimit?: InputMaybe<Scalars['Int']['input']>;
  teamDesignersLimit?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Not used anymore */
  teamFonts?: InputMaybe<Scalars['Boolean']['input']>;
  teamUsersLimit?: InputMaybe<Scalars['Int']['input']>;
  temporaryEnterprise?: InputMaybe<Scalars['String']['input']>;
  useAppFileNaming?: InputMaybe<Scalars['Boolean']['input']>;
  veeva?: InputMaybe<Scalars['Boolean']['input']>;
  whiteLabelAccess?: InputMaybe<Scalars['Boolean']['input']>;
  whiteLabeledIntegration?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for updating a team user group. */
export type InputUpdateTeamUserGroup = {
  /** New description for the group (optional). */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID of the group to update. */
  groupId: Scalars['Int']['input'];
  /** New name for the group (optional). */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of the team that owns the group. */
  teamId: Scalars['Int']['input'];
};

/** Input for updating template categories visibility status. */
export type InputUpdateTemplateCategoriesStatus = {
  /** IDs of categories to update. */
  categoryIds: Array<Scalars['Int']['input']>;
  /** Whether categories should be visible in the app. */
  showInApp: Scalars['Boolean']['input'];
  /** Whether categories should be visible in the gallery. */
  showInGallery: Scalars['Boolean']['input'];
};

/** Input for updating template categories. */
export type InputUpdateTemplatesCategories = {
  /** Category IDs to assign to the templates. */
  categoryIds: Array<Scalars['Int']['input']>;
  /** IDs of templates to update. */
  templateIds: Array<Scalars['Int']['input']>;
};

/** Input for updating templates visibility status. */
export type InputUpdateTemplatesStatus = {
  /** New status value to set. */
  status: Scalars['Boolean']['input'];
  /** IDs of templates to update. */
  templateIds: Array<Scalars['Int']['input']>;
};

/** Input for updating template tags. */
export type InputUpdateTemplatesTags = {
  /** Tag IDs to assign to the templates. */
  tagIds: Array<Scalars['Int']['input']>;
  /** IDs of templates to update. */
  templateIds: Array<Scalars['Int']['input']>;
};

export type InputUpdateTemporaryEnterprise = {
  accepted: Scalars['Boolean']['input'];
  declined: Scalars['Boolean']['input'];
  revoked: Scalars['Boolean']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputUpdateTestAccountStatus = {
  id: Scalars['Int']['input'];
  status: Scalars['Boolean']['input'];
};

export type InputUpdateTestUserStatus = {
  id: Scalars['Int']['input'];
  status: Scalars['Boolean']['input'];
};

export type InputUpdateTranslateFeed = {
  designHash: Scalars['String']['input'];
  error?: InputMaybe<ErrorTranslate>;
  success?: InputMaybe<SuccessTranslate>;
};

export type InputUpdateUsageRestriction = {
  action?: InputMaybe<UsageRestrictionAction>;
  expiresAt?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<UsageRestrictionScope>;
};

export type InputUpdateUseAppFileNaming = {
  status: Scalars['Boolean']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputUpdateUseNewAdStudio = {
  teamId: Scalars['Int']['input'];
  value: Scalars['Boolean']['input'];
};

export type InputUpdateUserActiveStatus = {
  id: Scalars['Int']['input'];
  status: Scalars['Boolean']['input'];
};

export type InputUpdateUserOnboarding = {
  /** The user's company industry */
  companyIndustry?: InputMaybe<Scalars['String']['input']>;
  /** The user's company size */
  companySize?: InputMaybe<Scalars['String']['input']>;
  /** The user's company name */
  companyWebsite?: InputMaybe<Scalars['String']['input']>;
  /** Nova onboarding: User's main goals */
  goals?: InputMaybe<Scalars['String']['input']>;
  /** How did the user hear about us */
  heardAboutUs?: InputMaybe<Scalars['String']['input']>;
  /** The user's job function */
  jobFunction?: InputMaybe<Scalars['String']['input']>;
  /** Nova onboarding: Onboarding ad studio */
  onboardingAdStudio?: InputMaybe<Scalars['String']['input']>;
  /** Nova onboarding: Onboarding flow type */
  onboardingFlow?: InputMaybe<Scalars['String']['input']>;
  /** Nova onboarding: Onboarding moodboard */
  onboardingMoodboard?: InputMaybe<Scalars['String']['input']>;
  /** Nova onboarding: Onboarding version */
  onboardingVersion?: InputMaybe<Scalars['String']['input']>;
  /** The user's role */
  role?: InputMaybe<Scalars['String']['input']>;
  /** Whether the user wants to skip the onboarding process. */
  skipOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  /** Onboarding status (completed, pending, skipped) */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Nova onboarding: User's title */
  title?: InputMaybe<Scalars['String']['input']>;
  topUseCases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The user's intention */
  useCase?: InputMaybe<Scalars['String']['input']>;
  /** User's selected intent during onboarding (canvas, adStudio, other) */
  userIntent?: InputMaybe<Scalars['String']['input']>;
};

export type InputUpdateUserSettings = {
  editorSettings?: InputMaybe<InputUpdateEditorSettings>;
};

export type InputUpdateV6CreditsPerSeat = {
  /** null clears the override and returns the team to its plan default */
  creditsPerSeat?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
};

/** Input for updating a design version name. */
export type InputUpdateVersionName = {
  /** Hash of the design that contains the version. */
  hash: Scalars['String']['input'];
  /** ID of the version to rename. */
  versionId: Scalars['String']['input'];
  /** New name for the version. */
  versionName: Scalars['String']['input'];
};

export type InputUpdateWorkflow = {
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  hash: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  workflow?: InputMaybe<Scalars['WorkflowJson']['input']>;
};

/** Input for uploading a brand kit logo. */
export type InputUploadBrandKitLogo = {
  /** ID of the brand kit to upload a logo for. */
  brandKitId: Scalars['Int']['input'];
  /** ID of the logo folder to place this logo in (optional). */
  folderId?: InputMaybe<Scalars['Int']['input']>;
  /** Hash identifier of the pre-uploaded logo file. */
  hash: Scalars['String']['input'];
  /** Display name for the logo. */
  name: Scalars['String']['input'];
};

/** Input for getting a brand kit logo upload URL. */
export type InputUploadBrandKitLogoUrl = {
  /** ID of the brand kit to upload a logo for. */
  brandKitId: Scalars['Int']['input'];
};

export type InputUploadCommentAttachment = {
  commentId: Scalars['Int']['input'];
  format: CommentAttachmentFormat;
  name: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  source: Scalars['String']['input'];
  threadId?: InputMaybe<Scalars['Int']['input']>;
  type: CommentAttachmentType;
  /** Ignored: the attachment's link is built from the upload bucket's own address. */
  url: Scalars['String']['input'];
};

/** Input for uploading a font. */
export type InputUploadFont = {
  /** ID of the brand kit to upload the font to. */
  brandKitId: Scalars['Int']['input'];
  /** Hash identifier of the pre-uploaded font file. */
  hash: Scalars['String']['input'];
  /** Whether this is a migration from another system. */
  migrate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display name for the font. */
  name: Scalars['String']['input'];
  /**
   * Store the file exactly as uploaded, without the automatic fix for browsers. Leaving it out
   * applies the fix whenever one is known, as every upload always has.
   */
  storeAsUploaded?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputUploadNextGenLogo = {
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  mediaBase64: Scalars['String']['input'];
  nextGenId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputUploadNextGenMedia = {
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  generateDescription?: InputMaybe<Scalars['Boolean']['input']>;
  mediaBase64: Scalars['String']['input'];
  nextGenId?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type InputUploadToGoogleDrive = {
  fileName: Scalars['String']['input'];
  fileUrl: Scalars['String']['input'];
  folderId?: InputMaybe<Scalars['String']['input']>;
  mimeType: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputUploadToSharePoint = {
  destination?: InputMaybe<SharePointUploadDestinationInput>;
  fileName: Scalars['String']['input'];
  fileUrl: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for upserting external tracking URLs for a design. */
export type InputUpsertDesignExternalTracking = {
  /** The ID of the design. */
  designId: Scalars['Int']['input'];
  /** A list of external tracking URLs to upsert. */
  urls: Array<InputUpsertExternalTrackingUrl>;
};

/** Input for upserting a dynamic variable. */
export type InputUpsertDynamicVar = {
  /** The default value for the dynamic variable. */
  defaultValue: Scalars['String']['input'];
  /** The ID of the dynamic variable (if updating an existing one). */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The macro code for the dynamic variable. */
  macroCode: Scalars['String']['input'];
};

/** Input for upserting dynamic variables for a design. */
export type InputUpsertDynamicVars = {
  /** The ID of the design. */
  designId: Scalars['Int']['input'];
  /** A list of dynamic variables to upsert. */
  vars: Array<InputUpsertDynamicVar>;
};

/** Input for upserting (inserting or updating) an external tracking URL. */
export type InputUpsertExternalTrackingUrl = {
  /** The ID of the external tracking URL (if updating an existing one). */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The type of external tracking. */
  trackingType: AdTagExternalDesignTrackingType;
  /** The URL for external tracking. */
  url: Scalars['String']['input'];
};

/**
 * Input for creating or updating a template.
 * Used by administrators to manage templates.
 */
export type InputUpsertTemplate = {
  /** Category IDs to associate with the template. */
  categoryIds: Array<Scalars['Int']['input']>;
  /** Design ID to use for the template. */
  designId: Scalars['Int']['input'];
  /** Whether the template should be hidden in the Static section. */
  hideInStaticSection: Scalars['Boolean']['input'];
  /** ID of existing template to update (omit for create). */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Whether the template should be pinned to the top. */
  pinToTop: Scalars['Boolean']['input'];
  /** Whether the template should be visible in the app. */
  showInApp: Scalars['Boolean']['input'];
  /** Whether the template should be visible in the gallery. */
  showInGallery: Scalars['Boolean']['input'];
  /** Tag IDs to associate with the template. */
  tagIds: Array<Scalars['Int']['input']>;
  /** Tags to associate with the template (legacy). */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether the template is used in the Create Agent. */
  useInCreateAgent: Scalars['Boolean']['input'];
};

/** Input for creating or updating a template category. */
export type InputUpsertTemplateCategory = {
  /** ID of existing category to update (omit for create). */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Machine-readable identifier for the category. */
  identifier: Scalars['String']['input'];
  /** Display name of the category. */
  name: Scalars['String']['input'];
  /** Whether the category should be visible in the app. */
  showInApp: Scalars['Boolean']['input'];
  /** Whether the category should be visible in the gallery. */
  showInGallery: Scalars['Boolean']['input'];
};

/** Input for creating or updating a template tag. */
export type InputUpsertTemplateTag = {
  /** ID of existing tag to update (omit for create). */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Whether this tag represents a color. */
  isColor: Scalars['Boolean']['input'];
  /** Whether this tag represents a style. */
  isStyle: Scalars['Boolean']['input'];
  /** Display name of the tag. */
  name: Scalars['String']['input'];
  /** Whether the tag should be visible in the app. */
  showInApp: Scalars['Boolean']['input'];
  /** Whether the tag should be visible in the gallery. */
  showInGallery: Scalars['Boolean']['input'];
};

export type InputUrlDataToBrandKit = {
  colors?: InputMaybe<Array<InputColor>>;
  fonts?: InputMaybe<Array<InputAddFontToBrandKit>>;
  logo?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Array<Scalars['String']['input']>>;
  url: Scalars['String']['input'];
};

export type InputUsedGoogleFont = {
  fontName: Scalars['String']['input'];
  fontType?: InputMaybe<Scalars['String']['input']>;
  variants: Array<InputGoogleFontWeight>;
};

export type InputUser = {
  /** Email of the user to retrieve information for. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** ID of the user to retrieve information for. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputUserDefaults = {
  /** First-party first/last-touch attribution (tb_first_touch / tb_last_touch cookies), persisted at account creation (DAT-55). */
  attribution?: InputMaybe<InputSignupAttribution>;
  /** Whether the user's email is a work email. */
  isWorkEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Source from which the user came to pricing. */
  pricingSource?: InputMaybe<Scalars['String']['input']>;
};

export type InputUserName = {
  /** New name to set for the user. */
  name: Scalars['String']['input'];
};

export type InputUserSsoEnforced = {
  email: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputUserUserId = {
  userId: Scalars['Int']['input'];
};

export type InputValidEmail = {
  email: Scalars['String']['input'];
};

export type InputValidProviderAlias = {
  email: Scalars['String']['input'];
};

export type InputVariationLayer = {
  id: Scalars['Int']['input'];
  layerType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type InputVariationSuggestions = {
  imageHash?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputVeeva = {
  teamId: Scalars['Int']['input'];
  veeva: Scalars['Boolean']['input'];
};

export type InputVeevaClient = {
  code: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

export type InputVeevaDocNumber = {
  docNumber: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
  vaultDNS: Scalars['String']['input'];
};

export type InputVeevaDocument = {
  docID: Scalars['Int']['input'];
  sessionId: Scalars['String']['input'];
  /** @deprecated Field no longer supported */
  url?: InputMaybe<Scalars['String']['input']>;
  urls?: InputMaybe<Scalars['JSON']['input']>;
  vaultDNS: Scalars['String']['input'];
};

export type InputVeevaEmail = {
  email: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputVeevaSession = {
  sessionId: Scalars['String']['input'];
  vaultDNS: Scalars['String']['input'];
};

export type InputVerifyMoodBoardAccess = {
  hash: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type InputVerifyUserEmail = {
  id: Scalars['Int']['input'];
  status: Scalars['Boolean']['input'];
};

export type InputVideoGeneration = {
  /** Omni single clip: true lets the clip cut between shots when the prompt asks for it. Absent/false keeps the default single unbroken scene. Ignored for edits, scene cards and other models. */
  allowSceneCuts?: InputMaybe<Scalars['Boolean']['input']>;
  aspectRatio: Scalars['String']['input'];
  audio?: InputMaybe<Scalars['Boolean']['input']>;
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  /** The Copilot chat thread this generation was started from. Recorded on the ai_studio_generation row (with generationSource AI_STUDIO) so the Copilot lists only its own chat's generations. Verified before any credit is held: a thread that is not this user's Copilot chat on this design is not recorded. */
  chatThreadId?: InputMaybe<Scalars['String']['input']>;
  /** What the Copilot client knew when it started this generation ({ toolCallId, announced, client }), stored on the ai_studio_generation row so any browser can pick the generation up. Requires generationSource AI_STUDIO. Capped at 32 KB. */
  copilotKickoff?: InputMaybe<Scalars['JSON']['input']>;
  createMedia?: InputMaybe<Scalars['Boolean']['input']>;
  creditOperationName?: InputMaybe<Scalars['String']['input']>;
  /** Design hash of the Ad Studio design where generation was triggered */
  designHash?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  /** When AI_STUDIO, the request is recorded as an ai_studio_generation row grouping its variant operations */
  generationSource?: InputMaybe<GenerationSource>;
  image?: InputMaybe<Scalars['String']['input']>;
  lastFrameImage?: InputMaybe<Scalars['String']['input']>;
  /** With createMedia: the name the clip's library row is saved under, at most 100 UTF-16 units, as the row keeps them (trimmed; blank is none). Absent, the row is named AI Generated Video. */
  mediaName?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<VideoGenerationMode>;
  model?: InputMaybe<Scalars['String']['input']>;
  moodboardContext?: InputMaybe<InputMoodboardContext>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  referenceImages?: InputMaybe<Array<Scalars['String']['input']>>;
  resolution: Scalars['String']['input'];
  /** User-authored scene cards (1-10). Presence is what makes the request a multi-scene chain; Omni fresh generations only — rejected for edits and other models. */
  scenes?: InputMaybe<Array<InputMultiSceneScene>>;
  /** Omni asset edit: media hash of the source video. The server resolves the media record and builds the permanent asset URL itself — the client never supplies a URL. */
  sourceMediaHash?: InputMaybe<Scalars['String']['input']>;
  /** A multi-scene video asked for by length alone: the server splits the length into scenes, drafts them from userPrompt (the brief) and referenceImages (at most 10, they condition the first scene's still), then generates and stitches the chain. Omni fresh generations only; exclusive with scenes, image, lastFrameImage and sourceMediaHash. */
  storyboard?: InputMaybe<InputVideoStoryboard>;
  teamId: Scalars['Int']['input'];
  /** AI Studio composer toggle: ground the generation in the design's ad context (requires designHash) */
  useDesignContext?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  userPrompt?: InputMaybe<Scalars['String']['input']>;
};

/** The length of a multi-scene video the server drafts itself, and the scenes when the user laid them out. */
export type InputVideoStoryboard = {
  /** The scenes the user laid out, in order (2-10). Each is drafted as given instead of the server splitting the length and planning the scenes; the anchor still still comes from referenceImages. */
  scenes?: InputMaybe<Array<InputVideoStoryboardScene>>;
  /** Exact length of the stitched video in whole seconds: 11-100, or with scenes their sum (at most 100). */
  totalDurationSeconds: Scalars['Int']['input'];
};

/** One scene the user laid out for a drafted multi-scene video. */
export type InputVideoStoryboardScene = {
  /** Scene length in whole seconds, 3-10. */
  durationSeconds: Scalars['Int']['input'];
  /** What the scene shows, at most 600 characters. */
  prompt: Scalars['String']['input'];
  /** Photos tied to this scene, at most 3: they condition its still beside the anchor. */
  referenceImages?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Voice and tone settings for AI-generated content in a brand kit. */
export type InputVoiceAndTone = {
  /** Whether the brand tone was AI-suggested. */
  aiSuggestedBrandTone?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the brand voice was AI-suggested. */
  aiSuggestedBrandVoice?: InputMaybe<Scalars['Boolean']['input']>;
  /** Array of tone attributes for the brand. */
  brandTone?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Description of the brand's voice. */
  brandVoice?: InputMaybe<Scalars['String']['input']>;
};

export type InputWarmDesignedTextChecks = {
  /** The open design. Only images its team can reach are checked. Send this or projectId, not both. */
  designHash?: InputMaybe<Scalars['String']['input']>;
  /**
   * The project, where no design exists yet (the Home chat and the start-from-assets picker). Only images its team
   * can reach are checked. Send this or designHash, not both.
   */
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** The attached images' urls, as the chat sends them in attachedImageUrls. At most 4 distinct images are checked. */
  urls: Array<Scalars['String']['input']>;
};

export type InputWatchdogEvaluateResize = {
  /** Whether the captured candidate was ultimately applied (training signal). Grade-time captures set false. */
  applied?: InputMaybe<Scalars['Boolean']['input']>;
  candidateDesignId?: InputMaybe<Scalars['Int']['input']>;
  /** Null for GRADE_CANDIDATE rows (content-addressed); set for applied/legacy captures. */
  candidateHash?: InputMaybe<Scalars['String']['input']>;
  candidateHeight: Scalars['Int']['input'];
  /** Content-mode discriminant: S3 key of the gzipped candidate JSON. When set, the worker scores it directly (render deferred). */
  candidateJsonKey?: InputMaybe<Scalars['String']['input']>;
  candidateWidth: Scalars['Int']['input'];
  checksum: Scalars['String']['input'];
  /** Hook-site timestamp (ISO) — queue latency must not skew resize_created_at. */
  createdAtIso: Scalars['String']['input'];
  /** Per-method extras (isOpusVersion, transactionId, variantId/version, matched hashes, fallbackStrategy, candidateSource, …). */
  methodDetail?: InputMaybe<Scalars['JSON']['input']>;
  referenceHash: Scalars['String']['input'];
  referenceIsFallback: Scalars['Boolean']['input'];
  resizeMethod: ResizeWatchdogMethod;
  teamId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputWorkerUploadFont = {
  bannersnackFontId: Scalars['Int']['input'];
  brandKitId: Scalars['Int']['input'];
  createdById: Scalars['Int']['input'];
  hash: Scalars['String']['input'];
  isLastRetry?: InputMaybe<Scalars['Boolean']['input']>;
  migrationId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  typographyOptions?: InputMaybe<Array<InputTypography>>;
};

export type InputWorkflowFetchUrl = {
  operationId?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type InputWriteOffTeamUsageRecurly = {
  /** The impressions settled by this write-off; defaults in the UI to unbilledNow. */
  amount: Scalars['Int']['input'];
  note: Scalars['String']['input'];
  rowId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

/** Types of AI-generated insights available for brand analysis */
export enum InsightType {
  /** Target audience analysis and demographic insights */
  AUDIENCE = 'AUDIENCE',
  /** Call-to-action effectiveness and optimization recommendations */
  CTA = 'CTA',
  /** Analysis of attention-grabbing elements and opening techniques */
  HOOKS = 'HOOKS',
  /** Landing page experience and conversion optimization insights */
  LANDING_PAGES = 'LANDING_PAGES',
  /** Performance metrics and optimization opportunities */
  PERFORMANCE = 'PERFORMANCE',
  /** Sentiment analysis of ad content and messaging tone */
  SENTIMENT = 'SENTIMENT',
  /** Overall strategic summary of the brand's advertising approach */
  SUMMARY = 'SUMMARY'
}

/** AI-generated insights and recommendations for ad improvement */
export type InsightsRecommendations = {
  __typename?: 'InsightsRecommendations';
  /**
   * Specific areas where the ad could be improved
   * @deprecated Use keyLearnings instead
   */
  areasForImprovement: Array<Scalars['String']['output']>;
  keyLearnings: Array<Scalars['String']['output']>;
  /** Identified strengths in the ad's content and presentation */
  strengths: Array<Scalars['String']['output']>;
};

export type IntegrationAccount = {
  __typename?: 'IntegrationAccount';
  id: Scalars['String']['output'];
  identifier: Scalars['String']['output'];
  name: Scalars['String']['output'];
  platform: AiAgentPlatform;
};

export enum IntegrationAccountType {
  PERSONAL = 'PERSONAL',
  TEAM = 'TEAM'
}

/** @deprecated This type is no longer used */
export type IntegrationCampaign = {
  __typename?: 'IntegrationCampaign';
  name: Scalars['String']['output'];
  platform: Scalars['String']['output'];
  platformAccountId: Scalars['String']['output'];
  platformAccountName: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type IntegrationCustomer = {
  __typename?: 'IntegrationCustomer';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type IntegrationFilesUploadUrlResult = {
  __typename?: 'IntegrationFilesUploadUrlResult';
  hash: Scalars['String']['output'];
  uploadUrl: PresignedPost;
};

export type IntegrationFolder = {
  __typename?: 'IntegrationFolder';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
};

export type IntegrationItems = {
  __typename?: 'IntegrationItems';
  createdDate?: Maybe<Scalars['String']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  format?: Maybe<MediaFormat>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  modifiedDate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nextToken?: Maybe<Scalars['String']['output']>;
  ownerNames?: Maybe<Array<Scalars['String']['output']>>;
  parent?: Maybe<Scalars['String']['output']>;
  processing?: Maybe<Scalars['Boolean']['output']>;
  provider?: Maybe<IntegrationProvider>;
  searchParentId?: Maybe<Scalars['String']['output']>;
  searchParentName?: Maybe<Scalars['String']['output']>;
  shared?: Maybe<Scalars['Boolean']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  thumbnailLink?: Maybe<Scalars['String']['output']>;
  type?: Maybe<MediaType>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type IntegrationItemsResult = {
  __typename?: 'IntegrationItemsResult';
  items: Array<IntegrationItems>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export enum IntegrationProvider {
  BYNDER = 'bynder',
  DROPBOX = 'dropbox',
  GOOGLE_DRIVE = 'google_drive',
  VEEVA_VAULT = 'veeva_vault'
}

export enum Integrations {
  ADOBE_AEM = 'ADOBE_AEM',
  BYNDER = 'BYNDER',
  /** Reserved for Cloudinary's own OAuth connection. The generic connect flow refuses it. */
  CLOUDINARY = 'CLOUDINARY',
  CM360 = 'CM360',
  DROPBOX = 'DROPBOX',
  DV360 = 'DV360',
  GOOGLE_ADS = 'GOOGLE_ADS',
  GOOGLE_DRIVE = 'GOOGLE_DRIVE',
  LINKEDIN = 'LINKEDIN',
  META = 'META',
  PINTEREST = 'PINTEREST',
  SHAREPOINT = 'SHAREPOINT',
  SLACK = 'SLACK',
  TIKTOK = 'TIKTOK',
  VEEVA_VAULT = 'VEEVA_VAULT'
}

export type IntegrationsMediaUploading = {
  __typename?: 'IntegrationsMediaUploading';
  fileId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type IntercomCompany = {
  __typename?: 'IntercomCompany';
  adStudioExperience?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  industry?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  onlyAdStudioAccess?: Maybe<Scalars['Boolean']['output']>;
  plan?: Maybe<Scalars['String']['output']>;
  planActivatedAt?: Maybe<Scalars['String']['output']>;
  planCanceledAt?: Maybe<Scalars['String']['output']>;
  planEndAt?: Maybe<Scalars['String']['output']>;
  planExpiresAt?: Maybe<Scalars['String']['output']>;
  planFrequency?: Maybe<Scalars['String']['output']>;
  planStartAt?: Maybe<Scalars['String']['output']>;
  planState?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  trial?: Maybe<Scalars['Boolean']['output']>;
  trialEndAt?: Maybe<Scalars['String']['output']>;
  trialStartAt?: Maybe<Scalars['String']['output']>;
  userCount?: Maybe<Scalars['Int']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export enum IntercomJobType {
  ADD_USER_TO_COMPANY = 'ADD_USER_TO_COMPANY',
  DELETE_COMPANY = 'DELETE_COMPANY',
  DELETE_USER = 'DELETE_USER',
  DELETE_USER_FROM_COMPANY = 'DELETE_USER_FROM_COMPANY',
  TRACK = 'TRACK',
  UPDATE_ATTRIBUTES = 'UPDATE_ATTRIBUTES'
}

export enum IntercomTrackingType {
  ADD_USER_TO_TEAM = 'ADD_USER_TO_TEAM',
  CHANGE_USER_EMAIL = 'CHANGE_USER_EMAIL',
  CREATE_CONVERSATION = 'CREATE_CONVERSATION',
  CREATE_TEAM = 'CREATE_TEAM',
  CREATE_USER = 'CREATE_USER',
  CUSTOM_BRAND_GRAPHICS = 'CUSTOM_BRAND_GRAPHICS',
  CUSTOM_EMAIL_INVALID = 'CUSTOM_EMAIL_INVALID',
  CUSTOM_EMAIL_VALID = 'CUSTOM_EMAIL_VALID',
  CUSTOM_INVALID_LINK = 'CUSTOM_INVALID_LINK',
  CUSTOM_VALID_LINK = 'CUSTOM_VALID_LINK',
  DELETE_TEAM = 'DELETE_TEAM',
  DELETE_USER = 'DELETE_USER',
  DELETE_USER_FROM_TEAM = 'DELETE_USER_FROM_TEAM',
  INITIATE_CONVERSATION = 'INITIATE_CONVERSATION',
  ME_ADD_USER_TO_TEAM = 'ME_ADD_USER_TO_TEAM',
  ONLY_AD_STUDIO_EXPERIMENT = 'ONLY_AD_STUDIO_EXPERIMENT',
  START_SUBSCRIPTION = 'START_SUBSCRIPTION',
  UPDATE_TEAM = 'UPDATE_TEAM',
  UPDATE_USER = 'UPDATE_USER'
}

export type IntercomUser = {
  __typename?: 'IntercomUser';
  customAttributes?: Maybe<IntercomUserCustomAttributes>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type IntercomUserCustomAttributes = {
  __typename?: 'IntercomUserCustomAttributes';
  emailConfirmed?: Maybe<Scalars['Boolean']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

export type IntercomUserOrCompany = IntercomCompany | IntercomUser;

export type InternalMutation = {
  __typename?: 'InternalMutation';
  CNAMEDomainsLookup: Scalars['Boolean']['output'];
  /** @deprecated Not used */
  _empty?: Maybe<Scalars['String']['output']>;
  adTagReportScheduleJob: Scalars['Boolean']['output'];
  adTagReportScheduleRun: Scalars['Boolean']['output'];
  addAiDesignCardToMoodboard: AddAiDesignCardToMoodboardPayload;
  addAiImageCardsToMoodboard: AddAiImageCardsToMoodboardPayload;
  addAiVideoCardsToMoodboard: AddAiVideoCardsToMoodboardPayload;
  /** @deprecated Use processAutomatedOptimizeReportJob instead */
  aiAgentAutomatedReportScheduleJob: Scalars['Boolean']['output'];
  aiReportHtmlToPdfCallback: Scalars['Boolean']['output'];
  aiResizeHTMLPreviewJson: Scalars['Boolean']['output'];
  aiResizeHTMLUpdateJson: Scalars['Boolean']['output'];
  aiResizeUpdateJson: Scalars['Boolean']['output'];
  /** Ensure a design JSON is saved (internal use). */
  assureDesignJsonIsSaved: AssureDesignJsonIsSavedPayload;
  buildJsonDesignFromExtractedInfo: Scalars['JSON']['output'];
  checkAiModelDeprecations: Scalars['Boolean']['output'];
  checkCutoutCredits: Scalars['Boolean']['output'];
  /** Decides once per set version whether a download gets a motion draft, and records the decision. */
  claimMotionDraft: MotionDraftClaim;
  cleanupAiOperations: Scalars['Boolean']['output'];
  cleanupTemporaryAccounts: Scalars['Boolean']['output'];
  cleanupTestAccounts: Scalars['Boolean']['output'];
  cloneDesignFromEnv: CloneDesignFromEnvPayload;
  /** Clone moodboard from another environment (live to dev) with asset transfer */
  cloneMoodBoardFromEnv: CloneMoodBoardFromEnvPayload;
  collectTransactionData: CollectTransactionDataPayload;
  /**
   * Terminal write for a brand kit document extraction, called by the ai-creator worker.
   * Dropped unless the version is current and the row is still running.
   */
  completeBrandKitDocumentExtraction: Scalars['Boolean']['output'];
  completeBrandStyleReevaluation: BrandStyleReevaluationResult;
  /** Writes the motion design set and puts the draft on Home. Returns the design id, or null when no size fits. */
  completeMotionDraft?: Maybe<Scalars['Int']['output']>;
  /** Create a media asset via API (internal use). */
  createApiMedia: Media;
  /** @deprecated Migration service has been removed */
  createCustomSizesFromBSCustomSizes: Scalars['Boolean']['output'];
  createDefaultBrandKitButton: Scalars['Boolean']['output'];
  /** Create a design (internal use). */
  createDesign: CreateDesignPayload;
  /** @deprecated Migration service has been removed */
  createDesignFromBSBanner: Scalars['Boolean']['output'];
  /** Create a new design set (internal user). */
  createDesignSet: CreateDesignPayload;
  /** @deprecated Migration service has been removed */
  createDesignSetFromBSBannerSet: Scalars['Boolean']['output'];
  createFeature: CreateFeatureResult;
  /** @deprecated Migration service has been removed */
  createFolderFromBSFolder: CreateFolderPayload;
  /** Create a media asset with a specific user (internal use). */
  createMedia: Media;
  createMediaFolder: CreateMediaFolderPayload;
  /** @deprecated Migration service has been removed */
  createMediaFromBSMedia: Scalars['Boolean']['output'];
  createPlan: CreatePlanResult;
  deactivateAdTagFeature: Scalars['Boolean']['output'];
  deleteAssets: Scalars['Boolean']['output'];
  deleteEverything: Scalars['Boolean']['output'];
  deleteIdentityProviderDomains: Scalars['Boolean']['output'];
  deleteTeamAssets: Scalars['Boolean']['output'];
  /**
   * One pass of the trial-abuse signup-velocity sweep. Statsig-gated and in
   * shadow mode by default (trial_abuse_sweeper dynamic config). Returns true
   * when the pass completed; the evidence goes to structured logs and Slack
   * rather than the response, because the caller is a fire-and-forget cron.
   */
  detectTrialAbuse: Scalars['Boolean']['output'];
  /** @deprecated Brand template migration service has been removed. @BreakingBad */
  doMigrateBrandTemplates: Scalars['Boolean']['output'];
  download: Download;
  downloadZipResult: DownloadZipResultPayload;
  duplicateSubFolder: DuplicateFolderPayload;
  emailConfigLookup: Scalars['Boolean']['output'];
  endABTest: Scalars['Boolean']['output'];
  /**
   * Brings one team's ad serving in line with its subscription (stop when no live subscription,
   * resume when subscribed again). Called from the Recurly webhooks; the hourly sweep is the
   * guarantee. Returns the outcome name.
   */
  enforceAdServingEntitlement: Scalars['String']['output'];
  /**
   * Hourly: switches off the ad tags of teams with no live subscription and back on when they
   * subscribe again (services/adServing/entitlement). Shadow unless the Statsig gate is on.
   */
  enforceAdServingEntitlementSweep: Scalars['Boolean']['output'];
  /** Daily: expires static-to-motion drafts left undecided past the team's expiryDays (their sets go to the trash), and fails drafts stuck generating or completing. */
  expireMotionDrafts: Scalars['Boolean']['output'];
  /**
   * @deprecated No resolver implemented for exportDpaFinished mutation
   * @deprecated exportDpaFinished mutation has been removed
   */
  exportDpaFinished: Scalars['Boolean']['output'];
  exportImageForLastSavedDesigns: ExportImageForLastSavedDesignsPayload;
  /** Update export status for media (internal use). */
  exportMediaUpdate: Scalars['Boolean']['output'];
  exportResult: ExportResultPayload;
  /** Marks a live draft failed. True when the draft changed. */
  failMotionDraft: Scalars['Boolean']['output'];
  /** Hourly: fails multi-scene video operations still pending long after any chain could have finished, releasing their credit holds. */
  failStaleMultiSceneChains: Scalars['Boolean']['output'];
  feedSync: Scalars['Boolean']['output'];
  /**
   * Writes a .fig job's status only while the key's claim is still that job's (and, with onlyIfPending, only while
   * the record says PENDING), in one step. True when it wrote. Internal use only (apps/figma).
   */
  figFileReport: Scalars['Boolean']['output'];
  /** @deprecated This mutation is deprecated and will be removed in a future version */
  finalizeCreditTransaction: CreditTransactionPayload;
  generateDesign: Array<GeneratedDesignResult>;
  /** Kick off a layered-ad generation (internal use for AI agents). Creates a PENDING AiOperation and enqueues a LayeredAd job. */
  generateLayeredAd: Array<LayeredAdOperationResult>;
  generateProductPhotography: Array<GeneratedImageResult>;
  generateText: GeneratedTextResult;
  /** Job 2's real body. With variationIndex, materializes exactly that variation; without it, every remaining one (deploy-overlap path). */
  internalApplyContentVariations: Scalars['Boolean']['output'];
  /** Marks the job FAILED with a reason — the WHOLE row when variationIndex is omitted or the job has no bundle yet (e.g. copy-generation failure); otherwise just that one label's outcome, letting the rollup land on DONE_WITH_ERRORS when other variations already succeeded. */
  internalFailContentVariationJob: Scalars['Boolean']['output'];
  /**
   * Retires a ContentVariationJob whose BullMQ job died at the QUEUE level
   * (stall-limit exceeded, attempts exhausted) rather than inside the
   * processor's own try/catch — createAiWorker.ts's queue-failure backstop is
   * the only caller. Unlike internalFailContentVariationJob, every decision
   * (whether the row/label is even still safe to fail) is taken from a state
   * read inside the SAME lock as the write, so a retried delivery that
   * genuinely finished its work in between can never be raced into a false
   * failure. Returns whether a row existed, exactly like
   * internalFailContentVariationJob.
   *
   * GENERATE: no-op once the row already has a bundle (Job 1's real work
   * landed) or is already terminal; otherwise fails the whole row.
   * APPLY with variationIndex: no-op once that label is CREATED or FAILED;
   * any other status (PENDING, ASSETS_READY, CREATING) is failed. It never
   * deletes or touches a variation Design: materialization runs inside
   * graphql, so a design checkpointed under CREATING may still be finishing.
   * APPLY with no variationIndex is a legacy pre-split
   * whole-batch payload that owns the whole row, so it fails the whole row.
   */
  internalFailDeadContentVariationQueueJob: Scalars['Boolean']['output'];
  /** Marks one variation's asset stage complete: resolves and persists its blurred-skeleton preview url. Returns the url, or null when nothing resolved. */
  internalMarkContentVariationAssetsReady?: Maybe<Scalars['String']['output']>;
  /** Validates + stores Job 1's content bundle; fires an AiOperation per aiGenerate imagery slot; enqueues Job 2 itself (status APPLYING) only when there is no imagery to wait on. */
  internalSubmitContentVariationBundle: ContentVariationSubmitBundleResult;
  invalidatePayment: InvalidatePaymentPayload;
  /**
   * Scan a RAW design document for resizeability problems and return the refactored JSON, for the e2e
   * control suite — whose corpus has no Design rows, so the by-hash Query is unreachable from it.
   * Persists nothing.
   */
  lintDesignJsonResizeability: DesignLintRefactorResult;
  logTeamCreditsToRecurly: Scalars['Boolean']['output'];
  logTeamUsageToRecurly: Scalars['Boolean']['output'];
  markAbandonedUsers: Scalars['Boolean']['output'];
  /**
   * Bulk-mark AI operations as viewed after sending email notification.
   * Called by ai-mail-notification worker to prevent re-sending.
   */
  markAiOperationsViewed: Scalars['Boolean']['output'];
  /**
   * Mark a design as a template (internal).
   * For internal system use when converting designs.
   */
  markDesignAsTemplate: Scalars['Boolean']['output'];
  /**
   * Mark a design set as a template (internal).
   * For internal system use when converting designs.
   */
  markDesignSetAsTemplate: Scalars['Boolean']['output'];
  markTeamAssetsForDeletion: Scalars['Boolean']['output'];
  /** @deprecated Migration service has been removed */
  migrateBanners: Scalars['Boolean']['output'];
  /** @deprecated Migration service has been removed */
  migrateFolders: Scalars['Boolean']['output'];
  /** Move cached design JSONs to permanent storage (internal use). */
  moveCacheJsons: MoveCacheJsonsPayload;
  parseTemplate: ParseTemplate;
  /** Op-free crafted-layered persist. Resolves team owner from brandKitId, writes the crafted design, returns its id. */
  persistCraftedDesign: Scalars['Int']['output'];
  /**
   * Durably persist a rotated LinkedIn refresh token (optimistic concurrency).
   * Returns true when the rotation was applied, false on a compare-and-set loss.
   */
  persistLinkedInRotatedToken: Scalars['Boolean']['output'];
  persistPinterestRotatedToken: Scalars['Boolean']['output'];
  /**
   * Posts yesterday's Copilot sentiment digest to Slack (apps/crons, daily 06:00 UTC). A repeated call for the
   * same day does nothing; false when the post failed (the day is then free for a rerun).
   */
  postCopilotSentimentDigest: Scalars['Boolean']['output'];
  /**
   * Scores the kept Figma .fig file imports and, from 06:00 UTC, posts yesterday's as their own "Figma file imports"
   * message (meant for an hourly apps/crons job): each frame's kept design rendered and compared with our renderer's
   * drawing of the frame from the file (CRE-868). Every call scores; a posted day is not posted again. False when the
   * post failed (the day is then free for a rerun). Only the crons service may call it: each call scans the bucket and
   * renders, posted day or not.
   */
  postFigFileImportScoreDigest: Scalars['Boolean']['output'];
  /**
   * Posts yesterday's Figma import scores to Slack (meant for an hourly apps/crons job from 06:00 UTC): each import's design
   * rendered live and compared with the plugin's frame picture (CRE-704). A repeated call for the same day does
   * nothing; false when the post failed (the day is then free for a rerun).
   */
  postFigmaImportScoreDigest: Scalars['Boolean']['output'];
  /**
   * Scores the kept PSD imports and, from 06:00 UTC, posts yesterday's PSD import scores to Slack (meant for an hourly
   * apps/crons job): each artboard's kept design rendered and compared with the picture Photoshop saved in the file
   * (CRE-724). Every call scores; a posted day is not posted again. False when the post failed (the day is then free
   * for a rerun).
   */
  postPsdImportScoreDigest: Scalars['Boolean']['output'];
  processAutomatedOptimizeReportJob: Scalars['Boolean']['output'];
  /** Process moodboard content without uploading to S3 — returns processed cards for Yjs sync and performs DB/workflow side effects */
  processMoodBoardContent: MoodBoardProcessPayload;
  /** @deprecated This mutation is deprecated and will be removed in a future version */
  processRecurlyWebhook: Scalars['Boolean']['output'];
  /**
   * Deletes unlabelled design-scorer shadow rows older than 90 days (apps/crons, daily); labelled rows stay for
   * calibration. True when the prune ran. Snapshots expire with the temp bucket's lifecycle.
   */
  pruneDesignScorerShadow: Scalars['Boolean']['output'];
  /**
   * Record that a feed's S3 payload was rewritten: bump feed.checksum and drop
   * the search index. The caller uploads the payload first.
   *
   * Deliberately narrow — it touches NO lifecycle state (status, feedError,
   * schedule, logs, rows, thumbnail). Writers that also complete a lifecycle use
   * their own completion mutation so the lifecycle and checksum land together;
   * this is for writers that publish bytes and own no lifecycle.
   */
  publishFeedPayload: Scalars['Boolean']['output'];
  /**
   * Purges the next designs trashed more than 6 months ago, from where the last call
   * stopped, the way purgeTrashedDesigns does. Designs it leaves alone are checked again
   * on the next pass. One call runs at a time.
   */
  purgeNextTrashedDesigns: PurgeNextTrashedDesignsPayload;
  /**
   * Hard-deletes trashed designs, after copying what it takes to bring them back into
   * purged_designs in the same transaction. SELECT restore_purged_designs(ARRAY[<ids>])
   * puts them back.
   */
  purgeTrashedDesigns: PurgeTrashedDesignsPayload;
  /** Op-free crafted-layered slot failure: bumps the batch failed count + emits crafted_ads_generation_failed. */
  recordCraftedBatchFailure: Scalars['Boolean']['output'];
  /** Records one shadow comparison. True when the row was written. The resolver never errors; a request that fails in transport still reaches the caller. */
  recordDesignScorerShadow: Scalars['Boolean']['output'];
  /** Web Risk enrichment verdict written back by the web-risk-worker (spec §8). */
  recordPhishingUrlVerdict: RecordPhishingUrlVerdictResult;
  reindexDesignFeedAdjustments: Scalars['Boolean']['output'];
  removeImageBackground: NextGenRemBgProcessedMedia;
  removeUrlsFromDesigns: Scalars['Boolean']['output'];
  /**
   * Render a finished Copilot ad to a public JPEG for the "your ad is ready" email.
   * Null when the operation is not a finished layered ad or the render fails.
   */
  renderLayeredAdPreview?: Maybe<Scalars['String']['output']>;
  /**
   * Repairs stored font files that Chrome refused during a browser export, the way Admin → Repair
   * stored font does: the original is backed up, a file is written only when the repair fully fixes
   * it, and the font's CDN copy is cleared. Every refused font is repaired, whenever it was uploaded
   * and even when its upload kept the file as uploaded. Only this environment's own stored font files
   * are repaired; any other refused URL is logged and ignored.
   */
  repairRefusedFonts: Array<RefusedFontRepair>;
  resetAddonUsageForTeam: ResetAddonUsageForTeamPayload;
  resetDesignEstimateSize: Scalars['Boolean']['output'];
  /**
   * Reset the no-downloads cache for a team (internal use).
   * @deprecated This mutation is deprecated and will be removed in a future version
   */
  resetNoDownloadsCache: Scalars['Boolean']['output'];
  /** Grade one applied AI resize (json+html tiers) and post it to the resize grade feed channel. Stores nothing. */
  resizeGradeFeedPost: ResizeGradeFeedPostResult;
  /**
   * Resize a design with the FLEX engine ("Smart layout") from an in-memory
   * design, for callers with no persisted Design row. Returns one entry per
   * target, null where flex declined the source or the layout failed.
   */
  resizeWithFlex: Array<Maybe<FlexResizeResult>>;
  /**
   * Resize a design against the PUBLIC template catalogue, for callers with no
   * owning team (sample ads are generated for prospects who own no designs).
   * Returns one entry per target, null where no template matched.
   */
  resizeWithPublicTemplate: Array<Maybe<PublicTemplateResizeResult>>;
  revokeAccess: Scalars['Boolean']['output'];
  /** @deprecated This mutation is deprecated and will be removed in a future version */
  rollbackCreditTransaction: CreditTransactionPayload;
  /**
   * One pass of the Ad Studio Copilot sentiment sweep for this environment (apps/crons, every 2 minutes on dev
   * main and prod): scores Copilot threads that went quiet and posts their signals to Slack. True when the pass ran.
   */
  runCopilotSentimentSweep: Scalars['Boolean']['output'];
  /**
   * One pass of the Copilot sentiment triage for this environment (apps/crons, every 2 minutes on dev main and
   * prod): judges the negative signals whose alerts went out, files or merges their Linear tickets under
   * COPILOT_TRIAGE_MODE, and answers each alert and digest in Slack. True when the pass ran.
   */
  runCopilotSentimentTriage: Scalars['Boolean']['output'];
  saveBrandKitColors: Scalars['Boolean']['output'];
  saveBrandKitCompetitorFromChat: SaveBrandKitCompetitorFromChatPayload;
  saveBrandKitFonts: Scalars['Boolean']['output'];
  saveBrandKitLogos: Scalars['Boolean']['output'];
  saveBrandKitMedia: Scalars['Boolean']['output'];
  saveBrandKitTargetAudienceFromChat: SaveBrandKitTargetAudienceFromChatPayload;
  saveBrandKitVoiceAndTone: Scalars['Boolean']['output'];
  saveBrandStyleSourceImages: Array<BrandStyleSourceImage>;
  /**
   * DEPRECATED: use processMoodBoardContent + moodboard REST PUT directly. Kept for backward compatibility with external internal callers. Internally routes through processMoodBoardContent + direct-S3 write via the moodboard REST PUT.
   * @deprecated Internal callers should migrate to processMoodBoardContent + moodboard REST PUT
   */
  saveMoodBoardContent: MoodBoardProcessPayload;
  send7DaysMail: Scalars['Boolean']['output'];
  send21DaysMail: Scalars['Boolean']['output'];
  sendCompanyDataToIntercom: SendDataToIntercomPayload;
  sendEmail: Scalars['Boolean']['output'];
  /**
   * Emails the team's admins that the team reached the given usage milestone.
   * Called by the credits service (sendEnterpriseUsageEmail); dedupe per cycle
   * lives there. Returns false when the team has no admin to notify.
   */
  sendEnterpriseCreditsUsageEmail: Scalars['Boolean']['output'];
  sendMailBeforeRevokingAccess: Scalars['Boolean']['output'];
  sendUserEmailAddonCreditsUsage: Scalars['Boolean']['output'];
  sendUserEmailAddonImpressionsUsage: Scalars['Boolean']['output'];
  sendWorkflowMessage?: Maybe<SendWorkflowMessageResponse>;
  /** Store AI-generated metadata for a media (called by ai-generation workers) */
  setMediaAiMetadata?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Start extracting a brand from a website into a hidden draft kit for one Copilot chat. Only ai-agents
   * may call it: the caller names the user, whose DESIGN permission is checked here.
   */
  startCopilotBrandExtraction: CopilotBrandExtractionStart;
  /**
   * Start putting a brand on the Copilot's open template design (flat_to_layers_brandify): a website's, or
   * the design's own kit's when none is named. The flat-to-layers pipeline reads the design as the template
   * and replaces its layers, for a design with
   * one size and one slide. Only ai-agents may call it: the caller names the user, whose DESIGN permission
   * is checked here, and it starts a long generation.
   */
  startCopilotBrandOnTemplate: StartedCopilotBrandOnTemplate;
  /**
   * Start rebuilding a Copilot chat image as an editable design ("make it editable"): Edit design's
   * lift on a media library item, for a design with one size and one slide. Only ai-agents may call
   * it: the caller names the user, whose DESIGN permission is checked here, and it starts a paid
   * generation.
   */
  startCopilotEditDesign: StartedCopilotEditDesign;
  /**
   * Start a Copilot image, video or long video for one generateMedia call, as the browser's card would.
   * Only ai-agents may call it: the caller names the user, whose DESIGN permission is checked here, the
   * team billed is the design's, and it starts a paid generation.
   */
  startCopilotGeneration: StartedCopilotGeneration;
  /**
   * Start importing the media at a URL into a design's library for one Copilot
   * tool call: a direct image or video link is imported before this returns, a
   * web page is scraped and finishes later. Only ai-agents may call it: the
   * caller names the user, whose DESIGN permission is checked here.
   */
  startCopilotMediaImport: CopilotMediaImport;
  /**
   * Change part of a finished Copilot long video for one editVideoScenes call, as the browser's card would:
   * the changed scenes' opening pictures are edited first (each billed), then the scenes are made again.
   * Returns at once; the picture edits and the regeneration run on after it. Only ai-agents may call it:
   * the caller names the user, whose DESIGN permission is checked here, and the team billed is the design's.
   */
  startCopilotSceneEdit: StartedCopilotSceneEdit;
  /** @deprecated This mutation is deprecated and will be removed in a future version */
  startCreditTransaction: CreditTransactionPayload;
  /** Hand a drafted storyboard to its waiting multi-scene operation and start the chain (called by the ai-generation draft worker). Returns false when the operation is no longer waiting for its draft. */
  startDraftedMultiSceneChain: Scalars['Boolean']['output'];
  startImageGenerationFromPrompt: Array<GeneratedImageResult>;
  /** Starts a sponsored clip for a claimed draft (the team is not charged). Returns the AI operation id. */
  startMotionDraftClip: Scalars['Int']['output'];
  startVideoGenerationFromPrompt: Array<GeneratedVideoResult>;
  /** Stop A/B tests for a team (internal use). */
  stopTeamAbTests: Scalars['Boolean']['output'];
  /**
   * Store one logo or brand image the Copilot pulled out of a document attached to
   * a conversation. A public object with no Media row: it belongs to the
   * conversation, not to the media library or the brand kit. Only ai-agents may
   * call it: the caller names the user, so any other service could otherwise
   * use it to host files publicly.
   */
  storeCopilotDocumentImage: StoredCopilotDocumentImage;
  /** Soft-deletes Copilot brand-from-URL draft kits older than 7 days. */
  sweepCopilotBrandDrafts: Scalars['Boolean']['output'];
  /**
   * Sync a card hash to Yjs after video processing — use updateMedia with moodBoardMeta instead
   * @deprecated Use updateMedia with moodBoardMeta input instead
   */
  syncMoodBoardCardHash: SyncMoodBoardCardHashPayload;
  syncSubscription: SyncSubscriptionPayload;
  trackAiResizeStepFailed: Scalars['Boolean']['output'];
  /**
   * Retained @signed internal trigger for crafted-ads generation (a cross-service RPC into graphql). The
   * FLOOR-job producer is removed and Home-visit is the primary trigger, but this endpoint is KEPT: it is
   * still called by old ai-creator pods draining 120s-delayed floor jobs during a rolling deploy, and it
   * stays available as the internal trigger surface for future callers. The resolver delegates to the
   * self-gating generateCraftedAds service (gate -> completeness -> 0-crafted -> 0-in-flight), so redundant
   * or ineligible calls bail cleanly. (Under review 2026-07-24 — see the crafted follow-ups note.)
   */
  triggerCraftedAdsIfReady: Scalars['Boolean']['output'];
  triggerDpaSync: Scalars['Boolean']['output'];
  updateAiGenerationRulesFromChat: UpdateAiGenerationRulesFromChatPayload;
  updateAutomatedOptimizeReport: Scalars['Boolean']['output'];
  updateBrandKitDescription: Scalars['Boolean']['output'];
  updateBrandKitProfile: Scalars['Boolean']['output'];
  updateBrandKitStyle: Scalars['Boolean']['output'];
  updateBrandKitWithFonts: Scalars['Boolean']['output'];
  updateBulkDesigns: Scalars['Boolean']['output'];
  updateBulkRemoveBgFeed: Scalars['Boolean']['output'];
  updateBulkRevertBgFeed: Scalars['Boolean']['output'];
  updateBulkSmartCropFeed: Scalars['Boolean']['output'];
  /** Update a team's owner via customer support (internal use). */
  updateCSTeamOwner: Scalars['Boolean']['output'];
  /** Update a design's JSON content (internal use for AI agents). */
  updateDesign: UpdateDesignPayload;
  updateDesignSize: Scalars['Boolean']['output'];
  updateFacebookPublishStatus: Scalars['Boolean']['output'];
  updateFeature: UpdateFeatureResult;
  updateFeedData: Scalars['Boolean']['output'];
  /**
   * Called when LinkedIn publishing completes (success or failure).
   *
   * Finalizes the credit transaction on full success, rolls it back on any
   * failure (all-or-nothing), and cleans up Redis job tracking.
   */
  updateLinkedInPublishStatus: Scalars['Boolean']['output'];
  /** @deprecated Migration service has been removed */
  updateMigratedDesignStatus: Scalars['Boolean']['output'];
  /** @deprecated Migration service has been removed */
  updateMigratedFolderStatus: Scalars['Boolean']['output'];
  /** Update moodboard attributes (called by internal services) */
  updateMoodBoard: MoodBoard;
  updateNextGenAIFetchedStatus: Scalars['Boolean']['output'];
  updateOperation?: Maybe<Scalars['Boolean']['output']>;
  /** Record the PLACED design a non-terminal operation has already assembled, so a client can show the ad while it is still being verified. Stored under the placedDesignJson key, never designJson: the placed design is a preview and is never the applyable result. LAST-WRITE-WINS, not write-once, so a re-delivered job's own placed design can correct what the client is showing. Side-effect free: no analytics, credits, webhooks or status change. */
  updateOperationPlacedDesign?: Maybe<Scalars['Boolean']['output']>;
  /** Record the preview image a non-terminal operation has already produced, so a client can show it before the result is assembled. LAST-WRITE-WINS, not write-once: a re-delivered job re-runs its pipeline and produces a different image, and the newer one has to be able to correct what the client is showing. Side-effect free: no analytics, credits, webhooks or status change. */
  updateOperationPreview?: Maybe<Scalars['Boolean']['output']>;
  /** Record a non-terminal operation's current stage. Side-effect free: no analytics, credits, webhooks or status change. */
  updateOperationStage?: Maybe<Scalars['Boolean']['output']>;
  updatePhotoshopStatus: UpdatePhotoshopStatusPayload;
  updatePinterestCatalogPublishStatus: Scalars['Boolean']['output'];
  updatePinterestPublishStatus: Scalars['Boolean']['output'];
  /** @deprecated Migration service has been removed */
  updateProjectLogo: SetProjectLogoPayload;
  /**
   * Called when CM360 publishing is completed
   *
   * Updates publishing status and handles cleanup for CM360 operations.
   * Called on both success and failure to track exports and clean up resources.
   */
  updatePublishStatusCm360: Scalars['Boolean']['output'];
  updatePublishStatusDv360: Scalars['Boolean']['output'];
  /**
   * Called when Google Ads publishing is completed
   *
   * Updates publishing status and handles cleanup for Google Ads operations.
   * Called on both success and failure to track exports and clean up resources.
   */
  updatePublishStatusGoogleAds: Scalars['Boolean']['output'];
  updateTikTokCatalogPublishStatus: Scalars['Boolean']['output'];
  updateTikTokPublishStatus: Scalars['Boolean']['output'];
  updateTranslateFeed: Scalars['Boolean']['output'];
  /** @deprecated Migration service has been removed */
  uploadMigrateFont: UploadFontPayload;
  /** Deterministic watchdog evaluation of one applied resize candidate (json+html tiers, no LLM). Idempotent on (candidateHash, checksum). */
  watchdogEvaluateResize: WatchdogEvaluateResult;
  workflowFetchUrl?: Maybe<WorkflowFetchUrlResponse>;
};


export type InternalMutationAdTagReportScheduleRunArgs = {
  input: InputAdTagReportScheduleRun;
};


export type InternalMutationAddAiDesignCardToMoodboardArgs = {
  input: InputAddAiDesignCardToMoodboard;
};


export type InternalMutationAddAiImageCardsToMoodboardArgs = {
  input: InputAddAiImageCardsToMoodboard;
};


export type InternalMutationAddAiVideoCardsToMoodboardArgs = {
  input: InputAddAiVideoCardsToMoodboard;
};


export type InternalMutationAiReportHtmlToPdfCallbackArgs = {
  input: InputAiReportHtmlToPdfCallback;
};


export type InternalMutationAiResizeHtmlPreviewJsonArgs = {
  input: InputAiResizeHtmlPreviewJson;
};


export type InternalMutationAiResizeHtmlUpdateJsonArgs = {
  input: InputAiResizeHtmlUpdateJson;
};


export type InternalMutationAiResizeUpdateJsonArgs = {
  input: InputAiResizeUpdateJson;
};


export type InternalMutationAssureDesignJsonIsSavedArgs = {
  input: InputAssureDesignJsonIsSaved;
};


export type InternalMutationBuildJsonDesignFromExtractedInfoArgs = {
  input: InputBuildJsonDesignFromExtractedInfo;
};


export type InternalMutationClaimMotionDraftArgs = {
  input: InputClaimMotionDraft;
};


export type InternalMutationCloneDesignFromEnvArgs = {
  input: InputCloneDesignFromEnv;
};


export type InternalMutationCloneMoodBoardFromEnvArgs = {
  input: InputCloneMoodBoardFromEnv;
};


export type InternalMutationCollectTransactionDataArgs = {
  input: InputCollectTransactionData;
};


export type InternalMutationCompleteBrandKitDocumentExtractionArgs = {
  input: InputCompleteBrandKitDocumentExtraction;
};


export type InternalMutationCompleteBrandStyleReevaluationArgs = {
  input: InputCompleteBrandStyleReevaluation;
};


export type InternalMutationCompleteMotionDraftArgs = {
  input: InputCompleteMotionDraft;
};


export type InternalMutationCreateApiMediaArgs = {
  input: InputCreateApiMedia;
};


export type InternalMutationCreateCustomSizesFromBsCustomSizesArgs = {
  input: InputCreateCustomSizesFromBsCustomSizes;
};


export type InternalMutationCreateDefaultBrandKitButtonArgs = {
  input: InputCreateDefaultBrandKitButton;
};


export type InternalMutationCreateDesignArgs = {
  input: InputCreateDesign;
  userId: Scalars['Int']['input'];
};


export type InternalMutationCreateDesignFromBsBannerArgs = {
  input: InputCreateDesignFromBsBanner;
};


export type InternalMutationCreateDesignSetArgs = {
  input: InputInternalCreateDesignFromJsons;
  userId: Scalars['Int']['input'];
};


export type InternalMutationCreateDesignSetFromBsBannerSetArgs = {
  input: InputCreateDesignSetFromBsBannerSet;
};


export type InternalMutationCreateFeatureArgs = {
  input: InputCreateFeature;
};


export type InternalMutationCreateFolderFromBsFolderArgs = {
  input: InputCreateFolderFromBsFolder;
};


export type InternalMutationCreateMediaArgs = {
  input: InputCreateMedia;
  userId: Scalars['Int']['input'];
};


export type InternalMutationCreateMediaFolderArgs = {
  input: InputCreateMediaFolderInternal;
};


export type InternalMutationCreateMediaFromBsMediaArgs = {
  input: InputMigrate;
};


export type InternalMutationCreatePlanArgs = {
  input: InputCreatePlan;
};


export type InternalMutationDeactivateAdTagFeatureArgs = {
  input: InputAdTagFeatureState;
};


export type InternalMutationDoMigrateBrandTemplatesArgs = {
  input: InputDoMigrateBrandTemplates;
};


export type InternalMutationDownloadArgs = {
  anonymousId?: InputMaybe<Scalars['String']['input']>;
  input: InputDownloadCreate;
  skipAccessCheck?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type InternalMutationDownloadZipResultArgs = {
  input: InputDownloadZipResult;
};


export type InternalMutationDuplicateSubFolderArgs = {
  input: InputDuplicateSubFolder;
};


export type InternalMutationEnforceAdServingEntitlementArgs = {
  input: InputEnforceAdServingEntitlement;
};


export type InternalMutationExportDpaFinishedArgs = {
  input: ExportDpaFinishedInput;
};


export type InternalMutationExportImageForLastSavedDesignsArgs = {
  input?: InputMaybe<InputExportImageForLastSavedDesigns>;
};


export type InternalMutationExportMediaUpdateArgs = {
  input: InputExportMedia;
};


export type InternalMutationExportResultArgs = {
  input: InputExportResult;
};


export type InternalMutationFailMotionDraftArgs = {
  input: InputFailMotionDraft;
};


export type InternalMutationFeedSyncArgs = {
  input?: InputMaybe<InputSyncFeedInternal>;
};


export type InternalMutationFigFileReportArgs = {
  input: InputFigFileReport;
};


export type InternalMutationFinalizeCreditTransactionArgs = {
  input: FinalizeCreditTransactionInput;
};


export type InternalMutationGenerateDesignArgs = {
  input: InputGenerateDesign;
};


export type InternalMutationGenerateLayeredAdArgs = {
  input: InputGenerateLayeredAd;
  userId: Scalars['Int']['input'];
};


export type InternalMutationGenerateProductPhotographyArgs = {
  input: InputProductPhotography;
};


export type InternalMutationGenerateTextArgs = {
  input: InputTextGeneration;
};


export type InternalMutationInternalApplyContentVariationsArgs = {
  jobId: Scalars['Int']['input'];
  variationIndex?: InputMaybe<Scalars['Int']['input']>;
};


export type InternalMutationInternalFailContentVariationJobArgs = {
  jobId: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
  variationIndex?: InputMaybe<Scalars['Int']['input']>;
};


export type InternalMutationInternalFailDeadContentVariationQueueJobArgs = {
  jobId: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
  stage: ContentVariationQueueStage;
  variationIndex?: InputMaybe<Scalars['Int']['input']>;
};


export type InternalMutationInternalMarkContentVariationAssetsReadyArgs = {
  jobId: Scalars['Int']['input'];
  variationIndex: Scalars['Int']['input'];
};


export type InternalMutationInternalSubmitContentVariationBundleArgs = {
  bundle: Scalars['JSON']['input'];
  carriesAssetRefs?: InputMaybe<Scalars['Boolean']['input']>;
  jobId: Scalars['Int']['input'];
};


export type InternalMutationInvalidatePaymentArgs = {
  input: InputInvalidatePayment;
};


export type InternalMutationLintDesignJsonResizeabilityArgs = {
  input: InputLintDesignJsonResizeability;
};


export type InternalMutationMarkAiOperationsViewedArgs = {
  operationIds: Array<Scalars['Int']['input']>;
};


export type InternalMutationMarkDesignAsTemplateArgs = {
  input: InputMarkDesignAsTemplate;
};


export type InternalMutationMarkDesignSetAsTemplateArgs = {
  input: InputMarkDesignSetAsTemplate;
};


export type InternalMutationMarkTeamAssetsForDeletionArgs = {
  input: InputMarkTeamAssetsForDeletion;
};


export type InternalMutationMigrateBannersArgs = {
  input: InputMigrate;
};


export type InternalMutationMigrateFoldersArgs = {
  input: InputMigrate;
};


export type InternalMutationMoveCacheJsonsArgs = {
  input?: InputMaybe<InputMoveCacheJsons>;
};


export type InternalMutationParseTemplateArgs = {
  input: InputParseTemplate;
};


export type InternalMutationPersistCraftedDesignArgs = {
  input: InputPersistCraftedDesign;
};


export type InternalMutationPersistLinkedInRotatedTokenArgs = {
  input: InputLinkedInRotatedToken;
};


export type InternalMutationPersistPinterestRotatedTokenArgs = {
  input: InputPinterestRotatedToken;
};


export type InternalMutationProcessMoodBoardContentArgs = {
  input: InputProcessMoodBoardContent;
};


export type InternalMutationProcessRecurlyWebhookArgs = {
  input: ProcessRecurlyWebhookInput;
};


export type InternalMutationPublishFeedPayloadArgs = {
  input: InputPublishFeedPayload;
};


export type InternalMutationPurgeNextTrashedDesignsArgs = {
  input?: InputMaybe<InputPurgeNextTrashedDesigns>;
};


export type InternalMutationPurgeTrashedDesignsArgs = {
  input: InputPurgeTrashedDesigns;
};


export type InternalMutationRecordCraftedBatchFailureArgs = {
  input: InputRecordCraftedBatchFailure;
};


export type InternalMutationRecordDesignScorerShadowArgs = {
  input: InputRecordDesignScorerShadow;
};


export type InternalMutationRecordPhishingUrlVerdictArgs = {
  input: InputRecordPhishingUrlVerdict;
};


export type InternalMutationReindexDesignFeedAdjustmentsArgs = {
  input: InputReindexDesignFeedAdjustments;
};


export type InternalMutationRemoveImageBackgroundArgs = {
  input: InputNextGenRemoveBg;
};


export type InternalMutationRemoveUrlsFromDesignsArgs = {
  input: InputRemoveUrlsFromDesigns;
};


export type InternalMutationRenderLayeredAdPreviewArgs = {
  operationId: Scalars['Int']['input'];
};


export type InternalMutationRepairRefusedFontsArgs = {
  input: InputRepairRefusedFonts;
};


export type InternalMutationResetAddonUsageForTeamArgs = {
  input: InputResetAddonUsageForTeam;
};


export type InternalMutationResetNoDownloadsCacheArgs = {
  input: InputResetNoDownloadsCache;
};


export type InternalMutationResizeGradeFeedPostArgs = {
  input: InputResizeGradeFeedPost;
};


export type InternalMutationResizeWithFlexArgs = {
  input: InputResizeWithFlex;
};


export type InternalMutationResizeWithPublicTemplateArgs = {
  input: InputResizeWithPublicTemplate;
};


export type InternalMutationRollbackCreditTransactionArgs = {
  input: RollbackCreditTransactionInput;
};


export type InternalMutationSaveBrandKitColorsArgs = {
  input: InputSaveBrandKitColors;
};


export type InternalMutationSaveBrandKitCompetitorFromChatArgs = {
  input: InputSaveBrandKitCompetitorFromChat;
};


export type InternalMutationSaveBrandKitFontsArgs = {
  input: InputSaveBrandKitFonts;
};


export type InternalMutationSaveBrandKitLogosArgs = {
  input: InputSaveBrandKitLogos;
};


export type InternalMutationSaveBrandKitMediaArgs = {
  input: InputSaveBrandKitMedia;
};


export type InternalMutationSaveBrandKitTargetAudienceFromChatArgs = {
  input: InputSaveBrandKitTargetAudienceFromChat;
};


export type InternalMutationSaveBrandKitVoiceAndToneArgs = {
  input: InputSaveBrandKitVoiceAndTone;
};


export type InternalMutationSaveBrandStyleSourceImagesArgs = {
  input: InputSaveBrandStyleSourceImages;
};


export type InternalMutationSaveMoodBoardContentArgs = {
  input: InputSaveMoodBoardContent;
};


export type InternalMutationSendCompanyDataToIntercomArgs = {
  input: InputUpdateCompany;
};


export type InternalMutationSendEmailArgs = {
  input: InputEmailSend;
};


export type InternalMutationSendEnterpriseCreditsUsageEmailArgs = {
  input: InputEnterpriseCreditsUsageEmail;
};


export type InternalMutationSendWorkflowMessageArgs = {
  input: InputSendWorkflowMessage;
};


export type InternalMutationSetMediaAiMetadataArgs = {
  aiModel?: InputMaybe<Scalars['String']['input']>;
  mediaHash: Scalars['String']['input'];
  metadataType: Scalars['String']['input'];
  metadataValue: Scalars['JSON']['input'];
  metadataVersion?: InputMaybe<Scalars['Int']['input']>;
};


export type InternalMutationStartCopilotBrandExtractionArgs = {
  input: InputStartCopilotBrandExtraction;
  userId: Scalars['Int']['input'];
};


export type InternalMutationStartCopilotBrandOnTemplateArgs = {
  input: InputStartCopilotBrandOnTemplate;
  userId: Scalars['Int']['input'];
};


export type InternalMutationStartCopilotEditDesignArgs = {
  input: InputStartCopilotEditDesign;
  userId: Scalars['Int']['input'];
};


export type InternalMutationStartCopilotGenerationArgs = {
  input: InputStartCopilotGeneration;
  userId: Scalars['Int']['input'];
};


export type InternalMutationStartCopilotMediaImportArgs = {
  input: InputStartCopilotMediaImport;
  userId: Scalars['Int']['input'];
};


export type InternalMutationStartCopilotSceneEditArgs = {
  input: InputStartCopilotSceneEdit;
  userId: Scalars['Int']['input'];
};


export type InternalMutationStartCreditTransactionArgs = {
  input: StartCreditTransactionInternalInput;
};


export type InternalMutationStartDraftedMultiSceneChainArgs = {
  input: InputStartDraftedMultiSceneChain;
};


export type InternalMutationStartImageGenerationFromPromptArgs = {
  input: InputImageGeneration;
};


export type InternalMutationStartMotionDraftClipArgs = {
  input: InputStartMotionDraftClip;
};


export type InternalMutationStartVideoGenerationFromPromptArgs = {
  input: InputVideoGeneration;
};


export type InternalMutationStopTeamAbTestsArgs = {
  input: InputStopTeamAbTests;
};


export type InternalMutationStoreCopilotDocumentImageArgs = {
  input: InputStoreCopilotDocumentImage;
  userId: Scalars['Int']['input'];
};


export type InternalMutationSyncMoodBoardCardHashArgs = {
  input: InputSyncMoodBoardCardHash;
};


export type InternalMutationSyncSubscriptionArgs = {
  input: InputSyncSubscription;
};


export type InternalMutationTrackAiResizeStepFailedArgs = {
  input: InputTrackAiResizeStepFailed;
};


export type InternalMutationTriggerCraftedAdsIfReadyArgs = {
  input: InputTriggerCraftedAdsIfReady;
};


export type InternalMutationTriggerDpaSyncArgs = {
  input: InputTriggerDpaSync;
};


export type InternalMutationUpdateAiGenerationRulesFromChatArgs = {
  input: InputUpdateAiGenerationRulesFromChat;
};


export type InternalMutationUpdateAutomatedOptimizeReportArgs = {
  input: InputUpdateAutomatedOptimizeReport;
};


export type InternalMutationUpdateBrandKitDescriptionArgs = {
  input: InputUpdateBrandKitDescription;
};


export type InternalMutationUpdateBrandKitProfileArgs = {
  input: InputUpdateBrandKitProfile;
};


export type InternalMutationUpdateBrandKitStyleArgs = {
  input: InputUpdateBrandKitStyle;
};


export type InternalMutationUpdateBrandKitWithFontsArgs = {
  input: InputUpdateBrandKitWithFonts;
};


export type InternalMutationUpdateBulkDesignsArgs = {
  input: InputUpdateBulkDesigns;
};


export type InternalMutationUpdateBulkRemoveBgFeedArgs = {
  input: InputUpdateBulkRemoveBgFeed;
};


export type InternalMutationUpdateBulkRevertBgFeedArgs = {
  input: InputUpdateBulkRevertBgFeed;
};


export type InternalMutationUpdateBulkSmartCropFeedArgs = {
  input: InputUpdateBulkSmartCropFeed;
};


export type InternalMutationUpdateCsTeamOwnerArgs = {
  input: InputCsTeamOwnerUpdate;
};


export type InternalMutationUpdateDesignArgs = {
  input: InputUpdateDesign;
  userId: Scalars['Int']['input'];
};


export type InternalMutationUpdateDesignSizeArgs = {
  input: InputUpdateDesignSize;
};


export type InternalMutationUpdateFacebookPublishStatusArgs = {
  input: InputFacebookPublishUpdateStatus;
};


export type InternalMutationUpdateFeatureArgs = {
  input: InputUpdateFeature;
};


export type InternalMutationUpdateFeedDataArgs = {
  input: InputUpdateFeedData;
};


export type InternalMutationUpdateLinkedInPublishStatusArgs = {
  input: InputLinkedInPublishUpdate;
};


export type InternalMutationUpdateMigratedDesignStatusArgs = {
  input: InputUpdateMigratedDesignStatus;
};


export type InternalMutationUpdateMigratedFolderStatusArgs = {
  input: InputUpdateMigratedFolderStatus;
};


export type InternalMutationUpdateMoodBoardArgs = {
  input: InputUpdateMoodBoardInternal;
};


export type InternalMutationUpdateNextGenAiFetchedStatusArgs = {
  input: InputUpdateNextGenAiFetchedStatus;
};


export type InternalMutationUpdateOperationArgs = {
  input: InputUpdateOperation;
};


export type InternalMutationUpdateOperationPlacedDesignArgs = {
  input: InputUpdateOperationPlacedDesign;
};


export type InternalMutationUpdateOperationPreviewArgs = {
  input: InputUpdateOperationPreview;
};


export type InternalMutationUpdateOperationStageArgs = {
  input: InputUpdateOperationStage;
};


export type InternalMutationUpdatePhotoshopStatusArgs = {
  input: InputUpdatePhotoshopStatus;
};


export type InternalMutationUpdatePinterestCatalogPublishStatusArgs = {
  input: UpdatePinterestCatalogPublishStatusInput;
};


export type InternalMutationUpdatePinterestPublishStatusArgs = {
  input: UpdatePinterestPublishStatusInput;
};


export type InternalMutationUpdateProjectLogoArgs = {
  input: InputProjectUpdate;
};


export type InternalMutationUpdatePublishStatusCm360Args = {
  input: InputCm360PublishUpdate;
};


export type InternalMutationUpdatePublishStatusDv360Args = {
  input: InputDv360PublishUpdate;
};


export type InternalMutationUpdatePublishStatusGoogleAdsArgs = {
  input: InputGoogleAdsPublishUpdate;
};


export type InternalMutationUpdateTikTokCatalogPublishStatusArgs = {
  input: UpdateTikTokCatalogPublishStatusInput;
};


export type InternalMutationUpdateTikTokPublishStatusArgs = {
  input: InputTikTokPublishUpdateStatus;
};


export type InternalMutationUpdateTranslateFeedArgs = {
  input: InputUpdateTranslateFeed;
};


export type InternalMutationUploadMigrateFontArgs = {
  input: InputWorkerUploadFont;
};


export type InternalMutationWatchdogEvaluateResizeArgs = {
  input: InputWatchdogEvaluateResize;
};


export type InternalMutationWorkflowFetchUrlArgs = {
  input: InputWorkflowFetchUrl;
};

export type InternalQuery = {
  __typename?: 'InternalQuery';
  /** @deprecated Not used */
  _empty?: Maybe<Scalars['String']['output']>;
  account?: Maybe<RecurlyAccount>;
  adTagDynamicVar: Array<AdTagExternalDesignTrackingUrl>;
  adTagExternalDesignTracking: Array<AdTagExternalDesignTrackingUrl>;
  aiResizeModel: AiResizeModelPayload;
  aiResizeSampleHtml: AiResizeSampleHtmlPayload;
  aiResizeSessionPrompts: AiResizeSessionPromptsPayload;
  /** Newest VALID brand-kit images that carry an AI description, capped (default 8). Fixed work: one media page + one batched description load. */
  brandKitDescribedAssets: Array<BrandKitDescribedAsset>;
  /**
   * A fresh short-lived signed GET for the private document a job at this version is
   * about to extract. Null when the job is superseded, so a stale job never obtains one.
   * The worker asks right before the download; the URL in its payload is an older
   * signature kept only as a fallback.
   */
  brandKitDocumentExtractionSourceUrl?: Maybe<Scalars['String']['output']>;
  brandedDomainList: Array<Maybe<Scalars['String']['output']>>;
  /** Check AI operations status (internal use for ai-mail-notification service) */
  checkAiOperationsInternal: Array<Maybe<GeneratedImageResult>>;
  /** A Copilot chat's newest media imports on a design, with image descriptions. Only ai-agents may call it. */
  copilotMediaImports: Array<CopilotMediaImport>;
  /**
   * A finished long video's scenes for the Copilot's getVideoScenes, found by media hash in the design's
   * generations. Only ai-agents may call it: the user it names must be able to edit the design.
   */
  copilotVideoStoryboard: CopilotVideoStoryboard;
  /** Get a design by hash (internal use). */
  design?: Maybe<Design>;
  /** Get a design's JSON data by hash (internal use). */
  designJson: JsonDesignWithHash;
  downloadStatus: DownloadStatus;
  /**
   * Returns the subset of input email domains that already belong to an existing
   * team owner in creatopy-db. Used by lead-pipeline to skip prospecting existing customers.
   */
  existingCustomerEmailDomains: Array<Scalars['String']['output']>;
  extractResizeInfo: ExtractResizeInfoPayload;
  featureComparer: Array<Feature>;
  /**
   * The Figma plugin's font check for a .fig STRUCTURE job, with one missing-fonts list per frame (in the order of
   * frames). Each frame is the JSON of one root the check walks. Internal use only (apps/figma).
   */
  figFileFonts: FigFileFonts;
  /** A .fig import's status record as the last job on the key left it. Internal use only (apps/figma). */
  figFileImportStatus: FigFileImportStatus;
  /**
   * Get all fonts by family name.
   * Retrieves all weights and variants of a specified font family.
   */
  fontsByFamily?: Maybe<Array<Font>>;
  getActiveUsageRestrictions: Array<ActiveUsageRestriction>;
  /** Full Ad Studio context for a design: cached design summary + brand kit. */
  getAdStudioContext: AdStudioContext;
  /** The same 3-5 ephemeral AI-suggested audiences the Content panel offers when the Brand Kit has none saved — for the Copilot, which cannot reach the user-authenticated Query.suggestDefaultAudiences. EPHEMERAL: never written to the Brand Kit, and source says whether they came from the model or the preset fallback. Same service, same cache, so panel and chat suggest the same names. */
  getAdStudioDefaultAudiences: DefaultAudiences;
  /** Deterministic design facts only (sizes, texts, urls, fonts, colors) — never reads or computes the AI summary. */
  getAdStudioDesignFacts: Scalars['JSON']['output'];
  /** On-demand render of the design's main size for the Copilot's eyes: live jpg-png render of the saved JSON, degrading to the S3 preview. Pass source: 'preview' to skip the live render entirely — the fast path the dock-open greeting needs. sizeId renders that size instead of the main size; slideId renders that slide instead of the first; maxEdgePx downscales the render on its long edge (latency + payload-size lever). All three are optional and default to today's behaviour. NULLABLE: the preview-only path answers null when a design has no thumbnail yet, which is an expected state rather than a failure. The default path still errors. { imageBase64, contentType, width, height, source }. */
  getAdStudioDesignRender?: Maybe<Scalars['JSON']['output']>;
  /** AI Studio generation feed for one design (internal use for AI agents). Same service as the public Query field; the caller is responsible for scoping teamId, since internal fields carry no @access directive. */
  getAiStudioGenerationsInternal: AiStudioGenerationsInternalResult;
  /** Get brand kit context for AI generation (internal use) */
  getBrandKitContext?: Maybe<BrandKitContextResult>;
  /**
   * Placeable brand-kit roster for the Copilot picker.
   *
   * The query argument filters on an item NAME, case-insensitively, in every
   * category. Logos additionally match on their filename: they are an in-memory
   * association rather than a queryable collection, so their filter runs here and
   * can read the field, and a kit storing several logos under one name has
   * nothing else to tell them apart. Assets and components are narrowed by the
   * database on name alone.
   */
  getBrandKitItems?: Maybe<BrandKitItemsResult>;
  /** Get the appropriate design size type based on dimensions. */
  getDesignSizeType: GetDesignSizeTypePayload;
  getEmailTemplate?: Maybe<EmailTemplate>;
  getEmailTemplates: Array<EmailTemplate>;
  getFeaturebaseTeamData: FeaturebaseTeamDataPayload;
  /** Load moodboard content for internal services (moodboard collaboration service) */
  getMoodBoardContent: MoodBoardContentPayload;
  getNextGenBrandfetchInternal?: Maybe<NextGenBrandfetchInternalData>;
  /** Get recent AI operations for a user, filtered by status (internal use for ai-mail-notification dedup) */
  getRecentAiOperationsForUser: Array<RecentAiOperation>;
  /** The user's recent Copilot ads not seen yet, newest first (internal use for the "your ad is ready" email) */
  getRecentCopilotAdsForUser: Array<RecentCopilotAd>;
  /**
   * Describe the images currently on a design's stage, so the Copilot can
   * resolve "the motor oil canister" to a layer. Reads stored descriptions and
   * backfills a bounded number of misses (internal use).
   *
   * The urls are client-supplied, so the backfill — the paid half — only runs
   * for media reachable from the designHash team. Omit designHash and stored
   * descriptions still read, but nothing is generated.
   */
  getStageImageDescriptions?: Maybe<StageImageDescriptionsResult>;
  getTeamGoogleAdsIntegrationsByTeamUserId: Array<GoogleAdsIntegrationByTeamUserIdResult>;
  getTeamMetaIntegrationsByTeamUserId: Array<TeamMetaIntegrationByTeamUserIdResult>;
  /** Extract text from an image using AI vision (internal use for AI agents) */
  getTextExtraction: TextExtractionResult;
  /** Get user info for email notifications (internal use for ai-mail-notification service) */
  getUserForNotification?: Maybe<AiMailNotificationUserInfo>;
  /** Get variation suggestions for an image (internal use for AI agents) */
  getVariationSuggestions: VariationSuggestionsResult;
  /**
   * Good customer team owners used as seeds for lookalike prospecting.
   * Internal, service-to-service only — restricted to the lead-pipeline service.
   */
  goodCustomerTeamOwners: Array<GoodCustomerTeamOwner>;
  /**
   * Get all available Google fonts.
   * Internal version without caching.
   */
  googleFonts: Array<GoogleFont>;
  /** AiOperation status for the job's fired image slots — scoped to ONE variation when variationIndex is given, which is how each per-variation apply job waits on its own imagery only. */
  internalContentVariationImageStatus: Array<ContentVariationImageOperationStatus>;
  /** Everything Job 1 (ai-generation) needs for its single generateObject call: input snapshot, design summary, brand kit, current copy per target, library photo metadata. */
  internalContentVariationJobContext: ContentVariationJobContext;
  /** The Ad Studio Copilot's read of a design family's content-variation jobs — active or recently-finished, same shape and same underlying service as the public contentVariationJobs query. No user/checkDesignAccess check: graphql already authorised the calling user for this design at the /api/chat/stream boundary before ai-agents ran (mirrors adStudioContext.InternalQuery's getAdStudioDesignFacts). Only ai-agents may call it: the caller names the design, so any other service could otherwise read any design's job labels and errors. */
  internalContentVariationJobsForDesign: Array<ContentVariationJobSummary>;
  /**
   * Is the document extraction stamped with this version still the one the row waits for?
   * The worker asks before downloading and calling the model.
   */
  isBrandKitDocumentExtractionCurrent: Scalars['Boolean']['output'];
  /**
   * Is the brand-profile extraction stamped with this version still the one the kit is waiting for?
   * False once a later enqueue or a user edit has superseded it, or once the lifecycle left 'running'.
   * The worker asks BEFORE scraping and analysing so a superseded job does not pay for a Chromium
   * launch and a model call only to have its result dropped by the write-time guard.
   */
  isBrandProfileExtractionCurrent: Scalars['Boolean']['output'];
  /** Salient region per media key, from the permanent focal-region cache (internal use for AI resize and design-sampler) */
  mediaFocalRegions: MediaFocalRegionsPayload;
  /** Get detailed information about a media asset (internal use). */
  mediaInfo?: Maybe<Media>;
  /**
   * Sync-time Meta token for the feed-sync worker (CRE-423): resolved fresh per
   * run from business_social_link so the 60-day token never sits in a Redis
   * job payload and stays current across retry backoff.
   *
   * It also carries the catalog's set state and seeded column order, for the
   * same reason: a BullMQ payload is a snapshot taken at enqueue, and a user can
   * request an import at any point during a run — a snapshot silently drops it.
   */
  metaFeedSyncAuth: MetaFeedSyncAuth;
  plans: Array<PlanGroup>;
  /**
   * Get all fonts assigned to a project through its brand kit.
   * Internal use only.
   */
  projectFonts: Array<Font>;
  /**
   * All paying (subscriber) Recurly accounts, mapped for the lead-pipeline
   * source-customer backfill. Internal, service-to-service only.
   */
  recurlyPayingAccounts: Array<RecurlyPayingAccount>;
  /**
   * Current children of a sample-ads claim's design set (id, hash, name, real
   * dimensions, updatedAt, and the FULL design JSON) — the read side of the
   * lead-pipeline "pull edited designs" flow. Errors carry SAMPLE_AD_SET_*
   * codes in extensions.code. Internal, service-to-service only.
   */
  sampleAdSetSnapshot: SampleAdSetSnapshotPayload;
  /** Get a signed URL for uploading media (internal use). */
  signUploadUrl: SignUploadUrlResult;
  subscription?: Maybe<RecurlyAccountSubscription>;
  subscriptionPlanVersion: Scalars['Int']['output'];
  subscriptionTermEnd: Scalars['Date']['output'];
  /**
   * Get a team by ID (internal use).
   * Requires signed access with HUBSPOT permission.
   */
  team?: Maybe<Team>;
  teamAttribution: TeamAttribution;
  /**
   * Get just a team's display name (internal use).
   * Deliberately narrower than the team query: callers that only need the name
   * for operator-facing output must not gain read access to the whole Team
   * object (owner identity, testAccount, settings).
   * Null when the team does not exist.
   */
  teamName?: Maybe<Scalars['String']['output']>;
  /** Get a team's owner ID (internal use). */
  teamOwnerId: Scalars['Int']['output'];
  /** Get teams owned by a user (internal use). */
  teamsOwnedByUser: Array<Team>;
  /** Retrieve user information for internal services. Requires HUBSPOT signed access. */
  user?: Maybe<User>;
  /** Validate user token and return user information for moodboard service. */
  validateUserToken?: Maybe<User>;
  /** Verify moodboard access and get user permissions for internal services */
  verifyMoodBoardAccess: MoodBoardAccessPayload;
};


export type InternalQueryAccountArgs = {
  input: InputAccount;
};


export type InternalQueryAdTagDynamicVarArgs = {
  input: InputDesignAdTagByHash;
};


export type InternalQueryAdTagExternalDesignTrackingArgs = {
  input: InputDesignAdTagByHash;
};


export type InternalQueryAiResizeModelArgs = {
  input: InputAiResizeModel;
};


export type InternalQueryAiResizeSampleHtmlArgs = {
  input: InputAiResizeSampleHtml;
};


export type InternalQueryAiResizeSessionPromptsArgs = {
  input: InputAiResizeSessionPrompts;
};


export type InternalQueryBrandKitDescribedAssetsArgs = {
  brandKitId: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type InternalQueryBrandKitDocumentExtractionSourceUrlArgs = {
  input: InputIsBrandKitDocumentExtractionCurrent;
};


export type InternalQueryCheckAiOperationsInternalArgs = {
  input: InputCheckAiOperations;
};


export type InternalQueryCopilotMediaImportsArgs = {
  input: InputCopilotMediaImports;
  userId: Scalars['Int']['input'];
};


export type InternalQueryCopilotVideoStoryboardArgs = {
  input: InputCopilotVideoStoryboard;
  userId: Scalars['Int']['input'];
};


export type InternalQueryDesignArgs = {
  input: InputDesign;
};


export type InternalQueryDesignJsonArgs = {
  input: InputInternalDesignJson;
};


export type InternalQueryDownloadStatusArgs = {
  input: InputDownload;
};


export type InternalQueryExistingCustomerEmailDomainsArgs = {
  domains: Array<Scalars['String']['input']>;
};


export type InternalQueryExtractResizeInfoArgs = {
  input: InputExtractResizeInfo;
};


export type InternalQueryFigFileFontsArgs = {
  input: InputFigFileFonts;
};


export type InternalQueryFigFileImportStatusArgs = {
  key: Scalars['String']['input'];
};


export type InternalQueryFontsByFamilyArgs = {
  input: InputFontsByFamily;
};


export type InternalQueryGetActiveUsageRestrictionsArgs = {
  input: GetActiveUsageRestrictionsInput;
};


export type InternalQueryGetAdStudioContextArgs = {
  designHash: Scalars['String']['input'];
};


export type InternalQueryGetAdStudioDefaultAudiencesArgs = {
  designHash: Scalars['String']['input'];
};


export type InternalQueryGetAdStudioDesignFactsArgs = {
  designHash: Scalars['String']['input'];
};


export type InternalQueryGetAdStudioDesignRenderArgs = {
  designHash: Scalars['String']['input'];
  maxEdgePx?: InputMaybe<Scalars['Int']['input']>;
  sizeId?: InputMaybe<Scalars['Int']['input']>;
  slideId?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};


export type InternalQueryGetAiStudioGenerationsInternalArgs = {
  input: InputAiStudioGenerations;
};


export type InternalQueryGetBrandKitContextArgs = {
  brandKitId: Scalars['Int']['input'];
};


export type InternalQueryGetBrandKitItemsArgs = {
  brandKitId: Scalars['Int']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type InternalQueryGetDesignSizeTypeArgs = {
  input: InputGetDesignSizeType;
};


export type InternalQueryGetEmailTemplateArgs = {
  identifier: Scalars['String']['input'];
};


export type InternalQueryGetFeaturebaseTeamDataArgs = {
  input: InputGetFeaturebaseTeamData;
};


export type InternalQueryGetMoodBoardContentArgs = {
  input: InputGetMoodBoardContent;
};


export type InternalQueryGetNextGenBrandfetchInternalArgs = {
  nextGenId: Scalars['Int']['input'];
};


export type InternalQueryGetRecentAiOperationsForUserArgs = {
  input: InputGetRecentAiOperations;
};


export type InternalQueryGetRecentCopilotAdsForUserArgs = {
  input: InputGetRecentCopilotAds;
};


export type InternalQueryGetStageImageDescriptionsArgs = {
  designHash?: InputMaybe<Scalars['String']['input']>;
  urls: Array<Scalars['String']['input']>;
};


export type InternalQueryGetTeamGoogleAdsIntegrationsByTeamUserIdArgs = {
  input: InputTeamIntegrationByTeamUserId;
};


export type InternalQueryGetTeamMetaIntegrationsByTeamUserIdArgs = {
  input: InputTeamIntegrationByTeamUserId;
};


export type InternalQueryGetTextExtractionArgs = {
  input: InputTextExtraction;
};


export type InternalQueryGetUserForNotificationArgs = {
  userId: Scalars['Int']['input'];
};


export type InternalQueryGetVariationSuggestionsArgs = {
  input: InputVariationSuggestions;
};


export type InternalQueryInternalContentVariationImageStatusArgs = {
  jobId: Scalars['Int']['input'];
  variationIndex?: InputMaybe<Scalars['Int']['input']>;
};


export type InternalQueryInternalContentVariationJobContextArgs = {
  jobId: Scalars['Int']['input'];
};


export type InternalQueryInternalContentVariationJobsForDesignArgs = {
  designHash: Scalars['String']['input'];
};


export type InternalQueryIsBrandKitDocumentExtractionCurrentArgs = {
  input: InputIsBrandKitDocumentExtractionCurrent;
};


export type InternalQueryIsBrandProfileExtractionCurrentArgs = {
  input: InputIsBrandProfileExtractionCurrent;
};


export type InternalQueryMediaFocalRegionsArgs = {
  input: InputMediaFocalRegions;
};


export type InternalQueryMediaInfoArgs = {
  input: InputMediaInfoQuery;
};


export type InternalQueryMetaFeedSyncAuthArgs = {
  input: InputMetaFeedSyncAuth;
};


export type InternalQueryPlansArgs = {
  input: InputPlansInternal;
};


export type InternalQueryProjectFontsArgs = {
  input: InputProjectFonts;
};


export type InternalQuerySampleAdSetSnapshotArgs = {
  designSetHash: Scalars['String']['input'];
};


export type InternalQuerySubscriptionArgs = {
  input: InputSubscription;
};


export type InternalQuerySubscriptionPlanVersionArgs = {
  input: InputSubscriptionPlanVersion;
};


export type InternalQuerySubscriptionTermEndArgs = {
  input: InputSubscriptionTermEnd;
};


export type InternalQueryTeamArgs = {
  input: InputTeam;
};


export type InternalQueryTeamAttributionArgs = {
  input: InputTeamAttribution;
};


export type InternalQueryTeamNameArgs = {
  input: InputTeam;
};


export type InternalQueryTeamOwnerIdArgs = {
  input: InputTeamOwner;
};


export type InternalQueryTeamsOwnedByUserArgs = {
  input: InputTeamsOwnedByUser;
};


export type InternalQueryUserArgs = {
  input: InputUser;
};


export type InternalQueryValidateUserTokenArgs = {
  token: Scalars['String']['input'];
};


export type InternalQueryVerifyMoodBoardAccessArgs = {
  input: InputVerifyMoodBoardAccess;
};

export type InvalidatePaymentPayload = {
  __typename?: 'InvalidatePaymentPayload';
  result: Scalars['Boolean']['output'];
};

/** Response after inviting a user to a team. */
export type InviteTeamUserPayload = {
  __typename?: 'InviteTeamUserPayload';
  /** Information about the invited user. */
  invitee: TeamUserInvitee;
};

export type Invoice = {
  __typename?: 'Invoice';
  /** Balance on credit invoices */
  balance: Scalars['Float']['output'];
  createdAt: Scalars['Date']['output'];
  /** Description of credit invoices */
  description: Scalars['String']['output'];
  /** Applied discount. 0 if none applied */
  discount: Scalars['Float']['output'];
  frequency: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  lineItems?: Maybe<Array<LineItem>>;
  number: Scalars['String']['output'];
  paid: Scalars['Float']['output'];
  planCode?: Maybe<Scalars['String']['output']>;
  planName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  state: InvoiceStatus;
  total: Scalars['Float']['output'];
  transactions?: Maybe<Array<Transaction>>;
  /** Invoice type */
  type: InvoiceType;
};

export enum InvoiceStatus {
  CLOSED = 'CLOSED',
  FAILED = 'FAILED',
  OPEN = 'OPEN',
  PAID = 'PAID',
  PAST_DUE = 'PAST_DUE',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  VOIDED = 'VOIDED'
}

export enum InvoiceType {
  CHARGE = 'CHARGE',
  CREDIT = 'CREDIT',
  LEGACY = 'LEGACY'
}

export type Item = {
  __typename?: 'Item';
  /** Discount applied at item level if the coupon has been created like that */
  dicount?: Maybe<Scalars['Float']['output']>;
  /** Item code */
  itemCode?: Maybe<Scalars['String']['output']>;
  /** Plan code */
  planCode?: Maybe<Scalars['String']['output']>;
  /** Pices */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** Total amount */
  subtotal?: Maybe<Scalars['Float']['output']>;
  /** Price per Item */
  unitAmount?: Maybe<Scalars['Float']['output']>;
};

export type JobProgress = {
  __typename?: 'JobProgress';
  completed: Scalars['Int']['output'];
  details?: Maybe<Scalars['JSON']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  failed: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  progress: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type JoinMoodboardTeamResult = {
  __typename?: 'JoinMoodboardTeamResult';
  success: Scalars['Boolean']['output'];
  teamId: Scalars['Int']['output'];
};

/** Response after requesting to join a team. */
export type JoinTeamPayload = {
  __typename?: 'JoinTeamPayload';
  /**
   * ID of the invitation created for the join request. Null when the user was
   * auto-joined (PLA-464): they were added directly, so there is no request
   * pending and no invitation row is created.
   */
  invitationId?: Maybe<Scalars['Int']['output']>;
  /** Status of the join request. */
  requestStatus: Scalars['String']['output'];
};

/** Design JSON data with hash identifier. */
export type JsonDesignWithHash = {
  __typename?: 'JsonDesignWithHash';
  /** JSON representation of the design content. */
  banner: Scalars['JsonDesign']['output'];
  /** Unique hash identifier for the design. */
  hash: Scalars['String']['output'];
  /** ID of the user who created or last modified the design. */
  userId?: Maybe<Scalars['Int']['output']>;
};

export enum KeyMetric {
  CTR = 'CTR'
}

export type KeycloakConfigFile = {
  __typename?: 'KeycloakConfigFile';
  result?: Maybe<Scalars['String']['output']>;
};

/**
 * Brand-kit custom fonts that fully cover the design's feed text for a
 * single language code.
 */
export type LanguageCompatibleFonts = {
  __typename?: 'LanguageCompatibleFonts';
  /** Names of brand-kit custom font families compatible with the language's feed text. */
  fontFamilies: Array<Scalars['String']['output']>;
  /** Language code these fonts cover. */
  languageCode: Scalars['String']['output'];
};

/** Supported Google fonts for a single language code. */
export type LanguageSupportedFonts = {
  __typename?: 'LanguageSupportedFonts';
  /** Names of Google font families that support this language. */
  fonts: Array<Scalars['String']['output']>;
  /** Language code these fonts cover. */
  languageCode: Scalars['String']['output'];
};

/** Last completed AI generation for a design (image or video) */
export type LastCompletedGeneration = {
  __typename?: 'LastCompletedGeneration';
  /** Aspect ratio string e.g. 1:1, 16:9, 9:16 */
  aspectRatio: Scalars['String']['output'];
  /** Media kind: image or video */
  mediaKind: Scalars['String']['output'];
  /** Backend operation ID */
  operationId: Scalars['Int']['output'];
  /** Result URLs (image URLs or video URL) */
  urls: Array<Scalars['String']['output']>;
};

export type LastMetaPublicationInput = {
  designId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

/**
 * Where an ORDER change puts a layer among the layers of its own slide or group, which it never leaves (a group moves as
 * one): FRONT or BACK of them, as the editor's Bring to front and Send to back; ABOVE or BEHIND the relativeToRef layer,
 * directly in front of or behind it, unless it already is in front of or behind it. A relativeToRef inside a group the
 * layer is not in stands for that group.
 */
export enum LayerOrder {
  ABOVE = 'ABOVE',
  BACK = 'BACK',
  BEHIND = 'BEHIND',
  FRONT = 'FRONT'
}

/** Whose logo a layered ad shows: the brand kit's (the engine picks it) or none. */
export enum LayeredAdLogoChoice {
  BRAND_KIT = 'BRAND_KIT',
  NONE = 'NONE'
}

export type LayeredAdOperationResult = {
  __typename?: 'LayeredAdOperationResult';
  id: Scalars['Int']['output'];
};

/** Where a layout change puts a layer, on each size's own canvas. */
export enum LayoutPosition {
  BOTTOM = 'BOTTOM',
  BOTTOM_LEFT = 'BOTTOM_LEFT',
  BOTTOM_RIGHT = 'BOTTOM_RIGHT',
  CENTER = 'CENTER',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
  TOP = 'TOP',
  TOP_LEFT = 'TOP_LEFT',
  TOP_RIGHT = 'TOP_RIGHT'
}

/**
 * Declares that a `layoutRepair` report is coming for this tool call — sent
 * BEFORE the client even starts Tier 1's settle wait, at the moment it
 * decides a copilot write will run layout repair. Pairs the turn-end gate's
 * await with the exact write that will report it, structurally rather than
 * via a hand-kept server-side list of tool ids (the list drifted: three
 * tracked ids ran no client-side repair at all, so every call to them forced
 * a 20-second stall). See the report-delivery contract in
 * `studioAssistantStore/index.ts`.
 */
export type LayoutRepairExpectationInput = {
  /** The Mastra tool-call id a `layoutRepair` report is about to be reported for. */
  toolCallId: Scalars['String']['input'];
};

/**
 * Report of the deterministic layout repair (Tier 1, Ad Studio Copilot) that
 * ran after a copilot write. Not a pending-tool correlation — nothing blocks
 * on this — it feeds the Tier 2 turn-end judgement gate, which reads whether
 * the layout moved at all this turn.
 */
export type LayoutRepairPushInput = {
  /** Client-shaped LayoutRepairPayload (LayoutRepairResult serialised unchanged): { moved, applied: [{ layerId, x?, y?, width?, height?, source }], skipped, findings: [{ type, layerIds, detail }], unrepaired: [{ type, layerIds, detail, suggestedFix? }], unrepairedOnTouched?, movedLayers?: [{ layerId, sizeId, before, after }], timedOut, failed }. Opaque here; the authoritative shape is ai-agents RefreshBodySchema, which STRIPS what it does not declare. */
  payload: Scalars['JSON']['input'];
  /** The Mastra tool-call id of the write this repair pass followed. */
  toolCallId: Scalars['String']['input'];
};

export type LineItem = {
  __typename?: 'LineItem';
  addOnCode?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  unitAmount?: Maybe<Scalars['Float']['output']>;
};

export type LinkBusinessFbInput = {
  code: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type LinkBusinessFbResponse = {
  __typename?: 'LinkBusinessFbResponse';
  accountId: Scalars['String']['output'];
};

/** Link domain distribution statistics */
export type LinkDistribution = {
  __typename?: 'LinkDistribution';
  /** Number of ads linking to this domain */
  count: Scalars['Int']['output'];
  /** Domain name */
  domain: Scalars['String']['output'];
  /** Percentage of total ads linking to this domain */
  percentage: Scalars['Float']['output'];
};

/** Link usage statistics */
export type LinkStats = {
  __typename?: 'LinkStats';
  /** Number of ads using this link */
  count: Scalars['Int']['output'];
  /** Full link URL */
  link: Scalars['String']['output'];
  /** Percentage of total ads using this link */
  percent: Scalars['Float']['output'];
};

/** A LinkedIn sponsored ad account the member can publish creatives into. */
export type LinkedInAdAccount = {
  __typename?: 'LinkedInAdAccount';
  /** Numeric ad account id */
  id: Scalars['String']['output'];
  /** Ad account display name */
  name?: Maybe<Scalars['String']['output']>;
  /** Account reference (organization the account belongs to) */
  reference?: Maybe<Scalars['String']['output']>;
  /** Account status (e.g. ACTIVE) */
  status?: Maybe<Scalars['String']['output']>;
  /** Full URN — urn:li:sponsoredAccount:{id} */
  urn: Scalars['String']['output'];
};

/** Response containing list of LinkedIn ad accounts */
export type LinkedInAdAccounts = {
  __typename?: 'LinkedInAdAccounts';
  accounts: Array<LinkedInAdAccount>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

/** Input for fetching LinkedIn sponsored ad accounts */
export type LinkedInAdAccountsInput = {
  /** Email resolving the LinkedIn CloudIntegration row */
  email: Scalars['String']['input'];
  /** Team ID for access control */
  teamId: Scalars['Int']['input'];
};

/** An existing LinkedIn campaign a creative can be published into. */
export type LinkedInCampaign = {
  __typename?: 'LinkedInCampaign';
  /** Parent campaign group URN (urn:li:sponsoredCampaignGroup:{id}) — scopes the ad-set reuse picker to the selected group. */
  campaignGroup?: Maybe<Scalars['String']['output']>;
  /** Campaign format (STANDARD_UPDATE, SINGLE_VIDEO, …) */
  format: Scalars['String']['output'];
  /** Numeric campaign id */
  id: Scalars['String']['output'];
  /** Campaign name */
  name: Scalars['String']['output'];
  /** Campaign status (ACTIVE, PAUSED, …) */
  status: Scalars['String']['output'];
  /** Full URN — urn:li:sponsoredCampaign:{id} */
  urn: Scalars['String']['output'];
};

/**
 * An existing LinkedIn campaign group (UI "Campaign") a new campaign can be
 * created under, or that a creative can be published into by reusing one of its
 * campaigns.
 */
export type LinkedInCampaignGroup = {
  __typename?: 'LinkedInCampaignGroup';
  /** Numeric campaign group id */
  id: Scalars['String']['output'];
  /** Campaign group name */
  name: Scalars['String']['output'];
  /** Group-level objective (optional, immutable on LinkedIn; campaigns in the group inherit it) */
  objectiveType?: Maybe<Scalars['String']['output']>;
  /** Campaign group status (ACTIVE, DRAFT, …) */
  status: Scalars['String']['output'];
  /** Full URN — urn:li:sponsoredCampaignGroup:{id} */
  urn: Scalars['String']['output'];
};

/** Settings to create a campaign group (the LinkedIn Campaign level). totalBudget requires schedule.end. */
export type LinkedInCampaignGroupSettingsInput = {
  name: Scalars['String']['input'];
  /** Group-level objective (LinkedIn UI sets the objective on the Campaign). Must match campaignSettings.objectiveType when both are set. */
  objectiveType?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<LinkedInScheduleInput>;
  totalBudget?: InputMaybe<LinkedInMoneyInput>;
};

/** Response containing list of LinkedIn campaign groups */
export type LinkedInCampaignGroups = {
  __typename?: 'LinkedInCampaignGroups';
  campaignGroups: Array<LinkedInCampaignGroup>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

/** Input for fetching LinkedIn campaign groups within an ad account */
export type LinkedInCampaignGroupsInput = {
  /** Email resolving the LinkedIn CloudIntegration row */
  email: Scalars['String']['input'];
  /** Optional search query to filter campaign groups by name */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Selected sponsored ad account URN (urn:li:sponsoredAccount:{id}) */
  sponsoredAccountUrn: Scalars['String']['input'];
  /** Team ID for access control */
  teamId: Scalars['Int']['input'];
};

/** Settings to create a campaign (the LinkedIn Ad set level). objectiveType drives cost/optimization/format. */
export type LinkedInCampaignSettingsInput = {
  dailyBudget?: InputMaybe<LinkedInMoneyInput>;
  name: Scalars['String']['input'];
  objectiveType: Scalars['String']['input'];
  schedule: LinkedInScheduleInput;
  targeting: LinkedInTargetingInput;
  totalBudget?: InputMaybe<LinkedInMoneyInput>;
};

/** Response containing list of LinkedIn campaigns */
export type LinkedInCampaigns = {
  __typename?: 'LinkedInCampaigns';
  campaigns: Array<LinkedInCampaign>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

/** Input for fetching LinkedIn campaigns within an ad account */
export type LinkedInCampaignsInput = {
  /** Email resolving the LinkedIn CloudIntegration row */
  email: Scalars['String']['input'];
  /** Optional search query to filter campaigns by name */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Selected sponsored ad account URN (urn:li:sponsoredAccount:{id}) */
  sponsoredAccountUrn: Scalars['String']['input'];
  /** Team ID for access control */
  teamId: Scalars['Int']['input'];
};

/** Budget/bid money amount. */
export type LinkedInMoneyInput = {
  amount: Scalars['String']['input'];
  currencyCode: Scalars['String']['input'];
};

/** A LinkedIn organization the member can author DSC posts for (DSC author). */
export type LinkedInOrganization = {
  __typename?: 'LinkedInOrganization';
  /** Numeric organization id */
  id: Scalars['String']['output'];
  /** Organization display name */
  name?: Maybe<Scalars['String']['output']>;
  /** Full URN — urn:li:organization:{id} */
  urn: Scalars['String']['output'];
  /** Organization vanity name */
  vanityName?: Maybe<Scalars['String']['output']>;
};

/** Response containing list of LinkedIn organizations */
export type LinkedInOrganizations = {
  __typename?: 'LinkedInOrganizations';
  organizations: Array<LinkedInOrganization>;
};

/** Input for fetching LinkedIn DSC-author organizations */
export type LinkedInOrganizationsInput = {
  /** Email resolving the LinkedIn CloudIntegration row */
  email: Scalars['String']['input'];
  /** Team ID for access control */
  teamId: Scalars['Int']['input'];
};

/** Per-size creative result reported back from the LinkedIn publish worker */
export type LinkedInPerSizeStatusInput = {
  /** Created sponsored creative URN, if any */
  creativeUrn?: InputMaybe<Scalars['String']['input']>;
  /** Initial review status captured by the single non-blocking getCreative read */
  reviewStatus?: InputMaybe<Scalars['String']['input']>;
  /** Creatopy size/banner hash (LinkedInSize.sizeId) */
  size: Scalars['String']['input'];
};

/** Error reported back from the LinkedIn publish worker */
export type LinkedInPublishErrorInput = {
  code: Scalars['String']['input'];
  message: Scalars['String']['input'];
};

/** Run schedule, epoch milliseconds. */
export type LinkedInScheduleInput = {
  end?: InputMaybe<Scalars['Float']['input']>;
  start: Scalars['Float']['input'];
};

/** Geographic targeting by ISO-3166 alpha-2 country codes, e.g. US or GB. */
export type LinkedInTargetingInput = {
  countries: Array<Scalars['String']['input']>;
};

/** Variations for live feed display. @deprecated Use FeedVariationDisplay instead. */
export enum LiveFeedVariation {
  /**
   * A/B test variation. @deprecated Use FeedVariationDisplay instead.
   * @deprecated Use FeedVariationsDisplay instead
   */
  ABNTEST = 'ABNTEST',
  /**
   * Dynamic content variation. @deprecated Use FeedVariationDisplay instead.
   * @deprecated Use FeedVariationsDisplay instead
   */
  DYNAMIC = 'DYNAMIC',
  /**
   * Looping variation. @deprecated Use FeedVariationDisplay instead.
   * @deprecated Use FeedVariationsDisplay instead
   */
  LOOP = 'LOOP',
  /**
   * Specific row from the feed. @deprecated Use FeedVariationDisplay instead.
   * @deprecated Use FeedVariationsDisplay instead
   */
  SPECIFIC_ROW = 'SPECIFIC_ROW'
}

/** Settings for live feed variations. */
export type LiveFeedVariationType = {
  __typename?: 'LiveFeedVariationType';
  /** The index of the feed row to display (if type is specific_row). */
  feedRowIndex?: Maybe<Scalars['Int']['output']>;
  /** The target ID for the feed variation. */
  targetId?: Maybe<Scalars['String']['output']>;
  /** The type of feed variation display. @BreakingBad */
  type?: Maybe<FeedVariationDisplay>;
};

export type LoadBrandControlResult = {
  __typename?: 'LoadBrandControlResult';
  brandControl: BrandControl;
};

/** Geographic location targeted by an ad */
export type LocationAudience = {
  __typename?: 'LocationAudience';
  /** Number of people in this location */
  count: Scalars['Int']['output'];
  /** Whether this location is excluded from targeting */
  excluded: Scalars['Boolean']['output'];
  /** Name of the location */
  name: Scalars['String']['output'];
  /** Type of location (country, city, region) */
  type: Scalars['String']['output'];
};

/** Geographic location statistics (legacy audience analytics) */
export type LocationItem = {
  __typename?: 'LocationItem';
  /** Count of users in this location */
  count: Scalars['Int']['output'];
  /** Location name */
  name: Scalars['String']['output'];
  /** Percentage of total audience */
  percentage: Scalars['Float']['output'];
};

export type LocationType = {
  __typename?: 'LocationType';
  exportNext?: Maybe<Scalars['Boolean']['output']>;
  folderId?: Maybe<Scalars['Int']['output']>;
  isTemplate?: Maybe<Scalars['Boolean']['output']>;
  projectId?: Maybe<Scalars['Int']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
  teamId: Scalars['Int']['output'];
  teamName?: Maybe<Scalars['String']['output']>;
};

/**
 * How a design's brand-template locks bind the caller: NONE, not at all; ASK, a locked change is refused until the
 * call says the user agreed (lockedChangesAgreed); ALWAYS, refused whatever the call says (a Content editor).
 */
export enum LocksBind {
  ALWAYS = 'ALWAYS',
  ASK = 'ASK',
  NONE = 'NONE'
}

export type LoginEvent = {
  __typename?: 'LoginEvent';
  /** Authentication method: 'Password', 'SSO', or 'Impersonate' for staff impersonation sessions. */
  authMethod: Scalars['String']['output'];
  authType: Scalars['String']['output'];
  clientId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  eventType: Scalars['String']['output'];
  identityProvider?: Maybe<Scalars['String']['output']>;
  /** Set when the event originated from a staff member impersonating this user. Null otherwise. */
  impersonatedBy?: Maybe<ImpersonatorInfo>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  realm?: Maybe<Scalars['String']['output']>;
  refreshTokenId?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['Date']['output'];
  userId?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type LoginVeevaInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  vaultDNS: Scalars['String']['input'];
};

export type LoginVeevaResponse = {
  __typename?: 'LoginVeevaResponse';
  error?: Maybe<ErrorState>;
  expiresAt?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  vaultDNS?: Maybe<Scalars['String']['output']>;
  vaultInstances?: Maybe<Array<VaultInstance>>;
};

/** Structure for adding a logo from a URL. */
export type LogoFromUrl = {
  /** Base64 encoded logo data. */
  logo: Scalars['String']['input'];
  /** Source URL of the logo. */
  url: Scalars['String']['input'];
};

export enum LossyCompression {
  LOSSY_COMPRESSION_0 = 'LOSSY_COMPRESSION_0',
  LOSSY_COMPRESSION_20 = 'LOSSY_COMPRESSION_20',
  LOSSY_COMPRESSION_40 = 'LOSSY_COMPRESSION_40',
  LOSSY_COMPRESSION_60 = 'LOSSY_COMPRESSION_60',
  LOSSY_COMPRESSION_80 = 'LOSSY_COMPRESSION_80',
  LOSSY_COMPRESSION_100 = 'LOSSY_COMPRESSION_100',
  LOSSY_COMPRESSION_140 = 'LOSSY_COMPRESSION_140',
  LOSSY_COMPRESSION_200 = 'LOSSY_COMPRESSION_200'
}

export type MaintenanceType = {
  __typename?: 'MaintenanceType';
  active?: Maybe<Scalars['Boolean']['output']>;
  schedule?: Maybe<Scalars['Date']['output']>;
  seconds?: Maybe<Scalars['Int']['output']>;
};

export enum ManualPlacementSelection {
  BOTTOM_CENTER = 'BOTTOM_CENTER',
  BOTTOM_LEFT = 'BOTTOM_LEFT',
  BOTTOM_RIGHT = 'BOTTOM_RIGHT',
  CENTER_HORIZONTAL = 'CENTER_HORIZONTAL',
  CENTER_VERTICAL = 'CENTER_VERTICAL',
  LEFT_CENTER = 'LEFT_CENTER',
  RIGHT_CENTER = 'RIGHT_CENTER',
  UPPER_CENTER = 'UPPER_CENTER',
  UPPER_LEFT = 'UPPER_LEFT',
  UPPER_RIGHT = 'UPPER_RIGHT'
}

/** Response after marking a design as being edited. */
export type MarkEditDesignPayload = {
  __typename?: 'MarkEditDesignPayload';
  /** Whether an edit from the user's AI assistant is running on this design, or ended after openedAt. NONE without openedAt. */
  outsideEdit: OutsideEditState;
  /** Whether the operation was successful. */
  result: Scalars['Boolean']['output'];
};

/** @deprecated not used */
export enum MaskSource {
  GENERATED = 'GENERATED',
  MANUAL = 'MANUAL'
}

/** Matched size information */
export type MatchedSize = {
  __typename?: 'MatchedSize';
  designSizeName?: Maybe<Scalars['String']['output']>;
  height: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type MatcherData = {
  __typename?: 'MatcherData';
  screenshot?: Maybe<Scalars['String']['output']>;
};

export enum MaxColors {
  MAX_COLORS_24 = 'MAX_COLORS_24',
  MAX_COLORS_32 = 'MAX_COLORS_32',
  MAX_COLORS_64 = 'MAX_COLORS_64',
  MAX_COLORS_128 = 'MAX_COLORS_128',
  MAX_COLORS_256 = 'MAX_COLORS_256'
}

/** Measurement units for design dimensions. */
export enum MeasureUnit {
  /** Centimeters (print units). */
  CM = 'cm',
  /** Inches (print units). */
  IN = 'in',
  /** Millimeters (print units). */
  MM = 'mm',
  /** Pixels (screen units). */
  PX = 'px'
}

/**
 * A media asset in the system.
 * Represents images, videos, audio files, etc.
 */
export type Media = {
  __typename?: 'Media';
  /**
   * An AI-authored one-line description of what the asset depicts, e.g.
   * "A black backpack sits on a wet rock in a rainy forest setting." Null when none
   * was ever generated. Distinct from the name field, which for generated assets is
   * a generic label like "AI Generated Image".
   *
   * NOTE: no backticks in this description — the schema lives in a gql template
   * literal and a backtick silently terminates it, failing codegen with a
   * misleading "Unknown type" error.
   */
  aiDescription?: Maybe<Scalars['String']['output']>;
  /**
   * Whether this asset carries AI-generated provenance, read from its IPTC
   * DigitalSourceType. True when the recorded source type is generative, false when a
   * provenance record exists and is not generative, and NULL when nothing is known —
   * no record was ever written, or it could not be read. Absence of a record is not
   * evidence of absence, so callers must treat null as "unknown", not as "not AI".
   *
   * Nullable on purpose: a non-null field would force every construction of a Media
   * literal across the codebase to supply a value it does not have.
   */
  aiGenerated?: Maybe<Scalars['Boolean']['output']>;
  /** Checksum of the media file for integrity. */
  checksum: Scalars['String']['output'];
  /** When the media was created. */
  createdAt: Scalars['Date']['output'];
  /** ID of the user who created the media. */
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** User who created the media. */
  createdByUser?: Maybe<ByUser>;
  /** Duration in seconds (for video/audio). */
  duration?: Maybe<Scalars['Float']['output']>;
  /** Original filename of the media. */
  fileName: Scalars['String']['output'];
  /** Format of the media file (jpg, png, etc.). */
  format: Scalars['String']['output'];
  /** Hash identifier for the media (used in URLs). */
  hash: Scalars['String']['output'];
  /** Height of the media in pixels (if applicable). */
  height?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier for the media. */
  id: Scalars['Int']['output'];
  /** Display name of the media. */
  name: Scalars['String']['output'];
  /** File size in bytes. */
  size: Scalars['Int']['output'];
  /** Source URL for the media asset. */
  src: Scalars['String']['output'];
  /** Processing status of the media. */
  status: MediaStatus;
  /** Type of media (IMAGE, VIDEO, etc.). */
  type: MediaType;
  /** When the media was last updated. */
  updatedAt: Scalars['Date']['output'];
  /** Public URL to the media (if available). */
  url?: Maybe<Scalars['String']['output']>;
  /** Width of the media in pixels (if applicable). */
  width?: Maybe<Scalars['Int']['output']>;
};

export type MediaFileCropArea = {
  __typename?: 'MediaFileCropArea';
  bottom?: Maybe<Scalars['Int']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  left?: Maybe<Scalars['Int']['output']>;
  right?: Maybe<Scalars['Int']['output']>;
  top?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export enum MediaFilterAspectRatio {
  OTHERS = 'OTHERS',
  SIXTEEN_BY_NINE = 'SIXTEEN_BY_NINE'
}

export enum MediaFilterResolution {
  FHD = 'FHD',
  HD = 'HD',
  UHD = 'UHD'
}

export type MediaFocalRegion = {
  __typename?: 'MediaFocalRegion';
  focalHeight: Scalars['Float']['output'];
  focalWidth: Scalars['Float']['output'];
  height: Scalars['Float']['output'];
  key: Scalars['String']['output'];
  /** The image is a cutout (transparent background). */
  transparent?: Maybe<Scalars['Boolean']['output']>;
  /** The read floor this region satisfies; a consumer caching it re-fetches below this. */
  version: Scalars['Int']['output'];
  /** The source image's own dimensions — the frame the centroid and box are measured in. */
  width: Scalars['Float']['output'];
  /** Salient centroid, in source-image px. */
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type MediaFocalRegionsPayload = {
  __typename?: 'MediaFocalRegionsPayload';
  /** Only the keys that resolved — an absent key means the photo has no known subject. */
  regions: Array<MediaFocalRegion>;
};

export type MediaFolder = {
  __typename?: 'MediaFolder';
  createdAt: Scalars['Date']['output'];
  createdByUser?: Maybe<ByUser>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  type: MediaFolderType;
  updatedAt: Scalars['Date']['output'];
};

export enum MediaFolderType {
  LOGO = 'logo',
  MEDIA = 'media'
}

export type MediaFolders = {
  __typename?: 'MediaFolders';
  items: Array<MediaFolder>;
  path: Array<MediaParent>;
  rootFolderHash?: Maybe<Scalars['String']['output']>;
};

/** File formats supported for media assets. */
export enum MediaFormat {
  /** AVI video format */
  AVI = 'avi',
  /** GIF image format (supports animation) */
  GIF = 'gif',
  JPEG = 'jpeg',
  /** JPEG image format */
  JPG = 'jpg',
  /** Matroska video format */
  MKV = 'mkv',
  /** QuickTime video format */
  MOV = 'mov',
  /** MP3 audio format */
  MP3 = 'mp3',
  /** MP4 video format */
  MP4 = 'mp4',
  /** MPEG audio/video format */
  MPEG = 'mpeg',
  /** OGG audio format */
  OGG = 'ogg',
  /** PNG image format */
  PNG = 'png',
  PSD = 'psd',
  /** SVG vector format */
  SVG = 'svg',
  /** Flash animation format */
  SWF = 'swf',
  /** WAV audio format */
  WAV = 'wav',
  /** WebM video format */
  WEBM = 'webm',
  WEBP = 'webp'
}

export enum MediaOrientationType {
  ALL = 'all',
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical'
}

export type MediaParent = {
  __typename?: 'MediaParent';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** Paginated result of media assets. */
export type MediaResult = {
  __typename?: 'MediaResult';
  /** Media assets matching the query. */
  items: Array<Media>;
  /** Pagination information. */
  pageInfo: PageInfo;
};

/** Predefined folder types for organizing media in brand kit */
export enum MediaSourceType {
  AI_GENERATED_IMAGES = 'AI_GENERATED_IMAGES',
  AI_GENERATED_IMAGE_ADS = 'AI_GENERATED_IMAGE_ADS',
  AI_GENERATED_VIDEOS = 'AI_GENERATED_VIDEOS',
  STOCK_PHOTOS = 'STOCK_PHOTOS',
  STOCK_VIDEOS = 'STOCK_VIDEOS',
  UPLOADED_PHOTOS = 'UPLOADED_PHOTOS',
  UPLOADED_VIDEOS = 'UPLOADED_VIDEOS',
  URL_ASSETS = 'URL_ASSETS'
}

/** Processing status of media assets. */
export enum MediaStatus {
  /** Error occurred during processing */
  ERROR = 'ERROR',
  /** Media failed validation */
  INVALID = 'INVALID',
  /** Media is currently being processed */
  PROCESSING = 'PROCESSING',
  /** Media is processed and ready for use */
  VALID = 'VALID'
}

/** Types of media supported by the system. */
export enum MediaType {
  /** Audio files (mp3, etc.) */
  AUDIO = 'AUDIO',
  /** Image files (jpg, png, etc.) */
  IMAGE = 'IMAGE',
  /** PDF files */
  PDF = 'PDF',
  /** Adobe Photoshop files */
  PHOTOSHOP = 'PHOTOSHOP',
  /** Video files (mp4, etc.) */
  VIDEO = 'VIDEO'
}

/** Media type distribution statistics */
export type MediaTypeStats = {
  __typename?: 'MediaTypeStats';
  /** Percentage of ads using both images and videos */
  both: Scalars['Float']['output'];
  /** Percentage of ads using only images */
  imagesOnly: Scalars['Float']['output'];
  /** Percentage of ads with no media */
  noMedia: Scalars['Float']['output'];
  /** Percentage of ads using only videos */
  videosOnly: Scalars['Float']['output'];
};

/** Message part for structured content (Mastra UIMessage) */
export type MessagePart = {
  __typename?: 'MessagePart';
  /** Text content (if type is text) */
  text?: Maybe<Scalars['String']['output']>;
  /** Type of the part (text, image, etc) */
  type: Scalars['String']['output'];
};

export type MetaAdsItem = {
  __typename?: 'MetaAdsItem';
  adSetId: Scalars['String']['output'];
  campaignId: Scalars['String']['output'];
  createdTime: Scalars['String']['output'];
  effectiveStatus: Scalars['String']['output'];
  id: Scalars['String']['output'];
  metrics: MetaAdsMetrics;
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  thumbnailUrl: Scalars['String']['output'];
  updatedTime: Scalars['String']['output'];
};

export type MetaAdsMetrics = {
  __typename?: 'MetaAdsMetrics';
  clicks: Scalars['String']['output'];
  comments: Scalars['String']['output'];
  costPerResult: Array<MetaAdsResult>;
  cpc: Scalars['String']['output'];
  cpm: Scalars['String']['output'];
  ctr: Scalars['String']['output'];
  frequency: Scalars['String']['output'];
  impressions: Scalars['String']['output'];
  reach: Scalars['String']['output'];
  reactions: Scalars['String']['output'];
  results: Array<MetaAdsResult>;
  saves: Scalars['String']['output'];
  shares: Scalars['String']['output'];
  spend: Scalars['String']['output'];
};

export type MetaAdsPagination = {
  __typename?: 'MetaAdsPagination';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  previousCursor?: Maybe<Scalars['String']['output']>;
};

export type MetaAdsResult = {
  __typename?: 'MetaAdsResult';
  indicator: Scalars['String']['output'];
  values?: Maybe<Array<Maybe<MetaAdsResultValue>>>;
};

export type MetaAdsResultValue = {
  __typename?: 'MetaAdsResultValue';
  attribution_windows?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  value: Scalars['String']['output'];
};

export enum MetaAdsSortBy {
  COMMENTS = 'comments',
  COST_PER_RESULT = 'cost_per_result',
  IMPRESSIONS = 'impressions',
  REACH = 'reach',
  REACTIONS = 'reactions',
  RESULTS = 'results',
  SAVES = 'saves',
  SHARES = 'shares',
  SPEND = 'spend'
}

export enum MetaAdsSortOrder {
  ASCENDING = 'ascending',
  DESCENDING = 'descending'
}

export enum MetaAdsStatus {
  ACTIVE = 'ACTIVE',
  ADSET_PAUSED = 'ADSET_PAUSED',
  ARCHIVED = 'ARCHIVED',
  CAMPAIGN_PAUSED = 'CAMPAIGN_PAUSED',
  DELETED = 'DELETED',
  DISAPPROVED = 'DISAPPROVED',
  IN_PROCESS = 'IN_PROCESS',
  PAUSED = 'PAUSED',
  PENDING_BILLING_INFO = 'PENDING_BILLING_INFO',
  PENDING_REVIEW = 'PENDING_REVIEW',
  PREAPPROVED = 'PREAPPROVED',
  WITH_ISSUES = 'WITH_ISSUES'
}

export type MetaAdsSummary = {
  __typename?: 'MetaAdsSummary';
  accountId: Scalars['String']['output'];
  dateRange: Scalars['String']['output'];
  filteredBy?: Maybe<Scalars['String']['output']>;
  totalAds: Scalars['Int']['output'];
};

export type MetaCatalog = {
  __typename?: 'MetaCatalog';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productCount: Scalars['Int']['output'];
  /** The catalog's product-set count as Meta reports it. NULL = the count lookup failed — the picker hides the segment. */
  productSetCount?: Maybe<Scalars['Int']['output']>;
  /**
   * Smart default for the wizard's refresh schedule, derived from this Meta
   * catalog's own product-feed upload cadence (HOURLY/DAILY/WEEKLY → our
   * hourly/daily/weekly; MONTHLY/unknown → daily). NULL when Meta exposes no
   * readable feed schedule — the wizard then keeps its daily default. Always
   * user-overridable in the schedule step; never forced.
   */
  suggestedUpdateFrequency?: Maybe<UpdateFrequencyType>;
  /** Meta catalog vertical (commerce, hotels, ...) — captured at import into the catalog's metaVertical (D10) */
  vertical?: Maybe<Scalars['String']['output']>;
};

export type MetaFeedSyncAuth = {
  __typename?: 'MetaFeedSyncAuth';
  accessToken: Scalars['String']['output'];
  /**
   * The catalog's FeedColumn names in index order. Seeded at import and
   * authoritative — the worker emits exactly these columns in exactly this
   * order forever instead of re-deriving a schema per run.
   */
  columns: Array<Scalars['String']['output']>;
  /** Every product set of this catalog that is linked to a Meta set. */
  sets: Array<MetaSyncSet>;
};

/** The most recent Meta publication of a design — used to prefill the wizard on reopen for replace-creative. */
export type MetaPublication = {
  __typename?: 'MetaPublication';
  accountId: Scalars['String']['output'];
  adAccountId?: Maybe<Scalars['String']['output']>;
  adSetId?: Maybe<Scalars['String']['output']>;
  ads: Array<MetaPublicationAd>;
  /** Opt-in: auto-repoint this feed-batch publication's ads when its feed changes (Feature B). */
  autoSync: Scalars['Boolean']['output'];
  businessId?: Maybe<Scalars['String']['output']>;
  campaignId?: Maybe<Scalars['String']['output']>;
  /** When the publication was recorded; a publish's rows share it. */
  createdAt: Scalars['Date']['output'];
  creativeFeedBindings?: Maybe<CreativeFeedBindings>;
  /** True when the design changed since it was published (its checksum no longer matches the recorded one). */
  designChanged: Scalars['Boolean']['output'];
  /** True when the feed changed since a feed-batch publish (rows added/edited or the feed swapped); always false for a single publish. */
  feedChanged: Scalars['Boolean']['output'];
  feedId?: Maybe<Scalars['Int']['output']>;
  isFeedBatch: Scalars['Boolean']['output'];
  mediaType?: Maybe<FacebookAdMediaType>;
  pageId?: Maybe<Scalars['String']['output']>;
};

/** One published ad from a prior Meta publication (one for a single publish, N for a feed batch). */
export type MetaPublicationAd = {
  __typename?: 'MetaPublicationAd';
  adId: Scalars['String']['output'];
  feedRow?: Maybe<Scalars['String']['output']>;
  /** Persisted 0-based absolute catalog row. */
  feedRowIndex?: Maybe<Scalars['Int']['output']>;
  /** Current 0-based dense product-set position used to restore the row selector; null when the row left the scope. */
  feedRowOrdinal?: Maybe<Scalars['Int']['output']>;
};

/** One imported Meta product set, as the sync worker sees it at run time. */
export type MetaSyncSet = {
  __typename?: 'MetaSyncSet';
  /**
   * Whether this set's rows are already part of the catalog's payload. A row
   * exists because a user imported (or requested) the set; members stays null
   * until the first successful read, and an array — including an empty one —
   * means the set has been materialised.
   */
  materialised: Scalars['Boolean']['output'];
  /** The set's id at Meta — what the worker reads the products edge with. */
  sourceProductSetId: Scalars['String']['output'];
};

/** @deprecated Brand template migration service has been removed. @BreakingBad */
export type MigrateBrandTemplatesPayload = {
  __typename?: 'MigrateBrandTemplatesPayload';
  result: Scalars['Boolean']['output'];
};

/** @deprecated Migration service has been removed */
export type MigrateCount = {
  __typename?: 'MigrateCount';
  /** @deprecated Migration service has been removed */
  designsCount: Scalars['Int']['output'];
  /** @deprecated Migration service has been removed */
  foldersCount: Scalars['Int']['output'];
  /** @deprecated Migration service has been removed */
  workspacesCount: Scalars['Int']['output'];
};

/** @deprecated Migration service has been removed */
export type MigratePayload = {
  __typename?: 'MigratePayload';
  /** @deprecated Migration service has been removed */
  result?: Maybe<Scalars['JSON']['output']>;
};

/** @deprecated Migration service has been removed */
export enum MigrateStatus {
  /** @deprecated Migration service has been removed */
  ERROR = 'ERROR',
  /** @deprecated Migration service has been removed */
  INITIAL = 'INITIAL',
  /** @deprecated Migration service has been removed */
  NONE = 'NONE',
  /** @deprecated Migration service has been removed */
  PENDING = 'PENDING',
  /** @deprecated Migration service has been removed */
  READY = 'READY',
  /** @deprecated Migration service has been removed */
  SUCCESS = 'SUCCESS'
}

/** @deprecated Migration service has been removed */
export type MigrateStatusPayload = {
  __typename?: 'MigrateStatusPayload';
  /** @deprecated Migration service has been removed */
  bs: MigrateCount;
  /** @deprecated Migration service has been removed */
  imported: MigrateCount;
  /** @deprecated Migration service has been removed */
  status?: Maybe<MigrateStatus>;
};

/**
 * Information about a migrated template.
 * Used for legacy template migrations.
 */
export type MigratedTemplatePayload = {
  __typename?: 'MigratedTemplatePayload';
  /** Design ID of the migrated template. */
  designId: Scalars['Int']['output'];
  /** Unique hash identifier for the migrated template. */
  hash: Scalars['String']['output'];
  /** Display name of the migrated template. */
  name: Scalars['String']['output'];
};

/** @deprecated Migration service has been removed */
export type MigrationAccount = {
  __typename?: 'MigrationAccount';
  /** @deprecated Migration service has been removed */
  hasMigratePermissions: Scalars['Boolean']['output'];
  /** @deprecated Migration service has been removed */
  user: BsUser;
};

/** @deprecated Migration service has been removed */
export type MigrationAccountsPayload = {
  __typename?: 'MigrationAccountsPayload';
  /** @deprecated Migration service has been removed */
  accounts: Array<MigrationAccount>;
  /** @deprecated Migration service has been removed */
  eligible: Scalars['Boolean']['output'];
  /** @deprecated Migration service has been removed */
  migrationId: Scalars['Int']['output'];
  /** @deprecated Migration service has been removed */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** @deprecated Migration service has been removed */
export type MigrationBanner = {
  __typename?: 'MigrationBanner';
  /** @deprecated Migration service has been removed */
  bannerType?: Maybe<Scalars['String']['output']>;
  /** @deprecated Migration service has been removed */
  bannersnackBannerId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  bannersnackSetId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Migration service has been removed */
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  designId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Migration service has been removed */
  log?: Maybe<Scalars['String']['output']>;
  /** @deprecated Migration service has been removed */
  migrationId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Migration service has been removed */
  status?: Maybe<Scalars['String']['output']>;
  /** @deprecated Migration service has been removed */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** @deprecated Migration service has been removed */
export type MigrationCandidate = {
  __typename?: 'MigrationCandidate';
  /** @deprecated Migration service has been removed */
  bannersCount?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  bannersnackAvailableUserIds?: Maybe<Scalars['JSON']['output']>;
  /** @deprecated Migration service has been removed */
  bannersnackEmail?: Maybe<Scalars['String']['output']>;
  /** @deprecated Migration service has been removed */
  bannersnackTeamId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Migration service has been removed */
  bannersnackUserId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Migration service has been removed */
  foldersCount?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  fontsCount?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  id?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  keepAdTag?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Migration service has been removed */
  log?: Maybe<Scalars['String']['output']>;
  /** @deprecated Migration service has been removed */
  purchasedCredit?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  status?: Maybe<Scalars['String']['output']>;
  /** @deprecated Migration service has been removed */
  step?: Maybe<Scalars['String']['output']>;
  /** @deprecated Migration service has been removed */
  teamId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Migration service has been removed */
  valid?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Migration service has been removed */
  workspaceCount?: Maybe<Scalars['Int']['output']>;
};

/** @deprecated Migration service has been removed */
export type MigrationData = {
  __typename?: 'MigrationData';
  /** @deprecated Migration service has been removed */
  banners?: Maybe<Scalars['JSON']['output']>;
  /** @deprecated Migration service has been removed */
  media?: Maybe<Scalars['JSON']['output']>;
  /** @deprecated Migration service has been removed */
  mediaFolders?: Maybe<Scalars['JSON']['output']>;
  /** @deprecated Migration service has been removed */
  rootFolders?: Maybe<Scalars['JSON']['output']>;
  /** @deprecated Migration service has been removed */
  user?: Maybe<Scalars['JSON']['output']>;
  /** @deprecated Migration service has been removed */
  workspaces?: Maybe<Scalars['JSON']['output']>;
};

/** @deprecated Migration service has been removed */
export type MigrationDataPayload = {
  __typename?: 'MigrationDataPayload';
  /** @deprecated Migration service has been removed */
  BsPlanStatus: BsPlanStatus;
  /** @deprecated Migration service has been removed */
  adTagIsActivated: Scalars['Boolean']['output'];
  /** @deprecated Migration service has been removed */
  bannersCount: Scalars['Int']['output'];
  /** @deprecated Migration service has been removed */
  foldersCount: Scalars['Int']['output'];
  /** @deprecated Migration service has been removed */
  workspacesCount: Scalars['Int']['output'];
};

/** @deprecated Migration service has been removed */
export type MigrationFolder = {
  __typename?: 'MigrationFolder';
  /** @deprecated Migration service has been removed */
  bannersnackFolderId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  bannersnackParentId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Migration service has been removed */
  folderId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  log?: Maybe<Scalars['String']['output']>;
  /** @deprecated Migration service has been removed */
  migrationId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  status?: Maybe<Scalars['String']['output']>;
  /** @deprecated Migration service has been removed */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** @deprecated Migration service has been removed */
export type MigrationFont = {
  __typename?: 'MigrationFont';
  /** @deprecated Migration service has been removed */
  bannersnackFontId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  brandKitId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Migration service has been removed */
  fontId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  id?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  log?: Maybe<Scalars['String']['output']>;
  /** @deprecated Migration service has been removed */
  metaData?: Maybe<Scalars['JSON']['output']>;
  /** @deprecated Migration service has been removed */
  migrationId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  status?: Maybe<Scalars['String']['output']>;
  /** @deprecated Migration service has been removed */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Migration service has been removed */
  uploadedBy?: Maybe<Scalars['Int']['output']>;
};

/** @deprecated Migration service has been removed */
export type MigrationMedia = {
  __typename?: 'MigrationMedia';
  /** @deprecated Migration service has been removed */
  bannersnackMediaFolderId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  bannersnackMediaHash?: Maybe<Scalars['String']['output']>;
  /** @deprecated Migration service has been removed */
  bannersnackMediaId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Migration service has been removed */
  log?: Maybe<Scalars['String']['output']>;
  /** @deprecated Migration service has been removed */
  mediaId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  migrationId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Migration service has been removed */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** @deprecated Migration service has been removed */
export type MigrationMediaFolder = {
  __typename?: 'MigrationMediaFolder';
  /** @deprecated Migration service has been removed */
  bannersnackMediaFolderId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Migration service has been removed */
  mediaFolderId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  migrationId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Migration service has been removed */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** @deprecated Migration service has been removed */
export enum MigrationNewFeatures {
  /** @deprecated Migration service has been removed */
  AD_SERVING = 'AD_SERVING',
  /** @deprecated Migration service has been removed */
  BACKGROUND_REMOVER = 'BACKGROUND_REMOVER',
  /** @deprecated Migration service has been removed */
  FEED = 'FEED',
  /** @deprecated Migration service has been removed */
  INVITE_TEAM_MEMBERS = 'INVITE_TEAM_MEMBERS',
  /** @deprecated Migration service has been removed */
  PROJECTS = 'PROJECTS',
  /** @deprecated Migration service has been removed */
  UPLOAD_VIDEO_AUDIO = 'UPLOAD_VIDEO_AUDIO'
}

/** @deprecated Migration service has been removed */
export type MigrationPlanPayload = {
  __typename?: 'MigrationPlanPayload';
  /** @deprecated Migration service has been removed */
  billingFrequency: Scalars['Int']['output'];
  /** @deprecated Migration service has been removed */
  bsAmount: Scalars['Float']['output'];
  /** @deprecated Migration service has been removed */
  bsBillingFrequency: Scalars['Int']['output'];
  /** @deprecated Migration service has been removed */
  bsPlan: Scalars['String']['output'];
  /** @deprecated Migration service has been removed */
  credit: Scalars['Float']['output'];
  /** @deprecated Migration service has been removed */
  features: Array<Feature>;
  /** @deprecated Migration service has been removed */
  newFeatures: Array<MigrationNewFeatures>;
  /** @deprecated Migration service has been removed */
  originalPrice: Scalars['Float']['output'];
  /** @deprecated Migration service has been removed */
  price: Scalars['Float']['output'];
  /** @deprecated Migration service has been removed */
  type: MigrationPlanType;
};

/** @deprecated Migration service has been removed */
export enum MigrationPlanType {
  /** @deprecated Migration service has been removed */
  AUTOMATE_MONTHLY = 'AUTOMATE_MONTHLY',
  /** @deprecated Migration service has been removed */
  AUTOMATE_YEARLY = 'AUTOMATE_YEARLY',
  /** @deprecated Migration service has been removed */
  CREATE_MONTHLY = 'CREATE_MONTHLY',
  /** @deprecated Migration service has been removed */
  CREATE_YEARLY = 'CREATE_YEARLY',
  /** @deprecated Migration service has been removed */
  NONE = 'NONE',
  /** @deprecated Migration service has been removed */
  PREMIUM_MONTHLY = 'PREMIUM_MONTHLY',
  /** @deprecated Migration service has been removed */
  PREMIUM_YEARLY = 'PREMIUM_YEARLY',
  /** @deprecated Migration service has been removed */
  STANDARD_MONTHLY = 'STANDARD_MONTHLY',
  /** @deprecated Migration service has been removed */
  STANDARD_YEARLY = 'STANDARD_YEARLY'
}

/** @deprecated Migration service has been removed */
export type MigrationSubscription = {
  __typename?: 'MigrationSubscription';
  /** @deprecated Migration service has been removed */
  bannersnackSubscriptionId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  chargeInvoiceId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Migration service has been removed */
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Migration service has been removed */
  credit?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Migration service has been removed */
  creditInvoiceId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Migration service has been removed */
  log?: Maybe<Scalars['String']['output']>;
  /** @deprecated Migration service has been removed */
  migrationId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** @deprecated Migration service has been removed */
export enum MigrationTable {
  /** @deprecated Migration service has been removed */
  BANNER = 'BANNER',
  /** @deprecated Migration service has been removed */
  CANDIDATE = 'CANDIDATE',
  /** @deprecated Migration service has been removed */
  FOLDER = 'FOLDER',
  /** @deprecated Migration service has been removed */
  FONT = 'FONT',
  /** @deprecated Migration service has been removed */
  MEDIA = 'MEDIA',
  /** @deprecated Migration service has been removed */
  MEDIA_FOLDER = 'MEDIA_FOLDER',
  /** @deprecated Migration service has been removed */
  SUBSCRIPTION = 'SUBSCRIPTION',
  /** @deprecated Migration service has been removed */
  USER = 'USER',
  /** @deprecated Migration service has been removed */
  WORKSPACE = 'WORKSPACE'
}

/** @deprecated Migration service has been removed */
export type MigrationTeamMembersPayload = {
  __typename?: 'MigrationTeamMembersPayload';
  /** @deprecated Migration service has been removed */
  team?: Maybe<BsTeam>;
};

/** @deprecated Migration service has been removed */
export type MigrationUser = {
  __typename?: 'MigrationUser';
  /** @deprecated Migration service has been removed */
  bannersnackEmail?: Maybe<Scalars['String']['output']>;
  /** @deprecated Migration service has been removed */
  bannersnackUserId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Migration service has been removed */
  invitationId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  migrationId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  roleId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  status?: Maybe<Scalars['String']['output']>;
  /** @deprecated Migration service has been removed */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Migration service has been removed */
  userId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  userRole?: Maybe<Scalars['String']['output']>;
};

/** @deprecated Migration service has been removed */
export type MigrationWorkspace = {
  __typename?: 'MigrationWorkspace';
  /** @deprecated Migration service has been removed */
  bannersnackWorkspaceId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Migration service has been removed */
  migrationId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  projectId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Migration service has been removed */
  status?: Maybe<Scalars['String']['output']>;
  /** @deprecated Migration service has been removed */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** @deprecated Migration service has been removed */
export type Migrations = MigrationBanner | MigrationCandidate | MigrationFolder | MigrationFont | MigrationMedia | MigrationMediaFolder | MigrationSubscription | MigrationUser | MigrationWorkspace;

/** @deprecated Migration service has been removed */
export type MigrationsPayload = {
  __typename?: 'MigrationsPayload';
  /** @deprecated Migration service has been removed */
  pageInfo: PageInfo;
  /** @deprecated Migration service has been removed */
  result: Array<Maybe<Migrations>>;
  /** @deprecated Migration service has been removed */
  total: Scalars['Int']['output'];
};

export type MonthlyConsumptionBreakdown = {
  __typename?: 'MonthlyConsumptionBreakdown';
  credits: Scalars['Int']['output'];
  month: Scalars['String']['output'];
};

export type MoodBoard = {
  __typename?: 'MoodBoard';
  /** @deprecated This field is deprecated and will be removed in the future */
  brandKit?: Maybe<BrandKit>;
  /**
   * Deprecated, use projectId. @BreakingBad
   * @deprecated This field is deprecated and will be removed in the future
   */
  brandKitId?: Maybe<Scalars['Int']['output']>;
  content: Scalars['JSON']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['Int']['output']>;
  hash: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  project?: Maybe<Project>;
  projectId?: Maybe<Scalars['Int']['output']>;
  screenshotGeneratedAt?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type MoodBoardAccessPayload = {
  __typename?: 'MoodBoardAccessPayload';
  moodboardHash?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<MoodBoardPermissions>;
  user?: Maybe<MoodBoardUser>;
};

/** Controls the level of access required for moodboard operations */
export enum MoodBoardAccessType {
  READ = 'READ',
  WRITE = 'WRITE'
}

export type MoodBoardComment = {
  __typename?: 'MoodBoardComment';
  authorEmail?: Maybe<Scalars['String']['output']>;
  authorName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  threadId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userAvatar?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type MoodBoardCommentThread = {
  __typename?: 'MoodBoardCommentThread';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  moodBoardId: Scalars['Int']['output'];
  position: Scalars['JSON']['output'];
  resolved: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type MoodBoardContentMetadata = {
  __typename?: 'MoodBoardContentMetadata';
  cardCount?: Maybe<Scalars['Int']['output']>;
  lastModified?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type MoodBoardContentMetadataInput = {
  cardCount?: InputMaybe<Scalars['Int']['input']>;
  lastModified?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type MoodBoardContentPayload = {
  __typename?: 'MoodBoardContentPayload';
  content: Scalars['JSON']['output'];
  /** @deprecated This field is deprecated and will be removed in the future */
  metadata?: Maybe<MoodBoardContentMetadata>;
  moodboardHash: Scalars['String']['output'];
};

export type MoodBoardPayload = {
  __typename?: 'MoodBoardPayload';
  error?: Maybe<ErrorCode>;
  moodBoard?: Maybe<MoodBoard>;
};

export type MoodBoardPermissions = {
  __typename?: 'MoodBoardPermissions';
  canEdit: Scalars['Boolean']['output'];
  canView: Scalars['Boolean']['output'];
};

export type MoodBoardProcessPayload = {
  __typename?: 'MoodBoardProcessPayload';
  metadata?: Maybe<MoodBoardContentMetadata>;
  /** Cards that received new hashes during content processing (for Yjs sync) */
  processedCards?: Maybe<Array<ProcessedCardUpdate>>;
};

export type MoodBoardShare = {
  __typename?: 'MoodBoardShare';
  allowTeamJoin: Scalars['Boolean']['output'];
  hash: Scalars['String']['output'];
  isPasswordProtected: Scalars['Boolean']['output'];
  isTemplate: Scalars['Boolean']['output'];
  moodboardId: Scalars['Int']['output'];
  publicStatus: PublicStatus;
  readOnly: Scalars['Boolean']['output'];
};

export type MoodBoardUser = {
  __typename?: 'MoodBoardUser';
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type MoodBoardVersion = {
  __typename?: 'MoodBoardVersion';
  lastModified: Scalars['Date']['output'];
  size: Scalars['Int']['output'];
  versionId: Scalars['String']['output'];
};

/** Paginated list of mood board versions */
export type MoodBoardVersionList = {
  __typename?: 'MoodBoardVersionList';
  /** Mood board versions in the current page */
  nodes: Array<MoodBoardVersion>;
  /** Pagination information */
  pageInfo: PageInfo;
};

export type MoodboardTeamInvitationResult = {
  __typename?: 'MoodboardTeamInvitationResult';
  invitationHash: Scalars['String']['output'];
  moodboardName: Scalars['String']['output'];
  returnUrl: Scalars['String']['output'];
  teamName: Scalars['String']['output'];
};

/** A chat thread for a moodboard */
export type MoodboardThread = {
  __typename?: 'MoodboardThread';
  /** ISO timestamp when thread was created */
  createdAt: Scalars['String']['output'];
  /** Unique thread ID */
  id: Scalars['String']['output'];
  /** Moodboard hash this thread belongs to */
  moodboardHash: Scalars['String']['output'];
  /** Optional moodboard name */
  moodboardName?: Maybe<Scalars['String']['output']>;
  /** Thread title */
  title: Scalars['String']['output'];
};

/** A finished motion version of a downloaded static set, waiting on Home for the user to approve, edit or dismiss. */
export type MotionDraft = {
  __typename?: 'MotionDraft';
  createdAt: Scalars['Date']['output'];
  /** The motion design set. */
  design: Design;
  id: Scalars['Int']['output'];
  /** How many downloaded sizes got a motion version, as recorded when it was made; null when every size got one. */
  partialSizes?: Maybe<MotionDraftPartialSizes>;
  /** The downloaded static set the motion version was made from; null when that set was deleted. */
  sourceDesign?: Maybe<Design>;
};

export type MotionDraftBox = {
  __typename?: 'MotionDraftBox';
  height: Scalars['Float']['output'];
  width: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type MotionDraftClaim = {
  __typename?: 'MotionDraftClaim';
  claimed: Scalars['Boolean']['output'];
  /** Set when a row was claimed, skipped, failed or taken over; absent for gate_closed, team_mismatch, no_sizes and duplicate. */
  draftId?: Maybe<Scalars['Int']['output']>;
  /** The hero's box on the primary size's canvas (claimed only). */
  heroBox?: Maybe<MotionDraftBox>;
  /** The hero picture's media URL (claimed only). */
  heroImageUrl?: Maybe<Scalars['String']['output']>;
  /** The areas the clip keeps calm, in the primary size's canvas coordinates (claimed only). */
  keepStillBoxes?: Maybe<Array<MotionDraftBox>>;
  /** The size the clip is generated from (claimed only). */
  primaryDesignId?: Maybe<Scalars['Int']['output']>;
  /** Why nothing is generated: a MotionSkipReason, daily_cap or no_json (skipped rows), hero_unfetchable or hero_foreign_media (failed rows), or gate_closed, team_mismatch, no_sizes or duplicate (no row). */
  reason?: Maybe<Scalars['String']['output']>;
  /** The sizes the motion version is made for (claimed only). */
  sizeDesignIds?: Maybe<Array<Scalars['Int']['output']>>;
};

export type MotionDraftDecision = {
  __typename?: 'MotionDraftDecision';
  /** The motion design set's hash (open it in the editor, or find it next to the source set). */
  designHash: Scalars['String']['output'];
  draftId: Scalars['Int']['output'];
};

export type MotionDraftPartialSizes = {
  __typename?: 'MotionDraftPartialSizes';
  made: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MoveAbTestPayload = {
  __typename?: 'MoveAbTestPayload';
  abTest: AbTest;
};

export type MoveBrandTemplateDesignsAndFoldersPayload = {
  __typename?: 'MoveBrandTemplateDesignsAndFoldersPayload';
  designs: Array<Design>;
  folders: Array<Folder>;
};

/** Response after moving cached design JSONs. */
export type MoveCacheJsonsPayload = {
  __typename?: 'MoveCacheJsonsPayload';
  /** Number of design JSONs that were moved. */
  movedCount: Scalars['Int']['output'];
};

/** Response after moving a design. */
export type MoveDesignPayload = {
  __typename?: 'MoveDesignPayload';
  /** The moved design. */
  design: Design;
};

/**
 * Input for moving media elements.
 * Used to organize media assets in folders and brand kits.
 */
export type MoveElements = {
  /** ID of the source brand kit. */
  brandKitId: Scalars['Int']['input'];
  /** ID of the destination brand kit. */
  destinationBrandKitId: Scalars['Int']['input'];
  /** ID of the destination folder. */
  destinationFolderId?: InputMaybe<Scalars['Int']['input']>;
  /** IDs of elements to move. */
  elementIds: Array<Scalars['Int']['input']>;
  /** ID of the team that owns the media. */
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type MoveFolderPayload = {
  __typename?: 'MoveFolderPayload';
  folder: Folder;
};

/** Information about media movement. */
export type MoveMedia = {
  __typename?: 'MoveMedia';
  /** IDs of media elements that were moved. */
  mediaElementsIds: Array<Scalars['Int']['output']>;
  /** ID of the parent folder the media was moved to. */
  parentId?: Maybe<Scalars['Int']['output']>;
};

/** Input for moving media elements (deprecated). */
export type MoveMediaElements = {
  /** ID of the brand kit that owns the media. */
  brandKitId: Scalars['Int']['input'];
  /** IDs of media elements to move. */
  mediaElementsIds: Array<Scalars['Int']['input']>;
  /** ID of the parent folder to move to. */
  parentId?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the team that owns the media. */
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

/** Response after moving media elements. */
export type MoveMediaElementsPayload = {
  __typename?: 'MoveMediaElementsPayload';
  /** IDs of media elements that were moved. */
  mediaElementsIds: Array<Scalars['Int']['output']>;
  /** ID of the parent folder the media was moved to. */
  parentId?: Maybe<Scalars['Int']['output']>;
};

export type MoveMediaFoldersPayload = {
  __typename?: 'MoveMediaFoldersPayload';
  mediaFoldersIds: Array<Scalars['Int']['output']>;
  parentId?: Maybe<Scalars['Int']['output']>;
};

export type MoveTeamPayload = {
  __typename?: 'MoveTeamPayload';
  result: Scalars['Boolean']['output'];
};

/** Response after moving media elements to a brand kit. */
export type MoveToBrandkitPayload = {
  __typename?: 'MoveToBrandkitPayload';
  /** ID of the brand kit the media was moved to. */
  brandkitId?: Maybe<Scalars['Int']['output']>;
  /** IDs of media elements that were moved. */
  mediaElementsIds: Array<Scalars['Int']['output']>;
};

export enum Mp4Quality {
  CUSTOM = 'CUSTOM',
  HIGH = 'HIGH',
  LOW = 'LOW',
  MAX_QUALITY = 'MAX_QUALITY',
  MEDIUM = 'MEDIUM'
}

export type MultiSceneStoryboard = {
  __typename?: 'MultiSceneStoryboard';
  aspectRatio: Scalars['String']['output'];
  /** The storyboard's brief; may be empty (a storyboard written from scratch has none). */
  brief?: Maybe<Scalars['String']['output']>;
  /** False when per-scene regen is impossible (segments expired, chain failed, pre-editing generation) — reopen as a new run instead. */
  editable: Scalars['Boolean']['output'];
  /** Whether the chain rendered with sound. Regens inherit it. */
  hasAudio: Scalars['Boolean']['output'];
  notEditableReason?: Maybe<Scalars['String']['output']>;
  operationId: Scalars['Int']['output'];
  scenes: Array<MultiSceneStoryboardScene>;
  /** Whether the source generation was grounded in its design context (On-brand) — reopen-as-new-run restores it. */
  useDesignContext: Scalars['Boolean']['output'];
};

/** Handle for a storyboard draft in progress: poll getMultiSceneStoryboardDraft with the operation id. Drafts run the full image chain (~40-50s). */
export type MultiSceneStoryboardDraft = {
  __typename?: 'MultiSceneStoryboardDraft';
  draftOperationId: Scalars['Int']['output'];
};

/** Poll result for a storyboard draft. scenes are set once status is SUCCESS. */
export type MultiSceneStoryboardDraftResult = {
  __typename?: 'MultiSceneStoryboardDraftResult';
  scenes?: Maybe<Array<MultiSceneStoryboardDraftScene>>;
  status: MultiSceneStoryboardDraftStatus;
};

export type MultiSceneStoryboardDraftScene = {
  __typename?: 'MultiSceneStoryboardDraftScene';
  durationSeconds: Scalars['Int']['output'];
  prompt: Scalars['String']['output'];
  /** Pre-filled reference images — the scene's generated still first (scene 1 = the resolved anchor). The cards are the single source of truth after drafting; users may change these freely. */
  referenceImages?: Maybe<Array<Scalars['String']['output']>>;
};

export enum MultiSceneStoryboardDraftStatus {
  FAIL = 'FAIL',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS'
}

/** One scene of a finished multi-scene generation, as an editable card. */
export type MultiSceneStoryboardScene = {
  __typename?: 'MultiSceneStoryboardScene';
  durationSeconds: Scalars['Int']['output'];
  /** 1-based chain position. */
  index: Scalars['Int']['output'];
  prompt: Scalars['String']['output'];
  referenceImages?: Maybe<Array<Scalars['String']['output']>>;
  /** Temp-bucket URL of the scene's generated segment — the edit surface's per-scene preview source. Null when the segment is no longer available. */
  segmentUrl?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** @deprecated Not used */
  _empty?: Maybe<Scalars['String']['output']>;
  _rateLimitTester?: Maybe<Scalars['String']['output']>;
  /**
   * Accept an invitation to join a team.
   * Requires authentication.
   */
  acceptTeamInvitation: AcceptTeamInvitationPayload;
  /** Mark all recent successful AI operations as viewed for the current user. Fire on canvas/editor mount. */
  acknowledgeRecentAiOperations: Scalars['Boolean']['output'];
  activateAddon: ActivateAddonPayload;
  activateTagContainerAdTag: Scalars['Boolean']['output'];
  /** Auto-activate a win-back trial for never-paying users from email campaign */
  activateWinBackTrial: ActivateWinBackTrialPayload;
  /** Sends the ad serving code for a design via email. */
  adServingSendCodeViaEmail: Scalars['Boolean']['output'];
  adTagAddNetwork: AddAdTagNetworkPayload;
  adTagContactMe: AdTagContactMePayload;
  adTagDisable: Scalars['Boolean']['output'];
  adTagDisableAbTest: Scalars['Boolean']['output'];
  adTagEnable: Scalars['Boolean']['output'];
  adTagEnableAbTest: Scalars['Boolean']['output'];
  adTagFeatureActivate: AdTagSubscriptionPayload;
  adTagFeatureDeactivate: Scalars['Boolean']['output'];
  adTagRemoveNetwork: RemoveAdTagNetworkPayload;
  adTagSync: AdTagSyncPayload;
  adTagSyncAbTest: Scalars['Boolean']['output'];
  adTagUpdateDynamicVars: Scalars['Boolean']['output'];
  adTagUpdateExternalDesignTracking: Scalars['Boolean']['output'];
  adTagUpdateSettings: AdTagDesignSettings;
  addAiResizeVariant: AiResizeVariant;
  /**
   * Append user-uploaded images to the brand kit's source images list and
   * trigger an async re-evaluation of the visual style. Deduplicates URLs.
   * Requires authentication and MANAGE_BRANDS permission.
   */
  addBrandStyleSourceImages: BrandKit;
  addCardToMoodBoard: AddCardToMoodBoardPayload;
  addColorToPalette: ColorPalettePayload;
  /** Adds a new custom ad network for a team. */
  addCustomAdNetwork: AdNetwork;
  addCustomSize: AddCustomSizePayload;
  /**
   * Add media assets to a design's media library.
   * Requires authentication and DESIGN permission on the design.
   */
  addDesignMediaToLibrary: Scalars['Boolean']['output'];
  /** Add dedicated reviewers to a design. Sends email notifications. External emails receive invitations. */
  addDesignReviewers: Array<DesignReviewer>;
  /** @deprecated Use getOrCreateDesignSetSizeType instead */
  addDesignSetSizeType: AddDesignSizeTypePayload;
  addDesignSizeType: AddDesignSizeTypePayload;
  /**
   * Adds sizes to a design the way Ad Studio's sizes panel does, under editDesign's locks: a size of an orientation the
   * design has, or any size of a one-layer design, is smart-resized and carried to the master's variations. Any other
   * size needs the AI resize: with spendCredits it starts (one at a time per design) and completeAiResizedSize adds it.
   * Requires the DESIGN permission on the design.
   */
  addDesignSizes: AddDesignSizesResult;
  /**
   * Add a design to templates.
   * Requires authentication and TEMPLATE permission on the design.
   * Records this action in the project's recent activity.
   */
  addDesignToTemplates: AddDesignToTemplatesPayload;
  addFolderToBrandTemplate: AddFolderToBrandTemplatePayload;
  addFolderToTemplates: AddFolderToTemplatesPayload;
  /**
   * Add fonts from URLs to an existing brand kit.
   * Requires authentication and MANAGE_BRANDS permission.
   */
  addFontsFromUrl: CreateBrandKitPayload;
  /**
   * Add logos from URLs to an existing brand kit.
   * Requires authentication and MANAGE_BRANDS permission.
   */
  addLogosFromUrl: CreateBrandKitPayload;
  /** Adds an ad network to a design's ad serving configuration. */
  addNetworkAdServing: AddNetworkAdServingPayload;
  /**
   * Add a new design to an existing design set.
   * Requires authentication and DESIGN permission on the design set.
   */
  addNewDesignToSet: AddNewDesignToSetPayload;
  addNewFeedColumn: Feed;
  /** Add a new key-value pair to the user's onboarding properties. */
  addNewValueToUserOnboarding: AddNewValueToUserOnboardingPayload;
  /**
   * Add a group to a project.
   * Requires authentication and MANAGE_PROJECTS permission on the project.
   */
  addProjectGroup: AddProjectGroupPayload;
  /**
   * Add a user to a project.
   * Requires authentication and MANAGE_PROJECTS permission on the project.
   */
  addProjectUser: AddProjectUserPayload;
  addTagContainerNetwork: AddAdTagNetworkPayload;
  addTeamToPaymentExperiment: AddTeamToPaymentExperimentPayload;
  addTextInsightToMoodBoard: AddTextInsightToMoodBoardPayload;
  addToBrandTemplate: BrandTemplatePayload;
  addToPinnedFolders: PinnedFolders;
  /** @deprecated We replaced this with Pinned folders */
  addToRecentFolders: RecentFolders;
  /**
   * Add a new typography configuration to a brand kit.
   * Requires authentication and MANAGE_BRANDS permission.
   */
  addTypography: AddTypographyPayload;
  addUrlDataToBrandKit: UrlDataToBrandkitPayload;
  /**
   * Add a user to a group within a team.
   * Requires authentication and MANAGE_TEAMS permission on the team.
   */
  addUserToGroup: AddUserToGroupPayload;
  /** File the caller's chat-less generations under the Copilot chat that started them (the first turn of a new chat, before the client knew the thread id). Only fills a missing chat, and only where the thread is the caller's Copilot chat on the generation's design. */
  adoptAiStudioGenerationChatThread: Scalars['Boolean']['output'];
  /**
   * Snapshot the master's current per-size JSONs as the sizes baseline used by
   * the cross-size push ("apply your edits to the other sizes"). Advances only
   * when the cross-size state is resolved: after a push applies (server-side)
   * or via this mutation's explicit acknowledge actions — the "Got it" dismiss
   * (nothing pushable) and "Keep sizes as they are" (differences are intended).
   * The variations sync deliberately does NOT advance it — that would absorb a
   * pending offer.
   * Requires DESIGN permission on the master.
   */
  advanceMasterSizesSyncBaseline: AdvanceSizesSyncBaselinePayload;
  /** @deprecated Use aiResizeDesign */
  aiResize: Scalars['Boolean']['output'];
  aiResizeDesign: AiResizeModelPayload;
  aiResizeDesignWithHtml: AiResizeModelPayload;
  applyAiResizeVariant: Scalars['Boolean']['output'];
  /**
   * Apply the ticked resizeability fixes to a saved design and return the refactored JSON.
   *
   * The write half of the pre-resize dialog, and the field that closes P-DIALOG: the browser could
   * previously ask what was wrong (`Query.lintDesignResizeability`) but had no way to obtain a fixed
   * document, because the only field that returned one was `@signed(access: [DEV])`.
   *
   * Persists NOTHING. The refactored document is returned for the client to persist through its own
   * save path, so the design's normal history, autosave and undo all still own the write.
   */
  applyDesignLintFixes: DesignLintRefactorResult;
  /** Approves a pending motion draft and moves its set next to the source set. Repeating it returns the same answer. */
  approveMotionDraft: MotionDraftDecision;
  /**
   * Approve a team invitation (for admins).
   * Requires authentication and MANAGE_TEAMS permission on the team.
   */
  approveTeamInvitation: ApproveTeamInvitationPayload;
  /**
   * Assign a brand kit to a design.
   * Requires authentication and DESIGN permission on the design.
   * Records this action in the project's recent activity.
   */
  assignDesignBrandKit: AssignDesignBrandKitPayload;
  /**
   * Assign the default brand kit to a design.
   * Requires authentication and DESIGN permission on the design.
   * Records this action in the project's recent activity.
   */
  assignDesignDefaultBrandKit: AssignDesignDefaultBrandKitPayload;
  assignUserRole: TeamUser;
  /**
   * Ensure a design JSON is saved.
   * Requires authentication and DESIGN permission on the design.
   */
  assureDesignJsonIsSaved: AssureDesignJsonIsSavedPayload;
  attachFeed: AttachFeedPayload;
  /** Trigger a password reset email via Keycloak. */
  authForgotPassword: AuthForgotPasswordResult;
  /** Authenticate a user with email and password via Keycloak ROPC. */
  authLogin: AuthLoginResult;
  /** Register a new user via Keycloak Admin API and authenticate them. */
  authRegister: AuthLoginResult;
  authenticateWithToken: AuthenticateWithTokenPayload;
  autoconfigTeamIdentityProvider: TeamIdentityProvider;
  automateCopilotAiReport: Scalars['Boolean']['output'];
  blurBg: BlurBg;
  bulkDeleteAiAgentReports: Scalars['Boolean']['output'];
  bulkRemoveBgFeed: Scalars['Boolean']['output'];
  bulkRevertBgFeed: Scalars['Boolean']['output'];
  bulkSmartCropFeed: Scalars['Boolean']['output'];
  cancelActiveJob: Scalars['Boolean']['output'];
  cancelAiResize: Scalars['Boolean']['output'];
  /** @deprecated Migration service has been removed */
  cancelBsSubscription: Scalars['Boolean']['output'];
  /** Stop a Copilot ad the caller started while it is still generating. Images generated before the stop stay charged. */
  cancelLayeredAd: CancelLayeredAdResult;
  cancelSubscription: CancelSubscriptionPayload;
  cancelWorkflow?: Maybe<CancelWorkflowResponse>;
  changeAbTestEndingType: AbTest;
  changeBrandControlOption: ChangeBrandControlOptionPayload;
  changeDesignFeedRow: ChangeDesignFeedRowPayload;
  changeDesignProductSet: ChangeDesignProductSetPayload;
  /**
   * Change the owner of a team.
   * Requires authentication and MANAGE_TEAMS permission on the team.
   */
  changeOwner: ChangeOwnerPayload;
  /**
   * Re-times a video by a speed curve (uniform speed is a two-point curve).
   * Produces a NEW mp4 file (ffmpeg re-encode) and returns its URL — the source
   * file is untouched.
   */
  changeVideoSpeed: ChangeVideoSpeedResult;
  /**
   * @deprecated Resolver has been removed
   * @deprecated checkFeedFields mutation has been removed
   */
  checkFeedFields: FeedFieldCheck;
  /** Claim the right to tell a generation's chat that it ended. The first claim wins and every later one answers false, so no other tab or device tells it again. Identified by one of its operations; only the user who started it may claim. */
  claimAiStudioGenerationAnnouncement: Scalars['Boolean']['output'];
  /** Claim the right to apply a generation's recorded outcome (a RUNNING write). The first claim wins; a RUNNING older than two minutes, left by a tab that died mid-apply, may be claimed again. Answers true for an operation filed under no generation. Only the user who started it may claim. */
  claimAiStudioGenerationApply: Scalars['Boolean']['output'];
  claimExperimentCredits: ClaimExperimentCreditsResult;
  /**
   * Adds the size an AI resize started by addDesignSizes laid out, once it is ready, under addDesignSizes' locks: its 3
   * credits are reserved and charged only then. Called again for the same variant, it answers the size it added.
   * Requires the DESIGN permission on the design.
   */
  completeAiResizedSize: CompleteAiResizedSizeResult;
  /** Finishes the connection with the code and state Cloudinary sent to the popup, and stores it server side. Returns true or a CLOUDINARY_CONNECT_REFUSED error; the tokens never reach the browser. */
  completeCloudinaryConnection: Scalars['Boolean']['output'];
  /** Confirm a user's email using a confirmation code. */
  confirmEmail: ConfirmEmailPayload;
  confirmEmailChange: Scalars['Boolean']['output'];
  /** The Advertise flow's Connect layers step: attach the catalog at the baked row and write every size, bound. */
  connectCatalogToDesign: ConnectCatalogToDesignPayload;
  consumeNextgenFlowCredits: ConsumeNextgenFlowCreditsPayload;
  continueAbTest: AbTest;
  convertHtmlToJson: ConvertHtmlToJsonResult;
  /**
   * Convert a single design to a design set.
   * Requires authentication and DESIGN permission on the design.
   */
  convertSingleDesignToSet: ConvertSingleDesignToSetPayload;
  convertTrialSubscription?: Maybe<RecurlySubscription>;
  /**
   * Redeems a sample-ads share link as a COPY: imports the group's ready designs
   * into the caller's team as ONE design set (gift semantics — no plan/quota
   * requirement). Multi-redeem: the original stays available; the same team
   * re-redeeming gets its existing copy back (alreadyCopied: true). Errors carry
   * SAMPLE_AD_* codes in extensions.code.
   */
  copySampleAdDesigns: CopySampleAdDesignsPayload;
  createAbTest: AbTest;
  createAiFlowCreatorChat: CreateAiFlowCreatorChatPayload;
  createAppIntegration: CreateAppIntegrationPayload;
  createAssetsNextgenAi: AssetsNextgenAi;
  /**
   * Create a new brand competitor.
   * Requires authentication and MANAGE_BRANDS permission.
   */
  createBrandCompetitor: BrandCompetitor;
  /**
   * Create a new brand kit for a team.
   * Requires authentication and MANAGE_BRANDS permission on the team.
   */
  createBrandKit: CreateBrandKitPayload;
  createBrandKitButton: BrandKitButton;
  /**
   * Create a new brand target audience.
   * Requires authentication and MANAGE_BRANDS permission.
   */
  createBrandTargetAudience: BrandTargetAudience;
  /** Create a new brand template */
  createBrandTemplate: CreateBrandTemplatePayload;
  createBrandTemplateSet: CreateBrandTemplatePayload;
  createBulkDesigns: CreateBulkDesignsPayload;
  createCloudIntegration: CreateCloudIntegrationPayload;
  createColorPalette: ColorPalettePayload;
  createComment: CreateCommentResult;
  createDemoMoodBoard: MoodBoard;
  /**
   * Create a new design.
   * Requires authentication and DESIGN permission on the specified resource.
   * Records this action in the project's recent activity.
   */
  createDesign: CreateDesignPayload;
  createDesignComponent: CreateDesignComponentPayload;
  /**
   * Create a design from a Getting Started step template.
   * Requires authentication and DESIGN permission on the team.
   */
  createDesignFromGettingStarted: CreateDesignFromGettingStartedPayload;
  /**
   * Create a design from a JSON design (typically generated from an image).
   * This mutation is specifically for AI-generated designs from images.
   * Automatically sets HTML settings with useAsClickTag enabled.
   * Requires authentication and DESIGN permission on the specified resource.
   * Records this action in the project's recent activity.
   */
  createDesignFromImageJson: CreateDesignPayload;
  createDesignFromJsons: CreateDesignFromJsonsPayload;
  /**
   * Create a design from a template.
   * Requires authentication and DESIGN permission on the specified resource.
   * Records this action in the project's recent activity.
   */
  createDesignFromTemplate: CreateDesignPayload;
  /**
   * Create a folder in a design's media library.
   * Requires authentication and DESIGN permission on the design.
   */
  createDesignMediaFolder: DesignMediaFolder;
  /**
   * Create a design set (deprecated).
   * Requires authentication and DESIGN permission on the specified resource.
   * Records this action in the project's recent activity.
   * @deprecated Don't use this anymore
   */
  createDesignSet: CreateDesignPayload;
  /**
   * Create a variation of a master design set. The DUPLICATE kind copies the
   * whole master set (all sizes, structure, content and custom code) and links
   * the copy to the master via masterSetId; the copy is excluded from all
   * standard design listings. Feed/product-catalog bindings and ad-serving
   * settings are NOT copied.
   * Requires authentication and DESIGN permission on the source design set.
   */
  createDesignVariation: CreateDesignVariationPayload;
  /**
   * Create a new design.
   * Requires authentication and DESIGN permission on the specified resource.
   * Records this action in the project's recent activity.
   */
  createDesignWithAsset: CreateDesignPayload;
  /**
   * Create a design with an image/video layer already placed on the stage.
   * This mutation is specifically for mood board functionality where the image should be
   * automatically placed on the design when created, with optional brand kit saving.
   * Requires authentication and DESIGN permission on the specified resource.
   * Records this action in the project's recent activity.
   */
  createDesignWithImageLayer: CreateDesignPayload;
  /**
   * Create a design with a video layer already placed on the stage.
   * This mutation is specifically for mood board functionality where the video should be
   * automatically placed on the design when created, with optional brand kit saving.
   * Handles both video URLs and hashes from S3 platform.
   * Requires authentication and DESIGN permission on the specified resource.
   * Records this action in the project's recent activity.
   */
  createDesignWithVideoLayer: CreateDesignPayload;
  createDriveFolder: CreateDriveFolderResult;
  createDummyComments: CreateDummyCommentsPayload;
  /**
   * Create or edit a webhook for a team.
   * Requires authentication and MANAGE_TEAMS permission on the team.
   */
  createEditTeamWebhook: TeamWebhook;
  createFeed: Feed;
  createFolder: CreateFolderPayload;
  /**
   * Create a design from a Creatopy template design.
   * Requires authentication and DESIGN permission on the team.
   */
  createFromCreatopyDesign: CreateFromCreatopyDesignPayload;
  createIntercomConversation: CreateIntercomConversationPayload;
  createLearnAgentReportSignedUrl: CreateLearnAgentReportSignedUrlPayload;
  /** Create a blank manual catalog with user-defined typed columns (CRE-424) */
  createManualCatalog: Catalog;
  /**
   * Create a media asset (deprecated).
   * Use createNewMedia mutation instead.
   * @deprecated Use createNewMedia mutation
   */
  createMedia: Media;
  createMediaFolder: CreateMediaFolderPayload;
  createMoodBoard: MoodBoard;
  createMoodBoardComment: MoodBoardComment;
  createMoodBoardCommentThread: MoodBoardCommentThread;
  createMoodBoardFromTemplateHash: MoodBoard;
  /**
   * Create a media asset for moodboard share uploads.
   * Does not require authentication - validates access via moodboard share hash.
   * Server-side processing handles thumbnail generation for videos.
   */
  createMoodBoardMedia: CreateMoodBoardMediaPayload;
  createMoodboardTeamInvitation: MoodboardTeamInvitationResult;
  /**
   * Create a new media asset.
   * Adds a new media asset to a project, team, or brand kit.
   */
  createNewMedia: CreateNewMediaPayload;
  createNextGenLogo: NextGenLogoSource;
  createNextGenMedia: NextGenMediaFile;
  /** @deprecated use createNextGenLogo */
  createNextGenSignedUrl: NextGenSignedUrlResponse;
  createNextgenAi: NextgenAi;
  /** @deprecated use createNextGenMedia */
  createNextgenAiBrandKit: BrandKit;
  createNextgenAiDesign: Array<NextgenAiDesign>;
  createOnboardingMoodBoard: MoodBoard;
  /** Create a dynamic/static set (CRE-418), in Meta as well on a catalog imported from Meta — smart sets go through setSmartSetEnabled */
  createProductSet: CreatedProductSet;
  /**
   * Create a new project.
   * Requires authentication and MANAGE_PROJECTS permission on the team.
   */
  createProject: ProjectPayload;
  createSubscription: SubscriptionActionResult;
  createSubscriptionChange: SubscriptionActionResult;
  /**
   * Create a new team.
   * Requires authentication.
   */
  createTeam: TeamCreatePayload;
  createTeamIdentityProvider: TeamIdentityProvider;
  /**
   * Create a user group within a team.
   * Requires authentication and MANAGE_TEAMS permission on the team.
   */
  createTeamUserGroup: CreateTeamUserGroupPayload;
  /** Brand Template Folders */
  createTemplatesFolder: CreateFolderPayload;
  createTemporaryDownloadPreview: CreateTemporaryDownloadPreviewPayload;
  createTemporaryPreview: CreateTemporaryPreviewPayload;
  createTranslateFeed: CreateTranslationFeedPayload;
  /**
   * Create default resources (team, project) for a new user.
   * Tracked in Intercom as adding a user to a company.
   */
  createUserDefaults: CreateUserDefaultsPayload;
  createVeevaApp: VeevaApp;
  createWorkflow: Array<Workflow>;
  /**
   * Crop a video to a rectangle of its frame.
   * Produces a NEW mp4 file (ffmpeg re-encode) and returns its URL — the source file is untouched.
   */
  cropVideo: CropVideoResult;
  /**
   * Cut a video down to a list of kept spans, concatenated in source order.
   * Produces a NEW mp4 file (ffmpeg trim + concat) and returns its URL — the source file is untouched.
   */
  cutVideo: CutVideoResult;
  dataLake: DataLakePayload;
  /**
   * "Not my brand", under the Ad Studio Copilot's "I found your brand on acme.com. Use it for your designs?":
   * empties the kit the user's signup filled from their work-email website, so it is a new signup's empty kit
   * again. Only that kit (created by the caller, its domain their email's; FORBIDDEN otherwise). Requires
   * MANAGE_BRANDS.
   */
  declineScannedBrand: Scalars['Boolean']['output'];
  /** Deindex a feed json from the search service (applied rate limit to 10 requests per minute) */
  deindexFeedRows: IndexFeedRowsPayload;
  deleteAbTest: AbTestDeleteResultPayload;
  deleteAbTestPermanently: Scalars['Boolean']['output'];
  /** Delete the user's account and associated data. */
  deleteAccount: DeleteAccountPayload;
  deleteAdPublishJobFromRedis: Scalars['Boolean']['output'];
  /** Delete an AdStudio chat thread (optional agentId; defaults to image creator agent) */
  deleteAdStudioThread: Scalars['Boolean']['output'];
  deleteAiAgentAutomationSchedule: Scalars['Boolean']['output'];
  deleteAppIntegration: Scalars['Boolean']['output'];
  /** @BreakingBad */
  deleteBrandCompetitor: Scalars['Boolean']['output'];
  /**
   * Delete a brand kit.
   * Requires authentication and MANAGE_BRANDS permission.
   */
  deleteBrandKit: Scalars['Boolean']['output'];
  deleteBrandKitButton: Scalars['Boolean']['output'];
  /** Remove a document from the brand kit. Fields already applied to the kit stay. Requires MANAGE_BRANDS. */
  deleteBrandKitDocument: Scalars['Boolean']['output'];
  /**
   * Delete a font from a brand kit.
   * Requires authentication and MANAGE_BRANDS permission.
   */
  deleteBrandKitFont: DeleteBrandKitFontPayload;
  /**
   * Delete a media asset from a brand kit.
   * Permanently removes a media asset from a brand kit.
   */
  deleteBrandKitMedia: DeleteBrandKitMediaPayload;
  /**
   * Delete target audience by ID.
   * Requires authentication and access to the brand kit.
   */
  deleteBrandTargetAudience: Scalars['Boolean']['output'];
  deleteCloudIntegration: DeleteCloudIntegrationPayload;
  /** Removes the team's Cloudinary cloud name and default folder. Refused when the team's plan doesn't include Cloudinary (PLAN_FEATURE_REFUSED). */
  deleteCloudinaryConfig: Scalars['Boolean']['output'];
  deleteColorPalette: Scalars['Boolean']['output'];
  deleteComment: DeleteCommentResult;
  deleteCommentsOnTemplateChange: DeleteCommentsOnTemplateChangeResult;
  deleteCopilotAiChat: DeleteCopilotAiChatPayload;
  deleteCopilotAiChatMessage: DeleteCopilotAiChatMessagePayload;
  deleteCustomTransition: Scalars['Boolean']['output'];
  /**
   * Delete a design (move to trash).
   * Requires authentication and DESIGN permission on the design.
   * Records this action in the project's recent activity.
   */
  deleteDesign: DeleteDesignPayload;
  deleteDesignComments: DeleteDesignCommentsResult;
  /** @deprecated Field no longer supported */
  deleteDesignComponent: Scalars['Boolean']['output'];
  deleteDesignComponents: Scalars['Boolean']['output'];
  deleteDesignFeedAdjustment?: Maybe<DesignFeedAdjustmentInfo>;
  /**
   * Delete a folder, its subfolders, and their items from a design's media library.
   * Media left with no references anywhere is permanently deleted.
   * Requires authentication and DESIGN permission on the design.
   */
  deleteDesignMediaFolder: Scalars['Boolean']['output'];
  /**
   * Permanently delete a design from trash.
   * Requires authentication and DESIGN permission on the team.
   */
  deleteDesignPermanently: Scalars['Boolean']['output'];
  deleteFeed: Scalars['Boolean']['output'];
  deleteFeedColumn: Feed;
  deleteFeedRows: Feed;
  deleteFolder: DeleteFolderPayload;
  deleteFolderPermanently: DeleteFolderPermanentlyPayload;
  /**
   * Delete a media asset.
   * Permanently removes a media asset from a project, team, or brand kit.
   */
  deleteMedia: Scalars['Boolean']['output'];
  deleteMediaFolder: Scalars['Boolean']['output'];
  /** @deprecated Migration service has been removed */
  deleteMigrationAccount: Scalars['Boolean']['output'];
  deleteMoodBoard: Scalars['Boolean']['output'];
  deleteMoodBoardComment: Scalars['Boolean']['output'];
  deleteMoodBoardCommentThread: Scalars['Boolean']['output'];
  deletePlatformAd: Scalars['Boolean']['output'];
  /** Delete a set; attached designs (D24) fall back to the full catalog */
  deleteProductSet: Scalars['Boolean']['output'];
  /**
   * Delete a project (move to trash).
   * Requires authentication and MANAGE_PROJECTS permission on the project.
   */
  deleteProject: DeleteProjectPayload;
  /**
   * Permanently delete a project from trash.
   * Requires authentication and MANAGE_PROJECTS permission on the team.
   */
  deleteProjectPermanently: DeleteProjectPermanentlyPayload;
  deleteReport: Scalars['Boolean']['output'];
  deleteReportSchedule: Scalars['Boolean']['output'];
  deleteRole: Scalars['Boolean']['output'];
  deleteSlideComments: DeleteSlideCommentsResult;
  /**
   * Delete a team.
   * Requires authentication and MANAGE_TEAMS permission on the team.
   */
  deleteTeam: DeleteTeamPayload;
  /**
   * Delete a client ID for a team's API access.
   * Requires authentication and VIEW permission on the team.
   */
  deleteTeamClientId: Scalars['Boolean']['output'];
  /**
   * Delete a webhook for a team.
   * Requires authentication and MANAGE_TEAMS permission on the team.
   */
  deleteTeamWebhook: Scalars['Int']['output'];
  deleteVeevaApp: Scalars['Boolean']['output'];
  deleteWorkflow?: Maybe<DeleteWorkflowResponse>;
  detachFeed: Scalars['Int']['output'];
  /** Disables ad serving for a design. */
  disableAdServing: Scalars['Boolean']['output'];
  discardAiResizeSession: Scalars['Boolean']['output'];
  /** Deletes the extraction's draft kit. A no-op once it was saved. */
  discardCopilotBrandExtraction: CopilotBrandExtraction;
  discountSubscription: DiscountSubscriptionPayload;
  discoverVeeva: DiscoverVeevaResponse;
  dismissAdServingPopup: Scalars['Boolean']['output'];
  dismissAdStudioReminder: Scalars['Boolean']['output'];
  dismissAdStudioSwitchBackBanner: Scalars['Boolean']['output'];
  /** Dismisses a pending motion draft and moves its set to the trash. Repeating it is a no-op. */
  dismissMotionDraft: Scalars['Boolean']['output'];
  /**
   * Toggle the display of the brand kit wizard for a team.
   * Requires authentication and MANAGE_BRANDS permission.
   */
  displayBrandKitWizard: DisplayBrandKitWizardPayload;
  download: Download;
  downloadCancel: DownloadCancel;
  downloadCancelAll: DownloadCancelAll;
  downloadInvoice: DownloadInvoicePayload;
  downloadRetry: Download;
  downloadViaEmail: DownloadViaEmail;
  /** Draft typed columns from a free-text prompt (CRE-424, 'Describe it') — result is an editable suggestion list (applied rate limit of 10 requests per minute) */
  draftColumnsFromPrompt: Array<DraftedCatalogColumn>;
  /** Manual multi-scene: draft one editable card prompt per scene from a brief. Flash text only — no video, no images, no credits. */
  draftMultiSceneStoryboard: MultiSceneStoryboardDraft;
  duplicateAiChat: AiChat;
  /**
   * Duplicate an existing brand kit to a team.
   * Requires authentication and MANAGE_BRANDS permission on the team.
   */
  duplicateBrandKit: CreateBrandKitPayload;
  /**
   * Duplicate target audience by ID.
   * Requires authentication and access to the brand kit.
   */
  duplicateBrandTargetAudience: BrandTargetAudience;
  duplicateBrandTemplate: BrandTemplatePayload;
  duplicateBrandTemplateFolder: DuplicateBrandTemplateFolderPayload;
  duplicateColorPalette: Array<ColorPalette>;
  /** @deprecated Use duplicateAiChat instead */
  duplicateCopilotAiChat: CopilotAiChat;
  /**
   * Duplicate a design.
   * Requires authentication and DESIGN permission on the design.
   * Records this action in the project's recent activity.
   */
  duplicateDesign: DuplicateDesignPayload;
  duplicateFolder: DuplicateFolderPayload;
  duplicateMoodBoard: MoodBoard;
  duplicateReport: DuplicateReportPayload;
  editColorInPalette: ColorPalettePayload;
  /**
   * Changes a design's layers in place on every size, saved like the editor's batch edit. Refused while anyone,
   * the caller included, has the design open in the editor. Requires the DESIGN permission on the design.
   */
  editDesign: EditDesignResult;
  editImage: Array<GeneratedImageResult>;
  /** Approves a pending motion draft to open it in the editor (the same as approve, counted apart). */
  editMotionDraft: MotionDraftDecision;
  /** Enables ad serving for a design on specified networks. @BreakingBad */
  enableAdServing: EnableAdServingPayload;
  /**
   * Switch a workspace to the new Ad Studio BETA. One-way and idempotent.
   * Requires MANAGE_PROJECTS permission.
   */
  enableProjectNewAdStudioBeta: Project;
  endSession: EndSessionPayload;
  /**
   * Enforce SSO authentication for a team.
   * Requires authentication, the identityProvider feature, and MANAGE_TEAMS permission.
   */
  enforceTeamSso: Scalars['Boolean']['output'];
  /**
   * Enforce two-factor authentication for a team.
   * Requires authentication, the enforceTwoFactor feature, and MANAGE_TEAMS permission.
   */
  enforceTeamTwoFactor: Scalars['Boolean']['output'];
  /** Enroll the team account into a payment variant (no-card access - optIn / optOut / trial custom..etc) */
  enrollTeamToPaymentVariant?: Maybe<EnrollTeamToVariantPayload>;
  estimateHtmlSize: Scalars['Boolean']['output'];
  expandImage: GeneratedImageResult;
  exportDesignThumbnail: ExportDesignThumbnailPayload;
  exportSetThumbnailAdmin: ExportSetThumbnailPayload;
  /**
   * Extract brand kit assets from a website URL.
   * This analyzes a website to extract logos, colors, brand name, and style information
   * that can be used to create a brand kit. Requires authentication.
   * @deprecated Unused. Will be removed in a future release.
   */
  extractBrandKitAssets: ExtractedBrandKitAssets;
  /** @deprecated Use getColumnsFromFeedSourceUrl */
  fetchFeedUrlColumns: Array<Scalars['String']['output']>;
  /** Generate an AI title for a Studio Assistant thread from its first messages (optional agentId; defaults to the Helper agent) */
  generateAdStudioThreadTitle?: Maybe<Scalars['String']['output']>;
  /** Validates the request, writes the ContentVariationJob row (GENERATING_CONTENT), and enqueues Job 1. */
  generateContentVariations: GenerateContentVariationsResult;
  /** @deprecated Use startLayeredAd for a new design; making an image editable moves to the lift engine. */
  generateDesignJsonFromImage: Array<GeneratedDesignFromImageResult>;
  generateDesignName: GenerateDesignNameResult;
  generateEmbedCode: GeneratedEmbedCodeResult;
  generateProductPhotography: Array<GeneratedImageResult>;
  /**
   * Generate a client ID for a team's API access.
   * Requires authentication and VIEW permission on the team.
   * @BreakingBad
   * This should be an input type not with arguments
   */
  generateTeamClientId: TeamClientId;
  generateText: GeneratedTextResult;
  generateVeevaNotes: GenerateVeevaNotes;
  generateVeevaPdf: GenerateVeevaPdfResponse;
  /** Retrieves the Bynder authentication URL. */
  getBynderAuthUrl: BynderAuthUrlResponse;
  /** Exchanges an authorization code for a Bynder access token. */
  getBynderToken: BynderTokenResponse;
  getOrCreateDesignSetSizeType: GetOrCreateDesignSizeTypePayload;
  handleTemporaryEnterprise: TeamSettings;
  impersonateUser: ImpersonateUserPayload;
  /** Copies an AEM author asset into The Brief's CDN and returns the hosted URL + dimensions. */
  importAemAsset: AemImportedAsset;
  /**
   * Record an uploaded brand guidelines document on the brand kit and start extracting
   * it. Requires MANAGE_BRANDS. At most 20 documents per kit.
   */
  importBrandKitDocument: BrandKitDocument;
  /**
   * Import media into a design's library from external URLs.
   * Requires authentication and DESIGN permission on the design.
   */
  importDesignMediaFromUrls: ImportDesignMediaFromUrlsResult;
  /** Starts the IMPORT job for the frames the user picked. Poll figFileStatus; designUrl is set once it is SUCCESS. */
  importFigFileFrames: FigFileJobPayload;
  /**
   * Import media out of another design (its canvas JSON and its library) into this design's library.
   * Requires authentication, DESIGN permission on the target, and access to the source design.
   */
  importMediaFromDesign: ImportMediaFromDesignResult;
  /** Import a Meta catalog as a new synced catalog (CRE-423, architecture §6.2) — continuous sync per D11 */
  importMetaCatalog: Catalog;
  /** Index a feed json in search service (applied rate limit to 10 requests per minute) */
  indexFeedRows: IndexFeedRowsPayload;
  /**
   * Initialize the sizes baseline if the master has NONE yet — a no-op
   * otherwise (never advances an existing pointer, so it is always safe to
   * call). The editor fires this as it opens a multi-size master (after its
   * own load-time save) so cross-size edit detection works before any
   * variation exists; masters with variations get the same initialization
   * from createDesignVariation. Requires DESIGN permission on the master.
   */
  initializeMasterSizesSyncBaseline: AdvanceSizesSyncBaselinePayload;
  initiateIntercomConversation: InitialIntercomConversationPayload;
  /** @deprecated Add Object feature has been removed. This mutation is no longer functional. */
  inpaintWithAi: GeneratedImageResult;
  integrateVeevaClient: LoginVeevaResponse;
  /**
   * Invite a user to join a team.
   * Requires authentication and access to the team and specified resources.
   */
  inviteTeamUser: InviteTeamUserPayload;
  /**
   * Invite multiple users to multiple resources within a team.
   * Requires authentication and access to the team.
   */
  inviteTeamUsersMultipleResources: InputInviteTeamUsersMultipleResourcesPayload;
  isAiOperationViewed: Scalars['Boolean']['output'];
  /** @deprecated Use validateCancellationReason instead. Returns isValid from the new response. */
  isValidCancellationReason: Scalars['Boolean']['output'];
  joinBetaNextgenAi: Scalars['Boolean']['output'];
  joinMoodboardTeam: JoinMoodboardTeamResult;
  /**
   * Request to join a team.
   * Requires authentication.
   */
  joinTeam?: Maybe<JoinTeamPayload>;
  /**
   * Request to join a team by business domain.
   * Requires authentication. Rate limited to 5 requests per minute.
   */
  joinTeamByBusinessDomain?: Maybe<JoinTeamPayload>;
  keepAliveLoginVeeva: LoginVeevaResponse;
  /**
   * Leave a team.
   * Requires authentication and access to the team.
   */
  leaveTeam: RemoveMemberPayload;
  linkBusinessFbAccount: LinkBusinessFbResponse;
  loginVeeva: LoginVeevaResponse;
  manuallyEndAbTest: AbTest;
  /**
   * Mark a design as being edited to prevent conflicts.
   * Requires authentication and access to the design.
   */
  markEditDesign: MarkEditDesignPayload;
  markProductUpdate: Scalars['Boolean']['output'];
  markTutorial: Scalars['Boolean']['output'];
  markTutorialAsViewed: Scalars['Boolean']['output'];
  /**
   * Mark Zapier feedback as shown to the user.
   * Requires authentication and VIEW permission on the team.
   */
  markZapierFeedbackAsShown: Scalars['Boolean']['output'];
  /** @deprecated Migration service has been removed */
  migrate: Scalars['Boolean']['output'];
  /** @deprecated Brand template migration service has been removed. @BreakingBad */
  migrateBrandTemplates: MigrateBrandTemplatesPayload;
  moveAbTest: MoveAbTestPayload;
  moveBrandTemplateDesignsAndFolders: MoveBrandTemplateDesignsAndFoldersPayload;
  /**
   * Move or copy a design to a different location.
   * Requires authentication and DESIGN permission on the resources.
   */
  moveDesign: MoveDesignPayload;
  /**
   * Move folders inside a design's media library (null destination = the root).
   * A folder cannot move into itself or its own subtree.
   * Requires authentication and DESIGN permission on the design.
   */
  moveDesignMediaFolders: Scalars['Boolean']['output'];
  /**
   * Move library media into a folder (null folder = the library root).
   * Requires authentication and DESIGN permission on the design.
   */
  moveDesignMediaToFolder: Scalars['Boolean']['output'];
  /**
   * Move media elements to a different location.
   * Moves media assets between folders or brand kits.
   */
  moveElements: MoveMediaElementsPayload;
  moveFolder: MoveFolderPayload;
  moveFolders: MoveMediaFoldersPayload;
  /**
   * Move logo elements to a different folder.
   * Moves logos between folders within or across brand kits.
   */
  moveLogoElements: MoveMediaElementsPayload;
  /**
   * Move media elements (deprecated).
   * Use moveElements mutation instead.
   * @deprecated Use moveElements mutation
   */
  moveMediaElements: MoveMediaElementsPayload;
  /** @deprecated Use moveFolders mutation instead. */
  moveMediaFolders: MoveMediaFoldersPayload;
  /**
   * Move media elements to a brand kit.
   * Moves specified media assets to a brand kit for organization.
   */
  moveToBrandkit: MoveToBrandkitPayload;
  /**
   * Create a new design set.
   * Requires authentication and DESIGN permission on the specified resource.
   * Records this action in the project's recent activity.
   */
  newDesignSet: CreateDesignPayload;
  /**
   * Optimize an image for web use.
   * Reduces image dimensions while maintaining quality.
   */
  optimizeImage: OptimizeImagePayload;
  /** Upsert a field override (D15) — merged over the source at read time; captures source snapshot + row hash on first write */
  overrideProductField: CatalogProduct;
  /** Pause an active subscription for a specified number of billing cycles */
  pauseSubscription: PauseSubscriptionResult;
  /**
   * CACHE-ON-APPLY for flex resize: promote the design's server-cached preview skeleton (the one
   * that produced the applied previews) into the long-lived applied tier, so future previews of
   * the unchanged design reuse the accepted layout instead of a live model call. Fire-and-forget
   * after a successful flex apply. Returns whether anything was promoted; never errors.
   */
  persistFlexDesignTree: Scalars['Boolean']['output'];
  /** @deprecated We replaced this with Pinned folders */
  pinFolder: PinFolderPayload;
  /** Plan the start-from-assets entry (one fast model call, deterministic fallback). Rate limited to 20 per minute. */
  planAdEntry: AdEntryPlan;
  /**
   * Plan one brand-grounded image per eligible image slot of a design.
   * Pure planning: fires no generation and spends no credits — the caller
   * fires each returned slot through generateProductPhotography.
   *
   * Rate-limited well below the Mutation default: it spends an uncached
   * Sonnet call per request and, unlike the generation it precedes, is not
   * metered by credits — so nothing else bounds its provider cost.
   */
  planBrandKitImagery: BrandKitImageryPlan;
  /**
   * Populate a brand kit from a website URL.
   * Optionally creates a new brand kit, sets brandName/brandDomain, and kicks off
   * all extraction workers. Returns immediately with brandKitId and nextgenAiId.
   * Requires authentication and MANAGE_BRANDS permission on the team.
   * A new kit counts toward the plan's brand kit limit: without room it refuses with
   * PLAN_FEATURE_REFUSED (featureName brandKits). A scan into the kit named by
   * brandKitId, or into the kit already holding the website's domain, is not checked.
   */
  populateBrandKitFromUrl: PopulateBrandKitResult;
  /** Post a journey feedback answer to the team's feedback channel in Slack. Returns whether it was delivered; production only. */
  postJourneyFeedback: Scalars['Boolean']['output'];
  /**
   * Processes data associated with a user joining via an external link.
   * Creates designs or brand kits based on stored after-join data.
   */
  processAfterJoin: AfterJoinPayload;
  /**
   * Starts the STRUCTURE job on an uploaded .fig: it lists the file's pages, frames and fonts. Poll figFileStatus;
   * once it is SUCCESS, structureUrl links the result.
   */
  processFigFile: FigFileJobPayload;
  processPhotoshopFile: PhotoshopDataPayload;
  processPhotoshopStructure: ProcessPhotoshopStructurePayload;
  /**
   * Turns the draft into a regular brand kit (MANAGE_BRANDS and a free kit slot), optionally assigned to the design.
   * Refused with EXTRACTION_RUNNING while the site is still being read.
   */
  promoteCopilotBrandExtraction: CopilotBrandExtraction;
  /**
   * Propagates freshly-added MASTER sizes to every variation set of the master
   * (concept 12: add a size once, it appears on the master and all variations),
   * using the master set as the template: per variation, missing sizes are
   * created through the resizeWithTemplate pipeline - the master supplies the
   * layout, the variation supplies the content. Idempotent (existing variation
   * sizes are untouched); per-variation/per-size failures are isolated.
   * Requires authentication and DESIGN permission on the master set.
   */
  propagateSizesToVariations: PropagateSizesToVariationsPayload;
  publicDownload: Download;
  publishCreativeCM360: PublishCreativeCm360Payload;
  publishCreativeDv360: PublishCreativeDv360Payload;
  publishDpaCatalog: PublishDpaCatalogResponse;
  /**
   * Publish a Creatopy design as a Google Ads campaign asset
   *
   * Creates ads or assets from Creatopy designs in Google Ads campaigns.
   * Supports Performance Max (asset creation) and Display campaigns (ad creation).
   *
   * The process is asynchronous - returns a job ID for tracking progress.
   * The system validates design sizes against Google Ads requirements before publishing.
   *
   * Performance Max: Creates image assets in asset groups
   * Display: Creates various ad types (Responsive, Image, HTML5) in ad groups
   */
  publishGoogleAdsCampaign: PublishGoogleAdsCampaignResponse;
  /**
   * Publish a Creatopy design as a LinkedIn sponsored creative into an existing campaign.
   *
   * Asynchronous — returns a job ID for tracking. A multi-size set fans out
   * one sponsored creative per LinkedIn-valid size; credits are all-or-nothing.
   */
  publishLinkedInCampaign: PublishLinkedInCampaignResponse;
  publishPinterestCampaign: PublishPinterestCampaignPayload;
  /** Pinterest catalog publish -- generates a feed CSV (URL mode) or additionally resolves/creates a Pinterest catalog+feed and triggers an ingest (DPA mode, type: pinterest). */
  publishPinterestCatalog: PublishDpaCatalogResponse;
  /**
   * @deprecated Resolver has been removed
   * @deprecated publishSingleCreative mutation has been removed
   */
  publishSingleCreative: PublishSingleCreativeResponse;
  publishTikTokCampaign: PublishTikTokCampaignPayload;
  /** TikTok catalog publish -- the design's own team is resolved from designHash and must be the authorized teamId, as for publishDpaCatalog. */
  publishTikTokCatalog: PublishDpaCatalogResponse;
  publishToCampaign: PublishToCampaignPayload;
  /** @deprecated Migration service has been removed */
  purchaseCredits: Scalars['Boolean']['output'];
  purchaseTopUpCredits: PurchaseTopUpCreditsPayload;
  /**
   * Push the edited master size's baseline-relative changes to its sibling
   * sizes ("apply your edits to the other sizes",
   * docs/adstudio-variations-master-sync.md). Geometry and per-size-scaled
   * properties are skipped so each size keeps its own layout; the sizes
   * baseline advances in the same call, only after a real write.
   * Requires DESIGN permission on the master.
   */
  pushMasterSizeChanges: PushMasterSizeChangesPayload;
  /** @deprecated We replaced this with reactivateSubscriptionV2 */
  reactivateSubscription: ReactivateSubscriptionPayload;
  reactivateSubscriptionV2: ReactivateSubscriptionResult;
  /**
   * Read the design as a whole — hierarchy, per-layer roles, the kit palette
   * mapped onto this design — BEFORE a brand-kit apply changes anything.
   * Pure planning: writes nothing, spends no credits. One uncached vision call
   * per new design+kit, so rate-limited like planBrandKitImagery.
   */
  readBrandKitConceptBrief: BrandKitConceptBriefResult;
  readThread: ReadThreadResult;
  /** Record what the Copilot asked to happen to a generation once it finishes, and how far applying it got. Identified by one of its operations. A status never moves backwards and a terminal one is final; returns false when the write was not accepted. */
  recordAiStudioGenerationOutcome: Scalars['Boolean']['output'];
  /** Marks a custom set as applied now, which moves it to the front of the team's list. False when the team has no such set. */
  recordCustomDesignSetUse: Scalars['Boolean']['output'];
  /** Tells the server the user copied the design's share link, which otherwise never reaches it. Writes nothing itself: the editor action log records the call, and the Copilot session verdict reads that log. Always true. */
  recordDesignShareLinkCopied: Scalars['Boolean']['output'];
  /**
   * Fire-and-forget warm signal (tab-leave). Returns whether a summary recompute was started.
   * includeGenerationGrounding additionally warms the style brief that AI generation
   * grounds on — opt-in, so callers that are nowhere near a generation don't pay for it.
   */
  refreshAdStudioContext: Scalars['Boolean']['output'];
  /**
   * Push the latest editor-context snapshot (and optionally a real
   * bannersetElementId for a pending addLayer) to the Mastra Studio
   * Assistant store so the next tool read in the same agent turn sees
   * post-mutation geometry. Fire-and-forget from the client; returns
   * true on accepted, false on upstream failure.
   */
  refreshStudioAssistantContext: Scalars['Boolean']['output'];
  /**
   * Re-run the AI extraction of a brand kit's profile from its website.
   * Requires authentication and MANAGE_BRANDS permission.
   */
  regenerateBrandKitProfile: BrandKitProfile;
  /** Per-scene edit of a finished multi-scene generation: regenerates only the changed/stale scenes (seam-pinned to keep the untouched neighbors valid) and restitches with the reused segments. Bills only the regenerated scenes' duration units. Creates a NEW parent operation — the source generation stays untouched. */
  regenerateMultiSceneScenes: Array<GeneratedVideoResult>;
  regenerateToken: RegenerateTokenPayload;
  /**
   * Reject an invitation to join a team.
   * Requires authentication.
   */
  rejectTeamInvitation: RejectTeamInvitationPayload;
  removeAiStudioResult: Scalars['Boolean']['output'];
  /**
   * Remove animation from a design.
   * Requires authentication.
   */
  removeAnimationFromDesign: JsonDesignWithHash;
  removeBg: RemoveBg;
  removeBgOnBoundedImage: RemoveBgOnBoundedImagePayload;
  removeBillingInfo: RemoveBillingInfoPayload;
  /**
   * Remove a source image from the brand kit's style analysis and trigger an
   * async re-evaluation of the visual style. No-op if the URL is not present.
   * Requires authentication and MANAGE_BRANDS permission.
   */
  removeBrandStyleSourceImage: BrandKit;
  removeBrandedResource: RemoveBrandedResourcePayload;
  removeColorFromPalette: ColorPalettePayload;
  removeCommentAttachment: RemoveCommentAttachmentResult;
  removeCustomSize: RemoveCustomSizePayload;
  /**
   * Remove a design from a design set.
   * Requires authentication and DESIGN permission on the design.
   */
  removeDesignFromSet: RemoveDesignFromSetPayload;
  /**
   * Remove media assets from a design's media library.
   * Requires authentication and DESIGN permission on the design.
   */
  removeDesignMediaFromLibrary: Scalars['Boolean']['output'];
  /** Remove a reviewer from a design. */
  removeDesignReviewer: Scalars['Boolean']['output'];
  removeDesignSizeType: RemoveDesignSizeTypePayload;
  /**
   * Removes the named sizes of a design, and on a master the same size types of every variation, as Ad Studio's sizes
   * panel does; a design keeps at least one size. Under editDesign's locks. Requires the DESIGN permission on the design.
   */
  removeDesignSizes: RemoveDesignSizesResult;
  /** Removes a dynamic variable from a design. */
  removeDynamicVar: RemoveDynamicVarPayload;
  /** Removes an external tracking URL from a design. */
  removeExternalTrackingUrl: RemoveExternalTrackingUrlPayload;
  /** Removes an ad network from a design's ad serving configuration. */
  removeNetworkAdServing: RemoveNetworkAdServingPayload;
  removeObject: GeneratedImageResult;
  /**
   * Remove a group from a project.
   * Requires authentication and MANAGE_PROJECTS permission on the project.
   */
  removeProjectGroup: RemoveProjectGroupPayload;
  /**
   * Remove a user from a project.
   * Requires authentication and MANAGE_PROJECTS permission on the project.
   */
  removeProjectUser: RemoveProjectUserPayload;
  removeTagContainerNetwork: RemoveAdTagNetworkPayload;
  removeTeamIdentityProvider: RemoveTeamIdentityProviderResponse;
  /**
   * Remove a user from a team.
   * Requires authentication and MANAGE_TEAMS permission on the team.
   */
  removeTeamUser: RemoveMemberPayload;
  /**
   * Remove a user group from a team.
   * Requires authentication and MANAGE_TEAMS permission on the team.
   */
  removeTeamUserGroup: RemoveTeamUserGroupPayload;
  /**
   * Remove a typography configuration from a brand kit.
   * Requires authentication and MANAGE_BRANDS permission.
   */
  removeTypography: Scalars['Boolean']['output'];
  /**
   * Remove a user from a group within a team.
   * Requires authentication and MANAGE_TEAMS permission on the team.
   */
  removeUserFromGroup: RemoveUserFromGroupPayload;
  /**
   * Soft-remove a whole variation (and its size children) — the Variations tab
   * undo of a duplicate. Paranoid delete of the master-linked top row; restorable
   * by restoreVariation with the same id/hash. Requires DESIGN permission on it.
   */
  removeVariation: RemoveVariationPayload;
  renameAbTest: AbTest;
  /**
   * Rename a brand kit.
   * Requires authentication and MANAGE_BRANDS permission.
   */
  renameBrandKit: RenameBrandKitPayload;
  /**
   * Rename brand target audience.
   * Requires authentication and MANAGE_BRANDS permission.
   */
  renameBrandTargetAudience: BrandTargetAudience;
  renameColorPalette: ColorPalettePayload;
  renameCopilotAiChat: RenameCopilotAiChatPayload;
  renameCustomSize: RenameCustomSizePayload;
  renameCustomTransition: CustomTransitionPayload;
  /**
   * Rename a design.
   * Requires authentication and DESIGN permission on the design.
   * Records this action in the project's recent activity.
   */
  renameDesign: RenameDesignPayload;
  renameDesignComponent: RenameDesignComponentPayload;
  /**
   * Rename a folder in a design's media library.
   * Requires authentication and DESIGN permission on the design.
   */
  renameDesignMediaFolder: DesignMediaFolder;
  renameDesignSizeType: RenameDesignSizeTypePayload;
  renameFolder: CreateFolderPayload;
  /**
   * Rename a media asset in a brand kit.
   * Updates the name of an existing media asset.
   */
  renameMedia: RenameMediaPayload;
  renameMediaFolder: RenameMediaFolderPayload;
  renameReport: RenameReportPayload;
  /**
   * Rename a client ID for a team's API access.
   * Requires authentication and VIEW permission on the team.
   */
  renameTeamClientId: TeamClientId;
  /**
   * Rename a typography configuration in a brand kit.
   * Requires authentication and MANAGE_BRANDS permission.
   */
  renameTypography: AddTypographyPayload;
  reorderPinnedFolderList: ReorderPinnedFolderListPayload;
  /**
   * Re-read a font's binary from S3 and refresh its parsed metric metadata.
   * Scoped to MANAGE_BRANDS on the brand kit that owns the font.
   */
  reparseFontMetrics: ReparseFontMetricsPayload;
  /**
   * Replace the copilot thread's brief-owned asset set iff the slot still
   * holds `expectedVersion` (compare-and-swap — no clock ordering). The
   * submitted order is the intent: first = product, rest = references; [] is
   * the explicit "deliberately none" state. `product` declares whether the
   * brief has a product at all (e.g. removing the featured image leaves the
   * rest as style references rather than promoting one); omitted, it is
   * derived from the submitted asset order — today's behaviour. A version
   * conflict answers `written: false` with the current slot instead of an
   * error. Supersedes `setBriefAssets`, which remains until clients migrate.
   */
  replaceBriefAssets: BriefAssetsWrite;
  reportAdStudioExperience: Scalars['Boolean']['output'];
  /** Request a confirmation code to verify the user's email. */
  requestConfirmationCode: RequestConfirmationCodePayload;
  /** Request to change the user's email address. */
  requestEmailChange: AccountChangePayload;
  /** Request to change the user's password. */
  requestPasswordChange: AccountChangePayload;
  /**
   * Import ONE product set of an on-demand Meta catalog — the Sets tab's Import
   * click. Asynchronous: it records the request as a product_set row (the row IS
   * the request, members IS NULL IS pending), flips the catalog to PROCESSING and
   * enqueues the rebuild that reads the set. Idempotent per set, and never a
   * no-op while a rebuild is already running. Only for an on-demand Meta catalog
   * — every other Meta catalog mirrors the whole catalog on every sync.
   */
  requestProductSetImport: RequestedProductSetImport;
  /**
   * Resend a team invitation.
   * Requires authentication and access to the team.
   */
  resendInvitation: ResendInvitationPayload;
  /** @deprecated Migration service has been removed */
  resendValidationCode: CheckValidCodePayload;
  reserveResizeApplyCredit: ReserveResizeApplyCreditPayload;
  /** Delete all threads for a design for the given Mastra agent (defaults to image creator) */
  resetAdStudioChat: Scalars['Boolean']['output'];
  /**
   * Reset sibling sizes back to the master size ("reset to main size"): each
   * target discards its own divergence and is rewritten to match the master
   * size on syncable paths. The inverse of pushMasterSizeChanges — the diff is
   * computed per target (target → source), so a size diverging from an
   * unchanged master size is still reverted. Geometry and per-size-scaled
   * properties stay per-size, and the resolved cross-size customisation records
   * are pruned. Requires DESIGN permission on the master.
   */
  resetSizesToMasterSize: ResetSizesToMasterSizePayload;
  /**
   * Reset a client ID for a team's API access.
   * Requires authentication and VIEW permission on the team.
   */
  resetTeamClientId: TeamClientId;
  /**
   * Create a new size inside a design set by cloning the matching size from
   * the set's source template. Matching is done by width and height of the
   * target designSizeTypeId. Returns null when no match is found so callers
   * can fall back to the regular resize flow.
   * Requires authentication and DESIGN permission on the design set.
   */
  resizeWithTemplate: ResizeWithTemplatePayload;
  restoreAbTest: RestoreAbTestPayload;
  /**
   * Restore a design from trash.
   * Requires authentication and DESIGN permission on the team.
   * Records this action in the project's recent activity.
   */
  restoreDesign: RestoreDesignPayload;
  /**
   * Restore a previously removed design to a design set.
   * Requires authentication and DESIGN permission on the design.
   */
  restoreDesignFromSet: RestoreDesignFromSetPayload;
  /**
   * Restore a project from trash.
   * Requires authentication and MANAGE_PROJECTS permission on the team.
   */
  restoreProject: RestoreProjectPayload;
  /**
   * Restore a variation removed by removeVariation (redo of a duplicate-undo, or
   * undo of a variation removal) — same id/hash. Requires DESIGN permission on it.
   */
  restoreVariation: RestoreVariationPayload;
  /**
   * Apply a declarative target state to a master's family — the Variations tab
   * undo/redo. Content is named by row checksum and resolved from the
   * persisted-version store; override records, master sync state, the
   * sizes-baseline pointer, the main-design choice and row liveness are written
   * verbatim. Every member is validated before anything is written, and the same
   * target applied twice is a no-op. Runs behind the master's sync lock.
   * Requires DESIGN permission on the master.
   */
  restoreVariationsFamilyState: RestoreVariationsFamilyStatePayload;
  /** Resume a paused subscription immediately */
  resumeSubscription: ResumeSubscriptionResult;
  /** Re-run a single failed AI image/video generation, faithfully reconstructing the original mutation input from the persisted AiOperation. Creates a NEW AiOperation (the old failed row is left untouched). */
  retryAiOperation: Array<GeneratedImageResult>;
  retryAiResizeVariant: Scalars['Boolean']['output'];
  /** Run the extraction again for a document. Requires MANAGE_BRANDS. */
  retryBrandKitDocumentImport: BrandKitDocument;
  /**
   * Manually trigger a re-evaluation of the visual style based on the brand
   * kit's current source images. Typically called after a previous attempt
   * errored out. Requires authentication and MANAGE_BRANDS permission.
   */
  retryBrandStyleEvaluation: BrandKit;
  retryJob: Scalars['Boolean']['output'];
  revertBgOnBoundedImage: RevertBgOnBoundedImagePayload;
  /** Delete a field override — the pristine source value shows through again */
  revertProductField: CatalogProduct;
  /**
   * Revoke a pending team invitation.
   * Requires authentication and MANAGE_TEAMS permission on the team.
   */
  revokeInvitation: RevokeInvitationPayload;
  runCustomWorkflow?: Maybe<RunCustomWorkflowResponse>;
  runWorkflow?: Maybe<RunWorkflowResponse>;
  /** Persists the team's Adobe Asset Selector MFE config (create or update). */
  saveAssetSelectorConfig: Scalars['Boolean']['output'];
  /**
   * Save JSON data for a brand kit.
   * Requires authentication and MANAGE_BRANDS permission.
   * @deprecated Use saveBrandKitJsonV2 instead
   */
  saveBrandKitJson: Scalars['BrandKitJson']['output'];
  saveBrandKitJsonV2: SaveBrandKitJsonV2Payload;
  saveCatalogVariationDesigns: SaveCatalogVariationDesignsPayload;
  /** Saves the team's Cloudinary cloud name, replacing any saved one. A different cloud (not just a change of case) resets the default folder to the root. Refused when the team's plan doesn't include Cloudinary (PLAN_FEATURE_REFUSED). */
  saveCloudinaryConfig: CloudinaryConfig;
  saveCopilotAiChatMessageAdditionalFeedback: Scalars['Boolean']['output'];
  saveCopilotAiChatMessageFeedback: SaveCopilotAiChatMessageFeedbackPayload;
  /**
   * Save the document the Copilot read in this thread into the design's brand kit (CURRENT)
   * or into a new kit in the design's team (NEW), overwriting the named fields (all when
   * omitted). Values come from the thread, never from the request. Requires MANAGE_BRANDS
   * on the kit (CURRENT) or the design's team (NEW), checked in the service. Errors:
   * NO_DOCUMENT_READ, NO_BRAND_KIT, BRAND_KIT_CHANGED, NOTHING_TO_SAVE (the save would change
   * nothing, so no kit is created or written), FORBIDDEN. With source WEBSITE the values come
   * from the chat's active website draft (NO_DOCUMENT_READ when it has none; BRAND_KIT_CHANGED when
   * it is not the extractionId the preview showed; EXTRACTION_RUNNING while the site is still being
   * read); NEW is refused with USE_PROMOTE, since a draft becomes a kit through
   * promoteCopilotBrandExtraction.
   */
  saveCopilotDocumentToBrandKit: SavedCopilotDocumentToBrandKit;
  saveCustomTransition: CustomTransitionPayload;
  saveDesignFeedAdjustment?: Maybe<DesignFeedAdjustmentInfo>;
  saveDesignsJsonsForLater: SaveDesignsJsonForLaterPayload;
  saveFeedInterval?: Maybe<DownloadFeedInterval>;
  savePlatformAd: PlatformAd;
  saveQuestionBg: Scalars['Boolean']['output'];
  saveReport: SaveReportPayload;
  saveSetHashes: Scalars['Boolean']['output'];
  /** @deprecated Change Object feature has been removed. This mutation is no longer functional. */
  searchAndReplace: Array<GeneratedImageResult>;
  /** @deprecated Migration service has been removed */
  selectMigrationAccount: Scalars['Boolean']['output'];
  selectVeevaVault: LoginVeevaResponse;
  sendBookACallContext: Scalars['Boolean']['output'];
  sendGclid: Scalars['Boolean']['output'];
  sendHtmlReportToEmail: Scalars['Boolean']['output'];
  sendMessageToSlackChannel: SendMessageToSlackChannelResult;
  /** Send a message in the ads library chat and get AI response */
  sendMyAdsLibraryMessage: SendMyMessageResponse;
  sendReferralLP: Scalars['Boolean']['output'];
  /** Send a test email */
  sendTestEmail: SendTestEmailPayload;
  sendTopUpCreditsEmail: Scalars['Boolean']['output'];
  sendUsageRestrictionAdminNotification: Scalars['Boolean']['output'];
  sendUtk: Scalars['Boolean']['output'];
  sendUtms: Scalars['Boolean']['output'];
  /** Update the Studio Assistant chat mode (Edit / Read) for a thread (optional agentId; defaults to the Helper agent) */
  setAdStudioThreadChatMode: Scalars['Boolean']['output'];
  /** Set an anonymous identifier for the authenticated user. */
  setAnonymousId: Scalars['Boolean']['output'];
  /**
   * Set a media asset as the brand kit logo.
   * Designates an existing media asset as the logo for a brand kit.
   */
  setBrandKitLogo: Media;
  /**
   * Save the brand profile for a brand kit.
   * Requires authentication and MANAGE_BRANDS permission.
   */
  setBrandKitProfile: BrandKitProfile;
  /**
   * Set visual style settings for a brand kit.
   * Requires authentication and MANAGE_BRANDS permission.
   */
  setBrandKitVisualStyle: BrandKitVisualStyle;
  /**
   * Set voice and tone settings for a brand kit.
   * Requires authentication and MANAGE_BRANDS permission.
   */
  setBrandKitVoiceAndTone: BrandKitVoiceAndTone;
  setBrandedColor: SetBrandedColorPayload;
  setBrandedDomain: SetBrandedDomainPayload;
  setBrandedEmail: SetBrandedEmailPayload;
  setBrandedFavicon: SetBrandedFaviconPayload;
  setBrandedLogo: SetBrandedLogoPayload;
  /**
   * Replace a copilot thread's brief-owned asset set (the living brief card's
   * edit path). The submitted order is the intent: the first asset becomes
   * the product (the engine's preserved base), the rest become style
   * references; an empty list is the explicit "deliberately none" state.
   * Returns the normalized set that was persisted.
   */
  setBriefAssets: Array<ChatBriefAsset>;
  /** Favorite / unfavorite a catalog for the current user (CRE-451) — per-user state, read access is enough */
  setCatalogFavorite: SetCatalogFavoritePayload;
  /** Sets the folder Save to Cloudinary files the team's exports in. Refused when the team's plan doesn't include Cloudinary (PLAN_FEATURE_REFUSED) or no cloud name is saved. */
  setCloudinaryDefaultFolder: CloudinaryConfig;
  /**
   * Puts a font on the draft's typography slots for the roles a missing brand font was meant for (MANAGE_BRANDS
   * on the draft's team). A name that is no longer missing is a no-op. Refused with EXTRACTION_RUNNING until
   * canFixFonts, BRAND_KIT_CHANGED once the extraction is not the chat's active one, NO_FONT_TO_USE without a
   * font linked to the draft, and FONT_NOT_LOADABLE for a Google font the editor cannot load by name.
   */
  setCopilotBrandExtractionFont: CopilotBrandExtraction;
  setDefaultGoogleAdsIntegrationAccount: Scalars['Boolean']['output'];
  setDefaultMetaIntegrationAccount: Scalars['Boolean']['output'];
  setDesignFeedRow: Scalars['Int']['output'];
  /** @deprecated Use setDesignPresetV2 instead */
  setDesignPreset: DownloadPreset;
  setDesignPresetV2: DownloadPresetV2;
  setEmailPreferences?: Maybe<EmailPreferences>;
  /**
   * Mark a project as favorite or remove favorite status.
   * Requires authentication and access to the project.
   */
  setFavoriteProject: SetFavoriteProjectPayload;
  /**
   * Set a team as favorite or remove favorite status.
   * Requires authentication and access to the team.
   */
  setFavouriteTeam: FavouriteTeamPayload;
  setFeedColumnSmartCropEnabled: SetFeedColumnSmartCropEnabledPayload;
  setFeedRowSmartCropReviewed: SetSmartCropOnFeedRowPayload;
  /**
   * Toggle whether @font-face metric overrides are emitted for this font variant.
   * Scoped to MANAGE_BRANDS on the brand kit that owns the font.
   */
  setFontMetricsOverrideDisabled: Font;
  /** Toggle Feature B auto-sync on the design's latest feed-batch Meta publication. Returns the new value. */
  setMetaPublicationAutoSync: Scalars['Boolean']['output'];
  /** @deprecated Migration service has been removed */
  setMigrationStep: Scalars['Boolean']['output'];
  setPageTitle: SetPageTitlePayload;
  /**
   * Set a project's logo.
   * Requires authentication and MANAGE_PROJECTS permission on the project.
   * Records this action in the project's recent activity.
   */
  setProjectLogo: SetProjectLogoPayload;
  setRole: TeamRole;
  setSharePointDefaultLocation: Scalars['Boolean']['output'];
  setSmartCropOnFeedRow: SetSmartCropOnFeedRowPayload;
  /** Enable (create, idempotent) or disable (delete) a smart set (CRE-417); returns the set when enabling */
  setSmartSetEnabled?: Maybe<ProductSet>;
  /**
   * Set a logo for a team.
   * Requires authentication and MANAGE_TEAMS permission on the team.
   */
  setTeamLogo: SetTeamLogoPayload;
  /** Enable or disable two-factor authentication for the user. */
  setTwoFactor: Scalars['Boolean']['output'];
  /**
   * Set typography options for a brand kit.
   * Requires authentication and MANAGE_BRANDS permission.
   */
  setTypographyOptions: SetTypographyOptionsPayload;
  /** Update the user's name. */
  setUserName: User;
  /** Update the user's profile picture. */
  setUserProfilePicture: User;
  /**
   * Promote a variation to be its family's master (Variations tab "Set as
   * master"): the current master is demoted to a variation of it and every
   * sibling variation is re-homed onto it. Re-parents the masterSetId FK
   * pointers, recomputes each demoted member's sync state against the new
   * master, and relabels languages. Requires DESIGN permission on the variation.
   */
  setVariationAsMaster: SetVariationAsMasterPayload;
  setVeevaOptions: VeevaOptionsResponse;
  settleResizeApplyCredit: Scalars['Boolean']['output'];
  /**
   * Share a design with users or groups.
   * Requires authentication and access to the design.
   */
  shareDesign: ShareDesignPayload;
  shareFolder: ShareFolderPayload;
  shareFoldersAndDesigns: ShareFoldersAndDesignsPayload;
  /**
   * Signs a browser upload of one .fig file into private storage and issues its import key. Every later .fig call
   * must come from the same user and team. Refused outside the fig_file_import gate or without Figma access.
   */
  signFigFileUploadUrl: FigFileUploadUrl;
  signShareUploadUrl: SignShareUploadUrlResult;
  signTempUploadUrl: SignUploadUrlResult;
  signUploadUrl: SignUploadUrlResult;
  /**
   * Smart-crop (Vision ROI) a batch of banners and return them re-framed.
   * Used by the resize picker to preview Smart / AI cards with the same crop
   * the apply step produces. The caller supplies the banner JSON it already
   * holds, so only authentication is required (no per-design access check).
   */
  smartCropBanners: SmartCropBannersPayload;
  solveComment: SolveCommentResult;
  startAiAgentAutomationSchedule: Scalars['Boolean']['output'];
  startAiResizeVariants: StartAiResizeVariantsPayload;
  startAutoCutVideo: GeneratedImageResult;
  startCaptionGeneration: GeneratedImageResult;
  /** Starts connecting the signed-in user's own Cloudinary login to the team's cloud: returns the sign-in URL to open in a popup. Refused when the team's plan doesn't include Cloudinary or no cloud name is saved. */
  startCloudinaryConnection: CloudinaryConnectionStart;
  /** @deprecated Use startGenerateBackgroundBria instead. This mutation is no longer functional. */
  startGenerateBackground: GeneratedImageResult;
  startGenerateBackgroundBria: Array<GeneratedImageResult>;
  startGenerateFromContent: GeneratedImageResult;
  startGenerateFromLineart: Array<GeneratedImageResult>;
  startImageGenerationFromPrompt: Array<GeneratedImageResult>;
  startImageUpscale: GeneratedImageResult;
  /** Start a layered ad on a design the signed-in user may edit, as the Ad Studio Copilot makes them: a painted background, the attached product kept as it is, the copy as real text and the brand kit's logo. The team, brand kit, brand style and image links come from the design and the team's library; refused before anything is written for a design with no brand kit, a team on the legacy credits, a plan without product photography or a balance that cannot pay the background image. Poll checkAiOperations with the returned id. */
  startLayeredAd: Array<LayeredAdOperationResult>;
  /** Start a new ads library chat session, replacing any existing session for the same competitor */
  startNewAdsLibraryChat: Scalars['Boolean']['output'];
  startRecomposeResize: RecomposeResizeOperation;
  startRemoveVideoBackground: GeneratedImageResult;
  startReplaceVideoBackground: GeneratedImageResult;
  /**
   * Copilot video dubbing: the source video's speech transcribed, translated into one language
   * and spoken again with a Gemini voice over the source's background, muxed onto the source
   * picture. Filed as a VIDEO generation of the Copilot chat (poll with checkAiOperations; the
   * result's mediaHashes[0] is the dubbed video). Gated by the ai_video_dubbing Statsig gate.
   * Not billed.
   */
  startVideoDubbing: Array<GeneratedVideoResult>;
  startVideoGenerationFromPrompt: Array<GeneratedVideoResult>;
  /**
   * AI voiceover: Gemini TTS narration of a script, finished as an audio media row
   * (poll with checkAiOperations; the result's mediaHashes[0] is the audio).
   * Gated by the ai_voiceover Statsig gate; one AI media credit per clip.
   */
  startVoiceoverGeneration: GeneratedImageResult;
  stopAiAgentAutomationSchedule: Scalars['Boolean']['output'];
  subscribeToHubspot: Scalars['Boolean']['output'];
  /**
   * @deprecated Use publishDpaCatalog instead
   * @deprecated syncDpaCatalog mutation has been removed
   */
  syncDpaCatalog: SyncDpaCatalogResponse;
  syncDpaCatalogWithDesign: SyncDpaCatalogWithDesignResponse;
  syncFeed?: Maybe<SyncFeed>;
  syncTagContainerAdTagNetworks: AdTagSyncPayload;
  /** Re-publishes the design's TikTok catalog with the settings its row saved (Sync design on an out-of-date catalog), bound like publishTikTokCatalog; answers with the Meta sync's shape. */
  syncTikTokCatalogWithDesign: SyncDpaCatalogWithDesignResponse;
  /**
   * Sync the given variations from their master (docs/adstudio-variations-master-sync.md):
   * each variation size becomes the paired master size's content overlaid with
   * everything the variation has diverged on (its recorded overrides), so
   * variation edits are never overwritten. Sizes without a recorded override
   * set are skipped conservatively. Requires DESIGN permission on the master.
   */
  syncVariationsFromMaster: SyncVariationsFromMasterPayload;
  /** Tag products; returns the number of (valid) products tagged */
  tagCatalogProducts: Scalars['Int']['output'];
  /** Test connection: checks the signed-in admin's own Cloudinary connection against the team's cloud and default folder with one folder list. Refused like listCloudinaryFolders; a missing default folder is reported, not refused. */
  testCloudinaryConnection: CloudinaryConnectionTest;
  /**
   * Translates text in the supplied design JSON with the team's
   * language-variation translator and returns the layer patches. layerIds
   * limits the translation to those elements; omitted, every editable text
   * layer is translated. Does not create a variation and does not save the
   * design — the light editor applies the patches itself.
   */
  translateLightEditorCopy: TranslateLightEditorCopyPayload;
  /**
   * Trim a video to an in/out window.
   * Produces a NEW mp4 file (ffmpeg re-encode) and returns its URL — the source file is untouched.
   */
  trimVideo: TrimVideoResult;
  /**
   * Remove sharing of a design from a user or group.
   * Requires authentication and access to the design.
   */
  unShareDesign: UnShareDesignPayload;
  unShareFolder: UnShareFolderPayload;
  undoDeleteFolder: UndoDeleteFolderPayload;
  unlinkBusinessAccount: UnlinkBusinessAccountResponse;
  unpinFolder: UnpinFolderPayload;
  unsubscribeFromHubspot: Scalars['Boolean']['output'];
  /** Remove a tag from products; returns the number of tag rows removed */
  untagCatalogProducts: Scalars['Int']['output'];
  updateAccessToken: RefreshTokenPayload;
  /**
   * Update ad serving access for a team.
   * Requires authentication and MANAGE_TEAMS permission on the team.
   */
  updateAdServingAccess: Scalars['Boolean']['output'];
  /** Updates the ad serving code for a design, usually triggered by a sync reason. */
  updateAdServingCode: UpdateAdServingCodePayload;
  /** Updates the ad serving settings for a design. */
  updateAdServingSettings: UpdateAdServingSettingsPayload;
  /** Rename a Studio Assistant thread title (optional agentId; defaults to the Helper agent) */
  updateAdStudioThreadTitle: Scalars['Boolean']['output'];
  updateAutomatedReportPublicStatus: CopilotPublicHashPayload;
  /** Update team billing info */
  updateBillingInfo: UpdateBillingActionResult;
  /** @BreakingBad */
  updateBrandCompetitor: BrandCompetitor;
  /**
   * Update the details of a brand kit.
   * Requires authentication and MANAGE_BRANDS permission.
   */
  updateBrandDetails: UpdateBrandDetailsPayload;
  /**
   * Update AI generation rules for a brand kit.
   * Requires authentication and MANAGE_BRANDS permission.
   */
  updateBrandKitAIGenerationRules: UpdateBrandDetailsPayload;
  updateBrandKitButton: BrandKitButton;
  /**
   * Update brand target audience.
   * Requires authentication and MANAGE_BRANDS permission.
   */
  updateBrandTargetAudience: BrandTargetAudience;
  /** Update name / sync schedule / target-ID column (CRE-420) — currency stays display-only (D20) */
  updateCatalogSettings: Catalog;
  updateColorPalette: ColorPalettePayload;
  updateColorPaletteOrder: Array<ColorPalette>;
  updateComment: Comment;
  updateCopilotAiChatPublicStatus: CopilotPublicHashPayload;
  updateCopilotAiReportPublicStatus: CopilotPublicHashPayload;
  /** Updates an existing custom ad network for a team. */
  updateCustomAdNetwork: AdNetwork;
  /**
   * Update a design's content.
   * Requires authentication and DESIGN permission on the design.
   * Records this action in the project's recent activity.
   */
  updateDesign: UpdateDesignPayload;
  /**
   * Change a design's approval status.
   * Requires DESIGN or APPROVE permission depending on the transition.
   */
  updateDesignApprovalStatus: UpdateDesignApprovalStatusPayload;
  /**
   * Update HTML export settings for a design.
   * Requires authentication and access to the design.
   */
  updateDesignHtmlSettings: UpdateDesignHtmlSettingsPayload;
  /**
   * Set which size child of a design SET hydrates as its main design in the
   * new Ad Studio single-design mode.
   */
  updateDesignMainDesign: UpdateDesignPayload;
  updateDesignMeasureUnit: UpdateDesignPayload;
  /**
   * Update a design set.
   * Requires authentication and DESIGN permission on the design.
   * Records this action in the project's recent activity.
   */
  updateDesignSet: UpdateDesignSetPayload;
  /**
   * Update a design's size type ID.
   * Requires authentication and DESIGN permission on the design.
   * Records this action in the project's recent activity.
   */
  updateDesignSizeTypeId: UpdateDesignPayload;
  /**
   * Update multiple designs in a batch.
   * Requires authentication. Access control to be implemented.
   */
  updateDesigns: UpdateDesignsPayload;
  updateDpaSettings: DpaSettings;
  /**
   * Update trial extension experiment status for a team.
   * Requires authentication and VIEW permission on the team.
   * @deprecated Not used
   */
  updateExtendTrial: Scalars['Boolean']['output'];
  updateFacebookDpaSettings: DpaSettings;
  updateFeed: Feed;
  updateFeedColumn: FeedColumn;
  updateFeedRow: Feed;
  updateMoodBoard: MoodBoard;
  updateMoodBoardComment: MoodBoardComment;
  updateMoodBoardCommentThread: MoodBoardCommentThread;
  updateMoodBoardContent: MoodBoard;
  updateMoodBoardShare: MoodBoardShare;
  updateNextgenAi: NextgenAi;
  /**
   * Update onboarding flows experiment status for a team.
   * Requires authentication and VIEW permission on the team.
   */
  updateOnboardingFlows: Scalars['Boolean']['output'];
  /**
   * Update the user's assignment in the onboarding flows trial experiment.
   * @deprecated Not used
   */
  updateOnboardingFlowsTrial: Scalars['Boolean']['output'];
  /** Update the Pinterest-family dpa_settings row (e.g. turn off auto-sync). Scoped to the pinterest family by the resolver so it never affects the meta row. */
  updatePinterestDpaSettings: DpaSettings;
  /** Update a set's name/rules/members — smart sets accept a name change only (worker-owned data) */
  updateProductSet: ProductSet;
  /**
   * Update a project's properties.
   * Requires authentication and MANAGE_PROJECTS permission on the project.
   * Records this action in the project's recent activity.
   */
  updateProject: ProjectPayload;
  /**
   * Enable, disable, or configure the design approval workflow for a project.
   * Requires MANAGE_PROJECTS permission.
   */
  updateProjectApprovalConfig: UpdateProjectApprovalConfigPayload;
  updatePublicBillingInfo: UpdateBillingActionResult;
  /** Update resource public status */
  updateResourceStatus: UpdateResourceStatusPayload;
  /**
   * Update whether comments are enabled on shared links for a team.
   * Requires authentication and MANAGE_TEAMS permission on the team.
   */
  updateShareLinkCommentsEnabled: UpdateShareLinkCommentsEnabledPayload;
  /**
   * Update whether downloads are enabled on shared links for a team.
   * Requires authentication and MANAGE_TEAMS permission on the team.
   */
  updateShareLinkDownloadEnabled: Scalars['Boolean']['output'];
  /** Save the Share panel's variation selection for this design's public link */
  updateShareVariationSelection: UpdateShareVariationSelectionPayload;
  /**
   * Set the number of paid seats on a V0/V1 subscription.
   * Requires authentication and MANAGE_TEAMS permission on the team.
   */
  updateSubscriptionSeats: UpdateSubscriptionSeatsPayload;
  updateSubscriptionV2: UpdateSubscriptionResult;
  /** Updates the status of a system ad network for a specific team. */
  updateSystemAdNetwork: AdNetwork;
  updateTagContainerAdTagSettings: TagContainer;
  /**
   * Update team properties.
   * Requires authentication and MANAGE_TEAMS permission on the team.
   */
  updateTeam: TeamCreatePayload;
  /**
   * Update a team's design debug status.
   * Requires authentication and MANAGE_TEAMS permission on the team.
   */
  updateTeamDesignDebugStatus: CloneDesignStatus;
  updateTeamIdentityProvider: TeamIdentityProviderUpdate;
  /**
   * PLA-463. Writes the SSO auto-join configuration for a team. Kept separate
   * from updateTeamIdentityProvider, which is a passthrough for Keycloak
   * connection settings — this is app-side policy and can be refused.
   */
  updateTeamIdentityProviderAutoJoin: TeamIdentityProviderAutoJoin;
  updateTeamIdentityProviderDomains: UpdateTeamIdentityProviderDomainsResult;
  /**
   * Update a pending team invitation.
   * Requires authentication and MANAGE_TEAMS permission on the team.
   */
  updateTeamInvitation: UpdateTeamInvitationPayload;
  /**
   * Update a user group within a team.
   * Requires authentication and MANAGE_TEAMS permission on the team.
   */
  updateTeamUserGroup: UpdateTeamUserGroupPayload;
  /** Update the TikTok-family dpa_settings row (e.g. turn off auto-sync). Scoped to the tiktok family by the resolver so it never affects the meta or pinterest row; the design's own team must be the authorized one. */
  updateTikTokDpaSettings: DpaSettings;
  updateUseNewAdStudio: ChangeBrandControlOptionPayload;
  /** Update the user's onboarding preferences. */
  updateUserOnboarding: UserOnboardingPayload;
  updateUserSettings: Scalars['Boolean']['output'];
  /**
   * Update a design version name.
   * Requires authentication and DESIGN permission on the design.
   */
  updateVersionName: UpdateVersionNamePayload;
  updateWorkflow?: Maybe<Workflow>;
  /**
   * Upload a logo to a brand kit.
   * Adds a new logo to a brand kit after it has been uploaded.
   */
  uploadBrandKitLogo: UploadBrandKitLogoPayload;
  uploadCommentAttachment: UploadCommentAttachmentResult;
  /**
   * Upload a new font to a brand kit.
   * Permanently stores a font for use in designs.
   */
  uploadFont: UploadFontPayload;
  uploadNextGenLogo: NextGenLogoSource;
  uploadNextGenMedia: NextGenMediaFile;
  uploadToGoogleDrive: UploadToGoogleDriveResult;
  uploadToSharePoint: UploadToSharePointResult;
  /** Upserts (inserts or updates) dynamic variables for a design. */
  upsertDynamicVars: UpsertDynamicVarsPayload;
  /** Upserts (inserts or updates) external tracking URLs for a design. */
  upsertExternalTrackingUrls: UpsertExternalTrackingUrlPayload;
  validateCancellationReason: CancellationReasonValidationResult;
  /**
   * Start the designed-text check (is the image a finished design with typeset text?) for images attached
   * to the Copilot, so a later turn can read the stored answer. Returns at once: false when the feature is
   * off for the team, otherwise true, whether or not some images were skipped.
   */
  warmDesignedTextChecks: Scalars['Boolean']['output'];
};


export type MutationAcceptTeamInvitationArgs = {
  input: InputAcceptTeamInvitation;
};


export type MutationActivateAddonArgs = {
  input: InputActivateAddon;
};


export type MutationActivateTagContainerAdTagArgs = {
  input: InputTagContainer;
};


export type MutationActivateWinBackTrialArgs = {
  input: InputActivateWinBackTrial;
};


export type MutationAdServingSendCodeViaEmailArgs = {
  input: InputAdServingSendCodeViaEmail;
};


export type MutationAdTagAddNetworkArgs = {
  input: InputUpdateNetwork;
};


export type MutationAdTagContactMeArgs = {
  input: InputAdTagContactMe;
};


export type MutationAdTagDisableArgs = {
  input: InputDesignAdTag;
};


export type MutationAdTagDisableAbTestArgs = {
  input: InputAbTest;
};


export type MutationAdTagEnableArgs = {
  input: InputDesignAdTag;
};


export type MutationAdTagEnableAbTestArgs = {
  input: InputAbTest;
};


export type MutationAdTagFeatureActivateArgs = {
  input: InputAdTagFeatureState;
};


export type MutationAdTagFeatureDeactivateArgs = {
  input: InputAdTagFeatureState;
};


export type MutationAdTagRemoveNetworkArgs = {
  input: InputUpdateNetwork;
};


export type MutationAdTagSyncArgs = {
  input: InputDesignAdTag;
};


export type MutationAdTagSyncAbTestArgs = {
  input: InputAbTest;
};


export type MutationAdTagUpdateDynamicVarsArgs = {
  input: InputUpdateAdTagDynamicVars;
};


export type MutationAdTagUpdateExternalDesignTrackingArgs = {
  input: InputUpdateAdTagExternalDesignTracking;
};


export type MutationAdTagUpdateSettingsArgs = {
  input: InputUpdateAdTagSettings;
};


export type MutationAddAiResizeVariantArgs = {
  input: InputAddAiResizeVariant;
};


export type MutationAddBrandStyleSourceImagesArgs = {
  input: InputAddBrandStyleSourceImages;
};


export type MutationAddCardToMoodBoardArgs = {
  input: AddCardToMoodBoardInput;
};


export type MutationAddColorToPaletteArgs = {
  input: InputAddColorToPalette;
};


export type MutationAddCustomAdNetworkArgs = {
  input: InputAddCustomAdNetwork;
};


export type MutationAddCustomSizeArgs = {
  input: InputAddCustomSize;
};


export type MutationAddDesignMediaToLibraryArgs = {
  input: InputAddDesignMediaToLibrary;
};


export type MutationAddDesignReviewersArgs = {
  input: InputAddDesignReviewers;
};


export type MutationAddDesignSetSizeTypeArgs = {
  input: InputAddDesignSetSizeType;
};


export type MutationAddDesignSizeTypeArgs = {
  input: InputAddDesignSizeType;
};


export type MutationAddDesignSizesArgs = {
  input: InputAddDesignSizes;
};


export type MutationAddDesignToTemplatesArgs = {
  input: InputAddDesignToTemplates;
};


export type MutationAddFolderToBrandTemplateArgs = {
  input: InputAddFolderToBrandTemplate;
};


export type MutationAddFolderToTemplatesArgs = {
  input: InputAddFolderToTemplates;
};


export type MutationAddFontsFromUrlArgs = {
  input: InputAddFontsFromUrl;
};


export type MutationAddLogosFromUrlArgs = {
  input: InputAddLogosFromUrl;
};


export type MutationAddNetworkAdServingArgs = {
  input: InputAddNetworkAdServing;
};


export type MutationAddNewDesignToSetArgs = {
  input: InputAddNewDesignToSet;
};


export type MutationAddNewFeedColumnArgs = {
  input: InputAddNewFeedColumn;
};


export type MutationAddNewValueToUserOnboardingArgs = {
  input: InputAddNewValueToUserOnboarding;
};


export type MutationAddProjectGroupArgs = {
  input: InputAddProjectGroup;
};


export type MutationAddProjectUserArgs = {
  input: InputAddProjectUser;
};


export type MutationAddTagContainerNetworkArgs = {
  input: InputUpdateTagContainerNetwork;
};


export type MutationAddTeamToPaymentExperimentArgs = {
  input: InputAddTeamToPaymentExperiment;
};


export type MutationAddTextInsightToMoodBoardArgs = {
  input: AddTextInsightToMoodBoardInput;
};


export type MutationAddToBrandTemplateArgs = {
  input: InputAddToBrandTemplate;
};


export type MutationAddToPinnedFoldersArgs = {
  input: InputAddPinnedFolder;
};


export type MutationAddToRecentFoldersArgs = {
  input: InputFolder;
};


export type MutationAddTypographyArgs = {
  input: InputAddTypography;
};


export type MutationAddUrlDataToBrandKitArgs = {
  input: InputAddUrlDataToBrandKit;
};


export type MutationAddUserToGroupArgs = {
  input: InputAddUserToGroup;
};


export type MutationAdoptAiStudioGenerationChatThreadArgs = {
  input: InputAdoptAiStudioGenerationChatThread;
};


export type MutationAdvanceMasterSizesSyncBaselineArgs = {
  input: InputDesign;
};


export type MutationAiResizeArgs = {
  input: InputAiResize;
};


export type MutationAiResizeDesignArgs = {
  input: InputAiResize;
};


export type MutationAiResizeDesignWithHtmlArgs = {
  input: InputAiResizeWithHtml;
};


export type MutationApplyAiResizeVariantArgs = {
  input: InputApplyAiResizeVariant;
};


export type MutationApplyDesignLintFixesArgs = {
  input: InputApplyDesignLintFixes;
};


export type MutationApproveMotionDraftArgs = {
  input: InputDecideMotionDraft;
};


export type MutationApproveTeamInvitationArgs = {
  input: InputApproveTeamInvitaion;
};


export type MutationAssignDesignBrandKitArgs = {
  input: InputAssignDesignBrandKit;
};


export type MutationAssignDesignDefaultBrandKitArgs = {
  input: InputAssignDesignDefaultBrandKit;
};


export type MutationAssignUserRoleArgs = {
  input: InputAssignUserRole;
};


export type MutationAssureDesignJsonIsSavedArgs = {
  input: InputAssureDesignJsonIsSaved;
};


export type MutationAttachFeedArgs = {
  input: InputAttachFeed;
};


export type MutationAuthForgotPasswordArgs = {
  input: AuthForgotPasswordInput;
};


export type MutationAuthLoginArgs = {
  input: AuthLoginInput;
};


export type MutationAuthRegisterArgs = {
  input: AuthRegisterInput;
};


export type MutationAuthenticateWithTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationAutoconfigTeamIdentityProviderArgs = {
  input: InputAutoconfigTeamIdentityProvider;
};


export type MutationAutomateCopilotAiReportArgs = {
  input: InputAutomateCopilotAiReport;
};


export type MutationBlurBgArgs = {
  input: InputBlurBg;
};


export type MutationBulkDeleteAiAgentReportsArgs = {
  input: InputBulkDeleteAiAgentReports;
};


export type MutationBulkRemoveBgFeedArgs = {
  input: InputBulkRemoveBgFeed;
};


export type MutationBulkRevertBgFeedArgs = {
  input: InputBulkRevertBgFeed;
};


export type MutationBulkSmartCropFeedArgs = {
  input: InputBulkSmartCropFeed;
};


export type MutationCancelActiveJobArgs = {
  input: CancelActiveJobInput;
};


export type MutationCancelAiResizeArgs = {
  input: InputCancelAiResize;
};


export type MutationCancelBsSubscriptionArgs = {
  input: InputCancelBsSubscription;
};


export type MutationCancelLayeredAdArgs = {
  input: InputCancelLayeredAd;
};


export type MutationCancelSubscriptionArgs = {
  input: InputCancelSubscription;
};


export type MutationCancelWorkflowArgs = {
  input: InputCancelWorkflow;
};


export type MutationChangeAbTestEndingTypeArgs = {
  input: InputChangeAbTestEndingType;
};


export type MutationChangeBrandControlOptionArgs = {
  input: InputChangeBrandControlOption;
};


export type MutationChangeDesignFeedRowArgs = {
  input: InputChangeDesignFeedRow;
};


export type MutationChangeDesignProductSetArgs = {
  input: InputChangeDesignProductSet;
};


export type MutationChangeOwnerArgs = {
  input: InputChangeOwner;
};


export type MutationChangeVideoSpeedArgs = {
  input: InputChangeVideoSpeed;
};


export type MutationCheckFeedFieldsArgs = {
  input: CheckFeedFieldsInput;
};


export type MutationClaimAiStudioGenerationAnnouncementArgs = {
  input: InputClaimAiStudioGenerationAnnouncement;
};


export type MutationClaimAiStudioGenerationApplyArgs = {
  input: InputClaimAiStudioGenerationApply;
};


export type MutationClaimExperimentCreditsArgs = {
  input: InputClaimExperimentCredits;
};


export type MutationCompleteAiResizedSizeArgs = {
  input: InputCompleteAiResizedSize;
};


export type MutationCompleteCloudinaryConnectionArgs = {
  input: InputCompleteCloudinaryConnection;
};


export type MutationConfirmEmailArgs = {
  input: InputConfirmEmail;
};


export type MutationConfirmEmailChangeArgs = {
  input: InputConfirmEmailChange;
};


export type MutationConnectCatalogToDesignArgs = {
  input: InputConnectCatalogToDesign;
};


export type MutationConsumeNextgenFlowCreditsArgs = {
  input: InputConsumeNextgenFlowCredits;
};


export type MutationContinueAbTestArgs = {
  input: InputContinueAbTest;
};


export type MutationConvertHtmlToJsonArgs = {
  input: ConvertHtmlToJsonInput;
};


export type MutationConvertSingleDesignToSetArgs = {
  input: InputConvertSingleDesignToSet;
};


export type MutationConvertTrialSubscriptionArgs = {
  input: InputConvertTrialSubscription;
};


export type MutationCopySampleAdDesignsArgs = {
  input: InputCopySampleAdDesigns;
};


export type MutationCreateAbTestArgs = {
  input: InputCreateAbTest;
};


export type MutationCreateAiFlowCreatorChatArgs = {
  input: CreateAiFlowCreatorChatInput;
};


export type MutationCreateAppIntegrationArgs = {
  input: InputCreateAppIntegration;
};


export type MutationCreateAssetsNextgenAiArgs = {
  input: InputCreateAssetsNextgenAi;
};


export type MutationCreateBrandCompetitorArgs = {
  input: CreateBrandCompetitorInput;
};


export type MutationCreateBrandKitArgs = {
  input: InputCreateBrandKit;
};


export type MutationCreateBrandKitButtonArgs = {
  input: InputCreateBrandKitButton;
};


export type MutationCreateBrandTargetAudienceArgs = {
  input: InputCreateBrandTargetAudience;
};


export type MutationCreateBrandTemplateArgs = {
  input: InputCreateBrandTemplate;
};


export type MutationCreateBrandTemplateSetArgs = {
  input: InputCreateBrandTemplateSet;
};


export type MutationCreateBulkDesignsArgs = {
  input: InputCreateBulkDesigns;
};


export type MutationCreateCloudIntegrationArgs = {
  input: InputCreateCloudIntegration;
};


export type MutationCreateColorPaletteArgs = {
  input: InputCreateColorPalette;
};


export type MutationCreateCommentArgs = {
  input: InputCreateComment;
};


export type MutationCreateDemoMoodBoardArgs = {
  input: InputCreateDemoMoodBoard;
};


export type MutationCreateDesignArgs = {
  input: InputCreateDesign;
};


export type MutationCreateDesignComponentArgs = {
  input: InputCreateDesignComponent;
};


export type MutationCreateDesignFromGettingStartedArgs = {
  input: InputCreateDesignFromGettingStarted;
};


export type MutationCreateDesignFromImageJsonArgs = {
  input: InputCreateDesignFromImageJson;
};


export type MutationCreateDesignFromJsonsArgs = {
  input: InputCreateDesignFromJsons;
};


export type MutationCreateDesignFromTemplateArgs = {
  input: InputCreateDesignFromTemplate;
};


export type MutationCreateDesignMediaFolderArgs = {
  input: InputCreateDesignMediaFolder;
};


export type MutationCreateDesignSetArgs = {
  input: InputCreateDesignSet;
};


export type MutationCreateDesignVariationArgs = {
  input: InputCreateDesignVariation;
};


export type MutationCreateDesignWithAssetArgs = {
  input: InputCreateDesignWithAsset;
};


export type MutationCreateDesignWithImageLayerArgs = {
  input: InputCreateDesignWithImageLayer;
};


export type MutationCreateDesignWithVideoLayerArgs = {
  input: InputCreateDesignWithVideoLayer;
};


export type MutationCreateDriveFolderArgs = {
  input: InputCreateDriveFolder;
};


export type MutationCreateDummyCommentsArgs = {
  input: InputCreateDummyComments;
};


export type MutationCreateEditTeamWebhookArgs = {
  input: InputCreateEditTeamWebhook;
};


export type MutationCreateFeedArgs = {
  input: InputCreateFeed;
};


export type MutationCreateFolderArgs = {
  input: InputCreateFolder;
};


export type MutationCreateFromCreatopyDesignArgs = {
  input: InputCreateFromCreatopyDesign;
};


export type MutationCreateIntercomConversationArgs = {
  input: InputCreateIntercomConversation;
};


export type MutationCreateLearnAgentReportSignedUrlArgs = {
  input: InputCreateLearnAgentReportSignedUrl;
};


export type MutationCreateManualCatalogArgs = {
  input: InputCreateManualCatalog;
};


export type MutationCreateMediaArgs = {
  input: InputCreateMedia;
};


export type MutationCreateMediaFolderArgs = {
  input: InputCreateMediaFolder;
};


export type MutationCreateMoodBoardArgs = {
  input: InputCreateMoodBoard;
};


export type MutationCreateMoodBoardCommentArgs = {
  input: CreateMoodBoardCommentInput;
};


export type MutationCreateMoodBoardCommentThreadArgs = {
  input: CreateMoodBoardCommentThreadInput;
};


export type MutationCreateMoodBoardFromTemplateHashArgs = {
  input: InputCreateMoodBoardFromTemplateHash;
};


export type MutationCreateMoodBoardMediaArgs = {
  input: InputCreateMoodBoardMedia;
};


export type MutationCreateMoodboardTeamInvitationArgs = {
  input: InputCreateMoodboardTeamInvitation;
};


export type MutationCreateNewMediaArgs = {
  input: InputCreateMedia;
};


export type MutationCreateNextGenLogoArgs = {
  input: InputCreateNextGenLogo;
};


export type MutationCreateNextGenMediaArgs = {
  input: InputCreateNextGenMedia;
};


export type MutationCreateNextGenSignedUrlArgs = {
  input: InputCreateNextGenSignedUrl;
};


export type MutationCreateNextgenAiArgs = {
  input: InputCreateNextgenAi;
};


export type MutationCreateNextgenAiBrandKitArgs = {
  input: InputCreateNextgenAiBrandKit;
};


export type MutationCreateNextgenAiDesignArgs = {
  input: InputCreateNextgenAiDesign;
};


export type MutationCreateOnboardingMoodBoardArgs = {
  input: InputCreateOnboardingMoodBoard;
};


export type MutationCreateProductSetArgs = {
  input: InputCreateProductSet;
};


export type MutationCreateProjectArgs = {
  input: InputCreateProject;
};


export type MutationCreateSubscriptionArgs = {
  input: InputCreateSubscription;
};


export type MutationCreateSubscriptionChangeArgs = {
  input: InputCreateSubscriptionChange;
};


export type MutationCreateTeamArgs = {
  input: InputTeamCreate;
};


export type MutationCreateTeamIdentityProviderArgs = {
  input: InputCreateTeamIdentityProvider;
};


export type MutationCreateTeamUserGroupArgs = {
  input: InputCreateTeamUserGroup;
};


export type MutationCreateTemplatesFolderArgs = {
  input: InputCreateTemplatesFolder;
};


export type MutationCreateTemporaryDownloadPreviewArgs = {
  input: InputTemporaryDownloadPreview;
};


export type MutationCreateTemporaryPreviewArgs = {
  input: InputTemporaryPreview;
};


export type MutationCreateTranslateFeedArgs = {
  input: InputCreateTranslationFeed;
};


export type MutationCreateUserDefaultsArgs = {
  input?: InputMaybe<InputUserDefaults>;
};


export type MutationCreateVeevaAppArgs = {
  input: VeevaAppInput;
};


export type MutationCreateWorkflowArgs = {
  input: InputCreateWorkflow;
};


export type MutationCropVideoArgs = {
  input: InputCropVideo;
};


export type MutationCutVideoArgs = {
  input: InputCutVideo;
};


export type MutationDataLakeArgs = {
  input: InputDataLake;
};


export type MutationDeclineScannedBrandArgs = {
  input: InputDeclineScannedBrand;
};


export type MutationDeindexFeedRowsArgs = {
  input: IndexFeedRowsInput;
};


export type MutationDeleteAbTestArgs = {
  input: InputAbTest;
};


export type MutationDeleteAbTestPermanentlyArgs = {
  input: InputAbTest;
};


export type MutationDeleteAdPublishJobFromRedisArgs = {
  input: DeleteAdPublishJobFromRedisInput;
};


export type MutationDeleteAdStudioThreadArgs = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  designHash: Scalars['String']['input'];
  threadId: Scalars['String']['input'];
};


export type MutationDeleteAiAgentAutomationScheduleArgs = {
  input: InputDeleteAiAgentAutomationSchedule;
};


export type MutationDeleteAppIntegrationArgs = {
  input: InputDeleteAppIntegration;
};


export type MutationDeleteBrandCompetitorArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteBrandKitArgs = {
  input: InputDeleteBrandKit;
};


export type MutationDeleteBrandKitButtonArgs = {
  input: InputDeleteBrandKitButton;
};


export type MutationDeleteBrandKitDocumentArgs = {
  input: InputBrandKitDocumentRef;
};


export type MutationDeleteBrandKitFontArgs = {
  input: InputDeleteBrandKitFont;
};


export type MutationDeleteBrandKitMediaArgs = {
  input: InputDeleteBrandKitMedia;
};


export type MutationDeleteBrandTargetAudienceArgs = {
  input: InputDelDubBrandTargetAudience;
};


export type MutationDeleteCloudIntegrationArgs = {
  input: InputDeleteCloudIntegration;
};


export type MutationDeleteCloudinaryConfigArgs = {
  input: InputDeleteCloudinaryConfig;
};


export type MutationDeleteColorPaletteArgs = {
  input: InputDeleteColorPalette;
};


export type MutationDeleteCommentArgs = {
  input: InputDeleteComment;
};


export type MutationDeleteCommentsOnTemplateChangeArgs = {
  input: InputDeleteCommentsOnTemplateChange;
};


export type MutationDeleteCopilotAiChatArgs = {
  input: InputDeleteCopilotAiChat;
};


export type MutationDeleteCopilotAiChatMessageArgs = {
  input: InputDeleteCopilotAiChatMessage;
};


export type MutationDeleteCustomTransitionArgs = {
  input: InputDeleteCustomTransition;
};


export type MutationDeleteDesignArgs = {
  input: InputDeleteDesign;
};


export type MutationDeleteDesignCommentsArgs = {
  input: InputDeleteDesignComments;
};


export type MutationDeleteDesignComponentArgs = {
  input: InputDeleteDesignComponent;
};


export type MutationDeleteDesignComponentsArgs = {
  input: InputDeleteDesignComponents;
};


export type MutationDeleteDesignFeedAdjustmentArgs = {
  input: DeleteAdjustmentInput;
};


export type MutationDeleteDesignMediaFolderArgs = {
  input: InputDeleteDesignMediaFolder;
};


export type MutationDeleteDesignPermanentlyArgs = {
  input: InputDeleteDesignPermanently;
};


export type MutationDeleteFeedArgs = {
  input: InputDeleteFeed;
};


export type MutationDeleteFeedColumnArgs = {
  input: InputDeleteFeedColumn;
};


export type MutationDeleteFeedRowsArgs = {
  input: InputDeleteFeedRows;
};


export type MutationDeleteFolderArgs = {
  input: InputDeleteFolder;
};


export type MutationDeleteFolderPermanentlyArgs = {
  input: InputDeleteFolderPermanently;
};


export type MutationDeleteMediaArgs = {
  input: InputDeleteMedia;
};


export type MutationDeleteMediaFolderArgs = {
  input: InputDeleteMediaFolder;
};


export type MutationDeleteMigrationAccountArgs = {
  input: InputMigrate;
};


export type MutationDeleteMoodBoardArgs = {
  input: InputDeleteMoodBoard;
};


export type MutationDeleteMoodBoardCommentArgs = {
  input: DeleteMoodBoardCommentInput;
};


export type MutationDeleteMoodBoardCommentThreadArgs = {
  input: DeleteMoodBoardCommentThreadInput;
};


export type MutationDeletePlatformAdArgs = {
  input: DeletePlatformAdInput;
};


export type MutationDeleteProductSetArgs = {
  input: InputDeleteProductSet;
};


export type MutationDeleteProjectArgs = {
  input: InputDeleteProject;
};


export type MutationDeleteProjectPermanentlyArgs = {
  input: InputDeleteProjectPermanently;
};


export type MutationDeleteReportArgs = {
  input: InputDeleteReport;
};


export type MutationDeleteReportScheduleArgs = {
  input: InputDeleteReportSchedule;
};


export type MutationDeleteRoleArgs = {
  input: InputDeleteRole;
};


export type MutationDeleteSlideCommentsArgs = {
  input: InputDeleteSlideComments;
};


export type MutationDeleteTeamArgs = {
  input: InputDeleteTeam;
};


export type MutationDeleteTeamClientIdArgs = {
  input: DeleteTeamClientId;
};


export type MutationDeleteTeamWebhookArgs = {
  input: InputDeleteTeamWebhook;
};


export type MutationDeleteVeevaAppArgs = {
  appId: Scalars['String']['input'];
};


export type MutationDeleteWorkflowArgs = {
  input: InputDeleteWorkflow;
};


export type MutationDetachFeedArgs = {
  input: InputDetachFeed;
};


export type MutationDisableAdServingArgs = {
  input: InputDisableAdServing;
};


export type MutationDiscardAiResizeSessionArgs = {
  input: InputDiscardAiResizeSession;
};


export type MutationDiscardCopilotBrandExtractionArgs = {
  input: InputCopilotBrandExtraction;
};


export type MutationDiscountSubscriptionArgs = {
  input: InputDiscountSubscription;
};


export type MutationDiscoverVeevaArgs = {
  input: InputVeevaEmail;
};


export type MutationDismissMotionDraftArgs = {
  input: InputDismissMotionDraft;
};


export type MutationDisplayBrandKitWizardArgs = {
  input: InputDisplayBrandKitWizard;
};


export type MutationDownloadArgs = {
  input: InputDownloadCreate;
};


export type MutationDownloadCancelArgs = {
  input: InputDownload;
};


export type MutationDownloadCancelAllArgs = {
  input?: InputMaybe<InputCancelDownload>;
};


export type MutationDownloadInvoiceArgs = {
  input: InputDownloadInvoice;
};


export type MutationDownloadRetryArgs = {
  input: InputDownload;
};


export type MutationDownloadViaEmailArgs = {
  input: InputDownload;
};


export type MutationDraftColumnsFromPromptArgs = {
  input: InputDraftColumnsFromPrompt;
};


export type MutationDraftMultiSceneStoryboardArgs = {
  input: InputDraftMultiSceneStoryboard;
};


export type MutationDuplicateAiChatArgs = {
  input: InputDuplicateCopilotAiChat;
};


export type MutationDuplicateBrandKitArgs = {
  input: InputDuplicateBrandKit;
};


export type MutationDuplicateBrandTargetAudienceArgs = {
  input: InputDelDubBrandTargetAudience;
};


export type MutationDuplicateBrandTemplateArgs = {
  input: InputDuplicateBrandTemplate;
};


export type MutationDuplicateBrandTemplateFolderArgs = {
  input: InputDuplicateBrandTemplateFolder;
};


export type MutationDuplicateColorPaletteArgs = {
  input: InputDuplicateColorPalette;
};


export type MutationDuplicateCopilotAiChatArgs = {
  input: InputDuplicateCopilotAiChat;
};


export type MutationDuplicateDesignArgs = {
  input: InputDuplicateDesign;
};


export type MutationDuplicateFolderArgs = {
  input: InputDuplicateFolder;
};


export type MutationDuplicateMoodBoardArgs = {
  input: InputDuplicateMoodBoard;
};


export type MutationDuplicateReportArgs = {
  input: InputDuplicateReport;
};


export type MutationEditColorInPaletteArgs = {
  input: InputEditColorInPalette;
};


export type MutationEditDesignArgs = {
  input: InputEditDesign;
};


export type MutationEditImageArgs = {
  input: InputEditImage;
};


export type MutationEditMotionDraftArgs = {
  input: InputDecideMotionDraft;
};


export type MutationEnableAdServingArgs = {
  input: InputEnableAdServing;
};


export type MutationEnableProjectNewAdStudioBetaArgs = {
  input: InputEnableProjectNewAdStudioBeta;
};


export type MutationEndSessionArgs = {
  input: InputEndSession;
};


export type MutationEnforceTeamSsoArgs = {
  input: EnforceSso;
};


export type MutationEnforceTeamTwoFactorArgs = {
  input: TeamTwoFactor;
};


export type MutationEnrollTeamToPaymentVariantArgs = {
  input: InputEnrollTeamToPaymentVariant;
};


export type MutationEstimateHtmlSizeArgs = {
  input: InputEstimateHtmlSize;
};


export type MutationExpandImageArgs = {
  input: InputExpandImage;
};


export type MutationExportDesignThumbnailArgs = {
  input: InputExportDesignThumbnail;
};


export type MutationExportSetThumbnailAdminArgs = {
  input: InputExportSetThumbnail;
};


export type MutationExtractBrandKitAssetsArgs = {
  input: InputExtractBrandKitAssets;
};


export type MutationFetchFeedUrlColumnsArgs = {
  input: InputFetchFeedUrl;
};


export type MutationGenerateAdStudioThreadTitleArgs = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  designHash: Scalars['String']['input'];
  threadId: Scalars['String']['input'];
};


export type MutationGenerateContentVariationsArgs = {
  input: InputGenerateContentVariations;
};


export type MutationGenerateDesignJsonFromImageArgs = {
  input: InputGenerateDesignJsonFromImage;
};


export type MutationGenerateDesignNameArgs = {
  input: InputGenerateDesignName;
};


export type MutationGenerateEmbedCodeArgs = {
  input: InputGenerateEmbedCode;
};


export type MutationGenerateProductPhotographyArgs = {
  input: InputProductPhotography;
};


export type MutationGenerateTeamClientIdArgs = {
  input: InputGenerateTeamClientId;
};


export type MutationGenerateTextArgs = {
  input: InputTextGeneration;
};


export type MutationGenerateVeevaNotesArgs = {
  input: InputGenerateVeevaNotes;
};


export type MutationGenerateVeevaPdfArgs = {
  input: InputGenerateVeevaPdf;
};


export type MutationGetBynderAuthUrlArgs = {
  input: InputBynderGetAuth;
};


export type MutationGetBynderTokenArgs = {
  input: InputGetBynderToken;
};


export type MutationGetOrCreateDesignSetSizeTypeArgs = {
  input: InputGetOrCreateDesignSetSizeType;
};


export type MutationHandleTemporaryEnterpriseArgs = {
  input: InputHandleTemporaryEnterprise;
};


export type MutationImpersonateUserArgs = {
  input: Scalars['Int']['input'];
};


export type MutationImportAemAssetArgs = {
  input: InputImportAemAsset;
};


export type MutationImportBrandKitDocumentArgs = {
  input: InputImportBrandKitDocument;
};


export type MutationImportDesignMediaFromUrlsArgs = {
  input: InputImportDesignMediaFromUrls;
};


export type MutationImportFigFileFramesArgs = {
  input: InputImportFigFileFrames;
};


export type MutationImportMediaFromDesignArgs = {
  input: InputImportMediaFromDesign;
};


export type MutationImportMetaCatalogArgs = {
  input: InputImportMetaCatalog;
};


export type MutationIndexFeedRowsArgs = {
  input: IndexFeedRowsInput;
};


export type MutationInitializeMasterSizesSyncBaselineArgs = {
  input: InputDesign;
};


export type MutationInitiateIntercomConversationArgs = {
  input: InputInitiateIntercomConversation;
};


export type MutationInpaintWithAiArgs = {
  input: InputInpaintWithAi;
};


export type MutationIntegrateVeevaClientArgs = {
  input: InputVeevaClient;
};


export type MutationInviteTeamUserArgs = {
  input: InputInviteTeamUser;
};


export type MutationInviteTeamUsersMultipleResourcesArgs = {
  input: InputInviteTeamUsersMultipleResources;
};


export type MutationIsAiOperationViewedArgs = {
  operationId: Scalars['Int']['input'];
};


export type MutationIsValidCancellationReasonArgs = {
  input: CancellationReasonValidation;
};


export type MutationJoinBetaNextgenAiArgs = {
  input: InputJoinBetaNextgenAi;
};


export type MutationJoinMoodboardTeamArgs = {
  input: InputJoinMoodboardTeam;
};


export type MutationJoinTeamArgs = {
  input: InputJoinTeam;
};


export type MutationJoinTeamByBusinessDomainArgs = {
  input: InputJoinTeam;
};


export type MutationKeepAliveLoginVeevaArgs = {
  input: InputVeevaSession;
};


export type MutationLeaveTeamArgs = {
  input: InputLeaveTeam;
};


export type MutationLinkBusinessFbAccountArgs = {
  input: LinkBusinessFbInput;
};


export type MutationLoginVeevaArgs = {
  input: LoginVeevaInput;
};


export type MutationManuallyEndAbTestArgs = {
  input: InputManuallyEndAbTest;
};


export type MutationMarkEditDesignArgs = {
  input: InputMarkEditDesign;
};


export type MutationMarkProductUpdateArgs = {
  input: InputMarkProductUpdate;
};


export type MutationMarkTutorialArgs = {
  input: InputMarkTutorial;
};


export type MutationMarkTutorialAsViewedArgs = {
  input: InputMarkTutorialAsViewed;
};


export type MutationMarkZapierFeedbackAsShownArgs = {
  input: InputMarkZapierFeedbackAsShown;
};


export type MutationMigrateArgs = {
  input: InputMigrationStart;
};


export type MutationMigrateBrandTemplatesArgs = {
  input: InputMigrateBrandTemplates;
};


export type MutationMoveAbTestArgs = {
  input: InputMoveAbTest;
};


export type MutationMoveBrandTemplateDesignsAndFoldersArgs = {
  input: InputMoveBrandTemplateDesignsAndFolders;
};


export type MutationMoveDesignArgs = {
  input: InputMoveDesign;
};


export type MutationMoveDesignMediaFoldersArgs = {
  input: InputMoveDesignMediaFolders;
};


export type MutationMoveDesignMediaToFolderArgs = {
  input: InputMoveDesignMediaToFolder;
};


export type MutationMoveElementsArgs = {
  input: MoveElements;
};


export type MutationMoveFolderArgs = {
  input: InputMoveFolder;
};


export type MutationMoveFoldersArgs = {
  input: InputMoveFolders;
};


export type MutationMoveLogoElementsArgs = {
  input: MoveElements;
};


export type MutationMoveMediaElementsArgs = {
  input: MoveMediaElements;
};


export type MutationMoveMediaFoldersArgs = {
  input: InputMoveMediaFolders;
};


export type MutationMoveToBrandkitArgs = {
  input: InputMoveToBrandkitElements;
};


export type MutationNewDesignSetArgs = {
  input: InputNewDesignSet;
};


export type MutationOptimizeImageArgs = {
  input: InputOptimizeImage;
};


export type MutationOverrideProductFieldArgs = {
  input: InputOverrideProductField;
};


export type MutationPauseSubscriptionArgs = {
  input: InputPauseSubscription;
};


export type MutationPersistFlexDesignTreeArgs = {
  input: InputPersistFlexDesignTree;
};


export type MutationPinFolderArgs = {
  input: InputFolder;
};


export type MutationPlanAdEntryArgs = {
  input: InputPlanAdEntry;
};


export type MutationPlanBrandKitImageryArgs = {
  attachedImageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  briefId?: InputMaybe<Scalars['String']['input']>;
  chatThreadId?: InputMaybe<Scalars['String']['input']>;
  designHash: Scalars['String']['input'];
  direction?: InputMaybe<Scalars['String']['input']>;
  forceRewrite?: InputMaybe<Scalars['Boolean']['input']>;
  forwardsImageAssets?: InputMaybe<Scalars['Boolean']['input']>;
  slideId?: InputMaybe<Scalars['Int']['input']>;
  targetDesignId?: InputMaybe<Scalars['Int']['input']>;
  writesImageFills?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPopulateBrandKitFromUrlArgs = {
  input: InputPopulateBrandKitFromUrl;
};


export type MutationPostJourneyFeedbackArgs = {
  input: InputPostJourneyFeedback;
};


export type MutationProcessAfterJoinArgs = {
  input: InputProcessAfterJoin;
};


export type MutationProcessFigFileArgs = {
  input: InputProcessFigFile;
};


export type MutationProcessPhotoshopFileArgs = {
  input: InputPhotoshopFile;
};


export type MutationProcessPhotoshopStructureArgs = {
  input: InputPhotoshopStructure;
};


export type MutationPromoteCopilotBrandExtractionArgs = {
  input: InputPromoteCopilotBrandExtraction;
};


export type MutationPropagateSizesToVariationsArgs = {
  input: InputPropagateSizesToVariations;
};


export type MutationPublicDownloadArgs = {
  input: InputDownloadCreate;
};


export type MutationPublishCreativeCm360Args = {
  input: PublishCreativeCm360Input;
};


export type MutationPublishCreativeDv360Args = {
  input: PublishCreativeDv360Input;
};


export type MutationPublishDpaCatalogArgs = {
  input: PublishDpaCatalogInput;
};


export type MutationPublishGoogleAdsCampaignArgs = {
  input: PublishGoogleAdsCampaignInput;
};


export type MutationPublishLinkedInCampaignArgs = {
  input: PublishLinkedInCampaignInput;
};


export type MutationPublishPinterestCampaignArgs = {
  input: PublishPinterestCampaignInput;
};


export type MutationPublishPinterestCatalogArgs = {
  input: PublishPinterestCatalogInput;
};


export type MutationPublishSingleCreativeArgs = {
  input: PublishSingleCreativeInput;
};


export type MutationPublishTikTokCampaignArgs = {
  input: PublishTikTokCampaignInput;
};


export type MutationPublishTikTokCatalogArgs = {
  input: PublishTikTokCatalogInput;
};


export type MutationPublishToCampaignArgs = {
  input: PublishToCampaignInput;
};


export type MutationPurchaseCreditsArgs = {
  input: InputMigrate;
};


export type MutationPurchaseTopUpCreditsArgs = {
  input: InputPurchaseTopUpCredits;
};


export type MutationPushMasterSizeChangesArgs = {
  input: InputPushMasterSizeChanges;
};


export type MutationReactivateSubscriptionArgs = {
  input: InputReactivateSubscription;
};


export type MutationReactivateSubscriptionV2Args = {
  input: InputReactivateSubscription;
};


export type MutationReadBrandKitConceptBriefArgs = {
  chatThreadId?: InputMaybe<Scalars['String']['input']>;
  designHash: Scalars['String']['input'];
  direction?: InputMaybe<Scalars['String']['input']>;
  paletteName?: InputMaybe<Scalars['String']['input']>;
  slotRoles?: InputMaybe<Scalars['Boolean']['input']>;
  targetDesignId?: InputMaybe<Scalars['Int']['input']>;
  templateRun?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationReadThreadArgs = {
  input: InputReadThread;
};


export type MutationRecordAiStudioGenerationOutcomeArgs = {
  input: InputRecordAiStudioGenerationOutcome;
};


export type MutationRecordCustomDesignSetUseArgs = {
  input: InputRecordCustomDesignSetUse;
};


export type MutationRecordDesignShareLinkCopiedArgs = {
  input: InputRecordDesignShareLinkCopied;
};


export type MutationRefreshAdStudioContextArgs = {
  designHash: Scalars['String']['input'];
  includeGenerationGrounding?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRefreshStudioAssistantContextArgs = {
  input: RefreshStudioAssistantContextInput;
};


export type MutationRegenerateBrandKitProfileArgs = {
  input: InputBrandKitId;
};


export type MutationRegenerateMultiSceneScenesArgs = {
  input: InputRegenerateMultiSceneScenes;
};


export type MutationRegenerateTokenArgs = {
  input: InputRegenerateToken;
};


export type MutationRejectTeamInvitationArgs = {
  input: InputRejectTeamInvitation;
};


export type MutationRemoveAiStudioResultArgs = {
  input: InputRemoveAiStudioResult;
};


export type MutationRemoveAnimationFromDesignArgs = {
  input: InputRemoveAnimationFromDesign;
};


export type MutationRemoveBgArgs = {
  input: InputRemoveBg;
};


export type MutationRemoveBgOnBoundedImageArgs = {
  input: InputRemoveBgOnBoundedImage;
};


export type MutationRemoveBillingInfoArgs = {
  input: InputRemoveBillingInfo;
};


export type MutationRemoveBrandStyleSourceImageArgs = {
  input: InputRemoveBrandStyleSourceImage;
};


export type MutationRemoveBrandedResourceArgs = {
  input: InputRemoveBrandedResource;
};


export type MutationRemoveColorFromPaletteArgs = {
  input: InputRemoveColorFromPalette;
};


export type MutationRemoveCommentAttachmentArgs = {
  input: InputRemoveCommentAttachment;
};


export type MutationRemoveCustomSizeArgs = {
  input: InputRemoveCustomSize;
};


export type MutationRemoveDesignFromSetArgs = {
  input: InputRemoveDesignFromSet;
};


export type MutationRemoveDesignMediaFromLibraryArgs = {
  input: InputRemoveDesignMediaFromLibrary;
};


export type MutationRemoveDesignReviewerArgs = {
  input: InputRemoveDesignReviewer;
};


export type MutationRemoveDesignSizeTypeArgs = {
  input: InputRemoveDesignSizeType;
};


export type MutationRemoveDesignSizesArgs = {
  input: InputRemoveDesignSizes;
};


export type MutationRemoveDynamicVarArgs = {
  input: InputRemoveDynamicVar;
};


export type MutationRemoveExternalTrackingUrlArgs = {
  input: InputRemoveDesignExternalTracking;
};


export type MutationRemoveNetworkAdServingArgs = {
  input: InputRemoveNetworkAdServing;
};


export type MutationRemoveObjectArgs = {
  input: InputRemoveObject;
};


export type MutationRemoveProjectGroupArgs = {
  input: InputRemoveProjectGroup;
};


export type MutationRemoveProjectUserArgs = {
  input: InputRemoveProjectUser;
};


export type MutationRemoveTagContainerNetworkArgs = {
  input: InputUpdateTagContainerNetwork;
};


export type MutationRemoveTeamIdentityProviderArgs = {
  input: InputRemoveTeamIdentityProvider;
};


export type MutationRemoveTeamUserArgs = {
  input: InputRemoveMember;
};


export type MutationRemoveTeamUserGroupArgs = {
  input: InputRemoveTeamUserGroup;
};


export type MutationRemoveTypographyArgs = {
  input: InputRemoveTypography;
};


export type MutationRemoveUserFromGroupArgs = {
  input: InputRemoveUserFromGroup;
};


export type MutationRemoveVariationArgs = {
  input: InputRemoveVariation;
};


export type MutationRenameAbTestArgs = {
  input: InputRenameAbTest;
};


export type MutationRenameBrandKitArgs = {
  input: InputRenameBrandKit;
};


export type MutationRenameBrandTargetAudienceArgs = {
  input: InputRenameBrandTargetAudience;
};


export type MutationRenameColorPaletteArgs = {
  input: InputRenameColorPalette;
};


export type MutationRenameCopilotAiChatArgs = {
  input: InputRenameCopilotAiChat;
};


export type MutationRenameCustomSizeArgs = {
  input: InputRenameCustomSize;
};


export type MutationRenameCustomTransitionArgs = {
  input: InputRenameCustomTransition;
};


export type MutationRenameDesignArgs = {
  input: InputRenameDesign;
};


export type MutationRenameDesignComponentArgs = {
  input: InputRenameDesignComponent;
};


export type MutationRenameDesignMediaFolderArgs = {
  input: InputRenameDesignMediaFolder;
};


export type MutationRenameDesignSizeTypeArgs = {
  input: InputRenameDesignSizeType;
};


export type MutationRenameFolderArgs = {
  input: InputRenameFolder;
};


export type MutationRenameMediaArgs = {
  input: InputRenameMedia;
};


export type MutationRenameMediaFolderArgs = {
  input: InputRenameMediaFolder;
};


export type MutationRenameReportArgs = {
  input: InputRenameReport;
};


export type MutationRenameTeamClientIdArgs = {
  input: RenameTeamClientId;
};


export type MutationRenameTypographyArgs = {
  input: InputRenameTypography;
};


export type MutationReorderPinnedFolderListArgs = {
  input: InputNewOrderPinnedFolderList;
};


export type MutationReparseFontMetricsArgs = {
  input: ReparseFontMetricsInput;
};


export type MutationReplaceBriefAssetsArgs = {
  assets: Array<InputBriefAsset>;
  designHash: Scalars['String']['input'];
  expectedVersion: Scalars['Int']['input'];
  product?: InputMaybe<BriefProductState>;
  productCount?: InputMaybe<Scalars['Int']['input']>;
  threadId: Scalars['String']['input'];
};


export type MutationReportAdStudioExperienceArgs = {
  input: InputReportAdStudioExperience;
};


export type MutationRequestProductSetImportArgs = {
  input: InputRequestProductSetImport;
};


export type MutationResendInvitationArgs = {
  input: InputResendInvitation;
};


export type MutationResendValidationCodeArgs = {
  input: InputMigrate;
};


export type MutationReserveResizeApplyCreditArgs = {
  input: InputReserveResizeApplyCredit;
};


export type MutationResetAdStudioChatArgs = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  designHash: Scalars['String']['input'];
};


export type MutationResetSizesToMasterSizeArgs = {
  input: InputResetSizesToMasterSize;
};


export type MutationResetTeamClientIdArgs = {
  input: ResetTeamClientId;
};


export type MutationResizeWithTemplateArgs = {
  input: InputResizeWithTemplate;
};


export type MutationRestoreAbTestArgs = {
  input: InputRestoreAbTest;
};


export type MutationRestoreDesignArgs = {
  input: InputRestoreDesign;
};


export type MutationRestoreDesignFromSetArgs = {
  input: InputRestoreDesignFromSet;
};


export type MutationRestoreProjectArgs = {
  input: InputRestoreProject;
};


export type MutationRestoreVariationArgs = {
  input: InputRestoreVariation;
};


export type MutationRestoreVariationsFamilyStateArgs = {
  input: InputRestoreVariationsFamilyState;
};


export type MutationResumeSubscriptionArgs = {
  input: InputResumeSubscription;
};


export type MutationRetryAiOperationArgs = {
  input: InputRetryAiOperation;
};


export type MutationRetryAiResizeVariantArgs = {
  input: InputRetryAiResizeVariant;
};


export type MutationRetryBrandKitDocumentImportArgs = {
  input: InputBrandKitDocumentRef;
};


export type MutationRetryBrandStyleEvaluationArgs = {
  input: InputRetryBrandStyleEvaluation;
};


export type MutationRetryJobArgs = {
  input: RetryJobInput;
};


export type MutationRevertBgOnBoundedImageArgs = {
  input: InputRevertBgOnBoundedImage;
};


export type MutationRevertProductFieldArgs = {
  input: InputRevertProductField;
};


export type MutationRevokeInvitationArgs = {
  input: InputRevokeInvitation;
};


export type MutationRunCustomWorkflowArgs = {
  input: InputRunCustomWorkflow;
};


export type MutationRunWorkflowArgs = {
  input: InputRunWorkflow;
};


export type MutationSaveAssetSelectorConfigArgs = {
  input: InputSaveAssetSelectorConfig;
};


export type MutationSaveBrandKitJsonArgs = {
  input: InputSaveBrandKitJson;
};


export type MutationSaveBrandKitJsonV2Args = {
  input: InputSaveBrandKitJson;
};


export type MutationSaveCatalogVariationDesignsArgs = {
  input: InputSaveCatalogVariationDesigns;
};


export type MutationSaveCloudinaryConfigArgs = {
  input: InputSaveCloudinaryConfig;
};


export type MutationSaveCopilotAiChatMessageAdditionalFeedbackArgs = {
  input: InputSaveCopilotAiChatMessageAdditionalFeedback;
};


export type MutationSaveCopilotAiChatMessageFeedbackArgs = {
  input: InputSaveCopilotAiChatMessageFeedback;
};


export type MutationSaveCopilotDocumentToBrandKitArgs = {
  input: InputSaveCopilotDocumentToBrandKit;
};


export type MutationSaveCustomTransitionArgs = {
  input: InputSaveCustomTransition;
};


export type MutationSaveDesignFeedAdjustmentArgs = {
  input: SaveAdjustmentInput;
};


export type MutationSaveDesignsJsonsForLaterArgs = {
  input: InputSaveDesignsJsonsForLater;
};


export type MutationSaveFeedIntervalArgs = {
  input: InputSaveFeedInterval;
};


export type MutationSavePlatformAdArgs = {
  input: SavePlatformAdInput;
};


export type MutationSaveQuestionBgArgs = {
  input: InputSaveQuestionBg;
};


export type MutationSaveReportArgs = {
  input: InputSaveReport;
};


export type MutationSaveSetHashesArgs = {
  input: InputSetHashes;
};


export type MutationSearchAndReplaceArgs = {
  input: InputSearchAndReplace;
};


export type MutationSelectMigrationAccountArgs = {
  input: InputSelectMigrationAccount;
};


export type MutationSelectVeevaVaultArgs = {
  input: SelectVeevaVaultInput;
};


export type MutationSendBookACallContextArgs = {
  input: InputSendBookACallContext;
};


export type MutationSendGclidArgs = {
  input: InputSendGclid;
};


export type MutationSendHtmlReportToEmailArgs = {
  input: InputSendHtmlReportToEmail;
};


export type MutationSendMessageToSlackChannelArgs = {
  input: SendMessageToSlackChannelInput;
};


export type MutationSendMyAdsLibraryMessageArgs = {
  input: SendMyMessageInput;
};


export type MutationSendReferralLpArgs = {
  input: InputSendReferralLp;
};


export type MutationSendTestEmailArgs = {
  input: InputSendTestEmail;
};


export type MutationSendTopUpCreditsEmailArgs = {
  input: InputSendTopUpCreditsEmail;
};


export type MutationSendUsageRestrictionAdminNotificationArgs = {
  input: InputSendUsageRestrictionAdminNotification;
};


export type MutationSendUtkArgs = {
  input: InputSendUtk;
};


export type MutationSendUtmsArgs = {
  input: InputSendUtms;
};


export type MutationSetAdStudioThreadChatModeArgs = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  chatMode: AdStudioChatMode;
  designHash: Scalars['String']['input'];
  threadId: Scalars['String']['input'];
};


export type MutationSetAnonymousIdArgs = {
  input: InputSetAnonymousId;
};


export type MutationSetBrandKitLogoArgs = {
  input: InputSetBrandKitLogo;
};


export type MutationSetBrandKitProfileArgs = {
  input: InputSetBrandKitProfile;
};


export type MutationSetBrandKitVisualStyleArgs = {
  input: InputSetBrandKitVisualStyle;
};


export type MutationSetBrandKitVoiceAndToneArgs = {
  input: InputSetBrandKitVoiceAndTone;
};


export type MutationSetBrandedColorArgs = {
  input: InputSetBrandedColor;
};


export type MutationSetBrandedDomainArgs = {
  input: InputSetBrandedDomain;
};


export type MutationSetBrandedEmailArgs = {
  input: InputSetBrandedEmail;
};


export type MutationSetBrandedFaviconArgs = {
  input: InputSetBrandedFavicon;
};


export type MutationSetBrandedLogoArgs = {
  input: InputSetBrandedLogo;
};


export type MutationSetBriefAssetsArgs = {
  assets: Array<InputBriefAsset>;
  designHash: Scalars['String']['input'];
  threadId: Scalars['String']['input'];
};


export type MutationSetCatalogFavoriteArgs = {
  input: InputSetCatalogFavorite;
};


export type MutationSetCloudinaryDefaultFolderArgs = {
  input: InputSetCloudinaryDefaultFolder;
};


export type MutationSetCopilotBrandExtractionFontArgs = {
  input: InputSetCopilotBrandExtractionFont;
};


export type MutationSetDefaultGoogleAdsIntegrationAccountArgs = {
  input: InputSetDefaultGoogleAdsIntegrationAccount;
};


export type MutationSetDefaultMetaIntegrationAccountArgs = {
  input: InputSetDefaultMetaIntegrationAccount;
};


export type MutationSetDesignFeedRowArgs = {
  input: InputSetDesignFeedRow;
};


export type MutationSetDesignPresetArgs = {
  input: InputDesignPreset;
};


export type MutationSetDesignPresetV2Args = {
  input: InputDesignPresetV2;
};


export type MutationSetEmailPreferencesArgs = {
  input: InputEmailPreferences;
};


export type MutationSetFavoriteProjectArgs = {
  input: InputSetFavoriteProject;
};


export type MutationSetFavouriteTeamArgs = {
  input: InputFavouriteTeam;
};


export type MutationSetFeedColumnSmartCropEnabledArgs = {
  input: InputSetFeedColumnSmartCropEnabled;
};


export type MutationSetFeedRowSmartCropReviewedArgs = {
  input: InputSetFeedRowSmartCropReviewed;
};


export type MutationSetFontMetricsOverrideDisabledArgs = {
  input: SetFontMetricsOverrideDisabledInput;
};


export type MutationSetMetaPublicationAutoSyncArgs = {
  input: SetMetaPublicationAutoSyncInput;
};


export type MutationSetMigrationStepArgs = {
  input: InputSetMigrationStep;
};


export type MutationSetPageTitleArgs = {
  input: InputSetPageTitle;
};


export type MutationSetProjectLogoArgs = {
  input: InputSetProjectLogo;
};


export type MutationSetRoleArgs = {
  input: InputSetRole;
};


export type MutationSetSharePointDefaultLocationArgs = {
  input: InputSetSharePointDefaultLocation;
};


export type MutationSetSmartCropOnFeedRowArgs = {
  input: InputSetSmartCropOnFeedRow;
};


export type MutationSetSmartSetEnabledArgs = {
  input: InputSetSmartSetEnabled;
};


export type MutationSetTeamLogoArgs = {
  input: InputSetTeamLogo;
};


export type MutationSetTwoFactorArgs = {
  input: InputTwoFactor;
};


export type MutationSetTypographyOptionsArgs = {
  input: InputSetTypographyOptions;
};


export type MutationSetUserNameArgs = {
  input: InputUserName;
};


export type MutationSetVariationAsMasterArgs = {
  input: InputSetVariationAsMaster;
};


export type MutationSetVeevaOptionsArgs = {
  input: VeevaOptionsData;
};


export type MutationSettleResizeApplyCreditArgs = {
  input: InputSettleResizeApplyCredit;
};


export type MutationShareDesignArgs = {
  input: InputShareDesign;
};


export type MutationShareFolderArgs = {
  input: InputShareFolder;
};


export type MutationShareFoldersAndDesignsArgs = {
  input: InputShareFoldersAndDesigns;
};


export type MutationSignFigFileUploadUrlArgs = {
  input: InputSignFigFileUploadUrl;
};


export type MutationSignShareUploadUrlArgs = {
  input: InputSignShareUploadUrl;
};


export type MutationSignTempUploadUrlArgs = {
  input: InputSignTempUploadUrl;
};


export type MutationSignUploadUrlArgs = {
  input: InputSignUploadUrl;
};


export type MutationSmartCropBannersArgs = {
  input: InputSmartCropBanners;
};


export type MutationSolveCommentArgs = {
  input: InputSolveComment;
};


export type MutationStartAiAgentAutomationScheduleArgs = {
  input: InputStartAiAgentAutomationSchedule;
};


export type MutationStartAiResizeVariantsArgs = {
  input: InputStartAiResizeVariants;
};


export type MutationStartAutoCutVideoArgs = {
  input: InputStartAutoCutVideo;
};


export type MutationStartCaptionGenerationArgs = {
  input: InputStartCaptionGeneration;
};


export type MutationStartCloudinaryConnectionArgs = {
  input: InputStartCloudinaryConnection;
};


export type MutationStartGenerateBackgroundArgs = {
  input: InputGenerateBackground;
};


export type MutationStartGenerateBackgroundBriaArgs = {
  input: InputGenerateBackgroundBria;
};


export type MutationStartGenerateFromContentArgs = {
  input: InputGenerateFromContent;
};


export type MutationStartGenerateFromLineartArgs = {
  input: InputGenerateFromLineart;
};


export type MutationStartImageGenerationFromPromptArgs = {
  input: InputImageGeneration;
};


export type MutationStartImageUpscaleArgs = {
  input: InputStartImageUpscale;
};


export type MutationStartLayeredAdArgs = {
  input: InputStartLayeredAd;
};


export type MutationStartNewAdsLibraryChatArgs = {
  input?: InputMaybe<StartNewChatInput>;
};


export type MutationStartRecomposeResizeArgs = {
  input: InputStartRecomposeResize;
};


export type MutationStartRemoveVideoBackgroundArgs = {
  input: InputRemoveVideoBackground;
};


export type MutationStartReplaceVideoBackgroundArgs = {
  input: InputReplaceVideoBackground;
};


export type MutationStartVideoDubbingArgs = {
  input: InputStartVideoDubbing;
};


export type MutationStartVideoGenerationFromPromptArgs = {
  input: InputVideoGeneration;
};


export type MutationStartVoiceoverGenerationArgs = {
  input: InputStartVoiceoverGeneration;
};


export type MutationStopAiAgentAutomationScheduleArgs = {
  input: InputStopAiAgentAutomationSchedule;
};


export type MutationSyncDpaCatalogArgs = {
  input: SyncDpaCatalogInput;
};


export type MutationSyncDpaCatalogWithDesignArgs = {
  input: SyncDpaCatalogWithDesignInput;
};


export type MutationSyncFeedArgs = {
  input: InputSyncFeed;
};


export type MutationSyncTagContainerAdTagNetworksArgs = {
  input: InputTagContainer;
};


export type MutationSyncTikTokCatalogWithDesignArgs = {
  input: SyncTikTokCatalogWithDesignInput;
};


export type MutationSyncVariationsFromMasterArgs = {
  input: InputSyncVariationsFromMaster;
};


export type MutationTagCatalogProductsArgs = {
  input: InputTagCatalogProducts;
};


export type MutationTestCloudinaryConnectionArgs = {
  input: InputTestCloudinaryConnection;
};


export type MutationTranslateLightEditorCopyArgs = {
  input: InputTranslateLightEditorCopy;
};


export type MutationTrimVideoArgs = {
  input: InputTrimVideo;
};


export type MutationUnShareDesignArgs = {
  input: InputUnShareDesign;
};


export type MutationUnShareFolderArgs = {
  input: InputUnShareFolder;
};


export type MutationUndoDeleteFolderArgs = {
  input: InputUndoDeleteFolder;
};


export type MutationUnlinkBusinessAccountArgs = {
  input: UnlinkBusinessAccountInput;
};


export type MutationUnpinFolderArgs = {
  input: InputFolder;
};


export type MutationUntagCatalogProductsArgs = {
  input: InputTagCatalogProducts;
};


export type MutationUpdateAccessTokenArgs = {
  input: InputUpdateAccessToken;
};


export type MutationUpdateAdServingAccessArgs = {
  input: InputUpdateAdServingAccess;
};


export type MutationUpdateAdServingCodeArgs = {
  input: InputUpdateAdServingCode;
};


export type MutationUpdateAdServingSettingsArgs = {
  input: InputUpdateAdServingSettings;
};


export type MutationUpdateAdStudioThreadTitleArgs = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  designHash: Scalars['String']['input'];
  threadId: Scalars['String']['input'];
  title: Scalars['String']['input'];
};


export type MutationUpdateAutomatedReportPublicStatusArgs = {
  input: InputUpdateAutomatedReportPublicStatus;
};


export type MutationUpdateBillingInfoArgs = {
  input: InputUpdateBillingInfo;
};


export type MutationUpdateBrandCompetitorArgs = {
  id: Scalars['Int']['input'];
  input: UpdateBrandCompetitorInput;
};


export type MutationUpdateBrandDetailsArgs = {
  input: InputUpdateBrandDetails;
};


export type MutationUpdateBrandKitAiGenerationRulesArgs = {
  input: InputUpdateBrandKitAiGenerationRules;
};


export type MutationUpdateBrandKitButtonArgs = {
  input: InputUpdateBrandKitButton;
};


export type MutationUpdateBrandTargetAudienceArgs = {
  input: InputUpdateBrandTargetAudience;
};


export type MutationUpdateCatalogSettingsArgs = {
  input: InputUpdateCatalogSettings;
};


export type MutationUpdateColorPaletteArgs = {
  input: InputUpdateColorPalette;
};


export type MutationUpdateColorPaletteOrderArgs = {
  input: InputUpdateColorPaletteOrder;
};


export type MutationUpdateCommentArgs = {
  input: InputUpdateComment;
};


export type MutationUpdateCopilotAiChatPublicStatusArgs = {
  input: InputUpdateCopilotAiChatPublicStatus;
};


export type MutationUpdateCopilotAiReportPublicStatusArgs = {
  input: InputUpdateCopilotAiReportPublicStatus;
};


export type MutationUpdateCustomAdNetworkArgs = {
  input: InputUpdateCustomAdNetwork;
};


export type MutationUpdateDesignArgs = {
  input: InputUpdateDesign;
};


export type MutationUpdateDesignApprovalStatusArgs = {
  input: InputUpdateDesignApprovalStatus;
};


export type MutationUpdateDesignHtmlSettingsArgs = {
  input: InputUpdateDesignHtmlSettings;
};


export type MutationUpdateDesignMainDesignArgs = {
  input: InputUpdateDesignMainDesign;
};


export type MutationUpdateDesignMeasureUnitArgs = {
  input: InputUpdateDesignMeasureUnit;
};


export type MutationUpdateDesignSetArgs = {
  input: InputUpdateDesignSet;
};


export type MutationUpdateDesignSizeTypeIdArgs = {
  input: InputUpdateDesignSizeTypeId;
};


export type MutationUpdateDesignsArgs = {
  input: Array<InputUpdateDesign>;
};


export type MutationUpdateDpaSettingsArgs = {
  input: UpdateDpaSettingsInput;
};


export type MutationUpdateExtendTrialArgs = {
  input: InputUpdateExtendTrial;
};


export type MutationUpdateFacebookDpaSettingsArgs = {
  input: UpdateFacebookDpaSettingsInput;
};


export type MutationUpdateFeedArgs = {
  input: InputUpdateFeed;
};


export type MutationUpdateFeedColumnArgs = {
  input: InputUpdateFeedColumn;
};


export type MutationUpdateFeedRowArgs = {
  input: InputUpdateFeedRow;
};


export type MutationUpdateMoodBoardArgs = {
  input: InputUpdateMoodBoard;
};


export type MutationUpdateMoodBoardCommentArgs = {
  input: UpdateMoodBoardCommentInput;
};


export type MutationUpdateMoodBoardCommentThreadArgs = {
  input: UpdateMoodBoardCommentThreadInput;
};


export type MutationUpdateMoodBoardContentArgs = {
  input: InputUpdateMoodBoardContent;
};


export type MutationUpdateMoodBoardShareArgs = {
  input: InputUpdateMoodBoardShare;
};


export type MutationUpdateNextgenAiArgs = {
  input: InputUpdateNextgenAi;
};


export type MutationUpdateOnboardingFlowsArgs = {
  input: InputUpdateOnboardingFlows;
};


export type MutationUpdateOnboardingFlowsTrialArgs = {
  input: InputUpdateOnboardingFlowsTrial;
};


export type MutationUpdatePinterestDpaSettingsArgs = {
  input: UpdatePinterestDpaSettingsInput;
};


export type MutationUpdateProductSetArgs = {
  input: InputUpdateProductSet;
};


export type MutationUpdateProjectArgs = {
  input: InputProjectUpdate;
};


export type MutationUpdateProjectApprovalConfigArgs = {
  input: InputUpdateProjectApprovalConfig;
};


export type MutationUpdatePublicBillingInfoArgs = {
  input: InputUpdatePublicBillingInfo;
};


export type MutationUpdateResourceStatusArgs = {
  input: InputUpdateResourceStatus;
};


export type MutationUpdateShareLinkCommentsEnabledArgs = {
  input: InputUpdateShareLinkCommentsEnabled;
};


export type MutationUpdateShareLinkDownloadEnabledArgs = {
  input: InputUpdateShareLinkDownloadEnabled;
};


export type MutationUpdateShareVariationSelectionArgs = {
  input: InputUpdateShareVariationSelection;
};


export type MutationUpdateSubscriptionSeatsArgs = {
  input: InputUpdateSubscriptionSeats;
};


export type MutationUpdateSubscriptionV2Args = {
  input: InputUpdateSubscription;
};


export type MutationUpdateSystemAdNetworkArgs = {
  input: InputUpdateSystemAdNetwork;
};


export type MutationUpdateTagContainerAdTagSettingsArgs = {
  input: InputUpdateTagContainerAdTagSettings;
};


export type MutationUpdateTeamArgs = {
  input: InputTeamUpdate;
};


export type MutationUpdateTeamDesignDebugStatusArgs = {
  input: InputTeamDebugStatus;
};


export type MutationUpdateTeamIdentityProviderArgs = {
  input: InputUpdateTeamIdentityProvider;
};


export type MutationUpdateTeamIdentityProviderAutoJoinArgs = {
  input: InputUpdateTeamIdentityProviderAutoJoin;
};


export type MutationUpdateTeamIdentityProviderDomainsArgs = {
  input: InputUpdateTeamIdentityProviderDomains;
};


export type MutationUpdateTeamInvitationArgs = {
  input: InputUpdateTeamInvitation;
};


export type MutationUpdateTeamUserGroupArgs = {
  input: InputUpdateTeamUserGroup;
};


export type MutationUpdateTikTokDpaSettingsArgs = {
  input: UpdateTikTokDpaSettingsInput;
};


export type MutationUpdateUseNewAdStudioArgs = {
  input: InputUpdateUseNewAdStudio;
};


export type MutationUpdateUserOnboardingArgs = {
  input: InputUpdateUserOnboarding;
};


export type MutationUpdateUserSettingsArgs = {
  input: InputUpdateUserSettings;
};


export type MutationUpdateVersionNameArgs = {
  input: InputUpdateVersionName;
};


export type MutationUpdateWorkflowArgs = {
  input: InputUpdateWorkflow;
};


export type MutationUploadBrandKitLogoArgs = {
  input: InputUploadBrandKitLogo;
};


export type MutationUploadCommentAttachmentArgs = {
  input: InputUploadCommentAttachment;
};


export type MutationUploadFontArgs = {
  input: InputUploadFont;
};


export type MutationUploadNextGenLogoArgs = {
  input: InputUploadNextGenLogo;
};


export type MutationUploadNextGenMediaArgs = {
  input: InputUploadNextGenMedia;
};


export type MutationUploadToGoogleDriveArgs = {
  input: InputUploadToGoogleDrive;
};


export type MutationUploadToSharePointArgs = {
  input: InputUploadToSharePoint;
};


export type MutationUpsertDynamicVarsArgs = {
  input: InputUpsertDynamicVars;
};


export type MutationUpsertExternalTrackingUrlsArgs = {
  input: InputUpsertDesignExternalTracking;
};


export type MutationValidateCancellationReasonArgs = {
  input: CancellationReasonValidation;
};


export type MutationWarmDesignedTextChecksArgs = {
  input: InputWarmDesignedTextChecks;
};

/** Arguments for updating a team's favorite status. */
export type MutationUpdateFavouriteTeamArgs = {
  __typename?: 'MutationUpdateFavouriteTeamArgs';
  /** Input for the favorite update. */
  input: FavouriteTeamPayload;
};

export enum NextGenAiFetchedStatus {
  FAILED = 'failed',
  PENDING = 'pending',
  PROCESSING = 'processing',
  SUCCESS = 'success'
}

export enum NextGenAiTemplateCategory {
  DISPLAY = 'DISPLAY',
  PRODUCT_SHOT = 'PRODUCT_SHOT',
  SOCIAL = 'SOCIAL',
  VIDEO = 'VIDEO',
  VIDEO_VERTICAL = 'VIDEO_VERTICAL'
}

export enum NextGenAiTemplateVariant {
  BRAND_TEMPLATE = 'BRAND_TEMPLATE',
  DYNAMIC_LAYOUT = 'DYNAMIC_LAYOUT'
}

export type NextGenBrandDescriptionData = {
  __typename?: 'NextGenBrandDescriptionData';
  data?: Maybe<Scalars['JSON']['output']>;
  fetched: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
};

export type NextGenBrandfetchData = {
  __typename?: 'NextGenBrandfetchData';
  data?: Maybe<Scalars['JSON']['output']>;
  fetched: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
};

export type NextGenBrandfetchInternalData = {
  __typename?: 'NextGenBrandfetchInternalData';
  data?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  status?: Maybe<NextGenAiFetchedStatus>;
};

export type NextGenButtonStyle = {
  __typename?: 'NextGenButtonStyle';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  borderColor?: Maybe<Scalars['String']['output']>;
  borderRadius: Scalars['Int']['output'];
  borderWidth: Scalars['Int']['output'];
  textColor?: Maybe<Scalars['String']['output']>;
};

export type NextGenColors = {
  __typename?: 'NextGenColors';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  buttonColor?: Maybe<Scalars['String']['output']>;
  buttonTextColor?: Maybe<Scalars['String']['output']>;
  descriptionColor?: Maybe<Scalars['String']['output']>;
  headlineColor?: Maybe<Scalars['String']['output']>;
};

export type NextGenFont = {
  __typename?: 'NextGenFont';
  allUrls?: Maybe<Array<NextGenFontUrl>>;
  fontFaceUrl?: Maybe<Scalars['String']['output']>;
  fontStyle: Scalars['String']['output'];
  fontWeight: Scalars['String']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  isBrandKitFont?: Maybe<Scalars['Boolean']['output']>;
  isCustom: Scalars['Boolean']['output'];
  isFallback: Scalars['Boolean']['output'];
  isGoogle: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type NextGenFontUrl = {
  __typename?: 'NextGenFontUrl';
  fontStyle: Scalars['String']['output'];
  fontWeight: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type NextGenFontsData = {
  __typename?: 'NextGenFontsData';
  data?: Maybe<Array<NextGenFont>>;
  fetched: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['Int']['output']>;
};

export type NextGenIdentity = {
  __typename?: 'NextGenIdentity';
  brandTone: Array<Scalars['String']['output']>;
  brandValues: Scalars['String']['output'];
  brandVoice: Scalars['String']['output'];
};

export type NextGenIdentityData = {
  __typename?: 'NextGenIdentityData';
  data?: Maybe<NextGenIdentity>;
  fetched: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['Int']['output']>;
};

export type NextGenLogo = {
  __typename?: 'NextGenLogo';
  favicon?: Maybe<Scalars['String']['output']>;
  logo: Array<NextGenLogoSource>;
};

export type NextGenLogoData = {
  __typename?: 'NextGenLogoData';
  data?: Maybe<NextGenLogo>;
  fetched: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['Int']['output']>;
};

export type NextGenLogoSource = {
  __typename?: 'NextGenLogoSource';
  colors?: Maybe<Array<Scalars['String']['output']>>;
  hash?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  src: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type NextGenMediaData = {
  __typename?: 'NextGenMediaData';
  data?: Maybe<Array<NextGenMediaFile>>;
  fetched: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['Int']['output']>;
};

export type NextGenMediaFile = {
  __typename?: 'NextGenMediaFile';
  /** @deprecated Field no longer supported */
  background?: Maybe<Scalars['String']['output']>;
  backgroundType?: Maybe<ImageBackgroundType>;
  cropArea?: Maybe<NextGenMediaFileCropArea>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  focalPoint?: Maybe<FocalPointResult>;
  generateDescription?: Maybe<Scalars['Boolean']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  useForGenerating?: Maybe<Scalars['Boolean']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type NextGenMediaFileCropArea = {
  __typename?: 'NextGenMediaFileCropArea';
  bottom?: Maybe<Scalars['Int']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  left?: Maybe<Scalars['Int']['output']>;
  right?: Maybe<Scalars['Int']['output']>;
  top?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type NextGenRemBgProcessedMedia = {
  __typename?: 'NextGenRemBGProcessedMedia';
  finalUrl: Scalars['String']['output'];
};

export type NextGenSignedUrlResponse = {
  __typename?: 'NextGenSignedUrlResponse';
  fields: Scalars['JSON']['output'];
  url: Scalars['String']['output'];
};

export type NextGenStyle = {
  __typename?: 'NextGenStyle';
  accentColor: Scalars['String']['output'];
  accentContrastColor: Scalars['String']['output'];
  backgroundColor: Scalars['String']['output'];
  borderRadius: Scalars['Int']['output'];
  brandKitColors?: Maybe<Array<Scalars['String']['output']>>;
  buttonColor?: Maybe<Scalars['String']['output']>;
  buttonStyle?: Maybe<NextGenButtonStyle>;
  buttonTextColor?: Maybe<Scalars['String']['output']>;
  colors: Array<Scalars['String']['output']>;
  descriptionColor?: Maybe<Scalars['String']['output']>;
  headlineColor?: Maybe<Scalars['String']['output']>;
  textColor: Scalars['String']['output'];
};

export type NextGenStyleData = {
  __typename?: 'NextGenStyleData';
  data?: Maybe<NextGenStyle>;
  fetched: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['Int']['output']>;
};

export type NextGenText = {
  __typename?: 'NextGenText';
  essentialText?: Maybe<Scalars['String']['output']>;
  innerText: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
};

export type NextGenTextData = {
  __typename?: 'NextGenTextData';
  data?: Maybe<NextGenText>;
  fetched: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['Int']['output']>;
};

export type NextgenAi = {
  __typename?: 'NextgenAi';
  content?: Maybe<Scalars['JSON']['output']>;
  fetchedBrandDescriptionStatus?: Maybe<NextGenAiFetchedStatus>;
  fetchedBrandStyleStatus?: Maybe<NextGenAiFetchedStatus>;
  fetchedBrandfetchStatus?: Maybe<NextGenAiFetchedStatus>;
  fetchedFontsStatus?: Maybe<NextGenAiFetchedStatus>;
  fetchedIdentityStatus?: Maybe<NextGenAiFetchedStatus>;
  fetchedLogoStatus?: Maybe<NextGenAiFetchedStatus>;
  fetchedMediaStatus?: Maybe<NextGenAiFetchedStatus>;
  fetchedStyleStatus?: Maybe<NextGenAiFetchedStatus>;
  fetchedTextStatus?: Maybe<NextGenAiFetchedStatus>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated can also be null */
  projectId: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
  urlContent?: Maybe<Scalars['JSON']['output']>;
};

export type NextgenAiAdminTemplate = {
  __typename?: 'NextgenAiAdminTemplate';
  category: NextGenAiTemplateCategory;
  id: Scalars['Int']['output'];
  published: Scalars['Boolean']['output'];
  setHash: Scalars['String']['output'];
  setName: Scalars['String']['output'];
  sizesCount: Scalars['Int']['output'];
};

export type NextgenAiDesign = {
  __typename?: 'NextgenAiDesign';
  /** The design to link to and to attach a feed to - the SET itself when this design is one. */
  designId: Scalars['Int']['output'];
  /** The design to link to and to attach a feed to - the SET itself when this design is one. */
  hash: Scalars['String']['output'];
  json?: Maybe<Scalars['JsonDesign']['output']>;
  /** The row that owns the returned json, which is where a write of that json belongs. Present exactly when json is; equal to hash unless the design was born as a set. */
  sizeHash?: Maybe<Scalars['String']['output']>;
  /** The row that owns the returned json, which is the id feed bindings are keyed by. Present exactly when json is; equal to designId unless the design was born as a set. */
  sizeId?: Maybe<Scalars['Int']['output']>;
  sizes: Array<Scalars['String']['output']>;
  uniqueId: Scalars['String']['output'];
};

export enum NextgenAiFetcherType {
  FETCH_AND_UPDATE_ONBOARDING_BRANDKIT_FONTS = 'FETCH_AND_UPDATE_ONBOARDING_BRANDKIT_FONTS',
  FETCH_BRANDFETCH = 'FETCH_BRANDFETCH',
  FETCH_BRAND_DESCRIPTION = 'FETCH_BRAND_DESCRIPTION',
  FETCH_BRAND_STYLE = 'FETCH_BRAND_STYLE',
  FETCH_FONTS = 'FETCH_FONTS',
  FETCH_LOGOS = 'FETCH_LOGOS',
  FETCH_MEDIA = 'FETCH_MEDIA',
  FETCH_ONBOARDING_BRANDKIT_ASSETS = 'FETCH_ONBOARDING_BRANDKIT_ASSETS',
  FETCH_STYLE = 'FETCH_STYLE',
  FETCH_TEXT = 'FETCH_TEXT'
}

export type NextgenAiTemplate = {
  __typename?: 'NextgenAiTemplate';
  hasVideo?: Maybe<Scalars['Boolean']['output']>;
  hash: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isTemplate?: Maybe<Scalars['Boolean']['output']>;
  json: JsonDesignWithHash;
  name?: Maybe<Scalars['String']['output']>;
  properties: TemplateProperties;
  setHash: Scalars['String']['output'];
  setName: Scalars['String']['output'];
  sizes?: Maybe<Scalars['Int']['output']>;
  /** A project template's last save — its preview's version, so the preview URL changes with every save. Null for the layouts, which render from their JSON. */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  width: Scalars['Int']['output'];
};

export type NextgenAiTemplateSize = {
  __typename?: 'NextgenAiTemplateSize';
  designSizeTypeName?: Maybe<Scalars['String']['output']>;
  hash: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};

export enum NextgenAiTemplateType {
  CREATOPY_TEMPLATE = 'CREATOPY_TEMPLATE',
  GENERATED_TEMPLATE = 'GENERATED_TEMPLATE',
  PROJECT_TEMPLATE = 'PROJECT_TEMPLATE'
}

export enum ObjectiveType {
  AWARENESS = 'awareness',
  ENGAGEMENT = 'engagement',
  SALES = 'sales',
  TRAFFIC = 'traffic'
}

export type OnboardingAssistantResponse = {
  __typename?: 'OnboardingAssistantResponse';
  contactLeadAIRecommendation: ContactLeadAiRecommendation;
  suggestedPlan: Scalars['String']['output'];
  topUseCases: Array<Scalars['String']['output']>;
};

export type OnboardingDataType = {
  __typename?: 'OnboardingDataType';
  enterpriseOneMonth?: Maybe<OnboardingFeatureType>;
};


export type OnboardingDataTypeEnterpriseOneMonthArgs = {
  input: InputOnboardingFeatures;
};

export type OnboardingFeatureType = {
  __typename?: 'OnboardingFeatureType';
  isEnabled: Scalars['Boolean']['output'];
};

/**
 * Response after optimizing an image.
 * Contains information about the original and optimized image.
 */
export type OptimizeImagePayload = {
  __typename?: 'OptimizeImagePayload';
  /** Height of the optimized image in pixels (if optimized). */
  newHeight?: Maybe<Scalars['Int']['output']>;
  /** URL to the optimized image (if optimized). */
  newUrl?: Maybe<Scalars['String']['output']>;
  /** Width of the optimized image in pixels (if optimized). */
  newWidth?: Maybe<Scalars['Int']['output']>;
  /** Whether the image was successfully optimized. */
  optimized: Scalars['Boolean']['output'];
  /** Height of the original image in pixels. */
  originalHeight: Scalars['Int']['output'];
  /** Width of the original image in pixels. */
  originalWidth: Scalars['Int']['output'];
};

export enum OrderBy {
  DATE_MODIFIED = 'DATE_MODIFIED',
  NAME = 'NAME'
}

export enum OrderType {
  ASC = 'ASC',
  DESC = 'DESC'
}

/** An edit from the user's AI assistant, as an open editor tab sees it (markEditDesign's outsideEdit). */
export enum OutsideEditState {
  /** Ended after the tab read the design: the tab reloads. */
  DONE = 'DONE',
  NONE = 'NONE',
  /** Running now: the tab waits, and its saves are refused. */
  RUNNING = 'RUNNING'
}

export enum PsdErrorCodes {
  INVALID_COLOR_DEPTH = 'INVALID_COLOR_DEPTH'
}

/** Pagination metadata for cursor-based pagination */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** Cursor pointing to the last item in current results */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Whether there are more items after the current page */
  hasNextPage: Scalars['Boolean']['output'];
};

/** Spending information for a Facebook page */
export type PageSpend = {
  __typename?: 'PageSpend';
  /** Amount spent in the current week */
  currentWeek?: Maybe<Scalars['String']['output']>;
  /** Whether this is a political advertising page */
  isPoliticalPage: Scalars['Boolean']['output'];
  /** Lifetime spending breakdown by disclaimer */
  lifetimeByDisclaimer: Array<SpendDisclaimer>;
  /** Weekly spending breakdown by disclaimer */
  weeklyByDisclaimer: Array<SpendDisclaimer>;
};

export type PaginatedAiAgentAutomatedReportSchedulePayload = {
  __typename?: 'PaginatedAiAgentAutomatedReportSchedulePayload';
  endCursor: Scalars['String']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  items: Array<AiAgentAutomatedReportSchedulePayload>;
};

export type PaginationResults = {
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Parent = {
  __typename?: 'Parent';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  publicHash: Scalars['String']['output'];
  publicStatus: PublicStatus;
  shared: Scalars['Boolean']['output'];
  template?: Maybe<Scalars['Boolean']['output']>;
};

export enum ParseStatus {
  FAILED = 'FAILED',
  NOT_EXISTS = 'NOT_EXISTS',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS'
}

export type ParseTemplate = {
  __typename?: 'ParseTemplate';
  success: Scalars['Boolean']['output'];
};

export type ParseTemplates = {
  __typename?: 'ParseTemplates';
  success: Scalars['Boolean']['output'];
};

export type PartnerDv360 = {
  __typename?: 'PartnerDV360';
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type PartnersDv360Payload = {
  __typename?: 'PartnersDV360Payload';
  items: Array<PartnerDv360>;
};

export type PartnersDv360Input = {
  email: Scalars['String']['input'];
  /** The team whose DV360 account to use, or the caller's own personal one */
  teamId: Scalars['Int']['input'];
};

/** Result of pause eligibility check */
export type PauseEligibilityResult = {
  __typename?: 'PauseEligibilityResult';
  /** Whether the subscription can be paused */
  canPause: Scalars['Boolean']['output'];
  /** Whether this is a yearly subscription */
  isYearly: Scalars['Boolean']['output'];
  /** Available pause duration options */
  pauseOptions: Array<PauseOption>;
  /** Reason code if not eligible */
  reasonCode?: Maybe<Scalars['String']['output']>;
};

/** Pause option available to the user */
export type PauseOption = {
  __typename?: 'PauseOption';
  /** Number of billing cycles */
  cycles: Scalars['Int']['output'];
  /** Translation key for the label */
  labelKey: Scalars['String']['output'];
};

/** Result of pause subscription operation */
export type PauseSubscriptionResult = {
  __typename?: 'PauseSubscriptionResult';
  /** Error message if operation failed */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Number of cycles the subscription is paused for */
  pauseCycles?: Maybe<Scalars['Int']['output']>;
  /** Date when the pause will start (next billing date) */
  pauseStartDate?: Maybe<Scalars['Date']['output']>;
  /** Date when the subscription will automatically resume */
  resumeDate?: Maybe<Scalars['Date']['output']>;
  subscription?: Maybe<RecurlySubscription>;
  success: Scalars['Boolean']['output'];
};

export type PaymentExperiment = {
  __typename?: 'PaymentExperiment';
  experimentId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  teamId?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  cardType?: Maybe<Scalars['String']['output']>;
  lastFour?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
};

export enum PaymentTypes {
  CREDITCARD = 'CREDITCARD',
  PAYPAL = 'PAYPAL'
}

/** Resolution of the images in a PDF standard export: larger images are brought down to it, and PDF/X-1a renders a page that uses transparency at it. */
export enum PdfImageResolution {
  /** 300 dpi: what commercial print asks of an image; the smaller file */
  DPI300 = 'dpi300',
  /** 600 dpi: keeps more of a large photo and small text on a rendered page sharper; up to four times the size */
  DPI600 = 'dpi600'
}

/** Printing condition a PDF standard export is converted to and declares. */
export enum PdfOutputProfile {
  /** GRACoL 2006 Coated 1 (CGATS TR 006): commercial sheetfed printing, North America */
  GRACOL2006_COATED1 = 'gracol2006_coated1',
  /** SWOP 2006 Coated 3 (CGATS TR 003): web offset publication printing, North America */
  SWOP2006_COATED3 = 'swop2006_coated3'
}

/** Print conformance standard a PDF export has to meet. */
export enum PdfStandard {
  PDFX1A = 'pdfx1a',
  PDFX4 = 'pdfx4'
}

export type PendingSubscriptionChange = {
  __typename?: 'PendingSubscriptionChange';
  activateAt: Scalars['Date']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  planCode: Scalars['String']['output'];
  planName: Scalars['String']['output'];
  planPrice?: Maybe<Scalars['Int']['output']>;
};

/** Performance analytics across platforms */
export type PerformanceAnalytics = {
  __typename?: 'PerformanceAnalytics';
  /** Distribution of ads across platforms */
  platformDistribution: Array<PlatformStats>;
};

export enum Permission {
  APPROVE = 'APPROVE',
  DESIGN = 'DESIGN',
  DOWNLOAD_AND_PUBLISH = 'DOWNLOAD_AND_PUBLISH',
  MANAGE_BRANDS = 'MANAGE_BRANDS',
  MANAGE_CATALOG = 'MANAGE_CATALOG',
  MANAGE_FEED = 'MANAGE_FEED',
  MANAGE_PROJECTS = 'MANAGE_PROJECTS',
  MANAGE_TEAMS = 'MANAGE_TEAMS',
  PUBLIC_API = 'PUBLIC_API',
  TEMPLATE = 'TEMPLATE',
  VIEW = 'VIEW'
}

export enum PermissionResource {
  BRAND_CONTROL = 'BRAND_CONTROL',
  BRAND_KIT = 'BRAND_KIT',
  COLOR_PALETTE = 'COLOR_PALETTE',
  DESIGN = 'DESIGN',
  DESIGNS = 'DESIGNS',
  DESIGN_SIZE_TYPE = 'DESIGN_SIZE_TYPE',
  FEED = 'FEED',
  FOLDER = 'FOLDER',
  MEDIA_FOLDER = 'MEDIA_FOLDER',
  MOOD_BOARD = 'MOOD_BOARD',
  PLATFORM_ADS = 'PLATFORM_ADS',
  PROJECT = 'PROJECT',
  TEAM = 'TEAM'
}

export type PersonalIntegrationResult = {
  __typename?: 'PersonalIntegrationResult';
  email: Scalars['String']['output'];
  type: Integrations;
};

export enum PhotoshopAction {
  ASSETS = 'assets',
  DESIGNS = 'designs',
  JSONS = 'jsons',
  STRUCTURE = 'structure'
}

export type PhotoshopDataPayload = {
  __typename?: 'PhotoshopDataPayload';
  /** The project phase 1 queued, when the caller may write to it; send it to processPhotoshopStructure. Null when unknown. */
  projectId?: Maybe<Scalars['Int']['output']>;
  result: Scalars['Boolean']['output'];
};

export type PhotoshopStatusPayload = {
  __typename?: 'PhotoshopStatusPayload';
  errorCode?: Maybe<PsdErrorCodes>;
  status: ParseStatus;
};

export type PinFolderPayload = {
  __typename?: 'PinFolderPayload';
  folderId: Scalars['Int']['output'];
  pinned: Scalars['Boolean']['output'];
};

export type PinnedFolder = {
  __typename?: 'PinnedFolder';
  folder: Folder;
  pos: Scalars['Int']['output'];
};

export type PinnedFolders = {
  __typename?: 'PinnedFolders';
  items: Array<PinnedFolder>;
};

/**
 * An existing DRAFT ad (inside an ad group) a creative can be re-pointed into (reuse).
 * Only drafts: Pinterest allows updating an ad's pin_id only for draft ads.
 */
export type PinterestAd = {
  __typename?: 'PinterestAd';
  adGroupId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type PinterestAdAccount = {
  __typename?: 'PinterestAdAccount';
  country?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  owner?: Maybe<PinterestAdAccountOwner>;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
};

export type PinterestAdAccountOwner = {
  __typename?: 'PinterestAdAccountOwner';
  /** BUSINESS or PINNER — null when the owner profile could not be resolved. */
  accountType?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PinterestAdAccountsInput = {
  /** email = connectedEmail (Pinterest username) */
  email: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

/** An existing Pinterest ad group (inside a campaign) a creative can be published into (reuse). */
export type PinterestAdGroup = {
  __typename?: 'PinterestAdGroup';
  campaignId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type PinterestAdGroupSettingsInput = {
  bidInMicroCurrency?: InputMaybe<Scalars['Int']['input']>;
  /** AUTOMATIC_BID | MAX_BID | TARGET_AVG; omitted = bid set ? MAX_BID : AUTOMATIC_BID */
  bidStrategyType?: InputMaybe<Scalars['String']['input']>;
  /** must match objectiveType */
  billableEvent: Scalars['String']['input'];
  /** required IFF non-CBO objective; omit for CBO */
  budgetInMicroCurrency?: InputMaybe<Scalars['Int']['input']>;
  /** DAILY | LIFETIME - non-CBO ad-group budgets only (no UI yet) */
  budgetType?: InputMaybe<Scalars['String']['input']>;
  /** Parent campaign's objective — required only when creating a new ad group inside a REUSED campaign (there is no campaignSettings then), so the worker can place the budget (CBO vs not). Ignored when creating a new campaign. */
  campaignObjectiveType?: InputMaybe<PinterestObjectiveType>;
  /** unix seconds */
  endTime?: InputMaybe<Scalars['Int']['input']>;
  /** BROAD-match keywords attached after ad-group create */
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  lifetimeFrequencyCap?: InputMaybe<Scalars['Int']['input']>;
  /** Optional ad-group name; the worker auto-generates one when omitted. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** required for WEB_CONVERSION */
  optimizationGoalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  /** STANDARD (default) | ACCELERATED */
  pacingDeliveryType?: InputMaybe<Scalars['String']['input']>;
  /** ALL (default) | SEARCH | BROWSE */
  placementGroup?: InputMaybe<Scalars['String']['input']>;
  /** unix seconds */
  startTime?: InputMaybe<Scalars['Int']['input']>;
  targeting?: InputMaybe<PinterestTargetingInput>;
};

export type PinterestAdGroupsInput = {
  adAccountId: Scalars['String']['input'];
  /** Scope ad groups to a campaign (ad groups are campaign-scoped). */
  campaignId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type PinterestAdSettingsInput = {
  /** When true, sent as ai_disclosures: { values: ['AI_MODIFIED'] } (Pinterest AI-content disclosure). */
  aiModified?: InputMaybe<Scalars['Boolean']['input']>;
  /** Pin alt text, for accessibility/screen readers. */
  altText?: InputMaybe<Scalars['String']['input']>;
  /** Organic board for the pin; omitted = the protected ads-only board (Ad-only Pin). */
  boardId?: InputMaybe<Scalars['String']['input']>;
  clickTrackingUrl?: InputMaybe<Scalars['String']['input']>;
  /** one of Pinterest's customizable CTA types */
  ctaType?: InputMaybe<Scalars['String']['input']>;
  /** Pin description shown on the pin detail page. */
  description?: InputMaybe<Scalars['String']['input']>;
  destinationUrl?: InputMaybe<Scalars['String']['input']>;
  /** CLOSEUP (default) | DIRECT_TO_DESTINATION */
  gridClickType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  viewTrackingUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PinterestAdsInput = {
  adAccountId: Scalars['String']['input'];
  /** Scope ads to an ad group (ads are ad-group-scoped). */
  adGroupId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type PinterestBoard = {
  __typename?: 'PinterestBoard';
  boardId: Scalars['String']['output'];
};

export type PinterestBoardOption = {
  __typename?: 'PinterestBoardOption';
  id: Scalars['String']['output'];
  isAdsOnly: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type PinterestBoardsInput = {
  adAccountId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type PinterestBoardsListInput = {
  adAccountId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export enum PinterestBudgetType {
  DAILY = 'DAILY',
  LIFETIME = 'LIFETIME'
}

/** An existing Pinterest campaign a creative can be published into (reuse). */
export type PinterestCampaign = {
  __typename?: 'PinterestCampaign';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  objectiveType: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type PinterestCampaignSettingsInput = {
  /** DAILY (default) | LIFETIME — which spend cap carries the CBO budget */
  budgetType?: InputMaybe<PinterestBudgetType>;
  /** micro-currency; set on Campaign IFF CBO objective */
  dailySpendCap?: InputMaybe<Scalars['Int']['input']>;
  /** unix seconds */
  endTime?: InputMaybe<Scalars['Int']['input']>;
  /** Pinterest budget adjustments — only valid with DAILY budgets */
  flexibleDailyBudgets?: InputMaybe<Scalars['Boolean']['input']>;
  /** micro-currency; required IFF budgetType LIFETIME (with startTime+endTime) */
  lifetimeSpendCap?: InputMaybe<Scalars['Int']['input']>;
  /** Optional campaign name; the worker auto-generates one when omitted. */
  name?: InputMaybe<Scalars['String']['input']>;
  objectiveType: PinterestObjectiveType;
  /** unix seconds — campaign schedule; both required for LIFETIME budgets */
  startTime?: InputMaybe<Scalars['Int']['input']>;
  status: PinterestEntityStatus;
};

export type PinterestCampaignsInput = {
  adAccountId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

/** A catalog option for the DPA Catalog publish mode's catalog picker. This integration only creates/lists RETAIL catalogs. */
export type PinterestCatalogOption = {
  __typename?: 'PinterestCatalogOption';
  catalogType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PinterestCatalogsInput = {
  adAccountId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

/** A connected Pinterest account's OWN profile (its /v5/user_account) — used to label the account/login row by business name instead of username. */
export type PinterestConnectedAccount = {
  __typename?: 'PinterestConnectedAccount';
  /** BUSINESS or PINNER — null when unresolved. */
  accountType?: Maybe<Scalars['String']['output']>;
  /** Business DISPLAY name from the account's own profile; null for a PINNER or when unresolved. */
  businessName?: Maybe<Scalars['String']['output']>;
  /** connectedEmail (Pinterest username) — the account identity. */
  email: Scalars['String']['output'];
};

export type PinterestConnectedAccountsInput = {
  teamId: Scalars['Int']['input'];
};

export type PinterestConversionTag = {
  __typename?: 'PinterestConversionTag';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PinterestConversionTagsInput = {
  adAccountId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export enum PinterestEntityStatus {
  ACTIVE = 'ACTIVE',
  PAUSED = 'PAUSED'
}

export enum PinterestObjectiveType {
  AWARENESS = 'AWARENESS',
  CONSIDERATION = 'CONSIDERATION',
  WEB_CONVERSION = 'WEB_CONVERSION'
}

export type PinterestPublishErrorInput = {
  code: Scalars['String']['input'];
  message: Scalars['String']['input'];
};

export type PinterestTargetingInput = {
  ageMax?: InputMaybe<Scalars['Int']['input']>;
  ageMin?: InputMaybe<Scalars['Int']['input']>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** lowercase Pinterest gender values: male | female | unknown */
  genders?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Pinterest interest taxonomy ids */
  interestIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ISO-639-1 language codes, e.g. en, de */
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** One taxonomy entry (e.g. an interest) for the targeting pickers. */
export type PinterestTargetingOption = {
  __typename?: 'PinterestTargetingOption';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PinterestTargetingOptionsInput = {
  adAccountId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  /** Pinterest taxonomy type, e.g. INTEREST */
  targetingType: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export enum PlacementType {
  AUTOMATIC = 'AUTOMATIC',
  MANUAL_PADDING = 'MANUAL_PADDING',
  MANUAL_PLACEMENT = 'MANUAL_PLACEMENT',
  ORIGINAL = 'ORIGINAL'
}

export type Plan = {
  __typename?: 'Plan';
  addons: Array<Addon>;
  autoRenew: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  features: PlanFeatures;
  id: Scalars['String']['output'];
  intervalLength: Scalars['Int']['output'];
  minimumEditors?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  planGroup?: Maybe<Scalars['String']['output']>;
  planPrice?: Maybe<Scalars['Int']['output']>;
  properties: PlanProperties;
  totalBillingCycles: Scalars['Int']['output'];
  trialLength: Scalars['Int']['output'];
};

export enum PlanActionType {
  CONTACT = 'contact',
  DEFAULT = 'default',
  FREE = 'free'
}

export type PlanFeatures = {
  __typename?: 'PlanFeatures';
  additional?: Maybe<Array<Scalars['String']['output']>>;
  base?: Maybe<Scalars['String']['output']>;
  bold?: Maybe<Array<Scalars['String']['output']>>;
  color: Scalars['String']['output'];
  dotted?: Maybe<Array<Scalars['String']['output']>>;
  iconColor: Scalars['String']['output'];
  notAvailable?: Maybe<Array<Scalars['String']['output']>>;
  now: Array<Scalars['String']['output']>;
  soon: Array<Scalars['String']['output']>;
};

export type PlanGroup = {
  __typename?: 'PlanGroup';
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  variations: Array<Plan>;
};

export enum PlanName {
  AD_OPTIMIZE = 'AD_OPTIMIZE',
  AD_SERVING = 'AD_SERVING',
  ASSETS = 'ASSETS',
  BASIC = 'BASIC',
  DEMO = 'DEMO',
  FREE = 'FREE',
  FREE_EXPERIMENT = 'FREE_EXPERIMENT',
  PLUS = 'PLUS',
  PLUS_TEMP = 'PLUS_TEMP',
  PREMIUM = 'PREMIUM',
  PRO = 'PRO',
  STANDARD = 'STANDARD',
  TEAM = 'TEAM',
  ULTRA = 'ULTRA',
  UNLIMITED = 'UNLIMITED'
}

export type PlanProperties = {
  __typename?: 'PlanProperties';
  /** Label for the call to action button – translation key */
  actionLabel: Scalars['String']['output'];
  actionType: PlanActionType;
  /** True if plan available for queried team */
  available: Scalars['Boolean']['output'];
  bgColor?: Maybe<Scalars['String']['output']>;
  /** Custom billing label – translation key */
  billingLabel?: Maybe<Scalars['String']['output']>;
  borderColor?: Maybe<Scalars['String']['output']>;
  bottomBgColor?: Maybe<Scalars['String']['output']>;
  bottomColor?: Maybe<Scalars['String']['output']>;
  boxBorderColor?: Maybe<Scalars['String']['output']>;
  buttonBackground?: Maybe<Scalars['String']['output']>;
  buttonBorder?: Maybe<Scalars['String']['output']>;
  buttonColor?: Maybe<Scalars['String']['output']>;
  buttonType: Scalars['String']['output'];
  color: Scalars['String']['output'];
  /** Plan description – translation key */
  description: Scalars['String']['output'];
  descriptionColor: Scalars['String']['output'];
  /** Plan subtitle – translation key */
  subTitle: Scalars['String']['output'];
  titleColor?: Maybe<Scalars['String']['output']>;
  titleGradient?: Maybe<Scalars['String']['output']>;
  upgradeBoxBgColor?: Maybe<Scalars['String']['output']>;
  upgradeBoxTitleColor?: Maybe<Scalars['String']['output']>;
  upgradeCardBackground?: Maybe<Scalars['String']['output']>;
  upgradeCardIllustration?: Maybe<Scalars['String']['output']>;
  upgradeCardSubTitle?: Maybe<Scalars['String']['output']>;
  upgradeCardTitle?: Maybe<Scalars['String']['output']>;
  upgradeCardTitleColor?: Maybe<Scalars['String']['output']>;
};

/** Supported advertising platforms for brand and ad analysis */
export enum Platform {
  /**
   * Deprecated: Use META instead
   * @deprecated Use META instead
   */
  FACEBOOK = 'FACEBOOK',
  /** Google Ads platform */
  GOOGLE = 'GOOGLE',
  /** LinkedIn advertising platform */
  LINKEDIN = 'LINKEDIN',
  /** Meta platforms (Facebook, Instagram, Messenger) */
  META = 'META'
}

export type PlatformAd = {
  __typename?: 'PlatformAd';
  adArchiveId: Scalars['String']['output'];
  brandKitId: Scalars['Int']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  platform: Scalars['String']['output'];
};

export type PlatformAdInput = {
  adArchiveId: Scalars['String']['input'];
  /** @deprecated Use projectId instead */
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  platform: Scalars['String']['input'];
  /** Project ID for context @BreakingBad */
  projectId: Scalars['Int']['input'];
};

/** Platform-specific statistics */
export type PlatformStats = {
  __typename?: 'PlatformStats';
  /** Number of ads on this platform */
  count: Scalars['Int']['output'];
  /** Percentage of total ads on this platform */
  percentage: Scalars['Float']['output'];
  /** Platform name */
  platform: Scalars['String']['output'];
};

/** Result returned immediately after kicking off brand kit population. */
export type PopulateBrandKitResult = {
  __typename?: 'PopulateBrandKitResult';
  /** ID of the brand kit being populated. */
  brandKitId: Scalars['Int']['output'];
  /** ID of the NextgenAi record tracking the extraction jobs. */
  nextgenAiId: Scalars['Int']['output'];
  /**
   * True when this call populated a brand kit that already existed — the one
   * named by the input's brandKitId, or the team's kit for the same domain —
   * rather than creating one. A client that discards an abandoned setup must
   * only delete a kit this call created.
   */
  reusedExisting: Scalars['Boolean']['output'];
};

export type PremiumAssetsUsageResult = {
  __typename?: 'PremiumAssetsUsageResult';
  result?: Maybe<Plan>;
};

/** Data for presigned post uploads (used for team logos). */
export type PresignedPost = {
  __typename?: 'PresignedPost';
  /** Fields to include in the form submission. */
  fields: Scalars['JSON']['output'];
  /** URL to post the file to. */
  url: Scalars['String']['output'];
};

export type PreviewCheckoutPayload = {
  __typename?: 'PreviewCheckoutPayload';
  /** Real account balance/credits (negative = credits available) */
  accountBalance?: Maybe<Scalars['Float']['output']>;
  /** Coupon information if a coupon was applied */
  couponInfo?: Maybe<CouponInfo>;
  detailed?: Maybe<Detailed>;
  discount: Scalars['Float']['output'];
  nextPayment: Scalars['Float']['output'];
  proratedCredits: Scalars['Float']['output'];
  proratedPrice: Scalars['Float']['output'];
  tax?: Maybe<Tax>;
  total: Scalars['Float']['output'];
};

export type PreviewSubscriptionChangePayload = {
  __typename?: 'PreviewSubscriptionChangePayload';
  discount: Scalars['Float']['output'];
  nextPayment: Scalars['Float']['output'];
  proratedCredits: Scalars['Float']['output'];
  proratedPrice: Scalars['Float']['output'];
};

export type PreviewTopUpCreditsPayload = {
  __typename?: 'PreviewTopUpCreditsPayload';
  credits?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  success: Scalars['Boolean']['output'];
  tax?: Maybe<Tax>;
  total?: Maybe<Scalars['Float']['output']>;
  unitAmount?: Maybe<Scalars['Float']['output']>;
};

export type PricingAbTestPayload = {
  __typename?: 'PricingAbTestPayload';
  version: Scalars['Int']['output'];
};

export enum PrintColorProfile {
  CMYK = 'cmyk',
  RGB = 'rgb'
}

export type ProcessPhotoshopStructurePayload = {
  __typename?: 'ProcessPhotoshopStructurePayload';
  result: Scalars['Boolean']['output'];
};

export type ProcessRecurlyWebhookInput = {
  recurlyEvent: Event;
};

/** Represents a card that was processed and received a new hash during save */
export type ProcessedCardUpdate = {
  __typename?: 'ProcessedCardUpdate';
  /** The new hash assigned to the card */
  hash: Scalars['String']['output'];
  /** The card ID */
  id: Scalars['String']['output'];
  /** The media's permanent link, set when the card's url was a temporary upload link */
  url?: Maybe<Scalars['String']['output']>;
};

export enum ProductPhotographyOption {
  PRESERVE_CONTENT = 'PRESERVE_CONTENT',
  USE_AS_INSPIRATION = 'USE_AS_INSPIRATION'
}

/**
 * A product set (CRE-418, §4.5): a named group of a catalog's products.
 * dynamic = rules evaluated at read time; static = stored members; smart =
 * worker-maintained per sync run (CRE-417 — on_offer is evaluated at read
 * time). The default "All products" set is virtual — not a row here.
 */
export type ProductSet = {
  __typename?: 'ProductSet';
  /** Null for a source-managed set — we never created it */
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** The set is gone at Meta. Its row and source id are KEPT — designs bind to it through design_feed.product_set_id (D24) */
  deletedAtSource?: Maybe<Scalars['Boolean']['output']>;
  /** Local product_set row. NULL for a set that lives only at the source (Meta-managed catalogs), until a design attaches it and mints the anchor */
  id?: Maybe<Scalars['Int']['output']>;
  /** set_too_large | catalog_full — the ceiling this set hit, so the disabled Import button can name it. Same lowercase-String reasoning as importState */
  importBlockedReason?: Maybe<Scalars['String']['output']>;
  /** Why the import failed: the CATALOG's own error (there is no per-set one), or the 'import_timed_out' marker for a run that never started */
  importError?: Maybe<Scalars['String']['output']>;
  /** pending | imported | failed. Null for a set nobody has imported — it has no local row, so no state, and the tab offers an Import button rather than a status. A String, not an enum: the shipped Sets table compares these lowercase values verbatim */
  importState?: Maybe<Scalars['String']['output']>;
  /** True for the automatic filterless 'All products' set a source platform exposes */
  isAllProducts: Scalars['Boolean']['output'];
  /** The user may import this set now. False alone says nothing about why — importBlockedReason does */
  isImportable?: Maybe<Scalars['Boolean']['output']>;
  /** Live member count — resolved against the merged products (D25), or as the source reports it for a source-managed set */
  matchCount: Scalars['Int']['output'];
  /** Dynamic sets only — how the rule list combines (CRE-423); resolved from the row, defaulting to ALL */
  matchMode?: Maybe<ProductSetMatchMode>;
  /** Static sets only — the user-picked productKeys */
  members?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  /** Dynamic sets only — the rule list */
  rules?: Maybe<Array<ProductSetRule>>;
  /** Set for smart sets only */
  smartKind?: Maybe<ProductSetSmartKind>;
  /** Id of the set at the catalog's source platform it is definition-synced from (CRE-423; provider = the catalog's sourceType — Meta today). Non-null renders the 'Synced from <provider>' badge; such sets are edited at the source, not here */
  sourceProductSetId?: Maybe<Scalars['String']['output']>;
  /** Null for a source-managed set — its definition is not stored here */
  type?: Maybe<ProductSetType>;
  /**
   * DEPRECATED, always false: no producer can set it since on-demand set import landed (#3785) — sets import without their filter ever being evaluated. Kept (constant false) one release cycle for deploy skew: already-loaded clients still select it. Remove after no deployed client does (follow-up to #3788).
   * @deprecated Always false — no producer since on-demand set import. Stop selecting; field is removed next cycle.
   */
  unsupportedFilter: Scalars['Boolean']['output'];
  /** Number of designs rendering this set (design_feed.product_set_id, D24) */
  usedInCount: Scalars['Int']['output'];
};

/** How a dynamic set's rules combine (CRE-423): all = every rule must match (AND, the default), any = at least one (OR) */
export enum ProductSetMatchMode {
  ALL = 'all',
  ANY = 'any'
}

/**
 * One structured condition of a dynamic set (§4.5), combined per the set's
 * matchMode. field is a source column name or a virtual field: 'tag' (product
 * tags), 'readiness' (the product's derived typed-IMAGE readiness),
 * 'availability' (the availability-like column). A catalog without IMAGE
 * columns matches no readiness rule. 'values' is the candidate set for
 * is_any/is_not_any (required by those ops, ignored by every other op).
 */
export type ProductSetRule = {
  __typename?: 'ProductSetRule';
  /** Price rules only: ISO currency of the amount (CM parity) */
  currency?: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
  op: ProductSetRuleOp;
  value: Scalars['String']['output'];
  values?: Maybe<Array<Scalars['String']['output']>>;
};

/**
 * Rule operators (§4.5) — gt/lt are the spec's '>'/'<'. CRE-423 adds gte/lte
 * (inclusive numeric), not_contains (negated contains), and is_any/is_not_any
 * (equality against any of a rule's 'values').
 */
export enum ProductSetRuleOp {
  CONTAINS = 'contains',
  GT = 'gt',
  GTE = 'gte',
  IS = 'is',
  IS_ANY = 'is_any',
  IS_NOT = 'is_not',
  IS_NOT_ANY = 'is_not_any',
  LT = 'lt',
  LTE = 'lte',
  NOT_CONTAINS = 'not_contains'
}

/** Smart set kinds (CRE-417, D13) — best_sellers is deferred */
export enum ProductSetSmartKind {
  BACK_IN_STOCK = 'back_in_stock',
  NEW_THIS_WEEK = 'new_this_week',
  ON_OFFER = 'on_offer'
}

export enum ProductSetType {
  DYNAMIC = 'dynamic',
  SMART = 'smart',
  STATIC = 'static'
}

export type ProductUpdate = {
  __typename?: 'ProductUpdate';
  datePublished?: Maybe<Scalars['Date']['output']>;
  description: Scalars['String']['output'];
  fileHash?: Maybe<Scalars['String']['output']>;
  fileType?: Maybe<MediaType>;
  id: Scalars['Int']['output'];
  standalone: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type ProductUpdateAudience = {
  __typename?: 'ProductUpdateAudience';
  planGroups?: Maybe<Array<Scalars['String']['output']>>;
  planVersions?: Maybe<Array<Scalars['Int']['output']>>;
  statsigExperiment?: Maybe<ProductUpdateAudienceExperiment>;
  statsigGate?: Maybe<Scalars['String']['output']>;
};

export type ProductUpdateAudienceExperiment = {
  __typename?: 'ProductUpdateAudienceExperiment';
  group: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

export type ProductUpdateResult = {
  __typename?: 'ProductUpdateResult';
  hasMajorUpdate: Scalars['Boolean']['output'];
  hasNewUpdates: Scalars['Boolean']['output'];
  updates: Array<ProductUpdate>;
};

export enum ProductUpdateVersion {
  MAJOR = 'Major',
  MINOR = 'Minor'
}

/**
 * A project in Creatopy, representing a collection of designs and folders.
 * Projects are used to organize work and can be shared with team members.
 */
export type Project = {
  __typename?: 'Project';
  /** Whether designs in this project can be shared. */
  allowSharing: Scalars['Boolean']['output'];
  /** The approval workflow configuration for this project. */
  approvalConfig?: Maybe<ApprovalConfig>;
  /** Brand kit associated with the project. */
  brandKit?: Maybe<BrandKit>;
  /** Theme color of the project. */
  color?: Maybe<Scalars['String']['output']>;
  /** ID of the user who created the project. */
  createdBy?: Maybe<Scalars['Int']['output']>;
  /** Description of the project. */
  description?: Maybe<Scalars['String']['output']>;
  /** Number of designs in the project. */
  designsCount: Scalars['Int']['output'];
  /** When the project was marked as favorite by the current user. */
  favoredAt?: Maybe<Scalars['Date']['output']>;
  /** User groups with access to the project. */
  groups: Array<TeamUserGroup>;
  /** Unique identifier for the project. */
  id: Scalars['Int']['output'];
  /** Whether the project was created without a brand kit: its kit is hidden and read-only. */
  isBrandKitHidden: Scalars['Boolean']['output'];
  /** Whether users can select a brand kit for this project. */
  isBrandKitSelectable: Scalars['Boolean']['output'];
  /** URL to the project's logo. */
  logo?: Maybe<Scalars['String']['output']>;
  /**
   * Whether this is the main project (deprecated).
   * @deprecated Field no longer supported
   */
  main: Scalars['Boolean']['output'];
  /** Maximum design size in MB allowed for this project. */
  maxDesignSize?: Maybe<Scalars['Float']['output']>;
  /** Team members with access to the project. */
  members: Array<TeamUser>;
  /** Name of the project. */
  name: Scalars['String']['output'];
  /** Whether this workspace uses the new Ad Studio BETA. One-way: it is never turned off. */
  newAdStudioBeta: Scalars['Boolean']['output'];
  /** When the project was last used by the current user. */
  recentlyUsedAt?: Maybe<Scalars['Date']['output']>;
  /** Whether all team members have access to this project. */
  teamAccess: Scalars['Boolean']['output'];
  /** ID of the team that owns this project. */
  teamId: Scalars['Int']['output'];
  /** Whether project calculations include unarchived designs. */
  unarchivedEstimation: Scalars['Boolean']['output'];
  /** When the project was last updated. */
  updatedAt: Scalars['Date']['output'];
};

/** Association between a project and a design. */
export type ProjectDesign = {
  __typename?: 'ProjectDesign';
  /** ID of the design. */
  designId: Scalars['Int']['output'];
  /** ID of the folder containing the design (if any). */
  folderId?: Maybe<Scalars['Int']['output']>;
  /** Whether the parent folder or project has been deleted. */
  parentDeleted: Scalars['Boolean']['output'];
  /** ID of the project. */
  projectId: Scalars['Int']['output'];
};

export type ProjectDesignTemplateType = {
  __typename?: 'ProjectDesignTemplateType';
  animated: Scalars['Boolean']['output'];
  hash: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** The template's last save, which a save of any of its sizes moves — its thumbnail's version, so its URL changes with every save. */
  updatedAt: Scalars['Date']['output'];
};

export type ProjectDesignTemplatesPayload = {
  __typename?: 'ProjectDesignTemplatesPayload';
  templates: Array<ProjectDesignTemplateType>;
};

/** Response containing project designs. */
export type ProjectDesignsPayload = {
  __typename?: 'ProjectDesignsPayload';
  /** List of designs in the project. */
  nodes: Array<Design>;
};

/** Response containing a project. */
export type ProjectPayload = {
  __typename?: 'ProjectPayload';
  /** The project data. */
  project: Project;
};

/** Paginated results of projects. */
export type ProjectsResults = PaginationResults & {
  __typename?: 'ProjectsResults';
  /** List of projects for the current page. */
  nodes: Array<Project>;
  /** Pagination information. */
  pageInfo: PageInfo;
  /** Total count of projects. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Response containing project shortcuts. */
export type ProjectsShortcutsResults = {
  __typename?: 'ProjectsShortcutsResults';
  /** List of project shortcuts. */
  nodes: Array<Project>;
};

/**
 * Response from propagateSizesToVariations. `masterMissingSizeTypeIds` lists
 * requested sizes whose MASTER child was not persisted yet (autosave still in
 * flight) - nothing was propagated for those and the caller may retry them.
 */
export type PropagateSizesToVariationsPayload = {
  __typename?: 'PropagateSizesToVariationsPayload';
  masterMissingSizeTypeIds: Array<Scalars['Int']['output']>;
  results: Array<VariationSizePropagation>;
};

export type PropagatedSize = {
  __typename?: 'PropagatedSize';
  /** The created variation child. Null unless status is CREATED. */
  createdDesign?: Maybe<Design>;
  designSizeTypeId: Scalars['Int']['output'];
  /** Merge path used (template = id-based, template_similarity = semantic). Null when nothing ran. */
  resizeType?: Maybe<ResizeWithTemplateType>;
  status: PropagatedSizeStatus;
};

/** Per-size outcome of propagating a master size into one variation set. */
export enum PropagatedSizeStatus {
  /** The variation already had this size - left untouched (idempotent skip). */
  ALREADY_PRESENT = 'ALREADY_PRESENT',
  /** The size was created in the variation (master layout + variation content). */
  CREATED = 'CREATED',
  /** The merge/persist failed for this size in this variation (isolated). */
  FAILED = 'FAILED'
}

/** Properties associated with a team invitation. */
export type Properties = {
  __typename?: 'Properties';
  /** IDs of designs the invited user will have access to. */
  designIds: Array<Maybe<Scalars['Int']['output']>>;
  /** IDs of folders the invited user will have access to. */
  folderIds: Array<Maybe<Scalars['Int']['output']>>;
  /** IDs of projects the invited user will have access to. */
  projectIds: Array<Maybe<Scalars['Int']['output']>>;
};

export enum ProviderType {
  OIDC = 'OIDC',
  SAML = 'SAML'
}

export enum PsdBundleMode {
  MULTI_ARTBOARD = 'MULTI_ARTBOARD',
  ZIP = 'ZIP'
}

/** Input for retrieving detailed information about a specific ad */
export type PublicAdDetailsInput = {
  /** Unique ad identifier */
  adId: Scalars['String']['input'];
  /** Brand/page ID on the specific platform */
  brandId: Scalars['String']['input'];
  /** Country code for geo-specific ad details */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Platform where the ad is published */
  platform: Platform;
};

/** Input for getting ad count statistics for a brand */
export type PublicBrandAdsCountInput = {
  /** Internal brand competitor ID */
  brandId: Scalars['Int']['input'];
};

/** Input for retrieving ads from a specific brand */
export type PublicBrandAdsInput = {
  /** Brand/page ID on the specific platform */
  brandId: Scalars['String']['input'];
  /** Country filter for ads (ISO country code, e.g., 'US', 'CA') */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Pagination token for retrieving next batch of results */
  nextPageToken?: InputMaybe<Scalars['String']['input']>;
  /** Platform to search for ads */
  platform: Platform;
};

export type PublicFeedData = {
  __typename?: 'PublicFeedData';
  columns?: Maybe<Array<FeedColumn>>;
  /** @deprecated Use feedJson */
  feedData: FeedData;
  feedJson: Scalars['FeedJson']['output'];
  hash: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Display name of the scoping product set. Null when unscoped. */
  productSetName?: Maybe<Scalars['String']['output']>;
  /** Absolute payload indices of the design's product-set members (ascending) when the shared MIRRORED design is scoped. The payload itself stays complete — these annotate it. Null when unscoped, the set is unresolvable, or it matches nothing. */
  rowIndices?: Maybe<Array<Scalars['Int']['output']>>;
  rows?: Maybe<Scalars['Int']['output']>;
  sourceType?: Maybe<FeedSourceType>;
  status?: Maybe<FeedStatus>;
  targetColumn?: Maybe<Scalars['String']['output']>;
};


export type PublicFeedDataColumnsArgs = {
  input?: InputMaybe<InputFeeds>;
};

export type PublicLinkPayload = {
  __typename?: 'PublicLinkPayload';
  hash: Scalars['String']['output'];
};

export type PublicResourcePayload = Design | Folder;

export enum PublicStatus {
  PRIVATE = 'private',
  PUBLIC = 'public'
}

/** Public information about a team. */
export type PublicTeamDetailsResult = {
  __typename?: 'PublicTeamDetailsResult';
  /** Name of the team. */
  name: Scalars['String']['output'];
};

/** One target's merged result. Null when nothing cleared the matcher. */
export type PublicTemplateResizeResult = {
  __typename?: 'PublicTemplateResizeResult';
  /** Layout-similarity score in [0, 1]. */
  confidence: Scalars['Float']['output'];
  jsonDesign: Scalars['JSON']['output'];
  matchedDesignId: Scalars['Int']['output'];
};

export type PublishCreativeCm360Input = {
  advertiserId: Scalars['String']['input'];
  /** @BreakingBad */
  creativeType: PublishingCreativeType;
  designId: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  /** @BreakingBad */
  exportSettings?: InputMaybe<AdPublishingExportSettings>;
  profileId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type PublishCreativeCm360Payload = {
  __typename?: 'PublishCreativeCm360Payload';
  jobId: Scalars['String']['output'];
};

export type PublishCreativeDv360Input = {
  advertiserId: Scalars['String']['input'];
  creativeType: PublishingCreativeType;
  designId: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  exportSettings: AdPublishingExportSettingsDv360;
  teamId: Scalars['Int']['input'];
};

export type PublishCreativeDv360Payload = {
  __typename?: 'PublishCreativeDV360Payload';
  jobId: Scalars['String']['output'];
};

export type PublishDpaCatalogInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  adAccountId?: InputMaybe<Scalars['String']['input']>;
  businessId?: InputMaybe<Scalars['String']['input']>;
  catalogId?: InputMaybe<Scalars['String']['input']>;
  catalogPublishMode?: InputMaybe<CatalogPublishMode>;
  createDraftFbCampaign?: InputMaybe<Scalars['Boolean']['input']>;
  designHash: Scalars['String']['input'];
  feedId?: InputMaybe<Scalars['Int']['input']>;
  forceUpdateJson?: InputMaybe<Scalars['Boolean']['input']>;
  includeVideos?: InputMaybe<Scalars['Boolean']['input']>;
  newCatalogName?: InputMaybe<Scalars['String']['input']>;
  pageId?: InputMaybe<Scalars['String']['input']>;
  skipSettingsUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  supplementary?: InputMaybe<Scalars['Boolean']['input']>;
  /** Writes the 4:5 and 9:16 renders into the catalog CSV with Meta's placement tags. A catalog publish saves the choice on the design's Meta settings for auto-sync to replay; leave it out (a link-only publish) to keep the saved choice. */
  tagImagesForPlacements?: InputMaybe<Scalars['Boolean']['input']>;
  teamId: Scalars['Int']['input'];
  type?: InputMaybe<DpaPlatformType>;
};

export type PublishDpaCatalogResponse = {
  __typename?: 'PublishDpaCatalogResponse';
  cost?: Maybe<Scalars['Int']['output']>;
  csvUrl?: Maybe<Scalars['String']['output']>;
  jobId?: Maybe<Scalars['String']['output']>;
  queueName?: Maybe<Scalars['String']['output']>;
};

export type PublishErrorInput = {
  code: Scalars['String']['input'];
  message: Scalars['String']['input'];
};

/**
 * Main input for publishing Google Ads campaigns from Creatopy designs
 *
 * This union type supports different campaign types (Performance Max, Display, Search).
 * Provide the campaign type discriminator and the corresponding type-specific input.
 */
export type PublishGoogleAdsCampaignInput = {
  /** Google Ads account ID where the campaign exists */
  adAccountId: Scalars['String']['input'];
  /** Campaign ID where the ad will be created */
  campaignId: Scalars['String']['input'];
  /** Discriminator field specifying the campaign type */
  campaignType: GoogleAdsCampaignType;
  /** Creatopy design ID to use for creating the ad creative */
  designId: Scalars['Int']['input'];
  /** Configuration for Display campaigns (use when campaignType = DISPLAY) */
  display?: InputMaybe<PublishGoogleAdsDisplayInput>;
  /** Email of the Google Ads account */
  email: Scalars['String']['input'];
  /** Manager account ID */
  managerId?: InputMaybe<Scalars['String']['input']>;
  /** Configuration for Performance Max campaigns (use when campaignType = PERFORMANCE_MAX) */
  performanceMax?: InputMaybe<PublishGoogleAdsPerformanceMaxInput>;
  /** Team ID for access control and billing */
  teamId: Scalars['Int']['input'];
};

/** Response returned after successfully submitting a Google Ads campaign publish request */
export type PublishGoogleAdsCampaignResponse = {
  __typename?: 'PublishGoogleAdsCampaignResponse';
  /** Job ID for tracking the asynchronous campaign publishing process */
  jobId: Scalars['String']['output'];
};

/** Base input fields common to all Display campaign ad types */
export type PublishGoogleAdsDisplayBaseInput = {
  /** Ad group ID where the ad will be created (optional - if not provided, a new ad group will be created) */
  adGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Name for the ad group (used when creating a new ad group, defaults to design name if not provided) */
  adGroupName?: InputMaybe<Scalars['String']['input']>;
  /** Custom name for the ad (defaults to design name if not provided) */
  adName?: InputMaybe<Scalars['String']['input']>;
  /** Final URL where users will be directed when they click the ad */
  finalUrl: Scalars['String']['input'];
};

/**
 * Union input for Display campaign ad types
 *
 * Use this to specify which type of Display ad to create along with
 * the type-specific configuration. Only one of the ad type inputs
 * should be provided based on the adType field.
 */
export type PublishGoogleAdsDisplayInput = {
  /** Discriminator field specifying which type of Display ad to create */
  adType: GoogleAdsAdType;
  /** Configuration for Responsive Display Ad (use when adType = RESPONSIVE_DISPLAY_AD) */
  responsiveDisplayAd?: InputMaybe<PublishGoogleAdsResponsiveDisplayInput>;
  /** Configuration for Image Ad (use when adType = IMAGE_AD or HTML5_UPLOAD_AD) */
  uploadAd?: InputMaybe<PublishGoogleAdsUploadInput>;
};

/**
 * Input for Performance Max campaign asset creation
 *
 * Performance Max campaigns use machine learning to optimize ad placement across
 * all Google channels (Search, Display, YouTube, Gmail, Maps, etc.)
 *
 * Image Requirements:
 * - Landscape Image (1.91:1 ratio): Required - min 600x314, recommended 1200x628
 * - Square Image (1:1 ratio): Required - min 300x300, recommended 1200x1200
 * - Logo Square (1:1 ratio): Required - min 128x128, recommended 1200x1200
 * - Logo Landscape (4:1 ratio): Optional - min 512x128, recommended 1200x300
 * - Portrait Image (4:5 ratio): Optional - min 480x600, recommended 960x1200
 */
export type PublishGoogleAdsPerformanceMaxInput = {
  /** Custom name for the image asset (defaults to design name if not provided) */
  adName?: InputMaybe<Scalars['String']['input']>;
  /** Specific asset field type for the image (MARKETING_IMAGE, SQUARE_MARKETING_IMAGE, etc.) */
  assetFieldType?: InputMaybe<Scalars['String']['input']>;
  /** Asset group ID to add the image asset to */
  assetGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Asset group name to add the image asset to */
  assetGroupName?: InputMaybe<Scalars['String']['input']>;
  /** Business name displayed in the ad */
  businessName?: InputMaybe<Scalars['String']['input']>;
  /** Descriptions (1-5 required, max 90 characters each) */
  descriptions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Final URL where users will be directed when they click the ad */
  finalUrl?: InputMaybe<Scalars['String']['input']>;
  /** Short headlines (1-5 required, max 30 characters each) */
  headlines?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Long headlines (1-5 required, max 90 characters each) */
  longHeadlines?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Logo image assets */
  uploadedLogos?: InputMaybe<Array<UploadedLogoInput>>;
};

/**
 * Input for Responsive Display Ad creation
 *
 * Responsive Display Ads automatically adjust size, appearance, and format
 * to fit available ad spaces across the Google Display Network.
 *
 * Required Image Types:
 * - Landscape Image (1.91:1 ratio): min 600x314, recommended 1200x628
 * - Square Image (1:1 ratio): min 300x300, recommended 1200x1200
 * - Logo Square (1:1 ratio): min 128x128, recommended 1200x1200
 *
 * Optional Image Types:
 * - Portrait Image (9:16 ratio): min 600x1067, recommended 1200x2133
 * - Logo Landscape (4:1 ratio): min 512x128, recommended 1200x300
 */
export type PublishGoogleAdsResponsiveDisplayInput = {
  /** Ad group ID where the ad will be created (optional - if not provided, a new ad group will be created) */
  adGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Name for the ad group (used when creating a new ad group, defaults to design name if not provided) */
  adGroupName?: InputMaybe<Scalars['String']['input']>;
  /** Custom name for the ad (defaults to design name if not provided) */
  adName?: InputMaybe<Scalars['String']['input']>;
  /** Business name displayed in the ad (required for branding) */
  businessName: Scalars['String']['input'];
  /** Descriptions (1-5 required, max 90 characters each) */
  descriptions: Array<Scalars['String']['input']>;
  /** Final URL where users will be directed when they click the ad */
  finalUrl: Scalars['String']['input'];
  /** Short headlines (1-5 required, max 30 characters each) */
  headlines: Array<Scalars['String']['input']>;
  /** Long headlines (1-5 required, max 90 characters each) */
  longHeadlines: Array<Scalars['String']['input']>;
};

/**
 * Input for Image Ad creation
 *
 * Image Ads use specific predefined sizes for display placements.
 * The design must match one of Google's supported image ad dimensions.
 *
 * Supported sizes include: 300x250, 728x90, 160x600, 320x50, 468x60,
 * 970x250, 336x280, 320x100, 970x90, 300x600, 250x250, 200x200
 */
export type PublishGoogleAdsUploadInput = {
  /** Ad group ID where the ad will be created (optional - if not provided, a new ad group will be created) */
  adGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Name for the ad group (used when creating a new ad group, defaults to design name if not provided) */
  adGroupName?: InputMaybe<Scalars['String']['input']>;
  /** Custom name for the ad (defaults to design name if not provided) */
  adName?: InputMaybe<Scalars['String']['input']>;
  /** Final URL where users will be directed when they click the ad */
  finalUrl: Scalars['String']['input'];
  /** Format of the ad (HTML5, JPG, PNG, etc.) */
  format?: InputMaybe<Scalars['String']['input']>;
  imageQuality?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Input for publishing a Creatopy design as a LinkedIn sponsored creative.
 *
 * The ad account / organization / campaign selections are threaded as
 * mutation INPUTS into the job payload (Google Ads pattern), NOT via
 * DpaSettings.platformSettings.
 */
export type PublishLinkedInCampaignInput = {
  /** Settings to create the campaign group (the Campaign level) when campaignGroupUrn is absent. */
  campaignGroupSettings?: InputMaybe<LinkedInCampaignGroupSettingsInput>;
  /** Existing campaign group URN the new campaign is created under (urn:li:sponsoredCampaignGroup:{id}). */
  campaignGroupUrn?: InputMaybe<Scalars['String']['input']>;
  /** Settings to create the campaign (the Ad set level) when campaignUrn is absent. */
  campaignSettings?: InputMaybe<LinkedInCampaignSettingsInput>;
  /** Existing campaign URN to publish into (urn:li:sponsoredCampaign:{id}). Omit + set campaignSettings to create one. */
  campaignUrn?: InputMaybe<Scalars['String']['input']>;
  /** Post commentary text */
  commentary: Scalars['String']['input'];
  /** Creative type discriminator (Phase 1: IMAGE only) */
  creativeType: PublishingCreativeType;
  /** Call-to-action label (optional) */
  ctaLabel?: InputMaybe<Scalars['String']['input']>;
  /** Creatopy design ID to use for creating the ad creative */
  designId: Scalars['Int']['input'];
  /** Email of the LinkedIn account (resolves the CloudIntegration row) */
  email: Scalars['String']['input'];
  /** Landing-page destination URL (optional) */
  landingPage?: InputMaybe<Scalars['String']['input']>;
  /** Selected DSC author organization URN (urn:li:organization:{id}) */
  organizationUrn: Scalars['String']['input'];
  /** Selected sponsored ad account URN (urn:li:sponsoredAccount:{id}) */
  sponsoredAccountUrn: Scalars['String']['input'];
  /** Team ID for access control and billing */
  teamId: Scalars['Int']['input'];
};

/** Response returned after submitting a LinkedIn publish request */
export type PublishLinkedInCampaignResponse = {
  __typename?: 'PublishLinkedInCampaignResponse';
  /** Job ID for tracking the asynchronous publish flow */
  jobId: Scalars['String']['output'];
};

export type PublishPinterestCampaignInput = {
  adAccountId: Scalars['String']['input'];
  /** Reuse an existing ad group (with its parent campaignId; skip both creates). Omit + set adGroupSettings to create one. */
  adGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Required only when creating the ad group (adGroupId absent). Set campaignObjectiveType inside it when the parent campaign is reused. */
  adGroupSettings?: InputMaybe<PinterestAdGroupSettingsInput>;
  /** Re-point an existing DRAFT ad (inside the reused adGroupId) at the new pin instead of creating an ad. Requires adGroupId and a single-size design. */
  adId?: InputMaybe<Scalars['String']['input']>;
  adSettings: PinterestAdSettingsInput;
  /** Reuse an existing campaign (skip campaign create). Omit + set campaignSettings to create one. */
  campaignId?: InputMaybe<Scalars['String']['input']>;
  /** Required only when creating the campaign (campaignId absent). */
  campaignSettings?: InputMaybe<PinterestCampaignSettingsInput>;
  designHash: Scalars['String']['input'];
  /** connectedEmail (Pinterest username) */
  email: Scalars['String']['input'];
  /** True for a Pin-only (organic) publish: creates a single Pin on adSettings.boardId, no campaign/ad-group/ad entities. Mutually exclusive with campaignId/adGroupId/adId. */
  pinOnly?: InputMaybe<Scalars['Boolean']['input']>;
  teamId: Scalars['Int']['input'];
};

export type PublishPinterestCampaignPayload = {
  __typename?: 'PublishPinterestCampaignPayload';
  campaignId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

export type PublishPinterestCatalogInput = {
  /** Unused in URL mode (type: pinterest_url); the ad account that owns the catalog in DPA mode (type: pinterest). */
  adAccountId?: InputMaybe<Scalars['String']['input']>;
  /** Reuse an existing Pinterest catalog (DPA mode only). Omit to let the worker resolve/create one by name. */
  catalogId?: InputMaybe<Scalars['String']['input']>;
  designHash: Scalars['String']['input'];
  /** connectedEmail (Pinterest username). Unused in URL mode (type: pinterest_url); required to resolve the refresh token for DPA mode (type: pinterest). */
  email?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
  /** The publish mode. pinterest_url = generate the CSV feed and stop (URL mode); pinterest = DPA mode (resolve/create a Pinterest catalog + feed pointed at the CSV and best-effort ingest). Mirrors Meta's PublishDpaCatalogInput.type. */
  type: DpaPlatformType;
};

/**
 * One outbound publish attempt to a third-party channel (publish_run design
 * spec) — the destination-side sibling of CatalogRun. There is NO stored
 * 'running' status: a stale 'queued' row older than the in-flight window
 * renders as timedOut=true, computed at read time (never persisted).
 */
export type PublishRun = {
  __typename?: 'PublishRun';
  /** The ingest run that cascaded into this publish; null for standalone manual publishes. */
  catalogRunId?: Maybe<Scalars['Int']['output']>;
  channel: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  /**
   * The design this publish was made from. Resolved deleted-inclusive: a publish
   * log records what happened, so deleting the design later must not blank out
   * its own history. Null only when the row carries no design_id at all.
   */
  design?: Maybe<PublishRunDesign>;
  /** finishedAt - startedAt in ms; null while still queued. */
  durationMs?: Maybe<Scalars['Int']['output']>;
  failedCount: Scalars['Int']['output'];
  failures: Array<PublishRunFailure>;
  finishedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  /** BullMQ flow-parent job id (stable across retries) — the finalize lookup key. */
  jobId?: Maybe<Scalars['String']['output']>;
  /** Created catalog/campaign/ad/pin ids, Meta batch handles. */
  remoteIds?: Maybe<Scalars['JSON']['output']>;
  skipped: Scalars['Int']['output'];
  startedAt: Scalars['Date']['output'];
  status: Scalars['String']['output'];
  succeeded: Scalars['Int']['output'];
  /** True only for a 'queued' row whose startedAt is older than the read-time in-flight window — never stored. */
  timedOut: Scalars['Boolean']['output'];
  total: Scalars['Int']['output'];
  trigger: Scalars['String']['output'];
  /** User who triggered a manual publish; null for feed_change/schedule triggers (and deleted users). */
  triggeredBy?: Maybe<User>;
};

/**
 * The design a publish run came from, as the log needs it — deliberately NOT the
 * full Design type. catalogPublishRuns authorises on the CATALOG, so a caller
 * with catalog access could otherwise select any field of a design they have no
 * DESIGN-level access to (the DESIGN access directive never runs on this path).
 * Only what the run-history row renders: the design and its thumbnail.
 */
export type PublishRunDesign = {
  __typename?: 'PublishRunDesign';
  hash: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** Thumbnail HASH (a set's thumb child, else the design itself), not a URL — feed it to the DesignThumb component, which builds the CDN path. */
  thumb?: Maybe<Scalars['String']['output']>;
  /** The design's last save — the thumbnail's version (DesignThumb's ?t=), so its URL changes with every save. */
  updatedAt: Scalars['Date']['output'];
};

/** One failed item of a publish run — item is the product/ad identifier (model stores number|string, stringified here). */
export type PublishRunFailure = {
  __typename?: 'PublishRunFailure';
  item: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export type PublishRuns = {
  __typename?: 'PublishRuns';
  hasNextPage: Scalars['Boolean']['output'];
  items: Array<PublishRun>;
  totalCount: Scalars['Int']['output'];
};

/** @deprecated publishSingleCreative mutation has been removed */
export type PublishSingleCreativeInput = {
  accountId: Scalars['String']['input'];
  adAccountId: Scalars['String']['input'];
  adId?: InputMaybe<Scalars['String']['input']>;
  adName?: InputMaybe<Scalars['String']['input']>;
  adSetId?: InputMaybe<Scalars['String']['input']>;
  adSetName?: InputMaybe<Scalars['String']['input']>;
  businessId: Scalars['String']['input'];
  campaignId?: InputMaybe<Scalars['String']['input']>;
  campaignName?: InputMaybe<Scalars['String']['input']>;
  designHash: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
  type: DpaPlatformType;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

/** @deprecated publishSingleCreative mutation has been removed */
export type PublishSingleCreativeResponse = {
  __typename?: 'PublishSingleCreativeResponse';
  campaignId: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  /** The resolved media type the publish will use (AUTO is resolved to IMAGE or VIDEO here). */
  mediaType?: Maybe<FacebookAdMediaType>;
};

export type PublishTikTokCampaignInput = {
  /** Required only when creating the ad group (adgroupId absent). */
  adGroupSettings?: InputMaybe<TikTokAdGroupSettingsInput>;
  adSettings: TikTokAdSettingsInput;
  /** Publish into an EXISTING ad group (skip campaign + ad-group create). Omit + set adGroupSettings to create one. */
  adgroupId?: InputMaybe<Scalars['String']['input']>;
  advertiserId: Scalars['String']['input'];
  /** Publish into an EXISTING campaign (skip campaign create). Omit + set campaignSettings to create one. */
  campaignId?: InputMaybe<Scalars['String']['input']>;
  /** Required only when creating the campaign (campaignId absent). */
  campaignSettings?: InputMaybe<TikTokCampaignSettingsInput>;
  /** Ad creative structure (default SEPARATE). OPTIMIZED = one Smart Creative ad for all sizes; only valid when creating a new ad group (adGroupSettings) with a Smart-Creative-eligible objective. */
  creativeMode?: InputMaybe<TikTokCreativeMode>;
  designHash: Scalars['String']['input'];
  /** A linked verified TikTok identity the ad runs under (required). TikTok sunset CUSTOMIZED_USER custom identities (Jan 2026), so ads must reference an account the advertiser has linked — no minting. */
  identityId: Scalars['String']['input'];
  /** Type of the linked identity (e.g. TT_USER, BC_AUTH_TT); must match the identity referenced by identityId or ad-create rejects the creative. */
  identityType?: InputMaybe<Scalars['String']['input']>;
  integrationId: Scalars['Int']['input'];
  /** Feed-row batch: a 1-based row range (e.g. "1-10", max 50) publishes those feed-row variations of a feed-backed design as discrete ads under the one ad group (SEPARATE: one ad per row and size; OPTIMIZED: one Smart Creative ad per row). TikTok caps an ad group at 20 ads. Omit for a normal single publish. */
  rowRange?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

export type PublishTikTokCampaignPayload = {
  __typename?: 'PublishTikTokCampaignPayload';
  jobId: Scalars['String']['output'];
};

/**
 * TikTok catalog publish. URL Catalog mode (type: tiktok_url): render the products and write the
 * TikTok-schema feed CSV the advertiser points a catalog feed at. DPA Catalog mode (type: tiktok):
 * the same CSV, then a catalog in the chosen Business Center (an existing one, or a new one named
 * catalogName in regionCode) with a daily scheduled feed at the CSV link, published with the user's
 * TikTok connection. Mirrors PublishPinterestCatalogInput.
 */
export type PublishTikTokCatalogInput = {
  /** DPA mode: the advertiser the catalog is published for. */
  advertiserId?: InputMaybe<Scalars['String']['input']>;
  /** TikTok requires a brand on every product. Used for every row when the feed carries no brand column; a brand column always wins. */
  brand?: InputMaybe<Scalars['String']['input']>;
  /** DPA mode: the Business Center the catalog belongs to (TikTok catalogs are Business Center assets). */
  businessCenterId?: InputMaybe<Scalars['String']['input']>;
  /** DPA mode: an existing catalog of that Business Center to publish into. Omitted = create one. */
  catalogId?: InputMaybe<Scalars['String']['input']>;
  /** DPA mode: name of the catalog to create when none is chosen. Defaults to the design's name. */
  catalogName?: InputMaybe<Scalars['String']['input']>;
  /** ISO 4217 code the prices are qualified with (TikTok reads "9.99 USD", never a bare amount). Defaults to USD. In DPA mode an existing catalog's own currency wins; a new catalog is created with this one. */
  currency?: InputMaybe<Scalars['String']['input']>;
  designHash: Scalars['String']['input'];
  /** DPA mode: the caller's TikTok connection (cloud_integrations id) whose token publishes the catalog. */
  integrationId?: InputMaybe<Scalars['Int']['input']>;
  /** DPA mode: region (catalog_conf.region_code) of the catalog to create when none is chosen. */
  regionCode?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
  /** The publish mode: tiktok_url generates the feed CSV and stops; tiktok also creates or reuses a catalog and its feed in the Business Center. */
  type: DpaPlatformType;
};

export type PublishToCampaignInput = {
  accountId: Scalars['String']['input'];
  adAccountId: Scalars['String']['input'];
  adCreativeSettings?: InputMaybe<FacebookAdCreativeSettingsInput>;
  adId?: InputMaybe<Scalars['String']['input']>;
  adName?: InputMaybe<Scalars['String']['input']>;
  adSetId?: InputMaybe<Scalars['String']['input']>;
  adSetName?: InputMaybe<Scalars['String']['input']>;
  adSetSettings?: InputMaybe<FacebookAdSetSettingsInput>;
  /** Status for the created Ad. Defaults to PAUSED (safe). ACTIVE lets the ad deliver — and spend budget — as soon as Meta's review passes. */
  adStatus?: InputMaybe<FacebookEntityStatus>;
  /** Feed-row batch opt-in: auto-repoint these ads when the feed changes (Feature B). Recorded on the publication; only meaningful with rowRange. */
  autoSync?: InputMaybe<Scalars['Boolean']['input']>;
  businessId: Scalars['String']['input'];
  campaignId?: InputMaybe<Scalars['String']['input']>;
  campaignName?: InputMaybe<Scalars['String']['input']>;
  campaignSettings?: InputMaybe<FacebookCampaignSettingsInput>;
  /** Feed-row batch: bind creative fields (Website URL / Headline / Primary text / Description) to feed columns so each row's ad gets per-row copy. Only meaningful with rowRange. */
  creativeFeedBindings?: InputMaybe<CreativeFeedBindingsInput>;
  designHash: Scalars['String']['input'];
  /** @deprecated Use adSetSettings.isDynamicCreative instead */
  isDynamicCreative?: InputMaybe<Scalars['Boolean']['input']>;
  pageId: Scalars['String']['input'];
  /** Feed-row batch: a 1-based row range (e.g. "1-3, 7", max 50) publishes those feed-row variations of a feed-backed design as N discrete ads under the one ad set. Omit for a normal single-creative publish. */
  rowRange?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
  /** The variation-family members to publish, as their own design hashes (the master's and each variation's). Omit for the design named by designHash alone — that is what every publish did before variations existed, and what a stored publication replays as. An empty list is an error, never "all". Each member becomes its own ad set with its own ad, so this is not combinable with rowRange, an existing adSetId, or an existing adId. */
  variationHashes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Use adCreativeSettings.link instead */
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PublishToCampaignPayload = {
  __typename?: 'PublishToCampaignPayload';
  campaignId: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  /** The resolved media type the publish will use (AUTO is resolved to IMAGE or VIDEO here). */
  mediaType?: Maybe<FacebookAdMediaType>;
  /** Number of feed rows published (feed-row batch only); null for a single creative. */
  rowCount?: Maybe<Scalars['Int']['output']>;
};

export type PublishToCatalogFlowInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  adAccountId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  designId: Scalars['Int']['input'];
  supplementary?: InputMaybe<Scalars['Boolean']['input']>;
  teamId: Scalars['Int']['input'];
};

export enum PublishingCreativeType {
  HTML5 = 'HTML5',
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO'
}

export type PurchaseTopUpCreditsPayload = {
  __typename?: 'PurchaseTopUpCreditsPayload';
  errorCode?: Maybe<Scalars['String']['output']>;
  invoiceId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  result: Scalars['Boolean']['output'];
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type PurgeNextTrashedDesignsPayload = {
  __typename?: 'PurgeNextTrashedDesignsPayload';
  /**
   * The designs this call checked, oldest in Trash first. A size whose set is also in
   * Trash is not checked on its own: it goes with its set.
   */
  checkedIds: Array<Scalars['Int']['output']>;
  /** Those whose purge failed; the next pass tries them again. */
  failedIds: Array<Scalars['Int']['output']>;
  /** Those of them that were deleted. A set's sizes are deleted with it but are not listed. */
  purgedIds: Array<Scalars['Int']['output']>;
  /** True when this call reached designs trashed less than 6 months ago: the next call starts again from the oldest. */
  reachedEnd: Scalars['Boolean']['output'];
};

export type PurgeTrashedDesignsPayload = {
  __typename?: 'PurgeTrashedDesignsPayload';
  /** Those of the requested designs that were deleted. A set's sizes are deleted with it but are not listed. */
  purgedIds: Array<Scalars['Int']['output']>;
};

/** Response after pushing the edited master size's changes to sibling sizes. */
export type PushMasterSizeChangesPayload = {
  __typename?: 'PushMasterSizeChangesPayload';
  /** The master, so clients can refresh checksums and the baseline in cache. */
  master: Design;
  pushedSizes: Array<PushedSizeResult>;
  /**
   * Deprecated, always null — kept one release so a stale bundle's selection still validates.
   * @deprecated Always null: the Variations tab undo records family snapshots client-side and restores through restoreVariationsFamilyState. Removed after one release.
   */
  revertToken?: Maybe<Scalars['String']['output']>;
  /** Source-size changes not pushed by design (geometry / per-size-scaled). */
  skippedPropertyCount: Scalars['Int']['output'];
  /**
   * Target sizes the push skipped. Emitted reasons: source-size,
   * ambiguous-size-type, not-found, target-unloadable, target-unsyncable.
   */
  skippedSizes: Array<SyncSkippedSize>;
  /** Structural changes the engine filtered out at compute time (slide-scoped / unsupported). */
  skippedStructuralCount: Scalars['Int']['output'];
  /** Pushable structural changes the source edit carries (slide-scoped excluded) — computed regardless of applyStructural. What actually landed per size is PushedSizeResult.structuralAppliedCount. */
  structuralCount: Scalars['Int']['output'];
};

/** Per-size outcome of a cross-size push. */
export type PushedSizeResult = {
  __typename?: 'PushedSizeResult';
  /** Property changes written into this size. */
  appliedCount: Scalars['Int']['output'];
  designSizeTypeId: Scalars['Int']['output'];
  /** Pushed changes withheld because this size customised the same property (its cross-size overrides). Always 0 for sizes opted in via overwriteCustomisedSizeTypeIds. */
  keptOverrideCount: Scalars['Int']['output'];
  /** Structural changes withheld because they collide with this size's own structural edits. Always 0 for sizes opted in via overwriteCustomisedSizeTypeIds. */
  keptStructuralCount: Scalars['Int']['output'];
  /** Pushed changes whose element does not exist in this size (skipped, kept per-size). */
  missingElementCount: Scalars['Int']['output'];
  /** Structural changes (add/remove/move/order) that landed on this size. */
  structuralAppliedCount: Scalars['Int']['output'];
  /** Structural changes skipped on this size (missing anchors, id collisions). */
  structuralSkippedCount: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** @deprecated Not used */
  _empty?: Maybe<Scalars['String']['output']>;
  _rateLimitTester?: Maybe<Scalars['String']['output']>;
  abTest: AbTest;
  abTestDesigns: DesignsResult;
  abTests: AbTests;
  /** Get account stats */
  account: AccountStatsPayload;
  /**
   * Analyze a specific ad and provide AI-generated insights including
   * performance metrics and recommendations for improvement.
   */
  adInsights: AdInsightsResponse;
  /** Retrieves a list of ad networks based on the provided input filters. */
  adNetworks: Array<AdNetwork>;
  /** @deprecated Use adPublishProgress instead */
  adPublishProgress: JobProgress;
  /** Retrieves ad serving network information for a specific design. */
  adServingNetworks: AdServingNetworksPayload;
  /** Retrieves ad serving settings for a specific design. */
  adServingSettings: AdServingSettingsPayload;
  /** Retrieves the ad serving status for a specific design. */
  adServingStatus: AdServingStatusPayload;
  /**
   * designVersionHistory for every removed size, and removed variation that is
   * not a set, of a master's family (the rows adStudioFamilyRows lists removed).
   * Requires authentication and DESIGN permission on the master.
   */
  adStudioFamilyRemovedVersionHistory: Array<DesignVersionHistory>;
  /**
   * Every row of a master's family (the master, its sizes, its non-catalog
   * variations and their sizes), removed ones included, with each removal, for
   * version history to tell what the family had at any moment. Empty for a hash
   * that is not a master.
   * Requires authentication and DESIGN permission on the master.
   */
  adStudioFamilyRows: Array<AdStudioFamilyRow>;
  /**
   * Several of ONE variation family's size documents in a single request.
   *
   * The Variations tab needs the banner JSON of every size of every variation to paint the
   * grid, and asked for them one `design(input:)` call at a time - so a family of
   * (variations + 1) x sizes exhausted the per-user `Query.design` rate-limit budget
   * before it finished loading, and the tab hung. The object-level directive in
   * `root.typeDefs.ts` buckets per SCHEMA COORDINATE, so that 200/30s is one budget
   * shared by every `design(input:)` caller in the editor - the tab's own fan-out is
   * what drains it, and it takes everything else reading a design down with it. One call
   * answers up to 50 sizes.
   *
   * Its own `@rateLimit` is deliberately much tighter than the 200/30s default it
   * replaces, because a call here is worth up to 50 document reads rather than one:
   * 40 x 50 caps this field at 2000 documents per 30s, against `Query.design`'s 200.
   * A tab open costs ONE call per 50 sizes, so 40 leaves room for reopening, remounting
   * and refetching a large family many times over within the window.
   *
   * A ROOT query, not a field of `Design`, for the same reason
   * `adStudioVariationsSyncEffects` is one: it reads size JSONs from S3, so it must be
   * reachable only with authentication and design access - never through `publicDesign`,
   * which carries neither and is undirected on the same type.
   *
   * Returns the requested rows, in request order, MINUS any hash that is not a size of the
   * authorized family, no longer exists, or is share-blocked. A short result is normal, not
   * an error: the caller's roster races removals, and a partial answer must not blank the
   * sizes that did resolve. Every field on the returned rows resolves through the ordinary
   * `Design` resolvers, so `json` keeps its own per-row phishing and team-only checks.
   */
  adStudioFamilySizeJsons: Array<AdStudioFamilySizeJson>;
  /** Which of a design's logo layers have at least one differing brand kit logo available — backs the Content panel's Logo row disabled state. */
  adStudioLogoAvailability: AdStudioLogoAvailability;
  adStudioTestClaimed: Scalars['Boolean']['output'];
  /**
   * Per-variation verdicts on whether syncing this master into its variations
   * would actually change them — computed over the raw feed-stripped documents
   * the sync mutation itself merges, so the tab's pill, banner and review modal
   * agree with what Apply will really do.
   *
   * A ROOT query, not a field of `Design`, on purpose: it reads the flagged
   * sizes' JSONs from S3, so it must be reachable only with authentication and
   * design access — never through `publicDesign` or a design LISTING, where
   * one request could fan it out across many designs at once.
   *
   * Empty for a design with no variations, and for anything that is not a
   * master top row.
   */
  adStudioVariationsSyncEffects: Array<VariationSyncEffect>;
  adTagDesignNetworks: AdTagDesignNetworksPayload;
  adTagDesignSettings: AdTagDesignSettings;
  adTagDesignSyncStatus: AdTagSyncStatusPayload;
  adTagDynamicVars: Array<AdTagDynamicVar>;
  adTagExternalDesignTracking: Array<AdTagExternalDesignTrackingUrl>;
  adTagGenerateCode: AdTagGenerateCodePayload;
  adTagReport: Scalars['String']['output'];
  adTagReportData: AdTagReportPayload;
  adTagReports: AdTagReportsPayload;
  adTagSubscription?: Maybe<AdTagSubscriptionPayload>;
  adTagTiers: AdTagTiersPayload;
  adTagUsage: AdTagUsage;
  /**
   * Add a single competitor by analyzing a company name or domain.
   * Requires authentication.
   */
  addCompetitor: Competitor;
  /** Get messages from a specific chat session with pagination */
  adsLibraryChatMessages: Array<AdsLibraryChatMessage>;
  /**
   * Retrieve a specific ads library chat session by ID
   * @deprecated Not used anymore
   */
  adsLibraryChatSession?: Maybe<AdsLibraryChatSession>;
  /** @BreakingBad */
  advertisersCM360: AdvertisersCm360Payload;
  advertisersDv360: AdvertisersDv360Payload;
  /** Reads a Content Fragment from its publish address and converts it to ISI rich text. templateLeaf is the ISI layer first leaf; its styling carries over to the copy. */
  aemContentFragmentIsi: AemContentFragmentIsi;
  /** Reads a Content Fragment picked in Adobe's picker from its AEM author repository, with the user's relayed IMS bearer, and converts it to ISI rich text. templateLeaf as for aemContentFragmentIsi. */
  aemContentFragmentIsiFromAuthor: AemContentFragmentIsi;
  aiResizeJson: Scalars['JsonDesign']['output'];
  aiResizeModels: AiResizeModelsPayload;
  aiResizeStatus: AiResizeStatusPayload;
  aiResizeUserModel: AiResizeModelPayload;
  aiResizeVariantStatus: AiResizeVariantStatusPayload;
  /**
   * Get all projects accessible to the current user.
   * Requires authentication and access to the team.
   */
  allUserProjects: AllUserProjectsResults;
  /**
   * The FLEX pre-warm: builds the layout analysis of a design's main size (LLM-authored tree +
   * deterministic decor classification, returned as `{ layoutTree, decor }`) and caches the
   * model's skeleton SERVER-SIDE, so the subsequent `resizeFlexVariants` reuses it — one model
   * call per modal open, nothing carried by the client. Fire it (and forget it) when the resize
   * panel opens. Never errors — returns an empty tree on any failure (the flex op then rebuilds
   * inline). Separate from `analyzeSourceDesign` (the template path's `textRoles` analyzer).
   */
  analyzeDesignTree: Scalars['JSON']['output'];
  /** Analyze an image to detect content type and suggest actions */
  analyzeImage: ImageAnalysisResult;
  /**
   * One-shot, geometry-only analysis of a design's main size: returns text roles
   * (headline / subheading / body / cta) + decorative-element classification, as
   * a JSON object. Fire it when the resize panel opens, then pass the result into
   * `resizeAlternatives` / `resizeWithTemplate` as `sourceAnalysis` so they
   * reuse it instead of recomputing. Never errors — returns an empty analysis on
   * any failure.
   */
  analyzeSourceDesign: Scalars['JSON']['output'];
  /** Templates for the app's panels. With forCompanyIndustry the answer depends on the signed-in user's industry, so it may be cached only per user. */
  appTemplates: AppTemplatesPayload;
  /** @deprecated Feature removed */
  askOnboardingAssistant: OnboardingAssistantResponse;
  /**
   * Get available scopes for API tokens based on team's feature access.
   * Requires authentication and VIEW permission on the team.
   */
  availableApiTokenScopes: Array<ApiTokenScope>;
  backgroundType: BackgroundTypeResult;
  balance: BalancePayload;
  /**
   * Get Bannersnack design JSON.
   * Requires authentication.
   */
  bannersnackDesignJson: JsonDesignWithHash;
  /**
   * Get Bannersnack design set JSON.
   * Requires authentication.
   */
  bannersnackDesignSetJson: Scalars['JsonDesignSet']['output'];
  /**
   * Get multiple Bannersnack design JSONs.
   * Requires authentication.
   */
  bannersnackDesignsJson: Array<JsonDesignWithHash>;
  billingInfo?: Maybe<BillingInfo>;
  braintreeClientToken: BraintreeClientTokenPayload;
  /**
   * Get comprehensive analytics for a brand including content analysis, performance metrics,
   * audience insights, and text patterns from their ads with optional country filtering.
   */
  brandAnalytics: BrandAnalyticsResponse;
  /**
   * Get a brand competitor by brand kit ID and brand fetch ID (unique constraint).
   * Requires authentication and access to the brand kit.
   */
  brandCompetitorByIds?: Maybe<BrandCompetitor>;
  /**
   * Get all brand competitors for a brand kit.
   * Requires authentication and access to the brand kit.
   */
  brandCompetitors: Array<BrandCompetitor>;
  /**
   * Generate AI-powered insights about a brand's advertising strategy.
   * Returns different types of insights based on the specified insight type.
   */
  brandInsights: BrandInsightsResponse;
  /**
   * Get the stored image description for a BrandKit asset.
   * Access is verified against the brandkit the asset is expected to belong to.
   * Returns null assetDescription when no description is available or when the
   * asset is not linked to the provided brand kit.
   */
  brandKitAssetDescription?: Maybe<BrandKitAssetDescription>;
  /** Documents uploaded to a brand kit, newest first. */
  brandKitDocuments: Array<BrandKitDocument>;
  /**
   * Get all weight variants of a font family within a specific brand kit.
   * Used by the Brandkit Font Settings dialog. Scoped to MANAGE_BRANDS on
   * the supplied brand kit so a user cannot read fonts of kits they do not
   * own.
   */
  brandKitFontsByFamily?: Maybe<Array<Font>>;
  /**
   * Get target audience for a brand kit ID.
   * Requires authentication and access to the brand kit.
   */
  brandTargetAudiences: Array<BrandTargetAudience>;
  /** @deprecated Use designProjectLogo instead */
  brandTemplateBrandKitLogo?: Maybe<DesignProjectLogoResult>;
  brandTemplateDesigns: DesignsResult;
  brandTemplateFolderTree: BrandTemplateFolderTreePayload;
  brandTemplateFolders: Folders;
  /**
   * The versioned brief-assets slot for the copilot thread — the v2
   * hydration source for the living brief card (null = no slot stamped
   * yet; a failed read is a thrown error, never an empty slot).
   * Supersedes `getBriefAssets`, which remains until clients migrate.
   */
  briefAssetsSlot?: Maybe<BriefAssetsSlot>;
  /** @deprecated Migration service has been removed */
  bsUserTeamMembers: MigrationTeamMembersPayload;
  bulkAbTestTagContainerSyncStatus: Array<AbTestTagContainerSyncStatus>;
  bulkAdTagDesignSyncStatus: Array<AdTagSyncStatusPayload>;
  bulkDownloadAiAgentAutomatedReports: Scalars['String']['output'];
  /** @deprecated This query is deprecated. Use bulkDownloadAiAgentAutomatedReports instead. */
  bulkDownloadAiAgentReports: Scalars['String']['output'];
  /**
   * Change history for a catalog, newest first (catalog_change design spec
   * §7). Catalog = feed identity (D23), so this is hash-based and the access
   * check runs in the service via the feed machinery — same pattern as
   * catalogPublishRuns (the @access directive's FEED resource only resolves
   * numeric ids, see catalog/typeDefs.ts's mutation block comment).
   */
  catalogChanges: CatalogChanges;
  /**
   * Publish run history for a catalog, newest first (publish_run design spec
   * §6). Catalog = feed identity (D23), so this is hash-based and the access
   * check runs in the service via the feed machinery — same pattern as
   * loadCatalog (the @access directive's FEED resource only resolves numeric
   * ids, see catalog/typeDefs.ts's mutation block comment).
   */
  catalogPublishRuns: PublishRuns;
  /**
   * Check if the current user has access to a project.
   * Requires authentication and attempts to access the project.
   */
  checkAccessToProject: Scalars['Boolean']['output'];
  checkActiveJob?: Maybe<JobProgress>;
  /** Checks if an ad network with the given name exists for a specific team. */
  checkAdNetworkExists: Scalars['Boolean']['output'];
  checkAiOperation: GeneratedImageResult;
  checkAiOperations: Array<Maybe<GeneratedImageResult>>;
  /**
   * Check compatibility of fonts for AI translation feeds.
   * Verifies fonts support all languages in translation feeds.
   */
  checkAiTranslateFeedFontsCompatibility: CheckAiTranslateFeedFontsCompatibilityPayload;
  /**
   * Check if multiple fonts are compatible with text content.
   * Performs batch compatibility checking for efficiency.
   */
  checkBulkFontCompatible: CheckFontCompatiblePayload;
  checkCouponApplied: CheckCouponAppliedPayload;
  /**
   * Check compatibility of all fonts used in a design.
   * Identifies any unsupported characters in the design's text.
   */
  checkDesignFontsCompatibility: CheckDesignFontsCompatibilityPayload;
  checkDownloadCache: DownloadCacheStatus;
  checkDuplicatingFolder: CheckDuplicatingFolderPayload;
  /**
   * Check if designs are being edited to prevent conflicts.
   * Requires authentication and access to every listed design.
   */
  checkEditingDesign?: Maybe<CheckEditingDesignPayload>;
  checkFeedColumnBgRemoveEligibility: FeedColumnBgRemoveEligibility;
  checkFeedSourceUrl: CheckFeedSourceUrlPayload;
  checkFeedStatusActionType: CheckFeedStatusActionTypePayload;
  /**
   * Check if a font is compatible with specific text content.
   * Verifies that a font has all the characters needed for the text.
   */
  checkFontCompatible: CheckFontCompatiblePayload;
  /**
   * Check if a font supports a specific language.
   * Returns true if the font has all necessary glyphs for the language.
   */
  checkFontCompatibleWithLanguage: Scalars['Boolean']['output'];
  /**
   * Whether browsers accept a font uploaded through fontUploadUrl, before it is stored.
   * Reads the uploaded file and writes nothing.
   */
  checkFontForBrowsers: FontBrowserCheckPayload;
  checkIfTeamIsInPaymentExperiment: CheckIfTeamIsInPaymentExperimentResult;
  checkIfUserIsInPaymentExperiment: CheckIfUserIsInPaymentExperimentResult;
  /**
   * Check media processing status for moodboard share uploads.
   * Does not require authentication - validates access via moodboard share hash.
   */
  checkMoodBoardMedia: CheckMoodBoardMediaPayload;
  checkScoreChecksum: Scalars['Boolean']['output'];
  checkTranslateFeedStatus: TranslateFeed;
  /** @deprecated Migration service has been removed */
  checkValidCode: CheckValidCodePayload;
  /** Active (GENERATING_CONTENT/APPLYING) or recently-finished content-variation jobs for a design's master set — the Content panel's placeholder-polling feed. */
  contentVariationJobs: Array<ContentVariationJobSummary>;
  /** The caller's draft that is this chat's brand right now, or null. */
  copilotActiveBrandExtraction?: Maybe<CopilotBrandExtraction>;
  /** One of the caller's Copilot brand extractions on a design; null when it is not theirs or not on that design. */
  copilotBrandExtraction?: Maybe<CopilotBrandExtraction>;
  /**
   * What saving the document the Copilot read in this thread would change on the design's
   * brand kit, field by field, and whether the user may update it or create a new kit.
   * A fixed-size answer: at most one change per CopilotDocumentBrandKitField. Errors:
   * NO_DOCUMENT_READ.
   */
  copilotDocumentBrandKitPreview: CopilotDocumentBrandKitPreview;
  /** One Copilot media import on a design the user can open; null when it is not on that design. */
  copilotMediaImport?: Maybe<CopilotMediaImport>;
  /** The caller's recent Copilot generations on a design, for the page to rebuild its registry: those it still has to act on (not yet told to their chat, or with an outcome not yet applied) first, then settled ones whose result cards the chat still draws. Last 7 days, at most 20, oldest → newest. */
  copilotPendingGenerations: Array<CopilotPendingGeneration>;
  /** A Copilot scene edit the server started, as its card polls it; FAILED when it is not this user's edit on that design. */
  copilotSceneEdit: CopilotSceneEdit;
  /**
   * Live match count for an ad-hoc rule list (CRE-419) — powers the dynamic-set
   * editor's "{n} products match now" line without saving the set. Access +
   * rate limit mirror loadProductSets (same S3 read underneath).
   */
  countProductSetRuleMatches: Scalars['Int']['output'];
  couponDiscount: CouponPayload;
  /**
   * Crafted Ads Home query: returns the team's persisted Crafted Ad designs (SET rows) and an
   * isGenerating flag the FE uses to drive polling while the kickoff is in flight.
   * Requires authentication AND team membership (enforced in the resolver).
   */
  craftedDesigns: CraftedDesignsResult;
  currentSubscription?: Maybe<CurrentSubscriptionPayload>;
  /** @deprecated This query is deprecated and will be removed in a future version */
  currentTeamDownloads: Scalars['Int']['output'];
  /** One page of a team's custom sets that still hold a size, but for a design set's own single size, most recently applied first, then the never applied by when they were added. */
  customDesignSetSizeTypes: CustomDesignSetSizeTypesPayload;
  /**
   * Get a design by hash.
   * Requires authentication and access to the design.
   */
  design: Design;
  /**
   * Get the approval history for a design.
   * Requires authentication and access to the design.
   */
  designApprovalHistory: Array<DesignApprovalHistoryEntry>;
  /**
   * The design check of one saved size and slide in the new Ad Studio, for the developer panel: rendered by jpg-png,
   * scored by the design scorer (surface canvas.live), cached by the saved content. Null when the
   * ad_studio_design_check gate is closed for the user and the design's team.
   */
  designCheck?: Maybe<DesignCheck>;
  designClickHeatmap: ClickHeatmapPayload;
  designComponent: DesignComponent;
  /**
   * A design's sizes, editor lock and feed state, and a summary of its layers, read raw from the stored file.
   * Requires authentication and access to the design.
   */
  designContent: DesignContent;
  designFeedAdjustment?: Maybe<Scalars['JSON']['output']>;
  designFeedAdjustments?: Maybe<DesignFeedAdjustmentInfo>;
  /**
   * Get HTML export settings for a design.
   * Requires authentication and access to the design.
   */
  designHtmlSettings?: Maybe<DesignHtmlSettings>;
  /**
   * Media that can be imported from a design: everything on its canvas, plus its own library.
   * A root query rather than a Design field on purpose — it reads the design JSON from S3,
   * and Design fields inherit the authorization of unauthenticated parents (publicDesign).
   * Requires authentication and access to the design.
   */
  designImportableMedia: DesignImportableMediaResult;
  /**
   * Get a design's location information.
   * Requires authentication and access to the design.
   */
  designLocation: DesignLocation;
  /**
   * Browse a project's folders and designs for the import picker.
   * Requires authentication and access to the team (and to the project and folder when given).
   */
  designMediaImportBrowse: DesignMediaImportBrowseResult;
  /**
   * Whether the workspace holding a design (or its set) is on the new Ad Studio BETA.
   * Requires authentication and access to the design.
   */
  designNewAdStudioBeta: Scalars['Boolean']['output'];
  /**
   * Get project logo information for a design.
   * Requires authentication and access to the design.
   */
  designProjectLogo?: Maybe<DesignProjectLogoResult>;
  /** Publish run history for a design, newest first (publish_run design spec §6). */
  designPublishRuns: PublishRuns;
  /**
   * Get design set templates based on filtering criteria.
   * Returns template sets organized by category.
   */
  designSetTemplates: DesignSetTemplatesPayload;
  designSizeType: DesignSizeType;
  /** The predefined (system) sizes and sets, the same for every caller. A selection without object fields may be served from a shared cache up to 10 minutes old. */
  designSizeTypes: Array<DesignSizeType>;
  /**
   * Get design templates based on filtering criteria.
   * Returns templates matching the specified criteria.
   */
  designTemplates: DesignTemplatesPayload;
  /**
   * Count templates by type for a specific design size.
   * Returns counts of static, animated, and video templates.
   */
  designTemplatesTypeCount: DesignTemplatesCountPayload;
  /**
   * Get a specific version of a design.
   * Requires authentication and DESIGN permission.
   */
  designVersion: DesignVersion;
  /**
   * Get version history for a design.
   * Requires authentication and DESIGN permission.
   */
  designVersionHistory: Array<DesignVersionHistory>;
  /**
   * Get designs with filtering and pagination.
   * Requires authentication and access to the specified resources.
   */
  designs: DesignsResult;
  /**
   * Ad-tag analytics (clicks/views) for a set of designs, by hash.
   *
   * Split out of the `designs` listing query so the list can render before the
   * heavier per-design `adTagAnalytics` aggregation (which sums ad-serving usage
   * across a set's sub-designs) resolves. The FE loads the base list first, then
   * calls this for the rendered rows and fills in the CTR/Impressions columns.
   *
   * Requires authentication; the resolver checks design access per hash (max 100).
   */
  designsAdTagAnalytics: DesignsAdTagAnalyticsResult;
  /**
   * Get designs by their hashes.
   * Requires authentication. Access control to be implemented.
   */
  designsByHashes: DesignsByHashResult;
  /**
   * Get duration information for designs.
   * Requires authentication and access to every listed design.
   */
  designsDuration: DesignsDurationPayload;
  designsFeedPropertyBinding: Array<DesignsFeedPropertyBinding>;
  /** @deprecated use designsFeedPropertyBinding */
  designsFeedUrlBinding: Array<DesignsFeedUrlBinding>;
  detectChatIntent: DetectChatIntentPayload;
  /** True when another team owner shares the current user's work-email domain. */
  domainHasOtherTeamOwner: Scalars['Boolean']['output'];
  /** Teams whose owner shares the current user's work-email domain. */
  domainTeamOwners: Array<DomainTeam>;
  downloadAiAgentAutomatedReport: DownloadAiAgentAutomatedReportPayload;
  /** @deprecated Using html downloads instead */
  downloadAiAgentReport: DownloadAiAgentReportPayload;
  downloadAudioUrl: DownloadAudioUrl;
  /**
   * Get download settings for shared links.
   * No authentication required.
   */
  downloadEnabledShareLink: DownloadEnabledShareLinkPayload;
  downloadFeedInterval?: Maybe<DownloadFeedInterval>;
  downloadIntegrationFile: DownloadIntegrationFileResult;
  /** @deprecated Use downloadPresetV2 instead */
  downloadPreset: DownloadPreset;
  downloadPresetV2: DownloadPresetV2;
  downloadReport: Scalars['String']['output'];
  downloadStatus: DownloadStatus;
  downloads: Array<Download>;
  dpaSettings: DpaSettings;
  expansion: ExpansionPayload;
  exportFeedToCsv: ExportFeedToCsvResult;
  /**
   * Get favorite elements for a design.
   * Requires authentication and access to the team.
   * Deprecated: Will be removed soon.
   * @deprecated Do not use it anymore is going to be removed soon
   */
  favoriteElements: Array<FavoriteElementResult>;
  /**
   * Get favorite projects for the current user.
   * Requires authentication and access to the team.
   */
  favoriteProjects: Array<Maybe<FavoriteProjectsResult>>;
  fbAdAccounts: Array<FbAdAccount>;
  fbAdCreative?: Maybe<FbAdCreative>;
  fbAdSets: Array<FbAdSet>;
  fbAds: Array<FbAd>;
  fbBusinesses: Array<FbBusiness>;
  fbCampaigns: Array<FbCampaign>;
  fbCatalogs: Array<FbCatalog>;
  fbCustomConversions: Array<FbCustomConversion>;
  fbInstantExperiences: Array<FbInstantExperience>;
  fbLeadForms: Array<FbLeadForm>;
  fbPages: Array<FbPage>;
  fbPixels: Array<FbPixel>;
  /** The saved audiences of a Meta ad account, deleted ones left out. */
  fbSavedAudiences: Array<FbSavedAudience>;
  featureAccessForAllPlans: FeatureAccessForAllPlansResponse;
  /**
   * Get a combination of features for each plan
   * @deprecated Use featuresComparison for app
   */
  featureComparer: FeaturesComparisonPayload;
  featureExposition: FeatureExpositionPayload;
  featuresAccess: FeaturesAccess;
  featuresAccessTestDirective: Scalars['String']['output'];
  featuresComparison: FeaturesComparisonPayload;
  feedFieldsValidation: FeedFieldsValidationPayload;
  feedRevertBgCount?: Maybe<Scalars['Int']['output']>;
  fetcherBrandIdentity: FetcherBrandIdentity;
  fetcherFonts: FetcherFontsData;
  fetcherLogo: FetcherLogoData;
  fetcherMedia: FetcherMediaData;
  fetcherPalette: FetcherPaletteData;
  fetcherScreenshot: FetcherScreenshotData;
  fetcherStyle: FetcherStyleData;
  fetcherText: FetcherTextData;
  /**
   * A .fig import's status, from the same record a plugin import reports to (kept one hour). Only the user and team
   * the key was issued to may read it. Refused outside the fig_file_import gate.
   */
  figFileStatus: FigFileStatus;
  financialData: FinancialData;
  /**
   * Suggest competitors for a brand kit's brand.
   * Requires authentication and access to the brand kit.
   */
  findBrandCompetitors: Array<BrandSearchApiResult>;
  /**
   * Find competitors for a given company name.
   * Requires authentication.
   */
  findCompetitors: Array<Competitor>;
  focalPoint: FocalPointResult;
  folder?: Maybe<Folder>;
  folderTree: FolderTreePayload;
  folders: Folders;
  /**
   * Get a presigned S3 URL for font uploads.
   * Used when uploading fonts to a brand kit.
   */
  fontUploadUrl: UploadUrlPayload;
  generateBrandedCopy: GeneratorBrandedCopyData;
  generateVeevaPdfStatus: GenerateVeevaPdfStatusResponse;
  generatorTextContent: GeneratorTextContentData;
  getAccessToken: GetAccessTokenResult;
  getActiveUsageRestrictions: Array<ActiveUsageRestriction>;
  /** Retrieves a specific ad network by its ID and team ID. */
  getAdNetworkById: AdNetwork;
  /** Get messages for an AdStudio thread (optional agentId; must match the thread's agent) */
  getAdStudioThreadMessages: Array<ThreadMessage>;
  /** Get all chat threads for a specific AdStudio design (optional Mastra agentId; defaults to image creator) */
  getAdStudioThreads: Array<AdStudioThread>;
  getAddonsUsage: AddonsUsage;
  getAiAgentAutomatedReportsDashboard: AiAgentAutomatedReportsDashboardPayload;
  getAiChats: AiChatsPayload;
  getAiOperationProgress: AiOperationProgress;
  getAiOperationUsage: AiOperationUsage;
  getAiStudioGenerations: AiStudioGenerationsResult;
  getAnimationSuggestions: AnimationSuggestionsResult;
  /** Returns the team's Asset Selector MFE config, or null when not configured. */
  getAssetSelectorConfig?: Maybe<AssetSelectorConfig>;
  getAuthEvents: Array<LoginEvent>;
  getAutomatedReportHtml: Scalars['String']['output'];
  getAutomatedReportHtmlById: Scalars['String']['output'];
  getAutomatedReportPublicHash: CopilotPublicHashPayload;
  getAutomatedReportPublicResourceAccess: CopilotPublicResourceAccessPayload;
  getAutomatedScheduleReports: Array<AiAgentAutomatedReportPayload>;
  /**
   * Get background remover credits for a team.
   * Requires authentication and access to the team.
   */
  getBgRemoverCredits: BgRemoverCreditsPayload;
  /**
   * Get a brand kit by ID.
   * Requires authentication and access to the brand kit.
   */
  getBrandKit: BrandKitResult;
  /**
   * Get brand kit JSON data by hash or ID.
   * Public access for shared links.
   */
  getBrandKitJson: GetBrandkitJsonPayload;
  /**
   * Get the structured brand profile for a brand kit.
   * Requires authentication and access to the brand kit.
   */
  getBrandKitProfile: BrandKitProfile;
  /**
   * Get the project ID associated with a brand kit.
   * Requires authentication and access to the brand kit.
   */
  getBrandKitProjectId: BrandKitProjectId;
  /**
   * Get visual style settings for a brand kit.
   * Requires authentication and access to the brand kit.
   */
  getBrandKitVisualStyle: BrandKitVisualStyle;
  /**
   * Get voice and tone settings for a brand kit.
   * Requires authentication and access to the brand kit.
   */
  getBrandKitVoiceAndTone: BrandKitVoiceAndTone;
  /**
   * The copilot thread's current brief-owned asset set (the briefAssets
   * metadata slot) — what the next Generate will resolve. Null when no brief
   * has stamped assets yet; the living brief card hydrates from this so a
   * remount reflects the slot, not the historical stamp.
   */
  getBriefAssets?: Maybe<Array<ChatBriefAsset>>;
  /** Retrieves a specific Bynder asset by its ID. */
  getBynderAsset: BynderAsset;
  /** Retrieves download information for a specific Bynder asset item. */
  getBynderAssetDownload: BynderAssetDownload;
  /** Retrieves a list of Bynder assets based on specified filters. */
  getBynderAssets: IntegrationItemsResult;
  /** Retrieves a list of Bynder collections. */
  getBynderCollections: IntegrationItemsResult;
  /** Retrieves the current authenticated Bynder user's details. */
  getBynderCurrentUser: BynderUser;
  getCloudIntegration: CloudIntegrationResult;
  /** The team's Cloudinary cloud name. Null when none is saved or the team's plan doesn't include Cloudinary (it stays saved). */
  getCloudinaryConfig?: Maybe<CloudinaryConfig>;
  getColumnsFromFeedSource: GetColumnsFromFeedSourcePayload;
  /** @deprecated Use getColumnsFromFeedSource instead */
  getColumnsFromFeedSourceUrl: GetColumnsFromFeedSourceUrlPayload;
  getCommentAttachmentUrl: CommentAttachmentUploadUrlPayload;
  getCommentAttachments: CommentAttachmentsResult;
  /**
   * Get the brand-kit custom font families that fully cover the design's feed
   * text for each of the given language codes. Each font is checked against the
   * actual concatenated row content for that language, so the result is
   * specific to this design's feed — not a generic language-coverage estimate.
   * Results are returned in the same order as the input languageCodes.
   */
  getCompatibleFontsForLanguages: Array<LanguageCompatibleFonts>;
  /** Generate an AI-powered summary of a competitor's advertising strategy */
  getCompetitorSummary: Scalars['String']['output'];
  getCopilotAiChatPublicHash: CopilotPublicHashPayload;
  getCopilotAiChatPublicResourceAccess: CopilotPublicResourceAccessPayload;
  /** @deprecated Use getAiChats instead */
  getCopilotAiChats: CopilotAiChatsPayload;
  getCopilotAiReportPublicHash: CopilotPublicHashPayload;
  getCopilotAiReportPublicResourceAccess: CopilotPublicResourceAccessPayload;
  getCreditBalance: CreditBalance;
  getCreditTransactionHistory: CreditTransactionHistoryPayload;
  getCustomBranding: GetCustomBrandingPayload;
  getCustomTransitions: Array<CustomTransitionPayload>;
  getDesignAnimatorSuggestions: DesignAnimatorSuggestionsResult;
  getDesignComments: DesignCommentsResult;
  /** @deprecated Field no longer supported */
  getDesignComponentName: GetDesignComponentNamePayload;
  /**
   * Get the current editing status of a design.
   * Returns whether someone else is currently editing the design.
   * Requires authentication and access to the design.
   */
  getDesignEditingStatus?: Maybe<DesignEditingStatusPayload>;
  /**
   * Get a design's type (design, set, component).
   * Requires authentication.
   */
  getDesignType: GetDesignTypePayload;
  getDetectedLanguageForText: DetectedLanguage;
  getDomainStatus: GetBrandStatusPayload;
  getDownloadCreditsUsage: DownloadCreditsUsage;
  getDriveItems: IntegrationItemsResult;
  getDropboxItems: IntegrationItemsResult;
  getEmailStatus: GetBrandStatusPayload;
  /**
   * Get SSO enforcement settings for a team.
   * Requires authentication and MANAGE_TEAMS permission on the team.
   */
  getEnforceTeamSso?: Maybe<EnforceTeamSsoPayload>;
  getExpiredSubscription?: Maybe<ExpiredSubscription>;
  getFeedColumnsMatch: FeedMatchedResult;
  getGoogleAdsCampaigns: GetGoogleAdsCampaignsPayload;
  /** @deprecated Use getIntegrations instead */
  getGoogleAdsIntegrations: Array<CloudIntegration>;
  /**
   * Get Google advertiser details by advertiser ID.
   * Returns advertiser information for a specific advertiser ID.
   */
  getGoogleAdvertiserById: GoogleAdvertiserByIdResponse;
  getGroupedIntegrationAccounts: GetGroupedIntegrationAccountsResult;
  /**
   * Get identity provider team invitation status.
   * Requires authentication.
   */
  getIdentityProviderTeamInvitationStatus: IdentityProviderInvitationStatus;
  getImageSubtleAnimation: ImageSubtleAnimationResult;
  getImpressionsTiers: Array<TierPrice>;
  getIntegrationAccountEmail: GetCloudIntegrationAccountEmailResult;
  getIntegrationAccounts: GetIntegrationAccountsResult;
  getIntegrationFilesUrl: IntegrationFilesUploadUrlResult;
  getIntegrations: Array<CloudIntegration>;
  /** @deprecated Brand template migration service has been removed. @BreakingBad */
  getIsTeamMigrated: Scalars['Boolean']['output'];
  getKeycloakConfigFile?: Maybe<KeycloakConfigFile>;
  /** Get the last completed AI generation (image or video) for an AdStudio design */
  getLastCompletedAdStudioGeneration?: Maybe<LastCompletedGeneration>;
  /** @deprecated Use getCopilotAiChatPublicHash instead */
  getLearnAgentChatPublicHash: Scalars['String']['output'];
  getLearnAgentReportHtml: Scalars['String']['output'];
  /** @deprecated Use getCopilotAiReportPublicHash instead */
  getLearnAgentReportPublicHash: Scalars['String']['output'];
  getMaintenance: MaintenanceType;
  getMatchingColors: NextGenColors;
  getMetaAdPreview: GetMetaAdPreviewPayload;
  getMetaAds: GetMetaAdsPayload;
  /** Get all chat threads for a specific moodboard */
  getMoodboardThreads: Array<MoodboardThread>;
  /** The editable storyboard of a finished multi-scene generation, rebuilt from its persisted rows (Manual: the stored cards; Auto: cards synthesized from the beat plan / shot templates). */
  getMultiSceneStoryboard: MultiSceneStoryboard;
  /** Poll a storyboard draft started by draftMultiSceneStoryboard. */
  getMultiSceneStoryboardDraft: MultiSceneStoryboardDraftResult;
  getNextGenBrandDescription: NextGenBrandDescriptionData;
  getNextGenBrandfetch: NextGenBrandfetchData;
  getNextGenFonts: NextGenFontsData;
  getNextGenIdentity: NextGenIdentityData;
  getNextGenLogo: NextGenLogoData;
  getNextGenMedia: NextGenMediaData;
  getNextGenRecommandedBrandKit: Scalars['Int']['output'];
  getNextGenStyle: NextGenStyleData;
  getNextGenText: NextGenTextData;
  getNextgenAI?: Maybe<NextgenAi>;
  getRecurringCreditsTiers: Array<TierPrice>;
  getRoomTypes: GetRoomTypesPayload;
  getSamlConfigFile?: Maybe<KeycloakConfigFile>;
  getSavedScore: Array<DesignWithIsCached>;
  getSeatsTiers: Array<TierPrice>;
  /**
   * Get comment settings for shared links.
   * No authentication required.
   */
  getShareLinkCommentsEnabled: GetShareLinkCommentsEnabledPayload;
  getSharePointAccessToken: SharePointAccessToken;
  getSharePointDefaultLocation?: Maybe<SharePointDefaultExportLocation>;
  getSharePointPersonalDrive: SharePointPersonalDriveContext;
  getSharedPublicChat: AiChat;
  /** @deprecated Use getSharedPublicChat instead */
  getSharedPublicLearnAgentChat: CopilotAiChat;
  getSharelinkScore: Array<SharelinkScore>;
  /**
   * Get a signed URL for uploading media.
   * Returns a temporary URL that can be used to upload media files.
   */
  getSignedMediaUrl: SignedMediaUrl;
  getSlackAccessToken: GetSlackAccessTokenResult;
  getSubscriptionInfo: SubscriptionInfo;
  /**
   * Get the Google fonts that support each of the given language codes.
   * Used to filter font pickers (e.g. fallback-font selection) so users only
   * see fonts whose subsets cover the requested languages. Results are returned
   * in the same order as the input.
   */
  getSupportedFontsForLanguages: Array<LanguageSupportedFonts>;
  /**
   * Get a processed SVG URL.
   * Requires authentication.
   */
  getSvgUrl: Scalars['String']['output'];
  /**
   * Get the system group for a team.
   * Requires authentication and access to the team.
   */
  getSystemGroup: GetSystemGroupPayload;
  /**
   * Get a team's brand kit.
   * Requires authentication and MANAGE_BRANDS permission on the team.
   */
  getTeamBrandKit?: Maybe<BrandKitResult>;
  getTeamConsumptionReport: TeamConsumptionReportPayload;
  getTeamIdentityProvider?: Maybe<TeamIdentityProvider>;
  /** @deprecated Use getTeamIdentityProvidersByDomain */
  getTeamIdentityProviderByDomain?: Maybe<IdentityProviderWithTeam>;
  getTeamIdentityProviderDomainsStatus?: Maybe<Array<TeamIdentityProviderDomain>>;
  getTeamIdentityProvidersByDomain?: Maybe<IdentityProvidersWithTeams>;
  /**
   * Get the success manager for a team.
   * Requires authentication and MANAGE_TEAMS permission on the team.
   */
  getTeamSuccessManager?: Maybe<TeamAccountManager>;
  /**
   * Get two-factor authentication settings for a team.
   * Requires authentication and VIEW permission on the team.
   */
  getTeamTwoFactor?: Maybe<TeamTwoFactorPayload>;
  /**
   * Get details about a temporary font.
   * Retrieves metadata for a font that is not yet uploaded permanently.
   */
  getTempFontDetails: FontDetailsPayload;
  getTemporaryEnterprise?: Maybe<TemporaryEnterprisePayload>;
  getTextExtraction: TextExtractionResult;
  /** Get messages for a specific thread */
  getThreadMessages: Array<ThreadMessage>;
  getTopUpCreditsTiers: Array<TierPrice>;
  /** @deprecated Feature removed */
  getTopUseCases: TopUseCasesResponse;
  getUrlContentType: GetUrlContentType;
  /** @deprecated Use getUserIdentityProviderAliases for multi-team domain support */
  getUserIdentityProviderAlias: TeamIdentityProviderAlias;
  getUserIdentityProviderAliases: UserIdentityProviderAliases;
  /** @deprecated Use me { userSettings } instead */
  getUserSettings: UserSettings;
  getUserSsoEnforced: UserIdentityProvider;
  getVariationSuggestions: VariationSuggestionsResult;
  getVeevaAppByTeam?: Maybe<VeevaAppPublic>;
  getVeevaDocumentByNumber: VeevaDocumentByNumberResult;
  getVeevaDocuments: VeevaResult;
  getVeevaOptions: VeevaOptions;
  getWorkflow?: Maybe<Workflow>;
  getWorkflowRealtimeSubscriptionToken?: Maybe<WorkflowRealtimeSubscriptionTokenResponse>;
  getWorkflowRuns?: Maybe<WorkflowRunsResponse>;
  /**
   * Fetch Google Ads accounts accessible to the authenticated user
   *
   * Returns a list of Google Ads accounts that the user has access to
   * through their Google OAuth token. Used for account selection in the UI.
   */
  googleAdsAccounts: GoogleAdsAccounts;
  /**
   * Fetch ad groups within a specific Google Ads account
   *
   * Returns a paginated list of ad groups with basic information like
   * name, status, and campaign ID. Supports search filtering.
   */
  googleAdsAdGroups: GoogleAdsAdGroups;
  /**
   * Fetch asset groups within Performance Max campaigns
   *
   * Asset groups are containers for assets in Performance Max campaigns.
   * Returns a paginated list with search filtering support.
   */
  googleAdsAssetGroups: GoogleAdsAssetGroups;
  /**
   * Fetch campaigns within a specific Google Ads account
   *
   * Returns a paginated list of campaigns with basic information like
   * name, status, bidding strategy, and budget. Supports search filtering.
   */
  googleAdsCampaigns: GoogleAdsCampaigns;
  /**
   * Get size requirements for Google Ads campaign types
   *
   * Returns available sizes for the specified campaign type along with
   * validation results showing which design sizes match the requirements.
   * Uses the existing validateAndEnrichDesignSizes function for validation.
   */
  googleAdsSizeRequirements: GoogleAdsSizeRequirementsResult;
  /**
   * Get a list of all available Google fonts.
   * Results are cached for 10 minutes.
   */
  googleFonts: Array<GoogleFont>;
  /** Provice payment details for Google Tag Manager (GTM) tracking. */
  gtmPaymentDetails: GtmPaymentDetailsPayload;
  /**
   * Check if a team is in the Ad Studio experiment.
   * Requires authentication.
   */
  hasAdStudioExperiment: HasAdStudioExperimentPayload;
  /**
   * Check if a team has designs with active ad tags.
   * Requires authentication.
   * @deprecated Not used
   */
  hasDesignsAdTagActive: HasDesignsAdTagActivePayload;
  /**
   * Whether the team has ever served an ad, live now or at any point in the past.
   * Unlike the deprecated hasDesignsAdTagActive, this is not limited to
   * currently-active ad tags.
   */
  hasEverServedAd: HasEverServedAdPayload;
  hasFeeds: Scalars['Boolean']['output'];
  hashedTeamId: Scalars['String']['output'];
  hubspotSubscriptionStatus: HubspotSubscriptionStatus;
  invoices: Array<Invoice>;
  /** The most recent Meta publication of a design (null if never published) — prefills the wizard on reopen. */
  lastMetaPublication?: Maybe<MetaPublication>;
  linkedBusinessSocialLinks?: Maybe<Array<BusinessSocialLink>>;
  /** Fetch LinkedIn sponsored ad accounts the member can publish into */
  linkedinAdAccounts: LinkedInAdAccounts;
  /** Fetch existing LinkedIn campaign groups within a selected ad account */
  linkedinCampaignGroups: LinkedInCampaignGroups;
  /** Fetch existing LinkedIn campaigns within a selected ad account */
  linkedinCampaigns: LinkedInCampaigns;
  /** Fetch LinkedIn organizations the member can author DSC posts for (DSC author discovery) */
  linkedinOrganizations: LinkedInOrganizations;
  /**
   * Scan a saved design for resizeability problems (the pre-resize dialog).
   * Requires authentication and access to the design.
   */
  lintDesignResizeability: DesignLintReport;
  /** One level of folders in the team's Cloudinary cloud, read with the signed-in admin's own Cloudinary connection. Refused with CLOUDINARY_REQUEST_REFUSED, its reason in extraInfo (and a 420's resetAt), when they aren't connected, their login belongs to another account, the folder is gone or Cloudinary is limiting requests. */
  listCloudinaryFolders: CloudinaryFolderPage;
  listCreditOperations: CreditOperationsPayload;
  listSharePointDrives: Array<SharePointDrive>;
  listSharePointFolderChildren: Array<SharePointDriveItem>;
  listSharePointSites: Array<SharePointSite>;
  loadBrandControl: LoadBrandControlResult;
  /**
   * Load brand kits for a team.
   * Requires authentication and access to the team.
   */
  loadBrandKits: BrandKitsResult;
  /**
   * Single catalog by hash. Access control runs in the service via the feed
   * machinery (catalog = feed identity, D23) — same check as loadFeed.
   */
  loadCatalog?: Maybe<Catalog>;
  /**
   * Connected designs of a catalog (CRE-426, §5, D19) — one entry per attached
   * design (design_feed join), enriched with publish/DPA/destination state.
   * Read-only aggregation over existing services, batched per data family (no
   * per-design N+1, no S3 read). Access via the feed machinery (hash-based,
   * like loadCatalog — read access, not manage).
   */
  loadCatalogConnections: Array<CatalogConnection>;
  /**
   * Merged products of a catalog (CRE-406): source rows ⊕ overrides ⊕ tags,
   * searchable and paginated. Access via the feed machinery (hash-based, like
   * loadCatalog); rate limit mirrors loadFeedRows.
   */
  loadCatalogProducts: CatalogProducts;
  loadCatalogs: Catalogs;
  loadFeed?: Maybe<Feed>;
  loadFeedRow?: Maybe<FeedRow>;
  /** Catalog rows, for members of the feed's team. Share links read rows from loadPublicFeed's payload instead. */
  loadFeedRows?: Maybe<FeedRows>;
  loadFeeds: Feeds;
  /**
   * Business-Manager catalog listing for the Meta import picker (CRE-422).
   * Requires a connected Meta account (business_social_link) — errors with
   * FB_TOKEN_EXPIRED / FbBusinessLinkNotFound codes surface the reconnect CTA.
   */
  loadMetaCatalogs: Array<MetaCatalog>;
  loadNextgenAiCreatopyTemplates: Array<CreatopyTemplate>;
  loadNextgenAiProjectTemplateSizes: Array<NextgenAiTemplateSize>;
  loadNextgenAiProjectTemplates: Array<NextgenAiTemplate>;
  loadNextgenAiTemplateSizes: Array<NextgenAiTemplateSize>;
  loadNextgenAiTemplates: Array<NextgenAiTemplate>;
  /**
   * All product sets of a catalog, wherever they live (CRE-418, §5).
   *
   * A mirrored catalog's sets are local rows, resolved once against the merged
   * products for live match counts (no per-set N+1). A Meta-managed one keeps
   * its sets at the source, so they are read live from there and carry the
   * source's own counts — callers get one list either way and never branch on
   * storage mode. Access via the feed machinery (hash-based, like loadCatalog);
   * rate limit mirrors loadCatalogProducts.
   */
  loadProductSets: Array<ProductSet>;
  loadPublicFeed?: Maybe<PublicFeedData>;
  loadSampleDemoFeeds: SampleDemoFeeds;
  loadSetHashes: Array<Scalars['String']['output']>;
  loginVeevaSso: LoginVeevaResponse;
  matcher: MatcherData;
  /** Get the currently authenticated user's information. */
  me: User;
  /**
   * Get media assets with filtering and pagination.
   * Returns a paginated list of media assets matching the criteria.
   */
  media: MediaResult;
  /**
   * Get a single media asset by its hash.
   * Returns detailed information about a specific media asset.
   */
  medium: Media;
  /** @deprecated Migration service has been removed */
  migrateStatus: MigrateStatusPayload;
  /**
   * Get information about a migrated template.
   * Used to retrieve data about templates migrated from legacy systems.
   * @deprecated Migration service has been removed
   * @deprecated Migration service has been removed
   */
  migratedTemplate: MigratedTemplatePayload;
  /** @deprecated Migration service has been removed */
  migrationAccounts: MigrationAccountsPayload;
  /** @deprecated Migration service has been removed */
  migrationData: MigrationDataPayload;
  /** @deprecated Migration service has been removed */
  migrationPlan: MigrationPlanPayload;
  moodBoard: MoodBoardPayload;
  moodBoardCommentThreads: Array<MoodBoardCommentThread>;
  moodBoardComments: Array<MoodBoardComment>;
  moodBoardShare: MoodBoardShare;
  moodBoardVersionContent: Scalars['JSON']['output'];
  moodBoardVersions: MoodBoardVersionList;
  moodBoardsByBrandKitId: Array<MoodBoard>;
  moodBoardsByProjectId: Array<MoodBoard>;
  /** The caller's own motion drafts (made by their downloads) waiting for a decision, newest first (at most 20). Empty while static_to_motion is closed. */
  motionDrafts: Array<MotionDraft>;
  onboardingData?: Maybe<OnboardingDataType>;
  partnersDv360: PartnersDv360Payload;
  /** Check if the subscription can be paused and get available pause options */
  pauseEligibility: PauseEligibilityResult;
  /** The signed-in user's own Google Ads integrations; input.userId is ignored. */
  personalGoogleAdsIntegrations: Array<GoogleAdsIntegrationResult>;
  /** The signed-in user's own integrations; input.userId is ignored. */
  personalIntegrations: Array<PersonalIntegrationResult>;
  /**
   * Get the user's personal project in a team.
   * Requires authentication and access to the team.
   */
  personalProject: Project;
  photoshopStatus: PhotoshopStatusPayload;
  pinnedFolders: PinnedFolders;
  pinterestAdAccounts: Array<PinterestAdAccount>;
  pinterestAdGroups: Array<PinterestAdGroup>;
  pinterestAds: Array<PinterestAd>;
  pinterestBoards: PinterestBoard;
  pinterestBoardsList: Array<PinterestBoardOption>;
  pinterestCampaigns: Array<PinterestCampaign>;
  pinterestCatalogs: Array<PinterestCatalogOption>;
  pinterestConnectedAccounts: Array<PinterestConnectedAccount>;
  pinterestConversionTags: Array<PinterestConversionTag>;
  pinterestTargetingOptions: Array<PinterestTargetingOption>;
  plans: Array<PlanGroup>;
  /** Get platform ads for a brand kit */
  platformAds: Array<PlatformAd>;
  premiumAssetsUsage: PremiumAssetsUsageResult;
  previewCheckout: PreviewCheckoutPayload;
  previewSubscriptionChange: PreviewSubscriptionChangePayload;
  previewTopUpCredits: PreviewTopUpCreditsPayload;
  previewUpdates?: Maybe<ProductUpdate>;
  pricingAbTest: PricingAbTestPayload;
  /**
   * Get a specific project by ID.
   * Requires authentication and access to the project.
   */
  project: Project;
  projectDesignTemplates: ProjectDesignTemplatesPayload;
  /**
   * Get designs in a project.
   * Requires authentication and access to the project.
   */
  projectDesigns: ProjectDesignsPayload;
  /**
   * Get projects with pagination.
   * Requires authentication and access to the team.
   */
  projects: ProjectsResults;
  /**
   * Get project shortcuts for quick access.
   * Requires authentication and access to the team.
   */
  projectsShortcuts: ProjectsShortcutsResults;
  promotionalPlan: Plan;
  /** Get detailed information about a specific ad including audience and transparency data */
  publicAdDetails: AdDetailsResponse;
  publicBraintreeClientToken: BraintreeClientTokenPayload;
  /** Retrieve ads from a specific brand across different platforms with pagination */
  publicBrandAds: BrandAdsResponse;
  /** Get the total count of ads for a brand across all platforms */
  publicBrandAdsCount: Array<PlatformStats>;
  /** Get detailed information about a specific Facebook brand/page */
  publicBrandDetails: FacebookBrandDetailsResponse;
  /**
   * Get a public design by public hash.
   * Public access, no authentication required.
   */
  publicDesign: Design;
  /**
   * Get public designs from a public folder.
   * Public access, no authentication required.
   */
  publicDesigns: DesignsResult;
  publicFolders: Folders;
  /** Get public link for Design or Folder */
  publicLink: PublicLinkPayload;
  /**
   * Get public details about a team.
   * Requires authentication and MANAGE_TEAMS permission on the team.
   */
  publicTeamDetails: PublicTeamDetailsResult;
  publishVeevaDocument: VeevaDocumentUpdateStatus;
  /** Grade a PASTED resize candidate against a SAVED reference design (the original being resized) with the resize-ranking engine's deterministic tiers (json + html — the image/vision tier never runs on this surface). Scoped to a design the caller can access. */
  rankResizeAgainstSaved: ResizeRankingResult;
  recentCreativesAndMoodboards: Array<RecentCreativeAndMoodboardItem>;
  recentDesigns: Array<Design>;
  /** @deprecated We replaced this with Pinned folders */
  recentFolders: RecentFolders;
  /**
   * designVersion for a removed size, or a removed variation that is not a set.
   * Requires authentication and DESIGN permission on it.
   */
  removedDesignVersion: DesignVersion;
  /**
   * Picker-fallback for `resizeWithTemplate`: when the strict auto-pick
   * fails (returns `resizeType: none`), call this to surface up to 3
   * relaxed matches. Each option carries a pre-rendered preview banner
   * the FE renders in a chooser modal; on confirm, FE feeds the chosen
   * `templateSetHash` back into `resizeWithTemplate` as
   * `templateSetIdOverride` to run the full resize against that
   * template.
   *
   * Returns an empty list when the team is outside the similarity
   * rollout, the source is unusable (multi-slide etc.), or no
   * candidate clears the relaxed confidence threshold.
   */
  resizeAlternatives: ResizeAlternativesPayload;
  /**
   * Flex-resize variants — a NEW alternative to template resize. The
   * `layoutTreeAgent` authors the source's layout TREE (structure + intent);
   * the deterministic engine renders it with Yoga at a representative
   * user-selected size per orientation and returns full preview banners in the
   * SAME shape as `resizeAlternatives` (so the picker modal renders them
   * unchanged). Returns an empty list when the source is unusable or no valid
   * tree could be produced.
   */
  resizeFlexVariants: ResizeAlternativesPayload;
  /** Get resource access (hasAcess, location, type) */
  resourceAccess: ResourceAccessPayload;
  scoring: ScoreResult;
  search: SearchPayload;
  /** Search for brands using external Brand Search API (alternative to Facebook). */
  searchBrandsApi: BrandSearchApiResponse;
  searchDriveItems: IntegrationItemsResult;
  searchDropboxItems: IntegrationItemsResult;
  /** Search inside feed json rows in the index of search service (applied rate limit to 50 requests per minute) */
  searchFeedRows: SearchFeedRowsPayload;
  /**
   * Search for Google ad suggestions based on keywords.
   * Returns advertisers and domains that match the search criteria.
   */
  searchGoogleSuggestions: GoogleSuggestionsSearchResponse;
  /**
   * Search for Facebook brands/pages based on various criteria.
   * Returns a list of brands that match the search query with their basic information.
   */
  searchPublicBrands: FacebookBrandSearchResponse;
  searchVeevaDocuments: VeevaResult;
  /** Reads a SharePoint document with the caller's own SharePoint connection and converts it to ISI rich text (CRE-706). templateLeaf as for aemContentFragmentIsi. */
  sharePointDocumentIsi: AemContentFragmentIsi;
  /** Get the Share panel's saved variation selection for a design's public link */
  shareVariationSelection: ShareVariationSelectionPayload;
  /**
   * Get sharing information for a design.
   * Requires authentication and access to the design.
   */
  sharedDesign: SharedDesignPayload;
  /**
   * Get designs shared with the current user.
   * Requires authentication and access to the specified resources.
   */
  sharedDesigns: DesignsResult;
  sharedFolderData: FolderSharedTo;
  sharedFolders: Folders;
  shutterstockCategories: ShutterstockCategoriesResult;
  shutterstockDownloadUrl: ShutterstockDownloadResult;
  /** Generates a signed URL for uploading an ad network logo. */
  signAdNetworkLogoUploadUrl: SignUploadUrlResult;
  /** Presigned upload for one brand kit document. Requires MANAGE_BRANDS. */
  signBrandKitDocumentUploadUrl: BrandKitDocumentUploadUrl;
  /**
   * Presigned upload for a document the user attaches to this design's chat,
   * for the assistant to read back. Requires the DESIGN permission on that
   * design — attaching a document the assistant reads is an act of editing
   * this design, not of administering the team's brand kit.
   *
   * Deliberately NOT `signBrandKitDocumentUploadUrl`, which requires
   * MANAGE_BRANDS and must keep it: that signer also feeds the import that
   * writes to the brand kit. Only the PERMISSION differs — both mint the same
   * owner-stamped key through the same service, so a chat upload is admitted,
   * owned and read exactly like any other.
   */
  signChatDocumentUploadUrl: ChatDocumentUploadUrl;
  signUploadUrl: SignUploadUrlResult;
  /** Get a presigned URL for uploading a profile picture. */
  signedUserProfilePicturePost: PresignedPost;
  slackChannels: SlackChannelsResult;
  slackIntegrations: Array<AppIntegration>;
  smartCrop: Array<SmartCropResult>;
  smartCropOnImage: SmartCropOnImagePayload;
  stockAudio: StockAudioPayload;
  stockMedia: StockMediaResult;
  storyBlocksDownloadUrl: StoryBlocksDownload;
  subscription?: Maybe<RecurlySubscription>;
  /** Which layers should vary in a content-variation run — LLM-picked (context-enriched), logic fallback, cached. */
  suggestContentVariationTargets: ContentVariationTargets;
  /** 3-5 AI-suggested audiences for per-audience content variations — ephemeral, empty when unavailable. */
  suggestDefaultAudiences: DefaultAudiences;
  /** The column matcher behind the catalog_column_matcher_v2 gate: the name matches, then the model for the rest. */
  suggestFeedColumnBindings: FeedBindingSuggestions;
  suggestedDesignSizeTypes: Array<DesignSizeType>;
  systemRoles: Array<TeamRole>;
  tagContainer: TagContainer;
  tagContainerAdTagNetworks: TagContainerNetworksPayload;
  tagContainerGenerateCode: TagContainerGenerateCodePayload;
  tagContainerSyncStatus: TagContainerSyncStatus;
  /**
   * Get a specific team by ID.
   * Requires authentication and access to the team.
   */
  team: Team;
  teamAbTests: AbTests;
  /**
   * Get client IDs for a team.
   * Requires authentication and VIEW permission on the team.
   */
  teamClientId: Array<Maybe<TeamClientId>>;
  /** The team's default (oldest) regular brand kit, or null if the team has none. Cheap single-kit lookup that does not load the full list. */
  teamDefaultBrandKit?: Maybe<BrandKit>;
  /** The team's most used single sizes (predefined, or the team's own custom ones) over the last 90 days, most designs first: ten at most, fewer when the team made designs at fewer sizes. */
  teamFrequentlyUsedDesignSizeTypes: Array<TeamFrequentlyUsedDesignSizeType>;
  teamGoogleAdsIntegrations: Array<GoogleAdsIntegrationResult>;
  teamIntegrations: Array<TeamIntegrationResult>;
  /** Get a list of team invitations for the current user. */
  teamInvitations: Array<TeamInvitation>;
  teamMetaIntegrations: Array<TeamMetaIntegrationResult>;
  teamPaymentVariant: TeamPaymentVariantPayload;
  teamPricingSource: TeamPricingSourcePayload;
  teamRole: TeamRole;
  teamRoleExists: Scalars['Boolean']['output'];
  teamRoles: Array<TeamRole>;
  /**
   * Fetch a specific team user group.
   * Requires authentication and MANAGE_TEAMS permission on the team.
   */
  teamUserGroup: TeamUserGroup;
  /**
   * Fetch all user groups in a team.
   * Requires authentication and access to the team.
   */
  teamUserGroups: Array<TeamUserGroup>;
  /**
   * Get webhooks for a team.
   * Requires authentication and VIEW permission on the team.
   */
  teamWebhook: Array<Maybe<TeamWebhook>>;
  /**
   * Get data about a specific webhook.
   * Requires authentication and VIEW permission on the team.
   */
  teamWebhookData: TeamWebhookData;
  /**
   * Get all teams the current user belongs to.
   * Requires authentication.
   */
  teams: Array<Team>;
  /**
   * Get teams that match the current user's email domain.
   * @deprecated Do not use anymore
   */
  teamsByUserDomain: Array<Maybe<TeamsByUserDomain>>;
  /**
   * Get a temporary presigned S3 URL for font uploads.
   * Used for font validation before permanent storage.
   */
  tempFontUploadUrl: UploadUrlPayload;
  /**
   * Get all template categories.
   * Returns a list of available template categories.
   */
  templateCategories: DesignTemplateCategoryPayload;
  /**
   * Get all template color tags.
   * Returns a list of color-specific template tags.
   */
  templateColorTags: DesignTemplateTagPayload;
  /**
   * Get information about a template design.
   * Deprecated: use templateSetDesigns instead.
   * @deprecated Use templateSetDesigns
   */
  templateDesign: TemplateDesignPayload;
  /**
   * Get detailed information about a template set design.
   * Returns comprehensive data about a specific template set.
   */
  templateSetDesigns: TemplateSetDesignsPayload;
  /**
   * Get all template style tags.
   * Returns a list of style-specific template tags.
   */
  templateStyleTags: DesignTemplateTagPayload;
  /**
   * Get all template tags.
   * Returns a list of available template tags.
   */
  templateTags: DesignTemplateTagPayload;
  /**
   * Get all templates filtered by the input filter.
   * Returns paginated templates for the website gallery.
   */
  templates: TemplatesWebsitePayload;
  /**
   * Get templates for sitemap generation.
   * Returns template data structured for XML sitemap creation.
   */
  templatesSitemap: TemplatesWebsiteSitemapPayload;
  tiktokAdGroups: Array<TikTokAdGroup>;
  tiktokAdvertisers: Array<TikTokAdvertiser>;
  /** DPA Catalog: the Business Centers a catalog can be created in, read with the caller's own TikTok connection. */
  tiktokBusinessCenters: Array<TikTokBusinessCenter>;
  tiktokCampaigns: Array<TikTokCampaign>;
  /** DPA Catalog: the regions a Business Center may create a catalog in, each with its currency when known. */
  tiktokCatalogRegions: Array<TikTokCatalogRegion>;
  /** DPA Catalog: the product catalogs of a Business Center. */
  tiktokCatalogs: Array<TikTokCatalog>;
  /** The design's attached feed checked against TikTok's product schema, for the warnings the catalog flows show before a publish. */
  tiktokFeedFieldsValidation: TikTokFeedFieldsValidationPayload;
  tiktokIdentities: Array<TikTokIdentity>;
  tiktokPixels: Array<TikTokPixel>;
  tiktokRegions: Array<TikTokRegion>;
  /** Track account properties in segment */
  trackAccountProperties: Scalars['Boolean']['output'];
  /** Track segment event */
  trackSegmentEvent: Scalars['Boolean']['output'];
  /**
   * Retrieves a paginated list of items in the team's trash.
   * Requires authentication and team access permissions.
   */
  trashItems: TrashItemsResult;
  tryAdStudio: TryAdStudioResult;
  tryNextgenAi: TryNextgenAiResult;
  tutorialsCategory: TutorialsResultApp;
  /** Get the two-factor authentication status for the current user. */
  twoFactor: TwoFactor;
  ugcExportStatus: DownloadStatus;
  /**
   * Get a presigned S3 URL for brand kit logo uploads.
   * Used when uploading logos to a brand kit.
   */
  uploadBrandKitLogoUrl: UploadBrandKitLogoUrlPayload;
  uploadMaskUrl: SignedMediaUrl;
  /** Get the onboarding preferences for the current user. */
  userOnboarding: UserOnboardingPayload;
  /** @BreakingBad */
  userProfilesCM360: UserProfilesCm360Payload;
  validEmail: ValidEmailResult;
  /**
   * Deprecated dummy. The layout-changed check is now performed server-side
   * inside `resizeWithTemplate` (id-based path falls through to similarity
   * automatically when the layout has drifted). This query always returns
   * `false` and exists only to give external clients a release cycle to
   * drop the field — remove from your queries.
   * @deprecated Layout-changed gating is handled server-side inside resizeWithTemplate. Drop this query — it now always returns false.
   */
  wasTemplateLayoutChanged: Scalars['Boolean']['output'];
  /**
   * Get all available webhook action types.
   * Requires authentication.
   */
  webhookActionList: Array<TeamWebhookActionType>;
  whatsNew: ProductUpdateResult;
  /**
   * Get the Zapier feedback level for a team.
   * Requires authentication and VIEW permission on the team.
   */
  zapierFeedbackLevel?: Maybe<FeedbackLevel>;
};


export type QueryAbTestArgs = {
  input: InputAbTest;
};


export type QueryAbTestDesignsArgs = {
  input: InputAbTest;
};


export type QueryAbTestsArgs = {
  input: InputAbTests;
};


export type QueryAccountArgs = {
  input: InputAccountStats;
};


export type QueryAdInsightsArgs = {
  input: AdInsightsInput;
};


export type QueryAdNetworksArgs = {
  input: InputAdNetworks;
};


export type QueryAdPublishProgressArgs = {
  input: GetAdPublishProgressInput;
};


export type QueryAdServingNetworksArgs = {
  input: InputAdServingNetworks;
};


export type QueryAdServingSettingsArgs = {
  input: InputAdServing;
};


export type QueryAdServingStatusArgs = {
  input: InputAdServingStatus;
};


export type QueryAdStudioFamilyRemovedVersionHistoryArgs = {
  input: InputDesignVersionHistory;
};


export type QueryAdStudioFamilyRowsArgs = {
  input: InputDesign;
};


export type QueryAdStudioFamilySizeJsonsArgs = {
  input: InputAdStudioFamilySizeJsons;
};


export type QueryAdStudioLogoAvailabilityArgs = {
  designHash: Scalars['String']['input'];
};


export type QueryAdStudioTestClaimedArgs = {
  input: InputAdStudioTestClaimed;
};


export type QueryAdStudioVariationsSyncEffectsArgs = {
  input: InputDesign;
};


export type QueryAdTagDesignNetworksArgs = {
  input: InputDesignAdTag;
};


export type QueryAdTagDesignSettingsArgs = {
  input: InputDesignAdTag;
};


export type QueryAdTagDesignSyncStatusArgs = {
  input: InputDesignAdTag;
};


export type QueryAdTagDynamicVarsArgs = {
  input: InputDesignAdTag;
};


export type QueryAdTagExternalDesignTrackingArgs = {
  input: InputDesignAdTag;
};


export type QueryAdTagGenerateCodeArgs = {
  input: InputAdTagGenerateCode;
};


export type QueryAdTagReportArgs = {
  input: InputAdTagReport;
};


export type QueryAdTagReportDataArgs = {
  input: InputAdTagReport;
};


export type QueryAdTagReportsArgs = {
  input: InputAdTagReports;
};


export type QueryAdTagSubscriptionArgs = {
  input: InputAdTagSubscription;
};


export type QueryAdTagUsageArgs = {
  input: InputAdTagUsage;
};


export type QueryAddCompetitorArgs = {
  input: InputAddCompetitor;
};


export type QueryAdsLibraryChatMessagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sessionId: Scalars['ID']['input'];
};


export type QueryAdsLibraryChatSessionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdvertisersCm360Args = {
  input: AdvertisersInput;
};


export type QueryAdvertisersDv360Args = {
  input: AdvertisersDv360Input;
};


export type QueryAemContentFragmentIsiArgs = {
  publishUrl: Scalars['String']['input'];
  templateLeaf?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryAemContentFragmentIsiFromAuthorArgs = {
  fragmentId: Scalars['String']['input'];
  imsToken: Scalars['String']['input'];
  repositoryId: Scalars['String']['input'];
  templateLeaf?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryAiResizeJsonArgs = {
  input: InputAiResizeJson;
};


export type QueryAiResizeStatusArgs = {
  input: InputAiResizeStatus;
};


export type QueryAiResizeVariantStatusArgs = {
  input: InputAiResizeVariantStatus;
};


export type QueryAllUserProjectsArgs = {
  input: InputAllUserProjects;
};


export type QueryAnalyzeDesignTreeArgs = {
  input: InputAnalyzeDesignTree;
};


export type QueryAnalyzeImageArgs = {
  imageUrl: Scalars['String']['input'];
};


export type QueryAnalyzeSourceDesignArgs = {
  input: InputAnalyzeSourceDesign;
};


export type QueryAppTemplatesArgs = {
  input: InputAppTemplates;
};


export type QueryAskOnboardingAssistantArgs = {
  input: InputAskOnboardingAssistant;
};


export type QueryAvailableApiTokenScopesArgs = {
  input: InputAvailableApiTokenScopes;
};


export type QueryBackgroundTypeArgs = {
  input: InputBackgroundType;
};


export type QueryBalanceArgs = {
  input: InputBalance;
};


export type QueryBannersnackDesignJsonArgs = {
  input: InputBannersnackDesignJson;
};


export type QueryBannersnackDesignSetJsonArgs = {
  input: InputBannersnackDesignJson;
};


export type QueryBannersnackDesignsJsonArgs = {
  input: InputBannersnackDesignsJson;
};


export type QueryBillingInfoArgs = {
  input: InputBillingInfo;
};


export type QueryBrandAnalyticsArgs = {
  brandCompetitorId?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<BrandAnalyticsInput>;
};


export type QueryBrandCompetitorByIdsArgs = {
  input: BrandCompetitorByIdsInput;
};


export type QueryBrandCompetitorsArgs = {
  input: BrandCompetitorsInput;
};


export type QueryBrandInsightsArgs = {
  input: BrandInsightsInput;
};


export type QueryBrandKitAssetDescriptionArgs = {
  input: InputBrandKitAssetDescription;
};


export type QueryBrandKitDocumentsArgs = {
  input: InputBrandKitDocuments;
};


export type QueryBrandKitFontsByFamilyArgs = {
  input: InputBrandKitFontsByFamily;
};


export type QueryBrandTargetAudiencesArgs = {
  input: InputBrandTargetAudience;
};


export type QueryBrandTemplateBrandKitLogoArgs = {
  input: InputDesign;
};


export type QueryBrandTemplateDesignsArgs = {
  input: InputBrandTemplateDesigns;
};


export type QueryBrandTemplateFolderTreeArgs = {
  input: InputBrandTemplatesFolderTree;
};


export type QueryBrandTemplateFoldersArgs = {
  input: InputBrandTemplateFolders;
};


export type QueryBriefAssetsSlotArgs = {
  designHash: Scalars['String']['input'];
  threadId: Scalars['String']['input'];
};


export type QueryBsUserTeamMembersArgs = {
  input: InputMigrate;
};


export type QueryBulkAbTestTagContainerSyncStatusArgs = {
  input: InputBulkAbTestTagContainerSyncStatus;
};


export type QueryBulkAdTagDesignSyncStatusArgs = {
  input: InputBulkDesignAdTag;
};


export type QueryBulkDownloadAiAgentAutomatedReportsArgs = {
  input: InputBulkDownloadAiAgentAutomatedReports;
};


export type QueryBulkDownloadAiAgentReportsArgs = {
  input: InputBulkDownloadAiAgentReports;
};


export type QueryCatalogChangesArgs = {
  input: CatalogChangesInput;
};


export type QueryCatalogPublishRunsArgs = {
  input: InputCatalogPublishRuns;
};


export type QueryCheckAccessToProjectArgs = {
  input: InputProject;
};


export type QueryCheckActiveJobArgs = {
  input: CheckActiveJobInput;
};


export type QueryCheckAdNetworkExistsArgs = {
  input: InputCheckAdNetworkExists;
};


export type QueryCheckAiOperationArgs = {
  input: InputCheckAiOperation;
};


export type QueryCheckAiOperationsArgs = {
  input: InputCheckAiOperations;
};


export type QueryCheckAiTranslateFeedFontsCompatibilityArgs = {
  input: InputCheckAiTranslateFeedFontsCompatibility;
};


export type QueryCheckBulkFontCompatibleArgs = {
  input: InputCheckBulkFontCompatible;
};


export type QueryCheckCouponAppliedArgs = {
  input: CheckCouponAppliedInput;
};


export type QueryCheckDesignFontsCompatibilityArgs = {
  input: InputCheckDesignFontsCompatibility;
};


export type QueryCheckDownloadCacheArgs = {
  input: InputDownloadCreate;
};


export type QueryCheckDuplicatingFolderArgs = {
  input: InputCheckDuplicatingFolder;
};


export type QueryCheckEditingDesignArgs = {
  input: InputCheckEditingDesign;
};


export type QueryCheckFeedColumnBgRemoveEligibilityArgs = {
  input: InputFeedColumnBgRemoveEligibility;
};


export type QueryCheckFeedSourceUrlArgs = {
  input: InputCheckFeedSourceUrl;
};


export type QueryCheckFeedStatusActionTypeArgs = {
  input: InputCheckFeedStatusActionType;
};


export type QueryCheckFontCompatibleArgs = {
  input: InputCheckFontCompatible;
};


export type QueryCheckFontCompatibleWithLanguageArgs = {
  input: InputCheckFontCompatibleWithLanguage;
};


export type QueryCheckFontForBrowsersArgs = {
  input: InputCheckFontForBrowsers;
};


export type QueryCheckIfTeamIsInPaymentExperimentArgs = {
  input: InputCheckIfTeamIsInPaymentExperiment;
};


export type QueryCheckMoodBoardMediaArgs = {
  input: InputCheckMoodBoardMedia;
};


export type QueryCheckScoreChecksumArgs = {
  input: InputCheckScoreChecksum;
};


export type QueryCheckTranslateFeedStatusArgs = {
  input: InputCheckTranslateFeedStatus;
};


export type QueryCheckValidCodeArgs = {
  input: InputCheckValidCode;
};


export type QueryContentVariationJobsArgs = {
  input: InputContentVariationJobs;
};


export type QueryCopilotActiveBrandExtractionArgs = {
  input: InputCopilotActiveBrandExtraction;
};


export type QueryCopilotBrandExtractionArgs = {
  input: InputCopilotBrandExtraction;
};


export type QueryCopilotDocumentBrandKitPreviewArgs = {
  input: InputCopilotDocumentBrandKitPreview;
};


export type QueryCopilotMediaImportArgs = {
  input: InputCopilotMediaImport;
};


export type QueryCopilotPendingGenerationsArgs = {
  input: InputCopilotPendingGenerations;
};


export type QueryCopilotSceneEditArgs = {
  input: InputCopilotSceneEdit;
};


export type QueryCountProductSetRuleMatchesArgs = {
  input: InputCountProductSetRuleMatches;
};


export type QueryCouponDiscountArgs = {
  input: InputCouponDiscount;
};


export type QueryCraftedDesignsArgs = {
  input: CraftedDesignsInput;
};


export type QueryCurrentSubscriptionArgs = {
  input: InputCurrentSubscription;
};


export type QueryCurrentTeamDownloadsArgs = {
  input: InputCurrentTeamDownloads;
};


export type QueryCustomDesignSetSizeTypesArgs = {
  input: InputCustomDesignSetSizeTypes;
};


export type QueryDesignArgs = {
  input: InputDesign;
};


export type QueryDesignApprovalHistoryArgs = {
  input: InputDesignApprovalHistory;
};


export type QueryDesignCheckArgs = {
  input: InputDesignCheck;
};


export type QueryDesignClickHeatmapArgs = {
  input: InputDesignClickHeatmap;
};


export type QueryDesignComponentArgs = {
  input: InputDesignComponent;
};


export type QueryDesignContentArgs = {
  input: InputDesignContent;
};


export type QueryDesignFeedAdjustmentArgs = {
  input: InputDesignFeedAdjustment;
};


export type QueryDesignFeedAdjustmentsArgs = {
  input: InputDesignFeedAdjustments;
};


export type QueryDesignHtmlSettingsArgs = {
  input: InputDesignHtmlSettings;
};


export type QueryDesignImportableMediaArgs = {
  input: InputDesign;
};


export type QueryDesignLocationArgs = {
  input: InputDesign;
};


export type QueryDesignMediaImportBrowseArgs = {
  input: InputDesignMediaImportBrowse;
};


export type QueryDesignNewAdStudioBetaArgs = {
  input: InputDesign;
};


export type QueryDesignProjectLogoArgs = {
  brandKitTemplatesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  input: InputDesign;
};


export type QueryDesignPublishRunsArgs = {
  input: InputDesignPublishRuns;
};


export type QueryDesignSetTemplatesArgs = {
  input: InputDesignSetTemplates;
};


export type QueryDesignSizeTypeArgs = {
  input: InputDesignSizeTypeInPx;
};


export type QueryDesignTemplatesArgs = {
  input: InputDesignTemplates;
};


export type QueryDesignTemplatesTypeCountArgs = {
  input: InputDesignTemplatesCount;
};


export type QueryDesignVersionArgs = {
  input: InputDesignVersion;
};


export type QueryDesignVersionHistoryArgs = {
  input: InputDesignVersionHistory;
};


export type QueryDesignsArgs = {
  input: InputDesigns;
};


export type QueryDesignsAdTagAnalyticsArgs = {
  input: InputDesignsAdTagAnalytics;
};


export type QueryDesignsByHashesArgs = {
  input: DesignsByHashes;
};


export type QueryDesignsDurationArgs = {
  input: InputDesignsDuration;
};


export type QueryDesignsFeedPropertyBindingArgs = {
  input: InputDesignsFeedPropertyBinding;
};


export type QueryDesignsFeedUrlBindingArgs = {
  input: InputDesignsFeedUrlBinding;
};


export type QueryDetectChatIntentArgs = {
  input: DetectChatIntentInput;
};


export type QueryDownloadAiAgentAutomatedReportArgs = {
  input: InputDownloadAiAgentAutomatedReport;
};


export type QueryDownloadAiAgentReportArgs = {
  input: InputDownloadAiAgentReport;
};


export type QueryDownloadAudioUrlArgs = {
  input: InputDownloadAudio;
};


export type QueryDownloadEnabledShareLinkArgs = {
  input: InputDownloadEnabledShareLink;
};


export type QueryDownloadFeedIntervalArgs = {
  input: InputDownloadFeedInterval;
};


export type QueryDownloadIntegrationFileArgs = {
  input: InputDownloadIntegrationFiles;
};


export type QueryDownloadPresetArgs = {
  input: InputDownloadPreset;
};


export type QueryDownloadPresetV2Args = {
  input: InputDownloadPreset;
};


export type QueryDownloadReportArgs = {
  input: InputDownloadReport;
};


export type QueryDownloadStatusArgs = {
  input: InputDownload;
};


export type QueryDpaSettingsArgs = {
  input: GetDpaSettingsInput;
};


export type QueryExpansionArgs = {
  input: InputExpansion;
};


export type QueryExportFeedToCsvArgs = {
  input: InputExportFeedToCsv;
};


export type QueryFavoriteElementsArgs = {
  input: InputFavoriteElements;
};


export type QueryFavoriteProjectsArgs = {
  input: InputFavoriteProjects;
};


export type QueryFbAdAccountsArgs = {
  input: GetFbAdAccountsInput;
};


export type QueryFbAdCreativeArgs = {
  input: GetFbAdCreativeInput;
};


export type QueryFbAdSetsArgs = {
  input: GetFbAdSetsInput;
};


export type QueryFbAdsArgs = {
  input: GetFbAdsInput;
};


export type QueryFbBusinessesArgs = {
  input: GetFbBusinessesInput;
};


export type QueryFbCampaignsArgs = {
  input: GetFbCampaignsInput;
};


export type QueryFbCatalogsArgs = {
  input: GetFbCatalogsInput;
};


export type QueryFbCustomConversionsArgs = {
  input: GetFbCustomConversionsInput;
};


export type QueryFbInstantExperiencesArgs = {
  input: GetFbInstantExperiencesInput;
};


export type QueryFbLeadFormsArgs = {
  input: GetFbLeadFormsInput;
};


export type QueryFbPagesArgs = {
  input: GetFbPagesInput;
};


export type QueryFbPixelsArgs = {
  input: GetFbPixelsInput;
};


export type QueryFbSavedAudiencesArgs = {
  input: GetFbSavedAudiencesInput;
};


export type QueryFeatureAccessForAllPlansArgs = {
  input: InputFeatureAccessForAllPlans;
};


export type QueryFeatureExpositionArgs = {
  input: InputFeatureExposition;
};


export type QueryFeaturesAccessArgs = {
  input: InputFeaturesAccess;
};


export type QueryFeaturesAccessTestDirectiveArgs = {
  input: InputFeaturesAccess;
};


export type QueryFeaturesComparisonArgs = {
  input: InputFeaturesComparison;
};


export type QueryFeedFieldsValidationArgs = {
  input: FeedFieldsValidationInput;
};


export type QueryFeedRevertBgCountArgs = {
  input: InputFeedRevertBgCount;
};


export type QueryFetcherBrandIdentityArgs = {
  input: InputBrandIdentity;
};


export type QueryFetcherFontsArgs = {
  input: InputFetcher;
};


export type QueryFetcherLogoArgs = {
  input: InputFetcher;
};


export type QueryFetcherMediaArgs = {
  input: InputFetcher;
};


export type QueryFetcherPaletteArgs = {
  input: InputFetcher;
};


export type QueryFetcherScreenshotArgs = {
  input: InputFetcher;
};


export type QueryFetcherStyleArgs = {
  input: InputFetcher;
};


export type QueryFetcherTextArgs = {
  input: InputFetcher;
};


export type QueryFigFileStatusArgs = {
  input: InputFigFileStatus;
};


export type QueryFindBrandCompetitorsArgs = {
  input: InputBrandKit;
};


export type QueryFindCompetitorsArgs = {
  input: InputFindCompetitors;
};


export type QueryFocalPointArgs = {
  input: InputFocalPoint;
};


export type QueryFolderArgs = {
  input: InputFolder;
};


export type QueryFolderTreeArgs = {
  input: InputFolderTree;
};


export type QueryFoldersArgs = {
  input: InputFolders;
};


export type QueryFontUploadUrlArgs = {
  input: InputFontUploadUrl;
};


export type QueryGenerateBrandedCopyArgs = {
  input: InputGenerateBrandedCopy;
};


export type QueryGenerateVeevaPdfStatusArgs = {
  input: InputGenerateVeevaPdfStatus;
};


export type QueryGeneratorTextContentArgs = {
  input: InputGeneratorTextContent;
};


export type QueryGetAccessTokenArgs = {
  input: InputGetAccessToken;
};


export type QueryGetActiveUsageRestrictionsArgs = {
  input: GetActiveUsageRestrictionsInput;
};


export type QueryGetAdNetworkByIdArgs = {
  input: InputGetAdNetworkById;
};


export type QueryGetAdStudioThreadMessagesArgs = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  designHash: Scalars['String']['input'];
  threadId: Scalars['String']['input'];
};


export type QueryGetAdStudioThreadsArgs = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  designHash: Scalars['String']['input'];
};


export type QueryGetAddonsUsageArgs = {
  input: InputAddonsUsage;
};


export type QueryGetAiAgentAutomatedReportsDashboardArgs = {
  input: InputGetAiAgentAutomatedReportsDashboard;
};


export type QueryGetAiChatsArgs = {
  input: InputGetAiChats;
};


export type QueryGetAiOperationProgressArgs = {
  input: InputGetAiOperationProgress;
};


export type QueryGetAiOperationUsageArgs = {
  input: InputAiOperationUsage;
};


export type QueryGetAiStudioGenerationsArgs = {
  input: InputAiStudioGenerations;
};


export type QueryGetAnimationSuggestionsArgs = {
  input: InputAnimationSuggestions;
};


export type QueryGetAssetSelectorConfigArgs = {
  teamId: Scalars['Int']['input'];
};


export type QueryGetAuthEventsArgs = {
  input: InputGetAuthEvents;
};


export type QueryGetAutomatedReportHtmlArgs = {
  input: InputGetAutomatedReportHtml;
};


export type QueryGetAutomatedReportHtmlByIdArgs = {
  input: InputGetAutomatedReportHtmlById;
};


export type QueryGetAutomatedReportPublicHashArgs = {
  input: InputGetAutomatedReportPublicHash;
};


export type QueryGetAutomatedReportPublicResourceAccessArgs = {
  input: InputGetAutomatedReportPublicResourceAccess;
};


export type QueryGetAutomatedScheduleReportsArgs = {
  input: InputGetAutomatedScheduleReports;
};


export type QueryGetBgRemoverCreditsArgs = {
  input: InputGetBgRemoverCredits;
};


export type QueryGetBrandKitArgs = {
  input: InputBrandKit;
};


export type QueryGetBrandKitJsonArgs = {
  input: InputGetBrandKitJson;
};


export type QueryGetBrandKitProfileArgs = {
  input: InputGetBrandKitProfile;
};


export type QueryGetBrandKitProjectIdArgs = {
  input: InputGetBrandKitProjectId;
};


export type QueryGetBrandKitVisualStyleArgs = {
  input: InputGetBrandKitVisualStyle;
};


export type QueryGetBrandKitVoiceAndToneArgs = {
  input: InputGetBrandKitVoiceAndTone;
};


export type QueryGetBriefAssetsArgs = {
  designHash: Scalars['String']['input'];
  threadId: Scalars['String']['input'];
};


export type QueryGetBynderAssetArgs = {
  input: InputGetBynderAsset;
};


export type QueryGetBynderAssetDownloadArgs = {
  input: InputGetBynderAssetDownload;
};


export type QueryGetBynderAssetsArgs = {
  input: InputGetBynderAssets;
};


export type QueryGetBynderCollectionsArgs = {
  input: InputGetBynderCollections;
};


export type QueryGetBynderCurrentUserArgs = {
  input: InputBynderGetCurrentUser;
};


export type QueryGetCloudIntegrationArgs = {
  input: InputGetCloudIntegration;
};


export type QueryGetCloudinaryConfigArgs = {
  input: InputGetCloudinaryConfig;
};


export type QueryGetColumnsFromFeedSourceArgs = {
  input: InputGetColumnsFromFeedSource;
};


export type QueryGetColumnsFromFeedSourceUrlArgs = {
  input: InputGetColumnsFromFeedSourceUrl;
};


export type QueryGetCommentAttachmentUrlArgs = {
  input: InputCommentAttachmentUploadUrl;
};


export type QueryGetCommentAttachmentsArgs = {
  input: InputGetCommentAttachments;
};


export type QueryGetCompatibleFontsForLanguagesArgs = {
  input: InputGetCompatibleFontsForLanguages;
};


export type QueryGetCompetitorSummaryArgs = {
  brandCompetitorId: Scalars['Int']['input'];
};


export type QueryGetCopilotAiChatPublicHashArgs = {
  input: InputGetCopilotAiChatPublicHash;
};


export type QueryGetCopilotAiChatPublicResourceAccessArgs = {
  input: InputGetCopilotAiPublicResourceAccess;
};


export type QueryGetCopilotAiChatsArgs = {
  input: InputGetCopilotAiChats;
};


export type QueryGetCopilotAiReportPublicHashArgs = {
  input: InputGetCopilotAiReportPublicHash;
};


export type QueryGetCopilotAiReportPublicResourceAccessArgs = {
  input: InputGetCopilotAiPublicResourceAccess;
};


export type QueryGetCreditBalanceArgs = {
  input: GetCreditBalanceInput;
};


export type QueryGetCreditTransactionHistoryArgs = {
  input: GetCreditTransactionHistoryInput;
};


export type QueryGetCustomBrandingArgs = {
  input: InputGetCustomBranding;
};


export type QueryGetCustomTransitionsArgs = {
  input: InputGetCustomTransitions;
};


export type QueryGetDesignAnimatorSuggestionsArgs = {
  input: InputDesignAnimatorSuggestions;
};


export type QueryGetDesignCommentsArgs = {
  input: InputGetDesignComments;
};


export type QueryGetDesignComponentNameArgs = {
  input: InputGetDesignComponentName;
};


export type QueryGetDesignEditingStatusArgs = {
  input: InputGetDesignEditingStatus;
};


export type QueryGetDesignTypeArgs = {
  input: InputGetDesignType;
};


export type QueryGetDetectedLanguageForTextArgs = {
  input: InputGetDetectedLanguageForText;
};


export type QueryGetDomainStatusArgs = {
  input: InputGetDomainStatus;
};


export type QueryGetDownloadCreditsUsageArgs = {
  input: InputDownloadCreditsUsage;
};


export type QueryGetDriveItemsArgs = {
  input: InputIntegrationItems;
};


export type QueryGetDropboxItemsArgs = {
  input: InputIntegrationItems;
};


export type QueryGetEmailStatusArgs = {
  input: InputGetEmailStatus;
};


export type QueryGetEnforceTeamSsoArgs = {
  input: GetEnforceTeamSso;
};


export type QueryGetExpiredSubscriptionArgs = {
  input: InputGetExpiredSubscription;
};


export type QueryGetFeedColumnsMatchArgs = {
  input: InputFeedMatch;
};


export type QueryGetGoogleAdsCampaignsArgs = {
  input: InputGetGoogleAdsCampaigns;
};


export type QueryGetGoogleAdsIntegrationsArgs = {
  input: InputTeamIntegration;
};


export type QueryGetGoogleAdvertiserByIdArgs = {
  input: GoogleAdvertiserByIdInput;
};


export type QueryGetGroupedIntegrationAccountsArgs = {
  input: InputGetIntegrationAccounts;
};


export type QueryGetIdentityProviderTeamInvitationStatusArgs = {
  input: InputGetIdentityProviderTeamInvitationStatus;
};


export type QueryGetImageSubtleAnimationArgs = {
  input: InputImageSubtleAnimation;
};


export type QueryGetImpressionsTiersArgs = {
  input: GetImpressionsTiersInput;
};


export type QueryGetIntegrationAccountEmailArgs = {
  input: InputGetCloudIntegrationAccountEmail;
};


export type QueryGetIntegrationAccountsArgs = {
  input: InputGetIntegrationAccounts;
};


export type QueryGetIntegrationFilesUrlArgs = {
  input: InputIntegrationFilesUploadUrl;
};


export type QueryGetIntegrationsArgs = {
  input: InputIntegrations;
};


export type QueryGetIsTeamMigratedArgs = {
  input: InputIsTeamMigrated;
};


export type QueryGetKeycloakConfigFileArgs = {
  input: ProviderType;
};


export type QueryGetLastCompletedAdStudioGenerationArgs = {
  designHash: Scalars['String']['input'];
};


export type QueryGetLearnAgentChatPublicHashArgs = {
  input: InputGetLearnAgentChatPublicHash;
};


export type QueryGetLearnAgentReportHtmlArgs = {
  input: InputGetLearnAgentReportHtml;
};


export type QueryGetLearnAgentReportPublicHashArgs = {
  input: InputGetLearnAgentReportPublicHash;
};


export type QueryGetMatchingColorsArgs = {
  input: InputMatchingColors;
};


export type QueryGetMetaAdPreviewArgs = {
  input: InputGetMetaAdPreview;
};


export type QueryGetMetaAdsArgs = {
  input: InputGetMetaAds;
};


export type QueryGetMoodboardThreadsArgs = {
  moodboardHash: Scalars['String']['input'];
};


export type QueryGetMultiSceneStoryboardArgs = {
  input: InputMultiSceneStoryboard;
};


export type QueryGetMultiSceneStoryboardDraftArgs = {
  input: InputMultiSceneStoryboardDraftPoll;
};


export type QueryGetNextGenBrandDescriptionArgs = {
  input: InputNextGenAiBrandedContent;
};


export type QueryGetNextGenBrandfetchArgs = {
  input: InputNextGenAiBrandedContent;
};


export type QueryGetNextGenFontsArgs = {
  input: InputNextGenAiBrandedContent;
};


export type QueryGetNextGenIdentityArgs = {
  input: InputNextGenAiBrandedContent;
};


export type QueryGetNextGenLogoArgs = {
  input: InputNextGenAiBrandedContent;
};


export type QueryGetNextGenMediaArgs = {
  input: InputNextGenAiBrandedContent;
};


export type QueryGetNextGenRecommandedBrandKitArgs = {
  input: InputNextGenRecommandedBrandKit;
};


export type QueryGetNextGenStyleArgs = {
  input: InputNextGenAiBrandedContent;
};


export type QueryGetNextGenTextArgs = {
  input: InputNextGenAiBrandedContent;
};


export type QueryGetNextgenAiArgs = {
  input: InputNextGenAi;
};


export type QueryGetRecurringCreditsTiersArgs = {
  input: GetCreditTiersInput;
};


export type QueryGetRoomTypesArgs = {
  input: InputGetRoomTypes;
};


export type QueryGetSamlConfigFileArgs = {
  input: InputGetSamlConfigFile;
};


export type QueryGetSavedScoreArgs = {
  input: InputGetSavedScore;
};


export type QueryGetSeatsTiersArgs = {
  input: GetSeatsTiersInput;
};


export type QueryGetShareLinkCommentsEnabledArgs = {
  input: InputGetShareLinkCommentsEnabled;
};


export type QueryGetSharePointAccessTokenArgs = {
  input: InputGetSharePointAccessToken;
};


export type QueryGetSharePointDefaultLocationArgs = {
  input: InputGetSharePointDefaultLocation;
};


export type QueryGetSharePointPersonalDriveArgs = {
  input: InputGetSharePointPersonalDrive;
};


export type QueryGetSharedPublicChatArgs = {
  input: InputGetSharedPublicLearnAgentChat;
};


export type QueryGetSharedPublicLearnAgentChatArgs = {
  input: InputGetSharedPublicLearnAgentChat;
};


export type QueryGetSharelinkScoreArgs = {
  input: InputGetSavedScore;
};


export type QueryGetSignedMediaUrlArgs = {
  input: InputSignedMediaUrl;
};


export type QueryGetSlackAccessTokenArgs = {
  input: InputGetSlackAccessToken;
};


export type QueryGetSubscriptionInfoArgs = {
  input: GetSubscriptionInfoInput;
};


export type QueryGetSupportedFontsForLanguagesArgs = {
  input: InputGetSupportedFontsForLanguages;
};


export type QueryGetSvgUrlArgs = {
  input: InputGetSvgUrl;
};


export type QueryGetSystemGroupArgs = {
  input: InputGetSystemGroup;
};


export type QueryGetTeamBrandKitArgs = {
  input: InputTeamBrandKit;
};


export type QueryGetTeamConsumptionReportArgs = {
  input: GetTeamConsumptionReportInput;
};


export type QueryGetTeamIdentityProviderArgs = {
  input: InputGetTeamIdentityProvider;
};


export type QueryGetTeamIdentityProviderDomainsStatusArgs = {
  input: InputGetTeamIdentityProviderDomainsStatus;
};


export type QueryGetTeamSuccessManagerArgs = {
  input: InputTeamSuccessManager;
};


export type QueryGetTeamTwoFactorArgs = {
  input: GetTeamTwoFactor;
};


export type QueryGetTempFontDetailsArgs = {
  input: InputGetTempFontDetails;
};


export type QueryGetTemporaryEnterpriseArgs = {
  input: InputGetTemporaryEnterprise;
};


export type QueryGetTextExtractionArgs = {
  input: InputTextExtraction;
};


export type QueryGetThreadMessagesArgs = {
  threadId: Scalars['String']['input'];
};


export type QueryGetTopUpCreditsTiersArgs = {
  input: GetCreditTiersInput;
};


export type QueryGetUrlContentTypeArgs = {
  input: InputGetUrlContentType;
};


export type QueryGetUserIdentityProviderAliasArgs = {
  input: InputValidProviderAlias;
};


export type QueryGetUserIdentityProviderAliasesArgs = {
  input: InputValidProviderAlias;
};


export type QueryGetUserSsoEnforcedArgs = {
  input: InputUserSsoEnforced;
};


export type QueryGetVariationSuggestionsArgs = {
  input: InputVariationSuggestions;
};


export type QueryGetVeevaAppByTeamArgs = {
  teamId: Scalars['Int']['input'];
};


export type QueryGetVeevaDocumentByNumberArgs = {
  input: InputVeevaDocNumber;
};


export type QueryGetVeevaDocumentsArgs = {
  input: InputVeevaSession;
};


export type QueryGetVeevaOptionsArgs = {
  input: VeevaOptionsQuery;
};


export type QueryGetWorkflowArgs = {
  input: InputGetWorkflow;
};


export type QueryGetWorkflowRealtimeSubscriptionTokenArgs = {
  input: InputGetWorkflowRealtimeSubscriptionToken;
};


export type QueryGetWorkflowRunsArgs = {
  input: InputGetWorkflowRuns;
};


export type QueryGoogleAdsAccountsArgs = {
  input: GoogleAdsAccountsInput;
};


export type QueryGoogleAdsAdGroupsArgs = {
  input: GoogleAdsAdGroupsInput;
};


export type QueryGoogleAdsAssetGroupsArgs = {
  input: GoogleAdsAssetGroupsInput;
};


export type QueryGoogleAdsCampaignsArgs = {
  input: GoogleAdsCampaignsInput;
};


export type QueryGoogleAdsSizeRequirementsArgs = {
  input: GoogleAdsSizeRequirementsInput;
};


export type QueryGtmPaymentDetailsArgs = {
  input: InputGtmPaymentDetails;
};


export type QueryHasAdStudioExperimentArgs = {
  input: InputHasAdStudioExperiment;
};


export type QueryHasDesignsAdTagActiveArgs = {
  input: InputHasDesignsAdTagActive;
};


export type QueryHasEverServedAdArgs = {
  input: InputHasEverServedAd;
};


export type QueryHasFeedsArgs = {
  input: InputHasFeeds;
};


export type QueryHashedTeamIdArgs = {
  input: InputHashedTeamId;
};


export type QueryInvoicesArgs = {
  input: InputInvoices;
};


export type QueryLastMetaPublicationArgs = {
  input: LastMetaPublicationInput;
};


export type QueryLinkedBusinessSocialLinksArgs = {
  input: GetLinkedBusinessLinksInput;
};


export type QueryLinkedinAdAccountsArgs = {
  input: LinkedInAdAccountsInput;
};


export type QueryLinkedinCampaignGroupsArgs = {
  input: LinkedInCampaignGroupsInput;
};


export type QueryLinkedinCampaignsArgs = {
  input: LinkedInCampaignsInput;
};


export type QueryLinkedinOrganizationsArgs = {
  input: LinkedInOrganizationsInput;
};


export type QueryLintDesignResizeabilityArgs = {
  input: InputLintDesignResizeability;
};


export type QueryListCloudinaryFoldersArgs = {
  input: InputListCloudinaryFolders;
};


export type QueryListSharePointDrivesArgs = {
  input: InputListSharePointDrives;
};


export type QueryListSharePointFolderChildrenArgs = {
  input: InputListSharePointFolderChildren;
};


export type QueryListSharePointSitesArgs = {
  input: InputListSharePointSites;
};


export type QueryLoadBrandControlArgs = {
  input: InputLoadBrandControl;
};


export type QueryLoadBrandKitsArgs = {
  input: InputBrandKits;
};


export type QueryLoadCatalogArgs = {
  input: InputCatalog;
};


export type QueryLoadCatalogConnectionsArgs = {
  input: InputCatalogConnections;
};


export type QueryLoadCatalogProductsArgs = {
  input: InputCatalogProducts;
};


export type QueryLoadCatalogsArgs = {
  input: InputCatalogs;
};


export type QueryLoadFeedArgs = {
  input: InputFeed;
};


export type QueryLoadFeedRowArgs = {
  input: InputFeedRow;
};


export type QueryLoadFeedRowsArgs = {
  input: InputFeedRows;
};


export type QueryLoadFeedsArgs = {
  input: InputFeeds;
};


export type QueryLoadMetaCatalogsArgs = {
  input: InputMetaCatalogs;
};


export type QueryLoadNextgenAiCreatopyTemplatesArgs = {
  input: InputLoadNextgenAiCreatopyTemplates;
};


export type QueryLoadNextgenAiProjectTemplateSizesArgs = {
  input: InputLoadNextgenAiTemplateSizes;
};


export type QueryLoadNextgenAiProjectTemplatesArgs = {
  input: InputLoadNextgenAiProjectTemplates;
};


export type QueryLoadNextgenAiTemplateSizesArgs = {
  input: InputLoadNextgenAiTemplateSizes;
};


export type QueryLoadNextgenAiTemplatesArgs = {
  input: InputLoadNextgenAiTemplates;
};


export type QueryLoadProductSetsArgs = {
  input: InputProductSets;
};


export type QueryLoadPublicFeedArgs = {
  input: InputPublicFeed;
};


export type QueryLoadSetHashesArgs = {
  input: InputSetHashes;
};


export type QueryLoginVeevaSsoArgs = {
  teamId: Scalars['Int']['input'];
};


export type QueryMatcherArgs = {
  input: InputMatcher;
};


export type QueryMediaArgs = {
  input: InputMedia;
};


export type QueryMediumArgs = {
  input: InputMedium;
};


export type QueryMigrateStatusArgs = {
  input: InputTeam;
};


export type QueryMigratedTemplateArgs = {
  input: InputDesign;
};


export type QueryMigrationAccountsArgs = {
  input: InputMigrationAccounts;
};


export type QueryMigrationDataArgs = {
  input: InputMigrate;
};


export type QueryMigrationPlanArgs = {
  input: InputMigrate;
};


export type QueryMoodBoardArgs = {
  input: InputGetMoodBoard;
};


export type QueryMoodBoardCommentThreadsArgs = {
  input: GetMoodBoardCommentThreadsInput;
};


export type QueryMoodBoardCommentsArgs = {
  input: GetMoodBoardCommentsInput;
};


export type QueryMoodBoardShareArgs = {
  input: InputGetMoodBoardShareByHash;
};


export type QueryMoodBoardVersionContentArgs = {
  input: InputGetMoodBoardVersionContent;
};


export type QueryMoodBoardVersionsArgs = {
  input: InputGetMoodBoardVersions;
};


export type QueryMoodBoardsByBrandKitIdArgs = {
  input: InputGetMoodBoardsByBrandKitId;
};


export type QueryMoodBoardsByProjectIdArgs = {
  input: InputGetMoodBoardsByProjectId;
};


export type QueryMotionDraftsArgs = {
  input: InputMotionDrafts;
};


export type QueryPartnersDv360Args = {
  input: PartnersDv360Input;
};


export type QueryPauseEligibilityArgs = {
  input: InputPauseEligibility;
};


export type QueryPersonalGoogleAdsIntegrationsArgs = {
  input: InputPersonalIntegration;
};


export type QueryPersonalIntegrationsArgs = {
  input: InputPersonalIntegration;
};


export type QueryPersonalProjectArgs = {
  input: InputPersonalProject;
};


export type QueryPhotoshopStatusArgs = {
  input: InputPhotoshopStatus;
};


export type QueryPinnedFoldersArgs = {
  input: InputPinnedFolders;
};


export type QueryPinterestAdAccountsArgs = {
  input: PinterestAdAccountsInput;
};


export type QueryPinterestAdGroupsArgs = {
  input: PinterestAdGroupsInput;
};


export type QueryPinterestAdsArgs = {
  input: PinterestAdsInput;
};


export type QueryPinterestBoardsArgs = {
  input: PinterestBoardsInput;
};


export type QueryPinterestBoardsListArgs = {
  input: PinterestBoardsListInput;
};


export type QueryPinterestCampaignsArgs = {
  input: PinterestCampaignsInput;
};


export type QueryPinterestCatalogsArgs = {
  input: PinterestCatalogsInput;
};


export type QueryPinterestConnectedAccountsArgs = {
  input: PinterestConnectedAccountsInput;
};


export type QueryPinterestConversionTagsArgs = {
  input: PinterestConversionTagsInput;
};


export type QueryPinterestTargetingOptionsArgs = {
  input: PinterestTargetingOptionsInput;
};


export type QueryPlansArgs = {
  input: InputPlans;
};


export type QueryPlatformAdsArgs = {
  input: InputGetPlatformAds;
};


export type QueryPremiumAssetsUsageArgs = {
  input: InputPremiumAssetsUsage;
};


export type QueryPreviewCheckoutArgs = {
  input: InputPreviewCheckout;
};


export type QueryPreviewSubscriptionChangeArgs = {
  input: InputPreviewSubscriptionChange;
};


export type QueryPreviewTopUpCreditsArgs = {
  input: InputPreviewTopUpCredits;
};


export type QueryPreviewUpdatesArgs = {
  input: InputMarkProductUpdate;
};


export type QueryPricingAbTestArgs = {
  input: InputPricingAbTest;
};


export type QueryProjectArgs = {
  input: InputProject;
};


export type QueryProjectDesignTemplatesArgs = {
  input: InputProjectDesignTemplates;
};


export type QueryProjectDesignsArgs = {
  input: InputProjectDesigns;
};


export type QueryProjectsArgs = {
  input: InputProjects;
};


export type QueryProjectsShortcutsArgs = {
  input: InputProjectsShortcuts;
};


export type QueryPromotionalPlanArgs = {
  input: InputPromotionalPlan;
};


export type QueryPublicAdDetailsArgs = {
  input: PublicAdDetailsInput;
};


export type QueryPublicBrandAdsArgs = {
  input: PublicBrandAdsInput;
};


export type QueryPublicBrandAdsCountArgs = {
  input: PublicBrandAdsCountInput;
};


export type QueryPublicBrandDetailsArgs = {
  brandId: Scalars['String']['input'];
};


export type QueryPublicDesignArgs = {
  input: InputPublicDesign;
};


export type QueryPublicDesignsArgs = {
  input: InputPublicDesigns;
};


export type QueryPublicFoldersArgs = {
  input: InputPublicFolders;
};


export type QueryPublicLinkArgs = {
  input: InputGetPublicLink;
};


export type QueryPublicTeamDetailsArgs = {
  input: InputPublicTeamDetails;
};


export type QueryPublishVeevaDocumentArgs = {
  input: InputVeevaDocument;
};


export type QueryRankResizeAgainstSavedArgs = {
  input: InputRankAgainstSaved;
};


export type QueryRecentCreativesAndMoodboardsArgs = {
  input: InputRecentCreativesAndMoodboards;
};


export type QueryRecentDesignsArgs = {
  input: InputRecentDesigns;
};


export type QueryRecentFoldersArgs = {
  input: InputRecentFolders;
};


export type QueryRemovedDesignVersionArgs = {
  input: InputDesignVersion;
};


export type QueryResizeAlternativesArgs = {
  input: InputResizeAlternatives;
};


export type QueryResizeFlexVariantsArgs = {
  input: InputResizeFlexVariants;
};


export type QueryResourceAccessArgs = {
  input: InputResourceAccess;
};


export type QueryScoringArgs = {
  input: InputScoringData;
};


export type QuerySearchArgs = {
  input: InputSearch;
};


export type QuerySearchBrandsApiArgs = {
  input: BrandSearchApiInput;
};


export type QuerySearchDriveItemsArgs = {
  input: InputIntegrationItems;
};


export type QuerySearchDropboxItemsArgs = {
  input: InputIntegrationItems;
};


export type QuerySearchFeedRowsArgs = {
  input: SearchFeedRowsInput;
};


export type QuerySearchGoogleSuggestionsArgs = {
  input: GoogleSuggestionsSearchInput;
};


export type QuerySearchPublicBrandsArgs = {
  input: FacebookBrandSearchInput;
};


export type QuerySearchVeevaDocumentsArgs = {
  input: InputSearchVeevaDocuments;
};


export type QuerySharePointDocumentIsiArgs = {
  driveId: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
  templateLeaf?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryShareVariationSelectionArgs = {
  input: InputShareVariationSelection;
};


export type QuerySharedDesignArgs = {
  input: InputSharedDesign;
};


export type QuerySharedDesignsArgs = {
  input: InputDesigns;
};


export type QuerySharedFolderDataArgs = {
  input: InputSharedFolder;
};


export type QuerySharedFoldersArgs = {
  input: InputFolders;
};


export type QueryShutterstockDownloadUrlArgs = {
  input: InputShutterstockImage;
};


export type QuerySignAdNetworkLogoUploadUrlArgs = {
  input: InputSignAdNetworkLogoUploadUrl;
};


export type QuerySignBrandKitDocumentUploadUrlArgs = {
  input: InputSignBrandKitDocumentUploadUrl;
};


export type QuerySignChatDocumentUploadUrlArgs = {
  input: InputSignChatDocumentUploadUrl;
};


export type QuerySignUploadUrlArgs = {
  input: InputSignUploadUrl;
};


export type QuerySlackChannelsArgs = {
  input: GetSlackChannelsInput;
};


export type QuerySlackIntegrationsArgs = {
  input: GetSlackIntegrationsInput;
};


export type QuerySmartCropArgs = {
  inputs: Array<InputSmartCrop>;
  skipTransparent?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySmartCropOnImageArgs = {
  input: InputSmartCropOnImage;
};


export type QueryStockAudioArgs = {
  input: InputStockAudio;
};


export type QueryStockMediaArgs = {
  input: InputStockMedia;
};


export type QueryStoryBlocksDownloadUrlArgs = {
  input: InputStorblocksItem;
};


export type QuerySubscriptionArgs = {
  input: InputSubscription;
};


export type QuerySuggestContentVariationTargetsArgs = {
  input: InputSuggestContentVariationTargets;
};


export type QuerySuggestDefaultAudiencesArgs = {
  designHash: Scalars['String']['input'];
};


export type QuerySuggestFeedColumnBindingsArgs = {
  input: InputSuggestFeedColumnBindings;
};


export type QuerySuggestedDesignSizeTypesArgs = {
  input?: InputMaybe<InputDesignSizeTypes>;
};


export type QueryTagContainerArgs = {
  input: InputTagContainer;
};


export type QueryTagContainerAdTagNetworksArgs = {
  input: InputTagContainer;
};


export type QueryTagContainerGenerateCodeArgs = {
  input: InputTagContainerGenerateCode;
};


export type QueryTagContainerSyncStatusArgs = {
  input: InputTagContainer;
};


export type QueryTeamArgs = {
  input: InputTeam;
};


export type QueryTeamAbTestsArgs = {
  input: InputTeamAbTests;
};


export type QueryTeamClientIdArgs = {
  input: InputTeamClientId;
};


export type QueryTeamDefaultBrandKitArgs = {
  input: InputTeamBrandKit;
};


export type QueryTeamFrequentlyUsedDesignSizeTypesArgs = {
  input: InputTeamFrequentlyUsedDesignSizeTypes;
};


export type QueryTeamGoogleAdsIntegrationsArgs = {
  input: InputTeamIntegration;
};


export type QueryTeamIntegrationsArgs = {
  input: InputTeamIntegration;
};


export type QueryTeamMetaIntegrationsArgs = {
  input: InputTeamIntegration;
};


export type QueryTeamPaymentVariantArgs = {
  input: InputTeamPaymentVariant;
};


export type QueryTeamPricingSourceArgs = {
  input: InputTeamPricingSource;
};


export type QueryTeamRoleArgs = {
  input: InputTeamRole;
};


export type QueryTeamRoleExistsArgs = {
  input: InputTeamRoleName;
};


export type QueryTeamRolesArgs = {
  input: InputTeamRoles;
};


export type QueryTeamUserGroupArgs = {
  input: InputTeamUserGroup;
};


export type QueryTeamUserGroupsArgs = {
  input: InputTeamUserGroups;
};


export type QueryTeamWebhookArgs = {
  input: InputTeamWebhook;
};


export type QueryTeamWebhookDataArgs = {
  input: InputTeamWebhookId;
};


export type QueryTempFontUploadUrlArgs = {
  input: InputFontUploadUrl;
};


export type QueryTemplateCategoriesArgs = {
  input?: InputMaybe<InputTemplateCategoriesWebsite>;
};


export type QueryTemplateDesignArgs = {
  input: InputDesign;
};


export type QueryTemplateSetDesignsArgs = {
  input: InputDesign;
};


export type QueryTemplatesArgs = {
  input: InputTemplatesWebsite;
};


export type QueryTemplatesSitemapArgs = {
  input?: InputMaybe<InputDesignSizeType>;
};


export type QueryTiktokAdGroupsArgs = {
  input: TikTokAdGroupsInput;
};


export type QueryTiktokAdvertisersArgs = {
  input: TikTokAdvertisersInput;
};


export type QueryTiktokBusinessCentersArgs = {
  input: TikTokBusinessCentersInput;
};


export type QueryTiktokCampaignsArgs = {
  input: TikTokCampaignsInput;
};


export type QueryTiktokCatalogRegionsArgs = {
  input: TikTokCatalogRegionsInput;
};


export type QueryTiktokCatalogsArgs = {
  input: TikTokCatalogsInput;
};


export type QueryTiktokFeedFieldsValidationArgs = {
  input: TikTokFeedFieldsValidationInput;
};


export type QueryTiktokIdentitiesArgs = {
  input: TikTokIdentitiesInput;
};


export type QueryTiktokPixelsArgs = {
  input: TikTokPixelsInput;
};


export type QueryTiktokRegionsArgs = {
  input: TikTokRegionsInput;
};


export type QueryTrackAccountPropertiesArgs = {
  input: TrackAccountPropertiesInput;
};


export type QueryTrackSegmentEventArgs = {
  input: InputTrackSegmentEvent;
};


export type QueryTrashItemsArgs = {
  input: InputTrashItems;
};


export type QueryUgcExportStatusArgs = {
  checksum: Scalars['String']['input'];
};


export type QueryUploadBrandKitLogoUrlArgs = {
  input: InputUploadBrandKitLogoUrl;
};


export type QueryUserProfilesCm360Args = {
  input: UserProfilesCm360Input;
};


export type QueryValidEmailArgs = {
  input: InputValidEmail;
};


export type QueryWasTemplateLayoutChangedArgs = {
  input: InputDesign;
};


export type QueryWhatsNewArgs = {
  input?: InputMaybe<InputProductUpdate>;
};


export type QueryZapierFeedbackLevelArgs = {
  input: InputTeamClientId;
};

/** Psychological performance metrics for ad effectiveness */
export type RadarMetrics = {
  __typename?: 'RadarMetrics';
  /** Motivation toward goal completion and action - scored 0-100 */
  achievement: Scalars['Int']['output'];
  /** Demonstration of expertise or professionalism - scored 0-100 */
  competence: Scalars['Int']['output'];
  /** Ability to spark interest and make users want to learn more - scored 0-100 */
  curiosity: Scalars['Int']['output'];
  /** How the ad makes users feel empowered or capable - scored 0-100 */
  empowerment: Scalars['Int']['output'];
  /** Likelihood to generate interactions (likes, comments, shares) - scored 0-100 */
  engagement: Scalars['Int']['output'];
  /** Impact on user's self-esteem or status perception - scored 0-100 */
  esteem: Scalars['Int']['output'];
};

/** Actual audience that was reached (legacy audience analytics) */
export type ReachedAudience = {
  __typename?: 'ReachedAudience';
  /** Age range distribution of reached audience */
  ageRanges: Array<AgeRangeItem>;
  /** Gender distribution of reached audience */
  genderDistribution: Array<GenderDistributionItem>;
  /** Total number of people reached */
  totalReach: Scalars['Float']['output'];
};

export type ReactivateSubscriptionPayload = {
  __typename?: 'ReactivateSubscriptionPayload';
  result: Scalars['Boolean']['output'];
};

export type ReactivateSubscriptionResult = {
  __typename?: 'ReactivateSubscriptionResult';
  result: RecurlySubscription;
};

export type ReadThreadResult = {
  __typename?: 'ReadThreadResult';
  thread: CommentThread;
};

export type RecentAiOperation = {
  __typename?: 'RecentAiOperation';
  /** Moodboard card ID for focus-on-open */
  cardId?: Maybe<Scalars['String']['output']>;
  /** Moodboard hash or design hash, depending on zone */
  contextHash?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  output?: Maybe<Scalars['JSON']['output']>;
  status: ImageGenerationStatus;
  /** Team ID from the operation */
  teamId: Scalars['Int']['output'];
  viewedAt?: Maybe<Scalars['String']['output']>;
  /** Derived from operation input: moodboard, adstudio, or null if unknown */
  zone?: Maybe<Scalars['String']['output']>;
};

export type RecentCopilotAd = {
  __typename?: 'RecentCopilotAd';
  /** The design the ad was generated for */
  designHash?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  status: ImageGenerationStatus;
  teamId: Scalars['Int']['output'];
  /** The Copilot chat thread the ad was requested from */
  threadId?: Maybe<Scalars['String']['output']>;
  viewedAt?: Maybe<Scalars['String']['output']>;
};

export type RecentCreativeAndMoodboardItem = Design | MoodBoard;

export type RecentFolder = {
  __typename?: 'RecentFolder';
  folder: Folder;
  pinned: Scalars['Boolean']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type RecentFolders = {
  __typename?: 'RecentFolders';
  items: Array<RecentFolder>;
};

export enum RecentlyProjectActions {
  ADD_DESIGN_TO_TEMPLATES = 'ADD_DESIGN_TO_TEMPLATES',
  CREATE_DESIGN = 'CREATE_DESIGN',
  CREATE_FOLDER = 'CREATE_FOLDER',
  CREATE_MEDIA = 'CREATE_MEDIA',
  DELETE_DESIGN = 'DELETE_DESIGN',
  DELETE_FOLDER = 'DELETE_FOLDER',
  DELETE_MEDIA = 'DELETE_MEDIA',
  DELETE_PROJECT = 'DELETE_PROJECT',
  DUPLICATE_DESIGN = 'DUPLICATE_DESIGN',
  DUPLICATE_FOLDER = 'DUPLICATE_FOLDER',
  UPDATE_DESIGN = 'UPDATE_DESIGN',
  UPDATE_FOLDER = 'UPDATE_FOLDER',
  UPDATE_MEDIA = 'UPDATE_MEDIA',
  UPDATE_PROJECT = 'UPDATE_PROJECT'
}

export type RecomposeResizeOperation = {
  __typename?: 'RecomposeResizeOperation';
  aiOperationId: Scalars['Int']['output'];
};

export type RecordPhishingUrlVerdictResult = {
  __typename?: 'RecordPhishingUrlVerdictResult';
  blocked: Scalars['Boolean']['output'];
  flagId: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type RecordType = {
  __typename?: 'RecordType';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type RecurlyAccount = {
  __typename?: 'RecurlyAccount';
  createdAt?: Maybe<Scalars['Date']['output']>;
  hasActiveSubscription?: Maybe<Scalars['Boolean']['output']>;
  hasCanceledSubscription?: Maybe<Scalars['Boolean']['output']>;
  hasFutureSubscription?: Maybe<Scalars['Boolean']['output']>;
  hasLiveSubscription?: Maybe<Scalars['Boolean']['output']>;
  hasPausedSubscription?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type RecurlyAccountSubscription = {
  __typename?: 'RecurlyAccountSubscription';
  activatedAt?: Maybe<Scalars['Date']['output']>;
  addOns?: Maybe<Array<Maybe<AddOnsType>>>;
  addOnsTotal?: Maybe<Scalars['Float']['output']>;
  autoRenew?: Maybe<Scalars['Boolean']['output']>;
  canceledAt?: Maybe<Scalars['Date']['output']>;
  collectionMethod?: Maybe<Scalars['String']['output']>;
  currentPeriodEndsAt?: Maybe<Scalars['Date']['output']>;
  currentPeriodStartedAt?: Maybe<Scalars['Date']['output']>;
  currentTermEndsAt?: Maybe<Scalars['Date']['output']>;
  currentTermStartedAt?: Maybe<Scalars['Date']['output']>;
  expirationReason?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['Date']['output']>;
  netTerms?: Maybe<Scalars['Int']['output']>;
  plan: RecurlyPlan;
  remainingBillingCycles?: Maybe<Scalars['Int']['output']>;
  renewalBillingCycles?: Maybe<Scalars['Int']['output']>;
  subscriptionState?: Maybe<Scalars['String']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  totalBillingCycles?: Maybe<Scalars['Int']['output']>;
  trialEndsAt?: Maybe<Scalars['Date']['output']>;
  trialStartAt?: Maybe<Scalars['Date']['output']>;
  trialStartedAt?: Maybe<Scalars['Date']['output']>;
};

export type RecurlyInternalAddOn = {
  __typename?: 'RecurlyInternalAddOn';
  addOn: RecurlyInternalAddOnMini;
  id: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  tierType: AddOnTierType;
  tiers?: Maybe<Array<RecurlyInternalAddOnTier>>;
  unitAmount: Scalars['Float']['output'];
};

export type RecurlyInternalAddOnMini = {
  __typename?: 'RecurlyInternalAddOnMini';
  addOnType: AddOnType;
  code: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type RecurlyInternalAddOnTier = {
  __typename?: 'RecurlyInternalAddOnTier';
  endingQuantity: Scalars['Int']['output'];
  unitAmount: Scalars['Float']['output'];
};

export type RecurlyPayingAccount = {
  __typename?: 'RecurlyPayingAccount';
  companyName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  teamId?: Maybe<Scalars['Int']['output']>;
};

export type RecurlyPlan = {
  __typename?: 'RecurlyPlan';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type RecurlySubscription = {
  __typename?: 'RecurlySubscription';
  addOns?: Maybe<Array<RecurlyInternalAddOn>>;
  addOnsTotal: Scalars['Float']['output'];
  /** next payment value */
  amountDue: Scalars['Float']['output'];
  autoRenew: Scalars['Boolean']['output'];
  /**
   * Total outstanding credit balance
   * @deprecated We made a separat request for balance
   */
  balance: Scalars['Float']['output'];
  canceledAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  currentPeriodEndsAt: Scalars['Date']['output'];
  currentPeriodStartedAt: Scalars['Date']['output'];
  currentTermEndsAt: Scalars['Date']['output'];
  discountAmountForNextPayment: Scalars['Float']['output'];
  /** this values is set when a yearly-monthly plan is scheduled to expire at currentPeriodEndsAt */
  expiresAt?: Maybe<Scalars['Date']['output']>;
  freeCreators: Scalars['Boolean']['output'];
  frequency: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  isDiscounted: Scalars['Boolean']['output'];
  /** True if the last invoice has PAST_DUE or FAILED status */
  pastDueInvoice: Scalars['Boolean']['output'];
  /** Date when the subscription was paused (null if not paused) */
  pausedAt?: Maybe<Scalars['Date']['output']>;
  pendingChange?: Maybe<PendingSubscriptionChange>;
  pendingQuantity?: Maybe<Scalars['Int']['output']>;
  planCode: Scalars['String']['output'];
  planName: Scalars['String']['output'];
  /** plan price, not addOn seat price */
  planPrice: Scalars['Float']['output'];
  planProperties?: Maybe<PlanProperties>;
  planVersion: Scalars['Int']['output'];
  previousPlanCode?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  /** Number of remaining pause cycles (null if not paused) */
  remainingPauseCycles?: Maybe<Scalars['Int']['output']>;
  /** Calculated date when the subscription will resume (null if not paused) */
  resumeDate?: Maybe<Scalars['Date']['output']>;
  state: SubscriptionStatus;
  subtotal: Scalars['Float']['output'];
  totalBillingCycles: Scalars['Int']['output'];
  trialEndsAt?: Maybe<Scalars['Date']['output']>;
};

export type RedisStreamInfo = {
  __typename?: 'RedisStreamInfo';
  docid: Scalars['String']['output'];
  firstEntryId?: Maybe<Scalars['String']['output']>;
  lastActivityTimestamp?: Maybe<Scalars['Float']['output']>;
  lastEntryId?: Maybe<Scalars['String']['output']>;
  messageCount: Scalars['Int']['output'];
  room: Scalars['String']['output'];
  streamName: Scalars['String']['output'];
};

export type RedisStreamsResult = {
  __typename?: 'RedisStreamsResult';
  hasMore: Scalars['Boolean']['output'];
  streams: Array<RedisStreamInfo>;
  totalCount: Scalars['Int']['output'];
};

export type RedisValue = {
  __typename?: 'RedisValue';
  keyExists: Scalars['Boolean']['output'];
  ttl?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type RefreshAddLayerCorrelationInput = {
  /** The real bannersetElementId the client assigned via processAddLayer. */
  layerId: Scalars['Int']['input'];
  /** The Mastra tool-call id of the pending addLayer execute. */
  toolCallId: Scalars['String']['input'];
};

/**
 * Correlation for a pending getCustomCode read: the client read the design's
 * current design-wide custom code (customStyle / customScript) from Redux; the
 * payload is relayed verbatim to the Mastra refresh route, which resolves the
 * awaited tool promise.
 */
export type RefreshCustomCodeCorrelationInput = {
  /** Client-shaped CustomCodeReadPayload: { customStyle, customScript, failed? }. */
  payload: Scalars['JSON']['input'];
  /** The Mastra tool-call id of the pending getCustomCode execute. */
  toolCallId: Scalars['String']['input'];
};

/**
 * Correlation for a pending getFeedRows read. The client fetched the requested
 * rows and already shaped the cell values (image→status marker, text truncated
 * + <user_data>-wrapped, no raw URLs); the payload is relayed verbatim to the
 * Mastra refresh route, which resolves the awaited tool promise.
 */
export type RefreshFeedRowsCorrelationInput = {
  /** Client-shaped FeedRowsReadPayload: { rows: [{ index, cells }], totalCount, truncated, missing?, unknownColumns?, noFeed? }. */
  payload: Scalars['JSON']['input'];
  /** The Mastra tool-call id of the pending getFeedRows execute. */
  toolCallId: Scalars['String']['input'];
};

/**
 * Correlation for a pending getFonts read: the client read the design's
 * available-fonts catalog (name + group); the payload is relayed verbatim to the
 * Mastra refresh route, which resolves the awaited tool promise.
 */
export type RefreshFontsCorrelationInput = {
  /** Client-shaped FontsReadPayload: { fonts: [{ name, group }], failed? }. */
  payload: Scalars['JSON']['input'];
  /** The Mastra tool-call id of the pending getFonts execute. */
  toolCallId: Scalars['String']['input'];
};

/**
 * Correlation for a pending setLayerProperties write (Ad Studio Copilot
 * placement engine): only the client can know what a layer write actually did
 * — which axes the editor owns, how a placement was snapped or clamped,
 * whether a colour applied — so it pushes the same sentence the user's pill
 * shows and the tool returns that instead of its own argument-derived guess.
 */
export type RefreshSetLayerPropertiesCorrelationInput = {
  /** Client-shaped LayerWriteOutcomePayload: { ok, summary?, error? }. */
  payload: Scalars['JSON']['input'];
  /** The Mastra tool-call id of the pending setLayerProperties execute. */
  toolCallId: Scalars['String']['input'];
};

/**
 * Correlation for a pending getSlideContent read: the client read the
 * requested slide's layers (from the same Redux state the Timeline bar
 * renders, not from the active-slide-only editor-context snapshot) and shaped
 * them exactly like getLayerProperties' own per-layer content; the payload is
 * relayed verbatim to the Mastra refresh route, which resolves the awaited
 * tool promise.
 */
export type RefreshSlideContentCorrelationInput = {
  /** Client-shaped SlideContentReadPayload: { layers, invalidSlideIndex?, failed? }. */
  payload: Scalars['JSON']['input'];
  /** The Mastra tool-call id of the pending getSlideContent execute. */
  toolCallId: Scalars['String']['input'];
};

/**
 * Mid-turn refresh payload pushed by the client after applying a Studio
 * Assistant mutation. The Mastra side keys the editor-context cache by
 * (threadId, designHash) and uses the optional addLayer correlation to
 * resolve the awaited addLayer execute with the real bannersetElementId.
 */
export type RefreshStudioAssistantContextInput = {
  /** Set when the trigger was an addLayer dispatch; carries the real bannersetElementId. */
  addLayer?: InputMaybe<RefreshAddLayerCorrelationInput>;
  /** Set when the trigger was a getCustomCode read; carries the design's current custom code to resolve the pending tool execute. */
  customCode?: InputMaybe<RefreshCustomCodeCorrelationInput>;
  designHash: Scalars['String']['input'];
  editorContext: StudioAssistantEditorContextInput;
  /** Set when the trigger was a getFeedRows read; carries the client-fetched rows to resolve the pending tool execute. */
  feedRows?: InputMaybe<RefreshFeedRowsCorrelationInput>;
  /** Set when the trigger was a getFonts read; carries the design's available-fonts catalog to resolve the pending tool execute. */
  fonts?: InputMaybe<RefreshFontsCorrelationInput>;
  /** Set when the trigger was a copilot write that ran deterministic layout repair (Tier 1); carries the repair outcome for the turn-end judgement gate. */
  layoutRepair?: InputMaybe<LayoutRepairPushInput>;
  /** Set when the trigger is a copilot write about to run deterministic layout repair (Tier 1); declares the report is coming for this tool call, sent before the settle wait even starts. */
  layoutRepairExpectation?: InputMaybe<LayoutRepairExpectationInput>;
  /** Set when the trigger was a setLayerProperties write (Ad Studio Copilot); carries what the write actually did to resolve the pending tool execute. */
  setLayerProperties?: InputMaybe<RefreshSetLayerPropertiesCorrelationInput>;
  /** Correlation for a pending getSlideContent read; see RefreshSlideContentCorrelationInput. */
  slideContent?: InputMaybe<RefreshSlideContentCorrelationInput>;
  threadId: Scalars['String']['input'];
  /**
   * Set when the trigger was a client-side tool outcome pushed over the
   * SHARED generic channel (see RefreshToolOutcomeInput) rather than one of
   * the named correlations above. Adding a new tool to this channel never
   * touches this input type again — only its own ai-agents zod schema, its
   * own execute(), and its own client push call site.
   */
  toolOutcome?: InputMaybe<RefreshToolOutcomeInput>;
  /** Set when the trigger was a verifyLayout read (Ad Studio Copilot layout self-review); carries the computed per-size violations report to resolve the pending tool execute. */
  verifyLayout?: InputMaybe<RefreshVerifyLayoutCorrelationInput>;
};

export type RefreshTokenPayload = {
  __typename?: 'RefreshTokenPayload';
  tokenUpdated: Scalars['Boolean']['output'];
};

/**
 * Generic correlation for a client-side tool outcome pushed over the SHARED
 * `toolOutcome` channel, instead of adding another named correlation input
 * like the ones above. `detail` is a bare JSON scalar — no schema-level
 * typing crosses GraphQL for it — so it is validated server-side, in the
 * ai-agents refresh route, against a zod schema keyed by `toolId`. An
 * unrecognized `toolId`, or a `detail` shape that doesn't match its
 * registered schema, rejects the WHOLE refresh mutation rather than silently
 * resolving the wrong pending tool call with an unvalidated payload.
 */
export type RefreshToolOutcomeInput = {
  /** Client-shaped outcome payload; shape depends on toolId — see the ai-agents refresh route's per-tool schema. */
  detail: Scalars['JSON']['input'];
  /** The Mastra tool-call id of the pending execute this outcome resolves. */
  toolCallId: Scalars['String']['input'];
  /** The Mastra tool id (e.g. setLayerAccessibility) whose outcome schema the detail field must match. */
  toolId: Scalars['String']['input'];
};

/**
 * Correlation for a pending verifyLayout read (Ad Studio Copilot layout
 * self-review): the client computed a per-size layout-violations report from
 * live Redux geometry (+ a rendered-DOM measurement for text-wrap breakage);
 * the payload is relayed verbatim to the Mastra refresh route, which resolves
 * the awaited tool promise.
 */
export type RefreshVerifyLayoutCorrelationInput = {
  /** Client-shaped VerifyLayoutReadPayload: { sizes: [{ sizeId, sizeName, violations: [{ type, layerIds, detail, suggestedFix? }] }], failed? }. */
  payload: Scalars['JSON']['input'];
  /** The Mastra tool-call id of the pending verifyLayout execute. */
  toolCallId: Scalars['String']['input'];
};

export type RefusedFontRepair = {
  __typename?: 'RefusedFontRepair';
  hash: Scalars['String']['output'];
  outcome: RefusedFontRepairOutcome;
  /** What the repair changed. */
  repairs: Array<Scalars['String']['output']>;
  /** What Chrome will still refuse. */
  unresolved: Array<Scalars['String']['output']>;
};

export enum RefusedFontRepairOutcome {
  /** The repair failed; the next export to see the refusal tries again. */
  FAILED = 'FAILED',
  /** The repair found nothing to fix, although Chrome refused the file. */
  NOTHING_TO_REPAIR = 'NOTHING_TO_REPAIR',
  /** No stored font has this hash. */
  NOT_FOUND = 'NOT_FOUND',
  /** The repaired file replaced the stored one, by this request or by another export's repair it waited for. */
  REPAIRED = 'REPAIRED',
  /** Another export was repairing this font and did not finish within 30 s, or its repair failed. */
  SKIPPED_IN_PROGRESS = 'SKIPPED_IN_PROGRESS',
  /** The file has a defect the repair cannot fix; nothing was written. */
  UNRESOLVED = 'UNRESOLVED'
}

export type RegenerateTokenPayload = {
  __typename?: 'RegenerateTokenPayload';
  accessToken?: Maybe<Scalars['String']['output']>;
};

/** Response after rejecting a team invitation. */
export type RejectTeamInvitationPayload = {
  __typename?: 'RejectTeamInvitationPayload';
  /** Whether the rejection was successful. */
  result: Scalars['Boolean']['output'];
};

export type RemoveAdTagNetworkPayload = {
  __typename?: 'RemoveAdTagNetworkPayload';
  result: Scalars['Boolean']['output'];
};

export type RemoveBg = {
  __typename?: 'RemoveBg';
  url: Scalars['String']['output'];
};

export type RemoveBgOnBoundedImagePayload = {
  __typename?: 'RemoveBgOnBoundedImagePayload';
  result: RemoveBgOnBoundedImagePayloadResult;
};

export type RemoveBgOnBoundedImagePayloadResult = {
  __typename?: 'RemoveBgOnBoundedImagePayloadResult';
  rowJson: Scalars['JSON']['output'];
};

export enum RemoveBgSize {
  FULL = 'FULL',
  PREVIEW = 'PREVIEW'
}

export type RemoveBillingInfoPayload = {
  __typename?: 'RemoveBillingInfoPayload';
  result: Scalars['Boolean']['output'];
};

export type RemoveBrandedResourcePayload = {
  __typename?: 'RemoveBrandedResourcePayload';
  result: Scalars['Boolean']['output'];
};

export type RemoveCommentAttachmentResult = {
  __typename?: 'RemoveCommentAttachmentResult';
  success: Scalars['Boolean']['output'];
  threadId: Scalars['Int']['output'];
};

export type RemoveCustomSizePayload = {
  __typename?: 'RemoveCustomSizePayload';
  success: Scalars['Boolean']['output'];
};

/** Response after removing a design from a set. */
export type RemoveDesignFromSetPayload = {
  __typename?: 'RemoveDesignFromSetPayload';
  designSet?: Maybe<Design>;
  /** Whether the removal was successful. */
  result: Scalars['Boolean']['output'];
};

export type RemoveDesignSizeTypePayload = {
  __typename?: 'RemoveDesignSizeTypePayload';
  success: Scalars['Boolean']['output'];
};

export type RemoveDesignSizesResult = {
  __typename?: 'RemoveDesignSizesResult';
  hash: Scalars['String']['output'];
  /** The caller's open editor tab steps aside for this edit: it reloads to show it. */
  openEditorRefreshes: Scalars['Boolean']['output'];
  removedSizeHashes: Array<Scalars['String']['output']>;
};

/** Payload for the removeDynamicVar mutation. */
export type RemoveDynamicVarPayload = {
  __typename?: 'RemoveDynamicVarPayload';
  /** The ID of the removed dynamic variable. */
  id: Scalars['Int']['output'];
  settingsOutOfSync: Scalars['Boolean']['output'];
  syncStatus: AdTagSyncStatus;
};

/** Payload for the removeExternalTrackingUrl mutation. */
export type RemoveExternalTrackingUrlPayload = {
  __typename?: 'RemoveExternalTrackingUrlPayload';
  /** The ID of the removed external tracking URL. */
  id: Scalars['Int']['output'];
};

/** Response after removing a member from a team. */
export type RemoveMemberPayload = {
  __typename?: 'RemoveMemberPayload';
  /** Whether the removal was successful. */
  result: Scalars['Boolean']['output'];
};

/** Payload for the removeNetworkAdServing mutation. */
export type RemoveNetworkAdServingPayload = {
  __typename?: 'RemoveNetworkAdServingPayload';
  /** Indicates if the settings are out of sync after removing the network. */
  settingsOutOfSync: Scalars['Boolean']['output'];
  /** The synchronization status of the ad tag. */
  syncStatus: AdTagSyncStatus;
};

/** @deprecated not used */
export type RemoveObjectChange = {
  id?: InputMaybe<Scalars['String']['input']>;
  maskId?: InputMaybe<Scalars['Int']['input']>;
  maskSource?: InputMaybe<MaskSource>;
  maskUrl?: InputMaybe<Scalars['String']['input']>;
  positivePoints?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

/** Response after removing a group from a project. */
export type RemoveProjectGroupPayload = {
  __typename?: 'RemoveProjectGroupPayload';
  /** Whether the removal was successful. */
  success: Scalars['Boolean']['output'];
};

/** Response after removing a user from a project. */
export type RemoveProjectUserPayload = {
  __typename?: 'RemoveProjectUserPayload';
  /** Whether the removal was successful. */
  success: Scalars['Boolean']['output'];
};

export type RemoveTeamIdentityProviderResponse = {
  __typename?: 'RemoveTeamIdentityProviderResponse';
  result: Scalars['Boolean']['output'];
};

/** Response after removing a team user group. */
export type RemoveTeamUserGroupPayload = {
  __typename?: 'RemoveTeamUserGroupPayload';
  /** Whether the removal was successful. */
  result: Scalars['Boolean']['output'];
};

/** Response after removing a user from a group. */
export type RemoveUserFromGroupPayload = {
  __typename?: 'RemoveUserFromGroupPayload';
  /** The updated group without the removed member. */
  group: TeamUserGroup;
};

/** Response after removing a variation. */
export type RemoveVariationPayload = {
  __typename?: 'RemoveVariationPayload';
  /**
   * The rows this call actually soft-deleted — the variation top row first, then
   * its size children.
   *
   * Reported so an undo can restore exactly this write set: children already
   * soft-deleted before the call are not touched by it and must not be brought
   * back by its inverse. EMPTY when the variation was already removed, which is
   * how a redo tells "I removed it" from "it was already gone" and keeps the set
   * it recorded.
   */
  removedHashes: Array<Scalars['String']['output']>;
  result: Scalars['Boolean']['output'];
};

export enum RemoveVideoBackgroundColor {
  BLACK = 'BLACK',
  BLUE = 'BLUE',
  CYAN = 'CYAN',
  GRAY = 'GRAY',
  GREEN = 'GREEN',
  MAGENTA = 'MAGENTA',
  ORANGE = 'ORANGE',
  RED = 'RED',
  TRANSPARENT = 'TRANSPARENT',
  WHITE = 'WHITE',
  YELLOW = 'YELLOW'
}

export enum RemoveVideoOutputContainerAndCodec {
  GIF = 'GIF',
  MKV_H264 = 'MKV_H264',
  MKV_H265 = 'MKV_H265',
  MKV_VP9 = 'MKV_VP9',
  MOV_H265 = 'MOV_H265',
  MOV_PRORESKS = 'MOV_PRORESKS',
  MP4_H264 = 'MP4_H264',
  MP4_H265 = 'MP4_H265',
  WEBM_VP9 = 'WEBM_VP9'
}

/** Response when renaming a brand kit. */
export type RenameBrandKitPayload = {
  __typename?: 'RenameBrandKitPayload';
  /** The renamed brand kit. */
  brandKit: BrandKit;
};

export type RenameCopilotAiChatPayload = {
  __typename?: 'RenameCopilotAiChatPayload';
  chatId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type RenameCustomSizePayload = {
  __typename?: 'RenameCustomSizePayload';
  customSize: CustomSize;
};

export type RenameDesignComponentPayload = {
  __typename?: 'RenameDesignComponentPayload';
  /** @deprecated Field no longer supported */
  design: Design;
  designComponent: DesignComponent;
};

/** Response after renaming a design. */
export type RenameDesignPayload = {
  __typename?: 'RenameDesignPayload';
  /** The renamed designs (can be multiple in case of sets). */
  designs?: Maybe<Array<Design>>;
  /** The caller's open editor tab steps aside for this rename: it reloads to show it. */
  openEditorRefreshes: Scalars['Boolean']['output'];
};

export type RenameDesignSizeTypePayload = {
  __typename?: 'RenameDesignSizeTypePayload';
  designSizeType: DesignSizeType;
};

export type RenameMediaFolderPayload = {
  __typename?: 'RenameMediaFolderPayload';
  mediaFolder: MediaFolder;
};

/** Response after renaming a media asset. */
export type RenameMediaPayload = {
  __typename?: 'RenameMediaPayload';
  /** The renamed media asset. */
  media: Media;
};

export type RenameReportPayload = {
  __typename?: 'RenameReportPayload';
  result: AdTagReportResult;
};

/** Input for renaming a team client ID. */
export type RenameTeamClientId = {
  /** ID of the client to rename. */
  id: Scalars['Int']['input'];
  /** New name for the client. */
  name: Scalars['String']['input'];
  /** New scopes for the client. */
  scopes?: InputMaybe<Array<ApiTokenScope>>;
  /** ID of the team that owns the client. */
  teamId: Scalars['Int']['input'];
};

export type RepairStoredFontResult = {
  __typename?: 'RepairStoredFontResult';
  /**
   * The copy of the ORIGINAL bytes this font has set aside, taken by the first repair that wrote.
   * Reported on every call, so the page can offer a rollback without asking again.
   */
  backup: StoredFontBackup;
  hash: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** What the repair changed. Empty means there was nothing this service could fix. */
  repairs: Array<Scalars['String']['output']>;
  /**
   * What the browsers' sanitizer will still refuse about the bytes. Non-empty with an empty
   * "repairs" is a file that cannot be fixed from here — distinct from a healthy one, which reports
   * both empty.
   */
  unresolved: Array<Scalars['String']['output']>;
  /** True only when "apply" was set and there was something to write. */
  written: Scalars['Boolean']['output'];
};

/** Input for re-parsing a font binary to refresh its metric metadata. */
export type ReparseFontMetricsInput = {
  brandKitId: Scalars['Int']['input'];
  fontId: Scalars['Int']['input'];
};

/** Response after reparsing font metrics. */
export type ReparseFontMetricsPayload = {
  __typename?: 'ReparseFontMetricsPayload';
  font: Font;
};

/** Result of requesting a confirmation code. */
export type RequestConfirmationCodePayload = {
  __typename?: 'RequestConfirmationCodePayload';
  /** Whether the confirmation code was successfully sent. */
  result: Scalars['Boolean']['output'];
};

/**
 * A set import the user asked for. The product_set row IS the request — there is
 * no import-state column, so everything here is derived from that row.
 */
export type RequestedProductSetImport = {
  __typename?: 'RequestedProductSetImport';
  /** Local product_set row id — what an attached design's scope points at (design_feed.product_set_id, D24) */
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** Requested but not yet in the catalog's payload (members IS NULL). False once a rebuild has read the set — an empty result still counts as read */
  pending: Scalars['Boolean']['output'];
  sourceProductSetId: Scalars['String']['output'];
};

/** Response after resending an invitation. */
export type ResendInvitationPayload = {
  __typename?: 'ResendInvitationPayload';
  /** Whether the resend was successful. */
  result: Scalars['Boolean']['output'];
};

export type ReserveResizeApplyCreditPayload = {
  __typename?: 'ReserveResizeApplyCreditPayload';
  transactionId?: Maybe<Scalars['Int']['output']>;
};

export type ResetAddonUsageForTeamPayload = {
  __typename?: 'ResetAddonUsageForTeamPayload';
  result: Scalars['Boolean']['output'];
};

/** Per-size outcome of a cross-size reset. */
export type ResetSizeResult = {
  __typename?: 'ResetSizeResult';
  /** Property values reverted to the source size's. */
  appliedCount: Scalars['Int']['output'];
  /** Recorded cross-size customisations of this size the reset resolved and pruned. */
  clearedOverrideCount: Scalars['Int']['output'];
  designSizeTypeId: Scalars['Int']['output'];
  /** Reverted changes whose element does not exist in this size (skipped, kept per-size). */
  missingElementCount: Scalars['Int']['output'];
};

/** Response after resetting sibling sizes to the master size. */
export type ResetSizesToMasterSizePayload = {
  __typename?: 'ResetSizesToMasterSizePayload';
  /** The master, so clients can refresh checksums and the baseline in cache. */
  master: Design;
  resetSizes: Array<ResetSizeResult>;
  /**
   * Deprecated, always null — kept one release so a stale bundle's selection still validates.
   * @deprecated Always null: the Variations tab undo records family snapshots client-side and restores through restoreVariationsFamilyState. Removed after one release.
   */
  revertToken?: Maybe<Scalars['String']['output']>;
  /** Differences left per-size by design (geometry / per-size-scaled), summed over the reset sizes. */
  skippedPropertyCount: Scalars['Int']['output'];
  /**
   * Target sizes the reset skipped. Emitted reasons: source-size,
   * ambiguous-size-type, not-found, target-unloadable, target-unsyncable.
   */
  skippedSizes: Array<SyncSkippedSize>;
  /** Structural differences (added/removed/moved elements, order) — never applied by a reset. */
  structuralCount: Scalars['Int']['output'];
};

/** Input for resetting a team client ID. */
export type ResetTeamClientId = {
  /** ID of the client to reset. */
  id: Scalars['Int']['input'];
  /** ID of the team that owns the client. */
  teamId: Scalars['Int']['input'];
};

/**
 * One row of the picker grid: a candidate template the user can confirm,
 * plus up to 3 previews (one per orientation the user selected). The
 * SET hash is fed back into `resizeWithTemplate` via
 * `templateSetIdOverride` on confirm.
 */
export type ResizeAlternative = {
  __typename?: 'ResizeAlternative';
  /**
   * Up to 3 previews — one for each orientation present in the user's
   * `designSizeTypeIds` selection. Empty array means no preview could
   * be built for any orientation (e.g. the candidate's children couldn't
   * be merged).
   */
  previews: Array<ResizeAlternativePreview>;
  /**
   * Set ONLY on the pre-selected best match — the auto-pick path the apply
   * would take (`template` id-based or `templateSimilarity`). `null` for
   * relaxed alternatives, which always apply via `templateSetIdOverride`.
   * The FE applies a best match by re-running `resizeWithTemplate` WITHOUT
   * an override.
   */
  resizeType?: Maybe<ResizeWithTemplateType>;
  /** Similarity score in `[0, 1]` that earned this candidate the slot. `1.0` = identical layout. */
  similarity: Scalars['Float']['output'];
  /** Provenance — same semantics as `ResizeWithTemplateMatchSource`. */
  sourceType: ResizeWithTemplateMatchSource;
  /** Hash of the candidate template SET. Feed back as `templateSetIdOverride`. */
  templateSetHash: Scalars['String']['output'];
};

/**
 * Picker-modal column. Maps to the `computeAspectBucket` classification
 * collapsed into 3 buckets (ultra-wide is folded into horizontal).
 */
export enum ResizeAlternativeOrientation {
  /** Wide — aspect ratio ≥ 1.15, including ultra-wide banners. */
  HORIZONTAL = 'horizontal',
  /** Aspect ratio near 1:1 (≈0.85–1.15). */
  SQUARE = 'square',
  /** Tall — aspect ratio < 0.85. */
  VERTICAL = 'vertical'
}

/**
 * One cell of the picker grid: the merged banner for a specific
 * (template × orientation) target size.
 */
export type ResizeAlternativePreview = {
  __typename?: 'ResizeAlternativePreview';
  /** Merged banner JSON ready to render in the picker. */
  banner: Scalars['JsonDesign']['output'];
  /** Pixel height of the target size this preview is rendered for. */
  height: Scalars['Int']['output'];
  /** Which orientation column this preview belongs to. */
  orientation: ResizeAlternativeOrientation;
  /** resize_rag_classes (`byClass`): the template class this preview stands for (extra-tall | tall | square | wide | extra-wide); null per orientation. */
  ratioClass?: Maybe<Scalars['String']['output']>;
  /** Hash of the original template child size this preview was derived from. */
  sourceDesignHash: Scalars['String']['output'];
  /** Pixel width of the target size this preview is rendered for. */
  width: Scalars['Int']['output'];
};

/** Response from `resizeAlternatives` — the picker rows plus the analysis used. */
export type ResizeAlternativesPayload = {
  __typename?: 'ResizeAlternativesPayload';
  /** Candidate template rows for the picker (empty when none / not eligible). */
  alternatives: Array<ResizeAlternative>;
  /**
   * The source-design analysis (text roles + decor classification) the previews
   * were built from — carried-in from the FE, or computed inline here. The FE
   * forwards it to `resizeWithTemplate` as `sourceAnalysis` so apply reuses the
   * EXACT same analysis (no divergent second LLM call). `null` only when nothing
   * was analyzed.
   */
  sourceAnalysis?: Maybe<Scalars['JSON']['output']>;
};

/** How a resize candidate was generated — the watchdog training label. A closed set so clients can't persist misspelled/spoofed sources. */
export enum ResizeCandidateSource {
  AI = 'AI',
  FLEX = 'FLEX',
  SMART = 'SMART',
  TEMPLATE = 'TEMPLATE'
}

export enum ResizeGradeFeedOutcome {
  NOT_POSTED = 'NOT_POSTED',
  POSTED = 'POSTED',
  POSTED_WITHOUT_IMAGES = 'POSTED_WITHOUT_IMAGES',
  /** Nothing to post: the feed is off here, Slack is not configured, or a design is gone or empty. */
  SKIPPED = 'SKIPPED'
}

export type ResizeGradeFeedPostResult = {
  __typename?: 'ResizeGradeFeedPostResult';
  outcome: ResizeGradeFeedOutcome;
  verdict?: Maybe<ResizeRankingVerdict>;
};

export type ResizeLayerCropData = {
  __typename?: 'ResizeLayerCropData';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type ResizeLayerInfo = {
  __typename?: 'ResizeLayerInfo';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  borderColor?: Maybe<Scalars['String']['output']>;
  borderRadius?: Maybe<Scalars['String']['output']>;
  borderWeight?: Maybe<Scalars['Int']['output']>;
  cropData?: Maybe<ResizeLayerCropData>;
  fontColor?: Maybe<Scalars['String']['output']>;
  fontFamily?: Maybe<Scalars['String']['output']>;
  fontSize?: Maybe<Scalars['String']['output']>;
  fontWeight?: Maybe<Scalars['Int']['output']>;
  group?: Maybe<Scalars['Int']['output']>;
  height: Scalars['Float']['output'];
  horizontalAlign?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  layerName: Scalars['String']['output'];
  layerText?: Maybe<Scalars['String']['output']>;
  layerType: Scalars['String']['output'];
  lineHeight?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Int']['output']>;
  rotation?: Maybe<Scalars['Float']['output']>;
  /** Subject layers only: the id of the photo whose salient region this box marks. */
  subjectFor?: Maybe<Scalars['Int']['output']>;
  textAlign?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  visible?: Maybe<Scalars['Boolean']['output']>;
  width: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
  zIndex?: Maybe<Scalars['Int']['output']>;
};

export enum ResizePlatform {
  ANTHROPIC = 'ANTHROPIC',
  GOOGLE = 'GOOGLE',
  OPEN_AI = 'OPEN_AI'
}

/** Which data tier produced a check: deterministic JSON rules, rendered-HTML measurement, or image/vision. */
export enum ResizeRankingCategory {
  HTML = 'HTML',
  IMAGE = 'IMAGE',
  JSON = 'JSON'
}

export type ResizeRankingDefect = {
  __typename?: 'ResizeRankingDefect';
  category: ResizeRankingCategory;
  /** Present only on reference-relative findings (overlap, edge clipping); null otherwise. Lets a programmatic consumer threshold/sort on how much worse the resize made it. */
  delta?: Maybe<ResizeRankingDelta>;
  description: Scalars['String']['output'];
  /** The id of the rule that produced this finding — lets a consumer nest the flat defect under its rule. */
  ruleId: Scalars['String']['output'];
  severity: ResizeRankingSeverity;
  type: Scalars['String']['output'];
};

/** Reference-relative magnitude of a finding (overlap / edge clipping): how much of the element was covered or clipped in the reference vs the candidate. refFraction 0 = new, > 0 = increased. */
export type ResizeRankingDelta = {
  __typename?: 'ResizeRankingDelta';
  candFraction: Scalars['Float']['output'];
  refFraction: Scalars['Float']['output'];
};

export type ResizeRankingDimension = {
  __typename?: 'ResizeRankingDimension';
  category: ResizeRankingCategory;
  id: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  /** 0-10 for this check, or null when it does not apply (e.g. nothing comparable). */
  score?: Maybe<Scalars['Float']['output']>;
  title: Scalars['String']['output'];
};

export type ResizeRankingResult = {
  __typename?: 'ResizeRankingResult';
  /** The rendered candidate image evaluated (phase 3); null until the image tier lands. */
  candidateImageUrl?: Maybe<Scalars['String']['output']>;
  defects: Array<ResizeRankingDefect>;
  dimensions: Array<ResizeRankingDimension>;
  /** Holistic 0-10 score. */
  overallScore: Scalars['Float']['output'];
  /** The rendered reference image evaluated (phase 3); null until the image tier lands. */
  referenceImageUrl?: Maybe<Scalars['String']['output']>;
  /** Per-rule nested breakdown (id, title, category, weight, score, status, notes, findings) — the canonical structure for the rich UI; supersedes dimensions+defects. */
  rules: Array<ResizeRankingRule>;
  /** The design scorer's grade of this ranking, set only where the surface reads the scorer (design_scorer_settings mode live). A UI that gets it shows its mean and verdict in place of the ranking's. */
  scorer?: Maybe<ResizeScorerGrade>;
  verdict: ResizeRankingVerdict;
};

/** One rule's full result — the rich, nested structure every surface (app dialog, admin tool, HTML report) renders identically: the per-rule score PLUS its weight, score-banded status, and its own findings. */
export type ResizeRankingRule = {
  __typename?: 'ResizeRankingRule';
  category: ResizeRankingCategory;
  findings: Array<ResizeRankingRuleFinding>;
  id: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  /** 0-10 for this rule, or null when it does not apply. */
  score?: Maybe<Scalars['Float']['output']>;
  status: ResizeRankingRuleStatus;
  title: Scalars['String']['output'];
  /** The rule's relative weight in the overall mean — shown subtly for transparency. */
  weight: Scalars['Float']['output'];
};

/** A single finding under a rule (the flat defect minus the redundant parent category/ruleId). */
export type ResizeRankingRuleFinding = {
  __typename?: 'ResizeRankingRuleFinding';
  /**
   * Whether this MAJOR reached the cap on its OWN, without the second MAJOR the gate normally waits for.
   * Nullable for the same reason as countsTowardCap: no grading written before engine 0.8.0 carries it.
   */
  capsAlone?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether this finding counts toward the aggregate cap gates, which are what decide a verdict. NULLABLE
   * for one reason only: stored gradings written before engine 0.6.0 (resize_watchdog_evaluation.detResult
   * is served through this type) carry no such field, and a non-null field would error every historical
   * row. A live grading always sets it.
   */
  countsTowardCap?: Maybe<Scalars['Boolean']['output']>;
  delta?: Maybe<ResizeRankingDelta>;
  description: Scalars['String']['output'];
  severity: ResizeRankingSeverity;
  /** The soften family this finding was eligible for, or null. Nullable for the same reason as countsTowardCap. */
  softenFamily?: Maybe<ResizeRankingSoftenFamily>;
  type: Scalars['String']['output'];
};

/** A single rule's status — its SCORE band (PASS >= 7.5, WARN >= 5, FAIL below, NA when it did not apply). The same bands as the overall verdict and the report/admin score colours; distinct from finding severity. */
export enum ResizeRankingRuleStatus {
  FAIL = 'FAIL',
  NA = 'NA',
  PASS = 'PASS',
  WARN = 'WARN'
}

export enum ResizeRankingSeverity {
  CRITICAL = 'CRITICAL',
  MAJOR = 'MAJOR',
  MINOR = 'MINOR'
}

/**
 * The soften a finding was ELIGIBLE for. Eligible, not fired: a soften that fired shows in the finding's
 * type and severity instead. Published so a STORED grading can be re-aggregated — which soften could have
 * reached a CRITICAL is what decides whether the caps fired, and the family budgets cannot be simulated
 * without it.
 */
export enum ResizeRankingSoftenFamily {
  CTA = 'CTA',
  IMAGE = 'IMAGE',
  LOGO = 'LOGO',
  SHAPE = 'SHAPE',
  TEXT = 'TEXT'
}

export enum ResizeRankingVerdict {
  BORDERLINE = 'BORDERLINE',
  FAIL = 'FAIL',
  PASS = 'PASS'
}

/** The design scorer's grade, on the ranking's 0-10 scale. */
export type ResizeScorerGrade = {
  __typename?: 'ResizeScorerGrade';
  /** The weighted mean before caps, the number the UIs show; null when no weighted rule was measured. */
  meanScore?: Maybe<Scalars['Float']['output']>;
  /** After caps, or null when nothing was measured. */
  score?: Maybe<Scalars['Float']['output']>;
  verdict: DesignScorerVerdict;
  /** The scorer's version that graded it. */
  version: Scalars['String']['output'];
};

export enum ResizeWatchdogBlindVerdict {
  FAIL = 'FAIL',
  PASS = 'PASS'
}

export enum ResizeWatchdogMethod {
  AI_HTML = 'AI_HTML',
  AI_VARIANT = 'AI_VARIANT',
  CLIENT_CLONE = 'CLIENT_CLONE',
  /** Grade-time capture — a generated candidate graded at rankResizeAgainstSaved, content-addressed (no live design). */
  GRADE_CANDIDATE = 'GRADE_CANDIDATE',
  TEMPLATE = 'TEMPLATE',
  TEMPLATE_SIMILARITY = 'TEMPLATE_SIMILARITY'
}

export enum ResizeWatchdogReviewChannel {
  DETERMINISTIC = 'DETERMINISTIC',
  FULL = 'FULL'
}

export enum ResizeWatchdogReviewMode {
  BLIND = 'BLIND',
  NORMAL = 'NORMAL'
}

export enum ResizeWatchdogReviewStatus {
  CONFIRMED = 'CONFIRMED',
  OVERRULED = 'OVERRULED',
  PENDING = 'PENDING'
}

export enum ResizeWatchdogSortField {
  CREATED_AT = 'CREATED_AT',
  /** Sorts by the EFFECTIVE mean — COALESCE(full_mean_score, det_mean_score), same rule as the verdict/grade filters and the displayed grade. Name kept for wire compat with the admin app's 'score' slug. */
  DET_MEAN_SCORE = 'DET_MEAN_SCORE',
  REVIEWED_AT = 'REVIEWED_AT'
}

export enum ResizeWatchdogSortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

/** Provenance of a `resizeWithTemplate` similarity match — which catalogue the winning template came from. */
export enum ResizeWithTemplateMatchSource {
  /** Static template catalogue (cross-team, editorially curated). */
  TEMPLATE = 'template',
  /** Snapshot of another SET in the same team's `user_design` pool. */
  USER_DESIGN = 'user_design'
}

/**
 * Response from resizeWithTemplate. One result per requested size — match
 * provenance (`resizeType`, `matchedDesignHash`, `matchedTemplateSetHash`,
 * `matchedSourceType`) lives per-size on each `ResizeWithTemplateResult`,
 * since different sizes can be resized against different templates.
 */
export type ResizeWithTemplatePayload = {
  __typename?: 'ResizeWithTemplatePayload';
  createdDesigns: Array<ResizeWithTemplateResult>;
};

/** Per-size outcome of a resizeWithTemplate request. */
export type ResizeWithTemplateResult = {
  __typename?: 'ResizeWithTemplateResult';
  /** The newly created design, or null when no matching template size exists. */
  createdDesign?: Maybe<Design>;
  /** Echoes the requested design size type id. */
  designSizeTypeId: Scalars['Int']['output'];
  /**
   * Hash of the child design (within the matched SET) that drove this
   * size's group. `null` when `resizeType` is `none`.
   */
  matchedDesignHash?: Maybe<Scalars['String']['output']>;
  /** Provenance of this size's matched SET. `null` when `resizeType` is `none`. */
  matchedSourceType?: Maybe<ResizeWithTemplateMatchSource>;
  /** Hash of the SET (parent of `matchedDesignHash`). `null` when `resizeType` is `none`. */
  matchedTemplateSetHash?: Maybe<Scalars['String']['output']>;
  /**
   * Which path resolved THIS size's template group. `none` when this
   * size produced no design (no matching template child / group path
   * failed) — the caller falls back to AI / legacy resize for it.
   */
  resizeType: ResizeWithTemplateType;
};

/**
 * Which path the backend used to resolve the resize. Drives both the
 * client-side analytics event (TEMPLATE vs TEMPLATE_SIMILARITY) and the
 * fallback decision (`none` → caller falls back to AI / legacy resize).
 */
export enum ResizeWithTemplateType {
  /** Neither id-based nor similarity produced a usable match. Caller should fall back to AI or legacy resize for every size in this call. */
  NONE = 'none',
  /** Source SET had a `templateId` and the main-size layout still matches the template — used id-based merge (`bannersetElementId` pairing). */
  TEMPLATE = 'template',
  /** Either no `templateId` or the layout drifted past tolerance — used similarity search on `design_layout_signature`. */
  TEMPLATE_SIMILARITY = 'template_similarity'
}

export type ResolveMoodBoardThreadInput = {
  moodBoardHash: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  threadId: Scalars['Int']['input'];
};

export enum ResourceAccess {
  LIMITED = 'LIMITED',
  NO_ACCESS = 'NO_ACCESS',
  PERSONAL = 'PERSONAL',
  PRIVATE = 'PRIVATE'
}

export type ResourceAccessPayload = {
  __typename?: 'ResourceAccessPayload';
  result: ResourceAccessResult;
};

export type ResourceAccessResult = {
  __typename?: 'ResourceAccessResult';
  accessType: AccessType;
  domainStatus?: Maybe<TeamBrandStatus>;
  location: LocationType;
  publicStatus?: Maybe<PublicStatus>;
  /** Whether to show predictive scoring (from team brand control). Defaults to true when not set. */
  showPredictiveScoring: Scalars['Boolean']['output'];
  type?: Maybe<ResourceAccess>;
};

export enum ResourceType {
  FAVICON = 'FAVICON',
  LOGO = 'LOGO'
}

export type RestoreAbTestPayload = {
  __typename?: 'RestoreAbTestPayload';
  abTest: AbTest;
};

/** Response after restoring a design to a set. */
export type RestoreDesignFromSetPayload = {
  __typename?: 'RestoreDesignFromSetPayload';
  /** Whether the restoration was successful. */
  result: Scalars['Boolean']['output'];
};

/** Response after restoring a design from trash. */
export type RestoreDesignPayload = {
  __typename?: 'RestoreDesignPayload';
  /** The restored design. */
  design: Design;
  /** The association between the design and its project. */
  projectDesign: ProjectDesign;
};

/** Response after restoring a project. */
export type RestoreProjectPayload = {
  __typename?: 'RestoreProjectPayload';
  /** ID of the restored project. */
  id: Scalars['Int']['output'];
  /** Designs within the project that were also restored. */
  innerDesigns: Array<TrashItemIdWithParentDeleted>;
  /** Folders within the project that were also restored. */
  innerFolders: Array<TrashItemIdWithParentDeleted>;
};

export type RestoreStoredFontResult = {
  __typename?: 'RestoreStoredFontResult';
  /** The backup as it stands after the call. Restoring does not consume it. */
  backup: StoredFontBackup;
  hash: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** True only when "apply" was set and there was a backup to put back. */
  restored: Scalars['Boolean']['output'];
};

/** Response after restoring a variation. */
export type RestoreVariationPayload = {
  __typename?: 'RestoreVariationPayload';
  result: Scalars['Boolean']['output'];
};

/** Response after restoring a family state. */
export type RestoreVariationsFamilyStatePayload = {
  __typename?: 'RestoreVariationsFamilyStatePayload';
  master: Design;
  /** How many size rows had their content rewritten. */
  writtenSizes: Scalars['Int']['output'];
};

export type RestrictionDetails = {
  __typename?: 'RestrictionDetails';
  action: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  requiresUpgrade?: Maybe<Scalars['Boolean']['output']>;
  scope: Scalars['String']['output'];
};

export enum RestrictionSeverity {
  AWARENESS = 'AWARENESS',
  EXPAND = 'EXPAND',
  PERSISTENT = 'PERSISTENT'
}

/** Result of resume subscription operation */
export type ResumeSubscriptionResult = {
  __typename?: 'ResumeSubscriptionResult';
  /** Error message if operation failed */
  errorMessage?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<RecurlySubscription>;
  success: Scalars['Boolean']['output'];
};

export type RetryJobInput = {
  designId: Scalars['Int']['input'];
  platform: DpaPlatformType;
};

export type RevertBgOnBoundedImagePayload = {
  __typename?: 'RevertBgOnBoundedImagePayload';
  result: RevertBgOnBoundedImagePayloadResult;
};

export type RevertBgOnBoundedImagePayloadResult = {
  __typename?: 'RevertBgOnBoundedImagePayloadResult';
  rowJson: Scalars['JSON']['output'];
};

/** Response after revoking an invitation. */
export type RevokeInvitationPayload = {
  __typename?: 'RevokeInvitationPayload';
  /** Whether the revocation was successful. */
  result: Scalars['Boolean']['output'];
};

export type RoleSettings = {
  __typename?: 'RoleSettings';
  editorType: Scalars['String']['output'];
};

export type RollbackCreditTransactionInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  transactionId: Scalars['Int']['input'];
};

export type RunCustomWorkflowResponse = {
  __typename?: 'RunCustomWorkflowResponse';
  id: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type RunWorkflowResponse = {
  __typename?: 'RunWorkflowResponse';
  ids: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SampleAdSetSnapshotDesign = {
  __typename?: 'SampleAdSetSnapshotDesign';
  designId: Scalars['Int']['output'];
  hash: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  json: Scalars['JSON']['output'];
  name: Scalars['String']['output'];
  /** ISO timestamp of the design's last save. */
  updatedAt: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type SampleAdSetSnapshotPayload = {
  __typename?: 'SampleAdSetSnapshotPayload';
  designs: Array<SampleAdSetSnapshotDesign>;
};

export type SampleDemoFeeds = {
  __typename?: 'SampleDemoFeeds';
  items: Array<FeedSample>;
};

export type SaveAdjustmentInput = {
  design?: InputMaybe<Scalars['JSON']['input']>;
  designId: Scalars['Int']['input'];
  layers?: InputMaybe<Array<AdjustmentLayerInput>>;
  rowIndex: Scalars['Int']['input'];
};

export type SaveBrandKitCompetitorFromChatPayload = {
  __typename?: 'SaveBrandKitCompetitorFromChatPayload';
  id: Scalars['Int']['output'];
};

/** Response when saving brand kit JSON data. */
export type SaveBrandKitJsonV2Payload = {
  __typename?: 'SaveBrandKitJsonV2Payload';
  /** JSON data that was saved. */
  brandkitJson: Scalars['BrandKitJson']['output'];
  /** Hash of the brand kit. */
  hash: Scalars['String']['output'];
};

export type SaveBrandKitTargetAudienceFromChatPayload = {
  __typename?: 'SaveBrandKitTargetAudienceFromChatPayload';
  id: Scalars['Int']['output'];
};

export type SaveCatalogVariationDesignsPayload = {
  __typename?: 'SaveCatalogVariationDesignsPayload';
  /** Opaque revision of the attachment, unchanged by this write. */
  attachmentRevision: Scalars['String']['output'];
  /** The value pinned into design_feed.bindings, aggregated over every size of the variation. */
  bindings: Scalars['Boolean']['output'];
  /** The sizes actually written. */
  designs: Array<Design>;
  /** False when the save deliberately left checksum debt because the catalog moved under the edit. */
  materializationCurrent: Scalars['Boolean']['output'];
  /** The variation top row: the set, or the design itself when single-shaped. */
  variation: Design;
};

export type SaveCopilotAiChatMessageAdditionalFeedbackPayload = {
  __typename?: 'SaveCopilotAiChatMessageAdditionalFeedbackPayload';
  chatId: Scalars['Int']['output'];
  messageId: Scalars['String']['output'];
};

export type SaveCopilotAiChatMessageFeedbackPayload = {
  __typename?: 'SaveCopilotAiChatMessageFeedbackPayload';
  chatId: Scalars['Int']['output'];
  isPositiveFeedback: Scalars['Boolean']['output'];
  messageId: Scalars['String']['output'];
  showAdditionalFeedbackModal: Scalars['Boolean']['output'];
};

export type SaveDesignsJsonForLaterPayload = {
  __typename?: 'SaveDesignsJsonForLaterPayload';
  savedHash: Scalars['String']['output'];
};

export type SavePlatformAdInput = {
  /** Platform ad archive ID */
  adArchiveId: Scalars['String']['input'];
  /** @deprecated Use projectId instead */
  brandKitId?: InputMaybe<Scalars['Int']['input']>;
  /** Platform ad data */
  data?: InputMaybe<Scalars['JSON']['input']>;
  /** Platform ad platform */
  platform: Scalars['String']['input'];
  /** Project ID for context @BreakingBad */
  projectId: Scalars['Int']['input'];
};

export type SaveReportPayload = {
  __typename?: 'SaveReportPayload';
  result: AdTagReportResult;
};

export type SavedCopilotDocumentToBrandKit = {
  __typename?: 'SavedCopilotDocumentToBrandKit';
  appliedFields: Array<CopilotDocumentBrandKitField>;
  brandKitId: Scalars['Int']['output'];
  brandKitName: Scalars['String']['output'];
  created: Scalars['Boolean']['output'];
};

export type Score = {
  __typename?: 'Score';
  accessibility?: Maybe<ScoringData>;
  brandAccuracy?: Maybe<ScoringData>;
};

export type ScoreResult = {
  __typename?: 'ScoreResult';
  refetchCachedDesigns: Scalars['Boolean']['output'];
  result: Score;
};

export type ScoringCriteria = {
  __typename?: 'ScoringCriteria';
  id: Scalars['String']['output'];
  score: Scalars['Int']['output'];
  summary: Scalars['String']['output'];
  title: Scalars['String']['output'];
  weight?: Maybe<Scalars['Int']['output']>;
};

export type ScoringData = {
  __typename?: 'ScoringData';
  criteria: Array<ScoringCriteria>;
  improvementSuggestions: Array<ImprovementSuggestions>;
  overallScore: Scalars['Int']['output'];
};

/** Address the feed by feedId (members of the feed's team only) or by designHash (a share link's design hash) */
export type SearchFeedRowsInput = {
  column?: InputMaybe<Scalars['String']['input']>;
  designHash?: InputMaybe<Scalars['String']['input']>;
  feedId?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  rowIndices?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type SearchFeedRowsPayload = {
  __typename?: 'SearchFeedRowsPayload';
  result: Array<SearchResult>;
};

export type SearchHasNextPage = {
  __typename?: 'SearchHasNextPage';
  brandKit?: Maybe<Scalars['Boolean']['output']>;
  design?: Maybe<Scalars['Boolean']['output']>;
  designSizeType?: Maybe<Scalars['Boolean']['output']>;
  folder?: Maybe<Scalars['Boolean']['output']>;
  project?: Maybe<Scalars['Boolean']['output']>;
  team?: Maybe<Scalars['Boolean']['output']>;
};

export enum SearchMode {
  CREATE_TEMPLATE = 'CREATE_TEMPLATE',
  FULL = 'FULL'
}

export type SearchPageInfo = {
  __typename?: 'SearchPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: SearchHasNextPage;
};

export type SearchPayload = {
  __typename?: 'SearchPayload';
  nodes: Array<SearchResultItem>;
  pageInfo: SearchPageInfo;
};

export type SearchResult = {
  __typename?: 'SearchResult';
  item: Scalars['JSON']['output'];
  refIndex: Scalars['Int']['output'];
};

export enum SearchResultCategory {
  BRAND_KIT = 'BRAND_KIT',
  CREATE_CUSTOM_SIZE = 'CREATE_CUSTOM_SIZE',
  DEFAULT = 'DEFAULT',
  DESIGN = 'DESIGN',
  DESIGN_SIZE_TYPE = 'DESIGN_SIZE_TYPE',
  FOLDER = 'FOLDER',
  PROJECT = 'PROJECT',
  TEAM = 'TEAM'
}

export type SearchResultItem = {
  __typename?: 'SearchResultItem';
  brandKitId?: Maybe<Scalars['Int']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  designHash?: Maybe<Scalars['String']['output']>;
  designSizeTypeCategory?: Maybe<Scalars['String']['output']>;
  designSizeTypeIsAnimated?: Maybe<Scalars['Boolean']['output']>;
  designSizeTypeIsStatic?: Maybe<Scalars['Boolean']['output']>;
  designSizeTypeIsVideo?: Maybe<Scalars['Boolean']['output']>;
  designType?: Maybe<Scalars['String']['output']>;
  folderId?: Maybe<Scalars['Int']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  isShared?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  projectId?: Maybe<Scalars['Int']['output']>;
  /**
   * Live sizes behind a DESIGN result: a set counts its live child sizes, a
   * standalone design is its own single size. Null for every other category,
   * whose id is not a design id. Exactly one size means the result behaves as a
   * single design for plan gating; any other count is gated as a set, including
   * zero for a set whose last size was removed.
   */
  sizesCount?: Maybe<Scalars['Int']['output']>;
  teamId?: Maybe<Scalars['Int']['output']>;
  template?: Maybe<Scalars['Boolean']['output']>;
  thumb?: Maybe<Scalars['String']['output']>;
  thumbId?: Maybe<Scalars['Int']['output']>;
  type: SearchResultCategory;
  width?: Maybe<Scalars['Float']['output']>;
};

export type SegmentPage = {
  path?: InputMaybe<Scalars['String']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type SegmentProperties = {
  anonymousId?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<SegmentPage>;
  userAgentData?: InputMaybe<Scalars['JSON']['input']>;
};

export type SelectVeevaVaultInput = {
  sessionId: Scalars['String']['input'];
  vaultId: Scalars['String']['input'];
  vaultIds: Array<VaultInstanceInput>;
};

export enum SendMessageDestination {
  EMAIL = 'email',
  NOTION = 'notion',
  SLACK = 'slack'
}

export type SendMessageToSlackChannelInput = {
  channelId: Scalars['String']['input'];
  reportName?: InputMaybe<Scalars['String']['input']>;
  reportUrl: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
  workspaceId: Scalars['String']['input'];
};

export type SendMessageToSlackChannelResult = {
  __typename?: 'SendMessageToSlackChannelResult';
  message?: Maybe<Scalars['String']['output']>;
  messageTimestamp?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Input for sending a message in the ads library chat */
export type SendMyMessageInput = {
  /** Brand kit ID for context */
  brandKitId: Scalars['ID']['input'];
  /** Competitor ID being discussed */
  competitorId: Scalars['ID']['input'];
  /** Message content to send */
  content: Scalars['String']['input'];
};

/** Response after sending a message in the ads library chat */
export type SendMyMessageResponse = {
  __typename?: 'SendMyMessageResponse';
  /** The message that was sent */
  message: AdsLibraryChatMessage;
  /** ID of the session where the message was sent */
  sessionId: Scalars['ID']['output'];
};

export type SendTestEmailPayload = {
  __typename?: 'SendTestEmailPayload';
  result: Scalars['Boolean']['output'];
};

export type SendWorkflowMessageResponse = {
  __typename?: 'SendWorkflowMessageResponse';
  success: Scalars['Boolean']['output'];
};

/** Sentiment distribution by category */
export type SentimentDistribution = {
  __typename?: 'SentimentDistribution';
  /** Sentiment category (positive, negative, neutral) */
  category: Scalars['String']['output'];
  /** Number of items in this category */
  count: Scalars['Int']['output'];
  /** Percentage of total items in this category */
  percentage: Scalars['Float']['output'];
};

/** Sentiment analysis statistics */
export type SentimentStats = {
  __typename?: 'SentimentStats';
  /** Distribution of sentiment categories */
  distribution: Array<SentimentDistribution>;
  /** Overall sentiment score */
  overallScore: Scalars['Float']['output'];
};

export type SetBrandedColorPayload = {
  __typename?: 'SetBrandedColorPayload';
  brandColor: Scalars['String']['output'];
};

export type SetBrandedDomainPayload = {
  __typename?: 'SetBrandedDomainPayload';
  brandDomain: Scalars['String']['output'];
};

export type SetBrandedEmailPayload = {
  __typename?: 'SetBrandedEmailPayload';
  brandRecords?: Maybe<BrandRecords>;
};

export type SetBrandedFaviconPayload = {
  __typename?: 'SetBrandedFaviconPayload';
  result: Scalars['Boolean']['output'];
};

export type SetBrandedLogoPayload = {
  __typename?: 'SetBrandedLogoPayload';
  result: Scalars['Boolean']['output'];
};

/** Result of setCatalogFavorite (CRE-451): the catalog hash + its new favorite state for the current user */
export type SetCatalogFavoritePayload = {
  __typename?: 'SetCatalogFavoritePayload';
  hash: Scalars['String']['output'];
  isFavorite: Scalars['Boolean']['output'];
};

/** Response after setting a project as favorite. */
export type SetFavoriteProjectPayload = {
  __typename?: 'SetFavoriteProjectPayload';
  /** When the project was marked as favorite (null if unfavorited). */
  favoredAt?: Maybe<Scalars['Date']['output']>;
  /** ID of the project that was marked as favorite. */
  projectId: Scalars['Int']['output'];
};

export type SetFeedColumnSmartCropEnabledPayload = {
  __typename?: 'SetFeedColumnSmartCropEnabledPayload';
  feed: Feed;
};

/** Input for toggling per-font metric-override behavior. */
export type SetFontMetricsOverrideDisabledInput = {
  brandKitId: Scalars['Int']['input'];
  disabled: Scalars['Boolean']['input'];
  fontId: Scalars['Int']['input'];
};

/** Result of setting Intercom email confirmation. */
export type SetIntercomEmailConfirmationPayload = {
  __typename?: 'SetIntercomEmailConfirmationPayload';
  /** Whether the operation was successful. */
  result: Scalars['Boolean']['output'];
};

export type SetMetaPublicationAutoSyncInput = {
  autoSync: Scalars['Boolean']['input'];
  designId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type SetPageTitlePayload = {
  __typename?: 'SetPageTitlePayload';
  result: Scalars['Boolean']['output'];
};

/** Response after setting a project logo. */
export type SetProjectLogoPayload = {
  __typename?: 'SetProjectLogoPayload';
  /** Whether the operation was successful. */
  result: Scalars['Boolean']['output'];
};

export type SetSmartCropOnFeedRowPayload = {
  __typename?: 'SetSmartCropOnFeedRowPayload';
  rowJson: Scalars['JSON']['output'];
};

/** Response after setting a team logo. */
export type SetTeamLogoPayload = {
  __typename?: 'SetTeamLogoPayload';
  /** Whether the operation was successful. */
  result: Scalars['Boolean']['output'];
};

/** Response when setting typography options. */
export type SetTypographyOptionsPayload = {
  __typename?: 'SetTypographyOptionsPayload';
  /** The updated brand kit. */
  brandKit: BrandKit;
};

/** Response after promoting a variation to master — carries the promoted design (the new master). */
export type SetVariationAsMasterPayload = {
  __typename?: 'SetVariationAsMasterPayload';
  master: Design;
};

/** Response after sharing a design. */
export type ShareDesignPayload = {
  __typename?: 'ShareDesignPayload';
  /** Whether the share operation was successful. */
  result: Scalars['Boolean']['output'];
};

export type ShareFolderPayload = {
  __typename?: 'ShareFolderPayload';
  shareFolder: Scalars['Boolean']['output'];
};

export type ShareFoldersAndDesignsPayload = {
  __typename?: 'ShareFoldersAndDesignsPayload';
  result: Array<ShareFoldersAndDesignsPayloadElement>;
};

export type ShareFoldersAndDesignsPayloadElement = {
  __typename?: 'ShareFoldersAndDesignsPayloadElement';
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isShared: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  template?: Maybe<Scalars['Boolean']['output']>;
  type: ShareFoldersAndDesignsShareElementType;
};

export type ShareFoldersAndDesignsShareElement = {
  id: Scalars['Int']['input'];
  type: ShareFoldersAndDesignsShareElementType;
};

export enum ShareFoldersAndDesignsShareElementType {
  DESIGN = 'DESIGN',
  FOLDER = 'FOLDER'
}

export type SharePointAccessToken = {
  __typename?: 'SharePointAccessToken';
  accessToken: Scalars['String']['output'];
  baseUrl: Scalars['String']['output'];
};

export type SharePointDefaultExportLocation = {
  __typename?: 'SharePointDefaultExportLocation';
  driveId: Scalars['String']['output'];
  driveName: Scalars['String']['output'];
  folderId: Scalars['String']['output'];
  folderPath: Scalars['String']['output'];
  siteId: Scalars['String']['output'];
  siteName: Scalars['String']['output'];
};

export type SharePointDefaultExportLocationInput = {
  driveId: Scalars['String']['input'];
  driveName: Scalars['String']['input'];
  folderId: Scalars['String']['input'];
  folderPath: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
  siteName: Scalars['String']['input'];
};

export type SharePointDrive = {
  __typename?: 'SharePointDrive';
  driveType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  webUrl: Scalars['String']['output'];
};

export type SharePointDriveItem = {
  __typename?: 'SharePointDriveItem';
  id: Scalars['String']['output'];
  isFolder: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  webUrl: Scalars['String']['output'];
};

export type SharePointPersonalDriveContext = {
  __typename?: 'SharePointPersonalDriveContext';
  driveId: Scalars['String']['output'];
  driveName: Scalars['String']['output'];
  siteId: Scalars['String']['output'];
  siteName: Scalars['String']['output'];
};

export type SharePointSite = {
  __typename?: 'SharePointSite';
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  webUrl: Scalars['String']['output'];
};

export type SharePointUploadDestinationInput = {
  driveId: Scalars['String']['input'];
  folderId: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
};

export type ShareVariationSelectionPayload = {
  __typename?: 'ShareVariationSelectionPayload';
  /** The variation hashes this link is currently saved to. Null means the whole family. */
  variationHashes?: Maybe<Scalars['String']['output']>;
};

/** Response containing users and groups with access to a shared design. */
export type SharedDesignPayload = {
  __typename?: 'SharedDesignPayload';
  /** List of team user groups with access to the design. */
  groups: Array<TeamUserGroup>;
  /** List of team users with access to the design. */
  users: Array<TeamUser>;
};

/** Information about how a design is shared. */
export type SharedPayload = {
  __typename?: 'SharedPayload';
  /** Whether the user has access via sharing. */
  accessByShare?: Maybe<Scalars['Boolean']['output']>;
  /** Number of groups with access. */
  groups: Scalars['Int']['output'];
  /** Number of individual members with access. */
  members: Scalars['Int']['output'];
};

export type SharelinkScore = {
  __typename?: 'SharelinkScore';
  designId: Scalars['Int']['output'];
  overallScore?: Maybe<Scalars['Int']['output']>;
};

export enum ShutterStockPeopleGender {
  BOTH = 'both',
  FEMALE = 'female',
  MALE = 'male'
}

export type ShutterstockCategoriesResult = {
  __typename?: 'ShutterstockCategoriesResult';
  records: Array<ShutterstockCategory>;
};

export type ShutterstockCategory = {
  __typename?: 'ShutterstockCategory';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ShutterstockDownloadResult = {
  __typename?: 'ShutterstockDownloadResult';
  url: Scalars['String']['output'];
};

export type SignShareUploadUrlResult = {
  __typename?: 'SignShareUploadUrlResult';
  fields: Scalars['JSON']['output'];
  url: Scalars['String']['output'];
};

export type SignUploadUrlResult = {
  __typename?: 'SignUploadUrlResult';
  fields: Scalars['JSON']['output'];
  url: Scalars['String']['output'];
};

/** Response containing a signed URL for media upload. */
export type SignedMediaUrl = {
  __typename?: 'SignedMediaUrl';
  /** Form fields needed for the upload. */
  fields: Scalars['JSON']['output'];
  /** Hash identifier for the upload. */
  hash: Scalars['String']['output'];
  /** Temporary path for the upload. */
  tempPath: Scalars['String']['output'];
  /** URL to upload the media to. */
  uploadUrl: Scalars['String']['output'];
};

export enum SignedServers {
  AD_PUBLISHING = 'AD_PUBLISHING',
  AD_REPORTS = 'AD_REPORTS',
  AI_AGENTS = 'AI_AGENTS',
  AI_CREATOR = 'AI_CREATOR',
  AI_GENERATION = 'AI_GENERATION',
  AI_OPTIMIZE_REPORT = 'AI_OPTIMIZE_REPORT',
  AI_RESIZE = 'AI_RESIZE',
  BYNDER = 'BYNDER',
  CREDITS = 'CREDITS',
  CRON = 'CRON',
  DEV = 'DEV',
  DPA = 'DPA',
  DUPLICATE_FOLDER = 'DUPLICATE_FOLDER',
  EMAIL = 'EMAIL',
  EXPORT_AMP = 'EXPORT_AMP',
  EXPORT_HTML = 'EXPORT_HTML',
  EXPORT_IMAGE = 'EXPORT_IMAGE',
  EXPORT_JPG_PNG = 'EXPORT_JPG_PNG',
  EXPORT_PDF = 'EXPORT_PDF',
  EXPORT_PSD = 'EXPORT_PSD',
  EXPORT_VIDEO = 'EXPORT_VIDEO',
  FEED_SYNC = 'FEED_SYNC',
  FIGMA = 'FIGMA',
  GIS = 'GIS',
  HUBSPOT = 'HUBSPOT',
  LEAD_PIPELINE = 'LEAD_PIPELINE',
  MEDIA_PROCESS = 'MEDIA_PROCESS',
  MOODBOARD = 'MOODBOARD',
  PHOTOSHOP = 'PHOTOSHOP',
  RESIZE_WATCHDOG = 'RESIZE_WATCHDOG',
  SHARE = 'SHARE',
  SITE = 'SITE',
  SMS = 'SMS',
  WEBHOOKS = 'WEBHOOKS',
  WEB_RISK_WORKER = 'WEB_RISK_WORKER',
  WORKFLOWS = 'WORKFLOWS',
  ZIP_MAKER_SERVICE = 'ZIP_MAKER_SERVICE'
}

export type SimilaritySearchResult = {
  __typename?: 'SimilaritySearchResult';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  intention: Scalars['String']['output'];
  phrase?: Maybe<Scalars['String']['output']>;
  similarity: Scalars['Float']['output'];
  source: SimilaritySearchSource;
};

export enum SimilaritySearchSource {
  EMBEDDING = 'embedding',
  INTENTION = 'intention'
}

export type Size = {
  hash: Scalars['String']['input'];
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

/** Size constraint with width and height */
export type SizeConstraint = {
  __typename?: 'SizeConstraint';
  height: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};

/** Size requirement with validation status for campaign types */
export type SizeRequirement = {
  __typename?: 'SizeRequirement';
  isMatched: Scalars['Boolean']['output'];
  isRequired: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  matchedSizes: Array<MatchedSize>;
  maximum?: Maybe<SizeConstraint>;
  minItems?: Maybe<Scalars['Int']['output']>;
  minimum: SizeConstraint;
  name: Scalars['String']['output'];
  ratio?: Maybe<Scalars['String']['output']>;
  ratioTolerance?: Maybe<Scalars['Float']['output']>;
  recommended?: Maybe<SizeConstraint>;
};

/** Special size type exceptions for responsive templates. */
export enum SizeTypeExceptionsTypes {
  /** Landscape art responsive format */
  RESPONSIVELANDSCAPEART = 'responsiveLandscapeArt',
  /** Square art responsive format */
  RESPONSIVESQUAREART = 'responsiveSquareArt'
}

export type SlackChannel = {
  __typename?: 'SlackChannel';
  id: Scalars['String']['output'];
  isMember: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type SlackChannelsResult = {
  __typename?: 'SlackChannelsResult';
  channels: Array<SlackChannel>;
};

export type SlideData = {
  __typename?: 'SlideData';
  id: Scalars['String']['output'];
  note: Scalars['String']['output'];
  noteId: Scalars['String']['output'];
  timing?: Maybe<Scalars['String']['output']>;
};

export type SlideDataInput = {
  slides: Array<InputMaybe<SlideDataInputItem>>;
};

export type SlideDataInputItem = {
  id: Scalars['String']['input'];
  note: Scalars['String']['input'];
  noteId: Scalars['String']['input'];
  timing?: InputMaybe<Scalars['String']['input']>;
};

export type SlideDataOutput = {
  __typename?: 'SlideDataOutput';
  slides: Array<Maybe<SlideData>>;
};

export enum Slides {
  ALL = 'all',
  CURRENT = 'current',
  CUSTOM = 'custom',
  FIRST = 'first',
  LAST = 'last'
}

/**
 * Response from `smartCropBanners`: the input banners with image layers
 * re-framed in place (`scaleMode` + `cropData` updated), in the SAME order as
 * `items`. On a Vision failure the corresponding banner is returned unchanged.
 */
export type SmartCropBannersPayload = {
  __typename?: 'SmartCropBannersPayload';
  banners: Array<Scalars['JsonDesign']['output']>;
};

export type SmartCropOnImagePayload = {
  __typename?: 'SmartCropOnImagePayload';
  focalArea: FeedFocalArea;
  imageHeight: Scalars['Int']['output'];
  imageWidth: Scalars['Int']['output'];
};

export type SmartCropResult = {
  __typename?: 'SmartCropResult';
  /** Crop background height — height of the scaled image */
  cropBackgroundHeight: Scalars['Float']['output'];
  /** Crop background width — width of the scaled image */
  cropBackgroundWidth: Scalars['Float']['output'];
  /** Crop background x — horizontal offset from the image layer top-left */
  cropBackgroundX: Scalars['Float']['output'];
  /** Crop background y — vertical offset */
  cropBackgroundY: Scalars['Float']['output'];
  rotation: Scalars['Float']['output'];
  /** True when the image is a cutout (transparent background) AND the caller requested skipTransparent. The crop values are a neutral fallback; the caller should leave the layer uncropped (contain it) so the subject is not clipped. Absent/false otherwise. */
  transparent?: Maybe<Scalars['Boolean']['output']>;
};

export type Snapshot = {
  id: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  timing: Scalars['Float']['input'];
};

export type SolveCommentResult = {
  __typename?: 'SolveCommentResult';
  thread: CommentThread;
};

/** Spending information with disclaimer */
export type SpendDisclaimer = {
  __typename?: 'SpendDisclaimer';
  /** Disclaimer text */
  disclaimer: Scalars['String']['output'];
  /** Amount spent under this disclaimer */
  spend: Scalars['Float']['output'];
};

/** One stage image and the description stored for it, if any. */
export type StageImageDescription = {
  __typename?: 'StageImageDescription';
  /** Stored or freshly generated description. Null when the url has no media row, or when generating one failed. */
  description?: Maybe<Scalars['String']['output']>;
  /** The image url exactly as it was passed in. */
  url: Scalars['String']['output'];
};

/** Descriptions for a slide's image layers, in the order the urls were given. */
export type StageImageDescriptionsResult = {
  __typename?: 'StageImageDescriptionsResult';
  items: Array<StageImageDescription>;
};

export type StartAiResizeVariantsPayload = {
  __typename?: 'StartAiResizeVariantsPayload';
  sessionId: Scalars['String']['output'];
  variants: Array<AiResizeVariant>;
};

export type StartCreditTransactionInternalInput = {
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  operationCount: Scalars['Int']['input'];
  operationName?: InputMaybe<Scalars['String']['input']>;
  operationType: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

/** Input for starting a new ads library chat session */
export type StartNewChatInput = {
  /** Brand kit ID for context */
  brandKitId: Scalars['ID']['input'];
  /** Competitor ID to analyze */
  competitorId: Scalars['ID']['input'];
  /** Optional custom title for the session */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StartedCopilotBrandOnTemplate = {
  __typename?: 'StartedCopilotBrandOnTemplate';
  /** The flat-to-layers operation the chat card polls. */
  aiOperationId: Scalars['Int']['output'];
  /** The one design the result is written to: the design itself, or a one-size set's only size. */
  targetDesignHash: Scalars['String']['output'];
};

export type StartedCopilotEditDesign = {
  __typename?: 'StartedCopilotEditDesign';
  /** The Edit design operation the chat card polls. */
  aiOperationId: Scalars['Int']['output'];
  /** The one design the result is written to: the design itself, or a one-size set's only size. */
  targetDesignHash: Scalars['String']['output'];
};

export type StartedCopilotGeneration = {
  __typename?: 'StartedCopilotGeneration';
  /** True when another attempt of the same turn holds its server starts: nothing started or billed, and operationIds is empty. */
  earlierAttemptStarted?: Maybe<Scalars['Boolean']['output']>;
  /** The started operations, lowest first: one per image variant, one for a video. */
  operationIds: Array<Scalars['Int']['output']>;
};

export type StartedCopilotSceneEdit = {
  __typename?: 'StartedCopilotSceneEdit';
  /** The new video's registry entry, in the browser's kickoff shape (toolCallId, announced, client). */
  copilotKickoff?: Maybe<Scalars['JSON']['output']>;
  /** True when another attempt of the same turn holds its server starts: nothing started or billed. */
  earlierAttemptStarted?: Maybe<Scalars['Boolean']['output']>;
  notEditableReason?: Maybe<Scalars['String']['output']>;
  /** The regeneration's operations, when no opening picture is edited and it started at once. */
  operationIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Set when nothing started: the video or a scene could not be changed. */
  refusal?: Maybe<CopilotLongVideoRefusal>;
  sceneCount?: Maybe<Scalars['Int']['output']>;
  /** The first opening-picture edit's operation, when pictures are edited first: poll copilotSceneEdit with it. */
  sceneEditId?: Maybe<Scalars['Int']['output']>;
  /** With UNKNOWN_SCENE: the scene number asked for, and how many the video has. */
  unknownScene?: Maybe<Scalars['Int']['output']>;
};

/** Represents the synchronization status of a network. */
export type StatusSyncNetwork = {
  __typename?: 'StatusSyncNetwork';
  /** The ID of the network. */
  id: Scalars['Int']['output'];
  /** The synchronization status of the network. */
  syncStatus: AdTagSyncStatus;
};

export type StockAudioPayload = {
  __typename?: 'StockAudioPayload';
  /** Audio categories */
  categories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Cursor for the next results */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Flag that shows if more results exist */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  records: Array<Maybe<StockMedia>>;
};

export type StockMedia = {
  __typename?: 'StockMedia';
  audioPath?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  extra?: Maybe<Scalars['JSON']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  hqUrl?: Maybe<Scalars['String']['output']>;
  imagePath?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pageUrl?: Maybe<Scalars['String']['output']>;
  poster?: Maybe<Scalars['String']['output']>;
  providerUrl?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  userLink?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type StockMediaResult = {
  __typename?: 'StockMediaResult';
  /** Audio categories */
  categories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Cursor for the next results */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Flag that shows if more results exist */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  records: Array<Maybe<StockMedia>>;
  /** Search id for shutterstock */
  searchId?: Maybe<Scalars['String']['output']>;
  spellcheckedQuery?: Maybe<Scalars['String']['output']>;
};

export enum StockMediaSource {
  AUDIOPROVIDERS = 'AUDIOPROVIDERS',
  GIPHY = 'GIPHY',
  MELODIE = 'MELODIE',
  PEXELS = 'PEXELS',
  PIXABAY = 'PIXABAY',
  SHUTTERSTOCK = 'SHUTTERSTOCK',
  STORYBLOCKS = 'STORYBLOCKS',
  UNSPLASH = 'UNSPLASH'
}

export enum StockMediaTypes {
  GIF = 'gif',
  SHUTTERSTOCK = 'shutterstock',
  STOCKAUDIO = 'stockAudio',
  STOCKPHOTOS = 'stockPhotos',
  STOCKVIDEOS = 'stockVideos'
}

export type StoredCopilotDocumentImage = {
  __typename?: 'StoredCopilotDocumentImage';
  url: Scalars['String']['output'];
};

/** The persisted vision-gate score for a design, read from design_score (written by the crafted batch and admin re-scores). Distinct from DesignEvalResult, which is a fresh live evaluation. The read query selects a compact subset; the re-score mutation returns the full breakdown. */
export type StoredDesignScore = {
  __typename?: 'StoredDesignScore';
  /** Whether brand-fidelity was scored when this row was saved (from stored context flags). */
  brandKitApplied: Scalars['Boolean']['output'];
  /** When this score was recorded. */
  createdAt: Scalars['Date']['output'];
  defects: Array<DesignEvalDefect>;
  dimensions: Array<DesignEvalCriterion>;
  /** Whether a reference logo was attached when this row was saved. */
  logoReferenceUsed: Scalars['Boolean']['output'];
  /** The judge model that produced this saved score (null on legacy rows). */
  modelId?: Maybe<Scalars['String']['output']>;
  overallScore: Scalars['Int']['output'];
  verdict: DesignEvalVerdict;
};

export type StoredFontBackup = {
  __typename?: 'StoredFontBackup';
  exists: Scalars['Boolean']['output'];
  /** ISO 8601 of when the backup was taken, null when there is none. */
  lastModified?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
};

export type StoredFontBackupResult = {
  __typename?: 'StoredFontBackupResult';
  backup: StoredFontBackup;
  hash: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type StoryBlocksDownload = {
  __typename?: 'StoryBlocksDownload';
  url?: Maybe<Scalars['String']['output']>;
};

export enum StreamSortField {
  LAST_ACTIVITY = 'LAST_ACTIVITY',
  MESSAGE_COUNT = 'MESSAGE_COUNT',
  NAME = 'NAME'
}

export enum StreamSortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type StudioAssistantEditorContextInput = {
  allSizeLayouts?: InputMaybe<Array<StudioAssistantSizeLayoutInput>>;
  currentSlideLayers?: InputMaybe<Array<StudioAssistantLayerSnapshotInput>>;
  sizesContext?: InputMaybe<StudioAssistantSizesContextInput>;
};

export type StudioAssistantFocusModeInput = {
  active: Scalars['Boolean']['input'];
  sizeId?: InputMaybe<Scalars['Int']['input']>;
};

export type StudioAssistantLayerGeometryInput = {
  height: Scalars['Float']['input'];
  /** The cross-size-stable bannersetElementId. */
  id: Scalars['Int']['input'];
  layerType: Scalars['String']['input'];
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rotation?: InputMaybe<Scalars['Float']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  width: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

/**
 * Flattened per-type layer snapshot. GraphQL input types can't be unions,
 * so every variant's fields are optional and `layerType` is the
 * discriminator. The Mastra readers re-narrow by `layerType`.
 */
export type StudioAssistantLayerSnapshotInput = {
  actions?: InputMaybe<Scalars['JSON']['input']>;
  alignment?: InputMaybe<Scalars['String']['input']>;
  autoWidth?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor?: InputMaybe<Scalars['JSON']['input']>;
  border?: InputMaybe<Scalars['JSON']['input']>;
  buttonLabel?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  colorGroups?: InputMaybe<Scalars['JSON']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  fontSize?: InputMaybe<Scalars['Float']['input']>;
  fontWeight?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Int']['input'];
  /** text | button | image | shape | video | svg | audio */
  layerType: Scalars['String']['input'];
  letterSpacing?: InputMaybe<Scalars['Float']['input']>;
  lineHeight?: InputMaybe<Scalars['Float']['input']>;
  loop?: InputMaybe<Scalars['Boolean']['input']>;
  /** An image layer's stored picture, sent when it differs from url (a stock photo's url is its provider's). */
  mediaUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  originalHeight?: InputMaybe<Scalars['Float']['input']>;
  originalWidth?: InputMaybe<Scalars['Float']['input']>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  /** autoWidth | shrink | fixed */
  resizing?: InputMaybe<Scalars['String']['input']>;
  scaleMode?: InputMaybe<Scalars['String']['input']>;
  /** circle | rectangle */
  shapeType?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  textTransform?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  verticalAlign?: InputMaybe<Scalars['String']['input']>;
  volume?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type StudioAssistantSizeEntryInput = {
  height: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  /** One of: square | vertical | horizontal */
  layoutKind: Scalars['String']['input'];
  name: Scalars['String']['input'];
  width: Scalars['Int']['input'];
};

export type StudioAssistantSizeLayoutInput = {
  /** The stage fill's type (backgroundColor.type): solid | lgrad | rgrad | image | none */
  fillType?: InputMaybe<Scalars['String']['input']>;
  height: Scalars['Int']['input'];
  /** One of: square | vertical | horizontal */
  layoutKind: Scalars['String']['input'];
  sizeId: Scalars['Int']['input'];
  slides: Array<StudioAssistantSlideLayoutInput>;
  width: Scalars['Int']['input'];
};

export type StudioAssistantSizesContextInput = {
  /** One of: all | square | vertical | horizontal */
  currentLayoutFilter: Scalars['String']['input'];
  /** Hash of the design the user is viewing (pairs with currentSizeId); drives layered-ad target resolution. */
  currentSizeHash?: InputMaybe<Scalars['String']['input']>;
  currentSizeId: Scalars['Int']['input'];
  /** The slide the user is on (bannersetElementId); the background candidate is resolved on it. */
  currentSlideId?: InputMaybe<Scalars['Int']['input']>;
  focusMode: StudioAssistantFocusModeInput;
  sizes: Array<StudioAssistantSizeEntryInput>;
};

export type StudioAssistantSlideLayoutInput = {
  isCover: Scalars['Boolean']['input'];
  layers: Array<StudioAssistantLayerGeometryInput>;
  slideId: Scalars['Int']['input'];
  slideIndex: Scalars['Int']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /** @deprecated Not used */
  _empty?: Maybe<Scalars['String']['output']>;
  /** Subscribe to streaming AI responses in the ads library chat */
  adsLibraryChatStream: AdsLibraryChatStreamPayload;
  aiFlowCreatorChatStream: AiFlowCreatorChatStreamPayload;
  askHubAgent: HubAgentStreamPayload;
  attachmentUploaded: UploadAttachmentResult;
  commentCreated: CreateCommentResult;
  commentDeleted: CommentDeletedResult;
  commentUpdated: Comment;
  /** @deprecated Use learnAgentAiChatStream instead */
  copilotAiChatStream: CopilotAiChatStreamPayload;
  /** @deprecated This subscription has been removed and will return empty results */
  getIntegrationCampaigns: GetIntegrationCampaignsResult;
  learnAgentAiChatStream: CopilotAiChatStreamPayload;
  threadUpdated: ThreadUpdatedResult;
};


export type SubscriptionAdsLibraryChatStreamArgs = {
  brandKitId?: InputMaybe<Scalars['ID']['input']>;
  competitorId?: InputMaybe<Scalars['ID']['input']>;
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  userMessage?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionAiFlowCreatorChatStreamArgs = {
  input: InputAiFlowCreatorChatStream;
};


export type SubscriptionAskHubAgentArgs = {
  input: InputAskHubAgent;
};


export type SubscriptionAttachmentUploadedArgs = {
  input: InputCommentSubscription;
};


export type SubscriptionCommentCreatedArgs = {
  input: InputCommentSubscription;
};


export type SubscriptionCommentDeletedArgs = {
  input: InputCommentSubscription;
};


export type SubscriptionCommentUpdatedArgs = {
  input: InputCommentSubscription;
};


export type SubscriptionCopilotAiChatStreamArgs = {
  input: InputCopilotAiChat;
};


export type SubscriptionGetIntegrationCampaignsArgs = {
  input: InputGetIntegrationCampaigns;
};


export type SubscriptionLearnAgentAiChatStreamArgs = {
  input: InputLearnAgentAiChat;
};


export type SubscriptionThreadUpdatedArgs = {
  input: InputCommentSubscription;
};

export type SubscriptionActionResult = CreateSubscriptionChangePayload | CreateSubscriptionPayload | ThreeDSecurePayload;

export type SubscriptionAddon = {
  __typename?: 'SubscriptionAddon';
  code: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  unitAmountInCents: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type SubscriptionInfo = {
  __typename?: 'SubscriptionInfo';
  addons?: Maybe<Array<SubscriptionAddon>>;
  creditBalance: CreditBalance;
  creditsLimit?: Maybe<CreditLimit>;
  currentPeriodEndsAt: Scalars['Date']['output'];
  currentPeriodStartedAt: Scalars['Date']['output'];
  hadTrialThatEnded: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  planCode: Scalars['String']['output'];
  planVersion: Scalars['String']['output'];
};

export type SubscriptionPlan = {
  __typename?: 'SubscriptionPlan';
  plan?: Maybe<Scalars['String']['output']>;
};

export enum SubscriptionStatus {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  FUTURE = 'FUTURE',
  LIVE = 'LIVE',
  NO_STATE = 'NO_STATE',
  PAUSED = 'PAUSED'
}

export type SuccessTranslate = {
  checksum: Scalars['String']['input'];
  rows: Scalars['Int']['input'];
  /**
   * How many languages the worker actually produced — the reservation is made
   * from the REQUESTED count, but only the diff against languages already in the
   * feed is sent to DeepL, so the two differ whenever a translation feed is
   * extended (CRE-471). Omitted by an older worker, which finalizes the whole
   * lock exactly as before.
   */
  translatedLanguageCount?: InputMaybe<Scalars['Int']['input']>;
};

export type SuggestedAudience = {
  __typename?: 'SuggestedAudience';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** @deprecated use PublishDpaCatalogInput instead */
export type SyncDpaCatalogInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  adAccountId?: InputMaybe<Scalars['String']['input']>;
  businessId?: InputMaybe<Scalars['String']['input']>;
  catalogId?: InputMaybe<Scalars['String']['input']>;
  createDraftFbCampaign?: InputMaybe<Scalars['Boolean']['input']>;
  designHash: Scalars['String']['input'];
  feedId?: InputMaybe<Scalars['Int']['input']>;
  forceUpdateJson?: InputMaybe<Scalars['Boolean']['input']>;
  newCatalogName?: InputMaybe<Scalars['String']['input']>;
  pageId?: InputMaybe<Scalars['String']['input']>;
  skipSettingsUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  supplementary?: InputMaybe<Scalars['Boolean']['input']>;
  teamId: Scalars['Int']['input'];
  type?: InputMaybe<DpaPlatformType>;
};

/** @deprecated use PublishDpaCatalogResponse instead */
export type SyncDpaCatalogResponse = {
  __typename?: 'SyncDpaCatalogResponse';
  cost?: Maybe<Scalars['Int']['output']>;
  csvUrl?: Maybe<Scalars['String']['output']>;
  jobId?: Maybe<Scalars['String']['output']>;
};

export type SyncDpaCatalogWithDesignInput = {
  designHash: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type SyncDpaCatalogWithDesignResponse = {
  __typename?: 'SyncDpaCatalogWithDesignResponse';
  jobId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type SyncFeed = {
  __typename?: 'SyncFeed';
  checksum?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use feedJson */
  data: FeedData;
  feedJson: Scalars['FeedJson']['output'];
  hash: Scalars['String']['output'];
};

/** Result of syncing a card hash */
export type SyncMoodBoardCardHashPayload = {
  __typename?: 'SyncMoodBoardCardHashPayload';
  success: Scalars['Boolean']['output'];
};

/** What kind of recorded divergence a relink drops (master value wins on this sync). */
export enum SyncRelinkKind {
  ADDED_ELEMENT = 'ADDED_ELEMENT',
  MOVED_ELEMENT = 'MOVED_ELEMENT',
  ORDER = 'ORDER',
  PROPERTY = 'PROPERTY',
  REMOVED_ELEMENT = 'REMOVED_ELEMENT'
}

/** Which kind of master change a skip withholds from a variation (kept as the variation's own). */
export enum SyncSkipKind {
  ADDED_ELEMENT = 'ADDED_ELEMENT',
  PROPERTY = 'PROPERTY'
}

/** A variation size the sync skipped, with the reason. */
export type SyncSkippedSize = {
  __typename?: 'SyncSkippedSize';
  /** Null when the size has no designSizeTypeId to pair by. */
  designSizeTypeId?: Maybe<Scalars['Int']['output']>;
  /**
   * Machine-readable reason. Emitted values: master-unloadable, master-unsyncable,
   * variation-unloadable, variation-unsyncable, never-captured, checksum-drift,
   * ambiguous-size-type, no-size-type, unpaired-standalone, no-project, add-failed,
   * already-processed, master-size-removed-kept, variation-added-kept.
   */
  reason: Scalars['String']['output'];
};

export type SyncSubscriptionPayload = {
  __typename?: 'SyncSubscriptionPayload';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Sync design: re-publish the design's TikTok catalog (either mode) with the settings its row saved, after the design changed. The TikTok counterpart of SyncDpaCatalogWithDesignInput. */
export type SyncTikTokCatalogWithDesignInput = {
  designHash: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

/** Per-variation outcome of a sync run. */
export type SyncVariationResult = {
  __typename?: 'SyncVariationResult';
  /** Master sizes that had no counterpart and were added to the variation. */
  addedSizes: Scalars['Int']['output'];
  /** Recorded divergences preserved across all synced sizes. */
  keptOverrideCount: Scalars['Int']['output'];
  skippedSizes: Array<SyncSkippedSize>;
  /** Sizes whose merged JSON was written. */
  syncedSizes: Scalars['Int']['output'];
  variation: Design;
  warnings: Array<Scalars['String']['output']>;
};

/** Response after syncing variations from their master. */
export type SyncVariationsFromMasterPayload = {
  __typename?: 'SyncVariationsFromMasterPayload';
  /** The master, so clients can refresh checksums in cache. */
  master: Design;
  results: Array<SyncVariationResult>;
  /**
   * Deprecated, always null — kept one release so a stale bundle's selection still validates.
   * @deprecated Always null: the Variations tab undo records family snapshots client-side and restores through restoreVariationsFamilyState. Removed after one release.
   */
  revertToken?: Maybe<Scalars['String']['output']>;
};

export type TagContainer = {
  __typename?: 'TagContainer';
  adTagProps?: Maybe<AdTagPropsType>;
  responsiveScaling: Scalars['Boolean']['output'];
  target: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
  useAsClickTag: Scalars['Boolean']['output'];
};

export type TagContainerEmbedsProgress = {
  __typename?: 'TagContainerEmbedsProgress';
  done: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TagContainerGenerateCodePayload = {
  __typename?: 'TagContainerGenerateCodePayload';
  code: Scalars['String']['output'];
};

export type TagContainerNetwork = {
  __typename?: 'TagContainerNetwork';
  id: Scalars['Int']['output'];
  syncStatus: AdTagSyncStatus;
};

export type TagContainerNetworksPayload = {
  __typename?: 'TagContainerNetworksPayload';
  embeds: TagContainerEmbedsProgress;
  networks: Array<TagContainerNetwork>;
};

export type TagContainerSyncStatus = {
  __typename?: 'TagContainerSyncStatus';
  active: Scalars['Boolean']['output'];
  embeds: EmbedsProgress;
  syncStatus: AdTagSyncStatus;
};

/** Target audience configuration (legacy audience analytics) */
export type TargetAudience = {
  __typename?: 'TargetAudience';
  /** Age range targeting */
  ageRange?: Maybe<AgeRange>;
  /** Primary gender target */
  gender: Scalars['String']['output'];
};

export type Tax = {
  __typename?: 'Tax';
  info?: Maybe<TaxInfo>;
  value: Scalars['Float']['output'];
};

export type TaxDetail = {
  __typename?: 'TaxDetail';
  rate?: Maybe<Scalars['Float']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
};

export type TaxInfo = {
  __typename?: 'TaxInfo';
  rate: Scalars['Float']['output'];
  region: Scalars['String']['output'];
  taxDetails: Array<TaxDetail>;
  type: Scalars['String']['output'];
};

/**
 * A team in Creatopy, representing a group of users working together.
 * Teams are the primary organizational unit for collaboration.
 */
export type Team = {
  __typename?: 'Team';
  /** When the team was created. */
  createdAt: Scalars['Date']['output'];
  customTransitions: Array<CustomTransitionPayload>;
  /** Whether debugging is enabled for this team. */
  debugEnabled: Scalars['Boolean']['output'];
  /** Whether the team is marked as favorite by the current user. */
  favourite: Scalars['Boolean']['output'];
  /** Whether the team has ever recorded ad impressions. */
  hasImpressions: Scalars['Boolean']['output'];
  /** Unique identifier for the team. */
  id: Scalars['Int']['output'];
  /** Users who have been invited to join the team. */
  invitees: Array<TeamUserInvitee>;
  /** Whether the current user is the owner of this team. */
  isOwner: Scalars['Boolean']['output'];
  /** Logo checksum for the team (if it has a logo). */
  logo?: Maybe<Scalars['String']['output']>;
  /** User groups within the team. */
  memberGroups: Array<TeamUserGroup>;
  /** Users who are members of the team. */
  members: Array<TeamUser>;
  /** Name of the team. */
  name: Scalars['String']['output'];
  /** User who created and owns the team. */
  owner: TeamUser;
  /** Permissions the current user has in this team. */
  permissions: TeamRolePermissions;
  /** Source of the team's pricing model. */
  pricingSource?: Maybe<Scalars['String']['output']>;
  /** Settings associated with the current user's role in the team. */
  roleSettings?: Maybe<RoleSettings>;
  /** SYSTEM / CUSTOM roles asociated with the team */
  roles: Array<TeamRole>;
  /** Settings and limits for the team. */
  settings: TeamSettings;
  /** Whether this is a test account. */
  testAccount: Scalars['Boolean']['output'];
  /** Total number of designs created in this team. */
  totalDesignsCreated: Scalars['Int']['output'];
};

/** Information about a team's account manager. */
export type TeamAccountManager = {
  __typename?: 'TeamAccountManager';
  /** Intercom admin ID for the account manager. */
  intercomAdminId: Scalars['Int']['output'];
  /** Name of the account manager. */
  name: Scalars['String']['output'];
  /** URL to the account manager's profile picture. */
  profilePicture?: Maybe<Scalars['String']['output']>;
};

export type TeamAdTags = {
  __typename?: 'TeamAdTags';
  active: Scalars['Int']['output'];
  inactive: Scalars['Int']['output'];
  /**
   * When the entitlement reconciler switched the team's serving off for having no live
   * subscription; null while the team serves (or was never switched off by it).
   */
  servingStoppedAt?: Maybe<Scalars['Date']['output']>;
  total: Scalars['Int']['output'];
};

/**
 * First-touch marketing attribution for a team — read from the owner's
 * user_attribution row with the team columns as fallback. All fields are null
 * for organic signups.
 */
export type TeamAttribution = {
  __typename?: 'TeamAttribution';
  /** GA4 client id captured from the payer's browser at checkout (null until a checkout). */
  gaClientId?: Maybe<Scalars['String']['output']>;
  /** Normalised OneTrust consent groups captured at checkout (e.g. C0001,C0002); null = never captured. */
  gaConsentGroups?: Maybe<Scalars['String']['output']>;
  /** GA4 session id captured at checkout; only meaningful right after that checkout. */
  gaSessionId?: Maybe<Scalars['String']['output']>;
  gclid?: Maybe<Scalars['String']['output']>;
  msclkid?: Maybe<Scalars['String']['output']>;
  /** Team owner id: the user server-side events for this team are sent as. */
  ownerId?: Maybe<Scalars['Int']['output']>;
  utmCampaign?: Maybe<Scalars['String']['output']>;
  utmMedium?: Maybe<Scalars['String']['output']>;
  utmSource?: Maybe<Scalars['String']['output']>;
};

export enum TeamBrandStatus {
  INVALID = 'INVALID',
  PENDING = 'PENDING',
  VALID = 'VALID'
}

/** API client credentials for a team. */
export type TeamClientId = {
  __typename?: 'TeamClientId';
  /** Client ID for authentication. */
  clientId: Scalars['String']['output'];
  /** Client secret for authentication. */
  clientSecret: Scalars['String']['output'];
  /** When the client was created. */
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** User who created the client. */
  createdByUser?: Maybe<ByUser>;
  /** ID of the client. */
  id: Scalars['Int']['output'];
  /** Name of the client. */
  name: Scalars['String']['output'];
  /** Scopes this token has access to. */
  scopes: Array<ApiTokenScope>;
};

export type TeamConsumptionReportPayload = {
  __typename?: 'TeamConsumptionReportPayload';
  breakdownByUsers: Array<UserConsumptionBreakdown>;
  monthlyBreakdown: Array<MonthlyConsumptionBreakdown>;
  totalTeamConsumption: Scalars['Int']['output'];
};

/** Response after creating a team. */
export type TeamCreatePayload = {
  __typename?: 'TeamCreatePayload';
  /** The newly created team. */
  team: Team;
};

export type TeamCreditsCombinedRow = {
  __typename?: 'TeamCreditsCombinedRow';
  exportCredits: Scalars['Int']['output'];
  newCredits: Scalars['Int']['output'];
  userEmail: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
  userName: Scalars['String']['output'];
};

export type TeamCreditsExportRow = {
  __typename?: 'TeamCreditsExportRow';
  credits: Scalars['Int']['output'];
  userEmail: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
  userName: Scalars['String']['output'];
};

export type TeamCreditsMonthlyRow = {
  __typename?: 'TeamCreditsMonthlyRow';
  exportCredits: Scalars['Int']['output'];
  month: Scalars['String']['output'];
  newCredits: Scalars['Int']['output'];
};

export type TeamCreditsReport = {
  __typename?: 'TeamCreditsReport';
  combinedRows: Array<TeamCreditsCombinedRow>;
  exportCreditsRows: Array<TeamCreditsExportRow>;
  monthlyRows: Array<TeamCreditsMonthlyRow>;
  newCreditsRows: Array<TeamCreditsRow>;
  planVersion: Scalars['Int']['output'];
  totalExportConsumption: Scalars['Int']['output'];
  totalNewCreditsConsumption: Scalars['Int']['output'];
};

export type TeamCreditsRow = {
  __typename?: 'TeamCreditsRow';
  credits: Scalars['Int']['output'];
  featureName: Scalars['String']['output'];
  featureType: Scalars['String']['output'];
  userEmail: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
  userName: Scalars['String']['output'];
};

/**
 * Current pre-v5 (legacy Redis counter) AI usage for a team. isLegacyCreditSystem is
 * false for v5/v6 teams (whose usage lives in the credit-transaction system), in which
 * case usedCredits/limitCredits are 0 and the admin UI hides the card.
 */
export type TeamCurrentAiUsage = {
  __typename?: 'TeamCurrentAiUsage';
  isLegacyCreditSystem: Scalars['Boolean']['output'];
  limitCredits: Scalars['Int']['output'];
  usedCredits: Scalars['Int']['output'];
};

/**
 * Current-billing-cycle AI/export consumption for a team, computed over the exact window and filters
 * the auto-restriction engine uses (so the admin number matches what drives restrictions). periodEnd
 * is the resolved cycle end, or trialEndsAt for an active trial.
 */
export type TeamCurrentPeriodUsage = {
  __typename?: 'TeamCurrentPeriodUsage';
  aiConsumedCredits: Scalars['Int']['output'];
  exportConsumedCredits: Scalars['Int']['output'];
  periodEnd: Scalars['Date']['output'];
  periodStart: Scalars['Date']['output'];
};

/** A team's design counter, echoed back after a reset so the caller can confirm it. */
export type TeamDesignCount = {
  __typename?: 'TeamDesignCount';
  teamId: Scalars['Int']['output'];
  totalDesignsCreated: Scalars['Int']['output'];
};

export type TeamDesignsMonthlyReport = {
  __typename?: 'TeamDesignsMonthlyReport';
  rows: Array<TeamDesignsMonthlyRow>;
};

export type TeamDesignsMonthlyRow = {
  __typename?: 'TeamDesignsMonthlyRow';
  count: Scalars['Int']['output'];
  month: Scalars['String']['output'];
};

/** A size the team creates designs at, with how many it created at it in the window. */
export type TeamFrequentlyUsedDesignSizeType = {
  __typename?: 'TeamFrequentlyUsedDesignSizeType';
  designSizeTypeId: Scalars['Int']['output'];
  /** Designs at this size created in the window; each size of a design set counts once. */
  designsCount: Scalars['Int']['output'];
};

/** Response containing just a team ID. */
export type TeamIdCreatePayload = {
  __typename?: 'TeamIdCreatePayload';
  /** ID of the team. */
  id: Scalars['Int']['output'];
};

export type TeamIdentityProvider = {
  __typename?: 'TeamIdentityProvider';
  alias?: Maybe<Scalars['String']['output']>;
  authorizationUrl?: Maybe<Scalars['String']['output']>;
  autoConfigUrl?: Maybe<Scalars['String']['output']>;
  /** PLA-463. Null means the user picks a brand kit at first login. */
  autoJoinBrandKitId?: Maybe<Scalars['Int']['output']>;
  /** PLA-463. Null means not configured — auto-join falls back to Light Editor. */
  autoJoinRoleId?: Maybe<Scalars['Int']['output']>;
  /** PLA-463. Doubles as the SSO auto-join switch. */
  automaticallyAddUsers?: Maybe<Scalars['Boolean']['output']>;
  backchannelSupported?: Maybe<Scalars['Boolean']['output']>;
  clientAssertionSigningAlg?: Maybe<Scalars['String']['output']>;
  clientAuthMethod?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  clientSecret?: Maybe<Scalars['String']['output']>;
  dashboardUrl?: Maybe<Scalars['String']['output']>;
  descriptorUrl?: Maybe<Scalars['String']['output']>;
  disableUserInfo?: Maybe<Scalars['Boolean']['output']>;
  domainVerificationHash: Scalars['String']['output'];
  domains?: Maybe<Array<TeamIdentityProviderDomain>>;
  entityIdUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  issuer?: Maybe<Scalars['String']['output']>;
  jwksUrl?: Maybe<Scalars['String']['output']>;
  logoutUrl?: Maybe<Scalars['String']['output']>;
  mappers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nameIDPolicyFormat?: Maybe<Scalars['String']['output']>;
  postBindingAuthnRequest?: Maybe<Scalars['Boolean']['output']>;
  postBindingLogout?: Maybe<Scalars['Boolean']['output']>;
  postBindingResponse?: Maybe<Scalars['Boolean']['output']>;
  principalAttribute?: Maybe<Scalars['String']['output']>;
  principalType?: Maybe<Scalars['String']['output']>;
  signInRedirectUrl?: Maybe<Scalars['String']['output']>;
  signOutRedirectUrl?: Maybe<Scalars['String']['output']>;
  signSpMetadata?: Maybe<Scalars['Boolean']['output']>;
  signatureAlgorithm?: Maybe<Scalars['String']['output']>;
  singleLogoutServiceUrl?: Maybe<Scalars['String']['output']>;
  singleSignOnServiceUrl?: Maybe<Scalars['String']['output']>;
  teamId: Scalars['Int']['output'];
  tokenUrl?: Maybe<Scalars['String']['output']>;
  type: ProviderType;
  useJwksUrl?: Maybe<Scalars['Boolean']['output']>;
  userInfoUrl?: Maybe<Scalars['String']['output']>;
  validateSignature?: Maybe<Scalars['Boolean']['output']>;
  validateSignatures?: Maybe<Scalars['Boolean']['output']>;
  verified: Scalars['Boolean']['output'];
  wantAssertionsEncrypted?: Maybe<Scalars['Boolean']['output']>;
  wantAssertionsSigned?: Maybe<Scalars['Boolean']['output']>;
  wantAuthnRequestsSigned?: Maybe<Scalars['Boolean']['output']>;
};

export type TeamIdentityProviderAlias = {
  __typename?: 'TeamIdentityProviderAlias';
  alias: Scalars['String']['output'];
};

export type TeamIdentityProviderAutoJoin = {
  __typename?: 'TeamIdentityProviderAutoJoin';
  autoJoinBrandKitId?: Maybe<Scalars['Int']['output']>;
  autoJoinRoleId?: Maybe<Scalars['Int']['output']>;
  enabled: Scalars['Boolean']['output'];
  teamId: Scalars['Int']['output'];
};

export type TeamIdentityProviderDomain = {
  __typename?: 'TeamIdentityProviderDomain';
  domainName: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
};

export type TeamIdentityProviderOption = {
  __typename?: 'TeamIdentityProviderOption';
  alias: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type TeamIdentityProviderUpdate = {
  __typename?: 'TeamIdentityProviderUpdate';
  authorizationUrl?: Maybe<Scalars['String']['output']>;
  autoConfigUrl?: Maybe<Scalars['String']['output']>;
  automaticallyAddUsers?: Maybe<Scalars['Boolean']['output']>;
  backchannelSupported?: Maybe<Scalars['Boolean']['output']>;
  clientAssertionSigningAlg?: Maybe<Scalars['String']['output']>;
  clientAuthMethod?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  clientSecret?: Maybe<Scalars['String']['output']>;
  disableUserInfo?: Maybe<Scalars['Boolean']['output']>;
  entityIdUrl?: Maybe<Scalars['String']['output']>;
  issuer?: Maybe<Scalars['String']['output']>;
  jwksUrl?: Maybe<Scalars['String']['output']>;
  logoutUrl?: Maybe<Scalars['String']['output']>;
  mappers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nameIDPolicyFormat?: Maybe<Scalars['String']['output']>;
  postBindingAuthnRequest?: Maybe<Scalars['Boolean']['output']>;
  postBindingLogout?: Maybe<Scalars['Boolean']['output']>;
  postBindingResponse?: Maybe<Scalars['Boolean']['output']>;
  principalAttribute?: Maybe<Scalars['String']['output']>;
  principalType?: Maybe<Scalars['String']['output']>;
  signInRedirectUrl?: Maybe<Scalars['String']['output']>;
  signOutRedirectUrl?: Maybe<Scalars['String']['output']>;
  signSpMetadata?: Maybe<Scalars['Boolean']['output']>;
  signatureAlgorithm?: Maybe<Scalars['String']['output']>;
  singleLogoutServiceUrl?: Maybe<Scalars['String']['output']>;
  singleSignOnServiceUrl?: Maybe<Scalars['String']['output']>;
  teamId: Scalars['Int']['output'];
  tokenUrl?: Maybe<Scalars['String']['output']>;
  useJwksUrl?: Maybe<Scalars['Boolean']['output']>;
  userInfoUrl?: Maybe<Scalars['String']['output']>;
  validateSignature?: Maybe<Scalars['Boolean']['output']>;
  validateSignatures?: Maybe<Scalars['Boolean']['output']>;
  wantAssertionsEncrypted?: Maybe<Scalars['Boolean']['output']>;
  wantAssertionsSigned?: Maybe<Scalars['Boolean']['output']>;
  wantAuthnRequestsSigned?: Maybe<Scalars['Boolean']['output']>;
};

export type TeamImpressionsBilling = {
  __typename?: 'TeamImpressionsBilling';
  /** How many months back a month's amount can be edited. */
  editableMonths: Scalars['Int']['output'];
  months: Array<TeamUsageMonth>;
  teamId: Scalars['Int']['output'];
  /** What the reporter would post next: all-time usage minus all-time billed, in whole thousands. */
  unbilledNow: Scalars['Int']['output'];
  usageRows: Array<TeamUsageRecord>;
};

export type TeamImpressionsMonthlyRow = {
  __typename?: 'TeamImpressionsMonthlyRow';
  count: Scalars['Int']['output'];
  month: Scalars['String']['output'];
};

export type TeamImpressionsReport = {
  __typename?: 'TeamImpressionsReport';
  rows: Array<TeamImpressionsMonthlyRow>;
};

export type TeamIntegration = {
  __typename?: 'TeamIntegration';
  email: Scalars['String']['output'];
  type: Integrations;
};

export type TeamIntegrationResult = {
  __typename?: 'TeamIntegrationResult';
  email: Scalars['String']['output'];
  type: Integrations;
};

/** Invitation from a team to a user. */
export type TeamInvitation = {
  __typename?: 'TeamInvitation';
  /** Email address the invitation was sent to. @BreakingBad */
  email?: Maybe<Scalars['String']['output']>;
  /** Unique hash for the invitation link. */
  hash: Scalars['String']['output'];
  /** Unique identifier of the invitation. */
  id: Scalars['Int']['output'];
  /** ID of the role the user will have when joining. */
  roleId: Scalars['Int']['output'];
  /** Information about the team that sent the invitation. */
  team: Team;
  /** ID of the team that sent the invitation. */
  teamId: Scalars['Int']['output'];
};

/**
 * Status of a team invitation.
 * Controls whether the invitation requires approval.
 */
export enum TeamInvitationStatus {
  /** Invitation has been approved. */
  APPROVED = 'APPROVED',
  /** Invitation is awaiting approval. */
  PENDING = 'PENDING'
}

export type TeamMetaIntegrationByTeamUserIdResult = {
  __typename?: 'TeamMetaIntegrationByTeamUserIdResult';
  accountId: Scalars['String']['output'];
  accountName: Scalars['String']['output'];
  apiKey: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type TeamMetaIntegrationResult = {
  __typename?: 'TeamMetaIntegrationResult';
  accountId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  selected: Scalars['Boolean']['output'];
};

export type TeamPaymentVariantPayload = {
  __typename?: 'TeamPaymentVariantPayload';
  variant?: Maybe<Variant>;
};

/**
 * Sources for team pricing models.
 * Determines which pricing system is used for the team.
 */
export enum TeamPricingSource {
  /** Alternative pricing model with 5% increase. */
  PLUS5 = 'PLUS5',
  /** Standard pricing model. */
  PRICING = 'PRICING'
}

export type TeamPricingSourcePayload = {
  __typename?: 'TeamPricingSourcePayload';
  result: Scalars['Boolean']['output'];
};

export type TeamRestrictionAllowance = {
  __typename?: 'TeamRestrictionAllowance';
  allowance: Scalars['Int']['output'];
  source: Scalars['String']['output'];
  thresholds: Array<TeamRestrictionThresholdRow>;
};

export type TeamRestrictionContext = {
  __typename?: 'TeamRestrictionContext';
  ai: TeamRestrictionAllowance;
  experiment: TeamRestrictionExperiment;
  export: TeamRestrictionAllowance;
  tier: Scalars['String']['output'];
};

export type TeamRestrictionExperiment = {
  __typename?: 'TeamRestrictionExperiment';
  gateOn: Scalars['Boolean']['output'];
  group?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
};

export type TeamRestrictionThresholdRow = {
  __typename?: 'TeamRestrictionThresholdRow';
  action: Scalars['String']['output'];
  multiplier: Scalars['Float']['output'];
  severity?: Maybe<Scalars['String']['output']>;
  value: Scalars['Int']['output'];
};

export type TeamRole = {
  __typename?: 'TeamRole';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** Map of permission flags set for the Team Role */
  permissions: TeamRolePermissions;
  roleSettings?: Maybe<RoleSettings>;
  teamId: Scalars['Int']['output'];
  /** SYSTEM roles are the same for all teams */
  type: Scalars['String']['output'];
  /** Team Members assigned to the Team Role */
  users: Array<TeamUser>;
};

export type TeamRolePermissions = {
  __typename?: 'TeamRolePermissions';
  approve: Scalars['Boolean']['output'];
  design: Scalars['Boolean']['output'];
  downloadAndPublish: Scalars['Boolean']['output'];
  manageBrands: Scalars['Boolean']['output'];
  manageFeed: Scalars['Boolean']['output'];
  manageProjects: Scalars['Boolean']['output'];
  manageTeam: Scalars['Boolean']['output'];
  publicApi: Scalars['Boolean']['output'];
  template: Scalars['Boolean']['output'];
  view: Scalars['Boolean']['output'];
};

export type TeamRoleTeamUser = {
  __typename?: 'TeamRoleTeamUser';
  teamRoleId: Scalars['Int']['output'];
  teamUserId: Scalars['Int']['output'];
};

/**
 * Settings and limits for a team.
 * These control the functionality available to the team.
 */
export type TeamSettings = {
  __typename?: 'TeamSettings';
  /** Whether the team was acquired through a reseller. */
  acquiredThroughReseller?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether the team has access to ad serving.
   *
   * Deprecated for READING - nothing selects it - but not dead: the admin
   * updateAdServingAccess mutation still writes this teamSettings property, so
   * the field cannot simply be deleted (follow-up item 5).
   * @deprecated Nothing reads this; the admin mutation still writes it
   */
  adServingAccess?: Maybe<Scalars['Boolean']['output']>;
  /** Whether Adobe AEM integration is enabled. */
  adobeAem?: Maybe<Scalars['Boolean']['output']>;
  /** Whether advanced CSS access is enabled. */
  advancedCssAccess?: Maybe<Scalars['Boolean']['output']>;
  /** Maximum number of AI credits allowed. */
  aiCreditsLimit?: Maybe<Scalars['Int']['output']>;
  /** When true, the team may create workspaces without a brand kit. */
  allowWorkspacesWithoutBrandKit?: Maybe<Scalars['Boolean']['output']>;
  /** Whether API Access is disabled. */
  apiAccessDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Maximum number of brand kits allowed. */
  brandKitsLimit?: Maybe<Scalars['Int']['output']>;
  /** Whether Branded Share Link is disabled. */
  brandedShareLinkDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether Bynder integration is enabled. */
  bynder?: Maybe<Scalars['Boolean']['output']>;
  /** Admin grant for Catalogs, off on every plan: true grants, false denies, null keeps the plan. */
  catalogs?: Maybe<Scalars['Boolean']['output']>;
  /** Whether staff switched Cloudinary on for the team (enableCloudinary). Off by default; the app offers Cloudinary to a team on its plan only with this on. */
  cloudinary?: Maybe<Scalars['Boolean']['output']>;
  /** Whether CMYK color support is enabled. */
  cmyk?: Maybe<Scalars['Boolean']['output']>;
  /** Whether design approval system is enabled. */
  designApprovalSystem?: Maybe<Scalars['Boolean']['output']>;
  /** Maximum height in pixels for designs. */
  designMaxHeight?: Maybe<Scalars['Int']['output']>;
  /** Maximum width in pixels for designs. */
  designMaxWidth?: Maybe<Scalars['Int']['output']>;
  /**
   * Disable Ad Studio Auto-save (deprecated).
   * @deprecated Use disableEditorAutoSave instead
   */
  disableAdStudioAutoSave?: Maybe<Scalars['Boolean']['output']>;
  /** When true, the light editor keeps a replaced image as is instead of removing its background automatically. */
  disableAutoBackgroundRemovalInLightEditor?: Maybe<Scalars['Boolean']['output']>;
  /** When true, hide Brand Kit in the light editor asset picker. */
  disableBrandKitInLightEditor?: Maybe<Scalars['Boolean']['output']>;
  /** Disable Editor Auto-save. */
  disableEditorAutoSave?: Maybe<Scalars['Boolean']['output']>;
  /** When true, the light editor shows a button that translates every text layer in the open design. */
  enableLightEditorTranslateAllTexts?: Maybe<Scalars['Boolean']['output']>;
  /** Whether two-factor authentication is enforced. */
  enforce2fa?: Maybe<Scalars['Boolean']['output']>;
  /** How SSO is enforced (OPTIONAL, ENFORCED, etc.). */
  enforceSso?: Maybe<Scalars['String']['output']>;
  /** Maximum number of export credits allowed. */
  exportCreditsLimit?: Maybe<Scalars['Int']['output']>;
  /** Admin override for feed-row batch publishing: true grants, false denies, null keeps the plan. */
  feedBatchPublish?: Maybe<Scalars['Boolean']['output']>;
  /** Whether real-time data feeds are enabled. */
  feedRealTimeData?: Maybe<Scalars['Boolean']['output']>;
  /** Whether Frontify integration is enabled. */
  frontify?: Maybe<Scalars['Boolean']['output']>;
  /** Frontify instance subdomain (e.g. mycompany for mycompany.frontify.com). When set, the Finder opens directly to this instance. */
  frontifyDomain?: Maybe<Scalars['String']['output']>;
  /** Maximum number of impressions allowed. */
  impressionsLimit?: Maybe<Scalars['Int']['output']>;
  /** Stable language-variation translator id (openai, deepl, anthropic, anthropic-opus). Defaults to deepl. */
  languageVariationTranslator?: Maybe<Scalars['String']['output']>;
  /** Maximum folder depth allowed (between 5-15, default: 5). */
  maxFolderDepth?: Maybe<Scalars['Int']['output']>;
  /** Whether Orange Logic integration is enabled. */
  orangeLogic?: Maybe<Scalars['Boolean']['output']>;
  /** Admin grant for the PDF/X print standards, off on every plan: true grants, false denies, null keeps the plan. */
  pdfStandards?: Maybe<Scalars['Boolean']['output']>;
  realTimeDataEnabledFeedTypes?: Maybe<Array<Maybe<FeedSourceType>>>;
  /** Whether SharePoint integration is enabled. */
  sharepoint?: Maybe<Scalars['Boolean']['output']>;
  /** Whether sticky ads access is enabled. */
  stickyAdsAccess?: Maybe<Scalars['Boolean']['output']>;
  /** Maximum number of content editors allowed. */
  teamContentEditorsLimit?: Maybe<Scalars['Int']['output']>;
  /** Maximum number of designers allowed. */
  teamDesignersLimit?: Maybe<Scalars['Int']['output']>;
  /** Maximum number of team users allowed. */
  teamUsersLimit?: Maybe<Scalars['Int']['output']>;
  /** Temporary enterprise access expiration (ISO date string). */
  temporaryEnterprise?: Maybe<Scalars['String']['output']>;
  /** When true, API exports use the app's download naming convention. */
  useAppFileNaming?: Maybe<Scalars['Boolean']['output']>;
  /** Whether Veeva integration is enabled. */
  veeva?: Maybe<Scalars['Boolean']['output']>;
  /** Whether white-label access is enabled. */
  whiteLabelAccess?: Maybe<Scalars['Boolean']['output']>;
  /** Whether white labeled integration property is enabled. */
  whiteLabeledIntegration?: Maybe<Scalars['Boolean']['output']>;
};

/** Input for managing two-factor authentication enforcement. */
export type TeamTwoFactor = {
  /** Whether to enforce two-factor authentication. */
  isEnforced: Scalars['Boolean']['input'];
  /** ID of the team to update. */
  teamId: Scalars['Int']['input'];
};

/** Information about two-factor authentication settings for a team. */
export type TeamTwoFactorPayload = {
  __typename?: 'TeamTwoFactorPayload';
  /** Name of the team. */
  teamName?: Maybe<Scalars['String']['output']>;
  /** Whether two-factor authentication is enforced for the team. */
  teamTwoFactorEnforce?: Maybe<Scalars['Boolean']['output']>;
  /** Whether two-factor authentication is enforced for the current user. */
  userTwoFactorEnforce?: Maybe<Scalars['Boolean']['output']>;
};

export type TeamTwoFactorResult = {
  __typename?: 'TeamTwoFactorResult';
  teamName: Scalars['String']['output'];
  teamTwoFactorEnforce: Scalars['Boolean']['output'];
  userTwoFactorEnforce: Scalars['Boolean']['output'];
};

export type TeamUsageMonth = {
  __typename?: 'TeamUsageMonth';
  amount: Scalars['Int']['output'];
  /** Whether the import has written a row for this month yet. */
  hasRow: Scalars['Boolean']['output'];
  lastEdit?: Maybe<TeamUsageRecordAction>;
  /** The calendar month, as YYYY-MM. */
  month: Scalars['String']['output'];
  /** The import wrote this month after the last admin edit, so the edit may have been overwritten. */
  overwrittenSinceEdit: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type TeamUsageRecord = {
  __typename?: 'TeamUsageRecord';
  amount: Scalars['Int']['output'];
  billedAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  lastAction?: Maybe<TeamUsageRecordAction>;
  lastError?: Maybe<Scalars['String']['output']>;
  lastErrorAt?: Maybe<Scalars['Date']['output']>;
  state: TeamUsageRecordState;
  updatedAt: Scalars['Date']['output'];
  usageId?: Maybe<Scalars['String']['output']>;
};

export type TeamUsageRecordAction = {
  __typename?: 'TeamUsageRecordAction';
  adminEmail: Scalars['String']['output'];
  at: Scalars['Date']['output'];
  billedAt?: Maybe<Scalars['Date']['output']>;
  invoiceReference?: Maybe<Scalars['String']['output']>;
  newAmount: Scalars['Int']['output'];
  note: Scalars['String']['output'];
  previousAmount: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export enum TeamUsageRecordState {
  BILLED = 'BILLED',
  /** Not yet posted to Recurly; the reporter retries it every run. */
  OPEN = 'OPEN',
  /** Posted to Recurly (has a usage id) and not yet billed. */
  POSTED = 'POSTED',
  /** Settled by an admin: counts as billed for the reporter, nothing is charged. */
  WRITTEN_OFF = 'WRITTEN_OFF'
}

/**
 * Public representation of a user in a team context.
 * Contains user information and permissions within the team.
 */
export type TeamUser = {
  __typename?: 'TeamUser';
  /** Email address of the user. */
  email: Scalars['String']['output'];
  /** Whether this is an API-only user (no UI access). */
  isAPIOnlyUser?: Maybe<Scalars['Boolean']['output']>;
  /** Full name of the user. */
  name: Scalars['String']['output'];
  /** Permissions granted to the user in the team. */
  permissions: TeamRolePermissions;
  /** URL to the user's profile picture. */
  profilePicture?: Maybe<Scalars['String']['output']>;
  /** Role name of the user in the team. */
  role: Scalars['String']['output'];
  /** ID of the team. */
  teamId: Scalars['Int']['output'];
  /** ID of the user's role in the team. */
  teamRoleId: Scalars['Int']['output'];
  /** URL to the user's profile or website. */
  url?: Maybe<Scalars['String']['output']>;
  /** ID of the user. */
  userId: Scalars['Int']['output'];
};

export type TeamUserDesignsReport = {
  __typename?: 'TeamUserDesignsReport';
  rows: Array<TeamUserDesignsRow>;
};

export type TeamUserDesignsRow = {
  __typename?: 'TeamUserDesignsRow';
  designCount: Scalars['Int']['output'];
  userEmail: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
  userName: Scalars['String']['output'];
};

/**
 * A group of users within a team.
 * Groups allow managing permissions for multiple users at once.
 */
export type TeamUserGroup = {
  __typename?: 'TeamUserGroup';
  /** Description of the group's purpose. */
  description?: Maybe<Scalars['String']['output']>;
  /** ID of the group. */
  id: Scalars['Int']['output'];
  /** Users who are members of this group. */
  members: Array<TeamUser>;
  /** Name of the group. */
  name: Scalars['String']['output'];
  /** ID of the team that owns the group. */
  teamId: Scalars['Int']['output'];
};

/** Information about a user invited to a team. */
export type TeamUserInvitee = {
  __typename?: 'TeamUserInvitee';
  /** When the invitation was created. */
  createdAt: Scalars['Date']['output'];
  /** Email address of the invited user. @BreakingBad */
  email?: Maybe<Scalars['String']['output']>;
  /** Unique hash used to build the accept-invitation link. */
  hash: Scalars['String']['output'];
  /** ID of the invitation. */
  id: Scalars['Int']['output'];
  /** User who sent the invitation. */
  inviter?: Maybe<TeamUser>;
  /** Whether this is a join request rather than an invitation. */
  joinRequest?: Maybe<Scalars['Boolean']['output']>;
  /** Resources the invited user will have access to. */
  properties: Properties;
  /** ID of the role assigned to the invited user. */
  roleId?: Maybe<Scalars['Int']['output']>;
  /** ID of the user who sent the invitation. */
  sentBy: Scalars['Int']['output'];
  /** Status of the invitation. */
  status: TeamInvitationStatus;
  /** ID of the team the user is invited to. */
  teamId: Scalars['Int']['output'];
};

/** Webhook configuration for a team. */
export type TeamWebhook = {
  __typename?: 'TeamWebhook';
  /** IDs of actions that trigger this webhook. */
  actions: Array<Scalars['Int']['output']>;
  /** When the webhook was created. */
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** User who created the webhook. */
  createdByUser?: Maybe<ByUser>;
  /** ID of the webhook. */
  id: Scalars['Int']['output'];
  /** Name of the webhook. */
  name: Scalars['String']['output'];
  /** URL to send webhook events to. */
  webhookUrl: Scalars['String']['output'];
};

/** Action configured for a webhook. */
export type TeamWebhookAction = {
  __typename?: 'TeamWebhookAction';
  /** ID of the action. */
  actionId: Scalars['Int']['output'];
  /** When the action was created. */
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** User who created the action. */
  createdByUser?: Maybe<ByUser>;
};

/** Type of action that can trigger a webhook. */
export type TeamWebhookActionType = {
  __typename?: 'TeamWebhookActionType';
  /** Configuration for the action. */
  config?: Maybe<Scalars['JSON']['output']>;
  /** When the action type was created. */
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** User who created the action type. */
  createdByUser?: Maybe<ByUser>;
  /** Description of what the action does. */
  description: Scalars['String']['output'];
  /** ID of the action type. */
  id: Scalars['Int']['output'];
  /** Name of the action type. */
  name: Scalars['String']['output'];
};

/** Data about a webhook configuration. */
export type TeamWebhookData = {
  __typename?: 'TeamWebhookData';
  /** Actions that trigger this webhook. */
  actions: Array<Maybe<TeamWebhookAction>>;
  /** Name of the webhook. */
  name: Scalars['String']['output'];
  /** URL to send webhook events to. */
  url: Scalars['String']['output'];
};

/** Team information matched by user's email domain. */
export type TeamsByUserDomain = {
  __typename?: 'TeamsByUserDomain';
  /** Unique identifier of the team. */
  id: Scalars['Int']['output'];
  /** Logo URL of the team. */
  logo?: Maybe<Scalars['String']['output']>;
  /** Name of the team. */
  name: Scalars['String']['output'];
  /** Number of members in the team. */
  totalMembers: Scalars['Int']['output'];
};

/**
 * Basic template information.
 * Simplified representation of a template.
 */
export type Template = {
  __typename?: 'Template';
  /** Unique hash identifier for the template. */
  hash: Scalars['String']['output'];
  /** Height of the template in pixels. */
  height: Scalars['Int']['output'];
  /** Width of the template in pixels. */
  width: Scalars['Int']['output'];
};

/**
 * Template category with associated templates.
 * Used for grouping templates by category.
 */
export type TemplateCategory = {
  __typename?: 'TemplateCategory';
  /** Category ID. */
  category: Scalars['Int']['output'];
  /** Unique hash identifier for the category. */
  hash: Scalars['String']['output'];
  /** Unique ID for the category. */
  id: Scalars['Int']['output'];
  /** Display name of the category. */
  name: Scalars['String']['output'];
  /** Tags associated with the category. */
  tags: Array<Scalars['String']['output']>;
  /** Templates in this category. */
  templates: Array<Template>;
};

/**
 * Color information for a template.
 * Represents dominant colors used in the template.
 */
export type TemplateColorPayload = {
  __typename?: 'TemplateColorPayload';
  /** Percentage area this color covers in the template. */
  area: Scalars['Float']['output'];
  /** Hex code of the color (e.g., '#FF5500'). */
  hexCode: Scalars['String']['output'];
};

/** Filter information for a template design. */
export type TemplateDesignFilterPayload = {
  __typename?: 'TemplateDesignFilterPayload';
  /** IDs of categories associated with the template. */
  categoryIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** ID of the design size type. */
  designSizeTypeId?: Maybe<Scalars['Int']['output']>;
  /** IDs of tags associated with the template. */
  tagIds?: Maybe<Array<Scalars['Int']['output']>>;
};

/** Information about a template design. */
export type TemplateDesignPayload = {
  __typename?: 'TemplateDesignPayload';
  /** Type of design size. */
  designSizeType: Scalars['String']['output'];
  /** Filter information for the template. */
  filter: TemplateDesignFilterPayload;
  /** Height of the design. */
  height?: Maybe<Scalars['Int']['output']>;
  /** Name of the template. */
  name: Scalars['String']['output'];
  /** Number of designs in the set. */
  setDesignCount?: Maybe<Scalars['Int']['output']>;
  /** Hash of the design set (if applicable). */
  setHash?: Maybe<Scalars['String']['output']>;
  /** Width of the design. */
  width?: Maybe<Scalars['Int']['output']>;
};

export type TemplateProperties = {
  __typename?: 'TemplateProperties';
  animated?: Maybe<Scalars['Boolean']['output']>;
  audioCount?: Maybe<Scalars['Int']['output']>;
  buttonCount?: Maybe<Scalars['Int']['output']>;
  elements?: Maybe<Scalars['JSON']['output']>;
  fullImageBackground?: Maybe<Scalars['Boolean']['output']>;
  imageCount?: Maybe<Scalars['Int']['output']>;
  mainImageRatio?: Maybe<Scalars['Float']['output']>;
  shapeCount?: Maybe<Scalars['Int']['output']>;
  svgCount?: Maybe<Scalars['Int']['output']>;
  textCount?: Maybe<Scalars['Int']['output']>;
  useOnlyWithTransparentImage?: Maybe<Scalars['Boolean']['output']>;
  videoCount?: Maybe<Scalars['Int']['output']>;
  whiteLogo?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Filter information for template set designs.
 * Includes the filter criteria used for template sets.
 */
export type TemplateSetDesignsFilterPayload = {
  __typename?: 'TemplateSetDesignsFilterPayload';
  /** Category IDs used for filtering. */
  categoryIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** ID of the design size type used for filtering. */
  designSizeTypeId?: Maybe<Scalars['Int']['output']>;
  /** Tag IDs used for filtering. */
  tagIds?: Maybe<Array<Scalars['Int']['output']>>;
};

/**
 * Detailed information about a template set design.
 * Used for displaying template set details.
 */
export type TemplateSetDesignsPayload = {
  __typename?: 'TemplateSetDesignsPayload';
  /** Dominant colors used in the template. */
  colors?: Maybe<Array<TemplateColorPayload>>;
  /** Type of design size (e.g., 'Facebook Post'). */
  designSizeType: Scalars['String']['output'];
  /** Category of design size type (e.g., 'Social Media'). */
  designSizeTypeCategory: Scalars['String']['output'];
  /** Filter criteria used for this template set. */
  filter: TemplateSetDesignsFilterPayload;
  /** Whether the template contains animations. */
  hasAnimation: Scalars['Boolean']['output'];
  /** Whether the template contains video elements. */
  hasVideo: Scalars['Boolean']['output'];
  /** Unique hash identifier for the template. */
  hash: Scalars['String']['output'];
  /** Height of the template in pixels. @BreakingBad */
  height?: Maybe<Scalars['Float']['output']>;
  /** Measurement unit used (px, in, etc.). */
  measureUnit?: Maybe<Scalars['String']['output']>;
  /** Display name of the template set. */
  name: Scalars['String']['output'];
  /** Number of designs in this set. */
  setDesignCount?: Maybe<Scalars['Int']['output']>;
  /** Hash of the template set. */
  setHash?: Maybe<Scalars['String']['output']>;
  /** Size variations of this template set. */
  sizes: Array<TemplateWebsitePayload>;
  /** Width of the template in pixels. @BreakingBad */
  width?: Maybe<Scalars['Float']['output']>;
};

export type TemplateSize = {
  designSizeTypeName?: InputMaybe<Scalars['String']['input']>;
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

/**
 * Template type information.
 * Basic template metadata used in listings.
 */
export type TemplateType = {
  __typename?: 'TemplateType';
  /** Access type of the template (public, premium, etc.). */
  accessType: Scalars['String']['output'];
  /** Category ID of the template. */
  category: Scalars['Int']['output'];
  /** Unique hash identifier for the template. */
  hash: Scalars['String']['output'];
  /** Unique ID for the template. */
  id: Scalars['Int']['output'];
  /** Order position in listings. */
  listOrder?: Maybe<Scalars['Int']['output']>;
  /** Display name of the template. */
  name: Scalars['String']['output'];
  /** Tags associated with the template. */
  tags: Array<Scalars['String']['output']>;
};

/**
 * Template information for website display.
 * Detailed template information for the public website.
 */
export type TemplateWebsitePayload = {
  __typename?: 'TemplateWebsitePayload';
  /** Name of the design type. */
  designTypeName?: Maybe<Scalars['String']['output']>;
  /** Whether the template contains animations. */
  hasAnimation: Scalars['Boolean']['output'];
  /** Whether the template contains video elements. */
  hasVideo: Scalars['Boolean']['output'];
  /** Unique hash identifier for the template. */
  hash: Scalars['String']['output'];
  /** Height of the template in pixels. */
  height: Scalars['Float']['output'];
  /** Unique ID for the template. */
  id: Scalars['Int']['output'];
  /** Measurement unit used (px, in, etc.). */
  measureUnit?: Maybe<Scalars['String']['output']>;
  /** Display name of the template. */
  name: Scalars['String']['output'];
  /** Hash of the template set (for set templates). */
  setHash?: Maybe<Scalars['String']['output']>;
  /** Size variations of this template. */
  sizes?: Maybe<Array<Maybe<TemplateWebsiteSizePayload>>>;
  /** Width of the template in pixels. */
  width: Scalars['Float']['output'];
};

/**
 * Template information for sitemap generation.
 * Simplified template data for XML sitemaps.
 */
export type TemplateWebsiteSitemapPayload = {
  __typename?: 'TemplateWebsiteSitemapPayload';
  /** Unique hash identifier for the template. */
  hash: Scalars['String']['output'];
  /** Display name of the template. */
  name: Scalars['String']['output'];
  /** Set sizes available for this template. */
  setSizes: Array<TemplateWebsiteSitemapSetSizePayload>;
};

/**
 * Size variation for sitemap template listings.
 * Used to list size options for sitemap generation.
 */
export type TemplateWebsiteSitemapSetSizePayload = {
  __typename?: 'TemplateWebsiteSitemapSetSizePayload';
  /** Unique hash identifier for this size variation. */
  hash: Scalars['String']['output'];
  /** Display name of this size variation. */
  name: Scalars['String']['output'];
};

/**
 * Size variation of a template for the website.
 * Used for responsive templates with multiple sizes.
 */
export type TemplateWebsiteSizePayload = {
  __typename?: 'TemplateWebsiteSizePayload';
  /** ID of the design size type for this variation. */
  designSizeTypeId?: Maybe<Scalars['Int']['output']>;
  /** Unique hash identifier for this size variation. */
  hash: Scalars['String']['output'];
  /** Height of the template size in pixels. */
  height: Scalars['Float']['output'];
  /** Width of the template size in pixels. */
  width: Scalars['Float']['output'];
};

/** Count of templates by type (static, animated, video). */
export type TemplatesTypeCount = {
  __typename?: 'TemplatesTypeCount';
  /** Number of animated templates. */
  animated: Scalars['Int']['output'];
  /** Number of static templates. */
  static: Scalars['Int']['output'];
  /** Number of video templates. */
  video: Scalars['Int']['output'];
};

/** Fields by which website templates can be ordered. */
export enum TemplatesWebsiteOrderByFields {
  /** Order by creation date */
  CREATED_AT = 'CREATED_AT',
  /** Order by design ID */
  DESIGN_ID = 'DESIGN_ID'
}

/**
 * Response payload for website templates query.
 * Includes pagination and templates.
 */
export type TemplatesWebsitePayload = {
  __typename?: 'TemplatesWebsitePayload';
  /** Pagination information. */
  pageInfo: PageInfo;
  /** List of templates matching the query criteria. */
  templates: Array<TemplateWebsitePayload>;
  /** Total count of templates matching the criteria. */
  totalCount: Scalars['Int']['output'];
};

/** Response payload for website sitemap templates query. */
export type TemplatesWebsiteSitemapPayload = {
  __typename?: 'TemplatesWebsiteSitemapPayload';
  /** List of templates for sitemap generation. */
  templates: Array<TemplateWebsiteSitemapPayload>;
};

export type TemporaryEnterprisePayload = {
  __typename?: 'TemporaryEnterprisePayload';
  acceptedAt?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  declined?: Maybe<Scalars['Boolean']['output']>;
  endedAt?: Maybe<Scalars['Date']['output']>;
  revoked?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** Text content analysis with examples */
export type TextContent = {
  __typename?: 'TextContent';
  /** List of ads that use this text */
  adIds: Array<AdReference>;
  /** Number of times this text appears */
  count: Scalars['Int']['output'];
  /** Whether this text is a CTA */
  noCTA: Scalars['Boolean']['output'];
  /** Percentage of total ads using this text */
  percent: Scalars['Float']['output'];
  /** The text content */
  text: Scalars['String']['output'];
};

export type TextExtractionResult = {
  __typename?: 'TextExtractionResult';
  texts: Array<Scalars['String']['output']>;
};

/** Theme analysis statistics */
export type ThemeStats = {
  __typename?: 'ThemeStats';
  /** Frequency of this theme */
  frequency: Scalars['Int']['output'];
  /** Percentage of total content using this theme */
  percentage: Scalars['Float']['output'];
  /** Theme identifier */
  theme: Scalars['String']['output'];
};

/** A message in a chat thread */
export type ThreadMessage = {
  __typename?: 'ThreadMessage';
  /** Message content */
  content: Scalars['String']['output'];
  /** ISO timestamp when message was created */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Message ID */
  id?: Maybe<Scalars['String']['output']>;
  /** Role: user or assistant */
  role: Scalars['String']['output'];
};

export type ThreadUpdatedResult = {
  __typename?: 'ThreadUpdatedResult';
  thread: CommentThread;
};

export type ThreeDSecurePayload = {
  __typename?: 'ThreeDSecurePayload';
  threeDSecureActionTokenId: Scalars['String']['output'];
};

export type ThresholdAddonsUsageRedis = {
  __typename?: 'ThresholdAddonsUsageRedis';
  credits?: Maybe<Scalars['Int']['output']>;
  impressions?: Maybe<Scalars['Int']['output']>;
};

export type Tier = {
  __typename?: 'Tier';
  currencies: Array<Currency>;
  endingQuantity: Scalars['Int']['output'];
};

export type TierPrice = {
  __typename?: 'TierPrice';
  currency: Scalars['String']['output'];
  endingQuantity: Scalars['Int']['output'];
  unitAmount: Scalars['Float']['output'];
};

export type TikTokAdGroup = {
  __typename?: 'TikTokAdGroup';
  adgroupId: Scalars['String']['output'];
  adgroupName: Scalars['String']['output'];
  campaignId: Scalars['String']['output'];
};

export type TikTokAdGroupSettingsInput = {
  adGroupName: Scalars['String']['input'];
  /** Cost-cap amount (USD) for bid_price-billed goals (CPC/CPM/CPV). Required when bidType=CUSTOM with those goals. */
  bidPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Bid strategy (default NO_BID = maximum delivery). CUSTOM (cost cap) requires the amount field matching the resolved goal's billing event. TikTok requires all ad groups of one CBO campaign to share the same bid type. */
  bidType?: InputMaybe<TikTokBidType>;
  budget: Scalars['Float']['input'];
  budgetMode: Scalars['String']['input'];
  /** Cost-cap amount (USD) for OCPM-billed goals (conversion_bid_price) — i.e. TRAFFIC_LANDING_PAGE_VIEW. Required when bidType=CUSTOM with an OCPM goal. */
  conversionBidPrice?: InputMaybe<Scalars['Float']['input']>;
  /** REACH-only frequency cap: show ads to a person no more than 'frequency' times every 'frequencySchedule' days (defaults 1 / 7). Ignored for goals without a frequency cap. */
  frequency?: InputMaybe<Scalars['Int']['input']>;
  frequencySchedule?: InputMaybe<Scalars['Int']['input']>;
  /** The pixel event to optimize for (TikTok optimization_event, e.g. ON_WEB_ORDER). Required with pixelId for pixel-gated goals; ignored otherwise. */
  optimizationEvent?: InputMaybe<Scalars['String']['input']>;
  /** Optional optimization goal from the objective's allowed set (else the objective default). billing_event is derived from the goal at publish time, never sent by the caller. */
  optimizationGoal?: InputMaybe<Scalars['String']['input']>;
  /** Data connection for pixel-gated goals (WEB_CONVERSIONS CONVERT): the tracking pixel the ad group optimizes against. Required with optimizationEvent for those goals; ignored otherwise. */
  pixelId?: InputMaybe<Scalars['String']['input']>;
  /** default PLACEMENT_TYPE_NORMAL */
  placementType?: InputMaybe<Scalars['String']['input']>;
  /** default placements: PLACEMENT_TIKTOK */
  placements?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduleEndTime?: InputMaybe<Scalars['String']['input']>;
  scheduleStartTime?: InputMaybe<Scalars['String']['input']>;
  /** Status the ad group is created with. Defaults to PAUSED (safe) — flip to ACTIVE to deliver immediately. */
  status?: InputMaybe<TikTokEntityStatus>;
  targeting?: InputMaybe<TikTokTargetingInput>;
};

export type TikTokAdGroupsInput = {
  advertiserId: Scalars['String']['input'];
  campaignId: Scalars['String']['input'];
  integrationId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type TikTokAdSettingsInput = {
  adName: Scalars['String']['input'];
  adText: Scalars['String']['input'];
  callToAction: TikTokCallToAction;
  /** Optional third-party (MMP) click tracking URL applied to the ad creative. */
  clickTrackingUrl?: InputMaybe<Scalars['String']['input']>;
  /** Optional third-party (MMP) impression tracking URL applied to the ad creative. */
  impressionTrackingUrl?: InputMaybe<Scalars['String']['input']>;
  landingPageUrl: Scalars['String']['input'];
};

export type TikTokAdvertiser = {
  __typename?: 'TikTokAdvertiser';
  advertiserId: Scalars['String']['output'];
  advertiserName: Scalars['String']['output'];
};

export type TikTokAdvertisersInput = {
  integrationId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

/** Ad-group bid strategy — maps to TikTok bid_type. NO_BID (default) = maximum delivery (lowest cost); CUSTOM = cost cap, requiring the amount field that matches the goal's billing event. */
export enum TikTokBidType {
  CUSTOM = 'CUSTOM',
  NO_BID = 'NO_BID'
}

/** A Business Center a catalog can be created in. source says where its id was learned: the token's own list (business_center), an identity linked through it (identity), or the ad account that belongs to it (advertiser), whose name is then the ad account's. */
export type TikTokBusinessCenter = {
  __typename?: 'TikTokBusinessCenter';
  bcId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  source: Scalars['String']['output'];
};

export type TikTokBusinessCentersInput = {
  /** The advertiser whose linked identities name Business Centers when the app cannot list them itself. */
  advertiserId: Scalars['String']['input'];
  integrationId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

/** Ad creative call-to-action — TikTok's general call_to_action values valid for the Reach/Traffic/Video-views objectives (VIEW_PROFILE is ENGAGEMENT-only and R&F/LIVE/effect-only values are omitted; added with their objectives later). CHECK_AVAILABLILITY is TikTok's historic typo kept for input compatibility; the live API now accepts only the corrected CHECK_AVAILABILITY, which the worker maps to at send time. */
export enum TikTokCallToAction {
  APPLY_NOW = 'APPLY_NOW',
  BOOK_NOW = 'BOOK_NOW',
  CALL_NOW = 'CALL_NOW',
  CHECK_AVAILABLILITY = 'CHECK_AVAILABLILITY',
  CONTACT_US = 'CONTACT_US',
  DOWNLOAD_NOW = 'DOWNLOAD_NOW',
  EXPERIENCE_NOW = 'EXPERIENCE_NOW',
  GET_QUOTE = 'GET_QUOTE',
  GET_SHOWTIMES = 'GET_SHOWTIMES',
  GET_TICKETS_NOW = 'GET_TICKETS_NOW',
  INSTALL_NOW = 'INSTALL_NOW',
  INTERESTED = 'INTERESTED',
  LEARN_MORE = 'LEARN_MORE',
  LISTEN_NOW = 'LISTEN_NOW',
  ORDER_NOW = 'ORDER_NOW',
  PLAY_GAME = 'PLAY_GAME',
  PREORDER_NOW = 'PREORDER_NOW',
  READ_MORE = 'READ_MORE',
  SEND_MESSAGE = 'SEND_MESSAGE',
  SHOP_NOW = 'SHOP_NOW',
  SIGN_UP = 'SIGN_UP',
  SUBSCRIBE = 'SUBSCRIBE',
  VIEW_NOW = 'VIEW_NOW',
  VISIT_STORE = 'VISIT_STORE',
  WATCH_NOW = 'WATCH_NOW'
}

export type TikTokCampaign = {
  __typename?: 'TikTokCampaign';
  /** BUDGET_MODE_INFINITE | BUDGET_MODE_DAY | BUDGET_MODE_TOTAL — a daily cap (without CBO) allows only daily ad-group budgets, on reuse too. Null when TikTok returned none. */
  budgetMode?: Maybe<Scalars['String']['output']>;
  /** Campaign budget optimization on — its ad groups are not bound to the campaign's budget mode. */
  budgetOptimizeOn?: Maybe<Scalars['Boolean']['output']>;
  campaignId: Scalars['String']['output'];
  campaignName: Scalars['String']['output'];
  objectiveType: Scalars['String']['output'];
};

export type TikTokCampaignSettingsInput = {
  budget?: InputMaybe<Scalars['Float']['input']>;
  /** e.g. BUDGET_MODE_INFINITE | BUDGET_MODE_DAY | BUDGET_MODE_TOTAL */
  budgetMode: Scalars['String']['input'];
  /** Campaign Budget Optimization: distribute the campaign budget across ad groups (which omit their own budget). */
  budgetOptimizeOn?: InputMaybe<Scalars['Boolean']['input']>;
  campaignName: Scalars['String']['input'];
  objectiveType: TikTokObjectiveType;
  /** Status the campaign is created with. Defaults to PAUSED (safe) — flip to ACTIVE to deliver immediately. */
  status?: InputMaybe<TikTokEntityStatus>;
};

export type TikTokCampaignsInput = {
  advertiserId: Scalars['String']['input'];
  integrationId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

/** A product catalog of a Business Center; region and currency are its immutable configuration. */
export type TikTokCatalog = {
  __typename?: 'TikTokCatalog';
  catalogId: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  regionCode?: Maybe<Scalars['String']['output']>;
};

/** A region a catalog may be created in, with the currency TikTok pairs it with when known. */
export type TikTokCatalogRegion = {
  __typename?: 'TikTokCatalogRegion';
  currency?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  regionCode: Scalars['String']['output'];
};

export type TikTokCatalogRegionsInput = {
  businessCenterId: Scalars['String']['input'];
  integrationId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type TikTokCatalogsInput = {
  businessCenterId: Scalars['String']['input'];
  integrationId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

/** How the ad's creatives are structured. SEPARATE (default): one SINGLE_VIDEO ad per size. OPTIMIZED: one Smart Creative ad holding all size videos — only when creating a new ad group with a Smart-Creative-eligible objective. */
export enum TikTokCreativeMode {
  OPTIMIZED = 'OPTIMIZED',
  SEPARATE = 'SEPARATE'
}

/** Status a created entity starts in — maps to TikTok operation_status (ACTIVE=ENABLE, PAUSED=DISABLE). */
export enum TikTokEntityStatus {
  ACTIVE = 'ACTIVE',
  PAUSED = 'PAUSED'
}

export type TikTokFeedFieldsValidationInput = {
  designHash: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

/**
 * What a TikTok catalog publish of the design's attached feed would run into, checked before the
 * publish (the TikTok counterpart of FeedFieldsValidationPayload): required columns the feed lacks
 * (missingFields) or leaves blank on some rows (emptyValueFields), repeated ids, and fields in a
 * shape TikTok's ingest refuses (wrongFormatFields). Field names are TikTok's (sku_id, price...).
 */
export type TikTokFeedFieldsValidationPayload = {
  __typename?: 'TikTokFeedFieldsValidationPayload';
  emptyValueFields: Array<Scalars['String']['output']>;
  hasDuplicatedIds: Scalars['Boolean']['output'];
  missingFields: Array<Scalars['String']['output']>;
  wrongFormatFields: Array<Scalars['String']['output']>;
};

export type TikTokIdentitiesInput = {
  advertiserId: Scalars['String']['input'];
  integrationId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type TikTokIdentity = {
  __typename?: 'TikTokIdentity';
  displayName: Scalars['String']['output'];
  identityId: Scalars['String']['output'];
  identityType: Scalars['String']['output'];
  profileImage?: Maybe<Scalars['String']['output']>;
};

export enum TikTokObjectiveType {
  REACH = 'REACH',
  TRAFFIC = 'TRAFFIC',
  VIDEO_VIEWS = 'VIDEO_VIEWS',
  /** Sales — CONVERT (pixel-gated) or CLICK goals; adgroup/create requires pixelId + optimizationEvent for CONVERT. */
  WEB_CONVERSIONS = 'WEB_CONVERSIONS'
}

/** A tracking pixel of the advertiser (/pixel/list/). Consumed by the Sales objective: adgroup/create REQUIRES pixelId + optimizationEvent for the pixel-gated WEB_CONVERSIONS CONVERT goal (and rejects pixel_id under TRAFFIC) — both live-verified. */
export type TikTokPixel = {
  __typename?: 'TikTokPixel';
  /** TikTok omits the code on some pixels — nullable. */
  pixelCode?: Maybe<Scalars['String']['output']>;
  pixelId: Scalars['String']['output'];
  pixelName: Scalars['String']['output'];
};

export type TikTokPixelsInput = {
  advertiserId: Scalars['String']['input'];
  integrationId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type TikTokRegion = {
  __typename?: 'TikTokRegion';
  level?: Maybe<Scalars['String']['output']>;
  locationId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  regionType?: Maybe<Scalars['String']['output']>;
};

export type TikTokRegionsInput = {
  advertiserId: Scalars['String']['input'];
  integrationId: Scalars['Int']['input'];
  /** Regions are scoped to the campaign objective + placements, so the objective is required. */
  objectiveType: TikTokObjectiveType;
  placements?: InputMaybe<Array<Scalars['String']['input']>>;
  teamId: Scalars['Int']['input'];
};

export type TikTokTargetingInput = {
  ageGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  genders?: InputMaybe<Array<Scalars['String']['input']>>;
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TopUseCasesResponse = {
  __typename?: 'TopUseCasesResponse';
  topUseCases: Array<Scalars['String']['output']>;
};

/**
 * Tracing context for distributed tracing.
 * Used for performance monitoring and debugging.
 */
export type TraceContext = {
  /** W3C Trace Context parent identifier. */
  traceparent?: InputMaybe<Scalars['String']['input']>;
  /** W3C Trace Context state. */
  tracestate?: InputMaybe<Scalars['String']['input']>;
};

export type TrackAccountPropertiesInput = {
  gclid?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

export type Transaction = {
  __typename?: 'Transaction';
  amount?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invoice?: Maybe<TransactionInvoice>;
};

export type TransactionInvoice = {
  __typename?: 'TransactionInvoice';
  id?: Maybe<Scalars['String']['output']>;
};

export type TranslateFeed = {
  __typename?: 'TranslateFeed';
  status: FeedStatus;
};

export type TranslateLightEditorCopyPayload = {
  __typename?: 'TranslateLightEditorCopyPayload';
  updates: Array<TranslateLightEditorLayerUpdate>;
};

export type TranslateLightEditorLayerUpdate = {
  __typename?: 'TranslateLightEditorLayerUpdate';
  /** Size this patch was built for. The client writes it only there. */
  designId: Scalars['Int']['output'];
  /** Element key (bannersetElementId, falling back to id). */
  layerId: Scalars['Int']['output'];
  /** Layer properties to write: slate config, and buttonLabel for buttons. */
  properties: Scalars['JSON']['output'];
};

export type TranslationCompareCandidateScore = {
  __typename?: 'TranslationCompareCandidateScore';
  dimensions: Array<TranslationCompareDimension>;
  findings: Array<TranslationCompareFinding>;
  inputFingerprint: Scalars['String']['output'];
  judgeModelId: Scalars['String']['output'];
  overallScore?: Maybe<Scalars['Float']['output']>;
  /** Base64 PNG of the design with this candidate's translations applied. Null when render failed. */
  previewImageBase64?: Maybe<Scalars['String']['output']>;
  promptHash: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
  /** Translated strings for this candidate, keyed by layerKey. */
  translations: Array<TranslationCompareLayerTranslation>;
  translatorId: Scalars['String']['output'];
  verdict: TranslationCompareVerdict;
};

export type TranslationCompareDimension = {
  __typename?: 'TranslationCompareDimension';
  category: Scalars['String']['output'];
  findings: Array<TranslationCompareFinding>;
  id: Scalars['String']['output'];
  /** 0-10, or null when the dimension did not apply. */
  score?: Maybe<Scalars['Float']['output']>;
  title: Scalars['String']['output'];
  weight: Scalars['Float']['output'];
};

export type TranslationCompareFinding = {
  __typename?: 'TranslationCompareFinding';
  description: Scalars['String']['output'];
  dimensionId: Scalars['String']['output'];
  layerKey?: Maybe<Scalars['String']['output']>;
  severity: TranslationCompareSeverity;
  type: Scalars['String']['output'];
};

export type TranslationCompareJudgeOption = {
  __typename?: 'TranslationCompareJudgeOption';
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
};

export type TranslationCompareLayerTranslation = {
  __typename?: 'TranslationCompareLayerTranslation';
  layerKey: Scalars['String']['output'];
  translatedText: Scalars['String']['output'];
};

export type TranslationCompareResult = {
  __typename?: 'TranslationCompareResult';
  bestTranslatorId?: Maybe<Scalars['String']['output']>;
  candidates: Array<TranslationCompareCandidateScore>;
  inputFingerprint: Scalars['String']['output'];
  judgeModelId: Scalars['String']['output'];
  layerCount: Scalars['Int']['output'];
  promptHash: Scalars['String']['output'];
  sourceLang: Scalars['String']['output'];
  /** Source layers used for the compare (shared across candidates). */
  sourceLayers: Array<TranslationCompareSourceLayer>;
  targetLang: Scalars['String']['output'];
};

export enum TranslationCompareSeverity {
  CRITICAL = 'CRITICAL',
  MAJOR = 'MAJOR',
  MINOR = 'MINOR'
}

export type TranslationCompareSourceLayer = {
  __typename?: 'TranslationCompareSourceLayer';
  layerKey: Scalars['String']['output'];
  layerRole?: Maybe<Scalars['String']['output']>;
  sourceText: Scalars['String']['output'];
};

export type TranslationCompareTranslatorOption = {
  __typename?: 'TranslationCompareTranslatorOption';
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
};

export enum TranslationCompareVerdict {
  BORDERLINE = 'BORDERLINE',
  FAIL = 'FAIL',
  PASS = 'PASS'
}

/** Transparency and spend information for an ad */
export type TransparencyInfo = {
  __typename?: 'TransparencyInfo';
  /** Additional page information */
  pageInfo?: Maybe<TransparencyPageInfo>;
  /** Spending information for the page */
  pageSpend?: Maybe<PageSpend>;
  /** Transparency information by location */
  transparencyByLocation?: Maybe<Scalars['String']['output']>;
  /** Verified voice context information */
  verifiedVoiceContext?: Maybe<Scalars['String']['output']>;
};

/** Additional transparency information about the page */
export type TransparencyPageInfo = {
  __typename?: 'TransparencyPageInfo';
  /** Type of entity (page, profile, etc.) */
  entityType: Scalars['String']['output'];
  /** Number of Facebook followers */
  fbFollowers: Scalars['Int']['output'];
  /** Number of Instagram followers */
  igFollowers: Scalars['Int']['output'];
  /** Instagram username */
  igUsername: Scalars['String']['output'];
  /** Whether Instagram account is verified */
  igVerification: Scalars['Boolean']['output'];
  /** Whether this is a profile page */
  isProfilePage: Scalars['Boolean']['output'];
  /** Page alias/username */
  pageAlias: Scalars['String']['output'];
  /** Page category */
  pageCategory: Scalars['String']['output'];
  /** Cover photo URL */
  pageCoverPhoto: Scalars['String']['output'];
  /** Facebook page ID */
  pageId: Scalars['String']['output'];
  /** Whether the page is deleted */
  pageIsDeleted: Scalars['Boolean']['output'];
  /** Whether the page is restricted */
  pageIsRestricted: Scalars['Boolean']['output'];
  /** Page name */
  pageName: Scalars['String']['output'];
  /** Profile URI */
  pageProfileUri: Scalars['String']['output'];
  /** Page verification status */
  pageVerification: Scalars['String']['output'];
  /** Profile photo URL */
  profilePhoto: Scalars['String']['output'];
};

/**
 * Represents an item in the team's trash that can be restored or permanently deleted.
 * Items are stored in trash for 30 days before automatic permanent deletion.
 */
export type TrashItem = {
  __typename?: 'TrashItem';
  /** ID of the brand kit this item was associated with. */
  brandKitId?: Maybe<Scalars['Int']['output']>;
  /** Color associated with the item. */
  color?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the item was moved to trash. */
  deletedAt: Scalars['Date']['output'];
  /** Type of design (for items where type is 'design'). */
  designType?: Maybe<DesignType>;
  /** For design sets, indicates the number of designs in the set. */
  designsCount?: Maybe<Scalars['Int']['output']>;
  /** Hash value of the design for URL reference. */
  hash?: Maybe<Scalars['String']['output']>;
  /** Height of the design in pixels or other units. */
  height?: Maybe<Scalars['Float']['output']>;
  /** Unique identifier for the trash item. */
  id: Scalars['Int']['output'];
  /** Location path where the item was stored before deletion. */
  location: Scalars['String']['output'];
  /** URL or reference to the item's logo. */
  logo?: Maybe<Scalars['String']['output']>;
  /** Unit of measurement for the item dimensions (px, cm, etc.). */
  measureUnit?: Maybe<MeasureUnit>;
  /** Name of the deleted item. */
  name: Scalars['String']['output'];
  /**
   * Boolean indicating if the item's parent is also deleted.
   * Used to determine if the item can be restored to its original location.
   */
  parentDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** Name of the parent item (folder or project) if available. */
  parentName?: Maybe<Scalars['String']['output']>;
  /** ID of the project this item belonged to. */
  projectId?: Maybe<Scalars['Int']['output']>;
  /** Size of the item in a human-readable format (e.g., '200 x 200 px'). */
  size?: Maybe<Scalars['String']['output']>;
  /** Boolean indicating if the item is a template. */
  template?: Maybe<Scalars['Boolean']['output']>;
  /** Thumbnail reference for the item. */
  thumb?: Maybe<Scalars['String']['output']>;
  /** The category of the deleted item (project, folder, design, or abTest). */
  type: TrashItemType;
  /** Width of the design in pixels or other units. */
  width?: Maybe<Scalars['Float']['output']>;
};

/**
 * Represents an item ID with information about whether its parent is also deleted.
 * Used when restoring items to determine proper restoration hierarchy.
 */
export type TrashItemIdWithParentDeleted = {
  __typename?: 'TrashItemIdWithParentDeleted';
  /** ID of the trash item. */
  id: Scalars['Int']['output'];
  /** Whether the parent of this item is also deleted. */
  parentDeleted: Scalars['Boolean']['output'];
};

/** The type of item in the trash. Items can be projects, folders, designs, or AB tests. */
export enum TrashItemType {
  /** An A/B test comparing different designs. */
  ABTEST = 'abTest',
  /** A design or design set. */
  DESIGN = 'design',
  /** A folder that can contain designs or other folders. */
  FOLDER = 'folder',
  /** A project containing designs and folders. */
  PROJECT = 'project'
}

/** Paginated results of trash items with page information for infinite scrolling. */
export type TrashItemsResult = PaginationResults & {
  __typename?: 'TrashItemsResult';
  /** List of trash items for the current page. */
  nodes: Array<TrashItem>;
  /** Pagination information including cursors for fetching next pages. */
  pageInfo: PageInfo;
  /** Total count of items in the trash. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Defines how trash items can be ordered in the list view. */
export enum TrashOrderBy {
  /** Order trash items by when they were deleted. */
  DELETEDAT = 'deletedAt',
  /** Order trash items alphabetically by name. */
  NAME = 'name'
}

export type TrimVideoResult = {
  __typename?: 'TrimVideoResult';
  /** Real duration of the trimmed clip, in seconds. */
  duration: Scalars['Float']['output'];
  /** URL of the trimmed mp4. */
  url: Scalars['String']['output'];
};

export type TryAdStudioResult = {
  __typename?: 'TryAdStudioResult';
  authSession?: Maybe<Scalars['String']['output']>;
  createdDesignHash?: Maybe<Scalars['String']['output']>;
  teamId: Scalars['Int']['output'];
};

export type TryNextgenAiResult = {
  __typename?: 'TryNextgenAiResult';
  authSession?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['Int']['output']>;
  teamId: Scalars['Int']['output'];
};

export type Tutorial = {
  __typename?: 'Tutorial';
  createdAt?: Maybe<Scalars['Date']['output']>;
  datePublished?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  tutorialCategoryId?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type TutorialCategory = {
  __typename?: 'TutorialCategory';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  tutorials?: Maybe<Array<Tutorial>>;
};

export type TutorialCategoryApp = {
  __typename?: 'TutorialCategoryApp';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  tutorialsViewed?: Maybe<Array<TutorialViewed>>;
};

export type TutorialViewed = {
  __typename?: 'TutorialViewed';
  datePublished?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  tutorialCategoryId?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  viewed?: Maybe<Scalars['Boolean']['output']>;
};

export type TutorialsResult = {
  __typename?: 'TutorialsResult';
  categories: Array<TutorialCategory>;
  hasNewTutorials: Scalars['Boolean']['output'];
};

export type TutorialsResultApp = {
  __typename?: 'TutorialsResultApp';
  categories: Array<TutorialCategoryApp>;
  hasNewTutorials: Scalars['Boolean']['output'];
};

/** Two-factor authentication status for a user. */
export type TwoFactor = {
  __typename?: 'TwoFactor';
  /** Whether the user has two-factor authentication enabled. */
  hasTwoFactor: Scalars['Boolean']['output'];
  /** Whether to display the two-factor authentication setup UI. */
  showTwoFactor: Scalars['Boolean']['output'];
};

export type TwoFactorAdmin = {
  __typename?: 'TwoFactorAdmin';
  hasTwoFactor: Scalars['Boolean']['output'];
  showTwoFactor: Scalars['Boolean']['output'];
};

/** Typography configuration for text elements in a brand kit. */
export type Typography = {
  __typename?: 'Typography';
  /** ID of the font in the brand kit (optional). */
  fontId?: Maybe<Scalars['Int']['output']>;
  /** Name of the font used. */
  fontName: Scalars['String']['output'];
  /** Size of the font in pixels. */
  fontSize: Scalars['Int']['output'];
  /** Weight of the font (e.g., 'regular', 'bold'). */
  fontWeight: Scalars['String']['output'];
  /** Line height multiplier (optional). */
  lineHeight?: Maybe<Scalars['Float']['output']>;
  /** Type of typography (e.g., 'heading', 'body', 'button'). */
  type: Scalars['String']['output'];
};

export enum UgcIntent {
  ADD_CAPTIONS = 'ADD_CAPTIONS',
  CREATE_VIDEO = 'CREATE_VIDEO',
  CREATE_VIDEO_WITH_CAPTIONS = 'CREATE_VIDEO_WITH_CAPTIONS',
  UNCLEAR = 'UNCLEAR'
}

/** Response after removing sharing of a design. */
export type UnShareDesignPayload = {
  __typename?: 'UnShareDesignPayload';
  /** Whether the unshare operation was successful. */
  result: Scalars['Boolean']['output'];
};

export type UnShareFolderPayload = {
  __typename?: 'UnShareFolderPayload';
  result: Scalars['Boolean']['output'];
};

export type UndoDeleteFolderPayload = {
  __typename?: 'UndoDeleteFolderPayload';
  folder: Folder;
  innerDesigns: Array<TrashItemIdWithParentDeleted>;
  innerFolders: Array<TrashItemIdWithParentDeleted>;
};

export type UnlinkBusinessAccountInput = {
  accountId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type UnlinkBusinessAccountResponse = {
  __typename?: 'UnlinkBusinessAccountResponse';
  accountId: Scalars['String']['output'];
};

export type UnpinFolderPayload = {
  __typename?: 'UnpinFolderPayload';
  folderId: Scalars['Int']['output'];
};

/**
 * Details about a font that doesn't support required characters.
 * Returned per (fontFamily, fontWeight, fontStyle, fontType) combo present in the design,
 * so the brand-kit fallback save can persist a record that matches what the live DOM renders.
 */
export type UnsupportedFont = {
  __typename?: 'UnsupportedFont';
  /** Name of the font family. */
  fontFamily: Scalars['String']['output'];
  /** Style of the original font as used in the design (e.g. normal, italic). */
  fontStyle: Scalars['String']['output'];
  /** Type of font (system, google, custom, etc.). */
  fontType: Scalars['String']['output'];
  /** URL to the font file (if available). */
  fontUrl?: Maybe<Scalars['String']['output']>;
  /** Weight of the original font as used in the design (e.g. 400, 700). */
  fontWeight: Scalars['Int']['output'];
};

/** Payload for the updateAdServingCode mutation. */
export type UpdateAdServingCodePayload = {
  __typename?: 'UpdateAdServingCodePayload';
  /** A list of ad serving networks and their updated statuses. */
  networks: Array<AdServingNetwork>;
};

/** Payload for the updateAdServingSettings mutation. */
export type UpdateAdServingSettingsPayload = {
  __typename?: 'UpdateAdServingSettingsPayload';
  /** The updated ad serving settings. */
  settings: AdServingDesignSettings;
  /** Indicates if the settings are out of sync after the update. */
  settingsOutOfSync: Scalars['Boolean']['output'];
  /** The synchronization status of the ad tag. */
  syncStatus: AdTagSyncStatus;
};

export type UpdateAiGenerationRulesFromChatPayload = {
  __typename?: 'UpdateAiGenerationRulesFromChatPayload';
  ok: Scalars['Boolean']['output'];
};

/** Input for updating an existing brand competitor. */
export type UpdateBrandCompetitorInput = {
  /** Domain/website of the competitor. */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** Facebook brand data as JSON. */
  facebookBrandData?: InputMaybe<Scalars['JSON']['input']>;
  /** Facebook page ID. */
  facebookPageId?: InputMaybe<Scalars['String']['input']>;
  /** Google advertiser ID. */
  googleAdvertiserId?: InputMaybe<Scalars['String']['input']>;
  /** Google data as JSON. */
  googleData?: InputMaybe<Scalars['JSON']['input']>;
  /** @BreakingBad */
  id: Scalars['Int']['input'];
  /** Name of the competitor. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Response when updating the details of a brand kit. */
export type UpdateBrandDetailsPayload = {
  __typename?: 'UpdateBrandDetailsPayload';
  /** The updated brand kit. */
  brandKit: BrandKit;
};

/** Response after changing approval status. */
export type UpdateDesignApprovalStatusPayload = {
  __typename?: 'UpdateDesignApprovalStatusPayload';
  /** The design hash. */
  designHash: Scalars['String']['output'];
  /** The previous status ID. */
  fromStatusId?: Maybe<Scalars['String']['output']>;
  /** The new status ID. */
  toStatusId: Scalars['String']['output'];
};

/** Response after updating HTML export settings. */
export type UpdateDesignHtmlSettingsPayload = {
  __typename?: 'UpdateDesignHtmlSettingsPayload';
  /** The updated HTML export settings. */
  result: DesignHtmlSettings;
};

/** Response after updating a design. */
export type UpdateDesignPayload = {
  __typename?: 'UpdateDesignPayload';
  /** The updated design. */
  design: Design;
};

/** Response after updating a design set. */
export type UpdateDesignSetPayload = {
  __typename?: 'UpdateDesignSetPayload';
  /** The updated design set. */
  design: Design;
};

/** Response after updating multiple designs in a batch. */
export type UpdateDesignsPayload = {
  __typename?: 'UpdateDesignsPayload';
  /** The parent design set if applicable. */
  designSet: Design;
  /** The updated designs. */
  designs: Array<Design>;
};

/** @deprecated use UpdateFacebookDpaSettingsInput instead */
export type UpdateDpaSettingsInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  adAccountId?: InputMaybe<Scalars['String']['input']>;
  businessId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  catalogId?: InputMaybe<Scalars['String']['input']>;
  designHash: Scalars['String']['input'];
  errors?: InputMaybe<Array<Scalars['String']['input']>>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  pageId?: InputMaybe<Scalars['String']['input']>;
  supplementary?: InputMaybe<Scalars['Boolean']['input']>;
  teamId: Scalars['Int']['input'];
  type?: InputMaybe<DpaPlatformType>;
};

export type UpdateFacebookDpaSettingsInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  adAccountId?: InputMaybe<Scalars['String']['input']>;
  businessId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  catalogId?: InputMaybe<Scalars['String']['input']>;
  designChecksum?: InputMaybe<Scalars['String']['input']>;
  designId: Scalars['Int']['input'];
  errors?: InputMaybe<Array<Scalars['String']['input']>>;
  fbCsvUrl?: InputMaybe<Scalars['String']['input']>;
  includeVideos?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  pageId?: InputMaybe<Scalars['String']['input']>;
  supplementary?: InputMaybe<Scalars['Boolean']['input']>;
  syncStatus?: InputMaybe<DpaSyncStatus>;
  teamId: Scalars['Int']['input'];
};

export type UpdateFeatureResult = {
  __typename?: 'UpdateFeatureResult';
  result: Scalars['Boolean']['output'];
};

export enum UpdateFrequencyType {
  FIFTEEN_MINUTES = 'fifteen_minutes',
  NEVER = 'never',
  ONCE_PER_DAY = 'once_per_day',
  ONCE_PER_HOUR = 'once_per_hour',
  WEEKLY = 'weekly'
}

export type UpdateMoodBoardCommentInput = {
  id: Scalars['Int']['input'];
  message: Scalars['String']['input'];
  moodBoardHash: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMoodBoardCommentThreadInput = {
  moodBoardHash: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['JSON']['input']>;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  threadId: Scalars['Int']['input'];
};

export type UpdatePermanentFlagPayload = {
  __typename?: 'UpdatePermanentFlagPayload';
  result: Scalars['Boolean']['output'];
};

export type UpdatePhotoshopStatusPayload = {
  __typename?: 'UpdatePhotoshopStatusPayload';
  result: Scalars['Boolean']['output'];
};

/**
 * Catalog (URL-mode) publish completion writeback -- kept separate from
 * UpdatePinterestPublishStatusInput because campaign publishes never touch
 * dpa_settings (see updatePinterestPublishStatus.ts), unlike catalog publishes.
 */
export type UpdatePinterestCatalogPublishStatusInput = {
  /** DPA mode only -- the resolved/created Pinterest catalog id, persisted into dpa_settings.catalogId on success. */
  catalogId?: InputMaybe<Scalars['String']['input']>;
  count: Scalars['Int']['input'];
  creditTransactionId?: InputMaybe<Scalars['Int']['input']>;
  /** Generated feed CSV URL -- persisted into dpa_settings.fbCsvUrl (reused column, see service) on success. */
  csvUrl?: InputMaybe<Scalars['String']['input']>;
  designHash: Scalars['String']['input'];
  error?: InputMaybe<PinterestPublishErrorInput>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  success: Scalars['Boolean']['input'];
  teamId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

/** Partial update of the Pinterest-family dpa_settings row (e.g. turn off auto-sync). Mirrors UpdateFacebookDpaSettingsInput but is always scoped to the pinterest family (type: pinterest) by its resolver, so it never touches the meta row. */
export type UpdatePinterestDpaSettingsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  adAccountId?: InputMaybe<Scalars['String']['input']>;
  catalogId?: InputMaybe<Scalars['String']['input']>;
  /** Parent design (set) id the row is persisted under -- the same id generateCatalog/dpaCatalog use as parentDesignId, NOT a set child's own id. */
  designId: Scalars['Int']['input'];
  errors?: InputMaybe<Array<Scalars['String']['input']>>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  syncStatus?: InputMaybe<DpaSyncStatus>;
  teamId: Scalars['Int']['input'];
};

export type UpdatePinterestPublishStatusInput = {
  count: Scalars['Int']['input'];
  creditTransactionId?: InputMaybe<Scalars['Int']['input']>;
  designHash: Scalars['String']['input'];
  error?: InputMaybe<PinterestPublishErrorInput>;
  jobData: Scalars['JSON']['input'];
  jobId?: InputMaybe<Scalars['String']['input']>;
  success: Scalars['Boolean']['input'];
  userId: Scalars['Int']['input'];
};

/** Response after updating approval config. */
export type UpdateProjectApprovalConfigPayload = {
  __typename?: 'UpdateProjectApprovalConfigPayload';
  /** The updated project. */
  project: Project;
};

export type UpdateResourceStatusPayload = {
  __typename?: 'UpdateResourceStatusPayload';
  result: Scalars['Boolean']['output'];
};

/** Response after updating comment settings for shared links. */
export type UpdateShareLinkCommentsEnabledPayload = {
  __typename?: 'UpdateShareLinkCommentsEnabledPayload';
  /** Whether the update was successful. */
  result: Scalars['Boolean']['output'];
};

export type UpdateShareVariationSelectionPayload = {
  __typename?: 'UpdateShareVariationSelectionPayload';
  result: Scalars['Boolean']['output'];
};

export type UpdateSubscriptionPayload = {
  __typename?: 'UpdateSubscriptionPayload';
  currentPeriodEndsAt?: Maybe<Scalars['Date']['output']>;
  result: Scalars['Boolean']['output'];
  trialEndsAt?: Maybe<Scalars['Date']['output']>;
};

export type UpdateSubscriptionResult = {
  __typename?: 'UpdateSubscriptionResult';
  result: RecurlySubscription;
};

export type UpdateSubscriptionSeatsPayload = {
  __typename?: 'UpdateSubscriptionSeatsPayload';
  /** When the new count takes effect. Null when it applied immediately. */
  effectiveAt?: Maybe<Scalars['Date']['output']>;
  seatsQuantity: Scalars['Int']['output'];
};

export type UpdateTeamIdentityProviderDomainsResult = {
  __typename?: 'UpdateTeamIdentityProviderDomainsResult';
  result?: Maybe<Array<TeamIdentityProviderDomain>>;
};

/** Response after updating a team invitation. */
export type UpdateTeamInvitationPayload = {
  __typename?: 'UpdateTeamInvitationPayload';
  /** Whether the update was successful. */
  result: Scalars['Boolean']['output'];
};

/** Response after updating a team user group. */
export type UpdateTeamUserGroupPayload = {
  __typename?: 'UpdateTeamUserGroupPayload';
  /** The updated team user group. */
  group: TeamUserGroup;
};

/**
 * Catalog publish completion writeback -- kept separate from InputTikTokPublishUpdateStatus
 * because campaign publishes never touch dpa_settings, unlike catalog publishes (mirrors
 * UpdatePinterestCatalogPublishStatusInput).
 */
export type UpdateTikTokCatalogPublishStatusInput = {
  /** DPA mode only -- the Business Center the catalog lives in, persisted into the row's platformSettings on success. */
  businessCenterId?: InputMaybe<Scalars['String']['input']>;
  /** DPA mode only -- the resolved/created TikTok catalog id, persisted into dpa_settings.catalogId on success. */
  catalogId?: InputMaybe<Scalars['String']['input']>;
  count: Scalars['Int']['input'];
  creditTransactionId?: InputMaybe<Scalars['Int']['input']>;
  /** Generated feed CSV URL -- persisted into dpa_settings.fbCsvUrl (the generic feed-URL column) on success. */
  csvUrl?: InputMaybe<Scalars['String']['input']>;
  designHash: Scalars['String']['input'];
  error?: InputMaybe<PublishErrorInput>;
  /** DPA mode only -- the scheduled feed the worker created or reused, persisted into the row's platformSettings on success. */
  feedId?: InputMaybe<Scalars['String']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  success: Scalars['Boolean']['input'];
  teamId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

/** Partial update of the TikTok-family dpa_settings row (e.g. turn off auto-sync). Mirrors UpdatePinterestDpaSettingsInput and is always scoped to the tiktok family (type: tiktok) by its resolver, so it never touches the meta or pinterest row of the same design. */
export type UpdateTikTokDpaSettingsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  adAccountId?: InputMaybe<Scalars['String']['input']>;
  catalogId?: InputMaybe<Scalars['String']['input']>;
  /** Parent design (set) id the row is persisted under -- the id the DPA Catalog wizard uses as parentDesignId, NOT a set child's own id. */
  designId: Scalars['Int']['input'];
  errors?: InputMaybe<Array<Scalars['String']['input']>>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  syncStatus?: InputMaybe<DpaSyncStatus>;
  teamId: Scalars['Int']['input'];
};

/** Response after updating a design version name. */
export type UpdateVersionNamePayload = {
  __typename?: 'UpdateVersionNamePayload';
  /** Whether the update was successful. */
  result: Scalars['Boolean']['output'];
};

export type UpdatesPayload = {
  __typename?: 'UpdatesPayload';
  audience?: Maybe<ProductUpdateAudience>;
  datePublished?: Maybe<Scalars['Date']['output']>;
  description: Scalars['String']['output'];
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** @deprecated This field is no longer used */
  onlyAdStudioUsers?: Maybe<Scalars['Boolean']['output']>;
  standalone: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  version: ProductUpdateVersion;
};

export type UploadAttachmentResult = {
  __typename?: 'UploadAttachmentResult';
  attachments?: Maybe<Array<Maybe<CommentAttachments>>>;
  id: Scalars['Int']['output'];
  threadId: Scalars['Int']['output'];
};

/** Response after uploading a brand kit logo. */
export type UploadBrandKitLogoPayload = {
  __typename?: 'UploadBrandKitLogoPayload';
  /** The uploaded logo media asset. */
  logo: Media;
};

/** Response containing a URL for uploading a brand kit logo. */
export type UploadBrandKitLogoUrlPayload = {
  __typename?: 'UploadBrandKitLogoUrlPayload';
  /** Hash identifier for the upload. */
  hash: Scalars['String']['output'];
  /** Presigned post data for uploading the file. */
  uploadUrl: PresignedPost;
};

export type UploadCommentAttachmentResult = {
  __typename?: 'UploadCommentAttachmentResult';
  attachment?: Maybe<Array<CommentAttachments>>;
  success: Scalars['Boolean']['output'];
};

/** Response after uploading a font. */
export type UploadFontPayload = {
  __typename?: 'UploadFontPayload';
  /** The uploaded font. */
  font: Font;
};

export type UploadToGoogleDriveResult = {
  __typename?: 'UploadToGoogleDriveResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  webViewLink?: Maybe<Scalars['String']['output']>;
};

export type UploadToSharePointResult = {
  __typename?: 'UploadToSharePointResult';
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  webUrl?: Maybe<Scalars['String']['output']>;
};

/** Response containing upload URL information. */
export type UploadUrlPayload = {
  __typename?: 'UploadUrlPayload';
  /** Hash identifier for the upload. */
  hash: Scalars['String']['output'];
  /** Presigned post data for uploading the file. */
  uploadUrl: PresignedPost;
};

/** Input for uploaded logo */
export type UploadedLogoInput = {
  /** Logo height in pixels */
  height: Scalars['Int']['input'];
  /** Logo name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Logo type */
  type: Scalars['String']['input'];
  /** Logo URL */
  url: Scalars['String']['input'];
  /** Logo width in pixels */
  width: Scalars['Int']['input'];
};

/** Payload for the upsertDynamicVars mutation. */
export type UpsertDynamicVarsPayload = {
  __typename?: 'UpsertDynamicVarsPayload';
  /** The list of upserted dynamic variables. */
  dynamicVars: Array<AdServingDynamicVar>;
  settingsOutOfSync: Scalars['Boolean']['output'];
  syncStatus: AdTagSyncStatus;
};

/** Payload for the upsertExternalTrackingUrls mutation. */
export type UpsertExternalTrackingUrlPayload = {
  __typename?: 'UpsertExternalTrackingUrlPayload';
  /** The list of upserted external tracking URLs. */
  externalTrackingUrls: Array<AdServingExternalTrackingUrl>;
};

export type UrlAdDataTextContent = {
  __typename?: 'UrlAdDataTextContent';
  cta: Scalars['String']['output'];
  description: Scalars['String']['output'];
  hashtags: Scalars['String']['output'];
  headline: Scalars['String']['output'];
  mediaDescriptionIndex?: Maybe<Scalars['Int']['output']>;
  technique: Scalars['String']['output'];
  tone: Scalars['String']['output'];
};

export type UrlDataToBrandkitPayload = {
  __typename?: 'UrlDataToBrandkitPayload';
  brandKit: BrandKit;
  colors?: Maybe<Array<Color>>;
  fonts?: Maybe<Array<Font>>;
  logo?: Maybe<Media>;
  media?: Maybe<Array<Media>>;
};

export type UsageRestriction = {
  __typename?: 'UsageRestriction';
  action: UsageRestrictionAction;
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  metadata?: Maybe<UsageRestrictionMetadata>;
  notes?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  scope: UsageRestrictionScope;
  teamId: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export enum UsageRestrictionAction {
  DISABLE = 'DISABLE',
  EXEMPT = 'EXEMPT',
  REQUIRE_BILLING_INFO = 'REQUIRE_BILLING_INFO',
  REQUIRE_UPGRADE = 'REQUIRE_UPGRADE',
  THROTTLE = 'THROTTLE',
  WARN = 'WARN'
}

export type UsageRestrictionMetadata = {
  __typename?: 'UsageRestrictionMetadata';
  escalatedFrom?: Maybe<Scalars['String']['output']>;
  previousAction?: Maybe<UsageRestrictionAction>;
  ruleId?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<RestrictionSeverity>;
};

export type UsageRestrictionPage = {
  __typename?: 'UsageRestrictionPage';
  items: Array<UsageRestriction>;
  total: Scalars['Int']['output'];
};

export enum UsageRestrictionScope {
  AI = 'AI',
  ALL = 'ALL',
  EXPORT = 'EXPORT',
  VIDEO = 'VIDEO'
}

export type UsedTrials = {
  __typename?: 'UsedTrials';
  /** @deprecated Use total instead, one trial is allowed from now on / account. */
  results?: Maybe<Scalars['JSON']['output']>;
  total: Scalars['Int']['output'];
};

/** User account information. */
export type User = {
  __typename?: 'User';
  /** Unique account identifier. */
  accountId: Scalars['String']['output'];
  /** Anonymous identifier for tracking before authentication. */
  anonymousId?: Maybe<Scalars['String']['output']>;
  /** Authentication ID (from identity provider). */
  authId: Scalars['String']['output'];
  /** Whether emails to this user bounce. */
  bounce: Scalars['Boolean']['output'];
  /** Whether the user's email is confirmed. */
  confirmed: Scalars['Boolean']['output'];
  /** When the user account was created. */
  createdAt: Scalars['Date']['output'];
  /** User's email address. */
  email: Scalars['String']['output'];
  emailPreferences: EmailPreferences;
  /** Unique identifier of the user. */
  id: Scalars['Int']['output'];
  /** User's full name. */
  name: Scalars['String']['output'];
  /** URL to the user's profile picture. */
  profilePicture?: Maybe<Scalars['String']['output']>;
  /** Teams that user belongs to with their memberships. */
  teams: Array<Team>;
  /** Whether this is a temporary user account. */
  tempUser: Scalars['Boolean']['output'];
  /** Whether this is a test user account. */
  testUser: Scalars['Boolean']['output'];
  userSettings: UserSettings;
};

export type UserConsumptionBreakdown = {
  __typename?: 'UserConsumptionBreakdown';
  breakdownByFeatures: Array<FeatureBreakdown>;
  totalUserConsumption: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type UserIdentityProvider = {
  __typename?: 'UserIdentityProvider';
  alias: Scalars['String']['output'];
  enforceSso?: Maybe<Scalars['Boolean']['output']>;
};

export type UserIdentityProviderAliases = {
  __typename?: 'UserIdentityProviderAliases';
  options: Array<TeamIdentityProviderOption>;
};

/** Onboarding preferences for a user. */
export type UserOnboarding = {
  __typename?: 'UserOnboarding';
  /** The user's company industry (limited to 100 characters). */
  companyIndustry?: Maybe<Scalars['String']['output']>;
  /** The user's company size (limited to 100 characters). */
  companySize?: Maybe<Scalars['String']['output']>;
  /** The user's company name (limited to 100 characters). */
  companyWebsite?: Maybe<Scalars['String']['output']>;
  /** Getting Started completed card IDs (JSON array string). */
  gettingStartedCompleted?: Maybe<Scalars['String']['output']>;
  /** How did the user hear about us (limited to 100 characters). */
  heardAboutUs?: Maybe<Scalars['String']['output']>;
  /** Whether the user has hidden the Getting Started section. */
  hideGettingStarted?: Maybe<Scalars['String']['output']>;
  /** Home page walkthrough status (not_started, in_progress, completed, cancelled). */
  homeWalkthroughStatus?: Maybe<Scalars['String']['output']>;
  /** The user's job function */
  jobFunction?: Maybe<Scalars['String']['output']>;
  /**
   * Whether the user has checked the moodboard onboarding video. No longer used.
   * @deprecated Feature removed. Field will be dropped in a future schema update.
   */
  moodboardVideoChecked?: Maybe<Scalars['String']['output']>;
  /** Nova onboarding: Onboarding ad studio */
  onboardingAdStudio?: Maybe<Scalars['String']['output']>;
  /** Nova onboarding: Onboarding flow type */
  onboardingFlow?: Maybe<Scalars['String']['output']>;
  /** Nova onboarding: Onboarding moodboard */
  onboardingMoodboard?: Maybe<Scalars['String']['output']>;
  /** Nova onboarding: Onboarding version */
  onboardingVersion?: Maybe<Scalars['String']['output']>;
  /** The user's selected role . */
  role?: Maybe<Scalars['String']['output']>;
  /** Whether the user has chosen to skip onboarding. */
  skip?: Maybe<Scalars['Boolean']['output']>;
  /** Onboarding status (completed, pending, skipped). Replaces role as the source of truth for completion. */
  status?: Maybe<Scalars['String']['output']>;
  /** The user's intention (limited to 100 characters). */
  useCase?: Maybe<Scalars['String']['output']>;
  /** User's selected intent during onboarding (canvas, adStudio, other). */
  userIntent?: Maybe<Scalars['String']['output']>;
};

/** Response wrapper for user onboarding data. */
export type UserOnboardingPayload = {
  __typename?: 'UserOnboardingPayload';
  /** User's onboarding preferences. */
  result?: Maybe<UserOnboarding>;
};

export enum UserOrgType {
  GROUP = 'GROUP',
  SINGLE = 'SINGLE'
}

export type UserProfileCm360 = {
  __typename?: 'UserProfileCm360';
  accountId?: Maybe<Scalars['String']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  profileId: Scalars['String']['output'];
  subAccountId?: Maybe<Scalars['String']['output']>;
  subAccountName?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type UserProfilesCm360Input = {
  email: Scalars['String']['input'];
  /** The team whose CM360 account to use, or the caller's own personal one */
  teamId: Scalars['Int']['input'];
};

export type UserProfilesCm360Payload = {
  __typename?: 'UserProfilesCm360Payload';
  items: Array<UserProfileCm360>;
};

export type UserSettings = {
  __typename?: 'UserSettings';
  editorSettings?: Maybe<EditorSettings>;
};

export type V6CreditsOverride = {
  __typename?: 'V6CreditsOverride';
  creditsPerSeat?: Maybe<Scalars['Int']['output']>;
  planClass: Scalars['String']['output'];
  planDefaultPerSeat: Scalars['Int']['output'];
  resolvedPool: Scalars['Int']['output'];
  seats: Scalars['Int']['output'];
};

export type ValidEmailResult = {
  __typename?: 'ValidEmailResult';
  email: Scalars['String']['output'];
  isValid: Scalars['Boolean']['output'];
};

export enum Variant {
  OPTIN = 'optIn',
  OPTOUT = 'optOut'
}

export type VariationSizePropagation = {
  __typename?: 'VariationSizePropagation';
  sizes: Array<PropagatedSize>;
  variationSetHash: Scalars['String']['output'];
  variationSetId: Scalars['Int']['output'];
};

export type VariationSuggestion = {
  __typename?: 'VariationSuggestion';
  category: Scalars['String']['output'];
  name: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
};

export type VariationSuggestionsResult = {
  __typename?: 'VariationSuggestionsResult';
  variations: Array<VariationSuggestion>;
};

/** Whether syncing the master into ONE variation would actually change it — computed over the raw feed-stripped documents the sync itself merges. */
export type VariationSyncEffect = {
  __typename?: 'VariationSyncEffect';
  /** Checksum detection flags this variation (the cheap, JSON-free signal the tab also computes locally). */
  checksumFlagged: Scalars['Boolean']['output'];
  /** Applied changes deduped per element across sizes (the review list's unit). */
  elementChangeCount: Scalars['Int']['output'];
  /** Sizes the sync would skip, with the mutation's own reasons. */
  skippedSizes: Array<VariationSyncEffectSkippedSize>;
  variationHash: Scalars['String']['output'];
  /** The sync would change the variation. FALSE only when that can be PROVEN — every degraded case reports true, so a real change is never hidden. */
  willApply: Scalars['Boolean']['output'];
};

/** One size the master→variations sync would skip, with the reason it reports. */
export type VariationSyncEffectSkippedSize = {
  __typename?: 'VariationSyncEffectSkippedSize';
  designSizeTypeId?: Maybe<Scalars['Int']['output']>;
  /** ambiguous-size-type, never-captured, checksum-drift, master-unloadable, variation-unsyncable, preview-failed, … */
  reason: Scalars['String']['output'];
};

export enum VariationTargetsSource {
  AI = 'AI',
  LOGIC = 'LOGIC'
}

export type VaultInstance = {
  __typename?: 'VaultInstance';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type VaultInstanceInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type VeevaApp = {
  __typename?: 'VeevaApp';
  appId: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  name: Scalars['String']['output'];
  team?: Maybe<Team>;
  teamId: Scalars['Int']['output'];
};

export type VeevaAppInput = {
  appId: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  name: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type VeevaAppPublic = {
  __typename?: 'VeevaAppPublic';
  appId: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  team?: Maybe<Team>;
  teamId: Scalars['Int']['output'];
};

export type VeevaClientResponse = {
  __typename?: 'VeevaClientResponse';
  status: Scalars['String']['output'];
};

export type VeevaDocumentByNumberResult = {
  __typename?: 'VeevaDocumentByNumberResult';
  document_number__v: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name__v: Scalars['String']['output'];
  status__v: Scalars['String']['output'];
};

export type VeevaDocumentUpdateStatus = {
  __typename?: 'VeevaDocumentUpdateStatus';
  status: Scalars['String']['output'];
};

export type VeevaDocumentsResult = {
  __typename?: 'VeevaDocumentsResult';
  document_number__v: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name__v: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  status__v: Scalars['String']['output'];
};

export type VeevaOptions = {
  __typename?: 'VeevaOptions';
  /** @deprecated Field no longer supported */
  animationNotes?: Maybe<Array<Scalars['String']['output']>>;
  designHash: Scalars['String']['output'];
  designSizes?: Maybe<Array<Maybe<DesignSize>>>;
  downloadCoverSlide?: Maybe<Scalars['Boolean']['output']>;
  exportAs?: Maybe<Array<Scalars['String']['output']>>;
  globalText?: Maybe<Scalars['String']['output']>;
  /** @BreakingBad slideData is now an array with notes, timings, design id */
  slideData?: Maybe<SlideDataOutput>;
};

export type VeevaOptionsData = {
  /** @deprecated Field no longer supported */
  animationNotes?: InputMaybe<Array<Scalars['String']['input']>>;
  designHash: Scalars['String']['input'];
  designSizes?: InputMaybe<Array<DesignSizeInput>>;
  downloadCoverSlide?: InputMaybe<Scalars['Boolean']['input']>;
  exportAs?: InputMaybe<Array<Scalars['String']['input']>>;
  globalText?: InputMaybe<Scalars['String']['input']>;
  /** @BreakingBad slideData is now an array with notes, timings, design id */
  slideData?: InputMaybe<SlideDataInput>;
};

export type VeevaOptionsQuery = {
  designHash: Scalars['String']['input'];
};

export type VeevaOptionsResponse = {
  __typename?: 'VeevaOptionsResponse';
  status: Scalars['String']['output'];
};

export type VeevaResult = {
  __typename?: 'VeevaResult';
  documents: Array<VeevaDocumentsResult>;
};

export enum VeoOptions {
  FIRST_LAST_FRAME = 'FIRST_LAST_FRAME',
  REFERENCE_TO_VIDEO = 'REFERENCE_TO_VIDEO'
}

export enum VideoGenerationAspectRatio {
  LANDSCAPE = 'LANDSCAPE',
  PORTRAIT = 'PORTRAIT',
  SQUARE = 'SQUARE'
}

export enum VideoGenerationMode {
  FAST = 'FAST',
  QUALITY = 'QUALITY'
}

export enum VideoGenerationType {
  PROMPT = 'PROMPT',
  PROMPT_AND_IMAGE = 'PROMPT_AND_IMAGE'
}

export type WatchdogEvaluateResult = {
  __typename?: 'WatchdogEvaluateResult';
  detVerdict: ResizeRankingVerdict;
  evaluationId: Scalars['Int']['output'];
  renderOk: Scalars['Boolean']['output'];
};

export type WhiteLabelAccess = {
  teamId: Scalars['Int']['input'];
  whiteLabelAccess: Scalars['Boolean']['input'];
};

export type WhiteLabeledIntegration = {
  teamId: Scalars['Int']['input'];
  whiteLabeledIntegration: Scalars['Boolean']['input'];
};

export type Workflow = {
  __typename?: 'Workflow';
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  hash: Scalars['String']['output'];
  name: Scalars['String']['output'];
  trigger: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  workflow: Scalars['WorkflowJson']['output'];
};

export type WorkflowFetchUrlResponse = {
  __typename?: 'WorkflowFetchUrlResponse';
  jobId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum WorkflowOperationStatus {
  FAIL = 'FAIL',
  SUCCESS = 'SUCCESS'
}

export type WorkflowRealtimeSubscriptionTokenResponse = {
  __typename?: 'WorkflowRealtimeSubscriptionTokenResponse';
  token?: Maybe<Scalars['TToken']['output']>;
};

export type WorkflowRun = {
  __typename?: 'WorkflowRun';
  data: WorkflowRunData;
  metadata: WorkflowRunMetadata;
};

export type WorkflowRunData = {
  __typename?: 'WorkflowRunData';
  batchId?: Maybe<Scalars['String']['output']>;
  cron?: Maybe<Scalars['String']['output']>;
  endedAt?: Maybe<Scalars['String']['output']>;
  environmentId?: Maybe<Scalars['String']['output']>;
  eventId?: Maybe<Scalars['String']['output']>;
  functionId?: Maybe<Scalars['String']['output']>;
  functionVersion?: Maybe<Scalars['Int']['output']>;
  originalRunId?: Maybe<Scalars['String']['output']>;
  output?: Maybe<Scalars['WorkflowRunOutput']['output']>;
  runId?: Maybe<Scalars['String']['output']>;
  runStartedAt?: Maybe<Scalars['String']['output']>;
  status?: Maybe<WorkflowRunStatus>;
};

export type WorkflowRunMetadata = {
  __typename?: 'WorkflowRunMetadata';
  cachedUntil?: Maybe<Scalars['String']['output']>;
  fetchedAt?: Maybe<Scalars['String']['output']>;
};

export enum WorkflowRunStatus {
  CANCELLED = 'Cancelled',
  COMPLETED = 'Completed',
  FAILED = 'Failed',
  RUNNING = 'Running'
}

export type WorkflowRunsResponse = {
  __typename?: 'WorkflowRunsResponse';
  error?: Maybe<Scalars['String']['output']>;
  runs: Array<WorkflowRun>;
};

export type WorkspaceSizes = {
  sizes?: InputMaybe<Array<BsCustomSize>>;
  workspaceId?: InputMaybe<Scalars['Int']['input']>;
};

export type CommentDeletedResult = {
  __typename?: 'commentDeletedResult';
  commentId?: Maybe<Scalars['Int']['output']>;
  threadId: Scalars['Int']['output'];
  threadWasDeleted: Scalars['Boolean']['output'];
};

export type CreateIntercomConversationPayload = {
  __typename?: 'createIntercomConversationPayload';
  result: Scalars['Boolean']['output'];
};

/** Information about a favorite team. */
export type FavouriteTeam = {
  __typename?: 'favouriteTeam';
  /** Whether the team is marked as favorite. */
  favourite: Scalars['Boolean']['output'];
  /** ID of the team. */
  teamId: Scalars['Int']['output'];
};

export type GetDesignComponentNamePayload = {
  __typename?: 'getDesignComponentNamePayload';
  name: Scalars['String']['output'];
};

/** Response containing a design's type. */
export type GetDesignTypePayload = {
  __typename?: 'getDesignTypePayload';
  /** Type of the design (design, set, component). */
  type: DesignType;
};

export type InitialIntercomConversationPayload = {
  __typename?: 'initialIntercomConversationPayload';
  result: Scalars['Boolean']['output'];
};

export type ReorderPinnedFolderListPayload = {
  __typename?: 'reorderPinnedFolderListPayload';
  result: Scalars['Boolean']['output'];
};

export type SendDataToIntercomPayload = {
  __typename?: 'sendDataToIntercomPayload';
  result: Scalars['Boolean']['output'];
};

export type UpdateBillingActionResult = BillingInfo | ThreeDSecurePayload;

/**
 * Target options for HTML export links.
 * These correspond to standard HTML link targets.
 */
export enum UrlTarget {
  /** Open in a new tab or window. */
  _BLANK = '_blank',
  /** Open in the parent frame. */
  _PARENT = '_parent',
  /** Open in the same frame. */
  _SELF = '_self',
  /** Open in the full body of the window. */
  _TOP = '_top'
}

export type DesignSizeTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type DesignSizeTypesQuery = { __typename?: 'Query', designSizeTypes: Array<{ __typename?: 'DesignSizeType', id: number, identifier?: string | null, category?: DesignSizeTypeCategory | null, name: string, width?: number | null, height?: number | null, measureUnit?: MeasureUnit | null, kind: DesignSizeTypeKind, video?: boolean | null, static?: boolean | null, animated?: boolean | null, countDesignSizeTypesInSet?: number | null }> };

export type MigratedTemplateQueryVariables = Exact<{
  input: InputDesign;
}>;


export type MigratedTemplateQuery = { __typename?: 'Query', migratedTemplate: { __typename?: 'MigratedTemplatePayload', name: string, designId: number, hash: string } };

export type TemplateCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type TemplateCategoriesQuery = { __typename?: 'Query', templateCategories: { __typename?: 'DesignTemplateCategoryPayload', categories: Array<{ __typename?: 'DesignTemplateCategoryItemPayload', id: number, identifier: string, name: string, showInApp: boolean, showInGallery: boolean }> } };

export type TemplateColorTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type TemplateColorTagsQuery = { __typename?: 'Query', templateColorTags: { __typename?: 'DesignTemplateTagPayload', tags: Array<{ __typename?: 'DesignTemplateTagItemPayload', id: number, name: string, showInApp: boolean, showInGallery: boolean, isColor: boolean, isStyle: boolean }> } };

export type TemplateSetDesignsQueryVariables = Exact<{
  input: InputDesign;
}>;


export type TemplateSetDesignsQuery = { __typename?: 'Query', templateSetDesigns: { __typename?: 'TemplateSetDesignsPayload', name: string, designSizeType: string, designSizeTypeCategory: string, height?: number | null, width?: number | null, measureUnit?: string | null, setHash?: string | null, hash: string, setDesignCount?: number | null, hasAnimation: boolean, hasVideo: boolean, filter: { __typename?: 'TemplateSetDesignsFilterPayload', designSizeTypeId?: number | null, tagIds?: Array<number> | null, categoryIds?: Array<number> | null }, sizes: Array<{ __typename?: 'TemplateWebsitePayload', id: number, hash: string, name: string, height: number, width: number, measureUnit?: string | null, hasAnimation: boolean, hasVideo: boolean }>, colors?: Array<{ __typename?: 'TemplateColorPayload', hexCode: string, area: number }> | null } };

export type TemplateStyleTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type TemplateStyleTagsQuery = { __typename?: 'Query', templateStyleTags: { __typename?: 'DesignTemplateTagPayload', tags: Array<{ __typename?: 'DesignTemplateTagItemPayload', id: number, name: string, showInApp: boolean, showInGallery: boolean, isColor: boolean, isStyle: boolean }> } };

export type TemplateTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type TemplateTagsQuery = { __typename?: 'Query', templateTags: { __typename?: 'DesignTemplateTagPayload', tags: Array<{ __typename?: 'DesignTemplateTagItemPayload', id: number, name: string, showInApp: boolean, showInGallery: boolean, isColor: boolean, isStyle: boolean }> } };

export type TemplatesQueryVariables = Exact<{
  input: InputTemplatesWebsite;
}>;


export type TemplatesQuery = { __typename?: 'Query', templates: { __typename?: 'TemplatesWebsitePayload', totalCount: number, templates: Array<{ __typename?: 'TemplateWebsitePayload', id: number, setHash?: string | null, hash: string, name: string, designTypeName?: string | null, width: number, height: number, hasAnimation: boolean, hasVideo: boolean, sizes?: Array<{ __typename?: 'TemplateWebsiteSizePayload', hash: string, width: number, height: number, designSizeTypeId?: number | null } | null> | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type TemplatesSitemapQueryVariables = Exact<{
  input: InputDesignSizeType;
}>;


export type TemplatesSitemapQuery = { __typename?: 'Query', templatesSitemap: { __typename?: 'TemplatesWebsiteSitemapPayload', templates: Array<{ __typename?: 'TemplateWebsiteSitemapPayload', hash: string, name: string, setSizes: Array<{ __typename?: 'TemplateWebsiteSitemapSetSizePayload', hash: string, name: string }> }> } };


export const DesignSizeTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"designSizeTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"designSizeTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"measureUnit"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"video"}},{"kind":"Field","name":{"kind":"Name","value":"static"}},{"kind":"Field","name":{"kind":"Name","value":"animated"}},{"kind":"Field","name":{"kind":"Name","value":"countDesignSizeTypesInSet"}}]}}]}}]} as unknown as DocumentNode;
export const MigratedTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"migratedTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InputDesign"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"migratedTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"designId"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}}]}}]}}]} as unknown as DocumentNode;
export const TemplateCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"templateCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templateCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"showInApp"}},{"kind":"Field","name":{"kind":"Name","value":"showInGallery"}}]}}]}}]}}]} as unknown as DocumentNode;
export const TemplateColorTagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"templateColorTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templateColorTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"showInApp"}},{"kind":"Field","name":{"kind":"Name","value":"showInGallery"}},{"kind":"Field","name":{"kind":"Name","value":"isColor"}},{"kind":"Field","name":{"kind":"Name","value":"isStyle"}}]}}]}}]}}]} as unknown as DocumentNode;
export const TemplateSetDesignsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"templateSetDesigns"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InputDesign"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templateSetDesigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"designSizeType"}},{"kind":"Field","name":{"kind":"Name","value":"designSizeTypeCategory"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"measureUnit"}},{"kind":"Field","name":{"kind":"Name","value":"setHash"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"setDesignCount"}},{"kind":"Field","name":{"kind":"Name","value":"hasAnimation"}},{"kind":"Field","name":{"kind":"Name","value":"hasVideo"}},{"kind":"Field","name":{"kind":"Name","value":"filter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"designSizeTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"tagIds"}},{"kind":"Field","name":{"kind":"Name","value":"categoryIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sizes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"measureUnit"}},{"kind":"Field","name":{"kind":"Name","value":"hasAnimation"}},{"kind":"Field","name":{"kind":"Name","value":"hasVideo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hexCode"}},{"kind":"Field","name":{"kind":"Name","value":"area"}}]}}]}}]}}]} as unknown as DocumentNode;
export const TemplateStyleTagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"templateStyleTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templateStyleTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"showInApp"}},{"kind":"Field","name":{"kind":"Name","value":"showInGallery"}},{"kind":"Field","name":{"kind":"Name","value":"isColor"}},{"kind":"Field","name":{"kind":"Name","value":"isStyle"}}]}}]}}]}}]} as unknown as DocumentNode;
export const TemplateTagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"templateTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templateTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"showInApp"}},{"kind":"Field","name":{"kind":"Name","value":"showInGallery"}},{"kind":"Field","name":{"kind":"Name","value":"isColor"}},{"kind":"Field","name":{"kind":"Name","value":"isStyle"}}]}}]}}]}}]} as unknown as DocumentNode;
export const TemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"templates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InputTemplatesWebsite"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"setHash"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"designTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"hasAnimation"}},{"kind":"Field","name":{"kind":"Name","value":"hasVideo"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"designSizeTypeId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode;
export const TemplatesSitemapDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"templatesSitemap"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InputDesignSizeType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templatesSitemap"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"setSizes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    designSizeTypes(variables?: DesignSizeTypesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DesignSizeTypesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DesignSizeTypesQuery>({ document: DesignSizeTypesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'designSizeTypes', 'query', variables);
    },
    migratedTemplate(variables: MigratedTemplateQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MigratedTemplateQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MigratedTemplateQuery>({ document: MigratedTemplateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'migratedTemplate', 'query', variables);
    },
    templateCategories(variables?: TemplateCategoriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TemplateCategoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TemplateCategoriesQuery>({ document: TemplateCategoriesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'templateCategories', 'query', variables);
    },
    templateColorTags(variables?: TemplateColorTagsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TemplateColorTagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TemplateColorTagsQuery>({ document: TemplateColorTagsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'templateColorTags', 'query', variables);
    },
    templateSetDesigns(variables: TemplateSetDesignsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TemplateSetDesignsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TemplateSetDesignsQuery>({ document: TemplateSetDesignsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'templateSetDesigns', 'query', variables);
    },
    templateStyleTags(variables?: TemplateStyleTagsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TemplateStyleTagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TemplateStyleTagsQuery>({ document: TemplateStyleTagsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'templateStyleTags', 'query', variables);
    },
    templateTags(variables?: TemplateTagsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TemplateTagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TemplateTagsQuery>({ document: TemplateTagsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'templateTags', 'query', variables);
    },
    templates(variables: TemplatesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TemplatesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TemplatesQuery>({ document: TemplatesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'templates', 'query', variables);
    },
    templatesSitemap(variables: TemplatesSitemapQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TemplatesSitemapQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TemplatesSitemapQuery>({ document: TemplatesSitemapDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'templatesSitemap', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;
// Structural duplicate of @thebrief-ai/shared/fonts/types.FontMetrics, inlined
// because this file is copied verbatim by tools/codegen/codegen-add-design-json-types.js
// into several autogenerated outputs across the monorepo. A cross-package
// import there creates a brittle build-order dependency on packages/shared/dist
// that has bitten CI before. Keep this in sync with packages/shared/src/fonts/types.ts.
type FontMetricsValues = {
  version: 1;
  unitsPerEm: number;
  hhea: { ascender: number; descender: number; lineGap: number };
  os2: {
    sTypoAscender: number;
    sTypoDescender: number;
    sTypoLineGap: number;
    usWinAscent: number;
    usWinDescent: number;
    fsSelection: number;
    useTypoMetrics: boolean;
  };
};

export type JsonGradColor = {
  c: string;
  p: number;
};

export type JsonMeasureUnit = 'px' | 'mm' | 'cm' | 'in';

export type JsonUrlTarget = '_blank' | '_self' | '_parent' | '_top';

export const JsonLayerTypeArr = [
  'embed',
  'image',
  'shape',
  'svg',
  'video',
  'audio',
  'text',
  'button',
  'youtube',
  'clipart',
  'countdown',
  'rain',
  'snow',
  'fog',
  'group',
  'frame',
  'flexStrip',
] as const;

export const NotAcceptedLayer = ['menu'];

export type JsonLayerType = (typeof JsonLayerTypeArr)[number];

export type JsonDesignBackground = JsonBackground & {
  borderColor?: string;
  useBorder: boolean;
};

export type EditorLayerFeed = Record<string, string | null>;
export type AdStudioLayerFeedPropertyBind = {
  hash: string;
  column: string;
  index?: string;
} | null;
export type AdStudioLayerFeed = Record<string, AdStudioLayerFeedPropertyBind | AdStudioLayerFeedPropertyBind[]>;

export type JsonPropertiesFeed = EditorLayerFeed | AdStudioLayerFeed;

export function isAdStudioLayerFeedProperty(
  variable: AdStudioLayerFeedPropertyBind | AdStudioLayerFeedPropertyBind[] | string | undefined,
): variable is AdStudioLayerFeedPropertyBind {
  return (
    variable !== null &&
    ((typeof variable === 'object' && 'hash' in variable && 'column' in variable) || Array.isArray(variable))
  );
}

export function isAdStudioLayerFeed(variable: JsonPropertiesFeed): variable is AdStudioLayerFeed {
  return variable !== null && Object.values(variable).some((value) => isAdStudioLayerFeedProperty(value));
}

export function isJsonFontSettings(variable: unknown): variable is JsonFontSettings {
  return (
    typeof variable === 'object' &&
    variable !== null &&
    'fontFamily' in variable &&
    'fontType' in variable &&
    'fontStyle' in variable &&
    'fontWeight' in variable &&
    'fontUrl' in variable
  );
}

export type EditorDesignFeed = {
  hash?: string;
  row?: number;
  name?: string;
  url?: string;
  background?: string;
};

export type AdStudioDesignFeed = {
  hashes?: { hash: string; row: number }[];
  properties?: {
    [key: string]: AdStudioDesignFeedProperty;
  };
  // Row keys (mirrors `DesignFeedAdjustment.adjustedRows`) that have a saved
  // per-row adjustment. Lets raw-json/embed consumers know which rows to fetch
  // the adjustment file for (`{feedHash}_adjustments/{designHash}/{rowKey}`)
  // without probing. Kept in sync client-side from the save/delete mutation
  // response (see useAdjustmentCapture) — the resolved values are NOT stored here.
  adjustments?: string[];
};

export type AdStudioDesignFeedProperty = { hash: string; column: string };

export function isAdStudioDesignFeedProperty(
  variable: Record<string, unknown>,
): variable is AdStudioDesignFeedProperty {
  return (
    typeof variable === 'object' && Object.keys(variable).includes('hash') && Object.keys(variable).includes('column')
  );
}

export function isAdStudioLayerFeedPropertyBind(
  variable: AdStudioLayerFeedPropertyBind | AdStudioLayerFeedPropertyBind[] | string | undefined,
): variable is AdStudioLayerFeedPropertyBind {
  return (
    (variable !== null && typeof variable === 'object' && 'hash' in variable && 'column' in variable) ||
    variable === null
  );
}

export type JsonDesignFeed = EditorDesignFeed | AdStudioDesignFeed;

export function isEditorDesignFeed(variable: JsonDesignFeed): variable is EditorDesignFeed {
  return typeof variable === 'object' && variable !== null && 'hash' in variable;
}

export function isAdStudioDesignFeed(variable: JsonDesignFeed): variable is AdStudioDesignFeed {
  return typeof variable === 'object' && variable !== null && 'hashes' in variable;
}

export type DetailedSnapshotType = {
  note?: string;
  id: string;
  timing: number;
};

export type JsonDesignProperties = {
  sortIndex?: number;
  name: string;
  width: number;
  height: number;
  loop: boolean;
  loopCount?: number;
  imageQuality?: number;
  bannerSize?: string;
  customSize?: boolean;
  presetSize?: boolean;
  backgroundColor?: JsonDesignBackground;
  /** @deprecated */
  lastId: number;
  useHandCursor?: boolean;
  urlTarget?: JsonUrlTarget;
  version?: string;
  showGuidelines: boolean;
  measureUnit: JsonMeasureUnit;
  sizeVariation?: string | null;
  feed?: JsonDesignFeed;
  fallbackImagePosition?: number;
  fallbackImageSlideIndex?: number;
  /** @deprecated */
  snapshots?: number[];
  detailedSnapshots?: DetailedSnapshotType[];
  bannerUrl: string;
  useAsClickTag: boolean;
  editableGeneralProperties?: string[];
  /** @deprecated */
  allEditableContent?: boolean;
  brandkitJsonHash?: string; // Used with fallback fonts to retrieve in the embeds
  brandkitJsonLastUpdated?: number; // Used to update the design when the fallback fonts are updated on brandkitJson
  designPermissions?: GeneralPermissions;
  /** Design-wide custom CSS (untagged) from the General tab; wrapped in <style> and injected into the exported <head>. Advanced authors may paste raw tags. Shared across all sizes. */
  customStyle?: string;
  /** Design-wide custom JS (untagged) from the General tab; wrapped in <script> and appended to the exported <body> (runs after the ad renders). Advanced authors may paste raw tags. Shared across all sizes. */
  customScript?: string;
};

export type JsonRGradPos =
  | 'center center'
  | 'center right'
  | 'center left'
  | 'bottom left'
  | 'bottom center'
  | 'bottom right'
  | 'top left'
  | 'top center'
  | 'custom'
  | 'top right';

export type JsonAlign = 'bottom' | 'center' | 'left' | 'middle' | 'right' | 'top';

export type JsonScaleMode =
  | 'scaleCrop'
  | 'userCrop'
  | 'exactFit'
  | 'maintainAspect'
  | 'noScale'
  | 'tile'
  | 'crop'
  | 'aspect'
  | 'mask'
  | 'stretch';

/**
 * The contain/fit scale mode (Flash SHOW_ALL): scales the image to fit inside
 * the layer WITHOUT clipping the subject. A transparent cutout is set to this on
 * resize so its subject stays whole. NOTE: `'aspect'` is the value used in
 * banner JSON — do NOT confuse it with the alternative `'maintainAspect'`
 * representation (`ScaleModeValue.ts`); they are different strings.
 */
export const CONTAIN_SCALE_MODE: JsonScaleMode = 'aspect';

/**
 * Scale modes that COVER the layer — they scale to fill the frame and clip
 * whatever overflows when the aspect ratio changes. A transparent cutout must
 * avoid these on resize (clipping cuts the subject); it is contained
 * (`CONTAIN_SCALE_MODE`) instead.
 */
export const CLIPPING_SCALE_MODES: ReadonlySet<JsonScaleMode> = new Set(['crop', 'scaleCrop', 'userCrop']);

export type JsonBackgroundType = 'solid' | 'rgrad' | 'lgrad' | 'image' | 'none';

export type JsonBackgroundSolid = {
  type: 'solid';
  scolor: string;
};

export type JsonBackgroundSolidText = JsonBackgroundSolid & {
  feed?: AdStudioLayerFeedPropertyBind;
};

export type JsonBackgroundLinearGradient = {
  type: 'lgrad';
  gradColors: JsonGradColor[];
  backgroundRotation: number;
};

export type JsonBackgroundRadialGradient = {
  type: 'rgrad';
  gradColors: JsonGradColor[];
  rgradPos: JsonRGradPos;
  backgroundRotation?: number;
  gradPosX?: string;
  gradPosY?: string;
  rotation?: number;
  // Ellipse-shape radii in CSS-compatible strings (e.g. `'40.5%'`). When both
  // are present, renderers emit `radial-gradient(ellipse <X> <Y> at …)` so
  // non-circular Figma radials (e.g. the Abanca FONDO horizontal-stripe
  // MULTIPLY vignette where the X-radius is 10× the Y-radius) match the source.
  // Default-undefined → renderers fall back to `circle at …`.
  gradRadiusX?: string;
  gradRadiusY?: string;
};

export type JsonBackgroundGradient = JsonBackgroundLinearGradient | JsonBackgroundRadialGradient;

/**
 * A gradient assigned to one colour group of an SVG layer. Deliberately the SAME
 * shape as the background gradient types: the Ad Studio `BackgroundPicker` already
 * emits exactly these fields, so the picker is reusable with no conversion layer.
 */
export type JsonSvgGradientFill = (JsonBackgroundLinearGradient | JsonBackgroundRadialGradient) & {
  /**
   * Set at intake when the artwork places this group's gradient in a way the fields
   * above cannot express (user-space coordinates, a transform, a focal point, `href`):
   * a snapshot of the direction fields plus a fingerprint of the artwork gradient's
   * placement (`artworkPlacementTag`). While both still match the fill and the artwork
   * the layer shows, renderers draw the artwork's own placement with these stops; any
   * other value falls back to the bounding-box geometry. Renderer-owned: no picker
   * writes it.
   *
   * Optional, and on this type only rather than on the background gradients, for the
   * mirror-skew reason given on `colorGroupGradients`.
   */
  artworkPlacement?: string;
};

/**
 * The effective fill of one SVG colour group: the solid string from `colorGroups`, or
 * the gradient from the sibling `colorGroupGradients` map when that group has one.
 *
 * This is a READ-SIDE convenience only. It is deliberately NOT the type of
 * `JsonSvgProperties.colorGroups`, which stays `Record<string, string>` — see the note
 * on `colorGroupGradients`.
 */
export type JsonSvgFill = string | JsonSvgGradientFill;

export type JsonBackgroundImage = {
  type: 'image';
  originalWidth: number;
  originalHeight: number;
  url: string;
  backgroundRotation?: number;
  scaleMode: JsonScaleMode;
  contentScale?: number;
  horizontalAlign: JsonAlign;
  verticalAlign: JsonAlign;
  contentOffsetX?: number;
  contentOffsetY?: number;
  localUrl?: string;
  hqUrl?: string;
  source?: string;
  hash?: string;
  licensing?: boolean;
  backupUrl?: string;
  focalPoint?: { x: number; y: number };
};

export type JsonBackgroundNone = {
  type: 'none';
};

export interface JsonBackgroundBorder {
  useBorder?: boolean;
  borderColor?: string;
}

export type JsonBackground =
  | JsonBackgroundNone
  | JsonBackgroundSolid
  | JsonBackgroundLinearGradient
  | JsonBackgroundRadialGradient
  | JsonBackgroundImage;

export type JsonBackgroundWithBorder = JsonBackgroundBorder & JsonBackground;

/** Per-corner radii for a text background, in the CSS `border-radius` order. */
export type JsonTextBackgroundCorners = {
  topLeft: number;
  topRight: number;
  bottomRight: number;
  bottomLeft: number;
};

export type JsonTextBackground = {
  mode: 'box' | 'perLine';
  fill: JsonBackground;
  fillEnabled?: boolean;
  border?: { color: string; weight: number };
  borderEnabled?: boolean;
  /**
   * The uniform corner radius, and the fallback for every reader that cannot
   * express four corners — today that is the curved-text SVG `<rect rx>`
   * (getCurveBoxBackgroundRects), which has no per-corner attribute.
   */
  radius?: number;
  /**
   * Per-corner override, winning over `radius` wherever four corners can be
   * drawn. A SIBLING field rather than widening `radius` to
   * `number | {…}` (the shape/button store's shape): JsonDesign.types.ts is
   * inlined verbatim into gitignored generated mirrors, so a fully cached CI
   * run pairs a fresh `shared/dist` with a stale mirror — where a CHANGED
   * field type is a hard assignability error across six projects, while a new
   * OPTIONAL field stays assignable both ways.
   */
  radiusCorners?: JsonTextBackgroundCorners;
};

export type JsonTextGradient =
  | JsonBackgroundNone
  | JsonBackgroundSolidText
  | JsonBackgroundLinearGradient
  | JsonBackgroundRadialGradient
  | JsonBackgroundImage;

export function isJsonBackgroundNone(bg: JsonBackground | undefined): bg is JsonBackgroundNone {
  return bg !== undefined && bg && bg.type === 'none';
}

export function isJsonBackgroundSolid(bg: JsonBackground | undefined): bg is JsonBackgroundSolid {
  return bg !== undefined && bg && bg.type === 'solid';
}

export function isJsonBackgroundSolidText(bg: JsonBackground | undefined): bg is JsonBackgroundSolidText {
  return isJsonBackgroundSolid(bg) && 'feed' in bg;
}

export function isJsonBackgroundLinearGradient(bg: JsonBackground | undefined): bg is JsonBackgroundLinearGradient {
  return bg !== undefined && bg && bg.type === 'lgrad';
}

export function isJsonBackgroundRadialGradient(bg: JsonBackground | undefined): bg is JsonBackgroundRadialGradient {
  return bg !== undefined && bg && bg.type === 'rgrad';
}

export function isJsonBackgroundImage(bg: JsonBackground | undefined): bg is JsonBackgroundImage {
  return bg !== undefined && bg && bg.type === 'image';
}

export function isJsonBackgroundGradient(bg: JsonBackground | undefined): bg is JsonBackgroundGradient {
  return bg !== undefined && bg && (bg.type === 'rgrad' || bg.type === 'lgrad');
}

export function isShapeWithBackgroundImage(element: JsonElement): element is JsonShapeWithBackgroundImage {
  return (
    isShape(element) &&
    !!element.properties?.backgroundColor &&
    isJsonBackgroundImage(element.properties.backgroundColor)
  );
}

export type JsonGuidelines = {
  v: number[];
  h: number[];
};

export type JsonSlideOrElement = JsonSlide | JsonElement;

export function isSlide(element: JsonSlideOrElement | JsonDesign): element is JsonSlide {
  return (element as JsonSlide).type === 'slide';
}

export function isElement(element: JsonSlideOrElement | JsonDesign): element is JsonElement {
  return (element as JsonElement).type === 'layer';
}

export function isDesign(element: JsonSlideOrElement | JsonDesign): element is JsonDesign {
  return !isElement(element) && !isSlide(element);
}

export function isJsonDesign(element: JsonDesign | JsonDesignSet): element is JsonDesign {
  return 'properties' in element && 'elements' in element;
}

export function isText(element: JsonElement): element is JsonText {
  return element.layerType === 'text';
}

export function isSvg(element: JsonElement): element is JsonSvg {
  return element.layerType === 'svg';
}

export function isAudio(element: JsonElement): element is JsonAudio {
  return element.layerType === 'audio';
}

export function isImage(element: JsonElement): element is JsonImage {
  return element.layerType === 'image';
}

export function isVideo(element: JsonElement): element is JsonVideo {
  return element.layerType === 'video';
}

export function isShape(element: JsonElement): element is JsonShape {
  return element.layerType === 'shape';
}

export function isEmbed(element: JsonElement): element is JsonEmbed {
  return element.layerType === 'embed';
}

export function isButton(element: JsonElement): element is JsonButton {
  return element.layerType === 'button';
}

export function isClipart(element: JsonElement): element is JsonClipart {
  return element.layerType === 'clipart';
}

export function isYoutube(element: JsonElement): element is JsonYoutube {
  return element.layerType === 'youtube';
}

export function isCountdown(element: JsonElement): element is JsonCountdown {
  return element.layerType === 'countdown';
}

type BuildWithAdvanced = { advancedProperties?: AdvancedProperties };

/**
 * True when any build phase (in/mid/out) carries a Resize advanced action — one predicate shared by the
 * editor and the html-next export.
 */
export function hasResizeAdvancedAction(
  properties:
    | { buildIn?: BuildWithAdvanced; buildMid?: BuildWithAdvanced; buildOut?: BuildWithAdvanced }
    | null
    | undefined,
): boolean {
  const { buildIn, buildMid, buildOut } = properties ?? {};
  return [buildIn, buildMid, buildOut].some(
    (build) => (build?.advancedProperties?.[AdvancedPanelItems.RESIZE]?.length ?? 0) > 0,
  );
}

export function isGroup(element: JsonElement): element is JsonGroup {
  return element.layerType === 'group';
}

export function isFrame(element: JsonElement): element is JsonFrame {
  return element.layerType === 'frame';
}

export function isGroupOrFrame(element: JsonElement): element is JsonGroup | JsonFrame {
  return isGroup(element) || isFrame(element);
}

export function isFlexStrip(element: JsonElement): element is JsonFlexStrip {
  return element.layerType === 'flexStrip';
}

export function isWeather(element: JsonElement): element is JsonRain | JsonSnow | JsonFog {
  return ['fog', 'rain', 'snow'].includes(element.layerType);
}

export function isMedia(element: JsonElement): element is JsonElementMedia {
  return isImage(element) || isSvg(element) || isVideo(element) || isAudio(element);
}

/**
 * The ISI convention: a layer whose name starts with `ISI:` (case-insensitive) is Important Safety
 * Information. Used by `hasIsiText` (does a design need an ISI export at all), by html-next's ISI-only
 * filter and by its Veeva screengrab render (which autoscroll box gets the reviewer-visible scrollbar).
 */
export function isIsiLayerName(layerName: string | null | undefined): boolean {
  return !!layerName && layerName.toLowerCase().startsWith('isi:');
}

export function hasIsiText(json: { elements: JsonGroup[] }): boolean {
  // Check if any element in the entire design has a layer name starting with "isi:"
  return json.elements.some((element: JsonGroup) => {
    if (isElement(element) && isEmbed(element)) {
      return isIsiLayerName((element as JsonElement).properties.layerName);
    } else if (isSlide(element) && (element as JsonSlide).elements) {
      const slide = element as JsonSlide;
      // For slide elements, check their child elements
      return slide.elements.some(
        (childElement) =>
          isElement(childElement) &&
          (isText(childElement) || isEmbed(childElement)) &&
          isIsiLayerName(childElement.properties.layerName),
      );
    } else if (isElement(element) && isText(element)) {
      // For direct text elements
      return isIsiLayerName((element as JsonElement).properties.layerName);
    }
    return false;
  });
}

export function hasAnimation({ properties: { buildIn, buildMid, buildOut } }: JsonElement) {
  if (!buildOut || !buildMid || !buildIn) {
    return false;
  }

  return buildIn.type !== 'none' || buildMid.type !== 'none' || buildOut.type !== 'none';
}

export function hasTextWithShrinkBehavior({
  properties: { config },
}: {
  properties: JsonTextProperties | JsonFlexStripProperties;
}) {
  return config?.boundary?.type === JsonTextContentBoundary.shrink;
}

export function hasTextWithAutoscrollBehavior({
  properties: { config },
}: {
  properties: JsonTextProperties | JsonFlexStripProperties;
}) {
  return config?.boundary?.type === JsonTextContentBoundary.autoscroll;
}

export function isAnimated(element: JsonElement): element is JsonAnimatedElement {
  return (
    hasAnimation(element) ||
    isVideo(element) ||
    isAudio(element) ||
    isYoutube(element) ||
    isEmbed(element) ||
    isCountdown(element) ||
    isWeather(element) ||
    (isText(element) && hasTextWithAutoscrollBehavior(element))
  );
}

export type JsonSlide = {
  properties: JsonSlideProperties;
  type: 'slide';
  elements: JsonElement[];
};

export type JsonTransitionType =
  | JsonTransitionAll['type']
  | 'none'
  | 'instant'
  | 'alpha'
  | 'alpha-words'
  | 'blur'
  | 'blur-words'
  | 'slide'
  | 'slideBounce'
  | 'slideElastic'
  | 'roll'
  | 'zoom'
  | 'flip'
  | 'rotate'
  | 'scale'
  | 'show'
  | 'tilt'
  | 'fly'
  | 'swing'
  | 'step'
  | 'hide'
  | 'cross'
  | 'slit'
  | 'scaleBounce'
  | 'scaleElastic'
  | 'vibrate'
  | 'flicker'
  | 'shake'
  | 'jello'
  | 'bounce'
  | 'pulsate'
  | 'blink'
  | 'video'
  | 'audio'
  | 'advanced'
  | 'shadowPop'
  | 'fadeAudio'
  | 'swing'
  | 'fly'
  | 'tilt'
  | 'slit'
  | 'step'
  | 'kenBurns'
  | 'gradientAnimation'
  | 'tracking'
  | 'highlight';

export type JsonTransitionTypeSlide =
  | 'none'
  | 'alpha'
  | 'blur'
  | 'slide'
  | 'slideBounce'
  | 'slideElastic'
  | 'scale'
  | 'scaleElastic'
  | 'scaleBounce'
  | 'roll'
  | 'zoom'
  | 'flip'
  | 'rotate'
  | 'swing'
  | 'fly'
  | 'tilt'
  | 'slit'
  | 'step';

export type JsonTransitionCrossType = 'cross' | 'hide' | 'show';

export type JsonTransitionDirection =
  | 'custom'
  | 'l2r'
  | 'r2l'
  | 't2b'
  | 'b2t'
  | 'top'
  | 'left'
  | 'right'
  | 'bottom'
  | 'topRight'
  | 'topLeft'
  | 'bottomRight'
  | 'bottomLeft'
  | 'forward'
  | 'backward'
  | 'center'
  | 'vertical'
  | 'horizontal'
  | 'random'
  | 'topForward'
  | 'topBack'
  | 'rightForward'
  | 'rightBack'
  | 'bottomForward'
  | 'bottomBack'
  | 'leftForward'
  | 'leftBack';

export type JsonSlideTransition = JsonTransition & {
  type: JsonTransitionTypeSlide;
  crosstype: JsonTransitionCrossType;
  duration: number;
};

export type JsonTweenType =
  | 'Sine'
  | 'Quad'
  | 'Cubic'
  | 'Quart'
  | 'Quint'
  | 'Expo'
  | 'Circ'
  | 'Strong'
  | 'Bounce'
  | 'Back'
  | 'Elastic';

export type JsonEaseType = 'linear' | 'ease' | 'easeIn' | 'easeOut' | 'easeInOut';

export type AdvancedMoveProperty = {
  delay: number;
  duration: number;
  fromX: number;
  toX: number;
  fromY: number;
  toY: number;
  tween: JsonTweenType;
  ease: JsonEaseType;
  // Optional quadratic-bezier control point (absolute canvas coords) bending THIS segment into a
  // curve for the "Path" animation. Absent → straight segment (a control at the segment midpoint is
  // the straight line, so old data is unchanged). Read by the shared `samplePathPoints` sampler.
  cx?: number;
  cy?: number;
  // The "Path" animation's global Curve amount, 0–1: how far the auto-smooth curve bends through the
  // anchors (`0` a straight polyline, `1` the full curve). Written uniformly across every segment of
  // a Path like `ease`; absent → the full curve, so pre-Curve-control paths are unchanged. Resolved
  // by the shared `resolvePathTension` and applied by `samplePathPoints`.
  tension?: number;
};

export type AdvancedOpacityProperty = {
  delay: number;
  duration: number;
  from: number;
  to: number;
  tween: JsonTweenType;
  ease: JsonEaseType;
};

export type AdvancedBlurProperty = {
  delay: number;
  duration: number;
  from: number;
  to: number;
  tween: JsonTweenType;
  ease: JsonEaseType;
};

export type AdvancedRotateProperty = {
  delay: number;
  duration: number;
  from: number;
  to: number;
  tween: JsonTweenType;
  ease: JsonEaseType;
};

export type AdvancedScaleProperty = {
  delay: number;
  duration: number;
  from: [number, number];
  to: [number, number];
  tween: JsonTweenType;
  ease: JsonEaseType;
  transformOrigin?: {
    from: string;
    to: string;
  };
};

export type AdvancedResizeProperty = {
  delay: number;
  duration: number;
  from: [number, number];
  to: [number, number];
  tween: JsonTweenType;
  ease: JsonEaseType;
  transformOrigin?: {
    from: string;
    to: string;
  };
};

export enum AdvancedPanelItems {
  MOVE = 'move',
  ROTATE = 'rotate',
  SCALE = 'scale',
  RESIZE = 'resize',
  OPACITY = 'opacity',
  BLUR = 'blur',
}

export const AdvancedPanelItemsValues = Object.values(AdvancedPanelItems);

export type AdvancedProperties = {
  [AdvancedPanelItems.MOVE]: AdvancedMoveProperty[];
  [AdvancedPanelItems.ROTATE]: AdvancedRotateProperty[];
  [AdvancedPanelItems.SCALE]: AdvancedScaleProperty[];
  [AdvancedPanelItems.RESIZE]: AdvancedResizeProperty[];
  [AdvancedPanelItems.OPACITY]: AdvancedOpacityProperty[];
  [AdvancedPanelItems.BLUR]: AdvancedBlurProperty[];
};

// export type JsonTransition = {
//     type: JsonTransitionType;
//     direction: JsonTransitionDirection;
//     duration: number;
//     delay: number;
//     tween: JsonTweenType;
//     ease: JsonEaseType;
//     wordsDuration?: number;
//     wordsAppearOrder?: 'l2r' | 'r2l';
//     slidePosX: number;
//     slidePosY: number;
//     alphaOffset: number;
//     slideOffset: number;
//     blurAmount: number;
//     zoom: number;
//     preset: string;
//     color?: string;
//     shadowLength?: number;
//     advancedProperties?: AdvancedProperties;
// };

type JsonTransitionBase = {
  id?: number | null;
  duration: number;
  delay: number;
  preset?: string;
  // Display-only: the preset this animation started from before its properties were customised
  // (which decouples `preset` to 'none'). Lets the UI keep showing the preset's name marked as
  // customised. Never affects playback. Absent on transitions predating the field.
  presetLabel?: string;
  tween: JsonTweenType;
  ease: JsonEaseType;
  advancedProperties?: AdvancedProperties;
};

export type JsonTransitionEffFlip = JsonTransitionBase & {
  type: 'flip';
  deg?: number;
  alphaOffset: number;
  direction: 'bottom' | 'top' | 'right' | 'left' | 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight';
};

export type JsonTransitionEffFly = JsonTransitionBase & {
  type: 'fly';
  alphaOffset: number;
  slideOffset: number;
  direction:
    | 'topBack'
    | 'topForward'
    | 'rightBack'
    | 'rightForward'
    | 'bottomBack'
    | 'bottomForward'
    | 'leftBack'
    | 'leftForward';
};

export type JsonTransitionEffShadowPop = JsonTransitionBase & {
  type: 'shadowPop';
  alphaOffset: number;
  color: string;
  shadowLength: number;
  direction: 'bottom' | 'top' | 'right' | 'left' | 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight';
};

export type WordTiming = {
  start: number;
  end: number;
};

export type JsonTransitionEffHighlight = JsonTransitionBase & {
  type: 'highlight';
  color: string;
  wordsDuration: number;
  wordTimings?: WordTiming[];
  wordsAppearOrder?: 'l2r' | 'r2l';
};

export type JsonTransitionEffTilt = JsonTransitionBase & {
  type: 'tilt';
  alphaOffset: number;
  slideOffset: number;
  direction: 'bottom' | 'top' | 'right' | 'left' | 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight';
};

export type JsonTransitionEffSwing = JsonTransitionBase & {
  type: 'swing';
  alphaOffset: number;
  slideOffset: number;
  direction: 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight';
};

export type JsonTransitionEffRotate = JsonTransitionBase & {
  type: 'rotate';
  alphaOffset: number;
  direction: 'forward' | 'backward';
};

export type JsonTransitionEffSlit = JsonTransitionBase & {
  type: 'slit';
  alphaOffset: number;
  direction: 'horizontal' | 'vertical' | 'topLeft' | 'topRight';
};

// TODO: JsonTransitionBase should not be here
export type JsonTransitionEffNone = JsonTransitionBase & {
  type: 'none';
};

// TODO: JsonTransitionBaseMid should not be here
export type JsonTransitionEffNoneMid = JsonTransitionBaseMid & {
  type: 'none';
};

export type JsonTransitionEffAudio = JsonTransitionBaseMid & {
  type: 'audio';
};

// TODO: JsonTransitionBase should not be here, only duration and delay
export type JsonTransitionEffInstant = JsonTransitionBase & {
  type: 'instant';
};

// TODO: JsonTransitionBaseMid should not be here
export type JsonTransitionEffInstantMid = JsonTransitionBaseMid & {
  type: 'instant';
};

export type JsonTransitionEffZoom = JsonTransitionBase & {
  type: 'zoom';
  alphaOffset: number;
  blurAmount: number;
  zoom: number;
  direction: 'l2r' | 'r2l' | 't2b' | 'b2t';
};

type JsonTransitionEffSlideBase = JsonTransitionBase & {
  direction: 'custom' | 'l2r' | 'r2l' | 't2b' | 'b2t';
  slidePosX: number;
  slidePosY: number;
  slideOffset: number;
  alphaOffset: number;
};

export type JsonTransitionEffSlide = JsonTransitionEffSlideBase & {
  type: 'slide';
};

export type JsonTransitionEffSlideBounce = JsonTransitionEffSlideBase & {
  type: 'slideBounce';
};

export type JsonTransitionEffSlideElastic = JsonTransitionEffSlideBase & {
  type: 'slideElastic';
};

export type JsonTransitionEffRoll = JsonTransitionEffSlideBase & {
  type: 'roll';
  blurAmount: number;
};

export type JsonTransitionEffFadeAudio = JsonTransitionBase & {
  type: 'fadeAudio';
};

export type JsonTransitionEffScale = JsonTransitionBase & {
  type: 'scale';
  direction: 'center' | 'topRight' | 'bottomRight' | 'bottomLeft' | 'topLeft' | 'l2r' | 'r2l' | 't2b' | 'b2t';
};

export type JsonTransitionEffSpreadFocus = JsonTransitionBase & {
  type: 'spreadFocus';
  // Edge softness (0-100). Drives the radial-gradient mask feather; the iris size
  // is driven by the timeline, not by this value.
  fade: number;
  // Focus-pull depth in px (0-40). The content animates `filter: blur(this) -> 0`
  // as the aperture opens, so the reveal reads as focus spreading from the center.
  // Absent/0 => no blur (the render path adds no `filter`, so pre-blur designs are
  // unchanged). Seeded to 12 only when the preset is freshly applied.
  blur?: number;
};

export type JsonTransitionEffFlash = JsonTransitionBase & {
  type: 'flash';
  // Flash intensity (0-100). Scales the starting blur + brightness + contrast;
  // the alpha (opacity 0 -> 1) is fixed.
  intensity: number;
};

// "Memory Book" / scrapbook: a build-IN entrance (gated behind NEW_ANIMATIONS). A stop-motion
// "placed photo" entrance — the element JUMPS in from OFF-canvas, in the `direction` corner and
// TILTED, through a few DISCRETE frames with NO tween between them (CSS `steps(frames, jump-none)`),
// settling straight (translate 0, rotate 0) at rest. transform-only (GPU-cheap, no drop-shadow, no
// cloned copies). Applied identically by the eff.js editor builder and html-next `keyframes/
// scrapbook.ts` (byte-parity). `direction: 'random'` resolves to a STABLE per-element corner keyed
// off the element id, so editor-live / frame-seek-export / embed always agree.
export type JsonTransitionEffScrapbook = JsonTransitionBase & {
  type: 'scrapbook';
  // Corner (or edge) the "photo" is flung in from; the tilt is derived from it (leading corner up).
  // `random` picks a stable corner per element (seeded by the element id, resolved once in the
  // builder — never re-randomized per frame/render). `custom` means the user dragged Slide's offset
  // gizmo to pick the EXACT off-canvas start point — the builder then reads `slidePosX`/`slidePosY`
  // (px, canvas-space) instead of the direction×`slideOffset` preset, and derives the tilt from the
  // drag vector.
  direction:
    | 'topLeft'
    | 'topRight'
    | 'bottomLeft'
    | 'bottomRight'
    | 'top'
    | 'bottom'
    | 'left'
    | 'right'
    | 'random'
    | 'custom';
  // Number of discrete stop-motion snaps (2-8, default 4 when absent). Fed to `steps(frames,
  // jump-none)` so the element holds `frames` distinct positions with no interpolation.
  frames: number;
  // Off-canvas start distance toward the corner, in PIXELS (canvas-relative, like `slide`'s
  // slideOffset) — NOT a percentage of the element's own box. A canvas-relative px origin keeps the
  // intermediate stop-motion frames on-canvas regardless of element size (a large element used to be
  // flung ~220% of its OWN box away, landing every snap fully off-canvas). Defaults to a sensible px
  // value in the builder when absent.
  slideOffset: number;
  // Exact off-canvas start point (px, canvas-space) used ONLY when `direction === 'custom'` — written
  // by Slide's draggable offset gizmo (reused for scrapbook via its allowlist). Ignored for the
  // directional presets, which derive the start from direction×`slideOffset`.
  slidePosX: number;
  slidePosY: number;
};

// "Slam": a build-IN impact entrance (gated behind NEW_ANIMATIONS). The element DROPS in OVERSIZED
// (scale) + transparent and SLAMS to rest with a hard landing — squash past rest, small rebound,
// settle to scale(1) — plus a tiny self-shake (±px translate jitter) right at impact. transform +
// opacity ONLY (GPU-composited — deliberately NOT drop-shadow/filter-animated so there is no lag).
// A single `intensity` (0-100, default 50) scales the oversized start, the squash/rebound overshoot
// and the shake amplitude together. Duration comes from the timeline build-in slot (no bespoke
// duration control). Applied identically by the eff.js editor builder and html-next `keyframes/
// slam.ts` (byte-parity).
export type JsonTransitionEffSlam = JsonTransitionBase & {
  type: 'slam';
  // Impact strength (0-100, default 50). Scales the oversized start scale, the squash/rebound
  // overshoot and the self-shake amplitude in lockstep (like Flash's single intensity slider).
  intensity: number;
};

// "Split slam": a build-IN impact entrance for IMAGE layers (gated behind NEW_ANIMATIONS). The
// artwork is split in two across the middle; the halves SLAM in from opposite sides under a heavy
// HORIZONTAL motion smear that ramps down, a brightness FLASH fires as they meet, and the scale
// overshoots and settles.
//
// The smear is real directional blur, which CSS has no primitive for (`filter: blur()` takes ONE
// length for both axes, and a filter list containing an SVG `url()` interpolates DISCRETELY so it
// cannot ramp). It is produced instead by the squash→blur→stretch trick: the wrapper stretches by
// `K`, each half pre-squashes by `1/K` inside it, and the wrapper's isotropic blur therefore lands
// K× wider than it is tall. `K` is fixed at 8 (visually ≈ an SVG `stdDeviation="24 0"`).
//
// `intensity` (0-100, default 50) is the ONE magnitude knob: it scales the blur, the flash and the
// entry overshoot together. `direction` picks which side each half comes from ('l2r' = top half
// from the left / bottom half from the right; 'r2l' mirrors it). Duration comes from the timeline
// build-in slot (no bespoke duration control). Applied identically by the eff.js editor builder and
// html-next `keyframes/splitSlam.ts` (byte-parity). AMP4ADS allows only opacity/transform — no
// filter, no pseudo-elements — so export-amp degrades it to a plain fade (presets/splitSlam.js).
export type JsonTransitionEffSplitSlam = JsonTransitionBase & {
  type: 'split-slam';
  // Impact strength (0-100, default 50). Scales the motion-smear blur, the impact flash and the
  // entry scale overshoot in lockstep (like Slam's / Flash's single intensity slider).
  intensity: number;
  // Which side the halves come from: 'l2r' (top from the left, bottom from the right) or 'r2l'
  // (mirrored). Only those two values are meaningful — the split is horizontal.
  direction: string;
};

// "Skid": a Slide-family build-IN / build-OUT entrance (gated behind NEW_ANIMATIONS). The element
// travels in from OFF-canvas along `direction`, OVERSHOOTS past rest and BRAKE-SQUASHES to settle — a
// fast-in, hard-decel skid. The energy is a MOTION-SMEAR: a per-axis scale proportional to the travel
// unit vector's components (works for cardinal AND `custom` directions, no rotate). transform +
// opacity ONLY (GPU-composited — no lag). `slideOffset` (px, canvas-relative) is the off-canvas start
// distance; `direction: 'custom'` (Slide's reused come-from handle) reads slidePosX/slidePosY. Applied
// identically by eff.js and html-next (byte-parity).
export type JsonTransitionEffSkid = JsonTransitionBase & {
  type: 'skid';
  // Axis the element travels in along (Slide's set). `custom` means the user dragged Slide's offset
  // gizmo to pick the EXACT off-canvas start point — the builder then reads slidePosX/slidePosY.
  direction: 'custom' | 'l2r' | 'r2l' | 't2b' | 'b2t';
  // Off-canvas start distance in PIXELS (canvas-relative, like Slide). Defaults to 400 in the builder
  // when absent. Also drives the overshoot magnitude (ov = 0.09 * slideOffset).
  slideOffset: number;
  // Exact off-canvas start point (px, canvas-space) used ONLY when `direction === 'custom'` — written
  // by Slide's draggable offset gizmo. Ignored for the directional presets.
  slidePosX: number;
  slidePosY: number;
};

// "TV collapse" (shown to users as "TV"): a build-IN / build-OUT transition (gated behind
// NEW_ANIMATIONS) that opens and closes a layer the way a TV screen powers on and off — the picture
// is revealed from (or closes into) a thin white-hot line across the middle and, on the `dot` finish,
// from a centre dot. Build-IN opens; build-OUT replays the same keyframes reversed, so it closes.
//
// THE ARTWORK IS NEVER DISTORTED. A real CRT genuinely squashes its raster into the line, and the
// first cut of this animation did the same with `transform: scaleY(0.012)` — but squashing a photo
// skews it, which is unusable for ad artwork. The layer instead sits at its true geometry underneath
// an animated MASK whose band grows from a hairline to the full box. What actually reads as "TV" is
// the white-hot line and the desaturated flash, not the distortion: with plain `brightness()` the
// revealed hairline renders in the picture's own colour and looks like a sliver of photo, so the line
// phase runs `brightness(3.2) saturate(0.15)` to drive it white-hot, and a glow overlay supplies the
// soft CRT bloom the hard-edged band cannot.
//
// Mechanism notes: the mask IMAGE is static and only `mask-size` animates (a mask declared inside
// `@keyframes` never repaints in LIVE playback while the frame-seek looks fine — the family trap that
// hid the blinds bug), the mask sits on the animated wrapper's CHILD so it cannot clip the glow
// line's bloom (render order is filter -> clip -> mask), and it rests grown PAST the box so it never
// clips a layer's drop-shadow once the build has ended.
//
// Applied identically by the eff.js editor builder and html-next `keyframes/tvCollapse.ts`
// (byte-parity). AMP4ADS allows only opacity/transform in keyframes — `mask-*` is rejected outright,
// exactly as it is for `reveal` — so export-amp degrades it to a plain fade (presets/tvCollapse.js).
export type JsonTransitionEffTvCollapse = JsonTransitionBase & {
  type: 'tvCollapse';
  // Which axis the picture opens ALONG: 'vertical' reveals from a HORIZONTAL line (the TV classic),
  // 'horizontal' from a VERTICAL one.
  axis: 'vertical' | 'horizontal';
  // Where the collapse ends: 'line' stops at the hot line and fades; 'dot' contracts that line to a
  // centre dot first (the retro CRT power-off).
  finish: 'line' | 'dot';
  // Strength of the glow-line overlay, 0-100 (default 60). Drives its peak opacity AND its bloom
  // (box-shadow blur/spread) together. 0 drops the overlay entirely — the reveal then reads as a
  // plain desaturated band opening.
  lineGlow: number;
};

// "Drift": a build-IN slide-family entrance (gated behind NEW_ANIMATIONS). The element enters from a
// come-from direction (like Slide) but travels a soft CURVED arc — bowing out along the PERPENDICULAR
// of the come-from vector to a mid-flight "belly", then decaying to rest — with a gentle scale
// "float" (0.98 -> 1). transform + opacity ONLY (GPU-composited — deliberately NOT drop-shadow/
// filter). Applied identically by the eff.js editor builder and html-next `keyframes/drift.ts`
// (byte-parity).
export type JsonTransitionEffDrift = JsonTransitionBase & {
  type: 'drift';
  // Come-from side (like Slide): l2r/r2l/t2b/b2t, or `custom` when the user dragged Slide's reused
  // offset gizmo (the builder then reads slidePosX/slidePosY instead of direction×slideOffset).
  direction: 'l2r' | 'r2l' | 't2b' | 'b2t' | 'custom';
  // Come-from distance toward the element, in PIXELS (canvas-relative, like Slide). Also drives the
  // magnitude of the perpendicular arc bow + the settle. Defaults to a sensible px value in the
  // builder when absent.
  slideOffset: number;
  // Exact come-from start point (px, canvas-space) used ONLY when `direction === 'custom'` — written
  // by Slide's draggable offset gizmo (reused for Drift via its allowlist). Ignored for the
  // directional presets, which derive the start from direction×slideOffset.
  slidePosX: number;
  slidePosY: number;
};

// "Whip": a Slide-family build-IN / build-OUT entrance (gated behind NEW_ANIMATIONS). Like Skid the
// element travels in from OFF-canvas along `direction`, but the drama is a DRAMATIC per-axis stretch
// (motion-smear) that SNAPS: the position lands clean at rest early while the scale over-stretches,
// snap-compresses, tiny counter-bounces, then settles. transform + opacity ONLY (GPU-composited — no
// lag). `slideOffset` (px, canvas-relative) is the off-canvas start distance; `direction: 'custom'`
// (Slide's reused come-from handle) reads slidePosX/slidePosY. Applied identically by eff.js and
// html-next (byte-parity).
export type JsonTransitionEffWhip = JsonTransitionBase & {
  type: 'whip';
  // Axis the element travels in along (Slide's set). `custom` means the user dragged Slide's offset
  // gizmo to pick the EXACT off-canvas start point — the builder then reads slidePosX/slidePosY.
  direction: 'custom' | 'l2r' | 'r2l' | 't2b' | 'b2t';
  // Off-canvas start distance in PIXELS (canvas-relative, like Slide). Defaults to 400 in the builder
  // when absent.
  slideOffset: number;
  // Exact off-canvas start point (px, canvas-space) used ONLY when `direction === 'custom'` — written
  // by Slide's draggable offset gizmo. Ignored for the directional presets.
  slidePosX: number;
  slidePosY: number;
};

// "Slingshot": a build-IN slide-family entrance (gated behind NEW_ANIMATIONS). The element starts held
// at its come-from point (like Slide), pulls 15% FURTHER out (anticipation wind-up), then LAUNCHES
// across — overshooting PAST rest — before a small settle-back to rest. translate ONLY (no scale — the
// drama is the wind-up -> overshoot). transform + opacity ONLY (GPU-composited — deliberately NOT
// drop-shadow/filter). Applied identically by the eff.js editor builder and html-next
// `keyframes/slingshot.ts` (byte-parity).
export type JsonTransitionEffSlingshot = JsonTransitionBase & {
  type: 'slingshot';
  // Come-from side (like Slide): l2r/r2l/t2b/b2t, or `custom` when the user dragged Slide's reused
  // offset gizmo (the builder then reads slidePosX/slidePosY instead of direction×slideOffset). The
  // launch/overshoot travels along this axis.
  direction: 'l2r' | 'r2l' | 't2b' | 'b2t' | 'custom';
  // Come-from distance toward the element, in PIXELS (canvas-relative, like Slide). Also drives the
  // wind-up + launch overshoot magnitudes. Defaults to a sensible px value in the builder when absent.
  slideOffset: number;
  // Exact come-from start point (px, canvas-space) used ONLY when `direction === 'custom'` — written
  // by Slide's draggable offset gizmo (reused for Slingshot via its allowlist). Ignored for the
  // directional presets, which derive the start from direction×slideOffset.
  slidePosX: number;
  slidePosY: number;
};

// --- registry animations (gated behind NEW_ANIMATIONS) ---
export type JsonTransitionEffSkew = JsonTransitionBase & {
  type: 'skew';
  // Which way the layer shears on entry before de-skewing upright with an overshoot.
  direction: 'left' | 'right';
};
export type JsonTransitionEffSquash = JsonTransitionBase & {
  type: 'squash';
  // Which axis stretches on entry before snapping to normal with an overshoot.
  direction: 'vertical' | 'horizontal';
};
export type JsonTransitionEffRock = JsonTransitionBaseMid & {
  type: 'rock';
  // A gentle continuous pendulum sway about a pinned off-center pivot (ambient "life"
  // for badges). `variation` picks the pivot: 'vertical' hangs/swings from the bottom
  // (transform-origin: bottom center); 'horizontal' rocks around a left-side pin
  // (transform-origin: center left). Timing (motionTime/duration/ease/tween) comes from
  // the base + build-mid config; the sway is one fixed cycle (0deg -> 3deg -> 0deg ->
  // -3deg -> 0deg, so 0% ≡ 100% and it loops cleanly).
  variation: 'vertical' | 'horizontal';
};
// The `reveal` family: ONE transition type whose soft-edged mask reveal is selected by
// `variation`. `wipe` ships first; iris/clock/blinds/zigzag are sibling PRs that only add
// a renderer `case` for their variation. The full `variation` union is declared here now
// so the data model + every codegen'd mirror stay stable ahead of those PRs.
export type JsonTransitionEffReveal = JsonTransitionBase & {
  type: 'reveal';
  variation: 'wipe' | 'iris' | 'clock' | 'blinds' | 'zigzag';
  // Direction the reveal edge travels across the element (linear variations).
  direction: 'l2r' | 'r2l' | 't2b' | 'b2t';
  // Soft-edge (feather) width of the reveal, 0 (hard edge) - 100 (very soft).
  softness: number;
  // How many strips the element is divided into. Used by `blinds` (venetian slats, 2-12) AND by
  // `zigzag` (serpentine bands, 3-15) — the same concept, so one field serves both rather than
  // adding a near-duplicate. Optional; the engines default to 5 when absent (old designs) or
  // invalid, and each variation clamps to its own range. Ignored by wipe/iris/clock.
  blindsCount?: number;
  // Where the `clock` sweep begins, in degrees clockwise from 12 o'clock (0 = 12, 90 = 3 o'clock).
  // Optional; defaults to 0. Ignored by every other variation.
  startAngle?: number;
  // Which way the `clock` sweep travels. Optional; defaults to 'cw'. Ignored by every other variation
  // — a linear reveal uses `direction` (l2r/r2l/...), which has no meaning for a radial sweep.
  sweepDirection?: 'cw' | 'ccw';
};
export type JsonTransitionEffFloat = JsonTransitionBaseMid & {
  type: 'float';
  // A seamless looping 3D bob (ambient premium "floating" loop). No extra params:
  // timing (motionTime/duration/ease/tween) comes from the base + build-mid config;
  // the keyframes are a single fixed cycle (0% ≡ 100% so it loops cleanly).
};
export type JsonTransitionEffShimmer = JsonTransitionBaseMid & {
  type: 'shimmer';
  // Soft glimmer sweep direction (left-to-right or right-to-left) of the diffuse band.
  direction: 'l2r' | 'r2l';
};

export type JsonTransitionEffKenBurns = JsonTransitionBase & {
  type: 'kenBurns';
  direction: 'top' | 'topRight' | 'right' | 'bottomRight' | 'bottom' | 'bottomLeft' | 'left' | 'topLeft' | 'center';
  alphaOffset: number;
};

export type JsonTransitionEffTracking = JsonTransitionBase & {
  type: 'tracking';
  letterSpacingType: string;
  expandLetterSpacing: number;
  contractLetterSpacing: number;
  alphaOffset: number;
};

export type JsonTransitionEffScaleElastic = JsonTransitionBase &
  Pick<JsonTransitionEffScale, 'direction'> & {
    type: 'scaleElastic';
  };
export type JsonTransitionEffScaleBounce = JsonTransitionBase &
  Pick<JsonTransitionEffScale, 'direction'> & {
    type: 'scaleBounce';
  };

export type JsonTransitionEffStep = JsonTransitionBase & {
  type: 'step';
  direction: 'top' | 'topRight' | 'right' | 'bottomRight' | 'bottom' | 'bottomLeft' | 'left' | 'topLeft' | 'center';
  alphaOffset: number;
  slideOffset: number;
};

export type JsonTransitionEffAlpha = JsonTransitionBase & {
  type: 'alpha';
};

export type JsonTransitionEffBlur = JsonTransitionBase & {
  type: 'blur';
  blurAmount: number;
};

// TODO: not final
export type JsonTransitionEffAlphaWords = JsonTransitionBase & {
  type: 'alpha-words';
  wordsAppearOrder: 'l2r' | 'r2l' | 'random';
  wordsDuration: number;
  wordTimings?: WordTiming[];
};

// TODO: not final
export type JsonTransitionEffBlurWords = JsonTransitionBase & {
  type: 'blur-words';
  blurAmount: number;
  wordsAppearOrder: 'l2r' | 'r2l' | 'random';
  wordsDuration: number;
};

// The `words-motion` family: ONE gated (NEW_ANIMATIONS) word-level transition type whose per-word
// reveal is selected by `variation`. Each word combines opacity 0->1 + filter blur->0 + a per-word
// transform (the variation): scaleDown (scale 1.3->1), pop (scale 0.6->1.05->1 overshoot), rise
// (translateY 12px->0), falling (translateY -12px->0), slide (translateX -20px->0). Reuses the
// alpha-words/blur-words word-split + per-word stagger; build-out plays the same keyframes reversed.
// The full `variation` union is declared here so the data model + every codegen'd mirror stay stable
// across the preset entries.
export type JsonTransitionEffWordsMotion = JsonTransitionBase & {
  type: 'words-motion';
  variation: 'scaleDown' | 'pop' | 'rise' | 'falling' | 'slide';
  wordsAppearOrder: 'l2r' | 'r2l' | 'random';
  wordsDuration: number;
  // De-blur amount (px) the word starts at, like Blur-Words. Default seeded via Defaults/preset.
  blurAmount: number;
  // Unified 0-100 magnitude for the per-word transform (`k = strength / 50`): 50 reproduces the
  // canonical values above, 100 doubles them, 0 collapses the transform to none (blur+fade only).
  // Each variation maps `k` onto its own range (scaleDown 1+0.3k, pop 1-0.4k -> 1+0.05k, rise/falling
  // ±12k px). Default seeded via Defaults/preset; old designs without it fall back to 50 in the engines.
  strength: number;
};

// The `chars` family: ONE gated (NEW_ANIMATIONS) CHARACTER-level transition type whose per-character
// reveal is selected by `variation` — typewriter (step-end appear, no fade), fade (opacity 0->1),
// deblur (blur(N)->0 + fade). Reuses the word-split pipeline at character granularity: the splitter
// emits the same `type: 'word'` nodes, one per character, so the per-element stagger, frame-seek,
// MP4 segment reset and play/pause cascade all apply unchanged. Deliberately transform-free — a
// transform would need `display: inline-block` on the span, which lets a line break mid-word.
// Build-in AND build-out; build-out replays the same keyframes reversed.
export type JsonTransitionEffChars = JsonTransitionBase & {
  type: 'chars';
  variation: 'typewriter' | 'fade' | 'deblur';
  wordsAppearOrder: 'l2r' | 'r2l' | 'random';
  // Per-CHARACTER window (seconds). Clamped by min(duration, wordsDuration) in both engines.
  wordsDuration: number;
  // De-blur amount (px) each character starts at. Only read by the `deblur` variation.
  blurAmount: number;
  // Typing rhythm for the `typewriter` variation: how much the per-character beats deviate from a
  // uniform stagger ('even' = uniform, 'natural' = human default, 'loose' = exaggerated). Purely a
  // redistribution of time INSIDE the build window — see packages/shared/src/utils/typewriterRhythm.ts.
  typingRhythm: 'even' | 'natural' | 'loose';
};

export type JsonTransitionEffAdvanced = JsonTransitionBase & {
  type: 'advanced';
  advancedProperties: AdvancedProperties;
};

type JsonTransitionBaseMid = JsonTransitionBase & {
  motionTime: number;
  startEnd?: string;
  preset?: string;
};

export type JsonTransitionEffJello = JsonTransitionBaseMid & {
  type: 'jello';
  direction: 'vertical' | 'horizontal';
};

export type JsonTransitionEffAdvancedMMid = JsonTransitionBaseMid & {
  type: 'advanced';
  advancedProperties: AdvancedProperties;
};

export type JsonTransitionEffPulsate = JsonTransitionBaseMid & {
  type: 'pulsate';
  variation: 'forward' | 'heartbeat' | 'backward' | 'ping';
};

export type JsonTransitionEffBounce = JsonTransitionBaseMid & {
  type: 'bounce';
  direction: 'left' | 'right' | 'top' | 'bottom';
};

export type JsonTransitionEffFlicker = JsonTransitionBaseMid & {
  type: 'flicker';
};

export type JsonTransitionEffVibrate = JsonTransitionBaseMid & {
  type: 'vibrate';
};

export type JsonTransitionEffBlink = JsonTransitionBaseMid & {
  type: 'blink';
};

export type JsonTransitionEffShake = JsonTransitionBaseMid & {
  type: 'shake';
  variation: 'horizontal' | 'vertical' | 'leftRight' | 'top' | 'left' | 'right';
};

export type JsonTransitionEffSpin = JsonTransitionBaseMid & {
  type: 'spin';
  variation: 'forward' | 'backward';
  rotations: number;
};

export type JsonTransitionEffVideo = JsonTransitionBaseMid & {
  type: 'video';
};

export type JsonTransitionEffGradientAnimation = JsonTransitionBaseMid & {
  type: 'gradientAnimation';
  direction: 'l2r' | 'r2l' | 't2b' | 'b2t';
  gradient: JsonTransitionGradColor;
};

// --- registry animations (gated behind NEW_ANIMATIONS) ---
export type JsonTransitionEffGlow = JsonTransitionBaseMid & {
  type: 'glow';
  // A looping neon halo (soft box-shadow "breathe", best for CTAs/buttons). `color`
  // is the glow color; timing (motionTime/duration/ease/tween) comes from the base +
  // build-mid config. Keyframes are a single fixed cycle (0% ≡ 100% so it loops cleanly).
  color: string;
};

export type JsonTransitionEffGlowGrow = JsonTransitionBaseMid & {
  type: 'glowGrow';
  // "Glow & Grow": a neon halo bloom (like `glow`) PLUS a synchronized scale "breath" — the
  // element swells ~8% (scale 1 → 1.08 → 1) with its peak timed exactly to the glow peak, so
  // glow and scale read as one synced pulse. `color` is the glow color; timing (motionTime =
  // one pulse cycle for the Infinite/Hover loop, plus duration/ease/tween) comes from the base
  // + build-mid config. Like Contour it is FINITE for Start/End = Timeline (one pulse auto-synced
  // to the bar, iterationCount 1) and LOOPS for Infinite/Hover (one pulse per motionTime). A
  // soft near-zero ramp (gentle edge stops) eases glow+scale up from rest so there is no hard pop.
  color: string;
  // The peak "grow" scale multiplier (the swell amount) at the 50% pulse peak — user-adjustable.
  // Defaults to 1.08 (~8%) when absent (unchanged look). Consistent across embed + editor
  // (see glowGrow.ts / eff.js); the rest stops stay at scale(1) so the pulse returns to rest.
  scale?: number;
};

export type JsonTransitionEffContour = JsonTransitionBaseMid & {
  type: 'contour';
  // A glowing light SEGMENT that travels continuously around the element's OUTLINE
  // (its border/perimeter), looping forever (best for buttons/CTAs/badges/bordered
  // shapes). `color` is the segment color; timing (motionTime = one lap, plus
  // duration/ease/tween) comes from the base + build-mid config. Keyframes animate a
  // registered `@property --contour-angle` 0deg → 360deg so a conic-gradient border ring
  // sweeps once per motionTime and loops seamlessly (0deg ≡ 360deg).
  color: string;
  // Outline thickness in px (the mask erosion band width): outer mask at the full
  // silhouette, inner eroded by 2*lineWidth so the visible line is ~lineWidth px. Defaults
  // to 3 when absent (unchanged look). Consistent across embed + editor (see contour.ts /
  // eff.js) since it is in the mask's own coordinate space.
  lineWidth?: number;
};

export type JsonTransition =
  | JsonTransitionEffFlip
  | JsonTransitionEffSlit
  | JsonTransitionEffZoom
  | JsonTransitionEffStep
  | JsonTransitionEffAlpha
  | JsonTransitionEffBlur
  | JsonTransitionEffAlphaWords
  | JsonTransitionEffBlurWords
  | JsonTransitionEffWordsMotion
  | JsonTransitionEffChars
  | JsonTransitionEffAdvanced
  | JsonTransitionEffSlide
  | JsonTransitionEffSlideBounce
  | JsonTransitionEffSlideElastic
  | JsonTransitionEffRoll
  | JsonTransitionEffFly
  | JsonTransitionEffShadowPop
  | JsonTransitionEffHighlight
  | JsonTransitionEffTilt
  | JsonTransitionEffSwing
  | JsonTransitionEffRotate
  | JsonTransitionEffKenBurns
  | JsonTransitionEffFadeAudio
  | JsonTransitionEffScale
  | JsonTransitionEffSpreadFocus
  | JsonTransitionEffFlash
  | JsonTransitionEffSkew
  | JsonTransitionEffSquash
  | JsonTransitionEffReveal
  | JsonTransitionEffScaleElastic
  | JsonTransitionEffScaleBounce
  | JsonTransitionEffInstant
  | JsonTransitionEffTracking
  | JsonTransitionEffScrapbook
  | JsonTransitionEffSlam
  | JsonTransitionEffSplitSlam
  | JsonTransitionEffTvCollapse
  | JsonTransitionEffSkid
  | JsonTransitionEffWhip
  | JsonTransitionEffDrift
  | JsonTransitionEffSlingshot
  | JsonTransitionEffNone;

export type JsonTransitionAll = JsonTransition | JsonTransitionMid;

export type CustomTransition = {
  id: number;
  name: string;
  properties: JsonTransitionAll;
};

export type JsonTransitionGradColor = {
  gradColors: JsonGradColor[];
};

export type JsonTransitionMid =
  | JsonTransitionEffRock
  | JsonTransitionEffFloat
  | JsonTransitionEffShimmer
  | JsonTransitionEffJello
  | JsonTransitionEffAdvancedMMid
  | JsonTransitionEffPulsate
  | JsonTransitionEffVibrate
  | JsonTransitionEffShake
  | JsonTransitionEffSpin
  | JsonTransitionEffBlink
  | JsonTransitionEffBounce
  | JsonTransitionEffFlicker
  | JsonTransitionEffInstantMid
  | JsonTransitionEffVideo
  | JsonTransitionEffAudio
  | JsonTransitionEffGradientAnimation
  | JsonTransitionEffGlow
  | JsonTransitionEffGlowGrow
  | JsonTransitionEffContour
  | JsonTransitionEffNoneMid;

export type JsonSlideProperties = {
  duration: number;
  /** @deprecated Use {@link JsonSlideProperties.bannersetElementId} instead. */
  id: number;
  bannersetElementId?: number;
  stopSlide: boolean;
  guidelines?: JsonGuidelines;
  transition?: JsonSlideTransition;
  /** @deprecated */
  editableContent?: boolean;
};

export type JsonElement =
  | JsonText
  | JsonButton
  | JsonImage
  | JsonSvg
  | JsonAudio
  | JsonVideo
  | JsonShape
  | JsonEmbed
  | JsonYoutube
  | JsonClipart
  | JsonCountdown
  | JsonSnow
  | JsonRain
  | JsonFog
  | JsonGroup
  | JsonFrame
  | JsonFlexStrip;
export type JsonElementMedia = JsonSvg | JsonAudio | JsonImage | JsonVideo;
export type JsonAnimatedElement = JsonVideo | JsonAudio | JsonYoutube | JsonEmbed;

export type JsonElementProperties = JsonElement['properties'];

export type JsonShadow = {
  useShadow: boolean;
  hShadow: number;
  vShadow: number;
  blur: number;
  spread: number;
  color: string;
};

export type JsonBlur = {
  useBlur: boolean;
  pixels: number;
};

/** The shape "Glass" effect: backdrop frost, rim refraction and border light. See docs/design-format/glass.md. */
export type JsonGlass = {
  useGlass: boolean;
  /** Master slider, 0-100. 50 = the advanced values as stored; scales frost and refraction 0-2x, dispersion 0-1.5x. */
  intensity: number;
  /** Advanced. Backdrop blur in px at design scale, 0-40. */
  frost: number;
  /** Advanced. Rim bend strength, 0-100. 0 = no displacement filter at all. */
  refraction: number;
  /** Advanced. How far in from the edge the bend reaches, 0-100. */
  depth: number;
  /** Advanced. RGB fringing at the rim, 0-100. 0 = the three channels bend together. */
  dispersion: number;
  /** Border light strength, 0-100. 0 = no rim, inner glow or sheen. */
  lightIntensity: number;
  /** Direction the light comes from, 0-360 degrees, 0 = top, clockwise. */
  lightAngle: number;
  /** Film grain overlay on the pane. */
  grain: boolean;
};

export type JsonOutline = {
  useOutline: boolean;
  color: string;
  width: number;
};

export const JsonFlipTypeArr = ['both', 'horizontal', 'none', 'vertical'] as const;

export type JsonFlipType = (typeof JsonFlipTypeArr)[number];

export type JsonTextAlignment = 'left' | 'right' | 'center' | 'justify';

export const JsonTextHorizontalAlignment = {
  left: 'left',
  center: 'center',
  right: 'right',
  justify: 'justify',
} as const;
export type JsonTextHorizontalAlignmentType =
  (typeof JsonTextHorizontalAlignment)[keyof typeof JsonTextHorizontalAlignment];

export const JsonTextVerticalAlignment = {
  top: 'top',
  center: 'center',
  bottom: 'bottom',
} as const;
export type JsonTextVerticalAlignmentType = (typeof JsonTextVerticalAlignment)[keyof typeof JsonTextVerticalAlignment];

export type JsonActionType = 'gotoURL' | 'gotoSlide' | 'toggleElement' | 'none';

export type JsonActionTarget = '_blank' | '_self' | '_parent' | '_top';

export type JsonActionSlide = 'prev' | 'next' | 'first' | 'last' | number;

// Extensible event type for actions - can be extended with new events in the future
export type JsonActionEvent = 'click' | 'hover' | 'videoEnd';

export const JsonTextContentBoundary = {
  /** @deprecated Use {@link JsonTextContentHeightType.auto} instead */
  overflow: 'overflow',
  shrink: 'shrink',
  ellipsis: 'ellipsis',
  autoscroll: 'autoscroll',
} as const;
export type JsonTextContentBoundaryType = (typeof JsonTextContentBoundary)[keyof typeof JsonTextContentBoundary];

export const RichBlocks = {
  LEGACY: 'legacy',
  PARAGRAPH: 'paragraph',
  SUB_PARAGRAPH: 'subparagraph',
  WRAPPER: 'wrapper',
  BULLET_LIST: 'bullet-list',
  NUMBERED_LIST: 'number-list',
  LIST_ITEM: 'list-item',
  FEED_CHIP: 'feed-chip',
  LINK: 'link',
  WORD: 'word',
  IMAGE: 'image',
} as const;

export type RichBlocksType = (typeof RichBlocks)[keyof typeof RichBlocks];

export const JsonTextContentHeight = {
  auto: 'auto',
  fixed: 'fixed',
} as const;
export type JsonTextContentHeightType = (typeof JsonTextContentHeight)[keyof typeof JsonTextContentHeight];

export const JsonTextContentWidth = {
  auto: 'auto',
  fixed: 'fixed',
} as const;
export type JsonTextContentWidthType = (typeof JsonTextContentWidth)[keyof typeof JsonTextContentWidth];

export type JsonActionGotoURL = {
  event: 'click';
  target: JsonActionTarget;
  type: 'gotoURL';
  url: string;
  useHandCursor: boolean;
};

export type JsonActionGotoSlide = {
  event: JsonActionEvent;
  type: 'gotoSlide';
  slide: JsonActionSlide;
  useHandCursor?: boolean;
};

export type JsonActionVideoEnd = {
  event: 'videoEnd';
  target: string | null;
  type: 'gotoSlide';
  url: string;
  slide: JsonActionSlide;
  useHandCursor: boolean;
};

export type JsonActionToggleElement = {
  event: JsonActionEvent;
  type: 'toggleElement';
  targetElementId: number;
  hideOnHoverOut?: boolean;
  useHandCursor?: boolean;
};

export type JsonActionNone = {
  type: 'none';
};

export type JsonAction =
  | JsonActionGotoURL
  | JsonActionGotoSlide
  | JsonActionToggleElement
  | JsonActionNone
  | JsonActionVideoEnd;

export function isJsonActionGotoSlide(action: JsonAction): action is JsonActionGotoSlide {
  return action.type === 'gotoSlide';
}

export function isJsonActionGotoURL(action: JsonAction): action is JsonActionGotoURL {
  return action.type === 'gotoURL';
}

export function isJsonActionNone(action: JsonAction): action is JsonActionNone {
  return action.type === 'none';
}

export function isJsonActionToggleElement(action: JsonAction): action is JsonActionToggleElement {
  return action.type === 'toggleElement';
}

/**
 * Pre-scan the design to find all element IDs that are targets of toggleElement actions.
 * These elements need to be kept in the DOM/export even if they're initially hidden.
 * If a target is a group, expands it to include all child element IDs.
 *
 * This utility is used during asset collection (export) to ensure hidden toggle targets
 * have their assets included in the final export.
 */
export function getToggleTargetIds(design: JsonDesign): Set<number> {
  const targetIds = new Set<number>();
  const processedTargets = new Set<number>();

  const getChildElementIds = (group: JsonGroup | JsonFrame): number[] => {
    const ids: number[] = [];
    const traverse = (elements: JsonElement[]) => {
      for (const el of elements) {
        if (isGroup(el) && el.elements) {
          // For nested groups, just traverse children (groups don't have DOM elements)
          traverse(el.elements);
        } else {
          // For frames and regular elements - add their ID (they have DOM elements)
          if (el.properties.bannersetElementId) {
            ids.push(el.properties.bannersetElementId);
          }
          // Frames also have children that need to be traversed
          if (isFrame(el) && el.elements) {
            traverse(el.elements);
          }
        }
      }
    };
    traverse(group.elements);
    return ids;
  };

  const findElementById = (targetElementId: number): JsonElement | null => {
    const findInElements = (elements: JsonElement[], targetId: number): JsonElement | null => {
      for (const element of elements) {
        if (element.properties.bannersetElementId === targetId) {
          return element;
        }
        if (isGroupOrFrame(element) && element.elements) {
          const found = findInElements(element.elements, targetId);
          if (found) {
            return found;
          }
        }
      }
      return null;
    };

    for (const slideOrElement of design.elements) {
      if (isSlide(slideOrElement)) {
        const found = findInElements(slideOrElement.elements, targetElementId);
        if (found) {
          return found;
        }
      } else if (slideOrElement.properties.bannersetElementId === targetElementId) {
        return slideOrElement;
      }
    }
    return null;
  };

  const processTargetId = (targetId: number): void => {
    if (processedTargets.has(targetId)) {
      return;
    }
    processedTargets.add(targetId);
    targetIds.add(targetId);

    // If target is a group or frame, expand to all child element IDs
    // Groups don't have DOM elements, so we need their children's assets
    // Frames DO have DOM elements, but their children are rendered inside them,
    // so we also need their children's assets when the frame is a toggle target
    const targetElement = findElementById(targetId);
    if (targetElement && isGroupOrFrame(targetElement)) {
      const childIds = getChildElementIds(targetElement as JsonGroup | JsonFrame);
      for (const id of childIds) {
        targetIds.add(id);
      }
    }
  };

  const scanElements = (elements: JsonElement[]): void => {
    for (const element of elements) {
      const actions = element.properties?.actions;
      if (actions) {
        for (const action of actions) {
          if (isJsonActionToggleElement(action) && action.targetElementId) {
            processTargetId(action.targetElementId);
          }
        }
      }

      // Recursively scan nested elements (groups, frames)
      if (isGroupOrFrame(element) && element.elements) {
        scanElements(element.elements);
      }
    }
  };

  for (const slideOrElement of design.elements) {
    if (isSlide(slideOrElement)) {
      if (slideOrElement.elements) {
        scanElements(slideOrElement.elements);
      }
    } else {
      // Non-slide element at root level
      const actions = slideOrElement.properties?.actions;
      if (actions) {
        for (const action of actions) {
          if (isJsonActionToggleElement(action) && action.targetElementId) {
            processTargetId(action.targetElementId);
          }
        }
      }
    }
  }

  return targetIds;
}

export type JsonTransitionBuildType = 'buildIn' | 'buildMid' | 'buildOut';

/** Screen reader / export accessibility settings for a layer. */
export type JsonAccessibility = {
  altText?: string;
  isDecorative?: boolean;
};

export type JsonBaseElementProperties = {
  /** @deprecated Use {@link JsonBaseElementProperties.bannersetElementId} instead. */
  id: number;
  bannersetElementId?: number | null;
  elementCategory?: string | null;
  layerName: string;
  isCaption?: boolean;
  // Mirror of CaptionStyleType in ./captionStyles. Inlined as a literal union
  // because this file is copied verbatim by codegen and can't have cross-file
  // imports (see header comment).
  captionStyle?:
    | 'style_1'
    | 'style_2'
    | 'style_3'
    | 'style_4'
    | 'style_5'
    | 'style_6'
    | 'style_7'
    | 'style_8'
    | 'style_9';
  /** For caption text layers: `bannersetElementId` of the video/audio layer the
   *  captions were generated from. Links captions to their source media so
   *  caption timing can be re-synced when the media's trim changes. */
  captionSourceLayerId?: number;
  /** For caption text layers: set when the trim resync hid the caption because
   *  it fell outside the media's trim window. Distinguishes trim-hides (safe to
   *  auto-restore when the trim widens back) from manual user hides (never
   *  auto-restored). */
  captionHiddenByTrim?: boolean;
  dropShadow?: JsonShadow;
  blur?: JsonBlur;
  glass?: JsonGlass;
  opacity: number;
  rotation: number;
  flip?: JsonFlipType;
  x: number;
  y: number;
  width: number;
  height: number;
  buildIn?: JsonTransition;
  buildMid?: JsonTransitionMid;
  buildOut?: JsonTransition;
  actions?: JsonAction[];
  locked?: boolean;
  lockedProperties?: string[];
  isAspectRatioLocked?: boolean;
  visible: boolean;
  hiddenOnSlides?: number[];
  group?: number | null;
  feed?: JsonPropertiesFeed;
  /** @deprecated */
  editableContent?: boolean;
  /** @deprecated */
  editableContentProperties?: string[];
  overlayPosition?: JsonOverlayPosition;
  embedCss?: string;
  accessibility?: JsonAccessibility;
  autoLayoutChild?: AutoLayoutChild;
  /**
   * Figma-style Constraints: how this element pins/scales relative to its parent
   * frame (or the top-level canvas) when the parent resizes. Gated behind the
   * `CONSTRAINTS` statsig gate — never read gate-off. **Absent ⇒ the element keeps
   * today's resize behavior (constraints are NOT applied) on every path** — the UI
   * writes an initial `{ horizontal: 'LEFT', vertical: 'TOP' }` only when the user
   * activates Constraints on the element (the single Position toggle).
   *
   * This field is ALSO the "Absolute position" (Figma "Ignore auto layout") signal
   * for a direct child of an active auto-layout frame: such a child that carries
   * `constraints` is taken OUT of the flex flow and positioned by them relative to
   * the AL frame; one WITHOUT `constraints` flows normally. (A plain-frame child or
   * a group member with `constraints` stays in flow — it is simply pinned on resize.)
   */
  constraints?: Constraints;
  /**
   * How the layer reacts when a served Fill ad scales (`responsiveReflow`). Absent = scales with
   * the ad like everything else. Only read by html-next reflow builds; the editor canvas and Fit
   * ignore it.
   */
  scaleLimits?: ScaleLimits;
};

export enum JsonOverlayPosition {
  TOP = 'top',
  BOTTOM = 'bottom',
}

export type ToggleValuePermission = {
  active: boolean;
};

export function isTogglePermission(value: boolean | ToggleValuePermission): value is ToggleValuePermission {
  return typeof value === 'object' && value !== null && 'active' in value;
}

export type BackgroundPermission = {
  active: boolean;
  border: ToggleValuePermission;
  backgroundColor: ToggleValuePermission;
};

export type TextContentChangePermission = {
  active: boolean;
  limitCharacters: ToggleValuePermission;
  maxLength: number;
  textBoxResizing: JsonTextContentHeightType;
  fontSize: number;
  boundary: JsonTextContentBoundaryType;
};

export type ButtonContentChangePermission = {
  active: boolean;
  limitCharacters: ToggleValuePermission;
  maxLength: number;
};

export type ButtonHoverPermission = {
  active: boolean;
  color: ToggleValuePermission;
  backgroundColor: ToggleValuePermission;
  borderColor?: ToggleValuePermission;
};

export type ImageContentChangePermission = {
  active: boolean;
  upload: boolean;
  aiGenerated: boolean;
  brandKit: boolean;
  stock: boolean;
  url: boolean;
  fromDAM: boolean;
};

export type AudioContentChangePermission = {
  active: boolean;
  upload: boolean;
  brandKit: boolean;
  stock: boolean;
  fromDAM: boolean;
};

export type VideoContentChangePermission = {
  active: boolean;
  upload: boolean;
  brandKit: boolean;
  stock: boolean;
  fromDAM: boolean;
};

export type FlexStripContentChangePermission = {
  active: boolean;
  limitCharacters: ToggleValuePermission;
  maxLength: number;
  fontSize: number;
};

/**
 * A brand-template author's restriction of the Brand Kit picker to ONE media folder.
 *
 * Carries the kit id as well as the folder id on purpose. The Brand Kit tab resolves its
 * kit from the PROJECT (`useProjectBrandKit`), and `getDefaultBrandKitId` gives a design
 * created from a template the DESTINATION project's selected kit — the template is never
 * consulted. So a bare folder id stops meaning anything once the design leaves the
 * workspace it was authored in, and could name a folder in an unrelated kit. The pair
 * makes the permission self-describing and gives the reader something to validate before
 * it queries.
 */
export type BrandKitFolderScope = {
  brandKitId: number;
  mediaFolderId: number;
};

export type GeneralPermissions = {
  addRemoveSizes: ToggleValuePermission;
  background: BackgroundPermission;
  /** Absent means unscoped, which is every design authored before this field existed. */
  brandKitFolder?: BrandKitFolderScope;
};

export type SizePositionLayerPermissions = {
  sizeChange: ToggleValuePermission;
  positionChange: ToggleValuePermission;
};

export type TextLayerPermissions = SizePositionLayerPermissions & {
  contentChange: TextContentChangePermission;
  color: ToggleValuePermission;
  fontSizeChange?: ToggleValuePermission;
  alignment?: ToggleValuePermission;
};

export type ButtonLayerPermissions = SizePositionLayerPermissions & {
  contentChange: ButtonContentChangePermission;
  buttonHoverState: ButtonHoverPermission;
  color: ToggleValuePermission;
  backgroundColor: ToggleValuePermission;
  borderColor?: ToggleValuePermission;
};

export type ShapeLayerPermissions = SizePositionLayerPermissions & {
  image: {
    active: boolean;
    contentChange: ImageContentChangePermission;
    focalPoint: ToggleValuePermission;
    aiEdit: ToggleValuePermission;
  };
  color: ToggleValuePermission;
};

export type AudioLayerPermissions = SizePositionLayerPermissions & {
  contentChange: AudioContentChangePermission;
  trim: ToggleValuePermission;
};

export type ExcludedLayersPermissions = SizePositionLayerPermissions & {
  contentChange: ToggleValuePermission;
};

export type MediaLayerPermissions = SizePositionLayerPermissions & {
  image: {
    active: boolean;
    contentChange: ImageContentChangePermission;
    focalPoint: ToggleValuePermission;
    aiEdit: ToggleValuePermission;
  };
  svg: {
    active: boolean;
    contentChange: ToggleValuePermission;
    color: ToggleValuePermission;
  };
  video: {
    active: boolean;
    contentChange: VideoContentChangePermission;
    trim: ToggleValuePermission;
  };
};

export type FlexStripLayerPermissions = SizePositionLayerPermissions & {
  contentChange: FlexStripContentChangePermission;
  color: ToggleValuePermission;
};

export type JsonTextCurveShape = 'none' | 'curve';

/**
 * PSD-105: provenance of a text layer whose Photoshop Gradient Overlay the PSD import wrote as per-line `lgrad`
 * leaf gradients. Written ONLY by the PSD import (apps/photoshop) and read ONLY by the PSD export (apps/export-psd),
 * which writes `sourceFills` as the live run fill while `leafFingerprint` still matches the leaves. No renderer reads
 * it: html-next, the editor and every export paint the leaves' own `gradient` / `color`. Copies carry it unchanged.
 */
export type JsonTextGradientOverlay = {
  version: 1;
  /** The overlay as Photoshop stored it, normalised (stop colours in the document colour space, `#rrggbb`). */
  overlay: {
    type: 'linear' | 'reflected';
    /** Degrees, Photoshop convention (90 points up). */
    angle: number;
    /** 1 = 100%. */
    scale: number;
    reverse: boolean;
    align: boolean;
    /** Fractions of the layer box. */
    offset: { x: number; y: number };
    /** 0-1; 1 = Photoshop's default 100%. */
    smoothness: number;
    method: 'classic' | 'perceptual';
    blendMode: 'normal';
    /** 0-1. */
    opacity: number;
    stops: { location: number; midpoint: number; color: string }[];
    opacityStops: { location: number; midpoint: number; opacity: number }[];
  };
  /** The PSD's own text fill of every leaf, in leaf order, as imported: what PSD export writes as the run fill. */
  sourceFills: string[];
  /** `fingerprintLeafFills(config)` (`@thebrief-ai/shared/text/textGradientOverlay`) when imported. */
  leafFingerprint: string;
};

export type JsonTextProperties = JsonBaseElementProperties & {
  text?: string;
  alignment: JsonTextAlignment;
  verticalAlign?: JsonTextVerticalAlignmentType;
  contentHeightType: JsonTextContentHeightType;
  contentWidthType?: JsonTextContentWidthType;
  fontSize: number;
  lineHeight: number;
  letterSpacing: number;
  /**
   * BUG-34837: where a line may break at a hard hyphen. Absent = the browser's rule (a break after any
   * hyphen-minus before a word character). 'none' = Photoshop's composer: never after a hyphen-minus
   * inside a letter-initial word (`isJoinableHyphenAt` in `@thebrief-ai/shared/text/hardHyphenJoin`).
   * Render-only: every renderer and line measurer joins at render time; the stored text never changes.
   */
  hyphenBreaks?: 'none';
  /**
   * PSD-210: the minimum word spacing of justified text, as a fraction of the font's space (Photoshop's
   * Justification > Word Spacing > Minimum; 0.8 = a space may shrink to 80 %), so a justified line fits the words
   * Photoshop fits on it. Read only when `alignment` is 'justify'; absent = the browser's spacing, as before.
   * Render-only: every renderer turns it into CSS `word-spacing` through `justifyWordSpacingEm`
   * (`@thebrief-ai/shared/text/justifyWordSpacing`); PSD export writes it back as the paragraph's minimum.
   */
  minWordSpacing?: number;
  /**
   * PSD-147: a horizontal glyph scale (Photoshop's character Horizontal Scale, or a text transform that scales x and y
   * differently). The text is laid out in a box `width / glyphScaleX` wide (lines wrap there) and drawn stretched by
   * `glyphScaleX` along x about the box's left edge, so its lines fill `width`; heights, font sizes and line pitch are
   * unchanged. Absent, 1 or invalid = no stretch, as before. Render-only: every reader goes through `textGlyphScaleX`
   * (`@thebrief-ai/shared/text/glyphScale`); resizers keep it; PSD export writes it back as the text's x scale.
   */
  glyphScaleX?: number;
  /**
   * PSD-194: true = text past the bottom edge of the box is not drawn (Photoshop hides overset paragraph text). Only
   * for fixed-height text whose boundary is none or 'overflow' (a shrink, ellipsis or autoscroll boundary wins); the
   * box clips at its bottom edge only, so glyphs that overhang its top or sides still draw. PSD import sets the height
   * on a line boundary (`baseline ≤ frame bottom`, measured in Photoshop 27.11), so whole lines show or hide. Absent =
   * overflowing lines paint below the box, as before. Read through `hidesOversetText`.
   */
  oversetHidden?: boolean;
  /** PSD-105: set by PSD import on a Gradient Overlay text layer; see {@link JsonTextGradientOverlay}. Not render input. */
  textGradientOverlay?: JsonTextGradientOverlay;
  config: JsonTextSlateConfig;
  hoverState?: Partial<
    Pick<JsonTextProperties, 'outline' | 'textShadow'> &
      Pick<JsonFontSettings, 'fontWeight' | 'fontStyle'> &
      Pick<JsonTextSlateConfigChildren, 'gradient' | 'textDecoration'> & {
        scale: JsonHoverScale;
        speed: HoverScaleSpeed;
      }
  >;
  textShadow?: JsonShadow;
  initialFontSize?: number;
  textDirection?: string | null;
  scale?: number;
  blendMode?: JsonBlendMode;
  outline?: JsonTextOutline;
  paddingTop?: number;
  paddingBottom?: number;
  paddingLeft?: number;
  paddingRight?: number;
  curveShape?: JsonTextCurveShape;
  curveAmount?: number;
  curveOffset?: number;
  background?: JsonTextBackground;
  editPermissions?: {
    active: boolean;
    permissions: TextLayerPermissions;
  };
  /**
   * CRE-389: the Adobe AEM Content Fragment this ISI layer is bound to. The editor and
   * html-next read the fragment at runtime; `config` keeps a snapshot of its copy, which
   * is what renders whenever AEM cannot be reached.
   */
  aemContentFragment?: { publishUrl: string };
  /**
   * CRE-706: an ISI bound to a SharePoint document, by its drive and item ids. Read with the
   * viewer's own SharePoint connection; html-next never reads it and renders the stored copy.
   */
  sharePointDocument?: { driveId: string; itemId: string };
};

/**
 * Non-render metadata about ONE layer element (docs/resize/*: "The `meta` section").
 *
 * `meta` is an optional plain object on a layer element, beside `properties`, never inside it and never on a slide.
 * The design root carries exactly one `meta.lint` key, `background`, holding the focal stamps of the design's own
 * backdrop — a picture that is not an element (focal-area-annotation.md, AIR-23 F1; {@link JsonDesignLintMeta}).
 * Nothing else is stamped on the root.
 *
 * - Never render input: no renderer, exporter, editor tool or prompt builder reads it.
 * - Beside `properties`, never inside it. Layer elements only — never a slide; the root's one exception is above.
 * - One plain object per namespace. `lint` is the only namespace; unknown keys are carried and ignored.
 * - Read and write ONLY through `packages/shared/src/design/lintMeta.ts` and the stamp readers
 *   (`readLegalText`, `readGroupResizeBehavior`, `readFocalArea`, `readKeepClear`, `readLegibilityFields`,
 *   `readSubjectCutout`, and `readLegibility` from `@thebrief-ai/design-linter/legibility`); the
 *   `@nx/workspace-no-raw-lint-meta` lint rule enforces it.
 * - Design sync carries only the registered paths (designSync `ELEMENT_META_SYNC_PATHS`), each as one unit.
 */
export type JsonElementMeta<Lint extends object> = { lint?: Lint };

/** `meta.lint` on a text layer. */
export type JsonTextLintMeta = { legalText?: JsonTextLegalText; legibility?: JsonTextLegibility };

/** `meta.lint` on an image layer. */
export type JsonImageLintMeta = {
  legalText?: JsonRasterLegalText;
  focalArea?: JsonImageFocalArea;
  keepClear?: JsonImageKeepClear;
  subjectCutout?: JsonImageSubjectCutout;
};

/**
 * The lift stamps this on the image layer it cut the ad's main subject into (a "Product" or "Subject" layer over a
 * Background the subject was erased from). It says the layer is a cut-out subject, never a disposable mark: AI
 * resize's recompose reads it as unmeasurable, so a small cut-out keeps the rebuild from offering to drop it.
 *
 * No asset guard: the lift's urls become media hashes on the first save. Read it ONLY through `readSubjectCutout`
 * (`@thebrief-ai/shared/design/subjectCutout`). Lives at `meta.lint.subjectCutout` ({@link JsonImageLintMeta}); the
 * contract is `docs/resize/subject-cutout-annotation.md`.
 */
export type JsonImageSubjectCutout = {
  v: 1;
  /** The only writer. The reader accepts any non-empty string. */
  writtenBy: 'lift';
};

/**
 * The two picture stamps (AIR-23), as one bag: `focalArea` and `keepClear` on any PICTURE HOST — an image layer, or a
 * shape whose fill is an image (`packages/shared/src/design/pictureHost.ts`). Read them ONLY through `readFocalArea`
 * / `readKeepClear`, which resolve the host and its asset guard; the value shapes are the same on every host.
 */
export type JsonPictureLintStamps = {
  focalArea?: JsonImageFocalArea;
  keepClear?: JsonImageKeepClear;
};

/**
 * `meta.lint` on a shape layer: the picture stamps, meaningful only while the shape's fill is an image — a fill
 * switched to a solid, a gradient or none, or to another asset, reads no claim (the readers' host and asset guards).
 */
export type JsonShapeLintMeta = JsonPictureLintStamps;

/**
 * `meta.lint` on the DESIGN ROOT (AIR-23, F1): exactly one key, `background` — the picture stamps of the design's own
 * backdrop (`properties.backgroundColor` when it is an image), which is no element and so has no element `meta`.
 * Meaningful only while that backdrop is a picture naming the stamped asset. Read and write ONLY through
 * `packages/shared/src/design/designLintMeta.ts` and `readBackgroundFocalArea` / `readBackgroundKeepClear`. Design
 * sync never diffs a root `meta`.
 */
export type JsonDesignLintMeta = { background?: JsonPictureLintStamps };

/** `meta.lint` on a group container. */
export type JsonGroupLintMeta = { resizeBehavior?: JsonGroupResizeBehavior };

/**
 * AIR-7: the pre-resize design linter's `tagLegalText` stamps this on a text layer it judged to be LEGAL TEXT
 * (terms, disclaimers, copyright/trademark notices, age or responsible-use warnings, political attribution,
 * financial disclosures, safety information including pharma ISI). It states what the layer IS and carries no
 * policy: what a resize engine does with it belongs to that engine.
 *
 * **Never read the raw field.** Read it ONLY through `readLegalText`
 * (`@thebrief-ai/shared/design/legalText`), which validates the shape, applies the reader-side `READ_FLOOR`,
 * derives the `ISI:` layer-name claim, and answers `null` ("no claim") the moment the copy no longer matches the
 * guard — any copy edit, translation or feed row. The consumer contract is `docs/resize/legal-text-annotation.md`.
 *
 * Lives at `meta.lint.legalText` ({@link JsonTextLintMeta}). A stamp stored under the legacy
 * `properties.legalText` is an unknown key: carried by copies, ignored by every reader, never rewritten.
 */
export type JsonTextLegalText = {
  v: 1;
  /** Widened to `string` on read, as `resizeBehavior`'s is. */
  writtenBy: 'tagLegalText';
  /** The probability stated when the stamp was written, 0..1 and ≥ the writer's floor. Never written when not given. */
  p: number;
  /** Validity guard, algorithm-tagged: `fnv1a64:<16 hex>` over the normalized copy. Not a security boundary. */
  copyDigest: string;
  /** Validity guard: code points of the normalized copy. */
  copyLength: number;
};

/**
 * Raster legal text (AIR-7 follow-up): the pre-resize design linter's `tagRasterLegalText` stamps this on an IMAGE
 * layer whose pixels a vision judge read as LEGAL TEXT (the same function-based definition as
 * {@link JsonTextLegalText}, plus regulatory marks such as FDIC, Equal Housing, 18+, ABTA, responsible-gambling marks or regulator seals). Same key
 * (`meta.lint.legalText`), a second shape, told apart by the layer type and `writtenBy`. A legacy
 * `properties.legalText` is ignored by every reader.
 *
 * It means **"this asset is legal copy"**, not "legal copy is visible": the guard binds the claim to one media asset
 * (`assetKey`, the media key parsed from `properties.url` when stamped), and crop, `contentScale` and offsets are
 * deliberately not part of it. It carries no copy.
 *
 * **Never read the raw field.** Read it ONLY through `readLegalText` (`@thebrief-ai/shared/design/legalText`),
 * which answers `null` ("no claim") the moment `url` names another asset, the layer is bound to a feed, or the
 * shape is not this one. The consumer contract is `docs/resize/legal-text-annotation.md`.
 */
export type JsonRasterLegalText = {
  v: 1;
  /** Widened to `string` on read. */
  writtenBy: 'tagRasterLegalText';
  /** The probability the judge STATED, 0..1 and ≥ the writer's floor. Never written when not given. */
  p: number;
  /** Validity guard: the media key parsed from `properties.url` when the stamp was written. */
  assetKey: string;
  /** Source x-height in ASSET pixels, when measured — for a minimum-scale legibility floor. */
  inkXHeightPx?: number;
};

/** A canvas-px box (2 dp). Distinct from {@link JsonLintBox}, which is frame FRACTIONS. */
export type JsonLintPxBox = { x: number; y: number; w: number; h: number };

/** AIR-28 phase 2: where the landing surface paints. Engines locate it by this, never by hex. */
export type JsonLegibilitySurfaceRef =
  | { kind: 'design-background' }
  | {
      kind: 'shape-fill' | 'frame-fill';
      /** `String(bannersetElementId ?? properties.id)` (treeIndex.ts:143-148); unique on the source design. */
      elementId: string;
    };

/** Why the surface carries no rec. Closed at gen 2; readers switch on it exhaustively. */
export type JsonLegibilitySurfaceDecline =
  | 'surface-transparent' // a translucent or absent design background (never-auto), or a rounded layer surface
  | 'surface-unkeyed' // the surface layer's element id names more than one node
  | 'multi-slide-surface' // a whole-design surface (background or depth-0 layer) on a multi-slide or cover-slide design
  | 'surface-tinted' // a full-canvas translucent painter sits above the surface
  | 'cotenant-unverifiable' // a layer above the surface has no colour the JSON states (D2)
  | 'too-many-checks' // more than MAX_SURFACE_CHECKS distinct colours land on the surface
  | 'no-safe-colour' // no candidate clears every check
  | 'surface-inconsistent'; // the computed entry failed its own validation (a defect; counted, never expected)

/** One colour that sits on the surface, and its WCAG 2.x floor. */
export type JsonLegibilitySurfaceCheck = { hex: string; floor: 3 | 4.5 };

export type JsonLegibilitySurfaceRec = {
  /** The colour to write on the surface, `#rrggbb` lowercase. Equal to `ownHex` when the surface already clears
   *  every check ("leave it"). */
  hex: string;
  /** min over `checks` of contrast(hex, check.hex) / check.floor, floored to 4 dp; ≥ 1. */
  minMargin: number;
  /** Every distinct colour on the surface, the highest floor per hex, sorted by hex; 1..32. */
  checks: JsonLegibilitySurfaceCheck[];
};

/**
 * The landing surface of a class-A text layer (F's painter). Computed ONCE per surface over every layer above it and
 * copied byte-identically onto every stamp that names `key` (owner D1, 2026-10-14). Per surface in its OUTPUT, an
 * engine applies EITHER this rec, leaving every text whose glyphs land on the surface in its source colour, OR text
 * recs, leaving the surface untouched.
 */
export type JsonLegibilitySurface = {
  /** `'bg'` for the design background, `el:<elementId>` for a layer. */
  key: string;
  ref: JsonLegibilitySurfaceRef;
  /** The surface's stored colour at source, canonical hex; `#ffffff` when the design has no background. */
  ownHex: string;
  /** `'design'`: the design background or a depth-0 layer (paints every slide). `'slide'`: a layer inside a slide. */
  scope: 'design' | 'slide';
  /** The opaque layers above the surface cover it entirely at source. */
  hiddenAtSource: boolean;
  /** `ownHex` continues a host edge seamlessly (a designed extension); `null` when no edge was measured. */
  seam: boolean | null;
  status: { status: 'ok' } | { status: 'declined'; reason: JsonLegibilitySurfaceDecline };
  /** Present iff `status.status === 'ok'`. */
  rec?: JsonLegibilitySurfaceRec;
  /** Advisory (owner D4); recomputable from status, seam and hiddenAtSource. Engines may ignore it. */
  preferred: 'text' | 'surface';
};

/**
 * AIR-28: the pre-resize design linter's `tagLegibility` stamps this on a text layer whose legibility DEPENDS on a
 * picture (class A): legible on its picture hosts, illegible on the colour it would land on if moved off them.
 * Size-specific (it carries the canvas it was measured on). Read ONLY through `readLegibility`
 * (`@thebrief-ai/design-linter/legibility`); contract `docs/resize/text-legibility-annotation.md`.
 */
export type JsonTextLegibility = {
  v: 1;
  /** Widened to `string` on read. */
  writtenBy: 'tagLegibility';
  /** Writer generation; LEGIBILITY_STAMP_GEN when written. Positive safe integer. A stamp below gen 2 carries no
   *  `surface`, a gen-2 stamp carries one, and a reader drops `surface` from a gen it does not know. */
  gen: number;
  /** T — the dominant RENDERED span colour: hex `#rrggbb` lowercase, its share of non-space chars (0..1, 4 dp),
   *  its WCAG relative luminance (0..1, 4 dp). */
  colour: { hex: string; share: number; L: number };
  /** Every other rendered colour at ≥ MINORITY_SHARE of the non-space chars, by share descending then hex ascending —
   *  the shared `dominantRenderedColour`'s minorities, in its order. `rec1` is present iff that colour fails 3:1
   *  against some `fallbackSet` colour AND `recs.status === 'ok'`: the same on-hue clamp as the dominant `rec1`,
   *  verified at 4.5:1 against every `fallbackSet` colour. `[]` for a single-colour layer. */
  minorities: Array<{
    hex: string;
    share: number;
    L: number;
    rec1?: { hex: string; minContrastVsFallbackSet: number; clamped: boolean };
  }>;
  /** `fnv1a64:<16 hex>` — `legibilitySceneDigest`: the design's render properties (canvas, background) and every layer
   *  that paints the text's slide (the slide's whole subtree and the show-on-all-slides layers not hidden on it), each
   *  without `meta`, ids or the editor's load defaults, keys sorted. The reader requires the current one: any edit on
   *  that slide or its canvas after the lint makes the claim stale. */
  sceneDigest: string;
  /** H, top-down paint order; 1..8 entries. Never `properties.id`. */
  hosts: Array<{
    kind: 'image' | 'shape';
    /** Media key of the host's picture url (parseMediaKey under the writer's mediaHosts). */
    assetKey: string;
    /** The host's box covers the canvas on both axes. */
    fullBleed: boolean;
    /** The set-stable id, only when the host carries one. Informational; the reader never requires it. */
    bannersetElementId?: number;
  }>;
  /** F — the first opaque normal-blend solid below the lowest host that covers the canvas (full-bleed tints
   *  composited), else the design-background solid, else white with `transparent: true`. */
  fallback: { hex: string; L: number; transparent?: true };
  /** F first, then the other opaque solids between the hosts and F that intersect the text box; deduped; ≤ 8. */
  fallbackSet: string[];
  /** The canvas and the region (canvas px: the text's INK region, the glyphs' bounding box inside its region over the
   *  hosts) the backdrop was measured on. Information: `sceneDigest` is the staleness guard. */
  measuredOn: { canvasW: number; canvasH: number; region: JsonLintPxBox; previewScale: number };
  /** Pixel evidence over the glyph-masked region (WCAG relative luminances, 4 dp). */
  backdrop: {
    medianL: number;
    /** p10 */
    poleLowL: number;
    /** p90 */
    poleHighL: number;
    /** Share of kept pixels with C(T, px) < 3. */
    failingShare: number;
    /** k — the kept share. */
    keptShare: number;
    measuredBy: 'preview';
  };
  /** The dominant colour's recolour: present iff `recs.status === 'ok'`. */
  rec1?: { hex: string; minContrastVsFallbackSet: number; clamped: boolean };
  /** `ok` iff every colour that fails 3:1 on the fallback set (T, and each failing minority) has a verified rec; a
   *  decline writes no rec on any colour. */
  recs: { status: 'ok' } | { status: 'declined'; reason: 'rec1-fails-floor' };
  /** `never-auto` iff `fallback.transparent`. */
  applyWhen: 'off-host' | 'never-auto';
  /** gen 2: F's landing surface. Absent on gen 1. Byte-identical on every stamp that names its `key`. */
  surface?: JsonLegibilitySurface;
};

/**
 * A box as fractions of an image's OWN frame ({@link JsonImageFocalArea}`.frame`): `x`/`y` the top-left corner,
 * `w`/`h` the size, each in [0, 1] at 4 dp (`roundLintBox`). Image fractions are size-invariant, which is what lets
 * a stamp travel to every size of a set unchanged and be read against each size's own render.
 */
export type JsonLintBox = { x: number; y: number; w: number; h: number };

/**
 * AIR-23 F3. The closed vocabulary of what a focal-annotation box encloses. Readers switch on it exhaustively.
 * face    — a human face, head included, nothing below the chin;
 * person  — a human figure larger than a face: body, hands, a group;
 * product — a manufactured item the picture sells or shows (a pack, a bottle, a shoe, a car, a plated dish),
 *           including its own printed label;
 * logo    — a brand mark baked into the picture, standing apart from a product's printed label;
 * text    — legible lettering baked into the picture (a sign, a headline in the photo), standing apart from a logo.
 *           Not a text slot and not a legal claim (`meta.lint.legalText` is the legal one);
 * other   — any other object a viewer would miss (an animal, a landmark), and every unclassified box. Never evidence
 *           that a box is decorative or sacrificable.
 */
export type JsonFocalKind = 'face' | 'person' | 'product' | 'logo' | 'text' | 'other';

/** A JsonLintBox plus what it encloses and the confidence the scan STATED for THIS box. Flat, so a pre-F3 reader
 *  still reads the edges. `p` is 0..1, ≥ its write floor, stored as stated; never inherited, never written when not given. */
export type JsonTypedLintBox = JsonLintBox & { kind: JsonFocalKind; p: number };

/**
 * The subject of `box`, as far as the WHOLE asset holds it — Bogdan's `fullBox` is `full.box`. Every box is a fraction
 * of the parent's `frame` (the real bitmap, oriented as the browser draws it).
 */
export type JsonImageFocalAreaFull = {
  /** ⊇ the parent `box` exactly (a union on 4-dp edges); may extend past `seen` — that is its purpose. */
  box: JsonLintBox;
  /** Unit interval, ≥ 0.6 when written. `by: 'scan'` ⇒ equals the parent `p`; else the judge's stated confidence. */
  p: number;
  /**
   * 'scan'        — a non-backdrop host whose `seen` is the whole frame: `box` IS the whole-asset box; no call was made.
   * 'asset-judge' — a per-asset vision judge saw the whole bitmap; its box agreed with `box` inside `seen` and was unioned with it.
   */
  by: 'scan' | 'asset-judge';
};

/**
 * AIR-23: the pre-resize design linter's `tagFocalArea` stamps this on each picture host the scan judged to be a
 * photograph with a subject — an IMAGE layer (a slide's background among them, never only it — owner, 2026-10-07), a
 * shape whose fill is an image, or the design background (`meta.lint.background`, read by `readBackgroundFocalArea`)
 * — naming the FOCAL AREA of the asset — the one box a crop must keep whole, the subject the picture is of.
 * It states what the picture SHOWS and carries no policy: how a resize engine keeps that box (pan, zoom, crop) is
 * that engine's own decision.
 *
 * **Never read the raw field.** Read it ONLY through `readFocalArea` (`@thebrief-ai/shared/design/focalStamps`),
 * which validates the shape, applies the reader-side `FOCAL_READ_FLOOR`, and answers `null` ("no claim", never
 * "no subject") the moment `properties.url` names another asset (`assetKey`), the layer is bound to a feed, or the
 * shape is not this one. The consumer contract is `docs/resize/focal-area-annotation.md`.
 *
 * Two frames to keep apart. `frame` is the asset's REAL bitmap dimensions at write time — never the stored
 * `originalWidth`/`originalHeight`, which the resize proxy and stale imports leave wrong — and `box` and `seen` are
 * fractions of it. `seen` is the window of the asset the writer could SEE when it wrote (the visible part of the
 * drawn picture at the writing size): the stamp's provenance, never the current size's window; `box ⊆ seen`. The
 * claim is about the subject pixels the writer saw, so a consumer owes at most `box` and may not infer that the
 * rest of the asset is unimportant.
 *
 * `full.box` (AIR-23 F2, {@link JsonImageFocalAreaFull}) is where that same subject is in the WHOLE bitmap, for the
 * reader of a size whose aspect reveals pixels the writing size cropped away — that reader does see them. It is not a
 * licence to show those pixels: `box` remains the claim about what the source showed. A consumer may infer the
 * subject's whole-asset extent only from `full`, never from `box` or `seen`.
 *
 * AIR-23 F3: `kind` ({@link JsonFocalKind}) says what the subject is, and the optional `core` is the part of it a
 * reader keeps whole before the rest of `box` (the face of a person, the label of a pack) — a typed box with its own
 * stated `p`, inside `box` up to one rounding step per edge. The `gen` 2 shape replaced the `gen` 1 shape in place:
 * nothing was persisted in production and no reader existed (AIR-23 F3).
 *
 * Lives at `meta.lint.focalArea` ({@link JsonImageLintMeta}). Not the asset-level `FocalRegion` image-detections
 * measures (a detector's centroid cached per media row): this is the linter's claim about ONE layer, and it reads
 * back as a `FocalRegion` in its own `frame`.
 */
export type JsonImageFocalArea = {
  v: 1;
  /**
   * The writer's generation (`FOCAL_STAMP_GEN`): a later lint re-stamps an older generation and leaves a newer one
   * alone. The reader accepts any positive integer.
   */
  gen: number;
  /** Widened to `string` on read, as `legalText`'s is. */
  writtenBy: 'tagFocalArea';
  /** Where the claim came from. `'model'` is the only value v1 writes; `'user'` is reserved and reads as no claim. */
  source: 'model';
  /** The confidence the scan STATED, 0..1 and ≥ the writer's floor. Never written when not given. */
  p: number;
  /** Validity guard: the media key parsed from `properties.url` when the stamp was written. */
  assetKey: string;
  /** The asset's REAL bitmap dimensions at write time, px — never the stored `originalWidth`/`originalHeight`. */
  frame: { w: number; h: number };
  /** What the subject is (AIR-23 F3). Required. */
  kind: JsonFocalKind;
  /** The focal area: ONE box a crop must keep whole, as fractions of `frame`. `box ⊆ seen`. */
  box: JsonLintBox;
  /**
   * The part of the subject a reader keeps whole before the rest of `box`; inside `box` up to one rounding step per
   * edge (AIR-23 F3). Absent = no core claim (never "the subject has none"). A visible-window claim like `box`.
   */
  core?: JsonTypedLintBox;
  /** The window of the asset the writer could see, as fractions of `frame`: provenance of the writing size. */
  seen: JsonLintBox;
  /**
   * absent — no whole-asset decision was recorded (the judge did not run for this asset, or failed transiently);
   * null   — the judge ran and gave no usable whole-asset claim;
   * object — the claim.
   * Absent and null are both final until the next `gen`: nothing re-attempts them at this generation.
   */
  full?: JsonImageFocalAreaFull | null;
};

/**
 * AIR-23: the pre-resize design linter's `tagFocalArea` stamps this beside {@link JsonImageFocalArea} on the same
 * IMAGE layer, naming the KEEP-CLEAR objects in the picture: one box per thing nothing may be placed OVER — a face,
 * a product, a logo baked into the photo. Direction matters: a box here is where the photo's SUBJECT IS and other
 * elements stay OUT of it — the opposite of content-variations' "text keep-clear zones", which mark where text may
 * go. A box here says "do not cover this", never "put text here".
 *
 * **Never read the raw field.** Read it ONLY through `readKeepClear` (`@thebrief-ai/shared/design/focalStamps`):
 * the guards of the focal stamp (`assetKey`, feed binding, floor, shape), plus 1..8 boxes each inside `seen`. The
 * consumer contract is `docs/resize/focal-area-annotation.md`.
 *
 * `frame` and `seen` mean what they mean on {@link JsonImageFocalArea}: the REAL bitmap dimensions, and the window
 * the writer could see. Lives at `meta.lint.keepClear` ({@link JsonImageLintMeta}).
 *
 * AIR-23 F3: each box is typed ({@link JsonTypedLintBox}: what it encloses and its own stated `p`), and the list is in
 * PRIORITY order — index 0 is the LAST box a reader gives up; `readKeepClear` hands each box its `rank` (index + 1).
 * The `gen` 2 shape replaced the `gen` 1 shape in place: nothing was persisted in production and no reader existed
 * (AIR-23 F3).
 */
export type JsonImageKeepClear = {
  v: 1;
  gen: number;
  /** Widened to `string` on read. */
  writtenBy: 'tagFocalArea';
  source: 'model';
  p: number;
  assetKey: string;
  frame: { w: number; h: number };
  /**
   * 1..8 typed boxes, one per object nothing may be placed over, each as fractions of `frame` and each ⊆ `seen`, in
   * PRIORITY order — index 0 is the LAST a reader gives up. The order IS the priority; there is no priority field.
   */
  boxes: JsonTypedLintBox[];
  seen: JsonLintBox;
};

export type JsonTextOutline = {
  useOutline?: boolean;
  color?: string;
  weight?: number;
  position?: 'behind' | 'infront';
  /**
   * PSD-257: this outline stands for Photoshop's Faux Bold, set by the PSD importer. Renderers draw it in the text's
   * own colour, and PSD export writes the Faux Bold toggle instead of a Stroke effect. Any edit of the outline drops it.
   */
  source?: 'fauxBold';
};

export type JsonText = {
  type: 'layer';
  layerType: 'text';
  properties: JsonTextProperties;
  /** Non-render metadata — see {@link JsonElementMeta}. */
  meta?: JsonElementMeta<JsonTextLintMeta>;
};

export type JsonOldTextV2 = {
  type: 'layer';
  layerType: 'text';
  properties: JsonTextProperties & { config: JsonTextOldConfig[] };
};

export type JsonOldTextV1 = {
  properties: JsonTextOldConfigStyle;
};

export type JsonFlexStripProperties = JsonBaseElementProperties & {
  percentageHeight: number;
  text: string;
  alignment: JsonTextAlignment;
  fontSize: number;
  lineHeight: number;
  letterSpacing: number;
  config: JsonTextSlateConfig;
  contentHeightType: JsonTextContentHeightType;
  hoverState?: Partial<
    Pick<JsonTextProperties, 'outline' | 'textShadow'> &
      Pick<JsonFontSettings, 'fontWeight' | 'fontStyle'> &
      Pick<JsonTextSlateConfigChildren, 'gradient' | 'textDecoration'> & {
        scale: JsonHoverScale;
        speed: HoverScaleSpeed;
      }
  >;
  verticalAlign?: JsonTextVerticalAlignmentType;
  textShadow?: JsonShadow;
  initialFontSize?: number;
  textDirection?: string | null;
  scale?: number;
  blendMode?: JsonBlendMode;
  outline?: JsonTextOutline;
  paddingTop?: number;
  paddingBottom?: number;
  paddingLeft?: number;
  paddingRight?: number;
  backgroundColor?: JsonBackground;
  textOffsetX?: number;
  textOffsetY?: number;
  editPermissions?: {
    active: boolean;
    permissions: FlexStripLayerPermissions;
  };
};

export type JsonFlexStrip = {
  type: 'layer';
  layerType: 'flexStrip';
  properties: JsonFlexStripProperties;
};

// TODO: add all attributes
export type JsonTextSlateConfigNodeDefault = {
  defaultFontSettings?: JsonFontSettings;
  children: Array<JsonTextSlateConfigChildren | JsonTextSlateConfigNode>;
  /**
   * PSD-243: a paragraph's first-line indent, px before the element's `scale` (a paragraph node only; readers take it
   * through `paragraphFirstLineIndent`). Every reader draws it as CSS's text-indent: html-next and the editor on the
   * paragraph row, the shared shrink/ellipsis measurement, the PDF/AMP vector text and PSD export (Photoshop's First
   * Line Indent). The PSD importer writes it, positive, on left-aligned box text it places at Photoshop's frame.
   * Absent (every other text): no indent, every reader as before.
   */
  firstLineIndent?: number;
  /**
   * CRE-957: extra space above a paragraph, in em of its own font size (its first leaf's, the size its row is drawn
   * at), so scale, shrink and resize carry it with the text; negative pulls the paragraph up. Readers take it through
   * `paragraphSpacesBefore`, which ignores it on a text's first block, on a paragraph without visible text and on any
   * other node type, and draw it as CSS's margin-top on the paragraph row: html-next (and the editor's resting text,
   * which shares its renderer) and the shared shrink/ellipsis measurement. Absent (every text today): no space, every
   * reader as before.
   */
  spaceBeforeEm?: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  style?: any;
};

export type JsonTextSlateConfigNodeLink = JsonTextSlateConfigNodeDefault & {
  type: typeof RichBlocks.LINK;
  url: string;
};

export type JsonTextSlateConfigNodeImage = JsonTextSlateConfigNodeDefault & {
  type: typeof RichBlocks.IMAGE;
  src: string;
  actionUrl?: string;
  style?: {
    width?: number;
    originalWidth?: number;
    originalHeight?: number;
    marginTop?: number;
    marginBottom?: number;
  };
};

export type JsonTextSlateConfigTextNode = JsonTextSlateConfigNodeDefault &
  (
    | { type: typeof RichBlocks.WORD }
    | { type: typeof RichBlocks.LEGACY }
    | { type: typeof RichBlocks.PARAGRAPH }
    | { type: typeof RichBlocks.SUB_PARAGRAPH }
    | { type: typeof RichBlocks.WRAPPER }
    | { type: typeof RichBlocks.BULLET_LIST }
    | { type: typeof RichBlocks.NUMBERED_LIST }
    | { type: typeof RichBlocks.LIST_ITEM }
    | { type: typeof RichBlocks.FEED_CHIP }
  );

export type JsonTextSlateConfigNode =
  | JsonTextSlateConfigTextNode
  | JsonTextSlateConfigNodeLink
  | JsonTextSlateConfigNodeImage;

export function isLTextLinkElement(element: JsonTextSlateConfigNode): element is JsonTextSlateConfigNode & {
  type: typeof RichBlocks.LINK;
  url: string;
} {
  return element.type === RichBlocks.LINK;
}

export function isTextImageElement(element: JsonTextSlateConfigNode): element is JsonTextSlateConfigNode & {
  type: typeof RichBlocks.IMAGE;
  src: string;
  actionUrl?: string;
} {
  return element.type === RichBlocks.IMAGE;
}

export function isSlateConfigChildren(
  config: JsonTextSlateConfigChildren | JsonTextSlateConfigNode | JsonTextOldConfig,
): config is JsonTextSlateConfigChildren {
  return !('children' in config) && 'fontSettings' in config;
}

export function isSlateConfigNode(
  config: JsonTextSlateConfigChildren | JsonTextSlateConfigNode | JsonTextOldConfig,
): config is JsonTextSlateConfigNode {
  return 'children' in config && 'type' in config;
}

export function isSlateConfig(config: JsonTextSlateConfig | JsonTextOldConfig[]): config is JsonTextSlateConfig {
  return 'type' in config && 'nodes' in config;
}

export function isTextOldConfig(config: JsonTextSlateConfig | JsonTextOldConfig): config is JsonTextOldConfig {
  return 'style' in config && 'children' in config;
}

export function isOldTextV1(node: JsonText | JsonOldTextV2 | JsonOldTextV1 | JsonFlexStrip): node is JsonOldTextV1 {
  return !('type' in node);
}

export function isOldSetText(node: JsonTextSet | JsonTextOldConfigStyle): node is JsonTextOldConfigStyle {
  return !('config' in node);
}

export type JsonFontSettings = {
  fontFamily: string;
  fontType: FontType;
  fontStyle: FontStyle;
  fontPrefix: string | null;
  fontWeight: number;
  fontFaceUrl: string | null;
  fontUrl: string | null;
  localUrl?: string;
  metrics?: FontMetricsValues | null;
  metricsOverrideDisabled?: boolean;
  /**
   * Raw PSD font name (e.g. "Gotham-Bold") attached at PSD-import time so
   * the frontend's missing-font replacement dialog can correlate text
   * fragments with the structure JSON's `unmatchedFonts` list and rewrite
   * `fontFamily` / `fontWeight` / etc. before phase 2 fires. Set only by
   * the photoshop worker; left undefined for designs created by other
   * means. Cleared once a deliberate replacement has been applied.
   */
  originalFontName?: string;
};

export type JsonTextSlateConfigChildren = {
  color: string;
  textScript: 'none' | 'superscript' | 'subscript';
  textDecoration: JsonTextDecoration;
  textTransform: TextTransform;
  fontSettings: JsonFontSettings;
  typography: 'heading' | 'subheading' | 'body';
  gradient?: JsonTextGradient;
  fontSizePercent: number;
  fontSize?: number;
  text: string;
  feed?: AdStudioLayerFeedPropertyBind;
  feedText?: AdStudioLayerFeedPropertyBind;
  fill?: boolean;
  highlight?: { color: string; radius?: number };
};

export enum TextContentBoundaryType {
  OVERFLOW = 'overflow',
  SHRINK = 'shrink',
  ELLIPSIS = 'ellipsis',
}

export type Boundary = {
  type?: JsonTextContentBoundaryType;
  shrinkValue?: number;
  shrinkCharsLength?: number;
  minFontSize?: number;
  scrollSpeed?: number;
  delayAnimationScroll?: number;
  lineClampColor?: string;
  lineClampValue?: number;
  overflowValue?: boolean;
};

export type JsonTextSlateConfig = {
  type: 'slate';
  nodes: JsonTextSlateConfigNode[];
  selection?: unknown;
  keepSelection?: boolean;
  boundary?: Boundary;
};

export type JsonTextOldConfigStyle = {
  fontFamily: string;
  fontType: FontType;
  fontStyle: FontStyle;
  fontPrefix: string | null;
  fontWeight: number | string;
  fontFaceUrl: string | null;
  fontUrl: string | null;
};

export interface JsonCountdownConfigStyle extends JsonTextOldConfigStyle {
  textDecoration: JsonTextDecoration;
  color: string;
}

export type JsonTextOldConfigChildren = {
  style: JsonTextOldConfigStyle;
};

export type JsonTextOldConfig = {
  style: JsonTextOldConfigStyle;
  children: JsonTextOldConfigChildren[];
};

export type JsonCountdownConfig = {
  style: JsonCountdownConfigStyle;
  children: { style: JsonCountdownConfigStyle }[];
};

/**
 * Which zone a "to date" countdown's digits are read in. `fixed`, or no mode at all, is `countTimeZone`: one end
 * for every viewer. `viewer` is each viewer's own zone; `countTimeZone` is still kept for the readers that cannot
 * follow the viewer's zone (the AMP export, the legacy `apps/embed` renderer, scripts in older exports).
 */
export type JsonCountdownTimeZoneMode = 'fixed' | 'viewer';

export type JsonCountdownProperties = JsonBaseElementProperties & {
  countToDate: boolean;
  countValue: string | number;
  countTimeZone: number;
  countTimeZoneMode?: JsonCountdownTimeZoneMode;
  fontSize: number;
  letterSpacing: number;
  lineHeight: number;
  scale: number;
  textShadow: JsonShadow;
  alignment: JsonTextAlignment;
  config: JsonCountdownConfig[];
  editPermissions?: {
    active: boolean;
    permissions: ExcludedLayersPermissions;
  };
};

export type JsonCountdown = {
  type: 'layer';
  layerType: 'countdown';
  properties: JsonCountdownProperties;
};

export type JsonRainProperties = JsonBaseElementProperties & {
  size: number;
  speed: number;
  density: number;
  opacity: number;
  particleSize: number;
  splashEffect: boolean;
  splashEffectParticleSize: number;
  splashEffectSize: number;
  editPermissions?: {
    active: boolean;
    permissions: ExcludedLayersPermissions;
  };
};

export type JsonRain = {
  type: 'layer';
  layerType: 'rain';
  properties: JsonRainProperties;
};

export type JsonSnowProperties = JsonBaseElementProperties & {
  size: number;
  speed: number;
  density: number;
  opacity: number;
  particleSize: number;
  editPermissions?: {
    active: boolean;
    permissions: ExcludedLayersPermissions;
  };
};

export type JsonSnow = {
  type: 'layer';
  layerType: 'snow';
  properties: JsonSnowProperties;
};

export type JsonFogProperties = JsonBaseElementProperties & {
  size: number;
  speed: number;
  density: number;
  opacity: number;
  editPermissions?: {
    active: boolean;
    permissions: ExcludedLayersPermissions;
  };
};

export type JsonFog = {
  type: 'layer';
  layerType: 'fog';
  properties: JsonFogProperties;
};

/** Each side's share of `JsonBorder.weight`, from 0 (no stroke on that side) to 1. A missing side draws the full weight. */
export type JsonBorderSideScale = {
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
};

export type JsonBorder = {
  color: string;
  weight: number;
  radius?:
    | number
    | {
        topLeft: number;
        topRight: number;
        bottomLeft: number;
        bottomRight: number;
      };
  /**
   * A stroke on some sides only, e.g. a Figma list divider or tab underline. A side draws
   * `weight × sideScale[side]` px, so anything that scales `weight` (smart resize, design sync)
   * scales the drawn sides with it. Writers store it only when the sides differ and keep `weight` =
   * the widest side, so `weight > 0` keeps meaning a stroke is drawn. Written for frames; read it
   * with `borderSideWidths` (`@thebrief-ai/shared/design/borderSides`).
   */
  sideScale?: JsonBorderSideScale;
  /**
   * A gradient stroke, e.g. a Figma button outline that fades from light to dark (CRE-840), meant to
   * be drawn in place of `color` on frames and shapes (docs/design-format/border-gradient.md says
   * which renderers do). Buttons, and every reader that draws a border in one colour, keep drawing
   * `color`, so writers set `color` to the gradient's average (`borderGradientAverageColor`). `null`
   * draws like no gradient: the editor merges each write into the stored border, so a solid colour
   * picked over a gradient writes `null`. Read it with `borderGradientOf`
   * (`@thebrief-ai/shared/design/borderGradient`).
   */
  gradient?: JsonBackgroundGradient | null;
};

export type FontType = 'google' | 'custom' | 'all' | 'bannersnack' | 'creatopy';
export type FontStyle = 'normal' | 'italic' | 'regular' | 'slanted' | 'oblique';
export type TextTransform = 'none' | 'uppercase' | 'lowercase' | 'capitalize';

export enum CustomTextMarks {
  DECORATION = 'textDecoration',
  SCRIPT = 'textScript',
  TRANSFORM = 'textTransform',
  FONT_SETTINGS = 'fontSettings',
  COLOR = 'color',
  GRADIENT = 'gradient',
  TYPOGRAPHY = 'typography',
  FONT_SIZE = 'fontSize',
  FONT_SIZE_PERCENT = 'fontSizePercent',
  FEED_TEXT = 'feedText',
  HIGHLIGHT = 'highlight',
}

export type JsonButtonLabelStyle = JsonFontSettings & {
  fontDesign?: string;
  textTransform?: TextTransform;
  fontSize?: number;
  color?: string;
  letterSpacing?: number;
  lineHeight?: number;
  /** Vertical offset in em units for fine-tuning text vertical alignment (-2 to 2) */
  labelVerticalOffset?: number;
  dropShadow?: JsonShadow;
  initialFontSize?: number;
  textDirection?: string;
  fontPrefix?: string | null;
};

/**
 * How a button meets a label it does not fit (the "Button resizing" control). Only
 * the choice is stored: every renderer measures the label it draws (see
 * `packages/shared/src/button/labelFit.ts`, which also reads the deprecated
 * `autoWidth` of buttons saved before `labelFit` existed).
 */
export const JsonButtonLabelFitMode = {
  /** The box grows to the label. */
  autoWidth: 'autoWidth',
  /** The label's font shrinks until the single-row label fits the box (never above the authored size). */
  shrink: 'shrink',
  /** The box keeps its size and the wrapper's overflow:hidden cuts a long label. */
  fixed: 'fixed',
} as const;
export type JsonButtonLabelFitModeType = (typeof JsonButtonLabelFitMode)[keyof typeof JsonButtonLabelFitMode];

export type JsonButtonLabelFit = {
  mode: JsonButtonLabelFitModeType;
};

/**
 * An icon drawn beside the button's label. Its size and gap are em of the label's authored
 * `labelStyle.fontSize`, so every path that scales the label scales the icon with it; "Shrink
 * text" fits only the label and leaves the icon at that size. Every renderer reads it through
 * `getButtonIconLayout` (`packages/shared/src/button/icon.ts`), and draws the SVG file as an
 * image: a mask filled with the label's colour, or the picture in its own colours.
 */
export type JsonButtonIcon = {
  /**
   * The media hash of the SVG file (`assets/media/<hash>`), the hash space of an svg layer's
   * `url`. The design carries no markup.
   */
  hash: string;
  /**
   * The artwork's width over its height. The stored files are drawn without their own
   * proportions (`preserveAspectRatio="none"`), so the renderers size the artwork from this.
   */
  aspectRatio: number;
  /**
   * `label` (the default when absent): the icon is drawn in the label's colour, hover included,
   * as a silhouette of the artwork (its own transparency kept). `original`: the icon keeps its
   * own colours. `custom`: a silhouette in `color`, hover or not.
   */
  colorMode?: 'label' | 'original' | 'custom';
  /** The solid colour a `custom` icon is drawn in; a `custom` icon without a valid one keeps its own colours. */
  color?: string;
  /** Where it was picked from (`element-<id>`, `brandKit-<hash>`); no renderer reads it. */
  sourceId?: string;
  /** The side of the label the icon sits on. */
  position: 'left' | 'right';
  /** The icon box's side, in em of the label's authored font size. */
  size: number;
  /** The space between the icon and the label, in em of the label's authored font size. */
  gap: number;
};

export type HoverScaleSpeed = 'none' | 'fast' | 'normal' | 'slow';

export type JsonHoverScale = {
  amount: number; // multiplier; 1.0 means no scale, range 1.0 to 1.5
};

export type JsonButtonProperties = JsonBaseElementProperties & {
  buttonLabel: string;
  html: string;
  /**
   * @deprecated Read through `getButtonLabelFitMode` (`@thebrief-ai/shared/button/labelFit`).
   * Only buttons saved before `labelFit` existed carry it; writing `labelFit` removes it.
   */
  autoWidth?: boolean;
  /** Absent means the deprecated `autoWidth` decides: `true` is auto width, anything else fixed. */
  labelFit?: JsonButtonLabelFit;
  /** Absent means the button draws its label alone. */
  icon?: JsonButtonIcon;
  alignment?: JsonTextAlignment;
  backgroundColor?: JsonBackground;
  backgroundOverColor?: string;
  labelShadow?: JsonShadow;
  labelStyle: JsonButtonLabelStyle;
  /** @deprecated */
  labelOffsetX: number;
  /** @deprecated */
  labelOffsetY: number;
  border?: JsonBorder;
  hoverState?: Partial<
    Pick<JsonButtonProperties, 'backgroundColor' | 'border' | 'dropShadow' | 'labelShadow' | 'labelStyle'> & {
      scale: JsonHoverScale;
      speed: HoverScaleSpeed;
    }
  >;
  localUrl?: string;
  paddingTop?: number;
  paddingBottom?: number;
  paddingLeft?: number;
  paddingRight?: number;
  editPermissions?: {
    active: boolean;
    permissions: ButtonLayerPermissions;
  };
  brandKitButtonId?: number | null;
};

export type JsonButton = {
  type: 'layer';
  layerType: 'button';
  properties: JsonButtonProperties;
};

export type JsonAdjustColor = {
  useAdjustColor: boolean;
  brightness: number;
  contrast: number;
  saturate: number;
  hue: number;
};

export type JsonCropData = {
  x: number;
  y: number;
  width: number;
  height: number;
  rotation?: number; // Inner image rotation in degrees (around center)
};

export type Axis = {
  x: number;
  y: number;
};

export type OldCropData = {
  cropData?: JsonCropData;
  scaleMode: JsonScaleMode;
  horizontalAlign: JsonAlign;
  verticalAlign: JsonAlign;
  contentOffsetX: number;
  contentOffsetY: number;
  contentScale: number;
};

/** Gradient mask: opacity fade (black = visible, transparent = hidden). Used with mask-image. */
export type JsonGradientMaskLinear = {
  type: 'linear';
  angleDeg?: number; // 0 = to top, 90 = to right, 180 = to bottom, 270 = to left
  stops: Array<{ position: number; opacity: number }>; // position 0..1, opacity 0..1
};

export type JsonGradientMaskRadial = {
  type: 'radial';
  cx?: number; // center x 0..1 (0.5 = center)
  cy?: number; // center y 0..1 (0.5 = center)
  stops: Array<{ position: number; opacity: number }>; // position 0..1 = center to edge
};

export type JsonGradientMask = JsonGradientMaskLinear | JsonGradientMaskRadial;

export type JsonImageProperties = JsonBaseElementProperties & {
  url: string;
  scaleMode: JsonScaleMode;
  horizontalAlign: JsonAlign;
  verticalAlign: JsonAlign;
  adjustColor: JsonAdjustColor;
  contentScale: number;
  contentOffsetX: number;
  contentOffsetY: number;
  originalWidth: number;
  originalHeight: number;
  hqUrl?: string;
  cropData?: JsonCropData;
  source?: string;
  hash?: string;
  licensing?: boolean;
  blendMode?: JsonBlendMode;
  mediaFolderId?: number;
  originalName?: string;
  maskImage?: string;
  gradientMask?: JsonGradientMask;
  // Corner radius reuses the shared JsonBorder.radius store (same as shapes/buttons/frames).
  // Images carry no stroke, so only `radius` is ever set here.
  border?: JsonBorder;
  // `imageOutline` (not `outline`) avoids a name collision with text layers' JsonTextOutline,
  // whose `weight`/`position` shape is read generically by the legacy banner runtime.
  imageOutline?: JsonOutline;
  focalPoint?: { x: number; y: number };
  oldCropData?: OldCropData;
  backupUrl?: string;
  localUrl?: string;
  editPermissions?: {
    active: boolean;
    permissions: MediaLayerPermissions;
  };
  hoverState?: Partial<
    Pick<JsonImageProperties, 'dropShadow' | 'blur' | 'adjustColor' | 'maskImage' | 'imageOutline'> & {
      scale: JsonHoverScale;
      speed: HoverScaleSpeed;
    }
  >;
  format?: string;
};

export type JsonImage = {
  type: 'layer';
  layerType: 'image';
  properties: JsonImageProperties;
  /** Non-render metadata — see {@link JsonElementMeta}. */
  meta?: JsonElementMeta<JsonImageLintMeta>;
};

export type JsonLineData = {
  iteration: number;
  width: number;
  height: number;
  left: number;
  leftMargin: number;
  rightMargin: number;
  leftWidth: number;
  rightWidth: number;
};

export type JsonSvgProperties = JsonBaseElementProperties & {
  url: string;
  colorGroups?: Record<string, string>;
  /**
   * Gradient fill for a colour group, keyed by the SAME index as `colorGroups`. A
   * gradient wins over the solid in `colorGroups` for the same key; writing a solid to a
   * group MUST delete its entry here, or the gradient silently returns later.
   *
   * A SEPARATE field on purpose. `JsonDesign.types.ts` is inlined verbatim into the
   * generated `graphql-internal-request` mirror, and those mirrors can skew in CI (the
   * generated file is gitignored, so it cannot contribute to an Nx build hash). Widening
   * `colorGroups` itself makes that skew a hard structural-assignability error across six
   * projects; an extra OPTIONAL field stays assignable in both directions.
   */
  colorGroupGradients?: Record<string, JsonSvgGradientFill>;
  originalWidth: number;
  originalHeight: number;
  originalName?: string;
  resourceKey?: string;
  lineData?: JsonLineData;
  svgText?: string;
  svgObject?: JsonSvgObject;
  source?: string;
  blendMode?: JsonBlendMode;
  scale?: number;
  /** Controls how SVG content fits within layer bounds. Required for correct MP4 export. */
  scaleMode?: JsonScaleMode;
  convertedFromText?: boolean;
  editPermissions?: {
    active: boolean;
    permissions: MediaLayerPermissions;
  };
  /** @deprecated */
  fillColor?: string;
  hoverState?: Partial<
    Pick<JsonSvgProperties, 'colorGroups' | 'blur' | 'dropShadow'> & {
      scale: JsonHoverScale;
      speed: HoverScaleSpeed;
    }
  >;
};

export type JsonSvgObject = {
  type: string;
  fillColor?: string;
  attributes: JsonSvgObjectAttributes;
  children: {
    type: string;
    attributes: JsonSvgObjectAttributes;
  }[];
};

export type JsonSvgObjectAttributes = {
  d: string;
  class?: string;
  fill?: string;
  [key: string]: string | undefined;
};

export type JsonSvg = {
  type: 'layer';
  layerType: 'svg';
  properties: JsonSvgProperties;
};

/**
 * The CSS `mix-blend-mode` keywords, plus Photoshop's three linear modes (BUG-34835), which CSS
 * cannot express: `linear-dodge` (Add, `min(1, B + S)`), `linear-light` (`clamp(B + 2S − 1)`) and
 * `linear-burn` (`max(0, B + S − 1)`), and Photoshop's `pin-light` (`max(min(B, 2S), 2S − 1)`) and
 * `vivid-light` (color burn with 2S below S = 0.5, color dodge with 2S − 1 above) (PSD-153), and
 * Figma's Soft Light, `figma-soft-light` (`clamp(2B − softlight(B, 1 − S))`, CRE-939), which is not
 * CSS `soft-light`. Renderers draw those exactly where they can (html-next in Blink) and as their
 * closest CSS mode everywhere else; see `packages/shared/src/blendModes/linearBlend.ts`. Never pass a
 * value to CSS unmapped.
 */
export type JsonBlendMode =
  | 'color'
  | 'color-burn'
  | 'color-dodge'
  | 'darken'
  | 'difference'
  | 'exclusion'
  | 'figma-soft-light'
  | 'hard-light'
  | 'hue'
  | 'lighten'
  | 'linear-burn'
  | 'linear-dodge'
  | 'linear-light'
  | 'luminosity'
  | 'multiply'
  | 'normal'
  | 'overlay'
  | 'pin-light'
  | 'saturation'
  | 'screen'
  | 'soft-light'
  | 'vivid-light';

export type JsonShapeProperties = JsonBaseElementProperties & {
  backgroundColor?: JsonBackground;
  type: 'circle' | 'rectangle';
  border?: JsonBorder;
  cropData?: JsonCropData;
  oldCropData?: OldCropData;
  blendMode?: JsonBlendMode;
  // Colour filter (brightness/contrast/saturate/hue) for image-fill shapes; mirrors
  // JsonImageProperties.adjustColor. Only surfaced in the UI when the fill is an image.
  adjustColor?: JsonAdjustColor;
  editPermissions?: {
    active: boolean;
    permissions: ShapeLayerPermissions;
  };
  hoverState?: Partial<
    Pick<JsonShapeProperties, 'border' | 'backgroundColor' | 'dropShadow'> & {
      scale: JsonHoverScale;
      speed: HoverScaleSpeed;
    }
  >;
};

export type JsonShape = {
  type: 'layer';
  layerType: 'shape';
  properties: JsonShapeProperties;
  /** Non-render metadata — see {@link JsonElementMeta}. */
  meta?: JsonElementMeta<JsonShapeLintMeta>;
};

export type JsonShapeWithBackgroundImage = JsonShape & {
  properties: { backgroundColor: JsonBackgroundImage };
};

export type JsonYoutubeProperties = JsonBaseElementProperties & {
  youtubeURL: string;
  autoplay: boolean;
  loop: boolean;
  adjustColor?: JsonAdjustColor;
  displayYoutubeLogo: boolean;
  soundOnMouseOver: boolean;
  volume: number;
  startAt: boolean;
  startAtTime: string;
  hideControls: boolean;
  editPermissions?: {
    active: boolean;
    permissions: ExcludedLayersPermissions;
  };
};

export type JsonYoutube = {
  type: 'layer';
  layerType: 'youtube';
  properties: JsonYoutubeProperties;
};

export type JsonUseIframe = 'auto' | 'yes' | 'no';

export type JsonEmbedProperties = JsonBaseElementProperties & {
  backgroundColor?: JsonBackground;
  code: string;
  useBorder: boolean;
  borderColor?: string;
  margin: number;
  originalWidth?: number;
  useIframe: JsonUseIframe;
  scrollbar: boolean;
  autoResize: boolean;
  adjustColor?: JsonAdjustColor;
  preventDefaultClickthrough?: boolean;
  editPermissions?: {
    active: boolean;
    permissions: ExcludedLayersPermissions;
  };
};

export type JsonEmbed = {
  type: 'layer';
  layerType: 'embed';
  properties: JsonEmbedProperties;
};

/**
 * How a group container should behave when the design is resized (CRE-674). Written by the pre-resize
 * design linter on the containers it builds or recognises; read by resize methods that choose to honour it —
 * today the AI-resize typed-groups lane (`collectTypedGroups`). **Absent, an unknown `v`, or failing `readGroupResizeBehavior` ⇒ today's resize behaviour on
 * every path.** Read it ONLY through `readGroupResizeBehavior`
 * (`@thebrief-ai/shared/design/groupResizeBehavior`), never the raw field; the consumer contract is
 * `docs/resize/group-resize-behavior.md`.
 *
 * - `rigid`: the subtree is one object. Apply one uniform scale + translation to all of it, text included; keep
 *   or drop it whole. If uniform scaling would take a text below the minimum font size, drop the unit rather
 *   than distort it.
 * - `flexible`: the children (rigid units or single layers) stay one cluster. Child order is PAINT order, not
 *   reading order, and every layer's paint order is always preserved.
 *
 * A consumer that moves children inside the unit must strip the stamp or re-stamp it — never "repair" one.
 *
 * Lives at `meta.lint.resizeBehavior` ({@link JsonGroupLintMeta}). A stamp stored under the legacy
 * `properties.resizeBehavior` is an unknown key: carried by copies, ignored by every reader, never rewritten.
 */
export type JsonGroupResizeBehavior = {
  v: 1;
  kind: 'rigid' | 'flexible';
  /**
   * Flexible only. `nudge`: keep the arrangement class (a row stays a row) and the child order; positions may
   * shift. `reflow`: the arrangement itself may change (row → column / staggered). Absent on `rigid`.
   */
  reflow?: 'nudge' | 'reflow';
  /** Direct children at write time. Validity guard, not an instruction. */
  childCount: number;
  /**
   * Per direct child, in child (= paint) order: its box relative to the group's reference box (the union of the
   * non-text children's boxes and the text children's top-left points), `[x, y, w, h]` as fractions at 3 dp.
   * Only `[x, y]` is compared for a text child. Validity guard, not an instruction.
   */
  childFrames: [number, number, number, number][];
  /** The reference box's width / height at write time, 3 dp — catches a non-uniform stretch. Validity guard. */
  aspect: number;
  writtenBy: 'design-linter';
};

export type JsonGroupProperties = JsonBaseElementProperties & {
  collapsed?: boolean;
  locked?: boolean;
  editPermissions?: {
    active: boolean;
    permissions: ExcludedLayersPermissions;
  };
};

export type JsonGroup = {
  type: 'layer';
  layerType: 'group';
  properties: JsonGroupProperties;
  /** Non-render metadata — see {@link JsonElementMeta}. */
  meta?: JsonElementMeta<JsonGroupLintMeta>;
  elements: JsonElement[];
};

export type AutoLayoutDirection = 'HORIZONTAL' | 'VERTICAL';

export type AutoLayoutWrap = 'NO_WRAP' | 'WRAP';

export type PrimaryAxisAlign = 'MIN' | 'CENTER' | 'MAX' | 'SPACE_BETWEEN';

export type CounterAxisAlign = 'MIN' | 'CENTER' | 'MAX';

export type CounterAxisAlignContent = 'AUTO' | 'SPACE_BETWEEN';

export type AutoLayoutPadding = {
  top: number;
  right: number;
  bottom: number;
  left: number;
};

export type AutoLayout = {
  active: boolean;
  direction: AutoLayoutDirection;
  wrap: AutoLayoutWrap;
  primaryAxisAlignItems: PrimaryAxisAlign;
  counterAxisAlignItems: CounterAxisAlign;
  counterAxisAlignContent: CounterAxisAlignContent;
  itemSpacing: number;
  counterAxisSpacing: number | null;
  padding: AutoLayoutPadding;
  itemReverseZIndex: boolean;
  primaryAxisSizingMode: 'FIXED' | 'AUTO';
  counterAxisSizingMode: 'FIXED' | 'AUTO';
};

export type AutoLayoutChild = {
  layoutGrow: 0 | 1;
  layoutAlign: 'INHERIT' | 'STRETCH';
};

/**
 * Figma-style Constraints model (see `JsonBaseElementProperties.constraints`).
 * Each axis is independent. Horizontal / vertical modes, and the exact position+
 * size math each produces when the parent resizes, are documented in
 * apps/app/docs/CONSTRAINTS_ARCHITECTURE.md and implemented once in the pure
 * resolver `packages/shared/src/smart-resize/constraints/resolveConstraints.ts`.
 */
export type HorizontalConstraint = 'LEFT' | 'RIGHT' | 'LEFT_RIGHT' | 'CENTER' | 'SCALE';
export type VerticalConstraint = 'TOP' | 'BOTTOM' | 'TOP_BOTTOM' | 'CENTER' | 'SCALE';
export type Constraints = {
  horizontal: HorizontalConstraint;
  vertical: VerticalConstraint;
};

/**
 * How a layer scales in a served Fill ad, relative to the ad's scale `k`:
 * - `NO_SHRINK` ("Don't shrink"): never drawn smaller than the designed size; the layer's scale is
 *   `max(1, 1/k)`, so it still grows in bigger slots.
 * - `FIXED` ("Fixed size"): always drawn at the designed size, never shrinking or growing; the
 *   layer's scale is `1/k`.
 */
export type ScaleLimitMode = 'NO_SHRINK' | 'FIXED';

/** Per-layer limits on how a served Fill ad scales the layer (see `JsonBaseElementProperties.scaleLimits`). */
export type ScaleLimits = {
  /** Absent = "Scale with ad" (the layer scales with the ad like everything else). The modes are exclusive. */
  mode?: ScaleLimitMode;
};

export type JsonFrameProperties = JsonBaseElementProperties & {
  collapsed?: boolean;
  locked?: boolean;
  border?: JsonBorder;
  backgroundColor?: JsonBackground;
  clipContent?: boolean;
  autoLayout?: AutoLayout;
  blendMode?: JsonBlendMode;
  /**
   * Blends only the frame's own fill (`backgroundColor`) with what is behind the frame, where `blendMode` blends the
   * frame and its children together. Children and stroke draw normally on top, like a Figma fill paint's blend mode.
   * Absent means normal: writers omit the key rather than store `normal`.
   */
  fillBlendMode?: JsonBlendMode;
  // A frame clips its children; these turn that clip into an arbitrary shape, so anything
  // inside animates behind a shaped window using the ordinary whole-layer animation stack.
  // Same fields, same semantics as image/video masks. Having either implies clipContent.
  maskImage?: string;
  gradientMask?: JsonGradientMask;
  editPermissions?: {
    active: boolean;
    permissions: ExcludedLayersPermissions;
  };
};

export type JsonFrame = {
  type: 'layer';
  layerType: 'frame';
  properties: JsonFrameProperties;
  elements: JsonElement[];
};

export type JsonAutoplay = 'enabled' | 'disabled';

export type JsonVideoProperties = JsonBaseElementProperties & {
  format: string;
  url: string;
  scaleMode: JsonScaleMode;
  horizontalAlign: JsonAlign;
  verticalAlign: JsonAlign;
  adjustColor?: JsonAdjustColor;
  contentScale: number;
  originalWidth: number;
  originalHeight: number;
  originalName?: string;
  hash?: string;
  cropData?: JsonCropData;
  startTime: number;
  endTime: number;
  duration: number;
  autoplay: JsonAutoplay;
  controls: boolean;
  loop: boolean;
  soundOnHover: boolean;
  volume: number;
  // Legacy: the editor no longer sets this. Retained on the type so stored
  // designs that still carry the flag continue to deserialize; consumers in
  // apps/app coerce it to false, while the html-next embed runtime honors any
  // pre-existing `true` value for backward compatibility.
  keepPlayingPastSlide?: boolean;
  provider?: JsonStockMediaProvider;
  maskImage?: string;
  gradientMask?: JsonGradientMask;
  // Corner radius reuses the shared JsonBorder.radius store (same as shapes/buttons/frames).
  // Videos carry no stroke, so only `radius` is ever set here.
  border?: JsonBorder;
  source?: string;
  blendMode?: JsonBlendMode;
  localUrl?: string;
  editPermissions?: {
    active: boolean;
    permissions: MediaLayerPermissions;
  };
};

export type JsonStockMediaProvider =
  | 'unsplash'
  | 'pixabay'
  | 'pexels'
  | 'giphy'
  | 'melodie'
  | 'audioProviders'
  | 'shutterstock';

export type JsonVideo = {
  type: 'layer';
  layerType: 'video';
  properties: JsonVideoProperties;
};

export type JsonAudioProperties = JsonBaseElementProperties & {
  format: string;
  url: string;
  startTime: number;
  endTime: number;
  originalName?: string;
  duration: number;
  volume: number;
  soundOnHover: boolean;
  localUrl?: string;
  provider?: JsonStockMediaProvider;
  editPermissions?: {
    active: boolean;
    permissions: AudioLayerPermissions;
  };
};

export type JsonAudio = {
  type: 'layer';
  layerType: 'audio';
  properties: JsonAudioProperties;
};

export type JsonClipartProperties = JsonBaseElementProperties & {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  svgObject: any;
  fillColor: string;
  editPermissions?: {
    active: boolean;
    permissions: ExcludedLayersPermissions;
  };
};

export type JsonClipart = {
  type: 'layer';
  layerType: 'clipart';
  properties: JsonClipartProperties;
};

/**
 * @deprecated  Groups ware moved under Elements level {@link JsonGroup}
 */
export type TGroup = {
  name: string;
  collapsed: boolean;
  parent: number | null;
  visible: boolean;
  locked?: boolean;
};

/**
 * @deprecated Groups ware moved under Elements level {@link JsonGroup}
 */
export type SlideGroups = {
  [groupId: number]: TGroup;
};

/**
 * @deprecated Groups ware moved under Elements level {@link JsonGroup}
 */
export type JsonGroups = {
  [slideId: number]: SlideGroups;
};

export type JsonDesign = {
  properties: JsonDesignProperties;
  elements: JsonSlideOrElement[];
  groups?: JsonGroups; // @deprecated Groups ware moved under Elements level {@link JsonGroup}
  resources?: Record<string, TResource>;
  version?: string;
  coverSlide?: JsonSlide | null;
  /** Non-render metadata on the root — only `lint.background` ({@link JsonDesignLintMeta}); see {@link JsonElementMeta}. */
  meta?: { lint?: JsonDesignLintMeta };
};

export type DesignJsonWithHash = {
  hash: string;
  json: JsonDesign;
};

type JsonSetBaseProperties = {
  bannersetElementType: string;
  layerType: JsonLayerType;
  elementCategory: number;
  locked: boolean;
  lockedProperties: string[];
  feed?: JsonPropertiesFeed;
};

export type JsonVideoSet = JsonVideoProperties & JsonSetBaseProperties;
export type JsonButtonSet = JsonButtonProperties & JsonSetBaseProperties;
export type JsonImageSet = JsonImageProperties & JsonSetBaseProperties;
export type JsonSvgSet = JsonSvgProperties & JsonSetBaseProperties;
export type JsonTextSet = JsonTextProperties & JsonSetBaseProperties;
export type JsonShapeSet = JsonShapeProperties & JsonSetBaseProperties;

export type JsonSetElement = JsonElementProperties & JsonSetBaseProperties;

export function isJsonSetSlide(element: JsonSetSlide | JsonSlideOrElement): element is JsonSetSlide {
  return 'elementType' in element && element.elementType === 'slide';
}

export function isJsonSetElement(element: JsonSetElement | JsonSlideOrElement): element is JsonSetElement {
  return 'bannersetElementType' in element;
}

export function isJsonSetImage(element: JsonSetElement): element is JsonImageSet {
  return element.layerType === 'image';
}

export function isJsonSetVideo(element: JsonSetElement): element is JsonVideoSet {
  return element.layerType === 'video';
}

export function isJsonSetSvg(element: JsonSetElement): element is JsonSvgSet {
  return element.layerType === 'svg';
}

export function isJsonSetText(element: JsonSetElement): element is JsonTextSet {
  return element.layerType === 'text';
}

export function isJsonSetButton(element: JsonSetElement): element is JsonButtonSet {
  return element.layerType === 'button';
}

export function isJsonSetShape(element: JsonSetElement): element is JsonShapeSet {
  return element.layerType === 'shape';
}

export type JsonSetSlide = JsonSlideProperties & {
  elements: JsonSetElement[];
  elementType: 'slide';
  feed?: JsonPropertiesFeed;
};

export function isJsonDesignSet(element: JsonDesignSet | JsonSetElement): element is JsonDesignSet {
  return 'elements' in element && !('layerType' in element) && !('elementType' in element);
}

export type JsonDesignSet = {
  hash: string;
  userId?: number;
  name: string;
  lastElementId: number;
  backgroundColor: JsonDesignBackground;
  loopCount: number;
  hasVideo: boolean;
  hasAudio: boolean;
  elements: JsonSetSlide[];
  feed?: JsonDesignFeed;
};

export type TResource = {
  content: string;
  usages: number;
};

export type JsonTextDecoration = 'none' | 'underline' | 'line-through';

export enum TextDecorationEnum {
  NONE = 'none',
  UNDERLINE = 'underline',
  STRIKETHROUGH = 'line-through',
}

export type Rect = {
  width: number;
  height: number;
  x: number;
  y: number;
};

export enum RemoveBgStatus {
  INITIAL = 'initial',
  DONE = 'done',
  ERROR = 'error',
  PROCESSING = 'processing',
  // Permanent: the URL does not resolve to an image (e.g. an HTML page).
  // Never retried by syncs or bulk re-runs; cleared when the URL changes or
  // the user reverts the column.
  INVALID = 'invalid',
}

export enum SmartCropStatus {
  INITIAL = 'initial',
  DONE = 'done',
  ERROR = 'error',
  PROCESSING = 'processing',
}

export type SmartCropMode = 'layerDefault' | 'autoCrop' | 'focalPoint';

export type FocalArea = {
  x: number;
  y: number;
  w: number;
  h: number;
};

export type SmartCropCell = {
  status: SmartCropStatus;
  focalArea?: FocalArea;
  source?: 'ai' | 'user';
  // True once the user has acknowledged this row in the smart-crop modal —
  // either by saving an edit or by navigating past it (auto-mark on next).
  // Drives the "reviewed" checkmark in the per-row list. AI-written rows
  // start with this unset so they show the "AI identified" state until the
  // user passes through.
  reviewed?: boolean;
  // Natural pixel dimensions of the source image, populated by the worker
  // from the focal-region API response. The canvas + export renderers use
  // these alongside `focalArea` to derive a layer-specific `cropData`
  // synchronously at feed-binding time (no image-load round-trip needed).
  imageWidth?: number;
  imageHeight?: number;
  // Per-cell zoom expressed as a percentage. 100 (or undefined) renders the
  // cover-fit crop centred on the focal point. Values >100 zoom in around
  // the focal point — the crop window grows beyond layer dimensions, so
  // the image fills more of the layer. Values <100 are not honored
  // (would leave empty edges; renderer treats them as 100).
  zoom?: number;
  // Renderers (canvas, export, ad-serving) skip focal-derived crops when
  // this is true and fall back to cover-fit. Stamped onto cells by the
  // `loadFeedRows` resolver based on the column-level `smartCropDisabled`
  // flag — keeps `feedJson()` row-local (no need to thread column
  // metadata) while letting the user toggle focal-point behaviour for
  // the whole column without losing the saved data.
  disabled?: boolean;
};

/**
 * Image readiness classification (CRE-415, D16 — docs/catalogs/architecture.md
 * §4.7), stamped per image cell at ingest by the sync paths:
 * - 'missing' — no URL, the URL did not answer a HEAD probe with a 2xx, or
 *   it answered with a non-image content-type (e.g. an HTML page);
 * - 'low' — reserved for min(width, height) < 500px or extreme aspect (>5:1).
 *   TODO(CRE-415): not produced yet — intrinsic dimensions need an image
 *   decode and no cheap dependency-free util exists in the repo; V1
 *   classifies by HEAD status only.
 * - 'ready' — the URL answered the probe.
 * Rows never classified (e.g. imported before this shipped) have no value and
 * surface as "unknown" in aggregates. Additive — consumers ignore unknown keys.
 */
export type ImageReadiness = 'ready' | 'low' | 'missing';

export type FeedImageCellValue = {
  url: string;
  removeBg?: RemoveBgStatus;
  smartCrop?: SmartCropCell;
  readiness?: ImageReadiness;
};

export type FeedColumnName = string;
export type FeedCellValue = string | FeedImageCellValue;
export type FeedJson = { data: FeedCellValue[][]; columns: FeedColumnName[] };

export type FeedRowJsonContent = Record<FeedColumnName, FeedCellValue>;
export type FeedRowJson = FeedRowJsonContent | FeedRowJsonContent[];

type FeedHash = string;
export type FeedHashWithRowJsonContent = Record<FeedHash, FeedRowJsonContent>;

export type FeedCSVData = { data: string[][]; columns: string[] };
export const EmptyFeedData: FeedCSVData = { data: [], columns: [] };

export function isImageCellValue(variable: FeedCellValue): variable is FeedImageCellValue {
  return !!variable && typeof variable === 'object' && 'url' in variable;
}

export type FontSettings = {
  fontFamily: string;
  fontType: string;
  fontStyle: string;
  fontPrefix: string | null;
  fontWeight: number;
  fontFaceUrl: string | null;
  fontUrl: string | null;
};

export type FallbackFont = {
  originalFont: FontSettings;
  fallbackFont: FontSettings | null;
};

export type LanguageFallbackFonts = {
  languageCode: string;
  fonts: FallbackFont[];
};

export type BrandKitJson = {
  fallbackFonts: LanguageFallbackFonts[];
};

export const EmptyBrandKitJson: BrandKitJson = {
  fallbackFonts: [],
};

export const EmptyFontSettings: FontSettings = {
  fontFamily: '',
  fontType: 'google',
  fontStyle: 'normal',
  fontPrefix: null,
  fontWeight: 400,
  fontFaceUrl: null,
  fontUrl: null,
};
